var _asyncToGenerator = require("/root/builder-surface/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
var _defineProperty = require("/root/builder-surface/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _slicedToArray = require("/root/builder-surface/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _toConsumableArray = require("/root/builder-surface/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _objectSpread = require("/root/builder-surface/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n16 = 0, F = function F() {}; return { s: F, n: function n() { return _n16 >= r.length ? { done: !0 } : { done: !1, value: r[_n16++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/*! drapcode-bootstrap - 1.0.44 */
!function (t, e) {
  'object' == typeof exports && 'object' == typeof module ? module.exports = e() : 'function' == typeof define && define.amd ? define([], e) : 'object' == typeof exports ? exports["drapcode-bootstrap"] = e() : t["drapcode-bootstrap"] = e();
}(window, function () {
  return function (t) {
    var e = {};
    function n(i) {
      if (e[i]) return e[i].exports;
      var r = e[i] = {
        i: i,
        l: !1,
        exports: {}
      };
      return t[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
    }
    return n.m = t, n.c = e, n.d = function (t, e, i) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: i
      });
    }, n.r = function (t) {
      'undefined' != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: 'Module'
      }), Object.defineProperty(t, '__esModule', {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && 'object' == typeof t && t && t.__esModule) return t;
      var i = Object.create(null);
      if (n.r(i), Object.defineProperty(i, 'default', {
        enumerable: !0,
        value: t
      }), 2 & e && 'string' != typeof t) for (var r in t) n.d(i, r, function (e) {
        return t[e];
      }.bind(null, r));
      return i;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t['default'];
      } : function () {
        return t;
      };
      return n.d(e, 'a', e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 77);
  }([function (t, e, n) {
    "use strict";

    (function (t) {
      n.d(e, "e", function () {
        return i;
      }), n.d(e, "p", function () {
        return r;
      }), n.d(e, "a", function () {
        return a;
      }), n.d(e, "c", function () {
        return o;
      }), n.d(e, "d", function () {
        return s;
      }), n.d(e, "o", function () {
        return l;
      }), n.d(e, "q", function () {
        return c;
      }), n.d(e, "t", function () {
        return d;
      }), n.d(e, "i", function () {
        return u;
      }), n.d(e, "r", function () {
        return h;
      }), n.d(e, "s", function () {
        return p;
      }), n.d(e, "k", function () {
        return g;
      }), n.d(e, "m", function () {
        return f;
      }), n.d(e, "j", function () {
        return m;
      }), n.d(e, "l", function () {
        return v;
      }), n.d(e, "g", function () {
        return b;
      }), n.d(e, "f", function () {
        return y;
      }), n.d(e, "h", function () {
        return w;
      }), n.d(e, "n", function () {
        return x;
      }), n.d(e, "b", function () {
        return j;
      });
      var i = '1.13.6',
        r = 'object' == typeof self && self.self === self && self || 'object' == typeof t && t.global === t && t || Function('return this')() || {},
        a = Array.prototype,
        o = Object.prototype,
        s = 'undefined' != typeof Symbol ? Symbol.prototype : null,
        l = a.push,
        c = a.slice,
        d = o.toString,
        u = o.hasOwnProperty,
        h = 'undefined' != typeof ArrayBuffer,
        p = 'undefined' != typeof DataView,
        g = Array.isArray,
        f = Object.keys,
        m = Object.create,
        v = h && ArrayBuffer.isView,
        b = isNaN,
        y = isFinite,
        w = !{
          toString: null
        }.propertyIsEnumerable('toString'),
        x = ['valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'],
        j = Math.pow(2, 53) - 1;
    }).call(this, n(23));
  }, function (t, e) {
    t.exports = function (t) {
      return null == t ? '' : '' + t;
    };
  }, function (t, e) {
    var n = 'abcdefghijklmnopqrstuvwxyz',
      i = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
      r = '0123456789',
      a = '~!@#$%^&()_+-={}[];\',';
    t.exports = function (t, e) {
      t || (t = 30), e || (e = 'aA0');
      var o = '';
      e.split('').forEach(function (t) {
        isNaN(parseInt(t)) ? /[a-z]/.test(t) ? o += n : /[A-Z]/.test(t) ? o += i : o += a : o += r;
      });
      for (var s = '', l = 0; l < t; l++) s += o.charAt(Math.floor(Math.random() * o.length));
      return s;
    };
  }, function (t, e, n) {
    var i = n(1),
      r = n(7),
      a = String.prototype.trim;
    t.exports = function (t, e) {
      return t = i(t), !e && a ? a.call(t) : (e = r(e), t.replace(new RegExp('^' + e + '+|' + e + '+$', 'g'), ''));
    };
  }, function (t, e, n) {
    var i;
    !function (e, n) {
      "use strict";

      1 && "object" == typeof t.exports ? t.exports = e.document ? n(e, !0) : function (t) {
        if (!t.document) throw new Error("jQuery requires a window with a document");
        return n(t);
      } : n(e);
    }("undefined" != typeof window ? window : this, function (n, r) {
      "use strict";

      var a = [],
        o = Object.getPrototypeOf,
        s = a.slice,
        l = a.flat ? function (t) {
          return a.flat.call(t);
        } : function (t) {
          return a.concat.apply([], t);
        },
        c = a.push,
        d = a.indexOf,
        u = {},
        h = u.toString,
        p = u.hasOwnProperty,
        g = p.toString,
        f = g.call(Object),
        m = {},
        v = function v(t) {
          return "function" == typeof t && "number" != typeof t.nodeType && "function" != typeof t.item;
        },
        b = function b(t) {
          return null != t && t === t.window;
        },
        y = n.document,
        w = {
          type: !0,
          src: !0,
          nonce: !0,
          noModule: !0
        };
      function x(t, e, n) {
        var i,
          r,
          a = (n = n || y).createElement("script");
        if (a.text = t, e) for (i in w) (r = e[i] || e.getAttribute && e.getAttribute(i)) && a.setAttribute(i, r);
        n.head.appendChild(a).parentNode.removeChild(a);
      }
      function j(t) {
        return null == t ? t + "" : "object" == typeof t || "function" == typeof t ? u[h.call(t)] || "object" : typeof t;
      }
      var C = "3.7.1",
        M = /HTML$/i,
        _k = function k(t, e) {
          return new _k.fn.init(t, e);
        };
      function O(t) {
        var e = !!t && "length" in t && t.length,
          n = j(t);
        return !v(t) && !b(t) && ("array" === n || 0 === e || "number" == typeof e && e > 0 && e - 1 in t);
      }
      function T(t, e) {
        return t.nodeName && t.nodeName.toLowerCase() === e.toLowerCase();
      }
      _k.fn = _k.prototype = {
        jquery: C,
        constructor: _k,
        length: 0,
        toArray: function toArray() {
          return s.call(this);
        },
        get: function get(t) {
          return null == t ? s.call(this) : t < 0 ? this[t + this.length] : this[t];
        },
        pushStack: function pushStack(t) {
          var e = _k.merge(this.constructor(), t);
          return e.prevObject = this, e;
        },
        each: function each(t) {
          return _k.each(this, t);
        },
        map: function map(t) {
          return this.pushStack(_k.map(this, function (e, n) {
            return t.call(e, n, e);
          }));
        },
        slice: function slice() {
          return this.pushStack(s.apply(this, arguments));
        },
        first: function first() {
          return this.eq(0);
        },
        last: function last() {
          return this.eq(-1);
        },
        even: function even() {
          return this.pushStack(_k.grep(this, function (t, e) {
            return (e + 1) % 2;
          }));
        },
        odd: function odd() {
          return this.pushStack(_k.grep(this, function (t, e) {
            return e % 2;
          }));
        },
        eq: function eq(t) {
          var e = this.length,
            n = +t + (t < 0 ? e : 0);
          return this.pushStack(n >= 0 && n < e ? [this[n]] : []);
        },
        end: function end() {
          return this.prevObject || this.constructor();
        },
        push: c,
        sort: a.sort,
        splice: a.splice
      }, _k.extend = _k.fn.extend = function () {
        var t,
          e,
          n,
          i,
          r,
          a,
          o = arguments[0] || {},
          s = 1,
          l = arguments.length,
          c = !1;
        for ("boolean" == typeof o && (c = o, o = arguments[s] || {}, s++), "object" == typeof o || v(o) || (o = {}), s === l && (o = this, s--); s < l; s++) if (null != (t = arguments[s])) for (e in t) i = t[e], "__proto__" !== e && o !== i && (c && i && (_k.isPlainObject(i) || (r = Array.isArray(i))) ? (n = o[e], a = r && !Array.isArray(n) ? [] : r || _k.isPlainObject(n) ? n : {}, r = !1, o[e] = _k.extend(c, a, i)) : void 0 !== i && (o[e] = i));
        return o;
      }, _k.extend({
        expando: "jQuery" + (C + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function error(t) {
          throw new Error(t);
        },
        noop: function noop() {},
        isPlainObject: function isPlainObject(t) {
          var e, n;
          return !(!t || "[object Object]" !== h.call(t)) && (!(e = o(t)) || "function" == typeof (n = p.call(e, "constructor") && e.constructor) && g.call(n) === f);
        },
        isEmptyObject: function isEmptyObject(t) {
          var e;
          for (e in t) return !1;
          return !0;
        },
        globalEval: function globalEval(t, e, n) {
          x(t, {
            nonce: e && e.nonce
          }, n);
        },
        each: function each(t, e) {
          var n,
            i = 0;
          if (O(t)) for (n = t.length; i < n && !1 !== e.call(t[i], i, t[i]); i++);else for (i in t) if (!1 === e.call(t[i], i, t[i])) break;
          return t;
        },
        text: function text(t) {
          var e,
            n = "",
            i = 0,
            r = t.nodeType;
          if (!r) for (; e = t[i++];) n += _k.text(e);
          return 1 === r || 11 === r ? t.textContent : 9 === r ? t.documentElement.textContent : 3 === r || 4 === r ? t.nodeValue : n;
        },
        makeArray: function makeArray(t, e) {
          var n = e || [];
          return null != t && (O(Object(t)) ? _k.merge(n, "string" == typeof t ? [t] : t) : c.call(n, t)), n;
        },
        inArray: function inArray(t, e, n) {
          return null == e ? -1 : d.call(e, t, n);
        },
        isXMLDoc: function isXMLDoc(t) {
          var e = t && t.namespaceURI,
            n = t && (t.ownerDocument || t).documentElement;
          return !M.test(e || n && n.nodeName || "HTML");
        },
        merge: function merge(t, e) {
          for (var n = +e.length, i = 0, r = t.length; i < n; i++) t[r++] = e[i];
          return t.length = r, t;
        },
        grep: function grep(t, e, n) {
          for (var i = [], r = 0, a = t.length, o = !n; r < a; r++) !e(t[r], r) !== o && i.push(t[r]);
          return i;
        },
        map: function map(t, e, n) {
          var i,
            r,
            a = 0,
            o = [];
          if (O(t)) for (i = t.length; a < i; a++) null != (r = e(t[a], a, n)) && o.push(r);else for (a in t) null != (r = e(t[a], a, n)) && o.push(r);
          return l(o);
        },
        guid: 1,
        support: m
      }), "function" == typeof Symbol && (_k.fn[Symbol.iterator] = a[Symbol.iterator]), _k.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (t, e) {
        u["[object " + e + "]"] = e.toLowerCase();
      });
      var S = a.pop,
        N = a.sort,
        L = a.splice,
        D = "[\\x20\\t\\r\\n\\f]",
        E = new RegExp("^" + D + "+|((?:^|[^\\\\])(?:\\\\.)*)" + D + "+$", "g");
      _k.contains = function (t, e) {
        var n = e && e.parentNode;
        return t === n || !(!n || 1 !== n.nodeType || !(t.contains ? t.contains(n) : t.compareDocumentPosition && 16 & t.compareDocumentPosition(n)));
      };
      var I = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
      function P(t, e) {
        return e ? "\0" === t ? "�" : t.slice(0, -1) + "\\" + t.charCodeAt(t.length - 1).toString(16) + " " : "\\" + t;
      }
      _k.escapeSelector = function (t) {
        return (t + "").replace(I, P);
      };
      var A = y,
        z = c;
      !function () {
        var t,
          e,
          i,
          r,
          o,
          l,
          c,
          u,
          h,
          g,
          f = z,
          v = _k.expando,
          b = 0,
          y = 0,
          w = tt(),
          x = tt(),
          j = tt(),
          C = tt(),
          M = function M(t, e) {
            return t === e && (o = !0), 0;
          },
          O = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" + "loop|multiple|open|readonly|required|scoped",
          I = "(?:\\\\[\\da-fA-F]{1,6}" + D + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
          P = "\\[" + D + "*(" + I + ")(?:" + D + "*([*^$|!~]?=)" + D + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + I + "))|)" + D + "*\\]",
          _ = ":(" + I + ")(?:\\((" + "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + "((?:\\\\.|[^\\\\()[\\]]|" + P + ")*)|" + ".*" + ")\\)|)",
          H = new RegExp(D + "+", "g"),
          V = new RegExp("^" + D + "*," + D + "*"),
          F = new RegExp("^" + D + "*([>+~]|" + D + ")" + D + "*"),
          R = new RegExp(D + "|>"),
          B = new RegExp(_),
          W = new RegExp("^" + I + "$"),
          Y = {
            ID: new RegExp("^#(" + I + ")"),
            CLASS: new RegExp("^\\.(" + I + ")"),
            TAG: new RegExp("^(" + I + "|[*])"),
            ATTR: new RegExp("^" + P),
            PSEUDO: new RegExp("^" + _),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + D + "*(even|odd|(([+-]|)(\\d*)n|)" + D + "*(?:([+-]|)" + D + "*(\\d+)|))" + D + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + O + ")$", "i"),
            needsContext: new RegExp("^" + D + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + D + "*((?:-\\d)?\\d*)" + D + "*\\)|)(?=[^-]|$)", "i")
          },
          U = /^(?:input|select|textarea|button)$/i,
          Z = /^h\d$/i,
          G = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
          q = /[+~]/,
          $ = new RegExp("\\\\[\\da-fA-F]{1,6}" + D + "?|\\\\([^\\r\\n\\f])", "g"),
          Q = function Q(t, e) {
            var n = "0x" + t.slice(1) - 65536;
            return e || (n < 0 ? String.fromCharCode(n + 65536) : String.fromCharCode(n >> 10 | 55296, 1023 & n | 56320));
          },
          J = function J() {
            lt();
          },
          X = ht(function (t) {
            return !0 === t.disabled && T(t, "fieldset");
          }, {
            dir: "parentNode",
            next: "legend"
          });
        try {
          f.apply(a = s.call(A.childNodes), A.childNodes), a[A.childNodes.length].nodeType;
        } catch (t) {
          f = {
            apply: function apply(t, e) {
              z.apply(t, s.call(e));
            },
            call: function call(t) {
              z.apply(t, s.call(arguments, 1));
            }
          };
        }
        function K(t, e, n, i) {
          var r,
            a,
            o,
            s,
            c,
            d,
            p,
            g = e && e.ownerDocument,
            b = e ? e.nodeType : 9;
          if (n = n || [], "string" != typeof t || !t || 1 !== b && 9 !== b && 11 !== b) return n;
          if (!i && (lt(e), e = e || l, u)) {
            if (11 !== b && (c = G.exec(t))) if (r = c[1]) {
              if (9 === b) {
                if (!(o = e.getElementById(r))) return n;
                if (o.id === r) return f.call(n, o), n;
              } else if (g && (o = g.getElementById(r)) && K.contains(e, o) && o.id === r) return f.call(n, o), n;
            } else {
              if (c[2]) return f.apply(n, e.getElementsByTagName(t)), n;
              if ((r = c[3]) && e.getElementsByClassName) return f.apply(n, e.getElementsByClassName(r)), n;
            }
            if (!(C[t + " "] || h && h.test(t))) {
              if (p = t, g = e, 1 === b && (R.test(t) || F.test(t))) {
                for ((g = q.test(t) && st(e.parentNode) || e) == e && m.scope || ((s = e.getAttribute("id")) ? s = _k.escapeSelector(s) : e.setAttribute("id", s = v)), a = (d = dt(t)).length; a--;) d[a] = (s ? "#" + s : ":scope") + " " + ut(d[a]);
                p = d.join(",");
              }
              try {
                return f.apply(n, g.querySelectorAll(p)), n;
              } catch (e) {
                C(t, !0);
              } finally {
                s === v && e.removeAttribute("id");
              }
            }
          }
          return bt(t.replace(E, "$1"), e, n, i);
        }
        function tt() {
          var t = [];
          return function n(i, r) {
            return t.push(i + " ") > e.cacheLength && delete n[t.shift()], n[i + " "] = r;
          };
        }
        function et(t) {
          return t[v] = !0, t;
        }
        function nt(t) {
          var e = l.createElement("fieldset");
          try {
            return !!t(e);
          } catch (t) {
            return !1;
          } finally {
            e.parentNode && e.parentNode.removeChild(e), e = null;
          }
        }
        function it(t) {
          return function (e) {
            return T(e, "input") && e.type === t;
          };
        }
        function rt(t) {
          return function (e) {
            return (T(e, "input") || T(e, "button")) && e.type === t;
          };
        }
        function at(t) {
          return function (e) {
            return "form" in e ? e.parentNode && !1 === e.disabled ? "label" in e ? "label" in e.parentNode ? e.parentNode.disabled === t : e.disabled === t : e.isDisabled === t || e.isDisabled !== !t && X(e) === t : e.disabled === t : "label" in e && e.disabled === t;
          };
        }
        function ot(t) {
          return et(function (e) {
            return e = +e, et(function (n, i) {
              for (var r, a = t([], n.length, e), o = a.length; o--;) n[r = a[o]] && (n[r] = !(i[r] = n[r]));
            });
          });
        }
        function st(t) {
          return t && void 0 !== t.getElementsByTagName && t;
        }
        function lt(t) {
          var n,
            i = t ? t.ownerDocument || t : A;
          return i != l && 9 === i.nodeType && i.documentElement ? (c = (l = i).documentElement, u = !_k.isXMLDoc(l), g = c.matches || c.webkitMatchesSelector || c.msMatchesSelector, c.msMatchesSelector && A != l && (n = l.defaultView) && n.top !== n && n.addEventListener("unload", J), m.getById = nt(function (t) {
            return c.appendChild(t).id = _k.expando, !l.getElementsByName || !l.getElementsByName(_k.expando).length;
          }), m.disconnectedMatch = nt(function (t) {
            return g.call(t, "*");
          }), m.scope = nt(function () {
            return l.querySelectorAll(":scope");
          }), m.cssHas = nt(function () {
            try {
              return l.querySelector(":has(*,:jqfake)"), !1;
            } catch (t) {
              return !0;
            }
          }), m.getById ? (e.filter.ID = function (t) {
            var e = t.replace($, Q);
            return function (t) {
              return t.getAttribute("id") === e;
            };
          }, e.find.ID = function (t, e) {
            if (void 0 !== e.getElementById && u) {
              var n = e.getElementById(t);
              return n ? [n] : [];
            }
          }) : (e.filter.ID = function (t) {
            var e = t.replace($, Q);
            return function (t) {
              var n = void 0 !== t.getAttributeNode && t.getAttributeNode("id");
              return n && n.value === e;
            };
          }, e.find.ID = function (t, e) {
            if (void 0 !== e.getElementById && u) {
              var n,
                i,
                r,
                a = e.getElementById(t);
              if (a) {
                if ((n = a.getAttributeNode("id")) && n.value === t) return [a];
                for (r = e.getElementsByName(t), i = 0; a = r[i++];) if ((n = a.getAttributeNode("id")) && n.value === t) return [a];
              }
              return [];
            }
          }), e.find.TAG = function (t, e) {
            return void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t) : e.querySelectorAll(t);
          }, e.find.CLASS = function (t, e) {
            if (void 0 !== e.getElementsByClassName && u) return e.getElementsByClassName(t);
          }, h = [], nt(function (t) {
            var e;
            c.appendChild(t).innerHTML = "<a id='" + v + "' href='' disabled='disabled'></a>" + "<select id='" + v + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>", t.querySelectorAll("[selected]").length || h.push("\\[" + D + "*(?:value|" + O + ")"), t.querySelectorAll("[id~=" + v + "-]").length || h.push("~="), t.querySelectorAll("a#" + v + "+*").length || h.push(".#.+[+~]"), t.querySelectorAll(":checked").length || h.push(":checked"), (e = l.createElement("input")).setAttribute("type", "hidden"), t.appendChild(e).setAttribute("name", "D"), c.appendChild(t).disabled = !0, 2 !== t.querySelectorAll(":disabled").length && h.push(":enabled", ":disabled"), (e = l.createElement("input")).setAttribute("name", ""), t.appendChild(e), t.querySelectorAll("[name='']").length || h.push("\\[" + D + "*name" + D + "*=" + D + "*(?:''|\"\")");
          }), m.cssHas || h.push(":has"), h = h.length && new RegExp(h.join("|")), M = function M(t, e) {
            if (t === e) return o = !0, 0;
            var n = !t.compareDocumentPosition - !e.compareDocumentPosition;
            return n || (1 & (n = (t.ownerDocument || t) == (e.ownerDocument || e) ? t.compareDocumentPosition(e) : 1) || !m.sortDetached && e.compareDocumentPosition(t) === n ? t === l || t.ownerDocument == A && K.contains(A, t) ? -1 : e === l || e.ownerDocument == A && K.contains(A, e) ? 1 : r ? d.call(r, t) - d.call(r, e) : 0 : 4 & n ? -1 : 1);
          }, l) : l;
        }
        for (t in K.matches = function (t, e) {
          return K(t, null, null, e);
        }, K.matchesSelector = function (t, e) {
          if (lt(t), u && !C[e + " "] && (!h || !h.test(e))) try {
            var n = g.call(t, e);
            if (n || m.disconnectedMatch || t.document && 11 !== t.document.nodeType) return n;
          } catch (t) {
            C(e, !0);
          }
          return K(e, l, null, [t]).length > 0;
        }, K.contains = function (t, e) {
          return (t.ownerDocument || t) != l && lt(t), _k.contains(t, e);
        }, K.attr = function (t, n) {
          (t.ownerDocument || t) != l && lt(t);
          var i = e.attrHandle[n.toLowerCase()],
            r = i && p.call(e.attrHandle, n.toLowerCase()) ? i(t, n, !u) : void 0;
          return void 0 !== r ? r : t.getAttribute(n);
        }, K.error = function (t) {
          throw new Error("Syntax error, unrecognized expression: " + t);
        }, _k.uniqueSort = function (t) {
          var e,
            n = [],
            i = 0,
            a = 0;
          if (o = !m.sortStable, r = !m.sortStable && s.call(t, 0), N.call(t, M), o) {
            for (; e = t[a++];) e === t[a] && (i = n.push(a));
            for (; i--;) L.call(t, n[i], 1);
          }
          return r = null, t;
        }, _k.fn.uniqueSort = function () {
          return this.pushStack(_k.uniqueSort(s.apply(this)));
        }, (e = _k.expr = {
          cacheLength: 50,
          createPseudo: et,
          match: Y,
          attrHandle: {},
          find: {},
          relative: {
            ">": {
              dir: "parentNode",
              first: !0
            },
            " ": {
              dir: "parentNode"
            },
            "+": {
              dir: "previousSibling",
              first: !0
            },
            "~": {
              dir: "previousSibling"
            }
          },
          preFilter: {
            ATTR: function ATTR(t) {
              return t[1] = t[1].replace($, Q), t[3] = (t[3] || t[4] || t[5] || "").replace($, Q), "~=" === t[2] && (t[3] = " " + t[3] + " "), t.slice(0, 4);
            },
            CHILD: function CHILD(t) {
              return t[1] = t[1].toLowerCase(), "nth" === t[1].slice(0, 3) ? (t[3] || K.error(t[0]), t[4] = +(t[4] ? t[5] + (t[6] || 1) : 2 * ("even" === t[3] || "odd" === t[3])), t[5] = +(t[7] + t[8] || "odd" === t[3])) : t[3] && K.error(t[0]), t;
            },
            PSEUDO: function PSEUDO(t) {
              var e,
                n = !t[6] && t[2];
              return Y.CHILD.test(t[0]) ? null : (t[3] ? t[2] = t[4] || t[5] || "" : n && B.test(n) && (e = dt(n, !0)) && (e = n.indexOf(")", n.length - e) - n.length) && (t[0] = t[0].slice(0, e), t[2] = n.slice(0, e)), t.slice(0, 3));
            }
          },
          filter: {
            TAG: function TAG(t) {
              var e = t.replace($, Q).toLowerCase();
              return "*" === t ? function () {
                return !0;
              } : function (t) {
                return T(t, e);
              };
            },
            CLASS: function CLASS(t) {
              var e = w[t + " "];
              return e || (e = new RegExp("(^|" + D + ")" + t + "(" + D + "|$)")) && w(t, function (t) {
                return e.test("string" == typeof t.className && t.className || void 0 !== t.getAttribute && t.getAttribute("class") || "");
              });
            },
            ATTR: function ATTR(t, e, n) {
              return function (i) {
                var r = K.attr(i, t);
                return null == r ? "!=" === e : !e || (r += "", "=" === e ? r === n : "!=" === e ? r !== n : "^=" === e ? n && 0 === r.indexOf(n) : "*=" === e ? n && r.indexOf(n) > -1 : "$=" === e ? n && r.slice(-n.length) === n : "~=" === e ? (" " + r.replace(H, " ") + " ").indexOf(n) > -1 : "|=" === e && (r === n || r.slice(0, n.length + 1) === n + "-"));
              };
            },
            CHILD: function CHILD(t, e, n, i, r) {
              var a = "nth" !== t.slice(0, 3),
                o = "last" !== t.slice(-4),
                s = "of-type" === e;
              return 1 === i && 0 === r ? function (t) {
                return !!t.parentNode;
              } : function (e, n, l) {
                var c,
                  d,
                  u,
                  h,
                  p,
                  g = a !== o ? "nextSibling" : "previousSibling",
                  f = e.parentNode,
                  m = s && e.nodeName.toLowerCase(),
                  y = !l && !s,
                  w = !1;
                if (f) {
                  if (a) {
                    for (; g;) {
                      for (u = e; u = u[g];) if (s ? T(u, m) : 1 === u.nodeType) return !1;
                      p = g = "only" === t && !p && "nextSibling";
                    }
                    return !0;
                  }
                  if (p = [o ? f.firstChild : f.lastChild], o && y) {
                    for (w = (h = (c = (d = f[v] || (f[v] = {}))[t] || [])[0] === b && c[1]) && c[2], u = h && f.childNodes[h]; u = ++h && u && u[g] || (w = h = 0) || p.pop();) if (1 === u.nodeType && ++w && u === e) {
                      d[t] = [b, h, w];
                      break;
                    }
                  } else if (y && (w = h = (c = (d = e[v] || (e[v] = {}))[t] || [])[0] === b && c[1]), !1 === w) for (; (u = ++h && u && u[g] || (w = h = 0) || p.pop()) && (!(s ? T(u, m) : 1 === u.nodeType) || !++w || (y && ((d = u[v] || (u[v] = {}))[t] = [b, w]), u !== e)););
                  return (w -= r) === i || w % i == 0 && w / i >= 0;
                }
              };
            },
            PSEUDO: function PSEUDO(t, n) {
              var i,
                r = e.pseudos[t] || e.setFilters[t.toLowerCase()] || K.error("unsupported pseudo: " + t);
              return r[v] ? r(n) : r.length > 1 ? (i = [t, t, "", n], e.setFilters.hasOwnProperty(t.toLowerCase()) ? et(function (t, e) {
                for (var i, a = r(t, n), o = a.length; o--;) t[i = d.call(t, a[o])] = !(e[i] = a[o]);
              }) : function (t) {
                return r(t, 0, i);
              }) : r;
            }
          },
          pseudos: {
            not: et(function (t) {
              var e = [],
                n = [],
                i = vt(t.replace(E, "$1"));
              return i[v] ? et(function (t, e, n, r) {
                for (var a, o = i(t, null, r, []), s = t.length; s--;) (a = o[s]) && (t[s] = !(e[s] = a));
              }) : function (t, r, a) {
                return e[0] = t, i(e, null, a, n), e[0] = null, !n.pop();
              };
            }),
            has: et(function (t) {
              return function (e) {
                return K(t, e).length > 0;
              };
            }),
            contains: et(function (t) {
              return t = t.replace($, Q), function (e) {
                return (e.textContent || _k.text(e)).indexOf(t) > -1;
              };
            }),
            lang: et(function (t) {
              return W.test(t || "") || K.error("unsupported lang: " + t), t = t.replace($, Q).toLowerCase(), function (e) {
                var n;
                do {
                  if (n = u ? e.lang : e.getAttribute("xml:lang") || e.getAttribute("lang")) return (n = n.toLowerCase()) === t || 0 === n.indexOf(t + "-");
                } while ((e = e.parentNode) && 1 === e.nodeType);
                return !1;
              };
            }),
            target: function target(t) {
              var e = n.location && n.location.hash;
              return e && e.slice(1) === t.id;
            },
            root: function root(t) {
              return t === c;
            },
            focus: function focus(t) {
              return t === function () {
                try {
                  return l.activeElement;
                } catch (t) {}
              }() && l.hasFocus() && !!(t.type || t.href || ~t.tabIndex);
            },
            enabled: at(!1),
            disabled: at(!0),
            checked: function checked(t) {
              return T(t, "input") && !!t.checked || T(t, "option") && !!t.selected;
            },
            selected: function selected(t) {
              return t.parentNode && t.parentNode.selectedIndex, !0 === t.selected;
            },
            empty: function empty(t) {
              for (t = t.firstChild; t; t = t.nextSibling) if (t.nodeType < 6) return !1;
              return !0;
            },
            parent: function parent(t) {
              return !e.pseudos.empty(t);
            },
            header: function header(t) {
              return Z.test(t.nodeName);
            },
            input: function input(t) {
              return U.test(t.nodeName);
            },
            button: function button(t) {
              return T(t, "input") && "button" === t.type || T(t, "button");
            },
            text: function text(t) {
              var e;
              return T(t, "input") && "text" === t.type && (null == (e = t.getAttribute("type")) || "text" === e.toLowerCase());
            },
            first: ot(function () {
              return [0];
            }),
            last: ot(function (t, e) {
              return [e - 1];
            }),
            eq: ot(function (t, e, n) {
              return [n < 0 ? n + e : n];
            }),
            even: ot(function (t, e) {
              for (var n = 0; n < e; n += 2) t.push(n);
              return t;
            }),
            odd: ot(function (t, e) {
              for (var n = 1; n < e; n += 2) t.push(n);
              return t;
            }),
            lt: ot(function (t, e, n) {
              var i;
              for (i = n < 0 ? n + e : n > e ? e : n; --i >= 0;) t.push(i);
              return t;
            }),
            gt: ot(function (t, e, n) {
              for (var i = n < 0 ? n + e : n; ++i < e;) t.push(i);
              return t;
            })
          }
        }).pseudos.nth = e.pseudos.eq, {
          radio: !0,
          checkbox: !0,
          file: !0,
          password: !0,
          image: !0
        }) e.pseudos[t] = it(t);
        for (t in {
          submit: !0,
          reset: !0
        }) e.pseudos[t] = rt(t);
        function ct() {}
        function dt(t, n) {
          var i,
            r,
            a,
            o,
            s,
            l,
            c,
            d = x[t + " "];
          if (d) return n ? 0 : d.slice(0);
          for (s = t, l = [], c = e.preFilter; s;) {
            for (o in i && !(r = V.exec(s)) || (r && (s = s.slice(r[0].length) || s), l.push(a = [])), i = !1, (r = F.exec(s)) && (i = r.shift(), a.push({
              value: i,
              type: r[0].replace(E, " ")
            }), s = s.slice(i.length)), e.filter) !(r = Y[o].exec(s)) || c[o] && !(r = c[o](r)) || (i = r.shift(), a.push({
              value: i,
              type: o,
              matches: r
            }), s = s.slice(i.length));
            if (!i) break;
          }
          return n ? s.length : s ? K.error(t) : x(t, l).slice(0);
        }
        function ut(t) {
          for (var e = 0, n = t.length, i = ""; e < n; e++) i += t[e].value;
          return i;
        }
        function ht(t, e, n) {
          var i = e.dir,
            r = e.next,
            a = r || i,
            o = n && "parentNode" === a,
            s = y++;
          return e.first ? function (e, n, r) {
            for (; e = e[i];) if (1 === e.nodeType || o) return t(e, n, r);
            return !1;
          } : function (e, n, l) {
            var c,
              d,
              u = [b, s];
            if (l) {
              for (; e = e[i];) if ((1 === e.nodeType || o) && t(e, n, l)) return !0;
            } else for (; e = e[i];) if (1 === e.nodeType || o) if (d = e[v] || (e[v] = {}), r && T(e, r)) e = e[i] || e;else {
              if ((c = d[a]) && c[0] === b && c[1] === s) return u[2] = c[2];
              if (d[a] = u, u[2] = t(e, n, l)) return !0;
            }
            return !1;
          };
        }
        function pt(t) {
          return t.length > 1 ? function (e, n, i) {
            for (var r = t.length; r--;) if (!t[r](e, n, i)) return !1;
            return !0;
          } : t[0];
        }
        function gt(t, e, n, i, r) {
          for (var a, o = [], s = 0, l = t.length, c = null != e; s < l; s++) (a = t[s]) && (n && !n(a, i, r) || (o.push(a), c && e.push(s)));
          return o;
        }
        function ft(t, e, n, i, r, a) {
          return i && !i[v] && (i = ft(i)), r && !r[v] && (r = ft(r, a)), et(function (a, o, s, l) {
            var c,
              u,
              h,
              p,
              g = [],
              m = [],
              v = o.length,
              b = a || function (t, e, n) {
                for (var i = 0, r = e.length; i < r; i++) K(t, e[i], n);
                return n;
              }(e || "*", s.nodeType ? [s] : s, []),
              y = !t || !a && e ? b : gt(b, g, t, s, l);
            if (n ? n(y, p = r || (a ? t : v || i) ? [] : o, s, l) : p = y, i) for (c = gt(p, m), i(c, [], s, l), u = c.length; u--;) (h = c[u]) && (p[m[u]] = !(y[m[u]] = h));
            if (a) {
              if (r || t) {
                if (r) {
                  for (c = [], u = p.length; u--;) (h = p[u]) && c.push(y[u] = h);
                  r(null, p = [], c, l);
                }
                for (u = p.length; u--;) (h = p[u]) && (c = r ? d.call(a, h) : g[u]) > -1 && (a[c] = !(o[c] = h));
              }
            } else p = gt(p === o ? p.splice(v, p.length) : p), r ? r(null, o, p, l) : f.apply(o, p);
          });
        }
        function mt(t) {
          for (var n, r, a, o = t.length, s = e.relative[t[0].type], l = s || e.relative[" "], c = s ? 1 : 0, u = ht(function (t) {
              return t === n;
            }, l, !0), h = ht(function (t) {
              return d.call(n, t) > -1;
            }, l, !0), p = [function (t, e, r) {
              var a = !s && (r || e != i) || ((n = e).nodeType ? u(t, e, r) : h(t, e, r));
              return n = null, a;
            }]; c < o; c++) if (r = e.relative[t[c].type]) p = [ht(pt(p), r)];else {
            if ((r = e.filter[t[c].type].apply(null, t[c].matches))[v]) {
              for (a = ++c; a < o && !e.relative[t[a].type]; a++);
              return ft(c > 1 && pt(p), c > 1 && ut(t.slice(0, c - 1).concat({
                value: " " === t[c - 2].type ? "*" : ""
              })).replace(E, "$1"), r, c < a && mt(t.slice(c, a)), a < o && mt(t = t.slice(a)), a < o && ut(t));
            }
            p.push(r);
          }
          return pt(p);
        }
        function vt(t, n) {
          var r,
            a = [],
            o = [],
            s = j[t + " "];
          if (!s) {
            for (n || (n = dt(t)), r = n.length; r--;) (s = mt(n[r]))[v] ? a.push(s) : o.push(s);
            (s = j(t, function (t, n) {
              var r = n.length > 0,
                a = t.length > 0,
                o = function o(_o2, s, c, d, h) {
                  var p,
                    g,
                    m,
                    v = 0,
                    y = "0",
                    w = _o2 && [],
                    x = [],
                    j = i,
                    C = _o2 || a && e.find.TAG("*", h),
                    M = b += null == j ? 1 : Math.random() || .1,
                    O = C.length;
                  for (h && (i = s == l || s || h); y !== O && null != (p = C[y]); y++) {
                    if (a && p) {
                      for (g = 0, s || p.ownerDocument == l || (lt(p), c = !u); m = t[g++];) if (m(p, s || l, c)) {
                        f.call(d, p);
                        break;
                      }
                      h && (b = M);
                    }
                    r && ((p = !m && p) && v--, _o2 && w.push(p));
                  }
                  if (v += y, r && y !== v) {
                    for (g = 0; m = n[g++];) m(w, x, s, c);
                    if (_o2) {
                      if (v > 0) for (; y--;) w[y] || x[y] || (x[y] = S.call(d));
                      x = gt(x);
                    }
                    f.apply(d, x), h && !_o2 && x.length > 0 && v + n.length > 1 && _k.uniqueSort(d);
                  }
                  return h && (b = M, i = j), w;
                };
              return r ? et(o) : o;
            }(o, a))).selector = t;
          }
          return s;
        }
        function bt(t, n, i, r) {
          var a,
            o,
            s,
            l,
            c,
            d = "function" == typeof t && t,
            h = !r && dt(t = d.selector || t);
          if (i = i || [], 1 === h.length) {
            if ((o = h[0] = h[0].slice(0)).length > 2 && "ID" === (s = o[0]).type && 9 === n.nodeType && u && e.relative[o[1].type]) {
              if (!(n = (e.find.ID(s.matches[0].replace($, Q), n) || [])[0])) return i;
              d && (n = n.parentNode), t = t.slice(o.shift().value.length);
            }
            for (a = Y.needsContext.test(t) ? 0 : o.length; a-- && (s = o[a], !e.relative[l = s.type]);) if ((c = e.find[l]) && (r = c(s.matches[0].replace($, Q), q.test(o[0].type) && st(n.parentNode) || n))) {
              if (o.splice(a, 1), !(t = r.length && ut(o))) return f.apply(i, r), i;
              break;
            }
          }
          return (d || vt(t, h))(r, n, !u, i, !n || q.test(t) && st(n.parentNode) || n), i;
        }
        ct.prototype = e.filters = e.pseudos, e.setFilters = new ct(), m.sortStable = v.split("").sort(M).join("") === v, lt(), m.sortDetached = nt(function (t) {
          return 1 & t.compareDocumentPosition(l.createElement("fieldset"));
        }), _k.find = K, _k.expr[":"] = _k.expr.pseudos, _k.unique = _k.uniqueSort, K.compile = vt, K.select = bt, K.setDocument = lt, K.tokenize = dt, K.escape = _k.escapeSelector, K.getText = _k.text, K.isXML = _k.isXMLDoc, K.selectors = _k.expr, K.support = _k.support, K.uniqueSort = _k.uniqueSort;
      }();
      var _ = function _(t, e, n) {
          for (var i = [], r = void 0 !== n; (t = t[e]) && 9 !== t.nodeType;) if (1 === t.nodeType) {
            if (r && _k(t).is(n)) break;
            i.push(t);
          }
          return i;
        },
        H = function H(t, e) {
          for (var n = []; t; t = t.nextSibling) 1 === t.nodeType && t !== e && n.push(t);
          return n;
        },
        V = _k.expr.match.needsContext,
        F = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
      function R(t, e, n) {
        return v(e) ? _k.grep(t, function (t, i) {
          return !!e.call(t, i, t) !== n;
        }) : e.nodeType ? _k.grep(t, function (t) {
          return t === e !== n;
        }) : "string" != typeof e ? _k.grep(t, function (t) {
          return d.call(e, t) > -1 !== n;
        }) : _k.filter(e, t, n);
      }
      _k.filter = function (t, e, n) {
        var i = e[0];
        return n && (t = ":not(" + t + ")"), 1 === e.length && 1 === i.nodeType ? _k.find.matchesSelector(i, t) ? [i] : [] : _k.find.matches(t, _k.grep(e, function (t) {
          return 1 === t.nodeType;
        }));
      }, _k.fn.extend({
        find: function find(t) {
          var e,
            n,
            i = this.length,
            r = this;
          if ("string" != typeof t) return this.pushStack(_k(t).filter(function () {
            for (e = 0; e < i; e++) if (_k.contains(r[e], this)) return !0;
          }));
          for (n = this.pushStack([]), e = 0; e < i; e++) _k.find(t, r[e], n);
          return i > 1 ? _k.uniqueSort(n) : n;
        },
        filter: function filter(t) {
          return this.pushStack(R(this, t || [], !1));
        },
        not: function not(t) {
          return this.pushStack(R(this, t || [], !0));
        },
        is: function is(t) {
          return !!R(this, "string" == typeof t && V.test(t) ? _k(t) : t || [], !1).length;
        }
      });
      var B,
        W = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
      (_k.fn.init = function (t, e, n) {
        var i, r;
        if (!t) return this;
        if (n = n || B, "string" == typeof t) {
          if (!(i = "<" === t[0] && ">" === t[t.length - 1] && t.length >= 3 ? [null, t, null] : W.exec(t)) || !i[1] && e) return !e || e.jquery ? (e || n).find(t) : this.constructor(e).find(t);
          if (i[1]) {
            if (e = e instanceof _k ? e[0] : e, _k.merge(this, _k.parseHTML(i[1], e && e.nodeType ? e.ownerDocument || e : y, !0)), F.test(i[1]) && _k.isPlainObject(e)) for (i in e) v(this[i]) ? this[i](e[i]) : this.attr(i, e[i]);
            return this;
          }
          return (r = y.getElementById(i[2])) && (this[0] = r, this.length = 1), this;
        }
        return t.nodeType ? (this[0] = t, this.length = 1, this) : v(t) ? void 0 !== n.ready ? n.ready(t) : t(_k) : _k.makeArray(t, this);
      }).prototype = _k.fn, B = _k(y);
      var Y = /^(?:parents|prev(?:Until|All))/,
        U = {
          children: !0,
          contents: !0,
          next: !0,
          prev: !0
        };
      function Z(t, e) {
        for (; (t = t[e]) && 1 !== t.nodeType;);
        return t;
      }
      _k.fn.extend({
        has: function has(t) {
          var e = _k(t, this),
            n = e.length;
          return this.filter(function () {
            for (var t = 0; t < n; t++) if (_k.contains(this, e[t])) return !0;
          });
        },
        closest: function closest(t, e) {
          var n,
            i = 0,
            r = this.length,
            a = [],
            o = "string" != typeof t && _k(t);
          if (!V.test(t)) for (; i < r; i++) for (n = this[i]; n && n !== e; n = n.parentNode) if (n.nodeType < 11 && (o ? o.index(n) > -1 : 1 === n.nodeType && _k.find.matchesSelector(n, t))) {
            a.push(n);
            break;
          }
          return this.pushStack(a.length > 1 ? _k.uniqueSort(a) : a);
        },
        index: function index(t) {
          return t ? "string" == typeof t ? d.call(_k(t), this[0]) : d.call(this, t.jquery ? t[0] : t) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
        },
        add: function add(t, e) {
          return this.pushStack(_k.uniqueSort(_k.merge(this.get(), _k(t, e))));
        },
        addBack: function addBack(t) {
          return this.add(null == t ? this.prevObject : this.prevObject.filter(t));
        }
      }), _k.each({
        parent: function parent(t) {
          var e = t.parentNode;
          return e && 11 !== e.nodeType ? e : null;
        },
        parents: function parents(t) {
          return _(t, "parentNode");
        },
        parentsUntil: function parentsUntil(t, e, n) {
          return _(t, "parentNode", n);
        },
        next: function next(t) {
          return Z(t, "nextSibling");
        },
        prev: function prev(t) {
          return Z(t, "previousSibling");
        },
        nextAll: function nextAll(t) {
          return _(t, "nextSibling");
        },
        prevAll: function prevAll(t) {
          return _(t, "previousSibling");
        },
        nextUntil: function nextUntil(t, e, n) {
          return _(t, "nextSibling", n);
        },
        prevUntil: function prevUntil(t, e, n) {
          return _(t, "previousSibling", n);
        },
        siblings: function siblings(t) {
          return H((t.parentNode || {}).firstChild, t);
        },
        children: function children(t) {
          return H(t.firstChild);
        },
        contents: function contents(t) {
          return null != t.contentDocument && o(t.contentDocument) ? t.contentDocument : (T(t, "template") && (t = t.content || t), _k.merge([], t.childNodes));
        }
      }, function (t, e) {
        _k.fn[t] = function (n, i) {
          var r = _k.map(this, e, n);
          return "Until" !== t.slice(-5) && (i = n), i && "string" == typeof i && (r = _k.filter(i, r)), this.length > 1 && (U[t] || _k.uniqueSort(r), Y.test(t) && r.reverse()), this.pushStack(r);
        };
      });
      var G = /[^\x20\t\r\n\f]+/g;
      function q(t) {
        return t;
      }
      function $(t) {
        throw t;
      }
      function Q(t, e, n, i) {
        var r;
        try {
          t && v(r = t.promise) ? r.call(t).done(e).fail(n) : t && v(r = t.then) ? r.call(t, e, n) : e.apply(void 0, [t].slice(i));
        } catch (t) {
          n.apply(void 0, [t]);
        }
      }
      _k.Callbacks = function (t) {
        t = "string" == typeof t ? function (t) {
          var e = {};
          return _k.each(t.match(G) || [], function (t, n) {
            e[n] = !0;
          }), e;
        }(t) : _k.extend({}, t);
        var e,
          n,
          i,
          r,
          a = [],
          o = [],
          s = -1,
          l = function l() {
            for (r = r || t.once, i = e = !0; o.length; s = -1) for (n = o.shift(); ++s < a.length;) !1 === a[s].apply(n[0], n[1]) && t.stopOnFalse && (s = a.length, n = !1);
            t.memory || (n = !1), e = !1, r && (a = n ? [] : "");
          },
          c = {
            add: function add() {
              return a && (n && !e && (s = a.length - 1, o.push(n)), function e(n) {
                _k.each(n, function (n, i) {
                  v(i) ? t.unique && c.has(i) || a.push(i) : i && i.length && "string" !== j(i) && e(i);
                });
              }(arguments), n && !e && l()), this;
            },
            remove: function remove() {
              return _k.each(arguments, function (t, e) {
                for (var n; (n = _k.inArray(e, a, n)) > -1;) a.splice(n, 1), n <= s && s--;
              }), this;
            },
            has: function has(t) {
              return t ? _k.inArray(t, a) > -1 : a.length > 0;
            },
            empty: function empty() {
              return a && (a = []), this;
            },
            disable: function disable() {
              return r = o = [], a = n = "", this;
            },
            disabled: function disabled() {
              return !a;
            },
            lock: function lock() {
              return r = o = [], n || e || (a = n = ""), this;
            },
            locked: function locked() {
              return !!r;
            },
            fireWith: function fireWith(t, n) {
              return r || (n = [t, (n = n || []).slice ? n.slice() : n], o.push(n), e || l()), this;
            },
            fire: function fire() {
              return c.fireWith(this, arguments), this;
            },
            fired: function fired() {
              return !!i;
            }
          };
        return c;
      }, _k.extend({
        Deferred: function Deferred(t) {
          var e = [["notify", "progress", _k.Callbacks("memory"), _k.Callbacks("memory"), 2], ["resolve", "done", _k.Callbacks("once memory"), _k.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", _k.Callbacks("once memory"), _k.Callbacks("once memory"), 1, "rejected"]],
            i = "pending",
            r = {
              state: function state() {
                return i;
              },
              always: function always() {
                return a.done(arguments).fail(arguments), this;
              },
              catch: function _catch(t) {
                return r.then(null, t);
              },
              pipe: function pipe() {
                var t = arguments;
                return _k.Deferred(function (n) {
                  _k.each(e, function (e, i) {
                    var r = v(t[i[4]]) && t[i[4]];
                    a[i[1]](function () {
                      var t = r && r.apply(this, arguments);
                      t && v(t.promise) ? t.promise().progress(n.notify).done(n.resolve).fail(n.reject) : n[i[0] + "With"](this, r ? [t] : arguments);
                    });
                  }), t = null;
                }).promise();
              },
              then: function then(t, i, r) {
                var a = 0;
                function o(t, e, i, r) {
                  return function () {
                    var s = this,
                      l = arguments,
                      c = function c() {
                        var n, c;
                        if (!(t < a)) {
                          if ((n = i.apply(s, l)) === e.promise()) throw new TypeError("Thenable self-resolution");
                          c = n && ("object" == typeof n || "function" == typeof n) && n.then, v(c) ? r ? c.call(n, o(a, e, q, r), o(a, e, $, r)) : (a++, c.call(n, o(a, e, q, r), o(a, e, $, r), o(a, e, q, e.notifyWith))) : (i !== q && (s = void 0, l = [n]), (r || e.resolveWith)(s, l));
                        }
                      },
                      d = r ? c : function () {
                        try {
                          c();
                        } catch (n) {
                          _k.Deferred.exceptionHook && _k.Deferred.exceptionHook(n, d.error), t + 1 >= a && (i !== $ && (s = void 0, l = [n]), e.rejectWith(s, l));
                        }
                      };
                    t ? d() : (_k.Deferred.getErrorHook ? d.error = _k.Deferred.getErrorHook() : _k.Deferred.getStackHook && (d.error = _k.Deferred.getStackHook()), n.setTimeout(d));
                  };
                }
                return _k.Deferred(function (n) {
                  e[0][3].add(o(0, n, v(r) ? r : q, n.notifyWith)), e[1][3].add(o(0, n, v(t) ? t : q)), e[2][3].add(o(0, n, v(i) ? i : $));
                }).promise();
              },
              promise: function promise(t) {
                return null != t ? _k.extend(t, r) : r;
              }
            },
            a = {};
          return _k.each(e, function (t, n) {
            var o = n[2],
              s = n[5];
            r[n[1]] = o.add, s && o.add(function () {
              i = s;
            }, e[3 - t][2].disable, e[3 - t][3].disable, e[0][2].lock, e[0][3].lock), o.add(n[3].fire), a[n[0]] = function () {
              return a[n[0] + "With"](this === a ? void 0 : this, arguments), this;
            }, a[n[0] + "With"] = o.fireWith;
          }), r.promise(a), t && t.call(a, a), a;
        },
        when: function when(t) {
          var e = arguments.length,
            n = e,
            i = Array(n),
            r = s.call(arguments),
            a = _k.Deferred(),
            o = function o(t) {
              return function (n) {
                i[t] = this, r[t] = arguments.length > 1 ? s.call(arguments) : n, --e || a.resolveWith(i, r);
              };
            };
          if (e <= 1 && (Q(t, a.done(o(n)).resolve, a.reject, !e), "pending" === a.state() || v(r[n] && r[n].then))) return a.then();
          for (; n--;) Q(r[n], o(n), a.reject);
          return a.promise();
        }
      });
      var J = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
      _k.Deferred.exceptionHook = function (t, e) {
        n.console && n.console.warn && t && J.test(t.name) && n.console.warn("jQuery.Deferred exception: " + t.message, t.stack, e);
      }, _k.readyException = function (t) {
        n.setTimeout(function () {
          throw t;
        });
      };
      var X = _k.Deferred();
      function K() {
        y.removeEventListener("DOMContentLoaded", K), n.removeEventListener("load", K), _k.ready();
      }
      _k.fn.ready = function (t) {
        return X.then(t).catch(function (t) {
          _k.readyException(t);
        }), this;
      }, _k.extend({
        isReady: !1,
        readyWait: 1,
        ready: function ready(t) {
          (!0 === t ? --_k.readyWait : _k.isReady) || (_k.isReady = !0, !0 !== t && --_k.readyWait > 0 || X.resolveWith(y, [_k]));
        }
      }), _k.ready.then = X.then, "complete" === y.readyState || "loading" !== y.readyState && !y.documentElement.doScroll ? n.setTimeout(_k.ready) : (y.addEventListener("DOMContentLoaded", K), n.addEventListener("load", K));
      var _tt = function tt(t, e, n, i, r, a, o) {
          var s = 0,
            l = t.length,
            c = null == n;
          if ("object" === j(n)) for (s in r = !0, n) _tt(t, e, s, n[s], !0, a, o);else if (void 0 !== i && (r = !0, v(i) || (o = !0), c && (o ? (e.call(t, i), e = null) : (c = e, e = function e(t, _e2, n) {
            return c.call(_k(t), n);
          })), e)) for (; s < l; s++) e(t[s], n, o ? i : i.call(t[s], s, e(t[s], n)));
          return r ? t : c ? e.call(t) : l ? e(t[0], n) : a;
        },
        et = /^-ms-/,
        nt = /-([a-z])/g;
      function it(t, e) {
        return e.toUpperCase();
      }
      function rt(t) {
        return t.replace(et, "ms-").replace(nt, it);
      }
      var at = function at(t) {
        return 1 === t.nodeType || 9 === t.nodeType || !+t.nodeType;
      };
      function ot() {
        this.expando = _k.expando + ot.uid++;
      }
      ot.uid = 1, ot.prototype = {
        cache: function cache(t) {
          var e = t[this.expando];
          return e || (e = {}, at(t) && (t.nodeType ? t[this.expando] = e : Object.defineProperty(t, this.expando, {
            value: e,
            configurable: !0
          }))), e;
        },
        set: function set(t, e, n) {
          var i,
            r = this.cache(t);
          if ("string" == typeof e) r[rt(e)] = n;else for (i in e) r[rt(i)] = e[i];
          return r;
        },
        get: function get(t, e) {
          return void 0 === e ? this.cache(t) : t[this.expando] && t[this.expando][rt(e)];
        },
        access: function access(t, e, n) {
          return void 0 === e || e && "string" == typeof e && void 0 === n ? this.get(t, e) : (this.set(t, e, n), void 0 !== n ? n : e);
        },
        remove: function remove(t, e) {
          var n,
            i = t[this.expando];
          if (void 0 !== i) {
            if (void 0 !== e) {
              n = (e = Array.isArray(e) ? e.map(rt) : (e = rt(e)) in i ? [e] : e.match(G) || []).length;
              for (; n--;) delete i[e[n]];
            }
            (void 0 === e || _k.isEmptyObject(i)) && (t.nodeType ? t[this.expando] = void 0 : delete t[this.expando]);
          }
        },
        hasData: function hasData(t) {
          var e = t[this.expando];
          return void 0 !== e && !_k.isEmptyObject(e);
        }
      };
      var st = new ot(),
        lt = new ot(),
        ct = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
        dt = /[A-Z]/g;
      function ut(t, e, n) {
        var i;
        if (void 0 === n && 1 === t.nodeType) if (i = "data-" + e.replace(dt, "-$&").toLowerCase(), "string" == typeof (n = t.getAttribute(i))) {
          try {
            n = function (t) {
              return "true" === t || "false" !== t && ("null" === t ? null : t === +t + "" ? +t : ct.test(t) ? JSON.parse(t) : t);
            }(n);
          } catch (t) {}
          lt.set(t, e, n);
        } else n = void 0;
        return n;
      }
      _k.extend({
        hasData: function hasData(t) {
          return lt.hasData(t) || st.hasData(t);
        },
        data: function data(t, e, n) {
          return lt.access(t, e, n);
        },
        removeData: function removeData(t, e) {
          lt.remove(t, e);
        },
        _data: function _data(t, e, n) {
          return st.access(t, e, n);
        },
        _removeData: function _removeData(t, e) {
          st.remove(t, e);
        }
      }), _k.fn.extend({
        data: function data(t, e) {
          var n,
            i,
            r,
            a = this[0],
            o = a && a.attributes;
          if (void 0 === t) {
            if (this.length && (r = lt.get(a), 1 === a.nodeType && !st.get(a, "hasDataAttrs"))) {
              for (n = o.length; n--;) o[n] && 0 === (i = o[n].name).indexOf("data-") && (i = rt(i.slice(5)), ut(a, i, r[i]));
              st.set(a, "hasDataAttrs", !0);
            }
            return r;
          }
          return "object" == typeof t ? this.each(function () {
            lt.set(this, t);
          }) : _tt(this, function (e) {
            var n;
            if (a && void 0 === e) return void 0 !== (n = lt.get(a, t)) || void 0 !== (n = ut(a, t)) ? n : void 0;
            this.each(function () {
              lt.set(this, t, e);
            });
          }, null, e, arguments.length > 1, null, !0);
        },
        removeData: function removeData(t) {
          return this.each(function () {
            lt.remove(this, t);
          });
        }
      }), _k.extend({
        queue: function queue(t, e, n) {
          var i;
          if (t) return e = (e || "fx") + "queue", i = st.get(t, e), n && (!i || Array.isArray(n) ? i = st.access(t, e, _k.makeArray(n)) : i.push(n)), i || [];
        },
        dequeue: function dequeue(t, e) {
          e = e || "fx";
          var n = _k.queue(t, e),
            i = n.length,
            r = n.shift(),
            a = _k._queueHooks(t, e);
          "inprogress" === r && (r = n.shift(), i--), r && ("fx" === e && n.unshift("inprogress"), delete a.stop, r.call(t, function () {
            _k.dequeue(t, e);
          }, a)), !i && a && a.empty.fire();
        },
        _queueHooks: function _queueHooks(t, e) {
          var n = e + "queueHooks";
          return st.get(t, n) || st.access(t, n, {
            empty: _k.Callbacks("once memory").add(function () {
              st.remove(t, [e + "queue", n]);
            })
          });
        }
      }), _k.fn.extend({
        queue: function queue(t, e) {
          var n = 2;
          return "string" != typeof t && (e = t, t = "fx", n--), arguments.length < n ? _k.queue(this[0], t) : void 0 === e ? this : this.each(function () {
            var n = _k.queue(this, t, e);
            _k._queueHooks(this, t), "fx" === t && "inprogress" !== n[0] && _k.dequeue(this, t);
          });
        },
        dequeue: function dequeue(t) {
          return this.each(function () {
            _k.dequeue(this, t);
          });
        },
        clearQueue: function clearQueue(t) {
          return this.queue(t || "fx", []);
        },
        promise: function promise(t, e) {
          var n,
            i = 1,
            r = _k.Deferred(),
            a = this,
            o = this.length,
            s = function s() {
              --i || r.resolveWith(a, [a]);
            };
          for ("string" != typeof t && (e = t, t = void 0), t = t || "fx"; o--;) (n = st.get(a[o], t + "queueHooks")) && n.empty && (i++, n.empty.add(s));
          return s(), r.promise(e);
        }
      });
      var ht = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
        pt = new RegExp("^(?:([+-])=|)(" + ht + ")([a-z%]*)$", "i"),
        gt = ["Top", "Right", "Bottom", "Left"],
        ft = y.documentElement,
        mt = function mt(t) {
          return _k.contains(t.ownerDocument, t);
        },
        vt = {
          composed: !0
        };
      ft.getRootNode && (mt = function mt(t) {
        return _k.contains(t.ownerDocument, t) || t.getRootNode(vt) === t.ownerDocument;
      });
      var bt = function bt(t, e) {
        return "none" === (t = e || t).style.display || "" === t.style.display && mt(t) && "none" === _k.css(t, "display");
      };
      function yt(t, e, n, i) {
        var r,
          a,
          o = 20,
          s = i ? function () {
            return i.cur();
          } : function () {
            return _k.css(t, e, "");
          },
          l = s(),
          c = n && n[3] || (_k.cssNumber[e] ? "" : "px"),
          d = t.nodeType && (_k.cssNumber[e] || "px" !== c && +l) && pt.exec(_k.css(t, e));
        if (d && d[3] !== c) {
          for (l /= 2, c = c || d[3], d = +l || 1; o--;) _k.style(t, e, d + c), (1 - a) * (1 - (a = s() / l || .5)) <= 0 && (o = 0), d /= a;
          d *= 2, _k.style(t, e, d + c), n = n || [];
        }
        return n && (d = +d || +l || 0, r = n[1] ? d + (n[1] + 1) * n[2] : +n[2], i && (i.unit = c, i.start = d, i.end = r)), r;
      }
      var wt = {};
      function xt(t) {
        var e,
          n = t.ownerDocument,
          i = t.nodeName,
          r = wt[i];
        return r || (e = n.body.appendChild(n.createElement(i)), r = _k.css(e, "display"), e.parentNode.removeChild(e), "none" === r && (r = "block"), wt[i] = r, r);
      }
      function jt(t, e) {
        for (var n, i, r = [], a = 0, o = t.length; a < o; a++) (i = t[a]).style && (n = i.style.display, e ? ("none" === n && (r[a] = st.get(i, "display") || null, r[a] || (i.style.display = "")), "" === i.style.display && bt(i) && (r[a] = xt(i))) : "none" !== n && (r[a] = "none", st.set(i, "display", n)));
        for (a = 0; a < o; a++) null != r[a] && (t[a].style.display = r[a]);
        return t;
      }
      _k.fn.extend({
        show: function show() {
          return jt(this, !0);
        },
        hide: function hide() {
          return jt(this);
        },
        toggle: function toggle(t) {
          return "boolean" == typeof t ? t ? this.show() : this.hide() : this.each(function () {
            bt(this) ? _k(this).show() : _k(this).hide();
          });
        }
      });
      var Ct,
        Mt,
        kt = /^(?:checkbox|radio)$/i,
        Ot = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
        Tt = /^$|^module$|\/(?:java|ecma)script/i;
      Ct = y.createDocumentFragment().appendChild(y.createElement("div")), (Mt = y.createElement("input")).setAttribute("type", "radio"), Mt.setAttribute("checked", "checked"), Mt.setAttribute("name", "t"), Ct.appendChild(Mt), m.checkClone = Ct.cloneNode(!0).cloneNode(!0).lastChild.checked, Ct.innerHTML = "<textarea>x</textarea>", m.noCloneChecked = !!Ct.cloneNode(!0).lastChild.defaultValue, Ct.innerHTML = "<option></option>", m.option = !!Ct.lastChild;
      var St = {
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""]
      };
      function Nt(t, e) {
        var n;
        return n = void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e || "*") : void 0 !== t.querySelectorAll ? t.querySelectorAll(e || "*") : [], void 0 === e || e && T(t, e) ? _k.merge([t], n) : n;
      }
      function Lt(t, e) {
        for (var n = 0, i = t.length; n < i; n++) st.set(t[n], "globalEval", !e || st.get(e[n], "globalEval"));
      }
      St.tbody = St.tfoot = St.colgroup = St.caption = St.thead, St.th = St.td, m.option || (St.optgroup = St.option = [1, "<select multiple='multiple'>", "</select>"]);
      var Dt = /<|&#?\w+;/;
      function Et(t, e, n, i, r) {
        for (var a, o, s, l, c, d, u = e.createDocumentFragment(), h = [], p = 0, g = t.length; p < g; p++) if ((a = t[p]) || 0 === a) if ("object" === j(a)) _k.merge(h, a.nodeType ? [a] : a);else if (Dt.test(a)) {
          for (o = o || u.appendChild(e.createElement("div")), s = (Ot.exec(a) || ["", ""])[1].toLowerCase(), l = St[s] || St._default, o.innerHTML = l[1] + _k.htmlPrefilter(a) + l[2], d = l[0]; d--;) o = o.lastChild;
          _k.merge(h, o.childNodes), (o = u.firstChild).textContent = "";
        } else h.push(e.createTextNode(a));
        for (u.textContent = "", p = 0; a = h[p++];) if (i && _k.inArray(a, i) > -1) r && r.push(a);else if (c = mt(a), o = Nt(u.appendChild(a), "script"), c && Lt(o), n) for (d = 0; a = o[d++];) Tt.test(a.type || "") && n.push(a);
        return u;
      }
      var It = /^([^.]*)(?:\.(.+)|)/;
      function Pt() {
        return !0;
      }
      function At() {
        return !1;
      }
      function zt(t, e, n, i, r, a) {
        var o, s;
        if ("object" == typeof e) {
          for (s in "string" != typeof n && (i = i || n, n = void 0), e) zt(t, s, n, i, e[s], a);
          return t;
        }
        if (null == i && null == r ? (r = n, i = n = void 0) : null == r && ("string" == typeof n ? (r = i, i = void 0) : (r = i, i = n, n = void 0)), !1 === r) r = At;else if (!r) return t;
        return 1 === a && (o = r, (r = function r(t) {
          return _k().off(t), o.apply(this, arguments);
        }).guid = o.guid || (o.guid = _k.guid++)), t.each(function () {
          _k.event.add(this, e, r, i, n);
        });
      }
      function _t(t, e, n) {
        n ? (st.set(t, e, !1), _k.event.add(t, e, {
          namespace: !1,
          handler: function handler(t) {
            var n,
              i = st.get(this, e);
            if (1 & t.isTrigger && this[e]) {
              if (i) (_k.event.special[e] || {}).delegateType && t.stopPropagation();else if (i = s.call(arguments), st.set(this, e, i), this[e](), n = st.get(this, e), st.set(this, e, !1), i !== n) return t.stopImmediatePropagation(), t.preventDefault(), n;
            } else i && (st.set(this, e, _k.event.trigger(i[0], i.slice(1), this)), t.stopPropagation(), t.isImmediatePropagationStopped = Pt);
          }
        })) : void 0 === st.get(t, e) && _k.event.add(t, e, Pt);
      }
      _k.event = {
        global: {},
        add: function add(t, e, n, i, r) {
          var a,
            o,
            s,
            l,
            c,
            d,
            u,
            h,
            p,
            g,
            f,
            m = st.get(t);
          if (at(t)) for (n.handler && (n = (a = n).handler, r = a.selector), r && _k.find.matchesSelector(ft, r), n.guid || (n.guid = _k.guid++), (l = m.events) || (l = m.events = Object.create(null)), (o = m.handle) || (o = m.handle = function (e) {
            return void 0 !== _k && _k.event.triggered !== e.type ? _k.event.dispatch.apply(t, arguments) : void 0;
          }), c = (e = (e || "").match(G) || [""]).length; c--;) p = f = (s = It.exec(e[c]) || [])[1], g = (s[2] || "").split(".").sort(), p && (u = _k.event.special[p] || {}, p = (r ? u.delegateType : u.bindType) || p, u = _k.event.special[p] || {}, d = _k.extend({
            type: p,
            origType: f,
            data: i,
            handler: n,
            guid: n.guid,
            selector: r,
            needsContext: r && _k.expr.match.needsContext.test(r),
            namespace: g.join(".")
          }, a), (h = l[p]) || ((h = l[p] = []).delegateCount = 0, u.setup && !1 !== u.setup.call(t, i, g, o) || t.addEventListener && t.addEventListener(p, o)), u.add && (u.add.call(t, d), d.handler.guid || (d.handler.guid = n.guid)), r ? h.splice(h.delegateCount++, 0, d) : h.push(d), _k.event.global[p] = !0);
        },
        remove: function remove(t, e, n, i, r) {
          var a,
            o,
            s,
            l,
            c,
            d,
            u,
            h,
            p,
            g,
            f,
            m = st.hasData(t) && st.get(t);
          if (m && (l = m.events)) {
            for (c = (e = (e || "").match(G) || [""]).length; c--;) if (p = f = (s = It.exec(e[c]) || [])[1], g = (s[2] || "").split(".").sort(), p) {
              for (u = _k.event.special[p] || {}, h = l[p = (i ? u.delegateType : u.bindType) || p] || [], s = s[2] && new RegExp("(^|\\.)" + g.join("\\.(?:.*\\.|)") + "(\\.|$)"), o = a = h.length; a--;) d = h[a], !r && f !== d.origType || n && n.guid !== d.guid || s && !s.test(d.namespace) || i && i !== d.selector && ("**" !== i || !d.selector) || (h.splice(a, 1), d.selector && h.delegateCount--, u.remove && u.remove.call(t, d));
              o && !h.length && (u.teardown && !1 !== u.teardown.call(t, g, m.handle) || _k.removeEvent(t, p, m.handle), delete l[p]);
            } else for (p in l) _k.event.remove(t, p + e[c], n, i, !0);
            _k.isEmptyObject(l) && st.remove(t, "handle events");
          }
        },
        dispatch: function dispatch(t) {
          var e,
            n,
            i,
            r,
            a,
            o,
            s = new Array(arguments.length),
            l = _k.event.fix(t),
            c = (st.get(this, "events") || Object.create(null))[l.type] || [],
            d = _k.event.special[l.type] || {};
          for (s[0] = l, e = 1; e < arguments.length; e++) s[e] = arguments[e];
          if (l.delegateTarget = this, !d.preDispatch || !1 !== d.preDispatch.call(this, l)) {
            for (o = _k.event.handlers.call(this, l, c), e = 0; (r = o[e++]) && !l.isPropagationStopped();) for (l.currentTarget = r.elem, n = 0; (a = r.handlers[n++]) && !l.isImmediatePropagationStopped();) l.rnamespace && !1 !== a.namespace && !l.rnamespace.test(a.namespace) || (l.handleObj = a, l.data = a.data, void 0 !== (i = ((_k.event.special[a.origType] || {}).handle || a.handler).apply(r.elem, s)) && !1 === (l.result = i) && (l.preventDefault(), l.stopPropagation()));
            return d.postDispatch && d.postDispatch.call(this, l), l.result;
          }
        },
        handlers: function handlers(t, e) {
          var n,
            i,
            r,
            a,
            o,
            s = [],
            l = e.delegateCount,
            c = t.target;
          if (l && c.nodeType && !("click" === t.type && t.button >= 1)) for (; c !== this; c = c.parentNode || this) if (1 === c.nodeType && ("click" !== t.type || !0 !== c.disabled)) {
            for (a = [], o = {}, n = 0; n < l; n++) void 0 === o[r = (i = e[n]).selector + " "] && (o[r] = i.needsContext ? _k(r, this).index(c) > -1 : _k.find(r, this, null, [c]).length), o[r] && a.push(i);
            a.length && s.push({
              elem: c,
              handlers: a
            });
          }
          return c = this, l < e.length && s.push({
            elem: c,
            handlers: e.slice(l)
          }), s;
        },
        addProp: function addProp(t, e) {
          Object.defineProperty(_k.Event.prototype, t, {
            enumerable: !0,
            configurable: !0,
            get: v(e) ? function () {
              if (this.originalEvent) return e(this.originalEvent);
            } : function () {
              if (this.originalEvent) return this.originalEvent[t];
            },
            set: function set(e) {
              Object.defineProperty(this, t, {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: e
              });
            }
          });
        },
        fix: function fix(t) {
          return t[_k.expando] ? t : new _k.Event(t);
        },
        special: {
          load: {
            noBubble: !0
          },
          click: {
            setup: function setup(t) {
              var e = this || t;
              return kt.test(e.type) && e.click && T(e, "input") && _t(e, "click", !0), !1;
            },
            trigger: function trigger(t) {
              var e = this || t;
              return kt.test(e.type) && e.click && T(e, "input") && _t(e, "click"), !0;
            },
            _default: function _default(t) {
              var e = t.target;
              return kt.test(e.type) && e.click && T(e, "input") && st.get(e, "click") || T(e, "a");
            }
          },
          beforeunload: {
            postDispatch: function postDispatch(t) {
              void 0 !== t.result && t.originalEvent && (t.originalEvent.returnValue = t.result);
            }
          }
        }
      }, _k.removeEvent = function (t, e, n) {
        t.removeEventListener && t.removeEventListener(e, n);
      }, _k.Event = function (t, e) {
        if (!(this instanceof _k.Event)) return new _k.Event(t, e);
        t && t.type ? (this.originalEvent = t, this.type = t.type, this.isDefaultPrevented = t.defaultPrevented || void 0 === t.defaultPrevented && !1 === t.returnValue ? Pt : At, this.target = t.target && 3 === t.target.nodeType ? t.target.parentNode : t.target, this.currentTarget = t.currentTarget, this.relatedTarget = t.relatedTarget) : this.type = t, e && _k.extend(this, e), this.timeStamp = t && t.timeStamp || Date.now(), this[_k.expando] = !0;
      }, _k.Event.prototype = {
        constructor: _k.Event,
        isDefaultPrevented: At,
        isPropagationStopped: At,
        isImmediatePropagationStopped: At,
        isSimulated: !1,
        preventDefault: function preventDefault() {
          var t = this.originalEvent;
          this.isDefaultPrevented = Pt, t && !this.isSimulated && t.preventDefault();
        },
        stopPropagation: function stopPropagation() {
          var t = this.originalEvent;
          this.isPropagationStopped = Pt, t && !this.isSimulated && t.stopPropagation();
        },
        stopImmediatePropagation: function stopImmediatePropagation() {
          var t = this.originalEvent;
          this.isImmediatePropagationStopped = Pt, t && !this.isSimulated && t.stopImmediatePropagation(), this.stopPropagation();
        }
      }, _k.each({
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        char: !0,
        code: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: !0
      }, _k.event.addProp), _k.each({
        focus: "focusin",
        blur: "focusout"
      }, function (t, e) {
        function n(t) {
          if (y.documentMode) {
            var n = st.get(this, "handle"),
              i = _k.event.fix(t);
            i.type = "focusin" === t.type ? "focus" : "blur", i.isSimulated = !0, n(t), i.target === i.currentTarget && n(i);
          } else _k.event.simulate(e, t.target, _k.event.fix(t));
        }
        _k.event.special[t] = {
          setup: function setup() {
            var i;
            if (_t(this, t, !0), !y.documentMode) return !1;
            (i = st.get(this, e)) || this.addEventListener(e, n), st.set(this, e, (i || 0) + 1);
          },
          trigger: function trigger() {
            return _t(this, t), !0;
          },
          teardown: function teardown() {
            var t;
            if (!y.documentMode) return !1;
            (t = st.get(this, e) - 1) ? st.set(this, e, t) : (this.removeEventListener(e, n), st.remove(this, e));
          },
          _default: function _default(e) {
            return st.get(e.target, t);
          },
          delegateType: e
        }, _k.event.special[e] = {
          setup: function setup() {
            var i = this.ownerDocument || this.document || this,
              r = y.documentMode ? this : i,
              a = st.get(r, e);
            a || (y.documentMode ? this.addEventListener(e, n) : i.addEventListener(t, n, !0)), st.set(r, e, (a || 0) + 1);
          },
          teardown: function teardown() {
            var i = this.ownerDocument || this.document || this,
              r = y.documentMode ? this : i,
              a = st.get(r, e) - 1;
            a ? st.set(r, e, a) : (y.documentMode ? this.removeEventListener(e, n) : i.removeEventListener(t, n, !0), st.remove(r, e));
          }
        };
      }), _k.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
      }, function (t, e) {
        _k.event.special[t] = {
          delegateType: e,
          bindType: e,
          handle: function handle(t) {
            var n,
              i = this,
              r = t.relatedTarget,
              a = t.handleObj;
            return r && (r === i || _k.contains(i, r)) || (t.type = a.origType, n = a.handler.apply(this, arguments), t.type = e), n;
          }
        };
      }), _k.fn.extend({
        on: function on(t, e, n, i) {
          return zt(this, t, e, n, i);
        },
        one: function one(t, e, n, i) {
          return zt(this, t, e, n, i, 1);
        },
        off: function off(t, e, n) {
          var i, r;
          if (t && t.preventDefault && t.handleObj) return i = t.handleObj, _k(t.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler), this;
          if ("object" == typeof t) {
            for (r in t) this.off(r, e, t[r]);
            return this;
          }
          return !1 !== e && "function" != typeof e || (n = e, e = void 0), !1 === n && (n = At), this.each(function () {
            _k.event.remove(this, t, n, e);
          });
        }
      });
      var Ht = /<script|<style|<link/i,
        Vt = /checked\s*(?:[^=]|=\s*.checked.)/i,
        Ft = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
      function Rt(t, e) {
        return T(t, "table") && T(11 !== e.nodeType ? e : e.firstChild, "tr") && _k(t).children("tbody")[0] || t;
      }
      function Bt(t) {
        return t.type = (null !== t.getAttribute("type")) + "/" + t.type, t;
      }
      function Wt(t) {
        return "true/" === (t.type || "").slice(0, 5) ? t.type = t.type.slice(5) : t.removeAttribute("type"), t;
      }
      function Yt(t, e) {
        var n, i, r, a, o, s;
        if (1 === e.nodeType) {
          if (st.hasData(t) && (s = st.get(t).events)) for (r in st.remove(e, "handle events"), s) for (n = 0, i = s[r].length; n < i; n++) _k.event.add(e, r, s[r][n]);
          lt.hasData(t) && (a = lt.access(t), o = _k.extend({}, a), lt.set(e, o));
        }
      }
      function Ut(t, e) {
        var n = e.nodeName.toLowerCase();
        "input" === n && kt.test(t.type) ? e.checked = t.checked : "input" !== n && "textarea" !== n || (e.defaultValue = t.defaultValue);
      }
      function Zt(t, e, n, i) {
        e = l(e);
        var r,
          a,
          o,
          s,
          c,
          d,
          u = 0,
          h = t.length,
          p = h - 1,
          g = e[0],
          f = v(g);
        if (f || h > 1 && "string" == typeof g && !m.checkClone && Vt.test(g)) return t.each(function (r) {
          var a = t.eq(r);
          f && (e[0] = g.call(this, r, a.html())), Zt(a, e, n, i);
        });
        if (h && (a = (r = Et(e, t[0].ownerDocument, !1, t, i)).firstChild, 1 === r.childNodes.length && (r = a), a || i)) {
          for (s = (o = _k.map(Nt(r, "script"), Bt)).length; u < h; u++) c = r, u !== p && (c = _k.clone(c, !0, !0), s && _k.merge(o, Nt(c, "script"))), n.call(t[u], c, u);
          if (s) for (d = o[o.length - 1].ownerDocument, _k.map(o, Wt), u = 0; u < s; u++) c = o[u], Tt.test(c.type || "") && !st.access(c, "globalEval") && _k.contains(d, c) && (c.src && "module" !== (c.type || "").toLowerCase() ? _k._evalUrl && !c.noModule && _k._evalUrl(c.src, {
            nonce: c.nonce || c.getAttribute("nonce")
          }, d) : x(c.textContent.replace(Ft, ""), c, d));
        }
        return t;
      }
      function Gt(t, e, n) {
        for (var i, r = e ? _k.filter(e, t) : t, a = 0; null != (i = r[a]); a++) n || 1 !== i.nodeType || _k.cleanData(Nt(i)), i.parentNode && (n && mt(i) && Lt(Nt(i, "script")), i.parentNode.removeChild(i));
        return t;
      }
      _k.extend({
        htmlPrefilter: function htmlPrefilter(t) {
          return t;
        },
        clone: function clone(t, e, n) {
          var i,
            r,
            a,
            o,
            s = t.cloneNode(!0),
            l = mt(t);
          if (!(m.noCloneChecked || 1 !== t.nodeType && 11 !== t.nodeType || _k.isXMLDoc(t))) for (o = Nt(s), i = 0, r = (a = Nt(t)).length; i < r; i++) Ut(a[i], o[i]);
          if (e) if (n) for (a = a || Nt(t), o = o || Nt(s), i = 0, r = a.length; i < r; i++) Yt(a[i], o[i]);else Yt(t, s);
          return (o = Nt(s, "script")).length > 0 && Lt(o, !l && Nt(t, "script")), s;
        },
        cleanData: function cleanData(t) {
          for (var e, n, i, r = _k.event.special, a = 0; void 0 !== (n = t[a]); a++) if (at(n)) {
            if (e = n[st.expando]) {
              if (e.events) for (i in e.events) r[i] ? _k.event.remove(n, i) : _k.removeEvent(n, i, e.handle);
              n[st.expando] = void 0;
            }
            n[lt.expando] && (n[lt.expando] = void 0);
          }
        }
      }), _k.fn.extend({
        detach: function detach(t) {
          return Gt(this, t, !0);
        },
        remove: function remove(t) {
          return Gt(this, t);
        },
        text: function text(t) {
          return _tt(this, function (t) {
            return void 0 === t ? _k.text(this) : this.empty().each(function () {
              1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = t);
            });
          }, null, t, arguments.length);
        },
        append: function append() {
          return Zt(this, arguments, function (t) {
            1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || Rt(this, t).appendChild(t);
          });
        },
        prepend: function prepend() {
          return Zt(this, arguments, function (t) {
            if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
              var e = Rt(this, t);
              e.insertBefore(t, e.firstChild);
            }
          });
        },
        before: function before() {
          return Zt(this, arguments, function (t) {
            this.parentNode && this.parentNode.insertBefore(t, this);
          });
        },
        after: function after() {
          return Zt(this, arguments, function (t) {
            this.parentNode && this.parentNode.insertBefore(t, this.nextSibling);
          });
        },
        empty: function empty() {
          for (var t, e = 0; null != (t = this[e]); e++) 1 === t.nodeType && (_k.cleanData(Nt(t, !1)), t.textContent = "");
          return this;
        },
        clone: function clone(t, e) {
          return t = null != t && t, e = null == e ? t : e, this.map(function () {
            return _k.clone(this, t, e);
          });
        },
        html: function html(t) {
          return _tt(this, function (t) {
            var e = this[0] || {},
              n = 0,
              i = this.length;
            if (void 0 === t && 1 === e.nodeType) return e.innerHTML;
            if ("string" == typeof t && !Ht.test(t) && !St[(Ot.exec(t) || ["", ""])[1].toLowerCase()]) {
              t = _k.htmlPrefilter(t);
              try {
                for (; n < i; n++) 1 === (e = this[n] || {}).nodeType && (_k.cleanData(Nt(e, !1)), e.innerHTML = t);
                e = 0;
              } catch (t) {}
            }
            e && this.empty().append(t);
          }, null, t, arguments.length);
        },
        replaceWith: function replaceWith() {
          var t = [];
          return Zt(this, arguments, function (e) {
            var n = this.parentNode;
            _k.inArray(this, t) < 0 && (_k.cleanData(Nt(this)), n && n.replaceChild(e, this));
          }, t);
        }
      }), _k.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
      }, function (t, e) {
        _k.fn[t] = function (t) {
          for (var n, i = [], r = _k(t), a = r.length - 1, o = 0; o <= a; o++) n = o === a ? this : this.clone(!0), _k(r[o])[e](n), c.apply(i, n.get());
          return this.pushStack(i);
        };
      });
      var qt = new RegExp("^(" + ht + ")(?!px)[a-z%]+$", "i"),
        $t = /^--/,
        Qt = function Qt(t) {
          var e = t.ownerDocument.defaultView;
          return e && e.opener || (e = n), e.getComputedStyle(t);
        },
        Jt = function Jt(t, e, n) {
          var i,
            r,
            a = {};
          for (r in e) a[r] = t.style[r], t.style[r] = e[r];
          for (r in i = n.call(t), e) t.style[r] = a[r];
          return i;
        },
        Xt = new RegExp(gt.join("|"), "i");
      function Kt(t, e, n) {
        var i,
          r,
          a,
          o,
          s = $t.test(e),
          l = t.style;
        return (n = n || Qt(t)) && (o = n.getPropertyValue(e) || n[e], s && o && (o = o.replace(E, "$1") || void 0), "" !== o || mt(t) || (o = _k.style(t, e)), !m.pixelBoxStyles() && qt.test(o) && Xt.test(e) && (i = l.width, r = l.minWidth, a = l.maxWidth, l.minWidth = l.maxWidth = l.width = o, o = n.width, l.width = i, l.minWidth = r, l.maxWidth = a)), void 0 !== o ? o + "" : o;
      }
      function te(t, e) {
        return {
          get: function get() {
            if (!t()) return (this.get = e).apply(this, arguments);
            delete this.get;
          }
        };
      }
      !function () {
        function t() {
          if (d) {
            c.style.cssText = "position:absolute;left:-11111px;width:60px;" + "margin-top:1px;padding:0;border:0", d.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;" + "margin:auto;border:1px;padding:1px;" + "width:60%;top:1%", ft.appendChild(c).appendChild(d);
            var t = n.getComputedStyle(d);
            i = "1%" !== t.top, l = 12 === e(t.marginLeft), d.style.right = "60%", o = 36 === e(t.right), r = 36 === e(t.width), d.style.position = "absolute", a = 12 === e(d.offsetWidth / 3), ft.removeChild(c), d = null;
          }
        }
        function e(t) {
          return Math.round(parseFloat(t));
        }
        var i,
          r,
          a,
          o,
          s,
          l,
          c = y.createElement("div"),
          d = y.createElement("div");
        d.style && (d.style.backgroundClip = "content-box", d.cloneNode(!0).style.backgroundClip = "", m.clearCloneStyle = "content-box" === d.style.backgroundClip, _k.extend(m, {
          boxSizingReliable: function boxSizingReliable() {
            return t(), r;
          },
          pixelBoxStyles: function pixelBoxStyles() {
            return t(), o;
          },
          pixelPosition: function pixelPosition() {
            return t(), i;
          },
          reliableMarginLeft: function reliableMarginLeft() {
            return t(), l;
          },
          scrollboxSize: function scrollboxSize() {
            return t(), a;
          },
          reliableTrDimensions: function reliableTrDimensions() {
            var t, e, i, r;
            return null == s && (t = y.createElement("table"), e = y.createElement("tr"), i = y.createElement("div"), t.style.cssText = "position:absolute;left:-11111px;border-collapse:separate", e.style.cssText = "box-sizing:content-box;border:1px solid", e.style.height = "1px", i.style.height = "9px", i.style.display = "block", ft.appendChild(t).appendChild(e).appendChild(i), r = n.getComputedStyle(e), s = parseInt(r.height, 10) + parseInt(r.borderTopWidth, 10) + parseInt(r.borderBottomWidth, 10) === e.offsetHeight, ft.removeChild(t)), s;
          }
        }));
      }();
      var ee = ["Webkit", "Moz", "ms"],
        ne = y.createElement("div").style,
        ie = {};
      function re(t) {
        var e = _k.cssProps[t] || ie[t];
        return e || (t in ne ? t : ie[t] = function (t) {
          for (var e = t[0].toUpperCase() + t.slice(1), n = ee.length; n--;) if ((t = ee[n] + e) in ne) return t;
        }(t) || t);
      }
      var ae = /^(none|table(?!-c[ea]).+)/,
        oe = {
          position: "absolute",
          visibility: "hidden",
          display: "block"
        },
        se = {
          letterSpacing: "0",
          fontWeight: "400"
        };
      function le(t, e, n) {
        var i = pt.exec(e);
        return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : e;
      }
      function ce(t, e, n, i, r, a) {
        var o = "width" === e ? 1 : 0,
          s = 0,
          l = 0,
          c = 0;
        if (n === (i ? "border" : "content")) return 0;
        for (; o < 4; o += 2) "margin" === n && (c += _k.css(t, n + gt[o], !0, r)), i ? ("content" === n && (l -= _k.css(t, "padding" + gt[o], !0, r)), "margin" !== n && (l -= _k.css(t, "border" + gt[o] + "Width", !0, r))) : (l += _k.css(t, "padding" + gt[o], !0, r), "padding" !== n ? l += _k.css(t, "border" + gt[o] + "Width", !0, r) : s += _k.css(t, "border" + gt[o] + "Width", !0, r));
        return !i && a >= 0 && (l += Math.max(0, Math.ceil(t["offset" + e[0].toUpperCase() + e.slice(1)] - a - l - s - .5)) || 0), l + c;
      }
      function de(t, e, n) {
        var i = Qt(t),
          r = (!m.boxSizingReliable() || n) && "border-box" === _k.css(t, "boxSizing", !1, i),
          a = r,
          o = Kt(t, e, i),
          s = "offset" + e[0].toUpperCase() + e.slice(1);
        if (qt.test(o)) {
          if (!n) return o;
          o = "auto";
        }
        return (!m.boxSizingReliable() && r || !m.reliableTrDimensions() && T(t, "tr") || "auto" === o || !parseFloat(o) && "inline" === _k.css(t, "display", !1, i)) && t.getClientRects().length && (r = "border-box" === _k.css(t, "boxSizing", !1, i), (a = s in t) && (o = t[s])), (o = parseFloat(o) || 0) + ce(t, e, n || (r ? "border" : "content"), a, i, o) + "px";
      }
      function ue(t, e, n, i, r) {
        return new ue.prototype.init(t, e, n, i, r);
      }
      _k.extend({
        cssHooks: {
          opacity: {
            get: function get(t, e) {
              if (e) {
                var n = Kt(t, "opacity");
                return "" === n ? "1" : n;
              }
            }
          }
        },
        cssNumber: {
          animationIterationCount: !0,
          aspectRatio: !0,
          borderImageSlice: !0,
          columnCount: !0,
          flexGrow: !0,
          flexShrink: !0,
          fontWeight: !0,
          gridArea: !0,
          gridColumn: !0,
          gridColumnEnd: !0,
          gridColumnStart: !0,
          gridRow: !0,
          gridRowEnd: !0,
          gridRowStart: !0,
          lineHeight: !0,
          opacity: !0,
          order: !0,
          orphans: !0,
          scale: !0,
          widows: !0,
          zIndex: !0,
          zoom: !0,
          fillOpacity: !0,
          floodOpacity: !0,
          stopOpacity: !0,
          strokeMiterlimit: !0,
          strokeOpacity: !0
        },
        cssProps: {},
        style: function style(t, e, n, i) {
          if (t && 3 !== t.nodeType && 8 !== t.nodeType && t.style) {
            var r,
              a,
              o,
              s = rt(e),
              l = $t.test(e),
              c = t.style;
            if (l || (e = re(s)), o = _k.cssHooks[e] || _k.cssHooks[s], void 0 === n) return o && "get" in o && void 0 !== (r = o.get(t, !1, i)) ? r : c[e];
            "string" === (a = typeof n) && (r = pt.exec(n)) && r[1] && (n = yt(t, e, r), a = "number"), null != n && n == n && ("number" !== a || l || (n += r && r[3] || (_k.cssNumber[s] ? "" : "px")), m.clearCloneStyle || "" !== n || 0 !== e.indexOf("background") || (c[e] = "inherit"), o && "set" in o && void 0 === (n = o.set(t, n, i)) || (l ? c.setProperty(e, n) : c[e] = n));
          }
        },
        css: function css(t, e, n, i) {
          var r,
            a,
            o,
            s = rt(e);
          return $t.test(e) || (e = re(s)), (o = _k.cssHooks[e] || _k.cssHooks[s]) && "get" in o && (r = o.get(t, !0, n)), void 0 === r && (r = Kt(t, e, i)), "normal" === r && e in se && (r = se[e]), "" === n || n ? (a = parseFloat(r), !0 === n || isFinite(a) ? a || 0 : r) : r;
        }
      }), _k.each(["height", "width"], function (t, e) {
        _k.cssHooks[e] = {
          get: function get(t, n, i) {
            if (n) return !ae.test(_k.css(t, "display")) || t.getClientRects().length && t.getBoundingClientRect().width ? de(t, e, i) : Jt(t, oe, function () {
              return de(t, e, i);
            });
          },
          set: function set(t, n, i) {
            var r,
              a = Qt(t),
              o = !m.scrollboxSize() && "absolute" === a.position,
              s = (o || i) && "border-box" === _k.css(t, "boxSizing", !1, a),
              l = i ? ce(t, e, i, s, a) : 0;
            return s && o && (l -= Math.ceil(t["offset" + e[0].toUpperCase() + e.slice(1)] - parseFloat(a[e]) - ce(t, e, "border", !1, a) - .5)), l && (r = pt.exec(n)) && "px" !== (r[3] || "px") && (t.style[e] = n, n = _k.css(t, e)), le(0, n, l);
          }
        };
      }), _k.cssHooks.marginLeft = te(m.reliableMarginLeft, function (t, e) {
        if (e) return (parseFloat(Kt(t, "marginLeft")) || t.getBoundingClientRect().left - Jt(t, {
          marginLeft: 0
        }, function () {
          return t.getBoundingClientRect().left;
        })) + "px";
      }), _k.each({
        margin: "",
        padding: "",
        border: "Width"
      }, function (t, e) {
        _k.cssHooks[t + e] = {
          expand: function expand(n) {
            for (var i = 0, r = {}, a = "string" == typeof n ? n.split(" ") : [n]; i < 4; i++) r[t + gt[i] + e] = a[i] || a[i - 2] || a[0];
            return r;
          }
        }, "margin" !== t && (_k.cssHooks[t + e].set = le);
      }), _k.fn.extend({
        css: function css(t, e) {
          return _tt(this, function (t, e, n) {
            var i,
              r,
              a = {},
              o = 0;
            if (Array.isArray(e)) {
              for (i = Qt(t), r = e.length; o < r; o++) a[e[o]] = _k.css(t, e[o], !1, i);
              return a;
            }
            return void 0 !== n ? _k.style(t, e, n) : _k.css(t, e);
          }, t, e, arguments.length > 1);
        }
      }), _k.Tween = ue, ue.prototype = {
        constructor: ue,
        init: function init(t, e, n, i, r, a) {
          this.elem = t, this.prop = n, this.easing = r || _k.easing._default, this.options = e, this.start = this.now = this.cur(), this.end = i, this.unit = a || (_k.cssNumber[n] ? "" : "px");
        },
        cur: function cur() {
          var t = ue.propHooks[this.prop];
          return t && t.get ? t.get(this) : ue.propHooks._default.get(this);
        },
        run: function run(t) {
          var e,
            n = ue.propHooks[this.prop];
          return this.options.duration ? this.pos = e = _k.easing[this.easing](t, this.options.duration * t, 0, 1, this.options.duration) : this.pos = e = t, this.now = (this.end - this.start) * e + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : ue.propHooks._default.set(this), this;
        }
      }, ue.prototype.init.prototype = ue.prototype, ue.propHooks = {
        _default: {
          get: function get(t) {
            var e;
            return 1 !== t.elem.nodeType || null != t.elem[t.prop] && null == t.elem.style[t.prop] ? t.elem[t.prop] : (e = _k.css(t.elem, t.prop, "")) && "auto" !== e ? e : 0;
          },
          set: function set(t) {
            _k.fx.step[t.prop] ? _k.fx.step[t.prop](t) : 1 !== t.elem.nodeType || !_k.cssHooks[t.prop] && null == t.elem.style[re(t.prop)] ? t.elem[t.prop] = t.now : _k.style(t.elem, t.prop, t.now + t.unit);
          }
        }
      }, ue.propHooks.scrollTop = ue.propHooks.scrollLeft = {
        set: function set(t) {
          t.elem.nodeType && t.elem.parentNode && (t.elem[t.prop] = t.now);
        }
      }, _k.easing = {
        linear: function linear(t) {
          return t;
        },
        swing: function swing(t) {
          return .5 - Math.cos(t * Math.PI) / 2;
        },
        _default: "swing"
      }, _k.fx = ue.prototype.init, _k.fx.step = {};
      var he,
        pe,
        ge = /^(?:toggle|show|hide)$/,
        fe = /queueHooks$/;
      function me() {
        pe && (!1 === y.hidden && n.requestAnimationFrame ? n.requestAnimationFrame(me) : n.setTimeout(me, _k.fx.interval), _k.fx.tick());
      }
      function ve() {
        return n.setTimeout(function () {
          he = void 0;
        }), he = Date.now();
      }
      function be(t, e) {
        var n,
          i = 0,
          r = {
            height: t
          };
        for (e = e ? 1 : 0; i < 4; i += 2 - e) r["margin" + (n = gt[i])] = r["padding" + n] = t;
        return e && (r.opacity = r.width = t), r;
      }
      function ye(t, e, n) {
        for (var i, r = (we.tweeners[e] || []).concat(we.tweeners["*"]), a = 0, o = r.length; a < o; a++) if (i = r[a].call(n, e, t)) return i;
      }
      function we(t, e, n) {
        var i,
          r,
          a = 0,
          o = we.prefilters.length,
          s = _k.Deferred().always(function () {
            delete l.elem;
          }),
          l = function l() {
            if (r) return !1;
            for (var e = he || ve(), n = Math.max(0, c.startTime + c.duration - e), i = 1 - (n / c.duration || 0), a = 0, o = c.tweens.length; a < o; a++) c.tweens[a].run(i);
            return s.notifyWith(t, [c, i, n]), i < 1 && o ? n : (o || s.notifyWith(t, [c, 1, 0]), s.resolveWith(t, [c]), !1);
          },
          c = s.promise({
            elem: t,
            props: _k.extend({}, e),
            opts: _k.extend(!0, {
              specialEasing: {},
              easing: _k.easing._default
            }, n),
            originalProperties: e,
            originalOptions: n,
            startTime: he || ve(),
            duration: n.duration,
            tweens: [],
            createTween: function createTween(e, n) {
              var i = _k.Tween(t, c.opts, e, n, c.opts.specialEasing[e] || c.opts.easing);
              return c.tweens.push(i), i;
            },
            stop: function stop(e) {
              var n = 0,
                i = e ? c.tweens.length : 0;
              if (r) return this;
              for (r = !0; n < i; n++) c.tweens[n].run(1);
              return e ? (s.notifyWith(t, [c, 1, 0]), s.resolveWith(t, [c, e])) : s.rejectWith(t, [c, e]), this;
            }
          }),
          d = c.props;
        for (!function (t, e) {
          var n, i, r, a, o;
          for (n in t) if (r = e[i = rt(n)], a = t[n], Array.isArray(a) && (r = a[1], a = t[n] = a[0]), n !== i && (t[i] = a, delete t[n]), (o = _k.cssHooks[i]) && "expand" in o) for (n in a = o.expand(a), delete t[i], a) n in t || (t[n] = a[n], e[n] = r);else e[i] = r;
        }(d, c.opts.specialEasing); a < o; a++) if (i = we.prefilters[a].call(c, t, d, c.opts)) return v(i.stop) && (_k._queueHooks(c.elem, c.opts.queue).stop = i.stop.bind(i)), i;
        return _k.map(d, ye, c), v(c.opts.start) && c.opts.start.call(t, c), c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always), _k.fx.timer(_k.extend(l, {
          elem: t,
          anim: c,
          queue: c.opts.queue
        })), c;
      }
      _k.Animation = _k.extend(we, {
        tweeners: {
          "*": [function (t, e) {
            var n = this.createTween(t, e);
            return yt(n.elem, t, pt.exec(e), n), n;
          }]
        },
        tweener: function tweener(t, e) {
          v(t) ? (e = t, t = ["*"]) : t = t.match(G);
          for (var n, i = 0, r = t.length; i < r; i++) n = t[i], we.tweeners[n] = we.tweeners[n] || [], we.tweeners[n].unshift(e);
        },
        prefilters: [function (t, e, n) {
          var i,
            r,
            a,
            o,
            s,
            l,
            c,
            d,
            u = "width" in e || "height" in e,
            h = this,
            p = {},
            g = t.style,
            f = t.nodeType && bt(t),
            m = st.get(t, "fxshow");
          for (i in n.queue || (null == (o = _k._queueHooks(t, "fx")).unqueued && (o.unqueued = 0, s = o.empty.fire, o.empty.fire = function () {
            o.unqueued || s();
          }), o.unqueued++, h.always(function () {
            h.always(function () {
              o.unqueued--, _k.queue(t, "fx").length || o.empty.fire();
            });
          })), e) if (r = e[i], ge.test(r)) {
            if (delete e[i], a = a || "toggle" === r, r === (f ? "hide" : "show")) {
              if ("show" !== r || !m || void 0 === m[i]) continue;
              f = !0;
            }
            p[i] = m && m[i] || _k.style(t, i);
          }
          if ((l = !_k.isEmptyObject(e)) || !_k.isEmptyObject(p)) for (i in u && 1 === t.nodeType && (n.overflow = [g.overflow, g.overflowX, g.overflowY], null == (c = m && m.display) && (c = st.get(t, "display")), "none" === (d = _k.css(t, "display")) && (c ? d = c : (jt([t], !0), c = t.style.display || c, d = _k.css(t, "display"), jt([t]))), ("inline" === d || "inline-block" === d && null != c) && "none" === _k.css(t, "float") && (l || (h.done(function () {
            g.display = c;
          }), null == c && (d = g.display, c = "none" === d ? "" : d)), g.display = "inline-block")), n.overflow && (g.overflow = "hidden", h.always(function () {
            g.overflow = n.overflow[0], g.overflowX = n.overflow[1], g.overflowY = n.overflow[2];
          })), l = !1, p) l || (m ? "hidden" in m && (f = m.hidden) : m = st.access(t, "fxshow", {
            display: c
          }), a && (m.hidden = !f), f && jt([t], !0), h.done(function () {
            for (i in f || jt([t]), st.remove(t, "fxshow"), p) _k.style(t, i, p[i]);
          })), l = ye(f ? m[i] : 0, i, h), i in m || (m[i] = l.start, f && (l.end = l.start, l.start = 0));
        }],
        prefilter: function prefilter(t, e) {
          e ? we.prefilters.unshift(t) : we.prefilters.push(t);
        }
      }), _k.speed = function (t, e, n) {
        var i = t && "object" == typeof t ? _k.extend({}, t) : {
          complete: n || !n && e || v(t) && t,
          duration: t,
          easing: n && e || e && !v(e) && e
        };
        return _k.fx.off ? i.duration = 0 : "number" != typeof i.duration && (i.duration in _k.fx.speeds ? i.duration = _k.fx.speeds[i.duration] : i.duration = _k.fx.speeds._default), null != i.queue && !0 !== i.queue || (i.queue = "fx"), i.old = i.complete, i.complete = function () {
          v(i.old) && i.old.call(this), i.queue && _k.dequeue(this, i.queue);
        }, i;
      }, _k.fn.extend({
        fadeTo: function fadeTo(t, e, n, i) {
          return this.filter(bt).css("opacity", 0).show().end().animate({
            opacity: e
          }, t, n, i);
        },
        animate: function animate(t, e, n, i) {
          var r = _k.isEmptyObject(t),
            a = _k.speed(e, n, i),
            o = function o() {
              var e = we(this, _k.extend({}, t), a);
              (r || st.get(this, "finish")) && e.stop(!0);
            };
          return o.finish = o, r || !1 === a.queue ? this.each(o) : this.queue(a.queue, o);
        },
        stop: function stop(t, e, n) {
          var i = function i(t) {
            var e = t.stop;
            delete t.stop, e(n);
          };
          return "string" != typeof t && (n = e, e = t, t = void 0), e && this.queue(t || "fx", []), this.each(function () {
            var e = !0,
              r = null != t && t + "queueHooks",
              a = _k.timers,
              o = st.get(this);
            if (r) o[r] && o[r].stop && i(o[r]);else for (r in o) o[r] && o[r].stop && fe.test(r) && i(o[r]);
            for (r = a.length; r--;) a[r].elem !== this || null != t && a[r].queue !== t || (a[r].anim.stop(n), e = !1, a.splice(r, 1));
            !e && n || _k.dequeue(this, t);
          });
        },
        finish: function finish(t) {
          return !1 !== t && (t = t || "fx"), this.each(function () {
            var e,
              n = st.get(this),
              i = n[t + "queue"],
              r = n[t + "queueHooks"],
              a = _k.timers,
              o = i ? i.length : 0;
            for (n.finish = !0, _k.queue(this, t, []), r && r.stop && r.stop.call(this, !0), e = a.length; e--;) a[e].elem === this && a[e].queue === t && (a[e].anim.stop(!0), a.splice(e, 1));
            for (e = 0; e < o; e++) i[e] && i[e].finish && i[e].finish.call(this);
            delete n.finish;
          });
        }
      }), _k.each(["toggle", "show", "hide"], function (t, e) {
        var n = _k.fn[e];
        _k.fn[e] = function (t, i, r) {
          return null == t || "boolean" == typeof t ? n.apply(this, arguments) : this.animate(be(e, !0), t, i, r);
        };
      }), _k.each({
        slideDown: be("show"),
        slideUp: be("hide"),
        slideToggle: be("toggle"),
        fadeIn: {
          opacity: "show"
        },
        fadeOut: {
          opacity: "hide"
        },
        fadeToggle: {
          opacity: "toggle"
        }
      }, function (t, e) {
        _k.fn[t] = function (t, n, i) {
          return this.animate(e, t, n, i);
        };
      }), _k.timers = [], _k.fx.tick = function () {
        var t,
          e = 0,
          n = _k.timers;
        for (he = Date.now(); e < n.length; e++) (t = n[e])() || n[e] !== t || n.splice(e--, 1);
        n.length || _k.fx.stop(), he = void 0;
      }, _k.fx.timer = function (t) {
        _k.timers.push(t), _k.fx.start();
      }, _k.fx.interval = 13, _k.fx.start = function () {
        pe || (pe = !0, me());
      }, _k.fx.stop = function () {
        pe = null;
      }, _k.fx.speeds = {
        slow: 600,
        fast: 200,
        _default: 400
      }, _k.fn.delay = function (t, e) {
        return t = _k.fx && _k.fx.speeds[t] || t, e = e || "fx", this.queue(e, function (e, i) {
          var r = n.setTimeout(e, t);
          i.stop = function () {
            n.clearTimeout(r);
          };
        });
      }, function () {
        var t = y.createElement("input"),
          e = y.createElement("select").appendChild(y.createElement("option"));
        t.type = "checkbox", m.checkOn = "" !== t.value, m.optSelected = e.selected, (t = y.createElement("input")).value = "t", t.type = "radio", m.radioValue = "t" === t.value;
      }();
      var xe,
        je = _k.expr.attrHandle;
      _k.fn.extend({
        attr: function attr(t, e) {
          return _tt(this, _k.attr, t, e, arguments.length > 1);
        },
        removeAttr: function removeAttr(t) {
          return this.each(function () {
            _k.removeAttr(this, t);
          });
        }
      }), _k.extend({
        attr: function attr(t, e, n) {
          var i,
            r,
            a = t.nodeType;
          if (3 !== a && 8 !== a && 2 !== a) return void 0 === t.getAttribute ? _k.prop(t, e, n) : (1 === a && _k.isXMLDoc(t) || (r = _k.attrHooks[e.toLowerCase()] || (_k.expr.match.bool.test(e) ? xe : void 0)), void 0 !== n ? null === n ? void _k.removeAttr(t, e) : r && "set" in r && void 0 !== (i = r.set(t, n, e)) ? i : (t.setAttribute(e, n + ""), n) : r && "get" in r && null !== (i = r.get(t, e)) ? i : null == (i = _k.find.attr(t, e)) ? void 0 : i);
        },
        attrHooks: {
          type: {
            set: function set(t, e) {
              if (!m.radioValue && "radio" === e && T(t, "input")) {
                var n = t.value;
                return t.setAttribute("type", e), n && (t.value = n), e;
              }
            }
          }
        },
        removeAttr: function removeAttr(t, e) {
          var n,
            i = 0,
            r = e && e.match(G);
          if (r && 1 === t.nodeType) for (; n = r[i++];) t.removeAttribute(n);
        }
      }), xe = {
        set: function set(t, e, n) {
          return !1 === e ? _k.removeAttr(t, n) : t.setAttribute(n, n), n;
        }
      }, _k.each(_k.expr.match.bool.source.match(/\w+/g), function (t, e) {
        var n = je[e] || _k.find.attr;
        je[e] = function (t, e, i) {
          var r,
            a,
            o = e.toLowerCase();
          return i || (a = je[o], je[o] = r, r = null != n(t, e, i) ? o : null, je[o] = a), r;
        };
      });
      var Ce = /^(?:input|select|textarea|button)$/i,
        Me = /^(?:a|area)$/i;
      function ke(t) {
        return (t.match(G) || []).join(" ");
      }
      function Oe(t) {
        return t.getAttribute && t.getAttribute("class") || "";
      }
      function Te(t) {
        return Array.isArray(t) ? t : "string" == typeof t && t.match(G) || [];
      }
      _k.fn.extend({
        prop: function prop(t, e) {
          return _tt(this, _k.prop, t, e, arguments.length > 1);
        },
        removeProp: function removeProp(t) {
          return this.each(function () {
            delete this[_k.propFix[t] || t];
          });
        }
      }), _k.extend({
        prop: function prop(t, e, n) {
          var i,
            r,
            a = t.nodeType;
          if (3 !== a && 8 !== a && 2 !== a) return 1 === a && _k.isXMLDoc(t) || (e = _k.propFix[e] || e, r = _k.propHooks[e]), void 0 !== n ? r && "set" in r && void 0 !== (i = r.set(t, n, e)) ? i : t[e] = n : r && "get" in r && null !== (i = r.get(t, e)) ? i : t[e];
        },
        propHooks: {
          tabIndex: {
            get: function get(t) {
              var e = _k.find.attr(t, "tabindex");
              return e ? parseInt(e, 10) : Ce.test(t.nodeName) || Me.test(t.nodeName) && t.href ? 0 : -1;
            }
          }
        },
        propFix: {
          for: "htmlFor",
          class: "className"
        }
      }), m.optSelected || (_k.propHooks.selected = {
        get: function get(t) {
          var e = t.parentNode;
          return e && e.parentNode && e.parentNode.selectedIndex, null;
        },
        set: function set(t) {
          var e = t.parentNode;
          e && (e.selectedIndex, e.parentNode && e.parentNode.selectedIndex);
        }
      }), _k.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
        _k.propFix[this.toLowerCase()] = this;
      }), _k.fn.extend({
        addClass: function addClass(t) {
          var e, n, i, r, a, o;
          return v(t) ? this.each(function (e) {
            _k(this).addClass(t.call(this, e, Oe(this)));
          }) : (e = Te(t)).length ? this.each(function () {
            if (i = Oe(this), n = 1 === this.nodeType && " " + ke(i) + " ") {
              for (a = 0; a < e.length; a++) r = e[a], n.indexOf(" " + r + " ") < 0 && (n += r + " ");
              o = ke(n), i !== o && this.setAttribute("class", o);
            }
          }) : this;
        },
        removeClass: function removeClass(t) {
          var e, n, i, r, a, o;
          return v(t) ? this.each(function (e) {
            _k(this).removeClass(t.call(this, e, Oe(this)));
          }) : arguments.length ? (e = Te(t)).length ? this.each(function () {
            if (i = Oe(this), n = 1 === this.nodeType && " " + ke(i) + " ") {
              for (a = 0; a < e.length; a++) for (r = e[a]; n.indexOf(" " + r + " ") > -1;) n = n.replace(" " + r + " ", " ");
              o = ke(n), i !== o && this.setAttribute("class", o);
            }
          }) : this : this.attr("class", "");
        },
        toggleClass: function toggleClass(t, e) {
          var n,
            i,
            r,
            a,
            o = typeof t,
            s = "string" === o || Array.isArray(t);
          return v(t) ? this.each(function (n) {
            _k(this).toggleClass(t.call(this, n, Oe(this), e), e);
          }) : "boolean" == typeof e && s ? e ? this.addClass(t) : this.removeClass(t) : (n = Te(t), this.each(function () {
            if (s) for (a = _k(this), r = 0; r < n.length; r++) i = n[r], a.hasClass(i) ? a.removeClass(i) : a.addClass(i);else void 0 !== t && "boolean" !== o || ((i = Oe(this)) && st.set(this, "__className__", i), this.setAttribute && this.setAttribute("class", i || !1 === t ? "" : st.get(this, "__className__") || ""));
          }));
        },
        hasClass: function hasClass(t) {
          var e,
            n,
            i = 0;
          for (e = " " + t + " "; n = this[i++];) if (1 === n.nodeType && (" " + ke(Oe(n)) + " ").indexOf(e) > -1) return !0;
          return !1;
        }
      });
      var Se = /\r/g;
      _k.fn.extend({
        val: function val(t) {
          var e,
            n,
            i,
            r = this[0];
          return arguments.length ? (i = v(t), this.each(function (n) {
            var r;
            1 === this.nodeType && (null == (r = i ? t.call(this, n, _k(this).val()) : t) ? r = "" : "number" == typeof r ? r += "" : Array.isArray(r) && (r = _k.map(r, function (t) {
              return null == t ? "" : t + "";
            })), (e = _k.valHooks[this.type] || _k.valHooks[this.nodeName.toLowerCase()]) && "set" in e && void 0 !== e.set(this, r, "value") || (this.value = r));
          })) : r ? (e = _k.valHooks[r.type] || _k.valHooks[r.nodeName.toLowerCase()]) && "get" in e && void 0 !== (n = e.get(r, "value")) ? n : "string" == typeof (n = r.value) ? n.replace(Se, "") : null == n ? "" : n : void 0;
        }
      }), _k.extend({
        valHooks: {
          option: {
            get: function get(t) {
              var e = _k.find.attr(t, "value");
              return null != e ? e : ke(_k.text(t));
            }
          },
          select: {
            get: function get(t) {
              var e,
                n,
                i,
                r = t.options,
                a = t.selectedIndex,
                o = "select-one" === t.type,
                s = o ? null : [],
                l = o ? a + 1 : r.length;
              for (i = a < 0 ? l : o ? a : 0; i < l; i++) if (((n = r[i]).selected || i === a) && !n.disabled && (!n.parentNode.disabled || !T(n.parentNode, "optgroup"))) {
                if (e = _k(n).val(), o) return e;
                s.push(e);
              }
              return s;
            },
            set: function set(t, e) {
              for (var n, i, r = t.options, a = _k.makeArray(e), o = r.length; o--;) ((i = r[o]).selected = _k.inArray(_k.valHooks.option.get(i), a) > -1) && (n = !0);
              return n || (t.selectedIndex = -1), a;
            }
          }
        }
      }), _k.each(["radio", "checkbox"], function () {
        _k.valHooks[this] = {
          set: function set(t, e) {
            if (Array.isArray(e)) return t.checked = _k.inArray(_k(t).val(), e) > -1;
          }
        }, m.checkOn || (_k.valHooks[this].get = function (t) {
          return null === t.getAttribute("value") ? "on" : t.value;
        });
      });
      var Ne = n.location,
        Le = {
          guid: Date.now()
        },
        De = /\?/;
      _k.parseXML = function (t) {
        var e, i;
        if (!t || "string" != typeof t) return null;
        try {
          e = new n.DOMParser().parseFromString(t, "text/xml");
        } catch (t) {}
        return i = e && e.getElementsByTagName("parsererror")[0], e && !i || _k.error("Invalid XML: " + (i ? _k.map(i.childNodes, function (t) {
          return t.textContent;
        }).join("\n") : t)), e;
      };
      var Ee = /^(?:focusinfocus|focusoutblur)$/,
        Ie = function Ie(t) {
          t.stopPropagation();
        };
      _k.extend(_k.event, {
        trigger: function trigger(t, e, i, r) {
          var a,
            o,
            s,
            l,
            c,
            d,
            u,
            h,
            g = [i || y],
            f = p.call(t, "type") ? t.type : t,
            m = p.call(t, "namespace") ? t.namespace.split(".") : [];
          if (o = h = s = i = i || y, 3 !== i.nodeType && 8 !== i.nodeType && !Ee.test(f + _k.event.triggered) && (f.indexOf(".") > -1 && (m = f.split("."), f = m.shift(), m.sort()), c = f.indexOf(":") < 0 && "on" + f, (t = t[_k.expando] ? t : new _k.Event(f, "object" == typeof t && t)).isTrigger = r ? 2 : 3, t.namespace = m.join("."), t.rnamespace = t.namespace ? new RegExp("(^|\\.)" + m.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, t.result = void 0, t.target || (t.target = i), e = null == e ? [t] : _k.makeArray(e, [t]), u = _k.event.special[f] || {}, r || !u.trigger || !1 !== u.trigger.apply(i, e))) {
            if (!r && !u.noBubble && !b(i)) {
              for (l = u.delegateType || f, Ee.test(l + f) || (o = o.parentNode); o; o = o.parentNode) g.push(o), s = o;
              s === (i.ownerDocument || y) && g.push(s.defaultView || s.parentWindow || n);
            }
            for (a = 0; (o = g[a++]) && !t.isPropagationStopped();) h = o, t.type = a > 1 ? l : u.bindType || f, (d = (st.get(o, "events") || Object.create(null))[t.type] && st.get(o, "handle")) && d.apply(o, e), (d = c && o[c]) && d.apply && at(o) && (t.result = d.apply(o, e), !1 === t.result && t.preventDefault());
            return t.type = f, r || t.isDefaultPrevented() || u._default && !1 !== u._default.apply(g.pop(), e) || !at(i) || c && v(i[f]) && !b(i) && ((s = i[c]) && (i[c] = null), _k.event.triggered = f, t.isPropagationStopped() && h.addEventListener(f, Ie), i[f](), t.isPropagationStopped() && h.removeEventListener(f, Ie), _k.event.triggered = void 0, s && (i[c] = s)), t.result;
          }
        },
        simulate: function simulate(t, e, n) {
          var i = _k.extend(new _k.Event(), n, {
            type: t,
            isSimulated: !0
          });
          _k.event.trigger(i, null, e);
        }
      }), _k.fn.extend({
        trigger: function trigger(t, e) {
          return this.each(function () {
            _k.event.trigger(t, e, this);
          });
        },
        triggerHandler: function triggerHandler(t, e) {
          var n = this[0];
          if (n) return _k.event.trigger(t, e, n, !0);
        }
      });
      var Pe = /\[\]$/,
        Ae = /\r?\n/g,
        ze = /^(?:submit|button|image|reset|file)$/i,
        _e = /^(?:input|select|textarea|keygen)/i;
      function He(t, e, n, i) {
        var r;
        if (Array.isArray(e)) _k.each(e, function (e, r) {
          n || Pe.test(t) ? i(t, r) : He(t + "[" + ("object" == typeof r && null != r ? e : "") + "]", r, n, i);
        });else if (n || "object" !== j(e)) i(t, e);else for (r in e) He(t + "[" + r + "]", e[r], n, i);
      }
      _k.param = function (t, e) {
        var n,
          i = [],
          r = function r(t, e) {
            var n = v(e) ? e() : e;
            i[i.length] = encodeURIComponent(t) + "=" + encodeURIComponent(null == n ? "" : n);
          };
        if (null == t) return "";
        if (Array.isArray(t) || t.jquery && !_k.isPlainObject(t)) _k.each(t, function () {
          r(this.name, this.value);
        });else for (n in t) He(n, t[n], e, r);
        return i.join("&");
      }, _k.fn.extend({
        serialize: function serialize() {
          return _k.param(this.serializeArray());
        },
        serializeArray: function serializeArray() {
          return this.map(function () {
            var t = _k.prop(this, "elements");
            return t ? _k.makeArray(t) : this;
          }).filter(function () {
            var t = this.type;
            return this.name && !_k(this).is(":disabled") && _e.test(this.nodeName) && !ze.test(t) && (this.checked || !kt.test(t));
          }).map(function (t, e) {
            var n = _k(this).val();
            return null == n ? null : Array.isArray(n) ? _k.map(n, function (t) {
              return {
                name: e.name,
                value: t.replace(Ae, "\r\n")
              };
            }) : {
              name: e.name,
              value: n.replace(Ae, "\r\n")
            };
          }).get();
        }
      });
      var Ve = /%20/g,
        Fe = /#.*$/,
        Re = /([?&])_=[^&]*/,
        Be = /^(.*?):[ \t]*([^\r\n]*)$/gm,
        We = /^(?:GET|HEAD)$/,
        Ye = /^\/\//,
        Ue = {},
        Ze = {},
        Ge = "*/".concat("*"),
        qe = y.createElement("a");
      function $e(t) {
        return function (e, n) {
          "string" != typeof e && (n = e, e = "*");
          var i,
            r = 0,
            a = e.toLowerCase().match(G) || [];
          if (v(n)) for (; i = a[r++];) "+" === i[0] ? (i = i.slice(1) || "*", (t[i] = t[i] || []).unshift(n)) : (t[i] = t[i] || []).push(n);
        };
      }
      function Qe(t, e, n, i) {
        var r = {},
          a = t === Ze;
        function o(s) {
          var l;
          return r[s] = !0, _k.each(t[s] || [], function (t, s) {
            var c = s(e, n, i);
            return "string" != typeof c || a || r[c] ? a ? !(l = c) : void 0 : (e.dataTypes.unshift(c), o(c), !1);
          }), l;
        }
        return o(e.dataTypes[0]) || !r["*"] && o("*");
      }
      function Je(t, e) {
        var n,
          i,
          r = _k.ajaxSettings.flatOptions || {};
        for (n in e) void 0 !== e[n] && ((r[n] ? t : i || (i = {}))[n] = e[n]);
        return i && _k.extend(!0, t, i), t;
      }
      qe.href = Ne.href, _k.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
          url: Ne.href,
          type: "GET",
          isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Ne.protocol),
          global: !0,
          processData: !0,
          async: !0,
          contentType: "application/x-www-form-urlencoded; charset=UTF-8",
          accepts: {
            "*": Ge,
            text: "text/plain",
            html: "text/html",
            xml: "application/xml, text/xml",
            json: "application/json, text/javascript"
          },
          contents: {
            xml: /\bxml\b/,
            html: /\bhtml/,
            json: /\bjson\b/
          },
          responseFields: {
            xml: "responseXML",
            text: "responseText",
            json: "responseJSON"
          },
          converters: {
            "* text": String,
            "text html": !0,
            "text json": JSON.parse,
            "text xml": _k.parseXML
          },
          flatOptions: {
            url: !0,
            context: !0
          }
        },
        ajaxSetup: function ajaxSetup(t, e) {
          return e ? Je(Je(t, _k.ajaxSettings), e) : Je(_k.ajaxSettings, t);
        },
        ajaxPrefilter: $e(Ue),
        ajaxTransport: $e(Ze),
        ajax: function ajax(t, e) {
          "object" == typeof t && (e = t, t = void 0), e = e || {};
          var i,
            r,
            a,
            o,
            s,
            l,
            c,
            d,
            u,
            h,
            p = _k.ajaxSetup({}, e),
            g = p.context || p,
            f = p.context && (g.nodeType || g.jquery) ? _k(g) : _k.event,
            m = _k.Deferred(),
            v = _k.Callbacks("once memory"),
            b = p.statusCode || {},
            w = {},
            x = {},
            j = "canceled",
            C = {
              readyState: 0,
              getResponseHeader: function getResponseHeader(t) {
                var e;
                if (c) {
                  if (!o) for (o = {}; e = Be.exec(a);) o[e[1].toLowerCase() + " "] = (o[e[1].toLowerCase() + " "] || []).concat(e[2]);
                  e = o[t.toLowerCase() + " "];
                }
                return null == e ? null : e.join(", ");
              },
              getAllResponseHeaders: function getAllResponseHeaders() {
                return c ? a : null;
              },
              setRequestHeader: function setRequestHeader(t, e) {
                return null == c && (t = x[t.toLowerCase()] = x[t.toLowerCase()] || t, w[t] = e), this;
              },
              overrideMimeType: function overrideMimeType(t) {
                return null == c && (p.mimeType = t), this;
              },
              statusCode: function statusCode(t) {
                var e;
                if (t) if (c) C.always(t[C.status]);else for (e in t) b[e] = [b[e], t[e]];
                return this;
              },
              abort: function abort(t) {
                var e = t || j;
                return i && i.abort(e), M(0, e), this;
              }
            };
          if (m.promise(C), p.url = ((t || p.url || Ne.href) + "").replace(Ye, Ne.protocol + "//"), p.type = e.method || e.type || p.method || p.type, p.dataTypes = (p.dataType || "*").toLowerCase().match(G) || [""], null == p.crossDomain) {
            l = y.createElement("a");
            try {
              l.href = p.url, l.href = l.href, p.crossDomain = qe.protocol + "//" + qe.host != l.protocol + "//" + l.host;
            } catch (t) {
              p.crossDomain = !0;
            }
          }
          if (p.data && p.processData && "string" != typeof p.data && (p.data = _k.param(p.data, p.traditional)), Qe(Ue, p, e, C), c) return C;
          for (u in (d = _k.event && p.global) && 0 == _k.active++ && _k.event.trigger("ajaxStart"), p.type = p.type.toUpperCase(), p.hasContent = !We.test(p.type), r = p.url.replace(Fe, ""), p.hasContent ? p.data && p.processData && 0 === (p.contentType || "").indexOf("application/x-www-form-urlencoded") && (p.data = p.data.replace(Ve, "+")) : (h = p.url.slice(r.length), p.data && (p.processData || "string" == typeof p.data) && (r += (De.test(r) ? "&" : "?") + p.data, delete p.data), !1 === p.cache && (r = r.replace(Re, "$1"), h = (De.test(r) ? "&" : "?") + "_=" + Le.guid++ + h), p.url = r + h), p.ifModified && (_k.lastModified[r] && C.setRequestHeader("If-Modified-Since", _k.lastModified[r]), _k.etag[r] && C.setRequestHeader("If-None-Match", _k.etag[r])), (p.data && p.hasContent && !1 !== p.contentType || e.contentType) && C.setRequestHeader("Content-Type", p.contentType), C.setRequestHeader("Accept", p.dataTypes[0] && p.accepts[p.dataTypes[0]] ? p.accepts[p.dataTypes[0]] + ("*" !== p.dataTypes[0] ? ", " + Ge + "; q=0.01" : "") : p.accepts["*"]), p.headers) C.setRequestHeader(u, p.headers[u]);
          if (p.beforeSend && (!1 === p.beforeSend.call(g, C, p) || c)) return C.abort();
          if (j = "abort", v.add(p.complete), C.done(p.success), C.fail(p.error), i = Qe(Ze, p, e, C)) {
            if (C.readyState = 1, d && f.trigger("ajaxSend", [C, p]), c) return C;
            p.async && p.timeout > 0 && (s = n.setTimeout(function () {
              C.abort("timeout");
            }, p.timeout));
            try {
              c = !1, i.send(w, M);
            } catch (t) {
              if (c) throw t;
              M(-1, t);
            }
          } else M(-1, "No Transport");
          function M(t, e, o, l) {
            var u,
              h,
              y,
              w,
              x,
              j = e;
            c || (c = !0, s && n.clearTimeout(s), i = void 0, a = l || "", C.readyState = t > 0 ? 4 : 0, u = t >= 200 && t < 300 || 304 === t, o && (w = function (t, e, n) {
              for (var i, r, a, o, s = t.contents, l = t.dataTypes; "*" === l[0];) l.shift(), void 0 === i && (i = t.mimeType || e.getResponseHeader("Content-Type"));
              if (i) for (r in s) if (s[r] && s[r].test(i)) {
                l.unshift(r);
                break;
              }
              if (l[0] in n) a = l[0];else {
                for (r in n) {
                  if (!l[0] || t.converters[r + " " + l[0]]) {
                    a = r;
                    break;
                  }
                  o || (o = r);
                }
                a = a || o;
              }
              if (a) return a !== l[0] && l.unshift(a), n[a];
            }(p, C, o)), !u && _k.inArray("script", p.dataTypes) > -1 && _k.inArray("json", p.dataTypes) < 0 && (p.converters["text script"] = function () {}), w = function (t, e, n, i) {
              var r,
                a,
                o,
                s,
                l,
                c = {},
                d = t.dataTypes.slice();
              if (d[1]) for (o in t.converters) c[o.toLowerCase()] = t.converters[o];
              for (a = d.shift(); a;) if (t.responseFields[a] && (n[t.responseFields[a]] = e), !l && i && t.dataFilter && (e = t.dataFilter(e, t.dataType)), l = a, a = d.shift()) if ("*" === a) a = l;else if ("*" !== l && l !== a) {
                if (!(o = c[l + " " + a] || c["* " + a])) for (r in c) if ((s = r.split(" "))[1] === a && (o = c[l + " " + s[0]] || c["* " + s[0]])) {
                  !0 === o ? o = c[r] : !0 !== c[r] && (a = s[0], d.unshift(s[1]));
                  break;
                }
                if (!0 !== o) if (o && t.throws) e = o(e);else try {
                  e = o(e);
                } catch (t) {
                  return {
                    state: "parsererror",
                    error: o ? t : "No conversion from " + l + " to " + a
                  };
                }
              }
              return {
                state: "success",
                data: e
              };
            }(p, w, C, u), u ? (p.ifModified && ((x = C.getResponseHeader("Last-Modified")) && (_k.lastModified[r] = x), (x = C.getResponseHeader("etag")) && (_k.etag[r] = x)), 204 === t || "HEAD" === p.type ? j = "nocontent" : 304 === t ? j = "notmodified" : (j = w.state, h = w.data, u = !(y = w.error))) : (y = j, !t && j || (j = "error", t < 0 && (t = 0))), C.status = t, C.statusText = (e || j) + "", u ? m.resolveWith(g, [h, j, C]) : m.rejectWith(g, [C, j, y]), C.statusCode(b), b = void 0, d && f.trigger(u ? "ajaxSuccess" : "ajaxError", [C, p, u ? h : y]), v.fireWith(g, [C, j]), d && (f.trigger("ajaxComplete", [C, p]), --_k.active || _k.event.trigger("ajaxStop")));
          }
          return C;
        },
        getJSON: function getJSON(t, e, n) {
          return _k.get(t, e, n, "json");
        },
        getScript: function getScript(t, e) {
          return _k.get(t, void 0, e, "script");
        }
      }), _k.each(["get", "post"], function (t, e) {
        _k[e] = function (t, n, i, r) {
          return v(n) && (r = r || i, i = n, n = void 0), _k.ajax(_k.extend({
            url: t,
            type: e,
            dataType: r,
            data: n,
            success: i
          }, _k.isPlainObject(t) && t));
        };
      }), _k.ajaxPrefilter(function (t) {
        var e;
        for (e in t.headers) "content-type" === e.toLowerCase() && (t.contentType = t.headers[e] || "");
      }), _k._evalUrl = function (t, e, n) {
        return _k.ajax({
          url: t,
          type: "GET",
          dataType: "script",
          cache: !0,
          async: !1,
          global: !1,
          converters: {
            "text script": function text_script() {}
          },
          dataFilter: function dataFilter(t) {
            _k.globalEval(t, e, n);
          }
        });
      }, _k.fn.extend({
        wrapAll: function wrapAll(t) {
          var e;
          return this[0] && (v(t) && (t = t.call(this[0])), e = _k(t, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && e.insertBefore(this[0]), e.map(function () {
            for (var t = this; t.firstElementChild;) t = t.firstElementChild;
            return t;
          }).append(this)), this;
        },
        wrapInner: function wrapInner(t) {
          return v(t) ? this.each(function (e) {
            _k(this).wrapInner(t.call(this, e));
          }) : this.each(function () {
            var e = _k(this),
              n = e.contents();
            n.length ? n.wrapAll(t) : e.append(t);
          });
        },
        wrap: function wrap(t) {
          var e = v(t);
          return this.each(function (n) {
            _k(this).wrapAll(e ? t.call(this, n) : t);
          });
        },
        unwrap: function unwrap(t) {
          return this.parent(t).not("body").each(function () {
            _k(this).replaceWith(this.childNodes);
          }), this;
        }
      }), _k.expr.pseudos.hidden = function (t) {
        return !_k.expr.pseudos.visible(t);
      }, _k.expr.pseudos.visible = function (t) {
        return !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length);
      }, _k.ajaxSettings.xhr = function () {
        try {
          return new n.XMLHttpRequest();
        } catch (t) {}
      };
      var Xe = {
          0: 200,
          1223: 204
        },
        Ke = _k.ajaxSettings.xhr();
      m.cors = !!Ke && "withCredentials" in Ke, m.ajax = Ke = !!Ke, _k.ajaxTransport(function (t) {
        var _e3, i;
        if (m.cors || Ke && !t.crossDomain) return {
          send: function send(r, a) {
            var o,
              s = t.xhr();
            if (s.open(t.type, t.url, t.async, t.username, t.password), t.xhrFields) for (o in t.xhrFields) s[o] = t.xhrFields[o];
            for (o in t.mimeType && s.overrideMimeType && s.overrideMimeType(t.mimeType), t.crossDomain || r["X-Requested-With"] || (r["X-Requested-With"] = "XMLHttpRequest"), r) s.setRequestHeader(o, r[o]);
            _e3 = function e(t) {
              return function () {
                _e3 && (_e3 = i = s.onload = s.onerror = s.onabort = s.ontimeout = s.onreadystatechange = null, "abort" === t ? s.abort() : "error" === t ? "number" != typeof s.status ? a(0, "error") : a(s.status, s.statusText) : a(Xe[s.status] || s.status, s.statusText, "text" !== (s.responseType || "text") || "string" != typeof s.responseText ? {
                  binary: s.response
                } : {
                  text: s.responseText
                }, s.getAllResponseHeaders()));
              };
            }, s.onload = _e3(), i = s.onerror = s.ontimeout = _e3("error"), void 0 !== s.onabort ? s.onabort = i : s.onreadystatechange = function () {
              4 === s.readyState && n.setTimeout(function () {
                _e3 && i();
              });
            }, _e3 = _e3("abort");
            try {
              s.send(t.hasContent && t.data || null);
            } catch (t) {
              if (_e3) throw t;
            }
          },
          abort: function abort() {
            _e3 && _e3();
          }
        };
      }), _k.ajaxPrefilter(function (t) {
        t.crossDomain && (t.contents.script = !1);
      }), _k.ajaxSetup({
        accepts: {
          script: "text/javascript, application/javascript, " + "application/ecmascript, application/x-ecmascript"
        },
        contents: {
          script: /\b(?:java|ecma)script\b/
        },
        converters: {
          "text script": function text_script(t) {
            return _k.globalEval(t), t;
          }
        }
      }), _k.ajaxPrefilter("script", function (t) {
        void 0 === t.cache && (t.cache = !1), t.crossDomain && (t.type = "GET");
      }), _k.ajaxTransport("script", function (t) {
        var e, _n2;
        if (t.crossDomain || t.scriptAttrs) return {
          send: function send(i, r) {
            e = _k("<script>").attr(t.scriptAttrs || {}).prop({
              charset: t.scriptCharset,
              src: t.url
            }).on("load error", _n2 = function n(t) {
              e.remove(), _n2 = null, t && r("error" === t.type ? 404 : 200, t.type);
            }), y.head.appendChild(e[0]);
          },
          abort: function abort() {
            _n2 && _n2();
          }
        };
      });
      var tn,
        en = [],
        nn = /(=)\?(?=&|$)|\?\?/;
      _k.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function jsonpCallback() {
          var t = en.pop() || _k.expando + "_" + Le.guid++;
          return this[t] = !0, t;
        }
      }), _k.ajaxPrefilter("json jsonp", function (t, e, i) {
        var r,
          a,
          o,
          s = !1 !== t.jsonp && (nn.test(t.url) ? "url" : "string" == typeof t.data && 0 === (t.contentType || "").indexOf("application/x-www-form-urlencoded") && nn.test(t.data) && "data");
        if (s || "jsonp" === t.dataTypes[0]) return r = t.jsonpCallback = v(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback, s ? t[s] = t[s].replace(nn, "$1" + r) : !1 !== t.jsonp && (t.url += (De.test(t.url) ? "&" : "?") + t.jsonp + "=" + r), t.converters["script json"] = function () {
          return o || _k.error(r + " was not called"), o[0];
        }, t.dataTypes[0] = "json", a = n[r], n[r] = function () {
          o = arguments;
        }, i.always(function () {
          void 0 === a ? _k(n).removeProp(r) : n[r] = a, t[r] && (t.jsonpCallback = e.jsonpCallback, en.push(r)), o && v(a) && a(o[0]), o = a = void 0;
        }), "script";
      }), m.createHTMLDocument = ((tn = y.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>", 2 === tn.childNodes.length), _k.parseHTML = function (t, e, n) {
        return "string" != typeof t ? [] : ("boolean" == typeof e && (n = e, e = !1), e || (m.createHTMLDocument ? ((i = (e = y.implementation.createHTMLDocument("")).createElement("base")).href = y.location.href, e.head.appendChild(i)) : e = y), a = !n && [], (r = F.exec(t)) ? [e.createElement(r[1])] : (r = Et([t], e, a), a && a.length && _k(a).remove(), _k.merge([], r.childNodes)));
        var i, r, a;
      }, _k.fn.load = function (t, e, n) {
        var i,
          r,
          a,
          o = this,
          s = t.indexOf(" ");
        return s > -1 && (i = ke(t.slice(s)), t = t.slice(0, s)), v(e) ? (n = e, e = void 0) : e && "object" == typeof e && (r = "POST"), o.length > 0 && _k.ajax({
          url: t,
          type: r || "GET",
          dataType: "html",
          data: e
        }).done(function (t) {
          a = arguments, o.html(i ? _k("<div>").append(_k.parseHTML(t)).find(i) : t);
        }).always(n && function (t, e) {
          o.each(function () {
            n.apply(this, a || [t.responseText, e, t]);
          });
        }), this;
      }, _k.expr.pseudos.animated = function (t) {
        return _k.grep(_k.timers, function (e) {
          return t === e.elem;
        }).length;
      }, _k.offset = {
        setOffset: function setOffset(t, e, n) {
          var i,
            r,
            a,
            o,
            s,
            l,
            c = _k.css(t, "position"),
            d = _k(t),
            u = {};
          "static" === c && (t.style.position = "relative"), s = d.offset(), a = _k.css(t, "top"), l = _k.css(t, "left"), ("absolute" === c || "fixed" === c) && (a + l).indexOf("auto") > -1 ? (o = (i = d.position()).top, r = i.left) : (o = parseFloat(a) || 0, r = parseFloat(l) || 0), v(e) && (e = e.call(t, n, _k.extend({}, s))), null != e.top && (u.top = e.top - s.top + o), null != e.left && (u.left = e.left - s.left + r), "using" in e ? e.using.call(t, u) : d.css(u);
        }
      }, _k.fn.extend({
        offset: function offset(t) {
          if (arguments.length) return void 0 === t ? this : this.each(function (e) {
            _k.offset.setOffset(this, t, e);
          });
          var e,
            n,
            i = this[0];
          return i ? i.getClientRects().length ? (e = i.getBoundingClientRect(), n = i.ownerDocument.defaultView, {
            top: e.top + n.pageYOffset,
            left: e.left + n.pageXOffset
          }) : {
            top: 0,
            left: 0
          } : void 0;
        },
        position: function position() {
          if (this[0]) {
            var t,
              e,
              n,
              i = this[0],
              r = {
                top: 0,
                left: 0
              };
            if ("fixed" === _k.css(i, "position")) e = i.getBoundingClientRect();else {
              for (e = this.offset(), n = i.ownerDocument, t = i.offsetParent || n.documentElement; t && (t === n.body || t === n.documentElement) && "static" === _k.css(t, "position");) t = t.parentNode;
              t && t !== i && 1 === t.nodeType && ((r = _k(t).offset()).top += _k.css(t, "borderTopWidth", !0), r.left += _k.css(t, "borderLeftWidth", !0));
            }
            return {
              top: e.top - r.top - _k.css(i, "marginTop", !0),
              left: e.left - r.left - _k.css(i, "marginLeft", !0)
            };
          }
        },
        offsetParent: function offsetParent() {
          return this.map(function () {
            for (var t = this.offsetParent; t && "static" === _k.css(t, "position");) t = t.offsetParent;
            return t || ft;
          });
        }
      }), _k.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
      }, function (t, e) {
        var n = "pageYOffset" === e;
        _k.fn[t] = function (i) {
          return _tt(this, function (t, i, r) {
            var a;
            if (b(t) ? a = t : 9 === t.nodeType && (a = t.defaultView), void 0 === r) return a ? a[e] : t[i];
            a ? a.scrollTo(n ? a.pageXOffset : r, n ? r : a.pageYOffset) : t[i] = r;
          }, t, i, arguments.length);
        };
      }), _k.each(["top", "left"], function (t, e) {
        _k.cssHooks[e] = te(m.pixelPosition, function (t, n) {
          if (n) return n = Kt(t, e), qt.test(n) ? _k(t).position()[e] + "px" : n;
        });
      }), _k.each({
        Height: "height",
        Width: "width"
      }, function (t, e) {
        _k.each({
          padding: "inner" + t,
          content: e,
          "": "outer" + t
        }, function (n, i) {
          _k.fn[i] = function (r, a) {
            var o = arguments.length && (n || "boolean" != typeof r),
              s = n || (!0 === r || !0 === a ? "margin" : "border");
            return _tt(this, function (e, n, r) {
              var a;
              return b(e) ? 0 === i.indexOf("outer") ? e["inner" + t] : e.document.documentElement["client" + t] : 9 === e.nodeType ? (a = e.documentElement, Math.max(e.body["scroll" + t], a["scroll" + t], e.body["offset" + t], a["offset" + t], a["client" + t])) : void 0 === r ? _k.css(e, n, s) : _k.style(e, n, r, s);
            }, e, o ? r : void 0, o);
          };
        });
      }), _k.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (t, e) {
        _k.fn[e] = function (t) {
          return this.on(e, t);
        };
      }), _k.fn.extend({
        bind: function bind(t, e, n) {
          return this.on(t, null, e, n);
        },
        unbind: function unbind(t, e) {
          return this.off(t, null, e);
        },
        delegate: function delegate(t, e, n, i) {
          return this.on(e, t, n, i);
        },
        undelegate: function undelegate(t, e, n) {
          return 1 === arguments.length ? this.off(t, "**") : this.off(e, t || "**", n);
        },
        hover: function hover(t, e) {
          return this.on("mouseenter", t).on("mouseleave", e || t);
        }
      }), _k.each(("blur focus focusin focusout resize scroll click dblclick " + "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " + "change select submit keydown keypress keyup contextmenu").split(" "), function (t, e) {
        _k.fn[e] = function (t, n) {
          return arguments.length > 0 ? this.on(e, null, t, n) : this.trigger(e);
        };
      });
      var rn = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
      _k.proxy = function (t, e) {
        var n, i, r;
        if ("string" == typeof e && (n = t[e], e = t, t = n), v(t)) return i = s.call(arguments, 2), (r = function r() {
          return t.apply(e || this, i.concat(s.call(arguments)));
        }).guid = t.guid = t.guid || _k.guid++, r;
      }, _k.holdReady = function (t) {
        t ? _k.readyWait++ : _k.ready(!0);
      }, _k.isArray = Array.isArray, _k.parseJSON = JSON.parse, _k.nodeName = T, _k.isFunction = v, _k.isWindow = b, _k.camelCase = rt, _k.type = j, _k.now = Date.now, _k.isNumeric = function (t) {
        var e = _k.type(t);
        return ("number" === e || "string" === e) && !isNaN(t - parseFloat(t));
      }, _k.trim = function (t) {
        return null == t ? "" : (t + "").replace(rn, "$1");
      }, 1 && (void 0 === (i = function () {
        return _k;
      }.apply(e, [])) || (t.exports = i));
      var an = n.jQuery,
        on = n.$;
      return _k.noConflict = function (t) {
        return n.$ === _k && (n.$ = on), t && n.jQuery === _k && (n.jQuery = an), _k;
      }, void 0 === r && (n.jQuery = n.$ = _k), _k;
    });
  }, function (t, e, n) {
    var i = n(1),
      r = n(21);
    t.exports = function (t, e, n, a) {
      t = i(t), e = ~~e;
      var o = 0;
      switch (n ? n.length > 1 && (n = n.charAt(0)) : n = ' ', a) {
        case 'right':
          return o = e - t.length, t + r(n, o);
        case 'both':
          return o = e - t.length, r(n, Math.ceil(o / 2)) + t + r(n, Math.floor(o / 2));
        default:
          return o = e - t.length, r(n, o) + t;
      }
    };
  }, function (t, e, n) {
    var i = n(1);
    t.exports = function (t, e) {
      t = i(t);
      var n = e ? t.slice(1).toLowerCase() : t.slice(1);
      return t.charAt(0).toUpperCase() + n;
    };
  }, function (t, e, n) {
    var i = n(13);
    t.exports = function (t) {
      return null == t ? '\\s' : t.source ? t.source : '[' + i(t) + ']';
    };
  }, function (t, e, n) {
    var i = n(1);
    t.exports = function (t) {
      return i(t).split('');
    };
  }, function (t, e, n) {
    var i = n(1),
      r = n(7),
      a = String.prototype.trimRight;
    t.exports = function (t, e) {
      return t = i(t), !e && a ? a.call(t) : (e = r(e), t.replace(new RegExp(e + '+$'), ''));
    };
  }, function (t, e, n) {
    "use strict";

    function i(t) {
      if (!(this instanceof i)) return new i(t);
      this._wrapped = t;
    }
    function r(t, e) {
      'function' == typeof e && (i.prototype[t] = function () {
        var t = [this._wrapped].concat(Array.prototype.slice.call(arguments)),
          n = e.apply(null, t);
        return 'string' == typeof n ? new i(n) : n;
      });
    }
    for (var a in i.VERSION = '3.3.6', i.isBlank = n(11), i.stripTags = n(28), i.capitalize = n(6), i.decapitalize = n(12), i.chop = n(29), i.trim = n(3), i.clean = n(30), i.cleanDiacritics = n(14), i.count = n(31), i.chars = n(8), i.swapCase = n(32), i.escapeHTML = n(33), i.unescapeHTML = n(35), i.splice = n(15), i.insert = n(37), i.replaceAll = n(38), i.include = n(39), i.join = n(40), i.lines = n(41), i.dedent = n(42), i.reverse = n(43), i.startsWith = n(44), i.endsWith = n(45), i.pred = n(46), i.succ = n(47), i.titleize = n(48), i.camelize = n(18), i.underscored = n(19), i.dasherize = n(20), i.classify = n(49), i.humanize = n(50), i.ltrim = n(51), i.rtrim = n(9), i.truncate = n(52), i.prune = n(53), i.words = n(54), i.pad = n(5), i.lpad = n(55), i.rpad = n(56), i.lrpad = n(57), i.sprintf = n(58), i.vsprintf = n(59), i.toNumber = n(60), i.numberFormat = n(61), i.strRight = n(62), i.strRightBack = n(63), i.strLeft = n(64), i.strLeftBack = n(65), i.toSentence = n(25), i.toSentenceSerial = n(66), i.slugify = n(67), i.surround = n(26), i.quote = n(68), i.unquote = n(69), i.repeat = n(70), i.naturalCmp = n(71), i.levenshtein = n(72), i.toBoolean = n(73), i.exports = n(74), i.escapeRegExp = n(13), i.wrap = n(75), i.map = n(76), i.strip = i.trim, i.lstrip = i.ltrim, i.rstrip = i.rtrim, i.center = i.lrpad, i.rjust = i.lpad, i.ljust = i.rpad, i.contains = i.include, i.q = i.quote, i.toBool = i.toBoolean, i.camelcase = i.camelize, i.mapChars = i.map, i.prototype = {
      value: function value() {
        return this._wrapped;
      }
    }, i) r(a, i[a]);
    function o(t) {
      r(t, function (e) {
        var n = Array.prototype.slice.call(arguments, 1);
        return String.prototype[t].apply(e, n);
      });
    }
    r('tap', function (t, e) {
      return e(t);
    });
    var s = ['toUpperCase', 'toLowerCase', 'split', 'replace', 'slice', 'substring', 'substr', 'concat'];
    for (var l in s) o(s[l]);
    t.exports = i;
  }, function (t, e, n) {
    var i = n(1);
    t.exports = function (t) {
      return /^\s*$/.test(i(t));
    };
  }, function (t, e, n) {
    var i = n(1);
    t.exports = function (t) {
      return (t = i(t)).charAt(0).toLowerCase() + t.slice(1);
    };
  }, function (t, e, n) {
    var i = n(1);
    t.exports = function (t) {
      return i(t).replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
    };
  }, function (t, e, n) {
    var i = n(1),
      r = 'ąàáäâãåæăćčĉęèéëêĝĥìíïîĵłľńňòóöőôõðøśșşšŝťțţŭùúüűûñÿýçżźž',
      a = 'aaaaaaaaaccceeeeeghiiiijllnnoooooooossssstttuuuuuunyyczzz';
    r += r.toUpperCase(), a = (a += a.toUpperCase()).split(''), r += 'ß', a.push('ss'), t.exports = function (t) {
      return i(t).replace(/.{1}/g, function (t) {
        var e = r.indexOf(t);
        return -1 === e ? t : a[e];
      });
    };
  }, function (t, e, n) {
    var i = n(8);
    t.exports = function (t, e, n, r) {
      var a = i(t);
      return a.splice(~~e, ~~n, r), a.join('');
    };
  }, function (t, e) {
    t.exports = function (t) {
      return t < 0 ? 0 : +t || 0;
    };
  }, function (t, e, n) {
    var i = n(1);
    t.exports = function (t, e) {
      return 0 === (t = i(t)).length ? '' : t.slice(0, -1) + String.fromCharCode(t.charCodeAt(t.length - 1) + e);
    };
  }, function (t, e, n) {
    var i = n(3),
      r = n(12);
    t.exports = function (t, e) {
      return t = i(t).replace(/[-_\s]+(.)?/g, function (t, e) {
        return e ? e.toUpperCase() : '';
      }), !0 === e ? r(t) : t;
    };
  }, function (t, e, n) {
    var i = n(3);
    t.exports = function (t) {
      return i(t).replace(/([a-z\d])([A-Z]+)/g, '$1_$2').replace(/[-\s]+/g, '_').toLowerCase();
    };
  }, function (t, e, n) {
    var i = n(3);
    t.exports = function (t) {
      return i(t).replace(/([A-Z])/g, '-$1').replace(/[-_\s]+/g, '-').toLowerCase();
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      if (e < 1) return '';
      for (var n = ''; e > 0;) 1 & e && (n += t), e >>= 1, t += t;
      return n;
    };
  }, function (t, e, n) {
    (function (e) {
      function n(t) {
        try {
          if (!e.localStorage) return !1;
        } catch (t) {
          return !1;
        }
        var n = e.localStorage[t];
        return null != n && 'true' === String(n).toLowerCase();
      }
      t.exports = function (t, e) {
        if (n('noDeprecation')) return t;
        var i = !1;
        return function () {
          if (!i) {
            if (n('throwDeprecation')) throw new Error(e);
            n('traceDeprecation') ? console.trace(e) : console.warn(e), i = !0;
          }
          return t.apply(this, arguments);
        };
      };
    }).call(this, n(23));
  }, function (t, e) {
    var n;
    n = function () {
      return this;
    }();
    try {
      n = n || new Function("return this")();
    } catch (t) {
      "object" == typeof window && (n = window);
    }
    t.exports = n;
  }, function (t, e, n) {
    var i;
    !function () {
      'use strict';

      var r = {
        not_string: /[^s]/,
        not_bool: /[^t]/,
        not_type: /[^T]/,
        not_primitive: /[^v]/,
        number: /[diefg]/,
        numeric_arg: /[bcdiefguxX]/,
        json: /[j]/,
        not_json: /[^j]/,
        text: /^[^\x25]+/,
        modulo: /^\x25{2}/,
        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
        key: /^([a-z_][a-z_\d]*)/i,
        key_access: /^\.([a-z_][a-z_\d]*)/i,
        index_access: /^\[(\d+)\]/,
        sign: /^[+-]/
      };
      function a(t) {
        return s(c(t), arguments);
      }
      function o(t, e) {
        return a.apply(null, [t].concat(e || []));
      }
      function s(t, e) {
        var n,
          i,
          o,
          s,
          l,
          c,
          d,
          u,
          h,
          p = 1,
          g = t.length,
          f = '';
        for (i = 0; i < g; i++) if ('string' == typeof t[i]) f += t[i];else if ('object' == typeof t[i]) {
          if ((s = t[i]).keys) for (n = e[p], o = 0; o < s.keys.length; o++) {
            if (null == n) throw new Error(a('[sprintf] Cannot access property "%s" of undefined value "%s"', s.keys[o], s.keys[o - 1]));
            n = n[s.keys[o]];
          } else n = s.param_no ? e[s.param_no] : e[p++];
          if (r.not_type.test(s.type) && r.not_primitive.test(s.type) && n instanceof Function && (n = n()), r.numeric_arg.test(s.type) && 'number' != typeof n && isNaN(n)) throw new TypeError(a('[sprintf] expecting number but found %T', n));
          switch (r.number.test(s.type) && (u = n >= 0), s.type) {
            case 'b':
              n = parseInt(n, 10).toString(2);
              break;
            case 'c':
              n = String.fromCharCode(parseInt(n, 10));
              break;
            case 'd':
            case 'i':
              n = parseInt(n, 10);
              break;
            case 'j':
              n = JSON.stringify(n, null, s.width ? parseInt(s.width) : 0);
              break;
            case 'e':
              n = s.precision ? parseFloat(n).toExponential(s.precision) : parseFloat(n).toExponential();
              break;
            case 'f':
              n = s.precision ? parseFloat(n).toFixed(s.precision) : parseFloat(n);
              break;
            case 'g':
              n = s.precision ? String(Number(n.toPrecision(s.precision))) : parseFloat(n);
              break;
            case 'o':
              n = (parseInt(n, 10) >>> 0).toString(8);
              break;
            case 's':
              n = String(n), n = s.precision ? n.substring(0, s.precision) : n;
              break;
            case 't':
              n = String(!!n), n = s.precision ? n.substring(0, s.precision) : n;
              break;
            case 'T':
              n = Object.prototype.toString.call(n).slice(8, -1).toLowerCase(), n = s.precision ? n.substring(0, s.precision) : n;
              break;
            case 'u':
              n = parseInt(n, 10) >>> 0;
              break;
            case 'v':
              n = n.valueOf(), n = s.precision ? n.substring(0, s.precision) : n;
              break;
            case 'x':
              n = (parseInt(n, 10) >>> 0).toString(16);
              break;
            case 'X':
              n = (parseInt(n, 10) >>> 0).toString(16).toUpperCase();
          }
          r.json.test(s.type) ? f += n : (!r.number.test(s.type) || u && !s.sign ? h = '' : (h = u ? '+' : '-', n = n.toString().replace(r.sign, '')), c = s.pad_char ? '0' === s.pad_char ? '0' : s.pad_char.charAt(1) : ' ', d = s.width - (h + n).length, l = s.width && d > 0 ? c.repeat(d) : '', f += s.align ? h + n + l : '0' === c ? h + l + n : l + h + n);
        }
        return f;
      }
      var l = Object.create(null);
      function c(t) {
        if (l[t]) return l[t];
        for (var e, n = t, i = [], a = 0; n;) {
          if (null !== (e = r.text.exec(n))) i.push(e[0]);else if (null !== (e = r.modulo.exec(n))) i.push('%');else {
            if (null === (e = r.placeholder.exec(n))) throw new SyntaxError('[sprintf] unexpected placeholder');
            if (e[2]) {
              a |= 1;
              var o = [],
                s = e[2],
                c = [];
              if (null === (c = r.key.exec(s))) throw new SyntaxError('[sprintf] failed to parse named argument key');
              for (o.push(c[1]); '' !== (s = s.substring(c[0].length));) if (null !== (c = r.key_access.exec(s))) o.push(c[1]);else {
                if (null === (c = r.index_access.exec(s))) throw new SyntaxError('[sprintf] failed to parse named argument key');
                o.push(c[1]);
              }
              e[2] = o;
            } else a |= 2;
            if (3 === a) throw new Error('[sprintf] mixing positional and named placeholders is not (yet) supported');
            i.push({
              placeholder: e[0],
              param_no: e[1],
              keys: e[2],
              sign: e[3],
              pad_char: e[4],
              align: e[5],
              width: e[6],
              precision: e[7],
              type: e[8]
            });
          }
          n = n.substring(e[0].length);
        }
        return l[t] = i;
      }
      1 && (e['sprintf'] = a, e['vsprintf'] = o), 'undefined' != typeof window && (window['sprintf'] = a, window['vsprintf'] = o, 1 && (void 0 === (i = function () {
        return {
          sprintf: a,
          vsprintf: o
        };
      }.call(e, n, e, t)) || (t.exports = i)));
    }();
  }, function (t, e, n) {
    var i = n(9);
    t.exports = function (t, e, n, r) {
      e = e || ', ', n = n || ' and ';
      var a = t.slice(),
        o = a.pop();
      return t.length > 2 && r && (n = i(e) + n), a.length ? a.join(e) + n + o : o;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return [e, t, e].join('');
    };
  }, function (t, e, n) {
    window, 1 && (t.exports = function (t) {
      var e = {};
      function n(i) {
        if (e[i]) return e[i].exports;
        var r = e[i] = {
          i: i,
          l: !1,
          exports: {}
        };
        return t[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
      }
      return n.m = t, n.c = e, n.d = function (t, e, i) {
        n.o(t, e) || Object.defineProperty(t, e, {
          enumerable: !0,
          get: i
        });
      }, n.r = function (t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(t, "__esModule", {
          value: !0
        });
      }, n.t = function (t, e) {
        if (1 & e && (t = n(t)), 8 & e) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var i = Object.create(null);
        if (n.r(i), Object.defineProperty(i, "default", {
          enumerable: !0,
          value: t
        }), 2 & e && "string" != typeof t) for (var r in t) n.d(i, r, function (e) {
          return t[e];
        }.bind(null, r));
        return i;
      }, n.n = function (t) {
        var e = t && t.__esModule ? function () {
          return t.default;
        } : function () {
          return t;
        };
        return n.d(e, "a", e), e;
      }, n.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }, n.p = "", n(n.s = 102);
    }([function (t, e, n) {
      "use strict";

      n.r(e), n.d(e, "default", function () {
        return xn;
      }), n.d(e, "VERSION", function () {
        return r.e;
      }), n.d(e, "restArguments", function () {
        return a;
      }), n.d(e, "isObject", function () {
        return o;
      }), n.d(e, "isNull", function () {
        return s;
      }), n.d(e, "isUndefined", function () {
        return l;
      }), n.d(e, "isBoolean", function () {
        return c;
      }), n.d(e, "isElement", function () {
        return d;
      }), n.d(e, "isString", function () {
        return h;
      }), n.d(e, "isNumber", function () {
        return p;
      }), n.d(e, "isDate", function () {
        return g;
      }), n.d(e, "isRegExp", function () {
        return f;
      }), n.d(e, "isError", function () {
        return m;
      }), n.d(e, "isSymbol", function () {
        return v;
      }), n.d(e, "isArrayBuffer", function () {
        return b;
      }), n.d(e, "isDataView", function () {
        return O;
      }), n.d(e, "isArray", function () {
        return T;
      }), n.d(e, "isFunction", function () {
        return x;
      }), n.d(e, "isArguments", function () {
        return L;
      }), n.d(e, "isFinite", function () {
        return D;
      }), n.d(e, "isNaN", function () {
        return E;
      }), n.d(e, "isTypedArray", function () {
        return V;
      }), n.d(e, "isEmpty", function () {
        return W;
      }), n.d(e, "isMatch", function () {
        return Y;
      }), n.d(e, "isEqual", function () {
        return G;
      }), n.d(e, "isMap", function () {
        return nt;
      }), n.d(e, "isWeakMap", function () {
        return it;
      }), n.d(e, "isSet", function () {
        return rt;
      }), n.d(e, "isWeakSet", function () {
        return at;
      }), n.d(e, "keys", function () {
        return B;
      }), n.d(e, "allKeys", function () {
        return q;
      }), n.d(e, "values", function () {
        return ot;
      }), n.d(e, "pairs", function () {
        return st;
      }), n.d(e, "invert", function () {
        return lt;
      }), n.d(e, "functions", function () {
        return ct;
      }), n.d(e, "methods", function () {
        return ct;
      }), n.d(e, "extend", function () {
        return ut;
      }), n.d(e, "extendOwn", function () {
        return ht;
      }), n.d(e, "assign", function () {
        return ht;
      }), n.d(e, "defaults", function () {
        return pt;
      }), n.d(e, "create", function () {
        return ft;
      }), n.d(e, "clone", function () {
        return mt;
      }), n.d(e, "tap", function () {
        return vt;
      }), n.d(e, "get", function () {
        return xt;
      }), n.d(e, "has", function () {
        return jt;
      }), n.d(e, "mapObject", function () {
        return Lt;
      }), n.d(e, "identity", function () {
        return Ct;
      }), n.d(e, "constant", function () {
        return I;
      }), n.d(e, "noop", function () {
        return Dt;
      }), n.d(e, "toPath", function () {
        return bt;
      }), n.d(e, "property", function () {
        return kt;
      }), n.d(e, "propertyOf", function () {
        return Et;
      }), n.d(e, "matcher", function () {
        return Mt;
      }), n.d(e, "matches", function () {
        return Mt;
      }), n.d(e, "times", function () {
        return It;
      }), n.d(e, "random", function () {
        return Pt;
      }), n.d(e, "now", function () {
        return At;
      }), n.d(e, "escape", function () {
        return Ht;
      }), n.d(e, "unescape", function () {
        return Vt;
      }), n.d(e, "templateSettings", function () {
        return Ft;
      }), n.d(e, "template", function () {
        return Zt;
      }), n.d(e, "result", function () {
        return Gt;
      }), n.d(e, "uniqueId", function () {
        return $t;
      }), n.d(e, "chain", function () {
        return Qt;
      }), n.d(e, "iteratee", function () {
        return St;
      }), n.d(e, "partial", function () {
        return Kt;
      }), n.d(e, "bind", function () {
        return te;
      }), n.d(e, "bindAll", function () {
        return ie;
      }), n.d(e, "memoize", function () {
        return re;
      }), n.d(e, "delay", function () {
        return ae;
      }), n.d(e, "defer", function () {
        return oe;
      }), n.d(e, "throttle", function () {
        return se;
      }), n.d(e, "debounce", function () {
        return le;
      }), n.d(e, "wrap", function () {
        return ce;
      }), n.d(e, "negate", function () {
        return de;
      }), n.d(e, "compose", function () {
        return ue;
      }), n.d(e, "after", function () {
        return he;
      }), n.d(e, "before", function () {
        return pe;
      }), n.d(e, "once", function () {
        return ge;
      }), n.d(e, "findKey", function () {
        return fe;
      }), n.d(e, "findIndex", function () {
        return ve;
      }), n.d(e, "findLastIndex", function () {
        return be;
      }), n.d(e, "sortedIndex", function () {
        return ye;
      }), n.d(e, "indexOf", function () {
        return xe;
      }), n.d(e, "lastIndexOf", function () {
        return je;
      }), n.d(e, "find", function () {
        return Ce;
      }), n.d(e, "detect", function () {
        return Ce;
      }), n.d(e, "findWhere", function () {
        return Me;
      }), n.d(e, "each", function () {
        return ke;
      }), n.d(e, "forEach", function () {
        return ke;
      }), n.d(e, "map", function () {
        return Oe;
      }), n.d(e, "collect", function () {
        return Oe;
      }), n.d(e, "reduce", function () {
        return Se;
      }), n.d(e, "foldl", function () {
        return Se;
      }), n.d(e, "inject", function () {
        return Se;
      }), n.d(e, "reduceRight", function () {
        return Ne;
      }), n.d(e, "foldr", function () {
        return Ne;
      }), n.d(e, "filter", function () {
        return Le;
      }), n.d(e, "select", function () {
        return Le;
      }), n.d(e, "reject", function () {
        return De;
      }), n.d(e, "every", function () {
        return Ee;
      }), n.d(e, "all", function () {
        return Ee;
      }), n.d(e, "some", function () {
        return Ie;
      }), n.d(e, "any", function () {
        return Ie;
      }), n.d(e, "contains", function () {
        return Pe;
      }), n.d(e, "includes", function () {
        return Pe;
      }), n.d(e, "include", function () {
        return Pe;
      }), n.d(e, "invoke", function () {
        return Ae;
      }), n.d(e, "pluck", function () {
        return ze;
      }), n.d(e, "where", function () {
        return _e;
      }), n.d(e, "max", function () {
        return He;
      }), n.d(e, "min", function () {
        return Ve;
      }), n.d(e, "shuffle", function () {
        return We;
      }), n.d(e, "sample", function () {
        return Be;
      }), n.d(e, "sortBy", function () {
        return Ye;
      }), n.d(e, "groupBy", function () {
        return Ze;
      }), n.d(e, "indexBy", function () {
        return Ge;
      }), n.d(e, "countBy", function () {
        return qe;
      }), n.d(e, "partition", function () {
        return $e;
      }), n.d(e, "toArray", function () {
        return Re;
      }), n.d(e, "size", function () {
        return Qe;
      }), n.d(e, "pick", function () {
        return Xe;
      }), n.d(e, "omit", function () {
        return Ke;
      }), n.d(e, "first", function () {
        return en;
      }), n.d(e, "head", function () {
        return en;
      }), n.d(e, "take", function () {
        return en;
      }), n.d(e, "initial", function () {
        return tn;
      }), n.d(e, "last", function () {
        return rn;
      }), n.d(e, "rest", function () {
        return nn;
      }), n.d(e, "tail", function () {
        return nn;
      }), n.d(e, "drop", function () {
        return nn;
      }), n.d(e, "compact", function () {
        return an;
      }), n.d(e, "flatten", function () {
        return on;
      }), n.d(e, "without", function () {
        return ln;
      }), n.d(e, "uniq", function () {
        return cn;
      }), n.d(e, "unique", function () {
        return cn;
      }), n.d(e, "union", function () {
        return dn;
      }), n.d(e, "intersection", function () {
        return un;
      }), n.d(e, "difference", function () {
        return sn;
      }), n.d(e, "unzip", function () {
        return hn;
      }), n.d(e, "transpose", function () {
        return hn;
      }), n.d(e, "zip", function () {
        return pn;
      }), n.d(e, "object", function () {
        return gn;
      }), n.d(e, "range", function () {
        return fn;
      }), n.d(e, "chunk", function () {
        return mn;
      }), n.d(e, "mixin", function () {
        return bn;
      });
      var i = {};
      n.r(i), n.d(i, "VERSION", function () {
        return r.e;
      }), n.d(i, "restArguments", function () {
        return a;
      }), n.d(i, "isObject", function () {
        return o;
      }), n.d(i, "isNull", function () {
        return s;
      }), n.d(i, "isUndefined", function () {
        return l;
      }), n.d(i, "isBoolean", function () {
        return c;
      }), n.d(i, "isElement", function () {
        return d;
      }), n.d(i, "isString", function () {
        return h;
      }), n.d(i, "isNumber", function () {
        return p;
      }), n.d(i, "isDate", function () {
        return g;
      }), n.d(i, "isRegExp", function () {
        return f;
      }), n.d(i, "isError", function () {
        return m;
      }), n.d(i, "isSymbol", function () {
        return v;
      }), n.d(i, "isArrayBuffer", function () {
        return b;
      }), n.d(i, "isDataView", function () {
        return O;
      }), n.d(i, "isArray", function () {
        return T;
      }), n.d(i, "isFunction", function () {
        return x;
      }), n.d(i, "isArguments", function () {
        return L;
      }), n.d(i, "isFinite", function () {
        return D;
      }), n.d(i, "isNaN", function () {
        return E;
      }), n.d(i, "isTypedArray", function () {
        return V;
      }), n.d(i, "isEmpty", function () {
        return W;
      }), n.d(i, "isMatch", function () {
        return Y;
      }), n.d(i, "isEqual", function () {
        return G;
      }), n.d(i, "isMap", function () {
        return nt;
      }), n.d(i, "isWeakMap", function () {
        return it;
      }), n.d(i, "isSet", function () {
        return rt;
      }), n.d(i, "isWeakSet", function () {
        return at;
      }), n.d(i, "keys", function () {
        return B;
      }), n.d(i, "allKeys", function () {
        return q;
      }), n.d(i, "values", function () {
        return ot;
      }), n.d(i, "pairs", function () {
        return st;
      }), n.d(i, "invert", function () {
        return lt;
      }), n.d(i, "functions", function () {
        return ct;
      }), n.d(i, "methods", function () {
        return ct;
      }), n.d(i, "extend", function () {
        return ut;
      }), n.d(i, "extendOwn", function () {
        return ht;
      }), n.d(i, "assign", function () {
        return ht;
      }), n.d(i, "defaults", function () {
        return pt;
      }), n.d(i, "create", function () {
        return ft;
      }), n.d(i, "clone", function () {
        return mt;
      }), n.d(i, "tap", function () {
        return vt;
      }), n.d(i, "get", function () {
        return xt;
      }), n.d(i, "has", function () {
        return jt;
      }), n.d(i, "mapObject", function () {
        return Lt;
      }), n.d(i, "identity", function () {
        return Ct;
      }), n.d(i, "constant", function () {
        return I;
      }), n.d(i, "noop", function () {
        return Dt;
      }), n.d(i, "toPath", function () {
        return bt;
      }), n.d(i, "property", function () {
        return kt;
      }), n.d(i, "propertyOf", function () {
        return Et;
      }), n.d(i, "matcher", function () {
        return Mt;
      }), n.d(i, "matches", function () {
        return Mt;
      }), n.d(i, "times", function () {
        return It;
      }), n.d(i, "random", function () {
        return Pt;
      }), n.d(i, "now", function () {
        return At;
      }), n.d(i, "escape", function () {
        return Ht;
      }), n.d(i, "unescape", function () {
        return Vt;
      }), n.d(i, "templateSettings", function () {
        return Ft;
      }), n.d(i, "template", function () {
        return Zt;
      }), n.d(i, "result", function () {
        return Gt;
      }), n.d(i, "uniqueId", function () {
        return $t;
      }), n.d(i, "chain", function () {
        return Qt;
      }), n.d(i, "iteratee", function () {
        return St;
      }), n.d(i, "partial", function () {
        return Kt;
      }), n.d(i, "bind", function () {
        return te;
      }), n.d(i, "bindAll", function () {
        return ie;
      }), n.d(i, "memoize", function () {
        return re;
      }), n.d(i, "delay", function () {
        return ae;
      }), n.d(i, "defer", function () {
        return oe;
      }), n.d(i, "throttle", function () {
        return se;
      }), n.d(i, "debounce", function () {
        return le;
      }), n.d(i, "wrap", function () {
        return ce;
      }), n.d(i, "negate", function () {
        return de;
      }), n.d(i, "compose", function () {
        return ue;
      }), n.d(i, "after", function () {
        return he;
      }), n.d(i, "before", function () {
        return pe;
      }), n.d(i, "once", function () {
        return ge;
      }), n.d(i, "findKey", function () {
        return fe;
      }), n.d(i, "findIndex", function () {
        return ve;
      }), n.d(i, "findLastIndex", function () {
        return be;
      }), n.d(i, "sortedIndex", function () {
        return ye;
      }), n.d(i, "indexOf", function () {
        return xe;
      }), n.d(i, "lastIndexOf", function () {
        return je;
      }), n.d(i, "find", function () {
        return Ce;
      }), n.d(i, "detect", function () {
        return Ce;
      }), n.d(i, "findWhere", function () {
        return Me;
      }), n.d(i, "each", function () {
        return ke;
      }), n.d(i, "forEach", function () {
        return ke;
      }), n.d(i, "map", function () {
        return Oe;
      }), n.d(i, "collect", function () {
        return Oe;
      }), n.d(i, "reduce", function () {
        return Se;
      }), n.d(i, "foldl", function () {
        return Se;
      }), n.d(i, "inject", function () {
        return Se;
      }), n.d(i, "reduceRight", function () {
        return Ne;
      }), n.d(i, "foldr", function () {
        return Ne;
      }), n.d(i, "filter", function () {
        return Le;
      }), n.d(i, "select", function () {
        return Le;
      }), n.d(i, "reject", function () {
        return De;
      }), n.d(i, "every", function () {
        return Ee;
      }), n.d(i, "all", function () {
        return Ee;
      }), n.d(i, "some", function () {
        return Ie;
      }), n.d(i, "any", function () {
        return Ie;
      }), n.d(i, "contains", function () {
        return Pe;
      }), n.d(i, "includes", function () {
        return Pe;
      }), n.d(i, "include", function () {
        return Pe;
      }), n.d(i, "invoke", function () {
        return Ae;
      }), n.d(i, "pluck", function () {
        return ze;
      }), n.d(i, "where", function () {
        return _e;
      }), n.d(i, "max", function () {
        return He;
      }), n.d(i, "min", function () {
        return Ve;
      }), n.d(i, "shuffle", function () {
        return We;
      }), n.d(i, "sample", function () {
        return Be;
      }), n.d(i, "sortBy", function () {
        return Ye;
      }), n.d(i, "groupBy", function () {
        return Ze;
      }), n.d(i, "indexBy", function () {
        return Ge;
      }), n.d(i, "countBy", function () {
        return qe;
      }), n.d(i, "partition", function () {
        return $e;
      }), n.d(i, "toArray", function () {
        return Re;
      }), n.d(i, "size", function () {
        return Qe;
      }), n.d(i, "pick", function () {
        return Xe;
      }), n.d(i, "omit", function () {
        return Ke;
      }), n.d(i, "first", function () {
        return en;
      }), n.d(i, "head", function () {
        return en;
      }), n.d(i, "take", function () {
        return en;
      }), n.d(i, "initial", function () {
        return tn;
      }), n.d(i, "last", function () {
        return rn;
      }), n.d(i, "rest", function () {
        return nn;
      }), n.d(i, "tail", function () {
        return nn;
      }), n.d(i, "drop", function () {
        return nn;
      }), n.d(i, "compact", function () {
        return an;
      }), n.d(i, "flatten", function () {
        return on;
      }), n.d(i, "without", function () {
        return ln;
      }), n.d(i, "uniq", function () {
        return cn;
      }), n.d(i, "unique", function () {
        return cn;
      }), n.d(i, "union", function () {
        return dn;
      }), n.d(i, "intersection", function () {
        return un;
      }), n.d(i, "difference", function () {
        return sn;
      }), n.d(i, "unzip", function () {
        return hn;
      }), n.d(i, "transpose", function () {
        return hn;
      }), n.d(i, "zip", function () {
        return pn;
      }), n.d(i, "object", function () {
        return gn;
      }), n.d(i, "range", function () {
        return fn;
      }), n.d(i, "chunk", function () {
        return mn;
      }), n.d(i, "mixin", function () {
        return bn;
      }), n.d(i, "default", function () {
        return yn;
      });
      var r = n(4);
      function a(t, e) {
        return e = null == e ? t.length - 1 : +e, function () {
          for (var n = Math.max(arguments.length - e, 0), i = Array(n), r = 0; r < n; r++) i[r] = arguments[r + e];
          switch (e) {
            case 0:
              return t.call(this, i);
            case 1:
              return t.call(this, arguments[0], i);
            case 2:
              return t.call(this, arguments[0], arguments[1], i);
          }
          var a = Array(e + 1);
          for (r = 0; r < e; r++) a[r] = arguments[r];
          return a[e] = i, t.apply(this, a);
        };
      }
      function o(t) {
        var e = typeof t;
        return "function" === e || "object" === e && !!t;
      }
      function s(t) {
        return null === t;
      }
      function l(t) {
        return void 0 === t;
      }
      function c(t) {
        return !0 === t || !1 === t || "[object Boolean]" === r.t.call(t);
      }
      function d(t) {
        return !(!t || 1 !== t.nodeType);
      }
      function u(t) {
        var e = "[object " + t + "]";
        return function (t) {
          return r.t.call(t) === e;
        };
      }
      var h = u("String"),
        p = u("Number"),
        g = u("Date"),
        f = u("RegExp"),
        m = u("Error"),
        v = u("Symbol"),
        b = u("ArrayBuffer"),
        y = u("Function"),
        w = r.p.document && r.p.document.childNodes;
      "object" != typeof Int8Array && "function" != typeof w && (y = function y(t) {
        return "function" == typeof t || !1;
      });
      var x = y,
        j = u("Object"),
        C = r.s && j(new DataView(new ArrayBuffer(8))),
        M = "undefined" != typeof Map && j(new Map()),
        k = u("DataView"),
        O = C ? function (t) {
          return null != t && x(t.getInt8) && b(t.buffer);
        } : k,
        T = r.k || u("Array");
      function S(t, e) {
        return null != t && r.i.call(t, e);
      }
      var N = u("Arguments");
      !function () {
        N(arguments) || (N = function N(t) {
          return S(t, "callee");
        });
      }();
      var L = N;
      function D(t) {
        return !v(t) && Object(r.f)(t) && !isNaN(parseFloat(t));
      }
      function E(t) {
        return p(t) && Object(r.g)(t);
      }
      function I(t) {
        return function () {
          return t;
        };
      }
      function P(t) {
        return function (e) {
          var n = t(e);
          return "number" == typeof n && n >= 0 && n <= r.b;
        };
      }
      function A(t) {
        return function (e) {
          return null == e ? void 0 : e[t];
        };
      }
      var z = A("byteLength"),
        _ = P(z),
        H = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/,
        V = r.r ? function (t) {
          return r.l ? Object(r.l)(t) && !O(t) : _(t) && H.test(r.t.call(t));
        } : I(!1),
        F = A("length");
      function R(t, e) {
        e = function (t) {
          for (var e = {}, n = t.length, i = 0; i < n; ++i) e[t[i]] = !0;
          return {
            contains: function contains(t) {
              return !0 === e[t];
            },
            push: function push(n) {
              return e[n] = !0, t.push(n);
            }
          };
        }(e);
        var n = r.n.length,
          i = t.constructor,
          a = x(i) && i.prototype || r.c,
          o = "constructor";
        for (S(t, o) && !e.contains(o) && e.push(o); n--;) (o = r.n[n]) in t && t[o] !== a[o] && !e.contains(o) && e.push(o);
      }
      function B(t) {
        if (!o(t)) return [];
        if (r.m) return Object(r.m)(t);
        var e = [];
        for (var n in t) S(t, n) && e.push(n);
        return r.h && R(t, e), e;
      }
      function W(t) {
        if (null == t) return !0;
        var e = F(t);
        return "number" == typeof e && (T(t) || h(t) || L(t)) ? 0 === e : 0 === F(B(t));
      }
      function Y(t, e) {
        var n = B(e),
          i = n.length;
        if (null == t) return !i;
        for (var r = Object(t), a = 0; a < i; a++) {
          var o = n[a];
          if (e[o] !== r[o] || !(o in r)) return !1;
        }
        return !0;
      }
      function U(t) {
        return t instanceof U ? t : this instanceof U ? void (this._wrapped = t) : new U(t);
      }
      function Z(t) {
        return new Uint8Array(t.buffer || t, t.byteOffset || 0, z(t));
      }
      function G(t, e) {
        return function t(e, n, i, a) {
          if (e === n) return 0 !== e || 1 / e == 1 / n;
          if (null == e || null == n) return !1;
          if (e != e) return n != n;
          var o = typeof e;
          return ("function" === o || "object" === o || "object" == typeof n) && function e(n, i, a, o) {
            n instanceof U && (n = n._wrapped), i instanceof U && (i = i._wrapped);
            var s = r.t.call(n);
            if (s !== r.t.call(i)) return !1;
            if (C && "[object Object]" == s && O(n)) {
              if (!O(i)) return !1;
              s = "[object DataView]";
            }
            switch (s) {
              case "[object RegExp]":
              case "[object String]":
                return "" + n == "" + i;
              case "[object Number]":
                return +n != +n ? +i != +i : 0 == +n ? 1 / +n == 1 / i : +n == +i;
              case "[object Date]":
              case "[object Boolean]":
                return +n == +i;
              case "[object Symbol]":
                return r.d.valueOf.call(n) === r.d.valueOf.call(i);
              case "[object ArrayBuffer]":
              case "[object DataView]":
                return e(Z(n), Z(i), a, o);
            }
            var l = "[object Array]" === s;
            if (!l && V(n)) {
              if (z(n) !== z(i)) return !1;
              if (n.buffer === i.buffer && n.byteOffset === i.byteOffset) return !0;
              l = !0;
            }
            if (!l) {
              if ("object" != typeof n || "object" != typeof i) return !1;
              var c = n.constructor,
                d = i.constructor;
              if (c !== d && !(x(c) && c instanceof c && x(d) && d instanceof d) && "constructor" in n && "constructor" in i) return !1;
            }
            o = o || [];
            for (var u = (a = a || []).length; u--;) if (a[u] === n) return o[u] === i;
            if (a.push(n), o.push(i), l) {
              if ((u = n.length) !== i.length) return !1;
              for (; u--;) if (!t(n[u], i[u], a, o)) return !1;
            } else {
              var h,
                p = B(n);
              if (u = p.length, B(i).length !== u) return !1;
              for (; u--;) if (!S(i, h = p[u]) || !t(n[h], i[h], a, o)) return !1;
            }
            return a.pop(), o.pop(), !0;
          }(e, n, i, a);
        }(t, e);
      }
      function q(t) {
        if (!o(t)) return [];
        var e = [];
        for (var n in t) e.push(n);
        return r.h && R(t, e), e;
      }
      function $(t) {
        var e = F(t);
        return function (n) {
          if (null == n) return !1;
          var i = q(n);
          if (F(i)) return !1;
          for (var r = 0; r < e; r++) if (!x(n[t[r]])) return !1;
          return t !== tt || !x(n[Q]);
        };
      }
      U.VERSION = r.e, U.prototype.value = function () {
        return this._wrapped;
      }, U.prototype.valueOf = U.prototype.toJSON = U.prototype.value, U.prototype.toString = function () {
        return String(this._wrapped);
      };
      var Q = "forEach",
        J = ["clear", "delete"],
        X = ["get", "has", "set"],
        K = J.concat(Q, X),
        tt = J.concat(X),
        et = ["add"].concat(J, Q, "has"),
        nt = M ? $(K) : u("Map"),
        it = M ? $(tt) : u("WeakMap"),
        rt = M ? $(et) : u("Set"),
        at = u("WeakSet");
      function ot(t) {
        for (var e = B(t), n = e.length, i = Array(n), r = 0; r < n; r++) i[r] = t[e[r]];
        return i;
      }
      function st(t) {
        for (var e = B(t), n = e.length, i = Array(n), r = 0; r < n; r++) i[r] = [e[r], t[e[r]]];
        return i;
      }
      function lt(t) {
        for (var e = {}, n = B(t), i = 0, r = n.length; i < r; i++) e[t[n[i]]] = n[i];
        return e;
      }
      function ct(t) {
        var e = [];
        for (var n in t) x(t[n]) && e.push(n);
        return e.sort();
      }
      function dt(t, e) {
        return function (n) {
          var i = arguments.length;
          if (e && (n = Object(n)), i < 2 || null == n) return n;
          for (var r = 1; r < i; r++) for (var a = arguments[r], o = t(a), s = o.length, l = 0; l < s; l++) {
            var c = o[l];
            e && void 0 !== n[c] || (n[c] = a[c]);
          }
          return n;
        };
      }
      var ut = dt(q),
        ht = dt(B),
        pt = dt(q, !0);
      function gt(t) {
        if (!o(t)) return {};
        if (r.j) return Object(r.j)(t);
        var e = function e() {};
        e.prototype = t;
        var n = new e();
        return e.prototype = null, n;
      }
      function ft(t, e) {
        var n = gt(t);
        return e && ht(n, e), n;
      }
      function mt(t) {
        return o(t) ? T(t) ? t.slice() : ut({}, t) : t;
      }
      function vt(t, e) {
        return e(t), t;
      }
      function bt(t) {
        return T(t) ? t : [t];
      }
      function yt(t) {
        return U.toPath(t);
      }
      function wt(t, e) {
        for (var n = e.length, i = 0; i < n; i++) {
          if (null == t) return;
          t = t[e[i]];
        }
        return n ? t : void 0;
      }
      function xt(t, e, n) {
        var i = wt(t, yt(e));
        return l(i) ? n : i;
      }
      function jt(t, e) {
        for (var n = (e = yt(e)).length, i = 0; i < n; i++) {
          var r = e[i];
          if (!S(t, r)) return !1;
          t = t[r];
        }
        return !!n;
      }
      function Ct(t) {
        return t;
      }
      function Mt(t) {
        return t = ht({}, t), function (e) {
          return Y(e, t);
        };
      }
      function kt(t) {
        return t = yt(t), function (e) {
          return wt(e, t);
        };
      }
      function Ot(t, e, n) {
        if (void 0 === e) return t;
        switch (null == n ? 3 : n) {
          case 1:
            return function (n) {
              return t.call(e, n);
            };
          case 3:
            return function (n, i, r) {
              return t.call(e, n, i, r);
            };
          case 4:
            return function (n, i, r, a) {
              return t.call(e, n, i, r, a);
            };
        }
        return function () {
          return t.apply(e, arguments);
        };
      }
      function Tt(t, e, n) {
        return null == t ? Ct : x(t) ? Ot(t, e, n) : o(t) && !T(t) ? Mt(t) : kt(t);
      }
      function St(t, e) {
        return Tt(t, e, 1 / 0);
      }
      function Nt(t, e, n) {
        return U.iteratee !== St ? U.iteratee(t, e) : Tt(t, e, n);
      }
      function Lt(t, e, n) {
        e = Nt(e, n);
        for (var i = B(t), r = i.length, a = {}, o = 0; o < r; o++) {
          var s = i[o];
          a[s] = e(t[s], s, t);
        }
        return a;
      }
      function Dt() {}
      function Et(t) {
        return null == t ? Dt : function (e) {
          return xt(t, e);
        };
      }
      function It(t, e, n) {
        var i = Array(Math.max(0, t));
        e = Ot(e, n, 1);
        for (var r = 0; r < t; r++) i[r] = e(r);
        return i;
      }
      function Pt(t, e) {
        return null == e && (e = t, t = 0), t + Math.floor(Math.random() * (e - t + 1));
      }
      U.toPath = bt, U.iteratee = St;
      var At = Date.now || function () {
        return new Date().getTime();
      };
      function zt(t) {
        var e = function e(_e4) {
            return t[_e4];
          },
          n = "(?:" + B(t).join("|") + ")",
          i = RegExp(n),
          r = RegExp(n, "g");
        return function (t) {
          return t = null == t ? "" : "" + t, i.test(t) ? t.replace(r, e) : t;
        };
      }
      var _t = {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#x27;",
          "`": "&#x60;"
        },
        Ht = zt(_t),
        Vt = zt(lt(_t)),
        Ft = U.templateSettings = {
          evaluate: /<%([\s\S]+?)%>/g,
          interpolate: /<%=([\s\S]+?)%>/g,
          escape: /<%-([\s\S]+?)%>/g
        },
        Rt = /(.)^/,
        Bt = {
          "'": "'",
          "\\": "\\",
          "\r": "r",
          "\n": "n",
          "\u2028": "u2028",
          "\u2029": "u2029"
        },
        Wt = /\\|'|\r|\n|\u2028|\u2029/g;
      function Yt(t) {
        return "\\" + Bt[t];
      }
      var Ut = /^\s*(\w|\$)+\s*$/;
      function Zt(t, e, n) {
        !e && n && (e = n), e = pt({}, e, U.templateSettings);
        var i = RegExp([(e.escape || Rt).source, (e.interpolate || Rt).source, (e.evaluate || Rt).source].join("|") + "|$", "g"),
          r = 0,
          a = "__p+='";
        t.replace(i, function (e, n, i, o, s) {
          return a += t.slice(r, s).replace(Wt, Yt), r = s + e.length, n ? a += "'+\n((__t=(" + n + "))==null?'':_.escape(__t))+\n'" : i ? a += "'+\n((__t=(" + i + "))==null?'':__t)+\n'" : o && (a += "';\n" + o + "\n__p+='"), e;
        }), a += "';\n";
        var o,
          s = e.variable;
        if (s) {
          if (!Ut.test(s)) throw new Error("variable is not a bare identifier: " + s);
        } else a = "with(obj||{}){\n" + a + "}\n", s = "obj";
        a = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + a + "return __p;\n";
        try {
          o = new Function(s, "_", a);
        } catch (t) {
          throw t.source = a, t;
        }
        var l = function l(t) {
          return o.call(this, t, U);
        };
        return l.source = "function(" + s + "){\n" + a + "}", l;
      }
      function Gt(t, e, n) {
        var i = (e = yt(e)).length;
        if (!i) return x(n) ? n.call(t) : n;
        for (var r = 0; r < i; r++) {
          var a = null == t ? void 0 : t[e[r]];
          void 0 === a && (a = n, r = i), t = x(a) ? a.call(t) : a;
        }
        return t;
      }
      var qt = 0;
      function $t(t) {
        var e = ++qt + "";
        return t ? t + e : e;
      }
      function Qt(t) {
        var e = U(t);
        return e._chain = !0, e;
      }
      function Jt(t, e, n, i, r) {
        if (!(i instanceof e)) return t.apply(n, r);
        var a = gt(t.prototype),
          s = t.apply(a, r);
        return o(s) ? s : a;
      }
      var Xt = a(function (t, e) {
        var n = Xt.placeholder,
          _i2 = function i() {
            for (var r = 0, a = e.length, o = Array(a), s = 0; s < a; s++) o[s] = e[s] === n ? arguments[r++] : e[s];
            for (; r < arguments.length;) o.push(arguments[r++]);
            return Jt(t, _i2, this, this, o);
          };
        return _i2;
      });
      Xt.placeholder = U;
      var Kt = Xt,
        te = a(function (t, e, n) {
          if (!x(t)) throw new TypeError("Bind must be called on a function");
          var i = a(function (r) {
            return Jt(t, i, e, this, n.concat(r));
          });
          return i;
        }),
        ee = P(F);
      function ne(t, e, n, i) {
        if (i = i || [], e || 0 === e) {
          if (e <= 0) return i.concat(t);
        } else e = 1 / 0;
        for (var r = i.length, a = 0, o = F(t); a < o; a++) {
          var s = t[a];
          if (ee(s) && (T(s) || L(s))) {
            if (e > 1) ne(s, e - 1, n, i), r = i.length;else for (var l = 0, c = s.length; l < c;) i[r++] = s[l++];
          } else n || (i[r++] = s);
        }
        return i;
      }
      var ie = a(function (t, e) {
        var n = (e = ne(e, !1, !1)).length;
        if (n < 1) throw new Error("bindAll must be passed function names");
        for (; n--;) {
          var i = e[n];
          t[i] = te(t[i], t);
        }
        return t;
      });
      function re(t, e) {
        var _n3 = function n(i) {
          var r = _n3.cache,
            a = "" + (e ? e.apply(this, arguments) : i);
          return S(r, a) || (r[a] = t.apply(this, arguments)), r[a];
        };
        return _n3.cache = {}, _n3;
      }
      var ae = a(function (t, e, n) {
          return setTimeout(function () {
            return t.apply(null, n);
          }, e);
        }),
        oe = Kt(ae, U, 1);
      function se(t, e, n) {
        var i,
          r,
          a,
          o,
          s = 0;
        n || (n = {});
        var l = function l() {
            s = !1 === n.leading ? 0 : At(), i = null, o = t.apply(r, a), i || (r = a = null);
          },
          c = function c() {
            var c = At();
            s || !1 !== n.leading || (s = c);
            var d = e - (c - s);
            return r = this, a = arguments, d <= 0 || d > e ? (i && (clearTimeout(i), i = null), s = c, o = t.apply(r, a), i || (r = a = null)) : i || !1 === n.trailing || (i = setTimeout(l, d)), o;
          };
        return c.cancel = function () {
          clearTimeout(i), s = 0, i = r = a = null;
        }, c;
      }
      function le(t, e, n) {
        var i,
          r,
          o,
          s,
          l,
          _c = function c() {
            var a = At() - r;
            e > a ? i = setTimeout(_c, e - a) : (i = null, n || (s = t.apply(l, o)), i || (o = l = null));
          },
          d = a(function (a) {
            return l = this, o = a, r = At(), i || (i = setTimeout(_c, e), n && (s = t.apply(l, o))), s;
          });
        return d.cancel = function () {
          clearTimeout(i), i = o = l = null;
        }, d;
      }
      function ce(t, e) {
        return Kt(e, t);
      }
      function de(t) {
        return function () {
          return !t.apply(this, arguments);
        };
      }
      function ue() {
        var t = arguments,
          e = t.length - 1;
        return function () {
          for (var n = e, i = t[e].apply(this, arguments); n--;) i = t[n].call(this, i);
          return i;
        };
      }
      function he(t, e) {
        return function () {
          if (--t < 1) return e.apply(this, arguments);
        };
      }
      function pe(t, e) {
        var n;
        return function () {
          return --t > 0 && (n = e.apply(this, arguments)), t <= 1 && (e = null), n;
        };
      }
      var ge = Kt(pe, 2);
      function fe(t, e, n) {
        e = Nt(e, n);
        for (var i, r = B(t), a = 0, o = r.length; a < o; a++) if (e(t[i = r[a]], i, t)) return i;
      }
      function me(t) {
        return function (e, n, i) {
          n = Nt(n, i);
          for (var r = F(e), a = t > 0 ? 0 : r - 1; a >= 0 && a < r; a += t) if (n(e[a], a, e)) return a;
          return -1;
        };
      }
      var ve = me(1),
        be = me(-1);
      function ye(t, e, n, i) {
        for (var r = (n = Nt(n, i, 1))(e), a = 0, o = F(t); a < o;) {
          var s = Math.floor((a + o) / 2);
          n(t[s]) < r ? a = s + 1 : o = s;
        }
        return a;
      }
      function we(t, e, n) {
        return function (i, a, o) {
          var s = 0,
            l = F(i);
          if ("number" == typeof o) t > 0 ? s = o >= 0 ? o : Math.max(o + l, s) : l = o >= 0 ? Math.min(o + 1, l) : o + l + 1;else if (n && o && l) return i[o = n(i, a)] === a ? o : -1;
          if (a != a) return (o = e(r.q.call(i, s, l), E)) >= 0 ? o + s : -1;
          for (o = t > 0 ? s : l - 1; o >= 0 && o < l; o += t) if (i[o] === a) return o;
          return -1;
        };
      }
      var xe = we(1, ve, ye),
        je = we(-1, be);
      function Ce(t, e, n) {
        var i = (ee(t) ? ve : fe)(t, e, n);
        if (void 0 !== i && -1 !== i) return t[i];
      }
      function Me(t, e) {
        return Ce(t, Mt(e));
      }
      function ke(t, e, n) {
        var i, r;
        if (e = Ot(e, n), ee(t)) for (i = 0, r = t.length; i < r; i++) e(t[i], i, t);else {
          var a = B(t);
          for (i = 0, r = a.length; i < r; i++) e(t[a[i]], a[i], t);
        }
        return t;
      }
      function Oe(t, e, n) {
        e = Nt(e, n);
        for (var i = !ee(t) && B(t), r = (i || t).length, a = Array(r), o = 0; o < r; o++) {
          var s = i ? i[o] : o;
          a[o] = e(t[s], s, t);
        }
        return a;
      }
      function Te(t) {
        var e = function e(_e5, n, i, r) {
          var a = !ee(_e5) && B(_e5),
            o = (a || _e5).length,
            s = t > 0 ? 0 : o - 1;
          for (r || (i = _e5[a ? a[s] : s], s += t); s >= 0 && s < o; s += t) {
            var l = a ? a[s] : s;
            i = n(i, _e5[l], l, _e5);
          }
          return i;
        };
        return function (t, n, i, r) {
          var a = arguments.length >= 3;
          return e(t, Ot(n, r, 4), i, a);
        };
      }
      var Se = Te(1),
        Ne = Te(-1);
      function Le(t, e, n) {
        var i = [];
        return e = Nt(e, n), ke(t, function (t, n, r) {
          e(t, n, r) && i.push(t);
        }), i;
      }
      function De(t, e, n) {
        return Le(t, de(Nt(e)), n);
      }
      function Ee(t, e, n) {
        e = Nt(e, n);
        for (var i = !ee(t) && B(t), r = (i || t).length, a = 0; a < r; a++) {
          var o = i ? i[a] : a;
          if (!e(t[o], o, t)) return !1;
        }
        return !0;
      }
      function Ie(t, e, n) {
        e = Nt(e, n);
        for (var i = !ee(t) && B(t), r = (i || t).length, a = 0; a < r; a++) {
          var o = i ? i[a] : a;
          if (e(t[o], o, t)) return !0;
        }
        return !1;
      }
      function Pe(t, e, n, i) {
        return ee(t) || (t = ot(t)), ("number" != typeof n || i) && (n = 0), xe(t, e, n) >= 0;
      }
      var Ae = a(function (t, e, n) {
        var i, r;
        return x(e) ? r = e : (e = yt(e), i = e.slice(0, -1), e = e[e.length - 1]), Oe(t, function (t) {
          var a = r;
          if (!a) {
            if (i && i.length && (t = wt(t, i)), null == t) return;
            a = t[e];
          }
          return null == a ? a : a.apply(t, n);
        });
      });
      function ze(t, e) {
        return Oe(t, kt(e));
      }
      function _e(t, e) {
        return Le(t, Mt(e));
      }
      function He(t, e, n) {
        var i,
          r,
          a = -1 / 0,
          o = -1 / 0;
        if (null == e || "number" == typeof e && "object" != typeof t[0] && null != t) for (var s = 0, l = (t = ee(t) ? t : ot(t)).length; s < l; s++) null != (i = t[s]) && i > a && (a = i);else e = Nt(e, n), ke(t, function (t, n, i) {
          ((r = e(t, n, i)) > o || r === -1 / 0 && a === -1 / 0) && (a = t, o = r);
        });
        return a;
      }
      function Ve(t, e, n) {
        var i,
          r,
          a = 1 / 0,
          o = 1 / 0;
        if (null == e || "number" == typeof e && "object" != typeof t[0] && null != t) for (var s = 0, l = (t = ee(t) ? t : ot(t)).length; s < l; s++) null != (i = t[s]) && i < a && (a = i);else e = Nt(e, n), ke(t, function (t, n, i) {
          ((r = e(t, n, i)) < o || r === 1 / 0 && a === 1 / 0) && (a = t, o = r);
        });
        return a;
      }
      var Fe = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
      function Re(t) {
        return t ? T(t) ? r.q.call(t) : h(t) ? t.match(Fe) : ee(t) ? Oe(t, Ct) : ot(t) : [];
      }
      function Be(t, e, n) {
        if (null == e || n) return ee(t) || (t = ot(t)), t[Pt(t.length - 1)];
        var i = Re(t),
          r = F(i);
        e = Math.max(Math.min(e, r), 0);
        for (var a = r - 1, o = 0; o < e; o++) {
          var s = Pt(o, a),
            l = i[o];
          i[o] = i[s], i[s] = l;
        }
        return i.slice(0, e);
      }
      function We(t) {
        return Be(t, 1 / 0);
      }
      function Ye(t, e, n) {
        var i = 0;
        return e = Nt(e, n), ze(Oe(t, function (t, n, r) {
          return {
            value: t,
            index: i++,
            criteria: e(t, n, r)
          };
        }).sort(function (t, e) {
          var n = t.criteria,
            i = e.criteria;
          if (n !== i) {
            if (n > i || void 0 === n) return 1;
            if (n < i || void 0 === i) return -1;
          }
          return t.index - e.index;
        }), "value");
      }
      function Ue(t, e) {
        return function (n, i, r) {
          var a = e ? [[], []] : {};
          return i = Nt(i, r), ke(n, function (e, r) {
            var o = i(e, r, n);
            t(a, e, o);
          }), a;
        };
      }
      var Ze = Ue(function (t, e, n) {
          S(t, n) ? t[n].push(e) : t[n] = [e];
        }),
        Ge = Ue(function (t, e, n) {
          t[n] = e;
        }),
        qe = Ue(function (t, e, n) {
          S(t, n) ? t[n]++ : t[n] = 1;
        }),
        $e = Ue(function (t, e, n) {
          t[n ? 0 : 1].push(e);
        }, !0);
      function Qe(t) {
        return null == t ? 0 : ee(t) ? t.length : B(t).length;
      }
      function Je(t, e, n) {
        return e in n;
      }
      var Xe = a(function (t, e) {
          var n = {},
            i = e[0];
          if (null == t) return n;
          x(i) ? (e.length > 1 && (i = Ot(i, e[1])), e = q(t)) : (i = Je, e = ne(e, !1, !1), t = Object(t));
          for (var r = 0, a = e.length; r < a; r++) {
            var o = e[r],
              s = t[o];
            i(s, o, t) && (n[o] = s);
          }
          return n;
        }),
        Ke = a(function (t, e) {
          var n,
            i = e[0];
          return x(i) ? (i = de(i), e.length > 1 && (n = e[1])) : (e = Oe(ne(e, !1, !1), String), i = function i(t, n) {
            return !Pe(e, n);
          }), Xe(t, i, n);
        });
      function tn(t, e, n) {
        return r.q.call(t, 0, Math.max(0, t.length - (null == e || n ? 1 : e)));
      }
      function en(t, e, n) {
        return null == t || t.length < 1 ? null == e || n ? void 0 : [] : null == e || n ? t[0] : tn(t, t.length - e);
      }
      function nn(t, e, n) {
        return r.q.call(t, null == e || n ? 1 : e);
      }
      function rn(t, e, n) {
        return null == t || t.length < 1 ? null == e || n ? void 0 : [] : null == e || n ? t[t.length - 1] : nn(t, Math.max(0, t.length - e));
      }
      function an(t) {
        return Le(t, Boolean);
      }
      function on(t, e) {
        return ne(t, e, !1);
      }
      var sn = a(function (t, e) {
          return e = ne(e, !0, !0), Le(t, function (t) {
            return !Pe(e, t);
          });
        }),
        ln = a(function (t, e) {
          return sn(t, e);
        });
      function cn(t, e, n, i) {
        c(e) || (i = n, n = e, e = !1), null != n && (n = Nt(n, i));
        for (var r = [], a = [], o = 0, s = F(t); o < s; o++) {
          var l = t[o],
            d = n ? n(l, o, t) : l;
          e && !n ? (o && a === d || r.push(l), a = d) : n ? Pe(a, d) || (a.push(d), r.push(l)) : Pe(r, l) || r.push(l);
        }
        return r;
      }
      var dn = a(function (t) {
        return cn(ne(t, !0, !0));
      });
      function un(t) {
        for (var e = [], n = arguments.length, i = 0, r = F(t); i < r; i++) {
          var a = t[i];
          if (!Pe(e, a)) {
            var o;
            for (o = 1; o < n && Pe(arguments[o], a); o++);
            o === n && e.push(a);
          }
        }
        return e;
      }
      function hn(t) {
        for (var e = t && He(t, F).length || 0, n = Array(e), i = 0; i < e; i++) n[i] = ze(t, i);
        return n;
      }
      var pn = a(hn);
      function gn(t, e) {
        for (var n = {}, i = 0, r = F(t); i < r; i++) e ? n[t[i]] = e[i] : n[t[i][0]] = t[i][1];
        return n;
      }
      function fn(t, e, n) {
        null == e && (e = t || 0, t = 0), n || (n = e < t ? -1 : 1);
        for (var i = Math.max(Math.ceil((e - t) / n), 0), r = Array(i), a = 0; a < i; a++, t += n) r[a] = t;
        return r;
      }
      function mn(t, e) {
        if (null == e || e < 1) return [];
        for (var n = [], i = 0, a = t.length; i < a;) n.push(r.q.call(t, i, i += e));
        return n;
      }
      function vn(t, e) {
        return t._chain ? U(e).chain() : e;
      }
      function bn(t) {
        return ke(ct(t), function (e) {
          var n = U[e] = t[e];
          U.prototype[e] = function () {
            var t = [this._wrapped];
            return r.o.apply(t, arguments), vn(this, n.apply(U, t));
          };
        }), U;
      }
      ke(["pop", "push", "reverse", "shift", "sort", "splice", "unshift"], function (t) {
        var e = r.a[t];
        U.prototype[t] = function () {
          var n = this._wrapped;
          return null != n && (e.apply(n, arguments), "shift" !== t && "splice" !== t || 0 !== n.length || delete n[0]), vn(this, n);
        };
      }), ke(["concat", "join", "slice"], function (t) {
        var e = r.a[t];
        U.prototype[t] = function () {
          var t = this._wrapped;
          return null != t && (t = e.apply(t, arguments)), vn(this, t);
        };
      });
      var yn = U,
        wn = bn(i);
      wn._ = wn;
      var xn = wn;
    }, function (t, e, n) {
      (function (i) {
        var r, a, o;
        o = "object" == typeof self && self.self === self && self || "object" == typeof i && i.global === i && i, r = [n(0), n(11), e], void 0 === (a = function (t, e, n) {
          o.Backbone = function (t, e, n, i) {
            var r = t.Backbone,
              a = Array.prototype.slice;
            e.VERSION = "1.3.3", e.$ = i, e.noConflict = function () {
              return t.Backbone = r, this;
            }, e.emulateHTTP = !1, e.emulateJSON = !1;
            var o = function o(t, e, i) {
                n.each(e, function (e, r) {
                  n[r] && (t.prototype[r] = function (t, e, i) {
                    switch (t) {
                      case 1:
                        return function () {
                          return n[e](this[i]);
                        };
                      case 2:
                        return function (t) {
                          return n[e](this[i], t);
                        };
                      case 3:
                        return function (t, r) {
                          return n[e](this[i], s(t, this), r);
                        };
                      case 4:
                        return function (t, r, a) {
                          return n[e](this[i], s(t, this), r, a);
                        };
                      default:
                        return function () {
                          var t = a.call(arguments);
                          return t.unshift(this[i]), n[e].apply(n, t);
                        };
                    }
                  }(e, r, i));
                });
              },
              s = function s(t, e) {
                return n.isFunction(t) ? t : n.isObject(t) && !e._isModel(t) ? l(t) : n.isString(t) ? function (e) {
                  return e.get(t);
                } : t;
              },
              l = function l(t) {
                var e = n.matches(t);
                return function (t) {
                  return e(t.attributes);
                };
              },
              c = e.Events = {},
              d = /\s+/,
              _u = function u(t, e, i, r, a) {
                var o,
                  s = 0;
                if (i && "object" == typeof i) {
                  void 0 !== r && "context" in a && void 0 === a.context && (a.context = r);
                  for (o = n.keys(i); s < o.length; s++) e = _u(t, e, o[s], i[o[s]], a);
                } else if (i && d.test(i)) for (o = i.split(d); s < o.length; s++) e = t(e, o[s], r, a);else e = t(e, i, r, a);
                return e;
              };
            c.on = function (t, e, n) {
              return h(this, t, e, n);
            };
            var h = function h(t, e, n, i, r) {
              return t._events = _u(p, t._events || {}, e, n, {
                context: i,
                ctx: t,
                listening: r
              }), r && ((t._listeners || (t._listeners = {}))[r.id] = r), t;
            };
            c.listenTo = function (t, e, i) {
              if (!t) return this;
              var r = t._listenId || (t._listenId = n.uniqueId("l")),
                a = this._listeningTo || (this._listeningTo = {}),
                o = a[r];
              if (!o) {
                var s = this._listenId || (this._listenId = n.uniqueId("l"));
                o = a[r] = {
                  obj: t,
                  objId: r,
                  id: s,
                  listeningTo: a,
                  count: 0
                };
              }
              return h(t, e, i, this, o), this;
            };
            var p = function p(t, e, n, i) {
              if (n) {
                var r = t[e] || (t[e] = []),
                  a = i.context,
                  o = i.ctx,
                  s = i.listening;
                s && s.count++, r.push({
                  callback: n,
                  context: a,
                  ctx: a || o,
                  listening: s
                });
              }
              return t;
            };
            c.off = function (t, e, n) {
              return this._events ? (this._events = _u(g, this._events, t, e, {
                context: n,
                listeners: this._listeners
              }), this) : this;
            }, c.stopListening = function (t, e, i) {
              var r = this._listeningTo;
              if (!r) return this;
              for (var a = t ? [t._listenId] : n.keys(r), o = 0; o < a.length; o++) {
                var s = r[a[o]];
                if (!s) break;
                s.obj.off(e, i, this);
              }
              return this;
            };
            var g = function g(t, e, i, r) {
              if (t) {
                var a,
                  o = 0,
                  s = r.context,
                  l = r.listeners;
                if (e || i || s) {
                  for (var c = e ? [e] : n.keys(t); o < c.length; o++) {
                    var d = t[e = c[o]];
                    if (!d) break;
                    for (var u = [], h = 0; h < d.length; h++) {
                      var p = d[h];
                      i && i !== p.callback && i !== p.callback._callback || s && s !== p.context ? u.push(p) : (a = p.listening) && 0 == --a.count && (delete l[a.id], delete a.listeningTo[a.objId]);
                    }
                    u.length ? t[e] = u : delete t[e];
                  }
                  return t;
                }
                for (var g = n.keys(l); o < g.length; o++) delete l[(a = l[g[o]]).id], delete a.listeningTo[a.objId];
              }
            };
            c.once = function (t, e, i) {
              var r = _u(f, {}, t, e, n.bind(this.off, this));
              return "string" == typeof t && null == i && (e = void 0), this.on(r, e, i);
            }, c.listenToOnce = function (t, e, i) {
              var r = _u(f, {}, e, i, n.bind(this.stopListening, this, t));
              return this.listenTo(t, r);
            };
            var f = function f(t, e, i, r) {
              if (i) {
                var a = t[e] = n.once(function () {
                  r(e, a), i.apply(this, arguments);
                });
                a._callback = i;
              }
              return t;
            };
            c.trigger = function (t) {
              if (!this._events) return this;
              for (var e = Math.max(0, arguments.length - 1), n = Array(e), i = 0; i < e; i++) n[i] = arguments[i + 1];
              return _u(m, this._events, t, void 0, n), this;
            };
            var m = function m(t, e, n, i) {
                if (t) {
                  var r = t[e],
                    a = t.all;
                  r && a && (a = a.slice()), r && v(r, i), a && v(a, [e].concat(i));
                }
                return t;
              },
              v = function v(t, e) {
                var n,
                  i = -1,
                  r = t.length,
                  a = e[0],
                  o = e[1],
                  s = e[2];
                switch (e.length) {
                  case 0:
                    for (; ++i < r;) (n = t[i]).callback.call(n.ctx);
                    return;
                  case 1:
                    for (; ++i < r;) (n = t[i]).callback.call(n.ctx, a);
                    return;
                  case 2:
                    for (; ++i < r;) (n = t[i]).callback.call(n.ctx, a, o);
                    return;
                  case 3:
                    for (; ++i < r;) (n = t[i]).callback.call(n.ctx, a, o, s);
                    return;
                  default:
                    for (; ++i < r;) (n = t[i]).callback.apply(n.ctx, e);
                    return;
                }
              };
            c.bind = c.on, c.unbind = c.off, n.extend(e, c);
            var b = e.Model = function (t, e) {
              var i = t || {};
              e || (e = {}), this.cid = n.uniqueId(this.cidPrefix), this.attributes = {}, e.collection && (this.collection = e.collection), e.parse && (i = this.parse(i, e) || {});
              var r = n.result(this, "defaults");
              i = n.defaults(n.extend({}, r, i), r), this.set(i, e), this.changed = {}, this.initialize.apply(this, arguments);
            };
            n.extend(b.prototype, c, {
              changed: null,
              validationError: null,
              idAttribute: "id",
              cidPrefix: "c",
              initialize: function initialize() {},
              toJSON: function toJSON(t) {
                return n.clone(this.attributes);
              },
              sync: function sync() {
                return e.sync.apply(this, arguments);
              },
              get: function get(t) {
                return this.attributes[t];
              },
              escape: function escape(t) {
                return n.escape(this.get(t));
              },
              has: function has(t) {
                return null != this.get(t);
              },
              matches: function matches(t) {
                return !!n.iteratee(t, this)(this.attributes);
              },
              set: function set(t, e, i) {
                if (null == t) return this;
                var r;
                if ("object" == typeof t ? (r = t, i = e) : (r = {})[t] = e, i || (i = {}), !this._validate(r, i)) return !1;
                var a = i.unset,
                  o = i.silent,
                  s = [],
                  l = this._changing;
                this._changing = !0, l || (this._previousAttributes = n.clone(this.attributes), this.changed = {});
                var c = this.attributes,
                  d = this.changed,
                  u = this._previousAttributes;
                for (var h in r) e = r[h], n.isEqual(c[h], e) || s.push(h), n.isEqual(u[h], e) ? delete d[h] : d[h] = e, a ? delete c[h] : c[h] = e;
                if (this.idAttribute in r && (this.id = this.get(this.idAttribute)), !o) {
                  s.length && (this._pending = i);
                  for (var p = 0; p < s.length; p++) this.trigger("change:" + s[p], this, c[s[p]], i);
                }
                if (l) return this;
                if (!o) for (; this._pending;) i = this._pending, this._pending = !1, this.trigger("change", this, i);
                return this._pending = !1, this._changing = !1, this;
              },
              unset: function unset(t, e) {
                return this.set(t, void 0, n.extend({}, e, {
                  unset: !0
                }));
              },
              clear: function clear(t) {
                var e = {};
                for (var i in this.attributes) e[i] = void 0;
                return this.set(e, n.extend({}, t, {
                  unset: !0
                }));
              },
              hasChanged: function hasChanged(t) {
                return null == t ? !n.isEmpty(this.changed) : n.has(this.changed, t);
              },
              changedAttributes: function changedAttributes(t) {
                if (!t) return !!this.hasChanged() && n.clone(this.changed);
                var e = this._changing ? this._previousAttributes : this.attributes,
                  i = {};
                for (var r in t) {
                  var a = t[r];
                  n.isEqual(e[r], a) || (i[r] = a);
                }
                return !!n.size(i) && i;
              },
              previous: function previous(t) {
                return null != t && this._previousAttributes ? this._previousAttributes[t] : null;
              },
              previousAttributes: function previousAttributes() {
                return n.clone(this._previousAttributes);
              },
              fetch: function fetch(t) {
                t = n.extend({
                  parse: !0
                }, t);
                var e = this,
                  i = t.success;
                return t.success = function (n) {
                  var r = t.parse ? e.parse(n, t) : n;
                  if (!e.set(r, t)) return !1;
                  i && i.call(t.context, e, n, t), e.trigger("sync", e, n, t);
                }, _(this, t), this.sync("read", this, t);
              },
              save: function save(t, e, i) {
                var r;
                null == t || "object" == typeof t ? (r = t, i = e) : (r = {})[t] = e;
                var a = (i = n.extend({
                  validate: !0,
                  parse: !0
                }, i)).wait;
                if (r && !a) {
                  if (!this.set(r, i)) return !1;
                } else if (!this._validate(r, i)) return !1;
                var o = this,
                  s = i.success,
                  l = this.attributes;
                i.success = function (t) {
                  o.attributes = l;
                  var e = i.parse ? o.parse(t, i) : t;
                  if (a && (e = n.extend({}, r, e)), e && !o.set(e, i)) return !1;
                  s && s.call(i.context, o, t, i), o.trigger("sync", o, t, i);
                }, _(this, i), r && a && (this.attributes = n.extend({}, l, r));
                var c = this.isNew() ? "create" : i.patch ? "patch" : "update";
                "patch" !== c || i.attrs || (i.attrs = r);
                var d = this.sync(c, this, i);
                return this.attributes = l, d;
              },
              destroy: function destroy(t) {
                t = t ? n.clone(t) : {};
                var e = this,
                  i = t.success,
                  r = t.wait,
                  a = function a() {
                    e.stopListening(), e.trigger("destroy", e, e.collection, t);
                  };
                t.success = function (n) {
                  r && a(), i && i.call(t.context, e, n, t), e.isNew() || e.trigger("sync", e, n, t);
                };
                var o = !1;
                return this.isNew() ? n.defer(t.success) : (_(this, t), o = this.sync("delete", this, t)), r || a(), o;
              },
              url: function url() {
                var t = n.result(this, "urlRoot") || n.result(this.collection, "url") || z();
                if (this.isNew()) return t;
                var e = this.get(this.idAttribute);
                return t.replace(/[^\/]$/, "$&/") + encodeURIComponent(e);
              },
              parse: function parse(t, e) {
                return t;
              },
              clone: function clone() {
                return new this.constructor(this.attributes);
              },
              isNew: function isNew() {
                return !this.has(this.idAttribute);
              },
              isValid: function isValid(t) {
                return this._validate({}, n.extend({}, t, {
                  validate: !0
                }));
              },
              _validate: function _validate(t, e) {
                if (!e.validate || !this.validate) return !0;
                t = n.extend({}, this.attributes, t);
                var i = this.validationError = this.validate(t, e) || null;
                return !i || (this.trigger("invalid", this, i, n.extend(e, {
                  validationError: i
                })), !1);
              }
            }), o(b, {
              keys: 1,
              values: 1,
              pairs: 1,
              invert: 1,
              pick: 0,
              omit: 0,
              chain: 1,
              isEmpty: 1
            }, "attributes");
            var y = e.Collection = function (t, e) {
                e || (e = {}), e.model && (this.model = e.model), void 0 !== e.comparator && (this.comparator = e.comparator), this._reset(), this.initialize.apply(this, arguments), t && this.reset(t, n.extend({
                  silent: !0
                }, e));
              },
              w = {
                add: !0,
                remove: !0,
                merge: !0
              },
              x = {
                add: !0,
                remove: !1
              },
              j = function j(t, e, n) {
                n = Math.min(Math.max(n, 0), t.length);
                var i,
                  r = Array(t.length - n),
                  a = e.length;
                for (i = 0; i < r.length; i++) r[i] = t[i + n];
                for (i = 0; i < a; i++) t[i + n] = e[i];
                for (i = 0; i < r.length; i++) t[i + a + n] = r[i];
              };
            n.extend(y.prototype, c, {
              model: b,
              initialize: function initialize() {},
              toJSON: function toJSON(t) {
                return this.map(function (e) {
                  return e.toJSON(t);
                });
              },
              sync: function sync() {
                return e.sync.apply(this, arguments);
              },
              add: function add(t, e) {
                return this.set(t, n.extend({
                  merge: !1
                }, e, x));
              },
              remove: function remove(t, e) {
                e = n.extend({}, e);
                var i = !n.isArray(t);
                t = i ? [t] : t.slice();
                var r = this._removeModels(t, e);
                return !e.silent && r.length && (e.changes = {
                  added: [],
                  merged: [],
                  removed: r
                }, this.trigger("update", this, e)), i ? r[0] : r;
              },
              set: function set(t, e) {
                if (null != t) {
                  (e = n.extend({}, w, e)).parse && !this._isModel(t) && (t = this.parse(t, e) || []);
                  var i = !n.isArray(t);
                  t = i ? [t] : t.slice();
                  var r = e.at;
                  null != r && (r = +r), r > this.length && (r = this.length), r < 0 && (r += this.length + 1);
                  var a,
                    o,
                    s = [],
                    l = [],
                    c = [],
                    d = [],
                    u = {},
                    h = e.add,
                    p = e.merge,
                    g = e.remove,
                    f = !1,
                    m = this.comparator && null == r && !1 !== e.sort,
                    v = n.isString(this.comparator) ? this.comparator : null;
                  for (o = 0; o < t.length; o++) {
                    a = t[o];
                    var b = this.get(a);
                    if (b) {
                      if (p && a !== b) {
                        var y = this._isModel(a) ? a.attributes : a;
                        e.parse && (y = b.parse(y, e)), b.set(y, e), c.push(b), m && !f && (f = b.hasChanged(v));
                      }
                      u[b.cid] || (u[b.cid] = !0, s.push(b)), t[o] = b;
                    } else h && (a = t[o] = this._prepareModel(a, e)) && (l.push(a), this._addReference(a, e), u[a.cid] = !0, s.push(a));
                  }
                  if (g) {
                    for (o = 0; o < this.length; o++) u[(a = this.models[o]).cid] || d.push(a);
                    d.length && this._removeModels(d, e);
                  }
                  var x = !1,
                    C = !m && h && g;
                  if (s.length && C ? (x = this.length !== s.length || n.some(this.models, function (t, e) {
                    return t !== s[e];
                  }), this.models.length = 0, j(this.models, s, 0), this.length = this.models.length) : l.length && (m && (f = !0), j(this.models, l, null == r ? this.length : r), this.length = this.models.length), f && this.sort({
                    silent: !0
                  }), !e.silent) {
                    for (o = 0; o < l.length; o++) null != r && (e.index = r + o), (a = l[o]).trigger("add", a, this, e);
                    (f || x) && this.trigger("sort", this, e), (l.length || d.length || c.length) && (e.changes = {
                      added: l,
                      removed: d,
                      merged: c
                    }, this.trigger("update", this, e));
                  }
                  return i ? t[0] : t;
                }
              },
              reset: function reset(t, e) {
                e = e ? n.clone(e) : {};
                for (var i = 0; i < this.models.length; i++) this._removeReference(this.models[i], e);
                return e.previousModels = this.models, this._reset(), t = this.add(t, n.extend({
                  silent: !0
                }, e)), e.silent || this.trigger("reset", this, e), t;
              },
              push: function push(t, e) {
                return this.add(t, n.extend({
                  at: this.length
                }, e));
              },
              pop: function pop(t) {
                var e = this.at(this.length - 1);
                return this.remove(e, t);
              },
              unshift: function unshift(t, e) {
                return this.add(t, n.extend({
                  at: 0
                }, e));
              },
              shift: function shift(t) {
                var e = this.at(0);
                return this.remove(e, t);
              },
              slice: function slice() {
                return a.apply(this.models, arguments);
              },
              get: function get(t) {
                if (null != t) return this._byId[t] || this._byId[this.modelId(t.attributes || t)] || t.cid && this._byId[t.cid];
              },
              has: function has(t) {
                return null != this.get(t);
              },
              at: function at(t) {
                return t < 0 && (t += this.length), this.models[t];
              },
              where: function where(t, e) {
                return this[e ? "find" : "filter"](t);
              },
              findWhere: function findWhere(t) {
                return this.where(t, !0);
              },
              sort: function sort(t) {
                var e = this.comparator;
                if (!e) throw new Error("Cannot sort a set without a comparator");
                t || (t = {});
                var i = e.length;
                return n.isFunction(e) && (e = n.bind(e, this)), 1 === i || n.isString(e) ? this.models = this.sortBy(e) : this.models.sort(e), t.silent || this.trigger("sort", this, t), this;
              },
              pluck: function pluck(t) {
                return this.map(t + "");
              },
              fetch: function fetch(t) {
                var e = (t = n.extend({
                    parse: !0
                  }, t)).success,
                  i = this;
                return t.success = function (n) {
                  var r = t.reset ? "reset" : "set";
                  i[r](n, t), e && e.call(t.context, i, n, t), i.trigger("sync", i, n, t);
                }, _(this, t), this.sync("read", this, t);
              },
              create: function create(t, e) {
                var i = (e = e ? n.clone(e) : {}).wait;
                if (!(t = this._prepareModel(t, e))) return !1;
                i || this.add(t, e);
                var r = this,
                  a = e.success;
                return e.success = function (t, e, n) {
                  i && r.add(t, n), a && a.call(n.context, t, e, n);
                }, t.save(null, e), t;
              },
              parse: function parse(t, e) {
                return t;
              },
              clone: function clone() {
                return new this.constructor(this.models, {
                  model: this.model,
                  comparator: this.comparator
                });
              },
              modelId: function modelId(t) {
                return t[this.model.prototype.idAttribute || "id"];
              },
              _reset: function _reset() {
                this.length = 0, this.models = [], this._byId = {};
              },
              _prepareModel: function _prepareModel(t, e) {
                if (this._isModel(t)) return t.collection || (t.collection = this), t;
                (e = e ? n.clone(e) : {}).collection = this;
                var i = new this.model(t, e);
                return i.validationError ? (this.trigger("invalid", this, i.validationError, e), !1) : i;
              },
              _removeModels: function _removeModels(t, e) {
                for (var n = [], i = 0; i < t.length; i++) {
                  var r = this.get(t[i]);
                  if (r) {
                    var a = this.indexOf(r);
                    this.models.splice(a, 1), this.length--, delete this._byId[r.cid];
                    var o = this.modelId(r.attributes);
                    null != o && delete this._byId[o], e.silent || (e.index = a, r.trigger("remove", r, this, e)), n.push(r), this._removeReference(r, e);
                  }
                }
                return n;
              },
              _isModel: function _isModel(t) {
                return t instanceof b;
              },
              _addReference: function _addReference(t, e) {
                this._byId[t.cid] = t;
                var n = this.modelId(t.attributes);
                null != n && (this._byId[n] = t), t.on("all", this._onModelEvent, this);
              },
              _removeReference: function _removeReference(t, e) {
                delete this._byId[t.cid];
                var n = this.modelId(t.attributes);
                null != n && delete this._byId[n], this === t.collection && delete t.collection, t.off("all", this._onModelEvent, this);
              },
              _onModelEvent: function _onModelEvent(t, e, n, i) {
                if (e) {
                  if (("add" === t || "remove" === t) && n !== this) return;
                  if ("destroy" === t && this.remove(e, i), "change" === t) {
                    var r = this.modelId(e.previousAttributes()),
                      a = this.modelId(e.attributes);
                    r !== a && (null != r && delete this._byId[r], null != a && (this._byId[a] = e));
                  }
                }
                this.trigger.apply(this, arguments);
              }
            }), o(y, {
              forEach: 3,
              each: 3,
              map: 3,
              collect: 3,
              reduce: 0,
              foldl: 0,
              inject: 0,
              reduceRight: 0,
              foldr: 0,
              find: 3,
              detect: 3,
              filter: 3,
              select: 3,
              reject: 3,
              every: 3,
              all: 3,
              some: 3,
              any: 3,
              include: 3,
              includes: 3,
              contains: 3,
              invoke: 0,
              max: 3,
              min: 3,
              toArray: 1,
              size: 1,
              first: 3,
              head: 3,
              take: 3,
              initial: 3,
              rest: 3,
              tail: 3,
              drop: 3,
              last: 3,
              without: 0,
              difference: 0,
              indexOf: 3,
              shuffle: 1,
              lastIndexOf: 3,
              isEmpty: 1,
              chain: 1,
              sample: 3,
              partition: 3,
              groupBy: 3,
              countBy: 3,
              sortBy: 3,
              indexBy: 3,
              findIndex: 3,
              findLastIndex: 3
            }, "models");
            var C = e.View = function (t) {
                this.cid = n.uniqueId("view"), n.extend(this, n.pick(t, k)), this._ensureElement(), this.initialize.apply(this, arguments);
              },
              M = /^(\S+)\s*(.*)$/,
              k = ["model", "collection", "el", "id", "attributes", "className", "tagName", "events"];
            n.extend(C.prototype, c, {
              tagName: "div",
              $: function $(t) {
                return this.$el.find(t);
              },
              initialize: function initialize() {},
              render: function render() {
                return this;
              },
              remove: function remove() {
                return this._removeElement(), this.stopListening(), this;
              },
              _removeElement: function _removeElement() {
                this.$el.remove();
              },
              setElement: function setElement(t) {
                return this.undelegateEvents(), this._setElement(t), this.delegateEvents(), this;
              },
              _setElement: function _setElement(t) {
                this.$el = t instanceof e.$ ? t : e.$(t), this.el = this.$el[0];
              },
              delegateEvents: function delegateEvents(t) {
                if (t || (t = n.result(this, "events")), !t) return this;
                for (var e in this.undelegateEvents(), t) {
                  var i = t[e];
                  if (n.isFunction(i) || (i = this[i]), i) {
                    var r = e.match(M);
                    this.delegate(r[1], r[2], n.bind(i, this));
                  }
                }
                return this;
              },
              delegate: function delegate(t, e, n) {
                return this.$el.on(t + ".delegateEvents" + this.cid, e, n), this;
              },
              undelegateEvents: function undelegateEvents() {
                return this.$el && this.$el.off(".delegateEvents" + this.cid), this;
              },
              undelegate: function undelegate(t, e, n) {
                return this.$el.off(t + ".delegateEvents" + this.cid, e, n), this;
              },
              _createElement: function _createElement(t) {
                return document.createElement(t);
              },
              _ensureElement: function _ensureElement() {
                if (this.el) this.setElement(n.result(this, "el"));else {
                  var t = n.extend({}, n.result(this, "attributes"));
                  this.id && (t.id = n.result(this, "id")), this.className && (t.class = n.result(this, "className")), this.setElement(this._createElement(n.result(this, "tagName"))), this._setAttributes(t);
                }
              },
              _setAttributes: function _setAttributes(t) {
                this.$el.attr(t);
              }
            }), e.sync = function (t, i, r) {
              var a = O[t];
              n.defaults(r || (r = {}), {
                emulateHTTP: e.emulateHTTP,
                emulateJSON: e.emulateJSON
              });
              var o = {
                type: a,
                dataType: "json"
              };
              if (r.url || (o.url = n.result(i, "url") || z()), null != r.data || !i || "create" !== t && "update" !== t && "patch" !== t || (o.contentType = "application/json", o.data = JSON.stringify(r.attrs || i.toJSON(r))), r.emulateJSON && (o.contentType = "application/x-www-form-urlencoded", o.data = o.data ? {
                model: o.data
              } : {}), r.emulateHTTP && ("PUT" === a || "DELETE" === a || "PATCH" === a)) {
                o.type = "POST", r.emulateJSON && (o.data._method = a);
                var s = r.beforeSend;
                r.beforeSend = function (t) {
                  if (t.setRequestHeader("X-HTTP-Method-Override", a), s) return s.apply(this, arguments);
                };
              }
              "GET" === o.type || r.emulateJSON || (o.processData = !1);
              var l = r.error;
              r.error = function (t, e, n) {
                r.textStatus = e, r.errorThrown = n, l && l.call(r.context, t, e, n);
              };
              var c = r.xhr = e.ajax(n.extend(o, r));
              return i.trigger("request", i, c, r), c;
            };
            var O = {
              create: "POST",
              update: "PUT",
              patch: "PATCH",
              delete: "DELETE",
              read: "GET"
            };
            e.ajax = function () {
              return e.$.ajax.apply(e.$, arguments);
            };
            var T = e.Router = function (t) {
                t || (t = {}), t.routes && (this.routes = t.routes), this._bindRoutes(), this.initialize.apply(this, arguments);
              },
              S = /\((.*?)\)/g,
              N = /(\(\?)?:\w+/g,
              L = /\*\w+/g,
              D = /[\-{}\[\]+?.,\\\^$|#\s]/g;
            n.extend(T.prototype, c, {
              initialize: function initialize() {},
              route: function route(t, i, r) {
                n.isRegExp(t) || (t = this._routeToRegExp(t)), n.isFunction(i) && (r = i, i = ""), r || (r = this[i]);
                var a = this;
                return e.history.route(t, function (n) {
                  var o = a._extractParameters(t, n);
                  !1 !== a.execute(r, o, i) && (a.trigger.apply(a, ["route:" + i].concat(o)), a.trigger("route", i, o), e.history.trigger("route", a, i, o));
                }), this;
              },
              execute: function execute(t, e, n) {
                t && t.apply(this, e);
              },
              navigate: function navigate(t, n) {
                return e.history.navigate(t, n), this;
              },
              _bindRoutes: function _bindRoutes() {
                if (this.routes) {
                  this.routes = n.result(this, "routes");
                  for (var t, e = n.keys(this.routes); null != (t = e.pop());) this.route(t, this.routes[t]);
                }
              },
              _routeToRegExp: function _routeToRegExp(t) {
                return t = t.replace(D, "\\$&").replace(S, "(?:$1)?").replace(N, function (t, e) {
                  return e ? t : "([^/?]+)";
                }).replace(L, "([^?]*?)"), new RegExp("^" + t + "(?:\\?([\\s\\S]*))?$");
              },
              _extractParameters: function _extractParameters(t, e) {
                var i = t.exec(e).slice(1);
                return n.map(i, function (t, e) {
                  return e === i.length - 1 ? t || null : t ? decodeURIComponent(t) : null;
                });
              }
            });
            var E = e.History = function () {
                this.handlers = [], this.checkUrl = n.bind(this.checkUrl, this), "undefined" != typeof window && (this.location = window.location, this.history = window.history);
              },
              I = /^[#\/]|\s+$/g,
              P = /^\/+|\/+$/g,
              A = /#.*$/;
            E.started = !1, n.extend(E.prototype, c, {
              interval: 50,
              atRoot: function atRoot() {
                return this.location.pathname.replace(/[^\/]$/, "$&/") === this.root && !this.getSearch();
              },
              matchRoot: function matchRoot() {
                return this.decodeFragment(this.location.pathname).slice(0, this.root.length - 1) + "/" === this.root;
              },
              decodeFragment: function decodeFragment(t) {
                return decodeURI(t.replace(/%25/g, "%2525"));
              },
              getSearch: function getSearch() {
                var t = this.location.href.replace(/#.*/, "").match(/\?.+/);
                return t ? t[0] : "";
              },
              getHash: function getHash(t) {
                var e = (t || this).location.href.match(/#(.*)$/);
                return e ? e[1] : "";
              },
              getPath: function getPath() {
                var t = this.decodeFragment(this.location.pathname + this.getSearch()).slice(this.root.length - 1);
                return "/" === t.charAt(0) ? t.slice(1) : t;
              },
              getFragment: function getFragment(t) {
                return null == t && (t = this._usePushState || !this._wantsHashChange ? this.getPath() : this.getHash()), t.replace(I, "");
              },
              start: function start(t) {
                if (E.started) throw new Error("Backbone.history has already been started");
                if (E.started = !0, this.options = n.extend({
                  root: "/"
                }, this.options, t), this.root = this.options.root, this._wantsHashChange = !1 !== this.options.hashChange, this._hasHashChange = "onhashchange" in window && (void 0 === document.documentMode || document.documentMode > 7), this._useHashChange = this._wantsHashChange && this._hasHashChange, this._wantsPushState = !!this.options.pushState, this._hasPushState = !(!this.history || !this.history.pushState), this._usePushState = this._wantsPushState && this._hasPushState, this.fragment = this.getFragment(), this.root = ("/" + this.root + "/").replace(P, "/"), this._wantsHashChange && this._wantsPushState) {
                  if (!this._hasPushState && !this.atRoot()) {
                    var e = this.root.slice(0, -1) || "/";
                    return this.location.replace(e + "#" + this.getPath()), !0;
                  }
                  this._hasPushState && this.atRoot() && this.navigate(this.getHash(), {
                    replace: !0
                  });
                }
                if (!this._hasHashChange && this._wantsHashChange && !this._usePushState) {
                  this.iframe = document.createElement("iframe"), this.iframe.src = "javascript:0", this.iframe.style.display = "none", this.iframe.tabIndex = -1;
                  var i = document.body,
                    r = i.insertBefore(this.iframe, i.firstChild).contentWindow;
                  r.document.open(), r.document.close(), r.location.hash = "#" + this.fragment;
                }
                var a = window.addEventListener || function (t, e) {
                  return attachEvent("on" + t, e);
                };
                if (this._usePushState ? a("popstate", this.checkUrl, !1) : this._useHashChange && !this.iframe ? a("hashchange", this.checkUrl, !1) : this._wantsHashChange && (this._checkUrlInterval = setInterval(this.checkUrl, this.interval)), !this.options.silent) return this.loadUrl();
              },
              stop: function stop() {
                var t = window.removeEventListener || function (t, e) {
                  return detachEvent("on" + t, e);
                };
                this._usePushState ? t("popstate", this.checkUrl, !1) : this._useHashChange && !this.iframe && t("hashchange", this.checkUrl, !1), this.iframe && (document.body.removeChild(this.iframe), this.iframe = null), this._checkUrlInterval && clearInterval(this._checkUrlInterval), E.started = !1;
              },
              route: function route(t, e) {
                this.handlers.unshift({
                  route: t,
                  callback: e
                });
              },
              checkUrl: function checkUrl(t) {
                var e = this.getFragment();
                if (e === this.fragment && this.iframe && (e = this.getHash(this.iframe.contentWindow)), e === this.fragment) return !1;
                this.iframe && this.navigate(e), this.loadUrl();
              },
              loadUrl: function loadUrl(t) {
                return !!this.matchRoot() && (t = this.fragment = this.getFragment(t), n.some(this.handlers, function (e) {
                  if (e.route.test(t)) return e.callback(t), !0;
                }));
              },
              navigate: function navigate(t, e) {
                if (!E.started) return !1;
                e && !0 !== e || (e = {
                  trigger: !!e
                }), t = this.getFragment(t || "");
                var n = this.root;
                "" !== t && "?" !== t.charAt(0) || (n = n.slice(0, -1) || "/");
                var i = n + t;
                if (t = this.decodeFragment(t.replace(A, "")), this.fragment !== t) {
                  if (this.fragment = t, this._usePushState) this.history[e.replace ? "replaceState" : "pushState"]({}, document.title, i);else {
                    if (!this._wantsHashChange) return this.location.assign(i);
                    if (this._updateHash(this.location, t, e.replace), this.iframe && t !== this.getHash(this.iframe.contentWindow)) {
                      var r = this.iframe.contentWindow;
                      e.replace || (r.document.open(), r.document.close()), this._updateHash(r.location, t, e.replace);
                    }
                  }
                  return e.trigger ? this.loadUrl(t) : void 0;
                }
              },
              _updateHash: function _updateHash(t, e, n) {
                if (n) {
                  var i = t.href.replace(/(javascript:|#).*$/, "");
                  t.replace(i + "#" + e);
                } else t.hash = "#" + e;
              }
            }), e.history = new E(), b.extend = y.extend = T.extend = C.extend = E.extend = function (t, e) {
              var i,
                r = this;
              return i = t && n.has(t, "constructor") ? t.constructor : function () {
                return r.apply(this, arguments);
              }, n.extend(i, r, e), i.prototype = n.create(r.prototype, t), i.prototype.constructor = i, i.__super__ = r.prototype, i;
            };
            var z = function z() {
                throw new Error('A "url" property or function must be specified');
              },
              _ = function _(t, e) {
                var n = e.error;
                e.error = function (i) {
                  n && n.call(e.context, t, i, e), t.trigger("error", t, i, e);
                };
              };
            return e;
          }(o, n, t, e);
        }.apply(e, r)) || (t.exports = a);
      }).call(this, n(26));
    }, function (t, e, n) {
      var i = n(42);
      t.exports = function (t, e, n) {
        return (e = i(e)) in t ? Object.defineProperty(t, e, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = n, t;
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e, n) {
      "use strict";

      n.d(e, "p", function () {
        return x;
      }), n.d(e, "u", function () {
        return h;
      }), n.d(e, "t", function () {
        return p;
      }), n.d(e, "k", function () {
        return b;
      }), n.d(e, "r", function () {
        return c;
      }), n.d(e, "g", function () {
        return j;
      }), n.d(e, "d", function () {
        return C;
      }), n.d(e, "b", function () {
        return m;
      }), n.d(e, "q", function () {
        return w;
      }), n.d(e, "f", function () {
        return O;
      }), n.d(e, "m", function () {
        return T;
      }), n.d(e, "e", function () {
        return y;
      }), n.d(e, "w", function () {
        return u;
      }), n.d(e, "s", function () {
        return v;
      }), n.d(e, "h", function () {
        return M;
      }), n.d(e, "i", function () {
        return g;
      }), n.d(e, "c", function () {
        return N;
      }), n.d(e, "j", function () {
        return E;
      }), n.d(e, "v", function () {
        return I;
      }), n.d(e, "a", function () {
        return d;
      }), n.d(e, "n", function () {
        return S;
      }), n.d(e, "l", function () {
        return L;
      }), n.d(e, "o", function () {
        return D;
      });
      var i = n(8),
        r = n.n(i),
        a = n(9),
        o = n.n(a),
        s = n(0),
        l = window.Element.prototype,
        c = l.matches || l.webkitMatchesSelector || l.mozMatchesSelector || l.msMatchesSelector,
        d = function t(e) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            i = Object(s.isArray)(e) ? o()(e) : [e];
          if (i.length) {
            var r = i.shift();
            if (r && (!n.unique || !document.querySelector('link[href="'.concat(r, '"]')))) {
              var a = document,
                l = a.head,
                c = document.createElement("link");
              c.href = r, c.rel = "stylesheet", n.prepand ? l.insertBefore(c, l.firstChild) : l.appendChild(c);
            }
            t(i);
          }
        },
        u = function u(t, e) {
          var n = {},
            i = Object(s.keys)(e);
          for (var r in t) if (t.hasOwnProperty(r)) {
            var a = t[r],
              o = e[r];
            i.indexOf(r) >= 0 ? a !== o && (n[r] = o) : n[r] = null;
          }
          for (var l in e) e.hasOwnProperty(l) && Object(s.isUndefined)(t[l]) && (n[l] = e[l]);
          return n;
        },
        h = function h(t, e, n) {
          e = e.split(/\s+/), t = t instanceof Array ? t : [t];
          for (var i = function i(_i3) {
              t.forEach(function (t) {
                return t.addEventListener(e[_i3], n);
              });
            }, r = 0; r < e.length; ++r) i(r);
        },
        p = function p(t, e, n) {
          e = e.split(/\s+/), t = t instanceof Array ? t : [t];
          for (var i = function i(_i4) {
              t.forEach(function (t) {
                return t.removeEventListener(e[_i4], n);
              });
            }, r = 0; r < e.length; ++r) i(r);
        },
        g = function g(t) {
          return t.replace(parseFloat(t), "");
        },
        f = function f(t) {
          return t[0].toUpperCase() + t.toLowerCase().slice(1);
        },
        m = function m(t) {
          var e = t.split("-").filter(String);
          return e[0].toLowerCase() + e.slice(1).map(f);
        },
        v = function v(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
            i = 0;
          if (isNaN(t)) return n;
          if (t = parseFloat(t), Math.floor(t) !== t) {
            var r = e.toString().split(".")[1];
            i = r ? r.length : 0;
          }
          return i ? parseFloat(t.toFixed(i)) : t;
        },
        b = function b(t) {
          return "draggable" in document.createElement("i") && (t ? t.get("Config").nativeDnD : 1);
        },
        y = function y(t) {
          return Object(s.isElement)(t) || w(t) ? t : t && t.getEl ? t.getEl() : void 0;
        },
        w = function w(t) {
          return t && 3 === t.nodeType;
        },
        x = function x(t) {
          return t && !w(t) && !function (t) {
            return t && 8 === t.nodeType;
          }(t);
        },
        j = function j(t, e) {
          var n = t;
          return Object(s.isElement)(t) && (n = e(t).data("model")), n;
        },
        C = function C(t) {
          var e,
            n = {
              top: 0,
              left: 0,
              width: 0,
              height: 0
            };
          if (!t) return n;
          if (w(t)) {
            var i = document.createRange();
            i.selectNode(t), e = i.getBoundingClientRect(), i.detach();
          }
          return e || (t.getBoundingClientRect ? t.getBoundingClientRect() : n);
        },
        M = function M(t) {
          return t.touches && t.touches[0] ? t.touches[0] : t;
        },
        k = function k(t) {
          return t.which || t.keyCode;
        },
        O = function O(t) {
          return String.fromCharCode(k(t));
        },
        T = function T(t) {
          return 27 === k(t);
        },
        S = function S(t) {
          return null !== t && !Array.isArray(t) && "object" === r()(t);
        },
        N = function N(t) {
          return t && t.charAt(0).toUpperCase() + t.substring(1);
        },
        L = function L(t) {
          return t && t.toHTML;
        },
        D = function D(t) {
          return t && t.toCSS;
        },
        E = function E(t) {
          return t.__gjsv;
        },
        I = function I(t, e) {
          t.__gjsv = e;
        };
    }, function (t, e, n) {
      "use strict";

      (function (t) {
        n.d(e, "e", function () {
          return i;
        }), n.d(e, "p", function () {
          return r;
        }), n.d(e, "a", function () {
          return a;
        }), n.d(e, "c", function () {
          return o;
        }), n.d(e, "d", function () {
          return s;
        }), n.d(e, "o", function () {
          return l;
        }), n.d(e, "q", function () {
          return c;
        }), n.d(e, "t", function () {
          return d;
        }), n.d(e, "i", function () {
          return u;
        }), n.d(e, "r", function () {
          return h;
        }), n.d(e, "s", function () {
          return p;
        }), n.d(e, "k", function () {
          return g;
        }), n.d(e, "m", function () {
          return f;
        }), n.d(e, "j", function () {
          return m;
        }), n.d(e, "l", function () {
          return v;
        }), n.d(e, "g", function () {
          return b;
        }), n.d(e, "f", function () {
          return y;
        }), n.d(e, "h", function () {
          return w;
        }), n.d(e, "n", function () {
          return x;
        }), n.d(e, "b", function () {
          return j;
        });
        var i = "1.13.6",
          r = "object" == typeof self && self.self === self && self || "object" == typeof t && t.global === t && t || Function("return this")() || {},
          a = Array.prototype,
          o = Object.prototype,
          s = "undefined" != typeof Symbol ? Symbol.prototype : null,
          l = a.push,
          c = a.slice,
          d = o.toString,
          u = o.hasOwnProperty,
          h = "undefined" != typeof ArrayBuffer,
          p = "undefined" != typeof DataView,
          g = Array.isArray,
          f = Object.keys,
          m = Object.create,
          v = h && ArrayBuffer.isView,
          b = isNaN,
          y = isFinite,
          w = !{
            toString: null
          }.propertyIsEnumerable("toString"),
          x = ["valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"],
          j = Math.pow(2, 53) - 1;
      }).call(this, n(26));
    }, function (t, e, n) {
      "use strict";

      n.r(e), n.d(e, "eventDrag", function () {
        return j;
      });
      var i = n(8),
        r = n.n(i),
        a = n(2),
        o = n.n(a),
        s = n(0),
        l = n(3),
        c = n(23),
        d = n(1),
        u = n.n(d),
        h = n(21),
        p = n(10),
        g = n(12);
      function f(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function m(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? f(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var v = u.a.Model.extend({
          defaults: {
            type: "text",
            label: "",
            name: "",
            min: "",
            max: "",
            unit: "",
            step: 1,
            value: "",
            target: "",
            default: "",
            placeholder: "",
            changeProp: 0,
            options: [],
            title: "",
            info: "",
            infoStyle: ""
          },
          initialize: function initialize() {
            var t = this.get("target"),
              e = this.get("name"),
              n = this.get("changeProp");
            if (t) {
              this.target = t, this.unset("target");
              var i = n ? "change:".concat(e) : "change:attributes:".concat(e);
              this.listenTo(t, i, this.targetUpdated);
            }
          },
          props: function props() {
            return this.attributes;
          },
          targetUpdated: function targetUpdated() {
            var t = this.getTargetValue();
            this.set({
              value: t
            }, {
              fromTarget: 1
            });
          },
          getTargetValue: function getTargetValue() {
            var t,
              e = this.get("name"),
              n = this.target;
            return t = this.get("changeProp") ? n.get(e) : n.getAttributes()[e], Object(s.isUndefined)(t) ? "" : t;
          },
          setTargetValue: function setTargetValue(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = this.target,
              i = this.get("name");
            if (!Object(s.isUndefined)(t)) {
              var r = t;
              if ("false" === t ? r = !1 : "true" === t && (r = !0), this.get("changeProp")) n.set(i, r, e);else {
                var a = m({}, n.get("attributes"));
                a[i] = r, n.set("attributes", a, e);
              }
            }
          },
          setValueFromInput: function setValueFromInput(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
              n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              i = {
                value: t
              };
            this.set(i, m(m({}, n), {}, {
              avoidStore: 1
            })), e && (this.set("value", "", n), this.set(i, n));
          },
          getInitValue: function getInitValue() {
            var t,
              e = this.target,
              n = this.get("name");
            if (e) {
              var i = e.get("attributes");
              t = this.get("changeProp") ? e.get(n) : i[n];
            }
            return t || this.get("value") || this.get("default");
          }
        }),
        b = u.a.Collection.extend({
          model: v,
          initialize: function initialize(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            this.em = e.em || "", this.listenTo(this, "add", this.handleAdd), this.listenTo(this, "reset", this.handleReset);
          },
          handleReset: function handleReset(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = e.previousModels,
              i = void 0 === n ? [] : n;
            i.forEach(function (t) {
              return t.trigger("remove");
            });
          },
          handleAdd: function handleAdd(t) {
            var e = this.target;
            e && (t.target = e);
          },
          setTarget: function setTarget(t) {
            this.target = t;
          },
          add: function add(t, e) {
            var n = this.em;
            if (Object(s.isString)(t) || Object(s.isArray)(t)) {
              var i = n && n.get && n.get("TraitManager"),
                r = function () {
                  var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                  return {
                    build: function build(e) {
                      var n = [];
                      "string" == typeof e && (e = [e]);
                      for (var i = 0; i < e.length; i++) {
                        var r = {},
                          a = e[i];
                        switch (r.name = a, a) {
                          case "target":
                            r.type = "select", r.default = !1, r.options = t.optionsTarget;
                        }
                        n.push(r);
                      }
                      return n;
                    }
                  };
                }(i && i.getConfig());
              Object(s.isString)(t) && (t = [t]);
              for (var a = 0, o = t.length; a < o; a++) {
                var l = t[a],
                  c = Object(s.isString)(l) ? r.build(l)[0] : l;
                c.target = this.target, t[a] = c;
              }
            }
            return u.a.Collection.prototype.add.apply(this, [t, e]);
          }
        });
      function y(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function w(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? y(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : y(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var x = function x(t) {
          return t.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
        },
        j = "component:drag",
        C = u.a.Model.extend(c.a).extend({
          defaults: {
            tagName: "div",
            type: "",
            name: "",
            removable: !0,
            draggable: !0,
            droppable: !0,
            badgable: !0,
            stylable: !0,
            "stylable-require": "",
            "style-signature": "",
            unstylable: "",
            highlightable: !0,
            copyable: !0,
            resizable: !1,
            editable: !1,
            layerable: !0,
            selectable: !0,
            hoverable: !0,
            void: !1,
            state: "",
            status: "",
            content: "",
            icon: "",
            style: "",
            classes: "",
            script: "",
            "script-export": "",
            attributes: "",
            traits: ["id", "title"],
            propagate: "",
            dmode: "",
            toolbar: null
          },
          init: function init() {},
          updated: function updated(t, e, n) {},
          removed: function removed() {},
          initialize: function initialize() {
            var t = this,
              e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              i = n.em,
              r = this.parent(),
              a = r && r.attributes;
            if (a && a.propagate) {
              var o = {},
                l = a.propagate;
              l.forEach(function (t) {
                return o[t] = r.get(t);
              }), o.propagate = l, o = w(w({}, o), e), this.set(o);
            }
            var c = this.get("propagate");
            c && this.set("propagate", Object(s.isArray)(c) ? c : [c]), n && n.config && n.config.voidElements.indexOf(this.get("tagName")) >= 0 && this.set("void", !0), n.em = i, this.opt = n, this.em = i, this.frame = n.frame, this.config = n.config || {}, this.set("attributes", w(w({}, this.defaults.attributes || {}), this.get("attributes") || {})), this.ccid = C.createId(this), this.initClasses(), this.initTraits(), this.initComponents(), this.initToolbar(), this.listenTo(this, "change:script", this.scriptUpdated), this.listenTo(this, "change:tagName", this.tagUpdated), this.listenTo(this, "change:attributes", this.attrUpdated), this.listenTo(this, "change:attributes:id", this._idUpdated), this.set("status", ""), this.views = [], ["classes", "traits", "components"].forEach(function (e) {
              var n = "add remove ".concat("components" !== e ? "change" : "");
              t.listenTo(t.get(e), n.trim(), function () {
                for (var n = arguments.length, i = new Array(n), r = 0; r < n; r++) i[r] = arguments[r];
                return t.emitUpdate.apply(t, [e].concat(i));
              });
            }), n.temporary || (this.init(), i && i.trigger("component:create", this));
          },
          is: function is(t) {
            return !(this.get("type") != t);
          },
          props: function props() {
            return this.attributes;
          },
          index: function index() {
            var t = this.collection;
            return t && t.indexOf(this);
          },
          setDragMode: function setDragMode(t) {
            return this.set("dmode", t);
          },
          find: function find(t) {
            var e = [],
              n = this.view.$el.find(t);
            return n.each(function (t) {
              var i = n.eq(t).data("model");
              i && e.push(i);
            }), e;
          },
          findType: function findType(t) {
            var e = [];
            return function n(i) {
              return i.forEach(function (i) {
                i.is(t) && e.push(i), n(i.components());
              });
            }(this.components()), e;
          },
          closest: function closest(t) {
            var e = this.view.$el.closest(t);
            return e.length && e.data("model");
          },
          closestType: function closestType(t) {
            for (var e = this.parent(); e && !e.is(t);) e = e.parent();
            return e;
          },
          tagUpdated: function tagUpdated() {
            var t = this.collection,
              e = t.indexOf(this);
            t.remove(this), t.add(this, {
              at: e
            });
          },
          replaceWith: function replaceWith(t) {
            var e = this.collection,
              n = e.indexOf(this);
            return e.remove(this), e.add(t, {
              at: n
            });
          },
          attrUpdated: function attrUpdated(t, e) {
            var n = this,
              i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              r = this.get("attributes"),
              a = r.class;
            a && this.setClass(a), delete r.class;
            var o = r.style;
            o && this.setStyle(o), delete r.style;
            var c = w({}, this.previous("attributes")),
              d = Object(l.w)(c, this.get("attributes"));
            Object(s.keys)(d).forEach(function (t) {
              return n.trigger("change:attributes:".concat(t), n, d[t], i);
            });
          },
          setAttributes: function setAttributes(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return this.set("attributes", w({}, t), e), this;
          },
          addAttributes: function addAttributes(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = w(w({}, this.getAttributes()), t);
            return this.setAttributes(n, e), this;
          },
          getStyle: function getStyle() {
            var t = this.em;
            if (t && t.getConfig("avoidInlineStyle")) {
              var e = t.get("state"),
                n = t.get("CssComposer").getIdRule(this.getId(), {
                  state: e
                });
              if (this.rule = n, n) return n.getStyle();
            }
            return c.a.getStyle.call(this);
          },
          setStyle: function setStyle() {
            var t = this,
              e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              i = this.em,
              r = this.opt;
            if (i && i.getConfig("avoidInlineStyle") && !r.temporary) {
              var a = this.get("style") || {};
              e = w(w({}, e = Object(s.isString)(e) ? this.parseStyle(e) : e), a);
              var o = i.get("state"),
                d = i.get("CssComposer"),
                u = this.getStyle();
              this.rule = d.setIdRule(this.getId(), e, w(w({}, n), {}, {
                state: o
              }));
              var h = Object(l.w)(u, e);
              this.set("style", {}, {
                silent: 1
              }), Object(s.keys)(h).forEach(function (e) {
                return t.trigger("change:style:".concat(e));
              });
            } else e = c.a.setStyle.apply(this, arguments);
            return e;
          },
          getAttributes: function getAttributes() {
            var t,
              e = this.em,
              n = [],
              i = w({}, this.get("attributes")),
              r = e && e.get("SelectorManager"),
              a = this.getId();
            return this.get("classes").forEach(function (t) {
              return n.push(Object(s.isString)(t) ? t : t.get("name"));
            }), n.length && (i.class = n.join(" ")), Object(s.has)(i, "id") || (function (t) {
              return t && t.getConfig("avoidInlineStyle");
            }(e) ? t = r && r.get(a, r.Selector.TYPE_ID) : Object(s.isEmpty)(this.getStyle()) || (t = 1), t && (i.id = this.getId())), i;
          },
          addClass: function addClass(t) {
            var e = this.em.get("SelectorManager").addClass(t);
            return this.get("classes").add(e);
          },
          setClass: function setClass(t) {
            return this.get("classes").reset(), this.addClass(t);
          },
          removeClass: function removeClass(t) {
            var e = [];
            t = Object(s.isArray)(t) ? t : [t];
            var n = this.get("classes"),
              i = p.a.TYPE_CLASS;
            return t.forEach(function (t) {
              t.split(" ").forEach(function (t) {
                var r = n.where({
                  name: t,
                  type: i
                })[0];
                r && e.push(n.remove(r));
              });
            }), e;
          },
          getClasses: function getClasses() {
            var t = this.getAttributes().class;
            return t ? t.split(" ") : [];
          },
          initClasses: function initClasses() {
            var t = this.get("attributes").class || [],
              e = [this, "change:classes", this.initClasses],
              n = this.get("classes") || t,
              i = Object(s.isString)(n) ? n.split(" ") : n;
            this.stopListening.apply(this, e);
            var r = this.normalizeClasses(i),
              a = new g.a([]);
            return this.set("classes", a), a.add(r), this.listenTo.apply(this, e), this;
          },
          initComponents: function initComponents() {
            var t = [this, "change:components", this.initComponents];
            this.stopListening.apply(this, t);
            var e = new h.a(null, this.opt);
            e.parent = this;
            var n = this.get("components"),
              i = !this.opt.avoidChildren;
            return this.set("components", e), i && e.add(Object(s.isFunction)(n) ? n(this) : n), this.listenTo.apply(this, t), this;
          },
          initTraits: function initTraits(t) {
            var e = this.em,
              n = [this, "change:traits", this.initTraits];
            this.stopListening.apply(this, n), this.loadTraits();
            var i = w({}, this.get("attributes")),
              r = this.get("traits");
            return r.each(function (t) {
              if (!t.get("changeProp")) {
                var e = t.get("name"),
                  n = t.getInitValue();
                e && n && (i[e] = n);
              }
            }), r.length && this.set("attributes", i), this.listenTo.apply(this, n), t && e && e.trigger("component:toggled"), this;
          },
          append: function append(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = this.components().add(t, e);
            return Object(s.isArray)(n) ? n : [n];
          },
          components: function components(t) {
            var e = this.get("components");
            return Object(s.isUndefined)(t) ? e : (e.reset(), t && this.append(t));
          },
          empty: function empty() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return this.components().reset(null, t), this;
          },
          parent: function parent() {
            var t = this.collection;
            return t && t.parent;
          },
          scriptUpdated: function scriptUpdated() {
            this.set("scriptUpdated", 1);
          },
          initToolbar: function initToolbar() {
            var t = this.em,
              e = t && t.getConfig("stylePrefix") || "";
            if (!this.get("toolbar")) {
              var n = [];
              this.collection && n.push({
                attributes: {
                  class: "fa fa-arrow-up"
                },
                command: function command(t) {
                  return t.runCommand("core:component-exit", {
                    force: 1
                  });
                }
              }), this.get("draggable") && n.push({
                attributes: {
                  class: "fa fa-arrows ".concat(e, "no-touch-actions"),
                  draggable: !0
                },
                command: "tlb-move"
              }), this.get("copyable") && n.push({
                attributes: {
                  class: "fa fa-clone"
                },
                command: "tlb-clone"
              }), this.get("removable") && n.push({
                attributes: {
                  class: "fa fa-trash-o"
                },
                command: "tlb-delete"
              }), this.get("traits").length > 0 && n.push({
                attributes: {
                  class: "fa fa-cog"
                },
                command: "tlb-trait-setting"
              }), this.set("toolbar", n);
            }
          },
          loadTraits: function loadTraits(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            if (t = t || this.get("traits"), !((t = Object(s.isFunction)(t) ? t(this) : t) instanceof b)) {
              var n = new b([], this.opt);
              n.setTarget(this), t.length && (t.forEach(function (t) {
                return t.attributes && delete t.attributes.value;
              }), n.add(t)), this.set("traits", n, e);
            }
            return this;
          },
          getTrait: function getTrait(t) {
            return this.get("traits").filter(function (e) {
              return e.get("id") === t || e.get("name") === t;
            })[0];
          },
          updateTrait: function updateTrait(t, e) {
            var n = this.em,
              i = this.getTrait(t);
            return i && i.set(e), n && n.trigger("component:toggled"), this;
          },
          getTraitIndex: function getTraitIndex(t) {
            var e = this.getTrait(t);
            return e ? this.get("traits").indexOf(e) : e;
          },
          removeTrait: function removeTrait(t) {
            var e = this,
              n = this.em,
              i = (Object(s.isArray)(t) ? t : [t]).map(function (t) {
                return e.getTrait(t);
              }),
              r = this.get("traits").remove(i);
            return n && n.trigger("component:toggled"), r;
          },
          addTrait: function addTrait(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = this.em,
              i = this.get("traits").add(t, e);
            return n && n.trigger("component:toggled"), i;
          },
          normalizeClasses: function normalizeClasses(t) {
            var e = [],
              n = this.em;
            if (n) {
              var i = n.get("SelectorManager");
              if (i) return t.forEach(function (t) {
                var n;
                n = "string" == typeof t ? t : t.name;
                var r = i.add(n);
                e.push(r);
              }), e;
            }
          },
          clone: function clone() {
            var t = this.em,
              e = this.getStyle(),
              n = w({}, this.attributes),
              i = w({}, this.opt);
            n.attributes = w({}, n.attributes), delete n.attributes.id, n.components = [], n.classes = [], n.traits = [], this.get("components").each(function (t, e) {
              n.components[e] = t.clone();
            }), this.get("traits").each(function (t, e) {
              n.traits[e] = t.clone();
            }), this.get("classes").each(function (t, e) {
              n.classes[e] = t.get("name");
            }), n.status = "", n.view = "", i.collection = null, t && t.getConfig("avoidInlineStyle") && !Object(s.isEmpty)(e) && (n.style = e);
            var r = new this.constructor(n, i);
            return t && t.trigger("component:clone", r), this.trigger("component:clone", r), r;
          },
          getName: function getName() {
            var t = this.em,
              e = this.attributes,
              n = e.type,
              i = e.tagName,
              r = this.get("name"),
              a = "div" == i,
              o = n || (a ? "box" : i),
              s = !n && i && !a && i,
              c = "domComponents.names.",
              d = r && t && t.t("".concat(c).concat(r)),
              u = s && t && t.t("".concat(c).concat(s)),
              h = t && (t.t("".concat(c).concat(n)) || t.t("".concat(c).concat(i)));
            return this.get("custom-name") || d || r || u || Object(l.c)(s) || h || Object(l.c)(o);
          },
          getIcon: function getIcon() {
            var t = this.get("icon");
            return t ? t + " " : "";
          },
          toHTML: function toHTML() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = this,
              n = [],
              i = t.tag,
              r = i || e.get("tagName"),
              a = e.get("void"),
              o = t.attributes,
              l = this.getAttrToHTML();
            for (var c in delete t.tag, o && (Object(s.isFunction)(o) ? l = o(e, l) || {} : Object(s.isObject)(o) && (l = o)), l) {
              var d = l[c],
                u = Object(s.isString)(d) ? d.replace(/"/g, "&quot;") : d;
              Object(s.isUndefined)(u) || (Object(s.isBoolean)(u) ? u && n.push(c) : n.push("".concat(c, '="').concat(u, '"')));
            }
            var h = n.length ? " ".concat(n.join(" ")) : "",
              p = "<".concat(r).concat(h).concat(a ? "/" : "", ">").concat(e.get("content"));
            return e.get("components").each(function (e) {
              return p += e.toHTML(t);
            }), !a && (p += "</".concat(r, ">")), p;
          },
          getAttrToHTML: function getAttrToHTML() {
            var t = this.getAttributes();
            return delete t.style, t;
          },
          toJSON: function toJSON() {
            for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
            var i = u.a.Model.prototype.toJSON.apply(this, e);
            if (i.attributes = this.getAttributes(), delete i.attributes.class, delete i.toolbar, delete i.traits, this.em.getConfig("avoidDefaults")) {
              var r = Object(s.result)(this, "defaults");
              Object(s.forEach)(r, function (t, e) {
                -1 === ["type", "content"].indexOf(e) && i[e] === t && delete i[e];
              }), Object(s.isEmpty)(i.type) && delete i.type, Object(s.forEach)(["attributes", "style"], function (t) {
                Object(s.isEmpty)(r[t]) && Object(s.isEmpty)(i[t]) && delete i[t];
              }), Object(s.forEach)(["classes", "components"], function (t) {
                Object(s.isEmpty)(r[t]) && !i[t].length && delete i[t];
              });
            }
            return i;
          },
          getId: function getId() {
            return (this.get("attributes") || {}).id || this.ccid || this.cid;
          },
          setId: function setId(t, e) {
            var n = w({}, this.get("attributes"));
            return n.id = t, this.set("attributes", n, e), this;
          },
          getEl: function getEl(t) {
            var e = this.getView(t);
            return e && e.el;
          },
          getView: function getView(t) {
            var e = this.view,
              n = this.views;
            return t && (e = n.filter(function (e) {
              return e._getFrame() === t.view;
            })[0]), e;
          },
          getCurrentView: function getCurrentView() {
            var t = (this.em.get("currentFrame") || {}).model;
            return this.getView(t);
          },
          getScriptString: function getScriptString(t) {
            var e = this,
              n = t || this.get("script");
            if (!n) return n;
            if ("function" == typeof n) {
              var i = n.toString().trim();
              n = (i = i.replace(/^function[\s\w]*\(\)\s?\{/, "").replace(/\}$/, "")).trim();
            }
            var a = this.em.getConfig(),
              o = x(a.tagVarStart || "{[ "),
              l = x(a.tagVarEnd || " ]}"),
              c = new RegExp("".concat(o, "([\\w\\d-]*)").concat(l), "g");
            return n.replace(c, function (t, n) {
              e.scriptUpdated();
              var i = e.attributes[n] || "";
              return Object(s.isArray)(i) || "object" == r()(i) ? JSON.stringify(i) : i;
            });
          },
          emitUpdate: function emitUpdate(t) {
            for (var e = this.em, n = "component:update" + (t ? ":".concat(t) : ""), i = arguments.length, r = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) r[a - 1] = arguments[a];
            t && this.updated.apply(this, [t, t && this.get(t), t && this.previous(t)].concat(r)), this.trigger.apply(this, [n].concat(r)), e && e.trigger.apply(e, [n, this].concat(r));
          },
          onAll: function onAll(t) {
            return Object(s.isFunction)(t) && (t(this), this.components().forEach(function (e) {
              return e.onAll(t);
            })), this;
          },
          remove: function remove() {
            var t = this.collection;
            return t && t.remove(this);
          },
          resetId: function resetId() {
            var t = this.em,
              e = this.getId();
            if (e) {
              var n = C.createId(this);
              this.setId(n);
              var i = t && t.get("CssComposer").getIdRule(e),
                r = i && i.get("selectors").at(0);
              return r && r.set("name", n), this;
            }
          },
          _getStyleRule: function _getStyleRule() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = t.id,
              n = this.em,
              i = e || this.getId();
            return n && n.get("CssComposer").getIdRule(i);
          },
          _getStyleSelector: function _getStyleSelector(t) {
            var e = this._getStyleRule(t);
            return e && e.get("selectors").at(0);
          },
          _idUpdated: function _idUpdated(t, e) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            if (!n.idUpdate) {
              var i = this.ccid,
                r = this.get("attributes") || {},
                a = r.id,
                o = (this.previous("attributes") || {}).id || i,
                s = C.getList(this);
              if (s[a]) return this.setId(o, {
                idUpdate: 1
              });
              delete s[o], s[a] = this, this.ccid = a;
              var l = this._getStyleSelector({
                id: o
              });
              l && l.set({
                name: a,
                label: a
              });
            }
          }
        }, {
          isComponent: function isComponent(t) {
            return {
              tagName: t.tagName ? t.tagName.toLowerCase() : ""
            };
          },
          ensureInList: function ensureInList(t) {
            var e = C.getList(t),
              n = t.getId(),
              i = e[n];
            if (i) {
              if (i !== t) {
                var r = C.getIncrementId(n, e);
                t.setId(r), e[r] = t;
              }
            } else e[n] = t;
            t.components().forEach(function (t) {
              return C.ensureInList(t);
            });
          },
          createId: function createId(t) {
            var e,
              n = C.getList(t),
              i = t.get("attributes").id;
            return i ? (e = C.getIncrementId(i, n), t.setId(e)) : e = C.getNewId(n), n[e] = t, e;
          },
          getNewId: function getNewId(t) {
            for (var e = Object.keys(t).length.toString().length + 2, n = (Math.random() + 1.1).toString(36).slice(-e), i = "i".concat(n); t[i];) i = C.getNewId(t);
            return i;
          },
          getIncrementId: function getIncrementId(t, e) {
            for (var n = 1, i = t; e[i];) n++, i = "".concat(t, "-").concat(n);
            return i;
          },
          getList: function getList(t) {
            var e = t.opt && t.opt.domc;
            return e ? e.componentsById : {};
          },
          checkId: function checkId(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
              n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              i = Object(s.isArray)(t) ? t : [t];
            i.forEach(function (t) {
              var i = t.attributes,
                r = void 0 === i ? {} : i,
                a = t.components,
                o = r.id;
              if (o && n[o]) {
                var l = C.getIncrementId(o, n);
                r.id = l, Object(s.isArray)(e) && e.forEach(function (t) {
                  var e = t.selectors;
                  e.forEach(function (t, n) {
                    t === "#".concat(o) && (e[n] = "#".concat(l));
                  });
                });
              }
              a && C.checkId(a, e, n);
            });
          }
        });
      e.default = C;
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(2),
        r = n.n(i),
        a = n(1),
        o = n.n(a),
        s = n(0),
        l = n(21),
        c = n(35),
        d = n(12),
        u = n(7),
        h = n(3);
      function p(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function g(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? p(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.default = o.a.View.extend({
        className: function className() {
          return this.getClasses();
        },
        tagName: function tagName() {
          return this.model.get("tagName");
        },
        initialize: function initialize() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = this.model,
            n = t.config || {},
            i = n.em,
            r = e.opt || {},
            a = this.$el,
            o = this.el,
            s = n.draggableComponents;
          this.opts = t, this.modelOpt = r, this.config = n, this.em = i || "", this.pfx = n.stylePrefix || "", this.ppfx = n.pStylePrefix || "", this.attr = e.get("attributes"), this.classe = this.attr.class || [], this.listenTo(e, "change:style", this.updateStyle), this.listenTo(e, "change:attributes change:_innertext", this.renderAttributes), this.listenTo(e, "change:highlightable", this.updateHighlight), this.listenTo(e, "change:status", this.updateStatus), this.listenTo(e, "change:script", this.reset), this.listenTo(e, "change:content", this.updateContent), this.listenTo(e, "change", this.handleChange), this.listenTo(e, "active", this.onActive), this.listenTo(e, "disable", this.onDisable), a.data("model", e), Object(h.v)(o, this), e.view = this, this._getFrame() && e.views.push(this), this.initClasses(), this.initComponents({
            avoidRender: 1
          }), this.events = g(g({}, this.events), s && {
            dragstart: "handleDragStart"
          }), this.delegateEvents(), !r.temporary && this.init(this._clbObj());
        },
        _clbObj: function _clbObj() {
          var t = this.em,
            e = this.model,
            n = this.el;
          return {
            editor: t && t.getEditor(),
            model: e,
            el: n
          };
        },
        init: function init() {},
        removed: function removed() {},
        onActive: function onActive() {},
        onDisable: function onDisable() {},
        remove: function remove() {
          var t = this;
          o.a.View.prototype.remove.apply(t, arguments);
          var e = t.model,
            n = t._getFrame() || {},
            i = n.model;
          e.components().forEach(function (t) {
            var e = t.getView(i);
            e && e.remove();
          });
          var r = e.views;
          return r.splice(r.indexOf(t), 1), t.removed(t._clbObj()), t.$el.data({
            model: "",
            collection: "",
            view: ""
          }), delete t.model, delete t.$el, delete t.el.__gjsv, delete t.childrenView, delete t.opts, t;
        },
        handleDragStart: function handleDragStart(t) {
          t.preventDefault(), t.stopPropagation(), this.em.get("Commands").run("tlb-move", {
            target: this.model,
            event: t
          });
        },
        initClasses: function initClasses() {
          var t = this.model,
            e = t.get("classes");
          e instanceof d.a && (this.stopListening(t, "change:classes", this.initClasses), this.listenTo(t, "change:classes", this.initClasses), this.listenTo(e, "add remove change", this.updateClasses), e.length && this.importClasses());
        },
        initComponents: function initComponents() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = this.model,
            n = this.$el,
            i = this.childrenView,
            r = "change:components",
            a = e.get("components"),
            o = [e, r, this.initComponents];
          a instanceof l.a && (n.data("collection", a), i && i.remove(), this.stopListening.apply(this, o), !t.avoidRender && this.renderChildren(), this.listenTo.apply(this, o));
        },
        handleChange: function handleChange() {
          var t = this.model,
            e = Object(s.keys)(t.changed);
          if (1 !== e.length || "status" !== e[0]) for (var n in t.emitUpdate(), t.changed) t.emitUpdate(n);
        },
        importClasses: function importClasses() {
          var t = this.config.em.get("SelectorManager");
          t && this.model.get("classes").each(function (e) {
            t.add(e.get("name"));
          });
        },
        updateStatus: function updateStatus() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = (this.em, this.el),
            n = this.model.get("status"),
            i = (this.pfx, this.ppfx),
            r = "".concat(i, "selected"),
            a = "".concat(r, "-parent"),
            o = "".concat(i, "freezed"),
            s = "".concat(i, "hovered"),
            l = [r, a, o, s];
          this.$el.removeClass(l.join(" "));
          var c = e.getAttribute("class") || "",
            d = "";
          switch (n) {
            case "selected":
              d = "".concat(c, " ").concat(r);
              break;
            case "selected-parent":
              d = "".concat(c, " ").concat(a);
              break;
            case "freezed":
              d = "".concat(c, " ").concat(o);
              break;
            case "freezed-selected":
              d = "".concat(c, " ").concat(o, " ").concat(r);
              break;
            case "hovered":
              d = t.avoidHover ? "" : "".concat(c, " ").concat(s);
          }
          (d = d.trim()) && e.setAttribute("class", d);
        },
        updateHighlight: function updateHighlight() {
          var t = this.model.get("highlightable");
          this.setAttribute("data-highlightable", t ? 1 : "");
        },
        updateStyle: function updateStyle() {
          var t = this.model,
            e = this.em,
            n = this.el;
          if (e && e.getConfig("avoidInlineStyle")) {
            t.get("_innertext") ? n.removeAttribute("id") : n.id = t.getId();
            var i = t.getStyle();
            !Object(s.isEmpty)(i) && t.setStyle(i);
          } else this.setAttribute("style", t.styleToString());
        },
        updateClasses: function updateClasses() {
          var t = this.model.get("classes").pluck("name").join(" ");
          this.setAttribute("class", t), this.updateStatus();
        },
        setAttribute: function setAttribute(t, e) {
          var n = this.$el;
          e ? n.attr(t, e) : n.removeAttr(t);
        },
        getClasses: function getClasses() {
          return this.model.getClasses().join(" ");
        },
        updateAttributes: function updateAttributes() {
          var t = [],
            e = this.model,
            n = this.$el,
            i = this.el,
            r = this.config,
            a = e.attributes,
            o = a.highlightable,
            l = a.textable,
            c = a.type,
            d = a._innertext,
            u = g(g(g({
              "data-gjs-type": c || "default"
            }, r.draggableComponents && !d ? {
              draggable: !0
            } : {}), o ? {
              "data-highlightable": 1
            } : {}), l ? {
              contenteditable: "false",
              "data-gjs-textable": "true"
            } : {});
          Object(s.each)(i.attributes, function (e) {
            return t.push(e.nodeName);
          }), t.forEach(function (t) {
            return n.removeAttr(t);
          });
          var h = g(g({}, u), e.getAttributes());
          Object(s.keys)(h).forEach(function (t) {
            return !1 === h[t] && delete h[t];
          }), n.attr(h), this.updateStyle();
        },
        updateContent: function updateContent() {
          this.getChildrenContainer().innerHTML = this.model.get("content");
        },
        prevDef: function prevDef(t) {
          t.preventDefault();
        },
        updateScript: function updateScript() {
          var t = this.model,
            e = this.em;
          t.get("script") && e && e.get("Canvas").getCanvasView().updateScript(this);
        },
        getChildrenContainer: function getChildrenContainer() {
          var t = this.el;
          return "function" == typeof this.getChildrenSelector ? t = this.el.querySelector(this.getChildrenSelector()) : this.getTemplate, t;
        },
        getOffsetRect: function getOffsetRect() {
          var t = {},
            e = this.el,
            n = 0,
            i = 0;
          return function r(a) {
            var o = a.offsetParent;
            o ? (n += o.offsetTop, i += o.offsetLeft, r(o)) : (t.top = e.offsetTop + n, t.left = e.offsetLeft + i, t.bottom = t.top + e.offsetHeight, t.right = t.left + e.offsetWidth);
          }(e), t;
        },
        isInViewport: function isInViewport() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = t.rect,
            n = this.el,
            i = n.ownerDocument,
            r = i.body,
            a = i.defaultView.frameElement,
            o = e || this.getOffsetRect(),
            s = o.top,
            l = o.left,
            c = this._getFrame().getOffsetRect();
          return s >= c.scrollTop && l >= c.scrollLeft && s <= c.scrollBottom && l <= a.offsetWidth + r.scrollLeft;
        },
        scrollIntoView: function scrollIntoView() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = this.getOffsetRect(),
            n = this.isInViewport({
              rect: e
            });
          if (!n || t.force) {
            var i = this.el;
            "smooth" !== t.behavior ? i.ownerDocument.defaultView.scrollTo(0, e.top) : i.scrollIntoView(g({
              behavior: "smooth",
              block: "nearest"
            }, t));
          }
        },
        reset: function reset() {
          var t = this.el;
          this.el = "", this._ensureElement(), this._setData(), Object(u.j)(t, this.el), this.render();
        },
        _setData: function _setData() {
          var t = this.model,
            e = t.components();
          this.$el.data({
            model: t,
            collection: e,
            view: this
          });
        },
        _getFrame: function _getFrame() {
          return this.config.frameView;
        },
        renderChildren: function renderChildren() {
          this.updateContent();
          var t = this.getChildrenContainer(),
            e = this.childrenView || new c.a({
              collection: this.model.get("components"),
              config: this.config,
              componentTypes: this.opts.componentTypes
            });
          e.render(t), this.childrenView = e;
          for (var n = Array.prototype.slice.call(e.el.childNodes), i = 0, r = n.length; i < r; i++) t.appendChild(n.shift());
        },
        renderAttributes: function renderAttributes() {
          this.updateAttributes(), this.updateClasses();
        },
        render: function render() {
          return this.renderAttributes(), this.modelOpt.temporary || (this.renderChildren(), this.updateScript(), Object(h.v)(this.el, this), this.postRender()), this;
        },
        postRender: function postRender() {
          var t = this.em,
            e = this.model;
          this.modelOpt.temporary || (this.onRender(this._clbObj()), t && t.trigger("component:mount", e));
        },
        onRender: function onRender() {}
      });
    }, function (t, e, n) {
      "use strict";

      n.d(e, "i", function () {
        return r;
      }), n.d(e, "g", function () {
        return a;
      }), n.d(e, "h", function () {
        return o;
      }), n.d(e, "f", function () {
        return s;
      }), n.d(e, "j", function () {
        return l;
      }), n.d(e, "b", function () {
        return c;
      }), n.d(e, "a", function () {
        return d;
      }), n.d(e, "e", function () {
        return u;
      }), n.d(e, "d", function () {
        return h;
      }), n.d(e, "c", function () {
        return p;
      });
      var i = n(0),
        r = "transitionend oTransitionEnd transitionend webkitTransitionEnd",
        a = function a(t) {
          return t && 9 === t.nodeType;
        },
        o = function o(t) {
          return t && !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length);
        },
        s = function s(t) {
          for (; t.firstChild;) t.removeChild(t.firstChild);
        },
        l = function l(t, e) {
          t.parentNode.replaceChild(e, t);
        },
        c = function c(t, e, n) {
          var r = t.childNodes,
            a = r.length,
            o = Object(i.isUndefined)(n) ? a : n;
          Object(i.isString)(e) && (t.insertAdjacentHTML("beforeEnd", e), e = t.lastChild, t.removeChild(e)), o >= a ? t.appendChild(e) : t.insertBefore(e, r[o]);
        },
        d = function d(t, e) {
          return c(t, e);
        },
        u = function u(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
            n = arguments.length > 2 ? arguments[2] : void 0,
            r = document.createElement(t);
          return e && Object(i.each)(e, function (t, e) {
            return r.setAttribute(e, t);
          }), n && (Object(i.isString)(n) ? r.innerHTML = n : r.appendChild(n)), r;
        },
        h = function h(t, e) {
          var n;
          try {
            n = new window[e](t.type, t);
          } catch (t) {
            (n = document.createEvent(e)).initEvent(t.type, !0, !0);
          }
          return n.keyCodeVal = t.keyCode, n._parentEvent = t, ["keyCode", "which"].forEach(function (t) {
            Object.defineProperty(n, t, {
              get: function get() {
                return this.keyCodeVal;
              }
            });
          }), n;
        },
        p = function p(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
            n = Array.isArray(e) ? e : [e];
          n.forEach(function (e) {
            var n = e.tag || "div",
              r = e.attributes || {},
              a = document.createElement(n);
            Object(i.each)(r, function (t, e) {
              a.setAttribute(e, t);
            }), t.appendChild(a);
          });
        };
    }, function (t, e) {
      function n(e) {
        return t.exports = n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, t.exports.__esModule = !0, t.exports.default = t.exports, n(e);
      }
      t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e, n) {
      var i = n(82),
        r = n(83),
        a = n(44),
        o = n(84);
      t.exports = function (t) {
        return i(t) || r(t) || a(t) || o();
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e, n) {
      "use strict";

      var i = n(1),
        r = n.n(i).a.Model.extend({
          idAttribute: "name",
          defaults: {
            name: "",
            label: "",
            type: 1,
            active: !0,
            private: !1,
            protected: !1
          },
          initialize: function initialize(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = e.config,
              i = void 0 === n ? {} : n,
              a = this.get("name"),
              o = this.get("label");
            a ? o || this.set("label", a) : this.set("name", o);
            var s = this.get("name"),
              l = i.escapeName,
              c = l ? l(s) : r.escapeName(s);
            this.set("name", c);
          },
          getFullName: function getFullName() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = t.escape,
              n = this.get("name"),
              i = "";
            switch (this.get("type")) {
              case 1:
                i = ".";
                break;
              case 2:
                i = "#";
            }
            return i + (e ? e(n) : n);
          }
        }, {
          TYPE_CLASS: 1,
          TYPE_ID: 2,
          escapeName: function escapeName(t) {
            return "".concat(t).trim().replace(/([^a-z0-9\w-\:]+)/gi, "-");
          }
        });
      e.a = r;
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = document,
        r = window,
        a = Array.prototype,
        o = a.filter,
        s = a.indexOf,
        l = a.map,
        c = a.push,
        d = a.reverse,
        u = a.slice,
        h = a.splice,
        p = /^#[\w-]*$/,
        g = /^\.[\w-]*$/,
        f = /<.+>/,
        m = /^\w+$/;
      function v(t, e) {
        return void 0 === e && (e = i), g.test(t) ? e.getElementsByClassName(t.slice(1)) : m.test(t) ? e.getElementsByTagName(t) : e.querySelectorAll(t);
      }
      function b(t, e) {
        if (void 0 === e && (e = i), t) {
          if (t.__cash) return t;
          var n = t;
          if (S(t)) {
            if (e.__cash && (e = e[0]), !(n = p.test(t) ? e.getElementById(t.slice(1)) : f.test(t) ? ct(t) : v(t, e))) return;
          } else if (T(t)) return this.ready(t);
          (n.nodeType || n === r) && (n = [n]), this.length = n.length;
          for (var a = 0, o = this.length; a < o; a++) this[a] = n[a];
        }
      }
      function y(t, e) {
        return new b(t, e);
      }
      var w = y.fn = y.prototype = b.prototype = {
        constructor: y,
        __cash: !0,
        length: 0,
        splice: h
      };
      w.get = function (t) {
        return void 0 === t ? u.call(this) : this[t < 0 ? t + this.length : t];
      }, w.eq = function (t) {
        return y(this.get(t));
      }, w.first = function () {
        return this.eq(0);
      }, w.last = function () {
        return this.eq(-1);
      }, w.map = function (t) {
        return y(l.call(this, function (e, n) {
          return t.call(e, n, e);
        }));
      }, w.slice = function () {
        return y(u.apply(this, arguments));
      };
      var x = /(?:^\w|[A-Z]|\b\w)/g,
        j = /[\s-_]+/g;
      function C(t) {
        return t.replace(x, function (t, e) {
          return t[e ? "toUpperCase" : "toLowerCase"]();
        }).replace(j, "");
      }
      function M(t, e) {
        for (var n = 0, i = t.length; n < i && !1 !== e.call(t[n], t[n], n, t); n++);
      }
      y.camelCase = C, y.each = M, w.each = function (t) {
        return M(this, function (e, n) {
          return t.call(e, n, e);
        }), this;
      }, w.removeProp = function (t) {
        return this.each(function (e, n) {
          delete n[t];
        });
      }, y.extend = w.extend = function (t) {
        void 0 === t && (t = this);
        for (var e = arguments, n = e.length, i = n < 2 ? 0 : 1; i < n; i++) for (var r in e[i]) t[r] = e[i][r];
        return t;
      };
      var k = 1;
      function O(t, e) {
        var n = t && (t.matches || t.webkitMatchesSelector || t.mozMatchesSelector || t.msMatchesSelector || t.oMatchesSelector);
        return !!n && n.call(t, e);
      }
      function T(t) {
        return "function" == typeof t;
      }
      function S(t) {
        return "string" == typeof t;
      }
      function N(t) {
        return !isNaN(parseFloat(t)) && isFinite(t);
      }
      y.guid = k, y.matches = O, y.isFunction = T, y.isString = S, y.isNumeric = N;
      var L = Array.isArray;
      function D(t) {
        return S(t) ? function (e, n) {
          return O(n, t);
        } : t.__cash ? function (e, n) {
          return t.is(n);
        } : function (t, e, n) {
          return e === n;
        };
      }
      y.isArray = L, w.prop = function (t, e) {
        if (t) {
          if (S(t)) return arguments.length < 2 ? this[0] && this[0][t] : this.each(function (n, i) {
            i[t] = e;
          });
          for (var n in t) this.prop(n, t[n]);
          return this;
        }
      }, w.filter = function (t) {
        if (!t) return y();
        var e = T(t) ? t : D(t);
        return y(o.call(this, function (n, i) {
          return e.call(n, i, n, t);
        }));
      };
      var E = /\S+/g;
      function I(t) {
        return S(t) && t.match(E) || [];
      }
      function P(t) {
        return t.filter(function (t, e, n) {
          return n.indexOf(t) === e;
        });
      }
      function A(t, e, n) {
        if (1 === t.nodeType) {
          var i = r.getComputedStyle(t, null);
          return e ? n ? i.getPropertyValue(e) : i[e] : i;
        }
      }
      function z(t, e) {
        return parseInt(A(t, e), 10) || 0;
      }
      w.hasClass = function (t) {
        var e = I(t),
          n = !1;
        return e.length && this.each(function (t, i) {
          return !(n = i.classList.contains(e[0]));
        }), n;
      }, w.removeAttr = function (t) {
        var e = I(t);
        return e.length ? this.each(function (t, n) {
          M(e, function (t) {
            n.removeAttribute(t);
          });
        }) : this;
      }, w.attr = function (t, e) {
        if (t) {
          if (S(t)) {
            if (arguments.length < 2) {
              if (!this[0]) return;
              var n = this[0].getAttribute(t);
              return null === n ? void 0 : n;
            }
            return null === e ? this.removeAttr(t) : this.each(function (n, i) {
              i.setAttribute(t, e);
            });
          }
          for (var i in t) this.attr(i, t[i]);
          return this;
        }
      }, w.toggleClass = function (t, e) {
        var n = I(t),
          i = void 0 !== e;
        return n.length ? this.each(function (t, r) {
          M(n, function (t) {
            i ? e ? r.classList.add(t) : r.classList.remove(t) : r.classList.toggle(t);
          });
        }) : this;
      }, w.addClass = function (t) {
        return this.toggleClass(t, !0);
      }, w.removeClass = function (t) {
        return arguments.length ? this.toggleClass(t, !1) : this.attr("class", "");
      }, y.unique = P, w.add = function (t, e) {
        return y(P(this.get().concat(y(t, e).get())));
      };
      var _ = /^--/;
      function H(t) {
        return _.test(t);
      }
      var V = {},
        F = i.createElement("div").style,
        R = ["webkit", "moz", "ms", "o"];
      function B(t, e) {
        if (void 0 === e && (e = H(t)), e) return t;
        if (!V[t]) {
          var n = C(t),
            i = "" + n.charAt(0).toUpperCase() + n.slice(1);
          M((n + " " + R.join(i + " ") + i).split(" "), function (e) {
            if (e in F) return V[t] = e, !1;
          });
        }
        return V[t];
      }
      y.prefixedProp = B;
      var W = {
        animationIterationCount: !0,
        columnCount: !0,
        flexGrow: !0,
        flexShrink: !0,
        fontWeight: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        widows: !0,
        zIndex: !0
      };
      function Y(t, e, n) {
        return void 0 === n && (n = H(t)), n || W[t] || !N(e) ? e : e + "px";
      }
      w.css = function (t, e) {
        if (S(t)) {
          var n = H(t);
          return t = B(t, n), arguments.length < 2 ? this[0] && A(this[0], t, n) : t ? (e = Y(t, e, n), this.each(function (i, r) {
            1 === r.nodeType && (n ? r.style.setProperty(t, e) : r.style[t] = e);
          })) : this;
        }
        for (var i in t) this.css(i, t[i]);
        return this;
      };
      var U = /^data-(.*)/;
      function Z(t) {
        return t.__cashData = t.__cashData || {};
      }
      function G(t, e) {
        var n = Z(t);
        if (e) {
          if (!(e in n)) {
            var i = t.dataset ? t.dataset[e] || t.dataset[C(e)] : y(t).attr("data-" + e);
            if (void 0 !== i) {
              try {
                i = JSON.parse(i);
              } catch (t) {}
              n[e] = i;
            }
          }
          return n[e];
        }
        return n;
      }
      function q(t, e) {
        return z(t, "border" + (e ? "Left" : "Top") + "Width") + z(t, "padding" + (e ? "Left" : "Top")) + z(t, "padding" + (e ? "Right" : "Bottom")) + z(t, "border" + (e ? "Right" : "Bottom") + "Width");
      }
      function $(t, e) {
        for (var n = 0, i = e.length; n < i; n++) if (t.indexOf(e[n]) < 0) return !1;
        return !0;
      }
      function Q(t, e, n) {
        M(t[n], function (t) {
          t[0];
          var i = t[1];
          e.removeEventListener(n, i);
        }), delete t[n];
      }
      function J(t) {
        return t.__cashEvents = t.__cashEvents || {};
      }
      function X(t) {
        var e = t.split(".");
        return [e[0], e.slice(1).sort()];
      }
      function K(t, e, n, i) {
        var r = J(t);
        if (e) {
          var a = r[e];
          if (!a) return;
          i && (i.guid = i.guid || k++), r[e] = a.filter(function (r) {
            var a = r[0],
              o = r[1];
            if (i && o.guid !== i.guid || !$(a, n)) return !0;
            t.removeEventListener(e, o);
          });
        } else if (n && n.length) for (e in r) K(t, e, n, i);else for (e in r) Q(r, t, e);
      }
      y.hasData = function (t) {
        return "__cashData" in t;
      }, w.data = function (t, e) {
        var n = this;
        if (!t) {
          if (!this[0]) return;
          return M(this[0].attributes, function (t) {
            var e = t.name.match(U);
            e && n.data(e[1]);
          }), G(this[0]);
        }
        if (S(t)) return void 0 === e ? this[0] && G(this[0], t) : this.each(function (n, i) {
          return function (t, e, n) {
            Z(t)[e] = n;
          }(i, t, e);
        });
        for (var i in t) this.data(i, t[i]);
        return this;
      }, w.removeData = function (t) {
        return this.each(function (e, n) {
          return function (t, e) {
            void 0 === e ? delete t.__cashData : delete Z(t)[e];
          }(n, t);
        });
      }, M(["Width", "Height"], function (t) {
        w["inner" + t] = function () {
          if (this[0]) return this[0] === r ? r["inner" + t] : this[0]["client" + t];
        };
      }), M(["width", "height"], function (t, e) {
        w[t] = function (n) {
          return this[0] ? arguments.length ? (n = parseInt(n, 10), this.each(function (i, r) {
            if (1 === r.nodeType) {
              var a = A(r, "boxSizing");
              r.style[t] = Y(t, n + ("border-box" === a ? q(r, !e) : 0));
            }
          })) : this[0] === r ? this[0][C("outer-" + t)] : this[0].getBoundingClientRect()[t] - q(this[0], !e) : void 0 === n ? void 0 : this;
        };
      }), M(["Width", "Height"], function (t, e) {
        w["outer" + t] = function (n) {
          if (this[0]) return this[0] === r ? r["outer" + t] : this[0]["offset" + t] + (n ? z(this[0], "margin" + (e ? "Top" : "Left")) + z(this[0], "margin" + (e ? "Bottom" : "Right")) : 0);
        };
      }), w.off = function (t, e) {
        var n = this;
        return void 0 === t ? this.each(function (t, e) {
          return K(e);
        }) : M(I(t), function (t) {
          var i = X(t),
            r = i[0],
            a = i[1];
          n.each(function (t, n) {
            return K(n, r, a, e);
          });
        }), this;
      }, w.on = function (t, e, n, i) {
        var r = this;
        if (!S(t)) {
          for (var a in t) this.on(a, e, t[a]);
          return this;
        }
        return T(e) && (n = e, e = !1), M(I(t), function (t) {
          var a = X(t),
            o = a[0],
            s = a[1];
          r.each(function (t, r) {
            var a = function t(a) {
              if (!a.namespace || $(s, a.namespace.split("."))) {
                var l = r;
                if (e) {
                  for (var c = a.target; !O(c, e);) {
                    if (c === r) return;
                    if (!(c = c.parentNode)) return;
                  }
                  l = c;
                }
                a.namespace = a.namespace || "";
                var d = n.call(l, a, a.data);
                i && K(r, o, s, t), !1 === d && (a.preventDefault(), a.stopPropagation());
              }
            };
            a.guid = n.guid = n.guid || k++, function (t, e, n, i) {
              i.guid = i.guid || k++;
              var r = J(t);
              r[e] = r[e] || [], r[e].push([n, i]), t.addEventListener(e, i);
            }(r, o, s, a);
          });
        }), this;
      }, w.one = function (t, e, n) {
        return this.on(t, e, n, !0);
      }, w.ready = function (t) {
        var e = function e() {
          return t(y);
        };
        return "loading" !== i.readyState ? setTimeout(e) : i.addEventListener("DOMContentLoaded", e), this;
      }, w.trigger = function (t, e) {
        var n = t;
        if (S(t)) {
          var r = X(t),
            a = r[0],
            o = r[1];
          (n = i.createEvent("HTMLEvents")).initEvent(a, !0, !0), n.namespace = o.join(".");
        }
        return n.data = e, this.each(function (t, e) {
          e.dispatchEvent(n);
        });
      };
      var tt = /select-one/i,
        et = /select-multiple/i;
      function nt(t) {
        var e = t.type;
        return tt.test(e) ? function (t) {
          return t.selectedIndex < 0 ? null : t.options[t.selectedIndex].value;
        }(t) : et.test(e) ? function (t) {
          var e = [];
          return M(t.options, function (t) {
            !t.selected || t.disabled || t.parentNode.disabled || e.push(t.value);
          }), e;
        }(t) : t.value;
      }
      var it = /%20/g,
        rt = /file|reset|submit|button|image/i,
        at = /radio|checkbox/i;
      w.serialize = function () {
        var t = "";
        return this.each(function (e, n) {
          M(n.elements || [n], function (e) {
            if (!e.disabled && e.name && "FIELDSET" !== e.tagName && !rt.test(e.type) && (!at.test(e.type) || e.checked)) {
              var n = nt(e);
              void 0 !== n && M(L(n) ? n : [n], function (n) {
                t += function (t, e) {
                  return "&" + encodeURIComponent(t) + "=" + encodeURIComponent(e).replace(it, "+");
                }(e.name, n);
              });
            }
          });
        }), t.substr(1);
      }, w.val = function (t) {
        return void 0 === t ? this[0] && nt(this[0]) : this.each(function (e, n) {
          var i = et.test(n.type),
            r = null === t ? i ? [] : "" : t;
          i && L(r) ? M(n.options, function (t) {
            t.selected = r.indexOf(t.value) >= 0;
          }) : n.value = r;
        });
      }, w.clone = function () {
        return this.map(function (t, e) {
          return e.cloneNode(!0);
        });
      }, w.detach = function () {
        return this.each(function (t, e) {
          e.parentNode && e.parentNode.removeChild(e);
        });
      };
      var ot,
        st = /^\s*<(\w+)[^>]*>/,
        lt = /^\s*<(\w+)\s*\/?>(?:<\/\1>)?\s*$/;
      function ct(t) {
        if (function () {
          if (!ot) {
            var t = i.createElement("table"),
              e = i.createElement("tr");
            ot = {
              "*": i.createElement("div"),
              tr: i.createElement("tbody"),
              td: e,
              th: e,
              thead: t,
              tbody: t,
              tfoot: t
            };
          }
        }(), !S(t)) return [];
        if (lt.test(t)) return [i.createElement(RegExp.$1)];
        var e = st.test(t) && RegExp.$1,
          n = ot[e] || ot["*"];
        return n.innerHTML = t, y(n.childNodes).detach().get();
      }
      function dt(t, e, n) {
        if (void 0 !== e) {
          var i = S(e);
          !i && e.length ? M(e, function (e) {
            return dt(t, e, n);
          }) : M(t, i ? function (t) {
            t.insertAdjacentHTML(n ? "afterbegin" : "beforeend", e);
          } : function (t, i) {
            return function (t, e, n) {
              n ? t.insertBefore(e, t.childNodes[0]) : t.appendChild(e);
            }(t, i ? e.cloneNode(!0) : e, n);
          });
        }
      }
      y.parseHTML = ct, w.empty = function () {
        var t = this[0];
        if (t) for (; t.firstChild;) t.removeChild(t.firstChild);
        return this;
      }, w.append = function () {
        var t = this;
        return M(arguments, function (e) {
          dt(t, e);
        }), this;
      }, w.appendTo = function (t) {
        return dt(y(t), this), this;
      }, w.html = function (t) {
        if (void 0 === t) return this[0] && this[0].innerHTML;
        var e = t.nodeType ? t[0].outerHTML : t;
        return this.each(function (t, n) {
          n.innerHTML = e;
        });
      }, w.insertAfter = function (t) {
        var e = this;
        return y(t).each(function (t, n) {
          var i = n.parentNode;
          e.each(function (e, r) {
            i.insertBefore(t ? r.cloneNode(!0) : r, n.nextSibling);
          });
        }), this;
      }, w.after = function () {
        var t = this;
        return M(d.apply(arguments), function (e) {
          d.apply(y(e).slice()).insertAfter(t);
        }), this;
      }, w.insertBefore = function (t) {
        var e = this;
        return y(t).each(function (t, n) {
          var i = n.parentNode;
          e.each(function (e, r) {
            i.insertBefore(t ? r.cloneNode(!0) : r, n);
          });
        }), this;
      }, w.before = function () {
        var t = this;
        return M(arguments, function (e) {
          y(e).insertBefore(t);
        }), this;
      }, w.prepend = function () {
        var t = this;
        return M(arguments, function (e) {
          dt(t, e, !0);
        }), this;
      }, w.prependTo = function (t) {
        return dt(y(t), d.apply(this.slice()), !0), this;
      }, w.remove = function () {
        return this.detach().off();
      }, w.replaceWith = function (t) {
        var e = this;
        return this.each(function (n, i) {
          var r = i.parentNode;
          if (r) {
            var a = n ? y(t).clone() : y(t);
            if (!a[0]) return e.remove(), !1;
            r.replaceChild(a[0], i), y(a[0]).after(a.slice(1));
          }
        });
      }, w.replaceAll = function (t) {
        return y(t).replaceWith(this), this;
      }, w.text = function (t) {
        return void 0 === t ? this[0] ? this[0].textContent : "" : this.each(function (e, n) {
          n.textContent = t;
        });
      };
      var ut = i.documentElement;
      w.offset = function () {
        var t = this[0];
        if (t) {
          var e = t.getBoundingClientRect();
          return {
            top: e.top + r.pageYOffset - ut.clientTop,
            left: e.left + r.pageXOffset - ut.clientLeft
          };
        }
      }, w.offsetParent = function () {
        return y(this[0] && this[0].offsetParent);
      }, w.position = function () {
        var t = this[0];
        if (t) return {
          left: t.offsetLeft,
          top: t.offsetTop
        };
      }, w.children = function (t) {
        var e = [];
        return this.each(function (t, n) {
          c.apply(e, n.children);
        }), e = y(P(e)), t ? e.filter(function (e, n) {
          return O(n, t);
        }) : e;
      }, w.contents = function () {
        var t = [];
        return this.each(function (e, n) {
          c.apply(t, "IFRAME" === n.tagName ? [n.contentDocument] : n.childNodes);
        }), y(t.length && P(t));
      }, w.find = function (t) {
        for (var e = [], n = 0, i = this.length; n < i; n++) {
          var r = v(t, this[n]);
          r.length && c.apply(e, r);
        }
        return y(e.length && P(e));
      }, w.has = function (t) {
        var e = S(t) ? function (e, n) {
          return !!v(t, n).length;
        } : function (e, n) {
          return n.contains(t);
        };
        return this.filter(e);
      }, w.is = function (t) {
        if (!t || !this[0]) return !1;
        var e = D(t),
          n = !1;
        return this.each(function (i, r) {
          return !(n = e(i, r, t));
        }), n;
      }, w.next = function () {
        return y(this[0] && this[0].nextElementSibling);
      }, w.not = function (t) {
        if (!t || !this[0]) return this;
        var e = D(t);
        return this.filter(function (n, i) {
          return !e(n, i, t);
        });
      }, w.parent = function () {
        var t = [];
        return this.each(function (e, n) {
          n && n.parentNode && t.push(n.parentNode);
        }), y(P(t));
      }, w.index = function (t) {
        var e = t ? y(t)[0] : this[0],
          n = t ? this : y(e).parent().children();
        return s.call(n, e);
      }, w.closest = function (t) {
        return t && this[0] ? this.is(t) ? this.filter(t) : this.parent().closest(t) : y();
      }, w.parents = function (t) {
        var e,
          n = [];
        return this.each(function (r, a) {
          for (e = a; e && e.parentNode && e !== i.body.parentNode;) e = e.parentNode, (!t || t && O(e, t)) && n.push(e);
        }), y(P(n));
      }, w.prev = function () {
        return y(this[0] && this[0].previousElementSibling);
      }, w.siblings = function () {
        var t = this[0];
        return this.parent().children().filter(function (e, n) {
          return n !== t;
        });
      }, e.default = y;
    }, function (t, e, n) {
      "use strict";

      var i = n(0),
        r = n(1),
        a = n.n(r),
        o = n(10);
      e.a = a.a.Collection.extend({
        model: o.a,
        modelId: function modelId(t) {
          return "".concat(t.name, "_").concat(t.type || o.a.TYPE_CLASS);
        },
        getStyleable: function getStyleable() {
          return Object(i.filter)(this.models, function (t) {
            return t.get("active") && !t.get("private");
          });
        },
        getValid: function getValid() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = t.noDisabled;
          return Object(i.filter)(this.models, function (t) {
            return !t.get("private");
          }).filter(function (t) {
            return e ? t.get("active") : 1;
          });
        },
        getFullString: function getFullString(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = [],
            i = t || this;
          return i.forEach(function (t) {
            return n.push(t.getFullName(e));
          }), n.join("").trim();
        }
      });
    }, function (t, e, n) {
      t.exports = function () {
        "use strict";

        var t = navigator.userAgent,
          e = navigator.platform,
          n = /gecko\/\d/i.test(t),
          i = /MSIE \d/.test(t),
          r = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(t),
          a = /Edge\/(\d+)/.exec(t),
          o = i || r || a,
          s = o && (i ? document.documentMode || 6 : +(a || r)[1]),
          l = !a && /WebKit\//.test(t),
          c = l && /Qt\/\d+\.\d+/.test(t),
          d = !a && /Chrome\/(\d+)/.exec(t),
          u = d && +d[1],
          h = /Opera\//.test(t),
          p = /Apple Computer/.test(navigator.vendor),
          g = /Mac OS X 1\d\D([8-9]|\d\d)\D/.test(t),
          f = /PhantomJS/.test(t),
          m = p && (/Mobile\/\w+/.test(t) || navigator.maxTouchPoints > 2),
          v = /Android/.test(t),
          b = m || v || /webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(t),
          y = m || /Mac/.test(e),
          w = /\bCrOS\b/.test(t),
          x = /win/i.test(e),
          j = h && t.match(/Version\/(\d*\.\d*)/);
        j && (j = Number(j[1])), j && j >= 15 && (h = !1, l = !0);
        var C = y && (c || h && (null == j || j < 12.11)),
          M = n || o && s >= 9;
        function k(t) {
          return new RegExp("(^|\\s)" + t + "(?:$|\\s)\\s*");
        }
        var O,
          T = function T(t, e) {
            var n = t.className,
              i = k(e).exec(n);
            if (i) {
              var r = n.slice(i.index + i[0].length);
              t.className = n.slice(0, i.index) + (r ? i[1] + r : "");
            }
          };
        function S(t) {
          for (var e = t.childNodes.length; e > 0; --e) t.removeChild(t.firstChild);
          return t;
        }
        function N(t, e) {
          return S(t).appendChild(e);
        }
        function L(t, e, n, i) {
          var r = document.createElement(t);
          if (n && (r.className = n), i && (r.style.cssText = i), "string" == typeof e) r.appendChild(document.createTextNode(e));else if (e) for (var a = 0; a < e.length; ++a) r.appendChild(e[a]);
          return r;
        }
        function D(t, e, n, i) {
          var r = L(t, e, n, i);
          return r.setAttribute("role", "presentation"), r;
        }
        function E(t, e) {
          if (3 == e.nodeType && (e = e.parentNode), t.contains) return t.contains(e);
          do {
            if (11 == e.nodeType && (e = e.host), e == t) return !0;
          } while (e = e.parentNode);
        }
        function I(t) {
          var e,
            n = t.ownerDocument || t;
          try {
            e = t.activeElement;
          } catch (t) {
            e = n.body || null;
          }
          for (; e && e.shadowRoot && e.shadowRoot.activeElement;) e = e.shadowRoot.activeElement;
          return e;
        }
        function P(t, e) {
          var n = t.className;
          k(e).test(n) || (t.className += (n ? " " : "") + e);
        }
        function A(t, e) {
          for (var n = t.split(" "), i = 0; i < n.length; i++) n[i] && !k(n[i]).test(e) && (e += " " + n[i]);
          return e;
        }
        O = document.createRange ? function (t, e, n, i) {
          var r = document.createRange();
          return r.setEnd(i || t, n), r.setStart(t, e), r;
        } : function (t, e, n) {
          var i = document.body.createTextRange();
          try {
            i.moveToElementText(t.parentNode);
          } catch (t) {
            return i;
          }
          return i.collapse(!0), i.moveEnd("character", n), i.moveStart("character", e), i;
        };
        var z = function z(t) {
          t.select();
        };
        function _(t) {
          return t.display.wrapper.ownerDocument;
        }
        function H(t) {
          return V(t.display.wrapper);
        }
        function V(t) {
          return t.getRootNode ? t.getRootNode() : t.ownerDocument;
        }
        function F(t) {
          return _(t).defaultView;
        }
        function R(t) {
          var e = Array.prototype.slice.call(arguments, 1);
          return function () {
            return t.apply(null, e);
          };
        }
        function B(t, e, n) {
          for (var i in e || (e = {}), t) !t.hasOwnProperty(i) || !1 === n && e.hasOwnProperty(i) || (e[i] = t[i]);
          return e;
        }
        function W(t, e, n, i, r) {
          null == e && -1 == (e = t.search(/[^\s\u00a0]/)) && (e = t.length);
          for (var a = i || 0, o = r || 0;;) {
            var s = t.indexOf("\t", a);
            if (s < 0 || s >= e) return o + (e - a);
            o += s - a, o += n - o % n, a = s + 1;
          }
        }
        m ? z = function z(t) {
          t.selectionStart = 0, t.selectionEnd = t.value.length;
        } : o && (z = function z(t) {
          try {
            t.select();
          } catch (t) {}
        });
        var Y = function Y() {
          this.id = null, this.f = null, this.time = 0, this.handler = R(this.onTimeout, this);
        };
        function U(t, e) {
          for (var n = 0; n < t.length; ++n) if (t[n] == e) return n;
          return -1;
        }
        Y.prototype.onTimeout = function (t) {
          t.id = 0, t.time <= +new Date() ? t.f() : setTimeout(t.handler, t.time - +new Date());
        }, Y.prototype.set = function (t, e) {
          this.f = e;
          var n = +new Date() + t;
          (!this.id || n < this.time) && (clearTimeout(this.id), this.id = setTimeout(this.handler, t), this.time = n);
        };
        var Z = {
            toString: function toString() {
              return "CodeMirror.Pass";
            }
          },
          G = {
            scroll: !1
          },
          q = {
            origin: "*mouse"
          },
          $ = {
            origin: "+move"
          };
        function Q(t, e, n) {
          for (var i = 0, r = 0;;) {
            var a = t.indexOf("\t", i);
            -1 == a && (a = t.length);
            var o = a - i;
            if (a == t.length || r + o >= e) return i + Math.min(o, e - r);
            if (r += a - i, i = a + 1, (r += n - r % n) >= e) return i;
          }
        }
        var J = [""];
        function X(t) {
          for (; J.length <= t;) J.push(K(J) + " ");
          return J[t];
        }
        function K(t) {
          return t[t.length - 1];
        }
        function tt(t, e) {
          for (var n = [], i = 0; i < t.length; i++) n[i] = e(t[i], i);
          return n;
        }
        function et() {}
        function nt(t, e) {
          var n;
          return Object.create ? n = Object.create(t) : (et.prototype = t, n = new et()), e && B(e, n), n;
        }
        var it = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
        function rt(t) {
          return /\w/.test(t) || t > "" && (t.toUpperCase() != t.toLowerCase() || it.test(t));
        }
        function at(t, e) {
          return e ? !!(e.source.indexOf("\\w") > -1 && rt(t)) || e.test(t) : rt(t);
        }
        function ot(t) {
          for (var e in t) if (t.hasOwnProperty(e) && t[e]) return !1;
          return !0;
        }
        var st = /[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065e\u0670\u06d6-\u06dc\u06de-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0900-\u0902\u093c\u0941-\u0948\u094d\u0951-\u0955\u0962\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2\u09e3\u0a01\u0a02\u0a3c\u0a41\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81\u0a82\u0abc\u0ac1-\u0ac5\u0ac7\u0ac8\u0acd\u0ae2\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86\u0f87\u0f90-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039\u103a\u103d\u103e\u1058\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085\u1086\u108d\u109d\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193b\u1a17\u1a18\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80\u1b81\u1ba2-\u1ba5\u1ba8\u1ba9\u1c2c-\u1c33\u1c36\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1dc0-\u1de6\u1dfd-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\ua672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua825\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\uaa29-\uaa2e\uaa31\uaa32\uaa35\uaa36\uaa43\uaa4c\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe5\uabe8\uabed\udc00-\udfff\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]/;
        function lt(t) {
          return t.charCodeAt(0) >= 768 && st.test(t);
        }
        function ct(t, e, n) {
          for (; (n < 0 ? e > 0 : e < t.length) && lt(t.charAt(e));) e += n;
          return e;
        }
        function dt(t, e, n) {
          for (var i = e > n ? -1 : 1;;) {
            if (e == n) return e;
            var r = (e + n) / 2,
              a = i < 0 ? Math.ceil(r) : Math.floor(r);
            if (a == e) return t(a) ? e : n;
            t(a) ? n = a : e = a + i;
          }
        }
        var ut = null;
        function ht(t, e, n) {
          var i;
          ut = null;
          for (var r = 0; r < t.length; ++r) {
            var a = t[r];
            if (a.from < e && a.to > e) return r;
            a.to == e && (a.from != a.to && "before" == n ? i = r : ut = r), a.from == e && (a.from != a.to && "before" != n ? i = r : ut = r);
          }
          return null != i ? i : ut;
        }
        var pt = function () {
          var t = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/,
            e = /[stwN]/,
            n = /[LRr]/,
            i = /[Lb1n]/,
            r = /[1n]/;
          function a(t, e, n) {
            this.level = t, this.from = e, this.to = n;
          }
          return function (o, s) {
            var l = "ltr" == s ? "L" : "R";
            if (0 == o.length || "ltr" == s && !t.test(o)) return !1;
            for (var c, d = o.length, u = [], h = 0; h < d; ++h) u.push((c = o.charCodeAt(h)) <= 247 ? "bbbbbbbbbtstwsbbbbbbbbbbbbbbssstwNN%%%NNNNNN,N,N1111111111NNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNbbbbbbsbbbbbbbbbbbbbbbbbbbbbbbbbb,N%%%%NNNNLNNNNN%%11NLNNN1LNNNNNLLLLLLLLLLLLLLLLLLLLLLLNLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLN".charAt(c) : 1424 <= c && c <= 1524 ? "R" : 1536 <= c && c <= 1785 ? "nnnnnnNNr%%r,rNNmmmmmmmmmmmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmmmmmmmmnnnnnnnnnn%nnrrrmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmnNmmmmmmrrmmNmmmmrr1111111111".charAt(c - 1536) : 1774 <= c && c <= 2220 ? "r" : 8192 <= c && c <= 8203 ? "w" : 8204 == c ? "b" : "L");
            for (var p = 0, g = l; p < d; ++p) {
              var f = u[p];
              "m" == f ? u[p] = g : g = f;
            }
            for (var m = 0, v = l; m < d; ++m) {
              var b = u[m];
              "1" == b && "r" == v ? u[m] = "n" : n.test(b) && (v = b, "r" == b && (u[m] = "R"));
            }
            for (var y = 1, w = u[0]; y < d - 1; ++y) {
              var x = u[y];
              "+" == x && "1" == w && "1" == u[y + 1] ? u[y] = "1" : "," != x || w != u[y + 1] || "1" != w && "n" != w || (u[y] = w), w = x;
            }
            for (var j = 0; j < d; ++j) {
              var C = u[j];
              if ("," == C) u[j] = "N";else if ("%" == C) {
                var M = void 0;
                for (M = j + 1; M < d && "%" == u[M]; ++M);
                for (var k = j && "!" == u[j - 1] || M < d && "1" == u[M] ? "1" : "N", O = j; O < M; ++O) u[O] = k;
                j = M - 1;
              }
            }
            for (var T = 0, S = l; T < d; ++T) {
              var N = u[T];
              "L" == S && "1" == N ? u[T] = "L" : n.test(N) && (S = N);
            }
            for (var L = 0; L < d; ++L) if (e.test(u[L])) {
              var D = void 0;
              for (D = L + 1; D < d && e.test(u[D]); ++D);
              for (var E = "L" == (L ? u[L - 1] : l), I = E == ("L" == (D < d ? u[D] : l)) ? E ? "L" : "R" : l, P = L; P < D; ++P) u[P] = I;
              L = D - 1;
            }
            for (var A, z = [], _ = 0; _ < d;) if (i.test(u[_])) {
              var H = _;
              for (++_; _ < d && i.test(u[_]); ++_);
              z.push(new a(0, H, _));
            } else {
              var V = _,
                F = z.length,
                R = "rtl" == s ? 1 : 0;
              for (++_; _ < d && "L" != u[_]; ++_);
              for (var B = V; B < _;) if (r.test(u[B])) {
                V < B && (z.splice(F, 0, new a(1, V, B)), F += R);
                var W = B;
                for (++B; B < _ && r.test(u[B]); ++B);
                z.splice(F, 0, new a(2, W, B)), F += R, V = B;
              } else ++B;
              V < _ && z.splice(F, 0, new a(1, V, _));
            }
            return "ltr" == s && (1 == z[0].level && (A = o.match(/^\s+/)) && (z[0].from = A[0].length, z.unshift(new a(0, 0, A[0].length))), 1 == K(z).level && (A = o.match(/\s+$/)) && (K(z).to -= A[0].length, z.push(new a(0, d - A[0].length, d)))), "rtl" == s ? z.reverse() : z;
          };
        }();
        function gt(t, e) {
          var n = t.order;
          return null == n && (n = t.order = pt(t.text, e)), n;
        }
        var ft = [],
          mt = function mt(t, e, n) {
            if (t.addEventListener) t.addEventListener(e, n, !1);else if (t.attachEvent) t.attachEvent("on" + e, n);else {
              var i = t._handlers || (t._handlers = {});
              i[e] = (i[e] || ft).concat(n);
            }
          };
        function vt(t, e) {
          return t._handlers && t._handlers[e] || ft;
        }
        function bt(t, e, n) {
          if (t.removeEventListener) t.removeEventListener(e, n, !1);else if (t.detachEvent) t.detachEvent("on" + e, n);else {
            var i = t._handlers,
              r = i && i[e];
            if (r) {
              var a = U(r, n);
              a > -1 && (i[e] = r.slice(0, a).concat(r.slice(a + 1)));
            }
          }
        }
        function yt(t, e) {
          var n = vt(t, e);
          if (n.length) for (var i = Array.prototype.slice.call(arguments, 2), r = 0; r < n.length; ++r) n[r].apply(null, i);
        }
        function wt(t, e, n) {
          return "string" == typeof e && (e = {
            type: e,
            preventDefault: function preventDefault() {
              this.defaultPrevented = !0;
            }
          }), yt(t, n || e.type, t, e), Ot(e) || e.codemirrorIgnore;
        }
        function xt(t) {
          var e = t._handlers && t._handlers.cursorActivity;
          if (e) for (var n = t.curOp.cursorActivityHandlers || (t.curOp.cursorActivityHandlers = []), i = 0; i < e.length; ++i) -1 == U(n, e[i]) && n.push(e[i]);
        }
        function jt(t, e) {
          return vt(t, e).length > 0;
        }
        function Ct(t) {
          t.prototype.on = function (t, e) {
            mt(this, t, e);
          }, t.prototype.off = function (t, e) {
            bt(this, t, e);
          };
        }
        function Mt(t) {
          t.preventDefault ? t.preventDefault() : t.returnValue = !1;
        }
        function kt(t) {
          t.stopPropagation ? t.stopPropagation() : t.cancelBubble = !0;
        }
        function Ot(t) {
          return null != t.defaultPrevented ? t.defaultPrevented : 0 == t.returnValue;
        }
        function Tt(t) {
          Mt(t), kt(t);
        }
        function St(t) {
          return t.target || t.srcElement;
        }
        function Nt(t) {
          var e = t.which;
          return null == e && (1 & t.button ? e = 1 : 2 & t.button ? e = 3 : 4 & t.button && (e = 2)), y && t.ctrlKey && 1 == e && (e = 3), e;
        }
        var Lt,
          Dt,
          Et = function () {
            if (o && s < 9) return !1;
            var t = L("div");
            return "draggable" in t || "dragDrop" in t;
          }();
        function It(t) {
          if (null == Lt) {
            var e = L("span", "​");
            N(t, L("span", [e, document.createTextNode("x")])), 0 != t.firstChild.offsetHeight && (Lt = e.offsetWidth <= 1 && e.offsetHeight > 2 && !(o && s < 8));
          }
          var n = Lt ? L("span", "​") : L("span", " ", null, "display: inline-block; width: 1px; margin-right: -1px");
          return n.setAttribute("cm-text", ""), n;
        }
        function Pt(t) {
          if (null != Dt) return Dt;
          var e = N(t, document.createTextNode("AخA")),
            n = O(e, 0, 1).getBoundingClientRect(),
            i = O(e, 1, 2).getBoundingClientRect();
          return S(t), !(!n || n.left == n.right) && (Dt = i.right - n.right < 3);
        }
        var At,
          zt = 3 != "\n\nb".split(/\n/).length ? function (t) {
            for (var e = 0, n = [], i = t.length; e <= i;) {
              var r = t.indexOf("\n", e);
              -1 == r && (r = t.length);
              var a = t.slice(e, "\r" == t.charAt(r - 1) ? r - 1 : r),
                o = a.indexOf("\r");
              -1 != o ? (n.push(a.slice(0, o)), e += o + 1) : (n.push(a), e = r + 1);
            }
            return n;
          } : function (t) {
            return t.split(/\r\n?|\n/);
          },
          _t = window.getSelection ? function (t) {
            try {
              return t.selectionStart != t.selectionEnd;
            } catch (t) {
              return !1;
            }
          } : function (t) {
            var e;
            try {
              e = t.ownerDocument.selection.createRange();
            } catch (t) {}
            return !(!e || e.parentElement() != t) && 0 != e.compareEndPoints("StartToEnd", e);
          },
          Ht = "oncopy" in (At = L("div")) || (At.setAttribute("oncopy", "return;"), "function" == typeof At.oncopy),
          Vt = null,
          Ft = {},
          Rt = {};
        function Bt(t, e) {
          arguments.length > 2 && (e.dependencies = Array.prototype.slice.call(arguments, 2)), Ft[t] = e;
        }
        function Wt(t) {
          if ("string" == typeof t && Rt.hasOwnProperty(t)) t = Rt[t];else if (t && "string" == typeof t.name && Rt.hasOwnProperty(t.name)) {
            var e = Rt[t.name];
            "string" == typeof e && (e = {
              name: e
            }), (t = nt(e, t)).name = e.name;
          } else {
            if ("string" == typeof t && /^[\w\-]+\/[\w\-]+\+xml$/.test(t)) return Wt("application/xml");
            if ("string" == typeof t && /^[\w\-]+\/[\w\-]+\+json$/.test(t)) return Wt("application/json");
          }
          return "string" == typeof t ? {
            name: t
          } : t || {
            name: "null"
          };
        }
        function Yt(t, e) {
          e = Wt(e);
          var n = Ft[e.name];
          if (!n) return Yt(t, "text/plain");
          var i = n(t, e);
          if (Ut.hasOwnProperty(e.name)) {
            var r = Ut[e.name];
            for (var a in r) r.hasOwnProperty(a) && (i.hasOwnProperty(a) && (i["_" + a] = i[a]), i[a] = r[a]);
          }
          if (i.name = e.name, e.helperType && (i.helperType = e.helperType), e.modeProps) for (var o in e.modeProps) i[o] = e.modeProps[o];
          return i;
        }
        var Ut = {};
        function Zt(t, e) {
          B(e, Ut.hasOwnProperty(t) ? Ut[t] : Ut[t] = {});
        }
        function Gt(t, e) {
          if (!0 === e) return e;
          if (t.copyState) return t.copyState(e);
          var n = {};
          for (var i in e) {
            var r = e[i];
            r instanceof Array && (r = r.concat([])), n[i] = r;
          }
          return n;
        }
        function qt(t, e) {
          for (var n; t.innerMode && (n = t.innerMode(e)) && n.mode != t;) e = n.state, t = n.mode;
          return n || {
            mode: t,
            state: e
          };
        }
        function $t(t, e, n) {
          return !t.startState || t.startState(e, n);
        }
        var Qt = function Qt(t, e, n) {
          this.pos = this.start = 0, this.string = t, this.tabSize = e || 8, this.lastColumnPos = this.lastColumnValue = 0, this.lineStart = 0, this.lineOracle = n;
        };
        function Jt(t, e) {
          if ((e -= t.first) < 0 || e >= t.size) throw new Error("There is no line " + (e + t.first) + " in the document.");
          for (var n = t; !n.lines;) for (var i = 0;; ++i) {
            var r = n.children[i],
              a = r.chunkSize();
            if (e < a) {
              n = r;
              break;
            }
            e -= a;
          }
          return n.lines[e];
        }
        function Xt(t, e, n) {
          var i = [],
            r = e.line;
          return t.iter(e.line, n.line + 1, function (t) {
            var a = t.text;
            r == n.line && (a = a.slice(0, n.ch)), r == e.line && (a = a.slice(e.ch)), i.push(a), ++r;
          }), i;
        }
        function Kt(t, e, n) {
          var i = [];
          return t.iter(e, n, function (t) {
            i.push(t.text);
          }), i;
        }
        function te(t, e) {
          var n = e - t.height;
          if (n) for (var i = t; i; i = i.parent) i.height += n;
        }
        function ee(t) {
          if (null == t.parent) return null;
          for (var e = t.parent, n = U(e.lines, t), i = e.parent; i; e = i, i = i.parent) for (var r = 0; i.children[r] != e; ++r) n += i.children[r].chunkSize();
          return n + e.first;
        }
        function ne(t, e) {
          var n = t.first;
          t: do {
            for (var i = 0; i < t.children.length; ++i) {
              var r = t.children[i],
                a = r.height;
              if (e < a) {
                t = r;
                continue t;
              }
              e -= a, n += r.chunkSize();
            }
            return n;
          } while (!t.lines);
          for (var o = 0; o < t.lines.length; ++o) {
            var s = t.lines[o].height;
            if (e < s) break;
            e -= s;
          }
          return n + o;
        }
        function ie(t, e) {
          return e >= t.first && e < t.first + t.size;
        }
        function re(t, e) {
          return String(t.lineNumberFormatter(e + t.firstLineNumber));
        }
        function ae(t, e, n) {
          if (void 0 === n && (n = null), !(this instanceof ae)) return new ae(t, e, n);
          this.line = t, this.ch = e, this.sticky = n;
        }
        function oe(t, e) {
          return t.line - e.line || t.ch - e.ch;
        }
        function se(t, e) {
          return t.sticky == e.sticky && 0 == oe(t, e);
        }
        function le(t) {
          return ae(t.line, t.ch);
        }
        function ce(t, e) {
          return oe(t, e) < 0 ? e : t;
        }
        function de(t, e) {
          return oe(t, e) < 0 ? t : e;
        }
        function ue(t, e) {
          return Math.max(t.first, Math.min(e, t.first + t.size - 1));
        }
        function he(t, e) {
          if (e.line < t.first) return ae(t.first, 0);
          var n = t.first + t.size - 1;
          return e.line > n ? ae(n, Jt(t, n).text.length) : function (t, e) {
            var n = t.ch;
            return null == n || n > e ? ae(t.line, e) : n < 0 ? ae(t.line, 0) : t;
          }(e, Jt(t, e.line).text.length);
        }
        function pe(t, e) {
          for (var n = [], i = 0; i < e.length; i++) n[i] = he(t, e[i]);
          return n;
        }
        Qt.prototype.eol = function () {
          return this.pos >= this.string.length;
        }, Qt.prototype.sol = function () {
          return this.pos == this.lineStart;
        }, Qt.prototype.peek = function () {
          return this.string.charAt(this.pos) || void 0;
        }, Qt.prototype.next = function () {
          if (this.pos < this.string.length) return this.string.charAt(this.pos++);
        }, Qt.prototype.eat = function (t) {
          var e = this.string.charAt(this.pos);
          if ("string" == typeof t ? e == t : e && (t.test ? t.test(e) : t(e))) return ++this.pos, e;
        }, Qt.prototype.eatWhile = function (t) {
          for (var e = this.pos; this.eat(t););
          return this.pos > e;
        }, Qt.prototype.eatSpace = function () {
          for (var t = this.pos; /[\s\u00a0]/.test(this.string.charAt(this.pos));) ++this.pos;
          return this.pos > t;
        }, Qt.prototype.skipToEnd = function () {
          this.pos = this.string.length;
        }, Qt.prototype.skipTo = function (t) {
          var e = this.string.indexOf(t, this.pos);
          if (e > -1) return this.pos = e, !0;
        }, Qt.prototype.backUp = function (t) {
          this.pos -= t;
        }, Qt.prototype.column = function () {
          return this.lastColumnPos < this.start && (this.lastColumnValue = W(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue), this.lastColumnPos = this.start), this.lastColumnValue - (this.lineStart ? W(this.string, this.lineStart, this.tabSize) : 0);
        }, Qt.prototype.indentation = function () {
          return W(this.string, null, this.tabSize) - (this.lineStart ? W(this.string, this.lineStart, this.tabSize) : 0);
        }, Qt.prototype.match = function (t, e, n) {
          if ("string" != typeof t) {
            var i = this.string.slice(this.pos).match(t);
            return i && i.index > 0 ? null : (i && !1 !== e && (this.pos += i[0].length), i);
          }
          var r = function r(t) {
            return n ? t.toLowerCase() : t;
          };
          if (r(this.string.substr(this.pos, t.length)) == r(t)) return !1 !== e && (this.pos += t.length), !0;
        }, Qt.prototype.current = function () {
          return this.string.slice(this.start, this.pos);
        }, Qt.prototype.hideFirstChars = function (t, e) {
          this.lineStart += t;
          try {
            return e();
          } finally {
            this.lineStart -= t;
          }
        }, Qt.prototype.lookAhead = function (t) {
          var e = this.lineOracle;
          return e && e.lookAhead(t);
        }, Qt.prototype.baseToken = function () {
          var t = this.lineOracle;
          return t && t.baseToken(this.pos);
        };
        var ge = function ge(t, e) {
            this.state = t, this.lookAhead = e;
          },
          fe = function fe(t, e, n, i) {
            this.state = e, this.doc = t, this.line = n, this.maxLookAhead = i || 0, this.baseTokens = null, this.baseTokenPos = 1;
          };
        function me(t, e, n, i) {
          var r = [t.state.modeGen],
            a = {};
          ke(t, e.text, t.doc.mode, n, function (t, e) {
            return r.push(t, e);
          }, a, i);
          for (var o = n.state, s = function s(i) {
              n.baseTokens = r;
              var s = t.state.overlays[i],
                l = 1,
                c = 0;
              n.state = !0, ke(t, e.text, s.mode, n, function (t, e) {
                for (var n = l; c < t;) {
                  var i = r[l];
                  i > t && r.splice(l, 1, t, r[l + 1], i), l += 2, c = Math.min(t, i);
                }
                if (e) if (s.opaque) r.splice(n, l - n, t, "overlay " + e), l = n + 2;else for (; n < l; n += 2) {
                  var a = r[n + 1];
                  r[n + 1] = (a ? a + " " : "") + "overlay " + e;
                }
              }, a), n.state = o, n.baseTokens = null, n.baseTokenPos = 1;
            }, l = 0; l < t.state.overlays.length; ++l) s(l);
          return {
            styles: r,
            classes: a.bgClass || a.textClass ? a : null
          };
        }
        function ve(t, e, n) {
          if (!e.styles || e.styles[0] != t.state.modeGen) {
            var i = be(t, ee(e)),
              r = e.text.length > t.options.maxHighlightLength && Gt(t.doc.mode, i.state),
              a = me(t, e, i);
            r && (i.state = r), e.stateAfter = i.save(!r), e.styles = a.styles, a.classes ? e.styleClasses = a.classes : e.styleClasses && (e.styleClasses = null), n === t.doc.highlightFrontier && (t.doc.modeFrontier = Math.max(t.doc.modeFrontier, ++t.doc.highlightFrontier));
          }
          return e.styles;
        }
        function be(t, e, n) {
          var i = t.doc,
            r = t.display;
          if (!i.mode.startState) return new fe(i, !0, e);
          var a = function (t, e, n) {
              for (var i, r, a = t.doc, o = n ? -1 : e - (t.doc.mode.innerMode ? 1e3 : 100), s = e; s > o; --s) {
                if (s <= a.first) return a.first;
                var l = Jt(a, s - 1),
                  c = l.stateAfter;
                if (c && (!n || s + (c instanceof ge ? c.lookAhead : 0) <= a.modeFrontier)) return s;
                var d = W(l.text, null, t.options.tabSize);
                (null == r || i > d) && (r = s - 1, i = d);
              }
              return r;
            }(t, e, n),
            o = a > i.first && Jt(i, a - 1).stateAfter,
            s = o ? fe.fromSaved(i, o, a) : new fe(i, $t(i.mode), a);
          return i.iter(a, e, function (n) {
            ye(t, n.text, s);
            var i = s.line;
            n.stateAfter = i == e - 1 || i % 5 == 0 || i >= r.viewFrom && i < r.viewTo ? s.save() : null, s.nextLine();
          }), n && (i.modeFrontier = s.line), s;
        }
        function ye(t, e, n, i) {
          var r = t.doc.mode,
            a = new Qt(e, t.options.tabSize, n);
          for (a.start = a.pos = i || 0, "" == e && we(r, n.state); !a.eol();) xe(r, a, n.state), a.start = a.pos;
        }
        function we(t, e) {
          if (t.blankLine) return t.blankLine(e);
          if (t.innerMode) {
            var n = qt(t, e);
            return n.mode.blankLine ? n.mode.blankLine(n.state) : void 0;
          }
        }
        function xe(t, e, n, i) {
          for (var r = 0; r < 10; r++) {
            i && (i[0] = qt(t, n).mode);
            var a = t.token(e, n);
            if (e.pos > e.start) return a;
          }
          throw new Error("Mode " + t.name + " failed to advance stream.");
        }
        fe.prototype.lookAhead = function (t) {
          var e = this.doc.getLine(this.line + t);
          return null != e && t > this.maxLookAhead && (this.maxLookAhead = t), e;
        }, fe.prototype.baseToken = function (t) {
          if (!this.baseTokens) return null;
          for (; this.baseTokens[this.baseTokenPos] <= t;) this.baseTokenPos += 2;
          var e = this.baseTokens[this.baseTokenPos + 1];
          return {
            type: e && e.replace(/( |^)overlay .*/, ""),
            size: this.baseTokens[this.baseTokenPos] - t
          };
        }, fe.prototype.nextLine = function () {
          this.line++, this.maxLookAhead > 0 && this.maxLookAhead--;
        }, fe.fromSaved = function (t, e, n) {
          return e instanceof ge ? new fe(t, Gt(t.mode, e.state), n, e.lookAhead) : new fe(t, Gt(t.mode, e), n);
        }, fe.prototype.save = function (t) {
          var e = !1 !== t ? Gt(this.doc.mode, this.state) : this.state;
          return this.maxLookAhead > 0 ? new ge(e, this.maxLookAhead) : e;
        };
        var je = function je(t, e, n) {
          this.start = t.start, this.end = t.pos, this.string = t.current(), this.type = e || null, this.state = n;
        };
        function Ce(t, e, n, i) {
          var r,
            a,
            o = t.doc,
            s = o.mode,
            l = Jt(o, (e = he(o, e)).line),
            c = be(t, e.line, n),
            d = new Qt(l.text, t.options.tabSize, c);
          for (i && (a = []); (i || d.pos < e.ch) && !d.eol();) d.start = d.pos, r = xe(s, d, c.state), i && a.push(new je(d, r, Gt(o.mode, c.state)));
          return i ? a : new je(d, r, c.state);
        }
        function Me(t, e) {
          if (t) for (;;) {
            var n = t.match(/(?:^|\s+)line-(background-)?(\S+)/);
            if (!n) break;
            t = t.slice(0, n.index) + t.slice(n.index + n[0].length);
            var i = n[1] ? "bgClass" : "textClass";
            null == e[i] ? e[i] = n[2] : new RegExp("(?:^|\\s)" + n[2] + "(?:$|\\s)").test(e[i]) || (e[i] += " " + n[2]);
          }
          return t;
        }
        function ke(t, e, n, i, r, a, o) {
          var s = n.flattenSpans;
          null == s && (s = t.options.flattenSpans);
          var l,
            c = 0,
            d = null,
            u = new Qt(e, t.options.tabSize, i),
            h = t.options.addModeClass && [null];
          for ("" == e && Me(we(n, i.state), a); !u.eol();) {
            if (u.pos > t.options.maxHighlightLength ? (s = !1, o && ye(t, e, i, u.pos), u.pos = e.length, l = null) : l = Me(xe(n, u, i.state, h), a), h) {
              var p = h[0].name;
              p && (l = "m-" + (l ? p + " " + l : p));
            }
            if (!s || d != l) {
              for (; c < u.start;) r(c = Math.min(u.start, c + 5e3), d);
              d = l;
            }
            u.start = u.pos;
          }
          for (; c < u.pos;) {
            var g = Math.min(u.pos, c + 5e3);
            r(g, d), c = g;
          }
        }
        var Oe = !1,
          Te = !1;
        function Se(t, e, n) {
          this.marker = t, this.from = e, this.to = n;
        }
        function Ne(t, e) {
          if (t) for (var n = 0; n < t.length; ++n) {
            var i = t[n];
            if (i.marker == e) return i;
          }
        }
        function Le(t, e) {
          for (var n, i = 0; i < t.length; ++i) t[i] != e && (n || (n = [])).push(t[i]);
          return n;
        }
        function De(t, e) {
          if (e.full) return null;
          var n = ie(t, e.from.line) && Jt(t, e.from.line).markedSpans,
            i = ie(t, e.to.line) && Jt(t, e.to.line).markedSpans;
          if (!n && !i) return null;
          var r = e.from.ch,
            a = e.to.ch,
            o = 0 == oe(e.from, e.to),
            s = function (t, e, n) {
              var i;
              if (t) for (var r = 0; r < t.length; ++r) {
                var a = t[r],
                  o = a.marker;
                if (null == a.from || (o.inclusiveLeft ? a.from <= e : a.from < e) || a.from == e && "bookmark" == o.type && (!n || !a.marker.insertLeft)) {
                  var s = null == a.to || (o.inclusiveRight ? a.to >= e : a.to > e);
                  (i || (i = [])).push(new Se(o, a.from, s ? null : a.to));
                }
              }
              return i;
            }(n, r, o),
            l = function (t, e, n) {
              var i;
              if (t) for (var r = 0; r < t.length; ++r) {
                var a = t[r],
                  o = a.marker;
                if (null == a.to || (o.inclusiveRight ? a.to >= e : a.to > e) || a.from == e && "bookmark" == o.type && (!n || a.marker.insertLeft)) {
                  var s = null == a.from || (o.inclusiveLeft ? a.from <= e : a.from < e);
                  (i || (i = [])).push(new Se(o, s ? null : a.from - e, null == a.to ? null : a.to - e));
                }
              }
              return i;
            }(i, a, o),
            c = 1 == e.text.length,
            d = K(e.text).length + (c ? r : 0);
          if (s) for (var u = 0; u < s.length; ++u) {
            var h = s[u];
            if (null == h.to) {
              var p = Ne(l, h.marker);
              p ? c && (h.to = null == p.to ? null : p.to + d) : h.to = r;
            }
          }
          if (l) for (var g = 0; g < l.length; ++g) {
            var f = l[g];
            null != f.to && (f.to += d), null == f.from ? Ne(s, f.marker) || (f.from = d, c && (s || (s = [])).push(f)) : (f.from += d, c && (s || (s = [])).push(f));
          }
          s && (s = Ee(s)), l && l != s && (l = Ee(l));
          var m = [s];
          if (!c) {
            var v,
              b = e.text.length - 2;
            if (b > 0 && s) for (var y = 0; y < s.length; ++y) null == s[y].to && (v || (v = [])).push(new Se(s[y].marker, null, null));
            for (var w = 0; w < b; ++w) m.push(v);
            m.push(l);
          }
          return m;
        }
        function Ee(t) {
          for (var e = 0; e < t.length; ++e) {
            var n = t[e];
            null != n.from && n.from == n.to && !1 !== n.marker.clearWhenEmpty && t.splice(e--, 1);
          }
          return t.length ? t : null;
        }
        function Ie(t) {
          var e = t.markedSpans;
          if (e) {
            for (var n = 0; n < e.length; ++n) e[n].marker.detachLine(t);
            t.markedSpans = null;
          }
        }
        function Pe(t, e) {
          if (e) {
            for (var n = 0; n < e.length; ++n) e[n].marker.attachLine(t);
            t.markedSpans = e;
          }
        }
        function Ae(t) {
          return t.inclusiveLeft ? -1 : 0;
        }
        function ze(t) {
          return t.inclusiveRight ? 1 : 0;
        }
        function _e(t, e) {
          var n = t.lines.length - e.lines.length;
          if (0 != n) return n;
          var i = t.find(),
            r = e.find(),
            a = oe(i.from, r.from) || Ae(t) - Ae(e);
          return a ? -a : oe(i.to, r.to) || ze(t) - ze(e) || e.id - t.id;
        }
        function He(t, e) {
          var n,
            i = Te && t.markedSpans;
          if (i) for (var r = void 0, a = 0; a < i.length; ++a) (r = i[a]).marker.collapsed && null == (e ? r.from : r.to) && (!n || _e(n, r.marker) < 0) && (n = r.marker);
          return n;
        }
        function Ve(t) {
          return He(t, !0);
        }
        function Fe(t) {
          return He(t, !1);
        }
        function Re(t, e) {
          var n,
            i = Te && t.markedSpans;
          if (i) for (var r = 0; r < i.length; ++r) {
            var a = i[r];
            a.marker.collapsed && (null == a.from || a.from < e) && (null == a.to || a.to > e) && (!n || _e(n, a.marker) < 0) && (n = a.marker);
          }
          return n;
        }
        function Be(t, e, n, i, r) {
          var a = Jt(t, e),
            o = Te && a.markedSpans;
          if (o) for (var s = 0; s < o.length; ++s) {
            var l = o[s];
            if (l.marker.collapsed) {
              var c = l.marker.find(0),
                d = oe(c.from, n) || Ae(l.marker) - Ae(r),
                u = oe(c.to, i) || ze(l.marker) - ze(r);
              if (!(d >= 0 && u <= 0 || d <= 0 && u >= 0) && (d <= 0 && (l.marker.inclusiveRight && r.inclusiveLeft ? oe(c.to, n) >= 0 : oe(c.to, n) > 0) || d >= 0 && (l.marker.inclusiveRight && r.inclusiveLeft ? oe(c.from, i) <= 0 : oe(c.from, i) < 0))) return !0;
            }
          }
        }
        function We(t) {
          for (var e; e = Ve(t);) t = e.find(-1, !0).line;
          return t;
        }
        function Ye(t, e) {
          var n = Jt(t, e),
            i = We(n);
          return n == i ? e : ee(i);
        }
        function Ue(t, e) {
          if (e > t.lastLine()) return e;
          var n,
            i = Jt(t, e);
          if (!Ze(t, i)) return e;
          for (; n = Fe(i);) i = n.find(1, !0).line;
          return ee(i) + 1;
        }
        function Ze(t, e) {
          var n = Te && e.markedSpans;
          if (n) for (var i = void 0, r = 0; r < n.length; ++r) if ((i = n[r]).marker.collapsed) {
            if (null == i.from) return !0;
            if (!i.marker.widgetNode && 0 == i.from && i.marker.inclusiveLeft && Ge(t, e, i)) return !0;
          }
        }
        function Ge(t, e, n) {
          if (null == n.to) {
            var i = n.marker.find(1, !0);
            return Ge(t, i.line, Ne(i.line.markedSpans, n.marker));
          }
          if (n.marker.inclusiveRight && n.to == e.text.length) return !0;
          for (var r = void 0, a = 0; a < e.markedSpans.length; ++a) if ((r = e.markedSpans[a]).marker.collapsed && !r.marker.widgetNode && r.from == n.to && (null == r.to || r.to != n.from) && (r.marker.inclusiveLeft || n.marker.inclusiveRight) && Ge(t, e, r)) return !0;
        }
        function qe(t) {
          for (var e = 0, n = (t = We(t)).parent, i = 0; i < n.lines.length; ++i) {
            var r = n.lines[i];
            if (r == t) break;
            e += r.height;
          }
          for (var a = n.parent; a; a = (n = a).parent) for (var o = 0; o < a.children.length; ++o) {
            var s = a.children[o];
            if (s == n) break;
            e += s.height;
          }
          return e;
        }
        function $e(t) {
          if (0 == t.height) return 0;
          for (var e, n = t.text.length, i = t; e = Ve(i);) {
            var r = e.find(0, !0);
            i = r.from.line, n += r.from.ch - r.to.ch;
          }
          for (i = t; e = Fe(i);) {
            var a = e.find(0, !0);
            n -= i.text.length - a.from.ch, n += (i = a.to.line).text.length - a.to.ch;
          }
          return n;
        }
        function Qe(t) {
          var e = t.display,
            n = t.doc;
          e.maxLine = Jt(n, n.first), e.maxLineLength = $e(e.maxLine), e.maxLineChanged = !0, n.iter(function (t) {
            var n = $e(t);
            n > e.maxLineLength && (e.maxLineLength = n, e.maxLine = t);
          });
        }
        var Je = function Je(t, e, n) {
          this.text = t, Pe(this, e), this.height = n ? n(this) : 1;
        };
        function Xe(t) {
          t.parent = null, Ie(t);
        }
        Je.prototype.lineNo = function () {
          return ee(this);
        }, Ct(Je);
        var Ke = {},
          tn = {};
        function en(t, e) {
          if (!t || /^\s*$/.test(t)) return null;
          var n = e.addModeClass ? tn : Ke;
          return n[t] || (n[t] = t.replace(/\S+/g, "cm-$&"));
        }
        function nn(t, e) {
          var n = D("span", null, null, l ? "padding-right: .1px" : null),
            i = {
              pre: D("pre", [n], "CodeMirror-line"),
              content: n,
              col: 0,
              pos: 0,
              cm: t,
              trailingSpace: !1,
              splitSpaces: t.getOption("lineWrapping")
            };
          e.measure = {};
          for (var r = 0; r <= (e.rest ? e.rest.length : 0); r++) {
            var a = r ? e.rest[r - 1] : e.line,
              o = void 0;
            i.pos = 0, i.addToken = an, Pt(t.display.measure) && (o = gt(a, t.doc.direction)) && (i.addToken = on(i.addToken, o)), i.map = [], ln(a, i, ve(t, a, e != t.display.externalMeasured && ee(a))), a.styleClasses && (a.styleClasses.bgClass && (i.bgClass = A(a.styleClasses.bgClass, i.bgClass || "")), a.styleClasses.textClass && (i.textClass = A(a.styleClasses.textClass, i.textClass || ""))), 0 == i.map.length && i.map.push(0, 0, i.content.appendChild(It(t.display.measure))), 0 == r ? (e.measure.map = i.map, e.measure.cache = {}) : ((e.measure.maps || (e.measure.maps = [])).push(i.map), (e.measure.caches || (e.measure.caches = [])).push({}));
          }
          if (l) {
            var s = i.content.lastChild;
            (/\bcm-tab\b/.test(s.className) || s.querySelector && s.querySelector(".cm-tab")) && (i.content.className = "cm-tab-wrap-hack");
          }
          return yt(t, "renderLine", t, e.line, i.pre), i.pre.className && (i.textClass = A(i.pre.className, i.textClass || "")), i;
        }
        function rn(t) {
          var e = L("span", "•", "cm-invalidchar");
          return e.title = "\\u" + t.charCodeAt(0).toString(16), e.setAttribute("aria-label", e.title), e;
        }
        function an(t, e, n, i, r, a, l) {
          if (e) {
            var c,
              d = t.splitSpaces ? function (t, e) {
                if (t.length > 1 && !/  /.test(t)) return t;
                for (var n = e, i = "", r = 0; r < t.length; r++) {
                  var a = t.charAt(r);
                  " " != a || !n || r != t.length - 1 && 32 != t.charCodeAt(r + 1) || (a = " "), i += a, n = " " == a;
                }
                return i;
              }(e, t.trailingSpace) : e,
              u = t.cm.state.specialChars,
              h = !1;
            if (u.test(e)) {
              c = document.createDocumentFragment();
              for (var p = 0;;) {
                u.lastIndex = p;
                var g = u.exec(e),
                  f = g ? g.index - p : e.length - p;
                if (f) {
                  var m = document.createTextNode(d.slice(p, p + f));
                  o && s < 9 ? c.appendChild(L("span", [m])) : c.appendChild(m), t.map.push(t.pos, t.pos + f, m), t.col += f, t.pos += f;
                }
                if (!g) break;
                p += f + 1;
                var v = void 0;
                if ("\t" == g[0]) {
                  var b = t.cm.options.tabSize,
                    y = b - t.col % b;
                  (v = c.appendChild(L("span", X(y), "cm-tab"))).setAttribute("role", "presentation"), v.setAttribute("cm-text", "\t"), t.col += y;
                } else "\r" == g[0] || "\n" == g[0] ? ((v = c.appendChild(L("span", "\r" == g[0] ? "␍" : "␤", "cm-invalidchar"))).setAttribute("cm-text", g[0]), t.col += 1) : ((v = t.cm.options.specialCharPlaceholder(g[0])).setAttribute("cm-text", g[0]), o && s < 9 ? c.appendChild(L("span", [v])) : c.appendChild(v), t.col += 1);
                t.map.push(t.pos, t.pos + 1, v), t.pos++;
              }
            } else t.col += e.length, c = document.createTextNode(d), t.map.push(t.pos, t.pos + e.length, c), o && s < 9 && (h = !0), t.pos += e.length;
            if (t.trailingSpace = 32 == d.charCodeAt(e.length - 1), n || i || r || h || a || l) {
              var w = n || "";
              i && (w += i), r && (w += r);
              var x = L("span", [c], w, a);
              if (l) for (var j in l) l.hasOwnProperty(j) && "style" != j && "class" != j && x.setAttribute(j, l[j]);
              return t.content.appendChild(x);
            }
            t.content.appendChild(c);
          }
        }
        function on(t, e) {
          return function (n, i, r, a, o, s, l) {
            r = r ? r + " cm-force-border" : "cm-force-border";
            for (var c = n.pos, d = c + i.length;;) {
              for (var u = void 0, h = 0; h < e.length && !((u = e[h]).to > c && u.from <= c); h++);
              if (u.to >= d) return t(n, i, r, a, o, s, l);
              t(n, i.slice(0, u.to - c), r, a, null, s, l), a = null, i = i.slice(u.to - c), c = u.to;
            }
          };
        }
        function sn(t, e, n, i) {
          var r = !i && n.widgetNode;
          r && t.map.push(t.pos, t.pos + e, r), !i && t.cm.display.input.needsContentAttribute && (r || (r = t.content.appendChild(document.createElement("span"))), r.setAttribute("cm-marker", n.id)), r && (t.cm.display.input.setUneditable(r), t.content.appendChild(r)), t.pos += e, t.trailingSpace = !1;
        }
        function ln(t, e, n) {
          var i = t.markedSpans,
            r = t.text,
            a = 0;
          if (i) for (var o, s, l, c, d, u, h, p = r.length, g = 0, f = 1, m = "", v = 0;;) {
            if (v == g) {
              l = c = d = s = "", h = null, u = null, v = 1 / 0;
              for (var b = [], y = void 0, w = 0; w < i.length; ++w) {
                var x = i[w],
                  j = x.marker;
                if ("bookmark" == j.type && x.from == g && j.widgetNode) b.push(j);else if (x.from <= g && (null == x.to || x.to > g || j.collapsed && x.to == g && x.from == g)) {
                  if (null != x.to && x.to != g && v > x.to && (v = x.to, c = ""), j.className && (l += " " + j.className), j.css && (s = (s ? s + ";" : "") + j.css), j.startStyle && x.from == g && (d += " " + j.startStyle), j.endStyle && x.to == v && (y || (y = [])).push(j.endStyle, x.to), j.title && ((h || (h = {})).title = j.title), j.attributes) for (var C in j.attributes) (h || (h = {}))[C] = j.attributes[C];
                  j.collapsed && (!u || _e(u.marker, j) < 0) && (u = x);
                } else x.from > g && v > x.from && (v = x.from);
              }
              if (y) for (var M = 0; M < y.length; M += 2) y[M + 1] == v && (c += " " + y[M]);
              if (!u || u.from == g) for (var k = 0; k < b.length; ++k) sn(e, 0, b[k]);
              if (u && (u.from || 0) == g) {
                if (sn(e, (null == u.to ? p + 1 : u.to) - g, u.marker, null == u.from), null == u.to) return;
                u.to == g && (u = !1);
              }
            }
            if (g >= p) break;
            for (var O = Math.min(p, v);;) {
              if (m) {
                var T = g + m.length;
                if (!u) {
                  var S = T > O ? m.slice(0, O - g) : m;
                  e.addToken(e, S, o ? o + l : l, d, g + S.length == v ? c : "", s, h);
                }
                if (T >= O) {
                  m = m.slice(O - g), g = O;
                  break;
                }
                g = T, d = "";
              }
              m = r.slice(a, a = n[f++]), o = en(n[f++], e.cm.options);
            }
          } else for (var N = 1; N < n.length; N += 2) e.addToken(e, r.slice(a, a = n[N]), en(n[N + 1], e.cm.options));
        }
        function cn(t, e, n) {
          this.line = e, this.rest = function (t) {
            for (var e, n; e = Fe(t);) t = e.find(1, !0).line, (n || (n = [])).push(t);
            return n;
          }(e), this.size = this.rest ? ee(K(this.rest)) - n + 1 : 1, this.node = this.text = null, this.hidden = Ze(t, e);
        }
        function dn(t, e, n) {
          for (var i, r = [], a = e; a < n; a = i) {
            var o = new cn(t.doc, Jt(t.doc, a), a);
            i = a + o.size, r.push(o);
          }
          return r;
        }
        var un = null,
          hn = null;
        function pn(t, e) {
          var n = vt(t, e);
          if (n.length) {
            var i,
              r = Array.prototype.slice.call(arguments, 2);
            un ? i = un.delayedCallbacks : hn ? i = hn : (i = hn = [], setTimeout(gn, 0));
            for (var a = function a(t) {
                i.push(function () {
                  return n[t].apply(null, r);
                });
              }, o = 0; o < n.length; ++o) a(o);
          }
        }
        function gn() {
          var t = hn;
          hn = null;
          for (var e = 0; e < t.length; ++e) t[e]();
        }
        function fn(t, e, n, i) {
          for (var r = 0; r < e.changes.length; r++) {
            var a = e.changes[r];
            "text" == a ? bn(t, e) : "gutter" == a ? wn(t, e, n, i) : "class" == a ? yn(t, e) : "widget" == a && xn(t, e, i);
          }
          e.changes = null;
        }
        function mn(t) {
          return t.node == t.text && (t.node = L("div", null, null, "position: relative"), t.text.parentNode && t.text.parentNode.replaceChild(t.node, t.text), t.node.appendChild(t.text), o && s < 8 && (t.node.style.zIndex = 2)), t.node;
        }
        function vn(t, e) {
          var n = t.display.externalMeasured;
          return n && n.line == e.line ? (t.display.externalMeasured = null, e.measure = n.measure, n.built) : nn(t, e);
        }
        function bn(t, e) {
          var n = e.text.className,
            i = vn(t, e);
          e.text == e.node && (e.node = i.pre), e.text.parentNode.replaceChild(i.pre, e.text), e.text = i.pre, i.bgClass != e.bgClass || i.textClass != e.textClass ? (e.bgClass = i.bgClass, e.textClass = i.textClass, yn(t, e)) : n && (e.text.className = n);
        }
        function yn(t, e) {
          !function (t, e) {
            var n = e.bgClass ? e.bgClass + " " + (e.line.bgClass || "") : e.line.bgClass;
            if (n && (n += " CodeMirror-linebackground"), e.background) n ? e.background.className = n : (e.background.parentNode.removeChild(e.background), e.background = null);else if (n) {
              var i = mn(e);
              e.background = i.insertBefore(L("div", null, n), i.firstChild), t.display.input.setUneditable(e.background);
            }
          }(t, e), e.line.wrapClass ? mn(e).className = e.line.wrapClass : e.node != e.text && (e.node.className = "");
          var n = e.textClass ? e.textClass + " " + (e.line.textClass || "") : e.line.textClass;
          e.text.className = n || "";
        }
        function wn(t, e, n, i) {
          if (e.gutter && (e.node.removeChild(e.gutter), e.gutter = null), e.gutterBackground && (e.node.removeChild(e.gutterBackground), e.gutterBackground = null), e.line.gutterClass) {
            var r = mn(e);
            e.gutterBackground = L("div", null, "CodeMirror-gutter-background " + e.line.gutterClass, "left: " + (t.options.fixedGutter ? i.fixedPos : -i.gutterTotalWidth) + "px; width: " + i.gutterTotalWidth + "px"), t.display.input.setUneditable(e.gutterBackground), r.insertBefore(e.gutterBackground, e.text);
          }
          var a = e.line.gutterMarkers;
          if (t.options.lineNumbers || a) {
            var o = mn(e),
              s = e.gutter = L("div", null, "CodeMirror-gutter-wrapper", "left: " + (t.options.fixedGutter ? i.fixedPos : -i.gutterTotalWidth) + "px");
            if (s.setAttribute("aria-hidden", "true"), t.display.input.setUneditable(s), o.insertBefore(s, e.text), e.line.gutterClass && (s.className += " " + e.line.gutterClass), !t.options.lineNumbers || a && a["CodeMirror-linenumbers"] || (e.lineNumber = s.appendChild(L("div", re(t.options, n), "CodeMirror-linenumber CodeMirror-gutter-elt", "left: " + i.gutterLeft["CodeMirror-linenumbers"] + "px; width: " + t.display.lineNumInnerWidth + "px"))), a) for (var l = 0; l < t.display.gutterSpecs.length; ++l) {
              var c = t.display.gutterSpecs[l].className,
                d = a.hasOwnProperty(c) && a[c];
              d && s.appendChild(L("div", [d], "CodeMirror-gutter-elt", "left: " + i.gutterLeft[c] + "px; width: " + i.gutterWidth[c] + "px"));
            }
          }
        }
        function xn(t, e, n) {
          e.alignable && (e.alignable = null);
          for (var i = k("CodeMirror-linewidget"), r = e.node.firstChild, a = void 0; r; r = a) a = r.nextSibling, i.test(r.className) && e.node.removeChild(r);
          Cn(t, e, n);
        }
        function jn(t, e, n, i) {
          var r = vn(t, e);
          return e.text = e.node = r.pre, r.bgClass && (e.bgClass = r.bgClass), r.textClass && (e.textClass = r.textClass), yn(t, e), wn(t, e, n, i), Cn(t, e, i), e.node;
        }
        function Cn(t, e, n) {
          if (Mn(t, e.line, e, n, !0), e.rest) for (var i = 0; i < e.rest.length; i++) Mn(t, e.rest[i], e, n, !1);
        }
        function Mn(t, e, n, i, r) {
          if (e.widgets) for (var a = mn(n), o = 0, s = e.widgets; o < s.length; ++o) {
            var l = s[o],
              c = L("div", [l.node], "CodeMirror-linewidget" + (l.className ? " " + l.className : ""));
            l.handleMouseEvents || c.setAttribute("cm-ignore-events", "true"), kn(l, c, n, i), t.display.input.setUneditable(c), r && l.above ? a.insertBefore(c, n.gutter || n.text) : a.appendChild(c), pn(l, "redraw");
          }
        }
        function kn(t, e, n, i) {
          if (t.noHScroll) {
            (n.alignable || (n.alignable = [])).push(e);
            var r = i.wrapperWidth;
            e.style.left = i.fixedPos + "px", t.coverGutter || (r -= i.gutterTotalWidth, e.style.paddingLeft = i.gutterTotalWidth + "px"), e.style.width = r + "px";
          }
          t.coverGutter && (e.style.zIndex = 5, e.style.position = "relative", t.noHScroll || (e.style.marginLeft = -i.gutterTotalWidth + "px"));
        }
        function On(t) {
          if (null != t.height) return t.height;
          var e = t.doc.cm;
          if (!e) return 0;
          if (!E(document.body, t.node)) {
            var n = "position: relative;";
            t.coverGutter && (n += "margin-left: -" + e.display.gutters.offsetWidth + "px;"), t.noHScroll && (n += "width: " + e.display.wrapper.clientWidth + "px;"), N(e.display.measure, L("div", [t.node], null, n));
          }
          return t.height = t.node.parentNode.offsetHeight;
        }
        function Tn(t, e) {
          for (var n = St(e); n != t.wrapper; n = n.parentNode) if (!n || 1 == n.nodeType && "true" == n.getAttribute("cm-ignore-events") || n.parentNode == t.sizer && n != t.mover) return !0;
        }
        function Sn(t) {
          return t.lineSpace.offsetTop;
        }
        function Nn(t) {
          return t.mover.offsetHeight - t.lineSpace.offsetHeight;
        }
        function Ln(t) {
          if (t.cachedPaddingH) return t.cachedPaddingH;
          var e = N(t.measure, L("pre", "x", "CodeMirror-line-like")),
            n = window.getComputedStyle ? window.getComputedStyle(e) : e.currentStyle,
            i = {
              left: parseInt(n.paddingLeft),
              right: parseInt(n.paddingRight)
            };
          return isNaN(i.left) || isNaN(i.right) || (t.cachedPaddingH = i), i;
        }
        function Dn(t) {
          return 50 - t.display.nativeBarWidth;
        }
        function En(t) {
          return t.display.scroller.clientWidth - Dn(t) - t.display.barWidth;
        }
        function In(t) {
          return t.display.scroller.clientHeight - Dn(t) - t.display.barHeight;
        }
        function Pn(t, e, n) {
          if (t.line == e) return {
            map: t.measure.map,
            cache: t.measure.cache
          };
          if (t.rest) {
            for (var i = 0; i < t.rest.length; i++) if (t.rest[i] == e) return {
              map: t.measure.maps[i],
              cache: t.measure.caches[i]
            };
            for (var r = 0; r < t.rest.length; r++) if (ee(t.rest[r]) > n) return {
              map: t.measure.maps[r],
              cache: t.measure.caches[r],
              before: !0
            };
          }
        }
        function An(t, e, n, i) {
          return Hn(t, _n(t, e), n, i);
        }
        function zn(t, e) {
          if (e >= t.display.viewFrom && e < t.display.viewTo) return t.display.view[fi(t, e)];
          var n = t.display.externalMeasured;
          return n && e >= n.lineN && e < n.lineN + n.size ? n : void 0;
        }
        function _n(t, e) {
          var n = ee(e),
            i = zn(t, n);
          i && !i.text ? i = null : i && i.changes && (fn(t, i, n, di(t)), t.curOp.forceUpdate = !0), i || (i = function (t, e) {
            var n = ee(e = We(e)),
              i = t.display.externalMeasured = new cn(t.doc, e, n);
            i.lineN = n;
            var r = i.built = nn(t, i);
            return i.text = r.pre, N(t.display.lineMeasure, r.pre), i;
          }(t, e));
          var r = Pn(i, e, n);
          return {
            line: e,
            view: i,
            rect: null,
            map: r.map,
            cache: r.cache,
            before: r.before,
            hasHeights: !1
          };
        }
        function Hn(t, e, n, i, r) {
          e.before && (n = -1);
          var a,
            l = n + (i || "");
          return e.cache.hasOwnProperty(l) ? a = e.cache[l] : (e.rect || (e.rect = e.view.text.getBoundingClientRect()), e.hasHeights || (function (t, e, n) {
            var i = t.options.lineWrapping,
              r = i && En(t);
            if (!e.measure.heights || i && e.measure.width != r) {
              var a = e.measure.heights = [];
              if (i) {
                e.measure.width = r;
                for (var o = e.text.firstChild.getClientRects(), s = 0; s < o.length - 1; s++) {
                  var l = o[s],
                    c = o[s + 1];
                  Math.abs(l.bottom - c.bottom) > 2 && a.push((l.bottom + c.top) / 2 - n.top);
                }
              }
              a.push(n.bottom - n.top);
            }
          }(t, e.view, e.rect), e.hasHeights = !0), (a = function (t, e, n, i) {
            var r,
              a = Rn(e.map, n, i),
              l = a.node,
              c = a.start,
              d = a.end,
              u = a.collapse;
            if (3 == l.nodeType) {
              for (var h = 0; h < 4; h++) {
                for (; c && lt(e.line.text.charAt(a.coverStart + c));) --c;
                for (; a.coverStart + d < a.coverEnd && lt(e.line.text.charAt(a.coverStart + d));) ++d;
                if ((r = o && s < 9 && 0 == c && d == a.coverEnd - a.coverStart ? l.parentNode.getBoundingClientRect() : Bn(O(l, c, d).getClientRects(), i)).left || r.right || 0 == c) break;
                d = c, c -= 1, u = "right";
              }
              o && s < 11 && (r = function (t, e) {
                if (!window.screen || null == screen.logicalXDPI || screen.logicalXDPI == screen.deviceXDPI || !function (t) {
                  if (null != Vt) return Vt;
                  var e = N(t, L("span", "x")),
                    n = e.getBoundingClientRect(),
                    i = O(e, 0, 1).getBoundingClientRect();
                  return Vt = Math.abs(n.left - i.left) > 1;
                }(t)) return e;
                var n = screen.logicalXDPI / screen.deviceXDPI,
                  i = screen.logicalYDPI / screen.deviceYDPI;
                return {
                  left: e.left * n,
                  right: e.right * n,
                  top: e.top * i,
                  bottom: e.bottom * i
                };
              }(t.display.measure, r));
            } else {
              var p;
              c > 0 && (u = i = "right"), r = t.options.lineWrapping && (p = l.getClientRects()).length > 1 ? p["right" == i ? p.length - 1 : 0] : l.getBoundingClientRect();
            }
            if (o && s < 9 && !c && (!r || !r.left && !r.right)) {
              var g = l.parentNode.getClientRects()[0];
              r = g ? {
                left: g.left,
                right: g.left + ci(t.display),
                top: g.top,
                bottom: g.bottom
              } : Fn;
            }
            for (var f = r.top - e.rect.top, m = r.bottom - e.rect.top, v = (f + m) / 2, b = e.view.measure.heights, y = 0; y < b.length - 1 && !(v < b[y]); y++);
            var w = y ? b[y - 1] : 0,
              x = b[y],
              j = {
                left: ("right" == u ? r.right : r.left) - e.rect.left,
                right: ("left" == u ? r.left : r.right) - e.rect.left,
                top: w,
                bottom: x
              };
            return r.left || r.right || (j.bogus = !0), t.options.singleCursorHeightPerLine || (j.rtop = f, j.rbottom = m), j;
          }(t, e, n, i)).bogus || (e.cache[l] = a)), {
            left: a.left,
            right: a.right,
            top: r ? a.rtop : a.top,
            bottom: r ? a.rbottom : a.bottom
          };
        }
        var Vn,
          Fn = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
          };
        function Rn(t, e, n) {
          for (var i, r, a, o, s, l, c = 0; c < t.length; c += 3) if (s = t[c], l = t[c + 1], e < s ? (r = 0, a = 1, o = "left") : e < l ? a = 1 + (r = e - s) : (c == t.length - 3 || e == l && t[c + 3] > e) && (r = (a = l - s) - 1, e >= l && (o = "right")), null != r) {
            if (i = t[c + 2], s == l && n == (i.insertLeft ? "left" : "right") && (o = n), "left" == n && 0 == r) for (; c && t[c - 2] == t[c - 3] && t[c - 1].insertLeft;) i = t[2 + (c -= 3)], o = "left";
            if ("right" == n && r == l - s) for (; c < t.length - 3 && t[c + 3] == t[c + 4] && !t[c + 5].insertLeft;) i = t[(c += 3) + 2], o = "right";
            break;
          }
          return {
            node: i,
            start: r,
            end: a,
            collapse: o,
            coverStart: s,
            coverEnd: l
          };
        }
        function Bn(t, e) {
          var n = Fn;
          if ("left" == e) for (var i = 0; i < t.length && (n = t[i]).left == n.right; i++);else for (var r = t.length - 1; r >= 0 && (n = t[r]).left == n.right; r--);
          return n;
        }
        function Wn(t) {
          if (t.measure && (t.measure.cache = {}, t.measure.heights = null, t.rest)) for (var e = 0; e < t.rest.length; e++) t.measure.caches[e] = {};
        }
        function Yn(t) {
          t.display.externalMeasure = null, S(t.display.lineMeasure);
          for (var e = 0; e < t.display.view.length; e++) Wn(t.display.view[e]);
        }
        function Un(t) {
          Yn(t), t.display.cachedCharWidth = t.display.cachedTextHeight = t.display.cachedPaddingH = null, t.options.lineWrapping || (t.display.maxLineChanged = !0), t.display.lineNumChars = null;
        }
        function Zn(t) {
          return d && v ? -(t.body.getBoundingClientRect().left - parseInt(getComputedStyle(t.body).marginLeft)) : t.defaultView.pageXOffset || (t.documentElement || t.body).scrollLeft;
        }
        function Gn(t) {
          return d && v ? -(t.body.getBoundingClientRect().top - parseInt(getComputedStyle(t.body).marginTop)) : t.defaultView.pageYOffset || (t.documentElement || t.body).scrollTop;
        }
        function qn(t) {
          var e = We(t).widgets,
            n = 0;
          if (e) for (var i = 0; i < e.length; ++i) e[i].above && (n += On(e[i]));
          return n;
        }
        function $n(t, e, n, i, r) {
          if (!r) {
            var a = qn(e);
            n.top += a, n.bottom += a;
          }
          if ("line" == i) return n;
          i || (i = "local");
          var o = qe(e);
          if ("local" == i ? o += Sn(t.display) : o -= t.display.viewOffset, "page" == i || "window" == i) {
            var s = t.display.lineSpace.getBoundingClientRect();
            o += s.top + ("window" == i ? 0 : Gn(_(t)));
            var l = s.left + ("window" == i ? 0 : Zn(_(t)));
            n.left += l, n.right += l;
          }
          return n.top += o, n.bottom += o, n;
        }
        function Qn(t, e, n) {
          if ("div" == n) return e;
          var i = e.left,
            r = e.top;
          if ("page" == n) i -= Zn(_(t)), r -= Gn(_(t));else if ("local" == n || !n) {
            var a = t.display.sizer.getBoundingClientRect();
            i += a.left, r += a.top;
          }
          var o = t.display.lineSpace.getBoundingClientRect();
          return {
            left: i - o.left,
            top: r - o.top
          };
        }
        function Jn(t, e, n, i, r) {
          return i || (i = Jt(t.doc, e.line)), $n(t, i, An(t, i, e.ch, r), n);
        }
        function Xn(t, e, n, i, r, a) {
          function o(e, o) {
            var s = Hn(t, r, e, o ? "right" : "left", a);
            return o ? s.left = s.right : s.right = s.left, $n(t, i, s, n);
          }
          i = i || Jt(t.doc, e.line), r || (r = _n(t, i));
          var s = gt(i, t.doc.direction),
            l = e.ch,
            c = e.sticky;
          if (l >= i.text.length ? (l = i.text.length, c = "before") : l <= 0 && (l = 0, c = "after"), !s) return o("before" == c ? l - 1 : l, "before" == c);
          function d(t, e, n) {
            return o(n ? t - 1 : t, 1 == s[e].level != n);
          }
          var u = ht(s, l, c),
            h = ut,
            p = d(l, u, "before" == c);
          return null != h && (p.other = d(l, h, "before" != c)), p;
        }
        function Kn(t, e) {
          var n = 0;
          e = he(t.doc, e), t.options.lineWrapping || (n = ci(t.display) * e.ch);
          var i = Jt(t.doc, e.line),
            r = qe(i) + Sn(t.display);
          return {
            left: n,
            right: n,
            top: r,
            bottom: r + i.height
          };
        }
        function ti(t, e, n, i, r) {
          var a = ae(t, e, n);
          return a.xRel = r, i && (a.outside = i), a;
        }
        function ei(t, e, n) {
          var i = t.doc;
          if ((n += t.display.viewOffset) < 0) return ti(i.first, 0, null, -1, -1);
          var r = ne(i, n),
            a = i.first + i.size - 1;
          if (r > a) return ti(i.first + i.size - 1, Jt(i, a).text.length, null, 1, 1);
          e < 0 && (e = 0);
          for (var o = Jt(i, r);;) {
            var s = ai(t, o, r, e, n),
              l = Re(o, s.ch + (s.xRel > 0 || s.outside > 0 ? 1 : 0));
            if (!l) return s;
            var c = l.find(1);
            if (c.line == r) return c;
            o = Jt(i, r = c.line);
          }
        }
        function ni(t, e, n, i) {
          i -= qn(e);
          var r = e.text.length,
            a = dt(function (e) {
              return Hn(t, n, e - 1).bottom <= i;
            }, r, 0);
          return {
            begin: a,
            end: r = dt(function (e) {
              return Hn(t, n, e).top > i;
            }, a, r)
          };
        }
        function ii(t, e, n, i) {
          return n || (n = _n(t, e)), ni(t, e, n, $n(t, e, Hn(t, n, i), "line").top);
        }
        function ri(t, e, n, i) {
          return !(t.bottom <= n) && (t.top > n || (i ? t.left : t.right) > e);
        }
        function ai(t, e, n, i, r) {
          r -= qe(e);
          var a = _n(t, e),
            o = qn(e),
            s = 0,
            l = e.text.length,
            c = !0,
            d = gt(e, t.doc.direction);
          if (d) {
            var u = (t.options.lineWrapping ? si : oi)(t, e, n, a, d, i, r);
            s = (c = 1 != u.level) ? u.from : u.to - 1, l = c ? u.to : u.from - 1;
          }
          var h,
            p,
            g = null,
            f = null,
            m = dt(function (e) {
              var n = Hn(t, a, e);
              return n.top += o, n.bottom += o, !!ri(n, i, r, !1) && (n.top <= r && n.left <= i && (g = e, f = n), !0);
            }, s, l),
            v = !1;
          if (f) {
            var b = i - f.left < f.right - i,
              y = b == c;
            m = g + (y ? 0 : 1), p = y ? "after" : "before", h = b ? f.left : f.right;
          } else {
            c || m != l && m != s || m++, p = 0 == m ? "after" : m == e.text.length ? "before" : Hn(t, a, m - (c ? 1 : 0)).bottom + o <= r == c ? "after" : "before";
            var w = Xn(t, ae(n, m, p), "line", e, a);
            h = w.left, v = r < w.top ? -1 : r >= w.bottom ? 1 : 0;
          }
          return ti(n, m = ct(e.text, m, 1), p, v, i - h);
        }
        function oi(t, e, n, i, r, a, o) {
          var s = dt(function (s) {
              var l = r[s],
                c = 1 != l.level;
              return ri(Xn(t, ae(n, c ? l.to : l.from, c ? "before" : "after"), "line", e, i), a, o, !0);
            }, 0, r.length - 1),
            l = r[s];
          if (s > 0) {
            var c = 1 != l.level,
              d = Xn(t, ae(n, c ? l.from : l.to, c ? "after" : "before"), "line", e, i);
            ri(d, a, o, !0) && d.top > o && (l = r[s - 1]);
          }
          return l;
        }
        function si(t, e, n, i, r, a, o) {
          var s = ni(t, e, i, o),
            l = s.begin,
            c = s.end;
          /\s/.test(e.text.charAt(c - 1)) && c--;
          for (var d = null, u = null, h = 0; h < r.length; h++) {
            var p = r[h];
            if (!(p.from >= c || p.to <= l)) {
              var g = Hn(t, i, 1 != p.level ? Math.min(c, p.to) - 1 : Math.max(l, p.from)).right,
                f = g < a ? a - g + 1e9 : g - a;
              (!d || u > f) && (d = p, u = f);
            }
          }
          return d || (d = r[r.length - 1]), d.from < l && (d = {
            from: l,
            to: d.to,
            level: d.level
          }), d.to > c && (d = {
            from: d.from,
            to: c,
            level: d.level
          }), d;
        }
        function li(t) {
          if (null != t.cachedTextHeight) return t.cachedTextHeight;
          if (null == Vn) {
            Vn = L("pre", null, "CodeMirror-line-like");
            for (var e = 0; e < 49; ++e) Vn.appendChild(document.createTextNode("x")), Vn.appendChild(L("br"));
            Vn.appendChild(document.createTextNode("x"));
          }
          N(t.measure, Vn);
          var n = Vn.offsetHeight / 50;
          return n > 3 && (t.cachedTextHeight = n), S(t.measure), n || 1;
        }
        function ci(t) {
          if (null != t.cachedCharWidth) return t.cachedCharWidth;
          var e = L("span", "xxxxxxxxxx"),
            n = L("pre", [e], "CodeMirror-line-like");
          N(t.measure, n);
          var i = e.getBoundingClientRect(),
            r = (i.right - i.left) / 10;
          return r > 2 && (t.cachedCharWidth = r), r || 10;
        }
        function di(t) {
          for (var e = t.display, n = {}, i = {}, r = e.gutters.clientLeft, a = e.gutters.firstChild, o = 0; a; a = a.nextSibling, ++o) {
            var s = t.display.gutterSpecs[o].className;
            n[s] = a.offsetLeft + a.clientLeft + r, i[s] = a.clientWidth;
          }
          return {
            fixedPos: ui(e),
            gutterTotalWidth: e.gutters.offsetWidth,
            gutterLeft: n,
            gutterWidth: i,
            wrapperWidth: e.wrapper.clientWidth
          };
        }
        function ui(t) {
          return t.scroller.getBoundingClientRect().left - t.sizer.getBoundingClientRect().left;
        }
        function hi(t) {
          var e = li(t.display),
            n = t.options.lineWrapping,
            i = n && Math.max(5, t.display.scroller.clientWidth / ci(t.display) - 3);
          return function (r) {
            if (Ze(t.doc, r)) return 0;
            var a = 0;
            if (r.widgets) for (var o = 0; o < r.widgets.length; o++) r.widgets[o].height && (a += r.widgets[o].height);
            return n ? a + (Math.ceil(r.text.length / i) || 1) * e : a + e;
          };
        }
        function pi(t) {
          var e = t.doc,
            n = hi(t);
          e.iter(function (t) {
            var e = n(t);
            e != t.height && te(t, e);
          });
        }
        function gi(t, e, n, i) {
          var r = t.display;
          if (!n && "true" == St(e).getAttribute("cm-not-content")) return null;
          var a,
            o,
            s = r.lineSpace.getBoundingClientRect();
          try {
            a = e.clientX - s.left, o = e.clientY - s.top;
          } catch (t) {
            return null;
          }
          var l,
            c = ei(t, a, o);
          if (i && c.xRel > 0 && (l = Jt(t.doc, c.line).text).length == c.ch) {
            var d = W(l, l.length, t.options.tabSize) - l.length;
            c = ae(c.line, Math.max(0, Math.round((a - Ln(t.display).left) / ci(t.display)) - d));
          }
          return c;
        }
        function fi(t, e) {
          if (e >= t.display.viewTo) return null;
          if ((e -= t.display.viewFrom) < 0) return null;
          for (var n = t.display.view, i = 0; i < n.length; i++) if ((e -= n[i].size) < 0) return i;
        }
        function mi(t, e, n, i) {
          null == e && (e = t.doc.first), null == n && (n = t.doc.first + t.doc.size), i || (i = 0);
          var r = t.display;
          if (i && n < r.viewTo && (null == r.updateLineNumbers || r.updateLineNumbers > e) && (r.updateLineNumbers = e), t.curOp.viewChanged = !0, e >= r.viewTo) Te && Ye(t.doc, e) < r.viewTo && bi(t);else if (n <= r.viewFrom) Te && Ue(t.doc, n + i) > r.viewFrom ? bi(t) : (r.viewFrom += i, r.viewTo += i);else if (e <= r.viewFrom && n >= r.viewTo) bi(t);else if (e <= r.viewFrom) {
            var a = yi(t, n, n + i, 1);
            a ? (r.view = r.view.slice(a.index), r.viewFrom = a.lineN, r.viewTo += i) : bi(t);
          } else if (n >= r.viewTo) {
            var o = yi(t, e, e, -1);
            o ? (r.view = r.view.slice(0, o.index), r.viewTo = o.lineN) : bi(t);
          } else {
            var s = yi(t, e, e, -1),
              l = yi(t, n, n + i, 1);
            s && l ? (r.view = r.view.slice(0, s.index).concat(dn(t, s.lineN, l.lineN)).concat(r.view.slice(l.index)), r.viewTo += i) : bi(t);
          }
          var c = r.externalMeasured;
          c && (n < c.lineN ? c.lineN += i : e < c.lineN + c.size && (r.externalMeasured = null));
        }
        function vi(t, e, n) {
          t.curOp.viewChanged = !0;
          var i = t.display,
            r = t.display.externalMeasured;
          if (r && e >= r.lineN && e < r.lineN + r.size && (i.externalMeasured = null), !(e < i.viewFrom || e >= i.viewTo)) {
            var a = i.view[fi(t, e)];
            if (null != a.node) {
              var o = a.changes || (a.changes = []);
              -1 == U(o, n) && o.push(n);
            }
          }
        }
        function bi(t) {
          t.display.viewFrom = t.display.viewTo = t.doc.first, t.display.view = [], t.display.viewOffset = 0;
        }
        function yi(t, e, n, i) {
          var r,
            a = fi(t, e),
            o = t.display.view;
          if (!Te || n == t.doc.first + t.doc.size) return {
            index: a,
            lineN: n
          };
          for (var s = t.display.viewFrom, l = 0; l < a; l++) s += o[l].size;
          if (s != e) {
            if (i > 0) {
              if (a == o.length - 1) return null;
              r = s + o[a].size - e, a++;
            } else r = s - e;
            e += r, n += r;
          }
          for (; Ye(t.doc, n) != n;) {
            if (a == (i < 0 ? 0 : o.length - 1)) return null;
            n += i * o[a - (i < 0 ? 1 : 0)].size, a += i;
          }
          return {
            index: a,
            lineN: n
          };
        }
        function wi(t) {
          for (var e = t.display.view, n = 0, i = 0; i < e.length; i++) {
            var r = e[i];
            r.hidden || r.node && !r.changes || ++n;
          }
          return n;
        }
        function xi(t) {
          t.display.input.showSelection(t.display.input.prepareSelection());
        }
        function ji(t, e) {
          void 0 === e && (e = !0);
          var n = t.doc,
            i = {},
            r = i.cursors = document.createDocumentFragment(),
            a = i.selection = document.createDocumentFragment(),
            o = t.options.$customCursor;
          o && (e = !0);
          for (var s = 0; s < n.sel.ranges.length; s++) if (e || s != n.sel.primIndex) {
            var l = n.sel.ranges[s];
            if (!(l.from().line >= t.display.viewTo || l.to().line < t.display.viewFrom)) {
              var c = l.empty();
              if (o) {
                var d = o(t, l);
                d && Ci(t, d, r);
              } else (c || t.options.showCursorWhenSelecting) && Ci(t, l.head, r);
              c || ki(t, l, a);
            }
          }
          return i;
        }
        function Ci(t, e, n) {
          var i = Xn(t, e, "div", null, null, !t.options.singleCursorHeightPerLine),
            r = n.appendChild(L("div", " ", "CodeMirror-cursor"));
          if (r.style.left = i.left + "px", r.style.top = i.top + "px", r.style.height = Math.max(0, i.bottom - i.top) * t.options.cursorHeight + "px", /\bcm-fat-cursor\b/.test(t.getWrapperElement().className)) {
            var a = Jn(t, e, "div", null, null),
              o = a.right - a.left;
            r.style.width = (o > 0 ? o : t.defaultCharWidth()) + "px";
          }
          if (i.other) {
            var s = n.appendChild(L("div", " ", "CodeMirror-cursor CodeMirror-secondarycursor"));
            s.style.display = "", s.style.left = i.other.left + "px", s.style.top = i.other.top + "px", s.style.height = .85 * (i.other.bottom - i.other.top) + "px";
          }
        }
        function Mi(t, e) {
          return t.top - e.top || t.left - e.left;
        }
        function ki(t, e, n) {
          var i = t.display,
            r = t.doc,
            a = document.createDocumentFragment(),
            o = Ln(t.display),
            s = o.left,
            l = Math.max(i.sizerWidth, En(t) - i.sizer.offsetLeft) - o.right,
            c = "ltr" == r.direction;
          function d(t, e, n, i) {
            e < 0 && (e = 0), e = Math.round(e), i = Math.round(i), a.appendChild(L("div", null, "CodeMirror-selected", "position: absolute; left: " + t + "px;\n                             top: " + e + "px; width: " + (null == n ? l - t : n) + "px;\n                             height: " + (i - e) + "px"));
          }
          function u(e, n, i) {
            var a,
              o,
              u = Jt(r, e),
              h = u.text.length;
            function p(n, i) {
              return Jn(t, ae(e, n), "div", u, i);
            }
            function g(e, n, i) {
              var r = ii(t, u, null, e),
                a = "ltr" == n == ("after" == i) ? "left" : "right";
              return p("after" == i ? r.begin : r.end - (/\s/.test(u.text.charAt(r.end - 1)) ? 2 : 1), a)[a];
            }
            var f = gt(u, r.direction);
            return function (t, e, n, i) {
              if (!t) return i(e, n, "ltr", 0);
              for (var r = !1, a = 0; a < t.length; ++a) {
                var o = t[a];
                (o.from < n && o.to > e || e == n && o.to == e) && (i(Math.max(o.from, e), Math.min(o.to, n), 1 == o.level ? "rtl" : "ltr", a), r = !0);
              }
              r || i(e, n, "ltr");
            }(f, n || 0, null == i ? h : i, function (t, e, r, u) {
              var m = "ltr" == r,
                v = p(t, m ? "left" : "right"),
                b = p(e - 1, m ? "right" : "left"),
                y = null == n && 0 == t,
                w = null == i && e == h,
                x = 0 == u,
                j = !f || u == f.length - 1;
              if (b.top - v.top <= 3) {
                var C = (c ? w : y) && j,
                  M = (c ? y : w) && x ? s : (m ? v : b).left,
                  k = C ? l : (m ? b : v).right;
                d(M, v.top, k - M, v.bottom);
              } else {
                var O, T, S, N;
                m ? (O = c && y && x ? s : v.left, T = c ? l : g(t, r, "before"), S = c ? s : g(e, r, "after"), N = c && w && j ? l : b.right) : (O = c ? g(t, r, "before") : s, T = !c && y && x ? l : v.right, S = !c && w && j ? s : b.left, N = c ? g(e, r, "after") : l), d(O, v.top, T - O, v.bottom), v.bottom < b.top && d(s, v.bottom, null, b.top), d(S, b.top, N - S, b.bottom);
              }
              (!a || Mi(v, a) < 0) && (a = v), Mi(b, a) < 0 && (a = b), (!o || Mi(v, o) < 0) && (o = v), Mi(b, o) < 0 && (o = b);
            }), {
              start: a,
              end: o
            };
          }
          var h = e.from(),
            p = e.to();
          if (h.line == p.line) u(h.line, h.ch, p.ch);else {
            var g = Jt(r, h.line),
              f = Jt(r, p.line),
              m = We(g) == We(f),
              v = u(h.line, h.ch, m ? g.text.length + 1 : null).end,
              b = u(p.line, m ? 0 : null, p.ch).start;
            m && (v.top < b.top - 2 ? (d(v.right, v.top, null, v.bottom), d(s, b.top, b.left, b.bottom)) : d(v.right, v.top, b.left - v.right, v.bottom)), v.bottom < b.top && d(s, v.bottom, null, b.top);
          }
          n.appendChild(a);
        }
        function Oi(t) {
          if (t.state.focused) {
            var e = t.display;
            clearInterval(e.blinker);
            var n = !0;
            e.cursorDiv.style.visibility = "", t.options.cursorBlinkRate > 0 ? e.blinker = setInterval(function () {
              t.hasFocus() || Li(t), e.cursorDiv.style.visibility = (n = !n) ? "" : "hidden";
            }, t.options.cursorBlinkRate) : t.options.cursorBlinkRate < 0 && (e.cursorDiv.style.visibility = "hidden");
          }
        }
        function Ti(t) {
          t.hasFocus() || (t.display.input.focus(), t.state.focused || Ni(t));
        }
        function Si(t) {
          t.state.delayingBlurEvent = !0, setTimeout(function () {
            t.state.delayingBlurEvent && (t.state.delayingBlurEvent = !1, t.state.focused && Li(t));
          }, 100);
        }
        function Ni(t, e) {
          t.state.delayingBlurEvent && !t.state.draggingText && (t.state.delayingBlurEvent = !1), "nocursor" != t.options.readOnly && (t.state.focused || (yt(t, "focus", t, e), t.state.focused = !0, P(t.display.wrapper, "CodeMirror-focused"), t.curOp || t.display.selForContextMenu == t.doc.sel || (t.display.input.reset(), l && setTimeout(function () {
            return t.display.input.reset(!0);
          }, 20)), t.display.input.receivedFocus()), Oi(t));
        }
        function Li(t, e) {
          t.state.delayingBlurEvent || (t.state.focused && (yt(t, "blur", t, e), t.state.focused = !1, T(t.display.wrapper, "CodeMirror-focused")), clearInterval(t.display.blinker), setTimeout(function () {
            t.state.focused || (t.display.shift = !1);
          }, 150));
        }
        function Di(t) {
          for (var e = t.display, n = e.lineDiv.offsetTop, i = Math.max(0, e.scroller.getBoundingClientRect().top), r = e.lineDiv.getBoundingClientRect().top, a = 0, l = 0; l < e.view.length; l++) {
            var c = e.view[l],
              d = t.options.lineWrapping,
              u = void 0,
              h = 0;
            if (!c.hidden) {
              if (r += c.line.height, o && s < 8) {
                var p = c.node.offsetTop + c.node.offsetHeight;
                u = p - n, n = p;
              } else {
                var g = c.node.getBoundingClientRect();
                u = g.bottom - g.top, !d && c.text.firstChild && (h = c.text.firstChild.getBoundingClientRect().right - g.left - 1);
              }
              var f = c.line.height - u;
              if ((f > .005 || f < -.005) && (r < i && (a -= f), te(c.line, u), Ei(c.line), c.rest)) for (var m = 0; m < c.rest.length; m++) Ei(c.rest[m]);
              if (h > t.display.sizerWidth) {
                var v = Math.ceil(h / ci(t.display));
                v > t.display.maxLineLength && (t.display.maxLineLength = v, t.display.maxLine = c.line, t.display.maxLineChanged = !0);
              }
            }
          }
          Math.abs(a) > 2 && (e.scroller.scrollTop += a);
        }
        function Ei(t) {
          if (t.widgets) for (var e = 0; e < t.widgets.length; ++e) {
            var n = t.widgets[e],
              i = n.node.parentNode;
            i && (n.height = i.offsetHeight);
          }
        }
        function Ii(t, e, n) {
          var i = n && null != n.top ? Math.max(0, n.top) : t.scroller.scrollTop;
          i = Math.floor(i - Sn(t));
          var r = n && null != n.bottom ? n.bottom : i + t.wrapper.clientHeight,
            a = ne(e, i),
            o = ne(e, r);
          if (n && n.ensure) {
            var s = n.ensure.from.line,
              l = n.ensure.to.line;
            s < a ? (a = s, o = ne(e, qe(Jt(e, s)) + t.wrapper.clientHeight)) : Math.min(l, e.lastLine()) >= o && (a = ne(e, qe(Jt(e, l)) - t.wrapper.clientHeight), o = l);
          }
          return {
            from: a,
            to: Math.max(o, a + 1)
          };
        }
        function Pi(t, e) {
          var n = t.display,
            i = li(t.display);
          e.top < 0 && (e.top = 0);
          var r = t.curOp && null != t.curOp.scrollTop ? t.curOp.scrollTop : n.scroller.scrollTop,
            a = In(t),
            o = {};
          e.bottom - e.top > a && (e.bottom = e.top + a);
          var s = t.doc.height + Nn(n),
            l = e.top < i,
            c = e.bottom > s - i;
          if (e.top < r) o.scrollTop = l ? 0 : e.top;else if (e.bottom > r + a) {
            var d = Math.min(e.top, (c ? s : e.bottom) - a);
            d != r && (o.scrollTop = d);
          }
          var u = t.options.fixedGutter ? 0 : n.gutters.offsetWidth,
            h = t.curOp && null != t.curOp.scrollLeft ? t.curOp.scrollLeft : n.scroller.scrollLeft - u,
            p = En(t) - n.gutters.offsetWidth,
            g = e.right - e.left > p;
          return g && (e.right = e.left + p), e.left < 10 ? o.scrollLeft = 0 : e.left < h ? o.scrollLeft = Math.max(0, e.left + u - (g ? 0 : 10)) : e.right > p + h - 3 && (o.scrollLeft = e.right + (g ? 0 : 10) - p), o;
        }
        function Ai(t, e) {
          null != e && (Hi(t), t.curOp.scrollTop = (null == t.curOp.scrollTop ? t.doc.scrollTop : t.curOp.scrollTop) + e);
        }
        function zi(t) {
          Hi(t);
          var e = t.getCursor();
          t.curOp.scrollToPos = {
            from: e,
            to: e,
            margin: t.options.cursorScrollMargin
          };
        }
        function _i(t, e, n) {
          null == e && null == n || Hi(t), null != e && (t.curOp.scrollLeft = e), null != n && (t.curOp.scrollTop = n);
        }
        function Hi(t) {
          var e = t.curOp.scrollToPos;
          e && (t.curOp.scrollToPos = null, Vi(t, Kn(t, e.from), Kn(t, e.to), e.margin));
        }
        function Vi(t, e, n, i) {
          var r = Pi(t, {
            left: Math.min(e.left, n.left),
            top: Math.min(e.top, n.top) - i,
            right: Math.max(e.right, n.right),
            bottom: Math.max(e.bottom, n.bottom) + i
          });
          _i(t, r.scrollLeft, r.scrollTop);
        }
        function Fi(t, e) {
          Math.abs(t.doc.scrollTop - e) < 2 || (n || pr(t, {
            top: e
          }), Ri(t, e, !0), n && pr(t), lr(t, 100));
        }
        function Ri(t, e, n) {
          e = Math.max(0, Math.min(t.display.scroller.scrollHeight - t.display.scroller.clientHeight, e)), (t.display.scroller.scrollTop != e || n) && (t.doc.scrollTop = e, t.display.scrollbars.setScrollTop(e), t.display.scroller.scrollTop != e && (t.display.scroller.scrollTop = e));
        }
        function Bi(t, e, n, i) {
          e = Math.max(0, Math.min(e, t.display.scroller.scrollWidth - t.display.scroller.clientWidth)), (n ? e == t.doc.scrollLeft : Math.abs(t.doc.scrollLeft - e) < 2) && !i || (t.doc.scrollLeft = e, mr(t), t.display.scroller.scrollLeft != e && (t.display.scroller.scrollLeft = e), t.display.scrollbars.setScrollLeft(e));
        }
        function Wi(t) {
          var e = t.display,
            n = e.gutters.offsetWidth,
            i = Math.round(t.doc.height + Nn(t.display));
          return {
            clientHeight: e.scroller.clientHeight,
            viewHeight: e.wrapper.clientHeight,
            scrollWidth: e.scroller.scrollWidth,
            clientWidth: e.scroller.clientWidth,
            viewWidth: e.wrapper.clientWidth,
            barLeft: t.options.fixedGutter ? n : 0,
            docHeight: i,
            scrollHeight: i + Dn(t) + e.barHeight,
            nativeBarWidth: e.nativeBarWidth,
            gutterWidth: n
          };
        }
        var Yi = function Yi(t, e, n) {
          this.cm = n;
          var i = this.vert = L("div", [L("div", null, null, "min-width: 1px")], "CodeMirror-vscrollbar"),
            r = this.horiz = L("div", [L("div", null, null, "height: 100%; min-height: 1px")], "CodeMirror-hscrollbar");
          i.tabIndex = r.tabIndex = -1, t(i), t(r), mt(i, "scroll", function () {
            i.clientHeight && e(i.scrollTop, "vertical");
          }), mt(r, "scroll", function () {
            r.clientWidth && e(r.scrollLeft, "horizontal");
          }), this.checkedZeroWidth = !1, o && s < 8 && (this.horiz.style.minHeight = this.vert.style.minWidth = "18px");
        };
        Yi.prototype.update = function (t) {
          var e = t.scrollWidth > t.clientWidth + 1,
            n = t.scrollHeight > t.clientHeight + 1,
            i = t.nativeBarWidth;
          if (n) {
            this.vert.style.display = "block", this.vert.style.bottom = e ? i + "px" : "0";
            var r = t.viewHeight - (e ? i : 0);
            this.vert.firstChild.style.height = Math.max(0, t.scrollHeight - t.clientHeight + r) + "px";
          } else this.vert.scrollTop = 0, this.vert.style.display = "", this.vert.firstChild.style.height = "0";
          if (e) {
            this.horiz.style.display = "block", this.horiz.style.right = n ? i + "px" : "0", this.horiz.style.left = t.barLeft + "px";
            var a = t.viewWidth - t.barLeft - (n ? i : 0);
            this.horiz.firstChild.style.width = Math.max(0, t.scrollWidth - t.clientWidth + a) + "px";
          } else this.horiz.style.display = "", this.horiz.firstChild.style.width = "0";
          return !this.checkedZeroWidth && t.clientHeight > 0 && (0 == i && this.zeroWidthHack(), this.checkedZeroWidth = !0), {
            right: n ? i : 0,
            bottom: e ? i : 0
          };
        }, Yi.prototype.setScrollLeft = function (t) {
          this.horiz.scrollLeft != t && (this.horiz.scrollLeft = t), this.disableHoriz && this.enableZeroWidthBar(this.horiz, this.disableHoriz, "horiz");
        }, Yi.prototype.setScrollTop = function (t) {
          this.vert.scrollTop != t && (this.vert.scrollTop = t), this.disableVert && this.enableZeroWidthBar(this.vert, this.disableVert, "vert");
        }, Yi.prototype.zeroWidthHack = function () {
          var t = y && !g ? "12px" : "18px";
          this.horiz.style.height = this.vert.style.width = t, this.horiz.style.visibility = this.vert.style.visibility = "hidden", this.disableHoriz = new Y(), this.disableVert = new Y();
        }, Yi.prototype.enableZeroWidthBar = function (t, e, n) {
          t.style.visibility = "", e.set(1e3, function i() {
            var r = t.getBoundingClientRect();
            ("vert" == n ? document.elementFromPoint(r.right - 1, (r.top + r.bottom) / 2) : document.elementFromPoint((r.right + r.left) / 2, r.bottom - 1)) != t ? t.style.visibility = "hidden" : e.set(1e3, i);
          });
        }, Yi.prototype.clear = function () {
          var t = this.horiz.parentNode;
          t.removeChild(this.horiz), t.removeChild(this.vert);
        };
        var Ui = function Ui() {};
        function Zi(t, e) {
          e || (e = Wi(t));
          var n = t.display.barWidth,
            i = t.display.barHeight;
          Gi(t, e);
          for (var r = 0; r < 4 && n != t.display.barWidth || i != t.display.barHeight; r++) n != t.display.barWidth && t.options.lineWrapping && Di(t), Gi(t, Wi(t)), n = t.display.barWidth, i = t.display.barHeight;
        }
        function Gi(t, e) {
          var n = t.display,
            i = n.scrollbars.update(e);
          n.sizer.style.paddingRight = (n.barWidth = i.right) + "px", n.sizer.style.paddingBottom = (n.barHeight = i.bottom) + "px", n.heightForcer.style.borderBottom = i.bottom + "px solid transparent", i.right && i.bottom ? (n.scrollbarFiller.style.display = "block", n.scrollbarFiller.style.height = i.bottom + "px", n.scrollbarFiller.style.width = i.right + "px") : n.scrollbarFiller.style.display = "", i.bottom && t.options.coverGutterNextToScrollbar && t.options.fixedGutter ? (n.gutterFiller.style.display = "block", n.gutterFiller.style.height = i.bottom + "px", n.gutterFiller.style.width = e.gutterWidth + "px") : n.gutterFiller.style.display = "";
        }
        Ui.prototype.update = function () {
          return {
            bottom: 0,
            right: 0
          };
        }, Ui.prototype.setScrollLeft = function () {}, Ui.prototype.setScrollTop = function () {}, Ui.prototype.clear = function () {};
        var qi = {
          native: Yi,
          null: Ui
        };
        function $i(t) {
          t.display.scrollbars && (t.display.scrollbars.clear(), t.display.scrollbars.addClass && T(t.display.wrapper, t.display.scrollbars.addClass)), t.display.scrollbars = new qi[t.options.scrollbarStyle](function (e) {
            t.display.wrapper.insertBefore(e, t.display.scrollbarFiller), mt(e, "mousedown", function () {
              t.state.focused && setTimeout(function () {
                return t.display.input.focus();
              }, 0);
            }), e.setAttribute("cm-not-content", "true");
          }, function (e, n) {
            "horizontal" == n ? Bi(t, e) : Fi(t, e);
          }, t), t.display.scrollbars.addClass && P(t.display.wrapper, t.display.scrollbars.addClass);
        }
        var Qi = 0;
        function Ji(t) {
          var e;
          t.curOp = {
            cm: t,
            viewChanged: !1,
            startHeight: t.doc.height,
            forceUpdate: !1,
            updateInput: 0,
            typing: !1,
            changeObjs: null,
            cursorActivityHandlers: null,
            cursorActivityCalled: 0,
            selectionChanged: !1,
            updateMaxLine: !1,
            scrollLeft: null,
            scrollTop: null,
            scrollToPos: null,
            focus: !1,
            id: ++Qi,
            markArrays: null
          }, e = t.curOp, un ? un.ops.push(e) : e.ownsGroup = un = {
            ops: [e],
            delayedCallbacks: []
          };
        }
        function Xi(t) {
          var e = t.curOp;
          e && function (t, e) {
            var n = t.ownsGroup;
            if (n) try {
              !function (t) {
                var e = t.delayedCallbacks,
                  n = 0;
                do {
                  for (; n < e.length; n++) e[n].call(null);
                  for (var i = 0; i < t.ops.length; i++) {
                    var r = t.ops[i];
                    if (r.cursorActivityHandlers) for (; r.cursorActivityCalled < r.cursorActivityHandlers.length;) r.cursorActivityHandlers[r.cursorActivityCalled++].call(null, r.cm);
                  }
                } while (n < e.length);
              }(n);
            } finally {
              un = null, function (t) {
                for (var e = 0; e < t.ops.length; e++) t.ops[e].cm.curOp = null;
                !function (t) {
                  for (var e = t.ops, n = 0; n < e.length; n++) Ki(e[n]);
                  for (var i = 0; i < e.length; i++) tr(e[i]);
                  for (var r = 0; r < e.length; r++) er(e[r]);
                  for (var a = 0; a < e.length; a++) nr(e[a]);
                  for (var o = 0; o < e.length; o++) ir(e[o]);
                }(t);
              }(n);
            }
          }(e);
        }
        function Ki(t) {
          var e = t.cm,
            n = e.display;
          !function (t) {
            var e = t.display;
            !e.scrollbarsClipped && e.scroller.offsetWidth && (e.nativeBarWidth = e.scroller.offsetWidth - e.scroller.clientWidth, e.heightForcer.style.height = Dn(t) + "px", e.sizer.style.marginBottom = -e.nativeBarWidth + "px", e.sizer.style.borderRightWidth = Dn(t) + "px", e.scrollbarsClipped = !0);
          }(e), t.updateMaxLine && Qe(e), t.mustUpdate = t.viewChanged || t.forceUpdate || null != t.scrollTop || t.scrollToPos && (t.scrollToPos.from.line < n.viewFrom || t.scrollToPos.to.line >= n.viewTo) || n.maxLineChanged && e.options.lineWrapping, t.update = t.mustUpdate && new dr(e, t.mustUpdate && {
            top: t.scrollTop,
            ensure: t.scrollToPos
          }, t.forceUpdate);
        }
        function tr(t) {
          t.updatedDisplay = t.mustUpdate && ur(t.cm, t.update);
        }
        function er(t) {
          var e = t.cm,
            n = e.display;
          t.updatedDisplay && Di(e), t.barMeasure = Wi(e), n.maxLineChanged && !e.options.lineWrapping && (t.adjustWidthTo = An(e, n.maxLine, n.maxLine.text.length).left + 3, e.display.sizerWidth = t.adjustWidthTo, t.barMeasure.scrollWidth = Math.max(n.scroller.clientWidth, n.sizer.offsetLeft + t.adjustWidthTo + Dn(e) + e.display.barWidth), t.maxScrollLeft = Math.max(0, n.sizer.offsetLeft + t.adjustWidthTo - En(e))), (t.updatedDisplay || t.selectionChanged) && (t.preparedSelection = n.input.prepareSelection());
        }
        function nr(t) {
          var e = t.cm;
          null != t.adjustWidthTo && (e.display.sizer.style.minWidth = t.adjustWidthTo + "px", t.maxScrollLeft < e.doc.scrollLeft && Bi(e, Math.min(e.display.scroller.scrollLeft, t.maxScrollLeft), !0), e.display.maxLineChanged = !1);
          var n = t.focus && t.focus == I(H(e));
          t.preparedSelection && e.display.input.showSelection(t.preparedSelection, n), (t.updatedDisplay || t.startHeight != e.doc.height) && Zi(e, t.barMeasure), t.updatedDisplay && fr(e, t.barMeasure), t.selectionChanged && Oi(e), e.state.focused && t.updateInput && e.display.input.reset(t.typing), n && Ti(t.cm);
        }
        function ir(t) {
          var e = t.cm,
            n = e.display,
            i = e.doc;
          t.updatedDisplay && hr(e, t.update), null == n.wheelStartX || null == t.scrollTop && null == t.scrollLeft && !t.scrollToPos || (n.wheelStartX = n.wheelStartY = null), null != t.scrollTop && Ri(e, t.scrollTop, t.forceScroll), null != t.scrollLeft && Bi(e, t.scrollLeft, !0, !0), t.scrollToPos && function (t, e) {
            if (!wt(t, "scrollCursorIntoView")) {
              var n = t.display,
                i = n.sizer.getBoundingClientRect(),
                r = null,
                a = n.wrapper.ownerDocument;
              if (e.top + i.top < 0 ? r = !0 : e.bottom + i.top > (a.defaultView.innerHeight || a.documentElement.clientHeight) && (r = !1), null != r && !f) {
                var o = L("div", "​", null, "position: absolute;\n                         top: " + (e.top - n.viewOffset - Sn(t.display)) + "px;\n                         height: " + (e.bottom - e.top + Dn(t) + n.barHeight) + "px;\n                         left: " + e.left + "px; width: " + Math.max(2, e.right - e.left) + "px;");
                t.display.lineSpace.appendChild(o), o.scrollIntoView(r), t.display.lineSpace.removeChild(o);
              }
            }
          }(e, function (t, e, n, i) {
            var r;
            null == i && (i = 0), t.options.lineWrapping || e != n || (n = "before" == e.sticky ? ae(e.line, e.ch + 1, "before") : e, e = e.ch ? ae(e.line, "before" == e.sticky ? e.ch - 1 : e.ch, "after") : e);
            for (var a = 0; a < 5; a++) {
              var o = !1,
                s = Xn(t, e),
                l = n && n != e ? Xn(t, n) : s,
                c = Pi(t, r = {
                  left: Math.min(s.left, l.left),
                  top: Math.min(s.top, l.top) - i,
                  right: Math.max(s.left, l.left),
                  bottom: Math.max(s.bottom, l.bottom) + i
                }),
                d = t.doc.scrollTop,
                u = t.doc.scrollLeft;
              if (null != c.scrollTop && (Fi(t, c.scrollTop), Math.abs(t.doc.scrollTop - d) > 1 && (o = !0)), null != c.scrollLeft && (Bi(t, c.scrollLeft), Math.abs(t.doc.scrollLeft - u) > 1 && (o = !0)), !o) break;
            }
            return r;
          }(e, he(i, t.scrollToPos.from), he(i, t.scrollToPos.to), t.scrollToPos.margin));
          var r = t.maybeHiddenMarkers,
            a = t.maybeUnhiddenMarkers;
          if (r) for (var o = 0; o < r.length; ++o) r[o].lines.length || yt(r[o], "hide");
          if (a) for (var s = 0; s < a.length; ++s) a[s].lines.length && yt(a[s], "unhide");
          n.wrapper.offsetHeight && (i.scrollTop = e.display.scroller.scrollTop), t.changeObjs && yt(e, "changes", e, t.changeObjs), t.update && t.update.finish();
        }
        function rr(t, e) {
          if (t.curOp) return e();
          Ji(t);
          try {
            return e();
          } finally {
            Xi(t);
          }
        }
        function ar(t, e) {
          return function () {
            if (t.curOp) return e.apply(t, arguments);
            Ji(t);
            try {
              return e.apply(t, arguments);
            } finally {
              Xi(t);
            }
          };
        }
        function or(t) {
          return function () {
            if (this.curOp) return t.apply(this, arguments);
            Ji(this);
            try {
              return t.apply(this, arguments);
            } finally {
              Xi(this);
            }
          };
        }
        function sr(t) {
          return function () {
            var e = this.cm;
            if (!e || e.curOp) return t.apply(this, arguments);
            Ji(e);
            try {
              return t.apply(this, arguments);
            } finally {
              Xi(e);
            }
          };
        }
        function lr(t, e) {
          t.doc.highlightFrontier < t.display.viewTo && t.state.highlight.set(e, R(cr, t));
        }
        function cr(t) {
          var e = t.doc;
          if (!(e.highlightFrontier >= t.display.viewTo)) {
            var n = +new Date() + t.options.workTime,
              i = be(t, e.highlightFrontier),
              r = [];
            e.iter(i.line, Math.min(e.first + e.size, t.display.viewTo + 500), function (a) {
              if (i.line >= t.display.viewFrom) {
                var o = a.styles,
                  s = a.text.length > t.options.maxHighlightLength ? Gt(e.mode, i.state) : null,
                  l = me(t, a, i, !0);
                s && (i.state = s), a.styles = l.styles;
                var c = a.styleClasses,
                  d = l.classes;
                d ? a.styleClasses = d : c && (a.styleClasses = null);
                for (var u = !o || o.length != a.styles.length || c != d && (!c || !d || c.bgClass != d.bgClass || c.textClass != d.textClass), h = 0; !u && h < o.length; ++h) u = o[h] != a.styles[h];
                u && r.push(i.line), a.stateAfter = i.save(), i.nextLine();
              } else a.text.length <= t.options.maxHighlightLength && ye(t, a.text, i), a.stateAfter = i.line % 5 == 0 ? i.save() : null, i.nextLine();
              if (+new Date() > n) return lr(t, t.options.workDelay), !0;
            }), e.highlightFrontier = i.line, e.modeFrontier = Math.max(e.modeFrontier, i.line), r.length && rr(t, function () {
              for (var e = 0; e < r.length; e++) vi(t, r[e], "text");
            });
          }
        }
        var dr = function dr(t, e, n) {
          var i = t.display;
          this.viewport = e, this.visible = Ii(i, t.doc, e), this.editorIsHidden = !i.wrapper.offsetWidth, this.wrapperHeight = i.wrapper.clientHeight, this.wrapperWidth = i.wrapper.clientWidth, this.oldDisplayWidth = En(t), this.force = n, this.dims = di(t), this.events = [];
        };
        function ur(t, e) {
          var n = t.display,
            i = t.doc;
          if (e.editorIsHidden) return bi(t), !1;
          if (!e.force && e.visible.from >= n.viewFrom && e.visible.to <= n.viewTo && (null == n.updateLineNumbers || n.updateLineNumbers >= n.viewTo) && n.renderedView == n.view && 0 == wi(t)) return !1;
          vr(t) && (bi(t), e.dims = di(t));
          var r = i.first + i.size,
            a = Math.max(e.visible.from - t.options.viewportMargin, i.first),
            o = Math.min(r, e.visible.to + t.options.viewportMargin);
          n.viewFrom < a && a - n.viewFrom < 20 && (a = Math.max(i.first, n.viewFrom)), n.viewTo > o && n.viewTo - o < 20 && (o = Math.min(r, n.viewTo)), Te && (a = Ye(t.doc, a), o = Ue(t.doc, o));
          var s = a != n.viewFrom || o != n.viewTo || n.lastWrapHeight != e.wrapperHeight || n.lastWrapWidth != e.wrapperWidth;
          !function (t, e, n) {
            var i = t.display;
            0 == i.view.length || e >= i.viewTo || n <= i.viewFrom ? (i.view = dn(t, e, n), i.viewFrom = e) : (i.viewFrom > e ? i.view = dn(t, e, i.viewFrom).concat(i.view) : i.viewFrom < e && (i.view = i.view.slice(fi(t, e))), i.viewFrom = e, i.viewTo < n ? i.view = i.view.concat(dn(t, i.viewTo, n)) : i.viewTo > n && (i.view = i.view.slice(0, fi(t, n)))), i.viewTo = n;
          }(t, a, o), n.viewOffset = qe(Jt(t.doc, n.viewFrom)), t.display.mover.style.top = n.viewOffset + "px";
          var c = wi(t);
          if (!s && 0 == c && !e.force && n.renderedView == n.view && (null == n.updateLineNumbers || n.updateLineNumbers >= n.viewTo)) return !1;
          var d = function (t) {
            if (t.hasFocus()) return null;
            var e = I(H(t));
            if (!e || !E(t.display.lineDiv, e)) return null;
            var n = {
              activeElt: e
            };
            if (window.getSelection) {
              var i = F(t).getSelection();
              i.anchorNode && i.extend && E(t.display.lineDiv, i.anchorNode) && (n.anchorNode = i.anchorNode, n.anchorOffset = i.anchorOffset, n.focusNode = i.focusNode, n.focusOffset = i.focusOffset);
            }
            return n;
          }(t);
          return c > 4 && (n.lineDiv.style.display = "none"), function (t, e, n) {
            var i = t.display,
              r = t.options.lineNumbers,
              a = i.lineDiv,
              o = a.firstChild;
            function s(e) {
              var n = e.nextSibling;
              return l && y && t.display.currentWheelTarget == e ? e.style.display = "none" : e.parentNode.removeChild(e), n;
            }
            for (var c = i.view, d = i.viewFrom, u = 0; u < c.length; u++) {
              var h = c[u];
              if (h.hidden) ;else if (h.node && h.node.parentNode == a) {
                for (; o != h.node;) o = s(o);
                var p = r && null != e && e <= d && h.lineNumber;
                h.changes && (U(h.changes, "gutter") > -1 && (p = !1), fn(t, h, d, n)), p && (S(h.lineNumber), h.lineNumber.appendChild(document.createTextNode(re(t.options, d)))), o = h.node.nextSibling;
              } else {
                var g = jn(t, h, d, n);
                a.insertBefore(g, o);
              }
              d += h.size;
            }
            for (; o;) o = s(o);
          }(t, n.updateLineNumbers, e.dims), c > 4 && (n.lineDiv.style.display = ""), n.renderedView = n.view, function (t) {
            if (t && t.activeElt && t.activeElt != I(V(t.activeElt)) && (t.activeElt.focus(), !/^(INPUT|TEXTAREA)$/.test(t.activeElt.nodeName) && t.anchorNode && E(document.body, t.anchorNode) && E(document.body, t.focusNode))) {
              var e = t.activeElt.ownerDocument,
                n = e.defaultView.getSelection(),
                i = e.createRange();
              i.setEnd(t.anchorNode, t.anchorOffset), i.collapse(!1), n.removeAllRanges(), n.addRange(i), n.extend(t.focusNode, t.focusOffset);
            }
          }(d), S(n.cursorDiv), S(n.selectionDiv), n.gutters.style.height = n.sizer.style.minHeight = 0, s && (n.lastWrapHeight = e.wrapperHeight, n.lastWrapWidth = e.wrapperWidth, lr(t, 400)), n.updateLineNumbers = null, !0;
        }
        function hr(t, e) {
          for (var n = e.viewport, i = !0;; i = !1) {
            if (i && t.options.lineWrapping && e.oldDisplayWidth != En(t)) i && (e.visible = Ii(t.display, t.doc, n));else if (n && null != n.top && (n = {
              top: Math.min(t.doc.height + Nn(t.display) - In(t), n.top)
            }), e.visible = Ii(t.display, t.doc, n), e.visible.from >= t.display.viewFrom && e.visible.to <= t.display.viewTo) break;
            if (!ur(t, e)) break;
            Di(t);
            var r = Wi(t);
            xi(t), Zi(t, r), fr(t, r), e.force = !1;
          }
          e.signal(t, "update", t), t.display.viewFrom == t.display.reportedViewFrom && t.display.viewTo == t.display.reportedViewTo || (e.signal(t, "viewportChange", t, t.display.viewFrom, t.display.viewTo), t.display.reportedViewFrom = t.display.viewFrom, t.display.reportedViewTo = t.display.viewTo);
        }
        function pr(t, e) {
          var n = new dr(t, e);
          if (ur(t, n)) {
            Di(t), hr(t, n);
            var i = Wi(t);
            xi(t), Zi(t, i), fr(t, i), n.finish();
          }
        }
        function gr(t) {
          var e = t.gutters.offsetWidth;
          t.sizer.style.marginLeft = e + "px", pn(t, "gutterChanged", t);
        }
        function fr(t, e) {
          t.display.sizer.style.minHeight = e.docHeight + "px", t.display.heightForcer.style.top = e.docHeight + "px", t.display.gutters.style.height = e.docHeight + t.display.barHeight + Dn(t) + "px";
        }
        function mr(t) {
          var e = t.display,
            n = e.view;
          if (e.alignWidgets || e.gutters.firstChild && t.options.fixedGutter) {
            for (var i = ui(e) - e.scroller.scrollLeft + t.doc.scrollLeft, r = e.gutters.offsetWidth, a = i + "px", o = 0; o < n.length; o++) if (!n[o].hidden) {
              t.options.fixedGutter && (n[o].gutter && (n[o].gutter.style.left = a), n[o].gutterBackground && (n[o].gutterBackground.style.left = a));
              var s = n[o].alignable;
              if (s) for (var l = 0; l < s.length; l++) s[l].style.left = a;
            }
            t.options.fixedGutter && (e.gutters.style.left = i + r + "px");
          }
        }
        function vr(t) {
          if (!t.options.lineNumbers) return !1;
          var e = t.doc,
            n = re(t.options, e.first + e.size - 1),
            i = t.display;
          if (n.length != i.lineNumChars) {
            var r = i.measure.appendChild(L("div", [L("div", n)], "CodeMirror-linenumber CodeMirror-gutter-elt")),
              a = r.firstChild.offsetWidth,
              o = r.offsetWidth - a;
            return i.lineGutter.style.width = "", i.lineNumInnerWidth = Math.max(a, i.lineGutter.offsetWidth - o) + 1, i.lineNumWidth = i.lineNumInnerWidth + o, i.lineNumChars = i.lineNumInnerWidth ? n.length : -1, i.lineGutter.style.width = i.lineNumWidth + "px", gr(t.display), !0;
          }
          return !1;
        }
        function br(t, e) {
          for (var n = [], i = !1, r = 0; r < t.length; r++) {
            var a = t[r],
              o = null;
            if ("string" != typeof a && (o = a.style, a = a.className), "CodeMirror-linenumbers" == a) {
              if (!e) continue;
              i = !0;
            }
            n.push({
              className: a,
              style: o
            });
          }
          return e && !i && n.push({
            className: "CodeMirror-linenumbers",
            style: null
          }), n;
        }
        function yr(t) {
          var e = t.gutters,
            n = t.gutterSpecs;
          S(e), t.lineGutter = null;
          for (var i = 0; i < n.length; ++i) {
            var r = n[i],
              a = r.className,
              o = r.style,
              s = e.appendChild(L("div", null, "CodeMirror-gutter " + a));
            o && (s.style.cssText = o), "CodeMirror-linenumbers" == a && (t.lineGutter = s, s.style.width = (t.lineNumWidth || 1) + "px");
          }
          e.style.display = n.length ? "" : "none", gr(t);
        }
        function wr(t) {
          yr(t.display), mi(t), mr(t);
        }
        function xr(t, e, i, r) {
          var a = this;
          this.input = i, a.scrollbarFiller = L("div", null, "CodeMirror-scrollbar-filler"), a.scrollbarFiller.setAttribute("cm-not-content", "true"), a.gutterFiller = L("div", null, "CodeMirror-gutter-filler"), a.gutterFiller.setAttribute("cm-not-content", "true"), a.lineDiv = D("div", null, "CodeMirror-code"), a.selectionDiv = L("div", null, null, "position: relative; z-index: 1"), a.cursorDiv = L("div", null, "CodeMirror-cursors"), a.measure = L("div", null, "CodeMirror-measure"), a.lineMeasure = L("div", null, "CodeMirror-measure"), a.lineSpace = D("div", [a.measure, a.lineMeasure, a.selectionDiv, a.cursorDiv, a.lineDiv], null, "position: relative; outline: none");
          var c = D("div", [a.lineSpace], "CodeMirror-lines");
          a.mover = L("div", [c], null, "position: relative"), a.sizer = L("div", [a.mover], "CodeMirror-sizer"), a.sizerWidth = null, a.heightForcer = L("div", null, null, "position: absolute; height: 50px; width: 1px;"), a.gutters = L("div", null, "CodeMirror-gutters"), a.lineGutter = null, a.scroller = L("div", [a.sizer, a.heightForcer, a.gutters], "CodeMirror-scroll"), a.scroller.setAttribute("tabIndex", "-1"), a.wrapper = L("div", [a.scrollbarFiller, a.gutterFiller, a.scroller], "CodeMirror"), d && u >= 105 && (a.wrapper.style.clipPath = "inset(0px)"), a.wrapper.setAttribute("translate", "no"), o && s < 8 && (a.gutters.style.zIndex = -1, a.scroller.style.paddingRight = 0), l || n && b || (a.scroller.draggable = !0), t && (t.appendChild ? t.appendChild(a.wrapper) : t(a.wrapper)), a.viewFrom = a.viewTo = e.first, a.reportedViewFrom = a.reportedViewTo = e.first, a.view = [], a.renderedView = null, a.externalMeasured = null, a.viewOffset = 0, a.lastWrapHeight = a.lastWrapWidth = 0, a.updateLineNumbers = null, a.nativeBarWidth = a.barHeight = a.barWidth = 0, a.scrollbarsClipped = !1, a.lineNumWidth = a.lineNumInnerWidth = a.lineNumChars = null, a.alignWidgets = !1, a.cachedCharWidth = a.cachedTextHeight = a.cachedPaddingH = null, a.maxLine = null, a.maxLineLength = 0, a.maxLineChanged = !1, a.wheelDX = a.wheelDY = a.wheelStartX = a.wheelStartY = null, a.shift = !1, a.selForContextMenu = null, a.activeTouch = null, a.gutterSpecs = br(r.gutters, r.lineNumbers), yr(a), i.init(a);
        }
        dr.prototype.signal = function (t, e) {
          jt(t, e) && this.events.push(arguments);
        }, dr.prototype.finish = function () {
          for (var t = 0; t < this.events.length; t++) yt.apply(null, this.events[t]);
        };
        var jr = 0,
          Cr = null;
        function Mr(t) {
          var e = t.wheelDeltaX,
            n = t.wheelDeltaY;
          return null == e && t.detail && t.axis == t.HORIZONTAL_AXIS && (e = t.detail), null == n && t.detail && t.axis == t.VERTICAL_AXIS ? n = t.detail : null == n && (n = t.wheelDelta), {
            x: e,
            y: n
          };
        }
        function kr(t) {
          var e = Mr(t);
          return e.x *= Cr, e.y *= Cr, e;
        }
        function Or(t, e) {
          d && 102 == u && (null == t.display.chromeScrollHack ? t.display.sizer.style.pointerEvents = "none" : clearTimeout(t.display.chromeScrollHack), t.display.chromeScrollHack = setTimeout(function () {
            t.display.chromeScrollHack = null, t.display.sizer.style.pointerEvents = "";
          }, 100));
          var i = Mr(e),
            r = i.x,
            a = i.y,
            o = Cr;
          0 === e.deltaMode && (r = e.deltaX, a = e.deltaY, o = 1);
          var s = t.display,
            c = s.scroller,
            p = c.scrollWidth > c.clientWidth,
            g = c.scrollHeight > c.clientHeight;
          if (r && p || a && g) {
            if (a && y && l) t: for (var f = e.target, m = s.view; f != c; f = f.parentNode) for (var v = 0; v < m.length; v++) if (m[v].node == f) {
              t.display.currentWheelTarget = f;
              break t;
            }
            if (r && !n && !h && null != o) return a && g && Fi(t, Math.max(0, c.scrollTop + a * o)), Bi(t, Math.max(0, c.scrollLeft + r * o)), (!a || a && g) && Mt(e), void (s.wheelStartX = null);
            if (a && null != o) {
              var b = a * o,
                w = t.doc.scrollTop,
                x = w + s.wrapper.clientHeight;
              b < 0 ? w = Math.max(0, w + b - 50) : x = Math.min(t.doc.height, x + b + 50), pr(t, {
                top: w,
                bottom: x
              });
            }
            jr < 20 && 0 !== e.deltaMode && (null == s.wheelStartX ? (s.wheelStartX = c.scrollLeft, s.wheelStartY = c.scrollTop, s.wheelDX = r, s.wheelDY = a, setTimeout(function () {
              if (null != s.wheelStartX) {
                var t = c.scrollLeft - s.wheelStartX,
                  e = c.scrollTop - s.wheelStartY,
                  n = e && s.wheelDY && e / s.wheelDY || t && s.wheelDX && t / s.wheelDX;
                s.wheelStartX = s.wheelStartY = null, n && (Cr = (Cr * jr + n) / (jr + 1), ++jr);
              }
            }, 200)) : (s.wheelDX += r, s.wheelDY += a));
          }
        }
        o ? Cr = -.53 : n ? Cr = 15 : d ? Cr = -.7 : p && (Cr = -1 / 3);
        var Tr = function Tr(t, e) {
          this.ranges = t, this.primIndex = e;
        };
        Tr.prototype.primary = function () {
          return this.ranges[this.primIndex];
        }, Tr.prototype.equals = function (t) {
          if (t == this) return !0;
          if (t.primIndex != this.primIndex || t.ranges.length != this.ranges.length) return !1;
          for (var e = 0; e < this.ranges.length; e++) {
            var n = this.ranges[e],
              i = t.ranges[e];
            if (!se(n.anchor, i.anchor) || !se(n.head, i.head)) return !1;
          }
          return !0;
        }, Tr.prototype.deepCopy = function () {
          for (var t = [], e = 0; e < this.ranges.length; e++) t[e] = new Sr(le(this.ranges[e].anchor), le(this.ranges[e].head));
          return new Tr(t, this.primIndex);
        }, Tr.prototype.somethingSelected = function () {
          for (var t = 0; t < this.ranges.length; t++) if (!this.ranges[t].empty()) return !0;
          return !1;
        }, Tr.prototype.contains = function (t, e) {
          e || (e = t);
          for (var n = 0; n < this.ranges.length; n++) {
            var i = this.ranges[n];
            if (oe(e, i.from()) >= 0 && oe(t, i.to()) <= 0) return n;
          }
          return -1;
        };
        var Sr = function Sr(t, e) {
          this.anchor = t, this.head = e;
        };
        function Nr(t, e, n) {
          var i = t && t.options.selectionsMayTouch,
            r = e[n];
          e.sort(function (t, e) {
            return oe(t.from(), e.from());
          }), n = U(e, r);
          for (var a = 1; a < e.length; a++) {
            var o = e[a],
              s = e[a - 1],
              l = oe(s.to(), o.from());
            if (i && !o.empty() ? l > 0 : l >= 0) {
              var c = de(s.from(), o.from()),
                d = ce(s.to(), o.to()),
                u = s.empty() ? o.from() == o.head : s.from() == s.head;
              a <= n && --n, e.splice(--a, 2, new Sr(u ? d : c, u ? c : d));
            }
          }
          return new Tr(e, n);
        }
        function Lr(t, e) {
          return new Tr([new Sr(t, e || t)], 0);
        }
        function Dr(t) {
          return t.text ? ae(t.from.line + t.text.length - 1, K(t.text).length + (1 == t.text.length ? t.from.ch : 0)) : t.to;
        }
        function Er(t, e) {
          if (oe(t, e.from) < 0) return t;
          if (oe(t, e.to) <= 0) return Dr(e);
          var n = t.line + e.text.length - (e.to.line - e.from.line) - 1,
            i = t.ch;
          return t.line == e.to.line && (i += Dr(e).ch - e.to.ch), ae(n, i);
        }
        function Ir(t, e) {
          for (var n = [], i = 0; i < t.sel.ranges.length; i++) {
            var r = t.sel.ranges[i];
            n.push(new Sr(Er(r.anchor, e), Er(r.head, e)));
          }
          return Nr(t.cm, n, t.sel.primIndex);
        }
        function Pr(t, e, n) {
          return t.line == e.line ? ae(n.line, t.ch - e.ch + n.ch) : ae(n.line + (t.line - e.line), t.ch);
        }
        function Ar(t) {
          t.doc.mode = Yt(t.options, t.doc.modeOption), zr(t);
        }
        function zr(t) {
          t.doc.iter(function (t) {
            t.stateAfter && (t.stateAfter = null), t.styles && (t.styles = null);
          }), t.doc.modeFrontier = t.doc.highlightFrontier = t.doc.first, lr(t, 100), t.state.modeGen++, t.curOp && mi(t);
        }
        function _r(t, e) {
          return 0 == e.from.ch && 0 == e.to.ch && "" == K(e.text) && (!t.cm || t.cm.options.wholeLineUpdateBefore);
        }
        function Hr(t, e, n, i) {
          function r(t) {
            return n ? n[t] : null;
          }
          function a(t, n, r) {
            !function (t, e, n, i) {
              t.text = e, t.stateAfter && (t.stateAfter = null), t.styles && (t.styles = null), null != t.order && (t.order = null), Ie(t), Pe(t, n);
              var r = i ? i(t) : 1;
              r != t.height && te(t, r);
            }(t, n, r, i), pn(t, "change", t, e);
          }
          function o(t, e) {
            for (var n = [], a = t; a < e; ++a) n.push(new Je(c[a], r(a), i));
            return n;
          }
          var s = e.from,
            l = e.to,
            c = e.text,
            d = Jt(t, s.line),
            u = Jt(t, l.line),
            h = K(c),
            p = r(c.length - 1),
            g = l.line - s.line;
          if (e.full) t.insert(0, o(0, c.length)), t.remove(c.length, t.size - c.length);else if (_r(t, e)) {
            var f = o(0, c.length - 1);
            a(u, u.text, p), g && t.remove(s.line, g), f.length && t.insert(s.line, f);
          } else if (d == u) {
            if (1 == c.length) a(d, d.text.slice(0, s.ch) + h + d.text.slice(l.ch), p);else {
              var m = o(1, c.length - 1);
              m.push(new Je(h + d.text.slice(l.ch), p, i)), a(d, d.text.slice(0, s.ch) + c[0], r(0)), t.insert(s.line + 1, m);
            }
          } else if (1 == c.length) a(d, d.text.slice(0, s.ch) + c[0] + u.text.slice(l.ch), r(0)), t.remove(s.line + 1, g);else {
            a(d, d.text.slice(0, s.ch) + c[0], r(0)), a(u, h + u.text.slice(l.ch), p);
            var v = o(1, c.length - 1);
            g > 1 && t.remove(s.line + 1, g - 1), t.insert(s.line + 1, v);
          }
          pn(t, "change", t, e);
        }
        function Vr(t, e, n) {
          !function t(i, r, a) {
            if (i.linked) for (var o = 0; o < i.linked.length; ++o) {
              var s = i.linked[o];
              if (s.doc != r) {
                var l = a && s.sharedHist;
                n && !l || (e(s.doc, l), t(s.doc, i, l));
              }
            }
          }(t, null, !0);
        }
        function Fr(t, e) {
          if (e.cm) throw new Error("This document is already in use.");
          t.doc = e, e.cm = t, pi(t), Ar(t), Rr(t), t.options.direction = e.direction, t.options.lineWrapping || Qe(t), t.options.mode = e.modeOption, mi(t);
        }
        function Rr(t) {
          ("rtl" == t.doc.direction ? P : T)(t.display.lineDiv, "CodeMirror-rtl");
        }
        function Br(t) {
          this.done = [], this.undone = [], this.undoDepth = t ? t.undoDepth : 1 / 0, this.lastModTime = this.lastSelTime = 0, this.lastOp = this.lastSelOp = null, this.lastOrigin = this.lastSelOrigin = null, this.generation = this.maxGeneration = t ? t.maxGeneration : 1;
        }
        function Wr(t, e) {
          var n = {
            from: le(e.from),
            to: Dr(e),
            text: Xt(t, e.from, e.to)
          };
          return Gr(t, n, e.from.line, e.to.line + 1), Vr(t, function (t) {
            return Gr(t, n, e.from.line, e.to.line + 1);
          }, !0), n;
        }
        function Yr(t) {
          for (; t.length && K(t).ranges;) t.pop();
        }
        function Ur(t, e, n, i) {
          var r = t.history;
          r.undone.length = 0;
          var a,
            o,
            s = +new Date();
          if ((r.lastOp == i || r.lastOrigin == e.origin && e.origin && ("+" == e.origin.charAt(0) && r.lastModTime > s - (t.cm ? t.cm.options.historyEventDelay : 500) || "*" == e.origin.charAt(0))) && (a = function (t, e) {
            return e ? (Yr(t.done), K(t.done)) : t.done.length && !K(t.done).ranges ? K(t.done) : t.done.length > 1 && !t.done[t.done.length - 2].ranges ? (t.done.pop(), K(t.done)) : void 0;
          }(r, r.lastOp == i))) o = K(a.changes), 0 == oe(e.from, e.to) && 0 == oe(e.from, o.to) ? o.to = Dr(e) : a.changes.push(Wr(t, e));else {
            var l = K(r.done);
            for (l && l.ranges || Zr(t.sel, r.done), a = {
              changes: [Wr(t, e)],
              generation: r.generation
            }, r.done.push(a); r.done.length > r.undoDepth;) r.done.shift(), r.done[0].ranges || r.done.shift();
          }
          r.done.push(n), r.generation = ++r.maxGeneration, r.lastModTime = r.lastSelTime = s, r.lastOp = r.lastSelOp = i, r.lastOrigin = r.lastSelOrigin = e.origin, o || yt(t, "historyAdded");
        }
        function Zr(t, e) {
          var n = K(e);
          n && n.ranges && n.equals(t) || e.push(t);
        }
        function Gr(t, e, n, i) {
          var r = e["spans_" + t.id],
            a = 0;
          t.iter(Math.max(t.first, n), Math.min(t.first + t.size, i), function (n) {
            n.markedSpans && ((r || (r = e["spans_" + t.id] = {}))[a] = n.markedSpans), ++a;
          });
        }
        function qr(t) {
          if (!t) return null;
          for (var e, n = 0; n < t.length; ++n) t[n].marker.explicitlyCleared ? e || (e = t.slice(0, n)) : e && e.push(t[n]);
          return e ? e.length ? e : null : t;
        }
        function $r(t, e) {
          var n = function (t, e) {
              var n = e["spans_" + t.id];
              if (!n) return null;
              for (var i = [], r = 0; r < e.text.length; ++r) i.push(qr(n[r]));
              return i;
            }(t, e),
            i = De(t, e);
          if (!n) return i;
          if (!i) return n;
          for (var r = 0; r < n.length; ++r) {
            var a = n[r],
              o = i[r];
            if (a && o) t: for (var s = 0; s < o.length; ++s) {
              for (var l = o[s], c = 0; c < a.length; ++c) if (a[c].marker == l.marker) continue t;
              a.push(l);
            } else o && (n[r] = o);
          }
          return n;
        }
        function Qr(t, e, n) {
          for (var i = [], r = 0; r < t.length; ++r) {
            var a = t[r];
            if (a.ranges) i.push(n ? Tr.prototype.deepCopy.call(a) : a);else {
              var o = a.changes,
                s = [];
              i.push({
                changes: s
              });
              for (var l = 0; l < o.length; ++l) {
                var c = o[l],
                  d = void 0;
                if (s.push({
                  from: c.from,
                  to: c.to,
                  text: c.text
                }), e) for (var u in c) (d = u.match(/^spans_(\d+)$/)) && U(e, Number(d[1])) > -1 && (K(s)[u] = c[u], delete c[u]);
              }
            }
          }
          return i;
        }
        function Jr(t, e, n, i) {
          if (i) {
            var r = t.anchor;
            if (n) {
              var a = oe(e, r) < 0;
              a != oe(n, r) < 0 ? (r = e, e = n) : a != oe(e, n) < 0 && (e = n);
            }
            return new Sr(r, e);
          }
          return new Sr(n || e, e);
        }
        function Xr(t, e, n, i, r) {
          null == r && (r = t.cm && (t.cm.display.shift || t.extend)), ia(t, new Tr([Jr(t.sel.primary(), e, n, r)], 0), i);
        }
        function Kr(t, e, n) {
          for (var i = [], r = t.cm && (t.cm.display.shift || t.extend), a = 0; a < t.sel.ranges.length; a++) i[a] = Jr(t.sel.ranges[a], e[a], null, r);
          ia(t, Nr(t.cm, i, t.sel.primIndex), n);
        }
        function ta(t, e, n, i) {
          var r = t.sel.ranges.slice(0);
          r[e] = n, ia(t, Nr(t.cm, r, t.sel.primIndex), i);
        }
        function ea(t, e, n, i) {
          ia(t, Lr(e, n), i);
        }
        function na(t, e, n) {
          var i = t.history.done,
            r = K(i);
          r && r.ranges ? (i[i.length - 1] = e, ra(t, e, n)) : ia(t, e, n);
        }
        function ia(t, e, n) {
          ra(t, e, n), function (t, e, n, i) {
            var r = t.history,
              a = i && i.origin;
            n == r.lastSelOp || a && r.lastSelOrigin == a && (r.lastModTime == r.lastSelTime && r.lastOrigin == a || function (t, e, n, i) {
              var r = e.charAt(0);
              return "*" == r || "+" == r && n.ranges.length == i.ranges.length && n.somethingSelected() == i.somethingSelected() && new Date() - t.history.lastSelTime <= (t.cm ? t.cm.options.historyEventDelay : 500);
            }(t, a, K(r.done), e)) ? r.done[r.done.length - 1] = e : Zr(e, r.done), r.lastSelTime = +new Date(), r.lastSelOrigin = a, r.lastSelOp = n, i && !1 !== i.clearRedo && Yr(r.undone);
          }(t, t.sel, t.cm ? t.cm.curOp.id : NaN, n);
        }
        function ra(t, e, n) {
          (jt(t, "beforeSelectionChange") || t.cm && jt(t.cm, "beforeSelectionChange")) && (e = function (t, e, n) {
            var i = {
              ranges: e.ranges,
              update: function update(e) {
                this.ranges = [];
                for (var n = 0; n < e.length; n++) this.ranges[n] = new Sr(he(t, e[n].anchor), he(t, e[n].head));
              },
              origin: n && n.origin
            };
            return yt(t, "beforeSelectionChange", t, i), t.cm && yt(t.cm, "beforeSelectionChange", t.cm, i), i.ranges != e.ranges ? Nr(t.cm, i.ranges, i.ranges.length - 1) : e;
          }(t, e, n));
          var i = n && n.bias || (oe(e.primary().head, t.sel.primary().head) < 0 ? -1 : 1);
          aa(t, sa(t, e, i, !0)), n && !1 === n.scroll || !t.cm || "nocursor" == t.cm.getOption("readOnly") || zi(t.cm);
        }
        function aa(t, e) {
          e.equals(t.sel) || (t.sel = e, t.cm && (t.cm.curOp.updateInput = 1, t.cm.curOp.selectionChanged = !0, xt(t.cm)), pn(t, "cursorActivity", t));
        }
        function oa(t) {
          aa(t, sa(t, t.sel, null, !1));
        }
        function sa(t, e, n, i) {
          for (var r, a = 0; a < e.ranges.length; a++) {
            var o = e.ranges[a],
              s = e.ranges.length == t.sel.ranges.length && t.sel.ranges[a],
              l = ca(t, o.anchor, s && s.anchor, n, i),
              c = o.head == o.anchor ? l : ca(t, o.head, s && s.head, n, i);
            (r || l != o.anchor || c != o.head) && (r || (r = e.ranges.slice(0, a)), r[a] = new Sr(l, c));
          }
          return r ? Nr(t.cm, r, e.primIndex) : e;
        }
        function la(t, e, n, i, r) {
          var a = Jt(t, e.line);
          if (a.markedSpans) for (var o = 0; o < a.markedSpans.length; ++o) {
            var s = a.markedSpans[o],
              l = s.marker,
              c = "selectLeft" in l ? !l.selectLeft : l.inclusiveLeft,
              d = "selectRight" in l ? !l.selectRight : l.inclusiveRight;
            if ((null == s.from || (c ? s.from <= e.ch : s.from < e.ch)) && (null == s.to || (d ? s.to >= e.ch : s.to > e.ch))) {
              if (r && (yt(l, "beforeCursorEnter"), l.explicitlyCleared)) {
                if (a.markedSpans) {
                  --o;
                  continue;
                }
                break;
              }
              if (!l.atomic) continue;
              if (n) {
                var u = l.find(i < 0 ? 1 : -1),
                  h = void 0;
                if ((i < 0 ? d : c) && (u = da(t, u, -i, u && u.line == e.line ? a : null)), u && u.line == e.line && (h = oe(u, n)) && (i < 0 ? h < 0 : h > 0)) return la(t, u, e, i, r);
              }
              var p = l.find(i < 0 ? -1 : 1);
              return (i < 0 ? c : d) && (p = da(t, p, i, p.line == e.line ? a : null)), p ? la(t, p, e, i, r) : null;
            }
          }
          return e;
        }
        function ca(t, e, n, i, r) {
          var a = i || 1;
          return la(t, e, n, a, r) || !r && la(t, e, n, a, !0) || la(t, e, n, -a, r) || !r && la(t, e, n, -a, !0) || (t.cantEdit = !0, ae(t.first, 0));
        }
        function da(t, e, n, i) {
          return n < 0 && 0 == e.ch ? e.line > t.first ? he(t, ae(e.line - 1)) : null : n > 0 && e.ch == (i || Jt(t, e.line)).text.length ? e.line < t.first + t.size - 1 ? ae(e.line + 1, 0) : null : new ae(e.line, e.ch + n);
        }
        function ua(t) {
          t.setSelection(ae(t.firstLine(), 0), ae(t.lastLine()), G);
        }
        function ha(t, e, n) {
          var i = {
            canceled: !1,
            from: e.from,
            to: e.to,
            text: e.text,
            origin: e.origin,
            cancel: function cancel() {
              return i.canceled = !0;
            }
          };
          return n && (i.update = function (e, n, r, a) {
            e && (i.from = he(t, e)), n && (i.to = he(t, n)), r && (i.text = r), void 0 !== a && (i.origin = a);
          }), yt(t, "beforeChange", t, i), t.cm && yt(t.cm, "beforeChange", t.cm, i), i.canceled ? (t.cm && (t.cm.curOp.updateInput = 2), null) : {
            from: i.from,
            to: i.to,
            text: i.text,
            origin: i.origin
          };
        }
        function pa(t, e, n) {
          if (t.cm) {
            if (!t.cm.curOp) return ar(t.cm, pa)(t, e, n);
            if (t.cm.state.suppressEdits) return;
          }
          if (!(jt(t, "beforeChange") || t.cm && jt(t.cm, "beforeChange")) || (e = ha(t, e, !0))) {
            var i = Oe && !n && function (t, e, n) {
              var i = null;
              if (t.iter(e.line, n.line + 1, function (t) {
                if (t.markedSpans) for (var e = 0; e < t.markedSpans.length; ++e) {
                  var n = t.markedSpans[e].marker;
                  !n.readOnly || i && -1 != U(i, n) || (i || (i = [])).push(n);
                }
              }), !i) return null;
              for (var r = [{
                  from: e,
                  to: n
                }], a = 0; a < i.length; ++a) for (var o = i[a], s = o.find(0), l = 0; l < r.length; ++l) {
                var c = r[l];
                if (!(oe(c.to, s.from) < 0 || oe(c.from, s.to) > 0)) {
                  var d = [l, 1],
                    u = oe(c.from, s.from),
                    h = oe(c.to, s.to);
                  (u < 0 || !o.inclusiveLeft && !u) && d.push({
                    from: c.from,
                    to: s.from
                  }), (h > 0 || !o.inclusiveRight && !h) && d.push({
                    from: s.to,
                    to: c.to
                  }), r.splice.apply(r, d), l += d.length - 3;
                }
              }
              return r;
            }(t, e.from, e.to);
            if (i) for (var r = i.length - 1; r >= 0; --r) ga(t, {
              from: i[r].from,
              to: i[r].to,
              text: r ? [""] : e.text,
              origin: e.origin
            });else ga(t, e);
          }
        }
        function ga(t, e) {
          if (1 != e.text.length || "" != e.text[0] || 0 != oe(e.from, e.to)) {
            var n = Ir(t, e);
            Ur(t, e, n, t.cm ? t.cm.curOp.id : NaN), va(t, e, n, De(t, e));
            var i = [];
            Vr(t, function (t, n) {
              n || -1 != U(i, t.history) || (xa(t.history, e), i.push(t.history)), va(t, e, null, De(t, e));
            });
          }
        }
        function fa(t, e, n) {
          var i = t.cm && t.cm.state.suppressEdits;
          if (!i || n) {
            for (var r, a = t.history, o = t.sel, s = "undo" == e ? a.done : a.undone, l = "undo" == e ? a.undone : a.done, c = 0; c < s.length && (r = s[c], n ? !r.ranges || r.equals(t.sel) : r.ranges); c++);
            if (c != s.length) {
              for (a.lastOrigin = a.lastSelOrigin = null;;) {
                if (!(r = s.pop()).ranges) {
                  if (i) return void s.push(r);
                  break;
                }
                if (Zr(r, l), n && !r.equals(t.sel)) return void ia(t, r, {
                  clearRedo: !1
                });
                o = r;
              }
              var d = [];
              Zr(o, l), l.push({
                changes: d,
                generation: a.generation
              }), a.generation = r.generation || ++a.maxGeneration;
              for (var u = jt(t, "beforeChange") || t.cm && jt(t.cm, "beforeChange"), h = function h(n) {
                  var i = r.changes[n];
                  if (i.origin = e, u && !ha(t, i, !1)) return s.length = 0, {};
                  d.push(Wr(t, i));
                  var a = n ? Ir(t, i) : K(s);
                  va(t, i, a, $r(t, i)), !n && t.cm && t.cm.scrollIntoView({
                    from: i.from,
                    to: Dr(i)
                  });
                  var o = [];
                  Vr(t, function (t, e) {
                    e || -1 != U(o, t.history) || (xa(t.history, i), o.push(t.history)), va(t, i, null, $r(t, i));
                  });
                }, p = r.changes.length - 1; p >= 0; --p) {
                var g = h(p);
                if (g) return g.v;
              }
            }
          }
        }
        function ma(t, e) {
          if (0 != e && (t.first += e, t.sel = new Tr(tt(t.sel.ranges, function (t) {
            return new Sr(ae(t.anchor.line + e, t.anchor.ch), ae(t.head.line + e, t.head.ch));
          }), t.sel.primIndex), t.cm)) {
            mi(t.cm, t.first, t.first - e, e);
            for (var n = t.cm.display, i = n.viewFrom; i < n.viewTo; i++) vi(t.cm, i, "gutter");
          }
        }
        function va(t, e, n, i) {
          if (t.cm && !t.cm.curOp) return ar(t.cm, va)(t, e, n, i);
          if (e.to.line < t.first) ma(t, e.text.length - 1 - (e.to.line - e.from.line));else if (!(e.from.line > t.lastLine())) {
            if (e.from.line < t.first) {
              var r = e.text.length - 1 - (t.first - e.from.line);
              ma(t, r), e = {
                from: ae(t.first, 0),
                to: ae(e.to.line + r, e.to.ch),
                text: [K(e.text)],
                origin: e.origin
              };
            }
            var a = t.lastLine();
            e.to.line > a && (e = {
              from: e.from,
              to: ae(a, Jt(t, a).text.length),
              text: [e.text[0]],
              origin: e.origin
            }), e.removed = Xt(t, e.from, e.to), n || (n = Ir(t, e)), t.cm ? function (t, e, n) {
              var i = t.doc,
                r = t.display,
                a = e.from,
                o = e.to,
                s = !1,
                l = a.line;
              t.options.lineWrapping || (l = ee(We(Jt(i, a.line))), i.iter(l, o.line + 1, function (t) {
                if (t == r.maxLine) return s = !0, !0;
              })), i.sel.contains(e.from, e.to) > -1 && xt(t), Hr(i, e, n, hi(t)), t.options.lineWrapping || (i.iter(l, a.line + e.text.length, function (t) {
                var e = $e(t);
                e > r.maxLineLength && (r.maxLine = t, r.maxLineLength = e, r.maxLineChanged = !0, s = !1);
              }), s && (t.curOp.updateMaxLine = !0)), function (t, e) {
                if (t.modeFrontier = Math.min(t.modeFrontier, e), !(t.highlightFrontier < e - 10)) {
                  for (var n = t.first, i = e - 1; i > n; i--) {
                    var r = Jt(t, i).stateAfter;
                    if (r && (!(r instanceof ge) || i + r.lookAhead < e)) {
                      n = i + 1;
                      break;
                    }
                  }
                  t.highlightFrontier = Math.min(t.highlightFrontier, n);
                }
              }(i, a.line), lr(t, 400);
              var c = e.text.length - (o.line - a.line) - 1;
              e.full ? mi(t) : a.line != o.line || 1 != e.text.length || _r(t.doc, e) ? mi(t, a.line, o.line + 1, c) : vi(t, a.line, "text");
              var d = jt(t, "changes"),
                u = jt(t, "change");
              if (u || d) {
                var h = {
                  from: a,
                  to: o,
                  text: e.text,
                  removed: e.removed,
                  origin: e.origin
                };
                u && pn(t, "change", t, h), d && (t.curOp.changeObjs || (t.curOp.changeObjs = [])).push(h);
              }
              t.display.selForContextMenu = null;
            }(t.cm, e, i) : Hr(t, e, i), ra(t, n, G), t.cantEdit && ca(t, ae(t.firstLine(), 0)) && (t.cantEdit = !1);
          }
        }
        function ba(t, e, n, i, r) {
          var a;
          i || (i = n), oe(i, n) < 0 && (n = (a = [i, n])[0], i = a[1]), "string" == typeof e && (e = t.splitLines(e)), pa(t, {
            from: n,
            to: i,
            text: e,
            origin: r
          });
        }
        function ya(t, e, n, i) {
          n < t.line ? t.line += i : e < t.line && (t.line = e, t.ch = 0);
        }
        function wa(t, e, n, i) {
          for (var r = 0; r < t.length; ++r) {
            var a = t[r],
              o = !0;
            if (a.ranges) {
              a.copied || ((a = t[r] = a.deepCopy()).copied = !0);
              for (var s = 0; s < a.ranges.length; s++) ya(a.ranges[s].anchor, e, n, i), ya(a.ranges[s].head, e, n, i);
            } else {
              for (var l = 0; l < a.changes.length; ++l) {
                var c = a.changes[l];
                if (n < c.from.line) c.from = ae(c.from.line + i, c.from.ch), c.to = ae(c.to.line + i, c.to.ch);else if (e <= c.to.line) {
                  o = !1;
                  break;
                }
              }
              o || (t.splice(0, r + 1), r = 0);
            }
          }
        }
        function xa(t, e) {
          var n = e.from.line,
            i = e.to.line,
            r = e.text.length - (i - n) - 1;
          wa(t.done, n, i, r), wa(t.undone, n, i, r);
        }
        function ja(t, e, n, i) {
          var r = e,
            a = e;
          return "number" == typeof e ? a = Jt(t, ue(t, e)) : r = ee(e), null == r ? null : (i(a, r) && t.cm && vi(t.cm, r, n), a);
        }
        function Ca(t) {
          this.lines = t, this.parent = null;
          for (var e = 0, n = 0; n < t.length; ++n) t[n].parent = this, e += t[n].height;
          this.height = e;
        }
        function Ma(t) {
          this.children = t;
          for (var e = 0, n = 0, i = 0; i < t.length; ++i) {
            var r = t[i];
            e += r.chunkSize(), n += r.height, r.parent = this;
          }
          this.size = e, this.height = n, this.parent = null;
        }
        Sr.prototype.from = function () {
          return de(this.anchor, this.head);
        }, Sr.prototype.to = function () {
          return ce(this.anchor, this.head);
        }, Sr.prototype.empty = function () {
          return this.head.line == this.anchor.line && this.head.ch == this.anchor.ch;
        }, Ca.prototype = {
          chunkSize: function chunkSize() {
            return this.lines.length;
          },
          removeInner: function removeInner(t, e) {
            for (var n = t, i = t + e; n < i; ++n) {
              var r = this.lines[n];
              this.height -= r.height, Xe(r), pn(r, "delete");
            }
            this.lines.splice(t, e);
          },
          collapse: function collapse(t) {
            t.push.apply(t, this.lines);
          },
          insertInner: function insertInner(t, e, n) {
            this.height += n, this.lines = this.lines.slice(0, t).concat(e).concat(this.lines.slice(t));
            for (var i = 0; i < e.length; ++i) e[i].parent = this;
          },
          iterN: function iterN(t, e, n) {
            for (var i = t + e; t < i; ++t) if (n(this.lines[t])) return !0;
          }
        }, Ma.prototype = {
          chunkSize: function chunkSize() {
            return this.size;
          },
          removeInner: function removeInner(t, e) {
            this.size -= e;
            for (var n = 0; n < this.children.length; ++n) {
              var i = this.children[n],
                r = i.chunkSize();
              if (t < r) {
                var a = Math.min(e, r - t),
                  o = i.height;
                if (i.removeInner(t, a), this.height -= o - i.height, r == a && (this.children.splice(n--, 1), i.parent = null), 0 == (e -= a)) break;
                t = 0;
              } else t -= r;
            }
            if (this.size - e < 25 && (this.children.length > 1 || !(this.children[0] instanceof Ca))) {
              var s = [];
              this.collapse(s), this.children = [new Ca(s)], this.children[0].parent = this;
            }
          },
          collapse: function collapse(t) {
            for (var e = 0; e < this.children.length; ++e) this.children[e].collapse(t);
          },
          insertInner: function insertInner(t, e, n) {
            this.size += e.length, this.height += n;
            for (var i = 0; i < this.children.length; ++i) {
              var r = this.children[i],
                a = r.chunkSize();
              if (t <= a) {
                if (r.insertInner(t, e, n), r.lines && r.lines.length > 50) {
                  for (var o = r.lines.length % 25 + 25, s = o; s < r.lines.length;) {
                    var l = new Ca(r.lines.slice(s, s += 25));
                    r.height -= l.height, this.children.splice(++i, 0, l), l.parent = this;
                  }
                  r.lines = r.lines.slice(0, o), this.maybeSpill();
                }
                break;
              }
              t -= a;
            }
          },
          maybeSpill: function maybeSpill() {
            if (!(this.children.length <= 10)) {
              var t = this;
              do {
                var e = new Ma(t.children.splice(t.children.length - 5, 5));
                if (t.parent) {
                  t.size -= e.size, t.height -= e.height;
                  var n = U(t.parent.children, t);
                  t.parent.children.splice(n + 1, 0, e);
                } else {
                  var i = new Ma(t.children);
                  i.parent = t, t.children = [i, e], t = i;
                }
                e.parent = t.parent;
              } while (t.children.length > 10);
              t.parent.maybeSpill();
            }
          },
          iterN: function iterN(t, e, n) {
            for (var i = 0; i < this.children.length; ++i) {
              var r = this.children[i],
                a = r.chunkSize();
              if (t < a) {
                var o = Math.min(e, a - t);
                if (r.iterN(t, o, n)) return !0;
                if (0 == (e -= o)) break;
                t = 0;
              } else t -= a;
            }
          }
        };
        var ka = function ka(t, e, n) {
          if (n) for (var i in n) n.hasOwnProperty(i) && (this[i] = n[i]);
          this.doc = t, this.node = e;
        };
        function Oa(t, e, n) {
          qe(e) < (t.curOp && t.curOp.scrollTop || t.doc.scrollTop) && Ai(t, n);
        }
        ka.prototype.clear = function () {
          var t = this.doc.cm,
            e = this.line.widgets,
            n = this.line,
            i = ee(n);
          if (null != i && e) {
            for (var r = 0; r < e.length; ++r) e[r] == this && e.splice(r--, 1);
            e.length || (n.widgets = null);
            var a = On(this);
            te(n, Math.max(0, n.height - a)), t && (rr(t, function () {
              Oa(t, n, -a), vi(t, i, "widget");
            }), pn(t, "lineWidgetCleared", t, this, i));
          }
        }, ka.prototype.changed = function () {
          var t = this,
            e = this.height,
            n = this.doc.cm,
            i = this.line;
          this.height = null;
          var r = On(this) - e;
          r && (Ze(this.doc, i) || te(i, i.height + r), n && rr(n, function () {
            n.curOp.forceUpdate = !0, Oa(n, i, r), pn(n, "lineWidgetChanged", n, t, ee(i));
          }));
        }, Ct(ka);
        var Ta = 0,
          Sa = function Sa(t, e) {
            this.lines = [], this.type = e, this.doc = t, this.id = ++Ta;
          };
        function Na(t, e, n, i, r) {
          if (i && i.shared) return function (t, e, n, i, r) {
            (i = B(i)).shared = !1;
            var a = [Na(t, e, n, i, r)],
              o = a[0],
              s = i.widgetNode;
            return Vr(t, function (t) {
              s && (i.widgetNode = s.cloneNode(!0)), a.push(Na(t, he(t, e), he(t, n), i, r));
              for (var l = 0; l < t.linked.length; ++l) if (t.linked[l].isParent) return;
              o = K(a);
            }), new La(a, o);
          }(t, e, n, i, r);
          if (t.cm && !t.cm.curOp) return ar(t.cm, Na)(t, e, n, i, r);
          var a = new Sa(t, r),
            o = oe(e, n);
          if (i && B(i, a, !1), o > 0 || 0 == o && !1 !== a.clearWhenEmpty) return a;
          if (a.replacedWith && (a.collapsed = !0, a.widgetNode = D("span", [a.replacedWith], "CodeMirror-widget"), i.handleMouseEvents || a.widgetNode.setAttribute("cm-ignore-events", "true"), i.insertLeft && (a.widgetNode.insertLeft = !0)), a.collapsed) {
            if (Be(t, e.line, e, n, a) || e.line != n.line && Be(t, n.line, e, n, a)) throw new Error("Inserting collapsed marker partially overlapping an existing one");
            Te = !0;
          }
          a.addToHistory && Ur(t, {
            from: e,
            to: n,
            origin: "markText"
          }, t.sel, NaN);
          var s,
            l = e.line,
            c = t.cm;
          if (t.iter(l, n.line + 1, function (i) {
            c && a.collapsed && !c.options.lineWrapping && We(i) == c.display.maxLine && (s = !0), a.collapsed && l != e.line && te(i, 0), function (t, e, n) {
              var i = n && window.WeakSet && (n.markedSpans || (n.markedSpans = new WeakSet()));
              i && t.markedSpans && i.has(t.markedSpans) ? t.markedSpans.push(e) : (t.markedSpans = t.markedSpans ? t.markedSpans.concat([e]) : [e], i && i.add(t.markedSpans)), e.marker.attachLine(t);
            }(i, new Se(a, l == e.line ? e.ch : null, l == n.line ? n.ch : null), t.cm && t.cm.curOp), ++l;
          }), a.collapsed && t.iter(e.line, n.line + 1, function (e) {
            Ze(t, e) && te(e, 0);
          }), a.clearOnEnter && mt(a, "beforeCursorEnter", function () {
            return a.clear();
          }), a.readOnly && (Oe = !0, (t.history.done.length || t.history.undone.length) && t.clearHistory()), a.collapsed && (a.id = ++Ta, a.atomic = !0), c) {
            if (s && (c.curOp.updateMaxLine = !0), a.collapsed) mi(c, e.line, n.line + 1);else if (a.className || a.startStyle || a.endStyle || a.css || a.attributes || a.title) for (var d = e.line; d <= n.line; d++) vi(c, d, "text");
            a.atomic && oa(c.doc), pn(c, "markerAdded", c, a);
          }
          return a;
        }
        Sa.prototype.clear = function () {
          if (!this.explicitlyCleared) {
            var t = this.doc.cm,
              e = t && !t.curOp;
            if (e && Ji(t), jt(this, "clear")) {
              var n = this.find();
              n && pn(this, "clear", n.from, n.to);
            }
            for (var i = null, r = null, a = 0; a < this.lines.length; ++a) {
              var o = this.lines[a],
                s = Ne(o.markedSpans, this);
              t && !this.collapsed ? vi(t, ee(o), "text") : t && (null != s.to && (r = ee(o)), null != s.from && (i = ee(o))), o.markedSpans = Le(o.markedSpans, s), null == s.from && this.collapsed && !Ze(this.doc, o) && t && te(o, li(t.display));
            }
            if (t && this.collapsed && !t.options.lineWrapping) for (var l = 0; l < this.lines.length; ++l) {
              var c = We(this.lines[l]),
                d = $e(c);
              d > t.display.maxLineLength && (t.display.maxLine = c, t.display.maxLineLength = d, t.display.maxLineChanged = !0);
            }
            null != i && t && this.collapsed && mi(t, i, r + 1), this.lines.length = 0, this.explicitlyCleared = !0, this.atomic && this.doc.cantEdit && (this.doc.cantEdit = !1, t && oa(t.doc)), t && pn(t, "markerCleared", t, this, i, r), e && Xi(t), this.parent && this.parent.clear();
          }
        }, Sa.prototype.find = function (t, e) {
          var n, i;
          null == t && "bookmark" == this.type && (t = 1);
          for (var r = 0; r < this.lines.length; ++r) {
            var a = this.lines[r],
              o = Ne(a.markedSpans, this);
            if (null != o.from && (n = ae(e ? a : ee(a), o.from), -1 == t)) return n;
            if (null != o.to && (i = ae(e ? a : ee(a), o.to), 1 == t)) return i;
          }
          return n && {
            from: n,
            to: i
          };
        }, Sa.prototype.changed = function () {
          var t = this,
            e = this.find(-1, !0),
            n = this,
            i = this.doc.cm;
          e && i && rr(i, function () {
            var r = e.line,
              a = ee(e.line),
              o = zn(i, a);
            if (o && (Wn(o), i.curOp.selectionChanged = i.curOp.forceUpdate = !0), i.curOp.updateMaxLine = !0, !Ze(n.doc, r) && null != n.height) {
              var s = n.height;
              n.height = null;
              var l = On(n) - s;
              l && te(r, r.height + l);
            }
            pn(i, "markerChanged", i, t);
          });
        }, Sa.prototype.attachLine = function (t) {
          if (!this.lines.length && this.doc.cm) {
            var e = this.doc.cm.curOp;
            e.maybeHiddenMarkers && -1 != U(e.maybeHiddenMarkers, this) || (e.maybeUnhiddenMarkers || (e.maybeUnhiddenMarkers = [])).push(this);
          }
          this.lines.push(t);
        }, Sa.prototype.detachLine = function (t) {
          if (this.lines.splice(U(this.lines, t), 1), !this.lines.length && this.doc.cm) {
            var e = this.doc.cm.curOp;
            (e.maybeHiddenMarkers || (e.maybeHiddenMarkers = [])).push(this);
          }
        }, Ct(Sa);
        var La = function La(t, e) {
          this.markers = t, this.primary = e;
          for (var n = 0; n < t.length; ++n) t[n].parent = this;
        };
        function Da(t) {
          return t.findMarks(ae(t.first, 0), t.clipPos(ae(t.lastLine())), function (t) {
            return t.parent;
          });
        }
        function Ea(t) {
          for (var e = function e(_e6) {
              var n = t[_e6],
                i = [n.primary.doc];
              Vr(n.primary.doc, function (t) {
                return i.push(t);
              });
              for (var r = 0; r < n.markers.length; r++) {
                var a = n.markers[r];
                -1 == U(i, a.doc) && (a.parent = null, n.markers.splice(r--, 1));
              }
            }, n = 0; n < t.length; n++) e(n);
        }
        La.prototype.clear = function () {
          if (!this.explicitlyCleared) {
            this.explicitlyCleared = !0;
            for (var t = 0; t < this.markers.length; ++t) this.markers[t].clear();
            pn(this, "clear");
          }
        }, La.prototype.find = function (t, e) {
          return this.primary.find(t, e);
        }, Ct(La);
        var Ia = 0,
          _Pa = function Pa(t, e, n, i, r) {
            if (!(this instanceof _Pa)) return new _Pa(t, e, n, i, r);
            null == n && (n = 0), Ma.call(this, [new Ca([new Je("", null)])]), this.first = n, this.scrollTop = this.scrollLeft = 0, this.cantEdit = !1, this.cleanGeneration = 1, this.modeFrontier = this.highlightFrontier = n;
            var a = ae(n, 0);
            this.sel = Lr(a), this.history = new Br(null), this.id = ++Ia, this.modeOption = e, this.lineSep = i, this.direction = "rtl" == r ? "rtl" : "ltr", this.extend = !1, "string" == typeof t && (t = this.splitLines(t)), Hr(this, {
              from: a,
              to: a,
              text: t
            }), ia(this, Lr(a), G);
          };
        _Pa.prototype = nt(Ma.prototype, {
          constructor: _Pa,
          iter: function iter(t, e, n) {
            n ? this.iterN(t - this.first, e - t, n) : this.iterN(this.first, this.first + this.size, t);
          },
          insert: function insert(t, e) {
            for (var n = 0, i = 0; i < e.length; ++i) n += e[i].height;
            this.insertInner(t - this.first, e, n);
          },
          remove: function remove(t, e) {
            this.removeInner(t - this.first, e);
          },
          getValue: function getValue(t) {
            var e = Kt(this, this.first, this.first + this.size);
            return !1 === t ? e : e.join(t || this.lineSeparator());
          },
          setValue: sr(function (t) {
            var e = ae(this.first, 0),
              n = this.first + this.size - 1;
            pa(this, {
              from: e,
              to: ae(n, Jt(this, n).text.length),
              text: this.splitLines(t),
              origin: "setValue",
              full: !0
            }, !0), this.cm && _i(this.cm, 0, 0), ia(this, Lr(e), G);
          }),
          replaceRange: function replaceRange(t, e, n, i) {
            ba(this, t, e = he(this, e), n = n ? he(this, n) : e, i);
          },
          getRange: function getRange(t, e, n) {
            var i = Xt(this, he(this, t), he(this, e));
            return !1 === n ? i : "" === n ? i.join("") : i.join(n || this.lineSeparator());
          },
          getLine: function getLine(t) {
            var e = this.getLineHandle(t);
            return e && e.text;
          },
          getLineHandle: function getLineHandle(t) {
            if (ie(this, t)) return Jt(this, t);
          },
          getLineNumber: function getLineNumber(t) {
            return ee(t);
          },
          getLineHandleVisualStart: function getLineHandleVisualStart(t) {
            return "number" == typeof t && (t = Jt(this, t)), We(t);
          },
          lineCount: function lineCount() {
            return this.size;
          },
          firstLine: function firstLine() {
            return this.first;
          },
          lastLine: function lastLine() {
            return this.first + this.size - 1;
          },
          clipPos: function clipPos(t) {
            return he(this, t);
          },
          getCursor: function getCursor(t) {
            var e = this.sel.primary();
            return null == t || "head" == t ? e.head : "anchor" == t ? e.anchor : "end" == t || "to" == t || !1 === t ? e.to() : e.from();
          },
          listSelections: function listSelections() {
            return this.sel.ranges;
          },
          somethingSelected: function somethingSelected() {
            return this.sel.somethingSelected();
          },
          setCursor: sr(function (t, e, n) {
            ea(this, he(this, "number" == typeof t ? ae(t, e || 0) : t), null, n);
          }),
          setSelection: sr(function (t, e, n) {
            ea(this, he(this, t), he(this, e || t), n);
          }),
          extendSelection: sr(function (t, e, n) {
            Xr(this, he(this, t), e && he(this, e), n);
          }),
          extendSelections: sr(function (t, e) {
            Kr(this, pe(this, t), e);
          }),
          extendSelectionsBy: sr(function (t, e) {
            Kr(this, pe(this, tt(this.sel.ranges, t)), e);
          }),
          setSelections: sr(function (t, e, n) {
            if (t.length) {
              for (var i = [], r = 0; r < t.length; r++) i[r] = new Sr(he(this, t[r].anchor), he(this, t[r].head || t[r].anchor));
              null == e && (e = Math.min(t.length - 1, this.sel.primIndex)), ia(this, Nr(this.cm, i, e), n);
            }
          }),
          addSelection: sr(function (t, e, n) {
            var i = this.sel.ranges.slice(0);
            i.push(new Sr(he(this, t), he(this, e || t))), ia(this, Nr(this.cm, i, i.length - 1), n);
          }),
          getSelection: function getSelection(t) {
            for (var e, n = this.sel.ranges, i = 0; i < n.length; i++) {
              var r = Xt(this, n[i].from(), n[i].to());
              e = e ? e.concat(r) : r;
            }
            return !1 === t ? e : e.join(t || this.lineSeparator());
          },
          getSelections: function getSelections(t) {
            for (var e = [], n = this.sel.ranges, i = 0; i < n.length; i++) {
              var r = Xt(this, n[i].from(), n[i].to());
              !1 !== t && (r = r.join(t || this.lineSeparator())), e[i] = r;
            }
            return e;
          },
          replaceSelection: function replaceSelection(t, e, n) {
            for (var i = [], r = 0; r < this.sel.ranges.length; r++) i[r] = t;
            this.replaceSelections(i, e, n || "+input");
          },
          replaceSelections: sr(function (t, e, n) {
            for (var i = [], r = this.sel, a = 0; a < r.ranges.length; a++) {
              var o = r.ranges[a];
              i[a] = {
                from: o.from(),
                to: o.to(),
                text: this.splitLines(t[a]),
                origin: n
              };
            }
            for (var s = e && "end" != e && function (t, e, n) {
                for (var i = [], r = ae(t.first, 0), a = r, o = 0; o < e.length; o++) {
                  var s = e[o],
                    l = Pr(s.from, r, a),
                    c = Pr(Dr(s), r, a);
                  if (r = s.to, a = c, "around" == n) {
                    var d = t.sel.ranges[o],
                      u = oe(d.head, d.anchor) < 0;
                    i[o] = new Sr(u ? c : l, u ? l : c);
                  } else i[o] = new Sr(l, l);
                }
                return new Tr(i, t.sel.primIndex);
              }(this, i, e), l = i.length - 1; l >= 0; l--) pa(this, i[l]);
            s ? na(this, s) : this.cm && zi(this.cm);
          }),
          undo: sr(function () {
            fa(this, "undo");
          }),
          redo: sr(function () {
            fa(this, "redo");
          }),
          undoSelection: sr(function () {
            fa(this, "undo", !0);
          }),
          redoSelection: sr(function () {
            fa(this, "redo", !0);
          }),
          setExtending: function setExtending(t) {
            this.extend = t;
          },
          getExtending: function getExtending() {
            return this.extend;
          },
          historySize: function historySize() {
            for (var t = this.history, e = 0, n = 0, i = 0; i < t.done.length; i++) t.done[i].ranges || ++e;
            for (var r = 0; r < t.undone.length; r++) t.undone[r].ranges || ++n;
            return {
              undo: e,
              redo: n
            };
          },
          clearHistory: function clearHistory() {
            var t = this;
            this.history = new Br(this.history), Vr(this, function (e) {
              return e.history = t.history;
            }, !0);
          },
          markClean: function markClean() {
            this.cleanGeneration = this.changeGeneration(!0);
          },
          changeGeneration: function changeGeneration(t) {
            return t && (this.history.lastOp = this.history.lastSelOp = this.history.lastOrigin = null), this.history.generation;
          },
          isClean: function isClean(t) {
            return this.history.generation == (t || this.cleanGeneration);
          },
          getHistory: function getHistory() {
            return {
              done: Qr(this.history.done),
              undone: Qr(this.history.undone)
            };
          },
          setHistory: function setHistory(t) {
            var e = this.history = new Br(this.history);
            e.done = Qr(t.done.slice(0), null, !0), e.undone = Qr(t.undone.slice(0), null, !0);
          },
          setGutterMarker: sr(function (t, e, n) {
            return ja(this, t, "gutter", function (t) {
              var i = t.gutterMarkers || (t.gutterMarkers = {});
              return i[e] = n, !n && ot(i) && (t.gutterMarkers = null), !0;
            });
          }),
          clearGutter: sr(function (t) {
            var e = this;
            this.iter(function (n) {
              n.gutterMarkers && n.gutterMarkers[t] && ja(e, n, "gutter", function () {
                return n.gutterMarkers[t] = null, ot(n.gutterMarkers) && (n.gutterMarkers = null), !0;
              });
            });
          }),
          lineInfo: function lineInfo(t) {
            var e;
            if ("number" == typeof t) {
              if (!ie(this, t)) return null;
              if (e = t, !(t = Jt(this, t))) return null;
            } else if (null == (e = ee(t))) return null;
            return {
              line: e,
              handle: t,
              text: t.text,
              gutterMarkers: t.gutterMarkers,
              textClass: t.textClass,
              bgClass: t.bgClass,
              wrapClass: t.wrapClass,
              widgets: t.widgets
            };
          },
          addLineClass: sr(function (t, e, n) {
            return ja(this, t, "gutter" == e ? "gutter" : "class", function (t) {
              var i = "text" == e ? "textClass" : "background" == e ? "bgClass" : "gutter" == e ? "gutterClass" : "wrapClass";
              if (t[i]) {
                if (k(n).test(t[i])) return !1;
                t[i] += " " + n;
              } else t[i] = n;
              return !0;
            });
          }),
          removeLineClass: sr(function (t, e, n) {
            return ja(this, t, "gutter" == e ? "gutter" : "class", function (t) {
              var i = "text" == e ? "textClass" : "background" == e ? "bgClass" : "gutter" == e ? "gutterClass" : "wrapClass",
                r = t[i];
              if (!r) return !1;
              if (null == n) t[i] = null;else {
                var a = r.match(k(n));
                if (!a) return !1;
                var o = a.index + a[0].length;
                t[i] = r.slice(0, a.index) + (a.index && o != r.length ? " " : "") + r.slice(o) || null;
              }
              return !0;
            });
          }),
          addLineWidget: sr(function (t, e, n) {
            return function (t, e, n, i) {
              var r = new ka(t, n, i),
                a = t.cm;
              return a && r.noHScroll && (a.display.alignWidgets = !0), ja(t, e, "widget", function (e) {
                var n = e.widgets || (e.widgets = []);
                if (null == r.insertAt ? n.push(r) : n.splice(Math.min(n.length, Math.max(0, r.insertAt)), 0, r), r.line = e, a && !Ze(t, e)) {
                  var i = qe(e) < t.scrollTop;
                  te(e, e.height + On(r)), i && Ai(a, r.height), a.curOp.forceUpdate = !0;
                }
                return !0;
              }), a && pn(a, "lineWidgetAdded", a, r, "number" == typeof e ? e : ee(e)), r;
            }(this, t, e, n);
          }),
          removeLineWidget: function removeLineWidget(t) {
            t.clear();
          },
          markText: function markText(t, e, n) {
            return Na(this, he(this, t), he(this, e), n, n && n.type || "range");
          },
          setBookmark: function setBookmark(t, e) {
            var n = {
              replacedWith: e && (null == e.nodeType ? e.widget : e),
              insertLeft: e && e.insertLeft,
              clearWhenEmpty: !1,
              shared: e && e.shared,
              handleMouseEvents: e && e.handleMouseEvents
            };
            return Na(this, t = he(this, t), t, n, "bookmark");
          },
          findMarksAt: function findMarksAt(t) {
            var e = [],
              n = Jt(this, (t = he(this, t)).line).markedSpans;
            if (n) for (var i = 0; i < n.length; ++i) {
              var r = n[i];
              (null == r.from || r.from <= t.ch) && (null == r.to || r.to >= t.ch) && e.push(r.marker.parent || r.marker);
            }
            return e;
          },
          findMarks: function findMarks(t, e, n) {
            t = he(this, t), e = he(this, e);
            var i = [],
              r = t.line;
            return this.iter(t.line, e.line + 1, function (a) {
              var o = a.markedSpans;
              if (o) for (var s = 0; s < o.length; s++) {
                var l = o[s];
                null != l.to && r == t.line && t.ch >= l.to || null == l.from && r != t.line || null != l.from && r == e.line && l.from >= e.ch || n && !n(l.marker) || i.push(l.marker.parent || l.marker);
              }
              ++r;
            }), i;
          },
          getAllMarks: function getAllMarks() {
            var t = [];
            return this.iter(function (e) {
              var n = e.markedSpans;
              if (n) for (var i = 0; i < n.length; ++i) null != n[i].from && t.push(n[i].marker);
            }), t;
          },
          posFromIndex: function posFromIndex(t) {
            var e,
              n = this.first,
              i = this.lineSeparator().length;
            return this.iter(function (r) {
              var a = r.text.length + i;
              if (a > t) return e = t, !0;
              t -= a, ++n;
            }), he(this, ae(n, e));
          },
          indexFromPos: function indexFromPos(t) {
            var e = (t = he(this, t)).ch;
            if (t.line < this.first || t.ch < 0) return 0;
            var n = this.lineSeparator().length;
            return this.iter(this.first, t.line, function (t) {
              e += t.text.length + n;
            }), e;
          },
          copy: function copy(t) {
            var e = new _Pa(Kt(this, this.first, this.first + this.size), this.modeOption, this.first, this.lineSep, this.direction);
            return e.scrollTop = this.scrollTop, e.scrollLeft = this.scrollLeft, e.sel = this.sel, e.extend = !1, t && (e.history.undoDepth = this.history.undoDepth, e.setHistory(this.getHistory())), e;
          },
          linkedDoc: function linkedDoc(t) {
            t || (t = {});
            var e = this.first,
              n = this.first + this.size;
            null != t.from && t.from > e && (e = t.from), null != t.to && t.to < n && (n = t.to);
            var i = new _Pa(Kt(this, e, n), t.mode || this.modeOption, e, this.lineSep, this.direction);
            return t.sharedHist && (i.history = this.history), (this.linked || (this.linked = [])).push({
              doc: i,
              sharedHist: t.sharedHist
            }), i.linked = [{
              doc: this,
              isParent: !0,
              sharedHist: t.sharedHist
            }], function (t, e) {
              for (var n = 0; n < e.length; n++) {
                var i = e[n],
                  r = i.find(),
                  a = t.clipPos(r.from),
                  o = t.clipPos(r.to);
                if (oe(a, o)) {
                  var s = Na(t, a, o, i.primary, i.primary.type);
                  i.markers.push(s), s.parent = i;
                }
              }
            }(i, Da(this)), i;
          },
          unlinkDoc: function unlinkDoc(t) {
            if (t instanceof Lo && (t = t.doc), this.linked) for (var e = 0; e < this.linked.length; ++e) if (this.linked[e].doc == t) {
              this.linked.splice(e, 1), t.unlinkDoc(this), Ea(Da(this));
              break;
            }
            if (t.history == this.history) {
              var n = [t.id];
              Vr(t, function (t) {
                return n.push(t.id);
              }, !0), t.history = new Br(null), t.history.done = Qr(this.history.done, n), t.history.undone = Qr(this.history.undone, n);
            }
          },
          iterLinkedDocs: function iterLinkedDocs(t) {
            Vr(this, t);
          },
          getMode: function getMode() {
            return this.mode;
          },
          getEditor: function getEditor() {
            return this.cm;
          },
          splitLines: function splitLines(t) {
            return this.lineSep ? t.split(this.lineSep) : zt(t);
          },
          lineSeparator: function lineSeparator() {
            return this.lineSep || "\n";
          },
          setDirection: sr(function (t) {
            var e;
            "rtl" != t && (t = "ltr"), t != this.direction && (this.direction = t, this.iter(function (t) {
              return t.order = null;
            }), this.cm && rr(e = this.cm, function () {
              Rr(e), mi(e);
            }));
          })
        }), _Pa.prototype.eachLine = _Pa.prototype.iter;
        var Aa = 0;
        function za(t) {
          var e = this;
          if (_a(e), !wt(e, t) && !Tn(e.display, t)) {
            Mt(t), o && (Aa = +new Date());
            var n = gi(e, t, !0),
              i = t.dataTransfer.files;
            if (n && !e.isReadOnly()) if (i && i.length && window.FileReader && window.File) for (var r = i.length, a = Array(r), s = 0, l = function l() {
                ++s == r && ar(e, function () {
                  var t = {
                    from: n = he(e.doc, n),
                    to: n,
                    text: e.doc.splitLines(a.filter(function (t) {
                      return null != t;
                    }).join(e.doc.lineSeparator())),
                    origin: "paste"
                  };
                  pa(e.doc, t), na(e.doc, Lr(he(e.doc, n), he(e.doc, Dr(t))));
                })();
              }, c = function c(t, n) {
                if (e.options.allowDropFileTypes && -1 == U(e.options.allowDropFileTypes, t.type)) l();else {
                  var i = new FileReader();
                  i.onerror = function () {
                    return l();
                  }, i.onload = function () {
                    var t = i.result;
                    /[\x00-\x08\x0e-\x1f]{2}/.test(t) || (a[n] = t), l();
                  }, i.readAsText(t);
                }
              }, d = 0; d < i.length; d++) c(i[d], d);else {
              if (e.state.draggingText && e.doc.sel.contains(n) > -1) return e.state.draggingText(t), void setTimeout(function () {
                return e.display.input.focus();
              }, 20);
              try {
                var u = t.dataTransfer.getData("Text");
                if (u) {
                  var h;
                  if (e.state.draggingText && !e.state.draggingText.copy && (h = e.listSelections()), ra(e.doc, Lr(n, n)), h) for (var p = 0; p < h.length; ++p) ba(e.doc, "", h[p].anchor, h[p].head, "drag");
                  e.replaceSelection(u, "around", "paste"), e.display.input.focus();
                }
              } catch (t) {}
            }
          }
        }
        function _a(t) {
          t.display.dragCursor && (t.display.lineSpace.removeChild(t.display.dragCursor), t.display.dragCursor = null);
        }
        function Ha(t) {
          if (document.getElementsByClassName) {
            for (var e = document.getElementsByClassName("CodeMirror"), n = [], i = 0; i < e.length; i++) {
              var r = e[i].CodeMirror;
              r && n.push(r);
            }
            n.length && n[0].operation(function () {
              for (var e = 0; e < n.length; e++) t(n[e]);
            });
          }
        }
        var Va = !1;
        function Fa(t) {
          var e = t.display;
          e.cachedCharWidth = e.cachedTextHeight = e.cachedPaddingH = null, e.scrollbarsClipped = !1, t.setSize();
        }
        for (var Ra = {
            3: "Pause",
            8: "Backspace",
            9: "Tab",
            13: "Enter",
            16: "Shift",
            17: "Ctrl",
            18: "Alt",
            19: "Pause",
            20: "CapsLock",
            27: "Esc",
            32: "Space",
            33: "PageUp",
            34: "PageDown",
            35: "End",
            36: "Home",
            37: "Left",
            38: "Up",
            39: "Right",
            40: "Down",
            44: "PrintScrn",
            45: "Insert",
            46: "Delete",
            59: ";",
            61: "=",
            91: "Mod",
            92: "Mod",
            93: "Mod",
            106: "*",
            107: "=",
            109: "-",
            110: ".",
            111: "/",
            145: "ScrollLock",
            173: "-",
            186: ";",
            187: "=",
            188: ",",
            189: "-",
            190: ".",
            191: "/",
            192: "`",
            219: "[",
            220: "\\",
            221: "]",
            222: "'",
            224: "Mod",
            63232: "Up",
            63233: "Down",
            63234: "Left",
            63235: "Right",
            63272: "Delete",
            63273: "Home",
            63275: "End",
            63276: "PageUp",
            63277: "PageDown",
            63302: "Insert"
          }, Ba = 0; Ba < 10; Ba++) Ra[Ba + 48] = Ra[Ba + 96] = String(Ba);
        for (var Wa = 65; Wa <= 90; Wa++) Ra[Wa] = String.fromCharCode(Wa);
        for (var Ya = 1; Ya <= 12; Ya++) Ra[Ya + 111] = Ra[Ya + 63235] = "F" + Ya;
        var Ua = {};
        function Za(t) {
          var e,
            n,
            i,
            r,
            a = t.split(/-(?!$)/);
          t = a[a.length - 1];
          for (var o = 0; o < a.length - 1; o++) {
            var s = a[o];
            if (/^(cmd|meta|m)$/i.test(s)) r = !0;else if (/^a(lt)?$/i.test(s)) e = !0;else if (/^(c|ctrl|control)$/i.test(s)) n = !0;else {
              if (!/^s(hift)?$/i.test(s)) throw new Error("Unrecognized modifier name: " + s);
              i = !0;
            }
          }
          return e && (t = "Alt-" + t), n && (t = "Ctrl-" + t), r && (t = "Cmd-" + t), i && (t = "Shift-" + t), t;
        }
        function Ga(t) {
          var e = {};
          for (var n in t) if (t.hasOwnProperty(n)) {
            var i = t[n];
            if (/^(name|fallthrough|(de|at)tach)$/.test(n)) continue;
            if ("..." == i) {
              delete t[n];
              continue;
            }
            for (var r = tt(n.split(" "), Za), a = 0; a < r.length; a++) {
              var o = void 0,
                s = void 0;
              a == r.length - 1 ? (s = r.join(" "), o = i) : (s = r.slice(0, a + 1).join(" "), o = "...");
              var l = e[s];
              if (l) {
                if (l != o) throw new Error("Inconsistent bindings for " + s);
              } else e[s] = o;
            }
            delete t[n];
          }
          for (var c in e) t[c] = e[c];
          return t;
        }
        function qa(t, e, n, i) {
          var r = (e = Xa(e)).call ? e.call(t, i) : e[t];
          if (!1 === r) return "nothing";
          if ("..." === r) return "multi";
          if (null != r && n(r)) return "handled";
          if (e.fallthrough) {
            if ("[object Array]" != Object.prototype.toString.call(e.fallthrough)) return qa(t, e.fallthrough, n, i);
            for (var a = 0; a < e.fallthrough.length; a++) {
              var o = qa(t, e.fallthrough[a], n, i);
              if (o) return o;
            }
          }
        }
        function $a(t) {
          var e = "string" == typeof t ? t : Ra[t.keyCode];
          return "Ctrl" == e || "Alt" == e || "Shift" == e || "Mod" == e;
        }
        function Qa(t, e, n) {
          var i = t;
          return e.altKey && "Alt" != i && (t = "Alt-" + t), (C ? e.metaKey : e.ctrlKey) && "Ctrl" != i && (t = "Ctrl-" + t), (C ? e.ctrlKey : e.metaKey) && "Mod" != i && (t = "Cmd-" + t), !n && e.shiftKey && "Shift" != i && (t = "Shift-" + t), t;
        }
        function Ja(t, e) {
          if (h && 34 == t.keyCode && t.char) return !1;
          var n = Ra[t.keyCode];
          return null != n && !t.altGraphKey && (3 == t.keyCode && t.code && (n = t.code), Qa(n, t, e));
        }
        function Xa(t) {
          return "string" == typeof t ? Ua[t] : t;
        }
        function Ka(t, e) {
          for (var n = t.doc.sel.ranges, i = [], r = 0; r < n.length; r++) {
            for (var a = e(n[r]); i.length && oe(a.from, K(i).to) <= 0;) {
              var o = i.pop();
              if (oe(o.from, a.from) < 0) {
                a.from = o.from;
                break;
              }
            }
            i.push(a);
          }
          rr(t, function () {
            for (var e = i.length - 1; e >= 0; e--) ba(t.doc, "", i[e].from, i[e].to, "+delete");
            zi(t);
          });
        }
        function to(t, e, n) {
          var i = ct(t.text, e + n, n);
          return i < 0 || i > t.text.length ? null : i;
        }
        function eo(t, e, n) {
          var i = to(t, e.ch, n);
          return null == i ? null : new ae(e.line, i, n < 0 ? "after" : "before");
        }
        function no(t, e, n, i, r) {
          if (t) {
            "rtl" == e.doc.direction && (r = -r);
            var a = gt(n, e.doc.direction);
            if (a) {
              var o,
                s = r < 0 ? K(a) : a[0],
                l = r < 0 == (1 == s.level) ? "after" : "before";
              if (s.level > 0 || "rtl" == e.doc.direction) {
                var c = _n(e, n);
                o = r < 0 ? n.text.length - 1 : 0;
                var d = Hn(e, c, o).top;
                o = dt(function (t) {
                  return Hn(e, c, t).top == d;
                }, r < 0 == (1 == s.level) ? s.from : s.to - 1, o), "before" == l && (o = to(n, o, 1));
              } else o = r < 0 ? s.to : s.from;
              return new ae(i, o, l);
            }
          }
          return new ae(i, r < 0 ? n.text.length : 0, r < 0 ? "before" : "after");
        }
        Ua.basic = {
          Left: "goCharLeft",
          Right: "goCharRight",
          Up: "goLineUp",
          Down: "goLineDown",
          End: "goLineEnd",
          Home: "goLineStartSmart",
          PageUp: "goPageUp",
          PageDown: "goPageDown",
          Delete: "delCharAfter",
          Backspace: "delCharBefore",
          "Shift-Backspace": "delCharBefore",
          Tab: "defaultTab",
          "Shift-Tab": "indentAuto",
          Enter: "newlineAndIndent",
          Insert: "toggleOverwrite",
          Esc: "singleSelection"
        }, Ua.pcDefault = {
          "Ctrl-A": "selectAll",
          "Ctrl-D": "deleteLine",
          "Ctrl-Z": "undo",
          "Shift-Ctrl-Z": "redo",
          "Ctrl-Y": "redo",
          "Ctrl-Home": "goDocStart",
          "Ctrl-End": "goDocEnd",
          "Ctrl-Up": "goLineUp",
          "Ctrl-Down": "goLineDown",
          "Ctrl-Left": "goGroupLeft",
          "Ctrl-Right": "goGroupRight",
          "Alt-Left": "goLineStart",
          "Alt-Right": "goLineEnd",
          "Ctrl-Backspace": "delGroupBefore",
          "Ctrl-Delete": "delGroupAfter",
          "Ctrl-S": "save",
          "Ctrl-F": "find",
          "Ctrl-G": "findNext",
          "Shift-Ctrl-G": "findPrev",
          "Shift-Ctrl-F": "replace",
          "Shift-Ctrl-R": "replaceAll",
          "Ctrl-[": "indentLess",
          "Ctrl-]": "indentMore",
          "Ctrl-U": "undoSelection",
          "Shift-Ctrl-U": "redoSelection",
          "Alt-U": "redoSelection",
          fallthrough: "basic"
        }, Ua.emacsy = {
          "Ctrl-F": "goCharRight",
          "Ctrl-B": "goCharLeft",
          "Ctrl-P": "goLineUp",
          "Ctrl-N": "goLineDown",
          "Ctrl-A": "goLineStart",
          "Ctrl-E": "goLineEnd",
          "Ctrl-V": "goPageDown",
          "Shift-Ctrl-V": "goPageUp",
          "Ctrl-D": "delCharAfter",
          "Ctrl-H": "delCharBefore",
          "Alt-Backspace": "delWordBefore",
          "Ctrl-K": "killLine",
          "Ctrl-T": "transposeChars",
          "Ctrl-O": "openLine"
        }, Ua.macDefault = {
          "Cmd-A": "selectAll",
          "Cmd-D": "deleteLine",
          "Cmd-Z": "undo",
          "Shift-Cmd-Z": "redo",
          "Cmd-Y": "redo",
          "Cmd-Home": "goDocStart",
          "Cmd-Up": "goDocStart",
          "Cmd-End": "goDocEnd",
          "Cmd-Down": "goDocEnd",
          "Alt-Left": "goGroupLeft",
          "Alt-Right": "goGroupRight",
          "Cmd-Left": "goLineLeft",
          "Cmd-Right": "goLineRight",
          "Alt-Backspace": "delGroupBefore",
          "Ctrl-Alt-Backspace": "delGroupAfter",
          "Alt-Delete": "delGroupAfter",
          "Cmd-S": "save",
          "Cmd-F": "find",
          "Cmd-G": "findNext",
          "Shift-Cmd-G": "findPrev",
          "Cmd-Alt-F": "replace",
          "Shift-Cmd-Alt-F": "replaceAll",
          "Cmd-[": "indentLess",
          "Cmd-]": "indentMore",
          "Cmd-Backspace": "delWrappedLineLeft",
          "Cmd-Delete": "delWrappedLineRight",
          "Cmd-U": "undoSelection",
          "Shift-Cmd-U": "redoSelection",
          "Ctrl-Up": "goDocStart",
          "Ctrl-Down": "goDocEnd",
          fallthrough: ["basic", "emacsy"]
        }, Ua.default = y ? Ua.macDefault : Ua.pcDefault;
        var io = {
          selectAll: ua,
          singleSelection: function singleSelection(t) {
            return t.setSelection(t.getCursor("anchor"), t.getCursor("head"), G);
          },
          killLine: function killLine(t) {
            return Ka(t, function (e) {
              if (e.empty()) {
                var n = Jt(t.doc, e.head.line).text.length;
                return e.head.ch == n && e.head.line < t.lastLine() ? {
                  from: e.head,
                  to: ae(e.head.line + 1, 0)
                } : {
                  from: e.head,
                  to: ae(e.head.line, n)
                };
              }
              return {
                from: e.from(),
                to: e.to()
              };
            });
          },
          deleteLine: function deleteLine(t) {
            return Ka(t, function (e) {
              return {
                from: ae(e.from().line, 0),
                to: he(t.doc, ae(e.to().line + 1, 0))
              };
            });
          },
          delLineLeft: function delLineLeft(t) {
            return Ka(t, function (t) {
              return {
                from: ae(t.from().line, 0),
                to: t.from()
              };
            });
          },
          delWrappedLineLeft: function delWrappedLineLeft(t) {
            return Ka(t, function (e) {
              var n = t.charCoords(e.head, "div").top + 5;
              return {
                from: t.coordsChar({
                  left: 0,
                  top: n
                }, "div"),
                to: e.from()
              };
            });
          },
          delWrappedLineRight: function delWrappedLineRight(t) {
            return Ka(t, function (e) {
              var n = t.charCoords(e.head, "div").top + 5,
                i = t.coordsChar({
                  left: t.display.lineDiv.offsetWidth + 100,
                  top: n
                }, "div");
              return {
                from: e.from(),
                to: i
              };
            });
          },
          undo: function undo(t) {
            return t.undo();
          },
          redo: function redo(t) {
            return t.redo();
          },
          undoSelection: function undoSelection(t) {
            return t.undoSelection();
          },
          redoSelection: function redoSelection(t) {
            return t.redoSelection();
          },
          goDocStart: function goDocStart(t) {
            return t.extendSelection(ae(t.firstLine(), 0));
          },
          goDocEnd: function goDocEnd(t) {
            return t.extendSelection(ae(t.lastLine()));
          },
          goLineStart: function goLineStart(t) {
            return t.extendSelectionsBy(function (e) {
              return ro(t, e.head.line);
            }, {
              origin: "+move",
              bias: 1
            });
          },
          goLineStartSmart: function goLineStartSmart(t) {
            return t.extendSelectionsBy(function (e) {
              return ao(t, e.head);
            }, {
              origin: "+move",
              bias: 1
            });
          },
          goLineEnd: function goLineEnd(t) {
            return t.extendSelectionsBy(function (e) {
              return function (t, e) {
                var n = Jt(t.doc, e),
                  i = function (t) {
                    for (var e; e = Fe(t);) t = e.find(1, !0).line;
                    return t;
                  }(n);
                return i != n && (e = ee(i)), no(!0, t, n, e, -1);
              }(t, e.head.line);
            }, {
              origin: "+move",
              bias: -1
            });
          },
          goLineRight: function goLineRight(t) {
            return t.extendSelectionsBy(function (e) {
              var n = t.cursorCoords(e.head, "div").top + 5;
              return t.coordsChar({
                left: t.display.lineDiv.offsetWidth + 100,
                top: n
              }, "div");
            }, $);
          },
          goLineLeft: function goLineLeft(t) {
            return t.extendSelectionsBy(function (e) {
              var n = t.cursorCoords(e.head, "div").top + 5;
              return t.coordsChar({
                left: 0,
                top: n
              }, "div");
            }, $);
          },
          goLineLeftSmart: function goLineLeftSmart(t) {
            return t.extendSelectionsBy(function (e) {
              var n = t.cursorCoords(e.head, "div").top + 5,
                i = t.coordsChar({
                  left: 0,
                  top: n
                }, "div");
              return i.ch < t.getLine(i.line).search(/\S/) ? ao(t, e.head) : i;
            }, $);
          },
          goLineUp: function goLineUp(t) {
            return t.moveV(-1, "line");
          },
          goLineDown: function goLineDown(t) {
            return t.moveV(1, "line");
          },
          goPageUp: function goPageUp(t) {
            return t.moveV(-1, "page");
          },
          goPageDown: function goPageDown(t) {
            return t.moveV(1, "page");
          },
          goCharLeft: function goCharLeft(t) {
            return t.moveH(-1, "char");
          },
          goCharRight: function goCharRight(t) {
            return t.moveH(1, "char");
          },
          goColumnLeft: function goColumnLeft(t) {
            return t.moveH(-1, "column");
          },
          goColumnRight: function goColumnRight(t) {
            return t.moveH(1, "column");
          },
          goWordLeft: function goWordLeft(t) {
            return t.moveH(-1, "word");
          },
          goGroupRight: function goGroupRight(t) {
            return t.moveH(1, "group");
          },
          goGroupLeft: function goGroupLeft(t) {
            return t.moveH(-1, "group");
          },
          goWordRight: function goWordRight(t) {
            return t.moveH(1, "word");
          },
          delCharBefore: function delCharBefore(t) {
            return t.deleteH(-1, "codepoint");
          },
          delCharAfter: function delCharAfter(t) {
            return t.deleteH(1, "char");
          },
          delWordBefore: function delWordBefore(t) {
            return t.deleteH(-1, "word");
          },
          delWordAfter: function delWordAfter(t) {
            return t.deleteH(1, "word");
          },
          delGroupBefore: function delGroupBefore(t) {
            return t.deleteH(-1, "group");
          },
          delGroupAfter: function delGroupAfter(t) {
            return t.deleteH(1, "group");
          },
          indentAuto: function indentAuto(t) {
            return t.indentSelection("smart");
          },
          indentMore: function indentMore(t) {
            return t.indentSelection("add");
          },
          indentLess: function indentLess(t) {
            return t.indentSelection("subtract");
          },
          insertTab: function insertTab(t) {
            return t.replaceSelection("\t");
          },
          insertSoftTab: function insertSoftTab(t) {
            for (var e = [], n = t.listSelections(), i = t.options.tabSize, r = 0; r < n.length; r++) {
              var a = n[r].from(),
                o = W(t.getLine(a.line), a.ch, i);
              e.push(X(i - o % i));
            }
            t.replaceSelections(e);
          },
          defaultTab: function defaultTab(t) {
            t.somethingSelected() ? t.indentSelection("add") : t.execCommand("insertTab");
          },
          transposeChars: function transposeChars(t) {
            return rr(t, function () {
              for (var e = t.listSelections(), n = [], i = 0; i < e.length; i++) if (e[i].empty()) {
                var r = e[i].head,
                  a = Jt(t.doc, r.line).text;
                if (a) if (r.ch == a.length && (r = new ae(r.line, r.ch - 1)), r.ch > 0) r = new ae(r.line, r.ch + 1), t.replaceRange(a.charAt(r.ch - 1) + a.charAt(r.ch - 2), ae(r.line, r.ch - 2), r, "+transpose");else if (r.line > t.doc.first) {
                  var o = Jt(t.doc, r.line - 1).text;
                  o && (r = new ae(r.line, 1), t.replaceRange(a.charAt(0) + t.doc.lineSeparator() + o.charAt(o.length - 1), ae(r.line - 1, o.length - 1), r, "+transpose"));
                }
                n.push(new Sr(r, r));
              }
              t.setSelections(n);
            });
          },
          newlineAndIndent: function newlineAndIndent(t) {
            return rr(t, function () {
              for (var e = t.listSelections(), n = e.length - 1; n >= 0; n--) t.replaceRange(t.doc.lineSeparator(), e[n].anchor, e[n].head, "+input");
              e = t.listSelections();
              for (var i = 0; i < e.length; i++) t.indentLine(e[i].from().line, null, !0);
              zi(t);
            });
          },
          openLine: function openLine(t) {
            return t.replaceSelection("\n", "start");
          },
          toggleOverwrite: function toggleOverwrite(t) {
            return t.toggleOverwrite();
          }
        };
        function ro(t, e) {
          var n = Jt(t.doc, e),
            i = We(n);
          return i != n && (e = ee(i)), no(!0, t, i, e, 1);
        }
        function ao(t, e) {
          var n = ro(t, e.line),
            i = Jt(t.doc, n.line),
            r = gt(i, t.doc.direction);
          if (!r || 0 == r[0].level) {
            var a = Math.max(n.ch, i.text.search(/\S/)),
              o = e.line == n.line && e.ch <= a && e.ch;
            return ae(n.line, o ? 0 : a, n.sticky);
          }
          return n;
        }
        function oo(t, e, n) {
          if ("string" == typeof e && !(e = io[e])) return !1;
          t.display.input.ensurePolled();
          var i = t.display.shift,
            r = !1;
          try {
            t.isReadOnly() && (t.state.suppressEdits = !0), n && (t.display.shift = !1), r = e(t) != Z;
          } finally {
            t.display.shift = i, t.state.suppressEdits = !1;
          }
          return r;
        }
        var so = new Y();
        function lo(t, e, n, i) {
          var r = t.state.keySeq;
          if (r) {
            if ($a(e)) return "handled";
            if (/\'$/.test(e) ? t.state.keySeq = null : so.set(50, function () {
              t.state.keySeq == r && (t.state.keySeq = null, t.display.input.reset());
            }), co(t, r + " " + e, n, i)) return !0;
          }
          return co(t, e, n, i);
        }
        function co(t, e, n, i) {
          var r = function (t, e, n) {
            for (var i = 0; i < t.state.keyMaps.length; i++) {
              var r = qa(e, t.state.keyMaps[i], n, t);
              if (r) return r;
            }
            return t.options.extraKeys && qa(e, t.options.extraKeys, n, t) || qa(e, t.options.keyMap, n, t);
          }(t, e, i);
          return "multi" == r && (t.state.keySeq = e), "handled" == r && pn(t, "keyHandled", t, e, n), "handled" != r && "multi" != r || (Mt(n), Oi(t)), !!r;
        }
        function uo(t, e) {
          var n = Ja(e, !0);
          return !!n && (e.shiftKey && !t.state.keySeq ? lo(t, "Shift-" + n, e, function (e) {
            return oo(t, e, !0);
          }) || lo(t, n, e, function (e) {
            if ("string" == typeof e ? /^go[A-Z]/.test(e) : e.motion) return oo(t, e);
          }) : lo(t, n, e, function (e) {
            return oo(t, e);
          }));
        }
        var ho = null;
        function po(t) {
          var e = this;
          if (!(t.target && t.target != e.display.input.getField() || (e.curOp.focus = I(H(e)), wt(e, t)))) {
            o && s < 11 && 27 == t.keyCode && (t.returnValue = !1);
            var i = t.keyCode;
            e.display.shift = 16 == i || t.shiftKey;
            var r = uo(e, t);
            h && (ho = r ? i : null, r || 88 != i || Ht || !(y ? t.metaKey : t.ctrlKey) || e.replaceSelection("", null, "cut")), n && !y && !r && 46 == i && t.shiftKey && !t.ctrlKey && document.execCommand && document.execCommand("cut"), 18 != i || /\bCodeMirror-crosshair\b/.test(e.display.lineDiv.className) || function (t) {
              var e = t.display.lineDiv;
              function n(t) {
                18 != t.keyCode && t.altKey || (T(e, "CodeMirror-crosshair"), bt(document, "keyup", n), bt(document, "mouseover", n));
              }
              P(e, "CodeMirror-crosshair"), mt(document, "keyup", n), mt(document, "mouseover", n);
            }(e);
          }
        }
        function go(t) {
          16 == t.keyCode && (this.doc.sel.shift = !1), wt(this, t);
        }
        function fo(t) {
          var e = this;
          if (!(t.target && t.target != e.display.input.getField() || Tn(e.display, t) || wt(e, t) || t.ctrlKey && !t.altKey || y && t.metaKey)) {
            var n = t.keyCode,
              i = t.charCode;
            if (h && n == ho) return ho = null, void Mt(t);
            if (!h || t.which && !(t.which < 10) || !uo(e, t)) {
              var r = String.fromCharCode(null == i ? n : i);
              "\b" != r && (function (t, e, n) {
                return lo(t, "'" + n + "'", e, function (e) {
                  return oo(t, e, !0);
                });
              }(e, t, r) || e.display.input.onKeyPress(t));
            }
          }
        }
        var mo,
          vo,
          bo = function bo(t, e, n) {
            this.time = t, this.pos = e, this.button = n;
          };
        function yo(t) {
          var e = this,
            n = e.display;
          if (!(wt(e, t) || n.activeTouch && n.input.supportsTouch())) if (n.input.ensurePolled(), n.shift = t.shiftKey, Tn(n, t)) l || (n.scroller.draggable = !1, setTimeout(function () {
            return n.scroller.draggable = !0;
          }, 100));else if (!jo(e, t)) {
            var i = gi(e, t),
              r = Nt(t),
              a = i ? function (t, e) {
                var n = +new Date();
                return vo && vo.compare(n, t, e) ? (mo = vo = null, "triple") : mo && mo.compare(n, t, e) ? (vo = new bo(n, t, e), mo = null, "double") : (mo = new bo(n, t, e), vo = null, "single");
              }(i, r) : "single";
            F(e).focus(), 1 == r && e.state.selectingText && e.state.selectingText(t), i && function (t, e, n, i, r) {
              var a = "Click";
              return "double" == i ? a = "Double" + a : "triple" == i && (a = "Triple" + a), lo(t, Qa(a = (1 == e ? "Left" : 2 == e ? "Middle" : "Right") + a, r), r, function (e) {
                if ("string" == typeof e && (e = io[e]), !e) return !1;
                var i = !1;
                try {
                  t.isReadOnly() && (t.state.suppressEdits = !0), i = e(t, n) != Z;
                } finally {
                  t.state.suppressEdits = !1;
                }
                return i;
              });
            }(e, r, i, a, t) || (1 == r ? i ? function (t, e, n, i) {
              o ? setTimeout(R(Ti, t), 0) : t.curOp.focus = I(H(t));
              var r,
                a = function (t, e, n) {
                  var i = t.getOption("configureMouse"),
                    r = i ? i(t, e, n) : {};
                  if (null == r.unit) {
                    var a = w ? n.shiftKey && n.metaKey : n.altKey;
                    r.unit = a ? "rectangle" : "single" == e ? "char" : "double" == e ? "word" : "line";
                  }
                  return (null == r.extend || t.doc.extend) && (r.extend = t.doc.extend || n.shiftKey), null == r.addNew && (r.addNew = y ? n.metaKey : n.ctrlKey), null == r.moveOnDrag && (r.moveOnDrag = !(y ? n.altKey : n.ctrlKey)), r;
                }(t, n, i),
                c = t.doc.sel;
              t.options.dragDrop && Et && !t.isReadOnly() && "single" == n && (r = c.contains(e)) > -1 && (oe((r = c.ranges[r]).from(), e) < 0 || e.xRel > 0) && (oe(r.to(), e) > 0 || e.xRel < 0) ? function (t, e, n, i) {
                var r = t.display,
                  a = !1,
                  c = ar(t, function (e) {
                    l && (r.scroller.draggable = !1), t.state.draggingText = !1, t.state.delayingBlurEvent && (t.hasFocus() ? t.state.delayingBlurEvent = !1 : Si(t)), bt(r.wrapper.ownerDocument, "mouseup", c), bt(r.wrapper.ownerDocument, "mousemove", d), bt(r.scroller, "dragstart", u), bt(r.scroller, "drop", c), a || (Mt(e), i.addNew || Xr(t.doc, n, null, null, i.extend), l && !p || o && 9 == s ? setTimeout(function () {
                      r.wrapper.ownerDocument.body.focus({
                        preventScroll: !0
                      }), r.input.focus();
                    }, 20) : r.input.focus());
                  }),
                  d = function d(t) {
                    a = a || Math.abs(e.clientX - t.clientX) + Math.abs(e.clientY - t.clientY) >= 10;
                  },
                  u = function u() {
                    return a = !0;
                  };
                l && (r.scroller.draggable = !0), t.state.draggingText = c, c.copy = !i.moveOnDrag, mt(r.wrapper.ownerDocument, "mouseup", c), mt(r.wrapper.ownerDocument, "mousemove", d), mt(r.scroller, "dragstart", u), mt(r.scroller, "drop", c), t.state.delayingBlurEvent = !0, setTimeout(function () {
                  return r.input.focus();
                }, 20), r.scroller.dragDrop && r.scroller.dragDrop();
              }(t, i, e, a) : function (t, e, n, i) {
                o && Si(t);
                var r = t.display,
                  a = t.doc;
                Mt(e);
                var s,
                  l,
                  c = a.sel,
                  d = c.ranges;
                if (i.addNew && !i.extend ? (l = a.sel.contains(n), s = l > -1 ? d[l] : new Sr(n, n)) : (s = a.sel.primary(), l = a.sel.primIndex), "rectangle" == i.unit) i.addNew || (s = new Sr(n, n)), n = gi(t, e, !0, !0), l = -1;else {
                  var u = wo(t, n, i.unit);
                  s = i.extend ? Jr(s, u.anchor, u.head, i.extend) : u;
                }
                i.addNew ? -1 == l ? (l = d.length, ia(a, Nr(t, d.concat([s]), l), {
                  scroll: !1,
                  origin: "*mouse"
                })) : d.length > 1 && d[l].empty() && "char" == i.unit && !i.extend ? (ia(a, Nr(t, d.slice(0, l).concat(d.slice(l + 1)), 0), {
                  scroll: !1,
                  origin: "*mouse"
                }), c = a.sel) : ta(a, l, s, q) : (l = 0, ia(a, new Tr([s], 0), q), c = a.sel);
                var h = n;
                function p(e) {
                  if (0 != oe(h, e)) if (h = e, "rectangle" == i.unit) {
                    for (var r = [], o = t.options.tabSize, d = W(Jt(a, n.line).text, n.ch, o), u = W(Jt(a, e.line).text, e.ch, o), p = Math.min(d, u), g = Math.max(d, u), f = Math.min(n.line, e.line), m = Math.min(t.lastLine(), Math.max(n.line, e.line)); f <= m; f++) {
                      var v = Jt(a, f).text,
                        b = Q(v, p, o);
                      p == g ? r.push(new Sr(ae(f, b), ae(f, b))) : v.length > b && r.push(new Sr(ae(f, b), ae(f, Q(v, g, o))));
                    }
                    r.length || r.push(new Sr(n, n)), ia(a, Nr(t, c.ranges.slice(0, l).concat(r), l), {
                      origin: "*mouse",
                      scroll: !1
                    }), t.scrollIntoView(e);
                  } else {
                    var y,
                      w = s,
                      x = wo(t, e, i.unit),
                      j = w.anchor;
                    oe(x.anchor, j) > 0 ? (y = x.head, j = de(w.from(), x.anchor)) : (y = x.anchor, j = ce(w.to(), x.head));
                    var C = c.ranges.slice(0);
                    C[l] = function (t, e) {
                      var n = e.anchor,
                        i = e.head,
                        r = Jt(t.doc, n.line);
                      if (0 == oe(n, i) && n.sticky == i.sticky) return e;
                      var a = gt(r);
                      if (!a) return e;
                      var o = ht(a, n.ch, n.sticky),
                        s = a[o];
                      if (s.from != n.ch && s.to != n.ch) return e;
                      var l,
                        c = o + (s.from == n.ch == (1 != s.level) ? 0 : 1);
                      if (0 == c || c == a.length) return e;
                      if (i.line != n.line) l = (i.line - n.line) * ("ltr" == t.doc.direction ? 1 : -1) > 0;else {
                        var d = ht(a, i.ch, i.sticky),
                          u = d - o || (i.ch - n.ch) * (1 == s.level ? -1 : 1);
                        l = d == c - 1 || d == c ? u < 0 : u > 0;
                      }
                      var h = a[c + (l ? -1 : 0)],
                        p = l == (1 == h.level),
                        g = p ? h.from : h.to,
                        f = p ? "after" : "before";
                      return n.ch == g && n.sticky == f ? e : new Sr(new ae(n.line, g, f), i);
                    }(t, new Sr(he(a, j), y)), ia(a, Nr(t, C, l), q);
                  }
                }
                var g = r.wrapper.getBoundingClientRect(),
                  f = 0;
                function m(e) {
                  t.state.selectingText = !1, f = 1 / 0, e && (Mt(e), r.input.focus()), bt(r.wrapper.ownerDocument, "mousemove", v), bt(r.wrapper.ownerDocument, "mouseup", b), a.history.lastSelOrigin = null;
                }
                var v = ar(t, function (e) {
                    0 !== e.buttons && Nt(e) ? function e(n) {
                      var o = ++f,
                        s = gi(t, n, !0, "rectangle" == i.unit);
                      if (s) if (0 != oe(s, h)) {
                        t.curOp.focus = I(H(t)), p(s);
                        var l = Ii(r, a);
                        (s.line >= l.to || s.line < l.from) && setTimeout(ar(t, function () {
                          f == o && e(n);
                        }), 150);
                      } else {
                        var c = n.clientY < g.top ? -20 : n.clientY > g.bottom ? 20 : 0;
                        c && setTimeout(ar(t, function () {
                          f == o && (r.scroller.scrollTop += c, e(n));
                        }), 50);
                      }
                    }(e) : m(e);
                  }),
                  b = ar(t, m);
                t.state.selectingText = b, mt(r.wrapper.ownerDocument, "mousemove", v), mt(r.wrapper.ownerDocument, "mouseup", b);
              }(t, i, e, a);
            }(e, i, a, t) : St(t) == n.scroller && Mt(t) : 2 == r ? (i && Xr(e.doc, i), setTimeout(function () {
              return n.input.focus();
            }, 20)) : 3 == r && (M ? e.display.input.onContextMenu(t) : Si(e)));
          }
        }
        function wo(t, e, n) {
          if ("char" == n) return new Sr(e, e);
          if ("word" == n) return t.findWordAt(e);
          if ("line" == n) return new Sr(ae(e.line, 0), he(t.doc, ae(e.line + 1, 0)));
          var i = n(t, e);
          return new Sr(i.from, i.to);
        }
        function xo(t, e, n, i) {
          var r, a;
          if (e.touches) r = e.touches[0].clientX, a = e.touches[0].clientY;else try {
            r = e.clientX, a = e.clientY;
          } catch (t) {
            return !1;
          }
          if (r >= Math.floor(t.display.gutters.getBoundingClientRect().right)) return !1;
          i && Mt(e);
          var o = t.display,
            s = o.lineDiv.getBoundingClientRect();
          if (a > s.bottom || !jt(t, n)) return Ot(e);
          a -= s.top - o.viewOffset;
          for (var l = 0; l < t.display.gutterSpecs.length; ++l) {
            var c = o.gutters.childNodes[l];
            if (c && c.getBoundingClientRect().right >= r) return yt(t, n, t, ne(t.doc, a), t.display.gutterSpecs[l].className, e), Ot(e);
          }
        }
        function jo(t, e) {
          return xo(t, e, "gutterClick", !0);
        }
        function Co(t, e) {
          Tn(t.display, e) || function (t, e) {
            return !!jt(t, "gutterContextMenu") && xo(t, e, "gutterContextMenu", !1);
          }(t, e) || wt(t, e, "contextmenu") || M || t.display.input.onContextMenu(e);
        }
        function Mo(t) {
          t.display.wrapper.className = t.display.wrapper.className.replace(/\s*cm-s-\S+/g, "") + t.options.theme.replace(/(^|\s)\s*/g, " cm-s-"), Un(t);
        }
        bo.prototype.compare = function (t, e, n) {
          return this.time + 400 > t && 0 == oe(e, this.pos) && n == this.button;
        };
        var ko = {
            toString: function toString() {
              return "CodeMirror.Init";
            }
          },
          Oo = {},
          To = {};
        function So(t, e, n) {
          if (!e != !(n && n != ko)) {
            var i = t.display.dragFunctions,
              r = e ? mt : bt;
            r(t.display.scroller, "dragstart", i.start), r(t.display.scroller, "dragenter", i.enter), r(t.display.scroller, "dragover", i.over), r(t.display.scroller, "dragleave", i.leave), r(t.display.scroller, "drop", i.drop);
          }
        }
        function No(t) {
          t.options.lineWrapping ? (P(t.display.wrapper, "CodeMirror-wrap"), t.display.sizer.style.minWidth = "", t.display.sizerWidth = null) : (T(t.display.wrapper, "CodeMirror-wrap"), Qe(t)), pi(t), mi(t), Un(t), setTimeout(function () {
            return Zi(t);
          }, 100);
        }
        function Lo(t, e) {
          var n = this;
          if (!(this instanceof Lo)) return new Lo(t, e);
          this.options = e = e ? B(e) : {}, B(Oo, e, !1);
          var i = e.value;
          "string" == typeof i ? i = new _Pa(i, e.mode, null, e.lineSeparator, e.direction) : e.mode && (i.modeOption = e.mode), this.doc = i;
          var r = new Lo.inputStyles[e.inputStyle](this),
            a = this.display = new xr(t, i, r, e);
          for (var c in a.wrapper.CodeMirror = this, Mo(this), e.lineWrapping && (this.display.wrapper.className += " CodeMirror-wrap"), $i(this), this.state = {
            keyMaps: [],
            overlays: [],
            modeGen: 0,
            overwrite: !1,
            delayingBlurEvent: !1,
            focused: !1,
            suppressEdits: !1,
            pasteIncoming: -1,
            cutIncoming: -1,
            selectingText: !1,
            draggingText: !1,
            highlight: new Y(),
            keySeq: null,
            specialChars: null
          }, e.autofocus && !b && a.input.focus(), o && s < 11 && setTimeout(function () {
            return n.display.input.reset(!0);
          }, 20), function (t) {
            var e = t.display;
            mt(e.scroller, "mousedown", ar(t, yo)), mt(e.scroller, "dblclick", o && s < 11 ? ar(t, function (e) {
              if (!wt(t, e)) {
                var n = gi(t, e);
                if (n && !jo(t, e) && !Tn(t.display, e)) {
                  Mt(e);
                  var i = t.findWordAt(n);
                  Xr(t.doc, i.anchor, i.head);
                }
              }
            }) : function (e) {
              return wt(t, e) || Mt(e);
            }), mt(e.scroller, "contextmenu", function (e) {
              return Co(t, e);
            }), mt(e.input.getField(), "contextmenu", function (n) {
              e.scroller.contains(n.target) || Co(t, n);
            });
            var n,
              i = {
                end: 0
              };
            function r() {
              e.activeTouch && (n = setTimeout(function () {
                return e.activeTouch = null;
              }, 1e3), (i = e.activeTouch).end = +new Date());
            }
            function a(t, e) {
              if (null == e.left) return !0;
              var n = e.left - t.left,
                i = e.top - t.top;
              return n * n + i * i > 400;
            }
            mt(e.scroller, "touchstart", function (r) {
              if (!wt(t, r) && !function (t) {
                if (1 != t.touches.length) return !1;
                var e = t.touches[0];
                return e.radiusX <= 1 && e.radiusY <= 1;
              }(r) && !jo(t, r)) {
                e.input.ensurePolled(), clearTimeout(n);
                var a = +new Date();
                e.activeTouch = {
                  start: a,
                  moved: !1,
                  prev: a - i.end <= 300 ? i : null
                }, 1 == r.touches.length && (e.activeTouch.left = r.touches[0].pageX, e.activeTouch.top = r.touches[0].pageY);
              }
            }), mt(e.scroller, "touchmove", function () {
              e.activeTouch && (e.activeTouch.moved = !0);
            }), mt(e.scroller, "touchend", function (n) {
              var i = e.activeTouch;
              if (i && !Tn(e, n) && null != i.left && !i.moved && new Date() - i.start < 300) {
                var o,
                  s = t.coordsChar(e.activeTouch, "page");
                o = !i.prev || a(i, i.prev) ? new Sr(s, s) : !i.prev.prev || a(i, i.prev.prev) ? t.findWordAt(s) : new Sr(ae(s.line, 0), he(t.doc, ae(s.line + 1, 0))), t.setSelection(o.anchor, o.head), t.focus(), Mt(n);
              }
              r();
            }), mt(e.scroller, "touchcancel", r), mt(e.scroller, "scroll", function () {
              e.scroller.clientHeight && (Fi(t, e.scroller.scrollTop), Bi(t, e.scroller.scrollLeft, !0), yt(t, "scroll", t));
            }), mt(e.scroller, "mousewheel", function (e) {
              return Or(t, e);
            }), mt(e.scroller, "DOMMouseScroll", function (e) {
              return Or(t, e);
            }), mt(e.wrapper, "scroll", function () {
              return e.wrapper.scrollTop = e.wrapper.scrollLeft = 0;
            }), e.dragFunctions = {
              enter: function enter(e) {
                wt(t, e) || Tt(e);
              },
              over: function over(e) {
                wt(t, e) || (function (t, e) {
                  var n = gi(t, e);
                  if (n) {
                    var i = document.createDocumentFragment();
                    Ci(t, n, i), t.display.dragCursor || (t.display.dragCursor = L("div", null, "CodeMirror-cursors CodeMirror-dragcursors"), t.display.lineSpace.insertBefore(t.display.dragCursor, t.display.cursorDiv)), N(t.display.dragCursor, i);
                  }
                }(t, e), Tt(e));
              },
              start: function start(e) {
                return function (t, e) {
                  if (o && (!t.state.draggingText || +new Date() - Aa < 100)) Tt(e);else if (!wt(t, e) && !Tn(t.display, e) && (e.dataTransfer.setData("Text", t.getSelection()), e.dataTransfer.effectAllowed = "copyMove", e.dataTransfer.setDragImage && !p)) {
                    var n = L("img", null, null, "position: fixed; left: 0; top: 0;");
                    n.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==", h && (n.width = n.height = 1, t.display.wrapper.appendChild(n), n._top = n.offsetTop), e.dataTransfer.setDragImage(n, 0, 0), h && n.parentNode.removeChild(n);
                  }
                }(t, e);
              },
              drop: ar(t, za),
              leave: function leave(e) {
                wt(t, e) || _a(t);
              }
            };
            var l = e.input.getField();
            mt(l, "keyup", function (e) {
              return go.call(t, e);
            }), mt(l, "keydown", ar(t, po)), mt(l, "keypress", ar(t, fo)), mt(l, "focus", function (e) {
              return Ni(t, e);
            }), mt(l, "blur", function (e) {
              return Li(t, e);
            });
          }(this), function () {
            var t;
            Va || (mt(window, "resize", function () {
              null == t && (t = setTimeout(function () {
                t = null, Ha(Fa);
              }, 100));
            }), mt(window, "blur", function () {
              return Ha(Li);
            }), Va = !0);
          }(), Ji(this), this.curOp.forceUpdate = !0, Fr(this, i), e.autofocus && !b || this.hasFocus() ? setTimeout(function () {
            n.hasFocus() && !n.state.focused && Ni(n);
          }, 20) : Li(this), To) To.hasOwnProperty(c) && To[c](this, e[c], ko);
          vr(this), e.finishInit && e.finishInit(this);
          for (var d = 0; d < Do.length; ++d) Do[d](this);
          Xi(this), l && e.lineWrapping && "optimizelegibility" == getComputedStyle(a.lineDiv).textRendering && (a.lineDiv.style.textRendering = "auto");
        }
        Lo.defaults = Oo, Lo.optionHandlers = To;
        var Do = [];
        function Eo(t, e, n, i) {
          var r,
            a = t.doc;
          null == n && (n = "add"), "smart" == n && (a.mode.indent ? r = be(t, e).state : n = "prev");
          var o = t.options.tabSize,
            s = Jt(a, e),
            l = W(s.text, null, o);
          s.stateAfter && (s.stateAfter = null);
          var c,
            d = s.text.match(/^\s*/)[0];
          if (i || /\S/.test(s.text)) {
            if ("smart" == n && ((c = a.mode.indent(r, s.text.slice(d.length), s.text)) == Z || c > 150)) {
              if (!i) return;
              n = "prev";
            }
          } else c = 0, n = "not";
          "prev" == n ? c = e > a.first ? W(Jt(a, e - 1).text, null, o) : 0 : "add" == n ? c = l + t.options.indentUnit : "subtract" == n ? c = l - t.options.indentUnit : "number" == typeof n && (c = l + n), c = Math.max(0, c);
          var u = "",
            h = 0;
          if (t.options.indentWithTabs) for (var p = Math.floor(c / o); p; --p) h += o, u += "\t";
          if (h < c && (u += X(c - h)), u != d) return ba(a, u, ae(e, 0), ae(e, d.length), "+input"), s.stateAfter = null, !0;
          for (var g = 0; g < a.sel.ranges.length; g++) {
            var f = a.sel.ranges[g];
            if (f.head.line == e && f.head.ch < d.length) {
              var m = ae(e, d.length);
              ta(a, g, new Sr(m, m));
              break;
            }
          }
        }
        Lo.defineInitHook = function (t) {
          return Do.push(t);
        };
        var Io = null;
        function Po(t) {
          Io = t;
        }
        function Ao(t, e, n, i, r) {
          var a = t.doc;
          t.display.shift = !1, i || (i = a.sel);
          var o = +new Date() - 200,
            s = "paste" == r || t.state.pasteIncoming > o,
            l = zt(e),
            c = null;
          if (s && i.ranges.length > 1) if (Io && Io.text.join("\n") == e) {
            if (i.ranges.length % Io.text.length == 0) {
              c = [];
              for (var d = 0; d < Io.text.length; d++) c.push(a.splitLines(Io.text[d]));
            }
          } else l.length == i.ranges.length && t.options.pasteLinesPerSelection && (c = tt(l, function (t) {
            return [t];
          }));
          for (var u = t.curOp.updateInput, h = i.ranges.length - 1; h >= 0; h--) {
            var p = i.ranges[h],
              g = p.from(),
              f = p.to();
            p.empty() && (n && n > 0 ? g = ae(g.line, g.ch - n) : t.state.overwrite && !s ? f = ae(f.line, Math.min(Jt(a, f.line).text.length, f.ch + K(l).length)) : s && Io && Io.lineWise && Io.text.join("\n") == l.join("\n") && (g = f = ae(g.line, 0)));
            var m = {
              from: g,
              to: f,
              text: c ? c[h % c.length] : l,
              origin: r || (s ? "paste" : t.state.cutIncoming > o ? "cut" : "+input")
            };
            pa(t.doc, m), pn(t, "inputRead", t, m);
          }
          e && !s && _o(t, e), zi(t), t.curOp.updateInput < 2 && (t.curOp.updateInput = u), t.curOp.typing = !0, t.state.pasteIncoming = t.state.cutIncoming = -1;
        }
        function zo(t, e) {
          var n = t.clipboardData && t.clipboardData.getData("Text");
          if (n) return t.preventDefault(), e.isReadOnly() || e.options.disableInput || !e.hasFocus() || rr(e, function () {
            return Ao(e, n, 0, null, "paste");
          }), !0;
        }
        function _o(t, e) {
          if (t.options.electricChars && t.options.smartIndent) for (var n = t.doc.sel, i = n.ranges.length - 1; i >= 0; i--) {
            var r = n.ranges[i];
            if (!(r.head.ch > 100 || i && n.ranges[i - 1].head.line == r.head.line)) {
              var a = t.getModeAt(r.head),
                o = !1;
              if (a.electricChars) {
                for (var s = 0; s < a.electricChars.length; s++) if (e.indexOf(a.electricChars.charAt(s)) > -1) {
                  o = Eo(t, r.head.line, "smart");
                  break;
                }
              } else a.electricInput && a.electricInput.test(Jt(t.doc, r.head.line).text.slice(0, r.head.ch)) && (o = Eo(t, r.head.line, "smart"));
              o && pn(t, "electricInput", t, r.head.line);
            }
          }
        }
        function Ho(t) {
          for (var e = [], n = [], i = 0; i < t.doc.sel.ranges.length; i++) {
            var r = t.doc.sel.ranges[i].head.line,
              a = {
                anchor: ae(r, 0),
                head: ae(r + 1, 0)
              };
            n.push(a), e.push(t.getRange(a.anchor, a.head));
          }
          return {
            text: e,
            ranges: n
          };
        }
        function Vo(t, e, n, i) {
          t.setAttribute("autocorrect", n ? "on" : "off"), t.setAttribute("autocapitalize", i ? "on" : "off"), t.setAttribute("spellcheck", !!e);
        }
        function Fo() {
          var t = L("textarea", null, null, "position: absolute; bottom: -1em; padding: 0; width: 1px; height: 1em; min-height: 1em; outline: none"),
            e = L("div", [t], null, "overflow: hidden; position: relative; width: 3px; height: 0px;");
          return l ? t.style.width = "1000px" : t.setAttribute("wrap", "off"), m && (t.style.border = "1px solid black"), e;
        }
        function Ro(t, e, n, i, r) {
          var a = e,
            o = n,
            s = Jt(t, e.line),
            l = r && "rtl" == t.direction ? -n : n;
          function c(a) {
            var o, c;
            if ("codepoint" == i) {
              var d = s.text.charCodeAt(e.ch + (n > 0 ? 0 : -1));
              if (isNaN(d)) o = null;else {
                var u = n > 0 ? d >= 55296 && d < 56320 : d >= 56320 && d < 57343;
                o = new ae(e.line, Math.max(0, Math.min(s.text.length, e.ch + n * (u ? 2 : 1))), -n);
              }
            } else o = r ? function (t, e, n, i) {
              var r = gt(e, t.doc.direction);
              if (!r) return eo(e, n, i);
              n.ch >= e.text.length ? (n.ch = e.text.length, n.sticky = "before") : n.ch <= 0 && (n.ch = 0, n.sticky = "after");
              var a = ht(r, n.ch, n.sticky),
                o = r[a];
              if ("ltr" == t.doc.direction && o.level % 2 == 0 && (i > 0 ? o.to > n.ch : o.from < n.ch)) return eo(e, n, i);
              var s,
                l = function l(t, n) {
                  return to(e, t instanceof ae ? t.ch : t, n);
                },
                c = function c(n) {
                  return t.options.lineWrapping ? (s = s || _n(t, e), ii(t, e, s, n)) : {
                    begin: 0,
                    end: e.text.length
                  };
                },
                d = c("before" == n.sticky ? l(n, -1) : n.ch);
              if ("rtl" == t.doc.direction || 1 == o.level) {
                var u = 1 == o.level == i < 0,
                  h = l(n, u ? 1 : -1);
                if (null != h && (u ? h <= o.to && h <= d.end : h >= o.from && h >= d.begin)) {
                  var p = u ? "before" : "after";
                  return new ae(n.line, h, p);
                }
              }
              var g = function g(t, e, i) {
                  for (var a = function a(t, e) {
                    return e ? new ae(n.line, l(t, 1), "before") : new ae(n.line, t, "after");
                  }; t >= 0 && t < r.length; t += e) {
                    var o = r[t],
                      s = e > 0 == (1 != o.level),
                      c = s ? i.begin : l(i.end, -1);
                    if (o.from <= c && c < o.to) return a(c, s);
                    if (c = s ? o.from : l(o.to, -1), i.begin <= c && c < i.end) return a(c, s);
                  }
                },
                f = g(a + i, i, d);
              if (f) return f;
              var m = i > 0 ? d.end : l(d.begin, -1);
              return null == m || i > 0 && m == e.text.length || !(f = g(i > 0 ? 0 : r.length - 1, i, c(m))) ? null : f;
            }(t.cm, s, e, n) : eo(s, e, n);
            if (null == o) {
              if (a || (c = e.line + l) < t.first || c >= t.first + t.size || (e = new ae(c, e.ch, e.sticky), !(s = Jt(t, c)))) return !1;
              e = no(r, t.cm, s, e.line, l);
            } else e = o;
            return !0;
          }
          if ("char" == i || "codepoint" == i) c();else if ("column" == i) c(!0);else if ("word" == i || "group" == i) for (var d = null, u = "group" == i, h = t.cm && t.cm.getHelper(e, "wordChars"), p = !0; !(n < 0) || c(!p); p = !1) {
            var g = s.text.charAt(e.ch) || "\n",
              f = at(g, h) ? "w" : u && "\n" == g ? "n" : !u || /\s/.test(g) ? null : "p";
            if (!u || p || f || (f = "s"), d && d != f) {
              n < 0 && (n = 1, c(), e.sticky = "after");
              break;
            }
            if (f && (d = f), n > 0 && !c(!p)) break;
          }
          var m = ca(t, e, a, o, !0);
          return se(a, m) && (m.hitSide = !0), m;
        }
        function Bo(t, e, n, i) {
          var r,
            a,
            o = t.doc,
            s = e.left;
          if ("page" == i) {
            var l = Math.min(t.display.wrapper.clientHeight, F(t).innerHeight || o(t).documentElement.clientHeight),
              c = Math.max(l - .5 * li(t.display), 3);
            r = (n > 0 ? e.bottom : e.top) + n * c;
          } else "line" == i && (r = n > 0 ? e.bottom + 3 : e.top - 3);
          for (; (a = ei(t, s, r)).outside;) {
            if (n < 0 ? r <= 0 : r >= o.height) {
              a.hitSide = !0;
              break;
            }
            r += 5 * n;
          }
          return a;
        }
        var Wo = function Wo(t) {
          this.cm = t, this.lastAnchorNode = this.lastAnchorOffset = this.lastFocusNode = this.lastFocusOffset = null, this.polling = new Y(), this.composing = null, this.gracePeriod = !1, this.readDOMTimeout = null;
        };
        function Yo(t, e) {
          var n = zn(t, e.line);
          if (!n || n.hidden) return null;
          var i = Jt(t.doc, e.line),
            r = Pn(n, i, e.line),
            a = gt(i, t.doc.direction),
            o = "left";
          a && (o = ht(a, e.ch) % 2 ? "right" : "left");
          var s = Rn(r.map, e.ch, o);
          return s.offset = "right" == s.collapse ? s.end : s.start, s;
        }
        function Uo(t, e) {
          return e && (t.bad = !0), t;
        }
        function Zo(t, e, n) {
          var i;
          if (e == t.display.lineDiv) {
            if (!(i = t.display.lineDiv.childNodes[n])) return Uo(t.clipPos(ae(t.display.viewTo - 1)), !0);
            e = null, n = 0;
          } else for (i = e;; i = i.parentNode) {
            if (!i || i == t.display.lineDiv) return null;
            if (i.parentNode && i.parentNode == t.display.lineDiv) break;
          }
          for (var r = 0; r < t.display.view.length; r++) {
            var a = t.display.view[r];
            if (a.node == i) return Go(a, e, n);
          }
        }
        function Go(t, e, n) {
          var i = t.text.firstChild,
            r = !1;
          if (!e || !E(i, e)) return Uo(ae(ee(t.line), 0), !0);
          if (e == i && (r = !0, e = i.childNodes[n], n = 0, !e)) {
            var a = t.rest ? K(t.rest) : t.line;
            return Uo(ae(ee(a), a.text.length), r);
          }
          var o = 3 == e.nodeType ? e : null,
            s = e;
          for (o || 1 != e.childNodes.length || 3 != e.firstChild.nodeType || (o = e.firstChild, n && (n = o.nodeValue.length)); s.parentNode != i;) s = s.parentNode;
          var l = t.measure,
            c = l.maps;
          function d(e, n, i) {
            for (var r = -1; r < (c ? c.length : 0); r++) for (var a = r < 0 ? l.map : c[r], o = 0; o < a.length; o += 3) {
              var s = a[o + 2];
              if (s == e || s == n) {
                var d = ee(r < 0 ? t.line : t.rest[r]),
                  u = a[o] + i;
                return (i < 0 || s != e) && (u = a[o + (i ? 1 : 0)]), ae(d, u);
              }
            }
          }
          var u = d(o, s, n);
          if (u) return Uo(u, r);
          for (var h = s.nextSibling, p = o ? o.nodeValue.length - n : 0; h; h = h.nextSibling) {
            if (u = d(h, h.firstChild, 0)) return Uo(ae(u.line, u.ch - p), r);
            p += h.textContent.length;
          }
          for (var g = s.previousSibling, f = n; g; g = g.previousSibling) {
            if (u = d(g, g.firstChild, -1)) return Uo(ae(u.line, u.ch + f), r);
            f += g.textContent.length;
          }
        }
        Wo.prototype.init = function (t) {
          var e = this,
            n = this,
            i = n.cm,
            r = n.div = t.lineDiv;
          function a(t) {
            for (var e = t.target; e; e = e.parentNode) {
              if (e == r) return !0;
              if (/\bCodeMirror-(?:line)?widget\b/.test(e.className)) break;
            }
            return !1;
          }
          function o(t) {
            if (a(t) && !wt(i, t)) {
              if (i.somethingSelected()) Po({
                lineWise: !1,
                text: i.getSelections()
              }), "cut" == t.type && i.replaceSelection("", null, "cut");else {
                if (!i.options.lineWiseCopyCut) return;
                var e = Ho(i);
                Po({
                  lineWise: !0,
                  text: e.text
                }), "cut" == t.type && i.operation(function () {
                  i.setSelections(e.ranges, 0, G), i.replaceSelection("", null, "cut");
                });
              }
              if (t.clipboardData) {
                t.clipboardData.clearData();
                var o = Io.text.join("\n");
                if (t.clipboardData.setData("Text", o), t.clipboardData.getData("Text") == o) return void t.preventDefault();
              }
              var s = Fo(),
                l = s.firstChild;
              Vo(l), i.display.lineSpace.insertBefore(s, i.display.lineSpace.firstChild), l.value = Io.text.join("\n");
              var c = I(V(r));
              z(l), setTimeout(function () {
                i.display.lineSpace.removeChild(s), c.focus(), c == r && n.showPrimarySelection();
              }, 50);
            }
          }
          r.contentEditable = !0, Vo(r, i.options.spellcheck, i.options.autocorrect, i.options.autocapitalize), mt(r, "paste", function (t) {
            !a(t) || wt(i, t) || zo(t, i) || s <= 11 && setTimeout(ar(i, function () {
              return e.updateFromDOM();
            }), 20);
          }), mt(r, "compositionstart", function (t) {
            e.composing = {
              data: t.data,
              done: !1
            };
          }), mt(r, "compositionupdate", function (t) {
            e.composing || (e.composing = {
              data: t.data,
              done: !1
            });
          }), mt(r, "compositionend", function (t) {
            e.composing && (t.data != e.composing.data && e.readFromDOMSoon(), e.composing.done = !0);
          }), mt(r, "touchstart", function () {
            return n.forceCompositionEnd();
          }), mt(r, "input", function () {
            e.composing || e.readFromDOMSoon();
          }), mt(r, "copy", o), mt(r, "cut", o);
        }, Wo.prototype.screenReaderLabelChanged = function (t) {
          t ? this.div.setAttribute("aria-label", t) : this.div.removeAttribute("aria-label");
        }, Wo.prototype.prepareSelection = function () {
          var t = ji(this.cm, !1);
          return t.focus = I(V(this.div)) == this.div, t;
        }, Wo.prototype.showSelection = function (t, e) {
          t && this.cm.display.view.length && ((t.focus || e) && this.showPrimarySelection(), this.showMultipleSelections(t));
        }, Wo.prototype.getSelection = function () {
          return this.cm.display.wrapper.ownerDocument.getSelection();
        }, Wo.prototype.showPrimarySelection = function () {
          var t = this.getSelection(),
            e = this.cm,
            i = e.doc.sel.primary(),
            r = i.from(),
            a = i.to();
          if (e.display.viewTo == e.display.viewFrom || r.line >= e.display.viewTo || a.line < e.display.viewFrom) t.removeAllRanges();else {
            var o = Zo(e, t.anchorNode, t.anchorOffset),
              s = Zo(e, t.focusNode, t.focusOffset);
            if (!o || o.bad || !s || s.bad || 0 != oe(de(o, s), r) || 0 != oe(ce(o, s), a)) {
              var l = e.display.view,
                c = r.line >= e.display.viewFrom && Yo(e, r) || {
                  node: l[0].measure.map[2],
                  offset: 0
                },
                d = a.line < e.display.viewTo && Yo(e, a);
              if (!d) {
                var u = l[l.length - 1].measure,
                  h = u.maps ? u.maps[u.maps.length - 1] : u.map;
                d = {
                  node: h[h.length - 1],
                  offset: h[h.length - 2] - h[h.length - 3]
                };
              }
              if (c && d) {
                var p,
                  g = t.rangeCount && t.getRangeAt(0);
                try {
                  p = O(c.node, c.offset, d.offset, d.node);
                } catch (t) {}
                p && (!n && e.state.focused ? (t.collapse(c.node, c.offset), p.collapsed || (t.removeAllRanges(), t.addRange(p))) : (t.removeAllRanges(), t.addRange(p)), g && null == t.anchorNode ? t.addRange(g) : n && this.startGracePeriod()), this.rememberSelection();
              } else t.removeAllRanges();
            }
          }
        }, Wo.prototype.startGracePeriod = function () {
          var t = this;
          clearTimeout(this.gracePeriod), this.gracePeriod = setTimeout(function () {
            t.gracePeriod = !1, t.selectionChanged() && t.cm.operation(function () {
              return t.cm.curOp.selectionChanged = !0;
            });
          }, 20);
        }, Wo.prototype.showMultipleSelections = function (t) {
          N(this.cm.display.cursorDiv, t.cursors), N(this.cm.display.selectionDiv, t.selection);
        }, Wo.prototype.rememberSelection = function () {
          var t = this.getSelection();
          this.lastAnchorNode = t.anchorNode, this.lastAnchorOffset = t.anchorOffset, this.lastFocusNode = t.focusNode, this.lastFocusOffset = t.focusOffset;
        }, Wo.prototype.selectionInEditor = function () {
          var t = this.getSelection();
          if (!t.rangeCount) return !1;
          var e = t.getRangeAt(0).commonAncestorContainer;
          return E(this.div, e);
        }, Wo.prototype.focus = function () {
          "nocursor" != this.cm.options.readOnly && (this.selectionInEditor() && I(V(this.div)) == this.div || this.showSelection(this.prepareSelection(), !0), this.div.focus());
        }, Wo.prototype.blur = function () {
          this.div.blur();
        }, Wo.prototype.getField = function () {
          return this.div;
        }, Wo.prototype.supportsTouch = function () {
          return !0;
        }, Wo.prototype.receivedFocus = function () {
          var t = this,
            e = this;
          this.selectionInEditor() ? setTimeout(function () {
            return t.pollSelection();
          }, 20) : rr(this.cm, function () {
            return e.cm.curOp.selectionChanged = !0;
          }), this.polling.set(this.cm.options.pollInterval, function t() {
            e.cm.state.focused && (e.pollSelection(), e.polling.set(e.cm.options.pollInterval, t));
          });
        }, Wo.prototype.selectionChanged = function () {
          var t = this.getSelection();
          return t.anchorNode != this.lastAnchorNode || t.anchorOffset != this.lastAnchorOffset || t.focusNode != this.lastFocusNode || t.focusOffset != this.lastFocusOffset;
        }, Wo.prototype.pollSelection = function () {
          if (null == this.readDOMTimeout && !this.gracePeriod && this.selectionChanged()) {
            var t = this.getSelection(),
              e = this.cm;
            if (v && d && this.cm.display.gutterSpecs.length && function (t) {
              for (var e = t; e; e = e.parentNode) if (/CodeMirror-gutter-wrapper/.test(e.className)) return !0;
              return !1;
            }(t.anchorNode)) return this.cm.triggerOnKeyDown({
              type: "keydown",
              keyCode: 8,
              preventDefault: Math.abs
            }), this.blur(), void this.focus();
            if (!this.composing) {
              this.rememberSelection();
              var n = Zo(e, t.anchorNode, t.anchorOffset),
                i = Zo(e, t.focusNode, t.focusOffset);
              n && i && rr(e, function () {
                ia(e.doc, Lr(n, i), G), (n.bad || i.bad) && (e.curOp.selectionChanged = !0);
              });
            }
          }
        }, Wo.prototype.pollContent = function () {
          null != this.readDOMTimeout && (clearTimeout(this.readDOMTimeout), this.readDOMTimeout = null);
          var t,
            e,
            n,
            i = this.cm,
            r = i.display,
            a = i.doc.sel.primary(),
            o = a.from(),
            s = a.to();
          if (0 == o.ch && o.line > i.firstLine() && (o = ae(o.line - 1, Jt(i.doc, o.line - 1).length)), s.ch == Jt(i.doc, s.line).text.length && s.line < i.lastLine() && (s = ae(s.line + 1, 0)), o.line < r.viewFrom || s.line > r.viewTo - 1) return !1;
          o.line == r.viewFrom || 0 == (t = fi(i, o.line)) ? (e = ee(r.view[0].line), n = r.view[0].node) : (e = ee(r.view[t].line), n = r.view[t - 1].node.nextSibling);
          var l,
            c,
            d = fi(i, s.line);
          if (d == r.view.length - 1 ? (l = r.viewTo - 1, c = r.lineDiv.lastChild) : (l = ee(r.view[d + 1].line) - 1, c = r.view[d + 1].node.previousSibling), !n) return !1;
          for (var u = i.doc.splitLines(function (t, e, n, i, r) {
              var a = "",
                o = !1,
                s = t.doc.lineSeparator(),
                l = !1;
              function c() {
                o && (a += s, l && (a += s), o = l = !1);
              }
              function d(t) {
                t && (c(), a += t);
              }
              function u(e) {
                if (1 == e.nodeType) {
                  var n = e.getAttribute("cm-text");
                  if (n) return void d(n);
                  var a,
                    h = e.getAttribute("cm-marker");
                  if (h) {
                    var p = t.findMarks(ae(i, 0), ae(r + 1, 0), (m = +h, function (t) {
                      return t.id == m;
                    }));
                    return void (p.length && (a = p[0].find(0)) && d(Xt(t.doc, a.from, a.to).join(s)));
                  }
                  if ("false" == e.getAttribute("contenteditable")) return;
                  var g = /^(pre|div|p|li|table|br)$/i.test(e.nodeName);
                  if (!/^br$/i.test(e.nodeName) && 0 == e.textContent.length) return;
                  g && c();
                  for (var f = 0; f < e.childNodes.length; f++) u(e.childNodes[f]);
                  /^(pre|p)$/i.test(e.nodeName) && (l = !0), g && (o = !0);
                } else 3 == e.nodeType && d(e.nodeValue.replace(/\u200b/g, "").replace(/\u00a0/g, " "));
                var m;
              }
              for (; u(e), e != n;) e = e.nextSibling, l = !1;
              return a;
            }(i, n, c, e, l)), h = Xt(i.doc, ae(e, 0), ae(l, Jt(i.doc, l).text.length)); u.length > 1 && h.length > 1;) if (K(u) == K(h)) u.pop(), h.pop(), l--;else {
            if (u[0] != h[0]) break;
            u.shift(), h.shift(), e++;
          }
          for (var p = 0, g = 0, f = u[0], m = h[0], v = Math.min(f.length, m.length); p < v && f.charCodeAt(p) == m.charCodeAt(p);) ++p;
          for (var b = K(u), y = K(h), w = Math.min(b.length - (1 == u.length ? p : 0), y.length - (1 == h.length ? p : 0)); g < w && b.charCodeAt(b.length - g - 1) == y.charCodeAt(y.length - g - 1);) ++g;
          if (1 == u.length && 1 == h.length && e == o.line) for (; p && p > o.ch && b.charCodeAt(b.length - g - 1) == y.charCodeAt(y.length - g - 1);) p--, g++;
          u[u.length - 1] = b.slice(0, b.length - g).replace(/^\u200b+/, ""), u[0] = u[0].slice(p).replace(/\u200b+$/, "");
          var x = ae(e, p),
            j = ae(l, h.length ? K(h).length - g : 0);
          return u.length > 1 || u[0] || oe(x, j) ? (ba(i.doc, u, x, j, "+input"), !0) : void 0;
        }, Wo.prototype.ensurePolled = function () {
          this.forceCompositionEnd();
        }, Wo.prototype.reset = function () {
          this.forceCompositionEnd();
        }, Wo.prototype.forceCompositionEnd = function () {
          this.composing && (clearTimeout(this.readDOMTimeout), this.composing = null, this.updateFromDOM(), this.div.blur(), this.div.focus());
        }, Wo.prototype.readFromDOMSoon = function () {
          var t = this;
          null == this.readDOMTimeout && (this.readDOMTimeout = setTimeout(function () {
            if (t.readDOMTimeout = null, t.composing) {
              if (!t.composing.done) return;
              t.composing = null;
            }
            t.updateFromDOM();
          }, 80));
        }, Wo.prototype.updateFromDOM = function () {
          var t = this;
          !this.cm.isReadOnly() && this.pollContent() || rr(this.cm, function () {
            return mi(t.cm);
          });
        }, Wo.prototype.setUneditable = function (t) {
          t.contentEditable = "false";
        }, Wo.prototype.onKeyPress = function (t) {
          0 == t.charCode || this.composing || (t.preventDefault(), this.cm.isReadOnly() || ar(this.cm, Ao)(this.cm, String.fromCharCode(null == t.charCode ? t.keyCode : t.charCode), 0));
        }, Wo.prototype.readOnlyChanged = function (t) {
          this.div.contentEditable = String("nocursor" != t);
        }, Wo.prototype.onContextMenu = function () {}, Wo.prototype.resetPosition = function () {}, Wo.prototype.needsContentAttribute = !0;
        var qo = function qo(t) {
          this.cm = t, this.prevInput = "", this.pollingFast = !1, this.polling = new Y(), this.hasSelection = !1, this.composing = null, this.resetting = !1;
        };
        qo.prototype.init = function (t) {
          var e = this,
            n = this,
            i = this.cm;
          this.createField(t);
          var r = this.textarea;
          function a(t) {
            if (!wt(i, t)) {
              if (i.somethingSelected()) Po({
                lineWise: !1,
                text: i.getSelections()
              });else {
                if (!i.options.lineWiseCopyCut) return;
                var e = Ho(i);
                Po({
                  lineWise: !0,
                  text: e.text
                }), "cut" == t.type ? i.setSelections(e.ranges, null, G) : (n.prevInput = "", r.value = e.text.join("\n"), z(r));
              }
              "cut" == t.type && (i.state.cutIncoming = +new Date());
            }
          }
          t.wrapper.insertBefore(this.wrapper, t.wrapper.firstChild), m && (r.style.width = "0px"), mt(r, "input", function () {
            o && s >= 9 && e.hasSelection && (e.hasSelection = null), n.poll();
          }), mt(r, "paste", function (t) {
            wt(i, t) || zo(t, i) || (i.state.pasteIncoming = +new Date(), n.fastPoll());
          }), mt(r, "cut", a), mt(r, "copy", a), mt(t.scroller, "paste", function (e) {
            if (!Tn(t, e) && !wt(i, e)) {
              if (!r.dispatchEvent) return i.state.pasteIncoming = +new Date(), void n.focus();
              var a = new Event("paste");
              a.clipboardData = e.clipboardData, r.dispatchEvent(a);
            }
          }), mt(t.lineSpace, "selectstart", function (e) {
            Tn(t, e) || Mt(e);
          }), mt(r, "compositionstart", function () {
            var t = i.getCursor("from");
            n.composing && n.composing.range.clear(), n.composing = {
              start: t,
              range: i.markText(t, i.getCursor("to"), {
                className: "CodeMirror-composing"
              })
            };
          }), mt(r, "compositionend", function () {
            n.composing && (n.poll(), n.composing.range.clear(), n.composing = null);
          });
        }, qo.prototype.createField = function (t) {
          this.wrapper = Fo(), this.textarea = this.wrapper.firstChild;
          var e = this.cm.options;
          Vo(this.textarea, e.spellcheck, e.autocorrect, e.autocapitalize);
        }, qo.prototype.screenReaderLabelChanged = function (t) {
          t ? this.textarea.setAttribute("aria-label", t) : this.textarea.removeAttribute("aria-label");
        }, qo.prototype.prepareSelection = function () {
          var t = this.cm,
            e = t.display,
            n = t.doc,
            i = ji(t);
          if (t.options.moveInputWithCursor) {
            var r = Xn(t, n.sel.primary().head, "div"),
              a = e.wrapper.getBoundingClientRect(),
              o = e.lineDiv.getBoundingClientRect();
            i.teTop = Math.max(0, Math.min(e.wrapper.clientHeight - 10, r.top + o.top - a.top)), i.teLeft = Math.max(0, Math.min(e.wrapper.clientWidth - 10, r.left + o.left - a.left));
          }
          return i;
        }, qo.prototype.showSelection = function (t) {
          var e = this.cm.display;
          N(e.cursorDiv, t.cursors), N(e.selectionDiv, t.selection), null != t.teTop && (this.wrapper.style.top = t.teTop + "px", this.wrapper.style.left = t.teLeft + "px");
        }, qo.prototype.reset = function (t) {
          if (!(this.contextMenuPending || this.composing && t)) {
            var e = this.cm;
            if (this.resetting = !0, e.somethingSelected()) {
              this.prevInput = "";
              var n = e.getSelection();
              this.textarea.value = n, e.state.focused && z(this.textarea), o && s >= 9 && (this.hasSelection = n);
            } else t || (this.prevInput = this.textarea.value = "", o && s >= 9 && (this.hasSelection = null));
            this.resetting = !1;
          }
        }, qo.prototype.getField = function () {
          return this.textarea;
        }, qo.prototype.supportsTouch = function () {
          return !1;
        }, qo.prototype.focus = function () {
          if ("nocursor" != this.cm.options.readOnly && (!b || I(V(this.textarea)) != this.textarea)) try {
            this.textarea.focus();
          } catch (t) {}
        }, qo.prototype.blur = function () {
          this.textarea.blur();
        }, qo.prototype.resetPosition = function () {
          this.wrapper.style.top = this.wrapper.style.left = 0;
        }, qo.prototype.receivedFocus = function () {
          this.slowPoll();
        }, qo.prototype.slowPoll = function () {
          var t = this;
          this.pollingFast || this.polling.set(this.cm.options.pollInterval, function () {
            t.poll(), t.cm.state.focused && t.slowPoll();
          });
        }, qo.prototype.fastPoll = function () {
          var t = !1,
            e = this;
          e.pollingFast = !0, e.polling.set(20, function n() {
            e.poll() || t ? (e.pollingFast = !1, e.slowPoll()) : (t = !0, e.polling.set(60, n));
          });
        }, qo.prototype.poll = function () {
          var t = this,
            e = this.cm,
            n = this.textarea,
            i = this.prevInput;
          if (this.contextMenuPending || this.resetting || !e.state.focused || _t(n) && !i && !this.composing || e.isReadOnly() || e.options.disableInput || e.state.keySeq) return !1;
          var r = n.value;
          if (r == i && !e.somethingSelected()) return !1;
          if (o && s >= 9 && this.hasSelection === r || y && /[\uf700-\uf7ff]/.test(r)) return e.display.input.reset(), !1;
          if (e.doc.sel == e.display.selForContextMenu) {
            var a = r.charCodeAt(0);
            if (8203 != a || i || (i = "​"), 8666 == a) return this.reset(), this.cm.execCommand("undo");
          }
          for (var l = 0, c = Math.min(i.length, r.length); l < c && i.charCodeAt(l) == r.charCodeAt(l);) ++l;
          return rr(e, function () {
            Ao(e, r.slice(l), i.length - l, null, t.composing ? "*compose" : null), r.length > 1e3 || r.indexOf("\n") > -1 ? n.value = t.prevInput = "" : t.prevInput = r, t.composing && (t.composing.range.clear(), t.composing.range = e.markText(t.composing.start, e.getCursor("to"), {
              className: "CodeMirror-composing"
            }));
          }), !0;
        }, qo.prototype.ensurePolled = function () {
          this.pollingFast && this.poll() && (this.pollingFast = !1);
        }, qo.prototype.onKeyPress = function () {
          o && s >= 9 && (this.hasSelection = null), this.fastPoll();
        }, qo.prototype.onContextMenu = function (t) {
          var e = this,
            n = e.cm,
            i = n.display,
            r = e.textarea;
          e.contextMenuPending && e.contextMenuPending();
          var a = gi(n, t),
            c = i.scroller.scrollTop;
          if (a && !h) {
            n.options.resetSelectionOnContextMenu && -1 == n.doc.sel.contains(a) && ar(n, ia)(n.doc, Lr(a), G);
            var d,
              u = r.style.cssText,
              p = e.wrapper.style.cssText,
              g = e.wrapper.offsetParent.getBoundingClientRect();
            if (e.wrapper.style.cssText = "position: static", r.style.cssText = "position: absolute; width: 30px; height: 30px;\n      top: " + (t.clientY - g.top - 5) + "px; left: " + (t.clientX - g.left - 5) + "px;\n      z-index: 1000; background: " + (o ? "rgba(255, 255, 255, .05)" : "transparent") + ";\n      outline: none; border-width: 0; outline: none; overflow: hidden; opacity: .05; filter: alpha(opacity=5);", l && (d = r.ownerDocument.defaultView.scrollY), i.input.focus(), l && r.ownerDocument.defaultView.scrollTo(null, d), i.input.reset(), n.somethingSelected() || (r.value = e.prevInput = " "), e.contextMenuPending = v, i.selForContextMenu = n.doc.sel, clearTimeout(i.detectingSelectAll), o && s >= 9 && m(), M) {
              Tt(t);
              var _f = function f() {
                bt(window, "mouseup", _f), setTimeout(v, 20);
              };
              mt(window, "mouseup", _f);
            } else setTimeout(v, 50);
          }
          function m() {
            if (null != r.selectionStart) {
              var t = n.somethingSelected(),
                a = "​" + (t ? r.value : "");
              r.value = "⇚", r.value = a, e.prevInput = t ? "" : "​", r.selectionStart = 1, r.selectionEnd = a.length, i.selForContextMenu = n.doc.sel;
            }
          }
          function v() {
            if (e.contextMenuPending == v && (e.contextMenuPending = !1, e.wrapper.style.cssText = p, r.style.cssText = u, o && s < 9 && i.scrollbars.setScrollTop(i.scroller.scrollTop = c), null != r.selectionStart)) {
              (!o || o && s < 9) && m();
              var t = 0,
                _a2 = function a() {
                  i.selForContextMenu == n.doc.sel && 0 == r.selectionStart && r.selectionEnd > 0 && "​" == e.prevInput ? ar(n, ua)(n) : t++ < 10 ? i.detectingSelectAll = setTimeout(_a2, 500) : (i.selForContextMenu = null, i.input.reset());
                };
              i.detectingSelectAll = setTimeout(_a2, 200);
            }
          }
        }, qo.prototype.readOnlyChanged = function (t) {
          t || this.reset(), this.textarea.disabled = "nocursor" == t, this.textarea.readOnly = !!t;
        }, qo.prototype.setUneditable = function () {}, qo.prototype.needsContentAttribute = !1, function (t) {
          var e = t.optionHandlers;
          function n(n, i, r, a) {
            t.defaults[n] = i, r && (e[n] = a ? function (t, e, n) {
              n != ko && r(t, e, n);
            } : r);
          }
          t.defineOption = n, t.Init = ko, n("value", "", function (t, e) {
            return t.setValue(e);
          }, !0), n("mode", null, function (t, e) {
            t.doc.modeOption = e, Ar(t);
          }, !0), n("indentUnit", 2, Ar, !0), n("indentWithTabs", !1), n("smartIndent", !0), n("tabSize", 4, function (t) {
            zr(t), Un(t), mi(t);
          }, !0), n("lineSeparator", null, function (t, e) {
            if (t.doc.lineSep = e, e) {
              var n = [],
                i = t.doc.first;
              t.doc.iter(function (t) {
                for (var r = 0;;) {
                  var a = t.text.indexOf(e, r);
                  if (-1 == a) break;
                  r = a + e.length, n.push(ae(i, a));
                }
                i++;
              });
              for (var r = n.length - 1; r >= 0; r--) ba(t.doc, e, n[r], ae(n[r].line, n[r].ch + e.length));
            }
          }), n("specialChars", /[\u0000-\u001f\u007f-\u009f\u00ad\u061c\u200b\u200e\u200f\u2028\u2029\u202d\u202e\u2066\u2067\u2069\ufeff\ufff9-\ufffc]/g, function (t, e, n) {
            t.state.specialChars = new RegExp(e.source + (e.test("\t") ? "" : "|\t"), "g"), n != ko && t.refresh();
          }), n("specialCharPlaceholder", rn, function (t) {
            return t.refresh();
          }, !0), n("electricChars", !0), n("inputStyle", b ? "contenteditable" : "textarea", function () {
            throw new Error("inputStyle can not (yet) be changed in a running editor");
          }, !0), n("spellcheck", !1, function (t, e) {
            return t.getInputField().spellcheck = e;
          }, !0), n("autocorrect", !1, function (t, e) {
            return t.getInputField().autocorrect = e;
          }, !0), n("autocapitalize", !1, function (t, e) {
            return t.getInputField().autocapitalize = e;
          }, !0), n("rtlMoveVisually", !x), n("wholeLineUpdateBefore", !0), n("theme", "default", function (t) {
            Mo(t), wr(t);
          }, !0), n("keyMap", "default", function (t, e, n) {
            var i = Xa(e),
              r = n != ko && Xa(n);
            r && r.detach && r.detach(t, i), i.attach && i.attach(t, r || null);
          }), n("extraKeys", null), n("configureMouse", null), n("lineWrapping", !1, No, !0), n("gutters", [], function (t, e) {
            t.display.gutterSpecs = br(e, t.options.lineNumbers), wr(t);
          }, !0), n("fixedGutter", !0, function (t, e) {
            t.display.gutters.style.left = e ? ui(t.display) + "px" : "0", t.refresh();
          }, !0), n("coverGutterNextToScrollbar", !1, function (t) {
            return Zi(t);
          }, !0), n("scrollbarStyle", "native", function (t) {
            $i(t), Zi(t), t.display.scrollbars.setScrollTop(t.doc.scrollTop), t.display.scrollbars.setScrollLeft(t.doc.scrollLeft);
          }, !0), n("lineNumbers", !1, function (t, e) {
            t.display.gutterSpecs = br(t.options.gutters, e), wr(t);
          }, !0), n("firstLineNumber", 1, wr, !0), n("lineNumberFormatter", function (t) {
            return t;
          }, wr, !0), n("showCursorWhenSelecting", !1, xi, !0), n("resetSelectionOnContextMenu", !0), n("lineWiseCopyCut", !0), n("pasteLinesPerSelection", !0), n("selectionsMayTouch", !1), n("readOnly", !1, function (t, e) {
            "nocursor" == e && (Li(t), t.display.input.blur()), t.display.input.readOnlyChanged(e);
          }), n("screenReaderLabel", null, function (t, e) {
            e = "" === e ? null : e, t.display.input.screenReaderLabelChanged(e);
          }), n("disableInput", !1, function (t, e) {
            e || t.display.input.reset();
          }, !0), n("dragDrop", !0, So), n("allowDropFileTypes", null), n("cursorBlinkRate", 530), n("cursorScrollMargin", 0), n("cursorHeight", 1, xi, !0), n("singleCursorHeightPerLine", !0, xi, !0), n("workTime", 100), n("workDelay", 100), n("flattenSpans", !0, zr, !0), n("addModeClass", !1, zr, !0), n("pollInterval", 100), n("undoDepth", 200, function (t, e) {
            return t.doc.history.undoDepth = e;
          }), n("historyEventDelay", 1250), n("viewportMargin", 10, function (t) {
            return t.refresh();
          }, !0), n("maxHighlightLength", 1e4, zr, !0), n("moveInputWithCursor", !0, function (t, e) {
            e || t.display.input.resetPosition();
          }), n("tabindex", null, function (t, e) {
            return t.display.input.getField().tabIndex = e || "";
          }), n("autofocus", null), n("direction", "ltr", function (t, e) {
            return t.doc.setDirection(e);
          }, !0), n("phrases", null);
        }(Lo), function (t) {
          var e = t.optionHandlers,
            n = t.helpers = {};
          t.prototype = {
            constructor: t,
            focus: function focus() {
              F(this).focus(), this.display.input.focus();
            },
            setOption: function setOption(t, n) {
              var i = this.options,
                r = i[t];
              i[t] == n && "mode" != t || (i[t] = n, e.hasOwnProperty(t) && ar(this, e[t])(this, n, r), yt(this, "optionChange", this, t));
            },
            getOption: function getOption(t) {
              return this.options[t];
            },
            getDoc: function getDoc() {
              return this.doc;
            },
            addKeyMap: function addKeyMap(t, e) {
              this.state.keyMaps[e ? "push" : "unshift"](Xa(t));
            },
            removeKeyMap: function removeKeyMap(t) {
              for (var e = this.state.keyMaps, n = 0; n < e.length; ++n) if (e[n] == t || e[n].name == t) return e.splice(n, 1), !0;
            },
            addOverlay: or(function (e, n) {
              var i = e.token ? e : t.getMode(this.options, e);
              if (i.startState) throw new Error("Overlays may not be stateful.");
              !function (t, e, n) {
                for (var i = 0, r = n(e); i < t.length && n(t[i]) <= r;) i++;
                t.splice(i, 0, e);
              }(this.state.overlays, {
                mode: i,
                modeSpec: e,
                opaque: n && n.opaque,
                priority: n && n.priority || 0
              }, function (t) {
                return t.priority;
              }), this.state.modeGen++, mi(this);
            }),
            removeOverlay: or(function (t) {
              for (var e = this.state.overlays, n = 0; n < e.length; ++n) {
                var i = e[n].modeSpec;
                if (i == t || "string" == typeof t && i.name == t) return e.splice(n, 1), this.state.modeGen++, void mi(this);
              }
            }),
            indentLine: or(function (t, e, n) {
              "string" != typeof e && "number" != typeof e && (e = null == e ? this.options.smartIndent ? "smart" : "prev" : e ? "add" : "subtract"), ie(this.doc, t) && Eo(this, t, e, n);
            }),
            indentSelection: or(function (t) {
              for (var e = this.doc.sel.ranges, n = -1, i = 0; i < e.length; i++) {
                var r = e[i];
                if (r.empty()) r.head.line > n && (Eo(this, r.head.line, t, !0), n = r.head.line, i == this.doc.sel.primIndex && zi(this));else {
                  var a = r.from(),
                    o = r.to(),
                    s = Math.max(n, a.line);
                  n = Math.min(this.lastLine(), o.line - (o.ch ? 0 : 1)) + 1;
                  for (var l = s; l < n; ++l) Eo(this, l, t);
                  var c = this.doc.sel.ranges;
                  0 == a.ch && e.length == c.length && c[i].from().ch > 0 && ta(this.doc, i, new Sr(a, c[i].to()), G);
                }
              }
            }),
            getTokenAt: function getTokenAt(t, e) {
              return Ce(this, t, e);
            },
            getLineTokens: function getLineTokens(t, e) {
              return Ce(this, ae(t), e, !0);
            },
            getTokenTypeAt: function getTokenTypeAt(t) {
              t = he(this.doc, t);
              var e,
                n = ve(this, Jt(this.doc, t.line)),
                i = 0,
                r = (n.length - 1) / 2,
                a = t.ch;
              if (0 == a) e = n[2];else for (;;) {
                var o = i + r >> 1;
                if ((o ? n[2 * o - 1] : 0) >= a) r = o;else {
                  if (!(n[2 * o + 1] < a)) {
                    e = n[2 * o + 2];
                    break;
                  }
                  i = o + 1;
                }
              }
              var s = e ? e.indexOf("overlay ") : -1;
              return s < 0 ? e : 0 == s ? null : e.slice(0, s - 1);
            },
            getModeAt: function getModeAt(e) {
              var n = this.doc.mode;
              return n.innerMode ? t.innerMode(n, this.getTokenAt(e).state).mode : n;
            },
            getHelper: function getHelper(t, e) {
              return this.getHelpers(t, e)[0];
            },
            getHelpers: function getHelpers(t, e) {
              var i = [];
              if (!n.hasOwnProperty(e)) return i;
              var r = n[e],
                a = this.getModeAt(t);
              if ("string" == typeof a[e]) r[a[e]] && i.push(r[a[e]]);else if (a[e]) for (var o = 0; o < a[e].length; o++) {
                var s = r[a[e][o]];
                s && i.push(s);
              } else a.helperType && r[a.helperType] ? i.push(r[a.helperType]) : r[a.name] && i.push(r[a.name]);
              for (var l = 0; l < r._global.length; l++) {
                var c = r._global[l];
                c.pred(a, this) && -1 == U(i, c.val) && i.push(c.val);
              }
              return i;
            },
            getStateAfter: function getStateAfter(t, e) {
              var n = this.doc;
              return be(this, (t = ue(n, null == t ? n.first + n.size - 1 : t)) + 1, e).state;
            },
            cursorCoords: function cursorCoords(t, e) {
              var n = this.doc.sel.primary();
              return Xn(this, null == t ? n.head : "object" == typeof t ? he(this.doc, t) : t ? n.from() : n.to(), e || "page");
            },
            charCoords: function charCoords(t, e) {
              return Jn(this, he(this.doc, t), e || "page");
            },
            coordsChar: function coordsChar(t, e) {
              return ei(this, (t = Qn(this, t, e || "page")).left, t.top);
            },
            lineAtHeight: function lineAtHeight(t, e) {
              return t = Qn(this, {
                top: t,
                left: 0
              }, e || "page").top, ne(this.doc, t + this.display.viewOffset);
            },
            heightAtLine: function heightAtLine(t, e, n) {
              var i,
                r = !1;
              if ("number" == typeof t) {
                var a = this.doc.first + this.doc.size - 1;
                t < this.doc.first ? t = this.doc.first : t > a && (t = a, r = !0), i = Jt(this.doc, t);
              } else i = t;
              return $n(this, i, {
                top: 0,
                left: 0
              }, e || "page", n || r).top + (r ? this.doc.height - qe(i) : 0);
            },
            defaultTextHeight: function defaultTextHeight() {
              return li(this.display);
            },
            defaultCharWidth: function defaultCharWidth() {
              return ci(this.display);
            },
            getViewport: function getViewport() {
              return {
                from: this.display.viewFrom,
                to: this.display.viewTo
              };
            },
            addWidget: function addWidget(t, e, n, i, r) {
              var a,
                o,
                s = this.display,
                l = (t = Xn(this, he(this.doc, t))).bottom,
                c = t.left;
              if (e.style.position = "absolute", e.setAttribute("cm-ignore-events", "true"), this.display.input.setUneditable(e), s.sizer.appendChild(e), "over" == i) l = t.top;else if ("above" == i || "near" == i) {
                var d = Math.max(s.wrapper.clientHeight, this.doc.height),
                  u = Math.max(s.sizer.clientWidth, s.lineSpace.clientWidth);
                ("above" == i || t.bottom + e.offsetHeight > d) && t.top > e.offsetHeight ? l = t.top - e.offsetHeight : t.bottom + e.offsetHeight <= d && (l = t.bottom), c + e.offsetWidth > u && (c = u - e.offsetWidth);
              }
              e.style.top = l + "px", e.style.left = e.style.right = "", "right" == r ? (c = s.sizer.clientWidth - e.offsetWidth, e.style.right = "0px") : ("left" == r ? c = 0 : "middle" == r && (c = (s.sizer.clientWidth - e.offsetWidth) / 2), e.style.left = c + "px"), n && (null != (o = Pi(a = this, {
                left: c,
                top: l,
                right: c + e.offsetWidth,
                bottom: l + e.offsetHeight
              })).scrollTop && Fi(a, o.scrollTop), null != o.scrollLeft && Bi(a, o.scrollLeft));
            },
            triggerOnKeyDown: or(po),
            triggerOnKeyPress: or(fo),
            triggerOnKeyUp: go,
            triggerOnMouseDown: or(yo),
            execCommand: function execCommand(t) {
              if (io.hasOwnProperty(t)) return io[t].call(null, this);
            },
            triggerElectric: or(function (t) {
              _o(this, t);
            }),
            findPosH: function findPosH(t, e, n, i) {
              var r = 1;
              e < 0 && (r = -1, e = -e);
              for (var a = he(this.doc, t), o = 0; o < e && !(a = Ro(this.doc, a, r, n, i)).hitSide; ++o);
              return a;
            },
            moveH: or(function (t, e) {
              var n = this;
              this.extendSelectionsBy(function (i) {
                return n.display.shift || n.doc.extend || i.empty() ? Ro(n.doc, i.head, t, e, n.options.rtlMoveVisually) : t < 0 ? i.from() : i.to();
              }, $);
            }),
            deleteH: or(function (t, e) {
              var n = this.doc.sel,
                i = this.doc;
              n.somethingSelected() ? i.replaceSelection("", null, "+delete") : Ka(this, function (n) {
                var r = Ro(i, n.head, t, e, !1);
                return t < 0 ? {
                  from: r,
                  to: n.head
                } : {
                  from: n.head,
                  to: r
                };
              });
            }),
            findPosV: function findPosV(t, e, n, i) {
              var r = 1,
                a = i;
              e < 0 && (r = -1, e = -e);
              for (var o = he(this.doc, t), s = 0; s < e; ++s) {
                var l = Xn(this, o, "div");
                if (null == a ? a = l.left : l.left = a, (o = Bo(this, l, r, n)).hitSide) break;
              }
              return o;
            },
            moveV: or(function (t, e) {
              var n = this,
                i = this.doc,
                r = [],
                a = !this.display.shift && !i.extend && i.sel.somethingSelected();
              if (i.extendSelectionsBy(function (o) {
                if (a) return t < 0 ? o.from() : o.to();
                var s = Xn(n, o.head, "div");
                null != o.goalColumn && (s.left = o.goalColumn), r.push(s.left);
                var l = Bo(n, s, t, e);
                return "page" == e && o == i.sel.primary() && Ai(n, Jn(n, l, "div").top - s.top), l;
              }, $), r.length) for (var o = 0; o < i.sel.ranges.length; o++) i.sel.ranges[o].goalColumn = r[o];
            }),
            findWordAt: function findWordAt(t) {
              var e = Jt(this.doc, t.line).text,
                n = t.ch,
                i = t.ch;
              if (e) {
                var r = this.getHelper(t, "wordChars");
                "before" != t.sticky && i != e.length || !n ? ++i : --n;
                for (var a = e.charAt(n), o = at(a, r) ? function (t) {
                    return at(t, r);
                  } : /\s/.test(a) ? function (t) {
                    return /\s/.test(t);
                  } : function (t) {
                    return !/\s/.test(t) && !at(t);
                  }; n > 0 && o(e.charAt(n - 1));) --n;
                for (; i < e.length && o(e.charAt(i));) ++i;
              }
              return new Sr(ae(t.line, n), ae(t.line, i));
            },
            toggleOverwrite: function toggleOverwrite(t) {
              null != t && t == this.state.overwrite || ((this.state.overwrite = !this.state.overwrite) ? P(this.display.cursorDiv, "CodeMirror-overwrite") : T(this.display.cursorDiv, "CodeMirror-overwrite"), yt(this, "overwriteToggle", this, this.state.overwrite));
            },
            hasFocus: function hasFocus() {
              return this.display.input.getField() == I(H(this));
            },
            isReadOnly: function isReadOnly() {
              return !(!this.options.readOnly && !this.doc.cantEdit);
            },
            scrollTo: or(function (t, e) {
              _i(this, t, e);
            }),
            getScrollInfo: function getScrollInfo() {
              var t = this.display.scroller;
              return {
                left: t.scrollLeft,
                top: t.scrollTop,
                height: t.scrollHeight - Dn(this) - this.display.barHeight,
                width: t.scrollWidth - Dn(this) - this.display.barWidth,
                clientHeight: In(this),
                clientWidth: En(this)
              };
            },
            scrollIntoView: or(function (t, e) {
              null == t ? (t = {
                from: this.doc.sel.primary().head,
                to: null
              }, null == e && (e = this.options.cursorScrollMargin)) : "number" == typeof t ? t = {
                from: ae(t, 0),
                to: null
              } : null == t.from && (t = {
                from: t,
                to: null
              }), t.to || (t.to = t.from), t.margin = e || 0, null != t.from.line ? function (t, e) {
                Hi(t), t.curOp.scrollToPos = e;
              }(this, t) : Vi(this, t.from, t.to, t.margin);
            }),
            setSize: or(function (t, e) {
              var n = this,
                i = function i(t) {
                  return "number" == typeof t || /^\d+$/.test(String(t)) ? t + "px" : t;
                };
              null != t && (this.display.wrapper.style.width = i(t)), null != e && (this.display.wrapper.style.height = i(e)), this.options.lineWrapping && Yn(this);
              var r = this.display.viewFrom;
              this.doc.iter(r, this.display.viewTo, function (t) {
                if (t.widgets) for (var e = 0; e < t.widgets.length; e++) if (t.widgets[e].noHScroll) {
                  vi(n, r, "widget");
                  break;
                }
                ++r;
              }), this.curOp.forceUpdate = !0, yt(this, "refresh", this);
            }),
            operation: function operation(t) {
              return rr(this, t);
            },
            startOperation: function startOperation() {
              return Ji(this);
            },
            endOperation: function endOperation() {
              return Xi(this);
            },
            refresh: or(function () {
              var t = this.display.cachedTextHeight;
              mi(this), this.curOp.forceUpdate = !0, Un(this), _i(this, this.doc.scrollLeft, this.doc.scrollTop), gr(this.display), (null == t || Math.abs(t - li(this.display)) > .5 || this.options.lineWrapping) && pi(this), yt(this, "refresh", this);
            }),
            swapDoc: or(function (t) {
              var e = this.doc;
              return e.cm = null, this.state.selectingText && this.state.selectingText(), Fr(this, t), Un(this), this.display.input.reset(), _i(this, t.scrollLeft, t.scrollTop), this.curOp.forceScroll = !0, pn(this, "swapDoc", this, e), e;
            }),
            phrase: function phrase(t) {
              var e = this.options.phrases;
              return e && Object.prototype.hasOwnProperty.call(e, t) ? e[t] : t;
            },
            getInputField: function getInputField() {
              return this.display.input.getField();
            },
            getWrapperElement: function getWrapperElement() {
              return this.display.wrapper;
            },
            getScrollerElement: function getScrollerElement() {
              return this.display.scroller;
            },
            getGutterElement: function getGutterElement() {
              return this.display.gutters;
            }
          }, Ct(t), t.registerHelper = function (e, i, r) {
            n.hasOwnProperty(e) || (n[e] = t[e] = {
              _global: []
            }), n[e][i] = r;
          }, t.registerGlobalHelper = function (e, i, r, a) {
            t.registerHelper(e, i, a), n[e]._global.push({
              pred: r,
              val: a
            });
          };
        }(Lo);
        var $o = "iter insert remove copy getEditor constructor".split(" ");
        for (var Qo in _Pa.prototype) _Pa.prototype.hasOwnProperty(Qo) && U($o, Qo) < 0 && (Lo.prototype[Qo] = function (t) {
          return function () {
            return t.apply(this.doc, arguments);
          };
        }(_Pa.prototype[Qo]));
        return Ct(_Pa), Lo.inputStyles = {
          textarea: qo,
          contenteditable: Wo
        }, Lo.defineMode = function (t) {
          Lo.defaults.mode || "null" == t || (Lo.defaults.mode = t), Bt.apply(this, arguments);
        }, Lo.defineMIME = function (t, e) {
          Rt[t] = e;
        }, Lo.defineMode("null", function () {
          return {
            token: function token(t) {
              return t.skipToEnd();
            }
          };
        }), Lo.defineMIME("text/plain", "null"), Lo.defineExtension = function (t, e) {
          Lo.prototype[t] = e;
        }, Lo.defineDocExtension = function (t, e) {
          _Pa.prototype[t] = e;
        }, Lo.fromTextArea = function (t, e) {
          if ((e = e ? B(e) : {}).value = t.value, !e.tabindex && t.tabIndex && (e.tabindex = t.tabIndex), !e.placeholder && t.placeholder && (e.placeholder = t.placeholder), null == e.autofocus) {
            var n = I(V(t));
            e.autofocus = n == t || null != t.getAttribute("autofocus") && n == document.body;
          }
          function i() {
            t.value = s.getValue();
          }
          var r;
          if (t.form && (mt(t.form, "submit", i), !e.leaveSubmitMethodAlone)) {
            var a = t.form;
            r = a.submit;
            try {
              var o = a.submit = function () {
                i(), a.submit = r, a.submit(), a.submit = o;
              };
            } catch (t) {}
          }
          e.finishInit = function (n) {
            n.save = i, n.getTextArea = function () {
              return t;
            }, n.toTextArea = function () {
              n.toTextArea = isNaN, i(), t.parentNode.removeChild(n.getWrapperElement()), t.style.display = "", t.form && (bt(t.form, "submit", i), e.leaveSubmitMethodAlone || "function" != typeof t.form.submit || (t.form.submit = r));
            };
          }, t.style.display = "none";
          var s = Lo(function (e) {
            return t.parentNode.insertBefore(e, t.nextSibling);
          }, e);
          return s;
        }, function (t) {
          t.off = bt, t.on = mt, t.wheelEventPixels = kr, t.Doc = _Pa, t.splitLines = zt, t.countColumn = W, t.findColumn = Q, t.isWordChar = rt, t.Pass = Z, t.signal = yt, t.Line = Je, t.changeEnd = Dr, t.scrollbarModel = qi, t.Pos = ae, t.cmpPos = oe, t.modes = Ft, t.mimeModes = Rt, t.resolveMode = Wt, t.getMode = Yt, t.modeExtensions = Ut, t.extendMode = Zt, t.copyState = Gt, t.startState = $t, t.innerMode = qt, t.commands = io, t.keyMap = Ua, t.keyName = Ja, t.isModifierKey = $a, t.lookupKey = qa, t.normalizeKeyMap = Ga, t.StringStream = Qt, t.SharedTextMarker = La, t.TextMarker = Sa, t.LineWidget = ka, t.e_preventDefault = Mt, t.e_stopPropagation = kt, t.e_stop = Tt, t.addClass = P, t.contains = E, t.rmClass = T, t.keyNames = Ra;
        }(Lo), Lo.version = "5.65.16", Lo;
      }();
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(8),
        r = n.n(i),
        a = n(2),
        o = n.n(a),
        s = n(1),
        l = n.n(s),
        c = n(0),
        d = n(3),
        u = n(7),
        h = n(20);
      function p(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function g(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? p(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var f = l.a.View.extend({
          events: function events() {
            return this.model.get("events") || {
              mousedown: "handleClick"
            };
          },
          attributes: function attributes() {
            return this.model.get("attributes");
          },
          initialize: function initialize() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = t.config,
              n = void 0 === e ? {} : e;
            this.em = n.em, this.editor = n.editor;
          },
          handleClick: function handleClick(t) {
            t.preventDefault(), t.stopPropagation();
            var e = this.editor,
              n = this.em,
              i = e.Canvas.getFrameEl().getBoundingClientRect(),
              r = i.left,
              a = i.top,
              o = g(g({}, t), {}, {
                clientX: t.clientX - r,
                clientY: t.clientY - a
              });
            n.trigger("toolbar:run:before"), this.execCommand(o);
          },
          execCommand: function execCommand(t) {
            var e = {
                event: t
              },
              n = this.model.get("command"),
              i = this.editor;
            "function" == typeof n && n(i, null, e), "string" == typeof n && i.runCommand(n, e);
          },
          render: function render() {
            var t = this.editor,
              e = this.$el,
              n = this.model,
              i = n.get("id"),
              r = n.get("label"),
              a = t.getConfig("stylePrefix");
            return e.addClass("".concat(a, "toolbar-item")), i && e.addClass("".concat(a, "toolbar-item__").concat(i)), r && e.append(r), this;
          }
        }),
        m = h.a.extend({
          itemView: f,
          initialize: function initialize() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            this.config = {
              editor: t.editor || "",
              em: t.em
            }, this.listenTo(this.collection, "reset", this.render);
          }
        }),
        v = l.a.Model.extend({
          defaults: {
            command: "",
            attributes: {}
          }
        }),
        b = l.a.Collection.extend({
          model: v
        });
      function y(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function w(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? y(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : y(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var x,
        j = l.a.$;
      e.default = {
        init: function init(t) {
          Object(c.bindAll)(this, "onHover", "onOut", "onClick", "onFrameScroll", "onFrameUpdated", "onContainerChange");
        },
        enable: function enable() {
          this.frameOff = this.canvasOff = this.adjScroll = null, this.startSelectComponent(), x = 1;
        },
        startSelectComponent: function startSelectComponent() {
          this.toggleSelectComponent(1), this.em.getSelected() && this.onSelect();
        },
        stopSelectComponent: function stopSelectComponent() {
          this.toggleSelectComponent();
        },
        toggleSelectComponent: function toggleSelectComponent(t) {
          var e = this,
            n = this.em,
            i = n.getConfig("listenToEl"),
            r = n.getContainer().parentNode,
            a = t ? "on" : "off",
            o = {
              on: d.u,
              off: d.t
            };
          !i.length && r && i.push(r), o[a](window, "resize", this.onFrameUpdated), o[a](i, "scroll", this.onContainerChange), n[a]("component:toggled", this.onSelect, this), n[a]("change:componentHovered", this.onHovered, this), n[a]("component:resize component:styleUpdate component:input", this.updateGlobalPos, this), n[a]("change:canvasOffset", this.updateAttached, this), n[a]("frame:updated", this.onFrameUpdated, this), n.get("Canvas").getFrames().forEach(function (t) {
            var n,
              i,
              r = t.view;
            r && (n = r.getWindow(), i = r.getBody(), o[a](i, "mouseover", e.onHover), o[a](i, "mouseleave", e.onOut), o[a](i, "click touchend", e.onClick), o[a](n, "scroll", e.onFrameScroll));
          });
        },
        onHover: function onHover(t) {
          t.stopPropagation();
          var e = t.target,
            n = Object(d.j)(e),
            i = n && n._getFrame(),
            r = j(e),
            a = r.data("model");
          if (!a) for (var o = r.parent(); !a && o.length && !Object(u.g)(o[0]);) a = o.data("model"), o = o.parent();
          if (a && !a.get("hoverable")) {
            for (var s = a && a.parent(); s && !s.get("hoverable");) s = s.parent();
            a = s;
          }
          this.currentDoc = e.ownerDocument, this.em.setHovered(a), i && this.em.set("currentFrame", i);
        },
        onFrameUpdated: function onFrameUpdated() {
          this.updateLocalPos(), this.updateGlobalPos();
        },
        onHovered: function onHovered(t, e) {
          var n = this,
            i = {};
          e && e.views.forEach(function (t) {
            var r = t.el,
              a = n.getElementPos(r);
            i = {
              el: r,
              pos: a,
              component: e,
              view: Object(d.j)(r)
            }, n.updateToolsLocal(i), r.ownerDocument === n.currentDoc && (n.elHovered = i);
          });
        },
        onSelect: Object(c.debounce)(function () {
          var t = this.em,
            e = t.getSelected(),
            n = t.get("currentFrame") || {},
            i = e && e.getView(n.model),
            r = i && i.el,
            a = {};
          r && Object(u.h)(r) && (a = {
            el: r,
            pos: this.getElementPos(r),
            component: e,
            view: Object(d.j)(r)
          }), this.elSelected = a, this.updateToolsGlobal(), this.updateToolsLocal(a), this.initResize(e);
        }),
        updateGlobalPos: function updateGlobalPos() {
          var t = this.getElSelected();
          t.el && (t.pos = this.getElementPos(t.el), this.updateToolsGlobal());
        },
        updateLocalPos: function updateLocalPos() {
          var t = this.getElHovered();
          t.el && (t.pos = this.getElementPos(t.el), this.updateToolsLocal());
        },
        getElHovered: function getElHovered() {
          return this.elHovered || {};
        },
        getElSelected: function getElSelected() {
          return this.elSelected || {};
        },
        onOut: function onOut() {
          var t = this;
          this.currentDoc = null, this.em.setHovered(0), this.elHovered = 0, this.updateToolsLocal(), this.canvas.getFrames().forEach(function (e) {
            var n = e.view,
              i = n && n.getToolsEl();
            i && t.toggleToolsEl(0, 0, {
              el: i
            });
          });
        },
        toggleToolsEl: function toggleToolsEl(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            i = n.el || this.canvas.getToolsEl(e);
          return i && (i.style.opacity = t ? 1 : 0), i || {};
        },
        showElementOffset: function showElementOffset(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          x && this.editor.runCommand("show-offset", {
            el: t,
            elPos: e,
            view: n.view,
            force: 1,
            top: 0,
            left: 0
          });
        },
        hideElementOffset: function hideElementOffset(t) {
          this.editor.stopCommand("show-offset", {
            view: t
          });
        },
        showFixedElementOffset: function showFixedElementOffset(t, e) {
          this.editor.runCommand("show-offset", {
            el: t,
            elPos: e,
            state: "Fixed"
          });
        },
        hideFixedElementOffset: function hideFixedElementOffset(t, e) {
          this.editor && this.editor.stopCommand("show-offset", {
            state: "Fixed"
          });
        },
        hideHighlighter: function hideHighlighter(t) {
          this.canvas.getHighlighter(t).style.opacity = 0;
        },
        onClick: function onClick(t) {
          t.stopPropagation(), t.preventDefault();
          var e = this.em;
          if (e.get("_cmpDrag")) return e.set("_cmpDrag");
          var n = j(t.target),
            i = n.data("model");
          if (!i) for (var r = n.parent(); !i && r.length && !Object(u.g)(r[0]);) i = r.data("model"), r = r.parent();
          if (i) if (i.get("selectable")) this.select(i, t);else {
            for (var a = i.parent(); a && !a.get("selectable");) a = a.parent();
            this.select(a, t);
          }
        },
        select: function select(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if (t) {
            var n = e.ctrlKey || e.metaKey,
              i = e.shiftKey,
              r = this.editor,
              a = this.em,
              o = r.getConfig("multipleSelection");
            if (n && o) r.selectToggle(t);else if (i && o) {
              a.clearSelection(r.Canvas.getWindow());
              var s,
                l,
                d = t.collection,
                u = d.indexOf(t);
              if (r.getSelectedAll(), r.getSelectedAll().forEach(function (t) {
                var e = t.collection,
                  n = e.indexOf(t);
                e === d && (n < u ? s = Object(c.isUndefined)(s) ? n : Math.max(s, n) : n > u && (l = Object(c.isUndefined)(l) ? n : Math.min(l, n)));
              }), !Object(c.isUndefined)(s)) for (; s !== u;) r.selectAdd(d.at(s)), s++;
              if (!Object(c.isUndefined)(l)) for (; l !== u;) r.selectAdd(d.at(l)), l--;
              r.selectAdd(t);
            } else r.select(t, {
              scroll: {}
            });
            this.initResize(t);
          }
        },
        updateBadge: function updateBadge(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            i = j(t).data("model");
          if (i && i.get("badgable")) {
            var r = this.getBadge(n);
            if (!n.posOnly) {
              var a = this.canvas.getConfig(),
                o = i.getIcon(),
                s = a.pStylePrefix || "",
                l = "".concat(s, "badge"),
                c = a.customBadgeLabel,
                d = "".concat(o ? '<div class="'.concat(l, '__icon">').concat(o, "</div>") : "", '\n        <div class="').concat(l, '__name">').concat(i.getName(), "</div>");
              r.innerHTML = c ? c(i) : d;
            }
            var u = "px",
              h = r.style;
            h.display = "block";
            var p = r ? r.offsetHeight : 0,
              g = 0 - p,
              f = n.topOff - p < 0 ? -n.topOff : g,
              m = n.leftOff < 0 ? -n.leftOff : 0;
            h.top = f + u, h.left = m + u;
          }
        },
        showHighlighter: function showHighlighter(t) {
          this.canvas.getHighlighter(t).style.opacity = "";
        },
        initResize: function initResize(t) {
          var e,
            n = this.em,
            i = this.canvas,
            a = n ? n.get("Editor") : "",
            o = (n ? n.get("Config") : "").stylePrefix || "",
            s = "".concat(o, "resizing"),
            l = !Object(c.isElement)(t) && Object(d.p)(t) ? t : n.getSelected(),
            u = l && l.get("resizable"),
            h = {},
            p = function p(t, e, n) {
              var i = n.docs;
              i && i.forEach(function (e) {
                var n = e.body,
                  i = n.className || "";
                n.className = ("add" == t ? "".concat(i, " ").concat(s) : i.replace(s, "")).trim();
              });
            };
          if (a && u) {
            var g = Object(c.isElement)(t) ? t : l.getEl();
            h = {
              onStart: function onStart(t) {
                var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                  a = r.el,
                  o = r.config,
                  s = r.resizer,
                  c = o.keyHeight,
                  u = o.keyWidth,
                  h = o.currentUnit,
                  g = o.keepAutoHeight,
                  f = o.keepAutoWidth;
                p("add", 0, r), e = n.get("StyleManager").getModelToStyle(l), i.toggleFramesEvents();
                var m = getComputedStyle(a),
                  v = e.getStyle(),
                  b = v[u];
                o.autoWidth = f && "auto" === b, isNaN(parseFloat(b)) && (b = m[u]);
                var y = v[c];
                o.autoHeight = g && "auto" === y, isNaN(parseFloat(y)) && (y = m[c]), s.startDim.w = parseFloat(b), s.startDim.h = parseFloat(y), x = 0, h && (o.unitHeight = Object(d.i)(y), o.unitWidth = Object(d.i)(b));
              },
              onMove: function onMove() {
                a.trigger("component:resize");
              },
              onEnd: function onEnd(t, e) {
                p("remove", 0, e), a.trigger("component:resize"), i.toggleFramesEvents(1), x = 1;
              },
              updateTarget: function updateTarget(t, r) {
                var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                if (e) {
                  var o = a.store,
                    s = a.selectedHandler,
                    l = a.config,
                    c = l.keyHeight,
                    d = l.keyWidth,
                    u = l.autoHeight,
                    h = l.autoWidth,
                    p = l.unitWidth,
                    g = l.unitHeight,
                    f = ["tc", "bc"].indexOf(s) >= 0,
                    m = ["cl", "cr"].indexOf(s) >= 0,
                    v = {},
                    b = o ? "" : 1;
                  if (!f) {
                    var y = i.getBody().offsetWidth,
                      x = r.w < y ? r.w : y;
                    v[d] = h ? "auto" : "".concat(x).concat(p);
                  }
                  m || (v[c] = u ? "auto" : "".concat(r.h).concat(g)), e.addStyle(w(w({}, v), {}, {
                    en: b
                  }), {
                    avoidStore: !o
                  });
                  var j = "update:component:style",
                    C = "".concat(j, ":").concat(c, " ").concat(j, ":").concat(d);
                  n && n.trigger(C, null, null, {
                    noEmit: 1
                  });
                }
              }
            }, "object" == r()(u) && (h = w(w({}, h), u)), this.resizer = a.runCommand("resize", {
              el: g,
              options: h,
              force: 1
            });
          } else a.stopCommand("resize"), this.resizer = null;
        },
        updateToolbar: function updateToolbar(t) {
          var e = this.config.em,
            n = t == e ? e.getSelected() : t,
            i = this.canvas.getToolbarEl(),
            r = i.style;
          if (n) {
            var a = n.get("toolbar");
            if (e.get("Config").showToolbar && a && a.length) {
              if (r.opacity = "", r.display = "", !this.toolbar) {
                i.innerHTML = "", this.toolbar = new b(a);
                var o = new m({
                  collection: this.toolbar,
                  editor: this.editor,
                  em: e
                });
                i.appendChild(o.render().el);
              }
              this.toolbar.reset(a), r.top = "-100px", r.left = 0;
            } else r.display = "none";
          } else r.opacity = 0;
        },
        updateToolbarPos: function updateToolbarPos(t) {
          var e = this.canvas.getToolbarEl().style;
          e.top = "".concat(t.top).concat("px"), e.left = "".concat(t.left).concat("px"), e.opacity = "";
        },
        getCanvasPosition: function getCanvasPosition() {
          return this.canvas.getCanvasView().getPosition();
        },
        getBadge: function getBadge() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return this.canvas.getBadgeEl(t.view);
        },
        onFrameScroll: function onFrameScroll() {
          this.updateTools();
        },
        updateTools: function updateTools() {
          this.updateToolsLocal(), this.updateGlobalPos();
        },
        isCompSelected: function isCompSelected(t) {
          return t && "selected" === t.get("status");
        },
        updateToolsLocal: function updateToolsLocal(t) {
          var e = t || this.getElHovered(),
            n = e.el,
            i = e.pos,
            r = e.view,
            a = e.component;
          if (n) {
            var o = a.get("hoverable"),
              s = this.lastHovered !== n,
              l = s ? {} : {
                posOnly: 1
              };
            s && o && (this.lastHovered = n, this.showHighlighter(r), this.showElementOffset(n, i, {
              view: r
            })), this.isCompSelected(a) && (this.hideHighlighter(r), this.hideElementOffset(r));
            var c = this.toggleToolsEl(1, r).style,
              d = this.canvas.canvasRectOffset(n, i),
              u = d.top,
              h = d.left;
            this.updateBadge(n, i, w(w({}, l), {}, {
              view: r,
              topOff: u,
              leftOff: h
            })), c.top = u + "px", c.left = h + "px", c.width = i.width + "px", c.height = i.height + "px";
          } else this.lastHovered = 0;
        },
        updateToolsGlobal: function updateToolsGlobal() {
          var t = this.getElSelected(),
            e = t.el,
            n = t.pos,
            i = t.component;
          if (!e) return this.toggleToolsEl(), void (this.lastSelected = 0);
          var r = this.canvas;
          this.lastSelected !== e && (this.lastSelected = e, this.updateToolbar(i));
          var a = this.toggleToolsEl(1).style,
            o = r.getTargetToElementFixed(e, r.getToolbarEl(), {
              pos: n
            }),
            s = o.canvasOffsetTop,
            l = o.canvasOffsetLeft;
          a.top = s + "px", a.left = l + "px", a.width = n.width + "px", a.height = n.height + "px", this.updateToolbarPos({
            top: o.top,
            left: o.left
          });
        },
        updateAttached: Object(c.debounce)(function () {
          this.updateGlobalPos();
        }),
        onContainerChange: Object(c.debounce)(function () {
          this.em.refreshCanvas();
        }, 150),
        getElementPos: function getElementPos(t) {
          return this.canvas.getCanvasView().getElementPos(t);
        },
        hideBadge: function hideBadge() {
          this.getBadge().style.display = "none";
        },
        cleanPrevious: function cleanPrevious(t) {
          t && t.set({
            status: "",
            state: ""
          });
        },
        getContentWindow: function getContentWindow() {
          return this.canvas.getWindow();
        },
        run: function run(t) {
          this.editor = t && t.get("Editor"), this.enable();
        },
        stop: function stop(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            i = this.em,
            r = this.editor;
          this.stopSelectComponent(), !n.preserveSelected && i.setSelected(null), this.onOut(), this.toggleToolsEl(), r && r.stopCommand("resize");
        }
      };
    }, function (t, e) {
      t.exports = function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e, n) {
      var i = n(42);
      function r(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, i(r.key), r);
        }
      }
      t.exports = function (t, e, n) {
        return e && r(t.prototype, e), n && r(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), t;
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e, n) {
      "use strict";

      n.d(e, "a", function () {
        return p;
      });
      var i = n(2),
        r = n.n(i),
        a = n(15),
        o = n.n(a),
        s = n(16),
        l = n.n(s),
        c = n(0),
        d = n(3);
      function u(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function h(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? u(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var p = function () {
        function t() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return o()(this, t), this.opts = {
            container: null,
            onStart: null,
            onDrag: null,
            onEnd: null,
            setPosition: null,
            getPosition: null,
            guidesStatic: null,
            guidesTarget: null,
            snapOffset: 5,
            doc: 0,
            scale: 1
          }, Object(c.bindAll)(this, "drag", "stop", "keyHandle", "handleScroll"), this.setOptions(e), this.delta = {
            x: 0,
            y: 0
          }, this;
        }
        return l()(t, [{
          key: "setOptions",
          value: function value() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            this.opts = h(h({}, this.opts), t);
          }
        }, {
          key: "toggleDrag",
          value: function value(t) {
            var e = this.getDocumentEl(),
              n = this.getContainerEl(),
              i = this.getWindowEl(),
              r = t ? "on" : "off",
              a = {
                on: d.u,
                off: d.t
              };
            a[r](n, "mousemove dragover", this.drag), a[r](e, "mouseup dragend touchend", this.stop), a[r](e, "keydown", this.keyHandle), a[r](i, "scroll", this.handleScroll);
          }
        }, {
          key: "handleScroll",
          value: function value() {
            var t = this.lastScroll,
              e = this.delta,
              n = this.getScrollInfo(),
              i = {
                x: n.x - t.x,
                y: n.y - t.y
              };
            this.move(e.x + i.x, e.y + i.y), this.lastScrollDiff = i;
          }
        }, {
          key: "start",
          value: function value(t) {
            var e = this.opts,
              n = e.onStart;
            this.toggleDrag(1), this.startPointer = this.getPointerPos(t), this.guidesStatic = Object(c.result)(e, "guidesStatic") || [], this.guidesTarget = Object(c.result)(e, "guidesTarget") || [], Object(c.isFunction)(n) && n(t, this), this.startPosition = this.getStartPosition(), this.lastScrollDiff = {
              x: 0,
              y: 0
            }, this.globScrollDiff = {
              x: 0,
              y: 0
            }, this.drag(t);
          }
        }, {
          key: "drag",
          value: function value(t) {
            var e = this,
              n = this.opts,
              i = this.lastScrollDiff,
              r = this.globScrollDiff,
              a = n.onDrag,
              o = this.startPointer,
              s = this.getPointerPos(t),
              l = {
                x: r.x + i.x,
                y: r.y + i.y
              };
            this.globScrollDiff = l;
            var d = {
              x: s.x - o.x + l.x,
              y: s.y - o.y + l.y
            };
            this.lastScrollDiff = {
              x: 0,
              y: 0
            };
            var u = this.lockedAxis;
            "x" === (u = t.shiftKey ? !u && this.detectAxisLock(d.x, d.y) : null) ? d.x = o.x : "y" === u && (d.y = o.y);
            var p = function p(i) {
                ["x", "y"].forEach(function (t) {
                  return i[t] = i[t] * Object(c.result)(n, "scale");
                }), e.delta = i, e.move(i.x, i.y), Object(c.isFunction)(a) && a(t, e);
              },
              g = h({}, d);
            if (this.currentPointer = s, this.lockedAxis = u, this.lastScroll = this.getScrollInfo(), p(d), this.guidesTarget.length) {
              var f = this.snapGuides(g),
                m = f.newDelta,
                v = f.trgX,
                b = f.trgY;
              (v || b) && p(m);
            }
            0 === t.which && this.stop(t);
          }
        }, {
          key: "snapGuides",
          value: function value(t) {
            var e = this,
              n = t,
              i = this.trgX,
              r = this.trgY;
            return this.guidesTarget.forEach(function (n) {
              n.x && e.trgX || n.y && e.trgY || (n.active = 0, e.guidesStatic.forEach(function (a) {
                if (!(n.y && a.x || n.x && a.y)) {
                  var o = n.y && a.y,
                    s = o ? "y" : "x",
                    l = n[s],
                    d = a[s],
                    u = t[s],
                    h = o ? r : i;
                  if (e.isPointIn(l, d) && Object(c.isUndefined)(h)) {
                    var p = u - (l - d);
                    e.setGuideLock(n, p);
                  }
                }
              }));
            }), i = this.trgX, r = this.trgY, ["x", "y"].forEach(function (i) {
              var r = i.toUpperCase(),
                a = e["trg".concat(r)];
              a && !e.isPointIn(t[i], a.lock) && (e.setGuideLock(a, null), a = null), a && !Object(c.isUndefined)(a.lock) && (n[i] = a.lock);
            }), {
              newDelta: n,
              trgX: this.trgX,
              trgY: this.trgY
            };
          }
        }, {
          key: "isPointIn",
          value: function value(t, e) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              i = n.offset,
              r = i || this.opts.snapOffset;
            return t >= e && t <= e + r || t <= e && t >= e - r;
          }
        }, {
          key: "setGuideLock",
          value: function value(t, e) {
            var n = Object(c.isUndefined)(t.x) ? "Y" : "X",
              i = "trg".concat(n);
            return null !== e ? (t.active = 1, t.lock = e, this[i] = t) : (delete t.active, delete t.lock, delete this[i]), t;
          }
        }, {
          key: "stop",
          value: function value(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = this.delta,
              i = e.cancel,
              r = i ? 0 : n.x,
              a = i ? 0 : n.y;
            this.toggleDrag(), this.lockedAxis = null, this.move(r, a, 1);
            var o = this.opts.onEnd;
            Object(c.isFunction)(o) && o(t, this, {
              cancelled: i
            });
          }
        }, {
          key: "keyHandle",
          value: function value(t) {
            Object(d.m)(t) && this.stop(t, {
              cancel: 1
            });
          }
        }, {
          key: "move",
          value: function value(t, e, n) {
            var i = this.el,
              r = this.opts,
              a = this.startPosition;
            if (a) {
              var o = r.setPosition,
                s = a.x + t,
                l = a.y + e;
              this.position = {
                x: s,
                y: l,
                end: n
              }, Object(c.isFunction)(o) && o(this.position), i && (i.style.left = "".concat(s, "px"), i.style.top = "".concat(l, "px"));
            }
          }
        }, {
          key: "getContainerEl",
          value: function value() {
            var t = this.opts.container;
            return t ? [t] : this.getDocumentEl();
          }
        }, {
          key: "getWindowEl",
          value: function value() {
            return this.getContainerEl().map(function (t) {
              var e = t.ownerDocument || t;
              return e.defaultView || e.parentWindow;
            });
          }
        }, {
          key: "getDocumentEl",
          value: function value(t) {
            var e = this.opts.doc;
            if (t = t || this.el, !this.docs) {
              var n = [document];
              t && n.push(t.ownerDocument), e && n.push(e), this.docs = n;
            }
            return this.docs;
          }
        }, {
          key: "getPointerPos",
          value: function value(t) {
            var e = this.opts.getPointerPosition,
              n = Object(d.h)(t);
            return e ? e(t) : {
              x: n.clientX,
              y: n.clientY
            };
          }
        }, {
          key: "getStartPosition",
          value: function value() {
            var t = this.el,
              e = this.opts.getPosition,
              n = {
                x: 0,
                y: 0
              };
            return Object(c.isFunction)(e) ? n = e() : t && (n = {
              x: parseFloat(t.style.left),
              y: parseFloat(t.style.top)
            }), n;
          }
        }, {
          key: "getScrollInfo",
          value: function value() {
            var t = this.opts.doc,
              e = t && t.body;
            return {
              y: e ? e.scrollTop : 0,
              x: e ? e.scrollLeft : 0
            };
          }
        }, {
          key: "detectAxisLock",
          value: function value(t, e) {
            var n = t,
              i = e,
              r = Math.abs(n),
              a = Math.abs(i);
            return i >= r || i <= -r ? "x" : n > a || n < -a ? "y" : void 0;
          }
        }]), t;
      }();
    }, function (t, e, n) {
      "use strict";

      var i = n(1),
        r = n.n(i),
        a = r.a.$;
      e.a = r.a.View.extend({
        events: {
          change: "handleChange"
        },
        template: function template() {
          return '<span class="'.concat(this.holderClass(), '"></span>');
        },
        inputClass: function inputClass() {
          return "".concat(this.ppfx, "field");
        },
        holderClass: function holderClass() {
          return "".concat(this.ppfx, "input-holder");
        },
        initialize: function initialize() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = t.ppfx || "";
          this.opts = t, this.ppfx = e, this.em = t.target || {}, this.listenTo(this.model, "change:value", this.handleModelChange);
        },
        elementUpdated: function elementUpdated() {
          this.model.trigger("el:change");
        },
        setValue: function setValue(t) {
          var e = this.model,
            n = t || e.get("defaults"),
            i = this.getInputEl();
          i && (i.value = n);
        },
        handleModelChange: function handleModelChange(t, e, n) {
          this.setValue(e, n);
        },
        handleChange: function handleChange(t) {
          t.stopPropagation();
          var e = this.getInputEl().value;
          this.model.set({
            value: e
          }, {
            fromInput: 1
          }), this.elementUpdated();
        },
        getInputEl: function getInputEl() {
          if (!this.inputEl) {
            var t = this.model,
              e = t.get("placeholder") || t.get("defaults") || "";
            this.inputEl = a('<input type="text" placeholder="'.concat(e, '">'));
          }
          return this.inputEl.get(0);
        },
        render: function render() {
          this.inputEl = null;
          var t = this.$el;
          return t.addClass(this.inputClass()), t.html(this.template()), t.find(".".concat(this.holderClass())).append(this.getInputEl()), this;
        }
      });
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(1),
        r = n.n(i),
        a = n(7);
      e.default = r.a.View.extend({
        initialize: function initialize(t) {
          this.config = t.config || {}, this.pfx = this.config.stylePrefix || "", this.target = t.target || {}, this.propTarget = t.propTarget || {}, this.onChange = t.onChange, this.onInputRender = t.onInputRender || {}, this.customValue = t.customValue || {}, this.properties = [];
          var e = this.collection;
          this.listenTo(e, "add", this.addTo), this.listenTo(e, "reset", this.render);
        },
        addTo: function addTo(t, e, n) {
          this.add(t, null, n);
        },
        add: function add(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            i = e || this.el,
            r = new t.typeView({
              model: t,
              name: t.get("name"),
              id: this.pfx + t.get("property"),
              target: this.target,
              propTarget: this.propTarget,
              onChange: this.onChange,
              onInputRender: this.onInputRender,
              config: this.config
            });
          "composite" != t.get("type") && (r.customValue = this.customValue), r.render();
          var o = r.el;
          this.properties.push(r), r.updateVisibility(), Object(a.b)(i, o, n.at);
        },
        render: function render() {
          var t = this,
            e = this.$el;
          this.clearItems();
          var n = document.createDocumentFragment();
          return this.collection.each(function (e) {
            return t.add(e, n);
          }), e.empty(), e.append(n), e.attr("class", "".concat(this.pfx, "properties")), this;
        },
        remove: function remove() {
          r.a.View.prototype.remove.apply(this, arguments), this.clearItems();
        },
        clearItems: function clearItems() {
          this.properties.forEach(function (t) {
            return t.remove();
          }), this.properties = [];
        }
      });
    }, function (t, e, n) {
      "use strict";

      var i = n(0),
        r = n(1),
        a = n.n(r);
      e.a = a.a.View.extend({
        itemView: "",
        itemsView: "",
        itemType: "type",
        autoAdd: 0,
        initialize: function initialize() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = arguments.length > 1 ? arguments[1] : void 0;
          this.config = e || t.config || {}, this.autoAdd && this.listenTo(this.collection, "add", this.addTo), this.items = [], this.init();
        },
        init: function init() {},
        addTo: function addTo(t) {
          this.add(t);
        },
        itemViewNotFound: function itemViewNotFound(t) {
          var e = this.config,
            n = this.ns,
            i = e.em,
            r = "".concat(n ? "[".concat(n, "]: ") : "", "'").concat(t, "' type not found");
          i && i.logWarning(r);
        },
        add: function add(t, e) {
          var n,
            r = this.config,
            a = this.reuseView,
            o = this.items,
            s = this.itemsView,
            l = void 0 === s ? {} : s,
            c = e || null,
            d = this.itemView,
            u = t.get(this.itemType);
          l[u] ? d = l[u] : !u || l[u] || Object(i.includes)(["button", "checkbox", "color", "date", "datetime-local", "email", "file", "hidden", "image", "month", "number", "password", "radio", "range", "reset", "search", "submit", "tel", "text", "time", "url", "week"], u) || this.itemViewNotFound(u), n = t.view && a ? t.view : new d({
            model: t,
            config: r
          }, r), o && o.push(n);
          var h = n.render().el;
          c ? c.appendChild(h) : this.$el.append(h);
        },
        render: function render() {
          var t = document.createDocumentFragment();
          return this.clearItems(), this.$el.empty(), this.collection.length && this.collection.each(function (e) {
            this.add(e, t);
          }, this), this.$el.append(t), this.onRender(), this;
        },
        onRender: function onRender() {},
        remove: function remove() {
          this.clearItems(), a.a.View.prototype.remove.apply(this, arguments);
        },
        clearItems: function clearItems() {
          this.items;
        }
      });
    }, function (t, e, n) {
      "use strict";

      var i,
        r = n(8),
        a = n.n(r),
        o = n(2),
        s = n.n(o),
        l = n(1),
        c = n.n(l),
        d = n(0);
      function u(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function h(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? u(Object(n), !0).forEach(function (e) {
            s()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.a = c.a.Collection.extend({
        initialize: function initialize(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          this.opt = e, this.listenTo(this, "add", this.onAdd), this.listenTo(this, "remove", this.removeChildren), this.listenTo(this, "reset", this.resetChildren), this.config = e.config, this.em = e.em, this.domc = e.domc;
        },
        resetChildren: function resetChildren(t) {
          var e = this,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            i = this,
            r = n.previousModels,
            a = void 0 === r ? [] : r;
          a.forEach(function (t) {
            return e.removeChildren(t, i, n);
          }), t.each(function (t) {
            return e.onAdd(t);
          });
        },
        removeChildren: function removeChildren(t, e) {
          var n = this,
            i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            r = this.domc,
            a = this.em,
            o = r ? r.allById() : {};
          if (!i.temporary) {
            var s = t.getId(),
              l = a.get("SelectorManager").getAll(),
              c = a.get("CssComposer").getAll();
            delete o[s];
            var d = c.remove(c.filter(function (t) {
              return t.getSelectors().getFullString() === "#".concat(s);
            }));
            if (l.remove(d.map(function (t) {
              return t.getSelectors().at(0);
            })), !t.opt.temporary) {
              var u = a.get("Commands"),
                h = t.get("style-signature"),
                p = {
                  target: t
                };
              h && u.run("core:component-style-clear", p), t.removed(), a.trigger("component:remove", t);
            }
            var g = t.components();
            g.forEach(function (t) {
              return n.removeChildren(t, e, i);
            });
          }
          var f = t.components(),
            m = a.get("UndoManager");
          a.stopListening(f), a.stopListening(t), a.stopListening(t.get("classes")), m.remove(t), m.remove(f);
        },
        model: function model(t, e) {
          var n,
            i = e.collection.opt,
            r = i.em,
            a = r.get("DomComponents").componentTypes;
          e.em = r, e.config = i.config, e.componentTypes = a, e.domc = i.domc;
          for (var o = 0; o < a.length; o++) if (a[o].id == t.type) {
            n = a[o].model;
            break;
          }
          return n || (n = a[a.length - 1].model, r && t.type && r.logWarning("Component type '".concat(t.type, "' not found"), {
            attrs: t,
            options: e
          })), new n(t, e);
        },
        parseString: function parseString(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = this.em,
            a = this.opt.domc,
            o = r.get("CssComposer"),
            s = r.get("Parser").parseHtml(t);
          return i || (i = n(5).default), i.checkId(s.html, s.css, a.componentsById), s.css && o && !e.temporary && o.addCollection(s.css, h(h({}, e), {}, {
            extend: 1
          })), s.html;
        },
        add: function add(t) {
          var e = this,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          Object(d.isString)(t) ? t = this.parseString(t, n) : Object(d.isArray)(t) && t.forEach(function (i, r) {
            if (Object(d.isString)(i)) {
              var a = e.parseString(i, n);
              t[r] = Object(d.isArray)(a) && !a.length ? null : a;
            }
          });
          var i = Object(d.isArray)(t);
          return t = (i ? t : [t]).filter(function (t) {
            return t;
          }).map(function (t) {
            return e.processDef(t);
          }), t = i ? t : t[0], c.a.Collection.prototype.add.apply(this, [t, n]);
        },
        processDef: function processDef(t) {
          if (t.cid && t.ccid) return t;
          var e = this.em,
            n = this.config,
            i = (void 0 === n ? {} : n).processor,
            r = t;
          if (i) {
            var o = i(r = h({}, r));
            o && (Object(d.each)(r, function (t, e) {
              return delete r[e];
            }), Object(d.extend)(r, o));
          }
          if (r.$$typeof && "object" == a()(r.props)) {
            (r = h({}, r)).props = h({}, r.props);
            var s = e.get("DomComponents"),
              l = e.get("Parser").parserHtml;
            Object(d.each)(r, function (t, e) {
              Object(d.includes)(["props", "type"], e) || delete r[e];
            });
            var c = r.props,
              u = c.children;
            delete c.children, delete r.props;
            var p = l.splitPropsFromAttr(c);
            r.attributes = p.attrs, u && (r.components = u), r.type ? s.getType(r.type) || (r.tagName = r.type, delete r.type) : r.type = "textnode", Object(d.extend)(r, p.props);
          }
          return r;
        },
        onAdd: function onAdd(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            i = this.domc,
            r = this.em,
            a = t.getStyle(),
            o = r && r.getConfig("avoidInlineStyle");
          if (i && i.Component.ensureInList(t), !Object(d.isEmpty)(a) && !o && r && r.get && r.getConfig("forceClass") && !n.temporary) {
            var s = t.cid;
            r.get("CssComposer").setClassRule(s, a), t.setStyle({}), t.addClass(s);
          }
        }
      });
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(1),
        r = n.n(i);
      r.a.$, e.default = r.a.View.extend({
        initialize: function initialize(t) {
          this.config = t || {}, this.editorModel = this.em = this.config.em || {}, this.pfx = this.config.stylePrefix, this.ppfx = this.config.pStylePrefix, this.hoverClass = this.pfx + "hover", this.badgeClass = this.pfx + "badge", this.plhClass = this.pfx + "placeholder", this.freezClass = this.ppfx + "freezed", this.canvas = this.em.get && this.em.get("Canvas"), this.em.get && this.setElement(this.getCanvas()), this.canvas && (this.$canvas = this.$el, this.canvasTool = this.getCanvasTools()), this.init(this.config);
        },
        onFrameScroll: function onFrameScroll(t) {},
        getCanvas: function getCanvas() {
          return this.canvas ? this.canvas.getElement() : null;
        },
        getCanvasBody: function getCanvasBody() {
          return this.canvas.getBody();
        },
        getCanvasWrapper: function getCanvasWrapper() {
          return this.canvas.getWrapperEl();
        },
        getCanvasTools: function getCanvasTools() {
          return this.canvas.getToolsEl();
        },
        offset: function offset(t) {
          var e = t.getBoundingClientRect();
          return {
            top: e.top + t.ownerDocument.body.scrollTop,
            left: e.left + t.ownerDocument.body.scrollLeft
          };
        },
        init: function init(t) {},
        callRun: function callRun(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = this.id;
          if (t.trigger("run:".concat(n, ":before"), e), !e || !e.abort) {
            var i = e.sender || t,
              r = this.run(t, i, e);
            return t.trigger("run:".concat(n), r, e), t.trigger("run", n, r, e), r;
          }
          t.trigger("abort:".concat(n), e);
        },
        callStop: function callStop(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = this.id,
            i = e.sender || t;
          t.trigger("stop:".concat(n, ":before"), e);
          var r = this.stop(t, i, e);
          return t.trigger("stop:".concat(n), r, e), t.trigger("stop", n, r, e), r;
        },
        stopCommand: function stopCommand() {
          this.em.get("Commands").stop(this.id);
        },
        run: function run(t, e) {},
        stop: function stop(t, e) {}
      });
    }, function (t, e, n) {
      "use strict";

      var i = n(2),
        r = n.n(i),
        a = n(0),
        o = n(3),
        s = n(29);
      function l(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function c(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? l(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var d = Object(s.a)().parseStyle;
      e.a = {
        parseStyle: d,
        extendStyle: function extendStyle(t) {
          return c(c({}, this.getStyle()), t);
        },
        getStyle: function getStyle() {
          return c({}, this.get("style") || {});
        },
        setStyle: function setStyle() {
          var t = this,
            e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          Object(a.isString)(e) && (e = d(e));
          var i = this.getStyle(),
            r = c({}, e);
          this.set("style", r, n);
          var s = Object(o.w)(i, r);
          return Object(a.keys)(s).forEach(function (e) {
            var n = t.em;
            t.trigger("change:style:".concat(e)), n && (n.trigger("styleable:change", t, e), n.trigger("styleable:change:".concat(e), t, e));
          }), r;
        },
        addStyle: function addStyle(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          "string" == typeof t ? t = {
            prop: e
          } : n = e || {}, t = this.extendStyle(t), this.setStyle(t, n);
        },
        removeStyle: function removeStyle(t) {
          var e = this.getStyle();
          delete e[t], this.setStyle(e);
        },
        styleToString: function styleToString() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = [],
            n = this.getStyle();
          for (var i in n) {
            var r = t.important,
              o = Object(a.isArray)(r) ? r.indexOf(i) >= 0 : r,
              s = "".concat(n[i]).concat(o ? " !important" : ""),
              l = "__" == i.substr(0, 2);
            s && !l && e.push("".concat(i, ":").concat(s, ";"));
          }
          return e.join("");
        },
        getSelectors: function getSelectors() {
          return this.get("selectors") || this.get("classes");
        },
        getSelectorsString: function getSelectorsString() {
          return this.selectorsToString ? this.selectorsToString() : this.getSelectors().getFullString();
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(2),
        r = n.n(i),
        a = n(1),
        o = n.n(a),
        s = n(30),
        l = n(0),
        c = n(3);
      function d(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function u(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? d(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var h = o.a.Model.extend({
          defaults: {
            name: "",
            property: "",
            type: "",
            defaults: "",
            info: "",
            value: "",
            icon: "",
            functionName: "",
            status: "",
            visible: !0,
            fixedValues: ["initial", "inherit"],
            full: 0,
            important: 0,
            toRequire: 0,
            requires: null,
            requiresParent: null
          },
          initialize: function initialize() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = this.get("id") || "",
              i = this.get("name") || "";
            !this.get("property") && this.set("property", (i || n).replace(/ /g, "-"));
            var r = this.get("property");
            !this.get("id") && this.set("id", r), !i && this.set("name", Object(c.c)(r).replace(/-/g, " ")), h.callInit(this, t, e);
          },
          init: function init() {},
          clearValue: function clearValue() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return this.set({
              value: void 0,
              status: ""
            }, t), this;
          },
          setValue: function setValue(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
              n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              i = this.parseValue(t),
              r = !e;
            !r && this.set({
              value: void 0
            }, {
              avoidStore: r,
              silent: !0
            }), this.set(i, u({
              avoidStore: r
            }, n));
          },
          setValueFromInput: function setValueFromInput(t, e) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            this.setValue(t, e, u(u({}, n), {}, {
              fromInput: 1
            }));
          },
          parseValue: function parseValue(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = {
                value: t
              },
              i = "!important";
            if (Object(l.isString)(t) && -1 !== t.indexOf(i) && (n.value = t.replace(i, "").trim(), n.important = 1), !this.get("functionName") && !e.complete) return n;
            var r = [],
              a = "".concat(n.value),
              o = a.indexOf("(") + 1,
              s = a.lastIndexOf(")"),
              c = a.substring(0, o - 1);
            if (c && (n.functionName = c), r.push(o), s >= 0 && r.push(s), n.value = String.prototype.substring.apply(a, r), e.numeric) {
              var d = parseFloat(n.value);
              n.unit = n.value.replace(d, ""), n.value = d;
            }
            return n;
          },
          splitValues: function splitValues(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ",",
              n = [],
              i = "(",
              r = ")",
              a = "",
              o = 0;
            return (t || "").split("").forEach(function (t) {
              t == i ? (o++, a += i) : t == r && o > 0 ? (o--, a += r) : t === e && 0 == o ? (n.push(a), a = "") : a += t;
            }), "" !== a && n.push(a), n.map(function (t) {
              return t.trim();
            });
          },
          getDefaultValue: function getDefaultValue() {
            return this.get("defaults");
          },
          getFullValue: function getFullValue(t) {
            var e = this.get("functionName"),
              n = this.getDefaultValue(),
              i = Object(l.isUndefined)(t) ? this.get("value") : t,
              r = !Object(l.isUndefined)(i) && "" !== i;
            if (i && n && i === n) return n;
            if (e && r) {
              var a = "url" === e ? "'".concat(i.replace(/'/g, ""), "'") : i;
              i = "".concat(e, "(").concat(a, ")");
            }
            return r && this.get("important") && (i = "".concat(i, " !important")), i || "";
          }
        }, {
          callParentInit: function callParentInit(t, e, n) {
            var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
            t.prototype.initialize.apply(e, [n, u(u({}, i), {}, {
              skipInit: 1
            })]);
          },
          callInit: function callInit(t, e) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            !n.skipInit && t.init(e, n);
          }
        }),
        p = h;
      function g(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function f(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? g(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : g(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var m = p.extend({
          defaults: f(f({}, p.prototype.defaults), {}, {
            detached: 0,
            properties: [],
            separator: " "
          }),
          initialize: function initialize() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            p.callParentInit(p, this, t, e);
            var i = this.get("properties") || [],
              r = n(24).default;
            this.set("properties", new r(i)), this.listenTo(this, "change:value", this.updateValues), p.callInit(this, t, e);
          },
          clearValue: function clearValue() {
            return this.get("properties").each(function (t) {
              return t.clearValue();
            }), p.prototype.clearValue.apply(this, arguments);
          },
          updateValues: function updateValues() {
            var t = this.getFullValue().split(this.getSplitSeparator());
            this.get("properties").each(function (e, n) {
              var i = t.length;
              t[n] || t[n % i + (1 != i && i % 2 ? 1 : 0)];
            });
          },
          getSplitSeparator: function getSplitSeparator() {
            return new RegExp("".concat(this.get("separator"), "(?![^\\(]*\\))"));
          },
          getDefaultValue: function getDefaultValue(t) {
            var e = this.get("defaults");
            return e && !t ? e : (e = "", this.get("properties").each(function (t, n) {
              return e += "".concat(t.getDefaultValue(), " ");
            }), e.trim());
          },
          getFullValue: function getFullValue() {
            return this.get("detached") ? "" : this.get("properties").getFullValue();
          },
          getPropertyAt: function getPropertyAt(t) {
            return this.get("properties").at(t);
          }
        }),
        v = o.a.Model.extend({
          defaults: {
            index: "",
            value: "",
            values: {},
            active: !1,
            preview: !1,
            properties: []
          },
          initialize: function initialize() {
            var t = this.get("properties"),
              e = this.get("value");
            this.set("properties", t instanceof yt ? t : new yt(t));
            var n = this.get("properties");
            if (n.forEach(this.onPropAdd, this), this.listenTo(n, "add", this.onPropAdd), !e) {
              var i = "",
                r = this.get("values");
              for (var a in r) i += " " + r[a];
              this.set("value", i.trim());
            }
          },
          onPropAdd: function onPropAdd(t) {
            var e = this.collection;
            t.parent = e && e.property;
          },
          getPropertyAt: function getPropertyAt(t) {
            return this.get("properties").at(t);
          },
          getPropertyValue: function getPropertyValue(t) {
            var e = "";
            return this.get("properties").each(function (n) {
              n.get("property") == t && (e = n.getFullValue());
            }), e;
          },
          getFullValue: function getFullValue() {
            var t = [];
            return this.get("properties").each(function (e) {
              return t.push(e.getFullValue());
            }), t.join(" ").trim();
          }
        });
      function b(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function y(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? b(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : b(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var w = o.a.Collection.extend({
        model: v,
        initialize: function initialize() {
          this.idx = 1, this.on("add", this.onAdd), this.on("reset", this.onReset);
        },
        onAdd: function onAdd(t, e, n) {
          n.noIncrement || t.set("index", this.idx++), n.active && this.active(this.indexOf(t));
        },
        onReset: function onReset() {
          this.idx = 1;
        },
        getSeparator: function getSeparator() {
          var t = this.property;
          return t ? t.get("layerSeparator") : ", ";
        },
        getLayersFromValue: function getLayersFromValue(t) {
          var e = this,
            n = [];
          return t.replace(/\(([\w\s,.]*)\)/g, function (e) {
            var n = e.replace(/,\s*/g, ",");
            t = t.replace(e, n);
          }), (t ? t.split(this.getSeparator()) : []).forEach(function (t) {
            n.push({
              properties: e.properties.parseValue(t)
            });
          }), n;
        },
        getLayersFromStyle: function getLayersFromStyle(t) {
          var e = [],
            n = this.properties;
          return n.each(function (n) {
            var i = t[n.get("property")];
            (i ? i.split(", ") : []).forEach(function (t, i) {
              t = n.parseValue(t.trim()).value;
              var r = e[i],
                a = y(y({}, n.attributes), {
                  value: t
                });
              r ? r.properties.push(a) : e[i] = {
                properties: [a]
              };
            });
          }), e.forEach(function (t) {
            var e = t.properties.map(function (t) {
              return t.property;
            });
            n.each(function (n) {
              var i = n.get("property");
              e.indexOf(i) < 0 && t.properties.push(y({}, n.attributes));
            });
          }), e;
        },
        active: function active(t) {
          this.each(function (t) {
            return t.set("active", 0);
          });
          var e = this.at(t);
          e && e.set("active", 1);
        },
        getFullValue: function getFullValue() {
          var t = [];
          return this.each(function (e) {
            return t.push(e.getFullValue());
          }), t.join(this.getSeparator());
        },
        getPropertyValues: function getPropertyValues(t, e) {
          var n = [];
          return this.each(function (i) {
            var r = i.getPropertyValue(t);
            r ? n.push(r) : !Object(l.isUndefined)(e) && n.push(e);
          }), n.join(", ");
        }
      });
      function x(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function j(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? x(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : x(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var C = m.extend({
          defaults: j(j({}, m.prototype.defaults), {}, {
            layers: [],
            layerSeparator: ", ",
            prepend: 0,
            preview: 0
          }),
          initialize: function initialize() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            m.callParentInit(m, this, t, e);
            var n = this.get("layers"),
              i = new w(n);
            i.property = this, i.properties = this.get("properties"), this.set("layers", i), m.callInit(this, t, e);
          },
          getLayers: function getLayers() {
            return this.get("layers");
          },
          getCurrentLayer: function getCurrentLayer() {
            return this.getLayers().filter(function (t) {
              return t.get("active");
            })[0];
          },
          getFullValue: function getFullValue() {
            return this.get("detached") ? "" : this.get("layers").getFullValue();
          },
          getValueFromStyle: function getValueFromStyle() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = this.getLayers().getLayersFromStyle(t);
            return new w(e).getFullValue();
          },
          clearValue: function clearValue() {
            return this.getLayers().reset(), m.prototype.clearValue.apply(this, arguments);
          },
          getValueFromTarget: function getValueFromTarget(t) {
            var e = this.attributes,
              n = e.detached,
              i = e.property,
              r = e.properties,
              a = t.getStyle(),
              o = {};
            return r.forEach(function (t) {
              var e = t.get("property"),
                n = a[e];
              n && (o[e] = n);
            }), n ? Object(l.keys)(o).length ? o : "" : a[i];
          },
          getLayersFromTarget: function getLayersFromTarget(t) {}
        }),
        M = n(25),
        k = n.n(M),
        O = ["status", "value"],
        T = ["complete"];
      function S(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function N(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? S(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : S(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var L = o.a.View.extend({
        template: function template() {
          var t = this.pfx,
            e = this.ppfx;
          return '\n      <div class="'.concat(t, 'label" data-sm-label></div>\n      <div class="').concat(e, 'fields" data-sm-fields></div>\n    ');
        },
        templateLabel: function templateLabel(t) {
          var e = this.pfx,
            n = this.em,
            i = t.parent,
            r = t.attributes,
            a = r.icon,
            o = void 0 === a ? "" : a,
            s = r.info,
            l = void 0 === s ? "" : s,
            c = r.id,
            d = r.name,
            u = n && n.t("styleManager.properties.".concat(c)) || d;
          return '\n      <span class="'.concat(e, "icon ").concat(o, '" title="').concat(l, '">\n        ').concat(u, "\n      </span>\n      ").concat(i ? "" : '<b class="'.concat(e, 'clear" ').concat("data-clear-style", ">&Cross;</b>"), "\n    ");
        },
        templateInput: function templateInput(t) {
          return '\n      <div class="'.concat(this.ppfx, 'field">\n        <input placeholder="').concat(t.getDefaultValue(), '"/>\n      </div>\n    ');
        },
        events: r()({
          change: "inputValueChanged"
        }, "click [".concat("data-clear-style", "]"), "clear"),
        initialize: function initialize() {
          var t = this,
            e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          Object(l.bindAll)(this, "targetUpdated", "__change", "__updateStyle"), this.config = e.config || {};
          var n = this.config.em;
          this.em = n, this.pfx = this.config.stylePrefix || "", this.ppfx = this.config.pStylePrefix || "", this.target = e.target || {}, this.propTarget = e.propTarget || {}, this.onChange = e.onChange, this.onInputRender = e.onInputRender || {}, this.customValue = e.customValue || {};
          var i = this.model;
          this.property = i.get("property"), this.input = null;
          var r = this.pfx;
          this.inputHolderId = "#" + r + "input-holder", this.sector = i.collection && i.collection.sector, this.__destroyFn = this.destroy ? this.destroy.bind(this) : function () {}, i.view = this, i.get("value") || i.set("value", i.getDefaultValue()), n && n.on("update:component:style:".concat(this.property), this.targetUpdated);
          var a = i.get("requires");
          a && Object.keys(a).forEach(function (e) {
            n && n.on("component:styleUpdate:".concat(e), t.targetUpdated);
          }), this.listenTo(this.propTarget, "update styleManager:update", this.targetUpdated), this.listenTo(i, "destroy remove", this.remove), this.listenTo(i, "change:value", this.modelValueChanged), this.listenTo(i, "targetUpdated", this.targetUpdated), this.listenTo(i, "change:visible", this.updateVisibility), this.listenTo(i, "change:status", this.updateStatus), this.listenTo(i, "change:name change:className change:full", this.render);
          var o = this.init && this.init.bind(this);
          o && o();
        },
        remove: function remove() {
          o.a.View.prototype.remove.apply(this, arguments), this.__destroyFn(this._getClbOpts());
        },
        updateStatus: function updateStatus() {
          var t = this.model,
            e = t.get("status"),
            n = t.parent,
            i = this.pfx,
            r = this.ppfx,
            a = this.config,
            o = "".concat(r, "four-color"),
            s = "".concat(r, "color-warn"),
            l = this.$el.children(".".concat(i, "label")),
            c = this.getClearEl(),
            d = c ? c.style : {};
          switch (l.removeClass("".concat(o, " ").concat(s)), d.display = "none", e) {
            case "updated":
              !n && l.addClass(o), a.clearProperties && (d.display = "inline");
              break;
            case "computed":
              l.addClass(s);
          }
        },
        clear: function clear(t) {
          var e = this;
          t && t.stopPropagation(), this.model.clearValue(), setTimeout(function () {
            return e.targetUpdated();
          });
        },
        getClearEl: function getClearEl() {
          return this.clearEl || (this.clearEl = this.el.querySelector("[".concat("data-clear-style", "]"))), this.clearEl;
        },
        getTarget: function getTarget() {
          return this.getTargetModel();
        },
        getTargets: function getTargets() {
          return this.propTarget.targets || [this.getTarget()];
        },
        getTargetModel: function getTargetModel() {
          return this.propTarget && this.propTarget.model;
        },
        getHelperModel: function getHelperModel() {
          return this.propTarget && this.propTarget.helper;
        },
        inputValueChanged: function inputValueChanged(t) {
          t && t.stopPropagation(), this.emit || (this.model.setValueFromInput(this.getInputValue()), this.elementUpdated());
        },
        elementUpdated: function elementUpdated() {
          this.setStatus("updated");
        },
        setStatus: function setStatus(t) {
          this.model.set("status", t);
          var e = this.model.parent;
          e && "updated" == t && e.set("status", t);
        },
        emitUpdateTarget: Object(l.debounce)(function () {
          var t = this.config.em;
          t && t.trigger("styleManager:update:target", this.getTarget());
        }),
        _getTargetData: function _getTargetData() {
          var t = this.model,
            e = this.config,
            n = this.getTargetValue({
              ignoreDefault: 1
            }),
            i = t.getDefaultValue(),
            r = this.getComputedValue(),
            a = "",
            o = "";
          return n ? (a = n, e.highlightChanged && (o = "updated")) : r && e.showComputed && r != i ? (a = r, e.highlightComputed && (o = "computed")) : (a = i, o = ""), {
            value: a,
            status: o,
            targetValue: n,
            defaultValue: i,
            computedValue: r
          };
        },
        targetUpdated: function targetUpdated(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          if (!this.config.fromLayer && (this.emitUpdateTarget(), this.checkVisibility())) {
            var i = this.config,
              r = i.em,
              a = this.model,
              o = a.get("property"),
              s = this._getTargetData(),
              l = s.status,
              c = s.value,
              d = k()(s, O),
              u = N({
                status: l,
                value: c
              }, d);
            return this.setStatus(l), a.setValue(c, 0, N({
              fromTarget: 1
            }, n)), r && (r.trigger("styleManager:change", this, o, c, u), r.trigger("styleManager:change:".concat(o), this, c, u), this._emitUpdate(u)), u;
          }
        },
        _emitUpdate: function _emitUpdate() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = this.em,
            n = this.model;
          if (e) {
            var i = n.get("property"),
              r = N(N({}, this._getEventData()), t),
              a = r.id;
            e.trigger("style:update", r), e.trigger("style:update:".concat(i), r), i !== a && e.trigger("style:update:".concat(a), r);
          }
        },
        _getEventData: function _getEventData() {
          var t = this.model;
          return {
            propertyView: this,
            targets: this.getTargets(),
            value: t.getFullValue(),
            property: t,
            id: t.get("id"),
            name: t.get("property")
          };
        },
        checkVisibility: function checkVisibility() {
          var t = 1;
          return this.config.hideNotStylable && (this.isTargetStylable() && this.isComponentStylable() ? this.show() : (this.hide(), t = 0), this.sector && this.sector.trigger("updateVisibility")), t;
        },
        getTargetValue: function getTargetValue() {
          var t,
            e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = this.model,
            i = this.getTargetModel(),
            r = this.customValue;
          if (!i) return t;
          if ((t = i.getStyle()[n.get("property")]) || e.ignoreDefault || (t = n.getDefaultValue()), "function" == typeof r && !e.ignoreCustomValue) {
            var a = n.collection.indexOf(n),
              o = r(this, a, t);
            o && (t = o);
          }
          return t;
        },
        getComputedValue: function getComputedValue() {
          var t = this.propTarget,
            e = t.computed || {},
            n = t.computedDefault || {},
            i = this.config.avoidComputed || [],
            r = this.model.get("property"),
            a = i.indexOf(r) < 0,
            o = e[r],
            s = n[Object(c.b)(r)];
          return e && a && s !== o && o || "";
        },
        getInputValue: function getInputValue() {
          var t = this.getInputEl();
          return t ? t.value : "";
        },
        modelValueChanged: function modelValueChanged(t, e) {
          var n = this,
            i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            r = this.model,
            a = r.getFullValue();
          i.fromInput || this.setValue(a), i.fromTarget || this.getTargets().forEach(function (t) {
            return n.__updateTarget(t, i);
          });
        },
        __updateTarget: function __updateTarget(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = this.model,
            i = this.config.em,
            r = n.get("property"),
            a = n.getFullValue(),
            o = this.onChange;
          if (t && this.isTargetStylable(t) && this.isComponentStylable()) {
            e.fromTarget || (o && !e.fromParent ? o(t, this, e) : this.updateTargetStyle(a, null, N(N({}, e), {}, {
              target: t
            })));
            var s = i && i.getSelected();
            i && s && (!e.noEmit && i.trigger("component:update", s), i.trigger("component:styleUpdate", s, r), i.trigger("component:styleUpdate:".concat(r), s)), this._emitUpdate();
          }
        },
        updateTargetStyle: function updateTargetStyle(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            i = e || this.model.get("property"),
            r = n.target || this.getTarget(),
            a = r.getStyle();
          t ? a[i] = t : delete a[i], n.avoidStore ? a.__ = 1 : delete a.__, r.setStyle(a, n);
          var o = this.getHelperModel();
          o && o.setStyle(a, n);
        },
        isTargetStylable: function isTargetStylable(t) {
          var e = t || this.getTarget(),
            n = this.model,
            i = n.get("id"),
            r = n.get("property"),
            a = n.get("toRequire"),
            o = e.get("unstylable"),
            s = e.get("stylable-require"),
            c = n.get("requires"),
            d = n.get("requiresParent"),
            u = this.sector ? this.sector.collection : null,
            h = this.em ? this.em.getSelected() : null,
            p = e.get("stylable");
          if (Object(l.isArray)(p) && (p = p.indexOf(r) >= 0), Object(l.isArray)(o) && (p = o.indexOf(r) < 0), a && (p = !t || s && (s.indexOf(i) >= 0 || s.indexOf(r) >= 0)), u && c) {
            var g = Object.keys(c);
            u.each(function (t) {
              t.get("properties").each(function (t) {
                if (Object(l.includes)(g, t.id)) {
                  var e = c[t.id];
                  p = p && Object(l.includes)(e, t.get("value"));
                }
              });
            });
          }
          if (d) {
            var f = h && h.parent(),
              m = f && f.getEl();
            if (m) {
              var v = window.getComputedStyle(m);
              Object(l.each)(d, function (t, e) {
                p = p && v[e] && Object(l.includes)(t, v[e]);
              });
            } else p = !1;
          }
          return p;
        },
        isComponentStylable: function isComponentStylable() {
          var t = this.em,
            e = t && t.getSelected();
          return !e || this.isTargetStylable(e);
        },
        setRawValue: function setRawValue(t) {
          this.setValue(this.model.parseValue(t));
        },
        setValue: function setValue(t) {
          var e = this.model,
            n = Object(l.isUndefined)(t) ? e.getDefaultValue() : t;
          if (this.update) return this.__update(n);
          var i = this.getInputEl();
          i && (i.value = n);
        },
        getInputEl: function getInputEl() {
          return this.input || (this.input = this.el.querySelector("input")), this.input;
        },
        updateVisibility: function updateVisibility() {
          this.el.style.display = this.model.get("visible") ? "block" : "none";
        },
        show: function show() {
          this.model.set("visible", 1);
        },
        hide: function hide() {
          this.model.set("visible", 0);
        },
        cleanValue: function cleanValue() {
          this.setValue("");
        },
        clearCached: function clearCached() {
          this.clearEl = null, this.input = null, this.$input = null;
        },
        __update: function __update(t) {
          var e = this.update && this.update.bind(this);
          e && e(N(N({}, this._getClbOpts()), {}, {
            value: t
          }));
        },
        __change: function __change() {
          for (var t = this.emit && this.emit.bind(this), e = arguments.length, n = new Array(e), i = 0; i < e; i++) n[i] = arguments[i];
          t && t.apply(void 0, [this._getClbOpts()].concat(n));
        },
        __updateStyle: function __updateStyle(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = e.complete,
            i = k()(e, T),
            r = !1 !== n;
          Object(c.n)(t) ? this.getTargets().forEach(function (e) {
            return e.addStyle(t, {
              avoidStore: !r
            });
          }) : this.model.setValueFromInput(t, n, i), r && this.elementUpdated();
        },
        _getClbOpts: function _getClbOpts() {
          var t = this.model;
          return {
            el: this.el,
            props: t.attributes,
            setProps: function setProps() {
              return t.set.apply(t, arguments);
            },
            change: this.__change,
            updateStyle: this.__updateStyle,
            targets: this.getTargets()
          };
        },
        render: function render() {
          this.clearCached();
          var t = this.pfx,
            e = this.model,
            n = this.el,
            i = this.$el,
            r = e.get("property"),
            a = e.get("full"),
            o = e.get("className") || "",
            s = "".concat(t, "property");
          this.createdEl && this.__destroyFn(this._getClbOpts()), i.empty().append(this.template(e)), i.find("[data-sm-label]").append(this.templateLabel(e));
          var l = this.create && this.create.bind(this);
          this.createdEl = l && l(this._getClbOpts()), i.find("[data-sm-fields]").append(this.createdEl || this.templateInput(e)), n.className = "".concat(s, " ").concat(t).concat(e.get("type"), " ").concat(s, "__").concat(r, " ").concat(o).trim(), n.className += a ? " ".concat(s, "--full") : "", this.updateStatus();
          var c = this.onRender && this.onRender.bind(this);
          c && c(), this.setValue(e.get("value"), {
            fromTarget: 1
          });
        }
      });
      function D(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function E(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? D(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : D(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var I = o.a.$,
        P = L.extend({
          templateInput: function templateInput() {
            var t = this.pfx;
            return '\n      <div class="'.concat(t, "field ").concat(t, 'composite">\n        <span id="').concat(t, 'input-holder"></span>\n      </div>\n    ');
          },
          inputValueChanged: function inputValueChanged() {
            if (!this.model.get("detached")) {
              for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
              L.prototype.inputValueChanged.apply(this, e);
            }
          },
          clear: function clear(t) {
            var e = this.properties;
            e && e.forEach(function (t) {
              return t.clear();
            }), L.prototype.clear.apply(this, arguments);
          },
          onRender: function onRender() {
            var t = this.model,
              e = t.get("properties") || [];
            if (this.properties = [], e.length && (this.$input || (this.$input = I('<input type="hidden" value="0">'), this.input = this.$input.get(0)), this.props || (this.props = t.get("properties")), !this.$props)) {
              this.props.each(function (e, n) {
                e && "composite" == e.get("type") && (this.props.remove(e), console.warn("Nested composite types not yet allowed.")), e.parent = t;
              }, this);
              var i = new (0, n(19).default)(this.getPropsConfig());
              this.$props = i.render().$el, this.properties = i.properties, this.$el.find("#".concat(this.pfx, "input-holder")).append(this.$props);
            }
          },
          getPropsConfig: function getPropsConfig(t) {
            var e = this,
              n = this.model,
              i = {
                config: E(E({}, this.config), {}, {
                  highlightComputed: 0
                }),
                collection: this.props,
                target: this.target,
                propTarget: this.propTarget,
                onChange: function onChange(t, e, i) {
                  n.set("value", n.getFullValue(), i);
                },
                customValue: function customValue(t, n) {
                  return e.valueOnIndex(n, t);
                }
              };
            return n.get("detached") && delete i.onChange, i;
          },
          valueOnIndex: function valueOnIndex(t, e) {
            var n = this.getTargetValue({
              ignoreDefault: 1
            });
            return n ? n.split(this.model.getSplitSeparator())[t] : e && e.getTargetValue({
              ignoreCustomValue: 1,
              ignoreDefault: 1
            });
          },
          clearCached: function clearCached() {
            L.prototype.clearCached.apply(this, arguments), this.$input = null, this.props = null, this.$props = null;
          }
        }),
        A = n(19);
      function z(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function _(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? z(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : z(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var H = o.a.View.extend({
          events: {
            click: "active",
            "click [data-close-layer]": "removeItem",
            "mousedown [data-move-layer]": "initSorter",
            "touchstart [data-move-layer]": "initSorter"
          },
          template: function template(t) {
            var e = this.pfx,
              n = this.ppfx,
              i = this.em,
              r = "".concat(i && i.t("styleManager.layer"), " ").concat(t.get("index"));
            return '\n      <div id="'.concat(e, 'move" class="').concat(n, 'no-touch-actions" data-move-layer>\n        <i class="fa fa-arrows"></i>\n      </div>\n      <div id="').concat(e, 'label">').concat(r, '</div>\n      <div id="').concat(e, 'preview-box">\n      \t<div id="').concat(e, 'preview" data-preview></div>\n      </div>\n      <div id="').concat(e, 'close-layer" class="').concat(e, 'btn-close" data-close-layer>\n        &Cross;\n      </div>\n      <div id="').concat(e, 'inputs" data-properties></div>\n      <div style="clear:both"></div>\n    ');
          },
          initialize: function initialize() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = this.model;
            this.stackModel = t.stackModel, this.config = t.config || {}, this.em = this.config.em, this.pfx = this.config.stylePrefix || "", this.ppfx = this.config.pStylePrefix || "", this.sorter = t.sorter || null, this.propsConfig = t.propsConfig || {}, this.customPreview = t.onPreview, this.listenTo(e, "destroy remove", this.remove), this.listenTo(e, "change:active", this.updateVisibility), this.listenTo(e.get("properties"), "change", this.updatePreview), e.view = this, e.set({
              droppable: 0,
              draggable: 1
            }), this.$el.data("model", e);
          },
          initSorter: function initSorter(t) {
            this.sorter && this.sorter.startSort(this.el);
          },
          removeItem: function removeItem(t) {
            t && t.stopPropagation(), this.remove();
          },
          remove: function remove() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = this.model,
              n = this.props,
              i = e.collection,
              r = this.stackModel;
            o.a.View.prototype.remove.apply(this, arguments), i && i.contains(e) && i.remove(e), r && r.set && (r.set({
              stackIndex: null
            }, {
              silent: !0
            }), !t.fromTarget && r.trigger("updateValue")), n && n.remove();
          },
          onPreview: function onPreview(t) {
            var e = this.stackModel,
              n = e && e.get("detached"),
              i = t.split(" "),
              r = [],
              a = {};
            return this.model.get("properties").each(function (t, e) {
              var o = t.get("property"),
                s = n ? t.getFullValue() : i[e] || "";
              if (s && "integer" == t.get("type")) {
                var l = parseInt(s, 10),
                  c = s.replace(l, "");
                s = (l = (l = (l = isNaN(l) ? 0 : l) > 3 ? 3 : l) < -3 ? -3 : l) + c;
              }
              r.push(s), a[o] = s;
            }), n ? a : r.join(" ");
          },
          updatePreview: function updatePreview() {
            var t = this.stackModel,
              e = this.customPreview,
              n = this.getPreviewEl(),
              i = this.model.getFullValue(),
              r = e ? e(i) : this.onPreview(i);
            if (r && t && n) {
              var a = n.style;
              if (Object(l.isString)(r)) a[t.get("property")] = r;else {
                var o = [];
                Object(l.each)(r, function (t, e) {
                  return o.push("".concat(e, ":").concat(t));
                }), n.setAttribute("style", o.join(";"));
              }
            }
          },
          getPropertiesWrapper: function getPropertiesWrapper() {
            return this.propsWrapEl || (this.propsWrapEl = this.el.querySelector("[data-properties]")), this.propsWrapEl;
          },
          getPreviewEl: function getPreviewEl() {
            return this.previewEl || (this.previewEl = this.el.querySelector("[data-preview]")), this.previewEl;
          },
          active: function active() {
            var t = this.model,
              e = t.collection;
            e.active(e.indexOf(t));
          },
          updateVisibility: function updateVisibility() {
            var t = this.pfx,
              e = this.getPropertiesWrapper(),
              n = this.model.get("active");
            e.style.display = n ? "" : "none", this.$el[n ? "addClass" : "removeClass"]("".concat(t, "active"));
          },
          render: function render() {
            var t = this.propsConfig,
              e = this.model,
              n = this.el,
              i = this.pfx,
              r = e.get("preview"),
              a = new A.default({
                collection: e.get("properties"),
                config: _(_({}, this.config), {}, {
                  fromLayer: 1
                }),
                target: t.target,
                customValue: t.customValue,
                propTarget: t.propTarget,
                onChange: t.onChange
              }),
              o = a.render().el;
            return n.innerHTML = this.template(e), n.className = "".concat(i, "layer").concat(r ? "" : " ".concat(i, "no-preview")), this.props = a, this.getPropertiesWrapper().appendChild(o), this.updateVisibility(), this.updatePreview(), this;
          }
        }),
        V = o.a.View.extend({
          initialize: function initialize(t) {
            this.config = t.config || {}, this.stackModel = t.stackModel, this.preview = t.preview, this.pfx = this.config.stylePrefix || "", this.ppfx = this.config.pStylePrefix || "", this.propsConfig = t.propsConfig;
            var e = this.pfx,
              n = this.ppfx,
              i = this.collection;
            this.className = "".concat(e, "layers ").concat(n, "field"), this.listenTo(i, "add", this.addTo), this.listenTo(i, "deselectAll", this.deselectAll), this.listenTo(i, "reset", this.reset), this.items = [];
            var r = this.config.em || "",
              a = r ? r.get("Utils") : "";
            this.sorter = a ? new a.Sorter({
              container: this.el,
              ignoreViewChildren: 1,
              containerSel: ".".concat(e, "layers"),
              itemSel: ".".concat(e, "layer"),
              pfx: this.config.pStylePrefix
            }) : "", i.view = this, this.$el.data("model", i), this.$el.data("collection", i);
          },
          addTo: function addTo(t) {
            var e = this.collection.indexOf(t);
            this.addToCollection(t, null, e);
          },
          addToCollection: function addToCollection(t, e, n) {
            var i = e || null,
              r = this.stackModel,
              a = this.config,
              o = this.sorter,
              s = this.propsConfig;
            void 0 !== this.preview && t.set("preview", this.preview);
            var l = new H({
                model: t,
                config: a,
                sorter: o,
                stackModel: r,
                propsConfig: s
              }),
              c = l.render().el;
            if (this.items.push(l), i) i.appendChild(c);else if (void 0 !== n) {
              var d = "before";
              this.$el.children().length == n && (n--, d = "after"), n < 0 ? this.$el.append(c) : this.$el.children().eq(n)[d](c);
            } else this.$el.append(c);
            return c;
          },
          deselectAll: function deselectAll() {
            this.$el.find("." + this.pfx + "layer").removeClass(this.pfx + "active");
          },
          reset: function reset(t, e) {
            this.clearItems(e), this.render();
          },
          render: function render() {
            var t = document.createDocumentFragment();
            return this.$el.empty(), this.collection.each(function (e) {
              this.addToCollection(e, t);
            }, this), this.$el.append(t), this.$el.attr("class", this.className), this.sorter && (this.sorter.plh = null), this;
          },
          remove: function remove() {
            this.clearItems(), o.a.View.prototype.remove.apply(this, arguments);
          },
          clearItems: function clearItems(t) {
            this.items.forEach(function (e) {
              return e.remove(t);
            }), this.items = [];
          }
        });
      function F(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      var R = new (n(31).a)(),
        B = P.extend({
          templateInput: function templateInput() {
            var t = this.pfx;
            return this.ppfx, '\n      <div class="'.concat(t, "field ").concat(t, 'stack">\n        <button type="button" id="').concat(t, 'add" data-add-layer>+</button>\n        <div data-layers-wrapper></div>\n      </div>\n    ');
          },
          init: function init() {
            var t = this.model;
            this.pfx, t.set("stackIndex", null), this.events["click [data-add-layer]"] = "addLayer", this.listenTo(t, "change:stackIndex", this.indexChanged), this.listenTo(t, "updateValue", this.inputValueChanged), this.delegateEvents();
            var e = this.getPropsConfig();
            this.layers = new V({
              collection: this.getLayers(),
              stackModel: t,
              preview: t.get("preview"),
              config: this.config,
              propsConfig: e
            });
            var i = n(19).default;
            this.propsView = new i({
              target: this.target,
              collection: t.get("properties"),
              stackModel: t,
              config: this.config,
              onChange: e.onChange,
              propTarget: e.propTarget
            });
          },
          targetUpdated: function targetUpdated() {
            var t,
              e = this;
            if (this.model.get("detached")) t = this._getTargetData(), this.setStatus(t.status), this.checkVisibility();else {
              for (var n = arguments.length, i = new Array(n), r = 0; r < n; r++) i[r] = arguments[r];
              t = P.prototype.targetUpdated.apply(this, i);
            }
            setTimeout(function () {
              return e.refreshLayers(t);
            });
          },
          getLayers: function getLayers() {
            return this.model.get("layers");
          },
          indexChanged: function indexChanged(t) {
            var e = this.model;
            this.getLayers().active(e.get("stackIndex"));
          },
          addLayer: function addLayer() {
            var t = this.model,
              e = this.getLayers(),
              n = t.get("prepend"),
              i = t.get("properties").deepClone();
            i.each(function (t) {
              return t.set("value", "");
            });
            var a = e.add({
              properties: i
            }, function (t) {
              for (var e = 1; e < arguments.length; e++) {
                var n = null != arguments[e] ? arguments[e] : {};
                e % 2 ? F(Object(n), !0).forEach(function (e) {
                  r()(t, e, n[e]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : F(Object(n)).forEach(function (e) {
                  Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
                });
              }
              return t;
            }({
              active: 1
            }, n && {
              at: 0
            }));
            this.inputValueChanged({
              up: 1
            }), t.set("stackIndex", e.indexOf(a));
          },
          inputValueChanged: function inputValueChanged() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = this.model;
            t.up && this.elementUpdated(), e.get("detached") ? e.get("properties").each(function (t) {
              return t.trigger("change:value");
            }) : e.set("value", this.getLayerValues());
          },
          setValue: function setValue() {},
          getLayerValues: function getLayerValues() {
            return this.getLayers().getFullValue();
          },
          _getClassRule: function _getClassRule() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = this.em,
              n = t.skipAdd,
              i = void 0 === n ? 1 : n,
              r = e.getSelected(),
              a = e.get("StyleManager").getModelToStyle(r, {
                skipAdd: i,
                useClasses: 1
              });
            return a !== r && a;
          },
          _getParentTarget: function _getParentTarget(t) {
            for (var e, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, i = this.em, r = this.model, a = r.get("property"), o = n.isValid || function (t) {
                return t.getStyle()[a];
              }, s = i.get("CssComposer").getAll().filter(function (e) {
                return e.selectorsToString() === t.getSelectorsString();
              }), l = s.reduce(function (t, e) {
                return t[e.getAtRule()] = e, t;
              }, {}), c = R.sortMediaObject(l), d = c.map(function (t) {
                return t.value;
              }), u = d.indexOf(t), h = d.splice(0, u), p = h.length - 1; p > -1; p--) {
              var g = h[p];
              if (o(g)) {
                e = g;
                break;
              }
            }
            return e;
          },
          refreshLayers: function refreshLayers() {
            var t,
              e,
              n,
              i,
              r,
              a,
              o = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              s = [],
              c = this.model,
              d = this.em,
              u = this.getLayers(),
              h = c.get("detached"),
              p = c.get("property"),
              g = this.getTarget(),
              f = this.getComputedValue(),
              m = d.getSelected(),
              v = {
                fromTarget: 1
              };
            if (h) {
              e = o.targetValue || {};
              var b = function b(t) {
                var e = c.get("properties").at(0).get("property");
                return t && !Object(l.isUndefined)(t.getStyle()[e]);
              };
              if (!Object(l.keys)(e).length && f && m) {
                var y = {
                  isValid: function isValid(t) {
                    return b(t);
                  }
                };
                (i = this._getParentTarget(g, y)) ? e = i.getStyle() : (n = this._getClassRule(), i = !(r = b(n) && n.getStyle()) && this._getParentTarget(this._getClassRule({
                  skipAdd: 0
                }), y), a = b(i) && i.getStyle(), e = r || a || {});
              }
              t = e, s = u.getLayersFromStyle(e);
            } else {
              var w = this.getTargetValue({
                  ignoreDefault: 1
                }),
                x = w;
              !x && f && ((i = this._getParentTarget(g)) ? x = i.getStyle()[p] : (a = (i = !(r = (n = this._getClassRule()) && n.getStyle()[p]) && this._getParentTarget(this._getClassRule({
                skipAdd: 0
              }))) && i.getStyle()[p], x = r || a || f)), t = x = x == c.getDefaultValue() ? "" : x, s = u.getLayersFromValue(x);
            }
            var j = c.getLayersFromTarget(g, {
              resultValue: t,
              layersObj: s
            }) || s;
            u.reset(null, v), u.add(j, v), c.set({
              stackIndex: null
            }, {
              silent: !0
            });
          },
          getTargetValue: function getTargetValue() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = this.model,
              n = e.attributes.detached,
              i = this.getTarget(),
              r = P.prototype.getTargetValue.call(this, t);
            return Object(l.isUndefined)(r) && !n ? r = e.getValueFromStyle(i.getStyle()) : n && (r = e.getValueFromTarget(i)), r;
          },
          getPropsConfig: function getPropsConfig() {
            var t = this,
              e = t.model;
            return {
              target: t.target,
              propTarget: t.propTarget,
              onChange: function onChange(n, i, a) {
                var o = i.model,
                  s = e.get("status");
                if (e.get("detached")) {
                  var l = o.get("property"),
                    c = o.getDefaultValue(),
                    d = t.getLayers(),
                    u = d.getPropertyValues(l, c);
                  i.updateTargetStyle(u, null, a), "background-image" != l || a.avoidStore || "computed" != s || e.get("properties").filter(function (t) {
                    return "__" == t.get("property").substr(0, 2);
                  }).forEach(function (e) {
                    var n = e.get("property"),
                      i = d.getPropertyValues(n, e.getDefaultValue());
                    t.getTargets().forEach(function (t) {
                      return t.addStyle(r()({}, n, i), a);
                    });
                  });
                } else if ("updated" == s) {
                  var h = e.getFullValue();
                  e.set("value", h, a), !h && i.updateTargetStyle(h, null, a);
                }
              }
            };
          },
          onRender: function onRender() {
            var t = this.el,
              e = this.layers,
              n = this.propsView,
              i = t.querySelector("[data-layers-wrapper]");
            n.render(), i.appendChild(e.render().el);
          }
        }),
        W = o.a.$,
        Y = L.extend({
          templateInput: function templateInput() {
            var t = this.pfx,
              e = this.em;
            return '\n    <div class="'.concat(t, "field ").concat(t, "file\">\n      <div id='").concat(t, "input-holder'>\n        <div class=\"").concat(t, 'btn-c">\n          <button class="').concat(t, 'btn" id="').concat(t, 'images" type="button">\n            ').concat(e.t("styleManager.fileButton"), '\n          </button>\n        </div>\n        <div style="clear:both;"></div>\n      </div>\n      <div id="').concat(t, 'preview-box">\n        <div id="').concat(t, 'preview-file"></div>\n        <div id="').concat(t, 'close">&Cross;</div>\n      </div>\n    </div>\n    ');
          },
          init: function init() {
            var t = this.em;
            this.modal = t.get("Modal"), this.am = t.get("AssetManager"), this.events["click #" + this.pfx + "close"] = "removeFile", this.events["click #" + this.pfx + "images"] = "openAssetManager", this.delegateEvents();
          },
          onRender: function onRender() {
            if (!this.$input) {
              var t = this.model.getDefaultValue();
              this.$input = W('<input placeholder="'.concat(t, '">'));
            }
            this.$preview || (this.$preview = this.$el.find("#" + this.pfx + "preview-file")), this.$previewBox || (this.$previewBox = this.$el.find("#" + this.pfx + "preview-box")), this.setValue(this.componentValue, 0);
          },
          clearCached: function clearCached() {
            L.prototype.clearCached.apply(this, arguments), this.$preview = null, this.$previewBox = null;
          },
          setValue: function setValue(t, e) {
            L.prototype.setValue.apply(this, arguments), this.setPreviewView(t && t != this.model.getDefaultValue()), this.setPreview(t);
          },
          setPreviewView: function setPreviewView(t) {
            var e = this.$previewBox;
            e && e[t ? "addClass" : "removeClass"]("".concat(this.pfx, "show")), e && e.css({
              display: t ? "block" : "none"
            });
          },
          spreadUrl: function spreadUrl(t) {
            this.model.set("value", t), this.setPreviewView(1);
          },
          setPreview: function setPreview(t) {
            var e = this.$preview;
            t = t && t.indexOf("url(") < 0 ? "url(".concat(t, ")") : t, e && e.css("background-image", t);
          },
          cleanValue: function cleanValue() {
            this.setPreviewView(0), this.model.set({
              value: ""
            }, {
              silent: !0
            });
          },
          removeFile: function removeFile() {
            this.model.set("value", this.model.getDefaultValue());
            for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
            L.prototype.cleanValue.apply(this, e), this.setPreviewView(0);
          },
          openAssetManager: function openAssetManager(t) {
            var e = this,
              n = this.em,
              i = this.modal,
              r = n ? n.get("Editor") : "";
            r && r.runCommand("open-assets", {
              types: ["image"],
              accept: "image/*",
              target: this.getTargetModel(),
              onClick: function onClick() {},
              onDblClick: function onDblClick() {},
              onSelect: function onSelect(t) {
                i.close();
                var n = Object(l.isString)(t) ? t : t.get("src");
                e.spreadUrl(n);
              }
            });
          }
        }),
        U = o.a.$,
        Z = L.extend({
          templateInput: function templateInput() {
            return "";
          },
          init: function init() {
            var t = this.model;
            this.listenTo(t, "change:unit", this.modelValueChanged), this.listenTo(t, "el:change", this.elementUpdated), this.listenTo(t, "change:units", this.render);
          },
          setValue: function setValue(t) {
            var e = this.model.parseValue(t);
            t = "".concat(e.value).concat(e.unit), this.inputInst.setValue(t, {
              silent: 1
            });
          },
          onRender: function onRender() {
            var t = this.ppfx;
            if (!this.input) {
              var e = this.model.input;
              e.ppfx = t, e.render(), this.el.querySelector(".".concat(t, "fields")).appendChild(e.el), this.$input = e.inputEl, this.unit = e.unitEl, this.$unit = U(this.unit), this.input = this.$input.get(0), this.inputInst = e;
            }
          },
          clearCached: function clearCached() {
            L.prototype.clearCached.apply(this, arguments), this.unit = null, this.$unit = null;
          }
        }),
        G = n(38);
      function q(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function $(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? q(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : q(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var Q = Z.extend({
          setValue: function setValue(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            e = $($({}, e), {}, {
              silent: 1
            }), this.inputInst.setValue(t, e);
          },
          onRender: function onRender() {
            if (!this.input) {
              var t = this.ppfx,
                e = new G.a({
                  target: this.target,
                  model: this.model,
                  ppfx: t
                }).render();
              this.el.querySelector(".".concat(t, "fields")).appendChild(e.el), this.$input = e.inputEl, this.$color = e.colorEl, this.input = this.$input.get(0), this.inputInst = e;
            }
          }
        }),
        J = n(9),
        X = n.n(J);
      function K(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function tt(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? K(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : K(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var et = p.extend({
        defaults: function defaults() {
          return tt(tt({}, p.prototype.defaults), {}, {
            options: [],
            full: 1
          });
        },
        initialize: function initialize() {
          for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
          p.prototype.initialize.apply(this, e), this.listenTo(this, "change:options", this.onOptionChange);
        },
        onOptionChange: function onOptionChange() {
          this.set("list", this.get("options"));
        },
        getOptions: function getOptions() {
          var t = this.attributes,
            e = t.options,
            n = t.list;
          return e && e.length ? e : n;
        },
        setOptions: function setOptions() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
          return this.set("options", t), this;
        },
        addOption: function addOption(t) {
          if (t) {
            var e = this.getOptions();
            this.setOptions([].concat(X()(e), [t]));
          }
          return this;
        }
      });
      function nt(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function it(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? nt(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : nt(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var rt = et.extend({
          defaults: function defaults() {
            return it(it({}, et.prototype.defaults()), {}, {
              full: 0
            });
          }
        }),
        at = (o.a.$, L.extend({
          templateInput: function templateInput() {
            var t = this.pfx,
              e = this.ppfx;
            return '\n      <div class="'.concat(e, "field ").concat(e, 'select">\n        <span id="').concat(t, 'input-holder"></span>\n        <div class="').concat(e, 'sel-arrow">\n          <div class="').concat(e, 'd-s-arrow"></div>\n        </div>\n      </div>\n    ');
          },
          initialize: function initialize() {
            for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
            L.prototype.initialize.apply(this, e), this.listenTo(this.model, "change:options", this.updateOptions);
          },
          updateOptions: function updateOptions() {
            this.input = null, this.onRender();
          },
          onRender: function onRender() {
            var t = this.pfx,
              e = this.model.getOptions();
            if (!this.input) {
              var n = "";
              e.forEach(function (t) {
                var e = t.name || t.value,
                  i = t.style ? t.style.replace(/"/g, "&quot;") : "",
                  r = i ? 'style="'.concat(i, '"') : "",
                  a = t.value.replace(/"/g, "&quot;");
                n += '<option value="'.concat(a, '" ').concat(r, ">").concat(e, "</option>");
              });
              var i = this.el.querySelector("#".concat(t, "input-holder"));
              i.innerHTML = "<select>".concat(n, "</select>"), this.input = i.firstChild;
            }
          }
        })),
        ot = L.extend({
          templateInput: function templateInput() {
            this.pfx;
            var t = this.ppfx;
            return '\n      <div class="'.concat(t, "field ").concat(t, 'field-radio">\n      </div>\n    ');
          },
          onRender: function onRender() {
            var t = this.pfx,
              e = this.ppfx,
              n = "".concat(e, "radio-item-label"),
              i = this.model,
              r = i.get("property"),
              a = i.get("list") || i.get("options") || [],
              o = i.cid,
              s = "".concat(t, "radio ").concat(t, "radio-").concat(r);
            if (!this.input && a && a.length) {
              var l = "";
              a.forEach(function (i) {
                var a = i.className ? "".concat(i.className, " ").concat(t, "icon ").concat(n) : "",
                  c = "".concat(r, "-").concat(i.value, "-").concat(o),
                  d = i.name || i.value,
                  u = i.title ? 'title="'.concat(i.title, '"') : "";
                l += '\n            <div class="'.concat(e, 'radio-item">\n              <input type="radio" class="').concat(s, '" id="').concat(c, '" name="').concat(r, "-").concat(o, '" value="').concat(i.value, '"/>\n              <label class="').concat(a || n, '" ').concat(u, ' for="').concat(c, '">').concat(a ? "" : d, "</label>\n            </div>\n          ");
              });
              var c = this.el.querySelector(".".concat(e, "field"));
              c.innerHTML = '<div class="'.concat(e, 'radio-items">').concat(l, "</div>"), this.input = c.firstChild;
            }
          },
          getInputValue: function getInputValue() {
            var t = this.getCheckedEl();
            return t ? t.value : "";
          },
          getCheckedEl: function getCheckedEl() {
            var t = this.getInputEl();
            return t ? t.querySelector("input:checked") : "";
          },
          setValue: function setValue(t) {
            var e = this.model,
              n = t || e.get("value") || e.getDefaultValue(),
              i = this.getInputEl(),
              r = i ? i.querySelector('[value="'.concat(n, '"]')) : "";
            if (r) r.checked = !0;else {
              var a = this.getCheckedEl();
              a && (a.checked = !1);
            }
          }
        }),
        st = n(32);
      function lt(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function ct(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? lt(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : lt(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var dt = p.extend({
        defaults: ct(ct({}, p.prototype.defaults), {}, {
          units: [],
          unit: "",
          step: 1,
          min: "",
          max: ""
        }),
        initialize: function initialize() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          p.callParentInit(p, this, t, e);
          var n = this.get("unit"),
            i = this.get("units");
          this.input = new st.a({
            model: this
          }), i.length && !n && this.set("unit", i[0]), p.callInit(this, t, e);
        },
        clearValue: function clearValue() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return this.set({
            value: void 0,
            unit: void 0
          }, t), this;
        },
        parseValue: function parseValue(t) {
          var e = p.prototype.parseValue.apply(this, arguments),
            n = this.input.validateInputValue(e.value, {
              deepCheck: 1
            }),
            i = n.value,
            r = n.unit;
          return e.value = i, e.unit = r, e;
        },
        getFullValue: function getFullValue() {
          var t = this.get("value"),
            e = this.get("unit");
          return t = Object(l.isUndefined)(t) ? "" : t, e = !Object(l.isUndefined)(e) && t ? e : "", t = "".concat(t).concat(e), p.prototype.getFullValue.apply(this, [t]);
        }
      });
      function ut(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function ht(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? ut(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ut(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var pt = dt.extend({
        defaults: ht(ht({}, dt.prototype.defaults), {}, {
          showInput: 1
        })
      });
      function gt(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function ft(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? gt(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : gt(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var mt = Z.extend({
        events: function events() {
          return ft(ft({}, Z.prototype.events), {}, {
            "change [type=range]": "inputValueChanged",
            "input [type=range]": "inputValueChangedSoft",
            change: ""
          });
        },
        templateInput: function templateInput(t) {
          var e = this.ppfx;
          return '\n      <div class="'.concat(e, "field ").concat(e, 'field-range">\n        <input type="range"\n          min="').concat(t.get("min"), '"\n          max="').concat(t.get("max"), '"\n          step="').concat(t.get("step"), '"/>\n      </div>\n    ');
        },
        getSliderEl: function getSliderEl() {
          return this.slider || (this.slider = this.el.querySelector("input[type=range]")), this.slider;
        },
        inputValueChanged: function inputValueChanged() {
          var t = this.model,
            e = t.get("step");
          this.getInputEl().value = this.getSliderEl().value;
          var n = this.getInputValue() - e;
          t.set("value", n, {
            avoidStore: 1
          }).set("value", n + e), this.elementUpdated();
        },
        inputValueChangedSoft: function inputValueChangedSoft() {
          this.getInputEl().value = this.getSliderEl().value, this.model.set("value", this.getInputValue(), {
            avoidStore: 1
          }), this.elementUpdated();
        },
        setValue: function setValue(t) {
          var e = this.model.parseValue(t);
          this.getSliderEl().value = parseFloat(e.value), Z.prototype.setValue.apply(this, arguments);
        },
        onRender: function onRender() {
          Z.prototype.onRender.apply(this, arguments), this.model.get("showInput") || (this.inputInst.el.style.display = "none");
        },
        clearCached: function clearCached() {
          Z.prototype.clearCached.apply(this, arguments), this.slider = null;
        }
      });
      function vt(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function bt(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? vt(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : vt(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var yt = e.default = o.a.Collection.extend(s.a).extend({
        extendViewApi: 1,
        types: [{
          id: "stack",
          model: C,
          view: B,
          isType: function isType(t) {
            if (t && "stack" == t.type) return t;
          }
        }, {
          id: "composite",
          model: m,
          view: P,
          isType: function isType(t) {
            if (t && "composite" == t.type) return t;
          }
        }, {
          id: "file",
          model: p,
          view: Y,
          isType: function isType(t) {
            if (t && "file" == t.type) return t;
          }
        }, {
          id: "color",
          model: p,
          view: Q,
          isType: function isType(t) {
            if (t && "color" == t.type) return t;
          }
        }, {
          id: "select",
          model: rt,
          view: at,
          isType: function isType(t) {
            if (t && "select" == t.type) return t;
          }
        }, {
          id: "radio",
          model: et,
          view: ot,
          isType: function isType(t) {
            if (t && "radio" == t.type) return t;
          }
        }, {
          id: "slider",
          model: pt,
          view: mt,
          isType: function isType(t) {
            if (t && "slider" == t.type) return t;
          }
        }, {
          id: "integer",
          model: dt,
          view: Z,
          isType: function isType(t) {
            if (t && "integer" == t.type) return t;
          }
        }, {
          id: "base",
          model: p,
          view: L,
          isType: function isType(t) {
            return t.type = "base", t;
          }
        }],
        deepClone: function deepClone() {
          var t = this.clone();
          return t.reset(t.map(function (t) {
            var e = t.clone();
            return e.typeView = t.typeView, e;
          })), t;
        },
        parseValue: function parseValue(t) {
          var e = this,
            n = [];
          return t.split(" ").forEach(function (t, i) {
            var r = e.at(i);
            r && n.push(bt(bt({}, r.attributes), {
              value: t
            }));
          }), n;
        },
        getFullValue: function getFullValue() {
          var t = "";
          return this.each(function (e) {
            return t += "".concat(e.getFullValue(), " ");
          }), t.trim();
        }
      });
    }, function (t, e, n) {
      var i = n(90);
      t.exports = function (t, e) {
        if (null == t) return {};
        var n,
          r,
          a = i(t, e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(t);
          for (r = 0; r < o.length; r++) n = o[r], e.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(t, n) && (a[n] = t[n]);
        }
        return a;
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e) {
      var n;
      n = function () {
        return this;
      }();
      try {
        n = n || new Function("return this")();
      } catch (t) {
        "object" == typeof window && (n = window);
      }
      t.exports = n;
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(1),
        r = n.n(i).a.$;
      e.default = {
        startSelectPosition: function startSelectPosition(t, e) {
          var n = this,
            i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          this.isPointed = !1;
          var r = this.editorModel.get("Utils"),
            a = t.ownerDocument.body;
          r && !this.sorter && (this.sorter = new r.Sorter({
            container: a,
            placer: this.canvas.getPlacerEl(),
            containerSel: "*",
            itemSel: "*",
            pfx: this.ppfx,
            direction: "a",
            document: e,
            wmargin: 1,
            nested: 1,
            em: this.editorModel,
            canvasRelative: 1,
            scale: function scale() {
              return n.em.getZoomDecimal();
            }
          })), i.onStart && (this.sorter.onStart = i.onStart), t && this.sorter.startSort(t, {
            container: a
          });
        },
        getOffsetDim: function getOffsetDim() {
          var t = this.offset(this.canvas.getFrameEl()),
            e = this.offset(this.canvas.getElement());
          return {
            top: t.top - e.top,
            left: t.left - e.left
          };
        },
        stopSelectPosition: function stopSelectPosition() {
          this.posTargetCollection = null, this.posIndex = "after" == this.posMethod && 0 !== this.cDim.length ? this.posIndex + 1 : this.posIndex, this.sorter && (this.sorter.moved = 0, this.sorter.endMove()), this.cDim && (this.posIsLastEl = 0 !== this.cDim.length && "after" == this.posMethod && this.posIndex == this.cDim.length, this.posTargetEl = 0 === this.cDim.length ? r(this.outsideElem) : !this.posIsLastEl && this.cDim[this.posIndex] ? r(this.cDim[this.posIndex][5]).parent() : r(this.outsideElem), this.posTargetModel = this.posTargetEl.data("model"), this.posTargetCollection = this.posTargetEl.data("model-comp"));
        },
        enable: function enable() {
          this.startSelectPosition();
        },
        nearFloat: function nearFloat(t, e, n) {
          var i = t || 0,
            r = e || "before",
            a = n.length,
            o = 0 !== a && "after" == r && i == a;
          return 0 !== a && (!o && !n[i][4] || n[i - 1] && !n[i - 1][4] || o && !n[i - 1][4]) ? 1 : 0;
        },
        run: function run() {
          this.enable();
        },
        stop: function stop() {
          this.stopSelectPosition(), this.$wrapper.css("cursor", ""), this.$wrapper.unbind();
        }
      };
    }, function (t, e, n) {
      "use strict";

      var i = n(40);
      window.Promise = window.Promise || i.a, e.a = "function" == typeof fetch ? fetch.bind() : function (t, e) {
        return new i.a(function (n, r) {
          var a = new XMLHttpRequest();
          for (var o in a.open(e.method || "get", t), a.withCredentials = "include" == e.credentials, e.headers || {}) a.setRequestHeader(o, e.headers[o]);
          a.onload = function (t) {
            return n({
              status: a.status,
              statusText: a.statusText,
              text: function text() {
                return i.a.resolve(a.responseText);
              }
            });
          }, a.onerror = r, a.upload && e.onProgress && (a.upload.onprogress = e.onProgress), e.body ? a.send(e.body) : a.send();
        });
      };
    }, function (t, e, n) {
      "use strict";

      var i = n(8),
        r = n.n(i),
        a = n(0);
      e.a = function (t) {
        var e = t;
        return {
          compTypes: "",
          modelAttrStart: "data-gjs-",
          splitPropsFromAttr: function splitPropsFromAttr() {
            var t = this,
              e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              n = {},
              i = {};
            return Object(a.each)(e, function (e, r) {
              if (0 === r.indexOf(t.modelAttrStart)) {
                var o = r.replace("data-gjs-", ""),
                  s = e.length,
                  l = e && Object(a.isString)(e),
                  c = l && e.substr(0, 1),
                  d = l && e.substr(s - 1);
                e = "false" !== (e = "true" === e || e) && e;
                try {
                  e = "{" == c && "}" == d || "[" == c && "]" == d ? JSON.parse(e) : e;
                } catch (t) {}
                n[o] = e;
              } else i[r] = e;
            }), {
              props: n,
              attrs: i
            };
          },
          parseStyle: function parseStyle(t) {
            for (var e = {}, n = t.split(";"), i = 0, r = n.length; i < r; i++) {
              var a = n[i].trim();
              if (a) {
                var o = a.split(":");
                e[o[0].trim()] = o.slice(1).join(":").trim();
              }
            }
            return e;
          },
          parseClass: function parseClass(t) {
            for (var e = [], n = t.split(" "), i = 0, r = n.length; i < r; i++) {
              var a = n[i].trim();
              a && e.push(a);
            }
            return e;
          },
          parseNode: function parseNode(n) {
            for (var i = [], a = n.childNodes, o = 0, s = a.length; o < s; o++) {
              var l = a[o],
                c = l.attributes || [],
                d = c.length,
                u = i[i.length - 1],
                h = l.childNodes.length,
                p = this.compTypes,
                g = {};
              if (p) {
                var f = "",
                  m = l.getAttribute && l.getAttribute("".concat("data-gjs-", "type"));
                if (m) g = {
                  type: m
                };else {
                  for (var v = 0; v < p.length; v++) {
                    var b = p[v];
                    if (f = b.model.isComponent(l)) {
                      "object" !== r()(f) && (f = {
                        type: b.id
                      });
                      break;
                    }
                  }
                  g = f;
                }
              }
              g.tagName || (g.tagName = l.tagName ? l.tagName.toLowerCase() : ""), d && (g.attributes = {});
              for (var y = 0; y < d; y++) {
                var w = c[y].nodeName,
                  x = c[y].nodeValue;
                if ("style" == w) g.style = this.parseStyle(x);else if ("class" == w) g.classes = this.parseClass(x);else {
                  if ("contenteditable" == w) continue;
                  if (0 === w.indexOf("data-gjs-")) {
                    var j = w.replace("data-gjs-", ""),
                      C = x.length,
                      M = x && x.substr(0, 1),
                      k = x && x.substr(C - 1);
                    x = "false" !== (x = "true" === x || x) && x;
                    try {
                      x = "{" == M && "}" == k || "[" == M && "]" == k ? JSON.parse(x) : x;
                    } catch (t) {}
                    g[j] = x;
                  } else "" === x && !0 === l[w] && (x = !0), g.attributes[w] = x;
                }
              }
              if (h && !g.components) {
                var O = l.childNodes[0];
                1 === h && 3 === O.nodeType ? (!g.type && (g.type = "text"), g.content = O.nodeValue) : g.components = this.parseNode(l);
              }
              if ("textnode" == g.type) {
                if (u && "textnode" == u.type) {
                  u.content += g.content;
                  continue;
                }
                if (!t.keepEmptyTextNodes) {
                  var T = l.nodeValue;
                  if (" " != T && !T.trim()) continue;
                }
              }
              var S = g.components;
              if (!g.type && S) {
                for (var N = 1, L = 0, D = 0; D < S.length; D++) {
                  var E = S[D],
                    I = E.type;
                  if (["text", "textnode"].indexOf(I) < 0 && e.textTags.indexOf(E.tagName) < 0) {
                    N = 0;
                    break;
                  }
                  "textnode" == I && (L = 1);
                }
                N && L && (g.type = "text");
              }
              (g.tagName || "textnode" == g.type) && i.push(g);
            }
            return i;
          },
          parse: function parse(t, n) {
            var i = e.em && e.em.get("Config") || {},
              r = {
                html: "",
                css: ""
              },
              a = document.createElement("div");
            a.innerHTML = t;
            var o = a.querySelectorAll("script"),
              s = o.length;
            if (!i.allowScripts) for (; s--;) o[s].parentNode.removeChild(o[s]);
            if (n) {
              for (var l = "", c = a.querySelectorAll("style"), d = c.length; d--;) l = c[d].innerHTML + l, c[d].parentNode.removeChild(c[d]);
              l && (r.css = n.parse(l));
            }
            var u = this.parseNode(a);
            return 1 == u.length && (u = u[0]), r.html = u, r;
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      var i = n(0),
        r = n(1),
        a = n.n(r),
        o = a.a.Model,
        s = a.a.View;
      e.a = {
        types: [],
        initialize: function initialize(t, e) {
          var n = this;
          this.model = function () {
            var t,
              e,
              i,
              r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            if (r && r.type) {
              var o = n.getBaseType();
              t = (i = n.getType(r.type)) ? i.model : o.model, e = i ? i.view : o.view;
            } else {
              var s = n.recognizeType(r);
              t = (i = s.type).model, e = i.view, r = s.attributes;
            }
            var l = new t(r, a);
            return l.typeView = e, l;
          };
          var i = this.init && this.init.bind(this);
          i && i();
        },
        recognizeType: function recognizeType(t) {
          for (var e = this.getTypes(), n = 0; n < e.length; n++) {
            var i = e[n],
              r = i.isType(t);
            if (r = "boolean" == typeof r && r ? {
              type: i.id
            } : r) return {
              type: i,
              attributes: r
            };
          }
          return {
            type: this.getBaseType(),
            attributes: t
          };
        },
        getBaseType: function getBaseType() {
          var t = this.getTypes();
          return t[t.length - 1];
        },
        getTypes: function getTypes() {
          return this.types;
        },
        getType: function getType(t) {
          for (var e = this.getTypes(), n = 0; n < e.length; n++) {
            var i = e[n];
            if (i.id === t) return i;
          }
        },
        addType: function addType(t, e) {
          var n = this.getType(t),
            r = this.getBaseType(),
            a = n ? n.model : r.model,
            l = n ? n.view : r.view,
            c = e.model,
            d = e.view,
            u = e.isType;
          c = c instanceof o || Object(i.isFunction)(c) ? c : a.extend(c || {}), d = d instanceof s || Object(i.isFunction)(d) ? d : l.extend(d || {}), !this.extendViewApi || e.model || e.view || (d = d.extend(e)), n ? (n.model = c, n.view = d, n.isType = u || n.isType) : (e.id = t, e.model = c, e.view = d, e.isType = u || function (e) {
            if (e && e.type == t) return !0;
          }, this.getTypes().unshift(e));
        }
      };
    }, function (t, e, n) {
      "use strict";

      var i = n(1),
        r = n.n(i),
        a = n(0),
        o = Number.MAX_VALUE;
      e.a = r.a.Model.extend({
        initialize: function initialize() {
          this.compCls = [], this.ids = [];
        },
        buildFromModel: function buildFromModel(t) {
          var e = this,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            i = "",
            r = this.em,
            a = r && r.getConfig("avoidInlineStyle"),
            o = t.styleToString(),
            s = t.get("classes"),
            l = n.wrapperIsBody,
            c = t.get("wrapper");
          if (this.ids.push("#".concat(t.getId())), s.each(function (t) {
            return e.compCls.push(t.getFullName());
          }), !a && o) {
            var d = "#".concat(t.getId());
            i = "".concat(d = l && c ? "body" : d, "{").concat(o, "}");
          }
          var u = t.components();
          return u.each(function (t) {
            return i += e.buildFromModel(t, n);
          }), i;
        },
        build: function build(t) {
          var e = this,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            i = n.cssc,
            r = n.em || "";
          this.em = r, this.compCls = [], this.ids = [];
          var o = this.buildFromModel(t, n),
            s = Object(a.isUndefined)(n.clearStyles) && r ? r.getConfig("clearStyles") : n.clearStyles;
          if (i) {
            var l = i.getAll(),
              c = {},
              d = [];
            l.each(function (t) {
              var i = t.getAtRule();
              if (i) {
                var r = c[i];
                r ? r.push(t) : c[i] = [t];
              } else o += e.buildFromRule(t, d, n);
            }), this.sortMediaObject(c).forEach(function (t) {
              var i = "",
                r = t.key;
              t.value.forEach(function (t) {
                var a = e.buildFromRule(t, d, n);
                t.get("singleAtRule") ? o += "".concat(r, "{").concat(a, "}") : i += a;
              }), i && (o += "".concat(r, "{").concat(i, "}"));
            }), r && s && l.remove(d);
          }
          return o;
        },
        buildFromRule: function buildFromRule(t, e) {
          var n,
            i = this,
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            a = "",
            o = t.selectorsToString({
              skipAdd: 1
            }),
            s = t.get("selectorsAdd"),
            l = t.get("singleAtRule");
          if (t.get("selectors").each(function (t) {
            var e = t.getFullName();
            (i.compCls.indexOf(e) >= 0 || i.ids.indexOf(e) >= 0 || r.keepUnusedStyles) && (n = 1);
          }), o && n || s || l) {
            var c = t.getDeclaration();
            c && (a += c);
          } else e.push(t);
          return a;
        },
        getQueryLength: function getQueryLength(t) {
          var e = /(-?\d*\.?\d+)\w{0,}/.exec(t);
          return e ? parseFloat(e[1]) : o;
        },
        sortMediaObject: function sortMediaObject() {
          var t = this,
            e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = [];
          return Object(a.each)(e, function (t, e) {
            return n.push({
              key: e,
              value: t
            });
          }), n.sort(function (e, n) {
            var i = [e.key, n.key].every(function (t) {
                return -1 !== t.indexOf("min-width");
              }),
              r = i ? e.key : n.key,
              a = i ? n.key : e.key;
            return t.getQueryLength(r) - t.getQueryLength(a);
          });
        }
      });
    }, function (t, e, n) {
      "use strict";

      var i = n(1),
        r = n.n(i),
        a = n(0),
        o = n(3),
        s = n(18);
      r.a.$, e.a = s.a.extend({
        events: {
          "change input": "handleChange",
          "change select": "handleUnitChange",
          "click [data-arrow-up]": "upArrowClick",
          "click [data-arrow-down]": "downArrowClick",
          "mousedown [data-arrows]": "downIncrement"
        },
        template: function template() {
          var t = this.ppfx;
          return '\n      <span class="'.concat(t, 'input-holder"></span>\n      <span class="').concat(t, 'field-units"></span>\n      <div class="').concat(t, 'field-arrows" data-arrows>\n        <div class="').concat(t, 'field-arrow-u" data-arrow-up></div>\n        <div class="').concat(t, 'field-arrow-d" data-arrow-down></div>\n      </div>\n    ');
        },
        inputClass: function inputClass() {
          var t = this.ppfx;
          return this.opts.contClass || "".concat(t, "field ").concat(t, "field-integer");
        },
        initialize: function initialize() {
          s.a.prototype.initialize.apply(this, arguments), Object(a.bindAll)(this, "moveIncrement", "upIncrement"), this.doc = document, this.listenTo(this.model, "change:unit", this.handleModelChange);
        },
        setValue: function setValue(t, e) {
          var n = e || {},
            i = this.validateInputValue(t, {
              deepCheck: 1
            }),
            r = {
              value: i.value
            };
          (i.unit || i.force) && (r.unit = i.unit), this.model.set(r, n), n.silent && this.handleModelChange();
        },
        handleChange: function handleChange(t) {
          t.stopPropagation(), this.setValue(this.getInputEl().value), this.elementUpdated();
        },
        handleUnitChange: function handleUnitChange(t) {
          t.stopPropagation();
          var e = this.getUnitEl().value;
          this.model.set("unit", e), this.elementUpdated();
        },
        elementUpdated: function elementUpdated() {
          this.model.trigger("el:change");
        },
        handleModelChange: function handleModelChange() {
          var t = this.model;
          this.getInputEl().value = t.get("value");
          var e = this.getUnitEl();
          e && (e.value = t.get("unit") || "");
        },
        getUnitEl: function getUnitEl() {
          if (!this.unitEl) {
            var t = this.model,
              e = t.get("units") || [];
            if (e.length) {
              var n = [];
              e.forEach(function (e) {
                var i = e == t.get("unit") ? "selected" : "";
                n.push("<option ".concat(i, ">").concat(e, "</option>"));
              });
              var i = document.createElement("div");
              i.innerHTML = '<select class="'.concat(this.ppfx, 'input-unit">').concat(n.join(""), "</select>"), this.unitEl = i.firstChild;
            }
          }
          return this.unitEl;
        },
        upArrowClick: function upArrowClick() {
          var t = this.model,
            e = t.get("step"),
            n = parseInt(t.get("value"), 10);
          n = this.normalizeValue(n + e);
          var i = this.validateInputValue(n);
          t.set("value", i.value), this.elementUpdated();
        },
        downArrowClick: function downArrowClick() {
          var t = this.model,
            e = t.get("step"),
            n = parseInt(t.get("value"), 10),
            i = this.normalizeValue(n - e),
            r = this.validateInputValue(i);
          t.set("value", r.value), this.elementUpdated();
        },
        downIncrement: function downIncrement(t) {
          t.preventDefault(), this.moved = 0;
          var e = this.model.get("value");
          e = this.normalizeValue(e), this.current = {
            y: t.pageY,
            val: e
          }, Object(o.u)(this.doc, "mousemove", this.moveIncrement), Object(o.u)(this.doc, "mouseup", this.upIncrement);
        },
        moveIncrement: function moveIncrement(t) {
          this.moved = 1;
          var e = this.model,
            n = e.get("step"),
            i = this.current,
            r = this.normalizeValue(i.val + (i.y - t.pageY) * n);
          return this.prValue = this.validateInputValue(r).value, e.set("value", this.prValue, {
            avoidStore: 1
          }), !1;
        },
        upIncrement: function upIncrement() {
          var t = this.model,
            e = t.get("step");
          if (Object(o.t)(this.doc, "mouseup", this.upIncrement), Object(o.t)(this.doc, "mousemove", this.moveIncrement), this.prValue && this.moved) {
            var n = this.prValue - e;
            t.set("value", n, {
              avoidStore: 1
            }).set("value", n + e), this.elementUpdated();
          }
        },
        normalizeValue: function normalizeValue(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
            n = this.model,
            i = n.get("step"),
            r = 0;
          if (isNaN(t)) return e;
          if (t = parseFloat(t), Math.floor(t) !== t) {
            var a = i.toString().split(".")[1];
            r = a ? a.length : 0;
          }
          return r ? parseFloat(t.toFixed(r)) : t;
        },
        validateInputValue: function validateInputValue(t, e) {
          var n = 0,
            i = e || {},
            r = this.model,
            o = Object(a.isUndefined)(t) ? "" : t,
            s = r.get("units") || [],
            l = r.get("unit") || s.length && s[0] || "",
            c = r.get("max"),
            d = r.get("min");
          if (i.deepCheck) {
            var u = r.get("fixedValues") || [];
            if (o) {
              var h = new RegExp("^" + u.join("|"), "g");
              if (u.length && h.test(o)) o = o.match(h)[0], l = "", n = 1;else {
                var p = o + "";
                o += "", o = parseFloat(o.replace(",", ".")), o = isNaN(o) ? "" : o;
                var g = p.replace(o, "");
                Object(a.indexOf)(s, g) >= 0 && (l = g);
              }
            }
          }
          return Object(a.isUndefined)(c) || "" === c || (o = o > c ? c : o), Object(a.isUndefined)(d) || "" === d || (o = o < d ? d : o), {
            force: n,
            value: o,
            unit: l
          };
        },
        render: function render() {
          s.a.prototype.render.call(this), this.unitEl = null;
          var t = this.getUnitEl();
          return t && this.$el.find(".".concat(this.ppfx, "field-units")).get(0).appendChild(t), this;
        }
      });
    }, function (t, e, n) {
      "use strict";

      var i = n(1),
        r = n.n(i),
        a = n(34);
      e.a = r.a.Collection.extend({
        model: a.a,
        initialize: function initialize(t, e) {
          var n = this;
          e && e.em && (this.editor = e.em), setTimeout(function () {
            n.on("remove", n.onRemove), n.on("add", n.onAdd);
          });
        },
        onAdd: function onAdd(t) {
          t.ensureSelectors();
        },
        onRemove: function onRemove(t) {
          var e = this.editor;
          e.stopListening(t), e.get("UndoManager").remove(t);
        },
        add: function add(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return "string" == typeof t && (t = this.editor.get("Parser").parseCss(t)), e.em = this.editor, r.a.Collection.prototype.add.apply(this, [t, e]);
        }
      });
    }, function (t, e, n) {
      "use strict";

      var i = n(0),
        r = n(1),
        a = n.n(r),
        o = n(23),
        s = n(12),
        l = window.CSS;
      e.a = a.a.Model.extend(o.a).extend({
        defaults: {
          selectors: [],
          selectorsAdd: "",
          style: {},
          mediaText: "",
          state: "",
          stylable: !0,
          atRuleType: "",
          singleAtRule: 0,
          important: 0
        },
        initialize: function initialize(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          this.config = t || {}, this.em = e.em, this.ensureSelectors();
        },
        ensureSelectors: function ensureSelectors() {
          var t = this.em,
            e = [],
            n = t && t.get("SelectorManager"),
            i = this.getSelectors(),
            r = Array.isArray(i);
          i.forEach(function (t) {
            return e.push(n ? n.add(t) : t);
          }), r && this.set("selectors", new s.a(e));
        },
        getAtRule: function getAtRule() {
          var t = this.get("atRuleType"),
            e = this.get("mediaText"),
            n = t ? "@".concat(t) : e ? "@media" : "";
          return n + (e && n ? " ".concat(e) : "");
        },
        selectorsToString: function selectorsToString() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = [],
            n = this.em,
            i = this.get("state"),
            r = this.get("wrapper"),
            a = this.get("selectorsAdd"),
            o = r && n && n.getConfig("wrapperIsBody"),
            s = {
              escape: function escape(t) {
                return l && l.escape ? l.escape(t) : t;
              }
            },
            c = o ? "body" : this.get("selectors").getFullString(0, s),
            d = i && !t.skipState ? ":".concat(i) : "";
          return c && e.push("".concat(c).concat(d)), a && !t.skipAdd && e.push(a), e.join(", ");
        },
        getDeclaration: function getDeclaration() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = "",
            n = this.selectorsToString(),
            i = this.styleToString(t),
            r = this.get("singleAtRule");
          return (n || r) && i && (e = r ? i : "".concat(n, "{").concat(i, "}")), e;
        },
        toCSS: function toCSS() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = "",
            n = this.getAtRule(),
            i = this.getDeclaration(t);
          return i && (e = i), n && e && (e = "".concat(n, "{").concat(e, "}")), e;
        },
        toJSON: function toJSON() {
          for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
          var r = a.a.Model.prototype.toJSON.apply(this, e);
          if (this.em.getConfig("avoidDefaults")) {
            var o = this.defaults;
            Object(i.forEach)(o, function (t, e) {
              r[e] === t && delete r[e];
            }), Object(i.isEmpty)(r.selectors) && delete r.selectors, Object(i.isEmpty)(r.style) && delete r.style;
          }
          return r;
        },
        compare: function compare(t, e, n) {
          var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
            a = e || "",
            o = n || "",
            s = r.selectorsAdd || "",
            l = r.atRuleType || "";
          t instanceof Array || t.models || (t = [t]);
          var c = Object(i.map)(t.models || t, function (t) {
              return t.get("name");
            }),
            d = Object(i.map)(this.get("selectors").models, function (t) {
              return t.get("name");
            }),
            u = !1;
          if (c.length !== d.length) return u;
          for (var h = 0; h < c.length; h++) {
            for (var p = 0, g = 0; g < d.length; g++) c[h] === d[g] && (p = 1);
            if (0 === p) return u;
          }
          return this.get("state") === a && this.get("mediaText") === o && this.get("selectorsAdd") === s && this.get("atRuleType") === l || u;
        }
      });
    }, function (t, e, n) {
      "use strict";

      var i = n(1),
        r = n.n(i),
        a = n(0);
      e.a = r.a.View.extend({
        initialize: function initialize(t) {
          this.opts = t || {}, this.config = t.config || {}, this.em = this.config.em;
          var e = this.collection;
          this.listenTo(e, "add", this.addTo), this.listenTo(e, "reset", this.resetChildren), this.listenTo(e, "remove", this.removeChildren);
        },
        removeChildren: function removeChildren(t, e) {
          var n = this,
            i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          t.views.forEach(function (t) {
            if (t) {
              var e = t.childrenView,
                n = t.scriptContainer;
              e && e.stopListening(), n && n.remove(), t.remove.apply(t);
            }
          });
          var r = t.components();
          r.forEach(function (t) {
            return n.removeChildren(t, e, i);
          });
        },
        addTo: function addTo(t) {
          var e = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            n = this.config.em,
            i = this.collection.indexOf(t);
          if (this.addToCollection(t, null, i), n && !e.temporary) {
            var r = function t(e) {
              n.trigger("component:add", e), e.components().forEach(function (e) {
                return t(e);
              });
            };
            r(t);
          }
        },
        addToCollection: function addToCollection(t, e, i) {
          this.compView || (this.compView = n(6).default);
          for (var r = this.config, o = this.opts, s = this.em, l = e || null, c = r.frameView, d = void 0 === c ? {} : c, u = d.model && t.getView(d.model), h = o.componentTypes || s && s.get("DomComponents").getTypes(), p = t.get("type"), g = this.compView, f = 0; f < h.length; f++) if (h[f].id == p) {
            g = h[f].view;
            break;
          }
          var m,
            v = u || new g({
              model: t,
              config: r,
              componentTypes: h
            });
          try {
            m = v.render().el;
          } catch (t) {
            m = document.createTextNode(""), s.logError(t);
          }
          if (l) l.appendChild(m);else {
            var b = this.parentEl,
              y = b.childNodes;
            if (Object(a.isUndefined)(i)) b.appendChild(m);else {
              var w = y.length == i;
              w && i--, w || !y.length ? b.appendChild(m) : b.insertBefore(m, y[i]);
            }
          }
          return m;
        },
        resetChildren: function resetChildren(t) {
          var e = this,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            i = n.previousModels,
            r = void 0 === i ? [] : i;
          this.parentEl.innerHTML = "", r.forEach(function (t) {
            return e.removeChildren(t, e.collection);
          }), t.each(function (t) {
            return e.addToCollection(t);
          });
        },
        render: function render(t) {
          var e = this,
            n = this.el,
            i = document.createDocumentFragment();
          return this.parentEl = t || this.el, this.collection.each(function (t) {
            return e.addToCollection(t, i);
          }), n.innerHTML = "", n.appendChild(i), this;
        }
      });
    }, function (t, e, n) {
      "use strict";

      var i,
        r = n(0),
        a = n(3),
        o = n(1),
        s = n.n(o),
        l = n(6),
        c = n(5),
        d = s.a.$;
      e.a = s.a.View.extend({
        events: {
          "mousedown [data-toggle-move]": "startSort",
          "touchstart [data-toggle-move]": "startSort",
          "click [data-toggle-visible]": "toggleVisibility",
          "click [data-toggle-select]": "handleSelect",
          "mouseover [data-toggle-select]": "handleHover",
          "click [data-toggle-open]": "toggleOpening",
          "dblclick [data-name]": "handleEdit",
          "focusout [data-name]": "handleEditEnd"
        },
        template: function template(t) {
          var e = this.pfx,
            n = this.ppfx,
            i = this.config,
            r = this.clsNoEdit,
            a = i.hidable,
            o = this.countChildren(t),
            s = o ? "" : this.clsNoChild,
            l = "".concat(this.clsTitle, " ").concat(s),
            c = "".concat(this.clsTitleC, " ").concat(n, "one-bg"),
            d = "".concat(this.clsCaret, " fa fa-chevron-right"),
            u = "".concat(this.inputNameCls, " ").concat(r, " ").concat(n, "no-app"),
            h = this.level + 1,
            p = "".concat(30 + 10 * h, "px"),
            g = t.getName(),
            f = t.getIcon(),
            m = "".concat(e, "layer");
          return "\n      ".concat(a ? '<i class="'.concat(e, "layer-vis fa fa-eye ").concat(this.isVisible() ? "" : "fa-eye-slash", '" data-toggle-visible></i>') : "", '\n      <div class="').concat(c, '">\n        <div class="').concat(l, '" title="').concat(g, '" style="padding-left: ').concat(p, '" data-toggle-select>\n          <div class="').concat(e, 'layer-title-inn">\n            <i class="').concat(d, '" data-toggle-open></i>\n            ').concat(f ? '<span class="'.concat(m, '__icon">').concat(f, "</span>") : "", '\n            <span class="').concat(u, '" data-name>').concat(g, '</span>\n          </div>\n        </div>\n      </div>\n      <div class="').concat(this.clsCount, '" data-count>').concat(o || "", '</div>\n      <div class="').concat(this.clsMove, '" data-toggle-move>\n        <i class="fa fa-arrows"></i>\n      </div>\n      <div class="').concat(this.clsChildren, '"></div>');
        },
        initialize: function initialize() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          this.opt = t, this.level = t.level, this.config = t.config, this.em = t.config.em, this.ppfx = this.em.get("Config").stylePrefix, this.sorter = t.sorter || "", this.pfx = this.config.stylePrefix, this.parentView = t.parentView;
          var e = this.pfx,
            n = this.ppfx,
            i = this.model,
            r = i.get("components"),
            a = i.get("type") || "default";
          i.set("open", !1), this.listenTo(r, "remove add reset", this.checkChildren), this.listenTo(i, "change:status", this.updateStatus), this.listenTo(i, "change:open", this.updateOpening), this.listenTo(i, "change:layerable", this.updateLayerable), this.listenTo(i, "change:style:display", this.updateVisibility), this.className = "".concat(e, "layer ").concat(e, "layer__t-").concat(a, " no-select ").concat(n, "two-color"), this.inputNameCls = "".concat(n, "layer-name"), this.clsTitleC = "".concat(e, "layer-title-c"), this.clsTitle = "".concat(e, "layer-title"), this.clsCaret = "".concat(e, "layer-caret"), this.clsCount = "".concat(e, "layer-count"), this.clsMove = "".concat(e, "layer-move"), this.clsChildren = "".concat(e, "layer-children"), this.clsNoChild = "".concat(e, "layer-no-chld"), this.clsEdit = "".concat(this.inputNameCls, "--edit"), this.clsNoEdit = "".concat(this.inputNameCls, "--no-edit"), this.$el.data("model", i), this.$el.data("collection", r), i.viewLayer = this;
        },
        getVisibilityEl: function getVisibilityEl() {
          return this.eyeEl || (this.eyeEl = this.$el.children(".".concat(this.pfx, "layer-vis"))), this.eyeEl;
        },
        updateVisibility: function updateVisibility() {
          var t = this.pfx,
            e = this.model,
            n = "".concat(t, "layer-hidden"),
            i = "none" === e.getStyle().display ? "addClass" : "removeClass";
          this.$el[i](n), this.getVisibilityEl()[i]("fa-eye-slash");
        },
        toggleVisibility: function toggleVisibility(t) {
          t && t.stopPropagation();
          var e = this.model,
            n = this.em,
            i = e.get("__prev-display"),
            r = e.getStyle(),
            a = r.display;
          "none" == a ? (delete r.display, i && (r.display = i, e.unset("__prev-display"))) : (a && e.set("__prev-display", a), r.display = "none"), e.setStyle(r), n && n.trigger("component:toggled");
        },
        handleEdit: function handleEdit(t) {
          t && t.stopPropagation();
          var e = this.em,
            n = this.$el,
            i = this.clsNoEdit,
            r = this.clsEdit,
            a = this.getInputName();
          a.contentEditable = !0, a.focus(), e && e.setEditing(1), n.find(".".concat(this.inputNameCls)).removeClass(i).addClass(r);
        },
        handleEditEnd: function handleEditEnd(t) {
          t && t.stopPropagation();
          var e = this.em,
            n = this.$el,
            i = this.clsNoEdit,
            r = this.clsEdit,
            a = this.getInputName(),
            o = a.textContent;
          a.scrollLeft = 0, a.contentEditable = !1, this.model.set({
            "custom-name": o
          }), e && e.setEditing(0), n.find(".".concat(this.inputNameCls)).addClass(i).removeClass(r);
        },
        getInputName: function getInputName() {
          return this.inputName || (this.inputName = this.el.querySelector(".".concat(this.inputNameCls))), this.inputName;
        },
        updateOpening: function updateOpening() {
          var t = this.opt.opened || {},
            e = this.model;
          e.get("open") ? (this.$el.addClass("open"), this.getCaret().addClass("fa-chevron-down"), t[e.cid] = e) : (this.$el.removeClass("open"), this.getCaret().removeClass("fa-chevron-down"), delete t[e.cid]);
        },
        toggleOpening: function toggleOpening(t) {
          t.stopPropagation(), this.model.get("components").length && this.model.set("open", !this.model.get("open"));
        },
        handleSelect: function handleSelect(t) {
          t.stopPropagation();
          var e = this.em,
            n = this.config;
          if (e) {
            var i = this.model;
            e.setSelected(i, {
              fromLayers: 1
            });
            var r = n.scrollCanvas;
            r && i.views.forEach(function (t) {
              return t.scrollIntoView(r);
            });
          }
        },
        handleHover: function handleHover(t) {
          t.stopPropagation();
          var e = this.em,
            n = this.config,
            i = this.model;
          e && n.showHover && e.setHovered(i, {
            fromLayers: 1
          });
        },
        startSort: function startSort(t) {
          t.stopPropagation();
          var e = this.em,
            n = this.sorter;
          t.button && 0 !== t.button || n && (n.onStart = function (t) {
            return e.trigger("".concat(c.eventDrag, ":start"), t);
          }, n.onMoveClb = function (t) {
            return e.trigger(c.eventDrag, t);
          }, n.startSort(t.target));
        },
        freeze: function freeze() {
          this.$el.addClass(this.pfx + "opac50"), this.model.set("open", 0);
        },
        unfreeze: function unfreeze() {
          this.$el.removeClass(this.pfx + "opac50");
        },
        updateStatus: function updateStatus(t) {
          l.default.prototype.updateStatus.apply(this, [{
            avoidHover: !this.config.highlightHover
          }]);
        },
        isVisible: function isVisible() {
          var t = this.model.getStyle().display;
          return !(t && "none" === t);
        },
        checkChildren: function checkChildren() {
          var t = this.model,
            e = this.clsNoChild,
            n = this.countChildren(t),
            i = this.$el.children(".".concat(this.clsTitleC)).children(".".concat(this.clsTitle)),
            r = this.cnt;
          r || (r = this.$el.children("[data-count]").get(0), this.cnt = r), i[n ? "removeClass" : "addClass"](e), r && (r.innerHTML = n || ""), !n && t.set("open", 0);
        },
        countChildren: function countChildren(t) {
          var e = 0;
          return t.get("components").each(function (t) {
            var n = this.opt.isCountable,
              i = this.config.hideTextnode;
            n && !n(t, i) || e++;
          }, this), e;
        },
        getCaret: function getCaret() {
          return this.caret && this.caret.length || (this.pfx, this.caret = this.$el.children(".".concat(this.clsTitleC)).find(".".concat(this.clsCaret))), this.caret;
        },
        setRoot: function setRoot(t) {
          t = Object(r.isString)(t) ? this.em.getWrapper().find(t)[0] : t;
          var e = Object(a.g)(t, d);
          e && (this.stopListening(), this.model = e, this.initialize(this.opt), this.render());
        },
        updateLayerable: function updateLayerable() {
          (this.parentView || this).render();
        },
        render: function render() {
          var t = this.model,
            e = this.config,
            a = this.pfx,
            o = this.ppfx,
            s = this.opt.isCountable,
            l = s && !s(t, e.hideTextnode),
            c = this.isVisible(),
            d = this.$el.empty(),
            u = this.level + 1;
          Object(r.isUndefined)(i) && (i = n(98).default);
          var h = new i({
            collection: t.get("components"),
            config: this.config,
            sorter: this.sorter,
            opened: this.opt.opened,
            parentView: this,
            parent: t,
            level: u
          }).render().$el;
          return this.config.showWrapper || 1 !== u ? (d.html(this.template(t)), d.find(".".concat(this.clsChildren)).append(h)) : d.append(h), t.get("draggable") && this.config.sortable || d.children(".".concat(this.clsMove)).remove(), !c && (this.className += " ".concat(a, "hide")), l && (this.className += " ".concat(o, "hidden")), d.attr("class", this.className), this.updateOpening(), this.updateStatus(), this.updateVisibility(), this;
        }
      });
    }, function (t, e, n) {
      "use strict";

      var i = n(1),
        r = n.n(i),
        a = r.a.View.extend({
          tagName: "style",
          initialize: function initialize() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            this.config = t.config || {};
            var e = this.model,
              n = "change:style change:state change:mediaText";
            this.listenTo(e, n, this.render), this.listenTo(e, "destroy remove", this.remove), this.listenTo(e.get("selectors"), "change", this.render);
          },
          render: function render() {
            var t = this.model.get("important");
            return this.el.innerHTML = this.model.toCSS({
              important: t
            }), this;
          }
        }),
        o = a.extend({
          _createElement: function _createElement(t) {
            return document.createTextNode("");
          },
          render: function render() {
            var t = this.model,
              e = t.get("important");
            return this.el.textContent = t.getDeclaration({
              important: e
            }), this;
          }
        }),
        s = r.a.$,
        l = function l(t, e) {
          return "".concat(t).concat(e ? "-".concat(parseFloat(e)) : "");
        };
      e.a = r.a.View.extend({
        initialize: function initialize(t) {
          var e = t.config || {};
          this.atRules = {}, this.config = e, this.em = e.em, this.pfx = e.stylePrefix || "", this.className = this.pfx + "rules";
          var n = this.collection;
          this.listenTo(n, "add", this.addTo), this.listenTo(n, "reset", this.render);
        },
        addTo: function addTo(t) {
          this.addToCollection(t);
        },
        addToCollection: function addToCollection(t, e) {
          if (this.renderStarted) {
            var n,
              i,
              r = e || null,
              s = {
                model: t,
                config: this.config
              };
            if ("keyframes" === t.get("atRuleType")) {
              var c = t.getAtRule(),
                d = this.atRules[c];
              if (!d) {
                var u = document.createElement("style");
                d = document.createTextNode(""), u.appendChild(document.createTextNode("".concat(c, "{"))), u.appendChild(d), u.appendChild(document.createTextNode("}")), this.atRules[c] = d, n = u;
              }
              i = new o(s), d.appendData(i.render().el.textContent);
            } else n = (i = new a(s)).render().el;
            var h = this.className,
              p = t.get("mediaText"),
              g = l(h),
              f = g;
            if (p && (f = l(h, this.getMediaWidth(p))), n) {
              var m,
                v = r || this.el;
              try {
                m = v.querySelector("#".concat(f));
              } catch (t) {}
              m || (m = v.querySelector("#".concat(g))), m.appendChild(n);
            }
            return n;
          }
        },
        getMediaWidth: function getMediaWidth(t) {
          return t && t.replace("(".concat(this.em.getConfig("mediaCondition"), ": "), "").replace(")", "");
        },
        render: function render() {
          var t = this;
          this.renderStarted = 1, this.atRules = {};
          var e = this.em,
            n = this.$el,
            i = this.className,
            r = this.collection,
            a = document.createDocumentFragment();
          n.empty();
          var o = e.get("DeviceManager").getAll().pluck("priority");
          return o.every(function (t) {
            return t;
          }) && o.unshift(0), o.forEach(function (t) {
            return s('<div id="'.concat(l(i, t), '"></div>')).appendTo(a);
          }), r.each(function (e) {
            return t.addToCollection(e, a);
          }), n.append(a), n.attr("class", i), this;
        }
      });
    }, function (t, e, n) {
      "use strict";

      var i = n(2),
        r = n.n(i),
        a = n(1),
        o = n.n(a),
        s = n(0),
        l = n(8),
        c = n.n(l),
        d = n(18);
      function u(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function h(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? u(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var p = o.a.$;
      !function (t, e) {
        var n = {
            beforeShow: u,
            move: u,
            change: u,
            show: u,
            hide: u,
            color: !1,
            flat: !1,
            showInput: !1,
            allowEmpty: !1,
            showButtons: !0,
            clickoutFiresChange: !0,
            showInitial: !1,
            showPalette: !1,
            showPaletteOnly: !1,
            hideAfterPaletteSelect: !1,
            togglePaletteOnly: !1,
            showSelectionPalette: !0,
            localStorageKey: !1,
            appendTo: "body",
            maxSelectionSize: 7,
            cancelText: "cancel",
            chooseText: "choose",
            togglePaletteMoreText: "more",
            togglePaletteLessText: "less",
            clearText: "Clear Color Selection",
            noColorSelectedText: "No Color Selected",
            preferredFormat: !1,
            className: "",
            containerClassName: "",
            replacerClassName: "",
            showAlpha: !1,
            theme: "sp-light",
            palette: [["#ffffff", "#000000", "#ff0000", "#ff8000", "#ffff00", "#008000", "#0000ff", "#4b0082", "#9400d3"]],
            selectionPalette: [],
            disabled: !1,
            offset: null
          },
          i = [],
          r = !!/msie/i.exec(window.navigator.userAgent),
          a = function () {
            function t(t, e) {
              return !!~("" + t).indexOf(e);
            }
            var e = document.createElement("div").style;
            return e.cssText = "background-color:rgba(0,0,0,.5)", t(e.backgroundColor, "rgba") || t(e.backgroundColor, "hsla");
          }(),
          o = ["<div class='sp-replacer'>", "<div class='sp-preview'><div class='sp-preview-inner'></div></div>", "<div class='sp-dd'>&#9660;</div>", "</div>"].join(""),
          s = function () {
            var t = "";
            if (r) for (var e = 1; e <= 6; e++) t += "<div class='sp-" + e + "'></div>";
            return ["<div class='sp-container sp-hidden'>", "<div class='sp-palette-container'>", "<div class='sp-palette sp-thumb sp-cf'></div>", "<div class='sp-palette-button-container sp-cf'>", "<button type='button' class='sp-palette-toggle'></button>", "</div>", "</div>", "<div class='sp-picker-container'>", "<div class='sp-top sp-cf'>", "<div class='sp-fill'></div>", "<div class='sp-top-inner'>", "<div class='sp-color'>", "<div class='sp-sat'>", "<div class='sp-val'>", "<div class='sp-dragger'></div>", "</div>", "</div>", "</div>", "<div class='sp-clear sp-clear-display'>", "</div>", "<div class='sp-hue'>", "<div class='sp-slider'></div>", t, "</div>", "</div>", "<div class='sp-alpha'><div class='sp-alpha-inner'><div class='sp-alpha-handle'></div></div></div>", "</div>", "<div class='sp-input-container sp-cf'>", "<input class='sp-input' type='text' spellcheck='false'  />", "</div>", "<div class='sp-initial sp-thumb sp-cf'></div>", "<div class='sp-button-container sp-cf'>", "<a class='sp-cancel' href='#'></a>", "<button type='button' class='sp-choose'></button>", "</div>", "</div>", "</div>"].join("");
          }();
        function l(e, n, i, r) {
          for (var o = [], s = 0; s < e.length; s++) {
            var l = e[s];
            if (l) {
              var c = k(l),
                d = c.toHsl().l < .5 ? "sp-thumb-el sp-thumb-dark" : "sp-thumb-el sp-thumb-light";
              d += k.equals(n, l) ? " sp-thumb-active" : "";
              var u = c.toString(r.preferredFormat || "rgb"),
                h = a ? "background-color:" + c.toRgbString() : "filter:" + c.toFilter();
              o.push('<span title="' + u + '" data-color="' + c.toRgbString() + '" class="' + d + '"><span class="sp-thumb-inner" style="' + h + ';"></span></span>');
            } else o.push(t("<div />").append(t('<span data-color="" style="background-color:transparent;" class="sp-clear-display"></span>').attr("title", r.noColorSelectedText)).html());
          }
          return "<div class='sp-cf " + i + "'>" + o.join("") + "</div>";
        }
        function d(c, d) {
          var u,
            m,
            v,
            b,
            y = function (e, i) {
              var r = t.extend({}, n, e);
              return r.callbacks = {
                move: p(r.move, i),
                change: p(r.change, i),
                show: p(r.show, i),
                hide: p(r.hide, i),
                beforeShow: p(r.beforeShow, i)
              }, r;
            }(d, c),
            w = y.flat,
            x = y.showSelectionPalette,
            j = y.localStorageKey,
            C = y.theme,
            M = y.callbacks,
            O = (u = Wt, m = 10, function () {
              var t = this,
                e = arguments,
                n = function n() {
                  b = null, u.apply(t, e);
                };
              v && clearTimeout(b), !v && b || (b = setTimeout(n, m));
            }),
            T = !1,
            S = !1,
            N = 0,
            L = 0,
            D = 0,
            E = 0,
            I = 0,
            P = 0,
            A = 0,
            z = 0,
            _ = 0,
            H = 0,
            V = 1,
            F = [],
            R = [],
            B = {},
            W = y.selectionPalette.slice(0),
            Y = y.maxSelectionSize,
            U = null,
            Z = c.ownerDocument,
            G = (Z.body, t(c)),
            q = !1,
            $ = t(s, Z).addClass(C),
            Q = $.find(".sp-picker-container"),
            J = $.find(".sp-color"),
            X = $.find(".sp-dragger"),
            K = $.find(".sp-hue"),
            tt = $.find(".sp-slider"),
            et = $.find(".sp-alpha-inner"),
            nt = $.find(".sp-alpha"),
            it = $.find(".sp-alpha-handle"),
            rt = $.find(".sp-input"),
            at = $.find(".sp-palette"),
            ot = $.find(".sp-initial"),
            st = $.find(".sp-cancel"),
            lt = $.find(".sp-clear"),
            ct = $.find(".sp-choose"),
            dt = $.find(".sp-palette-toggle"),
            ut = G.is("input"),
            ht = ut && "color" === G.attr("type") && f(),
            pt = ut && !w,
            gt = pt ? t(o).addClass(C).addClass(y.className).addClass(y.replacerClassName) : t([]),
            ft = pt ? gt : G,
            mt = gt.find(".sp-preview-inner"),
            vt = y.color || ut && G.val(),
            bt = !1,
            yt = y.preferredFormat,
            wt = !y.showButtons || y.clickoutFiresChange,
            xt = !vt,
            jt = y.allowEmpty && !ht;
          function Ct() {
            if (y.showPaletteOnly && (y.showPalette = !0), dt.text(y.showPaletteOnly ? y.togglePaletteMoreText : y.togglePaletteLessText), y.palette) {
              F = y.palette.slice(0), R = t.isArray(F[0]) ? F : [F], B = {};
              for (var e = 0; e < R.length; e++) for (var n = 0; n < R[e].length; n++) {
                var i = k(R[e][n]).toRgbString();
                B[i] = !0;
              }
            }
            $.toggleClass("sp-flat", w), $.toggleClass("sp-input-disabled", !y.showInput), $.toggleClass("sp-alpha-enabled", y.showAlpha), $.toggleClass("sp-clear-enabled", jt), $.toggleClass("sp-buttons-disabled", !y.showButtons), $.toggleClass("sp-palette-buttons-disabled", !y.togglePaletteOnly), $.toggleClass("sp-palette-disabled", !y.showPalette), $.toggleClass("sp-palette-only", y.showPaletteOnly), $.toggleClass("sp-initial-disabled", !y.showInitial), $.addClass(y.className).addClass(y.containerClassName), Wt();
          }
          function Mt() {
            if (j && window.localStorage) {
              try {
                var e = window.localStorage[j].split(",#");
                e.length > 1 && (delete window.localStorage[j], t.each(e, function (t, e) {
                  kt(e);
                }));
              } catch (t) {}
              try {
                W = window.localStorage[j].split(";");
              } catch (t) {}
            }
          }
          function kt(e) {
            if (x) {
              var n = k(e).toRgbString();
              if (!B[n] && -1 === t.inArray(n, W)) for (W.push(n); W.length > Y;) W.shift();
              if (j && window.localStorage) try {
                window.localStorage[j] = W.join(";");
              } catch (t) {}
            }
          }
          function Ot() {
            var e = Ht(),
              n = t.map(R, function (t, n) {
                return l(t, e, "sp-palette-row sp-palette-row-" + n, y);
              });
            Mt(), W && n.push(l(function () {
              var t = [];
              if (y.showPalette) for (var e = 0; e < W.length; e++) {
                var n = k(W[e]).toRgbString();
                B[n] || t.push(W[e]);
              }
              return t.reverse().slice(0, y.maxSelectionSize);
            }(), e, "sp-palette-row sp-palette-row-selection", y)), at.html(n.join(""));
          }
          function Tt() {
            if (y.showInitial) {
              var t = bt,
                e = Ht();
              ot.html(l([t, e], e, "sp-palette-row-initial", y));
            }
          }
          function St() {
            (L <= 0 || N <= 0 || E <= 0) && Wt(), S = !0, $.addClass("sp-dragging"), U = null, G.trigger("dragstart.spectrum", [Ht()]);
          }
          function Nt() {
            S = !1, $.removeClass("sp-dragging"), G.trigger("dragstop.spectrum", [Ht()]);
          }
          function Lt() {
            var t = rt.val();
            if (null !== t && "" !== t || !jt) {
              var e = k(t);
              e.isValid() ? (_t(e), Bt(!0)) : rt.addClass("sp-validation-error");
            } else _t(null), Bt(!0);
          }
          function Dt() {
            T ? At() : Et();
          }
          function Et() {
            var e = t.Event("beforeShow.spectrum");
            if (T) Wt();else if (G.trigger("beforeShow.spectrum", [Ht()]), !1 !== M.beforeShow(Ht()) && !e.isDefaultPrevented()) {
              !function () {
                for (var t = 0; t < i.length; t++) i[t] && i[t].hide();
              }(), T = !0;
              var n = t(Z);
              n.bind("keydown.spectrum", It), n.bind("click.spectrum", Pt), t(window).bind("resize.spectrum", O), gt.addClass("sp-active"), $.removeClass("sp-hidden"), Wt(), Ft(), bt = Ht(), Tt(), M.show(bt), G.trigger("show.spectrum", [bt]);
            }
          }
          function It(t) {
            27 === t.keyCode && At();
          }
          function Pt(t) {
            2 != t.button && (S || (wt ? Bt(!0) : zt(), At()));
          }
          function At() {
            T && !w && (T = !1, t(Z).unbind("keydown.spectrum", It), t(Z).unbind("click.spectrum", Pt), t(window).unbind("resize.spectrum", O), gt.removeClass("sp-active"), $.addClass("sp-hidden"), M.hide(Ht()), G.trigger("hide.spectrum", [Ht()]));
          }
          function zt() {
            _t(bt, !0);
          }
          function _t(t, e) {
            var n, i;
            k.equals(t, Ht()) ? Ft() : (!t && jt ? xt = !0 : (xt = !1, i = (n = k(t)).toHsv(), z = i.h % 360 / 360, _ = i.s, H = i.v, V = i.a), Ft(), n && n.isValid() && !e && (yt = y.preferredFormat || n.getFormat()));
          }
          function Ht(t) {
            return t = t || {}, jt && xt ? null : k.fromRatio({
              h: z,
              s: _,
              v: H,
              a: Math.round(100 * V) / 100
            }, {
              format: t.format || yt
            });
          }
          function Vt() {
            Ft(), M.move(Ht()), G.trigger("move.spectrum", [Ht()]);
          }
          function Ft() {
            rt.removeClass("sp-validation-error"), Rt();
            var t = k.fromRatio({
              h: z,
              s: 1,
              v: 1
            });
            J.css("background-color", t.toHexString());
            var e = yt;
            V < 1 && (0 !== V || "name" !== e) && ("hex" !== e && "hex3" !== e && "hex6" !== e && "name" !== e || (e = "rgb"));
            var n = Ht({
                format: e
              }),
              i = "";
            if (mt.removeClass("sp-clear-display"), mt.css("background-color", "transparent"), !n && jt) mt.addClass("sp-clear-display");else {
              var o = n.toHexString(),
                s = n.toRgbString();
              if (a || 1 === n.alpha ? mt.css("background-color", s) : (mt.css("background-color", "transparent"), mt.css("filter", n.toFilter())), y.showAlpha) {
                var l = n.toRgb();
                l.a = 0;
                var c = k(l).toRgbString(),
                  d = "linear-gradient(left, " + c + ", " + o + ")";
                r ? et.css("filter", k(c).toFilter({
                  gradientType: 1
                }, o)) : (et.css("background", "-webkit-" + d), et.css("background", "-moz-" + d), et.css("background", "-ms-" + d), et.css("background", "linear-gradient(to right, " + c + ", " + o + ")"));
              }
              i = n.toString(e);
            }
            y.showInput && rt.val(i), y.showPalette && Ot(), Tt();
          }
          function Rt() {
            var t = _,
              e = H;
            if (jt && xt) it.hide(), tt.hide(), X.hide();else {
              it.show(), tt.show(), X.show();
              var n = t * N,
                i = L - e * L;
              n = Math.max(-D, Math.min(N - D, n - D)), i = Math.max(-D, Math.min(L - D, i - D)), X.css({
                top: i + "px",
                left: n + "px"
              });
              var r = V * I;
              it.css({
                left: r - P / 2 + "px"
              });
              var a = z * E;
              tt.css({
                top: a - A + "px"
              });
            }
          }
          function Bt(t) {
            var e = Ht(),
              n = "",
              i = !k.equals(e, bt);
            e && (n = e.toString(yt), kt(e)), ut && G.val(n), t && i && (M.change(e), G.trigger("change", [e]));
          }
          function Wt() {
            T && (N = J.width(), L = J.height(), D = X.height(), K.width(), E = K.height(), A = tt.height(), I = nt.width(), P = it.width(), w || ($.css("position", "absolute"), y.offset ? $.offset(y.offset) : $.offset(function (e, n) {
              var i = e.outerWidth(),
                r = e.outerHeight(),
                a = n.outerHeight(),
                o = e[0].ownerDocument,
                s = o.documentElement,
                l = s.clientWidth,
                c = s.clientHeight,
                d = l + t(o).scrollLeft(),
                u = c + t(o).scrollTop(),
                h = n.offset();
              return h.top += a, h.left -= Math.min(h.left, h.left + i > d && d > i ? Math.abs(h.left + i - d) : 0), h.top -= Math.min(h.top, h.top + r > u && u > r ? Math.abs(r + a - 0) : 0), h;
            }($, ft))), Rt(), y.showPalette && Ot(), G.trigger("reflow.spectrum"));
          }
          function Yt() {
            At(), q = !0, G.attr("disabled", !0), ft.addClass("sp-disabled");
          }
          !function () {
            if (r && $.find("*:not(input)").attr("unselectable", "on"), Ct(), pt && G.after(gt).hide(), jt || lt.hide(), w) G.after($).hide();else {
              var e = "parent" === y.appendTo ? G.parent() : t(y.appendTo);
              1 !== e.length && (e = t("body")), e.append($);
            }
            function n(e) {
              return e.data && e.data.ignore ? (_t(t(e.target).closest(".sp-thumb-el").data("color")), Vt()) : (_t(t(e.target).closest(".sp-thumb-el").data("color")), Vt(), Bt(!0), y.hideAfterPaletteSelect && At()), !1;
            }
            Mt(), ft.bind("click.spectrum touchstart.spectrum", function (e) {
              q || Dt(), e.stopPropagation(), t(e.target).is("input") || e.preventDefault();
            }), (G.is(":disabled") || !0 === y.disabled) && Yt(), $.click(h), rt.change(Lt), rt.bind("paste", function () {
              setTimeout(Lt, 1);
            }), rt.keydown(function (t) {
              13 == t.keyCode && Lt();
            }), st.text(y.cancelText), st.bind("click.spectrum", function (t) {
              t.stopPropagation(), t.preventDefault(), zt(), At();
            }), lt.attr("title", y.clearText), lt.bind("click.spectrum", function (t) {
              t.stopPropagation(), t.preventDefault(), xt = !0, Vt(), w && Bt(!0);
            }), ct.text(y.chooseText), ct.bind("click.spectrum", function (t) {
              t.stopPropagation(), t.preventDefault(), r && rt.is(":focus") && rt.trigger("change"), rt.hasClass("sp-validation-error") || (Bt(!0), At());
            }), dt.text(y.showPaletteOnly ? y.togglePaletteMoreText : y.togglePaletteLessText), dt.bind("click.spectrum", function (t) {
              t.stopPropagation(), t.preventDefault(), y.showPaletteOnly = !y.showPaletteOnly, y.showPaletteOnly || w || $.css("left", "-=" + (Q.outerWidth(!0) + 5)), Ct();
            }), g(nt, function (t, e, n) {
              V = t / I, xt = !1, n.shiftKey && (V = Math.round(10 * V) / 10), Vt();
            }, St, Nt), g(K, function (t, e) {
              z = parseFloat(e / E), xt = !1, y.showAlpha || (V = 1), Vt();
            }, St, Nt), g(J, function (t, e, n) {
              if (n.shiftKey) {
                if (!U) {
                  var i = _ * N,
                    r = L - H * L,
                    a = Math.abs(t - i) > Math.abs(e - r);
                  U = a ? "x" : "y";
                }
              } else U = null;
              var o = !U || "y" === U;
              (!U || "x" === U) && (_ = parseFloat(t / N)), o && (H = parseFloat((L - e) / L)), xt = !1, y.showAlpha || (V = 1), Vt();
            }, St, Nt), vt ? (_t(vt), Ft(), yt = y.preferredFormat || k(vt).format, kt(vt)) : Ft(), w && Et();
            var i = r ? "mousedown.spectrum" : "click.spectrum touchstart.spectrum";
            at.delegate(".sp-thumb-el", i, n), ot.delegate(".sp-thumb-el:nth-child(1)", i, {
              ignore: !0
            }, n);
          }();
          var Ut = {
            show: Et,
            hide: At,
            toggle: Dt,
            reflow: Wt,
            option: function option(n, i) {
              return n === e ? t.extend({}, y) : i === e ? y[n] : (y[n] = i, "preferredFormat" === n && (yt = y.preferredFormat), void Ct());
            },
            enable: function enable() {
              q = !1, G.attr("disabled", !1), ft.removeClass("sp-disabled");
            },
            disable: Yt,
            offset: function offset(t) {
              y.offset = t, Wt();
            },
            set: function set(t) {
              _t(t), Bt();
            },
            get: Ht,
            destroy: function destroy() {
              G.show(), ft.unbind("click.spectrum touchstart.spectrum"), $.remove(), gt.remove(), i[Ut.id] = null;
            },
            container: $
          };
          return Ut.id = i.push(Ut) - 1, Ut;
        }
        function u() {}
        function h(t) {
          t.stopPropagation();
        }
        function p(t, e) {
          var n = Array.prototype.slice,
            i = n.call(arguments, 2);
          return function () {
            return t.apply(e, i.concat(n.call(arguments)));
          };
        }
        function g(e, n, i, a) {
          n = n || function () {}, i = i || function () {}, a = a || function () {};
          var o = document,
            s = !1,
            l = {},
            c = 0,
            d = 0,
            u = "ontouchstart" in window,
            h = {};
          function p(t) {
            t.stopPropagation && t.stopPropagation(), t.preventDefault && t.preventDefault(), t.returnValue = !1;
          }
          function g(t) {
            if (s) {
              if (r && o.documentMode < 9 && !t.button) return f();
              var i = t && t.touches && t.touches[0],
                a = i && i.pageX || t.pageX,
                h = i && i.pageY || t.pageY,
                g = Math.max(0, Math.min(a - l.left, d)),
                m = Math.max(0, Math.min(h - l.top, c));
              u && p(t), n.apply(e, [g, m, t]);
            }
          }
          function f() {
            s && (t(o).unbind(h), t(o.body).removeClass("sp-dragging"), setTimeout(function () {
              a.apply(e, arguments);
            }, 0)), s = !1;
          }
          h.selectstart = p, h.dragstart = p, h["touchmove mousemove"] = g, h["touchend mouseup"] = f, t(e).bind("touchstart mousedown", function (n) {
            var r = n.which ? 3 == n.which : 2 == n.button;
            r || s || !1 !== i.apply(e, arguments) && (s = !0, c = t(e).height(), d = t(e).width(), l = t(e).offset(), t(o).bind(h), t(o.body).addClass("sp-dragging"), g(n), p(n));
          });
        }
        function f() {
          return t.fn.spectrum.inputTypeColorSupport();
        }
        var m = "spectrum.id";
        t.fn.spectrum = function (e, n) {
          if ("string" == typeof e) {
            var r = this,
              a = Array.prototype.slice.call(arguments, 1);
            return this.each(function () {
              var n = i[t(this).data(m)];
              if (n) {
                var o = n[e];
                if (!o) throw new Error("Spectrum: no such method: '" + e + "'");
                "get" == e ? r = n.get() : "container" == e ? r = n.container : "option" == e ? r = n.option.apply(n, a) : "destroy" == e ? (n.destroy(), t(this).removeData(m)) : o.apply(n, a);
              }
            }), r;
          }
          return this.spectrum("destroy").each(function () {
            var n = d(this, t.extend({}, e, t(this).data()));
            t(this).data(m, n.id);
          });
        }, t.fn.spectrum.load = !0, t.fn.spectrum.loadOpts = {}, t.fn.spectrum.draggable = g, t.fn.spectrum.defaults = n, t.fn.spectrum.inputTypeColorSupport = function e() {
          if (void 0 === e._cachedResult) {
            var n = t("<input type='color'/>")[0];
            e._cachedResult = "color" === n.type && "" !== n.value;
          }
          return e._cachedResult;
        }, t.spectrum = {}, t.spectrum.localization = {}, t.spectrum.palettes = {}, t.fn.spectrum.processNativeColorInputs = function () {
          var e = t("input[type=color]");
          e.length && !f() && e.spectrum({
            preferredFormat: "hex6"
          });
        };
        var v = /^[\s,#]+/,
          b = /\s+$/,
          y = 0,
          w = Math,
          x = w.round,
          j = w.min,
          C = w.max,
          M = w.random,
          k = function t(e, n) {
            if (n = n || {}, (e = e || "") instanceof t) return e;
            if (!(this instanceof t)) return new t(e, n);
            var i = function (t) {
              var e,
                n,
                i,
                r = {
                  r: 0,
                  g: 0,
                  b: 0
                },
                a = 1,
                o = !1,
                s = !1;
              return "string" == typeof t && (t = function (t) {
                t = t.replace(v, "").replace(b, "").toLowerCase();
                var e,
                  n,
                  i = !1;
                if (W[t]) t = W[t], i = !0;else if ("transparent" == t) return {
                  r: 0,
                  g: 0,
                  b: 0,
                  a: 0,
                  format: "name"
                };
                return (e = tt.rgb.exec(t)) ? {
                  r: e[1],
                  g: e[2],
                  b: e[3]
                } : (e = tt.rgba.exec(t)) ? {
                  r: e[1],
                  g: e[2],
                  b: e[3],
                  a: e[4]
                } : (e = tt.hsl.exec(t)) ? {
                  h: e[1],
                  s: e[2],
                  l: e[3]
                } : (e = tt.hsla.exec(t)) ? {
                  h: e[1],
                  s: e[2],
                  l: e[3],
                  a: e[4]
                } : (e = tt.hsv.exec(t)) ? {
                  h: e[1],
                  s: e[2],
                  v: e[3]
                } : (e = tt.hsva.exec(t)) ? {
                  h: e[1],
                  s: e[2],
                  v: e[3],
                  a: e[4]
                } : (e = tt.hex8.exec(t)) ? {
                  a: (n = e[1], q(n) / 255),
                  r: q(e[2]),
                  g: q(e[3]),
                  b: q(e[4]),
                  format: i ? "name" : "hex8"
                } : (e = tt.hex6.exec(t)) ? {
                  r: q(e[1]),
                  g: q(e[2]),
                  b: q(e[3]),
                  format: i ? "name" : "hex"
                } : !!(e = tt.hex3.exec(t)) && {
                  r: q(e[1] + "" + e[1]),
                  g: q(e[2] + "" + e[2]),
                  b: q(e[3] + "" + e[3]),
                  format: i ? "name" : "hex"
                };
              }(t)), "object" == c()(t) && (t.hasOwnProperty("r") && t.hasOwnProperty("g") && t.hasOwnProperty("b") ? (e = t.r, n = t.g, i = t.b, r = {
                r: 255 * Z(e, 255),
                g: 255 * Z(n, 255),
                b: 255 * Z(i, 255)
              }, o = !0, s = "%" === String(t.r).substr(-1) ? "prgb" : "rgb") : t.hasOwnProperty("h") && t.hasOwnProperty("s") && t.hasOwnProperty("v") ? (t.s = Q(t.s), t.v = Q(t.v), r = function (t, e, n) {
                t = 6 * Z(t, 360), e = Z(e, 100), n = Z(n, 100);
                var i = w.floor(t),
                  r = t - i,
                  a = n * (1 - e),
                  o = n * (1 - r * e),
                  s = n * (1 - (1 - r) * e),
                  l = i % 6;
                return {
                  r: 255 * [n, o, a, a, s, n][l],
                  g: 255 * [s, n, n, o, a, a][l],
                  b: 255 * [a, a, s, n, n, o][l]
                };
              }(t.h, t.s, t.v), o = !0, s = "hsv") : t.hasOwnProperty("h") && t.hasOwnProperty("s") && t.hasOwnProperty("l") && (t.s = Q(t.s), t.l = Q(t.l), r = function (t, e, n) {
                var i, r, a;
                function o(t, e, n) {
                  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + 6 * (e - t) * n : n < .5 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t;
                }
                if (t = Z(t, 360), e = Z(e, 100), n = Z(n, 100), 0 === e) i = r = a = n;else {
                  var s = n < .5 ? n * (1 + e) : n + e - n * e,
                    l = 2 * n - s;
                  i = o(l, s, t + 1 / 3), r = o(l, s, t), a = o(l, s, t - 1 / 3);
                }
                return {
                  r: 255 * i,
                  g: 255 * r,
                  b: 255 * a
                };
              }(t.h, t.s, t.l), o = !0, s = "hsl"), t.hasOwnProperty("a") && (a = t.a)), a = U(a), {
                ok: o,
                format: t.format || s,
                r: j(255, C(r.r, 0)),
                g: j(255, C(r.g, 0)),
                b: j(255, C(r.b, 0)),
                a: a
              };
            }(e);
            this._originalInput = e, this._r = i.r, this._g = i.g, this._b = i.b, this._a = i.a, this._roundA = x(100 * this._a) / 100, this._format = n.format || i.format, this._gradientType = n.gradientType, this._r < 1 && (this._r = x(this._r)), this._g < 1 && (this._g = x(this._g)), this._b < 1 && (this._b = x(this._b)), this._ok = i.ok, this._tc_id = y++;
          };
        function O(t, e, n) {
          t = Z(t, 255), e = Z(e, 255), n = Z(n, 255);
          var i,
            r,
            a = C(t, e, n),
            o = j(t, e, n),
            s = (a + o) / 2;
          if (a == o) i = r = 0;else {
            var l = a - o;
            switch (r = s > .5 ? l / (2 - a - o) : l / (a + o), a) {
              case t:
                i = (e - n) / l + (e < n ? 6 : 0);
                break;
              case e:
                i = (n - t) / l + 2;
                break;
              case n:
                i = (t - e) / l + 4;
            }
            i /= 6;
          }
          return {
            h: i,
            s: r,
            l: s
          };
        }
        function T(t, e, n) {
          t = Z(t, 255), e = Z(e, 255), n = Z(n, 255);
          var i,
            r,
            a = C(t, e, n),
            o = j(t, e, n),
            s = a,
            l = a - o;
          if (r = 0 === a ? 0 : l / a, a == o) i = 0;else {
            switch (a) {
              case t:
                i = (e - n) / l + (e < n ? 6 : 0);
                break;
              case e:
                i = (n - t) / l + 2;
                break;
              case n:
                i = (t - e) / l + 4;
            }
            i /= 6;
          }
          return {
            h: i,
            s: r,
            v: s
          };
        }
        function S(t, e, n, i) {
          var r = [$(x(t).toString(16)), $(x(e).toString(16)), $(x(n).toString(16))];
          return i && r[0].charAt(0) == r[0].charAt(1) && r[1].charAt(0) == r[1].charAt(1) && r[2].charAt(0) == r[2].charAt(1) ? r[0].charAt(0) + r[1].charAt(0) + r[2].charAt(0) : r.join("");
        }
        function N(t, e, n, i) {
          var r;
          return [$((r = i, Math.round(255 * parseFloat(r)).toString(16))), $(x(t).toString(16)), $(x(e).toString(16)), $(x(n).toString(16))].join("");
        }
        function L(t, e) {
          e = 0 === e ? 0 : e || 10;
          var n = k(t).toHsl();
          return n.s -= e / 100, n.s = G(n.s), k(n);
        }
        function D(t, e) {
          e = 0 === e ? 0 : e || 10;
          var n = k(t).toHsl();
          return n.s += e / 100, n.s = G(n.s), k(n);
        }
        function E(t) {
          return k(t).desaturate(100);
        }
        function I(t, e) {
          e = 0 === e ? 0 : e || 10;
          var n = k(t).toHsl();
          return n.l += e / 100, n.l = G(n.l), k(n);
        }
        function P(t, e) {
          e = 0 === e ? 0 : e || 10;
          var n = k(t).toRgb();
          return n.r = C(0, j(255, n.r - x(-e / 100 * 255))), n.g = C(0, j(255, n.g - x(-e / 100 * 255))), n.b = C(0, j(255, n.b - x(-e / 100 * 255))), k(n);
        }
        function A(t, e) {
          e = 0 === e ? 0 : e || 10;
          var n = k(t).toHsl();
          return n.l -= e / 100, n.l = G(n.l), k(n);
        }
        function z(t, e) {
          var n = k(t).toHsl(),
            i = (x(n.h) + e) % 360;
          return n.h = i < 0 ? 360 + i : i, k(n);
        }
        function _(t) {
          var e = k(t).toHsl();
          return e.h = (e.h + 180) % 360, k(e);
        }
        function H(t) {
          var e = k(t).toHsl(),
            n = e.h;
          return [k(t), k({
            h: (n + 120) % 360,
            s: e.s,
            l: e.l
          }), k({
            h: (n + 240) % 360,
            s: e.s,
            l: e.l
          })];
        }
        function V(t) {
          var e = k(t).toHsl(),
            n = e.h;
          return [k(t), k({
            h: (n + 90) % 360,
            s: e.s,
            l: e.l
          }), k({
            h: (n + 180) % 360,
            s: e.s,
            l: e.l
          }), k({
            h: (n + 270) % 360,
            s: e.s,
            l: e.l
          })];
        }
        function F(t) {
          var e = k(t).toHsl(),
            n = e.h;
          return [k(t), k({
            h: (n + 72) % 360,
            s: e.s,
            l: e.l
          }), k({
            h: (n + 216) % 360,
            s: e.s,
            l: e.l
          })];
        }
        function R(t, e, n) {
          e = e || 6, n = n || 30;
          var i = k(t).toHsl(),
            r = 360 / n,
            a = [k(t)];
          for (i.h = (i.h - (r * e >> 1) + 720) % 360; --e;) i.h = (i.h + r) % 360, a.push(k(i));
          return a;
        }
        function B(t, e) {
          e = e || 6;
          for (var n = k(t).toHsv(), i = n.h, r = n.s, a = n.v, o = [], s = 1 / e; e--;) o.push(k({
            h: i,
            s: r,
            v: a
          })), a = (a + s) % 1;
          return o;
        }
        k.prototype = {
          isDark: function isDark() {
            return this.getBrightness() < 128;
          },
          isLight: function isLight() {
            return !this.isDark();
          },
          isValid: function isValid() {
            return this._ok;
          },
          getOriginalInput: function getOriginalInput() {
            return this._originalInput;
          },
          getFormat: function getFormat() {
            return this._format;
          },
          getAlpha: function getAlpha() {
            return this._a;
          },
          getBrightness: function getBrightness() {
            var t = this.toRgb();
            return (299 * t.r + 587 * t.g + 114 * t.b) / 1e3;
          },
          setAlpha: function setAlpha(t) {
            return this._a = U(t), this._roundA = x(100 * this._a) / 100, this;
          },
          toHsv: function toHsv() {
            var t = T(this._r, this._g, this._b);
            return {
              h: 360 * t.h,
              s: t.s,
              v: t.v,
              a: this._a
            };
          },
          toHsvString: function toHsvString() {
            var t = T(this._r, this._g, this._b),
              e = x(360 * t.h),
              n = x(100 * t.s),
              i = x(100 * t.v);
            return 1 == this._a ? "hsv(" + e + ", " + n + "%, " + i + "%)" : "hsva(" + e + ", " + n + "%, " + i + "%, " + this._roundA + ")";
          },
          toHsl: function toHsl() {
            var t = O(this._r, this._g, this._b);
            return {
              h: 360 * t.h,
              s: t.s,
              l: t.l,
              a: this._a
            };
          },
          toHslString: function toHslString() {
            var t = O(this._r, this._g, this._b),
              e = x(360 * t.h),
              n = x(100 * t.s),
              i = x(100 * t.l);
            return 1 == this._a ? "hsl(" + e + ", " + n + "%, " + i + "%)" : "hsla(" + e + ", " + n + "%, " + i + "%, " + this._roundA + ")";
          },
          toHex: function toHex(t) {
            return S(this._r, this._g, this._b, t);
          },
          toHexString: function toHexString(t) {
            return "#" + this.toHex(t);
          },
          toHex8: function toHex8() {
            return N(this._r, this._g, this._b, this._a);
          },
          toHex8String: function toHex8String() {
            return "#" + this.toHex8();
          },
          toRgb: function toRgb() {
            return {
              r: x(this._r),
              g: x(this._g),
              b: x(this._b),
              a: this._a
            };
          },
          toRgbString: function toRgbString() {
            return 1 == this._a ? "rgb(" + x(this._r) + ", " + x(this._g) + ", " + x(this._b) + ")" : "rgba(" + x(this._r) + ", " + x(this._g) + ", " + x(this._b) + ", " + this._roundA + ")";
          },
          toPercentageRgb: function toPercentageRgb() {
            return {
              r: x(100 * Z(this._r, 255)) + "%",
              g: x(100 * Z(this._g, 255)) + "%",
              b: x(100 * Z(this._b, 255)) + "%",
              a: this._a
            };
          },
          toPercentageRgbString: function toPercentageRgbString() {
            return 1 == this._a ? "rgb(" + x(100 * Z(this._r, 255)) + "%, " + x(100 * Z(this._g, 255)) + "%, " + x(100 * Z(this._b, 255)) + "%)" : "rgba(" + x(100 * Z(this._r, 255)) + "%, " + x(100 * Z(this._g, 255)) + "%, " + x(100 * Z(this._b, 255)) + "%, " + this._roundA + ")";
          },
          toName: function toName() {
            return 0 === this._a ? "transparent" : !(this._a < 1) && (Y[S(this._r, this._g, this._b, !0)] || !1);
          },
          toFilter: function toFilter(t) {
            var e = "#" + N(this._r, this._g, this._b, this._a),
              n = e,
              i = this._gradientType ? "GradientType = 1, " : "";
            return t && (n = k(t).toHex8String()), "progid:DXImageTransform.Microsoft.gradient(" + i + "startColorstr=" + e + ",endColorstr=" + n + ")";
          },
          toString: function toString(t) {
            var e = !!t;
            t = t || this._format;
            var n = !1,
              i = this._a < 1 && this._a >= 0;
            return e || !i || "hex" !== t && "hex6" !== t && "hex3" !== t && "name" !== t ? ("rgb" === t && (n = this.toRgbString()), "prgb" === t && (n = this.toPercentageRgbString()), "hex" !== t && "hex6" !== t || (n = this.toHexString()), "hex3" === t && (n = this.toHexString(!0)), "hex8" === t && (n = this.toHex8String()), "name" === t && (n = this.toName()), "hsl" === t && (n = this.toHslString()), "hsv" === t && (n = this.toHsvString()), n || this.toHexString()) : "name" === t && 0 === this._a ? this.toName() : this.toRgbString();
          },
          _applyModification: function _applyModification(t, e) {
            var n = t.apply(null, [this].concat([].slice.call(e)));
            return this._r = n._r, this._g = n._g, this._b = n._b, this.setAlpha(n._a), this;
          },
          lighten: function lighten() {
            return this._applyModification(I, arguments);
          },
          brighten: function brighten() {
            return this._applyModification(P, arguments);
          },
          darken: function darken() {
            return this._applyModification(A, arguments);
          },
          desaturate: function desaturate() {
            return this._applyModification(L, arguments);
          },
          saturate: function saturate() {
            return this._applyModification(D, arguments);
          },
          greyscale: function greyscale() {
            return this._applyModification(E, arguments);
          },
          spin: function spin() {
            return this._applyModification(z, arguments);
          },
          _applyCombination: function _applyCombination(t, e) {
            return t.apply(null, [this].concat([].slice.call(e)));
          },
          analogous: function analogous() {
            return this._applyCombination(R, arguments);
          },
          complement: function complement() {
            return this._applyCombination(_, arguments);
          },
          monochromatic: function monochromatic() {
            return this._applyCombination(B, arguments);
          },
          splitcomplement: function splitcomplement() {
            return this._applyCombination(F, arguments);
          },
          triad: function triad() {
            return this._applyCombination(H, arguments);
          },
          tetrad: function tetrad() {
            return this._applyCombination(V, arguments);
          }
        }, k.fromRatio = function (t, e) {
          if ("object" == c()(t)) {
            var n = {};
            for (var i in t) t.hasOwnProperty(i) && (n[i] = "a" === i ? t[i] : Q(t[i]));
            t = n;
          }
          return k(t, e);
        }, k.equals = function (t, e) {
          return !(!t || !e) && k(t).toRgbString() == k(e).toRgbString();
        }, k.random = function () {
          return k.fromRatio({
            r: M(),
            g: M(),
            b: M()
          });
        }, k.mix = function (t, e, n) {
          n = 0 === n ? 0 : n || 50;
          var i,
            r = k(t).toRgb(),
            a = k(e).toRgb(),
            o = n / 100,
            s = 2 * o - 1,
            l = a.a - r.a,
            c = 1 - (i = ((i = s * l == -1 ? s : (s + l) / (1 + s * l)) + 1) / 2),
            d = {
              r: a.r * i + r.r * c,
              g: a.g * i + r.g * c,
              b: a.b * i + r.b * c,
              a: a.a * o + r.a * (1 - o)
            };
          return k(d);
        }, k.readability = function (t, e) {
          var n = k(t),
            i = k(e),
            r = n.toRgb(),
            a = i.toRgb(),
            o = n.getBrightness(),
            s = i.getBrightness(),
            l = Math.max(r.r, a.r) - Math.min(r.r, a.r) + Math.max(r.g, a.g) - Math.min(r.g, a.g) + Math.max(r.b, a.b) - Math.min(r.b, a.b);
          return {
            brightness: Math.abs(o - s),
            color: l
          };
        }, k.isReadable = function (t, e) {
          var n = k.readability(t, e);
          return n.brightness > 125 && n.color > 500;
        }, k.mostReadable = function (t, e) {
          for (var n = null, i = 0, r = !1, a = 0; a < e.length; a++) {
            var o = k.readability(t, e[a]),
              s = o.brightness > 125 && o.color > 500,
              l = o.brightness / 125 * 3 + o.color / 500;
            (s && !r || s && r && l > i || !s && !r && l > i) && (r = s, i = l, n = k(e[a]));
          }
          return n;
        };
        var W = k.names = {
            aliceblue: "f0f8ff",
            antiquewhite: "faebd7",
            aqua: "0ff",
            aquamarine: "7fffd4",
            azure: "f0ffff",
            beige: "f5f5dc",
            bisque: "ffe4c4",
            black: "000",
            blanchedalmond: "ffebcd",
            blue: "00f",
            blueviolet: "8a2be2",
            brown: "a52a2a",
            burlywood: "deb887",
            burntsienna: "ea7e5d",
            cadetblue: "5f9ea0",
            chartreuse: "7fff00",
            chocolate: "d2691e",
            coral: "ff7f50",
            cornflowerblue: "6495ed",
            cornsilk: "fff8dc",
            crimson: "dc143c",
            cyan: "0ff",
            darkblue: "00008b",
            darkcyan: "008b8b",
            darkgoldenrod: "b8860b",
            darkgray: "a9a9a9",
            darkgreen: "006400",
            darkgrey: "a9a9a9",
            darkkhaki: "bdb76b",
            darkmagenta: "8b008b",
            darkolivegreen: "556b2f",
            darkorange: "ff8c00",
            darkorchid: "9932cc",
            darkred: "8b0000",
            darksalmon: "e9967a",
            darkseagreen: "8fbc8f",
            darkslateblue: "483d8b",
            darkslategray: "2f4f4f",
            darkslategrey: "2f4f4f",
            darkturquoise: "00ced1",
            darkviolet: "9400d3",
            deeppink: "ff1493",
            deepskyblue: "00bfff",
            dimgray: "696969",
            dimgrey: "696969",
            dodgerblue: "1e90ff",
            firebrick: "b22222",
            floralwhite: "fffaf0",
            forestgreen: "228b22",
            fuchsia: "f0f",
            gainsboro: "dcdcdc",
            ghostwhite: "f8f8ff",
            gold: "ffd700",
            goldenrod: "daa520",
            gray: "808080",
            green: "008000",
            greenyellow: "adff2f",
            grey: "808080",
            honeydew: "f0fff0",
            hotpink: "ff69b4",
            indianred: "cd5c5c",
            indigo: "4b0082",
            ivory: "fffff0",
            khaki: "f0e68c",
            lavender: "e6e6fa",
            lavenderblush: "fff0f5",
            lawngreen: "7cfc00",
            lemonchiffon: "fffacd",
            lightblue: "add8e6",
            lightcoral: "f08080",
            lightcyan: "e0ffff",
            lightgoldenrodyellow: "fafad2",
            lightgray: "d3d3d3",
            lightgreen: "90ee90",
            lightgrey: "d3d3d3",
            lightpink: "ffb6c1",
            lightsalmon: "ffa07a",
            lightseagreen: "20b2aa",
            lightskyblue: "87cefa",
            lightslategray: "789",
            lightslategrey: "789",
            lightsteelblue: "b0c4de",
            lightyellow: "ffffe0",
            lime: "0f0",
            limegreen: "32cd32",
            linen: "faf0e6",
            magenta: "f0f",
            maroon: "800000",
            mediumaquamarine: "66cdaa",
            mediumblue: "0000cd",
            mediumorchid: "ba55d3",
            mediumpurple: "9370db",
            mediumseagreen: "3cb371",
            mediumslateblue: "7b68ee",
            mediumspringgreen: "00fa9a",
            mediumturquoise: "48d1cc",
            mediumvioletred: "c71585",
            midnightblue: "191970",
            mintcream: "f5fffa",
            mistyrose: "ffe4e1",
            moccasin: "ffe4b5",
            navajowhite: "ffdead",
            navy: "000080",
            oldlace: "fdf5e6",
            olive: "808000",
            olivedrab: "6b8e23",
            orange: "ffa500",
            orangered: "ff4500",
            orchid: "da70d6",
            palegoldenrod: "eee8aa",
            palegreen: "98fb98",
            paleturquoise: "afeeee",
            palevioletred: "db7093",
            papayawhip: "ffefd5",
            peachpuff: "ffdab9",
            peru: "cd853f",
            pink: "ffc0cb",
            plum: "dda0dd",
            powderblue: "b0e0e6",
            purple: "800080",
            rebeccapurple: "663399",
            red: "f00",
            rosybrown: "bc8f8f",
            royalblue: "4169e1",
            saddlebrown: "8b4513",
            salmon: "fa8072",
            sandybrown: "f4a460",
            seagreen: "2e8b57",
            seashell: "fff5ee",
            sienna: "a0522d",
            silver: "c0c0c0",
            skyblue: "87ceeb",
            slateblue: "6a5acd",
            slategray: "708090",
            slategrey: "708090",
            snow: "fffafa",
            springgreen: "00ff7f",
            steelblue: "4682b4",
            tan: "d2b48c",
            teal: "008080",
            thistle: "d8bfd8",
            tomato: "ff6347",
            turquoise: "40e0d0",
            violet: "ee82ee",
            wheat: "f5deb3",
            white: "fff",
            whitesmoke: "f5f5f5",
            yellow: "ff0",
            yellowgreen: "9acd32"
          },
          Y = k.hexNames = function (t) {
            var e = {};
            for (var n in t) t.hasOwnProperty(n) && (e[t[n]] = n);
            return e;
          }(W);
        function U(t) {
          return t = parseFloat(t), (isNaN(t) || t < 0 || t > 1) && (t = 1), t;
        }
        function Z(t, e) {
          (function (t) {
            return "string" == typeof t && -1 != t.indexOf(".") && 1 === parseFloat(t);
          })(t) && (t = "100%");
          var n = function (t) {
            return "string" == typeof t && -1 != t.indexOf("%");
          }(t);
          return t = j(e, C(0, parseFloat(t))), n && (t = parseInt(t * e, 10) / 100), w.abs(t - e) < 1e-6 ? 1 : t % e / parseFloat(e);
        }
        function G(t) {
          return j(1, C(0, t));
        }
        function q(t) {
          return parseInt(t, 16);
        }
        function $(t) {
          return 1 == t.length ? "0" + t : "" + t;
        }
        function Q(t) {
          return t <= 1 && (t = 100 * t + "%"), t;
        }
        var J,
          X,
          K,
          tt = (X = "[\\s|\\(]+(" + (J = "(?:[-\\+]?\\d*\\.\\d+%?)|(?:[-\\+]?\\d+%?)") + ")[,|\\s]+(" + J + ")[,|\\s]+(" + J + ")\\s*\\)?", K = "[\\s|\\(]+(" + J + ")[,|\\s]+(" + J + ")[,|\\s]+(" + J + ")[,|\\s]+(" + J + ")\\s*\\)?", {
            rgb: new RegExp("rgb" + X),
            rgba: new RegExp("rgba" + K),
            hsl: new RegExp("hsl" + X),
            hsla: new RegExp("hsla" + K),
            hsv: new RegExp("hsv" + X),
            hsva: new RegExp("hsva" + K),
            hex3: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex6: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            hex8: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
          });
        window.tinycolor = k, t(function () {
          t.fn.spectrum.load && t.fn.spectrum.processNativeColorInputs();
        });
      }(p), e.a = d.a.extend({
        template: function template() {
          var t = this.ppfx;
          return '\n      <div class="'.concat(this.holderClass(), '"></div>\n      <div class="').concat(t, 'field-colorp">\n        <div class="').concat(t, 'field-colorp-c" data-colorp-c>\n          <div class="').concat(t, 'checker-bg"></div>\n        </div>\n      </div>\n    ');
        },
        inputClass: function inputClass() {
          var t = this.ppfx;
          return "".concat(t, "field ").concat(t, "field-color");
        },
        holderClass: function holderClass() {
          return "".concat(this.ppfx, "input-holder");
        },
        setValue: function setValue(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = this.model,
            i = n.get("defaults"),
            r = Object(s.isUndefined)(t) ? Object(s.isUndefined)(i) ? "" : i : t,
            a = this.getInputEl(),
            o = this.getColorEl(),
            l = "none" != r ? r : "";
          a.value = r, o.get(0).style.backgroundColor = l, (e.fromTarget || e.fromInput && !e.avoidStore) && (o.spectrum("set", l), this.noneColor = "none" == r);
        },
        getColorEl: function getColorEl() {
          if (!this.colorEl) {
            var t,
              e = this.em,
              n = this,
              i = this.ppfx,
              r = this.model,
              a = p('<div class="'.concat(this.ppfx, 'field-color-picker"></div>')),
              o = a.get(0).style,
              s = e && e.config ? e.config.el : "",
              l = e && e.getConfig && e.getConfig("colorPicker") || {},
              c = function c(t) {
                return (1 == t.getAlpha() ? t.toHexString() : t.toRgbString()).replace(/ /g, "");
              },
              d = 0;
            this.$el.find("[data-colorp-c]").append(a), a.spectrum(h(h(h({
              containerClassName: "".concat(i, "one-bg ").concat(i, "two-color"),
              appendTo: s || "body",
              maxSelectionSize: 8,
              showPalette: !0,
              showAlpha: !0,
              chooseText: "Ok",
              cancelText: "⨯",
              palette: []
            }, l), r.get("colorPicker") || {}), {}, {
              move: function move(t) {
                var e = c(t);
                o.backgroundColor = e, r.setValueFromInput(e, 0);
              },
              change: function change(t) {
                d = 1;
                var e = c(t);
                o.backgroundColor = e, r.setValueFromInput(0, 0), r.setValueFromInput(e), n.noneColor = 0;
              },
              show: function show(e) {
                d = 0, t = c(e);
              },
              hide: function hide(e) {
                !d && t && (n.noneColor && (t = ""), o.backgroundColor = t, a.spectrum("set", t), r.setValueFromInput(t, 0));
              }
            })), e && e.on && e.on("component:selected", function () {
              d = 1, a.spectrum("hide");
            }), this.colorEl = a;
          }
          return this.colorEl;
        },
        render: function render() {
          return d.a.prototype.render.call(this), this.getColorEl(), this;
        }
      });
    }, function (t, e, n) {
      !function (e) {
        var n,
          i = {},
          r = {
            16: !1,
            18: !1,
            17: !1,
            91: !1
          },
          a = "all",
          o = {
            "⇧": 16,
            shift: 16,
            "⌥": 18,
            alt: 18,
            option: 18,
            "⌃": 17,
            ctrl: 17,
            control: 17,
            "⌘": 91,
            command: 91
          },
          s = {
            backspace: 8,
            tab: 9,
            clear: 12,
            enter: 13,
            return: 13,
            esc: 27,
            escape: 27,
            space: 32,
            left: 37,
            up: 38,
            right: 39,
            down: 40,
            del: 46,
            delete: 46,
            home: 36,
            end: 35,
            pageup: 33,
            pagedown: 34,
            ",": 188,
            ".": 190,
            "/": 191,
            "`": 192,
            "-": 189,
            "=": 187,
            ";": 186,
            "'": 222,
            "[": 219,
            "]": 221,
            "\\": 220
          },
          l = function l(t) {
            return s[t] || t.toUpperCase().charCodeAt(0);
          },
          c = [];
        for (n = 1; n < 20; n++) s["f" + n] = 111 + n;
        function d(t, e) {
          for (var n = t.length; n--;) if (t[n] === e) return n;
          return -1;
        }
        function u(t, e) {
          if (t.length != e.length) return !1;
          for (var n = 0; n < t.length; n++) if (t[n] !== e[n]) return !1;
          return !0;
        }
        var h = {
          16: "shiftKey",
          18: "altKey",
          17: "ctrlKey",
          91: "metaKey"
        };
        function p(t) {
          for (n in r) r[n] = t[h[n]];
        }
        function g(t, e, n) {
          var r, a;
          r = m(t), void 0 === n && (n = e, e = "all");
          for (var o = 0; o < r.length; o++) a = [], (t = r[o].split("+")).length > 1 && (a = v(t), t = [t[t.length - 1]]), t = t[0], (t = l(t)) in i || (i[t] = []), i[t].push({
            shortcut: r[o],
            scope: e,
            method: n,
            key: r[o],
            mods: a
          });
        }
        for (n in o) g[n] = !1;
        function f() {
          return a || "all";
        }
        function m(t) {
          var e;
          return "" == (e = (t = t.replace(/\s/g, "")).split(","))[e.length - 1] && (e[e.length - 2] += ","), e;
        }
        function v(t) {
          for (var e = t.slice(0, t.length - 1), n = 0; n < e.length; n++) e[n] = o[e[n]];
          return e;
        }
        function b(t, e, n) {
          t.addEventListener ? t.addEventListener(e, n, !1) : t.attachEvent && t.attachEvent("on" + e, function () {
            n(window.event);
          });
        }
        b(document, "keydown", function (t) {
          !function (t) {
            var e, n, a, s, l, u;
            if (e = t.keyCode, -1 == d(c, e) && c.push(e), 93 != e && 224 != e || (e = 91), e in r) for (a in r[e] = !0, o) o[a] == e && (g[a] = !0);else if (p(t), g.filter.call(this, t) && e in i) for (u = f(), s = 0; s < i[e].length; s++) if ((n = i[e][s]).scope == u || "all" == n.scope) {
              for (a in l = n.mods.length > 0, r) (!r[a] && d(n.mods, +a) > -1 || r[a] && -1 == d(n.mods, +a)) && (l = !1);
              (0 != n.mods.length || r[16] || r[18] || r[17] || r[91]) && !l || !1 === n.method(t, n) && (t.preventDefault ? t.preventDefault() : t.returnValue = !1, t.stopPropagation && t.stopPropagation(), t.cancelBubble && (t.cancelBubble = !0));
            }
          }(t);
        }), b(document, "keyup", function (t) {
          var e,
            n = t.keyCode,
            i = d(c, n);
          if (i >= 0 && c.splice(i, 1), 93 != n && 224 != n || (n = 91), n in r) for (e in r[n] = !1, o) o[e] == n && (g[e] = !1);
        }), b(window, "focus", function () {
          for (n in r) r[n] = !1;
          for (n in o) g[n] = !1;
        });
        var y = e.key;
        e.key = g, e.key.setScope = function (t) {
          a = t || "all";
        }, e.key.getScope = f, e.key.deleteScope = function (t) {
          var e, n, r;
          for (e in i) for (n = i[e], r = 0; r < n.length;) n[r].scope === t ? n.splice(r, 1) : r++;
        }, e.key.filter = function (t) {
          var e = (t.target || t.srcElement).tagName;
          return !("INPUT" == e || "SELECT" == e || "TEXTAREA" == e);
        }, e.key.isPressed = function (t) {
          return "string" == typeof t && (t = l(t)), -1 != d(c, t);
        }, e.key.getPressedKeyCodes = function () {
          return c.slice(0);
        }, e.key.noConflict = function () {
          var t = e.key;
          return e.key = y, t;
        }, e.key.unbind = function (t, e) {
          var n,
            r,
            a,
            o,
            s,
            c = [];
          for (n = m(t), o = 0; o < n.length; o++) {
            if ((r = n[o].split("+")).length > 1 && (c = v(r), t = r[r.length - 1]), t = l(t), void 0 === e && (e = f()), !i[t]) return;
            for (a = 0; a < i[t].length; a++) (s = i[t][a]).scope === e && u(s.mods, c) && (i[t][a] = {});
          }
        }, t.exports = g;
      }(this);
    }, function (t, e, n) {
      "use strict";

      (function (t) {
        var i = n(77),
          r = n(78),
          a = n(79),
          o = setTimeout;
        function s(t) {
          return Boolean(t && void 0 !== t.length);
        }
        function l() {}
        function c(t) {
          if (!(this instanceof c)) throw new TypeError("Promises must be constructed via new");
          if ("function" != typeof t) throw new TypeError("not a function");
          this._state = 0, this._handled = !1, this._value = void 0, this._deferreds = [], f(t, this);
        }
        function d(t, e) {
          for (; 3 === t._state;) t = t._value;
          0 !== t._state ? (t._handled = !0, c._immediateFn(function () {
            var n = 1 === t._state ? e.onFulfilled : e.onRejected;
            if (null !== n) {
              var i;
              try {
                i = n(t._value);
              } catch (t) {
                return void h(e.promise, t);
              }
              u(e.promise, i);
            } else (1 === t._state ? u : h)(e.promise, t._value);
          })) : t._deferreds.push(e);
        }
        function u(t, e) {
          try {
            if (e === t) throw new TypeError("A promise cannot be resolved with itself.");
            if (e && ("object" == typeof e || "function" == typeof e)) {
              var n = e.then;
              if (e instanceof c) return t._state = 3, t._value = e, void p(t);
              if ("function" == typeof n) return void f((i = n, r = e, function () {
                i.apply(r, arguments);
              }), t);
            }
            t._state = 1, t._value = e, p(t);
          } catch (e) {
            h(t, e);
          }
          var i, r;
        }
        function h(t, e) {
          t._state = 2, t._value = e, p(t);
        }
        function p(t) {
          2 === t._state && 0 === t._deferreds.length && c._immediateFn(function () {
            t._handled || c._unhandledRejectionFn(t._value);
          });
          for (var e = 0, n = t._deferreds.length; e < n; e++) d(t, t._deferreds[e]);
          t._deferreds = null;
        }
        function g(t, e, n) {
          this.onFulfilled = "function" == typeof t ? t : null, this.onRejected = "function" == typeof e ? e : null, this.promise = n;
        }
        function f(t, e) {
          var n = !1;
          try {
            t(function (t) {
              n || (n = !0, u(e, t));
            }, function (t) {
              n || (n = !0, h(e, t));
            });
          } catch (t) {
            if (n) return;
            n = !0, h(e, t);
          }
        }
        c.prototype.catch = function (t) {
          return this.then(null, t);
        }, c.prototype.then = function (t, e) {
          var n = new this.constructor(l);
          return d(this, new g(t, e, n)), n;
        }, c.prototype.finally = i.a, c.all = function (t) {
          return new c(function (e, n) {
            if (!s(t)) return n(new TypeError("Promise.all accepts an array"));
            var i = Array.prototype.slice.call(t);
            if (0 === i.length) return e([]);
            var r = i.length;
            function a(t, o) {
              try {
                if (o && ("object" == typeof o || "function" == typeof o)) {
                  var s = o.then;
                  if ("function" == typeof s) return void s.call(o, function (e) {
                    a(t, e);
                  }, n);
                }
                i[t] = o, 0 == --r && e(i);
              } catch (t) {
                n(t);
              }
            }
            for (var o = 0; o < i.length; o++) a(o, i[o]);
          });
        }, c.any = a.a, c.allSettled = r.a, c.resolve = function (t) {
          return t && "object" == typeof t && t.constructor === c ? t : new c(function (e) {
            e(t);
          });
        }, c.reject = function (t) {
          return new c(function (e, n) {
            n(t);
          });
        }, c.race = function (t) {
          return new c(function (e, n) {
            if (!s(t)) return n(new TypeError("Promise.race accepts an array"));
            for (var i = 0, r = t.length; i < r; i++) c.resolve(t[i]).then(e, n);
          });
        }, c._immediateFn = "function" == typeof t && function (e) {
          t(e);
        } || function (t) {
          o(t, 0);
        }, c._unhandledRejectionFn = function (t) {
          "undefined" != typeof console && console && console.warn("Possible Unhandled Promise Rejection:", t);
        }, e.a = c;
      }).call(this, n(87).setImmediate);
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(1),
        r = n.n(i),
        a = r.a.Model.extend({
          defaults: {
            id: "",
            label: "",
            tagName: "span",
            className: "",
            command: "",
            context: "",
            buttons: [],
            attributes: {},
            options: {},
            active: !1,
            dragDrop: !1,
            togglable: !0,
            runDefaultCommand: !0,
            stopDefaultCommand: !1,
            disable: !1
          },
          initialize: function initialize(t) {
            if (this.get("buttons").length) {
              var e = n(41).default;
              this.set("buttons", new e(this.get("buttons")));
            }
          }
        });
      e.default = r.a.Collection.extend({
        model: a,
        deactivateAllExceptOne: function deactivateAllExceptOne(t, e) {
          this.forEach(function (n, i) {
            n !== t && (n.set("active", !1), e && n.get("buttons").length && n.get("buttons").deactivateAllExceptOne(t, e));
          });
        },
        deactivateAll: function deactivateAll(t, e) {
          var n = t || "";
          this.forEach(function (t) {
            t.get("context") == n && t !== e && (t.set("active", !1, {
              silent: 1
            }), t.trigger("updateActive", {
              fromCollection: 1
            }));
          });
        },
        disableAllButtons: function disableAllButtons(t) {
          var e = t || "";
          this.forEach(function (t, n) {
            t.get("context") == e && t.set("disable", !0);
          });
        },
        disableAllButtonsExceptOne: function disableAllButtonsExceptOne(t, e) {
          this.forEach(function (n, i) {
            n !== t && (n.set("disable", !0), e && n.get("buttons").length && n.get("buttons").disableAllButtonsExceptOne(t, e));
          });
        }
      });
    }, function (t, e, n) {
      var i = n(8).default,
        r = n(81);
      t.exports = function (t) {
        var e = r(t, "string");
        return "symbol" == i(e) ? e : String(e);
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e) {
      t.exports = function (t, e) {
        (null == e || e > t.length) && (e = t.length);
        for (var n = 0, i = new Array(e); n < e; n++) i[n] = t[n];
        return i;
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e, n) {
      var i = n(43);
      t.exports = function (t, e) {
        if (t) {
          if ("string" == typeof t) return i(t, e);
          var n = Object.prototype.toString.call(t).slice(8, -1);
          return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? i(t, e) : void 0;
        }
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e, n) {
      !function (t) {
        "use strict";

        function e(t) {
          for (var e = {}, n = 0; n < t.length; ++n) e[t[n].toLowerCase()] = !0;
          return e;
        }
        t.defineMode("css", function (e, n) {
          var i = n.inline;
          n.propertyKeywords || (n = t.resolveMode("text/css"));
          var r,
            a,
            o = e.indentUnit,
            s = n.tokenHooks,
            l = n.documentTypes || {},
            c = n.mediaTypes || {},
            d = n.mediaFeatures || {},
            u = n.mediaValueKeywords || {},
            h = n.propertyKeywords || {},
            p = n.nonStandardPropertyKeywords || {},
            g = n.fontProperties || {},
            f = n.counterDescriptors || {},
            m = n.colorKeywords || {},
            v = n.valueKeywords || {},
            b = n.allowNested,
            y = n.lineComment,
            w = !0 === n.supportsAtComponent,
            x = !1 !== e.highlightNonStandardPropertyKeywords;
          function j(t, e) {
            return r = e, t;
          }
          function C(t, e) {
            var n = t.next();
            if (s[n]) {
              var i = s[n](t, e);
              if (!1 !== i) return i;
            }
            return "@" == n ? (t.eatWhile(/[\w\\\-]/), j("def", t.current())) : "=" == n || ("~" == n || "|" == n) && t.eat("=") ? j(null, "compare") : '"' == n || "'" == n ? (e.tokenize = M(n), e.tokenize(t, e)) : "#" == n ? (t.eatWhile(/[\w\\\-]/), j("atom", "hash")) : "!" == n ? (t.match(/^\s*\w*/), j("keyword", "important")) : /\d/.test(n) || "." == n && t.eat(/\d/) ? (t.eatWhile(/[\w.%]/), j("number", "unit")) : "-" !== n ? /[,+>*\/]/.test(n) ? j(null, "select-op") : "." == n && t.match(/^-?[_a-z][_a-z0-9-]*/i) ? j("qualifier", "qualifier") : /[:;{}\[\]\(\)]/.test(n) ? j(null, n) : t.match(/^[\w-.]+(?=\()/) ? (/^(url(-prefix)?|domain|regexp)$/i.test(t.current()) && (e.tokenize = k), j("variable callee", "variable")) : /[\w\\\-]/.test(n) ? (t.eatWhile(/[\w\\\-]/), j("property", "word")) : j(null, null) : /[\d.]/.test(t.peek()) ? (t.eatWhile(/[\w.%]/), j("number", "unit")) : t.match(/^-[\w\\\-]*/) ? (t.eatWhile(/[\w\\\-]/), t.match(/^\s*:/, !1) ? j("variable-2", "variable-definition") : j("variable-2", "variable")) : t.match(/^\w+-/) ? j("meta", "meta") : void 0;
          }
          function M(t) {
            return function (e, n) {
              for (var i, r = !1; null != (i = e.next());) {
                if (i == t && !r) {
                  ")" == t && e.backUp(1);
                  break;
                }
                r = !r && "\\" == i;
              }
              return (i == t || !r && ")" != t) && (n.tokenize = null), j("string", "string");
            };
          }
          function k(t, e) {
            return t.next(), t.match(/^\s*[\"\')]/, !1) ? e.tokenize = null : e.tokenize = M(")"), j(null, "(");
          }
          function O(t, e, n) {
            this.type = t, this.indent = e, this.prev = n;
          }
          function T(t, e, n, i) {
            return t.context = new O(n, e.indentation() + (!1 === i ? 0 : o), t.context), n;
          }
          function S(t) {
            return t.context.prev && (t.context = t.context.prev), t.context.type;
          }
          function N(t, e, n) {
            return E[n.context.type](t, e, n);
          }
          function L(t, e, n, i) {
            for (var r = i || 1; r > 0; r--) n.context = n.context.prev;
            return N(t, e, n);
          }
          function D(t) {
            var e = t.current().toLowerCase();
            a = v.hasOwnProperty(e) ? "atom" : m.hasOwnProperty(e) ? "keyword" : "variable";
          }
          var E = {
            top: function top(t, e, n) {
              if ("{" == t) return T(n, e, "block");
              if ("}" == t && n.context.prev) return S(n);
              if (w && /@component/i.test(t)) return T(n, e, "atComponentBlock");
              if (/^@(-moz-)?document$/i.test(t)) return T(n, e, "documentTypes");
              if (/^@(media|supports|(-moz-)?document|import)$/i.test(t)) return T(n, e, "atBlock");
              if (/^@(font-face|counter-style)/i.test(t)) return n.stateArg = t, "restricted_atBlock_before";
              if (/^@(-(moz|ms|o|webkit)-)?keyframes$/i.test(t)) return "keyframes";
              if (t && "@" == t.charAt(0)) return T(n, e, "at");
              if ("hash" == t) a = "builtin";else if ("word" == t) a = "tag";else {
                if ("variable-definition" == t) return "maybeprop";
                if ("interpolation" == t) return T(n, e, "interpolation");
                if (":" == t) return "pseudo";
                if (b && "(" == t) return T(n, e, "parens");
              }
              return n.context.type;
            },
            block: function block(t, e, n) {
              if ("word" == t) {
                var i = e.current().toLowerCase();
                return h.hasOwnProperty(i) ? (a = "property", "maybeprop") : p.hasOwnProperty(i) ? (a = x ? "string-2" : "property", "maybeprop") : b ? (a = e.match(/^\s*:(?:\s|$)/, !1) ? "property" : "tag", "block") : (a += " error", "maybeprop");
              }
              return "meta" == t ? "block" : b || "hash" != t && "qualifier" != t ? E.top(t, e, n) : (a = "error", "block");
            },
            maybeprop: function maybeprop(t, e, n) {
              return ":" == t ? T(n, e, "prop") : N(t, e, n);
            },
            prop: function prop(t, e, n) {
              if (";" == t) return S(n);
              if ("{" == t && b) return T(n, e, "propBlock");
              if ("}" == t || "{" == t) return L(t, e, n);
              if ("(" == t) return T(n, e, "parens");
              if ("hash" != t || /^#([0-9a-fA-F]{3,4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(e.current())) {
                if ("word" == t) D(e);else if ("interpolation" == t) return T(n, e, "interpolation");
              } else a += " error";
              return "prop";
            },
            propBlock: function propBlock(t, e, n) {
              return "}" == t ? S(n) : "word" == t ? (a = "property", "maybeprop") : n.context.type;
            },
            parens: function parens(t, e, n) {
              return "{" == t || "}" == t ? L(t, e, n) : ")" == t ? S(n) : "(" == t ? T(n, e, "parens") : "interpolation" == t ? T(n, e, "interpolation") : ("word" == t && D(e), "parens");
            },
            pseudo: function pseudo(t, e, n) {
              return "meta" == t ? "pseudo" : "word" == t ? (a = "variable-3", n.context.type) : N(t, e, n);
            },
            documentTypes: function documentTypes(t, e, n) {
              return "word" == t && l.hasOwnProperty(e.current()) ? (a = "tag", n.context.type) : E.atBlock(t, e, n);
            },
            atBlock: function atBlock(t, e, n) {
              if ("(" == t) return T(n, e, "atBlock_parens");
              if ("}" == t || ";" == t) return L(t, e, n);
              if ("{" == t) return S(n) && T(n, e, b ? "block" : "top");
              if ("interpolation" == t) return T(n, e, "interpolation");
              if ("word" == t) {
                var i = e.current().toLowerCase();
                a = "only" == i || "not" == i || "and" == i || "or" == i ? "keyword" : c.hasOwnProperty(i) ? "attribute" : d.hasOwnProperty(i) ? "property" : u.hasOwnProperty(i) ? "keyword" : h.hasOwnProperty(i) ? "property" : p.hasOwnProperty(i) ? x ? "string-2" : "property" : v.hasOwnProperty(i) ? "atom" : m.hasOwnProperty(i) ? "keyword" : "error";
              }
              return n.context.type;
            },
            atComponentBlock: function atComponentBlock(t, e, n) {
              return "}" == t ? L(t, e, n) : "{" == t ? S(n) && T(n, e, b ? "block" : "top", !1) : ("word" == t && (a = "error"), n.context.type);
            },
            atBlock_parens: function atBlock_parens(t, e, n) {
              return ")" == t ? S(n) : "{" == t || "}" == t ? L(t, e, n, 2) : E.atBlock(t, e, n);
            },
            restricted_atBlock_before: function restricted_atBlock_before(t, e, n) {
              return "{" == t ? T(n, e, "restricted_atBlock") : "word" == t && "@counter-style" == n.stateArg ? (a = "variable", "restricted_atBlock_before") : N(t, e, n);
            },
            restricted_atBlock: function restricted_atBlock(t, e, n) {
              return "}" == t ? (n.stateArg = null, S(n)) : "word" == t ? (a = "@font-face" == n.stateArg && !g.hasOwnProperty(e.current().toLowerCase()) || "@counter-style" == n.stateArg && !f.hasOwnProperty(e.current().toLowerCase()) ? "error" : "property", "maybeprop") : "restricted_atBlock";
            },
            keyframes: function keyframes(t, e, n) {
              return "word" == t ? (a = "variable", "keyframes") : "{" == t ? T(n, e, "top") : N(t, e, n);
            },
            at: function at(t, e, n) {
              return ";" == t ? S(n) : "{" == t || "}" == t ? L(t, e, n) : ("word" == t ? a = "tag" : "hash" == t && (a = "builtin"), "at");
            },
            interpolation: function interpolation(t, e, n) {
              return "}" == t ? S(n) : "{" == t || ";" == t ? L(t, e, n) : ("word" == t ? a = "variable" : "variable" != t && "(" != t && ")" != t && (a = "error"), "interpolation");
            }
          };
          return {
            startState: function startState(t) {
              return {
                tokenize: null,
                state: i ? "block" : "top",
                stateArg: null,
                context: new O(i ? "block" : "top", t || 0, null)
              };
            },
            token: function token(t, e) {
              if (!e.tokenize && t.eatSpace()) return null;
              var n = (e.tokenize || C)(t, e);
              return n && "object" == typeof n && (r = n[1], n = n[0]), a = n, "comment" != r && (e.state = E[e.state](r, t, e)), a;
            },
            indent: function indent(t, e) {
              var n = t.context,
                i = e && e.charAt(0),
                r = n.indent;
              return "prop" != n.type || "}" != i && ")" != i || (n = n.prev), n.prev && ("}" != i || "block" != n.type && "top" != n.type && "interpolation" != n.type && "restricted_atBlock" != n.type ? (")" != i || "parens" != n.type && "atBlock_parens" != n.type) && ("{" != i || "at" != n.type && "atBlock" != n.type) || (r = Math.max(0, n.indent - o)) : r = (n = n.prev).indent), r;
            },
            electricChars: "}",
            blockCommentStart: "/*",
            blockCommentEnd: "*/",
            blockCommentContinue: " * ",
            lineComment: y,
            fold: "brace"
          };
        });
        var n = ["domain", "regexp", "url", "url-prefix"],
          i = e(n),
          r = ["all", "aural", "braille", "handheld", "print", "projection", "screen", "tty", "tv", "embossed"],
          a = e(r),
          o = ["width", "min-width", "max-width", "height", "min-height", "max-height", "device-width", "min-device-width", "max-device-width", "device-height", "min-device-height", "max-device-height", "aspect-ratio", "min-aspect-ratio", "max-aspect-ratio", "device-aspect-ratio", "min-device-aspect-ratio", "max-device-aspect-ratio", "color", "min-color", "max-color", "color-index", "min-color-index", "max-color-index", "monochrome", "min-monochrome", "max-monochrome", "resolution", "min-resolution", "max-resolution", "scan", "grid", "orientation", "device-pixel-ratio", "min-device-pixel-ratio", "max-device-pixel-ratio", "pointer", "any-pointer", "hover", "any-hover", "prefers-color-scheme", "dynamic-range", "video-dynamic-range"],
          s = e(o),
          l = ["landscape", "portrait", "none", "coarse", "fine", "on-demand", "hover", "interlace", "progressive", "dark", "light", "standard", "high"],
          c = e(l),
          d = ["align-content", "align-items", "align-self", "alignment-adjust", "alignment-baseline", "all", "anchor-point", "animation", "animation-delay", "animation-direction", "animation-duration", "animation-fill-mode", "animation-iteration-count", "animation-name", "animation-play-state", "animation-timing-function", "appearance", "azimuth", "backdrop-filter", "backface-visibility", "background", "background-attachment", "background-blend-mode", "background-clip", "background-color", "background-image", "background-origin", "background-position", "background-position-x", "background-position-y", "background-repeat", "background-size", "baseline-shift", "binding", "bleed", "block-size", "bookmark-label", "bookmark-level", "bookmark-state", "bookmark-target", "border", "border-bottom", "border-bottom-color", "border-bottom-left-radius", "border-bottom-right-radius", "border-bottom-style", "border-bottom-width", "border-collapse", "border-color", "border-image", "border-image-outset", "border-image-repeat", "border-image-slice", "border-image-source", "border-image-width", "border-left", "border-left-color", "border-left-style", "border-left-width", "border-radius", "border-right", "border-right-color", "border-right-style", "border-right-width", "border-spacing", "border-style", "border-top", "border-top-color", "border-top-left-radius", "border-top-right-radius", "border-top-style", "border-top-width", "border-width", "bottom", "box-decoration-break", "box-shadow", "box-sizing", "break-after", "break-before", "break-inside", "caption-side", "caret-color", "clear", "clip", "color", "color-profile", "column-count", "column-fill", "column-gap", "column-rule", "column-rule-color", "column-rule-style", "column-rule-width", "column-span", "column-width", "columns", "contain", "content", "counter-increment", "counter-reset", "crop", "cue", "cue-after", "cue-before", "cursor", "direction", "display", "dominant-baseline", "drop-initial-after-adjust", "drop-initial-after-align", "drop-initial-before-adjust", "drop-initial-before-align", "drop-initial-size", "drop-initial-value", "elevation", "empty-cells", "fit", "fit-content", "fit-position", "flex", "flex-basis", "flex-direction", "flex-flow", "flex-grow", "flex-shrink", "flex-wrap", "float", "float-offset", "flow-from", "flow-into", "font", "font-family", "font-feature-settings", "font-kerning", "font-language-override", "font-optical-sizing", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-synthesis", "font-variant", "font-variant-alternates", "font-variant-caps", "font-variant-east-asian", "font-variant-ligatures", "font-variant-numeric", "font-variant-position", "font-variation-settings", "font-weight", "gap", "grid", "grid-area", "grid-auto-columns", "grid-auto-flow", "grid-auto-rows", "grid-column", "grid-column-end", "grid-column-gap", "grid-column-start", "grid-gap", "grid-row", "grid-row-end", "grid-row-gap", "grid-row-start", "grid-template", "grid-template-areas", "grid-template-columns", "grid-template-rows", "hanging-punctuation", "height", "hyphens", "icon", "image-orientation", "image-rendering", "image-resolution", "inline-box-align", "inset", "inset-block", "inset-block-end", "inset-block-start", "inset-inline", "inset-inline-end", "inset-inline-start", "isolation", "justify-content", "justify-items", "justify-self", "left", "letter-spacing", "line-break", "line-height", "line-height-step", "line-stacking", "line-stacking-ruby", "line-stacking-shift", "line-stacking-strategy", "list-style", "list-style-image", "list-style-position", "list-style-type", "margin", "margin-bottom", "margin-left", "margin-right", "margin-top", "marks", "marquee-direction", "marquee-loop", "marquee-play-count", "marquee-speed", "marquee-style", "mask-clip", "mask-composite", "mask-image", "mask-mode", "mask-origin", "mask-position", "mask-repeat", "mask-size", "mask-type", "max-block-size", "max-height", "max-inline-size", "max-width", "min-block-size", "min-height", "min-inline-size", "min-width", "mix-blend-mode", "move-to", "nav-down", "nav-index", "nav-left", "nav-right", "nav-up", "object-fit", "object-position", "offset", "offset-anchor", "offset-distance", "offset-path", "offset-position", "offset-rotate", "opacity", "order", "orphans", "outline", "outline-color", "outline-offset", "outline-style", "outline-width", "overflow", "overflow-style", "overflow-wrap", "overflow-x", "overflow-y", "padding", "padding-bottom", "padding-left", "padding-right", "padding-top", "page", "page-break-after", "page-break-before", "page-break-inside", "page-policy", "pause", "pause-after", "pause-before", "perspective", "perspective-origin", "pitch", "pitch-range", "place-content", "place-items", "place-self", "play-during", "position", "presentation-level", "punctuation-trim", "quotes", "region-break-after", "region-break-before", "region-break-inside", "region-fragment", "rendering-intent", "resize", "rest", "rest-after", "rest-before", "richness", "right", "rotate", "rotation", "rotation-point", "row-gap", "ruby-align", "ruby-overhang", "ruby-position", "ruby-span", "scale", "scroll-behavior", "scroll-margin", "scroll-margin-block", "scroll-margin-block-end", "scroll-margin-block-start", "scroll-margin-bottom", "scroll-margin-inline", "scroll-margin-inline-end", "scroll-margin-inline-start", "scroll-margin-left", "scroll-margin-right", "scroll-margin-top", "scroll-padding", "scroll-padding-block", "scroll-padding-block-end", "scroll-padding-block-start", "scroll-padding-bottom", "scroll-padding-inline", "scroll-padding-inline-end", "scroll-padding-inline-start", "scroll-padding-left", "scroll-padding-right", "scroll-padding-top", "scroll-snap-align", "scroll-snap-type", "shape-image-threshold", "shape-inside", "shape-margin", "shape-outside", "size", "speak", "speak-as", "speak-header", "speak-numeral", "speak-punctuation", "speech-rate", "stress", "string-set", "tab-size", "table-layout", "target", "target-name", "target-new", "target-position", "text-align", "text-align-last", "text-combine-upright", "text-decoration", "text-decoration-color", "text-decoration-line", "text-decoration-skip", "text-decoration-skip-ink", "text-decoration-style", "text-emphasis", "text-emphasis-color", "text-emphasis-position", "text-emphasis-style", "text-height", "text-indent", "text-justify", "text-orientation", "text-outline", "text-overflow", "text-rendering", "text-shadow", "text-size-adjust", "text-space-collapse", "text-transform", "text-underline-position", "text-wrap", "top", "touch-action", "transform", "transform-origin", "transform-style", "transition", "transition-delay", "transition-duration", "transition-property", "transition-timing-function", "translate", "unicode-bidi", "user-select", "vertical-align", "visibility", "voice-balance", "voice-duration", "voice-family", "voice-pitch", "voice-range", "voice-rate", "voice-stress", "voice-volume", "volume", "white-space", "widows", "width", "will-change", "word-break", "word-spacing", "word-wrap", "writing-mode", "z-index", "clip-path", "clip-rule", "mask", "enable-background", "filter", "flood-color", "flood-opacity", "lighting-color", "stop-color", "stop-opacity", "pointer-events", "color-interpolation", "color-interpolation-filters", "color-rendering", "fill", "fill-opacity", "fill-rule", "image-rendering", "marker", "marker-end", "marker-mid", "marker-start", "paint-order", "shape-rendering", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "text-rendering", "baseline-shift", "dominant-baseline", "glyph-orientation-horizontal", "glyph-orientation-vertical", "text-anchor", "writing-mode"],
          u = e(d),
          h = ["accent-color", "aspect-ratio", "border-block", "border-block-color", "border-block-end", "border-block-end-color", "border-block-end-style", "border-block-end-width", "border-block-start", "border-block-start-color", "border-block-start-style", "border-block-start-width", "border-block-style", "border-block-width", "border-inline", "border-inline-color", "border-inline-end", "border-inline-end-color", "border-inline-end-style", "border-inline-end-width", "border-inline-start", "border-inline-start-color", "border-inline-start-style", "border-inline-start-width", "border-inline-style", "border-inline-width", "content-visibility", "margin-block", "margin-block-end", "margin-block-start", "margin-inline", "margin-inline-end", "margin-inline-start", "overflow-anchor", "overscroll-behavior", "padding-block", "padding-block-end", "padding-block-start", "padding-inline", "padding-inline-end", "padding-inline-start", "scroll-snap-stop", "scrollbar-3d-light-color", "scrollbar-arrow-color", "scrollbar-base-color", "scrollbar-dark-shadow-color", "scrollbar-face-color", "scrollbar-highlight-color", "scrollbar-shadow-color", "scrollbar-track-color", "searchfield-cancel-button", "searchfield-decoration", "searchfield-results-button", "searchfield-results-decoration", "shape-inside", "zoom"],
          p = e(h),
          g = e(["font-display", "font-family", "src", "unicode-range", "font-variant", "font-feature-settings", "font-stretch", "font-weight", "font-style"]),
          f = e(["additive-symbols", "fallback", "negative", "pad", "prefix", "range", "speak-as", "suffix", "symbols", "system"]),
          m = ["aliceblue", "antiquewhite", "aqua", "aquamarine", "azure", "beige", "bisque", "black", "blanchedalmond", "blue", "blueviolet", "brown", "burlywood", "cadetblue", "chartreuse", "chocolate", "coral", "cornflowerblue", "cornsilk", "crimson", "cyan", "darkblue", "darkcyan", "darkgoldenrod", "darkgray", "darkgreen", "darkgrey", "darkkhaki", "darkmagenta", "darkolivegreen", "darkorange", "darkorchid", "darkred", "darksalmon", "darkseagreen", "darkslateblue", "darkslategray", "darkslategrey", "darkturquoise", "darkviolet", "deeppink", "deepskyblue", "dimgray", "dimgrey", "dodgerblue", "firebrick", "floralwhite", "forestgreen", "fuchsia", "gainsboro", "ghostwhite", "gold", "goldenrod", "gray", "grey", "green", "greenyellow", "honeydew", "hotpink", "indianred", "indigo", "ivory", "khaki", "lavender", "lavenderblush", "lawngreen", "lemonchiffon", "lightblue", "lightcoral", "lightcyan", "lightgoldenrodyellow", "lightgray", "lightgreen", "lightgrey", "lightpink", "lightsalmon", "lightseagreen", "lightskyblue", "lightslategray", "lightslategrey", "lightsteelblue", "lightyellow", "lime", "limegreen", "linen", "magenta", "maroon", "mediumaquamarine", "mediumblue", "mediumorchid", "mediumpurple", "mediumseagreen", "mediumslateblue", "mediumspringgreen", "mediumturquoise", "mediumvioletred", "midnightblue", "mintcream", "mistyrose", "moccasin", "navajowhite", "navy", "oldlace", "olive", "olivedrab", "orange", "orangered", "orchid", "palegoldenrod", "palegreen", "paleturquoise", "palevioletred", "papayawhip", "peachpuff", "peru", "pink", "plum", "powderblue", "purple", "rebeccapurple", "red", "rosybrown", "royalblue", "saddlebrown", "salmon", "sandybrown", "seagreen", "seashell", "sienna", "silver", "skyblue", "slateblue", "slategray", "slategrey", "snow", "springgreen", "steelblue", "tan", "teal", "thistle", "tomato", "turquoise", "violet", "wheat", "white", "whitesmoke", "yellow", "yellowgreen"],
          v = e(m),
          b = ["above", "absolute", "activeborder", "additive", "activecaption", "afar", "after-white-space", "ahead", "alias", "all", "all-scroll", "alphabetic", "alternate", "always", "amharic", "amharic-abegede", "antialiased", "appworkspace", "arabic-indic", "armenian", "asterisks", "attr", "auto", "auto-flow", "avoid", "avoid-column", "avoid-page", "avoid-region", "axis-pan", "background", "backwards", "baseline", "below", "bidi-override", "binary", "bengali", "blink", "block", "block-axis", "blur", "bold", "bolder", "border", "border-box", "both", "bottom", "break", "break-all", "break-word", "brightness", "bullets", "button", "buttonface", "buttonhighlight", "buttonshadow", "buttontext", "calc", "cambodian", "capitalize", "caps-lock-indicator", "caption", "captiontext", "caret", "cell", "center", "checkbox", "circle", "cjk-decimal", "cjk-earthly-branch", "cjk-heavenly-stem", "cjk-ideographic", "clear", "clip", "close-quote", "col-resize", "collapse", "color", "color-burn", "color-dodge", "column", "column-reverse", "compact", "condensed", "conic-gradient", "contain", "content", "contents", "content-box", "context-menu", "continuous", "contrast", "copy", "counter", "counters", "cover", "crop", "cross", "crosshair", "cubic-bezier", "currentcolor", "cursive", "cyclic", "darken", "dashed", "decimal", "decimal-leading-zero", "default", "default-button", "dense", "destination-atop", "destination-in", "destination-out", "destination-over", "devanagari", "difference", "disc", "discard", "disclosure-closed", "disclosure-open", "document", "dot-dash", "dot-dot-dash", "dotted", "double", "down", "drop-shadow", "e-resize", "ease", "ease-in", "ease-in-out", "ease-out", "element", "ellipse", "ellipsis", "embed", "end", "ethiopic", "ethiopic-abegede", "ethiopic-abegede-am-et", "ethiopic-abegede-gez", "ethiopic-abegede-ti-er", "ethiopic-abegede-ti-et", "ethiopic-halehame-aa-er", "ethiopic-halehame-aa-et", "ethiopic-halehame-am-et", "ethiopic-halehame-gez", "ethiopic-halehame-om-et", "ethiopic-halehame-sid-et", "ethiopic-halehame-so-et", "ethiopic-halehame-ti-er", "ethiopic-halehame-ti-et", "ethiopic-halehame-tig", "ethiopic-numeric", "ew-resize", "exclusion", "expanded", "extends", "extra-condensed", "extra-expanded", "fantasy", "fast", "fill", "fill-box", "fixed", "flat", "flex", "flex-end", "flex-start", "footnotes", "forwards", "from", "geometricPrecision", "georgian", "grayscale", "graytext", "grid", "groove", "gujarati", "gurmukhi", "hand", "hangul", "hangul-consonant", "hard-light", "hebrew", "help", "hidden", "hide", "higher", "highlight", "highlighttext", "hiragana", "hiragana-iroha", "horizontal", "hsl", "hsla", "hue", "hue-rotate", "icon", "ignore", "inactiveborder", "inactivecaption", "inactivecaptiontext", "infinite", "infobackground", "infotext", "inherit", "initial", "inline", "inline-axis", "inline-block", "inline-flex", "inline-grid", "inline-table", "inset", "inside", "intrinsic", "invert", "italic", "japanese-formal", "japanese-informal", "justify", "kannada", "katakana", "katakana-iroha", "keep-all", "khmer", "korean-hangul-formal", "korean-hanja-formal", "korean-hanja-informal", "landscape", "lao", "large", "larger", "left", "level", "lighter", "lighten", "line-through", "linear", "linear-gradient", "lines", "list-item", "listbox", "listitem", "local", "logical", "loud", "lower", "lower-alpha", "lower-armenian", "lower-greek", "lower-hexadecimal", "lower-latin", "lower-norwegian", "lower-roman", "lowercase", "ltr", "luminosity", "malayalam", "manipulation", "match", "matrix", "matrix3d", "media-play-button", "media-slider", "media-sliderthumb", "media-volume-slider", "media-volume-sliderthumb", "medium", "menu", "menulist", "menulist-button", "menutext", "message-box", "middle", "min-intrinsic", "mix", "mongolian", "monospace", "move", "multiple", "multiple_mask_images", "multiply", "myanmar", "n-resize", "narrower", "ne-resize", "nesw-resize", "no-close-quote", "no-drop", "no-open-quote", "no-repeat", "none", "normal", "not-allowed", "nowrap", "ns-resize", "numbers", "numeric", "nw-resize", "nwse-resize", "oblique", "octal", "opacity", "open-quote", "optimizeLegibility", "optimizeSpeed", "oriya", "oromo", "outset", "outside", "outside-shape", "overlay", "overline", "padding", "padding-box", "painted", "page", "paused", "persian", "perspective", "pinch-zoom", "plus-darker", "plus-lighter", "pointer", "polygon", "portrait", "pre", "pre-line", "pre-wrap", "preserve-3d", "progress", "push-button", "radial-gradient", "radio", "read-only", "read-write", "read-write-plaintext-only", "rectangle", "region", "relative", "repeat", "repeating-linear-gradient", "repeating-radial-gradient", "repeating-conic-gradient", "repeat-x", "repeat-y", "reset", "reverse", "rgb", "rgba", "ridge", "right", "rotate", "rotate3d", "rotateX", "rotateY", "rotateZ", "round", "row", "row-resize", "row-reverse", "rtl", "run-in", "running", "s-resize", "sans-serif", "saturate", "saturation", "scale", "scale3d", "scaleX", "scaleY", "scaleZ", "screen", "scroll", "scrollbar", "scroll-position", "se-resize", "searchfield", "searchfield-cancel-button", "searchfield-decoration", "searchfield-results-button", "searchfield-results-decoration", "self-start", "self-end", "semi-condensed", "semi-expanded", "separate", "sepia", "serif", "show", "sidama", "simp-chinese-formal", "simp-chinese-informal", "single", "skew", "skewX", "skewY", "skip-white-space", "slide", "slider-horizontal", "slider-vertical", "sliderthumb-horizontal", "sliderthumb-vertical", "slow", "small", "small-caps", "small-caption", "smaller", "soft-light", "solid", "somali", "source-atop", "source-in", "source-out", "source-over", "space", "space-around", "space-between", "space-evenly", "spell-out", "square", "square-button", "start", "static", "status-bar", "stretch", "stroke", "stroke-box", "sub", "subpixel-antialiased", "svg_masks", "super", "sw-resize", "symbolic", "symbols", "system-ui", "table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row", "table-row-group", "tamil", "telugu", "text", "text-bottom", "text-top", "textarea", "textfield", "thai", "thick", "thin", "threeddarkshadow", "threedface", "threedhighlight", "threedlightshadow", "threedshadow", "tibetan", "tigre", "tigrinya-er", "tigrinya-er-abegede", "tigrinya-et", "tigrinya-et-abegede", "to", "top", "trad-chinese-formal", "trad-chinese-informal", "transform", "translate", "translate3d", "translateX", "translateY", "translateZ", "transparent", "ultra-condensed", "ultra-expanded", "underline", "unidirectional-pan", "unset", "up", "upper-alpha", "upper-armenian", "upper-greek", "upper-hexadecimal", "upper-latin", "upper-norwegian", "upper-roman", "uppercase", "urdu", "url", "var", "vertical", "vertical-text", "view-box", "visible", "visibleFill", "visiblePainted", "visibleStroke", "visual", "w-resize", "wait", "wave", "wider", "window", "windowframe", "windowtext", "words", "wrap", "wrap-reverse", "x-large", "x-small", "xor", "xx-large", "xx-small"],
          y = e(b),
          w = n.concat(r).concat(o).concat(l).concat(d).concat(h).concat(m).concat(b);
        function x(t, e) {
          for (var n, i = !1; null != (n = t.next());) {
            if (i && "/" == n) {
              e.tokenize = null;
              break;
            }
            i = "*" == n;
          }
          return ["comment", "comment"];
        }
        t.registerHelper("hintWords", "css", w), t.defineMIME("text/css", {
          documentTypes: i,
          mediaTypes: a,
          mediaFeatures: s,
          mediaValueKeywords: c,
          propertyKeywords: u,
          nonStandardPropertyKeywords: p,
          fontProperties: g,
          counterDescriptors: f,
          colorKeywords: v,
          valueKeywords: y,
          tokenHooks: {
            "/": function _(t, e) {
              return !!t.eat("*") && (e.tokenize = x, x(t, e));
            }
          },
          name: "css"
        }), t.defineMIME("text/x-scss", {
          mediaTypes: a,
          mediaFeatures: s,
          mediaValueKeywords: c,
          propertyKeywords: u,
          nonStandardPropertyKeywords: p,
          colorKeywords: v,
          valueKeywords: y,
          fontProperties: g,
          allowNested: !0,
          lineComment: "//",
          tokenHooks: {
            "/": function _(t, e) {
              return t.eat("/") ? (t.skipToEnd(), ["comment", "comment"]) : t.eat("*") ? (e.tokenize = x, x(t, e)) : ["operator", "operator"];
            },
            ":": function _(t) {
              return !!t.match(/^\s*\{/, !1) && [null, null];
            },
            $: function $(t) {
              return t.match(/^[\w-]+/), t.match(/^\s*:/, !1) ? ["variable-2", "variable-definition"] : ["variable-2", "variable"];
            },
            "#": function _(t) {
              return !!t.eat("{") && [null, "interpolation"];
            }
          },
          name: "css",
          helperType: "scss"
        }), t.defineMIME("text/x-less", {
          mediaTypes: a,
          mediaFeatures: s,
          mediaValueKeywords: c,
          propertyKeywords: u,
          nonStandardPropertyKeywords: p,
          colorKeywords: v,
          valueKeywords: y,
          fontProperties: g,
          allowNested: !0,
          lineComment: "//",
          tokenHooks: {
            "/": function _(t, e) {
              return t.eat("/") ? (t.skipToEnd(), ["comment", "comment"]) : t.eat("*") ? (e.tokenize = x, x(t, e)) : ["operator", "operator"];
            },
            "@": function _(t) {
              return t.eat("{") ? [null, "interpolation"] : !t.match(/^(charset|document|font-face|import|(-(moz|ms|o|webkit)-)?keyframes|media|namespace|page|supports)\b/i, !1) && (t.eatWhile(/[\w\\\-]/), t.match(/^\s*:/, !1) ? ["variable-2", "variable-definition"] : ["variable-2", "variable"]);
            },
            "&": function _() {
              return ["atom", "atom"];
            }
          },
          name: "css",
          helperType: "less"
        }), t.defineMIME("text/x-gss", {
          documentTypes: i,
          mediaTypes: a,
          mediaFeatures: s,
          propertyKeywords: u,
          nonStandardPropertyKeywords: p,
          fontProperties: g,
          counterDescriptors: f,
          colorKeywords: v,
          valueKeywords: y,
          supportsAtComponent: !0,
          tokenHooks: {
            "/": function _(t, e) {
              return !!t.eat("*") && (e.tokenize = x, x(t, e));
            }
          },
          name: "css",
          helperType: "gss"
        });
      }(n(13));
    }, function (t, e, n) {
      "use strict";

      n.r(e), e.default = {
        run: function run(t) {
          confirm("Are you sure to clean the canvas?") && (t.Storage.getCurrentStorage().attributes.isDeleteContent = !0, t.DomComponents.clear(), t.CssComposer.clear(), t.store());
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(0),
        r = n(3),
        a = n(17);
      e.default = {
        run: function run(t) {
          Object(i.bindAll)(this, "onKeyUp", "enableDragger", "disableDragger"), this.editor = t, this.canvasModel = this.canvas.getCanvasView().model, this.toggleMove(1);
        },
        stop: function stop(t) {
          this.toggleMove(), this.disableDragger();
        },
        onKeyUp: function onKeyUp(t) {
          " " === Object(r.f)(t) && this.editor.stopCommand(this.id);
        },
        enableDragger: function enableDragger(t) {
          this.toggleDragger(1, t);
        },
        disableDragger: function disableDragger(t) {
          this.toggleDragger(0, t);
        },
        toggleDragger: function toggleDragger(t, e) {
          var n = this.canvasModel,
            i = this.em,
            r = this.dragger,
            o = t ? "add" : "remove";
          this.getCanvas().classList[o]("".concat(this.ppfx, "is__grabbing")), r || (r = new a.a({
            getPosition: function getPosition() {
              return {
                x: n.get("x"),
                y: n.get("y")
              };
            },
            setPosition: function setPosition(t) {
              var e = t.x,
                i = t.y;
              n.set({
                x: e,
                y: i
              });
            },
            onStart: function onStart(t, e) {
              i.trigger("canvas:move:start", e);
            },
            onDrag: function onDrag(t, e) {
              i.trigger("canvas:move", e);
            },
            onEnd: function onEnd(t, e) {
              i.trigger("canvas:move:end", e);
            }
          }), this.dragger = r), t ? r.start(e) : r.stop();
        },
        toggleMove: function toggleMove(t) {
          var e = this.ppfx,
            n = t ? "add" : "remove",
            i = t ? "on" : "off",
            a = {
              on: r.u,
              off: r.t
            },
            o = this.getCanvas(),
            s = ["".concat(e, "is__grab")];
          !t && s.push("".concat(e, "is__grabbing")), s.forEach(function (t) {
            return o.classList[n](t);
          }), a[i](document, "keyup", this.onKeyUp), a[i](o, "mousedown", this.enableDragger), a[i](document, "mouseup", this.disableDragger);
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(9),
        r = n.n(i),
        a = n(0);
      e.default = {
        run: function run(t, e) {
          var n = this,
            i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            o = i.component || t.getSelectedAll();
          o = Object(a.isArray)(o) ? r()(o) : [o];
          var s = "",
            l = t.getComponents();
          if (l && 1 == l.length) {
            var c = t.getSelected();
            if ((s = c ? c.parent() : "") && !s.collection) return alert("Alert! The removal of the main component from a page is currently restricted.\n\nPlease click the Clear icon on the top bar if you like to Clear the page content."), this.em.logWarning("Alert! The removal of the main component from a page is currently restricted.\n\nPlease click the Clear icon on the top bar if you like to Clear the page content.", {
              component: c
            });
          }
          return t.select(null), o.forEach(function (t) {
            if (!t || !t.get("removable")) return n.em.logWarning("The element is not removable", {
              component: t
            });
            t.remove();
          }), o;
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(2),
        r = n.n(i),
        a = n(0),
        o = n(17);
      function s(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function l(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? s(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.default = {
        run: function run(t, e) {
          var n = this,
            i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          Object(a.bindAll)(this, "setPosition", "onStart", "onDrag", "onEnd", "getPosition", "getGuidesStatic", "renderGuide", "getGuidesTarget");
          var r = i.target,
            s = i.event,
            c = i.mode,
            d = i.dragger,
            u = void 0 === d ? {} : d,
            h = r.getEl(),
            p = l({
              doc: h.ownerDocument,
              onStart: this.onStart,
              onEnd: this.onEnd,
              onDrag: this.onDrag,
              getPosition: this.getPosition,
              setPosition: this.setPosition,
              guidesStatic: function guidesStatic() {
                return n.guidesStatic;
              },
              guidesTarget: function guidesTarget() {
                return n.guidesTarget;
              }
            }, u);
          this.setupGuides(), this.opts = i, this.editor = t, this.em = t.getModel(), this.target = r, this.isTran = "translate" == c, this.guidesContainer = this.getGuidesContainer(), this.guidesTarget = this.getGuidesTarget(), this.guidesStatic = this.getGuidesStatic();
          var g = this.dragger;
          return g ? g.setOptions(p) : (g = new o.a(p), this.dragger = g), s && g.start(s), this.toggleDrag(1), this.em.trigger("".concat("dmode", ":start"), this.getEventOpts()), g;
        },
        getEventOpts: function getEventOpts() {
          return {
            mode: this.opts.mode,
            target: this.target,
            guidesTarget: this.guidesTarget,
            guidesStatic: this.guidesStatic
          };
        },
        stop: function stop() {
          this.toggleDrag();
        },
        setupGuides: function setupGuides() {
          (this.guides || []).forEach(function (t) {
            var e = t.guide;
            e && e.parentNode.removeChild(e);
          }), this.guides = [];
        },
        getGuidesContainer: function getGuidesContainer() {
          var t = this,
            e = this.guidesEl;
          if (!e) {
            var n = this.editor,
              i = this.em,
              r = this.opts,
              o = n.getConfig("stylePrefix"),
              s = document.createElement("div"),
              l = document.createElement("div"),
              c = '<div class="'.concat(o, "guide-info__line ").concat(o, 'danger-bg">\n        <div class="').concat(o, "guide-info__content ").concat(o, 'danger-color"></div>\n      </div>');
            (e = document.createElement("div")).className = "".concat(o, "guides"), s.className = "".concat(o, "guide-info ").concat(o, "guide-info__x"), l.className = "".concat(o, "guide-info ").concat(o, "guide-info__y"), s.innerHTML = c, l.innerHTML = c, e.appendChild(s), e.appendChild(l), n.Canvas.getGlobalToolsEl().appendChild(e), this.guidesEl = e, this.elGuideInfoX = s, this.elGuideInfoY = l, this.elGuideInfoContentX = s.querySelector(".".concat(o, "guide-info__content")), this.elGuideInfoContentY = l.querySelector(".".concat(o, "guide-info__content")), i.on("canvas:update frame:scroll", Object(a.debounce)(function () {
              t.updateGuides(), r.debug && t.guides.forEach(function (e) {
                return t.renderGuide(e);
              });
            }, 200));
          }
          return e;
        },
        getGuidesStatic: function getGuidesStatic() {
          var t = this,
            e = [],
            n = this.target.getEl(),
            i = n.parentNode,
            r = void 0 === i ? {} : i;
          return Object(a.each)(r.children, function (i) {
            return e = e.concat(n !== i ? t.getElementGuides(i) : []);
          }), e.concat(this.getElementGuides(r));
        },
        getGuidesTarget: function getGuidesTarget() {
          return this.getElementGuides(this.target.getEl());
        },
        updateGuides: function updateGuides(t) {
          var e,
            n,
            i = this;
          (t || this.guides).forEach(function (t) {
            var r = t.origin,
              o = e === r ? n : i.getElementPos(r);
            e = r, n = o, Object(a.each)(i.getGuidePosUpdate(t, o), function (e, n) {
              return t[n] = e;
            }), t.originRect = o;
          });
        },
        getGuidePosUpdate: function getGuidePosUpdate(t, e) {
          var n = {},
            i = e.top,
            r = e.height,
            a = e.left,
            o = e.width;
          switch (t.type) {
            case "t":
              n.y = i;
              break;
            case "b":
              n.y = i + r;
              break;
            case "l":
              n.x = a;
              break;
            case "r":
              n.x = a + o;
              break;
            case "x":
              n.x = a + o / 2;
              break;
            case "y":
              n.y = i + r / 2;
          }
          return n;
        },
        renderGuide: function renderGuide() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = t.guide || document.createElement("div"),
            n = "px",
            i = t.active ? 2 : 1,
            r = e.children[0];
          return e.style = "position: absolute; background-color: ".concat(t.active ? "green" : "red", ";"), e.children.length || ((r = document.createElement("div")).style = "position: absolute; color: red; padding: 5px; top: 0; left: 0;", e.appendChild(r)), t.y ? (e.style.width = "100%", e.style.height = "".concat(i).concat(n), e.style.top = "".concat(t.y).concat(n), e.style.left = 0) : (e.style.width = "".concat(i).concat(n), e.style.height = "100%", e.style.left = "".concat(t.x).concat(n), e.style.top = "0".concat(n)), !t.guide && this.guidesContainer.appendChild(e), e;
        },
        getElementPos: function getElementPos(t) {
          return this.editor.Canvas.getElementPos(t, {
            noScroll: 1
          });
        },
        getElementGuides: function getElementGuides(t) {
          var e = this,
            n = this.opts,
            i = this.getElementPos(t),
            r = i.top,
            a = i.height,
            o = i.left,
            s = i.width,
            c = [{
              type: "t",
              y: r
            }, {
              type: "b",
              y: r + a
            }, {
              type: "l",
              x: o
            }, {
              type: "r",
              x: o + s
            }, {
              type: "x",
              x: o + s / 2
            }, {
              type: "y",
              y: r + a / 2
            }].map(function (r) {
              return l(l({}, r), {}, {
                origin: t,
                originRect: i,
                guide: n.debug && e.renderGuide(r)
              });
            });
          return c.forEach(function (t) {
            return e.guides.push(t);
          }), c;
        },
        getTranslate: function getTranslate(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "x",
            n = 0;
          return (t || "").split(" ").forEach(function (t) {
            var i = t.trim(),
              r = "translate".concat(e.toUpperCase(), "(");
            0 === i.indexOf(r) && (n = parseFloat(i.replace(r, "")));
          }), n;
        },
        setTranslate: function setTranslate(t, e, n) {
          var i = "translate".concat(e.toUpperCase(), "("),
            r = "".concat(i).concat(n, ")"),
            a = (t || "").split(" ").map(function (t) {
              return 0 === t.trim().indexOf(i) && (t = r), t;
            }).join(" ");
          return a.indexOf(i) < 0 && (a += " ".concat(r)), a;
        },
        getPosition: function getPosition() {
          var t = this.target,
            e = this.isTran,
            n = t.getStyle(),
            i = n.left,
            r = n.top,
            a = n.transform,
            o = 0,
            s = 0;
          return e ? (o = this.getTranslate(a), s = this.getTranslate(a, "y")) : (o = parseFloat(i), s = parseFloat(r)), {
            x: o,
            y: s
          };
        },
        setPosition: function setPosition(t) {
          var e = t.x,
            n = t.y,
            i = t.end,
            r = t.position,
            o = t.width,
            s = t.height,
            l = this.target,
            c = this.isTran,
            d = i ? "" : 1,
            u = "".concat(e).concat("px"),
            h = "".concat(n).concat("px");
          if (c) {
            var p = l.getStyle().transform || "";
            return p = this.setTranslate(p, "x", u), p = this.setTranslate(p, "y", h), l.addStyle({
              transform: p,
              en: d
            }, {
              avoidStore: !i
            });
          }
          var g = {
              position: r,
              width: o,
              height: s
            },
            f = {
              left: u,
              top: h,
              en: d
            };
          Object(a.keys)(g).forEach(function (t) {
            var e = g[t];
            e && (f[t] = e);
          }), l.addStyle(f, {
            avoidStore: !i
          });
        },
        _getDragData: function _getDragData() {
          var t = this.target;
          return {
            target: t,
            parent: t.parent(),
            index: t.index()
          };
        },
        onStart: function onStart() {
          var t = this.target,
            e = this.editor,
            n = this.isTran,
            i = this.opts,
            r = i.center,
            a = i.onStart,
            o = e.Canvas,
            s = t.getStyle();
          if (a && a(this._getDragData()), !n && "absolute" !== s.position) {
            var l = o.offset(t.getEl()),
              c = l.left,
              d = l.top,
              u = l.width,
              h = l.height;
            if (r) {
              var p = o.getMouseRelativeCanvas(event);
              c = p.x, d = p.y;
            }
            this.setPosition({
              x: c,
              y: d,
              width: "".concat(u, "px"),
              height: "".concat(h, "px"),
              position: "absolute"
            });
          }
        },
        onDrag: function onDrag() {
          var t = this,
            e = this.guidesTarget,
            n = this.opts,
            i = n.onDrag;
          this.updateGuides(e), n.debug && e.forEach(function (e) {
            return t.renderGuide(e);
          }), n.guidesInfo && this.renderGuideInfo(e.filter(function (t) {
            return t.active;
          })), i && i(this._getDragData());
        },
        onEnd: function onEnd(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            i = this.editor,
            r = this.opts,
            a = this.id,
            o = r.onEnd;
          o && o(t, n, l(l({
            event: t
          }, n), this._getDragData())), i.stopCommand(a), this.hideGuidesInfo(), this.em.trigger("".concat("dmode", ":end"), this.getEventOpts());
        },
        hideGuidesInfo: function hideGuidesInfo() {
          var t = this;
          ["X", "Y"].forEach(function (e) {
            var n = t["elGuideInfo".concat(e)];
            n && (n.style.display = "none");
          });
        },
        renderGuideInfo: function renderGuideInfo() {
          var t = this,
            e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
            n = this.guidesStatic;
          this.hideGuidesInfo(), e.forEach(function (e) {
            var i = e.origin,
              r = e.x,
              o = t.getElementPos(i),
              s = Object(a.isUndefined)(r) ? "y" : "x",
              c = "y" === s,
              d = o[c ? "left" : "top"],
              u = o.rect[c ? "left" : "top"],
              h = c ? d + o.width : d + o.height,
              p = c ? u + o.rect.width : u + o.rect.height,
              g = t["elGuideInfo".concat(s.toUpperCase())],
              f = t["elGuideInfoContent".concat(s.toUpperCase())],
              m = g.style,
              v = n.filter(function (t) {
                return t.type === e.type;
              }).map(function (t) {
                var e = t.originRect,
                  n = e.left,
                  i = e.width,
                  r = e.top,
                  a = e.height,
                  o = c ? n + i : r + a;
                return {
                  gap: o < d ? d - o : (c ? n : r) - h,
                  guide: t
                };
              }).filter(function (t) {
                return t.gap > 0;
              }).sort(function (t, e) {
                return t.gap - e.gap;
              }).map(function (t) {
                return t.guide;
              })[0];
            if (v) {
              var b = v.originRect,
                y = b.left,
                w = b.width,
                x = b.top,
                j = b.height,
                C = b.rect,
                M = c ? y < o.left : x < o.top,
                k = c ? y : x,
                O = c ? C.left : C.top,
                T = c ? y + w : x + j,
                S = c ? C.left + C.width : C.top + C.height,
                N = c ? e.y : e.x,
                L = M ? T : h,
                D = "".concat(N, "px"),
                E = M ? d - T : k - h,
                I = M ? u - S : O - p;
              m.display = "", m[c ? "top" : "left"] = D, m[c ? "left" : "top"] = "".concat(L, "px"), m[c ? "width" : "height"] = "".concat(E, "px"), f.innerHTML = "".concat(Math.round(I), "px"), t.em.trigger("".concat("dmode", ":active"), l(l({}, t.getEventOpts()), {}, {
                guide: e,
                guidesStatic: n,
                matched: v,
                posFirst: N,
                posSecond: L,
                size: E,
                sizeRaw: I,
                elGuideInfo: g,
                elGuideInfoCnt: f
              }));
            }
          });
        },
        toggleDrag: function toggleDrag(t) {
          var e = this.ppfx,
            n = this.editor,
            i = t ? "add" : "remove",
            r = ["".concat(e, "is__grabbing")],
            a = n.Canvas,
            o = a.getBody();
          r.forEach(function (t) {
            return o.classList[i](t);
          }), a[t ? "startAutoscroll" : "stopAutoscroll"]();
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e), e.default = {
        run: function run(t) {
          if (t.Canvas.hasFocus()) {
            var e = [];
            t.getSelectedAll().forEach(function (t) {
              var n = t.components(),
                i = n && n.at(0);
              i && e.push(i);
            }), e.length && t.select(e);
          }
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e), e.default = {
        run: function run(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          if (t.Canvas.hasFocus() || n.force) {
            var i = [];
            t.getSelectedAll().forEach(function (t) {
              for (var e = t.parent(); e && !e.get("selectable");) e = e.parent();
              e && i.push(e);
            }), i.length && t.select(i);
          }
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e), e.default = {
        run: function run(t) {
          if (t.Canvas.hasFocus()) {
            var e = [];
            t.getSelectedAll().forEach(function (t) {
              var n = t.collection,
                i = n.indexOf(t),
                r = n.at(i + 1);
              e.push(r || t);
            }), e.length && t.select(e);
          }
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e), e.default = {
        run: function run(t) {
          if (t.Canvas.hasFocus()) {
            var e = [];
            t.getSelectedAll().forEach(function (t) {
              var n = t.collection,
                i = n.indexOf(t),
                r = n.at(i - 1);
              e.push(r && i - 1 >= 0 ? r : t);
            }), e.length && t.select(e);
          }
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(0);
      e.default = {
        run: function run(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            r = n.target,
            a = t.DomComponents,
            o = r.get("type"),
            s = a.getWrapper().findType(o).length,
            l = [];
          if (!s) {
            var c = t.CssComposer.getAll(),
              d = r.get("style-signature");
            d = Object(i.isArray)(d) ? d : [d], c.forEach(function (t) {
              var e = t.selectorsToString();
              d.forEach(function (n) {
                n && e.indexOf(n) >= 0 && l.push(t);
              });
            }), c.remove(l);
          }
          return l;
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(9),
        r = n.n(i);
      e.default = {
        run: function run(t) {
          var e = t.getModel(),
            n = r()(t.getSelectedAll());
          n.length && e.set("clipboard", n);
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(0),
        r = n(1),
        a = n.n(r),
        o = n(14),
        s = a.a.$;
      e.default = Object(i.extend)({}, o.default, {
        init: function init(t) {
          Object(i.bindAll)(this, "startDelete", "stopDelete", "onDelete"), this.hoverClass = this.pfx + "hover-delete", this.badgeClass = this.pfx + "badge-red";
        },
        enable: function enable() {
          this.$el.find("*").mouseover(this.startDelete).mouseout(this.stopDelete).click(this.onDelete);
        },
        startDelete: function startDelete(t) {
          t.stopPropagation();
          var e = s(t.target);
          e.data("model").get("removable") && (e.addClass(this.hoverClass), this.attachBadge(e.get(0)));
        },
        stopDelete: function stopDelete(t) {
          t.stopPropagation(), s(t.target).removeClass(this.hoverClass), this.badge && this.badge.css({
            left: -1e3,
            top: -1e3
          });
        },
        onDelete: function onDelete(t) {
          t.stopPropagation();
          var e = s(t.target);
          e.data("model").get("removable") && (e.data("model").destroy(), this.removeBadge(), this.clean());
        },
        updateBadgeLabel: function updateBadgeLabel(t) {
          this.badge.html("Remove " + t.getName());
        }
      });
    }, function (t, e, n) {
      "use strict";

      n.r(e), e.default = {
        run: function run(t) {
          t.setDevice("Desktop");
        },
        stop: function stop() {}
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e), e.default = {
        run: function run(t) {
          t.setDevice("Mobile landscape");
        },
        stop: function stop() {}
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e), e.default = {
        run: function run(t) {
          t.setDevice("Mobile portrait");
        },
        stop: function stop() {}
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e), e.default = {
        run: function run(t) {
          t.setDevice("Tablet");
        },
        stop: function stop() {}
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(1),
        r = n.n(i).a.$;
      e.default = {
        run: function run(t, e) {
          var n = this;
          e && e.set && e.set("active", 0);
          var i = t.getConfig(),
            a = t.Modal,
            o = i.stylePrefix;
          if (this.cm = t.CodeManager || null, !this.$editors) {
            var s = this.buildEditor("htmlmixed", "hopscotch", "HTML"),
              l = this.buildEditor("css", "hopscotch", "CSS");
            this.htmlEditor = s.el, this.cssEditor = l.el;
            var c = r('<div class="'.concat(o, 'export-dl"></div>'));
            c.append(s.$el).append(l.$el), this.$editors = c;
          }
          a.open({
            title: i.textViewCode,
            content: this.$editors
          }).getModel().once("change:open", function () {
            return t.stopCommand(n.id);
          }), this.htmlEditor.setContent(t.getHtml()), this.cssEditor.setContent(t.getCss());
        },
        stop: function stop(t) {
          var e = t.Modal;
          e && e.close();
        },
        buildEditor: function buildEditor(t, e, n) {
          var i = document.createElement("textarea");
          !this.codeMirror && (this.codeMirror = this.cm.getViewer("CodeMirror"));
          var r = this.codeMirror.clone().set({
              label: n,
              codeName: t,
              theme: e,
              input: i
            }),
            a = new this.cm.EditorView({
              model: r,
              config: this.cm.getConfig()
            }).render().$el;
          return r.init(i), {
            el: r,
            $el: a
          };
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(0);
      e.default = {
        isEnabled: function isEnabled() {
          var t = document;
          return t.fullscreenElement || t.webkitFullscreenElement || t.mozFullScreenElement ? 1 : 0;
        },
        enable: function enable(t) {
          var e = "";
          return t.requestFullscreen ? t.requestFullscreen() : t.webkitRequestFullscreen ? (e = "webkit", t.webkitRequestFullscreen()) : t.mozRequestFullScreen ? (e = "moz", t.mozRequestFullScreen()) : t.msRequestFullscreen ? t.msRequestFullscreen() : console.warn("Fullscreen not supported"), e;
        },
        disable: function disable() {
          var t = document;
          this.isEnabled() && (t.exitFullscreen ? t.exitFullscreen() : t.webkitExitFullscreen ? t.webkitExitFullscreen() : t.mozCancelFullScreen ? t.mozCancelFullScreen() : t.msExitFullscreen && t.msExitFullscreen());
        },
        fsChanged: function fsChanged(t, e) {
          document;
          var n = (t || "") + "fullscreenchange";
          this.isEnabled() || (this.stop(null, this.sender), document.removeEventListener(n, this.fsChanged));
        },
        run: function run(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          this.sender = e;
          var r = n.target,
            a = Object(i.isElement)(r) ? r : document.querySelector(r),
            o = this.enable(a || t.getContainer());
          this.fsChanged = this.fsChanged.bind(this, o), document.addEventListener(o + "fullscreenchange", this.fsChanged), t.trigger("change:canvasOffset");
        },
        stop: function stop(t, e) {
          e && e.set && e.set("active", !1), this.disable(), t && t.trigger("change:canvasOffset");
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(0),
        r = n(1),
        a = n.n(r),
        o = n(3),
        s = n(14),
        l = n(27),
        c = a.a.$;
      e.default = Object(i.extend)({}, l.default, s.default, {
        init: function init(t) {
          s.default.init.apply(this, arguments), Object(i.bindAll)(this, "initSorter", "rollback", "onEndMove"), this.opt = t, this.hoverClass = this.ppfx + "highlighter-warning", this.badgeClass = this.ppfx + "badge-warning", this.noSelClass = this.ppfx + "no-select";
        },
        enable: function enable() {
          for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
          s.default.enable.apply(this, e), this.getBadgeEl().addClass(this.badgeClass), this.getHighlighterEl().addClass(this.hoverClass);
          var i = this.$wrapper;
          i.css("cursor", "move"), i.on("mousedown", this.initSorter), i.addClass(this.noSelClass);
        },
        toggleClipboard: function toggleClipboard() {},
        initSorter: function initSorter(t) {
          var e = c(t.target).data("model").get("draggable");
          e && (this.cacheEl = null, this.startSelectPosition(t.target, this.frameEl.contentDocument), this.sorter.draggable = e, this.sorter.onEndMove = this.onEndMove.bind(this), this.stopSelectComponent(), this.$wrapper.off("mousedown", this.initSorter), Object(o.u)(this.getContentWindow(), "keydown", this.rollback));
        },
        initSorterFromModel: function initSorterFromModel(t) {
          var e = t.get("draggable");
          if (e) {
            this.cacheEl = null;
            var n = t.view.el;
            this.startSelectPosition(n, this.frameEl.contentDocument), this.sorter.draggable = e, this.sorter.onEndMove = this.onEndMoveFromModel.bind(this), this.stopSelectComponent(), Object(o.u)(this.getContentWindow(), "keydown", this.rollback);
          }
        },
        initSorterFromModels: function initSorterFromModels(t) {
          this.cacheEl = null;
          var e = t[t.length - 1],
            n = (this.em.get("currentFrame") || {}).model,
            i = e.getEl(n),
            r = i.ownerDocument;
          this.startSelectPosition(i, r, {
            onStart: this.onStart
          }), this.sorter.draggable = e.get("draggable"), this.sorter.toMove = t, this.sorter.onMoveClb = this.onDrag, this.sorter.onEndMove = this.onEndMoveFromModel.bind(this), this.stopSelectComponent(), Object(o.u)(this.getContentWindow(), "keydown", this.rollback);
        },
        onEndMoveFromModel: function onEndMoveFromModel() {
          Object(o.t)(this.getContentWindow(), "keydown", this.rollback);
        },
        onEndMove: function onEndMove() {
          this.enable(), Object(o.t)(this.getContentWindow(), "keydown", this.rollback);
        },
        onSelect: function onSelect(t, e) {},
        rollback: function rollback(t, e) {
          (27 == (t.which || t.keyCode) || e) && (this.sorter.moved = !1, this.sorter.endMove());
        },
        getBadgeEl: function getBadgeEl() {
          return this.$badge || (this.$badge = c(this.getBadge())), this.$badge;
        },
        getHighlighterEl: function getHighlighterEl() {
          return this.$hl || (this.$hl = c(this.canvas.getHighlighter())), this.$hl;
        },
        stop: function stop() {
          for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
          s.default.stop.apply(this, e), this.getBadgeEl().removeClass(this.badgeClass), this.getHighlighterEl().removeClass(this.hoverClass);
          var i = this.$wrapper;
          i.css("cursor", "").unbind().removeClass(this.noSelClass);
        }
      });
    }, function (t, e, n) {
      "use strict";

      n.r(e), e.default = {
        run: function run(t, e) {
          var n = this,
            i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            r = t.Modal,
            a = t.AssetManager,
            o = a.getConfig(),
            s = a.getContainer(),
            l = i.modalTitle || t.t("assetManager.modalTitle") || "",
            c = i.types,
            d = i.accept;
          if (a.setTarget(i.target), a.onClick(i.onClick), a.onDblClick(i.onDblClick), a.onSelect(i.onSelect), !this.rendered || c) {
            var u = a.getAll().filter(function (t) {
              return 1;
            });
            c && c.length && (u = u.filter(function (t) {
              return -1 !== c.indexOf(t.get("type"));
            })), a.render(u), this.rendered = 1;
          }
          if (d) {
            var h = s.querySelector("input#".concat(o.stylePrefix, "uploadFile"));
            h && h.setAttribute("accept", d);
          }
          return r.open({
            title: l,
            content: s
          }).getModel().once("change:open", function () {
            return t.stopCommand(n.id);
          }), this;
        },
        stop: function stop(t) {
          return t.Modal.close(), this;
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e), e.default = {
        run: function run(t, e) {
          var n = t.BlockManager,
            i = t.Panels;
          if (!this.blocks) {
            n.render();
            var r = "views-container",
              a = document.createElement("div"),
              o = i.getPanel(r) || i.addPanel({
                id: r
              });
            a.appendChild(n.getContainer()), o.set("appendContent", a).trigger("change:appendContent"), this.blocks = a;
          }
          this.blocks.style.display = "block";
        },
        stop: function stop() {
          var t = this.blocks;
          t && (t.style.display = "none");
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(1);
      n.n(i).a.$, e.default = {
        run: function run(t) {
          var e = t.LayerManager,
            n = t.Panels;
          if (!this.layers) {
            var i = "views-container",
              r = document.createElement("div"),
              a = n.getPanel(i) || n.addPanel({
                id: i
              });
            r.appendChild(e.render()), a.set("appendContent", r).trigger("change:appendContent"), this.layers = r;
          }
          this.layers.style.display = "block";
        },
        stop: function stop() {
          var t = this.layers;
          t && (t.style.display = "none");
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(1),
        r = n.n(i).a.$;
      e.default = {
        run: function run(t, e) {
          if (this.sender = e, !this.$cn) {
            var n = t.getConfig(),
              i = t.Panels;
            this.$cn = r("<div></div>"), this.$cn2 = r("<div></div>"), this.$cn.append(this.$cn2);
            var a = t.DeviceManager;
            a && n.showDevices && i.addPanel({
              id: "devices-c"
            }).set("appendContent", a.render()).trigger("change:appendContent");
            var o = t.SelectorManager;
            o && this.$cn2.append(o.render([])), this.$cn2.append(t.StyleManager.render());
            var s = t.StyleManager.getConfig().stylePrefix;
            this.$header = r('<div class="'.concat(s, 'header">').concat(t.t("styleManager.empty"), "</div>")), this.$cn.append(this.$header), i.getPanel("views-container") ? this.panel = i.getPanel("views-container") : this.panel = i.addPanel({
              id: "views-container"
            }), this.panel.set("appendContent", this.$cn).trigger("change:appendContent"), this.target = t.editor, this.listenTo(this.target, "component:toggled", this.toggleSm);
          }
          this.toggleSm();
        },
        toggleSm: function toggleSm() {
          var t = this.target,
            e = this.sender;
          if (!e || !e.get || e.get("active")) {
            var n = t.get("SelectorManager").getConfig().componentFirst,
              i = t.getSelectedAll().length;
            1 === i || i > 1 && n ? (this.$cn2.show(), this.$header.hide()) : (this.$cn2.hide(), this.$header.show());
          }
        },
        stop: function stop() {
          this.$cn2 && this.$cn2.hide(), this.$header && this.$header.hide();
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(1),
        r = n.n(i).a.$;
      e.default = {
        run: function run(t, e) {
          this.sender = e;
          var n = t.getModel(),
            i = t.Config.stylePrefix,
            a = t.TraitManager;
          if (!this.$cn) {
            var o = a.getTraitsViewer(),
              s = a.getConfig();
            this.$cn = r("<div></div>"), this.$cn2 = r("<div></div>"), this.$cn.append(this.$cn2), this.$header = r("<div>").append('<div class="'.concat(s.stylePrefix, 'header">').concat(n.t("traitManager.empty"), "</div>")), this.$cn.append(this.$header), this.$cn2.append('<div class="'.concat(i, 'traits-label">').concat(n.t("traitManager.label"), "</div>")), this.$cn2.append(o.render().el);
            var l = t.Panels;
            (l.getPanel("views-container") ? l.getPanel("views-container") : l.addPanel({
              id: "views-container"
            })).set("appendContent", this.$cn.get(0)).trigger("change:appendContent"), this.target = t.getModel(), this.listenTo(this.target, "component:toggled", this.toggleTm);
          }
          this.toggleTm();
        },
        toggleTm: function toggleTm() {
          var t = this.sender;
          t && t.get && !t.get("active") || (1 === this.target.getSelectedAll().length ? (this.$cn2.show(), this.$header.hide()) : (this.$cn2.hide(), this.$header.show()));
        },
        stop: function stop() {
          this.$cn2 && this.$cn2.hide(), this.$header && this.$header.hide();
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(0);
      e.default = {
        run: function run(t) {
          var e = t.getModel().get("clipboard"),
            n = t.getSelected();
          e && n && (t.getSelectedAll().forEach(function (n) {
            if (n) {
              var r,
                a = n.collection,
                o = a.indexOf(n) + 1,
                s = e.filter(function (t) {
                  return t.get("copyable");
                });
              r = Object(i.contains)(e, n) && n.get("copyable") ? a.add(n.clone(), {
                at: o
              }) : a.add(s.map(function (t) {
                return t.clone();
              }), {
                at: o
              }), (r = Object(i.isArray)(r) ? r : [r]).forEach(function (e) {
                return t.trigger("component:paste", e);
              });
            }
          }), n.emitUpdate());
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(0),
        r = "sw-visibility";
      e.default = {
        getPanels: function getPanels(t) {
          return this.panels || (this.panels = t.Panels.getPanels()), this.panels;
        },
        preventDrag: function preventDrag(t) {
          t.abort = 1;
        },
        tglPointers: function tglPointers(t, e) {
          var n = t.Canvas.getBody().querySelectorAll(".".concat(this.ppfx, "no-pointer"));
          Object(i.each)(n, function (t) {
            return t.style.pointerEvents = e ? "" : "all";
          });
        },
        tglEffects: function tglEffects(t) {
          var e = this.em;
          e && e[t ? "on" : "off"]("run:tlb-move:before", this.preventDrag);
        },
        run: function run(t, e) {
          var n = this;
          this.sender = e, this.shouldRunSwVisibility || (this.shouldRunSwVisibility = t.Commands.isActive(r)), this.shouldRunSwVisibility && t.stopCommand(r), t.getModel().stopDefault();
          var i = this.getPanels(t),
            a = t.Canvas.getElement(),
            o = t.getEl(),
            s = t.Config.stylePrefix;
          if (!this.helper) {
            var l = document.createElement("span");
            l.className = "".concat(s, "off-prv fa fa-eye-slash"), o.appendChild(l), l.onclick = function () {
              return n.stopCommand();
            }, this.helper = l;
          }
          this.helper.style.display = "inline-block", this.tglPointers(t), i.forEach(function (t) {
            return t.set("visible", !1);
          });
          var c = a.style;
          c.width = "100%", c.height = "100%", c.top = "0", c.left = "0", c.padding = "0", c.margin = "0", t.refresh(), this.tglEffects(1);
        },
        stop: function stop(t) {
          var e = this.sender,
            n = void 0 === e ? {} : e;
          n.set && n.set("active", 0);
          var i = this.getPanels(t);
          this.shouldRunSwVisibility && (t.runCommand(r), this.shouldRunSwVisibility = !1), t.getModel().runDefault(), i.forEach(function (t) {
            return t.set("visible", !0);
          }), t.Canvas.getElement().setAttribute("style", ""), this.helper && (this.helper.style.display = "none"), t.refresh(), this.tglPointers(t, 1), this.tglEffects();
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e), e.default = {
        run: function run(t, e, n) {
          var i = n || {},
            r = i.el || "",
            a = t.Canvas,
            o = this.canvasResizer,
            s = i.options || {},
            l = a.getCanvasView();
          return s.appendTo = a.getResizerEl(), s.prefix = t.getConfig().stylePrefix, s.posFetcher = l.getElementPos.bind(l), s.mousePosFetcher = a.getMouseRelativePos, o && !i.forceNew || (this.canvasResizer = t.Utils.Resizer.init(s), o = this.canvasResizer), o.setOptions(s), o.blur(), o.focus(r), o;
        },
        stop: function stop() {
          var t = this.canvasResizer;
          t && t.blur();
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e), e.default = {
        run: function run(t) {
          var e = t.Storage.getCurrentStorage();
          e.attributes.isDeleteContent && (e.attributes.isDeleteContent = !1), t.store();
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(2),
        r = n.n(i),
        a = n(1),
        o = n.n(a),
        s = n(0),
        l = n(3);
      function c(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      var d = o.a.$;
      e.default = {
        getOffsetMethod: function getOffsetMethod(t) {
          return "get" + (t || "") + "OffsetViewerEl";
        },
        run: function run(t, e, n) {
          var i = n || {},
            a = i.state || "",
            o = t.getConfig(),
            u = this.em.getZoomDecimal(),
            h = i.el || "";
          if (!o.showOffsets || Object(l.q)(h) || !o.showOffsetsSelected && "Fixed" == a) t.stopCommand(this.id, n);else {
            var p = t.Canvas,
              g = function (t) {
                for (var e = 1; e < arguments.length; e++) {
                  var n = null != arguments[e] ? arguments[e] : {};
                  e % 2 ? c(Object(n), !0).forEach(function (e) {
                    r()(t, e, n[e]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function (e) {
                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
                  });
                }
                return t;
              }({}, i.elPos || p.getElementPos(h));
            Object(s.isUndefined)(i.top) || (g.top = i.top), Object(s.isUndefined)(i.left) || (g.left = i.left);
            var f = window.getComputedStyle(h),
              m = this.ppfx,
              v = a + "State",
              b = p[this.getOffsetMethod(a)](n.view);
            b.style.opacity = "";
            var y = this["marginT" + a],
              w = this["marginB" + a],
              x = this["marginL" + a],
              j = this["marginR" + a],
              C = this["padT" + a],
              M = this["padB" + a],
              k = this["padL" + a],
              O = this["padR" + a];
            if (b.childNodes.length && (this[v] = "1", y = b.querySelector("[data-offset-m-t]"), w = b.querySelector("[data-offset-m-b]"), x = b.querySelector("[data-offset-m-l]"), j = b.querySelector("[data-offset-m-r]"), C = b.querySelector("[data-offset-p-t]"), M = b.querySelector("[data-offset-p-b]"), k = b.querySelector("[data-offset-p-l]"), O = b.querySelector("[data-offset-p-r]")), !this[v]) {
              var T = a.toLowerCase(),
                S = T + "margin-v",
                N = T + "padding-v",
                L = d('<div class="'.concat(m, 'marginName">')).get(0),
                D = d('<div class="'.concat(m, 'paddingName">')).get(0),
                E = m + N + "-el",
                I = "".concat(m + S + "-el", " ").concat(m + S),
                P = "".concat(E, " ").concat(m + N);
              y = d('<div class="'.concat(I, '-top"></div>')).get(0), w = d('<div class="'.concat(I, '-bottom"></div>')).get(0), x = d('<div class="'.concat(I, '-left"></div>')).get(0), j = d('<div class="'.concat(I, '-right"></div>')).get(0), C = d('<div class="'.concat(P, '-top"></div>')).get(0), M = d('<div class="'.concat(P, '-bottom"></div>')).get(0), k = d('<div class="'.concat(P, '-left"></div>')).get(0), O = d('<div class="'.concat(P, '-right"></div>')).get(0), this["marginT" + a] = y, this["marginB" + a] = w, this["marginL" + a] = x, this["marginR" + a] = j, this["padT" + a] = C, this["padB" + a] = M, this["padL" + a] = k, this["padR" + a] = O, L.appendChild(y), L.appendChild(w), L.appendChild(x), L.appendChild(j), D.appendChild(C), D.appendChild(M), D.appendChild(k), D.appendChild(O), b.appendChild(L), b.appendChild(D), this[v] = "1";
            }
            var A = parseFloat(f.marginLeft.replace("px", "")) * u,
              z = parseFloat(f.marginRight.replace("px", "")) * u,
              _ = parseFloat(f.marginTop.replace("px", "")) * u,
              H = parseFloat(f.marginBottom.replace("px", "")) * u,
              V = y.style,
              F = w.style,
              R = x.style,
              B = j.style,
              W = C.style,
              Y = M.style,
              U = k.style,
              Z = O.style,
              G = parseFloat(g.left),
              q = parseFloat(f.width) * u + "px";
            V.height = _ + "px", V.width = q, V.top = g.top - _ + "px", V.left = G + "px", F.height = H + "px", F.width = q, F.top = g.top + g.height + "px", F.left = G + "px";
            var $ = g.height + _ + H + "px",
              Q = g.top - _ + "px";
            R.height = $, R.width = A + "px", R.top = Q, R.left = G - A + "px", B.height = $, B.width = z + "px", B.top = Q, B.left = G + g.width + "px";
            var J = parseFloat(f.paddingTop) * u;
            W.height = J + "px";
            var X = parseFloat(f.paddingBottom) * u;
            Y.height = X + "px";
            var K = g.height - X - J + "px",
              tt = g.top + J + "px";
            U.height = K, U.width = parseFloat(f.paddingLeft) * u + "px", U.top = tt;
            var et = parseFloat(f.paddingRight) * u;
            Z.height = K, Z.width = et + "px", Z.top = tt;
          }
        },
        stop: function stop(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            i = n || {},
            r = i.state || "",
            a = this.getOffsetMethod(r),
            o = t.Canvas,
            s = o[a](n.view);
          s.style.opacity = 0;
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e), e.default = {
        run: function run(t) {
          this.toggleVis(t);
        },
        stop: function stop(t) {
          this.toggleVis(t, 0);
        },
        toggleVis: function toggleVis(t) {
          var e = this,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
          if (!t.Commands.isActive("preview")) {
            var i = n ? "add" : "remove";
            t.Canvas.getFrames().forEach(function (t) {
              t.view.getBody().classList[i]("".concat(e.ppfx, "dashed"));
            });
          }
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(2),
        r = n.n(i),
        a = {
          stylePrefix: "",
          appendTo: "",
          sortable: 1,
          hidable: 1,
          hideTextnode: 1,
          root: "",
          showWrapper: 1,
          showHover: 1,
          scrollCanvas: {
            behavior: "smooth",
            block: "nearest"
          },
          scrollLayers: {
            behavior: "auto",
            block: "nearest"
          },
          highlightHover: 1
        },
        o = n(36),
        s = n(0);
      function l(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function c(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? l(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.default = function () {
        var t,
          e,
          n = {};
        return {
          name: "LayerManager",
          init: function init() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return (n = c(c({}, a), e)).stylePrefix = e.pStylePrefix, t = n.em, this;
          },
          getConfig: function getConfig() {
            return n;
          },
          onLoad: function onLoad() {
            e = new o.a({
              level: 0,
              config: n,
              opened: n.opened || {},
              model: t.get("DomComponents").getWrapper()
            }), t && t.on("component:selected", this.componentChanged), this.componentChanged();
          },
          postRender: function postRender() {
            var t = n.appendTo,
              e = n.root;
            e && this.setRoot(e), t && (Object(s.isElement)(t) ? t : document.querySelector(t)).appendChild(this.render());
          },
          setRoot: function setRoot(t) {
            return e.setRoot(t), this;
          },
          getRoot: function getRoot() {
            return e.model;
          },
          getAll: function getAll() {
            return e;
          },
          componentChanged: function componentChanged(e) {
            var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            if (!i.fromLayers) {
              var r = t.get("opened"),
                a = t.getSelected(),
                o = n.scrollLayers,
                s = a && a.collection ? a.collection.parent : null;
              for (var l in r) r[l].set("open", 0);
              for (; s;) s.set("open", 1), r[s.cid] = s, s = s.collection ? s.collection.parent : null;
              if (a && o) {
                var c = a.viewLayer && a.viewLayer.el;
                c && c.scrollIntoView(o);
              }
            }
          },
          render: function render() {
            return e.render().el;
          }
        };
      };
    }, function (t, e, n) {
      var i, r, a;
      r = [n(0), n(1)], void 0 === (a = "function" == typeof (i = function i(t, e) {
        var n = Array.prototype.slice;
        function i(t, e, n) {
          return n.length <= 4 ? t.call(e, n[0], n[1], n[2], n[3]) : t.apply(e, n);
        }
        function r(t, e) {
          return n.call(t, e);
        }
        function a(e, n) {
          return null != e && (t.isArray(n) || (n = r(arguments, 1)), t.all(n, function (t) {
            return t in e;
          }));
        }
        var o,
          s,
          l = (o = !1, s = -1, function () {
            return o || (s++, o = !0, t.defer(function () {
              o = !1;
            })), s;
          });
        function c() {
          this.registeredObjects = [], this.cidIndexes = [];
        }
        function d(e, n, i, r) {
          for (var a, o = 0, s = n.length; o < s; o++) if (a = n[o]) {
            if ("on" === e) {
              if (!r.objectRegistry.register(a)) continue;
            } else if (!r.objectRegistry.unregister(a)) continue;
            t.isFunction(a[e]) && a[e]("all", i, r);
          }
        }
        function u(e, n) {
          var i = n.type,
            r = n.undoTypes,
            a = !r[i] || r[i][e];
          t.isFunction(a) && a(n.object, n.before, n.after, n.options);
        }
        function h(e, i, r, a, o) {
          if (!(r.isCurrentlyUndoRedoing || "undo" === e && -1 === r.pointer || "redo" === e && r.pointer === r.length - 1)) {
            r.isCurrentlyUndoRedoing = !0;
            var s,
              l,
              c = "undo" === e;
            for (o ? l = c && r.pointer === r.length - 1 || !c && -1 === r.pointer ? t.clone(r.models) : n.apply(r.models, c ? [0, r.pointer] : [r.pointer, r.length - 1]) : (s = r.at(c ? r.pointer : r.pointer + 1), l = a ? r.where({
              magicFusionIndex: s.get("magicFusionIndex")
            }) : [s]), r.pointer += (c ? -1 : 1) * l.length; s = c ? l.pop() : l.shift();) s[e]();
            r.isCurrentlyUndoRedoing = !1, i.trigger(e, i);
          }
        }
        function p(t, e, n, r) {
          if (t.track && !t.isCurrentlyUndoRedoing && e in r && function (t, e) {
            var n = t.condition,
              r = typeof n;
            return "function" === r ? !!i(n, t, e) : "boolean" !== r || n;
          }(r[e], n)) {
            var o = i(r[e].on, r[e], n);
            if (a(o, "object", "before", "after")) {
              if (o.type = e, o.magicFusionIndex = l(), o.undoTypes = r, t.pointer < t.length - 1) for (var s = t.length - t.pointer - 1; s--;) t.pop();
              t.pointer = t.length, t.add(o), t.length > t.maximumStackLength && (t.shift(), t.pointer--);
            }
          }
        }
        c.prototype = {
          isRegistered: function isRegistered(e) {
            return e && e.cid ? this.registeredObjects[e.cid] : t.contains(this.registeredObjects, e);
          },
          register: function register(t) {
            return !this.isRegistered(t) && (t && t.cid ? (this.registeredObjects[t.cid] = t, this.cidIndexes.push(t.cid)) : this.registeredObjects.push(t), !0);
          },
          unregister: function unregister(e) {
            if (this.isRegistered(e)) {
              if (e && e.cid) delete this.registeredObjects[e.cid], this.cidIndexes.splice(t.indexOf(this.cidIndexes, e.cid), 1);else {
                var n = t.indexOf(this.registeredObjects, e);
                this.registeredObjects.splice(n, 1);
              }
              return !0;
            }
            return !1;
          },
          get: function get() {
            return t.map(this.cidIndexes, function (t) {
              return this.registeredObjects[t];
            }, this).concat(this.registeredObjects);
          }
        };
        var g = {
          add: {
            undo: function undo(t, e, n, i) {
              t.remove(n, i);
            },
            redo: function redo(t, e, n, i) {
              i.index && (i.at = i.index), t.add(n, i);
            },
            on: function on(e, n, i) {
              return {
                object: n,
                before: void 0,
                after: e,
                options: t.clone(i)
              };
            }
          },
          remove: {
            undo: function undo(t, e, n, i) {
              "index" in i && (i.at = i.index), t.add(e, i);
            },
            redo: function redo(t, e, n, i) {
              t.remove(e, i);
            },
            on: function on(e, n, i) {
              return {
                object: n,
                before: e,
                after: void 0,
                options: t.clone(i)
              };
            }
          },
          change: {
            undo: function undo(e, n, i, r) {
              t.isEmpty(n) ? t.each(t.keys(i), e.unset, e) : (e.set(n), r && r.unsetData && r.unsetData.before && r.unsetData.before.length && t.each(r.unsetData.before, e.unset, e));
            },
            redo: function redo(e, n, i, r) {
              t.isEmpty(i) ? t.each(t.keys(n), e.unset, e) : (e.set(i), r && r.unsetData && r.unsetData.after && r.unsetData.after.length && t.each(r.unsetData.after, e.unset, e));
            },
            on: function on(e, n) {
              var i = e.changedAttributes(),
                r = t.keys(i),
                a = t.pick(e.previousAttributes(), r),
                o = t.keys(a),
                s = (n || (n = {})).unsetData = {
                  after: [],
                  before: []
                };
              return r.length != o.length && (r.length > o.length ? t.each(r, function (t) {
                t in a || s.before.push(t);
              }, this) : t.each(o, function (t) {
                t in i || s.after.push(t);
              })), {
                object: e,
                before: a,
                after: i,
                options: t.clone(n)
              };
            }
          },
          reset: {
            undo: function undo(t, e, n) {
              t.reset(e);
            },
            redo: function redo(t, e, n) {
              t.reset(n);
            },
            on: function on(e, n) {
              return {
                object: e,
                before: n.previousModels,
                after: t.clone(e.models)
              };
            }
          }
        };
        function f() {}
        function m(e, n, i, r) {
          if ("object" == typeof n) return t.each(n, function (t, n) {
            2 === e ? m(e, t, i, r) : m(e, n, t, i);
          });
          switch (e) {
            case 0:
              a(i, "undo", "redo", "on") && t.all(t.pick(i, "undo", "redo", "on"), t.isFunction) && (r[n] = i);
              break;
            case 1:
              r[n] && t.isObject(i) && (r[n] = t.extend({}, r[n], i));
              break;
            case 2:
              delete r[n];
          }
          return this;
        }
        f.prototype = g;
        var v = e.Model.extend({
            defaults: {
              type: null,
              object: null,
              before: null,
              after: null,
              magicFusionIndex: null
            },
            undo: function undo(t) {
              u("undo", this.attributes);
            },
            redo: function redo(t) {
              u("redo", this.attributes);
            }
          }),
          b = e.Collection.extend({
            model: v,
            pointer: -1,
            track: !1,
            isCurrentlyUndoRedoing: !1,
            maximumStackLength: 1 / 0,
            setMaxLength: function setMaxLength(t) {
              this.maximumStackLength = t;
            }
          }),
          y = e.Model.extend({
            defaults: {
              maximumStackLength: 1 / 0,
              track: !1
            },
            initialize: function initialize(e) {
              this.stack = new b(), this.objectRegistry = new c(), this.undoTypes = new f(), this.stack.setMaxLength(this.get("maximumStackLength")), this.on("change:maximumStackLength", function (t, e) {
                this.stack.setMaxLength(e);
              }, this), e && e.track && this.startTracking(), e && e.register && (t.isArray(e.register) || t.isArguments(e.register) ? i(this.register, this, e.register) : this.register(e.register));
            },
            startTracking: function startTracking() {
              this.set("track", !0), this.stack.track = !0;
            },
            stopTracking: function stopTracking() {
              this.set("track", !1), this.stack.track = !1;
            },
            isTracking: function isTracking() {
              return this.get("track");
            },
            _addToStack: function _addToStack(t) {
              p(this.stack, t, r(arguments, 1), this.undoTypes);
            },
            register: function register() {
              d("on", arguments, this._addToStack, this);
            },
            unregister: function unregister() {
              d("off", arguments, this._addToStack, this);
            },
            unregisterAll: function unregisterAll() {
              i(this.unregister, this, this.objectRegistry.get());
            },
            undo: function undo(t) {
              h("undo", this, this.stack, t);
            },
            undoAll: function undoAll() {
              h("undo", this, this.stack, !1, !0);
            },
            redo: function redo(t) {
              h("redo", this, this.stack, t);
            },
            redoAll: function redoAll() {
              h("redo", this, this.stack, !1, !0);
            },
            isAvailable: function isAvailable(t) {
              var e = this.stack,
                n = e.length;
              switch (t) {
                case "undo":
                  return n > 0 && e.pointer > -1;
                case "redo":
                  return n > 0 && e.pointer < n - 1;
                default:
                  return !1;
              }
            },
            merge: function merge(e) {
              for (var n, i = t.isArray(e) ? e : r(arguments); n = i.pop();) n instanceof y && n.stack instanceof b && (n.stack = this.stack);
            },
            addUndoType: function addUndoType(t, e) {
              m(0, t, e, this.undoTypes);
            },
            changeUndoType: function changeUndoType(t, e) {
              m(1, t, e, this.undoTypes);
            },
            removeUndoType: function removeUndoType(t) {
              m(2, t, void 0, this.undoTypes);
            },
            clear: function clear() {
              this.stack.reset(), this.stack.pointer = -1;
            }
          });
        return t.extend(y, {
          defaults: function defaults(e) {
            t.extend(y.prototype.defaults, e);
          },
          addUndoType: function addUndoType(t, e) {
            m(0, t, e, g);
          },
          changeUndoType: function changeUndoType(t, e) {
            m(1, t, e, g);
          },
          removeUndoType: function removeUndoType(t) {
            m(2, t, void 0, g);
          }
        }), e.UndoManager = y;
      }) ? i.apply(e, r) : i) || (t.exports = a);
    }, function (t, e, n) {
      "use strict";

      e.a = function (t) {
        var e = this.constructor;
        return this.then(function (n) {
          return e.resolve(t()).then(function () {
            return n;
          });
        }, function (n) {
          return e.resolve(t()).then(function () {
            return e.reject(n);
          });
        });
      };
    }, function (t, e, n) {
      "use strict";

      e.a = function (t) {
        return new this(function (e, n) {
          if (!t || void 0 === t.length) return n(new TypeError(typeof t + " " + t + " is not iterable(cannot read property Symbol(Symbol.iterator))"));
          var i = Array.prototype.slice.call(t);
          if (0 === i.length) return e([]);
          var r = i.length;
          function a(t, n) {
            if (n && ("object" == typeof n || "function" == typeof n)) {
              var o = n.then;
              if ("function" == typeof o) return void o.call(n, function (e) {
                a(t, e);
              }, function (n) {
                i[t] = {
                  status: "rejected",
                  reason: n
                }, 0 == --r && e(i);
              });
            }
            i[t] = {
              status: "fulfilled",
              value: n
            }, 0 == --r && e(i);
          }
          for (var o = 0; o < i.length; o++) a(o, i[o]);
        });
      };
    }, function (t, e, n) {
      "use strict";

      function i(t, e) {
        this.name = "AggregateError", this.errors = t, this.message = e || "";
      }
      i.prototype = Error.prototype, e.a = function (t) {
        var e = this;
        return new e(function (n, r) {
          if (!t || void 0 === t.length) return r(new TypeError("Promise.any accepts an array"));
          var a = Array.prototype.slice.call(t);
          if (0 === a.length) return r();
          for (var o = [], s = 0; s < a.length; s++) try {
            e.resolve(a[s]).then(n).catch(function (t) {
              o.push(t), o.length === a.length && r(new i(o, "All promises were rejected"));
            });
          } catch (t) {
            r(t);
          }
        });
      };
    }, function (t, e, n) {
      var i = n(95),
        r = n(96),
        a = n(44),
        o = n(97);
      t.exports = function (t, e) {
        return i(t) || r(t, e) || a(t, e) || o();
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e, n) {
      var i = n(8).default;
      t.exports = function (t, e) {
        if ("object" != i(t) || !t) return t;
        var n = t[Symbol.toPrimitive];
        if (void 0 !== n) {
          var r = n.call(t, e || "default");
          if ("object" != i(r)) return r;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === e ? String : Number)(t);
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e, n) {
      var i = n(43);
      t.exports = function (t) {
        if (Array.isArray(t)) return i(t);
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e) {
      t.exports = function (t) {
        if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e) {
      t.exports = function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(8),
        r = n.n(i),
        a = n(2),
        o = n.n(a),
        s = n(0),
        l = n(39),
        c = n.n(l);
      function d(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function u(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? d(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.default = function () {
        var t,
          e,
          n = {},
          i = {
            defaults: {
              "core:undo": {
                keys: "⌘+z, ctrl+z",
                handler: "core:undo"
              },
              "core:redo": {
                keys: "⌘+shift+z, ctrl+shift+z",
                handler: "core:redo"
              },
              "core:copy": {
                keys: "⌘+c, ctrl+c",
                handler: "core:copy"
              },
              "core:paste": {
                keys: "⌘+v, ctrl+v",
                handler: "core:paste"
              },
              "core:component-next": {
                keys: "s",
                handler: "core:component-next"
              },
              "core:component-prev": {
                keys: "w",
                handler: "core:component-prev"
              },
              "core:component-enter": {
                keys: "d",
                handler: "core:component-enter"
              },
              "core:component-exit": {
                keys: "a",
                handler: "core:component-exit"
              },
              "core:component-delete": {
                keys: "backspace, delete",
                handler: "core:component-delete",
                opts: {
                  prevent: 1
                }
              }
            }
          };
        return {
          keymaster: c.a,
          name: "Keymaps",
          getConfig: function getConfig() {
            return e;
          },
          init: function init() {
            var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return e = u(u({}, i), n), t = e.em, this.em = t, this;
          },
          onLoad: function onLoad() {
            var t = e.defaults;
            for (var n in t) {
              var i = t[n];
              this.add(n, i.keys, i.handler, i.opts || {});
            }
          },
          add: function add(t, e, i) {
            var a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
              o = this.em,
              l = o.get("Commands"),
              d = o.getEditor(),
              u = o.get("Canvas"),
              h = {
                id: t,
                keys: e,
                handler: i
              },
              p = n[t];
            return p && this.remove(t), n[t] = h, c()(e, function (e, n) {
              var c = {
                event: e,
                h: n
              };
              if (i = Object(s.isString)(i) ? l.get(i) : i, !o.isEditing() && !d.Canvas.isInputFocused() || a.force) {
                a.prevent && u.getCanvasView().preventDefault(e), "object" == r()(i) ? l.runCommand(i, c) : i(d, 0, c);
                var h = [t, n.shortcut, e];
                o.trigger.apply(o, ["keymap:emit"].concat(h)), o.trigger.apply(o, ["keymap:emit:".concat(t)].concat(h));
              }
            }), o.trigger("keymap:add", h), h;
          },
          get: function get(t) {
            return n[t];
          },
          getAll: function getAll() {
            return n;
          },
          remove: function remove(t) {
            var e = this.em,
              i = this.get(t);
            if (i) return delete n[t], c.a.unbind(i.keys), e && e.trigger("keymap:remove", i), i;
          },
          removeAll: function removeAll() {
            var t = this;
            return Object.keys(n).forEach(function (e) {
              return t.remove(e);
            }), this;
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(2),
        r = n.n(i),
        a = n(76),
        o = n.n(a);
      function s(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function l(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? s(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.default = function () {
        var t,
          e,
          n,
          i,
          r = {
            maximumStackLength: 500
          };
        return {
          name: "UndoManager",
          init: function init() {
            var a = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            n = l(l({}, a), r), t = n.em, this.em = t, (e = new o.a(l({
              track: !0,
              register: []
            }, n))).changeUndoType("change", {
              condition: !1
            }), e.changeUndoType("add", {
              on: function on(t, e) {
                var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                if (!n.avoidStore) return {
                  object: e,
                  before: void 0,
                  after: t,
                  options: l({}, n)
                };
              }
            }), e.changeUndoType("remove", {
              on: function on(t, e) {
                var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                if (!n.avoidStore) return {
                  object: e,
                  before: t,
                  after: void 0,
                  options: l({}, n)
                };
              }
            });
            var s = {
                on: function on(t, e) {
                  var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                  if (!i && (i = t.previousAttributes()), !n.avoidStore) {
                    var r = {
                      object: t,
                      before: i,
                      after: t.toJSON()
                    };
                    return i = null, r;
                  }
                },
                undo: function undo(t, e, n, i) {
                  t.set(e);
                },
                redo: function redo(t, e, n, i) {
                  t.set(n);
                }
              },
              c = ["style", "attributes", "content", "src"];
            return c.forEach(function (t) {
              return e.addUndoType("change:".concat(t), s);
            }), e.on("undo redo", function () {
              return t.trigger("component:toggled change:canvasOffset");
            }), ["undo", "redo"].forEach(function (n) {
              return e.on(n, function () {
                return t.trigger(n);
              });
            }), this;
          },
          getConfig: function getConfig() {
            return n;
          },
          add: function add(t) {
            return e.register(t), this;
          },
          remove: function remove(t) {
            return e.unregister(t), this;
          },
          removeAll: function removeAll() {
            return e.unregisterAll(), this;
          },
          start: function start() {
            return e.startTracking(), this;
          },
          stop: function stop() {
            return e.stopTracking(), this;
          },
          undo: function undo() {
            var n = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
            return !t.isEditing() && e.undo(n), this;
          },
          undoAll: function undoAll() {
            return e.undoAll(), this;
          },
          redo: function redo() {
            var n = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
            return !t.isEditing() && e.redo(n), this;
          },
          redoAll: function redoAll() {
            return e.redoAll(), this;
          },
          hasUndo: function hasUndo() {
            return e.isAvailable("undo");
          },
          hasRedo: function hasRedo() {
            return e.isAvailable("redo");
          },
          getStack: function getStack() {
            return e.stack;
          },
          getStackGroup: function getStackGroup() {
            var t = [],
              e = [];
            return this.getStack().forEach(function (n) {
              var i = n.get("magicFusionIndex");
              e.indexOf(i) < 0 && (e.push(i), t.push(n));
            }), t;
          },
          getPointer: function getPointer() {
            return this.getStack().pointer;
          },
          clear: function clear() {
            return e.clear(), this;
          },
          getInstance: function getInstance() {
            return e;
          }
        };
      };
    }, function (t, e, n) {
      (function (t) {
        var i = void 0 !== t && t || "undefined" != typeof self && self || window,
          r = Function.prototype.apply;
        function a(t, e) {
          this._id = t, this._clearFn = e;
        }
        e.setTimeout = function () {
          return new a(r.call(setTimeout, i, arguments), clearTimeout);
        }, e.setInterval = function () {
          return new a(r.call(setInterval, i, arguments), clearInterval);
        }, e.clearTimeout = e.clearInterval = function (t) {
          t && t.close();
        }, a.prototype.unref = a.prototype.ref = function () {}, a.prototype.close = function () {
          this._clearFn.call(i, this._id);
        }, e.enroll = function (t, e) {
          clearTimeout(t._idleTimeoutId), t._idleTimeout = e;
        }, e.unenroll = function (t) {
          clearTimeout(t._idleTimeoutId), t._idleTimeout = -1;
        }, e._unrefActive = e.active = function (t) {
          clearTimeout(t._idleTimeoutId);
          var e = t._idleTimeout;
          e >= 0 && (t._idleTimeoutId = setTimeout(function () {
            t._onTimeout && t._onTimeout();
          }, e));
        }, n(88), e.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== t && t.setImmediate || this && this.setImmediate, e.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== t && t.clearImmediate || this && this.clearImmediate;
      }).call(this, n(26));
    }, function (t, e, n) {
      (function (t, e) {
        !function (t, n) {
          "use strict";

          if (!t.setImmediate) {
            var i,
              r,
              a,
              o,
              s,
              l = 1,
              c = {},
              d = !1,
              u = t.document,
              h = Object.getPrototypeOf && Object.getPrototypeOf(t);
            h = h && h.setTimeout ? h : t, "[object process]" === {}.toString.call(t.process) ? i = function i(t) {
              e.nextTick(function () {
                g(t);
              });
            } : function () {
              if (t.postMessage && !t.importScripts) {
                var e = !0,
                  n = t.onmessage;
                return t.onmessage = function () {
                  e = !1;
                }, t.postMessage("", "*"), t.onmessage = n, e;
              }
            }() ? (o = "setImmediate$" + Math.random() + "$", s = function s(e) {
              e.source === t && "string" == typeof e.data && 0 === e.data.indexOf(o) && g(+e.data.slice(o.length));
            }, t.addEventListener ? t.addEventListener("message", s, !1) : t.attachEvent("onmessage", s), i = function i(e) {
              t.postMessage(o + e, "*");
            }) : t.MessageChannel ? ((a = new MessageChannel()).port1.onmessage = function (t) {
              g(t.data);
            }, i = function i(t) {
              a.port2.postMessage(t);
            }) : u && "onreadystatechange" in u.createElement("script") ? (r = u.documentElement, i = function i(t) {
              var e = u.createElement("script");
              e.onreadystatechange = function () {
                g(t), e.onreadystatechange = null, r.removeChild(e), e = null;
              }, r.appendChild(e);
            }) : i = function i(t) {
              setTimeout(g, 0, t);
            }, h.setImmediate = function (t) {
              "function" != typeof t && (t = new Function("" + t));
              for (var e = new Array(arguments.length - 1), n = 0; n < e.length; n++) e[n] = arguments[n + 1];
              var r = {
                callback: t,
                args: e
              };
              return c[l] = r, i(l), l++;
            }, h.clearImmediate = p;
          }
          function p(t) {
            delete c[t];
          }
          function g(t) {
            if (d) setTimeout(g, 0, t);else {
              var e = c[t];
              if (e) {
                d = !0;
                try {
                  !function (t) {
                    var e = t.callback,
                      n = t.args;
                    switch (n.length) {
                      case 0:
                        e();
                        break;
                      case 1:
                        e(n[0]);
                        break;
                      case 2:
                        e(n[0], n[1]);
                        break;
                      case 3:
                        e(n[0], n[1], n[2]);
                        break;
                      default:
                        e.apply(void 0, n);
                    }
                  }(e);
                } finally {
                  p(t), d = !1;
                }
              }
            }
          }
        }("undefined" == typeof self ? void 0 === t ? this : t : self);
      }).call(this, n(26), n(89));
    }, function (t, e) {
      var n,
        i,
        r = t.exports = {};
      function a() {
        throw new Error("setTimeout has not been defined");
      }
      function o() {
        throw new Error("clearTimeout has not been defined");
      }
      function s(t) {
        if (n === setTimeout) return setTimeout(t, 0);
        if ((n === a || !n) && setTimeout) return n = setTimeout, setTimeout(t, 0);
        try {
          return n(t, 0);
        } catch (e) {
          try {
            return n.call(null, t, 0);
          } catch (e) {
            return n.call(this, t, 0);
          }
        }
      }
      !function () {
        try {
          n = "function" == typeof setTimeout ? setTimeout : a;
        } catch (t) {
          n = a;
        }
        try {
          i = "function" == typeof clearTimeout ? clearTimeout : o;
        } catch (t) {
          i = o;
        }
      }();
      var l,
        c = [],
        d = !1,
        u = -1;
      function h() {
        d && l && (d = !1, l.length ? c = l.concat(c) : u = -1, c.length && p());
      }
      function p() {
        if (!d) {
          var t = s(h);
          d = !0;
          for (var e = c.length; e;) {
            for (l = c, c = []; ++u < e;) l && l[u].run();
            u = -1, e = c.length;
          }
          l = null, d = !1, function (t) {
            if (i === clearTimeout) return clearTimeout(t);
            if ((i === o || !i) && clearTimeout) return i = clearTimeout, clearTimeout(t);
            try {
              i(t);
            } catch (e) {
              try {
                return i.call(null, t);
              } catch (e) {
                return i.call(this, t);
              }
            }
          }(t);
        }
      }
      function g(t, e) {
        this.fun = t, this.array = e;
      }
      function f() {}
      r.nextTick = function (t) {
        var e = new Array(arguments.length - 1);
        if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) e[n - 1] = arguments[n];
        c.push(new g(t, e)), 1 !== c.length || d || s(p);
      }, g.prototype.run = function () {
        this.fun.apply(null, this.array);
      }, r.title = "browser", r.browser = !0, r.env = {}, r.argv = [], r.version = "", r.versions = {}, r.on = f, r.addListener = f, r.once = f, r.off = f, r.removeListener = f, r.removeAllListeners = f, r.emit = f, r.prependListener = f, r.prependOnceListener = f, r.listeners = function (t) {
        return [];
      }, r.binding = function (t) {
        throw new Error("process.binding is not supported");
      }, r.cwd = function () {
        return "/";
      }, r.chdir = function (t) {
        throw new Error("process.chdir is not supported");
      }, r.umask = function () {
        return 0;
      };
    }, function (t, e) {
      t.exports = function (t, e) {
        if (null == t) return {};
        var n,
          i,
          r = {},
          a = Object.keys(t);
        for (i = 0; i < a.length; i++) n = a[i], e.indexOf(n) >= 0 || (r[n] = t[n]);
        return r;
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e, n) {
      !function (t) {
        "use strict";

        var e = {
            script: [["lang", /(javascript|babel)/i, "javascript"], ["type", /^(?:text|application)\/(?:x-)?(?:java|ecma)script$|^module$|^$/i, "javascript"], ["type", /./, "text/plain"], [null, null, "javascript"]],
            style: [["lang", /^css$/i, "css"], ["type", /^(text\/)?(x-)?(stylesheet|css)$/i, "css"], ["type", /./, "text/plain"], [null, null, "css"]]
          },
          n = {};
        function i(t, e) {
          var i = t.match(function (t) {
            return n[t] || (n[t] = new RegExp("\\s+" + t + "\\s*=\\s*('|\")?([^'\"]+)('|\")?\\s*"));
          }(e));
          return i ? /^\s*(.*?)\s*$/.exec(i[2])[1] : "";
        }
        function r(t, e) {
          return new RegExp((e ? "^" : "") + "</\\s*" + t + "\\s*>", "i");
        }
        function a(t, e) {
          for (var n in t) for (var i = e[n] || (e[n] = []), r = t[n], a = r.length - 1; a >= 0; a--) i.unshift(r[a]);
        }
        t.defineMode("htmlmixed", function (n, o) {
          var s = t.getMode(n, {
              name: "xml",
              htmlMode: !0,
              multilineTagIndentFactor: o.multilineTagIndentFactor,
              multilineTagIndentPastTag: o.multilineTagIndentPastTag,
              allowMissingTagName: o.allowMissingTagName
            }),
            l = {},
            c = o && o.tags,
            d = o && o.scriptTypes;
          if (a(e, l), c && a(c, l), d) for (var u = d.length - 1; u >= 0; u--) l.script.unshift(["type", d[u].matches, d[u].mode]);
          function h(e, a) {
            var o,
              c = s.token(e, a.htmlState),
              d = /\btag\b/.test(c);
            if (d && !/[<>\s\/]/.test(e.current()) && (o = a.htmlState.tagName && a.htmlState.tagName.toLowerCase()) && l.hasOwnProperty(o)) a.inTag = o + " ";else if (a.inTag && d && />$/.test(e.current())) {
              var u = /^([\S]+) (.*)/.exec(a.inTag);
              a.inTag = null;
              var p = ">" == e.current() && function (t, e) {
                  for (var n = 0; n < t.length; n++) {
                    var r = t[n];
                    if (!r[0] || r[1].test(i(e, r[0]))) return r[2];
                  }
                }(l[u[1]], u[2]),
                g = t.getMode(n, p),
                f = r(u[1], !0),
                m = r(u[1], !1);
              a.token = function (t, e) {
                return t.match(f, !1) ? (e.token = h, e.localState = e.localMode = null, null) : function (t, e, n) {
                  var i = t.current(),
                    r = i.search(e);
                  return r > -1 ? t.backUp(i.length - r) : i.match(/<\/?$/) && (t.backUp(i.length), t.match(e, !1) || t.match(i)), n;
                }(t, m, e.localMode.token(t, e.localState));
              }, a.localMode = g, a.localState = t.startState(g, s.indent(a.htmlState, "", ""));
            } else a.inTag && (a.inTag += e.current(), e.eol() && (a.inTag += " "));
            return c;
          }
          return {
            startState: function startState() {
              return {
                token: h,
                inTag: null,
                localMode: null,
                localState: null,
                htmlState: t.startState(s)
              };
            },
            copyState: function copyState(e) {
              var n;
              return e.localState && (n = t.copyState(e.localMode, e.localState)), {
                token: e.token,
                inTag: e.inTag,
                localMode: e.localMode,
                localState: n,
                htmlState: t.copyState(s, e.htmlState)
              };
            },
            token: function token(t, e) {
              return e.token(t, e);
            },
            indent: function indent(e, n, i) {
              return !e.localMode || /^\s*<\//.test(n) ? s.indent(e.htmlState, n, i) : e.localMode.indent ? e.localMode.indent(e.localState, n, i) : t.Pass;
            },
            innerMode: function innerMode(t) {
              return {
                state: t.localState || t.htmlState,
                mode: t.localMode || s
              };
            }
          };
        }, "xml", "javascript", "css"), t.defineMIME("text/html", "htmlmixed");
      }(n(13), n(92), n(93), n(45));
    }, function (t, e, n) {
      !function (t) {
        "use strict";

        var e = {
            autoSelfClosers: {
              area: !0,
              base: !0,
              br: !0,
              col: !0,
              command: !0,
              embed: !0,
              frame: !0,
              hr: !0,
              img: !0,
              input: !0,
              keygen: !0,
              link: !0,
              meta: !0,
              param: !0,
              source: !0,
              track: !0,
              wbr: !0,
              menuitem: !0
            },
            implicitlyClosed: {
              dd: !0,
              li: !0,
              optgroup: !0,
              option: !0,
              p: !0,
              rp: !0,
              rt: !0,
              tbody: !0,
              td: !0,
              tfoot: !0,
              th: !0,
              tr: !0
            },
            contextGrabbers: {
              dd: {
                dd: !0,
                dt: !0
              },
              dt: {
                dd: !0,
                dt: !0
              },
              li: {
                li: !0
              },
              option: {
                option: !0,
                optgroup: !0
              },
              optgroup: {
                optgroup: !0
              },
              p: {
                address: !0,
                article: !0,
                aside: !0,
                blockquote: !0,
                dir: !0,
                div: !0,
                dl: !0,
                fieldset: !0,
                footer: !0,
                form: !0,
                h1: !0,
                h2: !0,
                h3: !0,
                h4: !0,
                h5: !0,
                h6: !0,
                header: !0,
                hgroup: !0,
                hr: !0,
                menu: !0,
                nav: !0,
                ol: !0,
                p: !0,
                pre: !0,
                section: !0,
                table: !0,
                ul: !0
              },
              rp: {
                rp: !0,
                rt: !0
              },
              rt: {
                rp: !0,
                rt: !0
              },
              tbody: {
                tbody: !0,
                tfoot: !0
              },
              td: {
                td: !0,
                th: !0
              },
              tfoot: {
                tbody: !0
              },
              th: {
                td: !0,
                th: !0
              },
              thead: {
                tbody: !0,
                tfoot: !0
              },
              tr: {
                tr: !0
              }
            },
            doNotIndent: {
              pre: !0
            },
            allowUnquoted: !0,
            allowMissing: !0,
            caseFold: !0
          },
          n = {
            autoSelfClosers: {},
            implicitlyClosed: {},
            contextGrabbers: {},
            doNotIndent: {},
            allowUnquoted: !1,
            allowMissing: !1,
            allowMissingTagName: !1,
            caseFold: !1
          };
        t.defineMode("xml", function (i, r) {
          var a,
            o,
            s = i.indentUnit,
            l = {},
            c = r.htmlMode ? e : n;
          for (var d in c) l[d] = c[d];
          for (var d in r) l[d] = r[d];
          function u(t, e) {
            function n(n) {
              return e.tokenize = n, n(t, e);
            }
            var i = t.next();
            return "<" == i ? t.eat("!") ? t.eat("[") ? t.match("CDATA[") ? n(p("atom", "]]>")) : null : t.match("--") ? n(p("comment", "--\x3e")) : t.match("DOCTYPE", !0, !0) ? (t.eatWhile(/[\w\._\-]/), n(function t(e) {
              return function (n, i) {
                for (var r; null != (r = n.next());) {
                  if ("<" == r) return i.tokenize = t(e + 1), i.tokenize(n, i);
                  if (">" == r) {
                    if (1 == e) {
                      i.tokenize = u;
                      break;
                    }
                    return i.tokenize = t(e - 1), i.tokenize(n, i);
                  }
                }
                return "meta";
              };
            }(1))) : null : t.eat("?") ? (t.eatWhile(/[\w\._\-]/), e.tokenize = p("meta", "?>"), "meta") : (a = t.eat("/") ? "closeTag" : "openTag", e.tokenize = h, "tag bracket") : "&" == i ? (t.eat("#") ? t.eat("x") ? t.eatWhile(/[a-fA-F\d]/) && t.eat(";") : t.eatWhile(/[\d]/) && t.eat(";") : t.eatWhile(/[\w\.\-:]/) && t.eat(";")) ? "atom" : "error" : (t.eatWhile(/[^&<]/), null);
          }
          function h(t, e) {
            var n,
              i,
              r = t.next();
            if (">" == r || "/" == r && t.eat(">")) return e.tokenize = u, a = ">" == r ? "endTag" : "selfcloseTag", "tag bracket";
            if ("=" == r) return a = "equals", null;
            if ("<" == r) {
              e.tokenize = u, e.state = b, e.tagName = e.tagStart = null;
              var o = e.tokenize(t, e);
              return o ? o + " tag error" : "tag error";
            }
            return /[\'\"]/.test(r) ? (e.tokenize = (n = r, (i = function i(t, e) {
              for (; !t.eol();) if (t.next() == n) {
                e.tokenize = h;
                break;
              }
              return "string";
            }).isInAttribute = !0, i), e.stringStartCol = t.column(), e.tokenize(t, e)) : (t.match(/^[^\s\u00a0=<>\"\']*[^\s\u00a0=<>\"\'\/]/), "word");
          }
          function p(t, e) {
            return function (n, i) {
              for (; !n.eol();) {
                if (n.match(e)) {
                  i.tokenize = u;
                  break;
                }
                n.next();
              }
              return t;
            };
          }
          function g(t) {
            return t && t.toLowerCase();
          }
          function f(t, e, n) {
            this.prev = t.context, this.tagName = e || "", this.indent = t.indented, this.startOfLine = n, (l.doNotIndent.hasOwnProperty(e) || t.context && t.context.noIndent) && (this.noIndent = !0);
          }
          function m(t) {
            t.context && (t.context = t.context.prev);
          }
          function v(t, e) {
            for (var n;;) {
              if (!t.context) return;
              if (n = t.context.tagName, !l.contextGrabbers.hasOwnProperty(g(n)) || !l.contextGrabbers[g(n)].hasOwnProperty(g(e))) return;
              m(t);
            }
          }
          function b(t, e, n) {
            return "openTag" == t ? (n.tagStart = e.column(), y) : "closeTag" == t ? w : b;
          }
          function y(t, e, n) {
            return "word" == t ? (n.tagName = e.current(), o = "tag", C) : l.allowMissingTagName && "endTag" == t ? (o = "tag bracket", C(t, 0, n)) : (o = "error", y);
          }
          function w(t, e, n) {
            if ("word" == t) {
              var i = e.current();
              return n.context && n.context.tagName != i && l.implicitlyClosed.hasOwnProperty(g(n.context.tagName)) && m(n), n.context && n.context.tagName == i || !1 === l.matchClosing ? (o = "tag", x) : (o = "tag error", j);
            }
            return l.allowMissingTagName && "endTag" == t ? (o = "tag bracket", x(t, 0, n)) : (o = "error", j);
          }
          function x(t, e, n) {
            return "endTag" != t ? (o = "error", x) : (m(n), b);
          }
          function j(t, e, n) {
            return o = "error", x(t, 0, n);
          }
          function C(t, e, n) {
            if ("word" == t) return o = "attribute", M;
            if ("endTag" == t || "selfcloseTag" == t) {
              var i = n.tagName,
                r = n.tagStart;
              return n.tagName = n.tagStart = null, "selfcloseTag" == t || l.autoSelfClosers.hasOwnProperty(g(i)) ? v(n, i) : (v(n, i), n.context = new f(n, i, r == n.indented)), b;
            }
            return o = "error", C;
          }
          function M(t, e, n) {
            return "equals" == t ? k : (l.allowMissing || (o = "error"), C(t, 0, n));
          }
          function k(t, e, n) {
            return "string" == t ? O : "word" == t && l.allowUnquoted ? (o = "string", C) : (o = "error", C(t, 0, n));
          }
          function O(t, e, n) {
            return "string" == t ? O : C(t, 0, n);
          }
          return u.isInText = !0, {
            startState: function startState(t) {
              var e = {
                tokenize: u,
                state: b,
                indented: t || 0,
                tagName: null,
                tagStart: null,
                context: null
              };
              return null != t && (e.baseIndent = t), e;
            },
            token: function token(t, e) {
              if (!e.tagName && t.sol() && (e.indented = t.indentation()), t.eatSpace()) return null;
              a = null;
              var n = e.tokenize(t, e);
              return (n || a) && "comment" != n && (o = null, e.state = e.state(a || n, t, e), o && (n = "error" == o ? n + " error" : o)), n;
            },
            indent: function indent(e, n, i) {
              var r = e.context;
              if (e.tokenize.isInAttribute) return e.tagStart == e.indented ? e.stringStartCol + 1 : e.indented + s;
              if (r && r.noIndent) return t.Pass;
              if (e.tokenize != h && e.tokenize != u) return i ? i.match(/^(\s*)/)[0].length : 0;
              if (e.tagName) return !1 !== l.multilineTagIndentPastTag ? e.tagStart + e.tagName.length + 2 : e.tagStart + s * (l.multilineTagIndentFactor || 1);
              if (l.alignCDATA && /<!\[CDATA\[/.test(n)) return 0;
              var a = n && /^<(\/)?([\w_:\.-]*)/.exec(n);
              if (a && a[1]) for (; r;) {
                if (r.tagName == a[2]) {
                  r = r.prev;
                  break;
                }
                if (!l.implicitlyClosed.hasOwnProperty(g(r.tagName))) break;
                r = r.prev;
              } else if (a) for (; r;) {
                var o = l.contextGrabbers[g(r.tagName)];
                if (!o || !o.hasOwnProperty(g(a[2]))) break;
                r = r.prev;
              }
              for (; r && r.prev && !r.startOfLine;) r = r.prev;
              return r ? r.indent + s : e.baseIndent || 0;
            },
            electricInput: /<\/[\s\w:]+>$/,
            blockCommentStart: "\x3c!--",
            blockCommentEnd: "--\x3e",
            configuration: l.htmlMode ? "html" : "xml",
            helperType: l.htmlMode ? "html" : "xml",
            skipAttribute: function skipAttribute(t) {
              t.state == k && (t.state = C);
            },
            xmlCurrentTag: function xmlCurrentTag(t) {
              return t.tagName ? {
                name: t.tagName,
                close: "closeTag" == t.type
              } : null;
            },
            xmlCurrentContext: function xmlCurrentContext(t) {
              for (var e = [], n = t.context; n; n = n.prev) e.push(n.tagName);
              return e.reverse();
            }
          };
        }), t.defineMIME("text/xml", "xml"), t.defineMIME("application/xml", "xml"), t.mimeModes.hasOwnProperty("text/html") || t.defineMIME("text/html", {
          name: "xml",
          htmlMode: !0
        });
      }(n(13));
    }, function (t, e, n) {
      !function (t) {
        "use strict";

        t.defineMode("javascript", function (e, n) {
          var i,
            r,
            a = e.indentUnit,
            o = n.statementIndent,
            s = n.jsonld,
            l = n.json || s,
            c = !1 !== n.trackScope,
            d = n.typescript,
            u = n.wordCharacters || /[\w$\xa1-\uffff]/,
            h = function () {
              function t(t) {
                return {
                  type: t,
                  style: "keyword"
                };
              }
              var e = t("keyword a"),
                n = t("keyword b"),
                i = t("keyword c"),
                r = t("keyword d"),
                a = t("operator"),
                o = {
                  type: "atom",
                  style: "atom"
                };
              return {
                if: t("if"),
                while: e,
                with: e,
                else: n,
                do: n,
                try: n,
                finally: n,
                return: r,
                break: r,
                continue: r,
                new: t("new"),
                delete: i,
                void: i,
                throw: i,
                debugger: t("debugger"),
                var: t("var"),
                const: t("var"),
                let: t("var"),
                function: t("function"),
                catch: t("catch"),
                for: t("for"),
                switch: t("switch"),
                case: t("case"),
                default: t("default"),
                in: a,
                typeof: a,
                instanceof: a,
                true: o,
                false: o,
                null: o,
                undefined: o,
                NaN: o,
                Infinity: o,
                this: t("this"),
                class: t("class"),
                super: t("atom"),
                yield: i,
                export: t("export"),
                import: t("import"),
                extends: i,
                await: i
              };
            }(),
            p = /[+\-*&%=<>!?|~^@]/,
            g = /^@(context|id|value|language|type|container|list|set|reverse|index|base|vocab|graph)"/;
          function f(t, e, n) {
            return i = t, r = n, e;
          }
          function m(t, e) {
            var n,
              i = t.next();
            if ('"' == i || "'" == i) return e.tokenize = (n = i, function (t, e) {
              var i,
                r = !1;
              if (s && "@" == t.peek() && t.match(g)) return e.tokenize = m, f("jsonld-keyword", "meta");
              for (; null != (i = t.next()) && (i != n || r);) r = !r && "\\" == i;
              return r || (e.tokenize = m), f("string", "string");
            }), e.tokenize(t, e);
            if ("." == i && t.match(/^\d[\d_]*(?:[eE][+\-]?[\d_]+)?/)) return f("number", "number");
            if ("." == i && t.match("..")) return f("spread", "meta");
            if (/[\[\]{}\(\),;\:\.]/.test(i)) return f(i);
            if ("=" == i && t.eat(">")) return f("=>", "operator");
            if ("0" == i && t.match(/^(?:x[\dA-Fa-f_]+|o[0-7_]+|b[01_]+)n?/)) return f("number", "number");
            if (/\d/.test(i)) return t.match(/^[\d_]*(?:n|(?:\.[\d_]*)?(?:[eE][+\-]?[\d_]+)?)?/), f("number", "number");
            if ("/" == i) return t.eat("*") ? (e.tokenize = v, v(t, e)) : t.eat("/") ? (t.skipToEnd(), f("comment", "comment")) : Xt(t, e, 1) ? (function (t) {
              for (var e, n = !1, i = !1; null != (e = t.next());) {
                if (!n) {
                  if ("/" == e && !i) return;
                  "[" == e ? i = !0 : i && "]" == e && (i = !1);
                }
                n = !n && "\\" == e;
              }
            }(t), t.match(/^\b(([gimyus])(?![gimyus]*\2))+\b/), f("regexp", "string-2")) : (t.eat("="), f("operator", "operator", t.current()));
            if ("`" == i) return e.tokenize = b, b(t, e);
            if ("#" == i && "!" == t.peek()) return t.skipToEnd(), f("meta", "meta");
            if ("#" == i && t.eatWhile(u)) return f("variable", "property");
            if ("<" == i && t.match("!--") || "-" == i && t.match("->") && !/\S/.test(t.string.slice(0, t.start))) return t.skipToEnd(), f("comment", "comment");
            if (p.test(i)) return ">" == i && e.lexical && ">" == e.lexical.type || (t.eat("=") ? "!" != i && "=" != i || t.eat("=") : /[<>*+\-|&?]/.test(i) && (t.eat(i), ">" == i && t.eat(i))), "?" == i && t.eat(".") ? f(".") : f("operator", "operator", t.current());
            if (u.test(i)) {
              t.eatWhile(u);
              var r = t.current();
              if ("." != e.lastType) {
                if (h.propertyIsEnumerable(r)) {
                  var a = h[r];
                  return f(a.type, a.style, r);
                }
                if ("async" == r && t.match(/^(\s|\/\*([^*]|\*(?!\/))*?\*\/)*[\[\(\w]/, !1)) return f("async", "keyword", r);
              }
              return f("variable", "variable", r);
            }
          }
          function v(t, e) {
            for (var n, i = !1; n = t.next();) {
              if ("/" == n && i) {
                e.tokenize = m;
                break;
              }
              i = "*" == n;
            }
            return f("comment", "comment");
          }
          function b(t, e) {
            for (var n, i = !1; null != (n = t.next());) {
              if (!i && ("`" == n || "$" == n && t.eat("{"))) {
                e.tokenize = m;
                break;
              }
              i = !i && "\\" == n;
            }
            return f("quasi", "string-2", t.current());
          }
          function y(t, e) {
            e.fatArrowAt && (e.fatArrowAt = null);
            var n = t.string.indexOf("=>", t.start);
            if (!(n < 0)) {
              if (d) {
                var i = /:\s*(?:\w+(?:<[^>]*>|\[\])?|\{[^}]*\})\s*$/.exec(t.string.slice(t.start, n));
                i && (n = i.index);
              }
              for (var r = 0, a = !1, o = n - 1; o >= 0; --o) {
                var s = t.string.charAt(o),
                  l = "([{}])".indexOf(s);
                if (l >= 0 && l < 3) {
                  if (!r) {
                    ++o;
                    break;
                  }
                  if (0 == --r) {
                    "(" == s && (a = !0);
                    break;
                  }
                } else if (l >= 3 && l < 6) ++r;else if (u.test(s)) a = !0;else if (/["'\/`]/.test(s)) for (;; --o) {
                  if (0 == o) return;
                  if (t.string.charAt(o - 1) == s && "\\" != t.string.charAt(o - 2)) {
                    o--;
                    break;
                  }
                } else if (a && !r) {
                  ++o;
                  break;
                }
              }
              a && !r && (e.fatArrowAt = o);
            }
          }
          var w = {
            atom: !0,
            number: !0,
            variable: !0,
            string: !0,
            regexp: !0,
            this: !0,
            import: !0,
            "jsonld-keyword": !0
          };
          function x(t, e, n, i, r, a) {
            this.indented = t, this.column = e, this.type = n, this.prev = r, this.info = a, null != i && (this.align = i);
          }
          function j(t, e) {
            if (!c) return !1;
            for (var n = t.localVars; n; n = n.next) if (n.name == e) return !0;
            for (var i = t.context; i; i = i.prev) for (n = i.vars; n; n = n.next) if (n.name == e) return !0;
          }
          function C(t, e, n, i, r) {
            var a = t.cc;
            for (M.state = t, M.stream = r, M.marked = null, M.cc = a, M.style = e, t.lexical.hasOwnProperty("align") || (t.lexical.align = !0);;) if ((a.length ? a.pop() : l ? R : V)(n, i)) {
              for (; a.length && a[a.length - 1].lex;) a.pop()();
              return M.marked ? M.marked : "variable" == n && j(t, i) ? "variable-2" : e;
            }
          }
          var M = {
            state: null,
            column: null,
            marked: null,
            cc: null
          };
          function k() {
            for (var t = arguments.length - 1; t >= 0; t--) M.cc.push(arguments[t]);
          }
          function O() {
            return k.apply(null, arguments), !0;
          }
          function T(t, e) {
            for (var n = e; n; n = n.next) if (n.name == t) return !0;
            return !1;
          }
          function S(t) {
            var e = M.state;
            if (M.marked = "def", c) {
              if (e.context) if ("var" == e.lexical.info && e.context && e.context.block) {
                var i = function t(e, n) {
                  if (n) {
                    if (n.block) {
                      var i = t(e, n.prev);
                      return i ? i == n.prev ? n : new L(i, n.vars, !0) : null;
                    }
                    return T(e, n.vars) ? n : new L(n.prev, new D(e, n.vars), !1);
                  }
                  return null;
                }(t, e.context);
                if (null != i) return void (e.context = i);
              } else if (!T(t, e.localVars)) return void (e.localVars = new D(t, e.localVars));
              n.globalVars && !T(t, e.globalVars) && (e.globalVars = new D(t, e.globalVars));
            }
          }
          function N(t) {
            return "public" == t || "private" == t || "protected" == t || "abstract" == t || "readonly" == t;
          }
          function L(t, e, n) {
            this.prev = t, this.vars = e, this.block = n;
          }
          function D(t, e) {
            this.name = t, this.next = e;
          }
          var E = new D("this", new D("arguments", null));
          function I() {
            M.state.context = new L(M.state.context, M.state.localVars, !1), M.state.localVars = E;
          }
          function P() {
            M.state.context = new L(M.state.context, M.state.localVars, !0), M.state.localVars = null;
          }
          function A() {
            M.state.localVars = M.state.context.vars, M.state.context = M.state.context.prev;
          }
          function z(t, e) {
            var n = function n() {
              var n = M.state,
                i = n.indented;
              if ("stat" == n.lexical.type) i = n.lexical.indented;else for (var r = n.lexical; r && ")" == r.type && r.align; r = r.prev) i = r.indented;
              n.lexical = new x(i, M.stream.column(), t, null, n.lexical, e);
            };
            return n.lex = !0, n;
          }
          function _() {
            var t = M.state;
            t.lexical.prev && (")" == t.lexical.type && (t.indented = t.lexical.indented), t.lexical = t.lexical.prev);
          }
          function H(t) {
            return function e(n) {
              return n == t ? O() : ";" == t || "}" == n || ")" == n || "]" == n ? k() : O(e);
            };
          }
          function V(t, e) {
            return "var" == t ? O(z("vardef", e), Ct, H(";"), _) : "keyword a" == t ? O(z("form"), W, V, _) : "keyword b" == t ? O(z("form"), V, _) : "keyword d" == t ? M.stream.match(/^\s*$/, !1) ? O() : O(z("stat"), U, H(";"), _) : "debugger" == t ? O(H(";")) : "{" == t ? O(z("}"), P, st, _, A) : ";" == t ? O() : "if" == t ? ("else" == M.state.lexical.info && M.state.cc[M.state.cc.length - 1] == _ && M.state.cc.pop()(), O(z("form"), W, V, _, Nt)) : "function" == t ? O(It) : "for" == t ? O(z("form"), P, Lt, V, A, _) : "class" == t || d && "interface" == e ? (M.marked = "keyword", O(z("form", "class" == t ? t : e), Ht, _)) : "variable" == t ? d && "declare" == e ? (M.marked = "keyword", O(V)) : d && ("module" == e || "enum" == e || "type" == e) && M.stream.match(/^\s*\w/, !1) ? (M.marked = "keyword", "enum" == e ? O(Qt) : "type" == e ? O(At, H("operator"), ht, H(";")) : O(z("form"), Mt, H("{"), z("}"), st, _, _)) : d && "namespace" == e ? (M.marked = "keyword", O(z("form"), R, V, _)) : d && "abstract" == e ? (M.marked = "keyword", O(V)) : O(z("stat"), tt) : "switch" == t ? O(z("form"), W, H("{"), z("}", "switch"), P, st, _, _, A) : "case" == t ? O(R, H(":")) : "default" == t ? O(H(":")) : "catch" == t ? O(z("form"), I, F, V, _, A) : "export" == t ? O(z("stat"), Bt, _) : "import" == t ? O(z("stat"), Yt, _) : "async" == t ? O(V) : "@" == e ? O(R, V) : k(z("stat"), R, H(";"), _);
          }
          function F(t) {
            if ("(" == t) return O(zt, H(")"));
          }
          function R(t, e) {
            return Y(t, e, !1);
          }
          function B(t, e) {
            return Y(t, e, !0);
          }
          function W(t) {
            return "(" != t ? k() : O(z(")"), U, H(")"), _);
          }
          function Y(t, e, n) {
            if (M.state.fatArrowAt == M.stream.start) {
              var i = n ? J : Q;
              if ("(" == t) return O(I, z(")"), at(zt, ")"), _, H("=>"), i, A);
              if ("variable" == t) return k(I, Mt, H("=>"), i, A);
            }
            var r = n ? G : Z;
            return w.hasOwnProperty(t) ? O(r) : "function" == t ? O(It, r) : "class" == t || d && "interface" == e ? (M.marked = "keyword", O(z("form"), _t, _)) : "keyword c" == t || "async" == t ? O(n ? B : R) : "(" == t ? O(z(")"), U, H(")"), _, r) : "operator" == t || "spread" == t ? O(n ? B : R) : "[" == t ? O(z("]"), $t, _, r) : "{" == t ? ot(nt, "}", null, r) : "quasi" == t ? k(q, r) : "new" == t ? O(function (t) {
              return function (e) {
                return "." == e ? O(t ? K : X) : "variable" == e && d ? O(wt, t ? G : Z) : k(t ? B : R);
              };
            }(n)) : O();
          }
          function U(t) {
            return t.match(/[;\}\)\],]/) ? k() : k(R);
          }
          function Z(t, e) {
            return "," == t ? O(U) : G(t, e, !1);
          }
          function G(t, e, n) {
            var i = 0 == n ? Z : G,
              r = 0 == n ? R : B;
            return "=>" == t ? O(I, n ? J : Q, A) : "operator" == t ? /\+\+|--/.test(e) || d && "!" == e ? O(i) : d && "<" == e && M.stream.match(/^([^<>]|<[^<>]*>)*>\s*\(/, !1) ? O(z(">"), at(ht, ">"), _, i) : "?" == e ? O(R, H(":"), r) : O(r) : "quasi" == t ? k(q, i) : ";" != t ? "(" == t ? ot(B, ")", "call", i) : "." == t ? O(et, i) : "[" == t ? O(z("]"), U, H("]"), _, i) : d && "as" == e ? (M.marked = "keyword", O(ht, i)) : "regexp" == t ? (M.state.lastType = M.marked = "operator", M.stream.backUp(M.stream.pos - M.stream.start - 1), O(r)) : void 0 : void 0;
          }
          function q(t, e) {
            return "quasi" != t ? k() : "${" != e.slice(e.length - 2) ? O(q) : O(U, $);
          }
          function $(t) {
            if ("}" == t) return M.marked = "string-2", M.state.tokenize = b, O(q);
          }
          function Q(t) {
            return y(M.stream, M.state), k("{" == t ? V : R);
          }
          function J(t) {
            return y(M.stream, M.state), k("{" == t ? V : B);
          }
          function X(t, e) {
            if ("target" == e) return M.marked = "keyword", O(Z);
          }
          function K(t, e) {
            if ("target" == e) return M.marked = "keyword", O(G);
          }
          function tt(t) {
            return ":" == t ? O(_, V) : k(Z, H(";"), _);
          }
          function et(t) {
            if ("variable" == t) return M.marked = "property", O();
          }
          function nt(t, e) {
            return "async" == t ? (M.marked = "property", O(nt)) : "variable" == t || "keyword" == M.style ? (M.marked = "property", "get" == e || "set" == e ? O(it) : (d && M.state.fatArrowAt == M.stream.start && (n = M.stream.match(/^\s*:\s*/, !1)) && (M.state.fatArrowAt = M.stream.pos + n[0].length), O(rt))) : "number" == t || "string" == t ? (M.marked = s ? "property" : M.style + " property", O(rt)) : "jsonld-keyword" == t ? O(rt) : d && N(e) ? (M.marked = "keyword", O(nt)) : "[" == t ? O(R, lt, H("]"), rt) : "spread" == t ? O(B, rt) : "*" == e ? (M.marked = "keyword", O(nt)) : ":" == t ? k(rt) : void 0;
            var n;
          }
          function it(t) {
            return "variable" != t ? k(rt) : (M.marked = "property", O(It));
          }
          function rt(t) {
            return ":" == t ? O(B) : "(" == t ? k(It) : void 0;
          }
          function at(t, e, n) {
            function i(r, a) {
              if (n ? n.indexOf(r) > -1 : "," == r) {
                var o = M.state.lexical;
                return "call" == o.info && (o.pos = (o.pos || 0) + 1), O(function (n, i) {
                  return n == e || i == e ? k() : k(t);
                }, i);
              }
              return r == e || a == e ? O() : n && n.indexOf(";") > -1 ? k(t) : O(H(e));
            }
            return function (n, r) {
              return n == e || r == e ? O() : k(t, i);
            };
          }
          function ot(t, e, n) {
            for (var i = 3; i < arguments.length; i++) M.cc.push(arguments[i]);
            return O(z(e, n), at(t, e), _);
          }
          function st(t) {
            return "}" == t ? O() : k(V, st);
          }
          function lt(t, e) {
            if (d) {
              if (":" == t) return O(ht);
              if ("?" == e) return O(lt);
            }
          }
          function ct(t, e) {
            if (d && (":" == t || "in" == e)) return O(ht);
          }
          function dt(t) {
            if (d && ":" == t) return M.stream.match(/^\s*\w+\s+is\b/, !1) ? O(R, ut, ht) : O(ht);
          }
          function ut(t, e) {
            if ("is" == e) return M.marked = "keyword", O();
          }
          function ht(t, e) {
            return "keyof" == e || "typeof" == e || "infer" == e || "readonly" == e ? (M.marked = "keyword", O("typeof" == e ? B : ht)) : "variable" == t || "void" == e ? (M.marked = "type", O(yt)) : "|" == e || "&" == e ? O(ht) : "string" == t || "number" == t || "atom" == t ? O(yt) : "[" == t ? O(z("]"), at(ht, "]", ","), _, yt) : "{" == t ? O(z("}"), gt, _, yt) : "(" == t ? O(at(bt, ")"), pt, yt) : "<" == t ? O(at(ht, ">"), ht) : "quasi" == t ? k(mt, yt) : void 0;
          }
          function pt(t) {
            if ("=>" == t) return O(ht);
          }
          function gt(t) {
            return t.match(/[\}\)\]]/) ? O() : "," == t || ";" == t ? O(gt) : k(ft, gt);
          }
          function ft(t, e) {
            return "variable" == t || "keyword" == M.style ? (M.marked = "property", O(ft)) : "?" == e || "number" == t || "string" == t ? O(ft) : ":" == t ? O(ht) : "[" == t ? O(H("variable"), ct, H("]"), ft) : "(" == t ? k(Pt, ft) : t.match(/[;\}\)\],]/) ? void 0 : O();
          }
          function mt(t, e) {
            return "quasi" != t ? k() : "${" != e.slice(e.length - 2) ? O(mt) : O(ht, vt);
          }
          function vt(t) {
            if ("}" == t) return M.marked = "string-2", M.state.tokenize = b, O(mt);
          }
          function bt(t, e) {
            return "variable" == t && M.stream.match(/^\s*[?:]/, !1) || "?" == e ? O(bt) : ":" == t ? O(ht) : "spread" == t ? O(bt) : k(ht);
          }
          function yt(t, e) {
            return "<" == e ? O(z(">"), at(ht, ">"), _, yt) : "|" == e || "." == t || "&" == e ? O(ht) : "[" == t ? O(ht, H("]"), yt) : "extends" == e || "implements" == e ? (M.marked = "keyword", O(ht)) : "?" == e ? O(ht, H(":"), ht) : void 0;
          }
          function wt(t, e) {
            if ("<" == e) return O(z(">"), at(ht, ">"), _, yt);
          }
          function xt() {
            return k(ht, jt);
          }
          function jt(t, e) {
            if ("=" == e) return O(ht);
          }
          function Ct(t, e) {
            return "enum" == e ? (M.marked = "keyword", O(Qt)) : k(Mt, lt, Tt, St);
          }
          function Mt(t, e) {
            return d && N(e) ? (M.marked = "keyword", O(Mt)) : "variable" == t ? (S(e), O()) : "spread" == t ? O(Mt) : "[" == t ? ot(Ot, "]") : "{" == t ? ot(kt, "}") : void 0;
          }
          function kt(t, e) {
            return "variable" != t || M.stream.match(/^\s*:/, !1) ? ("variable" == t && (M.marked = "property"), "spread" == t ? O(Mt) : "}" == t ? k() : "[" == t ? O(R, H("]"), H(":"), kt) : O(H(":"), Mt, Tt)) : (S(e), O(Tt));
          }
          function Ot() {
            return k(Mt, Tt);
          }
          function Tt(t, e) {
            if ("=" == e) return O(B);
          }
          function St(t) {
            if ("," == t) return O(Ct);
          }
          function Nt(t, e) {
            if ("keyword b" == t && "else" == e) return O(z("form", "else"), V, _);
          }
          function Lt(t, e) {
            return "await" == e ? O(Lt) : "(" == t ? O(z(")"), Dt, _) : void 0;
          }
          function Dt(t) {
            return "var" == t ? O(Ct, Et) : "variable" == t ? O(Et) : k(Et);
          }
          function Et(t, e) {
            return ")" == t ? O() : ";" == t ? O(Et) : "in" == e || "of" == e ? (M.marked = "keyword", O(R, Et)) : k(R, Et);
          }
          function It(t, e) {
            return "*" == e ? (M.marked = "keyword", O(It)) : "variable" == t ? (S(e), O(It)) : "(" == t ? O(I, z(")"), at(zt, ")"), _, dt, V, A) : d && "<" == e ? O(z(">"), at(xt, ">"), _, It) : void 0;
          }
          function Pt(t, e) {
            return "*" == e ? (M.marked = "keyword", O(Pt)) : "variable" == t ? (S(e), O(Pt)) : "(" == t ? O(I, z(")"), at(zt, ")"), _, dt, A) : d && "<" == e ? O(z(">"), at(xt, ">"), _, Pt) : void 0;
          }
          function At(t, e) {
            return "keyword" == t || "variable" == t ? (M.marked = "type", O(At)) : "<" == e ? O(z(">"), at(xt, ">"), _) : void 0;
          }
          function zt(t, e) {
            return "@" == e && O(R, zt), "spread" == t ? O(zt) : d && N(e) ? (M.marked = "keyword", O(zt)) : d && "this" == t ? O(lt, Tt) : k(Mt, lt, Tt);
          }
          function _t(t, e) {
            return "variable" == t ? Ht(t, e) : Vt(t, e);
          }
          function Ht(t, e) {
            if ("variable" == t) return S(e), O(Vt);
          }
          function Vt(t, e) {
            return "<" == e ? O(z(">"), at(xt, ">"), _, Vt) : "extends" == e || "implements" == e || d && "," == t ? ("implements" == e && (M.marked = "keyword"), O(d ? ht : R, Vt)) : "{" == t ? O(z("}"), Ft, _) : void 0;
          }
          function Ft(t, e) {
            return "async" == t || "variable" == t && ("static" == e || "get" == e || "set" == e || d && N(e)) && M.stream.match(/^\s+#?[\w$\xa1-\uffff]/, !1) ? (M.marked = "keyword", O(Ft)) : "variable" == t || "keyword" == M.style ? (M.marked = "property", O(Rt, Ft)) : "number" == t || "string" == t ? O(Rt, Ft) : "[" == t ? O(R, lt, H("]"), Rt, Ft) : "*" == e ? (M.marked = "keyword", O(Ft)) : d && "(" == t ? k(Pt, Ft) : ";" == t || "," == t ? O(Ft) : "}" == t ? O() : "@" == e ? O(R, Ft) : void 0;
          }
          function Rt(t, e) {
            if ("!" == e) return O(Rt);
            if ("?" == e) return O(Rt);
            if (":" == t) return O(ht, Tt);
            if ("=" == e) return O(B);
            var n = M.state.lexical.prev;
            return k(n && "interface" == n.info ? Pt : It);
          }
          function Bt(t, e) {
            return "*" == e ? (M.marked = "keyword", O(qt, H(";"))) : "default" == e ? (M.marked = "keyword", O(R, H(";"))) : "{" == t ? O(at(Wt, "}"), qt, H(";")) : k(V);
          }
          function Wt(t, e) {
            return "as" == e ? (M.marked = "keyword", O(H("variable"))) : "variable" == t ? k(B, Wt) : void 0;
          }
          function Yt(t) {
            return "string" == t ? O() : "(" == t ? k(R) : "." == t ? k(Z) : k(Ut, Zt, qt);
          }
          function Ut(t, e) {
            return "{" == t ? ot(Ut, "}") : ("variable" == t && S(e), "*" == e && (M.marked = "keyword"), O(Gt));
          }
          function Zt(t) {
            if ("," == t) return O(Ut, Zt);
          }
          function Gt(t, e) {
            if ("as" == e) return M.marked = "keyword", O(Ut);
          }
          function qt(t, e) {
            if ("from" == e) return M.marked = "keyword", O(R);
          }
          function $t(t) {
            return "]" == t ? O() : k(at(B, "]"));
          }
          function Qt() {
            return k(z("form"), Mt, H("{"), z("}"), at(Jt, "}"), _, _);
          }
          function Jt() {
            return k(Mt, Tt);
          }
          function Xt(t, e, n) {
            return e.tokenize == m && /^(?:operator|sof|keyword [bcd]|case|new|export|default|spread|[\[{}\(,;:]|=>)$/.test(e.lastType) || "quasi" == e.lastType && /\{\s*$/.test(t.string.slice(0, t.pos - (n || 0)));
          }
          return I.lex = P.lex = !0, A.lex = !0, _.lex = !0, {
            startState: function startState(t) {
              var e = {
                tokenize: m,
                lastType: "sof",
                cc: [],
                lexical: new x((t || 0) - a, 0, "block", !1),
                localVars: n.localVars,
                context: n.localVars && new L(null, null, !1),
                indented: t || 0
              };
              return n.globalVars && "object" == typeof n.globalVars && (e.globalVars = n.globalVars), e;
            },
            token: function token(t, e) {
              if (t.sol() && (e.lexical.hasOwnProperty("align") || (e.lexical.align = !1), e.indented = t.indentation(), y(t, e)), e.tokenize != v && t.eatSpace()) return null;
              var n = e.tokenize(t, e);
              return "comment" == i ? n : (e.lastType = "operator" != i || "++" != r && "--" != r ? i : "incdec", C(e, n, i, r, t));
            },
            indent: function indent(e, i) {
              if (e.tokenize == v || e.tokenize == b) return t.Pass;
              if (e.tokenize != m) return 0;
              var r,
                s = i && i.charAt(0),
                l = e.lexical;
              if (!/^\s*else\b/.test(i)) for (var c = e.cc.length - 1; c >= 0; --c) {
                var d = e.cc[c];
                if (d == _) l = l.prev;else if (d != Nt && d != A) break;
              }
              for (; ("stat" == l.type || "form" == l.type) && ("}" == s || (r = e.cc[e.cc.length - 1]) && (r == Z || r == G) && !/^[,\.=+\-*:?[\(]/.test(i));) l = l.prev;
              o && ")" == l.type && "stat" == l.prev.type && (l = l.prev);
              var u = l.type,
                h = s == u;
              return "vardef" == u ? l.indented + ("operator" == e.lastType || "," == e.lastType ? l.info.length + 1 : 0) : "form" == u && "{" == s ? l.indented : "form" == u ? l.indented + a : "stat" == u ? l.indented + (function (t, e) {
                return "operator" == t.lastType || "," == t.lastType || p.test(e.charAt(0)) || /[,.]/.test(e.charAt(0));
              }(e, i) ? o || a : 0) : "switch" != l.info || h || 0 == n.doubleIndentSwitch ? l.align ? l.column + (h ? 0 : 1) : l.indented + (h ? 0 : a) : l.indented + (/^(?:case|default)\b/.test(i) ? a : 2 * a);
            },
            electricInput: /^\s*(?:case .*?:|default:|\{|\})$/,
            blockCommentStart: l ? null : "/*",
            blockCommentEnd: l ? null : "*/",
            blockCommentContinue: l ? null : " * ",
            lineComment: l ? null : "//",
            fold: "brace",
            closeBrackets: "()[]{}''\"\"``",
            helperType: l ? "json" : "javascript",
            jsonldMode: s,
            jsonMode: l,
            expressionAllowed: Xt,
            skipExpression: function skipExpression(e) {
              C(e, "atom", "atom", "true", new t.StringStream("", 2, null));
            }
          };
        }), t.registerHelper("wordChars", "javascript", /[\w$]/), t.defineMIME("text/javascript", "javascript"), t.defineMIME("text/ecmascript", "javascript"), t.defineMIME("application/javascript", "javascript"), t.defineMIME("application/x-javascript", "javascript"), t.defineMIME("application/ecmascript", "javascript"), t.defineMIME("application/json", {
          name: "javascript",
          json: !0
        }), t.defineMIME("application/x-json", {
          name: "javascript",
          json: !0
        }), t.defineMIME("application/manifest+json", {
          name: "javascript",
          json: !0
        }), t.defineMIME("application/ld+json", {
          name: "javascript",
          jsonld: !0
        }), t.defineMIME("text/typescript", {
          name: "javascript",
          typescript: !0
        }), t.defineMIME("application/typescript", {
          name: "javascript",
          typescript: !0
        });
      }(n(13));
    }, function (t, e, n) {
      !function (t) {
        t.extendMode("css", {
          commentStart: "/*",
          commentEnd: "*/",
          newlineAfterToken: function newlineAfterToken(t, e) {
            return /^[;{}]$/.test(e);
          }
        }), t.extendMode("javascript", {
          commentStart: "/*",
          commentEnd: "*/",
          newlineAfterToken: function newlineAfterToken(t, e, n, i) {
            return this.jsonMode ? /^[\[,{]$/.test(e) || /^}/.test(n) : (";" != e || !i.lexical || ")" != i.lexical.type) && /^[;{}]$/.test(e) && !/^;/.test(n);
          }
        });
        var e = /^(a|abbr|acronym|area|base|bdo|big|br|button|caption|cite|code|col|colgroup|dd|del|dfn|em|frame|hr|iframe|img|input|ins|kbd|label|legend|link|map|object|optgroup|option|param|q|samp|script|select|small|span|strong|sub|sup|textarea|tt|var)$/;
        t.extendMode("xml", {
          commentStart: "\x3c!--",
          commentEnd: "--\x3e",
          newlineAfterToken: function newlineAfterToken(t, n, i, r) {
            var a = !1;
            return "html" == this.configuration && (a = !!r.context && e.test(r.context.tagName)), !a && ("tag" == t && />$/.test(n) && r.context || /^</.test(i));
          }
        }), t.defineExtension("commentRange", function (e, n, i) {
          var r = this,
            a = t.innerMode(r.getMode(), r.getTokenAt(n).state).mode;
          r.operation(function () {
            if (e) r.replaceRange(a.commentEnd, i), r.replaceRange(a.commentStart, n), n.line == i.line && n.ch == i.ch && r.setCursor(n.line, n.ch + a.commentStart.length);else {
              var t = r.getRange(n, i),
                o = t.indexOf(a.commentStart),
                s = t.lastIndexOf(a.commentEnd);
              o > -1 && s > -1 && s > o && (t = t.substr(0, o) + t.substring(o + a.commentStart.length, s) + t.substr(s + a.commentEnd.length)), r.replaceRange(t, n, i);
            }
          });
        }), t.defineExtension("autoIndentRange", function (t, e) {
          var n = this;
          this.operation(function () {
            for (var i = t.line; i <= e.line; i++) n.indentLine(i, "smart");
          });
        }), t.defineExtension("autoFormatRange", function (e, n) {
          var i = this,
            r = i.getMode(),
            a = i.getRange(e, n).split("\n"),
            o = t.copyState(r, i.getTokenAt(e).state),
            s = i.getOption("tabSize"),
            l = "",
            c = 0,
            d = 0 === e.ch;
          function u() {
            l += "\n", d = !0, ++c;
          }
          for (var h = 0; h < a.length; ++h) {
            for (var p = new t.StringStream(a[h], s); !p.eol();) {
              var g = t.innerMode(r, o),
                f = r.token(p, o),
                m = p.current();
              p.start = p.pos, d && !/\S/.test(m) || (l += m, d = !1), !d && g.mode.newlineAfterToken && g.mode.newlineAfterToken(f, m, p.string.slice(p.pos) || a[h + 1] || "", g.state) && u();
            }
            !p.pos && r.blankLine && r.blankLine(o), !d && h < a.length - 1 && u();
          }
          i.operation(function () {
            i.replaceRange(l, e, n);
            for (var t = e.line + 1, r = e.line + c; t <= r; ++t) i.indentLine(t, "smart");
            i.setSelection(e, i.getCursor(!1));
          });
        });
      }(n(13));
    }, function (t, e) {
      t.exports = function (t) {
        if (Array.isArray(t)) return t;
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e) {
      t.exports = function (t, e) {
        var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
        if (null != n) {
          var i,
            r,
            a,
            o,
            s = [],
            l = !0,
            c = !1;
          try {
            if (a = (n = n.call(t)).next, 0 === e) {
              if (Object(n) !== n) return;
              l = !1;
            } else for (; !(l = (i = a.call(n)).done) && (s.push(i.value), s.length !== e); l = !0);
          } catch (t) {
            c = !0, r = t;
          } finally {
            try {
              if (!l && null != n.return && (o = n.return(), Object(o) !== o)) return;
            } finally {
              if (c) throw r;
            }
          }
          return s;
        }
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e) {
      t.exports = function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(1),
        r = n.n(i),
        a = n(36),
        o = n(5);
      e.default = r.a.View.extend({
        initialize: function initialize() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          this.opt = t;
          var e = t.config || {};
          this.level = t.level, this.config = e, this.preview = t.preview, this.ppfx = e.pStylePrefix || "", this.pfx = e.stylePrefix || "", this.parent = t.parent, this.parentView = t.parentView;
          var n = this.pfx,
            i = this.ppfx,
            r = this.parent,
            a = this.collection;
          this.listenTo(a, "add", this.addTo), this.listenTo(a, "reset resetNavigator", this.render), this.listenTo(a, "remove", this.removeChildren), this.className = "".concat(n, "layers");
          var s = e.em;
          if (e.sortable && !this.opt.sorter) {
            var l = s.get("Utils");
            this.opt.sorter = new l.Sorter({
              container: e.sortContainer || this.el,
              containerSel: ".".concat(this.className),
              itemSel: ".".concat(n, "layer"),
              ignoreViewChildren: 1,
              onEndMove: function onEndMove(t, e, n) {
                var i = e.getSourceModel();
                s.setSelected(i, {
                  forceChange: 1
                }), s.trigger("".concat(o.eventDrag, ":end"), n);
              },
              avoidSelectOnEnd: 1,
              nested: 1,
              ppfx: i,
              pfx: n
            });
          }
          this.sorter = this.opt.sorter || "", this.$el.data("collection", a), r && this.$el.data("model", r);
        },
        removeChildren: function removeChildren(t) {
          var e = t.viewLayer;
          e && (e.remove(), t.viewLayer = 0);
        },
        addTo: function addTo(t) {
          var e = this.collection.indexOf(t);
          this.addToCollection(t, null, e);
        },
        addToCollection: function addToCollection(t, e, n) {
          var i = this.level,
            r = this.parentView,
            o = e || null,
            s = new (0, a.a)({
              level: i,
              model: t,
              parentView: r,
              config: this.config,
              sorter: this.sorter,
              isCountable: this.isCountable,
              opened: this.opt.opened
            }).render().el;
          if (o) o.appendChild(s);else if (void 0 !== n) {
            var l = "before";
            this.$el.children().length == n && (n--, l = "after"), n < 0 ? this.$el.append(s) : this.$el.children().eq(n)[l](s);
          } else this.$el.append(s);
          return s;
        },
        isCountable: function isCountable(t, e) {
          var n = t.get("type"),
            i = t.get("tagName");
          return !(("textnode" == n || "br" == i) && e || !t.get("layerable"));
        },
        render: function render() {
          var t = this,
            e = document.createDocumentFragment(),
            n = this.el;
          return n.innerHTML = "", this.collection.each(function (n) {
            return t.addToCollection(n, e);
          }), n.appendChild(e), n.className = this.className, this;
        }
      });
    }, function (t, e, n) {
      var i = {
        "./CanvasClear": 46,
        "./CanvasClear.js": 46,
        "./CanvasMove": 47,
        "./CanvasMove.js": 47,
        "./CommandAbstract": 22,
        "./CommandAbstract.js": 22,
        "./ComponentDelete": 48,
        "./ComponentDelete.js": 48,
        "./ComponentDrag": 49,
        "./ComponentDrag.js": 49,
        "./ComponentEnter": 50,
        "./ComponentEnter.js": 50,
        "./ComponentExit": 51,
        "./ComponentExit.js": 51,
        "./ComponentNext": 52,
        "./ComponentNext.js": 52,
        "./ComponentPrev": 53,
        "./ComponentPrev.js": 53,
        "./ComponentStyleClear": 54,
        "./ComponentStyleClear.js": 54,
        "./CopyComponent": 55,
        "./CopyComponent.js": 55,
        "./DeleteComponent": 56,
        "./DeleteComponent.js": 56,
        "./DeviceDesktop": 57,
        "./DeviceDesktop.js": 57,
        "./DeviceMobile": 58,
        "./DeviceMobile.js": 58,
        "./DeviceMobilePtr": 59,
        "./DeviceMobilePtr.js": 59,
        "./DeviceTablet": 60,
        "./DeviceTablet.js": 60,
        "./ExportTemplate": 61,
        "./ExportTemplate.js": 61,
        "./Fullscreen": 62,
        "./Fullscreen.js": 62,
        "./MoveComponent": 63,
        "./MoveComponent.js": 63,
        "./OpenAssets": 64,
        "./OpenAssets.js": 64,
        "./OpenBlocks": 65,
        "./OpenBlocks.js": 65,
        "./OpenLayers": 66,
        "./OpenLayers.js": 66,
        "./OpenStyleManager": 67,
        "./OpenStyleManager.js": 67,
        "./OpenTraitManager": 68,
        "./OpenTraitManager.js": 68,
        "./PasteComponent": 69,
        "./PasteComponent.js": 69,
        "./Preview": 70,
        "./Preview.js": 70,
        "./Resize": 71,
        "./Resize.js": 71,
        "./SaveDb": 72,
        "./SaveDb.js": 72,
        "./SelectComponent": 14,
        "./SelectComponent.js": 14,
        "./SelectPosition": 27,
        "./SelectPosition.js": 27,
        "./ShowOffset": 73,
        "./ShowOffset.js": 73,
        "./SwitchVisibility": 74,
        "./SwitchVisibility.js": 74
      };
      function r(t) {
        var e = a(t);
        return n(e);
      }
      function a(t) {
        if (!n.o(i, t)) {
          var e = new Error("Cannot find module '" + t + "'");
          throw e.code = "MODULE_NOT_FOUND", e;
        }
        return i[t];
      }
      r.keys = function () {
        return Object.keys(i);
      }, r.resolve = a, t.exports = r, r.id = 99;
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(8),
        r = n.n(i),
        a = n(2),
        o = n.n(a),
        s = n(1),
        l = n.n(s),
        c = n(0),
        d = {
          stylePrefix: "comp-",
          wrapperId: "wrapper",
          wrapperName: "Body",
          wrapper: {
            removable: !1,
            copyable: !1,
            draggable: !1,
            components: [],
            traits: [],
            stylable: ["background", "background-color", "background-image", "background-repeat", "background-attachment", "background-position", "background-size"]
          },
          components: [],
          draggableComponents: 1,
          storeWrapper: 0,
          processor: 0,
          voidElements: ["area", "base", "br", "col", "embed", "hr", "img", "input", "keygen", "link", "menuitem", "meta", "param", "source", "track", "wbr"]
        },
        u = n(5),
        h = n(21),
        p = n(6),
        g = n(35);
      function f(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function m(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? f(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var v = u.default.extend({
          defaults: m(m({}, u.default.prototype.defaults), {}, {
            type: "cell",
            tagName: "td",
            draggable: ["tr"]
          })
        }, {
          isComponent: function isComponent(t) {
            var e = "",
              n = t.tagName;
            return "TD" != n && "TH" != n || (e = {
              type: "cell",
              tagName: n.toLowerCase()
            }), e;
          }
        }),
        b = p.default.extend({});
      function y(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function w(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? y(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : y(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var x = u.default.extend({
          defaults: w(w({}, u.default.prototype.defaults), {}, {
            tagName: "tr",
            draggable: ["thead", "tbody", "tfoot"],
            droppable: ["th", "td"]
          })
        }, {
          isComponent: function isComponent(t) {
            return "TR" == t.tagName && !0;
          }
        }),
        j = p.default.extend({});
      function C(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function M(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? C(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : C(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var k = u.default.extend({
          defaults: M(M({}, u.default.prototype.defaults), {}, {
            type: "table",
            tagName: "table",
            droppable: ["tbody", "thead", "tfoot"]
          }),
          initialize: function initialize(t, e) {
            u.default.prototype.initialize.apply(this, arguments);
            var n = this.get("components");
            !n.length && n.add({
              type: "tbody"
            });
          }
        }, {
          isComponent: function isComponent(t) {
            var e = "";
            return "TABLE" == t.tagName && (e = {
              type: "table"
            }), e;
          }
        }),
        O = p.default.extend({
          events: {}
        });
      function T(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function S(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? T(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : T(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var N = u.default.extend({
        defaults: S(S({}, u.default.prototype.defaults), {}, {
          type: "tbody",
          tagName: "tbody",
          draggable: ["table"],
          droppable: ["tr"],
          columns: 1,
          rows: 1
        }),
        initialize: function initialize(t, e) {
          u.default.prototype.initialize.apply(this, arguments);
          var n = this.get("components"),
            i = this.get("columns"),
            r = this.get("rows");
          if (!n.length) {
            for (var a = []; r--;) {
              for (var o = [], s = i; s--;) o.push({
                type: "cell",
                classes: ["cell"]
              });
              a.push({
                type: "row",
                classes: ["row"],
                components: o
              });
            }
            n.add(a);
          }
        }
      }, {
        isComponent: function isComponent(t) {
          var e = "";
          return "TBODY" == t.tagName && (e = {
            type: "tbody"
          }), e;
        }
      });
      function L(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function D(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? L(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : L(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var E = N.extend({
          defaults: D(D({}, N.prototype.defaults), {}, {
            type: "thead",
            tagName: "thead"
          })
        }, {
          isComponent: function isComponent(t) {
            var e = "";
            return "THEAD" == t.tagName && (e = {
              type: "thead"
            }), e;
          }
        }),
        I = p.default.extend({}),
        P = p.default.extend({});
      function A(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function z(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? A(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : A(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var _ = N.extend({
          defaults: z(z({}, N.prototype.defaults), {}, {
            type: "tfoot",
            tagName: "tfoot"
          })
        }, {
          isComponent: function isComponent(t) {
            var e = "";
            return "TFOOT" == t.tagName && (e = {
              type: "tfoot"
            }), e;
          }
        }),
        H = p.default.extend({});
      function V(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function F(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? V(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : V(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var R = 'xmlns="http://www.w3.org/2000/svg" width="100" viewBox="0 0 24 24" style="fill: rgba(0,0,0,0.15); transform: scale(0.75)"',
        B = u.default.extend({
          defaults: F(F({}, u.default.prototype.defaults), {}, {
            type: "image",
            tagName: "img",
            void: 1,
            droppable: 0,
            editable: 1,
            highlightable: 0,
            resizable: {
              ratioDefault: 1
            },
            traits: ["alt"],
            src: "<svg ".concat(R, '>\n        <path d="M8.5 13.5l2.5 3 3.5-4.5 4.5 6H5m16 1V5a2 2 0 0 0-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2z"></path>\n      </svg>'),
            fallback: "<svg ".concat(R, '>\n        <path d="M2.28 3L1 4.27l2 2V19c0 1.1.9 2 2 2h12.73l2 2L21 21.72 2.28 3m2.55 0L21 19.17V5a2 2 0 0 0-2-2H4.83M8.5 13.5l2.5 3 1-1.25L14.73 18H5l3.5-4.5z"></path>\n      </svg>'),
            file: ""
          }),
          initialize: function initialize(t, e) {
            u.default.prototype.initialize.apply(this, arguments);
            var n = this.get("attributes");
            n.src && this.set("src", n.src);
          },
          initToolbar: function initToolbar() {
            for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
            u.default.prototype.initToolbar.apply(this, e);
            var i = this.em;
            if (i) {
              var r = i.get("Commands"),
                a = "image-editor";
              if (r.has(a)) {
                for (var o = !1, s = this.get("toolbar"), l = 0; l < s.length; l++) if ("image-editor" === s[l].command) {
                  o = !0;
                  break;
                }
                o || (s.push({
                  attributes: {
                    class: "fa fa-pencil"
                  },
                  command: a
                }), this.set("toolbar", s));
              }
            }
          },
          getAttrToHTML: function getAttrToHTML() {
            for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
            var i = u.default.prototype.getAttrToHTML.apply(this, e),
              r = this.getSrcResult();
            return r && (i.src = r), i;
          },
          getSrcResult: function getSrcResult() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = this.get(t.fallback ? "fallback" : "src") || "",
              n = e;
            return e && "<svg" === e.substr(0, 4) && (n = "data:image/svg+xml;base64,".concat(window.btoa(e))), n;
          },
          isDefaultSrc: function isDefaultSrc() {
            return this.get("src") === Object(c.result)(this, "defaults").src;
          },
          parseUri: function parseUri(t) {
            var e = document.createElement("a");
            e.href = t;
            for (var n = {}, i = e.search.substring(1).split("&"), r = 0; r < i.length; r++) {
              var a = i[r].split("="),
                o = decodeURIComponent(a[0]);
              o && (n[o] = decodeURIComponent(a[1]));
            }
            return {
              hostname: e.hostname,
              pathname: e.pathname,
              protocol: e.protocol,
              search: e.search,
              hash: e.hash,
              port: e.port,
              query: n
            };
          }
        }, {
          isComponent: function isComponent(t) {
            var e = "";
            return "IMG" == t.tagName && (e = {
              type: "image"
            }), e;
          }
        });
      function W(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function Y(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? W(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : W(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var U = B.extend({
          defaults: Y(Y({}, B.prototype.defaults), {}, {
            type: "map",
            src: "",
            void: 0,
            mapUrl: "https://maps.google.com/maps",
            tagName: "iframe",
            mapType: "q",
            address: "",
            zoom: "1",
            attributes: {
              frameborder: 0
            },
            toolbar: u.default.prototype.defaults.toolbar,
            traits: [{
              label: "Address",
              name: "address",
              placeholder: "eg. London, UK",
              changeProp: 1
            }, {
              type: "select",
              label: "Map type",
              name: "mapType",
              changeProp: 1,
              options: [{
                value: "q",
                name: "Roadmap"
              }, {
                value: "w",
                name: "Satellite"
              }]
            }, {
              label: "Zoom",
              name: "zoom",
              type: "range",
              min: "1",
              max: "20",
              changeProp: 1
            }]
          }),
          initialize: function initialize(t, e) {
            this.get("src") ? this.parseFromSrc() : this.updateSrc(), B.prototype.initialize.apply(this, arguments), this.listenTo(this, "change:address change:zoom change:mapType", this.updateSrc);
          },
          updateSrc: function updateSrc() {
            this.set("src", this.getMapUrl());
          },
          getMapUrl: function getMapUrl() {
            var t = this.get("address"),
              e = this.get("zoom"),
              n = this.get("mapType");
            return t = t ? "&q=" + t : "", e = e ? "&z=" + e : "", n = n ? "&t=" + n : "", this.get("mapUrl") + "?" + t + e + n + "&output=embed";
          },
          parseFromSrc: function parseFromSrc() {
            var t = this.parseUri(this.get("src")).query;
            t.q && this.set("address", t.q), t.z && this.set("zoom", t.z), t.t && this.set("mapType", t.t);
          }
        }, {
          isComponent: function isComponent(t) {
            var e = "";
            return "IFRAME" == t.tagName && /maps\.google\.com/.test(t.src) && (e = {
              type: "map",
              src: t.src
            }), e;
          }
        }),
        Z = p.default.extend({
          tagName: "img",
          events: {
            dblclick: "onActive",
            click: "initResize",
            error: "onError",
            load: "onLoad",
            dragstart: "noDrag"
          },
          initialize: function initialize(t) {
            var e = this.model;
            p.default.prototype.initialize.apply(this, arguments), this.listenTo(e, "change:src", this.updateSrc), this.classEmpty = "".concat(this.ppfx, "plh-image");
            var n = this.config;
            n.modal && (this.modal = n.modal), n.am && (this.am = n.am), this.fetchFile();
          },
          fetchFile: function fetchFile() {
            if (!this.modelOpt.temporary) {
              var t = this.model,
                e = t.get("file");
              e && (this.em.get("AssetManager").FileUploader().uploadFile({
                dataTransfer: {
                  files: [e]
                }
              }, function (e) {
                var n = e && e.data && e.data[0],
                  i = n && (Object(c.isString)(n) ? n : n.src);
                i && t.set({
                  src: i
                });
              }), t.set("file", ""));
            }
          },
          updateSrc: function updateSrc() {
            var t = this.model,
              e = this.classEmpty,
              n = this.$el,
              i = t.getSrcResult(),
              r = i && !t.isDefaultSrc();
            t.addAttributes({
              src: i
            }), n[r ? "removeClass" : "addClass"](e);
          },
          onActive: function onActive(t) {
            t && t.stopPropagation();
            var e = this.opts.config.em,
              n = e ? e.get("Editor") : "";
            n && this.model.get("editable") && n.runCommand("open-assets", {
              target: this.model,
              types: ["image"],
              accept: "image/*",
              onSelect: function onSelect() {
                n.Modal.close(), n.AssetManager.setTarget(null);
              }
            });
          },
          onError: function onError() {
            var t = this.model.getSrcResult({
              fallback: 1
            });
            t && (this.el.src = t);
          },
          onLoad: function onLoad() {
            this.em.trigger("change:canvasOffset");
          },
          noDrag: function noDrag(t) {
            return t.preventDefault(), !1;
          },
          render: function render() {
            this.renderAttributes(), this.updateSrc();
            var t = this.$el,
              e = this.model,
              n = t.attr("class") || "";
            return !e.get("src") && t.attr("class", "".concat(n, " ").concat(this.classEmpty).trim()), this.postRender(), this;
          }
        }),
        G = Z.extend({
          tagName: "div",
          events: {},
          initialize: function initialize(t) {
            Z.prototype.initialize.apply(this, arguments), this.classEmpty = this.ppfx + "plh-map";
          },
          updateSrc: function updateSrc() {
            this.getIframe().src = this.model.get("src");
          },
          getIframe: function getIframe() {
            if (!this.iframe) {
              var t = document.createElement("iframe");
              t.src = this.model.get("src"), t.frameBorder = 0, t.style.height = "100%", t.style.width = "100%", t.className = this.ppfx + "no-pointer", this.iframe = t;
            }
            return this.iframe;
          },
          render: function render() {
            for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
            return Z.prototype.render.apply(this, e), this.updateClasses(), this.el.appendChild(this.getIframe()), this;
          }
        });
      function q(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function $(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? q(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : q(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var Q = u.default.extend({
        defaults: $($({}, u.default.prototype.defaults), {}, {
          type: "text",
          droppable: !1,
          editable: !0
        }),
        toHTML: function toHTML() {
          return this.trigger("sync:content", {
            silent: 1
          }), u.default.prototype.toHTML.apply(this, arguments);
        }
      });
      function J(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function X(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? J(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : J(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var K = Q.extend({
          defaults: X(X({}, Q.prototype.defaults), {}, {
            type: "link",
            tagName: "a",
            traits: ["title", "href", "target"]
          }),
          getAttrToHTML: function getAttrToHTML() {
            for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
            var i = Q.prototype.getAttrToHTML.apply(this, e);
            return delete i.onmousedown, i;
          }
        }, {
          isComponent: function isComponent(t) {
            var e;
            if ("A" == t.tagName) {
              e = {
                type: "link",
                editable: 0
              };
              var n = t.childNodes,
                i = n.length;
              i || delete e.editable;
              for (var r = 0; r < i; r++) {
                var a = n[r];
                if (3 == a.nodeType && "" != a.textContent.trim()) {
                  delete e.editable;
                  break;
                }
              }
            }
            return e;
          }
        }),
        tt = n(3);
      function et(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function nt(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? et(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : et(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var it = p.default.prototype,
        rt = p.default.extend({
          events: {
            dblclick: "onActive",
            input: "onInput"
          },
          initialize: function initialize(t) {
            it.initialize.apply(this, arguments), this.disableEditing = this.disableEditing.bind(this);
            var e = this.model,
              n = this.em;
            this.listenTo(e, "focus", this.onActive), this.listenTo(e, "change:content", this.updateContentText), this.listenTo(e, "sync:content", this.syncContent), this.rte = n && n.get("RichTextEditor");
          },
          updateContentText: function updateContentText(t, e) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            !n.fromDisable && this.disableEditing();
          },
          onActive: function onActive(t) {
            if (!this.rteEnabled && this.model.get("editable")) {
              t && t.stopPropagation && t.stopPropagation();
              var e = this.rte,
                n = this.em;
              if (e) try {
                this.activeRte = e.enable(this, this.activeRte);
              } catch (t) {
                n.logError(t);
              }
              this.toggleEvents(1);
            }
          },
          onDisable: function onDisable() {
            this.disableEditing();
          },
          disableEditing: function disableEditing() {
            var t = this.model,
              e = this.rte,
              n = this.activeRte,
              i = this.em,
              r = t.get("editable");
            if (e && r) {
              try {
                e.disable(this, n);
              } catch (t) {
                i.logError(t);
              }
              this.syncContent();
            }
            this.toggleEvents();
          },
          getContent: function getContent() {
            var t = this.activeRte;
            return t && "function" == typeof t.getContent ? t.getContent() : this.getChildrenContainer().innerHTML;
          },
          syncContent: function syncContent() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = this.model,
              n = this.rte,
              i = this.rteEnabled;
            if (i || t.force) {
              var r = this.getContent(),
                a = e.components(),
                o = nt({
                  fromDisable: 1
                }, t);
              if (a.length && a.reset(null, t), e.set("content", "", o), n.customRte) e.set("content", r, o);else {
                var s = function e(n) {
                  var i = !!n.get("textable"),
                    r = !["text", "default", ""].some(function (t) {
                      return n.is(t);
                    }) || i;
                  n.set(nt({
                    _innertext: !r,
                    editable: r && n.get("editable"),
                    selectable: r,
                    hoverable: r,
                    removable: i,
                    draggable: i,
                    highlightable: 0,
                    copyable: i
                  }, !i && {
                    toolbar: ""
                  }), t), n.get("components").each(function (t) {
                    return e(t);
                  });
                };
                !t.silent && e.trigger("change:content", e, "", o), a.add(r, t), a.each(function (t) {
                  return s(t);
                }), a.trigger("resetNavigator");
              }
            }
          },
          getModelsFromEl: function getModelsFromEl(t) {
            for (var e = [], n = (t || this.el).childNodes, i = 0; i < n.length; i++) {
              var r = n[i],
                a = r.__cashData && r.__cashData.model;
              a && (a.components = this.getModelsFromEl(r), a.get("content") && (a.attributes.content = r.textContent), e.push(a));
            }
            return e;
          },
          onInput: function onInput() {
            var t = this.em,
              e = ["".concat("component", ":update"), "".concat("component", ":input")].join(" ");
            t && t.trigger(e, this.model);
          },
          disablePropagation: function disablePropagation(t) {
            t.stopPropagation();
          },
          toggleEvents: function toggleEvents(t) {
            var e = this.em,
              n = {
                on: tt.u,
                off: tt.t
              },
              i = t ? "on" : "off";
            e.setEditing(t), this.rteEnabled = !!t;
            var r = [this.el.ownerDocument, document];
            if (n.off(r, "mousedown", this.disableEditing), n[i](r, "mousedown", this.disableEditing), e[i]("toolbar:run:before", this.disableEditing), this.$el.off("mousedown", this.disablePropagation), this.$el[i]("mousedown", this.disablePropagation), this.config.draggableComponents) for (var a = this.el; a;) a.draggable = !t, (a = a.parentNode) && "BODY" == a.tagName && (a = 0);
          }
        }),
        at = rt.extend({
          render: function render() {
            for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
            return rt.prototype.render.apply(this, e), this.el.addEventListener("click", this.prevDef, !0), this;
          }
        });
      function ot(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function st(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? ot(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ot(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var lt = Q.extend({
          defaults: st(st({}, Q.prototype.defaults), {}, {
            tagName: "label",
            traits: ["id", "title", "for"]
          })
        }, {
          isComponent: function isComponent(t) {
            if ("LABEL" == t.tagName) return {
              type: "label"
            };
          }
        }),
        ct = at.extend({
          tagName: "span"
        });
      function dt(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function ut(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? dt(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : dt(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var ht = "yt",
        pt = "vi",
        gt = "ytnc",
        ft = B.extend({
          defaults: ut(ut({}, B.prototype.defaults), {}, {
            type: "video",
            tagName: "video",
            videoId: "",
            void: 0,
            provider: ht,
            ytUrl: "https://www.youtube.com/embed/",
            ytncUrl: "https://www.youtube-nocookie.com/embed/",
            viUrl: "https://player.vimeo.com/video/",
            loop: 0,
            poster: "",
            muted: 0,
            autoplay: 0,
            controls: 1,
            color: "",
            list: "",
            rel: 1,
            modestbranding: 0,
            sources: [],
            attributes: {
              allowfullscreen: "allowfullscreen"
            },
            src: "Bizu6v9k5Uc"
          }),
          initialize: function initialize(t, e) {
            this.em = e.em, this.get("src") && this.parseFromSrc(), this.updateTraits(), this.listenTo(this, "change:provider", this.updateTraits), this.listenTo(this, "change:videoId change:provider", this.updateSrc), B.prototype.initialize.apply(this, arguments);
          },
          updateTraits: function updateTraits() {
            var t,
              e = "iframe";
            switch (this.get("provider")) {
              case ht:
                this.setAttributes(o()({}, "data-video-type", "youtube")), t = this.getYoutubeTraits();
                break;
              case gt:
                this.setAttributes(o()({}, "data-video-type", "youtube-nocookie")), t = this.getYoutubeTraits();
                break;
              case pt:
                this.setAttributes(o()({}, "data-video-type", "vimeo")), t = this.getVimeoTraits();
                break;
              default:
                this.setAttributes(o()({}, "data-video-type", "video")), e = "video", t = this.getSourceTraits();
            }
            this.set({
              tagName: e
            }, {
              silent: 1
            }), this.set({
              traits: t
            }), this.em.trigger("component:toggled");
          },
          parseFromSrc: function parseFromSrc() {
            var t = this.get("provider"),
              e = this.parseUri(this.get("src")),
              n = e.query;
            switch (t) {
              case ht:
              case gt:
              case pt:
                var i = e.pathname.split("/").pop();
                this.set("videoId", i), n.list && this.set("list", n.list), n.autoplay && this.set("autoplay", 1), n.loop && this.set("loop", 1), 0 === parseInt(n.controls) && this.set("controls", 0), n.color && this.set("color", n.color), "0" === n.rel && this.set("rel", 0), "1" === n.modestbranding && this.set("modestbranding", 1);
            }
          },
          updateSrc: function updateSrc() {
            var t = "";
            switch (this.get("provider")) {
              case ht:
                t = this.getYoutubeSrc();
                break;
              case gt:
                t = this.getYoutubeNoCookieSrc();
                break;
              case pt:
                t = this.getVimeoSrc();
            }
            this.set({
              src: t
            });
          },
          getAttrToHTML: function getAttrToHTML() {
            for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
            var i = B.prototype.getAttrToHTML.apply(this, e),
              r = this.get("provider");
            switch (r) {
              case ht:
              case gt:
              case pt:
                break;
              default:
                this.get("loop") && (i.loop = "loop"), this.get("autoplay") && (i.autoplay = "autoplay"), this.get("controls") && (i.controls = "controls");
            }
            return i;
          },
          getProviderTrait: function getProviderTrait() {
            return {
              type: "select",
              label: "Provider",
              name: "provider",
              changeProp: 1,
              options: [{
                value: "so",
                name: "HTML5 Source"
              }, {
                value: ht,
                name: "Youtube"
              }, {
                value: gt,
                name: "Youtube (no cookie)"
              }, {
                value: pt,
                name: "Vimeo"
              }]
            };
          },
          getSourceTraits: function getSourceTraits() {
            return [this.getProviderTrait(), {
              label: "Source",
              name: "src",
              placeholder: "eg. ./media/video.mp4",
              changeProp: 1
            }, {
              label: "Poster",
              name: "poster",
              placeholder: "eg. ./media/image.jpg"
            }, this.getAutoplayTrait(), this.getLoopTrait(), this.getControlsTrait(), this.getWebconnectVideoTrait()];
          },
          getYoutubeTraits: function getYoutubeTraits() {
            return [this.getProviderTrait(), {
              label: "Video ID",
              name: "videoId",
              placeholder: "eg. jNQXAC9IVRw",
              changeProp: 1
            }, this.getAutoplayTrait(), this.getLoopTrait(), this.getControlsTrait(), {
              type: "checkbox",
              label: "Related",
              name: "rel",
              changeProp: 1
            }, {
              type: "checkbox",
              label: "Modest",
              name: "modestbranding",
              changeProp: 1
            }, this.getWebconnectVideoTrait()];
          },
          getVimeoTraits: function getVimeoTraits() {
            return [this.getProviderTrait(), {
              label: "Video ID",
              name: "videoId",
              placeholder: "eg. 123456789",
              changeProp: 1
            }, {
              label: "Color",
              name: "color",
              placeholder: "eg. FF0000",
              changeProp: 1
            }, this.getAutoplayTrait(), this.getLoopTrait(), this.getWebconnectVideoTrait()];
          },
          getAutoplayTrait: function getAutoplayTrait() {
            return {
              type: "checkbox",
              label: "Autoplay",
              name: "autoplay",
              changeProp: 1
            };
          },
          getLoopTrait: function getLoopTrait() {
            return {
              type: "checkbox",
              label: "Loop",
              name: "loop",
              changeProp: 1
            };
          },
          getControlsTrait: function getControlsTrait() {
            return {
              type: "checkbox",
              label: "Controls",
              name: "controls",
              changeProp: 1
            };
          },
          getYoutubeSrc: function getYoutubeSrc() {
            var t = this.get("videoId"),
              e = this.get("ytUrl"),
              n = this.get("list");
            return e += t + (t.indexOf("?") < 0 ? "?" : ""), e += n ? "&list=".concat(n) : "", e += this.get("autoplay") ? "&autoplay=1" : "", e += this.get("controls") ? "" : "&controls=0&showinfo=0", e += this.get("loop") ? "&loop=1&playlist=".concat(t) : "", (e += this.get("rel") ? "" : "&rel=0") + (this.get("modestbranding") ? "&modestbranding=1" : "");
          },
          getYoutubeNoCookieSrc: function getYoutubeNoCookieSrc() {
            var t = this.getYoutubeSrc();
            return t.replace(this.get("ytUrl"), this.get("ytncUrl"));
          },
          getVimeoSrc: function getVimeoSrc() {
            var t = this.get("viUrl");
            return t += this.get("videoId") + "?", t += this.get("autoplay") ? "&autoplay=1" : "", t += this.get("loop") ? "&loop=1" : "", (t += this.get("controls") ? "" : "&title=0&portrait=0&badge=0") + (this.get("color") ? "&color=" + this.get("color") : "");
          },
          getWebconnectVideoTrait: function getWebconnectVideoTrait() {
            return {
              type: "webconnect-video",
              label: !1,
              content: "Insert your text here"
            };
          }
        }, {
          isComponent: function isComponent(t) {
            var e = "",
              n = /youtube\.com\/embed/.test(t.src),
              i = /youtube-nocookie\.com\/embed/.test(t.src),
              r = /player\.vimeo\.com\/video/.test(t.src),
              a = n || i || r;
            return ("VIDEO" == t.tagName || "IFRAME" == t.tagName && a) && (e = {
              type: "video"
            }, t.src && (e.src = t.src), a && (n ? e.provider = ht : i ? e.provider = gt : r && (e.provider = pt))), e;
          }
        }),
        mt = Z.extend({
          tagName: "div",
          events: {},
          initialize: function initialize(t) {
            p.default.prototype.initialize.apply(this, arguments);
            var e = this.model,
              n = ["loop", "autoplay", "controls", "color", "rel", "modestbranding", "poster"],
              i = n.map(function (t) {
                return "change:".concat(t);
              }).join(" ");
            this.listenTo(e, "change:provider", this.updateProvider), this.listenTo(e, "change:src", this.updateSrc), this.listenTo(e, i, this.updateVideo);
          },
          updateProvider: function updateProvider() {
            var t = this.model.get("provider");
            this.el.innerHTML = "", this.el.appendChild(this.renderByProvider(t));
          },
          updateSrc: function updateSrc() {
            var t = this.model,
              e = this.videoEl;
            if (e) {
              var n = t.get("provider"),
                i = t.get("src");
              switch (n) {
                case "yt":
                  i = t.getYoutubeSrc();
                  break;
                case "ytnc":
                  i = t.getYoutubeNoCookieSrc();
                  break;
                case "vi":
                  i = t.getVimeoSrc();
              }
              e.src = i;
            }
          },
          updateVideo: function updateVideo() {
            var t = this.model.get("provider"),
              e = this.videoEl,
              n = this.model;
            switch (t) {
              case "yt":
              case "ytnc":
              case "vi":
                this.model.trigger("change:videoId");
                break;
              default:
                e.loop = n.get("loop"), e.autoplay = n.get("autoplay"), e.controls = n.get("controls"), e.poster = n.get("poster");
            }
          },
          renderByProvider: function renderByProvider(t) {
            var e;
            switch (t) {
              case "yt":
                e = this.renderYoutube();
                break;
              case "ytnc":
                e = this.renderYoutubeNoCookie();
                break;
              case "vi":
                e = this.renderVimeo();
                break;
              default:
                e = this.renderSource();
            }
            return this.videoEl = e, e;
          },
          renderSource: function renderSource() {
            var t = document.createElement("video");
            return t.src = this.model.get("src"), this.initVideoEl(t), t;
          },
          renderYoutube: function renderYoutube() {
            var t = document.createElement("iframe");
            return t.src = this.model.getYoutubeSrc(), t.frameBorder = 0, t.setAttribute("allowfullscreen", !0), this.initVideoEl(t), t;
          },
          renderYoutubeNoCookie: function renderYoutubeNoCookie() {
            var t = document.createElement("iframe");
            return t.src = this.model.getYoutubeNoCookieSrc(), t.frameBorder = 0, t.setAttribute("allowfullscreen", !0), this.initVideoEl(t), t;
          },
          renderVimeo: function renderVimeo() {
            var t = document.createElement("iframe");
            return t.src = this.model.getVimeoSrc(), t.frameBorder = 0, t.setAttribute("allowfullscreen", !0), this.initVideoEl(t), t;
          },
          initVideoEl: function initVideoEl(t) {
            t.className = this.ppfx + "no-pointer", t.style.height = "100%", t.style.width = "100%";
          },
          render: function render() {
            for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
            Z.prototype.render.apply(this, e), this.updateClasses();
            var i = this.model.get("provider");
            return this.el.appendChild(this.renderByProvider(i)), this.updateVideo(), this;
          }
        });
      function vt(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function bt(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? vt(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : vt(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var yt = B.extend({
          defaults: bt(bt({}, B.prototype.defaults), {}, {
            type: "audio",
            tagName: "audio",
            void: 0,
            provider: "hso",
            loop: 0,
            muted: 0,
            autoplay: 0,
            controls: 1,
            list: "",
            sources: [],
            attributes: {},
            src: "https://cdn.pixabay.com/download/audio/2022/01/12/audio_45cacdef8f.mp3"
          }),
          initialize: function initialize(t, e) {
            this.em = e.em, this.updateTraits(), B.prototype.initialize.apply(this, arguments);
          },
          updateTraits: function updateTraits() {
            var t = this.getSourceTraits();
            this.setAttributes(o()({}, "data-audio-type", "url")), this.set({
              tagName: "audio"
            }, {
              silent: 1
            }), this.set({
              traits: t
            }), this.em.trigger("component:toggled");
          },
          updateSrc: function updateSrc() {
            this.set({
              src: ""
            });
          },
          getAttrToHTML: function getAttrToHTML() {
            for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
            var i = B.prototype.getAttrToHTML.apply(this, e);
            return this.get("loop") && (i.loop = "loop"), this.get("autoplay") && (i.autoplay = "autoplay"), this.get("controls") && (i.controls = "controls"), i;
          },
          getSourceTraits: function getSourceTraits() {
            return [{
              label: "Source",
              name: "src",
              placeholder: "eg. ./media/audio.mp3",
              changeProp: 1
            }, this.getAutoplayTrait(), this.getLoopTrait(), this.getControlsTrait(), this.getWebconnectAudioTrait()];
          },
          getAutoplayTrait: function getAutoplayTrait() {
            return {
              type: "checkbox",
              label: "Autoplay",
              name: "autoplay",
              changeProp: 1
            };
          },
          getLoopTrait: function getLoopTrait() {
            return {
              type: "checkbox",
              label: "Loop",
              name: "loop",
              changeProp: 1
            };
          },
          getControlsTrait: function getControlsTrait() {
            return {
              type: "checkbox",
              label: "Controls",
              name: "controls",
              changeProp: 1
            };
          },
          getWebconnectAudioTrait: function getWebconnectAudioTrait() {
            return {
              type: "drapcode-audio",
              label: !1,
              content: "Insert audio URL here"
            };
          }
        }, {
          isComponent: function isComponent(t) {
            var e = "";
            return "AUDIO" == t.tagName && (e = {
              type: "audio"
            }, t.src && (e.src = t.src)), e;
          }
        }),
        wt = Z.extend({
          tagName: "div",
          events: {},
          initialize: function initialize(t) {
            p.default.prototype.initialize.apply(this, arguments);
            var e = this.model,
              n = ["loop", "autoplay", "controls"],
              i = n.map(function (t) {
                return "change:".concat(t);
              }).join(" ");
            this.listenTo(e, "change:src", this.updateSrc), this.listenTo(e, i, this.updateAudio);
          },
          updateProvider: function updateProvider() {
            var t = this.model.get("provider");
            this.el.innerHTML = "", this.el.appendChild(this.renderByProvider(t));
          },
          updateSrc: function updateSrc() {
            var t = this.model,
              e = this.audioEl;
            if (e) {
              var n = t.get("src");
              e.src = n;
            }
          },
          updateAudio: function updateAudio() {
            var t = this.audioEl,
              e = this.model;
            t.loop = e.get("loop"), t.autoplay = e.get("autoplay"), t.controls = e.get("controls");
          },
          renderByProvider: function renderByProvider(t) {
            var e;
            return e = this.renderSource(), this.audioEl = e, e;
          },
          renderSource: function renderSource() {
            var t = document.createElement("audio");
            return t.src = this.model.get("src"), this.initAudioEl(t), t;
          },
          initAudioEl: function initAudioEl(t) {
            t.className = this.ppfx + "no-pointer", t.style.height = "100%", t.style.width = "100%";
          },
          render: function render() {
            for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
            Z.prototype.render.apply(this, e), this.updateClasses();
            var i = this.model.get("provider");
            return this.el.appendChild(this.renderByProvider(i)), this.updateAudio(), this;
          }
        });
      function xt(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function jt(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? xt(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : xt(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var Ct = u.default.extend({
          defaults: jt(jt({}, u.default.prototype.defaults), {}, {
            type: "script",
            droppable: !1,
            draggable: !1,
            layerable: !1
          })
        }, {
          isComponent: function isComponent(t) {
            if ("SCRIPT" == t.tagName) {
              var e = {
                type: "script"
              };
              return t.src && (e.src = t.src, e.onload = t.onload), e;
            }
          }
        }),
        Mt = Z.extend({
          tagName: "script",
          events: {},
          render: function render() {
            var t = this.model,
              e = t.get("src"),
              n = this.em,
              i = n && n.get("scriptCount") ? n.get("scriptCount") : 0,
              r = "";
            if (e) {
              var a = t.get("onload"),
                o = "script" + i,
                s = "script" + (i + 1);
              r = "var " + o + " = document.createElement('script');\n" + o + ".onload = function(){\n" + (a ? a + "();\n" : "") + "typeof " + s + "Start == 'function' && " + s + "Start();\n};\n" + o + ".src = '" + e + "';\nfunction " + o + "Start() { document.body.appendChild(" + o + "); };\n" + (i ? "" : o + "Start();"), n && n.set("scriptCount", i + 1);
            } else r = t.get("content");
            return this.el.innerHTML = r, this.postRender(), this;
          }
        });
      function kt(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function Ot(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? kt(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : kt(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var Tt = u.default.extend({
        defaults: Ot(Ot({}, u.default.prototype.defaults), {}, {
          resizable: {
            ratioDefault: 1
          },
          highlightable: 0
        }),
        getName: function getName() {
          var t = this.get("tagName"),
            e = this.get("custom-name");
          return t = t.charAt(0).toUpperCase() + t.slice(1), e || t;
        }
      }, {
        isComponent: function isComponent(t) {
          if (SVGElement && t instanceof SVGElement) return {
            tagName: t.tagName,
            type: "svg"
          };
        }
      });
      function St(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function Nt(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? St(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : St(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var Lt = Tt.extend({
          defaults: Nt(Nt({}, Tt.prototype.defaults), {}, {
            selectable: !1,
            hoverable: !1,
            layerable: !1
          })
        }, {
          isComponent: function isComponent(t) {
            if (Tt.isComponent(t) && "svg" !== t.tagName.toLowerCase()) return {
              tagName: t.tagName,
              type: "svg-in"
            };
          }
        }),
        Dt = p.default.extend({
          _createElement: function _createElement(t) {
            return document.createElementNS("http://www.w3.org/2000/svg", t);
          }
        });
      function Et(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function It(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? Et(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Et(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var Pt = u.default.extend({
        defaults: It(It({}, u.default.prototype.defaults), {}, {
          droppable: !1,
          layerable: !1,
          editable: !0
        }),
        toHTML: function toHTML() {
          return this.get("content").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
        }
      }, {
        isComponent: function isComponent(t) {
          var e = "";
          return 3 === t.nodeType && (e = {
            type: "textnode",
            content: t.textContent
          }), e;
        }
      });
      function At(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      var zt = Pt.extend({
          defaults: function (t) {
            for (var e = 1; e < arguments.length; e++) {
              var n = null != arguments[e] ? arguments[e] : {};
              e % 2 ? At(Object(n), !0).forEach(function (e) {
                o()(t, e, n[e]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : At(Object(n)).forEach(function (e) {
                Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
              });
            }
            return t;
          }({}, Pt.prototype.defaults),
          toHTML: function toHTML() {
            return "\x3c!--".concat(this.get("content"), "--\x3e");
          }
        }, {
          isComponent: function isComponent(t) {
            if (8 == t.nodeType) return {
              tagName: "NULL",
              type: "comment",
              content: t.textContent
            };
          }
        }),
        _t = p.default.extend({
          initialize: function initialize() {
            p.default.prototype.initialize.apply(this, arguments);
          },
          _setAttributes: function _setAttributes() {},
          renderAttributes: function renderAttributes() {},
          setAttribute: function setAttribute() {},
          updateAttributes: function updateAttributes() {},
          initClasses: function initClasses() {},
          initComponents: function initComponents() {},
          delegateEvents: function delegateEvents() {},
          _createElement: function _createElement() {
            return document.createTextNode("");
          },
          render: function render() {
            var t = this.model,
              e = this.el;
            return t.opt.temporary || (e.textContent = t.get("content")), this;
          }
        }),
        Ht = _t.extend({
          _createElement: function _createElement() {
            return document.createComment(this.model.get("content"));
          }
        }),
        Vt = u.default.extend({}, {
          isComponent: function isComponent() {
            return !1;
          }
        });
      function Ft(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function Rt(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? Ft(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Ft(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.default = function () {
        var t,
          e,
          n,
          i = {},
          a = {},
          o = [{
            id: "cell",
            model: v,
            view: b
          }, {
            id: "row",
            model: x,
            view: j
          }, {
            id: "table",
            model: k,
            view: O
          }, {
            id: "thead",
            model: E,
            view: I
          }, {
            id: "tbody",
            model: N,
            view: P
          }, {
            id: "tfoot",
            model: _,
            view: H
          }, {
            id: "map",
            model: U,
            view: G
          }, {
            id: "link",
            model: K,
            view: at
          }, {
            id: "label",
            model: lt,
            view: ct
          }, {
            id: "video",
            model: ft,
            view: mt
          }, {
            id: "audio",
            model: yt,
            view: wt
          }, {
            id: "image",
            model: B,
            view: Z
          }, {
            id: "script",
            model: Ct,
            view: Mt
          }, {
            id: "svg-in",
            model: Lt,
            view: Dt
          }, {
            id: "svg",
            model: Tt,
            view: Dt
          }, {
            id: "comment",
            model: zt,
            view: Ht
          }, {
            id: "textnode",
            model: Pt,
            view: _t
          }, {
            id: "text",
            model: Q,
            view: rt
          }, {
            id: "wrapper",
            model: Vt,
            view: p.default
          }, {
            id: "default",
            model: u.default,
            view: p.default
          }];
        return {
          Component: u.default,
          Components: h.a,
          ComponentsView: g.a,
          componentTypes: o,
          componentsById: a,
          name: "DomComponents",
          getConfig: function getConfig() {
            return i;
          },
          storageKey: function storageKey() {
            var t = [],
              e = i.stm && i.stm.getConfig() || {};
            return e.storeHtml && t.push("html"), e.storeComponents && t.push("components"), t;
          },
          init: function init(r) {
            var a = this;
            for (var s in t = (i = r || {}).em, this.em = t, t && (i.components = t.config.components || i.components), d) s in i || (i[s] = d[s]);
            var l = i.pStylePrefix;
            if (l && (i.stylePrefix = l + i.stylePrefix), t) {
              i.modal = t.get("Modal") || "", i.popover = t.get("Popover") || "", i.am = t.get("AssetManager") || "", t.get("Parser").compTypes = o, t.on("change:componentHovered", this.componentHovered, this);
              var c = t.get("selected");
              t.listenTo(c, "add", function (t, e, n) {
                return a.selectAdd(t, n);
              }), t.listenTo(c, "remove", function (t, e, n) {
                return a.selectRemove(t, n);
              });
            }
            var h = i.components,
              g = Rt({}, i.wrapper);
            return g["custom-name"] = i.wrapperName, g.wrapper = 1, g.type = "wrapper", h && h.constructor === Object && h.wrapper && (g = Rt({}, h), h = h.components || [], g.components = [], t && (t.config.components = h, i.components = h)), (e = new u.default(g, {
              em: t,
              config: i,
              componentTypes: o,
              domc: this
            })).set({
              attributes: {
                id: "wrapper"
              }
            }), n = new p.default({
              model: e,
              config: i,
              componentTypes: o
            }), this;
          },
          onLoad: function onLoad() {
            this.setComponents(i.components);
          },
          postLoad: function postLoad(t) {
            this.handleChanges(this.getWrapper(), null, {
              avoidStore: 1
            });
          },
          handleChanges: function handleChanges(e, n) {
            var i = this,
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              a = e.components(),
              o = t.get("UndoManager"),
              s = t.handleUpdates.bind(t),
              l = this.handleChanges.bind(this),
              c = this.handleChangesColl.bind(this),
              d = this.handleRemoves.bind(this);
            o && o.add(e), o && a && o.add(a);
            var u = "change:style change:content change:attributes change:src";
            [[e, u, s], [e, "change:components", c], [a, "add", l], [a, "remove", d], [e.get("classes"), "add remove", s]].forEach(function (e) {
              t.stopListening(e[0], e[1], e[2]), t.listenTo(e[0], e[1], e[2]);
            }), !r.avoidStore && s("", "", r), a.each(function (t) {
              return i.handleChanges(t, n, r);
            });
          },
          handleChangesColl: function handleChangesColl(e, n) {
            var i = t.get("UndoManager");
            if (i && n instanceof l.a.Collection) {
              var r = this.handleChanges.bind(this),
                a = this.handleRemoves.bind(this);
              i.add(n), [[n, "add", r], [n, "remove", a]].forEach(function (e) {
                t.stopListening(e[0], e[1], e[2]), t.listenTo(e[0], e[1], e[2]);
              });
            }
          },
          handleRemoves: function handleRemoves(e, n) {
            var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            !i.avoidStore && t.handleUpdates(e, n, i);
          },
          load: function load() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
              e = this.em,
              n = "";
            !t && i.stm && (t = i.em.getCacheLoad());
            var r = t,
              a = r.components,
              o = r.html;
            if (a) {
              if (Object(c.isObject)(a) || Object(c.isArray)(a)) n = a;else try {
                n = JSON.parse(a);
              } catch (t) {
                e && e.logError(t);
              }
            } else o && (n = o);
            var s = n && n.constructor === Object;
            return (n && n.length || s) && (this.clear(), s ? this.getWrapper().set(n) : this.getComponents().add(n)), n;
          },
          store: function store(t) {
            if (i.stm) {
              var e = {},
                n = this.storageKey();
              if (n.indexOf("html") >= 0 && (e.html = i.em.getHtml()), n.indexOf("components") >= 0) {
                this.em;
                var r = i.storeWrapper ? this.getWrapper() : this.getComponents();
                e.components = JSON.stringify(r);
              }
              return t || i.stm.store(e), e;
            }
          },
          getComponent: function getComponent() {
            return e;
          },
          getWrapper: function getWrapper() {
            return this.getComponent();
          },
          getComponents: function getComponents() {
            return this.getWrapper().get("components");
          },
          addComponent: function addComponent(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return this.getComponents().add(t, e);
          },
          render: function render() {
            return n.render().el;
          },
          clear: function clear() {
            return this.getComponents().map(function (t) {
              return t;
            }).forEach(function (t) {
              return t.remove();
            }), this;
          },
          setComponents: function setComponents(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            this.clear().addComponent(t, e);
          },
          addType: function addType(t, e) {
            var n = this.em,
              i = e.model,
              a = void 0 === i ? {} : i,
              s = e.view,
              l = void 0 === s ? {} : s,
              d = e.isComponent,
              u = e.extend,
              h = e.extendView,
              p = e.extendFn,
              g = void 0 === p ? [] : p,
              f = e.extendFnView,
              m = void 0 === f ? [] : f,
              v = this.getType(t),
              b = this.getType(u),
              y = this.getType(h),
              w = b || v || this.getType("default"),
              x = w.model,
              j = y ? y.view : w.view,
              C = function C(t, e, n) {
                return t.reduce(function (t, i) {
                  var r = e[i],
                    a = n.prototype[i];
                  return r && a && (t[i] = function () {
                    a.bind(this).apply(void 0, arguments), r.bind(this).apply(void 0, arguments);
                  }), t;
                }, {});
              };
            "object" === r()(a) && (e.model = x.extend(Rt(Rt(Rt({}, a), C(g, a, x)), {}, {
              defaults: Rt(Rt({}, x.prototype.defaults), Object(c.result)(a, "defaults") || {})
            }), {
              isComponent: !v || b || d ? d || function () {
                return 0;
              } : x.isComponent
            })), "object" === r()(l) && (e.view = j.extend(Rt(Rt({}, l), C(m, l, j)))), v ? (v.model = e.model, v.view = e.view) : (e.id = t, o.unshift(e));
            var M = "component:type:".concat(v ? "update" : "add");
            return n && n.trigger(M, v || e), this;
          },
          getType: function getType(t) {
            for (var e = o, n = 0; n < e.length; n++) if (e[n].id == t) return e[n];
          },
          removeType: function removeType(t) {
            var e = o,
              n = this.getType(t);
            if (n) {
              var i = e.indexOf(n);
              return e.splice(i, 1), n;
            }
          },
          getTypes: function getTypes() {
            return o;
          },
          selectAdd: function selectAdd(t) {
            var e = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            t && (t.set({
              status: "selected"
            }), ["component:selected", "component:toggled"].forEach(function (i) {
              return e.em.trigger(i, t, n);
            }));
          },
          selectRemove: function selectRemove(t) {
            var e = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            t && (this.em, t.set({
              status: "",
              state: ""
            }), ["component:deselected", "component:toggled"].forEach(function (i) {
              return e.em.trigger(i, t, n);
            }));
          },
          componentHovered: function componentHovered() {
            var t = i.em,
              e = t.get("componentHovered"),
              n = t.previous("componentHovered");
            n && "hovered" == n.get("status") && n.set({
              status: "",
              state: ""
            }), e && Object(c.isEmpty)(e.get("status")) && e.set("status", "hovered");
          },
          allById: function allById() {
            return a;
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(9),
        r = n.n(i),
        a = n(2),
        o = n.n(a),
        s = n(3),
        l = n(0),
        c = n(15),
        d = n.n(c),
        u = n(16),
        h = n.n(u),
        p = function () {
          function t(e, n) {
            var i = this;
            d()(this, t), this.em = e;
            var r = n || e.get("Canvas").getFrames().map(function (t) {
                return t.get("root").getEl();
              }),
              a = Array.isArray(r) ? r : [r];
            return this.el = r, this.counter = 0, Object(l.bindAll)(this, "handleDragEnter", "handleDragOver", "handleDrop", "handleDragLeave"), a.forEach(function (t) {
              return i.toggleEffects(t, 1);
            }), this;
          }
          return h()(t, [{
            key: "toggleEffects",
            value: function value(t, e) {
              var n = {
                  on: s.u,
                  off: s.t
                },
                i = e ? "on" : "off";
              n[i](t, "dragenter", this.handleDragEnter), n[i](t, "dragover", this.handleDragOver), n[i](t, "drop", this.handleDrop), n[i](t, "dragleave", this.handleDragLeave);
            }
          }, {
            key: "endDrop",
            value: function value(t, e) {
              var n = this.em,
                i = this.dragStop;
              this.counter = 0, this.over = 0, i && i(t), n.runDefault({
                preserveSelected: 1
              }), n.trigger("canvas:dragend", e);
            }
          }, {
            key: "handleDragLeave",
            value: function value(t) {
              this.updateCounter(-1, t);
            }
          }, {
            key: "updateCounter",
            value: function value(t, e) {
              this.counter += t, 0 === this.counter && this.endDrop(1, e);
            }
          }, {
            key: "handleDragEnter",
            value: function value(t) {
              var e = this,
                n = this.em,
                i = t.dataTransfer;
              if (this.updateCounter(1, t), !this.over) {
                this.over = 1;
                var r,
                  a,
                  o = n.get("Utils"),
                  s = n.get("Canvas"),
                  l = s.getBody(),
                  c = n.get("dragContent") || "<br>";
                if (n.stopDefault(), n.inAbsoluteMode()) {
                  var d = n.get("DomComponents").getWrapper(),
                    u = d.append({})[0],
                    h = n.get("Commands").run("core:component-drag", {
                      event: t,
                      guidesInfo: 1,
                      center: 1,
                      target: u,
                      onEnd: function onEnd(t, n, r) {
                        if (!r.cancelled) {
                          var a = d.append(c)[0],
                            o = u.getStyle(),
                            s = o.left,
                            l = o.top,
                            h = o.position;
                          a.addStyle({
                            left: s,
                            top: l,
                            position: h
                          }), e.handleDragEnd(a, i);
                        }
                        u.remove();
                      }
                    });
                  r = function r(e) {
                    return h.stop(t, {
                      cancel: e
                    });
                  }, a = function a(t) {
                    return c = t;
                  };
                } else {
                  var p = new o.Sorter({
                    em: n,
                    wmargin: 1,
                    nested: 1,
                    canvasRelative: 1,
                    direction: "a",
                    container: l,
                    placer: s.getPlacerEl(),
                    containerSel: "*",
                    itemSel: "*",
                    pfx: "gjs-",
                    onEndMove: function onEndMove(t) {
                      return e.handleDragEnd(t, i);
                    },
                    document: s.getFrameEl().contentDocument
                  });
                  p.setDropContent(c), p.startSort(), this.sorter = p, r = function r(t) {
                    t && (p.moved = 0), p.endMove();
                  }, a = function a(t) {
                    return p.setDropContent(t);
                  };
                }
                this.dragStop = r, this.dragContent = a, n.trigger("canvas:dragenter", i, c);
              }
            }
          }, {
            key: "handleDragEnd",
            value: function value(t, e) {
              if (t) {
                var n = this.em;
                n.set("dragResult", t), n.trigger("canvas:drop", e, t);
              }
            }
          }, {
            key: "handleDragOver",
            value: function value(t) {
              t.preventDefault(), this.em.trigger("canvas:dragover", t);
            }
          }, {
            key: "handleDrop",
            value: function value(t) {
              t.preventDefault();
              var e = this.dragContent,
                n = t.dataTransfer,
                i = this.getContentByData(n).content;
              t.target.style.border = "", i && e && e(i), this.endDrop(!i, t);
            }
          }, {
            key: "getContentByData",
            value: function value(t) {
              var e = this.em,
                n = t.types,
                i = t.files || [],
                r = e.get("dragContent"),
                a = t.getData("text");
              if (i.length) {
                a = [];
                for (var o = 0; o < i.length; o++) {
                  var s = i[o],
                    c = s.type.split("/")[0];
                  "image" == c && a.push({
                    type: c,
                    file: s,
                    attributes: {
                      alt: s.name
                    }
                  });
                }
              } else if (r) a = r;else if (Object(l.indexOf)(n, "text/html") >= 0) a = t.getData("text/html").replace(/<\/?meta[^>]*>/g, "");else if (Object(l.indexOf)(n, "text/uri-list") >= 0) a = {
                type: "link",
                attributes: {
                  href: a
                },
                content: a
              };else if (Object(l.indexOf)(n, "text/json") >= 0) {
                var d = t.getData("text/json");
                d && (a = JSON.parse(d));
              }
              var u = {
                content: a
              };
              return e.trigger("canvas:dragdata", t, u), u;
            }
          }]), t;
        }(),
        g = {
          stylePrefix: "cv-",
          scripts: [],
          styles: [],
          customBadgeLabel: "",
          autoscrollLimit: 50,
          notTextable: ["button", "a", "input[type=checkbox]", "input[type=radio]"]
        },
        f = n(1),
        m = n.n(f),
        v = n(5),
        b = n(33);
      function y(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function w(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? y(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : y(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var x = m.a.Model.extend({
          defaults: {
            wrapper: "",
            width: null,
            height: null,
            head: "",
            x: 0,
            y: 0,
            root: 0,
            components: 0,
            styles: 0,
            attributes: {}
          },
          initialize: function initialize(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = this.attributes,
              i = n.root,
              r = n.styles,
              a = n.components;
            this.set("head", []), this.em = e.em;
            var o = {
              em: e.em,
              config: e.em.get("DomComponents").getConfig(),
              frame: this
            };
            !i && this.set("root", new v.default({
              type: "wrapper",
              components: a || []
            }, o)), (!r || Object(l.isString)(r)) && this.set("styles", new b.a(r, o));
          },
          remove: function remove() {
            this.view = 0;
            var t = this.collection;
            return t && t.remove(this);
          },
          getHead: function getHead() {
            return r()(this.get("head"));
          },
          setHead: function setHead(t) {
            return this.set("head", r()(t));
          },
          addHeadItem: function addHeadItem(t) {
            var e = this.getHead();
            e.push(t), this.setHead(e);
          },
          getHeadByAttr: function getHeadByAttr(t, e, n) {
            return this.getHead().filter(function (i) {
              return i.attributes && i.attributes[t] == e && (!n || n === i.tag);
            })[0];
          },
          removeHeadByAttr: function removeHeadByAttr(t, e, n) {
            var i = this.getHead(),
              r = this.getHeadByAttr(t, e, n),
              a = i.indexOf(r);
            a >= 0 && (i.splice(a, 1), this.setHead(i));
          },
          addLink: function addLink(t) {
            !this.getHeadByAttr("href", t, "link") && this.addHeadItem({
              tag: "link",
              attributes: {
                href: t,
                rel: "stylesheet"
              }
            });
          },
          removeLink: function removeLink(t) {
            this.removeHeadByAttr("href", t, "link");
          },
          addScript: function addScript(t) {
            !this.getHeadByAttr("src", t, "script") && this.addHeadItem({
              tag: "script",
              attributes: {
                src: t
              }
            });
          },
          removeScript: function removeScript(t) {
            this.removeHeadByAttr("src", t, "script");
          },
          _emitUpdated: function _emitUpdated() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            this.em.trigger("frame:updated", w({
              frame: this
            }, t));
          }
        }),
        j = m.a.Collection.extend({
          model: x,
          initialize: function initialize() {
            Object(l.bindAll)(this, "itemLoaded");
          },
          itemLoaded: function itemLoaded() {
            this.loadedItems++, this.loadedItems >= this.itemsToLoad && (this.trigger("loaded:all"), this.listenToLoadItems(0));
          },
          listenToLoad: function listenToLoad() {
            this.loadedItems = 0, this.itemsToLoad = this.length, this.listenToLoadItems(1);
          },
          listenToLoadItems: function listenToLoadItems(t) {
            var e = this;
            this.forEach(function (n) {
              return n[t ? "on" : "off"]("loaded", e.itemLoaded);
            });
          }
        }),
        C = m.a.Model.extend({
          defaults: {
            frame: "",
            frames: "",
            wrapper: "",
            rulers: !1,
            zoom: 100,
            x: 0,
            y: 0
          },
          initialize: function initialize() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = t.em,
              n = t.styles,
              i = void 0 === n ? [] : n,
              r = t.scripts,
              a = void 0 === r ? [] : r,
              o = e && e.getWrapper(),
              s = e && e.getStyle(),
              l = new x({
                root: o,
                styles: s
              }, t);
            i.forEach(function (t) {
              return l.addLink(t);
            }), a.forEach(function (t) {
              return l.addScript(t);
            }), this.em = e, this.set("frame", l), this.set("frames", new j([l], t)), this.listenTo(this, "change:zoom", this.onZoomChange), this.listenTo(e, "change:device", this.updateDevice);
          },
          updateDevice: function updateDevice() {
            var t = this.em,
              e = t.getDeviceModel(),
              n = t.getCurrentFrameModel();
            if (n && e) {
              var i = e.attributes,
                r = i.width,
                a = i.height;
              n.set({
                width: r,
                height: a
              });
            }
          },
          onZoomChange: function onZoomChange() {
            this.get("zoom") < 1 && this.set("zoom", 1);
          }
        }),
        M = n(20),
        k = n(37),
        O = n(6),
        T = n(7);
      function S(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function N(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? S(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : S(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var L = m.a.View.extend({
          tagName: "iframe",
          attributes: {
            allowfullscreen: "allowfullscreen",
            "data-frame-el": !0,
            "data-hj-allow-iframe": !0
          },
          initialize: function initialize(t) {
            Object(l.bindAll)(this, "updateClientY", "stopAutoscroll", "autoscroll", "_emitUpdate");
            var e = this.model,
              n = this.el;
            this.config = N(N({}, t.config || {}), {}, {
              frameView: this
            }), this.ppfx = this.config.pStylePrefix || "", this.em = this.config.em, this.listenTo(e, "change:head", this.updateHead), e.view = this, Object(s.v)(n, this);
          },
          updateHead: function updateHead() {
            var t = this.getHead();
            Object(T.f)(t), Object(T.c)(t, this.model.getHead());
          },
          getEl: function getEl() {
            return this.el;
          },
          getWindow: function getWindow() {
            return this.getEl().contentWindow;
          },
          getDoc: function getDoc() {
            return this.getEl().contentDocument;
          },
          getHead: function getHead() {
            return this.getDoc() ? this.getDoc().querySelector("head") : null;
          },
          getBody: function getBody() {
            return this.getDoc() ? this.getDoc().querySelector("body") : null;
          },
          getWrapper: function getWrapper() {
            return this.getBody() ? this.getBody().querySelector("[data-gjs-type=wrapper]") : null;
          },
          getJsContainer: function getJsContainer() {
            return this.jsContainer || (console.log("Creating div element"), this.jsContainer = Object(T.e)("div", {
              class: "".concat(this.ppfx, "js-cont")
            })), this.jsContainer;
          },
          getToolsEl: function getToolsEl() {
            var t = this.config.frameWrapView;
            return t && t.elTools;
          },
          getGlobalToolsEl: function getGlobalToolsEl() {
            return this.em.get("Canvas").getGlobalToolsEl();
          },
          getHighlighter: function getHighlighter() {
            return this._getTool("[data-hl]");
          },
          getBadgeEl: function getBadgeEl() {
            return this._getTool("[data-badge]");
          },
          getOffsetViewerEl: function getOffsetViewerEl() {
            return this._getTool("[data-offset]");
          },
          getRect: function getRect() {
            return this.rect || (this.rect = this.el.getBoundingClientRect()), this.rect;
          },
          getOffsetRect: function getOffsetRect() {
            var t = this.el,
              e = this.getBody(),
              n = e.scrollTop,
              i = e.scrollLeft,
              r = t.offsetHeight,
              a = t.offsetWidth;
            return {
              top: t.offsetTop,
              left: t.offsetLeft,
              height: r,
              width: a,
              scrollTop: n,
              scrollLeft: i,
              scrollBottom: n + r,
              scrollRight: i + a
            };
          },
          _getTool: function _getTool(t) {
            var e = this.getToolsEl();
            return this[t] || (this[t] = e.querySelector(t)), this[t];
          },
          remove: function remove() {
            var t = this.root,
              e = this.model;
            this._toggleEffects(), m.a.View.prototype.remove.apply(this, arguments), t.remove(), e.remove();
          },
          startAutoscroll: function startAutoscroll() {
            var t = this;
            this.lastMaxHeight = this.getWrapper().offsetHeight - this.el.offsetHeight, setTimeout(function () {
              t._toggleAutoscrollFx(1), requestAnimationFrame(t.autoscroll);
            }, 0);
          },
          autoscroll: function autoscroll() {
            if (this.dragging) {
              var t = this.em.get("Canvas"),
                e = this.getWindow(),
                n = this.getBody().scrollTop,
                i = this.lastClientY || 0,
                r = t.getConfig().autoscrollLimit,
                a = this.getRect().height - r,
                o = n;
              i < r && (o -= r - i), i > a && (o += i - a), o !== n && o > 0 && o < this.lastMaxHeight && (this.getGlobalToolsEl().style.opacity = 0, this.showGlobalTools(), e.scrollTo(0, o)), requestAnimationFrame(this.autoscroll);
            }
          },
          updateClientY: function updateClientY(t) {
            t.preventDefault(), this.lastClientY = Object(s.h)(t).clientY * this.em.getZoomDecimal();
          },
          showGlobalTools: Object(l.debounce)(function () {
            this.getGlobalToolsEl().style.opacity = "";
          }, 50),
          stopAutoscroll: function stopAutoscroll() {
            this.dragging && this._toggleAutoscrollFx();
          },
          _toggleAutoscrollFx: function _toggleAutoscrollFx(t) {
            this.dragging = t;
            var e = this.getWindow(),
              n = t ? "on" : "off",
              i = {
                on: s.u,
                off: s.t
              };
            i[n](e, "mousemove dragover", this.updateClientY), i[n](e, "mouseup", this.stopAutoscroll);
          },
          render: function render() {
            var t = this.el,
              e = this.$el,
              n = this.ppfx,
              i = this.config;
            return e.attr({
              class: n + "frame"
            }), i.scripts.length ? this.renderScripts() : i.renderContent && (t.onload = this.renderBody.bind(this)), this;
          },
          renderScripts: function renderScripts() {
            var t = this,
              e = this.el,
              n = this.config;
            e.onload = function () {
              return function n(i) {
                if (i.length > 0) {
                  var r = i.shift(),
                    a = Object(T.e)("script", N({
                      type: "text/javascript"
                    }, Object(l.isString)(r) ? {
                      src: r
                    } : r));
                  a.onerror = a.onload = n.bind(null, i), e.contentDocument.head.appendChild(a);
                } else t.renderBody();
              }(r()(n.scripts));
            };
          },
          renderBody: function renderBody() {
            var t = this,
              e = this.config,
              n = this.model,
              i = this.ppfx,
              r = n.get("root"),
              a = n.get("styles"),
              o = e.em,
              c = this.getDoc(),
              d = this.getHead(),
              u = this.getBody(),
              h = this.getWindow(),
              p = o.get("Config"),
              g = [];
            h._isEditor = !0, e.styles.forEach(function (t) {
              return g.push(Object(l.isString)(t) ? {
                tag: "link",
                attributes: {
                  href: t,
                  rel: "stylesheet"
                }
              } : {
                tag: "link",
                attributes: N({
                  rel: "stylesheet"
                }, t)
              });
            }), g.length && Object(T.c)(d, g), Object(T.a)(u, "<style>\n      ".concat(p.baseCss || "", "\n\n      .").concat(i, "dashed *[data-highlightable] {\n        outline: 1px dashed rgba(170,170,170,0.7);\n        outline-offset: -2px;\n      }\n\n      .").concat(i, "selected {\n        outline: 3px solid #3b97e3 !important;\n        outline-offset: -3px;\n      }\n\n      .").concat(i, "selected-parent {\n        outline: 2px solid ").concat("#ffca6f", " !important\n      }\n\n      .").concat(i, "no-select {\n        user-select: none;\n        -webkit-user-select:none;\n        -moz-user-select: none;\n      }\n\n      .").concat(i, "freezed {\n        opacity: 0.5;\n        pointer-events: none;\n      }\n\n      .").concat(i, "no-pointer {\n        pointer-events: none;\n      }\n\n      .").concat(i, "plh-image {\n        background: #f5f5f5;\n        border: none;\n        height: 100px;\n        width: 100px;\n        display: block;\n        outline: 3px solid #ffca6f;\n        cursor: pointer;\n        outline-offset: -2px\n      }\n\n      .").concat(i, "grabbing {\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n      }\n\n      .").concat(i, "is__grabbing {\n        overflow-x: hidden;\n      }\n\n      .").concat(i, "is__grabbing,\n      .").concat(i, "is__grabbing * {\n        cursor: grabbing !important;\n      }\n\n      ").concat(p.canvasCss || "", "\n      ").concat(p.protectedCss || "", "\n    </style>")), this.root = new O.default({
              model: r,
              config: N(N({}, r.config), {}, {
                frameView: this
              })
            }).render(), Object(T.a)(u, this.root.el), Object(T.a)(u, new k.a({
              collection: a,
              config: N(N({}, o.get("CssComposer").getConfig()), {}, {
                frameView: this
              })
            }).render().el), Object(T.a)(u, this.getJsContainer()), Object(s.u)(u, "click", function (t) {
              return t && "A" == t.target.tagName && t.preventDefault();
            }), Object(s.u)(u, "submit", function (t) {
              return t && t.preventDefault();
            }), [{
              event: "keydown keyup keypress",
              class: "KeyboardEvent"
            }, {
              event: "mousemove",
              class: "MouseEvent"
            }, {
              event: "wheel",
              class: "WheelEvent"
            }].forEach(function (e) {
              return e.event.split(" ").forEach(function (n) {
                c.addEventListener(n, function (n) {
                  return t.el.dispatchEvent(Object(T.d)(n, e.class));
                });
              });
            }), this._toggleEffects(1), n.trigger("loaded");
          },
          _toggleEffects: function _toggleEffects(t) {
            (t ? s.u : s.t)(this.getWindow(), "".concat(T.i, " resize"), this._emitUpdate);
          },
          _emitUpdate: function _emitUpdate() {
            this.model._emitUpdated();
          }
        }),
        D = n(17);
      function E(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function I(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? E(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : E(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var P = m.a.View.extend({
          events: {
            "click [data-action-remove]": "remove",
            "mousedown [data-action-move]": "startDrag"
          },
          initialize: function initialize() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            Object(l.bindAll)(this, "onScroll", "frameLoaded", "updateOffset", "remove", "startDrag");
            var n = this.model,
              i = I(I({}, t.config || e), {}, {
                frameWrapView: this
              }),
              r = i.canvasView,
              a = i.em;
            this.cv = r, this.config = i, this.em = a, this.canvas = a && a.get("Canvas"), this.ppfx = i.pStylePrefix || "", this.frame = new L({
              model: n,
              config: i
            }), this.classAnim = "".concat(this.ppfx, "frame-wrapper--anim"), this.listenTo(n, "loaded", this.frameLoaded), this.listenTo(n, "change:x change:y", this.updatePos), this.listenTo(n, "change:width change:height", this.updateSize), this.updatePos(), this.setupDragger();
          },
          setupDragger: function setupDragger() {
            var t,
              e,
              n,
              i = this,
              r = this.canvas,
              a = this.model,
              o = function o(t) {
                r.toggleFramesEvents(t);
              };
            this.dragger = new D.a({
              onStart: function onStart() {
                var r = a.attributes,
                  s = r.x,
                  l = r.y;
                n = i.em.getZoomMultiplier(), t = s, e = l, o();
              },
              onEnd: function onEnd() {
                return o(1);
              },
              setPosition: function setPosition(i) {
                a.set({
                  x: t + i.x * n,
                  y: e + i.y * n
                });
              }
            });
          },
          startDrag: function startDrag(t) {
            t && this.dragger.start(t);
          },
          remove: function remove() {
            return m.a.View.prototype.remove.apply(this, arguments), this.frame.remove(), this;
          },
          updateOffset: Object(l.debounce)(function () {
            var t = this.em,
              e = this.$el,
              n = this.frame;
            t.runDefault({
              preserveSelected: 1
            }), e.removeClass(this.classAnim), n.model._emitUpdated();
          }),
          updatePos: function updatePos(t) {
            var e = this.model,
              n = this.el,
              i = e.attributes,
              r = i.x,
              a = i.y,
              o = n.style;
            this.frame.rect = 0, o.left = isNaN(r) ? r : "".concat(r, "px"), o.top = isNaN(a) ? a : "".concat(a, "px"), t && this.updateOffset();
          },
          updateSize: Object(l.debounce)(function () {
            this.updateDim();
          }),
          updateDim: function updateDim() {
            var t = this.em,
              e = this.el,
              n = this.$el,
              i = this.model,
              r = this.classAnim,
              a = i.attributes,
              o = a.width,
              s = a.height,
              c = e.style,
              d = c.width || "",
              u = c.height || "",
              h = o || "",
              p = s || "",
              g = d == h && u == p;
            if (this.frame.rect = 0, n.addClass(r), c.width = Object(l.isNumber)(h) ? "".concat(h).concat("px") : h, c.height = Object(l.isNumber)(p) ? "".concat(p).concat("px") : p, Object(l.isNull)(o) || Object(l.isNull)(s)) {
              var f = I(I({}, o ? {} : {
                width: e.offsetWidth
              }), s ? {} : {
                height: e.offsetHeight
              });
              i.set(f, {
                silent: 1
              });
            }
            t.stopDefault({
              preserveSelected: 1
            }), g ? this.updateOffset() : n.one(T.i, this.updateOffset);
          },
          onScroll: function onScroll() {
            var t = this.frame;
            this.em.trigger("frame:scroll", {
              frame: t,
              body: t.getBody(),
              target: t.getWindow()
            });
          },
          frameLoaded: function frameLoaded() {
            this.frame.getWindow().onscroll = this.onScroll, this.updateDim();
          },
          render: function render() {
            var t = this.frame,
              e = this.$el,
              n = this.ppfx,
              i = this.cv,
              r = this.model,
              a = this.el,
              o = r.attributes.onRender;
            t.render(), e.empty().attr({
              class: "".concat(n, "frame-wrapper")
            }).append('\n      <div class="'.concat(n, 'frame-wrapper__top gjs-two-color" data-frame-top>\n        <div class="').concat(n, 'frame-wrapper__name" data-action-move>\n          ').concat(r.get("name") || "", '\n        </div>\n        <div class="').concat(n, 'frame-wrapper__top-r">\n          <div class="').concat(n, 'frame-wrapper__icon" data-action-remove style="display: none">\n            <svg viewBox="0 0 24 24"><path d="M19 4h-3.5l-1-1h-5l-1 1H5v2h14M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12z"></path></svg>\n          </div>\n        </div>\n      </div>\n      <div class="').concat(n, 'frame-wrapper__right" data-frame-right></div>\n      <div class="').concat(n, 'frame-wrapper__left" data-frame-left></div>\n      <div class="').concat(n, 'frame-wrapper__bottom" data-frame-bottom></div>\n      ')).append(t.el), console.log("Create div element frame");
            var s = Object(T.e)("div", {
              class: "".concat(n, "tools"),
              style: "pointer-events:none; opacity: 0"
            }, '\n      <div class="'.concat(n, 'highlighter" data-hl></div>\n      <div class="').concat(n, 'badge" data-badge></div>\n      <div class="').concat(n, 'placeholder">\n        <div class="').concat(n, 'placeholder-int"></div>\n      </div>\n      <div class="').concat(n, 'ghost"></div>\n      <div class="').concat(n, 'toolbar" style="pointer-events:all"></div>\n      <div class="').concat(n, 'resizer"></div>\n      <div class="').concat(n, 'offset-v" data-offset>\n        <div class="gjs-marginName" data-offset-m>\n          <div class="gjs-margin-v-el gjs-margin-v-top" data-offset-m-t></div>\n          <div class="gjs-margin-v-el gjs-margin-v-bottom" data-offset-m-b></div>\n          <div class="gjs-margin-v-el gjs-margin-v-left" data-offset-m-l></div>\n          <div class="gjs-margin-v-el gjs-margin-v-right" data-offset-m-r></div>\n        </div>\n        <div class="gjs-paddingName" data-offset-m>\n          <div class="gjs-padding-v-el gjs-padding-v-top" data-offset-p-t></div>\n          <div class="gjs-padding-v-el gjs-padding-v-bottom" data-offset-p-b></div>\n          <div class="gjs-padding-v-el gjs-padding-v-left" data-offset-p-l></div>\n          <div class="gjs-padding-v-el gjs-padding-v-right" data-offset-p-r></div>\n        </div>\n      </div>\n      <div class="').concat(n, 'offset-fixed-v"></div>\n    '));
            return this.elTools = s, i.toolsWrapper.appendChild(s), o && o({
              el: a,
              elTop: a.querySelector("[data-frame-top]"),
              elRight: a.querySelector("[data-frame-right]"),
              elBottom: a.querySelector("[data-frame-bottom]"),
              elLeft: a.querySelector("[data-frame-left]"),
              frame: r,
              frameWrapperView: this,
              remove: this.remove,
              startDrag: this.startDrag
            }), this;
          }
        }),
        A = M.a.extend({
          itemView: P,
          autoAdd: 1,
          init: function init() {
            this.listenTo(this.collection, "reset", this.render);
          },
          onRender: function onRender() {
            var t = this.config,
              e = this.$el,
              n = t.em;
            n && e.attr({
              class: "".concat(n.getConfig("stylePrefix"), "frames")
            });
          }
        });
      function z(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function _(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? z(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : z(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var H,
        V = m.a.$,
        F = m.a.View.extend({
          events: {
            wheel: "onWheel"
          },
          template: function template() {
            var t = this.pfx;
            return '\n      <div class="'.concat(t, 'canvas__frames" data-frames></div>\n      <div id="').concat(t, 'tools" class="').concat(t, 'canvas__tools" data-tools></div>\n    ');
          },
          initialize: function initialize(t) {
            Object(l.bindAll)(this, "clearOff", "onKeyPress", "onCanvasMove"), Object(s.u)(window, "scroll resize", this.clearOff);
            var e = this.model,
              n = e.get("frames");
            this.config = t.config || {}, this.em = this.config.em || {}, this.pfx = this.config.stylePrefix || "", this.ppfx = this.config.pStylePrefix || "", this.className = this.config.stylePrefix + "canvas";
            var i = this.em,
              r = this.config;
            this.frames = new A({
              collection: n,
              config: _(_({}, r), {}, {
                canvasView: this,
                renderContent: 1
              })
            }), this.listenTo(i, "change:canvasOffset", this.clearOff), this.listenTo(i, "component:selected", this.checkSelected), this.listenTo(e, "change:zoom change:x change:y", this.updateFrames), this.listenTo(n, "loaded:all", function () {
              return i.trigger("loaded");
            }), this.toggleListeners(1);
          },
          checkSelected: function checkSelected(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = e.scroll,
              i = this.em.get("currentFrame");
            n && t.views.forEach(function (t) {
              t._getFrame() !== i && t.scrollIntoView(n);
            });
          },
          remove: function remove() {
            m.a.View.prototype.remove.apply(this, arguments), this.toggleListeners();
          },
          preventDefault: function preventDefault(t) {
            t && (t.preventDefault(), t._parentEvent && t._parentEvent.preventDefault());
          },
          onCanvasMove: function onCanvasMove(t) {},
          toggleListeners: function toggleListeners(t) {
            this.el, (t ? s.u : s.t)(document, "keypress", this.onKeyPress);
          },
          onKeyPress: function onKeyPress(t) {
            var e = this.em;
            " " !== Object(s.f)(t) || 1 === e.getZoomDecimal() || e.get("Canvas").isInputFocused() || (this.preventDefault(t), e.get("Editor").runCommand("core:canvas-move"));
          },
          onWheel: function onWheel(t) {
            if ((t.ctrlKey || t.metaKey) && this.em.getConfig("multiFrames")) {
              this.preventDefault(t);
              var e = this.model,
                n = Math.max(-1, Math.min(1, t.wheelDelta || -t.detail)),
                i = e.get("zoom");
              e.set("zoom", i + 2 * n);
            }
          },
          updateFrames: function updateFrames(t) {
            var e = this.em,
              n = this.model.attributes,
              i = n.x,
              r = n.y,
              a = this.getZoom(),
              o = {
                preserveSelected: 1
              },
              s = a ? 1 / a : 1;
            this.framesArea.style.transform = "scale(".concat(a, ") translate(").concat(i * s, "px, ").concat(r * s, "px)"), this.clearOff(), e.stopDefault(o), e.trigger("canvas:update", t), H && clearTimeout(H), H = setTimeout(function () {
              return e.runDefault(o);
            }, 300);
          },
          getZoom: function getZoom() {
            return this.em.getZoomDecimal();
          },
          isElInViewport: function isElInViewport(t) {
            var e = Object(s.e)(t),
              n = Object(s.d)(e),
              i = this.getFrameOffset(e),
              r = n.top,
              a = n.left;
            return r >= 0 && a >= 0 && r <= i.height && a <= i.width;
          },
          offset: function offset(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = Object(s.d)(t),
              i = t.ownerDocument.body,
              r = e.noScroll;
            return {
              top: n.top + (r ? 0 : i.scrollTop),
              left: n.left + (r ? 0 : i.scrollLeft),
              width: n.width,
              height: n.height
            };
          },
          clearOff: function clearOff() {
            this.frmOff = null, this.cvsOff = null;
          },
          getFrameOffset: function getFrameOffset(t) {
            if (!this.frmOff || t) {
              var e = this.frame.el,
                n = t ? t.ownerDocument.defaultView.frameElement : e;
              this.frmOff = this.offset(n || e);
            }
            return this.frmOff;
          },
          getCanvasOffset: function getCanvasOffset() {
            return this.cvsOff || (this.cvsOff = this.offset(this.el)), this.cvsOff;
          },
          getElementPos: function getElementPos(t, e) {
            var n = this.getZoom(),
              i = e || {},
              r = this.getFrameOffset(t),
              a = this.getCanvasOffset(),
              o = this.offset(t, e),
              s = i.avoidFrameOffset ? 0 : r.top,
              l = i.avoidFrameOffset ? 0 : r.left;
            return {
              top: o.top * n + s - a.top,
              left: o.left * n + l - a.left,
              height: o.height * n,
              width: o.width * n,
              zoom: n,
              rect: o
            };
          },
          getElementOffsets: function getElementOffsets(t) {
            var e = this;
            if (!t || Object(s.q)(t)) return {};
            var n = {},
              i = window.getComputedStyle(t);
            return ["marginTop", "marginRight", "marginBottom", "marginLeft", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft"].forEach(function (t) {
              n[t] = parseFloat(i[t]) * e.getZoom();
            }), n;
          },
          getPosition: function getPosition() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = this.frame.el.contentDocument;
            if (e) {
              var n = e.body,
                i = this.getZoom(),
                r = this.getFrameOffset(),
                a = this.getCanvasOffset(),
                o = t.noScroll;
              return {
                top: r.top + (o ? 0 : n.scrollTop) * i - a.top,
                left: r.left + (o ? 0 : n.scrollLeft) * i - a.left,
                width: a.width,
                height: a.height
              };
            }
          },
          updateScript: function updateScript(t) {
            var e = t.model,
              n = e.getId();
            t.scriptContainer || (t.scriptContainer = V('<div data-id="'.concat(n, '">')), this.getJsContainer().appendChild(t.scriptContainer.get(0))), t.el.id = n, t.scriptContainer.html("");
            var i = document.createElement("script");
            i.innerHTML = "\n        setTimeout(function() {\n          var item = document.getElementById('".concat(n, "');\n          if (!item) return;\n          (function(){\n            ").concat(e.getScriptString(), ";\n          }.bind(item))()\n        }, 1);"), setTimeout(function () {
              return t.scriptContainer.get(0).appendChild(i);
            }, 0);
          },
          getJsContainer: function getJsContainer(t) {
            var e = this.getFrameView(t);
            return e && e.getJsContainer();
          },
          getFrameView: function getFrameView(t) {
            return t && t._getFrame() || this.em.get("currentFrame");
          },
          render: function render() {
            var t = this.el,
              e = this.$el,
              n = this.ppfx,
              i = this.model,
              r = this.em,
              a = this.frames,
              o = r.get("CssComposer"),
              s = i.get("wrapper");
            e.html(this.template());
            var l = e.find("[data-frames]");
            this.framesArea = l.get(0), this.wrapper = s, s && "function" == typeof s.render && i.get("frame").set({
              wrapper: s,
              root: s.getWrapper(),
              styles: o.getAll()
            });
            var c = e.find("[data-tools]");
            this.toolsWrapper = c.get(0), c.append('\n      <div class="'.concat(n, "tools ").concat(n, 'tools-gl" style="pointer-events:none">\n        <div class="').concat(n, 'placeholder">\n          <div class="').concat(n, 'placeholder-int"></div>\n        </div>\n      </div>\n      <div id="').concat(n, 'tools" style="pointer-events:none">\n        <div class="').concat(n, 'badge"></div>\n        <div class="').concat(n, 'ghost"></div>\n        <div class="').concat(n, 'toolbar" style="pointer-events:all"></div>\n        <div class="').concat(n, 'resizer"></div>\n        <div class="').concat(n, 'offset-v"></div>\n        <div class="').concat(n, 'offset-fixed-v"></div>\n      </div>\n    '));
            var d = t.querySelector("#".concat(n, "tools"));
            this.hlEl = t.querySelector(".".concat(n, "highlighter")), this.badgeEl = t.querySelector(".".concat(n, "badge")), this.placerEl = t.querySelector(".".concat(n, "placeholder")), this.ghostEl = t.querySelector(".".concat(n, "ghost")), this.toolbarEl = t.querySelector(".".concat(n, "toolbar")), this.resizerEl = t.querySelector(".".concat(n, "resizer")), this.offsetEl = t.querySelector(".".concat(n, "offset-v")), this.fixedOffsetEl = t.querySelector(".".concat(n, "offset-fixed-v")), this.toolsGlobEl = t.querySelector(".".concat(n, "tools-gl")), this.toolsEl = d, this.el.className = this.className;
            var u = i.get("frames");
            return u.listenToLoad(), a.render(), r.setCurrentFrame(u.at(0).view), l.append(a.el), this.frame = u.at(0).view, this;
          }
        });
      function R(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function B(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? R(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : R(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      window.requestAnimationFrame, e.default = function () {
        var t,
          e,
          n = {};
        return {
          getCanvasView: function getCanvasView() {
            return e;
          },
          name: "Canvas",
          init: function init() {
            var i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            n = B(B(B({}, g), i), {}, {
              module: this
            }), this.em = n.em;
            var r = n.pStylePrefix;
            r && (n.stylePrefix = r + n.stylePrefix), t = new C(i), e = new F({
              model: t,
              config: n
            });
            var a = n.em.get("DomComponents");
            return a && this.setWrapper(a), this.model = t, this.startAutoscroll = this.startAutoscroll.bind(this), this.stopAutoscroll = this.stopAutoscroll.bind(this), this;
          },
          getConfig: function getConfig() {
            return n;
          },
          setWrapper: function setWrapper(e) {
            t.set("wrapper", e);
          },
          getElement: function getElement() {
            return e.el;
          },
          getFrame: function getFrame(e) {
            return e ? this.getFrames()[e] : t.get("frame");
          },
          getFrameEl: function getFrameEl() {
            var t = e.frame;
            return t && t.el;
          },
          getFramesEl: function getFramesEl() {
            return e.framesArea;
          },
          getWindow: function getWindow() {
            return this.getFrameEl().contentWindow;
          },
          getDocument: function getDocument() {
            var t = this.getFrameEl();
            return t && t.contentDocument;
          },
          getBody: function getBody() {
            var t = this.getDocument();
            return t && t.body;
          },
          getWrapperEl: function getWrapperEl() {
            var t = this.getBody();
            return t && t.querySelector("#wrapper");
          },
          _getCompFrame: function _getCompFrame(t) {
            return t && t._getFrame();
          },
          _getLocalEl: function _getLocalEl(t, e, n) {
            var i = t,
              r = this._getCompFrame(e);
            return r ? r[n]() : i;
          },
          getGlobalToolsEl: function getGlobalToolsEl() {
            return e.toolsGlobEl;
          },
          getToolsEl: function getToolsEl(t) {
            return this._getLocalEl(e.toolsEl, t, "getToolsEl");
          },
          getHighlighter: function getHighlighter(t) {
            return this._getLocalEl(e.hlEl, t, "getHighlighter");
          },
          getBadgeEl: function getBadgeEl(t) {
            return this._getLocalEl(e.badgeEl, t, "getBadgeEl");
          },
          getPlacerEl: function getPlacerEl() {
            return e.placerEl;
          },
          getGhostEl: function getGhostEl() {
            return e.ghostEl;
          },
          getToolbarEl: function getToolbarEl() {
            return e.toolbarEl;
          },
          getResizerEl: function getResizerEl() {
            return e.resizerEl;
          },
          getOffsetViewerEl: function getOffsetViewerEl(t) {
            return this._getLocalEl(e.offsetEl, t, "getOffsetViewerEl");
          },
          getFixedOffsetViewerEl: function getFixedOffsetViewerEl() {
            return e.fixedOffsetEl;
          },
          render: function render() {
            return e.render().el;
          },
          getOffset: function getOffset() {
            var t = this.offset(this.getFrameEl()),
              e = this.offset(this.getElement());
            return {
              top: t.top - e.top,
              left: t.left - e.left
            };
          },
          offset: function offset(t) {
            return e.offset(t);
          },
          setCustomBadgeLabel: function setCustomBadgeLabel(t) {
            n.customBadgeLabel = t;
          },
          getElementPos: function getElementPos(t, n) {
            return e.getElementPos(t, n);
          },
          getElementOffsets: function getElementOffsets(t) {
            return e.getElementOffsets(t);
          },
          getRect: function getRect() {
            var t = e.getPosition(),
              n = t.top,
              i = t.left;
            return B(B({}, e.getCanvasOffset()), {}, {
              topScroll: n,
              leftScroll: i
            });
          },
          getTargetToElementDim: function getTargetToElementDim(t, i) {
            var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              a = r || {},
              o = e.getPosition();
            if (o) {
              var s = a.elPos || e.getElementPos(i),
                l = r.toRight || 0,
                c = a.targetHeight || t.offsetHeight,
                d = a.targetWidth || t.offsetWidth,
                u = a.event || null,
                h = s.top - c,
                p = s.left;
              p += l ? s.width : 0;
              var g = (p = l ? p - d : p) < o.left ? o.left : p,
                f = h < o.top ? o.top : h,
                m = {
                  top: f = f > s.top + s.height ? s.top + s.height : f,
                  left: g,
                  elementTop: s.top,
                  elementLeft: s.left,
                  elementWidth: s.width,
                  elementHeight: s.height,
                  targetWidth: t.offsetWidth,
                  targetHeight: t.offsetHeight,
                  canvasTop: o.top,
                  canvasLeft: o.left,
                  canvasWidth: o.width,
                  canvasHeight: o.height
                };
              return u && n.em && n.em.trigger(u, m), m;
            }
          },
          canvasRectOffset: function canvasRectOffset(t, e) {
            var n = this,
              i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              r = function r(t) {
                var e = t.defaultView;
                return e && e.frameElement;
              },
              a = function a(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
                  a = arguments.length > 2 ? arguments[2] : void 0,
                  o = n.em.getZoomDecimal(),
                  s = e ? "top" : "left",
                  l = t.ownerDocument,
                  c = i.offset ? r(l) : {},
                  d = c.offsetTop,
                  u = void 0 === d ? 0 : d,
                  h = c.offsetLeft,
                  p = void 0 === h ? 0 : h,
                  g = l.body || {},
                  f = g.scrollTop,
                  m = void 0 === f ? 0 : f,
                  v = g.scrollLeft,
                  b = void 0 === v ? 0 : v,
                  y = e ? m : b,
                  w = e ? u : p;
                return a[s] - (y - w) * o;
              };
            return {
              top: a(t, 1, e),
              left: a(t, 0, e)
            };
          },
          getTargetToElementFixed: function getTargetToElementFixed(t, e) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              i = n.pos || this.getElementPos(t),
              r = n.canvasOff || this.canvasRectOffset(t, i),
              a = e.offsetHeight || 0,
              o = e.offsetWidth || 0,
              s = i.left + i.width,
              l = this.getCanvasView(),
              c = l.getPosition(),
              d = l.getFrameOffset(t),
              u = n.event,
              h = -a,
              p = i.width - o;
            p = i.left < -p ? -i.left : p, p = s > c.width ? p - (s - c.width) : p;
            var g = i.height + a,
              f = g < d.height;
            r.top < a && (f ? h += g : h = -r.top < i.height ? -r.top : i.height);
            var m = {
              top: h,
              left: p,
              canvasOffsetTop: r.top,
              canvasOffsetLeft: r.left
            };
            return u && this.em.trigger(u, m), m;
          },
          getMouseRelativePos: function getMouseRelativePos(t, e) {
            var n = 0,
              i = 0,
              r = (e || {}).subWinOffset,
              a = t.target.ownerDocument,
              o = a.defaultView || a.parentWindow,
              s = o.frameElement,
              l = r ? o.pageYOffset : 0,
              c = r ? o.pageXOffset : 0;
            if (s) {
              var d = s.getBoundingClientRect();
              n = d.top || 0, i = d.left || 0;
            }
            return {
              y: t.clientY + n - l,
              x: t.clientX + i - c
            };
          },
          getMouseRelativeCanvas: function getMouseRelativeCanvas(t, n) {
            var i = this.getZoomDecimal(),
              r = e.getPosition(n),
              a = r.top,
              o = r.left;
            return {
              y: t.clientY * i + a,
              x: t.clientX * i + o
            };
          },
          hasFocus: function hasFocus() {
            return this.getDocument().hasFocus();
          },
          isInputFocused: function isInputFocused() {
            var t = this.getDocument(),
              e = this.getFrameEl(),
              n = ["body"].concat(r()(this.getConfig().notTextable)),
              i = e && document.activeElement === e ? t && t.activeElement : document.activeElement;
            return i && !n.some(function (t) {
              return i.matches(t);
            });
          },
          scrollTo: function scrollTo(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = Object(s.e)(t),
              i = n && Object(s.j)(n);
            i && i.scrollIntoView(e);
          },
          startAutoscroll: function startAutoscroll(t) {
            var e = t && t.view || this.em.getCurrentFrame();
            e && e.startAutoscroll();
          },
          stopAutoscroll: function stopAutoscroll(t) {
            var e = t && t.view || this.em.getCurrentFrame();
            e && e.stopAutoscroll();
          },
          postRender: function postRender() {
            Object(s.k)(n.em) && (this.droppable = new p(n.em));
          },
          setZoom: function setZoom(e) {
            return t.set("zoom", parseFloat(e)), this;
          },
          getZoom: function getZoom() {
            return parseFloat(t.get("zoom"));
          },
          getZoomDecimal: function getZoomDecimal() {
            return this.getZoom() / 100;
          },
          getZoomMultiplier: function getZoomMultiplier() {
            var t = this.getZoomDecimal();
            return t ? 1 / t : 1;
          },
          toggleFramesEvents: function toggleFramesEvents(t) {
            this.getFramesEl().style.pointerEvents = t ? "" : "none";
          },
          getFrameWrapperEl: function getFrameWrapperEl() {
            return e.frame.getWrapper();
          },
          getFrames: function getFrames() {
            return t.get("frames").map(function (t) {
              return t;
            });
          },
          addFrame: function addFrame() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return t.get("frames").add(B({}, e), B(B({}, n), {}, {
              em: this.em
            }));
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(2),
        r = n.n(i),
        a = n(11),
        o = {
          stylePrefix: "gjs-",
          components: "",
          style: "",
          fromElement: 0,
          noticeOnUnload: !0,
          showOffsets: !1,
          showOffsetsSelected: !1,
          forceClass: !0,
          height: "900px",
          width: "100%",
          log: ["warning", "error"],
          baseCss: "\n    * {\n      box-sizing: border-box;\n    }\n    html, body, [data-gjs-type=wrapper] {\n      min-height: 100%;\n    }\n    body {\n      margin: 0;\n      height: 100%;\n      background-color: #fff\n    }\n    [data-gjs-type=wrapper] {\n      overflow: auto;\n      overflow-x: hidden;\n    }\n\n    * ::-webkit-scrollbar-track {\n      background: rgba(0, 0, 0, 0.1)\n    }\n\n    * ::-webkit-scrollbar-thumb {\n      background: rgba(255, 255, 255, 0.2)\n    }\n\n    * ::-webkit-scrollbar {\n      width: 10px\n    }\n  ",
          protectedCss: "* { box-sizing: border-box; } body {margin: 0;}",
          canvasCss: "",
          defaultCommand: "select-comp",
          showToolbar: 1,
          allowScripts: 0,
          showDevices: 1,
          devicePreviewMode: 0,
          mediaCondition: "max-width",
          tagVarStart: "{[ ",
          tagVarEnd: " ]}",
          keepEmptyTextNodes: 0,
          jsInHtml: !0,
          nativeDnD: 1,
          multipleSelection: 1,
          exportWrapper: 0,
          wrapperIsBody: 1,
          avoidInlineStyle: 1,
          avoidDefaults: 1,
          clearStyles: 0,
          dragMode: 0,
          listenToEl: [],
          cssIcons: "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css",
          el: "",
          i18n: {},
          undoManager: {},
          assetManager: {},
          canvas: {},
          layers: {},
          storageManager: {},
          richTextEditor: {},
          domComponents: {},
          modal: {},
          popover: {},
          codeManager: {},
          panels: {},
          commands: {},
          cssComposer: {},
          selectorManager: {},
          deviceManager: {
            devices: [{
              id: "desktop",
              name: "Desktop",
              width: ""
            }, {
              id: "tablet",
              name: "Tablet",
              width: "768px",
              widthMedia: "992px"
            }, {
              id: "mobileLandscape",
              name: "Mobile landscape",
              width: "568px",
              widthMedia: "768px"
            }, {
              id: "mobilePortrait",
              name: "Mobile portrait",
              width: "320px",
              widthMedia: "480px"
            }]
          },
          styleManager: {
            sectors: [{
              name: "General",
              open: !1,
              buildProps: ["float", "display", "position", "top", "right", "left", "bottom"]
            }, {
              name: "Flex",
              open: !1,
              buildProps: ["flex-direction", "flex-wrap", "justify-content", "align-items", "align-content", "order", "flex-basis", "flex-grow", "flex-shrink", "align-self"]
            }, {
              name: "Dimension",
              open: !1,
              buildProps: ["width", "height", "max-width", "min-height", "margin", "padding"]
            }, {
              name: "Typography",
              open: !1,
              buildProps: ["font-family", "font-size", "font-weight", "letter-spacing", "color", "line-height", "text-align", "text-shadow"],
              properties: [{
                property: "text-align",
                list: [{
                  value: "left",
                  className: "fa fa-align-left"
                }, {
                  value: "center",
                  className: "fa fa-align-center"
                }, {
                  value: "right",
                  className: "fa fa-align-right"
                }, {
                  value: "justify",
                  className: "fa fa-align-justify"
                }]
              }]
            }, {
              name: "Decorations",
              open: !1,
              buildProps: ["border-radius-c", "background-color", "border-radius", "border", "box-shadow", "background"]
            }, {
              name: "Extra",
              open: !1,
              buildProps: ["transition", "perspective", "transform"]
            }]
          },
          blockManager: {},
          traitManager: {},
          textViewCode: "Code",
          keepUnusedStyles: 0,
          multiFrames: 0
        },
        s = n(0),
        l = n(1),
        c = n.n(l),
        d = n(3);
      function u(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function h(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? u(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      c.a.$ = a.default;
      var p,
        g,
        f = [n(115), n(116), n(85), n(86), n(110), n(109), n(111), n(112), n(107), n(113), n(114), n(108), n(106), n(117), n(103), n(118), n(104), n(100), n(75), n(101), n(119), n(105)],
        m = c.a.Collection;
      !function (t) {
        var e = t.$;
        if (e && "jQuery" !== e.prototype.constructor.name) {
          var n = e.fn;
          n.hide = function () {
            return this.css("display", "none");
          }, n.show = function () {
            return this.css("display", "block");
          }, n.focus = function () {
            var t = this.get(0);
            return t && t.focus(), this;
          }, n.bind = function (t, e) {
            return this.on(t, e);
          }, n.unbind = function (t, e) {
            if (Object(s.isObject)(t)) {
              for (var n in t) t.hasOwnProperty(n) && this.off(n, t[n]);
              return this;
            }
            return this.off(t, e);
          }, n.click = function (t) {
            return t ? this.on("click", t) : this.trigger("click");
          }, n.change = function (t) {
            return t ? this.on("change", t) : this.trigger("change");
          }, n.keydown = function (t) {
            return t ? this.on("keydown", t) : this.trigger("keydown");
          }, n.delegate = function (t, e, n, i) {
            return i || (i = n), this.on(e, t, function (t) {
              t.data = n, i(t);
            });
          }, n.scrollLeft = function () {
            var t = this.get(0),
              e = (t = 9 == t.nodeType ? t.defaultView : t) instanceof Window ? t : null;
            return e ? e.pageXOffset : t.scrollLeft || 0;
          }, n.scrollTop = function () {
            var t = this.get(0),
              e = (t = 9 == t.nodeType ? t.defaultView : t) instanceof Window ? t : null;
            return e ? e.pageYOffset : t.scrollTop || 0;
          };
          var i = e.prototype.offset;
          n.offset = function (t) {
            var e, n;
            return t && (e = t.top, n = t.left), void 0 !== e && this.css("top", "".concat(e, "px")), void 0 !== n && this.css("left", "".concat(n, "px")), i.call(this);
          }, e.map = function (t, e) {
            for (var n = [], i = 0; i < t.length; i++) n.push(e(t[i], i));
            return n;
          };
          var r = Array.prototype.indexOf;
          e.inArray = function (t, e, n) {
            return null == e ? -1 : r.call(e, t, n);
          }, e.Event = function (t, n) {
            if (!(this instanceof e.Event)) return new e.Event(t, n);
            this.type = t, this.isDefaultPrevented = function () {
              return !1;
            };
          };
        }
      }({
        Backbone: c.a,
        $: c.a.$
      });
      var v = {
          debug: console.log,
          info: console.info,
          warning: console.warn,
          error: console.error
        },
        b = c.a.Model.extend({
          defaults: function defaults() {
            return {
              editing: 0,
              selected: new m(),
              clipboard: null,
              dmode: 0,
              componentHovered: null,
              previousModel: null,
              changesCount: 0,
              storables: [],
              modules: [],
              toLoad: [],
              opened: {},
              device: ""
            };
          },
          initialize: function initialize() {
            var t = this,
              e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            this.config = e, this.set("Config", e), this.set("modules", []), this.set("toLoad", []), this.set("storables", []), this.set("selected", new m()), this.set("dmode", e.dragMode);
            var n = e.el,
              i = e.log,
              r = !0 === i ? Object(s.keys)(v) : Object(s.isArray)(i) ? i : [];
            Object(s.bindAll)(this, "initBaseColorPicker"), n && e.fromElement && (this.config.components = n.innerHTML), this.attrsOrig = n ? Object(s.toArray)(n.attributes).reduce(function (t, e) {
              return t[e.nodeName] = e.nodeValue, t;
            }, {}) : "", f.forEach(function (e) {
              return t.loadModule(e);
            }), this.on("change:componentHovered", this.componentHovered, this), this.on("change:changesCount", this.updateChanges, this), r.forEach(function (e) {
              return t.listenLog(e);
            }), [{
              from: "change:selectedComponent",
              to: "component:toggled"
            }].forEach(function (e) {
              var n = e.from,
                i = e.to;
              t.listenTo(t, n, function () {
                for (var e = arguments.length, r = new Array(e), a = 0; a < e; a++) r[a] = arguments[a];
                t.trigger.apply(t, [i].concat(r)), t.logWarning("The event '".concat(n, "' is deprecated, replace it with '").concat(i, "'"));
              });
            });
          },
          getContainer: function getContainer() {
            return this.config.el;
          },
          listenLog: function listenLog(t) {
            this.listenTo(this, "log:".concat(t), v[t]);
          },
          getConfig: function getConfig(t) {
            var e = this.config;
            return Object(s.isUndefined)(t) ? e : e[t];
          },
          loadOnStart: function loadOnStart() {
            var t = this,
              e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
              n = this.get("StorageManager");
            this.get("toLoad").forEach(function (t) {
              t.onLoad();
            });
            var i = function i() {
              var n = t.get("modules");
              n && n.forEach(function (e) {
                return e.postLoad && e.postLoad(t);
              }), e && e();
            };
            n && n.canAutoload() ? this.load(i) : i();
          },
          updateChanges: function updateChanges() {
            var t = this,
              e = this.get("StorageManager"),
              n = this.get("changesCount");
            g && clearTimeout(g), g = setTimeout(function () {
              return t.trigger("update");
            });
            var i = document.querySelector(".btn-save");
            n ? i.classList.add("text-warning") : i.classList.remove("text-warning"), this.config.noticeOnUnload && (window.onbeforeunload = n ? function (t) {
              return 1;
            } : null), e.isAutosave() && n >= e.getStepsBeforeSave() && this.store();
          },
          loadModule: function loadModule(t) {
            var e = this.config,
              n = new (t.default || t)(),
              i = n.name.charAt(0).toLowerCase() + n.name.slice(1),
              r = Object(s.isUndefined)(e[i]) ? e[n.name] : e[i],
              a = r || {},
              o = this.get("StorageManager");
            if (a.pStylePrefix = e.pStylePrefix || "", Object(s.isUndefined)(r) || r || (a._disable = 1), n.storageKey && n.store && n.load && o) {
              a.stm = o;
              var l = "domComponents" == i ? "unshift" : "push";
              this.get("storables")[l](n);
            }
            return a.em = this, n.init(h({}, a)), !n.private && this.set(n.name, n), n.onLoad && this.get("toLoad").push(n), this.get("modules").push(n), this;
          },
          init: function init(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            this.destroyed && (this.initialize(e), this.destroyed = 0), this.set("Editor", t);
          },
          getEditor: function getEditor() {
            return this.get("Editor");
          },
          handleUpdates: function handleUpdates(t, e) {
            var n = this,
              i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            i.temporary || (p && clearInterval(p), p = setTimeout(function () {
              i.avoidStore || n.set("changesCount", n.get("changesCount") + 1, i);
            }, 0));
          },
          componentHovered: function componentHovered(t, e, n) {
            var i = this.previous("componentHovered");
            i && this.trigger("component:unhovered", i, n), e && this.trigger("component:hovered", e, n);
          },
          getSelected: function getSelected() {
            return this.get("selected").last();
          },
          getSelectedAll: function getSelectedAll() {
            var t = this.get("selected");
            return t && t.models || [];
          },
          setSelected: function setSelected(t) {
            var e = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              i = Object(s.isArray)(t),
              r = i ? t : [t],
              o = this.get("selected");
            i && this.removeSelected(o.filter(function (t) {
              return !Object(s.contains)(r, t);
            })), r.forEach(function (t) {
              var r = Object(d.g)(t, a.default);
              r && !r.get("selectable") || (!i && e.removeSelected(o.filter(function (t) {
                return t !== r;
              })), e.addSelected(r, n));
            });
          },
          addSelected: function addSelected(t) {
            var e = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              i = Object(d.g)(t, a.default),
              r = Object(s.isArray)(i) ? i : [i];
            r.forEach(function (t) {
              if (!t || t.get("selectable")) {
                var i = e.get("selected");
                n.forceChange && i.remove(t, n), i.push(t, n);
              }
            });
          },
          removeSelected: function removeSelected(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            this.get("selected").remove(Object(d.g)(t, a.default), e);
          },
          toggleSelected: function toggleSelected(t) {
            var e = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              i = Object(d.g)(t, a.default),
              r = Object(s.isArray)(i) ? i : [i];
            r.forEach(function (t) {
              e.get("selected").contains(t) ? e.removeSelected(t, n) : e.addSelected(t, n);
            });
          },
          setHovered: function setHovered(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = Object(d.g)(t, a.default);
            n && !n.get("hoverable") || (e.forceChange && this.set("componentHovered", ""), this.set("componentHovered", n, e));
          },
          getHovered: function getHovered() {
            return this.get("componentHovered");
          },
          setComponents: function setComponents(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return this.get("DomComponents").setComponents(t, e);
          },
          getComponents: function getComponents() {
            var t = this.get("DomComponents"),
              e = this.get("CodeManager");
            if (t && e) {
              var n = t.getComponents();
              return e.getCode(n, "json");
            }
          },
          setStyle: function setStyle(t) {
            for (var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = this.get("CssComposer").getAll(), i = 0, r = n.length; i < r; i++) n.pop();
            return n.add(t, e), this;
          },
          getStyle: function getStyle() {
            return this.get("CssComposer").getAll();
          },
          setState: function setState(t) {
            return this.set("state", t), this;
          },
          getState: function getState() {
            return this.get("state");
          },
          getHtml: function getHtml() {
            var t = this.config,
              e = t.exportWrapper,
              n = t.wrapperIsBody,
              i = t.jsInHtml ? this.getJs() : "",
              r = this.get("DomComponents").getComponent();
            return this.get("CodeManager").getCode(r, "html", {
              exportWrapper: e,
              wrapperIsBody: n
            }) + (i ? "<script>".concat(i, "<\/script>") : "");
          },
          getCss: function getCss() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = this.config,
              n = e.wrapperIsBody,
              i = t.avoidProtected,
              r = Object(s.isUndefined)(t.keepUnusedStyles) ? e.keepUnusedStyles : t.keepUnusedStyles,
              a = this.get("CssComposer"),
              o = this.get("DomComponents").getComponent(),
              l = i ? "" : e.protectedCss;
            return l + this.get("CodeManager").getCode(o, "css", {
              cssc: a,
              wrapperIsBody: n,
              keepUnusedStyles: r
            });
          },
          getJs: function getJs() {
            var t = this.get("DomComponents").getWrapper();
            return this.get("CodeManager").getCode(t, "js").trim();
          },
          store: function store(t) {
            var e = this,
              n = this.get("StorageManager"),
              i = {};
            if (n) return this.get("storables").forEach(function (t) {
              var e = t.store(1);
              for (var n in e) i[n] = e[n];
            }), n.store(i, function (n) {
              t && t(n), e.set("changesCount", 0), e.trigger("storage:store", i);
            }), i;
          },
          load: function load() {
            var t = this,
              e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
            this.getCacheLoad(1, function (n) {
              t.get("storables") && t.get("storables").forEach(function (e) {
                e.load(n), e.postLoad && e.postLoad(t);
              }), e && e(n);
            });
          },
          getCacheLoad: function getCacheLoad(t, e) {
            var n = this;
            if (this.cacheLoad && !t) return this.cacheLoad;
            var i = this.get("StorageManager"),
              r = [];
            if (!i) return {};
            this.get("storables").forEach(function (t) {
              var e = t.storageKey;
              e = Object(s.isFunction)(e) ? e() : e, (Object(s.isArray)(e) ? e : [e]).forEach(function (t) {
                return r.push(t);
              });
            }), i.load(r, function (t) {
              n.cacheLoad = t, e && e(t), setTimeout(function () {
                return n.trigger("storage:load", t);
              });
            });
          },
          getDeviceModel: function getDeviceModel() {
            var t = this.get("device");
            return this.get("DeviceManager").get(t);
          },
          runDefault: function runDefault() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = this.get("Commands").get(this.config.defaultCommand);
            e && !this.defaultRunning && (e.stop(this, this, t), e.run(this, this, t), this.defaultRunning = 1);
          },
          stopDefault: function stopDefault() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = this.get("Commands"),
              n = e.get(this.config.defaultCommand);
            n && (n.stop(this, this, t), this.defaultRunning = 0);
          },
          refreshCanvas: function refreshCanvas() {
            this.set("canvasOffset", null), this.set("canvasOffset", this.get("Canvas").getOffset());
          },
          clearSelection: function clearSelection(t) {
            (t || window).getSelection().removeAllRanges();
          },
          getCurrentMedia: function getCurrentMedia() {
            var t = this.config,
              e = this.getDeviceModel(),
              n = t.mediaCondition,
              i = t.devicePreviewMode,
              r = e && e.get("widthMedia");
            return e && r && !i ? "(".concat(n, ": ").concat(r, ")") : "";
          },
          getWrapper: function getWrapper() {
            return this.get("DomComponents").getWrapper();
          },
          setCurrentFrame: function setCurrentFrame(t) {
            return this.set("currentFrame", t);
          },
          getCurrentFrame: function getCurrentFrame() {
            return this.get("currentFrame");
          },
          getCurrentFrameModel: function getCurrentFrameModel() {
            return (this.getCurrentFrame() || {}).model;
          },
          getDirtyCount: function getDirtyCount() {
            return this.get("changesCount");
          },
          getZoomDecimal: function getZoomDecimal() {
            return this.get("Canvas").getZoomDecimal();
          },
          getZoomMultiplier: function getZoomMultiplier() {
            return this.get("Canvas").getZoomMultiplier();
          },
          setDragMode: function setDragMode(t) {
            return this.set("dmode", t);
          },
          t: function t() {
            var t;
            return (t = this.get("I18n")).t.apply(t, arguments);
          },
          inAbsoluteMode: function inAbsoluteMode() {
            return "absolute" === this.get("dmode");
          },
          destroyAll: function destroyAll() {
            var t = this.config,
              e = this.getEditor(),
              n = (t.grapesjs || {}).editors,
              i = void 0 === n ? [] : n,
              r = this.attributes,
              o = r.DomComponents,
              s = r.CssComposer,
              l = r.UndoManager,
              c = r.Panels,
              d = r.Canvas,
              u = r.Keymaps,
              h = r.RichTextEditor;
            this.stopDefault(), o.clear(), s.clear(), l.clear().removeAll(), c.getPanels().reset(), d.getCanvasView().remove(), u.removeAll(), h.destroy(), this.view.remove(), this.stopListening(), this.clear({
              silent: !0
            }), this.destroyed = 1, i.splice(i.indexOf(e), 1), Object(a.default)(t.el).empty().attr(this.attrsOrig);
          },
          setEditing: function setEditing(t) {
            return this.set("editing", t), this;
          },
          isEditing: function isEditing() {
            return !!this.get("editing");
          },
          log: function log(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = e.ns,
              i = e.level,
              r = void 0 === i ? "debug" : i;
            if (this.trigger("log", t, e), r && this.trigger("log:".concat(r), t, e), n) {
              var a = "log-".concat(n);
              this.trigger(a, t, e), r && this.trigger("".concat(a, ":").concat(r), t, e);
            }
          },
          logInfo: function logInfo(t, e) {
            this.log(t, h(h({}, e), {}, {
              level: "info"
            }));
          },
          logWarning: function logWarning(t, e) {
            this.log(t, h(h({}, e), {}, {
              level: "warning"
            }));
          },
          logError: function logError(t, e) {
            this.log(t, h(h({}, e), {}, {
              level: "error"
            }));
          },
          initBaseColorPicker: function initBaseColorPicker(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = this.getConfig(),
              i = n.colorPicker,
              r = void 0 === i ? {} : i,
              o = n.el,
              s = n.stylePrefix;
            return Object(a.default)(t).spectrum(h(h({
              containerClassName: "".concat(s, "one-bg ").concat(s, "two-color"),
              appendTo: o || "body",
              maxSelectionSize: 8,
              showPalette: !0,
              palette: [],
              showAlpha: !0,
              chooseText: "Ok",
              cancelText: "⨯"
            }, e), r));
          },
          data: function data(t, e, n) {
            if (t["_gjs-data"] || (t["_gjs-data"] = {}), Object(s.isUndefined)(n)) return t["_gjs-data"][e];
            t["_gjs-data"][e] = n;
          }
        }),
        y = c.a.$,
        w = c.a.View.extend({
          initialize: function initialize() {
            var t = this,
              e = this.model;
            e.view = this, this.conf = e.config, this.pn = e.get("Panels"), this.cv = e.get("Canvas"), e.on("loaded", function () {
              t.pn.active(), t.pn.disableButtons(), setTimeout(function () {
                e.runDefault(), e.trigger("load", e.get("Editor"));
              });
            });
          },
          render: function render() {
            this.model;
            var t = this.$el,
              e = this.conf,
              n = e.stylePrefix,
              i = y(e.el || "body ".concat(e.container));
            return Object(d.a)(e.cssIcons, {
              unique: 1,
              prepand: 1
            }), t.empty(), e.width && i.css("width", e.width), e.height && i.css("height", e.height), t.append(this.cv.render()), t.append(this.pn.render()), t.attr("class", "".concat(n, "editor ").concat(n, "one-bg ").concat(n, "two-color")), i.addClass("".concat(n, "editor-cont")).empty().append(t), this;
          }
        });
      function x(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function j(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? x(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : x(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var C = function C() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = j(j({}, o), t);
          e.pStylePrefix = e.stylePrefix;
          var n = new b(e),
            i = new w({
              model: n,
              config: e
            });
          return {
            $: a.default,
            editor: n,
            init: function init() {
              var t = this,
                r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
              return n.init(this, j(j({}, e), r)), ["I18n", "Utils", "Config", "Commands", "Keymaps", "Modal", "Popover", "Panels", "Canvas", "Parser", "CodeManager", "UndoManager", "RichTextEditor", "DomComponents", ["Components", "DomComponents"], "LayerManager", ["Layers", "LayerManager"], "CssComposer", ["Css", "CssComposer"], "StorageManager", ["Storage", "StorageManager"], "AssetManager", ["Assets", "AssetManager"], "BlockManager", ["Blocks", "BlockManager"], "TraitManager", ["Traits", "TraitManager"], "SelectorManager", ["Selectors", "SelectorManager"], "StyleManager", ["Styles", "StyleManager"], "DeviceManager", ["Devices", "DeviceManager"]].forEach(function (e) {
                Array.isArray(e) ? t[e[0]] = n.get(e[1]) : t[e] = n.get(e);
              }), n.on("loaded", function () {
                t.UndoManager.clear(), n.get("modules").forEach(function (t) {
                  t.postRender && t.postRender(i);
                });
              }), this;
            },
            getConfig: function getConfig(t) {
              return n.getConfig(t);
            },
            getHtml: function getHtml(t) {
              return n.getHtml(t);
            },
            getCss: function getCss(t) {
              return n.getCss(t);
            },
            getJs: function getJs() {
              return n.getJs();
            },
            getComponents: function getComponents() {
              return n.get("DomComponents").getComponents();
            },
            getWrapper: function getWrapper() {
              return n.get("DomComponents").getWrapper();
            },
            setComponents: function setComponents(t) {
              var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              return n.setComponents(t, e), this;
            },
            addComponents: function addComponents(t, e) {
              return this.getWrapper().append(t, e);
            },
            getStyle: function getStyle() {
              return n.get("CssComposer").getAll();
            },
            setStyle: function setStyle(t) {
              var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              return n.setStyle(t, e), this;
            },
            getSelected: function getSelected() {
              return n.getSelected();
            },
            getSelectedAll: function getSelectedAll() {
              return n.getSelectedAll();
            },
            getSelectedToStyle: function getSelectedToStyle() {
              var t = n.getSelected();
              if (t) return this.StyleManager.getModelToStyle(t);
            },
            select: function select(t, e) {
              return n.setSelected(t, e), this;
            },
            selectAdd: function selectAdd(t) {
              return n.addSelected(t), this;
            },
            selectRemove: function selectRemove(t) {
              return n.removeSelected(t), this;
            },
            selectToggle: function selectToggle(t) {
              return n.toggleSelected(t), this;
            },
            setDevice: function setDevice(t) {
              return n.set("device", t), this;
            },
            getDevice: function getDevice() {
              return n.get("device");
            },
            runCommand: function runCommand(t) {
              var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              return n.get("Commands").run(t, e);
            },
            stopCommand: function stopCommand(t) {
              var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              return n.get("Commands").stop(t, e);
            },
            store: function store(t) {
              return n.store(t);
            },
            load: function load(t) {
              return n.load(t);
            },
            getContainer: function getContainer() {
              return e.el;
            },
            getDirtyCount: function getDirtyCount() {
              return n.getDirtyCount();
            },
            refresh: function refresh() {
              n.refreshCanvas();
            },
            setCustomRte: function setCustomRte(t) {
              this.RichTextEditor.customRte = t;
            },
            setCustomParserCss: function setCustomParserCss(t) {
              return this.Parser.getConfig().parserCss = t, this;
            },
            setDragMode: function setDragMode(t) {
              return n.setDragMode(t), this;
            },
            log: function log(t) {
              var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              return n.log(t, e), this;
            },
            t: function t() {
              return n.t.apply(n, arguments);
            },
            on: function on(t, e) {
              return n.on(t, e), this;
            },
            once: function once(t, e) {
              return n.once(t, e), this;
            },
            off: function off(t, e) {
              return n.off(t, e), this;
            },
            trigger: function trigger(t) {
              return n.trigger.apply(n, arguments), this;
            },
            destroy: function destroy() {
              return n.destroyAll();
            },
            getEl: function getEl() {
              return i.el;
            },
            getModel: function getModel() {
              return n;
            },
            render: function render() {
              return i.render(), i.el;
            }
          };
        },
        M = {
          plugins: []
        };
      function k(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function O(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? k(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : k(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      !function () {
        if (function () {
          for (var t, e = window.navigator.userAgent, n = [["edge", /Edge\/([0-9\._]+)/], ["ie", /MSIE\s(7\.0)/], ["ie", /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/], ["ie", /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/]], i = 0; i < n.length && !(t = n[i][1].exec(e)); i++);
          return !!t;
        }()) {
          var t = DOMImplementation.prototype.createHTMLDocument;
          DOMImplementation.prototype.createHTMLDocument = function (e) {
            return e || (e = ""), t.apply(document.implementation, [e]);
          };
        }
      }();
      var T = new function (t) {
          var e = void 0 || {};
          for (var n in M) n in e || (e[n] = M[n]);
          var i = {};
          return {
            add: function add(t, e) {
              return i[t] ? i[t] : (i[t] = e, e);
            },
            get: function get(t) {
              return i[t];
            },
            getAll: function getAll() {
              return i;
            }
          };
        }(),
        S = [],
        N = {
          autorender: 1,
          plugins: [],
          pluginsOpts: {}
        };
      e.default = {
        $: a.default,
        editors: S,
        plugins: T,
        version: "0.1.12",
        init: function init() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = t.container;
          if (!e) throw new Error("'container' is required");
          (t = O(O(O({}, N), t), {}, {
            grapesjs: this
          })).el = Object(s.isElement)(e) ? e : document.querySelector(e);
          var n = new C(t).init();
          return t.plugins.forEach(function (e) {
            var i = T.get(e),
              r = t.pluginsOpts[e] || {};
            if (!i) {
              var a = window[e];
              i = a && a.default ? a.default : a;
            }
            i ? i(n, r) : Object(s.isFunction)(e) && e(n, r);
          }), n.getModel().loadOnStart(), t.autorender && n.render(), S.push(n), n;
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = {
          assets: [],
          noAssets: "",
          stylePrefix: "am-",
          upload: 0,
          uploadName: "files",
          headers: {},
          params: {},
          credentials: "include",
          multiUpload: !0,
          autoAdd: 1,
          customFetch: "",
          uploadFile: "",
          embedAsBase64: 1,
          handleAdd: "",
          dropzone: 0,
          openAssetsOnDrop: 1,
          dropzoneContent: "",
          beforeUpload: null,
          showUrlInput: !0
        },
        r = n(1),
        a = n.n(r),
        o = n(2),
        s = n.n(o),
        l = a.a.Model.extend({
          idAttribute: "src",
          defaults: {
            type: "",
            src: ""
          },
          getFilename: function getFilename() {
            return this.get("src").split("/").pop();
          },
          getExtension: function getExtension() {
            return this.getFilename().split(".").pop();
          }
        });
      function c(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function d(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? c(Object(n), !0).forEach(function (e) {
            s()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var u = l.extend({
          defaults: d(d({}, l.prototype.defaults), {}, {
            type: "image",
            unitDim: "px",
            height: 0,
            width: 0
          })
        }),
        h = n(0),
        p = a.a.View.extend({
          initialize: function initialize() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            this.options = t, this.collection = t.collection;
            var e = t.config || {};
            this.config = e, this.pfx = e.stylePrefix || "", this.ppfx = e.pStylePrefix || "", this.em = e.em, this.className = this.pfx + "asset", this.listenTo(this.model, "destroy remove", this.remove), this.model.view = this;
            var n = this.init && this.init.bind(this);
            n && n(t);
          },
          template: function template() {
            var t = this.pfx;
            return '\n      <div class="'.concat(t, 'preview-cont">\n        ').concat(this.getPreview(), '\n      </div>\n      <div class="').concat(t, 'meta">\n        ').concat(this.getInfo(), '\n      </div>\n      <div class="').concat(t, 'close" data-toggle="asset-remove">\n        &Cross;\n      </div>\n    ');
          },
          updateTarget: function updateTarget(t) {
            t && t.set && (t.set("attributes", Object(h.clone)(t.get("attributes"))), t.set("src", this.model.get("src")));
          },
          getPreview: function getPreview() {
            return "";
          },
          getInfo: function getInfo() {
            return "";
          },
          render: function render() {
            var t = this.el;
            return t.innerHTML = this.template(this, this.model), t.className = this.className, this;
          }
        }).extend({
          events: {
            "click [data-toggle=asset-remove]": "onRemove",
            click: "onClick",
            dblclick: "onDblClick"
          },
          getPreview: function getPreview() {
            var t = this.pfx,
              e = this.model.get("src");
            return '\n      <div class="'.concat(t, 'preview" style="background-image: url(\'').concat(e, '\');"></div>\n      <div class="').concat(t, "preview-bg ").concat(this.ppfx, 'checker-bg"></div>\n    ');
          },
          getInfo: function getInfo() {
            var t = this.pfx,
              e = this.model,
              n = e.get("name"),
              i = e.get("width"),
              r = e.get("height"),
              a = e.get("unitDim"),
              o = i && r ? "".concat(i, "x").concat(r).concat(a) : "";
            return n = n || e.getFilename(), '\n      <div class="'.concat(t, 'name">').concat(n, '</div>\n      <div class="').concat(t, 'dimensions">').concat(o, "</div>\n    ");
          },
          init: function init(t) {
            var e = this.pfx;
            this.className += " ".concat(e, "asset-image");
          },
          onClick: function onClick() {
            var t = this.config.onClick,
              e = this.model;
            this.collection.trigger("deselectAll"), this.$el.addClass(this.pfx + "highlight"), Object(h.isFunction)(t) ? t(e) : this.updateTarget(this.collection.target);
          },
          onDblClick: function onDblClick() {
            var t = this.em,
              e = this.model,
              n = this.config.onDblClick;
            Object(h.isFunction)(n) ? n(e) : (this.updateTarget(this.collection.target), t && t.get("Modal").close());
            var i = this.collection.onSelect;
            Object(h.isFunction)(i) && i(e);
          },
          onRemove: function onRemove(t) {
            t.stopImmediatePropagation(), this.model.collection.remove(this.model);
          }
        }),
        g = n(30),
        f = a.a.Collection.extend(g.a).extend({
          types: [{
            id: "image",
            model: u,
            view: p,
            isType: function isType(t) {
              return "string" == typeof t ? {
                type: "image",
                src: t
              } : t;
            }
          }]
        }),
        m = n(25),
        v = n.n(m),
        b = ["pfx", "ppfx", "em"],
        y = a.a.View.extend({
          events: {
            submit: "handleSubmit"
          },
          template: function template(t) {
            var e = t.pfx,
              n = t.ppfx,
              i = t.em,
              r = (v()(t, b), "");
            return this.config.showUrlInput && (r = '\n          <form class="'.concat(e, 'add-asset">\n            <div class="').concat(n, "field ").concat(e, 'add-field">\n              <input placeholder="').concat(i && i.t("assetManager.inputPlh"), '"/>\n            </div>\n            <button class="').concat(n, 'btn-prim">').concat(i && i.t("assetManager.addButton"), '</button>\n            <div style="clear:both"></div>\n          </form>\n      ')), '\n    <div class="'.concat(e, 'assets-cont">\n      <div class="').concat(e, 'assets-header">\n        ').concat(r, '\n      </div>\n      <div class="').concat(e, 'assets" data-el="assets"></div>\n      <div style="clear:both"></div>\n    </div>\n    ');
          },
          initialize: function initialize(t) {
            this.options = t, this.config = t.config, this.pfx = this.config.stylePrefix || "", this.ppfx = this.config.pStylePrefix || "", this.em = this.config.em;
            var e = this.collection;
            this.listenTo(e, "reset", this.renderAssets), this.listenTo(e, "add", this.addToAsset), this.listenTo(e, "remove", this.removedAsset), this.listenTo(e, "deselectAll", this.deselectAll);
          },
          handleSubmit: function handleSubmit(t) {
            t.preventDefault();
            var e = this.getAddInput(),
              n = e && e.value.trim(),
              i = this.config.handleAdd;
            n && (e.value = "", this.getAssetsEl().scrollTop = 0, i ? i.bind(this)(n) : this.options.globalCollection.add(n, {
              at: 0
            }));
          },
          getAssetsEl: function getAssetsEl() {
            return this.el.querySelector(".".concat(this.pfx, "assets"));
          },
          getAddInput: function getAddInput() {
            return this.inputUrl && this.inputUrl.value || (this.inputUrl = this.el.querySelector(".".concat(this.pfx, "add-asset input"))), this.inputUrl;
          },
          removedAsset: function removedAsset(t) {
            this.collection.length || this.toggleNoAssets();
          },
          addToAsset: function addToAsset(t) {
            1 == this.collection.length && this.toggleNoAssets(1), this.addAsset(t);
          },
          addAsset: function addAsset(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
              n = e,
              i = this.collection,
              r = this.config,
              a = new t.typeView({
                model: t,
                collection: i,
                config: r
              }).render().el;
            if (n) n.appendChild(a);else {
              var o = this.getAssetsEl();
              o && o.insertBefore(a, o.firstChild);
            }
            return a;
          },
          toggleNoAssets: function toggleNoAssets(t) {
            var e = this.$el.find(".".concat(this.pfx, "assets"));
            if (t) e.empty();else {
              var n = this.config.noAssets;
              n && e.append(n);
            }
          },
          deselectAll: function deselectAll() {
            var t = this.pfx;
            this.$el.find(".".concat(t, "highlight")).removeClass("".concat(t, "highlight"));
          },
          renderAssets: function renderAssets() {
            var t = this,
              e = document.createDocumentFragment(),
              n = this.$el.find(".".concat(this.pfx, "assets"));
            n.empty(), this.toggleNoAssets(this.collection.length), this.collection.each(function (n) {
              return t.addAsset(n, e);
            }), n.append(e);
          },
          render: function render() {
            var t = this.options.fu.render().el;
            return this.$el.empty(), this.$el.append(t).append(this.template(this)), this.el.className = "".concat(this.ppfx, "asset-manager"), this.renderAssets(), this.rendered = 1, this;
          }
        }),
        w = n(28);
      function x(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for (var n = 0, i = new Array(e); n < e; n++) i[n] = t[n];
        return i;
      }
      var j = a.a.View.extend({
        template: Object(h.template)('\n  <form>\n    <div id="<%= pfx %>title"><%= title %></div>\n    <input type="file" id="<%= uploadId %>" name="file" accept="*/*" <%= disabled ? \'disabled\' : \'\' %> <%= multiUpload ? \'multiple\' : \'\' %>/>\n    <div style="clear:both;"></div>\n  </form>\n  '),
        events: {},
        initialize: function initialize() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          this.options = t;
          var e = t.config || {};
          this.config = e, this.em = this.config.em, this.pfx = e.stylePrefix || "", this.ppfx = e.pStylePrefix || "", this.target = this.options.globalCollection || {}, this.uploadId = this.pfx + "uploadFile", this.disabled = void 0 !== e.disableUpload ? e.disableUpload : !e.upload && !e.embedAsBase64, this.multiUpload = void 0 === e.multiUpload || e.multiUpload, this.events["change #" + this.uploadId] = "uploadFile";
          var n = e.uploadFile;
          n ? this.uploadFile = n.bind(this) : !e.upload && e.embedAsBase64 && (this.uploadFile = this.constructor.embedAsBase64), this.delegateEvents();
        },
        onUploadStart: function onUploadStart() {
          var t = this.config.em;
          t && t.trigger("asset:upload:start");
        },
        onUploadEnd: function onUploadEnd(t) {
          var e = this.$el,
            n = this.config.em;
          n && n.trigger("asset:upload:end", t);
          var i = e.find("input");
          i && i.val("");
        },
        onUploadError: function onUploadError(t) {
          var e = this.config.em;
          this.onUploadEnd(t), e && e.trigger("asset:upload:error", t);
        },
        onUploadResponse: function onUploadResponse(t, e) {
          var n,
            i = this.config.em,
            r = this.config,
            a = this.target;
          try {
            n = "string" == typeof t ? JSON.parse(t) : t;
          } catch (e) {
            n = t;
          }
          i && i.trigger("asset:upload:response", n), r.autoAdd && a && a.add(n.data, {
            at: 0
          }), this.onUploadEnd(t), e && e(n);
        },
        uploadFile: function uploadFile(t, e) {
          var n = this,
            i = t.dataTransfer ? t.dataTransfer.files : t.target.files,
            r = this.config,
            a = r.beforeUpload;
          if (!1 !== (a && a(i))) {
            var o = new FormData(),
              s = r.params,
              l = r.customFetch;
            for (var c in s) o.append(c, s[c]);
            if (this.multiUpload) for (var d = 0; d < i.length; d++) o.append("".concat(r.uploadName, "[]"), i[d]);else i.length && o.append(r.uploadName, i[0]);
            this.target;
            var u = r.upload,
              h = r.headers;
            if (void 0 === h["X-Requested-With"] && (h["X-Requested-With"] = "XMLHttpRequest"), u) {
              this.onUploadStart();
              var p = {
                method: "post",
                credentials: r.credentials || "include",
                headers: h,
                body: o
              };
              return (l ? l(u, p) : Object(w.a)(u, p).then(function (t) {
                return 1 == (t.status / 200 | 0) ? t.text() : t.text().then(function (t) {
                  return Promise.reject(t);
                });
              })).then(function (t) {
                return n.onUploadResponse(t, e);
              }).catch(function (t) {
                return n.onUploadError(t);
              });
            }
          }
        },
        initDrop: function initDrop() {
          var t = this;
          !this.uploadForm && (this.uploadForm = this.$el.find("form").get(0), "draggable" in this.uploadForm) && (this.uploadFile, this.uploadForm.ondragover = function () {
            return this.className = t.pfx + "hover", !1;
          }, this.uploadForm.ondragleave = function () {
            return this.className = "", !1;
          }, this.uploadForm.ondrop = function (e) {
            this.className = "", e.preventDefault(), t.uploadFile(e);
          });
        },
        initDropzone: function initDropzone(t) {
          var e = this,
            n = 0,
            i = this.config,
            r = t.model,
            a = t.el,
            o = r.get("Editor"),
            s = (r.get("Config").el, r.get("Canvas").getBody()),
            l = this.ppfx,
            c = "".concat(l, "dropzone-active"),
            d = "".concat(l, "dropzone"),
            u = function u() {
              a.className = a.className.replace(c, "").trim(), n = 0;
            },
            h = function h() {
              return n || (a.className += " ".concat(c), n = 1), !1;
            },
            p = function p() {
              return u(), !1;
            },
            g = function g(t) {
              if (u(), t.preventDefault(), t.stopPropagation(), e.uploadFile(t), i.openAssetsOnDrop && o) {
                var n = o.getSelected();
                o.runCommand("open-assets", {
                  target: n,
                  onSelect: function onSelect() {
                    o.Modal.close(), o.AssetManager.setTarget(null);
                  }
                });
              }
              return !1;
            };
          t.$el.append('<div class="'.concat(d, '">').concat(i.dropzoneContent, "</div>")), u(), "draggable" in a && [a, s].forEach(function (t) {
            t.ondragover = h, t.ondragleave = p, t.ondrop = g;
          });
        },
        render: function render() {
          var t = this.$el,
            e = this.pfx,
            n = this.em;
          return t.html(this.template({
            title: n && n.t("assetManager.uploadTitle"),
            uploadId: this.uploadId,
            disabled: this.disabled,
            multiUpload: this.multiUpload,
            pfx: e
          })), this.initDrop(), t.attr("class", e + "file-uploader"), this;
        }
      }, {
        embedAsBase64: function embedAsBase64(t, e) {
          var n = this,
            i = t.dataTransfer ? t.dataTransfer.files : t.target.files,
            r = {
              data: []
            };
          if (FileReader) {
            var a,
              o = [],
              s = /^(.+)\/(.+)$/,
              l = function (t, e) {
                var _n4 = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                if (!_n4) {
                  if (Array.isArray(t) || (_n4 = function (t, e) {
                    if (t) {
                      if ("string" == typeof t) return x(t, e);
                      var n = Object.prototype.toString.call(t).slice(8, -1);
                      return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? x(t, e) : void 0;
                    }
                  }(t)) || e && t && "number" == typeof t.length) {
                    _n4 && (t = _n4);
                    var i = 0,
                      r = function r() {};
                    return {
                      s: r,
                      n: function n() {
                        return i >= t.length ? {
                          done: !0
                        } : {
                          done: !1,
                          value: t[i++]
                        };
                      },
                      e: function e(t) {
                        throw t;
                      },
                      f: r
                    };
                  }
                  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                var a,
                  o = !0,
                  s = !1;
                return {
                  s: function s() {
                    _n4 = _n4.call(t);
                  },
                  n: function n() {
                    var t = _n4.next();
                    return o = t.done, t;
                  },
                  e: function e(t) {
                    s = !0, a = t;
                  },
                  f: function f() {
                    try {
                      o || null == _n4.return || _n4.return();
                    } finally {
                      if (s) throw a;
                    }
                  }
                };
              }(i);
            try {
              var c = function c() {
                var t = a.value,
                  e = new Promise(function (e, n) {
                    var i = new FileReader();
                    i.addEventListener("load", function (r) {
                      var a,
                        o = t.name,
                        l = s.exec(t.type);
                      if ("image" === (a = l ? l[1] : t.type)) {
                        var c = {
                            src: i.result,
                            name: o,
                            type: a,
                            height: 0,
                            width: 0
                          },
                          d = new Image();
                        d.addEventListener("error", function (t) {
                          n(t);
                        }), d.addEventListener("load", function () {
                          c.height = d.height, c.width = d.width, e(c);
                        }), d.src = c.src;
                      } else e(a ? {
                        src: i.result,
                        name: o,
                        type: a
                      } : i.result);
                    }), i.addEventListener("error", function (t) {
                      n(t);
                    }), i.addEventListener("abort", function (t) {
                      n("Aborted");
                    }), i.readAsDataURL(t);
                  });
                o.push(e);
              };
              for (l.s(); !(a = l.n()).done;) c();
            } catch (t) {
              l.e(t);
            } finally {
              l.f();
            }
            Promise.all(o).then(function (t) {
              r.data = t, n.onUploadResponse(r, e);
            }, function (t) {
              n.onUploadError(t);
            });
          } else this.onUploadError(new Error("Unsupported platform, FileReader is not defined"));
        }
      });
      e.default = function () {
        var t,
          e,
          n,
          r = {};
        return {
          name: "AssetManager",
          storageKey: "assets",
          getConfig: function getConfig() {
            return r;
          },
          init: function init(a) {
            var o = this;
            for (var s in r = a || {}, i) s in r || (r[s] = i[s]);
            var l = r.pStylePrefix,
              c = r.em;
            l && (r.stylePrefix = l + r.stylePrefix), t = new f([]);
            var d = {
              collection: new f([]),
              globalCollection: t,
              config: r
            };
            return n = new j(d), d.fu = n, e = new y(d), t.listenTo(t, "add", function (t) {
              o.getAllVisible().add(t), c && c.trigger("asset:add", t);
            }), t.listenTo(t, "remove", function (t) {
              o.getAllVisible().remove(t), c && c.trigger("asset:remove", t);
            }), this;
          },
          add: function add(e) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return void 0 === n.at && (n.at = 0), t.add(e, n);
          },
          get: function get(e) {
            return t.where({
              src: e
            })[0];
          },
          getAll: function getAll() {
            return t;
          },
          getAllVisible: function getAllVisible() {
            return e.collection;
          },
          remove: function remove(t) {
            var e = this.get(t);
            return this.getAll().remove(e), this;
          },
          store: function store(t) {
            var e = {},
              n = JSON.stringify(this.getAll().toJSON());
            return e[this.storageKey] = n, !t && r.stm && r.stm.store(e), e;
          },
          load: function load() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = this.storageKey,
              n = t[e] || [];
            if ("string" == typeof n) try {
              n = JSON.parse(t[e]);
            } catch (t) {}
            return n && n.length && this.getAll().reset(n), n;
          },
          getContainer: function getContainer() {
            return e.el;
          },
          getAssetsEl: function getAssetsEl() {
            return e.el.querySelector("[data-el=assets]");
          },
          render: function render(t) {
            var n = t || this.getAll().models;
            return e.rendered || e.render(), e.collection.reset(n), this.getContainer();
          },
          addType: function addType(t, e) {
            this.getAll().addType(t, e);
          },
          getType: function getType(t) {
            return this.getAll().getType(t);
          },
          getTypes: function getTypes() {
            return this.getAll().getTypes();
          },
          AssetsView: function AssetsView() {
            return e;
          },
          FileUploader: function FileUploader() {
            return n;
          },
          onLoad: function onLoad() {
            this.getAll().reset(r.assets);
          },
          postRender: function postRender(t) {
            r.dropzone && n.initDropzone(t);
          },
          setTarget: function setTarget(t) {
            e.collection.target = t;
          },
          onSelect: function onSelect(t) {
            e.collection.onSelect = t;
          },
          onClick: function onClick(t) {
            r.onClick = t;
          },
          onDblClick: function onDblClick(t) {
            r.onDblClick = t;
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(0),
        r = {
          stylePrefix: "trt-",
          appendTo: "",
          optionsTarget: [{
            value: !1
          }, {
            value: "_blank"
          }]
        },
        a = n(20),
        o = n(2),
        s = n.n(o),
        l = n(80),
        c = n.n(l),
        d = n(1),
        u = n.n(d),
        h = n(3);
      function p(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function g(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? p(Object(n), !0).forEach(function (e) {
            s()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var f = u.a.$,
        m = u.a.View.extend({
          events: {},
          eventCapture: ["change"],
          appendInput: 1,
          attributes: function attributes() {
            return this.model.get("attributes");
          },
          templateLabel: function templateLabel() {
            var t = this.ppfx,
              e = this.getLabel(),
              n = this.getLabelTitle(),
              i = this.getLabelTitleInfo();
            return '<div class="'.concat(t, 'label" title="').concat(n, '">').concat(e).concat(i, "</div>");
          },
          templateInput: function templateInput() {
            var t = this.clsField;
            return '<div class="'.concat(t, '" data-input></div>');
          },
          initialize: function initialize() {
            var t = this,
              e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              n = e.config,
              i = void 0 === n ? {} : n,
              r = this.model,
              a = this.eventCapture,
              o = r.target,
              s = r.attributes.type;
            this.config = i, this.em = i.em, this.pfx = i.stylePrefix || "", this.ppfx = i.pStylePrefix || "", this.target = o;
            var l = this.ppfx;
            this.clsField = "".concat(l, "field ").concat(l, "field-").concat(s), [["change:value", this.onValueChange], ["remove", this.removeView]].forEach(function (e) {
              var n = c()(e, 2),
                i = n[0],
                a = n[1];
              r.off(i, a), t.listenTo(r, i, a);
            }), r.view = this, this.listenTo(r, "change:label", this.render), this.listenTo(r, "change:placeholder", this.rerender), a.forEach(function (e) {
              return t.events[e] = "onChange";
            }), this.delegateEvents(), this.init();
          },
          getClbOpts: function getClbOpts() {
            return {
              component: this.target,
              trait: this.model,
              elInput: this.getInputElem()
            };
          },
          removeView: function removeView() {
            this.remove(), this.removed();
          },
          init: function init() {},
          removed: function removed() {},
          onRender: function onRender() {},
          onUpdate: function onUpdate() {},
          onEvent: function onEvent() {},
          onChange: function onChange(t) {
            var e = this.getInputElem();
            e && !Object(i.isUndefined)(e.value) && this.model.set("value", e.value), this.onEvent(g(g({}, this.getClbOpts()), {}, {
              event: t
            }));
          },
          getValueForTarget: function getValueForTarget() {
            return this.model.get("value");
          },
          setInputValue: function setInputValue(t) {
            var e = this.getInputElem();
            e && (e.value = t);
          },
          onValueChange: function onValueChange(t, e) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            if (n.fromTarget) this.setInputValue(t.get("value")), this.postUpdate();else {
              var i = this.getValueForTarget();
              t.setTargetValue(i, n);
            }
          },
          renderLabel: function renderLabel() {
            var t = this.$el,
              e = this.target,
              n = this.getLabel(),
              i = this.templateLabel(e);
            this.createLabel && (i = this.createLabel({
              label: n,
              component: e,
              trait: this
            }) || ""), t.find("[data-label]").append(i);
          },
          getLabel: function getLabel() {
            var t = this.em,
              e = this.model.attributes,
              n = e.label,
              i = e.name;
            return t.t("traitManager.traits.labels.".concat(i)) || Object(h.c)(n || i).replace(/-/g, " ");
          },
          getLabelTitle: function getLabelTitle() {
            var t = this.em,
              e = this.model.attributes,
              n = e.label,
              i = e.name,
              r = e.title;
            return r ? Object(h.c)(r).replace(/-/g, " ") : t.t("traitManager.traits.labels.".concat(i)) || Object(h.c)(n || i).replace(/-/g, " ");
          },
          getLabelTitleInfo: function getLabelTitleInfo() {
            var t = this.model.attributes,
              e = t.info,
              n = t.infoStyle;
            return e ? '<i class="gjs-block__info-fa fa fa-info-circle" style="'.concat(n || "margin-left: 5px", '" title="').concat(e, '"></i>') : "";
          },
          getComponent: function getComponent() {
            return this.target;
          },
          getInputEl: function getInputEl() {
            if (!this.$input) {
              var t = this.em,
                e = this.model,
                n = e,
                r = e.attributes.name,
                a = n.get("placeholder") || n.get("default") || "",
                o = n.get("type") || "text",
                s = n.get("min"),
                l = n.get("max"),
                c = this.getModelValue(),
                d = f('<input type="'.concat(o, '" placeholder="').concat(a, '">')),
                u = t.t("traitManager.traits.attributes.".concat(r)) || {};
              d.attr(u), Object(i.isUndefined)(c) || (n.set({
                value: c
              }, {
                silent: !0
              }), d.prop("value", c)), s && d.prop("min", s), l && d.prop("max", l), this.$input = d;
            }
            return this.$input.get(0);
          },
          getInputElem: function getInputElem() {
            var t = this.input,
              e = this.$input;
            return t || e && e.get && e.get(0) || this.getElInput();
          },
          getModelValue: function getModelValue() {
            var t,
              e = this.model,
              n = this.target,
              r = e.get("name");
            if (e.get("changeProp")) t = n.get(r);else {
              var a = n.get("attributes");
              t = e.get("value") || a[r];
            }
            return Object(i.isUndefined)(t) ? "" : t;
          },
          getElInput: function getElInput() {
            return this.elInput;
          },
          renderField: function renderField() {
            var t = this.$el,
              e = this.appendInput,
              n = this.model,
              r = t.find("[data-input]"),
              a = r[r.length - 1],
              o = n.el;
            o || (o = this.createInput ? this.createInput(this.getClbOpts()) : this.getInputEl()), Object(i.isString)(o) ? (a.innerHTML = o, this.elInput = a.firstChild) : (e ? a.appendChild(o) : a.insertBefore(o, a.firstChild), this.elInput = o), n.el = this.elInput;
          },
          hasLabel: function hasLabel() {
            var t = this.model.attributes.label;
            return !this.noLabel && !1 !== t;
          },
          rerender: function rerender() {
            this.model.el = null, this.render();
          },
          postUpdate: function postUpdate() {
            this.onUpdate(this.getClbOpts());
          },
          render: function render() {
            var t = this.$el,
              e = this.pfx,
              n = this.ppfx,
              r = this.model.attributes.type,
              a = this.hasLabel && this.hasLabel(),
              o = "".concat(e, "trait");
            this.$input = null;
            var s = '<div class="'.concat(o, " ").concat(o, "--").concat(r, '">\n      ').concat(a ? '<div class="'.concat(n, 'label-wrp" data-label></div>') : "", '\n      <div class="').concat(n, "field-wrp ").concat(n, "field-wrp--").concat(r, '" data-input>\n        ').concat(this.templateInput ? Object(i.isFunction)(this.templateInput) ? this.templateInput(this.getClbOpts()) : this.templateInput : "", "\n      </div>\n    </div>");
            return t.empty().append(s), a && this.renderLabel(), this.renderField(), this.el.className = "".concat(o, "__wrp"), this.postUpdate(), this.onRender(this.getClbOpts()), this;
          }
        }),
        v = u.a.$,
        b = m.extend({
          init: function init() {
            this.listenTo(this.model, "change:options", this.rerender);
          },
          templateInput: function templateInput() {
            var t = this.ppfx,
              e = this.clsField;
            return '<div class="'.concat(e, '">\n      <div data-input></div>\n      <div class="').concat(t, 'sel-arrow">\n        <div class="').concat(t, 'd-s-arrow"></div>\n      </div>\n    </div>');
          },
          getInputEl: function getInputEl() {
            if (!this.$input) {
              var t = this.model,
                e = this.em,
                n = t.get("name"),
                r = t.get("options") || [],
                a = [],
                o = "<select>";
              r.forEach(function (t) {
                var r,
                  s,
                  l,
                  c = "";
                Object(i.isString)(t) ? (r = t, s = t) : (r = t.name || t.label || t.value, s = "".concat(Object(i.isUndefined)(t.value) ? t.id : t.value).replace(/"/g, "&quot;"), c += (l = t.style ? t.style.replace(/"/g, "&quot;") : "") ? ' style="'.concat(l, '"') : "");
                var d = e.t("traitManager.traits.options.".concat(n, ".").concat(s)) || r;
                o += '<option value="'.concat(s, '"').concat(c, ">").concat(d, "</option>"), a.push(s);
              }), o += "</select>", this.$input = v(o);
              var s = t.getTargetValue(),
                l = a.indexOf(s) >= 0 ? s : t.get("default");
              !Object(i.isUndefined)(l) && this.$input.val(l);
            }
            return this.$input.get(0);
          }
        }),
        y = m.extend({
          appendInput: 0,
          templateInput: function templateInput() {
            var t = this.ppfx,
              e = this.clsField;
            return '<label class="'.concat(e, '" data-input>\n    <i class="').concat(t, 'chk-icon"></i>\n  </label>');
          },
          onChange: function onChange() {
            var t = this.getInputElem().checked;
            this.model.set("value", this.getCheckedValue(t));
          },
          getCheckedValue: function getCheckedValue(t) {
            var e = t,
              n = this.model.attributes,
              r = n.valueTrue,
              a = n.valueFalse;
            return e && !Object(i.isUndefined)(r) && (e = r), e || Object(i.isUndefined)(a) || (e = a), e;
          },
          getInputEl: function getInputEl() {
            for (var t = !this.$input, e = arguments.length, n = new Array(e), r = 0; r < e; r++) n[r] = arguments[r];
            var a = m.prototype.getInputEl.apply(this, n);
            if (t) {
              var o,
                s,
                l = this.model,
                c = this.target,
                d = l.attributes,
                u = (d.valueTrue, d.valueFalse),
                h = l.get("name");
              l.get("changeProp") ? s = o = c.get(h) : o = !(!(s = c.get("attributes")[h]) && "" !== s), Object(i.isUndefined)(u) || s !== u || (o = !1), a.checked = o;
            }
            return a;
          }
        }),
        w = n(32),
        x = m.extend({
          getValueForTarget: function getValueForTarget() {
            var t = this.model.attributes,
              e = t.value,
              n = t.unit;
            return e ? e + n : "";
          },
          getInputEl: function getInputEl() {
            if (!this.input) {
              var t = this.getModelValue(),
                e = new w.a({
                  contClass: this.ppfx + "field-int",
                  model: this.model,
                  ppfx: this.ppfx
                });
              this.input = e.render(), this.$input = this.input.inputEl, this.$unit = this.input.unitEl, this.model.set("value", t), this.$input.val(t), this.input = e.el;
            }
            return this.input;
          }
        }),
        j = n(38),
        C = m.extend({
          templateInput: "",
          getInputEl: function getInputEl() {
            if (!this.input) {
              var t = this.model,
                e = this.getModelValue(),
                n = new j.a({
                  model: t,
                  target: this.config.em,
                  contClass: this.ppfx + "field-color",
                  ppfx: this.ppfx
                }).render();
              n.setValue(e, {
                fromTarget: 1
              }), this.input = n.el;
            }
            return this.input;
          }
        }),
        M = m.extend({
          events: {
            "click button": "handleClick"
          },
          templateInput: "",
          handleClick: function handleClick() {
            var t = this.model,
              e = this.em,
              n = t.get("command");
            n && (Object(i.isString)(n) ? e.get("Commands").run(n) : n(e.get("Editor"), t));
          },
          renderLabel: function renderLabel() {
            this.model.get("label") && m.prototype.renderLabel.apply(this, arguments);
          },
          getInputEl: function getInputEl() {
            var t = this.model,
              e = this.ppfx,
              n = t.props(),
              i = n.labelButton,
              r = n.text,
              a = n.full,
              o = i || r,
              s = "".concat(e, "btn");
            return '<button type="button" class="'.concat(s, "-prim").concat(a ? " ".concat(s, "--full") : "", '">').concat(o, "</button>");
          }
        }),
        k = a.a.extend({
          ns: "Traits",
          itemView: m,
          reuseView: 1,
          itemsView: {
            text: m,
            number: x,
            select: b,
            checkbox: y,
            color: C,
            button: M
          },
          initialize: function initialize() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = t.config || {};
            this.config = e, this.em = t.editor, this.pfx = e.stylePrefix || "", this.ppfx = e.pStylePrefix || "", this.className = this.pfx + "traits";
            var n = "component:toggled";
            this.listenTo(this.em, n, this.updatedCollection), this.updatedCollection();
          },
          updatedCollection: function updatedCollection() {
            var t = this.ppfx,
              e = this.em.getSelected();
            this.el.className = "".concat(this.className, " ").concat(t, "one-bg ").concat(t, "two-color"), this.collection = e ? e.get("traits") : [], this.render();
          }
        });
      e.default = function () {
        var t,
          e = {};
        return {
          TraitsView: k,
          name: "TraitManager",
          getConfig: function getConfig() {
            return e;
          },
          init: function init() {
            var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            e = n, Object(i.defaults)(e, r);
            var a = e.pStylePrefix;
            return a && (e.stylePrefix = "".concat(a).concat(e.stylePrefix)), t = new k({
              collection: [],
              editor: e.em,
              config: e
            }), this;
          },
          postRender: function postRender() {
            var t = this.getConfig().appendTo;
            t && (Object(i.isElement)(t) ? t : document.querySelector(t)).appendChild(this.render());
          },
          getTraitsViewer: function getTraitsViewer() {
            return t;
          },
          addType: function addType(e, n) {
            var i = t.itemView;
            t.itemsView[e] = i.extend(n);
          },
          getType: function getType(e) {
            return t.itemsView[e];
          },
          render: function render() {
            return t.render().el;
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(2),
        r = n.n(i),
        a = n(0),
        o = {
          appendTo: "",
          appendOnClick: 0,
          appendOnDblClick: 0,
          blocks: []
        },
        s = n(1),
        l = n.n(s),
        c = l.a.Model.extend({
          defaults: {
            id: "",
            label: "",
            open: !0,
            attributes: {}
          }
        }),
        d = l.a.Model.extend({
          defaults: {
            activate: 0,
            select: 0,
            resetId: 0,
            label: "",
            disable: 0,
            media: "",
            content: "",
            category: "",
            attributes: {}
          },
          initialize: function initialize() {
            var t = this.get("category");
            t && "string" == typeof t && new c({
              id: t,
              label: t
            });
          }
        }),
        u = l.a.Collection.extend({
          model: d
        }),
        h = l.a.Collection.extend({
          model: c
        }),
        p = n(3),
        g = l.a.View.extend({
          events: {
            click: "handleClick",
            dblclick: "handleDblClick",
            mousedown: "startDrag",
            dragstart: "handleDragStart",
            drag: "handleDrag",
            dragend: "handleDragEnd"
          },
          initialize: function initialize(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = this.model;
            this.em = e.em, this.config = e, this.endDrag = this.endDrag.bind(this), this.ppfx = e.pStylePrefix || "", this.listenTo(n, "destroy remove", this.remove), this.listenTo(n, "change", this.render);
          },
          handleClick: function handleClick() {
            var t = this.config,
              e = this.model,
              n = this.em;
            if (t.appendOnClick) {
              var i,
                r = t.getSorter(),
                a = e.get("content"),
                o = n.getSelected();
              if (r.setDropContent(a), o) if (r.validTarget(o.getEl(), a).valid) i = o;else {
                var s = o.parent();
                r.validTarget(s.getEl(), a).valid && (i = s);
              }
              if (!i) {
                var l = n.getWrapper();
                r.validTarget(l.getEl(), a).valid && (i = l);
              }
              var c = i && i.append(a)[0];
              c && n.setSelected(c, {
                scroll: 1
              });
            }
          },
          handleDblClick: function handleDblClick() {
            var t = this.config,
              e = this.model,
              n = this.em;
            if (t.appendOnDblClick) {
              var i,
                r = t.getSorter(),
                a = e.get("content"),
                o = n.getSelected();
              if (r.setDropContent(a), o) {
                var s = o.parent();
                void 0 === s ? r.validTarget(o.getEl(), a).valid && (i = o) : r.validTarget(s.getEl(), a).valid && (i = s);
              }
              if (!i) {
                var l = n.getWrapper();
                r.validTarget(l.getEl(), a).valid && (i = l);
              }
              var c = i && i.append(a)[0];
              c && n.setSelected(c, {
                scroll: 1
              });
            }
          },
          startDrag: function startDrag(t) {
            var e = this.config,
              n = this.em,
              i = this.model.get("disable");
            if (0 === t.button && e.getSorter && !this.el.draggable && !i) {
              n.refreshCanvas();
              var r = e.getSorter();
              r.setDragHelper(this.el, t), r.setDropContent(this.model.get("content")), r.startSort(this.el), Object(p.u)(document, "mouseup", this.endDrag);
            }
          },
          handleDragStart: function handleDragStart(t) {
            var e = this.em,
              n = this.model,
              i = n.get("content"),
              r = Object(a.isObject)(i) ? JSON.stringify(i) : i;
            e.set("dragResult"), t.dataTransfer.setData("text", r), e.set("dragContent", i), e.trigger("block:drag:start", n, t);
          },
          handleDrag: function handleDrag(t) {
            this.em.trigger("block:drag", this.model, t);
          },
          handleDragEnd: function handleDragEnd() {
            var t = this.em,
              e = this.model,
              n = t.get("dragResult");
            if (n) {
              var i = n.get && n.get("activeOnRender");
              (e.get("activate") || i) && (n.trigger("active"), n.set("activeOnRender", 0)), e.get("select") && t.setSelected(n), e.get("resetId") && n.onAll(function (t) {
                return t.resetId();
              });
            }
            t.set({
              dragResult: null,
              dragContent: null
            }), t.trigger("block:drag:stop", n, e);
          },
          endDrag: function endDrag(t) {
            Object(p.t)(document, "mouseup", this.endDrag);
            var e = this.config.getSorter();
            e.moved = 0, e.endMove();
          },
          render: function render() {
            var t = this.em,
              e = this.el,
              n = this.$el,
              i = this.ppfx,
              r = this.model,
              a = r.get("disable"),
              o = r.get("attributes") || {},
              s = o.class || "",
              l = o.title || "",
              c = "".concat(i, "block"),
              d = t && t.t("blockManager.labels.".concat(r.id)) || r.get("label"),
              u = r.get("render"),
              h = r.get("media"),
              g = a ? "".concat(c, "--disable") : "".concat(i, "four-color-h");
            n.attr(o), e.className = "".concat(s, " ").concat(c, " ").concat(i, "one-bg ").concat(g).trim(), e.innerHTML = "\n      ".concat(h ? '<div class="'.concat(c, '__media">').concat(h, "</div>") : "", '\n      <div class="').concat(c, '-label">').concat(d, "</div>\n    "), e.title = e.textContent.trim().startsWith(".") ? l : e.textContent.trim(), e.setAttribute("draggable", !(!Object(p.k)(t) || a));
            var f = u && u({
              el: e,
              model: r,
              className: c,
              prefix: i
            });
            return f && (e.innerHTML = f), this;
          }
        }),
        f = l.a.View.extend({
          template: Object(a.template)('\n  <div class="<%= pfx %>title">\n    <i class="<%= pfx %>caret-icon"></i>\n    <%= label %>\n  </div>\n  <div class="<%= pfx %>blocks-c"></div>\n  '),
          events: {},
          initialize: function initialize() {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            this.config = t;
            var e = t.pStylePrefix || "";
            this.em = t.em, this.pfx = e, this.caretR = "fa fa-caret-right", this.caretD = "fa fa-caret-down", this.iconClass = "".concat(e, "caret-icon"), this.activeClass = "".concat(e, "open"), this.className = "".concat(e, "block-category"), this.events["click .".concat(e, "title")] = "toggle", this.listenTo(this.model, "change:open", this.updateVisibility), this.delegateEvents();
          },
          updateVisibility: function updateVisibility() {
            this.model.get("open") ? this.open() : this.close();
          },
          open: function open() {
            this.el.className = "".concat(this.className, " ").concat(this.activeClass), this.getIconEl().className = "".concat(this.iconClass, " ").concat(this.caretD), this.getBlocksEl().style.display = "";
          },
          close: function close() {
            this.el.className = this.className, this.getIconEl().className = "".concat(this.iconClass, " ").concat(this.caretR), this.getBlocksEl().style.display = "none";
          },
          toggle: function toggle() {
            var t = this.model;
            t.set("open", !t.get("open"));
          },
          getIconEl: function getIconEl() {
            return this.iconEl || (this.iconEl = this.el.querySelector("." + this.iconClass)), this.iconEl;
          },
          getBlocksEl: function getBlocksEl() {
            return this.blocksEl || (this.blocksEl = this.el.querySelector("." + this.pfx + "blocks-c")), this.blocksEl;
          },
          append: function append(t) {
            this.getBlocksEl().appendChild(t);
          },
          render: function render() {
            var t = this.em,
              e = this.el,
              n = this.$el,
              i = this.model,
              r = t.t("blockManager.categories.".concat(i.id)) || i.get("label");
            return e.innerHTML = this.template({
              pfx: this.pfx,
              label: r
            }), e.className = this.className, n.css({
              order: i.get("order")
            }), this.updateVisibility(), this;
          }
        });
      function m(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function v(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? m(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var b = l.a.View.extend({
        initialize: function initialize(t, e) {
          Object(a.bindAll)(this, "getSorter", "onDrag", "onDrop"), this.config = e || {}, this.categories = t.categories || "", this.renderedCategories = [];
          var n = this.config.pStylePrefix || "";
          this.ppfx = n, this.noCatClass = "".concat(n, "blocks-no-cat"), this.blockContClass = "".concat(n, "blocks-c"), this.catsClass = "".concat(n, "block-categories");
          var i = this.collection;
          this.listenTo(i, "add", this.addTo), this.listenTo(i, "reset", this.render), this.em = this.config.em, this.tac = "test-tac", this.grabbingCls = this.ppfx + "grabbing", this.em && (this.config.getSorter = this.getSorter, this.canvas = this.em.get("Canvas"));
        },
        updateConfig: function updateConfig() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          this.config = v(v({}, this.config), t);
        },
        getSorter: function getSorter() {
          if (this.em) {
            if (!this.sorter) {
              var t = this.em.get("Utils"),
                e = this.canvas;
              this.sorter = new t.Sorter({
                container: e.getBody(),
                placer: e.getPlacerEl(),
                containerSel: "*",
                itemSel: "*",
                pfx: this.ppfx,
                onStart: this.onDrag,
                onEndMove: this.onDrop,
                onMove: this.onMove,
                document: e.getFrameEl().contentDocument,
                direction: "a",
                wmargin: 1,
                nested: 1,
                em: this.em,
                canvasRelative: 1
              });
            }
            return this.sorter;
          }
        },
        onDrag: function onDrag(t) {
          this.em.stopDefault(), this.em.trigger("block:drag:start", t);
        },
        onMove: function onMove(t) {
          this.em.trigger("block:drag:move", t);
        },
        onDrop: function onDrop(t) {
          var e = this.em;
          e.runDefault(), t && t.get && (t.get("activeOnRender") && (t.trigger("active"), t.set("activeOnRender", 0)), e.trigger("block:drag:stop", t));
        },
        addTo: function addTo(t) {
          this.add(t);
        },
        add: function add(t, e) {
          var n = this.config,
            i = e || null,
            r = new g({
              model: t,
              attributes: t.get("attributes")
            }, n).render().el,
            o = t.get("category");
          if (o && this.categories && !n.ignoreCategories) {
            Object(a.isString)(o) ? o = {
              id: o,
              label: o
            } : Object(a.isObject)(o) && !o.id && (o.id = o.label);
            var s = this.categories.add(o),
              l = s.get("id"),
              c = this.renderedCategories[l],
              d = this.getCategoriesEl();
            return t.set("category", s), !c && d && (c = new f({
              model: s
            }, this.config).render(), this.renderedCategories[l] = c, d.appendChild(c.el)), void (c && c.append(r));
          }
          i ? i.appendChild(r) : this.append(r);
        },
        getCategoriesEl: function getCategoriesEl() {
          return this.catsEl || (this.catsEl = this.el.querySelector(".".concat(this.catsClass))), this.catsEl;
        },
        getBlocksEl: function getBlocksEl() {
          return this.blocksEl || (this.blocksEl = this.el.querySelector(".".concat(this.noCatClass, " .").concat(this.blockContClass))), this.blocksEl;
        },
        append: function append(t) {
          var e = this.getBlocksEl();
          e && e.appendChild(t);
        },
        render: function render() {
          var t = this,
            e = this.ppfx,
            n = document.createDocumentFragment();
          this.catsEl = null, this.blocksEl = null, this.renderedCategories = [], this.el.innerHTML = '\n      <div class="'.concat(this.catsClass, '"></div>\n      <div class="').concat(this.noCatClass, '">\n        <div class="').concat(this.blockContClass, '"></div>\n      </div>\n    '), this.collection.each(function (e) {
            return t.add(e, n);
          }), this.append(n);
          var i = "".concat(this.blockContClass, "s ").concat(e, "one-bg ").concat(e, "two-color");
          return this.$el.addClass(i), this;
        }
      });
      function y(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function w(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? y(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : y(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.default = function () {
        var t,
          e,
          n,
          i = {},
          r = [];
        return {
          name: "BlockManager",
          init: function init(n) {
            var a = (i = n || {}).em;
            for (var s in o) s in i || (i[s] = o[s]);
            return t = new u([]), e = new u([]), r = new h(), t.listenTo(t, "add", function (t) {
              e.add(t), a && a.trigger("block:add", t);
            }), t.listenTo(t, "remove", function (t) {
              e.remove(t), a && a.trigger("block:remove", t);
            }), t.listenTo(t, "reset", function (t) {
              e.reset(t.models);
            }), this;
          },
          getConfig: function getConfig() {
            return i;
          },
          onLoad: function onLoad() {
            var t = this.getAll();
            !t.length && t.reset(i.blocks);
          },
          postRender: function postRender() {
            n = new b({
              collection: e,
              categories: r
            }, i);
            var t = this.getConfig().appendTo;
            t && (Object(a.isElement)(t) ? t : document.querySelector(t)).appendChild(this.render(e.models));
          },
          add: function add(e, n) {
            var i = n || {};
            return i.id = e, t.add(i);
          },
          get: function get(e) {
            return t.get(e);
          },
          getAll: function getAll() {
            return t;
          },
          getAllVisible: function getAllVisible() {
            return e;
          },
          remove: function remove(e) {
            return t.remove(e);
          },
          getCategories: function getCategories() {
            return r;
          },
          getContainer: function getContainer() {
            return n.el;
          },
          render: function render(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              a = t || this.getAll().models;
            if (e.external) {
              var o = new u(a);
              return new b({
                collection: o,
                categories: r
              }, w(w({}, i), e)).render().el;
            }
            return n && (n.updateConfig(e), n.collection.reset(a), n.rendered || (n.render(), n.rendered = 1)), this.getContainer();
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = "sw-visibility",
        r = "open-layers",
        a = {
          stylePrefix: "pn-",
          defaults: [{
            id: "commands",
            buttons: [{}]
          }, {
            id: "devices-c",
            buttons: [{
              active: !0,
              id: "set-device-desktop",
              className: "fa fa-desktop",
              command: "set-device-desktop",
              attributes: {
                title: "Desktop"
              }
            }, {
              id: "set-device-tablet",
              className: "fa fa-tablet",
              command: "set-device-tablet",
              attributes: {
                title: "Tablet"
              }
            }, {
              id: "set-device-mobile-ptr",
              className: "fa fa-mobile",
              command: "set-device-mobile-ptr",
              attributes: {
                title: "Mobile"
              }
            }, {
              id: "set-device-mobile",
              className: "fa fa-mobile",
              command: "set-device-mobile",
              attributes: {
                title: "Mobile Landscape"
              }
            }, {
              id: "versions",
              className: "fa fa-code-fork",
              command: "switch-version",
              attributes: {
                title: "Switch Version"
              }
            }, {
              id: "shortcut",
              className: "fa fa-search",
              command: "shortcut",
              attributes: {
                title: "Shortcut"
              }
            }, {
              id: "custom-open-blocks",
              className: "fa fa-plus-circle btn btn-theme-primary--light btn-xs",
              command: "custom-open-blocks",
              togglable: 1,
              attributes: {
                title: "Add Components",
                id: "add-components"
              }
            }]
          }, {
            id: "options",
            buttons: [{
              active: !0,
              id: i,
              className: "fa fa-square-o",
              command: i,
              context: i,
              attributes: {
                title: "View components"
              }
            }, {
              id: "preview",
              className: "fa fa-eye",
              command: "custom-preview",
              context: "preview",
              attributes: {
                title: "Preview"
              }
            }, {
              id: "build",
              className: "fa fa-paper-plane-o",
              command: "custom-build",
              context: "build",
              attributes: {
                title: "Production"
              }
            }, {
              id: "code-editor",
              className: "wb webconnect-layout-text-sidebar-reverse",
              command: "code-editor-open",
              attributes: {
                title: "View Code"
              }
            }, {
              id: "undo",
              className: "fa fa-undo",
              command: function command(t) {
                return t.runCommand("core:undo");
              }
            }, {
              id: "redo",
              className: "fa fa-repeat",
              command: function command(t) {
                return t.runCommand("core:redo");
              }
            }, {
              id: "save-db",
              className: "fa fa-save btn-save",
              command: "save-db",
              context: "save-db",
              attributes: {
                title: "Save"
              }
            }, {
              id: "cmd-clear",
              className: "fa fa-trash",
              command: "cmd-clear",
              context: "cmd-clear",
              attributes: {
                title: "Clear"
              }
            }]
          }, {
            id: "views",
            buttons: [{
              id: "open-sm",
              className: "fa fa-paint-brush",
              command: "open-sm",
              active: !0,
              togglable: 0,
              attributes: {
                title: "Open Style Manager"
              }
            }, {
              id: "open-tm",
              className: "fa fa-cog",
              command: "open-tm",
              togglable: 0,
              attributes: {
                title: "Settings"
              }
            }, {
              id: r,
              className: "fa fa-bars",
              command: r,
              togglable: 0,
              attributes: {
                title: "Open Layer Manager"
              }
            }]
          }],
          em: null,
          delayBtnsShow: 300
        },
        o = n(1),
        s = n.n(o),
        l = n(41),
        c = s.a.Model.extend({
          defaults: {
            id: "",
            content: "",
            visible: !0,
            buttons: [],
            attributes: {}
          },
          initialize: function initialize(t) {
            this.btn = this.get("buttons") || [], this.buttons = new l.default(this.btn), this.set("buttons", this.buttons);
          }
        }),
        d = s.a.Collection.extend({
          model: c
        }),
        u = n(2),
        h = n.n(u),
        p = n(0);
      function g(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function f(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? g(Object(n), !0).forEach(function (e) {
            h()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : g(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      s.a.$;
      var m = s.a.View.extend({
          tagName: function tagName() {
            return this.model.get("tagName");
          },
          events: {
            click: "clicked"
          },
          initialize: function initialize(t) {
            var e = this.model.get("className");
            this.config = t.config || {}, this.em = this.config.em || {};
            var n = this.config.stylePrefix || "",
              i = this.config.pStylePrefix || "";
            this.pfx = n, this.ppfx = this.config.pStylePrefix || "", this.id = n + this.model.get("id"), this.activeCls = "".concat(n, "active ").concat(i, "four-color"), this.disableCls = "".concat(i, "disabled"), this.btnsVisCls = "".concat(n, "visible"), this.className = n + "btn" + (e ? " " + e : ""), this.listenTo(this.model, "change", this.render), this.listenTo(this.model, "change:active updateActive", this.updateActive), this.listenTo(this.model, "checkActive", this.checkActive), this.listenTo(this.model, "change:bntsVis", this.updateBtnsVis), this.listenTo(this.model, "change:attributes", this.updateAttributes), this.listenTo(this.model, "change:className", this.updateClassName), this.listenTo(this.model, "change:disable", this.updateDisable), this.em && this.em.get && (this.commands = this.em.get("Commands"));
          },
          updateClassName: function updateClassName() {
            var t = this.model,
              e = this.pfx,
              n = t.get("className"),
              i = t.get("attributes").class,
              r = "".concat(i || "", " ").concat(e, "btn ").concat(n || "");
            this.$el.attr("class", r.trim());
          },
          updateAttributes: function updateAttributes() {
            var t = this.em,
              e = this.model,
              n = this.$el,
              i = e.get("attributes") || {},
              r = t && t.t && t.t("panels.buttons.titles.".concat(e.id));
            n.attr(i), r && n.attr({
              title: r
            }), this.updateClassName();
          },
          updateBtnsVis: function updateBtnsVis() {
            this.$buttons && (this.model.get("bntsVis") ? this.$buttons.addClass(this.btnsVisCls) : this.$buttons.removeClass(this.btnsVisCls));
          },
          updateActive: function updateActive() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = this.model,
              n = this.commands,
              i = this.$el,
              r = this.activeCls,
              a = t.fromCollection,
              o = e.get("context"),
              s = e.get("options"),
              l = e.get("command"),
              c = {};
            n && Object(p.isString)(l) ? c = n.get(l) || {} : Object(p.isFunction)(l) ? c = n.create({
              run: l
            }) : null !== l && Object(p.isObject)(l) && (c = n.create(l)), e.get("active") ? (!a && e.collection.deactivateAll(o, e), e.set("active", !0, {
              silent: !0
            }).trigger("checkActive"), n.runCommand(c, f(f({}, s), {}, {
              sender: e
            })), c.noStop && e.set("active", !1)) : (i.removeClass(r), n.stopCommand(c, f(f({}, s), {}, {
              sender: e,
              force: 1
            })));
          },
          updateDisable: function updateDisable() {
            var t = this.disableCls,
              e = this.model.get("disable");
            this.$el[e ? "addClass" : "removeClass"](t);
          },
          checkActive: function checkActive() {
            var t = this.model,
              e = this.$el,
              n = this.activeCls;
            t.get("active") ? e.addClass(n) : e.removeClass(n);
          },
          clicked: function clicked(t) {
            this.model.get("bntsVis") || this.model.get("disable") || this.toggleActive();
          },
          toggleActive: function toggleActive() {
            var t = this.model,
              e = t.attributes,
              n = e.active,
              i = e.togglable;
            n && !i || (t.set("active", !n), this.em.get("Commands").get("select-comp"), n ? t.get("runDefaultCommand") && this.em.runDefault() : t.get("stopDefaultCommand") && this.em.stopDefault());
          },
          render: function render() {
            var t = this.model.get("label"),
              e = this.$el;
            return e.empty(), this.updateAttributes(), t && e.append(t), this.checkActive(), this.updateDisable(), this;
          }
        }),
        v = s.a.View.extend({
          initialize: function initialize(t) {
            this.opt = t || {}, this.config = this.opt.config || {}, this.pfx = this.config.stylePrefix || "", this.parentM = this.opt.parentM || null, this.listenTo(this.collection, "add", this.addTo), this.listenTo(this.collection, "reset remove", this.render), this.className = this.pfx + "buttons";
          },
          addTo: function addTo(t) {
            this.addToCollection(t);
          },
          addToCollection: function addToCollection(t, e) {
            var n = e || null,
              i = new m({
                model: t,
                config: this.config,
                parentM: this.parentM
              }).render().el;
            return n ? n.appendChild(i) : this.$el.append(i), i;
          },
          render: function render() {
            var t = document.createDocumentFragment();
            return this.$el.empty(), this.collection.each(function (e) {
              this.addToCollection(e, t);
            }, this), this.$el.append(t), this.$el.attr("class", Object(p.result)(this, "className")), this;
          }
        });
      function b(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      var y = s.a.View.extend({
          initialize: function initialize(t) {
            var e = t.config || {},
              n = this.model;
            this.config = e, this.pfx = e.stylePrefix || "", this.ppfx = e.pStylePrefix || "", this.buttons = n.get("buttons"), this.className = this.pfx + "panel", this.id = this.pfx + n.get("id"), this.listenTo(n, "change:appendContent", this.appendContent), this.listenTo(n, "change:content", this.updateContent), this.listenTo(n, "change:visible", this.toggleVisible), n.view = this;
          },
          appendContent: function appendContent() {
            this.$el.append(this.model.get("appendContent"));
          },
          updateContent: function updateContent() {
            this.$el.html(this.model.get("content"));
          },
          toggleVisible: function toggleVisible() {
            this.model.get("visible") ? this.$el.removeClass("".concat(this.ppfx, "hidden")) : this.$el.addClass("".concat(this.ppfx, "hidden"));
          },
          attributes: function attributes() {
            return this.model.get("attributes");
          },
          initResize: function initResize() {
            var t = this.config.em,
              e = t ? t.get("Editor") : "",
              n = this.model.get("resizable");
            if (e && n) {
              var i,
                r,
                a,
                o = !0 === n ? [1, 1, 1, 1] : n,
                s = o.length,
                l = 0;
              2 == s ? (i = o[0], a = o[0], r = o[1], l = o[1]) : 4 == s && (i = o[0], r = o[1], a = o[2], l = o[3]);
              var c = e.Utils.Resizer.init(function (t) {
                for (var e = 1; e < arguments.length; e++) {
                  var n = null != arguments[e] ? arguments[e] : {};
                  e % 2 ? b(Object(n), !0).forEach(function (e) {
                    h()(t, e, n[e]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : b(Object(n)).forEach(function (e) {
                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
                  });
                }
                return t;
              }({
                tc: i,
                cr: r,
                bc: a,
                cl: l,
                tl: 0,
                tr: 0,
                bl: 0,
                br: 0,
                appendTo: this.el,
                silentFrames: 1,
                avoidContainerUpdate: 1,
                prefix: e.getConfig().stylePrefix,
                onEnd: function onEnd() {
                  t && t.trigger("change:canvasOffset");
                },
                posFetcher: function posFetcher(t, e) {
                  var n = e.target,
                    i = t.style,
                    r = c.getConfig(),
                    a = r.keyWidth,
                    o = r.keyHeight,
                    s = t.getBoundingClientRect(),
                    l = "container" == n,
                    d = i[a],
                    u = i[o];
                  return {
                    left: 0,
                    top: 0,
                    width: d && !l ? parseFloat(d) : s.width,
                    height: u && !l ? parseFloat(u) : s.height
                  };
                }
              }, n));
              c.blur = function () {}, c.focus(this.el);
            }
          },
          render: function render() {
            var t = this.$el,
              e = this.ppfx,
              n = "".concat(this.className, " ").concat(this.id, " ").concat(e, "one-bg ").concat(e, "two-color");
            if (t.addClass(n), this.buttons.length) {
              var i = new v({
                collection: this.buttons,
                config: this.config
              });
              t.append(i.render().el);
            }
            return t.append(this.model.get("content")), this;
          }
        }),
        w = s.a.View.extend({
          initialize: function initialize(t) {
            this.opt = t || {}, this.config = this.opt.config || {}, this.pfx = this.config.stylePrefix || "";
            var e = this.collection;
            this.listenTo(e, "add", this.addTo), this.listenTo(e, "reset", this.render), this.listenTo(e, "remove", this.onRemove), this.className = this.pfx + "panels";
          },
          onRemove: function onRemove(t) {
            var e = t.view;
            e && e.remove();
          },
          addTo: function addTo(t) {
            this.addToCollection(t);
          },
          addToCollection: function addToCollection(t, e) {
            var n = e || null,
              i = this.config,
              r = t.get("el"),
              a = new y({
                el: r,
                model: t,
                config: i
              }),
              o = a.render().el,
              s = t.get("appendTo");
            return r || (s ? document.querySelector(s).appendChild(o) : n ? n.appendChild(o) : this.$el.append(o)), a.initResize(), o;
          },
          render: function render() {
            var t = this,
              e = this.$el,
              n = document.createDocumentFragment();
            return e.empty(), this.collection.each(function (e) {
              return t.addToCollection(e, n);
            }), e.append(n), e.attr("class", this.className), this;
          }
        });
      e.default = function () {
        var t,
          e,
          n = {};
        return {
          name: "Panels",
          init: function init(i) {
            for (var r in n = i || {}, a) r in n || (n[r] = a[r]);
            var o = n.pStylePrefix;
            return o && (n.stylePrefix = o + n.stylePrefix), t = new d(n.defaults), e = new w({
              collection: t,
              config: n
            }), this;
          },
          getPanels: function getPanels() {
            return t;
          },
          getPanelsEl: function getPanelsEl() {
            return e.el;
          },
          addPanel: function addPanel(e) {
            return t.add(e);
          },
          removePanel: function removePanel(e) {
            return t.remove(e);
          },
          getPanel: function getPanel(e) {
            var n = t.where({
              id: e
            });
            return n.length ? n[0] : null;
          },
          addButton: function addButton(t, e) {
            var n = this.getPanel(t);
            return n ? n.get("buttons").add(e) : null;
          },
          removeButton: function removeButton(t, e) {
            var n = this.getPanel(t);
            return n && n.get("buttons").remove(e);
          },
          getButton: function getButton(t, e) {
            var n = this.getPanel(t);
            if (n) {
              var i = n.get("buttons").where({
                id: e
              });
              return i.length ? i[0] : null;
            }
            return null;
          },
          render: function render() {
            return e.render().el;
          },
          active: function active() {
            this.getPanels().each(function (t) {
              t.get("buttons").each(function (t) {
                t.get("active") && t.trigger("updateActive");
              });
            });
          },
          disableButtons: function disableButtons() {
            this.getPanels().each(function (t) {
              t.get("buttons").each(function (t) {
                t.get("disable") && t.trigger("change:disable");
              });
            });
          },
          Panel: c
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(2),
        r = n.n(i),
        a = n(0),
        o = {
          stylePrefix: "sm-",
          sectors: [],
          appendTo: "",
          hideNotStylable: !0,
          highlightChanged: !0,
          highlightComputed: !0,
          showComputed: !0,
          clearProperties: 0,
          avoidComputed: ["width", "height"]
        },
        s = n(1),
        l = n.n(s),
        c = n(24),
        d = function d() {
          return {
            build: function build(t) {
              var e = [];
              "string" == typeof t && (t = [t]);
              for (var n = 0, i = t.length; n < i; n++) {
                var r = {},
                  a = t[n];
                switch (r.property = a, a) {
                  case "border-radius-c":
                    r.property = "border-radius";
                }
                switch (a) {
                  case "top":
                  case "right":
                  case "bottom":
                  case "left":
                  case "margin-top":
                  case "margin-right":
                  case "margin-bottom":
                  case "margin-left":
                  case "padding-top":
                  case "padding-right":
                  case "padding-bottom":
                  case "padding-left":
                  case "width":
                  case "max-width":
                  case "min-width":
                  case "height":
                  case "max-height":
                  case "min-height":
                  case "flex-basis":
                    r.fixedValues = ["initial", "inherit", "auto", "min-content", "max-content"];
                    break;
                  case "font-size":
                    r.fixedValues = ["medium", "xx-small", "x-small", "small", "large", "x-large", "xx-large", "smaller", "larger", "length", "initial", "inherit"];
                    break;
                  case "letter-spacing":
                  case "line-height":
                    r.fixedValues = ["normal", "initial", "inherit"];
                }
                switch (a) {
                  case "float":
                  case "position":
                  case "text-align":
                    r.type = "radio";
                    break;
                  case "display":
                  case "flex-direction":
                  case "flex-wrap":
                  case "justify-content":
                  case "align-items":
                  case "align-content":
                  case "align-self":
                  case "font-family":
                  case "font-weight":
                  case "border-style":
                  case "box-shadow-type":
                  case "background-repeat":
                  case "background-position":
                  case "background-attachment":
                  case "background-size":
                  case "transition-property":
                  case "transition-timing-function":
                  case "cursor":
                  case "overflow":
                  case "overflow-x":
                  case "overflow-y":
                    r.type = "select";
                    break;
                  case "top":
                  case "right":
                  case "bottom":
                  case "left":
                  case "margin-top":
                  case "margin-right":
                  case "margin-bottom":
                  case "margin-left":
                  case "padding-top":
                  case "padding-right":
                  case "padding-bottom":
                  case "padding-left":
                  case "min-height":
                  case "min-width":
                  case "max-height":
                  case "max-width":
                  case "width":
                  case "height":
                  case "font-size":
                  case "letter-spacing":
                  case "line-height":
                  case "text-shadow-h":
                  case "text-shadow-v":
                  case "text-shadow-blur":
                  case "border-radius-c":
                  case "border-top-left-radius":
                  case "border-top-right-radius":
                  case "border-bottom-left-radius":
                  case "border-bottom-right-radius":
                  case "border-width":
                  case "box-shadow-h":
                  case "box-shadow-v":
                  case "box-shadow-blur":
                  case "box-shadow-spread":
                  case "transition-duration":
                  case "perspective":
                  case "transform-rotate-x":
                  case "transform-rotate-y":
                  case "transform-rotate-z":
                  case "transform-scale-x":
                  case "transform-scale-y":
                  case "transform-scale-z":
                  case "order":
                  case "flex-grow":
                  case "flex-shrink":
                  case "flex-basis":
                    r.type = "integer";
                    break;
                  case "margin":
                  case "padding":
                  case "border-radius":
                  case "border":
                  case "transform":
                    r.type = "composite";
                    break;
                  case "color":
                  case "text-shadow-color":
                  case "background-color":
                  case "border-color":
                  case "box-shadow-color":
                    r.type = "color";
                    break;
                  case "text-shadow":
                  case "box-shadow":
                  case "background":
                  case "transition":
                    r.type = "stack";
                    break;
                  case "background-image":
                    r.type = "file";
                }
                switch (a) {
                  case "float":
                  case "background-color":
                  case "text-shadow":
                    r.defaults = "none";
                    break;
                  case "display":
                    r.defaults = "block";
                    break;
                  case "flex-direction":
                    r.defaults = "row";
                    break;
                  case "flex-wrap":
                    r.defaults = "nowrap";
                    break;
                  case "justify-content":
                    r.defaults = "flex-start";
                    break;
                  case "align-items":
                  case "align-content":
                    r.defaults = "stretch";
                    break;
                  case "align-self":
                    r.defaults = "auto";
                    break;
                  case "position":
                    r.defaults = "static";
                    break;
                  case "margin-top":
                  case "margin-right":
                  case "margin-bottom":
                  case "margin-left":
                  case "padding-top":
                  case "padding-right":
                  case "padding-bottom":
                  case "padding-left":
                  case "text-shadow-h":
                  case "text-shadow-v":
                  case "text-shadow-blur":
                  case "border-radius-c":
                  case "box-shadow-h":
                  case "box-shadow-v":
                  case "box-shadow-spread":
                  case "perspective":
                  case "transform-rotate-x":
                  case "transform-rotate-y":
                  case "transform-rotate-z":
                  case "order":
                  case "flex-grow":
                    r.defaults = 0;
                    break;
                  case "border-top-left-radius":
                  case "border-top-right-radius":
                  case "border-bottom-left-radius":
                  case "border-bottom-right-radius":
                    r.defaults = "0px";
                    break;
                  case "transform-scale-x":
                  case "transform-scale-y":
                  case "transform-scale-z":
                  case "flex-shrink":
                    r.defaults = 1;
                    break;
                  case "box-shadow-blur":
                    r.defaults = "5px";
                    break;
                  case "top":
                  case "right":
                  case "bottom":
                  case "left":
                  case "min-height":
                  case "min-width":
                  case "max-height":
                  case "max-width":
                  case "width":
                  case "height":
                  case "background-size":
                  case "cursor":
                  case "flex-basis":
                    r.defaults = "auto";
                    break;
                  case "font-family":
                    r.defaults = "Arial, Helvetica, sans-serif";
                    break;
                  case "font-size":
                  case "border-width":
                    r.defaults = "medium";
                    break;
                  case "font-weight":
                    r.defaults = "400";
                    break;
                  case "letter-spacing":
                  case "line-height":
                    r.defaults = "normal";
                    break;
                  case "color":
                  case "text-shadow-color":
                  case "border-color":
                  case "box-shadow-color":
                    r.defaults = "black";
                    break;
                  case "text-align":
                    r.defaults = "left";
                    break;
                  case "border-style":
                    r.defaults = "solid";
                    break;
                  case "box-shadow-type":
                    r.defaults = "";
                    break;
                  case "background-repeat":
                    r.defaults = "repeat";
                    break;
                  case "background-position":
                    r.defaults = "left top";
                    break;
                  case "background-attachment":
                    r.defaults = "scroll";
                    break;
                  case "transition-property":
                    r.defaults = "width";
                    break;
                  case "transition-duration":
                    r.defaults = "2";
                    break;
                  case "transition-timing-function":
                    r.defaults = "ease";
                    break;
                  case "overflow":
                  case "overflow-x":
                  case "overflow-y":
                    r.defaults = "visible";
                }
                switch (a) {
                  case "flex-direction":
                  case "flex-wrap":
                  case "justify-content":
                  case "align-items":
                  case "align-content":
                    r.requires = {
                      display: ["flex"]
                    };
                    break;
                  case "order":
                  case "flex-basis":
                  case "flex-grow":
                  case "flex-shrink":
                  case "align-self":
                    r.requiresParent = {
                      display: ["flex"]
                    };
                }
                switch (a) {
                  case "top":
                  case "bottom":
                  case "margin-top":
                  case "margin-bottom":
                  case "padding-top":
                  case "padding-bottom":
                  case "min-height":
                  case "max-height":
                  case "height":
                    r.units = ["px", "%", "vh", "em", "rem"];
                    break;
                  case "right":
                  case "left":
                  case "margin-right":
                  case "margin-left":
                  case "padding-right":
                  case "padding-left":
                  case "min-width":
                  case "max-width":
                  case "width":
                    r.units = ["px", "%", "vw", "em", "rem"];
                    break;
                  case "flex-basis":
                    r.units = ["px", "%", "vw", "vh"];
                    break;
                  case "text-shadow-v":
                  case "text-shadow-h":
                  case "text-shadow-blur":
                  case "border-radius-c":
                  case "border-top-left-radius":
                  case "border-top-right-radius":
                  case "border-bottom-left-radius":
                  case "border-bottom-right-radius":
                  case "box-shadow-h":
                  case "box-shadow-v":
                    r.units = ["px", "%"];
                    break;
                  case "font-size":
                  case "letter-spacing":
                  case "line-height":
                    r.units = ["px", "em", "rem", "%", "vw", "vh"];
                    break;
                  case "border-width":
                    r.units = ["px", "em"];
                    break;
                  case "box-shadow-blur":
                  case "box-shadow-spread":
                  case "perspective":
                    r.units = ["px"];
                    break;
                  case "transition-duration":
                    r.units = ["s"];
                    break;
                  case "transform-rotate-x":
                  case "transform-rotate-y":
                  case "transform-rotate-z":
                    r.units = ["deg"];
                }
                switch (a) {
                  case "padding-top":
                  case "padding-right":
                  case "padding-bottom":
                  case "padding-left":
                  case "min-height":
                  case "min-width":
                  case "max-height":
                  case "max-width":
                  case "width":
                  case "height":
                  case "font-size":
                  case "text-shadow-blur":
                  case "border-radius-c":
                  case "border-top-left-radius":
                  case "border-top-right-radius":
                  case "border-bottom-left-radius":
                  case "border-bottom-right-radius":
                  case "border-width":
                  case "box-shadow-blur":
                  case "transition-duration":
                  case "perspective":
                  case "flex-basis":
                    r.min = 0;
                }
                switch (a) {
                  case "text-shadow":
                  case "box-shadow":
                  case "background":
                    r.preview = !0;
                }
                switch (a) {
                  case "background":
                    r.detached = !0;
                }
                switch (a) {
                  case "transform-rotate-x":
                    r.functionName = "rotateX";
                    break;
                  case "transform-rotate-y":
                    r.functionName = "rotateY";
                    break;
                  case "transform-rotate-z":
                    r.functionName = "rotateZ";
                    break;
                  case "transform-scale-x":
                    r.functionName = "scaleX";
                    break;
                  case "transform-scale-y":
                    r.functionName = "scaleY";
                    break;
                  case "transform-scale-z":
                    r.functionName = "scaleZ";
                    break;
                  case "background-image":
                    r.functionName = "url";
                }
                switch (a) {
                  case "float":
                    r.list = [{
                      value: "none"
                    }, {
                      value: "left"
                    }, {
                      value: "right"
                    }];
                    break;
                  case "display":
                    r.list = [{
                      value: "block"
                    }, {
                      value: "inline"
                    }, {
                      value: "inline-block"
                    }, {
                      value: "flex"
                    }, {
                      value: "none"
                    }];
                    break;
                  case "flex-direction":
                    r.list = [{
                      value: "row"
                    }, {
                      value: "row-reverse"
                    }, {
                      value: "column"
                    }, {
                      value: "column-reverse"
                    }];
                    break;
                  case "flex-wrap":
                    r.list = [{
                      value: "nowrap"
                    }, {
                      value: "wrap"
                    }, {
                      value: "wrap-reverse"
                    }];
                    break;
                  case "justify-content":
                    r.list = [{
                      value: "flex-start"
                    }, {
                      value: "flex-end"
                    }, {
                      value: "center"
                    }, {
                      value: "space-between"
                    }, {
                      value: "space-around"
                    }, {
                      value: "space-evenly"
                    }];
                    break;
                  case "align-items":
                    r.list = [{
                      value: "flex-start"
                    }, {
                      value: "flex-end"
                    }, {
                      value: "center"
                    }, {
                      value: "baseline"
                    }, {
                      value: "stretch"
                    }];
                    break;
                  case "align-content":
                    r.list = [{
                      value: "flex-start"
                    }, {
                      value: "flex-end"
                    }, {
                      value: "center"
                    }, {
                      value: "space-between"
                    }, {
                      value: "space-around"
                    }, {
                      value: "stretch"
                    }];
                    break;
                  case "align-self":
                    r.list = [{
                      value: "auto"
                    }, {
                      value: "flex-start"
                    }, {
                      value: "flex-end"
                    }, {
                      value: "center"
                    }, {
                      value: "baseline"
                    }, {
                      value: "stretch"
                    }];
                    break;
                  case "position":
                    r.list = [{
                      value: "static"
                    }, {
                      value: "relative"
                    }, {
                      value: "absolute"
                    }, {
                      value: "fixed"
                    }, {
                      value: "sticky"
                    }];
                    break;
                  case "font-family":
                    var o = ", sans-serif",
                      s = ["Arial, Helvetica" + o, "Arial Black, Gadget" + o, "Brush Script MT" + o, "Comic Sans MS, cursive" + o, "Courier New, Courier, monospace", "Georgia, serif", "Helvetica" + o, "Impact, Charcoal" + o, "Lucida Sans Unicode, Lucida Grande" + o, "Tahoma, Geneva" + o, "Times New Roman, Times, serif", "Trebuchet MS, Helvetica" + o, "Verdana, Geneva" + o];
                    r.list = [];
                    for (var l = 0, c = s.length; l < c; l++) {
                      var d = {};
                      d.value = s[l], d.name = s[l].split(",")[0], r.list.push(d);
                    }
                    break;
                  case "font-weight":
                    r.list = [{
                      value: "100",
                      name: "Thin"
                    }, {
                      value: "200",
                      name: "Extra-Light"
                    }, {
                      value: "300",
                      name: "Light"
                    }, {
                      value: "400",
                      name: "Normal"
                    }, {
                      value: "500",
                      name: "Medium"
                    }, {
                      value: "600",
                      name: "Semi-Bold"
                    }, {
                      value: "700",
                      name: "Bold"
                    }, {
                      value: "800",
                      name: "Extra-Bold"
                    }, {
                      value: "900",
                      name: "Ultra-Bold"
                    }];
                    break;
                  case "text-align":
                    r.list = [{
                      value: "left"
                    }, {
                      value: "center"
                    }, {
                      value: "right"
                    }, {
                      value: "justify"
                    }];
                    break;
                  case "border-style":
                    r.list = [{
                      value: "none"
                    }, {
                      value: "solid"
                    }, {
                      value: "dotted"
                    }, {
                      value: "dashed"
                    }, {
                      value: "double"
                    }, {
                      value: "groove"
                    }, {
                      value: "ridge"
                    }, {
                      value: "inset"
                    }, {
                      value: "outset"
                    }];
                    break;
                  case "box-shadow-type":
                    r.list = [{
                      value: "",
                      name: "Outside"
                    }, {
                      value: "inset",
                      name: "Inside"
                    }];
                    break;
                  case "background-repeat":
                    r.list = [{
                      value: "repeat"
                    }, {
                      value: "repeat-x"
                    }, {
                      value: "repeat-y"
                    }, {
                      value: "no-repeat"
                    }];
                    break;
                  case "background-position":
                    r.list = [{
                      value: "left top"
                    }, {
                      value: "left center"
                    }, {
                      value: "left bottom"
                    }, {
                      value: "right top"
                    }, {
                      value: "right center"
                    }, {
                      value: "right bottom"
                    }, {
                      value: "center top"
                    }, {
                      value: "center center"
                    }, {
                      value: "center bottom"
                    }];
                    break;
                  case "background-attachment":
                    r.list = [{
                      value: "scroll"
                    }, {
                      value: "fixed"
                    }, {
                      value: "local"
                    }];
                    break;
                  case "background-size":
                    r.list = [{
                      value: "auto"
                    }, {
                      value: "cover"
                    }, {
                      value: "contain"
                    }];
                    break;
                  case "transition-property":
                    r.list = [{
                      value: "all"
                    }, {
                      value: "width"
                    }, {
                      value: "height"
                    }, {
                      value: "background-color"
                    }, {
                      value: "transform"
                    }, {
                      value: "box-shadow"
                    }, {
                      value: "opacity"
                    }];
                    break;
                  case "transition-timing-function":
                    r.list = [{
                      value: "linear"
                    }, {
                      value: "ease"
                    }, {
                      value: "ease-in"
                    }, {
                      value: "ease-out"
                    }, {
                      value: "ease-in-out"
                    }];
                    break;
                  case "cursor":
                    r.list = [{
                      value: "auto"
                    }, {
                      value: "default"
                    }, {
                      value: "none"
                    }, {
                      value: "initial"
                    }, {
                      value: "inherit"
                    }, {
                      value: "pointer"
                    }, {
                      value: "copy"
                    }, {
                      value: "crosshair"
                    }, {
                      value: "grab"
                    }, {
                      value: "grabbing"
                    }, {
                      value: "help"
                    }, {
                      value: "move"
                    }, {
                      value: "text"
                    }, {
                      value: "context-menu"
                    }, {
                      value: "progress"
                    }, {
                      value: "wait"
                    }, {
                      value: "vertical-text"
                    }, {
                      value: "alias"
                    }, {
                      value: "no-drop"
                    }, {
                      value: "not-allowed"
                    }];
                    break;
                  case "overflow":
                  case "overflow-x":
                  case "overflow-y":
                    r.list = [{
                      value: "visible"
                    }, {
                      value: "hidden"
                    }, {
                      value: "scroll"
                    }, {
                      value: "auto"
                    }];
                }
                switch (a) {
                  case "margin":
                    r.properties = this.build(["margin-top", "margin-right", "margin-bottom", "margin-left"]);
                    break;
                  case "padding":
                    r.properties = this.build(["padding-top", "padding-right", "padding-bottom", "padding-left"]);
                    break;
                  case "text-shadow":
                    r.properties = this.build(["text-shadow-h", "text-shadow-v", "text-shadow-blur", "text-shadow-color"]);
                    break;
                  case "border":
                    r.properties = this.build(["border-width", "border-style", "border-color"]);
                    break;
                  case "border-radius":
                    r.properties = this.build(["border-top-left-radius", "border-top-right-radius", "border-bottom-right-radius", "border-bottom-left-radius"]);
                    break;
                  case "box-shadow":
                    r.properties = this.build(["box-shadow-h", "box-shadow-v", "box-shadow-blur", "box-shadow-spread", "box-shadow-color", "box-shadow-type"]);
                    break;
                  case "background":
                    r.properties = this.build(["background-image", "background-repeat", "background-position", "background-attachment", "background-size"]);
                    break;
                  case "transition":
                    r.properties = this.build(["transition-property", "transition-duration", "transition-timing-function"]);
                    break;
                  case "transform":
                    r.properties = this.build(["transform-rotate-x", "transform-rotate-y", "transform-rotate-z", "transform-scale-x", "transform-scale-y", "transform-scale-z"]);
                }
                e.push(r);
              }
              return e;
            }
          };
        },
        u = l.a.Model.extend({
          defaults: {
            id: "",
            name: "",
            open: !0,
            buildProps: "",
            extendBuilded: 1,
            properties: []
          },
          initialize: function initialize(t) {
            var e,
              n = t || {},
              i = this.buildProperties(n.buildProps),
              r = this.get("name") || "";
            !this.get("id") && this.set("id", r.replace(/ /g, "_").toLowerCase()), e = i ? this.extendProperties(i) : this.get("properties");
            var a = new c.default(e);
            a.sector = this, this.set("properties", a);
          },
          extendProperties: function extendProperties(t, e, n) {
            for (var i = t.length, r = e || this.get("properties"), o = this.get("extendBuilded"), s = [], l = 0, c = r.length; l < c; l++) {
              for (var d = r[l], u = 0, h = 0; h < i; h++) {
                var p = t[h];
                if (d.property != p.property && d.id != p.property) ;else {
                  var g = d.properties;
                  g && g.length && (d.properties = this.extendProperties(p.properties || [], g, 1)), t[h] = o ? Object(a.extend)(p, d) : d, s[h] = t[h], u = 1;
                }
              }
              u || (t.push(d), s.push(d));
            }
            return n ? s.filter(function (t) {
              return t;
            }) : t;
          },
          buildProperties: function buildProperties(t) {
            var e = t || [];
            if (e.length) return this.propFactory || (this.propFactory = new d()), this.propFactory.build(e);
          }
        }),
        h = l.a.Collection.extend({
          model: u
        }),
        p = n(3),
        g = n(7),
        f = n(19),
        m = l.a.View.extend({
          template: Object(a.template)('\n  <div class="<%= pfx %>title" data-sector-title>\n    <i id="<%= pfx %>caret" class="fa"></i>\n    <%= label %>\n  </div>'),
          events: {
            "click [data-sector-title]": "toggle"
          },
          initialize: function initialize(t) {
            this.config = t.config || {}, this.em = this.config.em, this.pfx = this.config.stylePrefix || "", this.target = t.target || {}, this.propTarget = t.propTarget || {}, this.caretR = "fa-caret-right", this.caretD = "fa-caret-down";
            var e = this.model;
            this.listenTo(e, "change:open", this.updateOpen), this.listenTo(e, "updateVisibility", this.updateVisibility), this.listenTo(e, "destroy remove", this.remove);
          },
          updateVisibility: function updateVisibility() {
            var t;
            this.model.get("properties").each(function (e) {
              e.get("visible") && (t = 1);
            }), this.el.style.display = t ? "block" : "none";
          },
          updateOpen: function updateOpen() {
            this.model.get("open") ? this.show() : this.hide();
          },
          show: function show() {
            this.$el.addClass(this.pfx + "open"), this.getPropertiesEl().style.display = "", this.$caret.removeClass(this.caretR).addClass(this.caretD);
          },
          hide: function hide() {
            this.$el.removeClass(this.pfx + "open"), this.getPropertiesEl().style.display = "none", this.$caret.removeClass(this.caretD).addClass(this.caretR);
          },
          getPropertiesEl: function getPropertiesEl() {
            return this.$el.find(".".concat(this.pfx, "properties")).get(0);
          },
          toggle: function toggle(t) {
            var e = this.model.get("open") ? 0 : 1;
            this.model.set("open", e);
          },
          render: function render() {
            var t = this.pfx,
              e = this.model,
              n = this.em,
              i = this.$el,
              r = e.attributes,
              a = r.id,
              o = r.name,
              s = n && n.t("styleManager.sectors.".concat(a)) || o;
            return i.html(this.template({
              pfx: t,
              label: s
            })), this.$caret = i.find("#".concat(t, "caret")), this.renderProperties(), i.attr("class", "".concat(t, "sector ").concat(t, "sector__").concat(a, " no-select")), this.updateOpen(), this;
          },
          renderProperties: function renderProperties() {
            var t = this.model.get("properties");
            if (t) {
              var e = new f.default({
                collection: t,
                target: this.target,
                propTarget: this.propTarget,
                config: this.config
              });
              this.$el.append(e.render().el);
            }
          }
        });
      function v(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function b(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? v(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var y = l.a.View.extend({
        initialize: function initialize() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = t.config || {};
          this.pfx = e.stylePrefix || "", this.ppfx = e.pStylePrefix || "", this.target = t.target || {}, this.config = e;
          var n = {};
          Object(a.extend)(n, l.a.Events);
          var i = document.body,
            r = document.createElement("el-".concat(new Date().getTime()));
          i.appendChild(r), n.computedDefault = b({}, window.getComputedStyle(r)), i.removeChild(r), this.propTarget = n;
          var o = this.collection,
            s = "component:toggled component:update:classes change:state change:device frame:resized";
          this.listenTo(o, "add", this.addTo), this.listenTo(o, "reset", this.render), this.listenTo(this.target, s, this.targetUpdated);
        },
        addTo: function addTo(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          this.addToCollection(t, null, n);
        },
        toggleStateCls: function toggleStateCls() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
            e = arguments.length > 1 ? arguments[1] : void 0;
          t.forEach(function (t) {
            var n = t.getEl();
            n && n.classList && n.classList[e ? "add" : "remove"]("hc-state");
          });
        },
        targetUpdated: function targetUpdated(t) {
          var e = this.target,
            n = this.propTarget,
            i = e.getSelectedAll(),
            r = e.getSelected(),
            a = t && t.toHTML ? t : r;
          if (a && this.toggleStateCls([a]), r) {
            var o = e.get("Config").devicePreviewMode ? "" : e.get("state"),
              s = e.get("SelectorManager").getConfig().componentFirst,
              l = r.getEl();
            if (n.helper = null, n.targets = null, l && Object(p.p)(l)) {
              var c = o ? ":".concat(o) : null;
              n.computed = window.getComputedStyle(l, c);
            }
            r = e.get("StyleManager").getModelToStyle(r), o && (function () {
              var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                i = e.get("CssComposer"),
                r = i.getAll(),
                a = i.getClassRule("hc-state");
              a ? (r.remove(a), r.add(a)) : a = i.setClassRule("hc-state"), a.set("important", 1), a.setStyle(t), n.helper = a;
            }(r.getStyle()), this.toggleStateCls(i, 1)), n.model = r, s && (n.targets = i), n.trigger("update");
          }
        },
        setTarget: function setTarget(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = this.target,
            i = Object(a.isArray)(t) ? t : [t],
            r = e.targetIsClass,
            o = e.stylable,
            s = [];
          i.forEach(function (t) {
            var e = t;
            if (Object(a.isString)(t)) {
              var i,
                l = n.get("CssComposer").getAll();
              r && (i = l.filter(function (e) {
                return e.get("selectors").getFullString() === t;
              })[0]), i || (i = l.filter(function (e) {
                return e.get("selectorsAdd") === t;
              })[0]), i || (i = l.add({
                selectors: [],
                selectorsAdd: t
              })), o && i.set({
                stylable: o
              }), e = i;
            }
            s.push(e);
          });
          var l = this.propTarget;
          return l.targets = s, l.trigger("update"), s;
        },
        addToCollection: function addToCollection(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            i = this.pfx,
            r = this.target,
            a = this.propTarget,
            o = this.config,
            s = this.el,
            l = e || s,
            c = new m({
              model: t,
              id: "".concat(i).concat(t.get("id")),
              name: t.get("name"),
              properties: t.get("properties"),
              target: r,
              propTarget: a,
              config: o
            }).render().el;
          return Object(g.b)(l, c, n.at), c;
        },
        render: function render() {
          var t = this,
            e = document.createDocumentFragment(),
            n = this.$el,
            i = this.pfx,
            r = this.ppfx;
          return n.empty(), this.collection.each(function (n) {
            return t.addToCollection(n, e);
          }), n.append(e), n.addClass("".concat(i, "sectors ").concat(r, "one-bg ").concat(r, "two-color")), this;
        }
      });
      function w(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function x(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? w(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : w(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.default = function () {
        var t,
          e,
          n,
          i = {};
        return {
          name: "StyleManager",
          getConfig: function getConfig() {
            return i;
          },
          init: function init(r) {
            var a = (i = x(x({}, o), r)).pStylePrefix;
            return this.em = i.em, a && (i.stylePrefix = a + i.stylePrefix), t = new c.default(), e = new h([], i), n = new y({
              collection: e,
              target: i.em,
              config: i
            }), this;
          },
          onLoad: function onLoad() {
            e.add(i.sectors, {
              silent: !0
            });
          },
          postRender: function postRender() {
            var t = this.getConfig().appendTo;
            t && (Object(a.isElement)(t) ? t : document.querySelector(t)).appendChild(this.render());
          },
          addSector: function addSector(t, n) {
            var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              r = this.getSector(t);
            return r || (n.id = t, r = e.add(n, i)), r;
          },
          getSector: function getSector(t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              i = e.where({
                id: t
              })[0];
            return !i && n.warn && this._logNoSector(t), i;
          },
          removeSector: function removeSector(t) {
            return this.getSectors().remove(this.getSector(t, {
              warn: 1
            }));
          },
          getSectors: function getSectors() {
            return e;
          },
          addProperty: function addProperty(t, e) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              i = this.getSector(t, {
                warn: 1
              }),
              r = null;
            return i && (r = i.get("properties").add(e, n)), r;
          },
          getProperty: function getProperty(t, e) {
            var n,
              i = this.getSector(t, {
                warn: 1
              });
            return i && (n = i.get("properties").filter(function (t) {
              return t.get("property") === e || t.get("id") === e;
            })[0]), n || null;
          },
          removeProperty: function removeProperty(t, e) {
            var n = this.getProperties(t);
            return n && n.remove(this.getProperty(t, e));
          },
          getProperties: function getProperties(t) {
            var e = null,
              n = this.getSector(t, {
                warn: 1
              });
            return n && (e = n.get("properties")), e;
          },
          getModelToStyle: function getModelToStyle(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = i.em,
              r = e.skipAdd,
              a = t.get("classes"),
              o = t.getId();
            if (n) {
              var s,
                l = n.getConfig(),
                c = n.get("UndoManager"),
                d = n.get("CssComposer"),
                u = n.get("SelectorManager"),
                h = u ? u.getConfig() : {},
                p = l.devicePreviewMode ? "" : n.get("state"),
                g = a.getStyleable(),
                f = g.length,
                m = !h.componentFirst || e.useClasses,
                v = {
                  state: p
                };
              if (c.stop(), f && m) {
                var b = n.getCurrentMedia();
                (s = d.get(g, p, b)) || r || (s = d.add(g, p, b));
              } else l.avoidInlineStyle && (!(s = d.getIdRule(o, v)) && !r && (s = d.setIdRule(o, {}, v)), t.is("wrapper") && s.set("wrapper", 1));
              s && (t = s), c.start();
            }
            return t;
          },
          addType: function addType(e, n) {
            t.addType(e, n);
          },
          getType: function getType(e) {
            return t.getType(e);
          },
          getTypes: function getTypes() {
            return t.getTypes();
          },
          createType: function createType(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = e.model,
              r = void 0 === n ? {} : n,
              a = e.view,
              o = void 0 === a ? {} : a,
              s = this.getType(t);
            if (s) return new s.view(x({
              model: new s.model(r),
              config: i
            }, o));
          },
          setTarget: function setTarget(t, e) {
            return n.setTarget(t, e);
          },
          getEmitter: function getEmitter() {
            return n.propTarget;
          },
          render: function render() {
            return n.render().el;
          },
          _logNoSector: function _logNoSector(t) {
            var e = this.em;
            e && e.logWarning("'".concat(t, "' sector not found"));
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(0),
        r = {
          stylePrefix: "cm-",
          inlineCss: !1
        },
        a = n(2),
        o = n.n(a),
        s = n(1),
        l = n.n(s);
      function c(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function d(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? c(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var u = l.a.Model.extend({
          build: function build(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = t.get("components");
            return e.exportWrapper ? t.toHTML(d({}, e.wrapperIsBody && {
              tag: "body"
            })) : this.buildModels(n);
          },
          buildModels: function buildModels(t) {
            var e = "";
            return t.each(function (t) {
              e += t.toHTML();
            }), e;
          }
        }),
        h = n(31),
        p = l.a.Model.extend({
          build: function build(t) {
            var e = t.toJSON();
            return this.beforeEach(e), Object(i.each)(e, function (t, n) {
              var i = e[n];
              if (i instanceof l.a.Model) e[n] = this.build(i);else if (i instanceof l.a.Collection) {
                var r = i;
                e[n] = [], r.length && r.each(function (t, i) {
                  e[n][i] = this.build(t);
                }, this);
              }
            }, this), e;
          },
          beforeEach: function beforeEach(t) {
            delete t.status;
          }
        }),
        g = l.a.Model.extend({
          mapModel: function mapModel(t) {
            var e = "",
              n = t.get("script-export") || t.get("script"),
              r = t.get("type"),
              a = t.get("components"),
              o = t.getId();
            if (n) {
              var s = t.get("attributes");
              s = Object(i.extend)({}, s, {
                id: o
              }), t.set("attributes", s, {
                silent: 1
              });
              var l = t.getScriptString(n);
              if (t.get("scriptUpdated")) this.mapJs[r + "-" + o] = {
                ids: [o],
                code: l
              };else {
                var c = this.mapJs[r];
                c ? c.ids.push(o) : this.mapJs[r] = {
                  ids: [o],
                  code: l
                };
              }
            }
            return a.each(function (t) {
              e += this.mapModel(t);
            }, this), e;
          },
          build: function build(t) {
            this.mapJs = {}, this.mapModel(t);
            var e = "";
            for (var n in this.mapJs) {
              var i = this.mapJs[n],
                r = "#" + i.ids.join(", #");
              e += "\n        var items = document.querySelectorAll('".concat(r, "');\n        for (var i = 0, len = items.length; i < len; i++) {\n          (function(){").concat(i.code, "}.bind(items[i]))();\n        }");
            }
            return e;
          }
        }),
        f = n(13),
        m = n.n(f);
      function v(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      n(91), n(45), n(94);
      var b = l.a.Model.extend({
          defaults: {
            input: "",
            label: "",
            codeName: "",
            theme: "hopscotch",
            readOnly: !0,
            lineNumbers: !0
          },
          init: function init(t) {
            return Object(i.bindAll)(this, "onChange"), this.editor = m.a.fromTextArea(t, function (t) {
              for (var e = 1; e < arguments.length; e++) {
                var n = null != arguments[e] ? arguments[e] : {};
                e % 2 ? v(Object(n), !0).forEach(function (e) {
                  o()(t, e, n[e]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function (e) {
                  Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
                });
              }
              return t;
            }({
              dragDrop: !1,
              lineWrapping: !0,
              mode: this.get("codeName")
            }, this.attributes)), this.element = t, this.editor.on("change", this.onChange), this;
          },
          onChange: function onChange() {
            this.trigger("update", this);
          },
          getEditor: function getEditor() {
            return this.editor;
          },
          getElement: function getElement() {
            return this.element;
          },
          setElement: function setElement(t) {
            return this.element = t, this;
          },
          refresh: function refresh() {
            return this.getEditor().refresh(), this;
          },
          focus: function focus() {
            return this.getEditor().focus(), this;
          },
          getContent: function getContent() {
            var t = this.getEditor();
            return t && t.getValue();
          },
          setContent: function setContent(t) {
            var e = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              i = this.editor;
            i && (i.setValue(t), i.autoFormatRange && (m.a.commands.selectAll(i), i.autoFormatRange(i.getCursor(!0), i.getCursor(!1)), m.a.commands.goDocStart(i)), !n.noRefresh && setTimeout(function () {
              return e.refresh();
            }));
          }
        }),
        y = l.a.View.extend({
          template: Object(i.template)('\n  <div class="<%= pfx %>editor" id="<%= pfx %><%= codeName %>">\n  \t<div id="<%= pfx %>title"><%= label %></div>\n  \t<div id="<%= pfx %>code"></div>\n  </div>'),
          initialize: function initialize(t) {
            this.config = t.config || {}, this.pfx = this.config.stylePrefix;
          },
          render: function render() {
            var t = this.model.toJSON();
            return t.pfx = this.pfx, this.$el.html(this.template(t)), this.$el.attr("class", this.pfx + "editor-c"), this.$el.find("#" + this.pfx + "code").append(this.model.get("input")), this;
          }
        });
      e.default = function () {
        var t = {},
          e = {},
          n = {},
          a = {},
          o = {};
        return {
          getConfig: function getConfig() {
            return t;
          },
          config: t,
          EditorView: y,
          name: "CodeManager",
          init: function init(e) {
            for (var i in t = e || {}, r) i in t || (t[i] = r[i]);
            var a = t.pStylePrefix;
            return a && (t.stylePrefix = a + t.stylePrefix), n.html = new u(), n.css = new h.a(), n.json = new p(), n.js = new g(), o.CodeMirror = new b(), this.loadDefaultGenerators().loadDefaultViewers(), this;
          },
          addGenerator: function addGenerator(t, n) {
            return e[t] = n, this;
          },
          getGenerator: function getGenerator(t) {
            return e[t] || null;
          },
          getGenerators: function getGenerators() {
            return e;
          },
          addViewer: function addViewer(t, e) {
            return a[t] = e, this;
          },
          getViewer: function getViewer(t) {
            return a[t] || null;
          },
          getViewers: function getViewers() {
            return a;
          },
          createViewer: function createViewer() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = Object(i.isUndefined)(t.type) ? "CodeMirror" : t.type,
              n = this.getViewer(e) && this.getViewer(e).clone();
            console.log("Creating div element codemanager:index");
            var r = document.createElement("div"),
              a = document.createElement("textarea");
            return r.appendChild(a), n.set(t), n.init(a), n.setElement(r), n;
          },
          updateViewer: function updateViewer(t, e) {
            t.setContent(e);
          },
          getCode: function getCode(e, n) {
            var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            i.em = t.em;
            var r = this.getGenerator(n);
            return r ? r.build(e, i) : "";
          },
          loadDefaultGenerators: function loadDefaultGenerators() {
            for (var t in n) this.addGenerator(t, n[t]);
            return this;
          },
          loadDefaultViewers: function loadDefaultViewers() {
            for (var t in o) this.addViewer(t, o[t]);
            return this;
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(2),
        r = n.n(i),
        a = {
          devices: []
        },
        o = n(1),
        s = n.n(o),
        l = s.a.Model.extend({
          idAttribute: "name",
          defaults: {
            name: "",
            width: null,
            height: "",
            widthMedia: null,
            priority: null
          },
          initialize: function initialize() {
            var t = this;
            null === this.get("widthMedia") && this.set("widthMedia", this.get("width")), null === this.get("width") && this.set("width", this.get("widthMedia")), !this.get("priority") && this.set("priority", parseFloat(this.get("widthMedia")) || 0), ["width", "height", "widthMedia"].forEach(function (e) {
              return t.checkUnit(e);
            });
          },
          checkUnit: function checkUnit(t) {
            var e = this.get(t) || "";
            (parseFloat(e) || 0).toString() === e.toString() && this.set(t, "".concat(e, "px"));
          }
        }),
        c = s.a.Collection.extend({
          model: l,
          comparator: function comparator(t, e) {
            var n = Number.MAX_VALUE;
            return (e.get("priority") || n) - (t.get("priority") || n);
          },
          getSorted: function getSorted() {
            return this.sort();
          }
        }),
        d = n(0),
        u = s.a.View.extend({
          template: Object(d.template)('\n    <div class="<%= ppfx %>device-label"><%= deviceLabel %></div>\n    <div class="<%= ppfx %>field <%= ppfx %>select">\n      <span id="<%= ppfx %>input-holder">\n        <select class="<%= ppfx %>devices"></select>\n      </span>\n      <div class="<%= ppfx %>sel-arrow">\n        <div class="<%= ppfx %>d-s-arrow"></div>\n      </div>\n    </div>\n    <button style="display:none" class="<%= ppfx %>add-trasp">+</button>'),
          events: {
            change: "updateDevice"
          },
          initialize: function initialize(t) {
            this.config = t.config || {}, this.em = this.config.em, this.ppfx = this.config.pStylePrefix || "", this.events["click ." + this.ppfx + "add-trasp"] = this.startAdd, this.listenTo(this.em, "change:device", this.updateSelect), this.delegateEvents();
          },
          startAdd: function startAdd() {},
          updateDevice: function updateDevice() {
            var t = this.em;
            if (t) {
              var e = this.devicesEl,
                n = e ? e.val() : "";
              t.set("device", n);
            }
          },
          updateSelect: function updateSelect() {
            var t = this.em,
              e = this.devicesEl;
            if (t && t.getDeviceModel && e) {
              var n = t.getDeviceModel(),
                i = n ? n.get("name") : "";
              e.val(i);
            }
          },
          getOptions: function getOptions() {
            var t = this.collection,
              e = this.em,
              n = "";
            return t.each(function (t) {
              var i = t.attributes,
                r = i.name,
                a = i.id,
                o = e && e.t && e.t("deviceManager.devices.".concat(a)) || r;
              n += '<option value="'.concat(r, '">').concat(o, "</option>");
            }), n;
          },
          render: function render() {
            var t = this.em,
              e = this.ppfx,
              n = this.$el,
              i = this.el;
            return n.html(this.template({
              ppfx: e,
              deviceLabel: t && t.t && t.t("deviceManager.device")
            })), this.devicesEl = n.find(".".concat(e, "devices")), this.devicesEl.append(this.getOptions()), i.className = "".concat(e, "devices-c"), this;
          }
        });
      function h(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function p(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? h(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.default = function () {
        var t,
          e,
          n = {};
        return {
          name: "DeviceManager",
          init: function init(i) {
            var r = this;
            for (var o in n = i || {}, a) o in n || (n[o] = a[o]);
            return t = new c(), (n.devices || []).forEach(function (t) {
              return r.add(t.id || t.name, t.width, t);
            }), e = new u({
              collection: t,
              config: n
            }), this;
          },
          add: function add(e, n) {
            var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              r = p(p({}, i), {}, {
                id: e,
                name: i.name || e,
                width: n
              });
            return t.add(r);
          },
          get: function get(e) {
            return t.get(e);
          },
          getAll: function getAll() {
            return t;
          },
          render: function render() {
            return e.render().el;
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(2),
        r = n.n(i),
        a = {
          id: "gjs-",
          autosave: 1,
          autoload: 1,
          type: "local",
          stepsBeforeSave: 1,
          storeComponents: 1,
          storeStyles: 1,
          storeHtml: 1,
          storeCss: 1,
          checkLocal: 1,
          params: {},
          headers: {},
          urlStore: "",
          urlLoad: "",
          beforeSend: function beforeSend(t, e) {},
          onComplete: function onComplete(t, e) {},
          contentTypeJson: !0,
          credentials: "include",
          fetchOptions: ""
        },
        o = n(1),
        s = n.n(o),
        l = s.a.Model.extend({
          defaults: {
            checkLocal: !0
          },
          store: function store(t, e) {
            for (var n in this.checkStorageEnvironment(), t) localStorage.setItem(n, t[n]);
            "function" == typeof e && e();
          },
          load: function load(t, e) {
            this.checkStorageEnvironment();
            for (var n = {}, i = 0, r = t.length; i < r; i++) {
              var a = localStorage.getItem(t[i]);
              a && (n[t[i]] = a);
            }
            return "function" == typeof e && e(n), n;
          },
          remove: function remove(t) {
            this.checkStorageEnvironment();
            for (var e = 0, n = t.length; e < n; e++) localStorage.removeItem(t[e]);
          },
          checkStorageEnvironment: function checkStorageEnvironment() {
            this.get("checkLocal") && !localStorage && console.warn("Your browser doesn't support localStorage");
          }
        }),
        c = n(28),
        d = n(0);
      function u(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function h(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? u(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var p = s.a.Model.extend({
        fetch: c.a,
        defaults: {
          urlStore: "",
          urlLoad: "",
          params: {},
          beforeSend: function beforeSend() {},
          onComplete: function onComplete() {},
          contentTypeJson: !1,
          credentials: "include",
          fetchOptions: ""
        },
        onStart: function onStart() {
          this.get("em");
          var t = this.get("beforeSend");
          t && t();
        },
        onError: function onError(t, e) {
          var n = document.querySelector(".btn-save");
          if (t ? n.classList.add("text-warning") : n.classList.remove("text-warning"), e) {
            var i = this.get("em");
            i && i.logError(t), e(t);
          } else {
            var r = this.get("em");
            console.error(t), r && r.logError(t), r && r.trigger("storage:error", t);
          }
        },
        onResponse: function onResponse(t, e) {
          var n = this.get("em"),
            i = this.get("onComplete"),
            r = this.get("contentTypeJson") && t && "string" == typeof t ? JSON.parse(t) : t;
          i && i(r), e && e(r), n && n.trigger("storage:response", r);
        },
        store: function store(t, e, n) {
          var i = {};
          for (var r in t) i[r] = t[r];
          var a = this.get("urlStore");
          this.get("isDeleteContent") && (a += "/delete"), this.request(a, {
            body: i
          }, e, n), this.resetAttributes();
        },
        resetAttributes: function resetAttributes() {
          this.set("isDeleteContent", !1);
        },
        load: function load(t, e, n) {
          this.request(this.get("urlLoad"), {
            method: "get"
          }, e, n);
        },
        request: function request(t) {
          var e,
            n,
            i = this,
            r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
            o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
            s = this.get("contentTypeJson"),
            l = this.get("headers") || {},
            c = this.get("params"),
            u = "X-Requested-With",
            p = "Content-Type",
            g = r.body || {};
          for (var f in c) g[f] = c[f];
          if (Object(d.isUndefined)(l[u]) && (l[u] = "XMLHttpRequest"), Object(d.isUndefined)(l[p]) && s && (l[p] = "application/json; charset=utf-8"), s) n = JSON.stringify(g);else for (var m in n = new FormData(), g) n.append(m, g[m]);
          "post" === (e = {
            method: r.method || "post",
            credentials: this.get("credentials"),
            headers: l
          }).method && (e.body = n);
          var v = this.get("fetchOptions") || {},
            b = Object(d.isFunction)(v) ? v(e) : e;
          this.onStart(), this.fetch(t, h(h({}, e), b || {})).then(function (t) {
            return 1 == (t.status / 200 | 0) ? t.text() : t.text().then(function (t) {
              return Promise.reject(t);
            });
          }).then(function (t) {
            return i.onResponse(t, a);
          }).catch(function (t) {
            return i.onError(t, o);
          });
        }
      });
      function g(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function f(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? g(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : g(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.default = function () {
        var t,
          e = {},
          n = {},
          i = {};
        return {
          name: "StorageManager",
          init: function init() {
            var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return e = f(f({}, a), n), t = e.em, e._disable && (e.type = 0), i.remote = new p(e), i.local = new l(e), e.currentStorage = e.type, this.loadDefaultProviders().setCurrent(e.type), this;
          },
          getConfig: function getConfig() {
            return e;
          },
          isAutosave: function isAutosave() {
            return !!e.autosave;
          },
          setAutosave: function setAutosave(t) {
            return e.autosave = !!t, this;
          },
          getStepsBeforeSave: function getStepsBeforeSave() {
            return e.stepsBeforeSave;
          },
          setStepsBeforeSave: function setStepsBeforeSave(t) {
            return e.stepsBeforeSave = t, this;
          },
          add: function add(t, e) {
            return n[t] = e, this;
          },
          get: function get(t) {
            return n[t] || null;
          },
          getStorages: function getStorages() {
            return n;
          },
          getCurrent: function getCurrent() {
            return e.currentStorage;
          },
          setCurrent: function setCurrent(t) {
            return e.currentStorage = t, this;
          },
          store: function store(t, n) {
            var i = this,
              r = this.get(this.getCurrent()),
              a = {};
            for (var o in this.onStart("store", t), t) a[e.id + o] = t[o];
            return r ? r.store(a, function (t) {
              n && n(t), i.onEnd("store", t);
            }, function (t) {
              i.onError("store", t);
            }) : null;
          },
          load: function load(t, n) {
            var i = this,
              r = this.get(this.getCurrent()),
              a = [],
              o = {};
            "string" == typeof t && (t = [t]), this.onStart("load", t);
            for (var s = 0, l = t.length; s < l; s++) a.push(e.id + t[s]);
            r ? r.load(a, function (t) {
              var r = new RegExp("^" + e.id);
              for (var a in t) {
                var s = a.replace(r, "");
                o[s] = t[a];
              }
              n && n(o), i.onEnd("load", o);
            }, function (t) {
              n && n(o), i.onError("load", t);
            }) : n && n(o);
          },
          loadDefaultProviders: function loadDefaultProviders() {
            for (var t in i) this.add(t, i[t]);
            return this;
          },
          getCurrentStorage: function getCurrentStorage() {
            return this.get(this.getCurrent());
          },
          onStart: function onStart(e, n) {
            t && (t.trigger("storage:start"), e && t.trigger("".concat("storage:start", ":").concat(e), n));
          },
          onEnd: function onEnd(e, n) {
            t && (t.trigger("storage:end"), e && t.trigger("".concat("storage:end", ":").concat(e), n));
          },
          onError: function onError(e, n) {
            t && (t.trigger("storage:error", n), e && t.trigger("".concat("storage:error", ":").concat(e), n), this.onEnd(e, n));
          },
          canAutoload: function canAutoload() {
            return this.getCurrentStorage() && this.getConfig().autoload;
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(2),
        r = n.n(i),
        a = {
          textTags: ["br", "b", "i", "u", "a", "ul", "ol"],
          parserCss: null,
          parserHtml: null
        },
        o = n(0),
        s = {
          4: "media",
          5: "font-face",
          6: "page",
          7: "keyframes",
          11: "counter-style",
          12: "supports",
          13: "document",
          14: "font-feature-values",
          15: "viewport"
        },
        l = Object(o.keys)(s),
        c = ["5", "6", "11", "15"],
        d = ["font-face", "page", "counter-style", "viewport"],
        u = function u() {
          for (var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", e = [], n = [], i = t.split(","), r = 0, a = i.length; r < a; r++) {
            var o = i[r].trim();
            if (/^(\.{1}[\w\-]+)+(:{1,2}[\w\-()]+)?$/gi.test(o) || /^(#{1}[\w\-]+){1}(:{1,2}[\w\-()]+)?$/gi.test(o)) {
              var s = o.split(".").filter(Boolean);
              n.push(s);
            } else e.push(o);
          }
          return {
            result: n,
            add: e
          };
        },
        h = function h(t) {
          for (var e = t.style, n = {}, i = 0, r = e.length; i < r; i++) {
            var a = e[i],
              o = e.getPropertyValue(a),
              s = e.getPropertyPriority(a);
            n[a] = "".concat(o).concat(s ? " !".concat(s) : "");
          }
          return n;
        },
        p = function p(t) {
          return (t.conditionText || t.media && t.media.mediaText || t.name || t.selectorText || "").trim();
        },
        g = function g(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            i = {},
            r = t.length,
            a = t[r - 1],
            o = a ? a.split(/:(.+)/) : [],
            s = o[1],
            l = n.atRule,
            c = n.selectorsAdd,
            u = n.mediaText,
            h = d.indexOf(l) >= 0;
          return h && (i.singleAtRule = 1), l && (i.atRuleType = l), c && (i.selectorsAdd = c), u && (i.mediaText = u), s && (t[r - 1] = o[0], i.state = s, o.splice(o.length - 1, 1)), i.selectors = t, i.style = e, i;
        },
        f = function f(t) {
          var e = document.createElement("style");
          e.innerHTML = t, document.head.appendChild(e);
          var n = e.sheet;
          return document.head.removeChild(e), function t(e) {
            for (var n = [], i = e.cssRules || [], r = 0, a = i.length; r < a; r++) {
              var o = i[r],
                d = o.type.toString(),
                f = 0,
                m = "",
                v = "",
                b = o.selectorText || o.keyText,
                y = c.indexOf(d) >= 0;
              if (y) f = 1, m = s[d], v = p(o);else if (l.indexOf(d) >= 0) {
                var w = t(o);
                v = p(o);
                for (var x = 0, j = w.length; x < j; x++) {
                  var C = w[x];
                  v && (C.mediaText = v), C.atRuleType = s[d];
                }
                n = n.concat(w);
              }
              if (b || y) {
                for (var M = h(o), k = u(b), O = k.add, T = void 0, S = 0, N = (b = k.result).length; S < N; S++) {
                  var L = g(b[S], M, {
                    atRule: s[d]
                  });
                  n.push(L), T = L;
                }
                if (O.length) {
                  var D = O.join(", ");
                  if (T) T.selectorsAdd = D;else {
                    var E = {
                      selectors: [],
                      selectorsAdd: D,
                      style: M
                    };
                    f && (E.singleAtRule = f), m && (E.atRuleType = m), v && (E.mediaText = v), n.push(E);
                  }
                }
              }
            }
            return n;
          }(n);
        },
        m = function m() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return {
            parse: function parse(e) {
              var n = this,
                i = [],
                r = t.parserCss,
                a = t.em,
                o = void 0 === a ? {} : a,
                s = o && o.get && o.get("Editor");
              return (r ? r(e, s) : f(e)).forEach(function (t) {
                return i = i.concat(n.checkNode(t));
              }), i;
            },
            checkNode: function checkNode(t) {
              var e = t,
                n = e.selectors,
                i = e.style;
              if (Object(o.isString)(n)) {
                var r = [],
                  a = u(n),
                  s = a.result,
                  l = a.add.join(", "),
                  c = {
                    atRule: t.atRule,
                    mediaText: t.params
                  };
                s.length ? s.forEach(function (t) {
                  r.push(g(t, i, c));
                }) : r.push(g([], i, c)), l && (r[r.length - 1].selectorsAdd = l), t = r;
              }
              return t;
            }
          };
        },
        v = n(29);
      function b(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function y(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? b(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : b(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.default = function () {
        var t,
          e,
          n = {};
        return {
          compTypes: "",
          parserCss: null,
          parserHtml: null,
          name: "Parser",
          getConfig: function getConfig() {
            return n;
          },
          init: function init() {
            var i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return (n = y(y({}, a), i)).Parser = this, t = new v.a(n), e = new m(n), this.em = n.em, this.parserCss = e, this.parserHtml = t, this;
          },
          parseHtml: function parseHtml(n) {
            var i = this.em,
              r = this.compTypes;
            return t.compTypes = i ? i.get("DomComponents").getTypes() : r, t.parse(n, e);
          },
          parseCss: function parseCss(t) {
            return e.parse(t);
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(2),
        r = n.n(i),
        a = n(0),
        o = n(3),
        s = {
          stylePrefix: "clm-",
          appendTo: "",
          selectors: [],
          states: [{
            name: "hover"
          }, {
            name: "active"
          }, {
            name: "nth-of-type(2n)"
          }],
          escapeName: 0,
          selectedName: 0,
          iconAdd: '<svg viewBox="0 0 24 24"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"></path></svg>',
          iconSync: '<svg viewBox="0 0 24 24"><path d="M12 18c-3.31 0-6-2.69-6-6 0-1 .25-1.97.7-2.8L5.24 7.74A7.93 7.93 0 0 0 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4m0-11V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1-.25 1.97-.7 2.8l1.46 1.46A7.93 7.93 0 0 0 20 12c0-4.42-3.58-8-8-8z"></path></svg>',
          iconTagOn: '<svg viewBox="0 0 24 24"><path d="M19 19H5V5h10V3H5c-1.11 0-2 .89-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-8h-2m-11.09-.92L6.5 11.5 11 16 21 6l-1.41-1.42L11 13.17l-3.09-3.09z"></path></svg>',
          iconTagOff: '<svg viewBox="0 0 24 24"><path d="M19 3H5c-1.11 0-2 .89-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5a2 2 0 0 0-2-2m0 2v14H5V5h14z"></path></svg>',
          iconTagRemove: '<svg viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"></path></svg>',
          render: 0,
          componentFirst: 0
        },
        l = n(10),
        c = n(12),
        d = n(9),
        u = n.n(d),
        h = n(1),
        p = n.n(h),
        g = p.a.View.extend({
          template: function template() {
            var t = this.pfx,
              e = this.model,
              n = this.config,
              i = e.get("label") || "";
            return '\n      <span id="'.concat(t, 'checkbox" class="').concat(t, 'tag-status" data-tag-status></span>\n      <span id="').concat(t, 'tag-label" data-tag-name>').concat(i, '</span>\n      <span id="').concat(t, 'close" class="').concat(t, 'tag-close" data-tag-remove>\n        ').concat(n.iconTagRemove, "\n      </span>\n    ");
          },
          events: {
            "click [data-tag-remove]": "removeTag",
            "click [data-tag-status]": "changeStatus",
            "dblclick [data-tag-name]": "startEditTag",
            "focusout [data-tag-name]": "endEditTag"
          },
          initialize: function initialize(t) {
            var e = t.config || {};
            this.config = e, this.coll = t.coll || null, this.pfx = e.stylePrefix || "", this.ppfx = e.pStylePrefix || "", this.em = e.em, this.listenTo(this.model, "change:active", this.updateStatus);
          },
          getInputEl: function getInputEl() {
            return this.inputEl || (this.inputEl = this.el.querySelector("[data-tag-name]")), this.inputEl;
          },
          startEditTag: function startEditTag() {
            var t = this.em,
              e = this.getInputEl();
            e.contentEditable = !0, e.focus(), t && t.setEditing(1);
          },
          endEditTag: function endEditTag() {
            var t = this.model,
              e = this.getInputEl(),
              n = e.textContent,
              i = this.em,
              r = i && i.get("SelectorManager");
            if (e.contentEditable = !1, i && i.setEditing(0), r) {
              var a = r.escapeName(n);
              r.get(a) ? e.innerText = t.get("label") : t.set({
                name: a,
                label: n
              });
            }
          },
          changeStatus: function changeStatus() {
            var t = this.model;
            t.set("active", !t.get("active"));
          },
          removeTag: function removeTag() {
            var t = this.em,
              e = this.model;
            (t && t.getSelectedAll()).forEach(function (t) {
              !e.get("protected") && t && t.getSelectors().remove(e);
            });
          },
          updateStatus: function updateStatus() {
            var t = this.model,
              e = this.$el,
              n = this.config,
              i = n.iconTagOn,
              r = n.iconTagOff,
              a = e.find("[data-tag-status]");
            t.get("active") ? (a.html(i), e.removeClass("opac50")) : (a.html(r), e.addClass("opac50"));
          },
          render: function render() {
            var t = this.pfx,
              e = this.ppfx;
            return this.$el.html(this.template()), this.$el.attr("class", "".concat(t, "tag ").concat(e, "three-bg")), this.updateStatus(), this;
          }
        }),
        f = p.a.View.extend({
          template: function template(t) {
            var e = t.labelInfo,
              n = t.labelStates,
              i = t.labelHead,
              r = t.iconSync,
              a = t.iconAdd,
              o = t.pfx,
              s = t.ppfx;
            return '\n    <div id="'.concat(o, 'up" class="').concat(o, 'header">\n      <div id="').concat(o, 'label" class="').concat(o, 'header-label">').concat(i, '</div>\n      <div id="').concat(o, 'status-c" class="').concat(o, 'header-status">\n        <span id="').concat(o, 'input-c" data-states-c>\n          <div class="').concat(s, "field ").concat(s, 'select">\n            <span id="').concat(s, 'input-holder">\n              <select id="').concat(o, 'states" data-states>\n                <option value="">').concat(n, '</option>\n              </select>\n            </span>\n            <div class="').concat(s, 'sel-arrow">\n              <div class="').concat(s, 'd-s-arrow"></div>\n            </div>\n          </div>\n        </span>\n      </div>\n    </div>\n    <div id="').concat(o, 'tags-field" class="').concat(s, 'field">\n      <div id="').concat(o, 'tags-c" data-selectors></div>\n      <input id="').concat(o, 'new" data-input/>\n      <span id="').concat(o, 'add-tag" class="').concat(o, "tags-btn ").concat(o, 'tags-btn__add" data-add>\n        ').concat(a, '\n      </span>\n      <span class="').concat(o, "tags-btn ").concat(o, 'tags-btn__sync" style="display: none" data-sync-style>\n        ').concat(r, '\n      </span>\n    </div>\n    <div class="').concat(o, 'sels-info">\n      <div class="').concat(o, 'label-sel">').concat(e, ':</div>\n      <div class="').concat(o, 'sels" data-selected></div>\n      <div style="clear:both"></div>\n    </div>');
          },
          events: {
            "change [data-states]": "stateChanged",
            "click [data-add]": "startNewTag",
            "focusout [data-input]": "endNewTag",
            "keyup [data-input]": "onInputKeyUp",
            "click [data-sync-style]": "syncStyle"
          },
          initialize: function initialize() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            this.config = t.config || {}, this.pfx = this.config.stylePrefix || "", this.ppfx = this.config.pStylePrefix || "", this.className = this.pfx + "tags", this.stateInputId = this.pfx + "states", this.stateInputC = this.pfx + "input-c", this.states = this.config.states || [];
            var e = this.config.em,
              n = this.getStyleEmitter(),
              i = this.collection;
            this.target = this.config.em, this.em = e;
            var r = "component:toggled component:update:classes",
              a = "component:update:classes change:state";
            this.listenTo(e, r, this.componentChanged), this.listenTo(n, "styleManager:update", this.componentChanged), this.listenTo(e, a, this.__handleStateChange), this.listenTo(e, "styleable:change change:device", this.checkSync), this.listenTo(i, "add", this.addNew), this.listenTo(i, "reset", this.renderClasses), this.listenTo(i, "remove", this.tagRemoved), this.delegateEvents();
          },
          syncStyle: function syncStyle() {
            var t,
              e = this.em,
              n = this.getTarget(),
              i = e.get("CssComposer"),
              r = this.getCommonSelectors({
                opts: {
                  noDisabled: 1
                }
              }),
              a = e.get("state"),
              o = e.getCurrentMedia(),
              s = [],
              l = i.get(r, a, o) || i.add(r, a, o);
            this.getTargets().forEach(function (e) {
              var n = i.getIdRule(e.getId(), {
                state: a,
                mediaText: o
              });
              t = n.getStyle(), n.setStyle({}), s.push(n);
            }), t && l.addStyle(t), e.trigger("component:toggled"), e.trigger("component:sync-style", {
              component: n,
              selectors: r,
              mediaText: o,
              rule: l,
              ruleComponents: s,
              state: a
            });
          },
          getStyleEmitter: function getStyleEmitter() {
            var t = this.em,
              e = t && t.get("StyleManager");
            return e && e.getEmitter() || {};
          },
          tagRemoved: function tagRemoved(t) {
            this.updateStateVis();
          },
          getStateOptions: function getStateOptions() {
            var t = this.states,
              e = this.em,
              n = [];
            return t.forEach(function (t) {
              return n.push('<option value="'.concat(t.name, '">').concat(e.t("selectorManager.states.".concat(t.name)) || t.label || t.name, "</option>"));
            }), n.join("");
          },
          addNew: function addNew(t) {
            this.addToClasses(t);
          },
          startNewTag: function startNewTag() {
            this.$addBtn.css({
              display: "none"
            }), this.$input.show().focus();
          },
          endNewTag: function endNewTag() {
            this.$addBtn.css({
              display: ""
            }), this.$input.hide().val("");
          },
          onInputKeyUp: function onInputKeyUp(t) {
            13 === t.keyCode ? this.addNewTag(this.$input.val()) : 27 === t.keyCode && this.endNewTag();
          },
          checkStates: function checkStates() {
            var t = this.em.getState(),
              e = this.getStates();
            e && e.val(t);
          },
          componentChanged: Object(a.debounce)(function () {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = t.targets;
            this.updateSelection(e);
          }),
          updateSelection: function updateSelection(t) {
            var e = t || this.getTargets(),
              n = [];
            return (e = Object(a.isArray)(e) ? e : [e]) && e.length && (n = this.getCommonSelectors({
              targets: e
            }), this.checkSync({
              validSelectors: n
            })), this.collection.reset(n), this.updateStateVis(e), n;
          },
          getCommonSelectors: function getCommonSelectors() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = t.targets,
              n = t.opts,
              i = void 0 === n ? {} : n,
              r = e || this.getTargets(),
              a = r.map(function (t) {
                return t.getSelectors && t.getSelectors().getValid(i);
              }).filter(function (t) {
                return t;
              });
            return this._commonSelectors.apply(this, u()(a));
          },
          _commonSelectors: function _commonSelectors() {
            for (var t = this, e = arguments.length, n = new Array(e), i = 0; i < e; i++) n[i] = arguments[i];
            return n.length ? 1 === n.length ? n[0] : 2 === n.length ? n[0].filter(function (t) {
              return n[1].indexOf(t) >= 0;
            }) : n.slice(1).reduce(function (e, n) {
              return t._commonSelectors(e, n);
            }, n[0]) : [];
          },
          checkSync: Object(a.debounce)(function () {
            var t,
              e = this.$btnSyncEl,
              n = this.config,
              i = this.collection,
              r = this.getTarget();
            if (r && n.componentFirst && i.length) {
              var o = r.getStyle();
              t = !Object(a.isEmpty)(o);
            }
            e && e[t ? "show" : "hide"]();
          }),
          getTarget: function getTarget() {
            return this.target.getSelected();
          },
          getTargets: function getTargets() {
            return this.target.getSelectedAll();
          },
          updateStateVis: function updateStateVis(t) {
            var e = this.em,
              n = e && e.getConfig("avoidInlineStyle"),
              i = this.collection.length || n ? "" : "none";
            this.getStatesC().css("display", i), this.updateSelector(t);
          },
          __handleStateChange: function __handleStateChange() {
            this.updateSelector(this.getTargets());
          },
          updateSelector: function updateSelector(t) {
            var e = this,
              n = this.el.querySelector("[data-selected]"),
              i = [],
              r = t || this.getTargets();
            (r = Object(a.isArray)(r) ? r : [r]).forEach(function (t) {
              return i.push(e.__getName(t));
            }), n && (n.innerHTML = i.join(", ")), this.checkStates();
          },
          __getName: function __getName(t) {
            var e,
              n = this.pfx,
              i = this.config,
              r = this.em,
              o = i.selectedName,
              s = i.componentFirst;
            if (Object(a.isString)(t)) e = '<span class="'.concat(n, 'sel-gen">').concat(t, "</span>");else {
              if (!t || !t.get) return;
              var l = t.getSelectors().getStyleable(),
                c = r.get("state"),
                d = t.getId ? '<span class="'.concat(n, 'sel-cmp">').concat(t.getName(), '</span><span class="').concat(n, 'sel-id">#').concat(t.getId(), "</span>") : "";
              e = (e = this.collection.getFullString(l)) ? '<span class="'.concat(n, 'sel-rule">').concat(e, "</span>") : t.get("selectorsAdd") || d, e = s && d ? d : e, e += c ? '<span class="'.concat(n, 'sel-state">:').concat(c, "</span>") : "", e = o ? o({
                result: e,
                state: c,
                target: t
              }) : e;
            }
            return e && '<span class="'.concat(n, 'sel">').concat(e, "</span>");
          },
          stateChanged: function stateChanged(t) {
            var e = this.em,
              n = t.target.value;
            e.set("state", n);
          },
          addNewTag: function addNewTag(t) {
            var e = this,
              n = this.em;
            if (t.trim()) {
              if (n) {
                var i = n.get("SelectorManager").add({
                  label: t
                });
                this.getTargets().forEach(function (t) {
                  t.getSelectors().add(i), e.collection.add(i), e.updateStateVis();
                });
              }
              this.endNewTag();
            }
          },
          addToClasses: function addToClasses(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
              n = e,
              i = this.getClasses(),
              r = new g({
                model: t,
                config: this.config,
                coll: this.collection
              }).render().el;
            return n ? n.appendChild(r) : i.append(r), r;
          },
          renderClasses: function renderClasses() {
            var t = this,
              e = document.createDocumentFragment(),
              n = this.getClasses();
            n.empty(), this.collection.each(function (n) {
              return t.addToClasses(n, e);
            }), n.append(e);
          },
          getClasses: function getClasses() {
            return this.$el.find("[data-selectors]");
          },
          getStates: function getStates() {
            if (!this.$states) {
              var t = this.$el.find("[data-states]");
              this.$states = t[0] && t;
            }
            return this.$states;
          },
          getStatesC: function getStatesC() {
            return this.$statesC || (this.$statesC = this.$el.find("#" + this.stateInputC)), this.$statesC;
          },
          render: function render() {
            var t = this.em,
              e = this.pfx,
              n = this.ppfx,
              i = this.config,
              r = this.$el,
              a = this.el,
              o = i.render,
              s = {
                iconSync: i.iconSync,
                iconAdd: i.iconAdd,
                labelHead: t.t("selectorManager.label"),
                labelStates: t.t("selectorManager.emptyState"),
                labelInfo: t.t("selectorManager.selected"),
                ppfx: n,
                pfx: e,
                el: a
              };
            r.html(this.template(s));
            var l = o && o(s);
            l && l !== a && r.empty().append(l), this.$input = r.find("[data-input]"), this.$addBtn = r.find("[data-add]"), this.$classes = r.find("#" + e + "tags-c"), this.$btnSyncEl = r.find("[data-sync-style]"), this.$input.hide();
            var c = this.getStates();
            return c && c.append(this.getStateOptions()), this.renderClasses(), r.attr("class", "".concat(this.className, " ").concat(n, "one-bg ").concat(n, "two-color")), this;
          }
        });
      function m(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function v(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? m(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var b = function b(t) {
          return Object(a.isString)(t) && "#" == t[0];
        },
        y = function y(t) {
          return Object(a.isString)(t) && "." == t[0];
        };
      e.default = function (t) {
        var e,
          n = t || {};
        return {
          Selector: l.a,
          Selectors: c.a,
          name: "SelectorManager",
          getConfig: function getConfig() {
            return n;
          },
          init: function init() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              i = (n = v(v({}, s), t)).em,
              r = n.pStylePrefix;
            return this.em = i, r && (n.stylePrefix = r + n.stylePrefix), this.selectorTags = new f({
              collection: new c.a([], {
                em: i,
                config: n
              }),
              config: n
            }), (e = new c.a(n.selectors)).on("add", function (t) {
              return i.trigger("selector:add", t);
            }), e.on("remove", function (t) {
              return i.trigger("selector:remove", t);
            }), e.on("change", function (t) {
              return i.trigger("selector:update", t, t.previousAttributes(), t.changedAttributes());
            }), i.on("change:state", function (t, e) {
              return i.trigger("selector:state", e);
            }), this;
          },
          postRender: function postRender() {
            var t = this.getConfig().appendTo;
            t && (Object(a.isElement)(t) ? t : document.querySelector(t)).appendChild(this.render([]));
          },
          select: function select(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = Array.isArray(t) ? t : [t],
              i = this.em.get("StyleManager").setTarget(n, e),
              r = i.filter(function (t) {
                return t;
              }).map(function (t) {
                return Object(o.l)(t) || Object(o.o)(t) && !t.get("selectorsAdd") ? t : t.getSelectorsString();
              });
            return this.selectorTags.componentChanged({
              targets: r
            }), this;
          },
          setState: function setState(t) {
            return this.em.setState(t), this;
          },
          getState: function getState() {
            return this.em.setState();
          },
          addSelector: function addSelector(t) {
            var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = v({}, i);
            Object(a.isObject)(t) ? r = t : r.name = t, b(r.name) ? (r.name = r.name.substr(1), r.type = l.a.TYPE_ID) : y(r.name) && (r.name = r.name.substr(1)), r.label && !r.name && (r.name = this.escapeName(r.label));
            var o = r.name,
              s = o ? this.get(o, r.type) : e.where(r)[0];
            return s || e.add(r, {
              config: n
            });
          },
          getSelector: function getSelector(t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : l.a.TYPE_CLASS;
            return b(t) ? (t = t.substr(1), n = l.a.TYPE_ID) : y(t) && (t = t.substr(1)), e.where({
              name: t,
              type: n
            })[0];
          },
          add: function add(t) {
            var e = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return Object(a.isArray)(t) ? t.map(function (t) {
              return e.addSelector(t, n);
            }) : this.addSelector(t, n);
          },
          addClass: function addClass(t) {
            var e = this,
              n = [];
            return Object(a.isString)(t) && (t = t.trim().split(" ")), t.forEach(function (t) {
              return n.push(e.addSelector(t));
            }), n;
          },
          get: function get(t, e) {
            var n = this;
            if (Object(a.isArray)(t)) {
              var i = [];
              return t.map(function (t) {
                return n.getSelector(t);
              }).filter(function (t) {
                return t;
              }).forEach(function (t) {
                return i.indexOf(t) < 0 && i.push(t);
              }), i;
            }
            return this.getSelector(t, e);
          },
          getAll: function getAll() {
            return e;
          },
          escapeName: function escapeName(t) {
            var e = n.escapeName;
            return e ? e(t) : l.a.escapeName(t);
          },
          render: function render(t) {
            return t ? (this.selectorTags = new f({
              collection: new c.a(t),
              config: n
            }), this.selectorTags.render().el) : this.selectorTags.render().el;
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(2),
        r = n.n(i),
        a = {
          stylePrefix: "mdl-",
          title: "",
          content: "",
          backdrop: !0
        },
        o = n(1),
        s = n.n(o),
        l = s.a.Model.extend({
          defaults: {
            title: "",
            content: "",
            open: !1
          }
        }),
        c = s.a.View.extend({
          template: function template(t) {
            var e = t.pfx,
              n = t.ppfx,
              i = t.content,
              r = t.title;
            return '<div class="'.concat(e, "dialog ").concat(n, "one-bg ").concat(n, 'two-color">\n      <div class="').concat(e, 'header">\n        <div class="').concat(e, 'title">').concat(r, '</div>\n        <div class="').concat(e, 'btn-close" data-close-modal>&Cross;</div>\n      </div>\n      <div class="').concat(e, 'content">\n        <div id="').concat(e, 'c">').concat(i, '</div>\n        <div style="clear:both"></div>\n      </div>\n    </div>\n    <div class="').concat(e, 'collector" style="display: none"></div>');
          },
          events: {
            click: "onClick",
            "click [data-close-modal]": "hide"
          },
          initialize: function initialize(t) {
            var e = this.model,
              n = t.config || {},
              i = n.stylePrefix || "";
            this.config = n, this.pfx = i, this.ppfx = n.pStylePrefix || "", this.listenTo(e, "change:open", this.updateOpen), this.listenTo(e, "change:title", this.updateTitle), this.listenTo(e, "change:content", this.updateContent);
          },
          onClick: function onClick(t) {
            this.config.backdrop && t.target === this.el && this.hide();
          },
          getCollector: function getCollector() {
            return this.$collector || (this.$collector = this.$el.find("." + this.pfx + "collector")), this.$collector;
          },
          getContent: function getContent() {
            var t = this.pfx;
            return this.$content || (this.$content = this.$el.find(".".concat(t, "content #").concat(t, "c"))), this.$content;
          },
          getTitle: function getTitle() {
            return this.$title || (this.$title = this.$el.find("." + this.pfx + "title")), this.$title.get(0);
          },
          updateContent: function updateContent() {
            var t = this.getContent(),
              e = t.children(),
              n = this.getCollector(),
              i = this.model.get("content");
            e.length && n.append(e), t.empty().append(i);
          },
          updateTitle: function updateTitle() {
            var t = this.getTitle();
            t && (t.innerHTML = this.model.get("title"));
          },
          updateOpen: function updateOpen() {
            this.el.style.display = this.model.get("open") ? "" : "none";
          },
          hide: function hide() {
            this.model.set("open", 0);
          },
          show: function show() {
            this.model.set("open", 1);
          },
          render: function render() {
            var t = this.$el,
              e = this.pfx,
              n = (this.ppfx, this.model.toJSON());
            return n.pfx = this.pfx, n.ppfx = this.ppfx, t.html(this.template(n)), t.attr("class", "".concat(e, "container")), this.updateOpen(), this;
          }
        });
      function d(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function u(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? d(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.default = function () {
        var t,
          e,
          n = {},
          i = function i(t, e) {
            e && e.trigger("modal:".concat(t ? "open" : "close"));
          };
        return {
          name: "Modal",
          getConfig: function getConfig() {
            return n;
          },
          init: function init() {
            var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              o = (n = u(u({}, a), r)).em;
            this.em = o;
            var s = n.pStylePrefix;
            return s && (n.stylePrefix = s + n.stylePrefix), (t = new l(n)).on("change:open", function (t, e) {
              return i(e, o);
            }), e = new c({
              model: t,
              config: n
            }), this;
          },
          postRender: function postRender(t) {
            var e = t.model.getConfig().el || t.el;
            this.render().appendTo(e);
          },
          open: function open() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return t.title && this.setTitle(t.title), t.content && this.setContent(t.content), e.show(), this;
          },
          close: function close() {
            return e.hide(), this;
          },
          onceClose: function onceClose(t) {
            return this.em.once("modal:close", t), this;
          },
          onceOpen: function onceOpen(t) {
            return this.em.once("modal:open", t), this;
          },
          isOpen: function isOpen() {
            return !!t.get("open");
          },
          setTitle: function setTitle(e) {
            return t.set("title", e), this;
          },
          getTitle: function getTitle() {
            return t.get("title");
          },
          setContent: function setContent(e) {
            return t.set("content", " "), t.set("content", e), this;
          },
          getContent: function getContent() {
            return t.get("content");
          },
          getContentEl: function getContentEl() {
            return e.getContent().get(0);
          },
          getModel: function getModel() {
            return t;
          },
          render: function render() {
            return e.render().$el;
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(2),
        r = n.n(i),
        a = {
          stylePrefix: "pop-",
          title: "",
          content: "",
          top: 0,
          bottom: 0,
          right: 0,
          left: 0,
          backdrop: !0
        },
        o = n(1),
        s = n.n(o),
        l = s.a.Model.extend({
          defaults: {
            title: "",
            content: "",
            top: 0,
            bottom: 0,
            right: 0,
            left: 0,
            open: !1
          }
        }),
        c = s.a.View.extend({
          template: function template(t) {
            var e = t.pfx,
              n = t.ppfx,
              i = t.content,
              r = t.title;
            return t.top, t.bottom, t.left, t.right, '<div class="'.concat(e, "dialog ").concat(n, "one-bg ").concat(n, 'two-color">\n      <div class="').concat(e, 'header">\n        <div class="').concat(e, 'title">').concat(r, '</div>\n        <div class="').concat(e, 'btn-close" data-close-popover>&Cross;</div>\n      </div>\n      <div class="').concat(e, 'content">\n        <div id="').concat(e, 'c">').concat(i, '</div>\n        <div style="clear:both"></div>\n      </div>\n    </div>\n    <div class="').concat(e, 'collector" style="display: none"></div>');
          },
          events: {
            click: "onClick",
            "click [data-close-popover]": "hide"
          },
          initialize: function initialize(t) {
            var e = this.model,
              n = t.config || {},
              i = n.stylePrefix || "";
            this.config = n, this.pfx = i, this.ppfx = n.pStylePrefix || "", this.listenTo(e, "change:open", this.updateOpen), this.listenTo(e, "change:title", this.updateTitle), this.listenTo(e, "change:content", this.updateContent);
          },
          onClick: function onClick(t) {
            this.config.backdrop && t.target === this.el && this.hide();
          },
          getCollector: function getCollector() {
            return this.$collector || (this.$collector = this.$el.find("." + this.pfx + "collector")), this.$collector;
          },
          getContent: function getContent() {
            var t = this.pfx;
            return this.$content || (this.$content = this.$el.find(".".concat(t, "content #").concat(t, "c"))), this.$content;
          },
          getTitle: function getTitle() {
            return this.$title || (this.$title = this.$el.find("." + this.pfx + "title")), this.$title.get(0);
          },
          updateContent: function updateContent() {
            var t = this.getContent(),
              e = t.children(),
              n = this.getCollector(),
              i = this.model.get("content");
            e.length && n.append(e), t.empty().append(i);
          },
          updateTitle: function updateTitle() {
            var t = this.getTitle();
            t && (t.innerHTML = this.model.get("title"));
          },
          updateOpen: function updateOpen() {
            this.el.style.display = this.model.get("open") ? "" : "none", this.el.style.top = this.model.get("top") + "px", this.el.style.bottom = this.model.get("bottom") + "px", this.el.style.right = this.model.get("right") + "px", this.el.style.left = this.model.get("left") + "px";
          },
          hide: function hide() {
            this.model.set("open", 0);
          },
          show: function show() {
            this.model.set("open", 1);
          },
          render: function render() {
            var t = this.$el,
              e = this.pfx,
              n = (this.ppfx, this.model.toJSON());
            return n.pfx = this.pfx, n.ppfx = this.ppfx, t.html(this.template(n)), t.attr("class", "".concat(e, "container")), this.updateOpen(), this;
          }
        });
      function d(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function u(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? d(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.default = function () {
        var t,
          e,
          n = {},
          i = function i(t, e) {
            e && e.trigger("popover:".concat(t ? "open" : "close"));
          };
        return {
          name: "Popover",
          getConfig: function getConfig() {
            return n;
          },
          init: function init() {
            var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              o = (n = u(u({}, a), r)).em;
            this.em = o;
            var s = n.pStylePrefix;
            return s && (n.stylePrefix = s + n.stylePrefix), (t = new l(n)).on("change:open", function (t, e) {
              return i(e, o);
            }), e = new c({
              model: t,
              config: n
            }), this;
          },
          postRender: function postRender(t) {
            var e = t.model.getConfig().el || t.el;
            this.render().appendTo(e);
          },
          open: function open() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return t.title && this.setTitle(t.title), t.content && this.setContent(t.content), t.top && this.setTop(t.top), t.bottom && this.setBottom(t.bottom), t.left && this.setLeft(t.left), t.right && this.setRight(t.right), e.show(), this;
          },
          close: function close() {
            return e.hide(), this;
          },
          onceClose: function onceClose(t) {
            return this.em.once("popover:close", t), this;
          },
          onceOpen: function onceOpen(t) {
            return this.em.once("popover:open", t), this;
          },
          isOpen: function isOpen() {
            return !!t.get("open");
          },
          setTitle: function setTitle(e) {
            return t.set("title", e), this;
          },
          getTitle: function getTitle() {
            return t.get("title");
          },
          setContent: function setContent(e) {
            return t.set("content", " "), t.set("content", e), this;
          },
          getContent: function getContent() {
            return t.get("content");
          },
          getContentEl: function getContentEl() {
            return e.getContent().get(0);
          },
          setTop: function setTop(e) {
            return t.set("top", e), this;
          },
          getTop: function getTop() {
            return t.get("top");
          },
          setBottom: function setBottom(e) {
            return t.set("bottom", e), this;
          },
          getBottom: function getBottom() {
            return t.get("bottom");
          },
          setLeft: function setLeft(e) {
            return t.set("left", e), this;
          },
          getLeft: function getLeft() {
            return t.get("left");
          },
          setRight: function setRight(e) {
            return t.set("right", e), this;
          },
          getRight: function getRight() {
            return t.get("right");
          },
          getModel: function getModel() {
            return t;
          },
          render: function render() {
            return e.render().$el;
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(17),
        r = n(2),
        a = n.n(r),
        o = n(1),
        s = n.n(o),
        l = n(0),
        c = n(3);
      function d(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function u(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? d(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var h = s.a.$,
        p = s.a.View.extend({
          initialize: function initialize(t) {
            this.opt = t || {}, Object(l.bindAll)(this, "startSort", "onMove", "endMove", "rollback", "updateOffset", "moveDragHelper");
            var e = t || {};
            this.elT = 0, this.elL = 0, this.borderOffset = e.borderOffset || 10;
            var n = e.container;
            this.el = "string" == typeof n ? document.querySelector(n) : n, this.$el = h(this.el), this.containerSel = e.containerSel || "div", this.itemSel = e.itemSel || "div", this.draggable = e.draggable || !0, this.nested = e.nested || 0, this.pfx = e.pfx || "", this.ppfx = e.ppfx || "", this.freezeClass = e.freezeClass || this.pfx + "freezed", this.onStart = e.onStart || "", this.onEndMove = e.onEndMove || "", this.direction = e.direction || "v", this.onMoveClb = e.onMove || "", this.relative = e.relative || 0, this.ignoreViewChildren = e.ignoreViewChildren || 0, this.ignoreModels = e.ignoreModels || 0, this.plh = e.placer || "", this.wmargin = e.wmargin || 0, this.offTop = e.offsetTop || 0, this.offLeft = e.offsetLeft || 0, this.document = e.document || document, this.$document = h(this.document), this.dropContent = null, this.em = e.em || "", this.dragHelper = null, this.canvasRelative = e.canvasRelative || 0, this.selectOnEnd = !e.avoidSelectOnEnd, this.scale = e.scale, this.activeTextModel = null, this.em && this.em.on && (this.em.on("change:canvasOffset", this.updateOffset), this.updateOffset());
          },
          getScale: function getScale() {
            return Object(l.result)(this, scale) || 1;
          },
          getContainerEl: function getContainerEl(t) {
            if (t && (this.el = t), !this.el) {
              var e = this.opt.container;
              this.el = "string" == typeof e ? document.querySelector(e) : e, this.$el = h(this.el);
            }
            return this.el;
          },
          getDocuments: function getDocuments(t) {
            var e = this.em,
              n = t ? t.ownerDocument : e && e.get("Canvas").getBody().ownerDocument,
              i = [document];
            return n && i.push(n), i;
          },
          updateOffset: function updateOffset() {
            var t = this.em.get("canvasOffset") || {};
            this.offTop = t.top, this.offLeft = t.left;
          },
          setDropContent: function setDropContent(t) {
            this.dropModel = null, this.dropContent = t;
          },
          updateTextViewCursorPosition: function updateTextViewCursorPosition(t) {
            var e = this.em.get("Canvas"),
              n = e.getDocument(),
              i = null;
            if (n.caretRangeFromPoint) {
              var r = Object(c.h)(t);
              i = n.caretRangeFromPoint(r.clientX, r.clientY);
            } else t.rangeParent && (i = n.createRange()).setStart(t.rangeParent, t.rangeOffset);
            var a = e.getWindow().getSelection();
            e.getFrameEl().focus(), a.removeAllRanges(), i && a.addRange(i);
          },
          setContentEditable: function setContentEditable(t, e) {
            if (t) {
              var n = t.getEl();
              n.contentEditable != e && (n.contentEditable = e);
            }
          },
          toggleSortCursor: function toggleSortCursor(t) {
            var e = this.em,
              n = e && e.get("Canvas");
            n && (t ? n.startAutoscroll() : n.stopAutoscroll());
          },
          setDragHelper: function setDragHelper(t, e) {
            for (var n = e || "", i = t.cloneNode(1), r = t.getBoundingClientRect(), a = getComputedStyle(t), o = "", s = 0; s < a.length; s++) {
              var l = a[s];
              o += "".concat(l, ":").concat(a.getPropertyValue(l), ";");
            }
            document.body.appendChild(i), i.className += " ".concat(this.pfx, "bdrag"), i.setAttribute("style", o), this.dragHelper = i, i.style.width = "".concat(r.width, "px"), i.style.height = "".concat(r.height, "px"), n && this.moveDragHelper(n), this.em && h(this.em.get("Canvas").getBody().ownerDocument).off("mousemove", this.moveDragHelper).on("mousemove", this.moveDragHelper), h(document).off("mousemove", this.moveDragHelper).on("mousemove", this.moveDragHelper);
          },
          moveDragHelper: function moveDragHelper(t) {
            var e = t.target.ownerDocument;
            if (this.dragHelper && e) {
              var n = t.pageY,
                i = t.pageX,
                r = 0,
                a = 0,
                o = (e.defaultView || e.parentWindow).frameElement,
                s = this.dragHelper.style;
              if (o) {
                var l = o.getBoundingClientRect();
                r = l.top + document.documentElement.scrollTop, a = l.left + document.documentElement.scrollLeft, n = t.clientY, i = t.clientX;
              }
              s.top = n + r + "px", s.left = i + a + "px";
            }
          },
          matches: function matches(t, e, n) {
            return c.r.call(t, e);
          },
          closest: function closest(t, e) {
            if (t) {
              for (var n = t.parentNode; n && 1 === n.nodeType;) {
                if (this.matches(n, e)) return n;
                n = n.parentNode;
              }
              return null;
            }
          },
          offset: function offset(t) {
            var e = t.getBoundingClientRect();
            return {
              top: e.top + document.body.scrollTop,
              left: e.left + document.body.scrollLeft
            };
          },
          createPlaceholder: function createPlaceholder() {
            var t = this.pfx,
              e = document.createElement("div"),
              n = document.createElement("div");
            return e.className = t + "placeholder", e.style.display = "none", e.style["pointer-events"] = "none", n.className = t + "placeholder-int", e.appendChild(n), e;
          },
          startSort: function startSort(t) {
            var e,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              i = this.em,
              r = this.itemSel,
              a = this.containerSel,
              o = this.getContainerEl(n.container),
              s = this.getDocuments(t),
              l = this.onStart,
              d = this.plh;
            this.dropModel = null, this.target = null, this.prevTarget = null, this.moved = 0, t && !this.matches(t, "".concat(r, ", ").concat(a)) && (t = this.closest(t, r)), this.eV = t, d || (d = this.createPlaceholder(), o.appendChild(d), this.plh = d), t && ((e = this.getSourceModel(t)) && e.set && e.set("status", "freezed"), this.srcModel = e), Object(c.u)(o, "mousemove dragover", this.onMove), Object(c.u)(s, "mouseup dragend touchend", this.endMove), Object(c.u)(s, "keydown", this.rollback), l && l({
              target: e,
              parent: e && e.parent(),
              index: e && e.index()
            }), i && i.clearSelection(), this.toggleSortCursor(1), i && i.trigger("sorter:drag:start", t, e);
          },
          getTargetModel: function getTargetModel(t) {
            var e = t || this.target;
            return h(e).data("model");
          },
          getSourceModel: function getSourceModel(t) {
            var e = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              i = n.target,
              r = n.avoidChildren,
              a = void 0 === r ? 1 : r,
              o = this.em,
              s = this.eV,
              l = t || s,
              c = this.dropModel,
              d = this.dropContent,
              p = function p(t) {
                return t && i && t.opt && t.opt.avoidChildren && e.isTextableActive(t, i);
              };
            if (d && o) {
              if (p(c) && (c = null), !c) {
                var g = o.get("DomComponents").getComponents(),
                  f = {
                    avoidChildren: a,
                    avoidStore: 1,
                    avoidUpdateStyle: 1
                  },
                  m = g.add(d, u(u({}, f), {}, {
                    temporary: 1
                  }));
                if (c = (c = g.remove(m, f)) instanceof Array ? c[0] : c, this.dropModel = c, p(c)) return this.getSourceModel(l, {
                  target: i,
                  avoidChildren: 0
                });
              }
              return c;
            }
            return l && h(l).data("model");
          },
          selectTargetModel: function selectTargetModel(t, e) {
            if (!(t instanceof s.a.Collection || e && e === t)) {
              var n = this.targetModel;
              n && n !== this.srcModel && n.set("status", ""), t && t.set && (t.set("status", "selected-parent"), this.targetModel = t);
            }
          },
          onMove: function onMove(t) {
            var e = t,
              n = this.em,
              i = this.onMoveClb,
              r = this.plh;
            this.moved = 1;
            var a = r.style.display;
            a && "none" !== a || (r.style.display = "block");
            var o = this.offset(this.el);
            this.elT = this.wmargin ? Math.abs(o.top) : o.top, this.elL = this.wmargin ? Math.abs(o.left) : o.left;
            var s = t.pageY - this.elT + this.el.scrollTop,
              c = t.pageX - this.elL + this.el.scrollLeft;
            if (this.canvasRelative && n) {
              var d = n.get("Canvas").getMouseRelativeCanvas(t, {
                noScroll: 1
              });
              c = d.x, s = d.y;
            }
            this.rX = c, this.rY = s, this.eventMove = t;
            var u = this.getSourceModel(),
              p = this.dimsFromTarget(t.target, c, s),
              g = this.target,
              f = g && this.getTargetModel(g);
            if (this.selectTargetModel(f, u), f || (r.style.display = "none"), g) {
              this.lastDims = p;
              var m = this.findPosition(p, c, s);
              this.isTextableActive(u, f) ? (this.activeTextModel = f, this.setContentEditable(f, !0), r.style.display = "none", this.lastPos = m, this.updateTextViewCursorPosition(e)) : (this.disableTextable(), this.activeTextModel = null, this.lastPos && this.lastPos.index == m.index && this.lastPos.method == m.method || (this.movePlaceholder(this.plh, p, m, this.prevTargetDim), this.$plh || (this.$plh = h(this.plh)), this.canvasRelative || (this.offTop && this.$plh.css("top", "+=" + this.offTop + "px"), this.offLeft && this.$plh.css("left", "+=" + this.offLeft + "px")), this.lastPos = m)), Object(l.isFunction)(i) && i({
                event: t,
                target: u,
                parent: f,
                index: m.index + ("after" == m.method ? 1 : 0)
              }), n && n.trigger("sorter:drag", {
                target: g,
                targetModel: f,
                sourceModel: u,
                dims: p,
                pos: m,
                x: c,
                y: s
              });
            }
          },
          isTextableActive: function isTextableActive(t, e) {
            return t && t.get && t.get("textable") && e && e.is("text");
          },
          disableTextable: function disableTextable() {
            var t = this.activeTextModel;
            t && t.getView().disableEditing();
          },
          isInFlow: function isInFlow(t, e) {
            if (!t) return !1;
            e = e || document.body;
            var n = t;
            return n.offsetHeight, !!this.styleInFlow(n, e);
          },
          styleInFlow: function styleInFlow(t, e) {
            if (!Object(c.q)(t)) {
              var n = t.style || {},
                i = h(t),
                r = e && h(e);
              if (!(n.overflow && "visible" !== n.overflow || "none" !== i.css("float") || r && "flex" == r.css("display") && "column" !== r.css("flex-direction"))) {
                switch (n.position) {
                  case "static":
                  case "relative":
                  case "":
                    break;
                  default:
                    return;
                }
                switch (t.tagName) {
                  case "TR":
                  case "TBODY":
                  case "THEAD":
                  case "TFOOT":
                    return !0;
                }
                switch (i.css("display")) {
                  case "block":
                  case "list-item":
                  case "table":
                  case "flex":
                    return !0;
                }
              }
            }
          },
          validTarget: function validTarget(t, e) {
            var n = this.getTargetModel(t),
              i = this.getSourceModel(e, {
                target: n
              }),
              r = {
                valid: !0,
                src: e = i && i.view && i.view.el,
                srcModel: i,
                trg: t = n && n.view && n.view.el,
                trgModel: n
              };
            if (!e || !t) return r.valid = !1, r;
            var a = i.get("draggable");
            a = a instanceof Array ? a.join(", ") : a, r.dragInfo = a, a = Object(l.isString)(a) ? this.matches(t, a) : a, r.draggable = a;
            var o = n.get("droppable");
            return o = (o = o instanceof s.a.Collection ? 1 : o) instanceof Array ? o.join(", ") : o, r.dropInfo = o, o = Object(l.isString)(o) ? this.matches(e, o) : o, o = a && this.isTextableActive(i, n) ? 1 : o, r.droppable = o, o && a || (r.valid = !1), r;
          },
          dimsFromTarget: function dimsFromTarget(t, e, n) {
            var i = this.em,
              r = [];
            if (!t) return r;
            if (this.matches(t, "".concat(this.itemSel, ", ").concat(this.containerSel)) || (t = this.closest(t, this.itemSel)), this.draggable instanceof Array && (t = this.closest(t, this.draggable.join(","))), !t) return r;
            if (this.prevTarget && this.prevTarget != t && (this.prevTarget = null), !this.prevTarget) {
              this.targetP = this.closest(t, this.containerSel);
              var a = this.validTarget(t);
              if (i && i.trigger("sorter:drag:validation", a), !a.valid && this.targetP) return this.dimsFromTarget(this.targetP, e, n);
              this.prevTarget = t, this.prevTargetDim = this.getDim(t), this.cacheDimsP = this.getChildrenDim(this.targetP), this.cacheDims = this.getChildrenDim(t);
            }
            if (this.prevTarget == t && (r = this.cacheDims), this.target = this.prevTarget, this.nearBorders(this.prevTargetDim, e, n) || !this.nested && !this.cacheDims.length) {
              var o = this.targetP;
              o && this.validTarget(o).valid && (r = this.cacheDimsP, this.target = o);
            }
            return this.lastPos = null, r;
          },
          getTargetFromEl: function getTargetFromEl(t) {
            var e,
              n = t,
              i = this.targetPrev,
              r = this.em,
              a = this.containerSel,
              o = this.itemSel;
            if (this.matches(n, "".concat(o, ", ").concat(a)) || (n = this.closest(n, o)), this.draggable instanceof Array && (n = this.closest(n, this.draggable.join(","))), i && i != n && (this.targetPrev = ""), !this.targetPrev) {
              e = this.closest(n, a);
              var s = this.validTarget(n);
              if (r && r.trigger("sorter:drag:validation", s), !s.valid && e) return this.getTargetFromEl(e);
              this.targetPrev = n;
            }
            return this.nearElBorders(n) && (e = this.closest(n, a)) && this.validTarget(e).valid && (n = e), n;
          },
          nearElBorders: function nearElBorders(t) {
            var e = t.getBoundingClientRect(),
              n = t.ownerDocument.body,
              i = this.getCurrentPos(),
              r = i.x,
              a = i.y,
              o = e.top + n.scrollTop,
              s = e.left + n.scrollLeft,
              l = e.width,
              c = e.height;
            if (a < o + 10 || a > o + c - 10 || r < s + 10 || r > s + l - 10) return 1;
          },
          getCurrentPos: function getCurrentPos() {
            var t = this.eventMove;
            return {
              x: t.pageX || 0,
              y: t.pageY || 0
            };
          },
          getDim: function getDim(t) {
            var e,
              n,
              i,
              r,
              a = this.em;
            if (this.canvasRelative && a) {
              var o = a.get("Canvas"),
                s = o.getElementPos(t, {
                  noScroll: 1
                }),
                l = o.getElementOffsets(t);
              e = s.top - l.marginTop, n = s.left - l.marginLeft, i = s.height + l.marginTop + l.marginBottom, r = s.width + l.marginLeft + l.marginRight;
            } else {
              var c = this.offset(t);
              e = this.relative ? t.offsetTop : c.top - (this.wmargin ? -1 : 1) * this.elT, n = this.relative ? t.offsetLeft : c.left - (this.wmargin ? -1 : 1) * this.elL, i = t.offsetHeight, r = t.offsetWidth;
            }
            return [e, n, i, r];
          },
          getChildrenDim: function getChildrenDim(t) {
            var e = this,
              n = [];
            if (!t) return n;
            var i = this.getTargetModel(t);
            if (i && i.view && !this.ignoreViewChildren) {
              var r = i.getCurrentView ? i.getCurrentView() : i.view;
              t = r.getChildrenContainer();
            }
            return Object(l.each)(t.children, function (i, r) {
              var a = Object(c.g)(i, h),
                o = a && a.index ? a.index() : r;
              if (Object(c.q)(i) || e.matches(i, e.itemSel)) {
                var s = e.getDim(i),
                  l = e.direction;
                l = "v" == l || "h" != l && e.isInFlow(i, t), s.push(l, i, o), n.push(s);
              }
            }), n;
          },
          nearBorders: function nearBorders(t, e, n) {
            var i = 0,
              r = this.borderOffset,
              a = e || 0,
              o = n || 0,
              s = t[0],
              l = t[1],
              c = t[2],
              d = t[3];
            return (s + r > o || o > s + c - r || l + r > a || a > l + d - r) && (i = 1), !!i;
          },
          findPosition: function findPosition(t, e, n) {
            for (var i = {
                index: 0,
                indexEl: 0,
                method: "before"
              }, r = 0, a = 0, o = 0, s = 0, l = 0, c = 0, d = 0, u = 0, h = 0, p = t.length; h < p; h++) if (o = (u = t[h])[1] + u[3], d = u[0] + u[2], l = u[1] + u[3] / 2, c = u[0] + u[2] / 2, !(a && u[1] > a || s && c >= s || r && o < r)) if (i.index = h, i.indexEl = u[6], u[4]) {
              if (n < c) {
                i.method = "before";
                break;
              }
              i.method = "after";
            } else n < d && (s = d), e < l ? (a = l, i.method = "before") : (r = l, i.method = "after");
            return i;
          },
          movePlaceholder: function movePlaceholder(t, e, n, i) {
            var r = 0,
              a = 0,
              o = 0,
              s = 0,
              l = "px",
              c = n.method,
              d = e[n.index];
            if (t.classList.remove("vertical"), t.classList.add("horizontal"), d) d[4] ? (o = d[3] + l, s = "auto", r = "before" == c ? d[0] - 0 : d[0] + d[2] - 0, a = d[1]) : (o = "auto", s = d[2] - 0 + l, r = d[0] + 0, a = "before" == c ? d[1] - 0 : d[1] + d[3] - 0, t.classList.remove("horizontal"), t.classList.add("vertical"));else {
              if (!this.nested) return void (t.style.display = "none");
              i && (r = i[0] + 5, a = i[1] + 5, o = parseInt(i[3]) - 10 + l, s = "auto");
            }
            t.style.top = r + l, t.style.left = a + l, o && (t.style.width = o), s && (t.style.height = s);
          },
          endMove: function endMove(t) {
            var e,
              n = this,
              i = this.eV,
              r = [],
              a = this.getDocuments(),
              o = this.getContainerEl(),
              s = this.onEndMove,
              d = this.target,
              h = this.lastPos;
            if (Object(c.t)(o, "mousemove dragover", this.onMove), Object(c.t)(a, "mouseup dragend touchend", this.endMove), Object(c.t)(a, "keydown", this.rollback), this.plh.style.display = "none", i && (e = this.getSourceModel(), this.selectOnEnd && e && e.set && (e.set("status", ""), e.set("status", "selected"))), this.moved) {
              var p = this.toMove;
              (Object(l.isArray)(p) ? p : p ? [p] : [i]).forEach(function (t) {
                r.push(n.move(d, t, h));
              });
            }
            this.plh && (this.plh.style.display = "none");
            var g = this.dragHelper;
            if (g && (g.parentNode.removeChild(g), this.dragHelper = null), this.disableTextable(), this.selectTargetModel(), this.toggleSortCursor(), this.toMove = null, this.eventMove = 0, this.dropModel = null, Object(l.isFunction)(s)) {
              var f = {
                target: e,
                parent: e && e.parent(),
                index: e && e.index()
              };
              r.length ? r.forEach(function (t) {
                return s(t, n, f);
              }) : s(null, this, u(u({}, f), {}, {
                cancelled: 1
              }));
            }
          },
          move: function move(t, e, n) {
            var i = this.em,
              r = this.activeTextModel,
              a = this.dropContent,
              o = Object(c.e)(e);
            i && i.trigger("component:dragEnd:before", t, o, n);
            var l,
              d,
              p,
              g = [],
              f = n.indexEl,
              m = this.validTarget(t, o),
              v = h(t).data("collection"),
              b = m.srcModel,
              y = m.droppable,
              w = m.draggable,
              x = m.dropInfo,
              j = m.dragInfo,
              C = m.trgModel;
            y = C instanceof s.a.Collection ? 1 : y;
            var M = this.isTextableActive(b, C);
            if (v && y && w) {
              var k = {
                at: f = "after" === n.method ? f + 1 : f,
                noIncrement: 1
              };
              if (a ? (l = a, k.silent = !1, k.avoidUpdateStyle = 1) : (k.temporary = 1, d = v.add({}, u({}, k)), b.collection && (l = b.collection.remove(b, {
                temporary: 1
              }))), M) {
                var O = r.getView();
                r.trigger("active");
                var T = O.activeRte,
                  S = b.getEl();
                delete b.opt.temporary, b.getView().render(), S.setAttribute("data-gjs-textable", "true");
                var N = S.outerHTML;
                T.insertHTML && T.insertHTML(N);
              } else p = v.add(l, k);
              a ? this.dropContent = null : v.remove(d), this.prevTarget = null;
            } else v || g.push("Target collection not found"), y || g.push("Target is not droppable, accepts [".concat(x, "]")), w || g.push("Component not draggable, acceptable by [".concat(j, "]")), console.warn("Invalid target position: " + g.join(", "));
            return i && i.trigger("component:dragEnd", v, l, g), i && i.trigger("sorter:drag:end", {
              targetCollection: v,
              modelToDrop: l,
              warns: g,
              validResult: m,
              dst: t,
              srcEl: o
            }), p;
          },
          rollback: function rollback(t) {
            Object(c.t)(this.getDocuments(), "keydown", this.rollback), 27 == (t.which || t.keyCode) && (this.moved = 0, this.endMove());
          }
        }),
        g = n(15),
        f = n.n(g),
        m = n(16),
        v = n.n(m);
      function b(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function y(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? b(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : b(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var w = {
          mousePosFetcher: null,
          updateTarget: null,
          ratioDefault: 0,
          posFetcher: null,
          onStart: null,
          onMove: null,
          onEnd: null,
          onUpdateContainer: function onUpdateContainer() {},
          step: 1,
          minDim: 32,
          maxDim: "",
          unitHeight: "px",
          unitWidth: "px",
          keyHeight: "height",
          keyWidth: "width",
          currentUnit: 1,
          silentFrames: 0,
          avoidContainerUpdate: 0,
          keepAutoHeight: !1,
          keepAutoWidth: !1,
          autoHeight: !1,
          autoWidth: !1,
          tl: 1,
          tc: 1,
          tr: 1,
          cl: 1,
          cr: 1,
          bl: 1,
          bc: 1,
          br: 1
        },
        x = function x(t, e) {
          var n = e || window,
            i = t.getBoundingClientRect();
          return {
            left: i.left + n.pageXOffset,
            top: i.top + n.pageYOffset,
            width: i.width,
            height: i.height
          };
        },
        j = function () {
          function t() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return f()(this, t), this.setOptions(e), Object(l.bindAll)(this, "handleKeyDown", "handleMouseDown", "move", "stop"), this;
          }
          return v()(t, [{
            key: "getConfig",
            value: function value() {
              return this.opts;
            }
          }, {
            key: "setOptions",
            value: function value() {
              var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
              this.opts = Object(l.defaults)(t, w), this.setup();
            }
          }, {
            key: "setup",
            value: function value() {
              var t = this.opts,
                e = t.prefix || "",
                n = t.appendTo || document.body,
                i = this.container;
              for (i || ((i = document.createElement("div")).className = "".concat(e, "resizer-c"), n.appendChild(i), this.container = i); i.firstChild;) i.removeChild(i.firstChild);
              var r = {};
              for (var a in ["tl", "tc", "tr", "cl", "cr", "bl", "bc", "br"].forEach(function (e) {
                return r[e] = t[e] ? function (t, e) {
                  var n = e.prefix || "",
                    i = document.createElement("i");
                  return i.className = n + "resizer-h " + n + "resizer-h-" + t, i.setAttribute("data-" + n + "handler", t), i;
                }(e, t) : "";
              }), r) {
                var o = r[a];
                o && i.appendChild(o);
              }
              this.handlers = r, this.mousePosFetcher = t.mousePosFetcher, this.updateTarget = t.updateTarget, this.posFetcher = t.posFetcher, this.onStart = t.onStart, this.onMove = t.onMove, this.onEnd = t.onEnd, this.onUpdateContainer = t.onUpdateContainer;
            }
          }, {
            key: "toggleFrames",
            value: function value(t) {
              if (this.opts.silentFrames) {
                var e = document.querySelectorAll("iframe");
                Object(l.each)(e, function (e) {
                  return e.style.pointerEvents = t ? "none" : "";
                });
              }
            }
          }, {
            key: "isHandler",
            value: function value(t) {
              var e = this.handlers;
              for (var n in e) if (e[n] === t) return !0;
              return !1;
            }
          }, {
            key: "getFocusedEl",
            value: function value() {
              return this.el;
            }
          }, {
            key: "getDocumentEl",
            value: function value() {
              return [this.el.ownerDocument, document];
            }
          }, {
            key: "getElementPos",
            value: function value(t) {
              var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                n = this.posFetcher || "";
              return n ? n(t, e) : x(t);
            }
          }, {
            key: "focus",
            value: function value(t) {
              t && t === this.el || (this.el = t, this.updateContainer({
                forceShow: 1
              }), Object(c.u)(this.getDocumentEl(), "mousedown", this.handleMouseDown));
            }
          }, {
            key: "blur",
            value: function value() {
              this.container.style.display = "none", this.el && (Object(c.t)(this.getDocumentEl(), "mousedown", this.handleMouseDown), this.el = null);
            }
          }, {
            key: "start",
            value: function value(t) {
              if (0 === t.button) {
                t.preventDefault(), t.stopPropagation();
                var e = this.el,
                  n = this.opts || {},
                  i = "data-" + n.prefix + "handler",
                  r = this.getElementPos(e, {
                    target: "el"
                  });
                this.handlerAttr = t.target.getAttribute(i), this.clickedHandler = t.target, this.startDim = {
                  t: r.top,
                  l: r.left,
                  w: r.width,
                  h: r.height
                }, this.rectDim = {
                  t: r.top,
                  l: r.left,
                  w: r.width,
                  h: r.height
                }, this.startPos = {
                  x: t.clientX,
                  y: t.clientY
                };
                var a = this.getDocumentEl();
                Object(c.u)(a, "mousemove", this.move), Object(c.u)(a, "keydown", this.handleKeyDown), Object(c.u)(a, "mouseup", this.stop), Object(l.isFunction)(this.onStart) && this.onStart(t, {
                  docs: a,
                  config: n,
                  el: e,
                  resizer: this
                }), this.toggleFrames(1), this.move(t);
              }
            }
          }, {
            key: "move",
            value: function value(t) {
              var e = this.onMove,
                n = this.mousePosFetcher,
                i = n ? n(t) : {
                  x: t.clientX,
                  y: t.clientY
                };
              this.currentPos = i, this.delta = {
                x: i.x - this.startPos.x,
                y: i.y - this.startPos.y
              }, this.keys = {
                shift: t.shiftKey,
                ctrl: t.ctrlKey,
                alt: t.altKey
              }, this.rectDim = this.calc(this), this.updateRect(0), e && e(t), 0 === t.which && this.stop(t);
            }
          }, {
            key: "stop",
            value: function value(t) {
              var e = this.opts,
                n = this.getDocumentEl();
              Object(c.t)(n, "mousemove", this.move), Object(c.t)(n, "keydown", this.handleKeyDown), Object(c.t)(n, "mouseup", this.stop), this.updateRect(1), this.toggleFrames(), Object(l.isFunction)(this.onEnd) && this.onEnd(t, {
                docs: n,
                config: e
              });
            }
          }, {
            key: "updateRect",
            value: function value(t) {
              var e = this.el,
                n = this.opts,
                i = this.rectDim,
                r = this.updateTarget,
                a = this.getSelectedHandler(),
                o = n.unitHeight,
                s = n.unitWidth,
                c = n.keyWidth,
                d = n.keyHeight;
              if (Object(l.isFunction)(r)) r(e, i, {
                store: t,
                selectedHandler: a,
                resizer: this,
                config: n
              });else {
                var u = e.style;
                u[c] = i.w + s, u[d] = i.h + o;
              }
              this.updateContainer();
            }
          }, {
            key: "updateContainer",
            value: function value() {
              var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                e = this.opts,
                n = this.container,
                i = this.el,
                r = n.style;
              !e.avoidContainerUpdate && i && t.forceShow && (r.display = "block"), this.onUpdateContainer({
                el: n,
                resizer: this,
                opts: y(y({}, e), t)
              });
            }
          }, {
            key: "getSelectedHandler",
            value: function value() {
              var t = this.handlers;
              if (this.selectedHandler) for (var e in t) if (t[e] === this.selectedHandler) return e;
            }
          }, {
            key: "handleKeyDown",
            value: function value(t) {
              27 === t.keyCode && (this.rectDim = this.startDim, this.stop(t));
            }
          }, {
            key: "handleMouseDown",
            value: function value(t) {
              var e = t.target;
              this.isHandler(e) ? (this.selectedHandler = e, this.start(t)) : e !== this.el && (this.selectedHandler = "", this.blur());
            }
          }, {
            key: "calc",
            value: function value(t) {
              var e,
                n = this.opts || {},
                i = n.step,
                r = this.startDim,
                a = n.minDim,
                o = n.maxDim,
                s = t.delta.x,
                l = t.delta.y,
                d = r.w,
                u = r.h,
                h = {
                  t: 0,
                  l: 0,
                  w: d,
                  h: u
                };
              if (t) {
                var p = t.handlerAttr;
                ~p.indexOf("r") && (e = Object(c.s)(d + s * i, i), e = Math.max(a, e), o && (e = Math.min(o, e)), h.w = e), ~p.indexOf("b") && (e = Object(c.s)(u + l * i, i), e = Math.max(a, e), o && (e = Math.min(o, e)), h.h = e), ~p.indexOf("l") && (e = Object(c.s)(d - s * i, i), e = Math.max(a, e), o && (e = Math.min(o, e)), h.w = e), ~p.indexOf("t") && (e = Object(c.s)(u - l * i, i), e = Math.max(a, e), o && (e = Math.min(o, e)), h.h = e);
                var g = n.ratioDefault ? !t.keys.shift : t.keys.shift;
                if (p.indexOf("c") < 0 && g) {
                  var f = r.w / r.h;
                  h.w / h.h > f ? h.h = Math.round(h.w / f) : h.w = Math.round(h.h * f);
                }
                return ~p.indexOf("l") && (h.l = r.w - h.w), ~p.indexOf("t") && (h.t = r.h - h.h), h;
              }
            }
          }]), t;
        }(),
        C = {
          init: function init(t) {
            return new j(t);
          }
        };
      e.default = function () {
        return {
          name: "Utils",
          init: function init() {
            return this;
          },
          Sorter: p,
          Resizer: C,
          Dragger: i.a
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(2),
        r = n.n(i),
        a = n(8),
        o = n.n(a),
        s = n(0),
        l = {
          placeholder: "eg. Text here"
        },
        c = {
          locale: "en",
          localeFallback: "en",
          detectLocale: 1,
          debug: 0,
          messages: {
            en: {
              assetManager: {
                addButton: "Add image",
                inputPlh: "http://path/to/the/image.jpg",
                modalTitle: "Select Image",
                uploadTitle: "Drop files here or click to upload"
              },
              blockManager: {
                labels: {},
                categories: {}
              },
              domComponents: {
                names: {
                  "": "Box",
                  wrapper: "Body",
                  text: "Text",
                  comment: "Comment",
                  image: "Image",
                  video: "Video",
                  audio: "Audio",
                  label: "Label",
                  link: "Link",
                  map: "Map",
                  tfoot: "Table foot",
                  tbody: "Table body",
                  thead: "Table head",
                  table: "Table",
                  row: "Table row",
                  cell: "Table cell"
                }
              },
              deviceManager: {
                device: "Device",
                devices: {
                  desktop: "Desktop",
                  tablet: "Tablet",
                  mobileLandscape: "Mobile Landscape",
                  mobilePortrait: "Mobile Portrait"
                }
              },
              panels: {
                buttons: {
                  titles: {
                    preview: "Preview",
                    fullscreen: "Fullscreen",
                    "sw-visibility": "View components",
                    "export-template": "View code",
                    "open-sm": "Open Style Manager",
                    "open-tm": "Settings",
                    "open-layers": "Open Layer Manager",
                    "open-blocks": "Open Blocks"
                  }
                }
              },
              selectorManager: {
                label: "Classes",
                selected: "Selected",
                emptyState: "- State -",
                states: {
                  hover: "Hover",
                  active: "Click",
                  "nth-of-type(2n)": "Even/Odd"
                }
              },
              styleManager: {
                empty: "Select an element before using Style Manager",
                layer: "Layer",
                fileButton: "Images",
                sectors: {
                  general: "General",
                  layout: "Layout",
                  typography: "Typography",
                  decorations: "Decorations",
                  extra: "Extra",
                  flex: "Flex",
                  dimension: "Dimension"
                },
                properties: {}
              },
              traitManager: {
                empty: "Select an element before using Trait Manager",
                label: "Component settings",
                traits: {
                  labels: {},
                  attributes: {
                    id: l,
                    alt: l,
                    title: l,
                    href: {
                      placeholder: "eg. https://google.com"
                    }
                  },
                  options: {
                    target: {
                      false: "This window",
                      _blank: "New window"
                    }
                  }
                }
              }
            }
          }
        };
      function d(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function u(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? d(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var h = function h(t) {
        return !Array.isArray(t) && null !== t && "object" === o()(t);
      };
      e.default = function () {
        return {
          name: "I18n",
          config: c,
          init: function init() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return this.config = u(u(u({}, c), t), {}, {
              messages: u(u({}, c.messages), t.messages || {})
            }), this.config.detectLocale && (this.config.locale = this._localLang()), this.em = t.em, this;
          },
          getConfig: function getConfig() {
            return this.config;
          },
          setLocale: function setLocale(t) {
            var e = this.em,
              n = this.config,
              i = {
                value: t,
                valuePrev: n.locale
              };
            return e && e.trigger("i18n:locale", i), n.locale = t, this;
          },
          getLocale: function getLocale() {
            return this.config.locale;
          },
          getMessages: function getMessages(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = this.config.messages;
            return t && !n[t] && this._debug("'".concat(t, "' i18n lang not found"), e), t ? n[t] : n;
          },
          setMessages: function setMessages(t) {
            var e = this.em;
            return this.config.messages = t, e && e.trigger("i18n:update", t), this;
          },
          addMessages: function addMessages(t) {
            var e = this.em,
              n = this.config.messages;
            return e && e.trigger("i18n:add", t), this.setMessages(function t() {
              for (var e = u({}, arguments.length <= 0 ? void 0 : arguments[0]), n = 1; n < arguments.length; n++) {
                var i = u({}, n < 0 || arguments.length <= n ? void 0 : arguments[n]);
                for (var r in i) {
                  var a = e[r],
                    o = i[r];
                  h(a) && h(o) ? e[r] = t(a, o) : e[r] = o;
                }
              }
              return e;
            }(n, t)), this;
          },
          t: function t(_t2) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = this.config,
              i = e.params || {},
              r = e.l || this.getLocale(),
              a = e.lFlb || n.localeFallback,
              o = this._getMsg(_t2, r, e);
            return o || (o = this._getMsg(_t2, a, e)), !o && this._debug("'".concat(_t2, "' i18n key not found in '").concat(r, "' lang"), e), o && Object(s.isString)(o) ? this._addParams(o, i) : o;
          },
          _localLang: function _localLang() {
            var t = window.navigator || {},
              e = t.language || t.userLanguage;
            return e ? e.split("-")[0] : "en";
          },
          _addParams: function _addParams(t, e) {
            var n = new RegExp("{([\\w\\d-]*)}", "g");
            return t.replace(n, function (t, n) {
              return e[n] || "";
            }).trim();
          },
          _getMsg: function _getMsg(t, e) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              i = this.getMessages(e, n);
            if (i) {
              var r = i[t];
              return !r && t.indexOf(".") > 0 && (r = t.split(".").reduce(function (t, e) {
                if (!Object(s.isUndefined)(t)) return t[e];
              }, i)), r;
            }
          },
          _debug: function _debug(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = this.em,
              i = this.config;
            (e.debug || i.debug) && n && n.logWarning(t);
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(9),
        r = n.n(i),
        a = n(2),
        o = n.n(a),
        s = n(15),
        l = n.n(s),
        c = n(16),
        d = n.n(c),
        u = n(3);
      function h(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function p(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? h(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var g = 1,
        f = 0,
        m = -1,
        v = function v(t) {
          var e = t.selection().anchorNode,
            n = e && e.parentNode,
            i = e && e.nextSibling;
          return n && "A" == n.nodeName || i && "A" == i.nodeName;
        },
        b = {
          bold: {
            name: "bold",
            icon: "<b>B</b>",
            attributes: {
              title: "Bold"
            },
            result: function result(t) {
              return t.exec("bold");
            }
          },
          italic: {
            name: "italic",
            icon: "<i>I</i>",
            attributes: {
              title: "Italic"
            },
            result: function result(t) {
              return t.exec("italic");
            }
          },
          underline: {
            name: "underline",
            icon: "<u>U</u>",
            attributes: {
              title: "Underline"
            },
            result: function result(t) {
              return t.exec("underline");
            }
          },
          strikethrough: {
            name: "strikethrough",
            icon: "<s>S</s>",
            attributes: {
              title: "Strike-through"
            },
            result: function result(t) {
              return t.insertHTML("<s>".concat(t.selection(), "</s>"));
            }
          },
          link: {
            icon: '<span style="transform:rotate(45deg)">&supdsub;</span>',
            name: "link",
            attributes: {
              style: "font-size:1.4rem;padding:0 4px 2px;",
              title: "Link"
            },
            state: function state(t, e) {
              return t && t.selection() && v(t) ? g : f;
            },
            result: function result(t) {
              v(t) ? t.exec("unlink") : t.insertHTML('<a class="link" href="">'.concat(t.selection(), "</a>"));
            }
          }
        },
        y = function () {
          function t() {
            var e = this,
              n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            l()(this, t);
            var i = n.el;
            if (i._rte) return i._rte;
            i._rte = this, this.setEl(i), this.updateActiveActions = this.updateActiveActions.bind(this);
            var r = n.actions || [];
            r.forEach(function (t, e) {
              "string" == typeof t ? t = b[t] : b[t.name] && (t = p(p({}, b[t.name]), t)), r[e] = t;
            });
            var a = r.length ? r : Object.keys(b).map(function (t) {
              return b[t];
            });
            n.classes = p(p({}, {
              actionbar: "actionbar",
              button: "action",
              active: "active",
              disabled: "disabled",
              inactive: "inactive"
            }), n.classes);
            var o = n.classes,
              s = n.actionbar;
            if (this.actionbar = s, this.settings = n, this.classes = o, this.actions = a, !s) {
              var c = n.actionbarContainer;
              (s = document.createElement("div")).className = o.actionbar, c.appendChild(s), this.actionbar = s, a.forEach(function (t) {
                return e.addAction(t);
              });
            }
            return n.styleWithCSS && this.exec("styleWithCSS"), this.syncActions(), this;
          }
          return d()(t, [{
            key: "destroy",
            value: function value() {
              this.el = 0, this.doc = 0, this.actionbar = 0, this.settings = {}, this.classes = {}, this.actions = [];
            }
          }, {
            key: "setEl",
            value: function value(t) {
              this.el = t, this.doc = t.ownerDocument;
            }
          }, {
            key: "updateActiveActions",
            value: function value() {
              var t = this;
              this.getActions().forEach(function (e) {
                var n = e.btn,
                  i = e.update,
                  r = p({}, t.classes),
                  a = r.active,
                  o = r.inactive,
                  s = r.disabled,
                  l = e.state,
                  c = e.name,
                  d = t.doc;
                if (n.className = n.className.replace(a, "").trim(), n.className = n.className.replace(o, "").trim(), n.className = n.className.replace(s, "").trim(), l) switch (l(t, d)) {
                  case g:
                    n.className += " ".concat(a);
                    break;
                  case f:
                    n.className += " ".concat(o);
                    break;
                  case m:
                    n.className += " ".concat(s);
                } else d.queryCommandSupported(c) && d.queryCommandState(c) && (n.className += " ".concat(a));
                i && i(t, e);
              });
            }
          }, {
            key: "enable",
            value: function value() {
              return this.enabled || (this.actionbarEl().style.display = "", this.el.contentEditable = !0, Object(u.u)(this.el, "mouseup keyup", this.updateActiveActions), this.syncActions(), this.updateActiveActions(), this.el.focus(), this.enabled = 1), this;
            }
          }, {
            key: "disable",
            value: function value() {
              return this.actionbarEl().style.display = "none", this.el.contentEditable = !1, Object(u.t)(this.el, "mouseup keyup", this.updateActiveActions), this.enabled = 0, this;
            }
          }, {
            key: "syncActions",
            value: function value() {
              var t = this;
              this.getActions().forEach(function (e) {
                if (t.settings.actionbar && (!e.state || e.state && e.state(t, t.doc) >= 0)) {
                  var n = e.event || "click";
                  e.btn["on".concat(n)] = function (n) {
                    e.result(t, e), t.updateActiveActions();
                  };
                }
              });
            }
          }, {
            key: "addAction",
            value: function value(t) {
              var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                n = e.sync,
                i = document.createElement("span"),
                r = t.icon,
                a = t.attributes || {};
              for (var o in i.className = this.classes.button, t.btn = i, a) i.setAttribute(o, a[o]);
              "string" == typeof r ? i.innerHTML = r : i.appendChild(r), this.actionbarEl().appendChild(i), n && (this.actions.push(t), this.syncActions());
            }
          }, {
            key: "getActions",
            value: function value() {
              return this.actions;
            }
          }, {
            key: "selection",
            value: function value() {
              return this.doc.getSelection();
            }
          }, {
            key: "exec",
            value: function value(t) {
              var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
              this.doc.execCommand(t, !1, e);
            }
          }, {
            key: "actionbarEl",
            value: function value() {
              return this.actionbar;
            }
          }, {
            key: "insertHTML",
            value: function value(t) {
              var e = this.doc,
                n = e.getSelection();
              if (n && n.rangeCount) {
                var i = e.createElement("div"),
                  r = n.getRangeAt(0);
                r.deleteContents(), i.innerHTML = t, Array.prototype.slice.call(i.childNodes).forEach(function (t) {
                  r.insertNode(t);
                }), n.removeAllRanges(), n.addRange(r), this.el.focus();
              }
            }
          }]), t;
        }(),
        w = {
          stylePrefix: "rte-",
          adjustToolbar: 1,
          actions: ["bold", "italic", "underline", "strikethrough", "link"]
        };
      function x(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function j(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? x(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : x(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.default = function () {
        var t,
          e,
          n,
          i = {},
          a = function a() {
            var e = t.style;
            e.top = "-1000px", e.left = "-1000px", e.display = "none";
          };
        return {
          customRte: null,
          name: "RichTextEditor",
          getConfig: function getConfig() {
            return i;
          },
          init: function init() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              r = (i = j(j({}, w), e)).pStylePrefix;
            return r && (i.stylePrefix = r + i.stylePrefix), this.pfx = i.stylePrefix, i.actions, (t = document.createElement("div")).className = "".concat(r, "rte-toolbar ").concat(r, "one-bg"), n = this.initRte(document.createElement("div")), Object(u.u)(t, "mousedown", function (t) {
              return t.stopPropagation();
            }), this;
          },
          destroy: function destroy() {
            var e = this.customRte;
            n && n.destroy(), e && e.destroy && e.destroy(), t = 0, n = 0, this.actionbar = 0, this.actions = 0;
          },
          postRender: function postRender(e) {
            var n = e.model.get("Canvas");
            t.style.pointerEvents = "all", a(), n.getToolsEl().appendChild(t);
          },
          initRte: function initRte(e) {
            var a = this.pfx,
              o = t,
              s = this.actionbar,
              l = this.actions || r()(i.actions),
              c = {
                actionbar: "".concat(a, "actionbar"),
                button: "".concat(a, "action"),
                active: "".concat(a, "active"),
                inactive: "".concat(a, "inactive"),
                disabled: "".concat(a, "disabled")
              },
              d = new y({
                el: e,
                classes: c,
                actions: l,
                actionbar: s,
                actionbarContainer: o
              });
            return n && n.setEl(e), d.actionbar && (this.actionbar = d.actionbar), d.actions && (this.actions = d.actions), d;
          },
          add: function add(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            e.name = t, n.addAction(e, {
              sync: 1
            });
          },
          get: function get(t) {
            var e;
            return n.getActions().forEach(function (n) {
              n.name == t && (e = n);
            }), e;
          },
          getAll: function getAll() {
            return n.getActions();
          },
          remove: function remove(t) {
            var e = this.getAll(),
              n = this.get(t);
            if (n) {
              var i = n.btn,
                r = e.indexOf(n);
              i.parentNode.removeChild(i), e.splice(r, 1);
            }
            return n;
          },
          getToolbarEl: function getToolbarEl() {
            return t;
          },
          updatePosition: function updatePosition() {
            var n = i.em.get("Canvas"),
              r = t.style,
              a = n.getTargetToElementFixed(e, t, {
                event: "rteToolbarPosUpdate"
              });
            r.top = a.top + "px", r.left = "0px";
          },
          enable: function enable(n, r) {
            e = n.el;
            var a = i.em.get("Canvas"),
              o = i.em,
              s = n.getChildrenContainer(),
              l = this.customRte;
            if (a.getElementPos(e), t.style.display = "", r = l ? l.enable(s, r) : this.initRte(s).enable(), o) {
              setTimeout(this.updatePosition.bind(this), 0);
              var c = "change:canvasOffset canvasScroll frame:scroll component:update";
              o.off(c, this.updatePosition, this), o.on(c, this.updatePosition, this), o.trigger("rte:enable", n, r);
            }
            return r;
          },
          disable: function disable(t, e) {
            var n = i.em,
              r = this.customRte,
              o = t.getChildrenContainer();
            r ? r.disable(o, e) : e && e.disable(), a(), n && n.trigger("rte:disable", t, e);
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(2),
        r = n.n(i),
        a = n(0),
        o = {
          stylePrefix: "css-",
          staticRules: "",
          rules: []
        },
        s = n(34),
        l = n(33),
        c = n(37),
        d = n(12),
        u = n(10);
      function h(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function p(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? h(Object(n), !0).forEach(function (e) {
            r()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.default = function () {
        var t,
          e,
          n,
          i = {};
        return {
          Selectors: d.a,
          name: "CssComposer",
          getConfig: function getConfig() {
            return i;
          },
          storageKey: function storageKey() {
            var t = [],
              e = i.stm && i.stm.getConfig() || {};
            return e.storeCss && t.push("css"), e.storeStyles && t.push("styles"), t;
          },
          init: function init(r) {
            for (var a in i = r || {}, o) a in i || (i[a] = o[a]);
            var s = i.pStylePrefix;
            s && (i.stylePrefix = s + i.stylePrefix);
            var d = i.em && i.em.config.style || "";
            return i.rules = d || i.rules, t = i.em, e = new l.a([], i), n = new c.a({
              collection: e,
              config: i
            }), this;
          },
          onLoad: function onLoad() {
            e.add(i.rules);
          },
          postLoad: function postLoad(t) {
            var e = this,
              n = "add remove",
              i = this.getAll(),
              r = t.get("UndoManager");
            r && r.add(i), t.stopListening(i, n, this.handleChange), t.listenTo(i, n, this.handleChange), i.each(function (t) {
              return e.handleChange(t, {
                avoidStore: 1
              });
            });
          },
          handleChange: function handleChange(e) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              i = "change:style",
              r = t.get("UndoManager");
            r && r.add(e);
            var a = t.handleUpdates.bind(t);
            t.stopListening(e, i, a), t.listenTo(e, i, a), !n.avoidStore && a("", "", n);
          },
          load: function load(t) {
            var n = t || "";
            !n && i.stm && (n = i.em.getCacheLoad());
            var r = n.styles || "";
            if (n.styles) try {
              r = JSON.parse(n.styles);
            } catch (t) {} else n.css && (r = i.em.get("Parser").parseCss(n.css));
            return Object(a.isArray)(r) ? r.length && e.reset(r) : r && e.reset(r), r;
          },
          store: function store(t) {
            if (i.stm) {
              var n = {},
                r = this.storageKey();
              return r.indexOf("css") >= 0 && (n.css = i.em.getCss()), r.indexOf("styles") >= 0 && (n.styles = JSON.stringify(e)), t || i.stm.store(n), n;
            }
          },
          add: function add(t, n, r) {
            var a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
              o = n || "",
              l = r || "",
              c = p({}, a),
              d = this.get(t, o, l, c);
            return d && d.config && !d.config.singleAtRule || (c.state = o, c.mediaText = l, c.selectors = [], (d = new s.a(c, i)).get("selectors").add(t), e.add(d)), d;
          },
          get: function get(t, n, i, r) {
            var a = null;
            return e.each(function (e) {
              a || e.compare(t, n, i, r) && (a = e);
            }), a;
          },
          getAll: function getAll() {
            return e;
          },
          clear: function clear() {
            return this.getAll().reset(), this;
          },
          addCollection: function addCollection(t) {
            for (var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = [], r = t instanceof Array ? t : [t], a = 0, o = r.length; a < o; a++) {
              var s = r[a] || {};
              if (s.selectors) {
                var l = i.em && i.em.get("SelectorManager");
                l || console.warn("Selector Manager not found");
                for (var c = s.selectors, d = c instanceof Array ? c : [c], u = [], h = 0, g = d.length; h < g; h++) {
                  var f = l.add(d[h]);
                  u.push(f);
                }
                var m = this.get(u, s.state, s.mediaText, s),
                  v = this.add(u, s.state, s.mediaText, s),
                  b = !m || !e.avoidUpdateStyle,
                  y = s.style || {};
                if (b) {
                  var w = e.extend ? p(p({}, v.get("style")), y) : y;
                  v.set("style", w);
                }
                n.push(v);
              }
            }
            return n;
          },
          setRule: function setRule(e, n) {
            var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              r = i.atRuleType,
              a = i.atRuleParams,
              o = t.get("Parser").parserCss.checkNode({
                selectors: e,
                style: n
              })[0],
              s = o.state,
              l = o.selectorsAdd,
              c = t.get("SelectorManager"),
              d = c.add(o.selectors),
              u = this.add(d, s, a, {
                selectorsAdd: l,
                atRule: r
              });
            return u.setStyle(n, i), u;
          },
          getRule: function getRule(e) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              i = t.get("SelectorManager"),
              r = t.get("Parser").parserCss.checkNode({
                selectors: e
              })[0],
              a = i.get(r.selectors),
              o = r.state,
              s = r.selectorsAdd,
              l = n.atRuleType,
              c = n.atRuleParams;
            return a && this.get(a, o, c, {
              selectorsAdd: s,
              atRule: l
            });
          },
          setIdRule: function setIdRule(e) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              r = i.state || "",
              a = i.mediaText || t.getCurrentMedia(),
              o = t.get("SelectorManager"),
              s = o.add({
                name: e,
                type: u.a.TYPE_ID
              }),
              l = this.add(s, r, a);
            return l.setStyle(n, i), l;
          },
          getIdRule: function getIdRule(e) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              i = n.state || "",
              r = n.mediaText || t.getCurrentMedia(),
              a = t.get("SelectorManager").get(e, u.a.TYPE_ID);
            return a && this.get(a, i, r);
          },
          setClassRule: function setClassRule(e) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              r = i.state || "",
              a = i.mediaText || t.getCurrentMedia(),
              o = t.get("SelectorManager"),
              s = o.add({
                name: e,
                type: u.a.TYPE_CLASS
              }),
              l = this.add(s, r, a);
            return l.setStyle(n, i), l;
          },
          getClassRule: function getClassRule(e) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              i = n.state || "",
              r = n.mediaText || t.getCurrentMedia(),
              a = t.get("SelectorManager").get(e, u.a.TYPE_CLASS);
            return a && this.get(a, i, r);
          },
          render: function render() {
            return n.render().el;
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var i = n(9),
        r = n.n(i),
        a = n(2),
        o = n.n(a),
        s = n(0),
        l = n(22),
        c = {
          stylePrefix: "com-",
          defaults: [],
          strict: 1
        },
        d = n(5);
      function u(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);
          e && (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, i);
        }
        return n;
      }
      function h(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? u(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.default = function () {
        var t,
          e = {},
          i = {},
          a = {},
          o = {},
          u = [["preview", "Preview", "preview"], ["resize", "Resize", "resize"], ["fullscreen", "Fullscreen", "fullscreen"], ["copy", "CopyComponent"], ["paste", "PasteComponent"], ["canvas-move", "CanvasMove"], ["canvas-clear", "CanvasClear"], ["open-code", "ExportTemplate", "export-template"], ["open-layers", "OpenLayers", "open-layers"], ["open-styles", "OpenStyleManager", "open-sm"], ["open-traits", "OpenTraitManager", "open-tm"], ["open-blocks", "OpenBlocks", "open-blocks"], ["open-assets", "OpenAssets", "open-assets"], ["save-db", "SaveDb", "save-db"], ["cmd-clear", "CanvasClear", "cmd-clear"], ["component-select", "SelectComponent", "select-comp"], ["component-outline", "SwitchVisibility", "sw-visibility"], ["component-offset", "ShowOffset", "show-offset"], ["component-move", "MoveComponent", "move-comp"], ["component-next", "ComponentNext"], ["component-prev", "ComponentPrev"], ["component-enter", "ComponentEnter"], ["component-exit", "ComponentExit", "select-parent"], ["component-delete", "ComponentDelete"], ["component-style-clear", "ComponentStyleClear"], ["component-drag", "ComponentDrag"], ["set-device-desktop", "DeviceDesktop", "set-device-desktop"], ["set-device-tablet", "DeviceTablet", "set-device-tablet"], ["set-device-mobile", "DeviceMobile", "set-device-mobile"], ["set-device-mobile-ptr", "DeviceMobilePtr", "set-device-mobile-ptr"]];
        return {
          CommandAbstract: l.default,
          name: "Commands",
          init: function init() {
            var i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            e = h(h({}, c), i), t = e.em;
            var o = e.pStylePrefix;
            for (var l in o && (e.stylePrefix = o + e.stylePrefix), e.defaults) {
              var p = e.defaults[l];
              p.id && this.add(p.id, p);
            }
            return a["tlb-delete"] = {
              run: function run(t) {
                return t.runCommand("core:component-delete");
              }
            }, a["tlb-clone"] = {
              run: function run(t) {
                t.runCommand("core:copy"), t.runCommand("core:paste");
              }
            }, a["tlb-trait-setting"] = {
              run: function run(t, e) {
                var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                  i = n && n.event,
                  r = n.target,
                  a = (r || t.getSelected(), i.clientX, i.clientY, t.TraitManager),
                  o = a.getTraitsViewer();
                t.Popover.open({
                  title: "Settings",
                  content: o.render().el
                }).getModel().once("change:open");
              }
            }, a["tlb-move"] = {
              run: function run(t, e) {
                var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                  i = t.getModel(),
                  a = n && n.event,
                  o = n.target,
                  l = o || t.getSelected(),
                  c = o ? [o] : r()(t.getSelectedAll()),
                  u = a && "dragstart" == a.type,
                  h = {
                    preserveSelected: 1
                  },
                  p = ["absolute", "translate"],
                  g = l.get("dmode") || i.get("dmode"),
                  f = function f() {
                    return i.stopDefault(h);
                  },
                  m = Object(s.includes)(p, g);
                if (c.forEach(function (t) {
                  return t.trigger("disable");
                }), !l || !l.get("draggable")) return i.logWarning("The element is not draggable");
                u ? setTimeout(f, 0) : f();
                var v = function v(t) {
                    i.trigger("".concat(d.eventDrag, ":start"), t);
                  },
                  b = function b(t) {
                    i.trigger(d.eventDrag, t);
                  },
                  y = function y(e, n, r) {
                    i.runDefault(h), c.forEach(function (t) {
                      return t.set("status", "selected");
                    }), t.select(c), l.emitUpdate(), i.trigger("".concat(d.eventDrag, ":end"), r), (m || r.cancelled) && i.set("_cmpDrag", 1);
                  };
                if (m) t.runCommand("core:component-drag", {
                  guidesInfo: 1,
                  mode: g,
                  target: l,
                  onStart: v,
                  onDrag: b,
                  onEnd: y,
                  event: a
                });else {
                  u && a.dataTransfer.setDragImage(l.view.el, 0, 0);
                  var w = t.Commands.get("move-comp");
                  w.onStart = v, w.onDrag = b, w.onEndMoveFromModel = y, w.initSorterFromModels(c);
                }
                c.forEach(function (t) {
                  return t.set("status", "freezed-selected");
                });
              }
            }, a["core:undo"] = function (t) {
              return t.UndoManager.undo();
            }, a["core:redo"] = function (t) {
              return t.UndoManager.redo();
            }, u.forEach(function (e) {
              var i = e[2],
                r = n(99)("./".concat(e[1])).default,
                o = "core:".concat(e[0]);
              a[o] = r, i && (a[i] = r, ["run", "stop"].forEach(function (e) {
                t.on("".concat(e, ":").concat(i), function () {
                  for (var n, i = arguments.length, r = new Array(i), a = 0; a < i; a++) r[a] = arguments[a];
                  return (n = t).trigger.apply(n, ["".concat(e, ":").concat(o)].concat(r));
                });
              }));
            }), e.em && (e.model = e.em.get("Canvas")), this.loadDefaultCommands(), this;
          },
          add: function add(t, e) {
            return Object(s.isFunction)(e) && (e = {
              run: e
            }), e.stop || (e.noStop = 1), delete e.initialize, e.id = t, i[t] = l.default.extend(e), this;
          },
          get: function get(n) {
            var r = i[n];
            return Object(s.isFunction)(r) ? (r = new r(e), i[n] = r) : r || t.logWarning("'".concat(n, "' command not found")), r;
          },
          extend: function extend(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = this.get(t);
            if (n) {
              var i = h(h({}, n.constructor.prototype), e);
              this.add(t, i);
              var r = u.filter(function (e) {
                return "core:".concat(e[0]) === t && e[2];
              })[0];
              r && this.add(r[2], i);
            }
            return this;
          },
          has: function has(t) {
            return !!i[t];
          },
          getAll: function getAll() {
            return i;
          },
          run: function run(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return this.runCommand(this.get(t), e);
          },
          stop: function stop(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return this.stopCommand(this.get(t), e);
          },
          isActive: function isActive(t) {
            return this.getActive().hasOwnProperty(t);
          },
          getActive: function getActive() {
            return o;
          },
          loadDefaultCommands: function loadDefaultCommands() {
            for (var t in a) this.add(t, a[t]);
            return this;
          },
          runCommand: function runCommand(n) {
            var i,
              r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            if (n && n.run) {
              var a = n.id,
                s = t.get("Editor");
              this.isActive(a) && !r.force && e.strict || (i = n.callRun(s, r), a && n.stop && !n.noStop && !r.abort && (o[a] = i));
            }
            return i;
          },
          stopCommand: function stopCommand(n) {
            var i,
              r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            if (n && n.run) {
              var a = n.id,
                s = t.get("Editor");
              (this.isActive(a) || r.force || !e.strict) && (a && delete o[a], i = n.callStop(s, r));
            }
            return i;
          },
          create: function create(t) {
            return t.stop || (t.noStop = 1), new (l.default.extend(t))(e);
          }
        };
      };
    }]).default);
  }, function (t, e, n) {
    var i = n(1);
    t.exports = function (t) {
      return i(t).replace(/<\/?[^>]+>/g, '');
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return null == t ? [] : (t = String(t), (e = ~~e) > 0 ? t.match(new RegExp('.{1,' + e + '}', 'g')) : [t]);
    };
  }, function (t, e, n) {
    var i = n(3);
    t.exports = function (t) {
      return i(t).replace(/\s\s+/g, ' ');
    };
  }, function (t, e, n) {
    var i = n(1);
    t.exports = function (t, e) {
      return t = i(t), e = i(e), 0 === t.length || 0 === e.length ? 0 : t.split(e).length - 1;
    };
  }, function (t, e, n) {
    var i = n(1);
    t.exports = function (t) {
      return i(t).replace(/\S/g, function (t) {
        return t === t.toUpperCase() ? t.toLowerCase() : t.toUpperCase();
      });
    };
  }, function (t, e, n) {
    var i = n(1),
      r = n(34),
      a = '[';
    for (var o in r) a += o;
    a += ']';
    var s = new RegExp(a, 'g');
    t.exports = function (t) {
      return i(t).replace(s, function (t) {
        return '&' + r[t] + ';';
      });
    };
  }, function (t, e) {
    t.exports = {
      '¢': 'cent',
      '£': 'pound',
      '¥': 'yen',
      '€': 'euro',
      '©': 'copy',
      '®': 'reg',
      '<': 'lt',
      '>': 'gt',
      '"': 'quot',
      '&': 'amp',
      '\'': '#39'
    };
  }, function (t, e, n) {
    var i = n(1),
      r = n(36);
    t.exports = function (t) {
      return i(t).replace(/\&([^;]{1,10});/g, function (t, e) {
        var n;
        return e in r ? r[e] : (n = e.match(/^#x([\da-fA-F]+)$/)) ? String.fromCharCode(parseInt(n[1], 16)) : (n = e.match(/^#(\d+)$/)) ? String.fromCharCode(~~n[1]) : t;
      });
    };
  }, function (t, e) {
    t.exports = {
      nbsp: ' ',
      cent: '¢',
      pound: '£',
      yen: '¥',
      euro: '€',
      copy: '©',
      reg: '®',
      lt: '<',
      gt: '>',
      quot: '"',
      amp: '&',
      apos: '\''
    };
  }, function (t, e, n) {
    var i = n(15);
    t.exports = function (t, e, n) {
      return i(t, e, 0, n);
    };
  }, function (t, e, n) {
    var i = n(1);
    t.exports = function (t, e, n, r) {
      var a = new RegExp(e, !0 === r ? 'gi' : 'g');
      return i(t).replace(a, n);
    };
  }, function (t, e, n) {
    var i = n(1);
    t.exports = function (t, e) {
      return '' === e || -1 !== i(t).indexOf(e);
    };
  }, function (t, e, n) {
    var i = n(1),
      r = [].slice;
    t.exports = function () {
      var t = r.call(arguments),
        e = t.shift();
      return t.join(i(e));
    };
  }, function (t, e) {
    t.exports = function (t) {
      return null == t ? [] : String(t).split(/\r\n?|\n/);
    };
  }, function (t, e, n) {
    var i = n(1);
    t.exports = function (t, e) {
      var n,
        r = function (t) {
          for (var e = t.match(/^[\s\\t]*/gm), n = e[0].length, i = 1; i < e.length; i++) n = Math.min(e[i].length, n);
          return n;
        }(t = i(t));
      return 0 === r ? t : (n = 'string' == typeof e ? new RegExp('^' + e, 'gm') : new RegExp('^[ \\t]{' + r + '}', 'gm'), t.replace(n, ''));
    };
  }, function (t, e, n) {
    var i = n(8);
    t.exports = function (t) {
      return i(t).reverse().join('');
    };
  }, function (t, e, n) {
    var i = n(1),
      r = n(16);
    t.exports = function (t, e, n) {
      return t = i(t), e = '' + e, n = null == n ? 0 : Math.min(r(n), t.length), t.lastIndexOf(e, n) === n;
    };
  }, function (t, e, n) {
    var i = n(1),
      r = n(16);
    t.exports = function (t, e, n) {
      return t = i(t), e = '' + e, (n = void 0 === n ? t.length - e.length : Math.min(r(n), t.length) - e.length) >= 0 && t.indexOf(e, n) === n;
    };
  }, function (t, e, n) {
    var i = n(17);
    t.exports = function (t) {
      return i(t, -1);
    };
  }, function (t, e, n) {
    var i = n(17);
    t.exports = function (t) {
      return i(t, 1);
    };
  }, function (t, e, n) {
    var i = n(1);
    t.exports = function (t) {
      return i(t).toLowerCase().replace(/(?:^|\s|-)\S/g, function (t) {
        return t.toUpperCase();
      });
    };
  }, function (t, e, n) {
    var i = n(6),
      r = n(18),
      a = n(1);
    t.exports = function (t) {
      return t = a(t), i(r(t.replace(/[\W_]/g, ' ')).replace(/\s/g, ''));
    };
  }, function (t, e, n) {
    var i = n(6),
      r = n(19),
      a = n(3);
    t.exports = function (t) {
      return i(a(r(t).replace(/_id$/, '').replace(/_/g, ' ')));
    };
  }, function (t, e, n) {
    var i = n(1),
      r = n(7),
      a = String.prototype.trimLeft;
    t.exports = function (t, e) {
      return t = i(t), !e && a ? a.call(t) : (e = r(e), t.replace(new RegExp('^' + e + '+'), ''));
    };
  }, function (t, e, n) {
    var i = n(1);
    t.exports = function (t, e, n) {
      return n = n || '...', e = ~~e, (t = i(t)).length > e ? t.slice(0, e) + n : t;
    };
  }, function (t, e, n) {
    var i = n(1),
      r = n(9);
    t.exports = function (t, e, n) {
      if (t = i(t), e = ~~e, n = null != n ? String(n) : '...', t.length <= e) return t;
      var a = t.slice(0, e + 1).replace(/.(?=\W*\w*$)/g, function (t) {
        return t.toUpperCase() !== t.toLowerCase() ? 'A' : ' ';
      });
      return ((a = a.slice(a.length - 2).match(/\w\w/) ? a.replace(/\s*\S+$/, '') : r(a.slice(0, a.length - 1))) + n).length > t.length ? t : t.slice(0, a.length) + n;
    };
  }, function (t, e, n) {
    var i = n(11),
      r = n(3);
    t.exports = function (t, e) {
      return i(t) ? [] : r(t, e).split(e || /\s+/);
    };
  }, function (t, e, n) {
    var i = n(5);
    t.exports = function (t, e, n) {
      return i(t, e, n);
    };
  }, function (t, e, n) {
    var i = n(5);
    t.exports = function (t, e, n) {
      return i(t, e, n, 'right');
    };
  }, function (t, e, n) {
    var i = n(5);
    t.exports = function (t, e, n) {
      return i(t, e, n, 'both');
    };
  }, function (t, e, n) {
    var i = n(22);
    t.exports = i(n(24).sprintf, 'sprintf() will be removed in the next major release, use the sprintf-js package instead.');
  }, function (t, e, n) {
    var i = n(22);
    t.exports = i(n(24).vsprintf, 'vsprintf() will be removed in the next major release, use the sprintf-js package instead.');
  }, function (t, e) {
    t.exports = function (t, e) {
      if (null == t) return 0;
      var n = Math.pow(10, isFinite(e) ? e : 0);
      return Math.round(t * n) / n;
    };
  }, function (t, e) {
    t.exports = function (t, e, n, i) {
      if (isNaN(t) || null == t) return '';
      i = 'string' == typeof i ? i : ',';
      var r = (t = t.toFixed(~~e)).split('.'),
        a = r[0],
        o = r[1] ? (n || '.') + r[1] : '';
      return a.replace(/(\d)(?=(?:\d{3})+$)/g, '$1' + i) + o;
    };
  }, function (t, e, n) {
    var i = n(1);
    t.exports = function (t, e) {
      t = i(t);
      var n = (e = i(e)) ? t.indexOf(e) : -1;
      return ~n ? t.slice(n + e.length, t.length) : t;
    };
  }, function (t, e, n) {
    var i = n(1);
    t.exports = function (t, e) {
      t = i(t);
      var n = (e = i(e)) ? t.lastIndexOf(e) : -1;
      return ~n ? t.slice(n + e.length, t.length) : t;
    };
  }, function (t, e, n) {
    var i = n(1);
    t.exports = function (t, e) {
      t = i(t);
      var n = (e = i(e)) ? t.indexOf(e) : -1;
      return ~n ? t.slice(0, n) : t;
    };
  }, function (t, e, n) {
    var i = n(1);
    t.exports = function (t, e) {
      t = i(t), e = i(e);
      var n = t.lastIndexOf(e);
      return ~n ? t.slice(0, n) : t;
    };
  }, function (t, e, n) {
    var i = n(25);
    t.exports = function (t, e, n) {
      return i(t, e, n, !0);
    };
  }, function (t, e, n) {
    var i = n(3),
      r = n(20),
      a = n(14);
    t.exports = function (t) {
      return i(r(a(t).replace(/[^\w\s-]/g, '-').toLowerCase()), '-');
    };
  }, function (t, e, n) {
    var i = n(26);
    t.exports = function (t, e) {
      return i(t, e || '"');
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return e = e || '"', t[0] === e && t[t.length - 1] === e ? t.slice(1, t.length - 1) : t;
    };
  }, function (t, e, n) {
    var i = n(1),
      r = n(21);
    t.exports = function (t, e, n) {
      if (t = i(t), e = ~~e, null == n) return r(t, e);
      for (var a = []; e > 0; a[--e] = t);
      return a.join(n);
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      if (t == e) return 0;
      if (!t) return -1;
      if (!e) return 1;
      for (var n = /(\.\d+|\d+|\D+)/g, i = String(t).match(n), r = String(e).match(n), a = Math.min(i.length, r.length), o = 0; o < a; o++) {
        var s = i[o],
          l = r[o];
        if (s !== l) {
          var c = +s,
            d = +l;
          return c == c && d == d ? c > d ? 1 : -1 : s < l ? -1 : 1;
        }
      }
      return i.length != r.length ? i.length - r.length : t < e ? -1 : 1;
    };
  }, function (t, e, n) {
    var i = n(1);
    t.exports = function (t, e) {
      'use strict';

      if ((t = i(t)) === (e = i(e))) return 0;
      if (!t || !e) return Math.max(t.length, e.length);
      for (var n = new Array(e.length + 1), r = 0; r < n.length; ++r) n[r] = r;
      for (r = 0; r < t.length; ++r) {
        for (var a = r + 1, o = 0; o < e.length; ++o) {
          var s = a,
            l = s + 1;
          (a = n[o] + (t.charAt(r) === e.charAt(o) ? 0 : 1)) > l && (a = l), a > (l = n[o + 1] + 1) && (a = l), n[o] = s;
        }
        n[o] = a;
      }
      return a;
    };
  }, function (t, e, n) {
    var i = n(3);
    function r(t, e) {
      var n,
        i,
        r = t.toLowerCase();
      for (e = [].concat(e), n = 0; n < e.length; n += 1) if (i = e[n]) {
        if (i.test && i.test(t)) return !0;
        if (i.toLowerCase() === r) return !0;
      }
    }
    t.exports = function (t, e, n) {
      return 'number' == typeof t && (t = '' + t), 'string' != typeof t ? !!t : !!r(t = i(t), e || ['true', '1']) || !r(t, n || ['false', '0']) && void 0;
    };
  }, function (t, e) {
    t.exports = function () {
      var t = {};
      for (var e in this) this.hasOwnProperty(e) && !e.match(/^(?:include|contains|reverse|join|map|wrap)$/) && (t[e] = this[e]);
      return t;
    };
  }, function (t, e, n) {
    var i = n(1);
    t.exports = function (t, e) {
      t = i(t);
      var n,
        r = (e = e || {}).width || 75,
        a = e.seperator || '\n',
        o = e.cut || !1,
        s = e.preserveSpaces || !1,
        l = e.trailingSpaces || !1;
      if (r <= 0) return t;
      if (o) {
        var c = 0;
        for (n = ''; c < t.length;) c % r == 0 && c > 0 && (n += a), n += t.charAt(c), c++;
        if (l) for (; c % r > 0;) n += ' ', c++;
        return n;
      }
      var d = t.split(' '),
        u = 0;
      for (n = ''; d.length > 0;) {
        if (1 + d[0].length + u > r && u > 0) {
          if (s) n += ' ', u++;else if (l) for (; u < r;) n += ' ', u++;
          n += a, u = 0;
        }
        u > 0 && (n += ' ', u++), n += d[0], u += d[0].length, d.shift();
      }
      if (l) for (; u < r;) n += ' ', u++;
      return n;
    };
  }, function (t, e, n) {
    var i = n(1);
    t.exports = function (t, e) {
      return 0 === (t = i(t)).length || 'function' != typeof e ? t : t.replace(/./g, e);
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var i = {};
    n.r(i), n.d(i, "VERSION", function () {
      return we["e"];
    }), n.d(i, "restArguments", function () {
      return xe;
    }), n.d(i, "isObject", function () {
      return je;
    }), n.d(i, "isNull", function () {
      return Ce;
    }), n.d(i, "isUndefined", function () {
      return Me;
    }), n.d(i, "isBoolean", function () {
      return ke;
    }), n.d(i, "isElement", function () {
      return Oe;
    }), n.d(i, "isString", function () {
      return Se;
    }), n.d(i, "isNumber", function () {
      return Ne;
    }), n.d(i, "isDate", function () {
      return Le;
    }), n.d(i, "isRegExp", function () {
      return De;
    }), n.d(i, "isError", function () {
      return Ee;
    }), n.d(i, "isSymbol", function () {
      return Ie;
    }), n.d(i, "isArrayBuffer", function () {
      return Pe;
    }), n.d(i, "isDataView", function () {
      return Be;
    }), n.d(i, "isArray", function () {
      return We;
    }), n.d(i, "isFunction", function () {
      return _e;
    }), n.d(i, "isArguments", function () {
      return Ze;
    }), n.d(i, "isFinite", function () {
      return Ge;
    }), n.d(i, "isNaN", function () {
      return qe;
    }), n.d(i, "isTypedArray", function () {
      return en;
    }), n.d(i, "isEmpty", function () {
      return on;
    }), n.d(i, "isMatch", function () {
      return sn;
    }), n.d(i, "isEqual", function () {
      return hn;
    }), n.d(i, "isMap", function () {
      return jn;
    }), n.d(i, "isWeakMap", function () {
      return Cn;
    }), n.d(i, "isSet", function () {
      return Mn;
    }), n.d(i, "isWeakSet", function () {
      return kn;
    }), n.d(i, "keys", function () {
      return an;
    }), n.d(i, "allKeys", function () {
      return pn;
    }), n.d(i, "values", function () {
      return On;
    }), n.d(i, "pairs", function () {
      return Tn;
    }), n.d(i, "invert", function () {
      return Sn;
    }), n.d(i, "functions", function () {
      return Nn;
    }), n.d(i, "methods", function () {
      return Nn;
    }), n.d(i, "extend", function () {
      return Dn;
    }), n.d(i, "extendOwn", function () {
      return En;
    }), n.d(i, "assign", function () {
      return En;
    }), n.d(i, "defaults", function () {
      return In;
    }), n.d(i, "create", function () {
      return An;
    }), n.d(i, "clone", function () {
      return zn;
    }), n.d(i, "tap", function () {
      return _n;
    }), n.d(i, "get", function () {
      return Rn;
    }), n.d(i, "has", function () {
      return Bn;
    }), n.d(i, "mapObject", function () {
      return Qn;
    }), n.d(i, "identity", function () {
      return Wn;
    }), n.d(i, "constant", function () {
      return $e;
    }), n.d(i, "noop", function () {
      return Jn;
    }), n.d(i, "toPath", function () {
      return Hn;
    }), n.d(i, "property", function () {
      return Un;
    }), n.d(i, "propertyOf", function () {
      return Xn;
    }), n.d(i, "matcher", function () {
      return Yn;
    }), n.d(i, "matches", function () {
      return Yn;
    }), n.d(i, "times", function () {
      return Kn;
    }), n.d(i, "random", function () {
      return ti;
    }), n.d(i, "now", function () {
      return ei;
    }), n.d(i, "escape", function () {
      return ri;
    }), n.d(i, "unescape", function () {
      return ai;
    }), n.d(i, "templateSettings", function () {
      return oi;
    }), n.d(i, "template", function () {
      return hi;
    }), n.d(i, "result", function () {
      return pi;
    }), n.d(i, "uniqueId", function () {
      return fi;
    }), n.d(i, "chain", function () {
      return mi;
    }), n.d(i, "iteratee", function () {
      return qn;
    }), n.d(i, "partial", function () {
      return yi;
    }), n.d(i, "bind", function () {
      return wi;
    }), n.d(i, "bindAll", function () {
      return Ci;
    }), n.d(i, "memoize", function () {
      return Mi;
    }), n.d(i, "delay", function () {
      return ki;
    }), n.d(i, "defer", function () {
      return Oi;
    }), n.d(i, "throttle", function () {
      return Ti;
    }), n.d(i, "debounce", function () {
      return Si;
    }), n.d(i, "wrap", function () {
      return Ni;
    }), n.d(i, "negate", function () {
      return Li;
    }), n.d(i, "compose", function () {
      return Di;
    }), n.d(i, "after", function () {
      return Ei;
    }), n.d(i, "before", function () {
      return Ii;
    }), n.d(i, "once", function () {
      return Pi;
    }), n.d(i, "findKey", function () {
      return Ai;
    }), n.d(i, "findIndex", function () {
      return _i;
    }), n.d(i, "findLastIndex", function () {
      return Hi;
    }), n.d(i, "sortedIndex", function () {
      return Vi;
    }), n.d(i, "indexOf", function () {
      return Ri;
    }), n.d(i, "lastIndexOf", function () {
      return Bi;
    }), n.d(i, "find", function () {
      return Wi;
    }), n.d(i, "detect", function () {
      return Wi;
    }), n.d(i, "findWhere", function () {
      return Yi;
    }), n.d(i, "each", function () {
      return Ui;
    }), n.d(i, "forEach", function () {
      return Ui;
    }), n.d(i, "map", function () {
      return Zi;
    }), n.d(i, "collect", function () {
      return Zi;
    }), n.d(i, "reduce", function () {
      return qi;
    }), n.d(i, "foldl", function () {
      return qi;
    }), n.d(i, "inject", function () {
      return qi;
    }), n.d(i, "reduceRight", function () {
      return $i;
    }), n.d(i, "foldr", function () {
      return $i;
    }), n.d(i, "filter", function () {
      return Qi;
    }), n.d(i, "select", function () {
      return Qi;
    }), n.d(i, "reject", function () {
      return Ji;
    }), n.d(i, "every", function () {
      return Xi;
    }), n.d(i, "all", function () {
      return Xi;
    }), n.d(i, "some", function () {
      return Ki;
    }), n.d(i, "any", function () {
      return Ki;
    }), n.d(i, "contains", function () {
      return tr;
    }), n.d(i, "includes", function () {
      return tr;
    }), n.d(i, "include", function () {
      return tr;
    }), n.d(i, "invoke", function () {
      return er;
    }), n.d(i, "pluck", function () {
      return nr;
    }), n.d(i, "where", function () {
      return ir;
    }), n.d(i, "max", function () {
      return rr;
    }), n.d(i, "min", function () {
      return ar;
    }), n.d(i, "shuffle", function () {
      return cr;
    }), n.d(i, "sample", function () {
      return lr;
    }), n.d(i, "sortBy", function () {
      return dr;
    }), n.d(i, "groupBy", function () {
      return hr;
    }), n.d(i, "indexBy", function () {
      return pr;
    }), n.d(i, "countBy", function () {
      return gr;
    }), n.d(i, "partition", function () {
      return fr;
    }), n.d(i, "toArray", function () {
      return sr;
    }), n.d(i, "size", function () {
      return mr;
    }), n.d(i, "pick", function () {
      return br;
    }), n.d(i, "omit", function () {
      return yr;
    }), n.d(i, "first", function () {
      return xr;
    }), n.d(i, "head", function () {
      return xr;
    }), n.d(i, "take", function () {
      return xr;
    }), n.d(i, "initial", function () {
      return wr;
    }), n.d(i, "last", function () {
      return Cr;
    }), n.d(i, "rest", function () {
      return jr;
    }), n.d(i, "tail", function () {
      return jr;
    }), n.d(i, "drop", function () {
      return jr;
    }), n.d(i, "compact", function () {
      return Mr;
    }), n.d(i, "flatten", function () {
      return kr;
    }), n.d(i, "without", function () {
      return Tr;
    }), n.d(i, "uniq", function () {
      return Sr;
    }), n.d(i, "unique", function () {
      return Sr;
    }), n.d(i, "union", function () {
      return Nr;
    }), n.d(i, "intersection", function () {
      return Lr;
    }), n.d(i, "difference", function () {
      return Or;
    }), n.d(i, "unzip", function () {
      return Dr;
    }), n.d(i, "transpose", function () {
      return Dr;
    }), n.d(i, "zip", function () {
      return Er;
    }), n.d(i, "object", function () {
      return Ir;
    }), n.d(i, "range", function () {
      return Pr;
    }), n.d(i, "chunk", function () {
      return Ar;
    }), n.d(i, "mixin", function () {
      return _r;
    }), n.d(i, "default", function () {
      return Hr;
    });
    var r = n(27),
      a = n.n(r),
      o = function o(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        var n = t.AssetManager,
          i = n.getConfig();
        i.upload = !1;
        var r = e.types;
        n.addType(r.button, {
          model: {
            defaults: {
              type: r.button,
              content: "",
              name: "Default Custom Button"
            },
            getName: function getName() {
              return this.get("name");
            }
          },
          view: {
            init: function init() {
              this.className += " ".concat(this.pfx, r.button);
            },
            getPreview: function getPreview() {
              return "".concat(this.model.get("label"));
            },
            getInfo: function getInfo() {
              return "".concat(this.model.get("name"));
            },
            updateTarget: function updateTarget(t) {
              var e = this.model.get("content");
              t.set("content", e);
            }
          }
        }), n.addType(r.card, {
          model: {
            defaults: {
              type: r.card,
              content: "",
              name: "Custom Card"
            },
            getName: function getName() {
              return this.get("name");
            }
          },
          view: {
            init: function init() {
              this.className += " ".concat(this.pfx, r.card);
            },
            getPreview: function getPreview() {
              return "".concat(this.model.get("label"));
            },
            getInfo: function getInfo() {
              return "".concat(this.model.get("name"));
            },
            updateTarget: function updateTarget(t) {
              var e = this.model.get("content");
              t.set("content", e);
            }
          }
        });
      },
      s = "<svg aria-hidden=\"true\" width=\"32\" height=\"50\" focusable=\"false\" data-prefix=\"fas\" data-icon=\"window-maximize\" class=\"svg-inline--fa fa-window-maximize fa-w-16\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><path fill=\"currentColor\" d=\"M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16 160H64v-84c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12v84z\"></path></svg>\n";
    var l = function l(t, e, n, i) {
      t.add(i, {
        label: n,
        category: e,
        content: {
          type: i,
          classes: ["container"]
        },
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n    <div class=\"drap-on-six\">").concat(s, "</div>\n    <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n      <a\n        target=\"_blank\"\n        href=\"https://academy.drapcode.com/docs/app-builder/layout-component-container\"\n        draggable=\"false\"\n      >\n        <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n      </a>\n    </div>\n    <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n  </div>\n  ");
        }
      });
    };
    var c = function c(t, e, n) {
      var i = t.getType("default"),
        r = i.model,
        a = i.view;
      t.addType(n, {
        model: r.extend({
          defaults: _objectSpread({}, r.prototype.defaults, {
            "custom-name": e,
            tagName: "div",
            droppable: !0,
            resizable: !0,
            traits: [{
              type: "class_select",
              options: [{
                value: "container",
                name: "Fixed (fixed with of n pixels)"
              }, {
                value: "container-fluid",
                name: "Fluid (100% width of parent element)"
              }],
              label: "Width"
            }].concat(r.prototype.defaults.traits)
          })
        }, {
          isComponent: function isComponent(t) {
            if (t && t.classList && (t.classList.contains("container") || t.classList.contains("container-fluid"))) return {
              type: n
            };
          }
        }),
        view: a
      });
    };
    var d = function d(t, e, n, i) {
      t.add(i, {
        label: n,
        category: e,
        activate: !0,
        select: !0,
        content: "\n          <button type=\"submit\" class=\"btn btn-primary btn-sm\">Send</button>\n      ",
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n    <div class=\"drap-on-six\"><svg class=\"gjs-block-svg\" viewBox=\"0 0 24 24\" width=\"32\" height=\"50\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path class=\"gjs-block-svg-path\" d=\"M22,9 C22,8.4 21.5,8 20.75,8 L3.25,8 C2.5,8 2,8.4 2,9 L2,15 C2,15.6 2.5,16 3.25,16 L20.75,16 C21.5,16 22,15.6 22,15 L22,9 Z M21,15 L3,15 L3,9 L21,9 L21,15 Z\" fill-rule=\"nonzero\"></path>\n    <rect class=\"gjs-block-svg-path\" x=\"4\" y=\"11.5\" width=\"16\" height=\"1\"></rect>\n    </svg></div>\n    <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n      <a\n        target=\"_blank\"\n        href=\"https://academy.drapcode.com/docs/app-builder/form-components#button\"\n        draggable=\"false\"\n      >\n        <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n      </a>\n    </div>\n    <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n  </div>\n    ");
        }
      });
    };
    var u = function u(t, e, n, i) {
        var r = t.getType("default"),
          a = r.model,
          o = r.view;
        var s;
        t.addType(n, {
          model: a.extend({
            defaults: _objectSpread({}, a.prototype.defaults, {
              "custom-name": e,
              editable: !0,
              droppable: !1,
              resizable: !0,
              attributes: {
                role: "button"
              },
              traits: [].concat(_toConsumableArray(a.prototype.defaults.traits), [{
                type: "content",
                label: "Text"
              }, {
                label: "Type",
                type: "button-type",
                name: "type",
                options: [{
                  value: "submit",
                  name: "Submit"
                }, {
                  value: "reset",
                  name: "Reset"
                }, {
                  value: "button",
                  name: "Button"
                }]
              }, {
                type: "webconnect-text",
                label: !1,
                content: "Send"
              }, {
                label: "Prevent Double Click",
                type: "checkbox",
                name: "data-prevent-dblclick"
              }, {
                label: "Disable Duration (milliseconds)",
                type: "number",
                name: "data-disable-duration",
                placeholder: "eg. 5000",
                min: 1e3,
                max: 15e3,
                step: 500,
                default: 5e3
              }])
            }),
            init: function init() {},
            onCustomButtonChange: function onCustomButtonChange() {
              this.components(this.get(n));
            },
            afterChange: function afterChange(t) {
              this.attributes.type === n && 0 === this.attributes.classes.filter(function (t) {
                return "btn" === t.id || "dc-button" === t.id;
              }).length && this.changeType("link");
            }
          }, {
            isComponent: function isComponent(t) {
              if (t && t.classList && (t.classList.contains("btn") || t.classList.contains("dc-button") || "BUTTON" === t.tagName)) return {
                type: n
              };
            }
          }),
          view: o.extend({
            events: {
              click: "handleClick",
              dblclick: "onActive"
            },
            init: function init() {
              this.listenTo(this.model, "change:content", this.updateContent), this.listenTo(this.model.components(), "add remove reset", this.onComponentsChange), this.onComponentsChange();
            },
            onComponentsChange: function onComponentsChange() {
              var _this = this;
              s && clearInterval(s), s = setTimeout(function () {
                var t = _this.model;
                t.set({
                  droppable: 1
                });
              }, 0);
            },
            onActive: function onActive() {
              var t = this.model;
              this.em.get("Commands").run(i, {
                target: t
              });
            },
            updateContent: function updateContent() {
              this.el.innerHTML = this.model.get("content");
            },
            handleClick: function handleClick(t) {
              t.preventDefault();
            }
          })
        });
      },
      h = "<svg aria-hidden=\"true\" width=\"32\" height=\"50\" focusable=\"false\" data-prefix=\"fas\" data-icon=\"columns\" class=\"svg-inline--fa fa-columns fa-w-16\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><path fill=\"currentColor\" d=\"M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64V160h160v256zm224 0H288V160h160v256z\"/></svg>";
    var p = function p(t, e, n, i) {
      t.add(i, {
        label: n,
        category: e,
        content: {
          type: i,
          classes: ["col"]
        },
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n      <div class=\"drap-on-six\">").concat(h, "</div>\n      <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n        <a\n          target=\"_blank\"\n          href=\"https://academy.drapcode.com/docs/app-builder/layout-component-row-column-break#column\"\n          draggable=\"false\"\n        >\n          <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </div>\n      <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n    </div>\n  ");
        }
      });
    };
    var g = function g(t, e, n, i) {
      var r = t.getType("default"),
        a = r.model,
        o = r.view,
        s = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
      t.addType(n, {
        model: a.extend({
          defaults: Object.assign({}, a.prototype.defaults, {
            "custom-name": e,
            draggable: ".row, .data-group, .data-list, .child-data-group",
            droppable: !0,
            resizable: {
              updateTarget: function updateTarget(t, e, n) {
                var r = void 0 !== i && i ? i.getSelected() : null;
                if (!r) return;
                var a = t.getRootNode().body.offsetWidth;
                var o = "";
                a >= 1200 ? o = "xl" : a >= 992 ? o = "lg" : a >= 768 ? o = "md" : a >= 576 && (o = "sm");
                var s = .5 * (t.parentElement.offsetWidth / 12),
                  l = e.w > t.offsetWidth + s,
                  c = e.w < t.offsetWidth - s;
                if (l || c) {
                  var _e7 = new RegExp("^col-" + o + "-\\d{1,2}$");
                  o || (_e7 = new RegExp("^col-\\d{1,2}$"));
                  var _n5 = !1,
                    _i5 = {},
                    _a3 = 0,
                    _s = null;
                  var _iterator = _createForOfIteratorHelper(t.classList),
                    _step;
                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      var _e9 = _step.value;
                      if (0 === _e9.indexOf("col-")) {
                        var _e9$split = _e9.split("-"),
                          _e9$split2 = _slicedToArray(_e9$split, 3),
                          _t5 = _e9$split2[0],
                          _r2 = _e9$split2[1],
                          _l = _e9$split2[2];
                        _l || (_l = _r2, _r2 = ""), _i5[_r2] = _l, _r2 === o && (_s = _e9, _a3 = _l, _n5 = !0);
                      }
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }
                  if (!_n5) {
                    var _t3 = ["", "xs", "sm", "md", "lg", "xl"];
                    for (var _i6 = 0, _t4 = _t3; _i6 < _t4.length; _i6++) {
                      var _e8 = _t4[_i6];
                      if (_i5[_e8] && (_a3 = _i5[_e8], _n5 = !0), _e8 === o) break;
                    }
                  }
                  var _c2 = Number(_a3);
                  l ? _c2++ : _c2--, _c2 > 12 && (_c2 = 12), _c2 < 1 && (_c2 = 1);
                  var _d = "col-" + o + "-" + _c2;
                  o || (_d = "col-" + _c2), r.addClass(_d), _s && _s !== _d && r.removeClass(_s), r.getTrait((o || "xs") + "_width").view.postUpdate();
                }
              },
              tl: 0,
              tc: 0,
              tr: 0,
              cl: 0,
              cr: 1,
              bl: 0,
              bc: 0,
              br: 0
            },
            traits: [{
              id: "xs_width",
              type: "class_select",
              options: [{
                value: "col",
                name: "Equal"
              }, {
                value: "col-auto",
                name: "Variable"
              }].concat(_toConsumableArray(s.map(function (t) {
                var e = Math.round(t / 12 * 100);
                return {
                  value: "col-" + t,
                  name: "".concat(e, "% of Row Width (").concat(t, "/12)")
                };
              }))),
              label: "Extra Smaller Mobiles Width"
            }, {
              id: "sm_width",
              type: "class_select",
              options: [{
                value: "",
                name: "None"
              }, {
                value: "col-sm",
                name: "Equal"
              }, {
                value: "col-sm-auto",
                name: "Variable"
              }].concat(_toConsumableArray(s.map(function (t) {
                var e = Math.round(t / 12 * 100);
                return {
                  value: "col-sm-" + t,
                  name: "".concat(e, "% of Row Width (").concat(t, "/12)")
                };
              }))),
              label: "Bigger Mobiles Width"
            }, {
              id: "md_width",
              type: "class_select",
              options: [{
                value: "",
                name: "None"
              }, {
                value: "col-md",
                name: "Equal"
              }, {
                value: "col-md-auto",
                name: "Variable"
              }].concat(_toConsumableArray(s.map(function (t) {
                var e = Math.round(t / 12 * 100);
                return {
                  value: "col-md-" + t,
                  name: "".concat(e, "% of Row Width (").concat(t, "/12)")
                };
              }))),
              label: "Medium Screens / Tablet Width"
            }, {
              id: "lg_width",
              type: "class_select",
              options: [{
                value: "",
                name: "None"
              }, {
                value: "col-lg",
                name: "Equal"
              }, {
                value: "col-lg-auto",
                name: "Variable"
              }].concat(_toConsumableArray(s.map(function (t) {
                var e = Math.round(t / 12 * 100);
                return {
                  value: "col-lg-" + t,
                  name: "".concat(e, "% of Row Width (").concat(t, "/12)")
                };
              }))),
              label: "Large Screens / Laptop Width"
            }, {
              id: "xl_width",
              type: "class_select",
              options: [{
                value: "",
                name: "None"
              }, {
                value: "col-xl",
                name: "Equal"
              }, {
                value: "col-xl-auto",
                name: "Variable"
              }].concat(_toConsumableArray(s.map(function (t) {
                var e = Math.round(t / 12 * 100);
                return {
                  value: "col-xl-" + t,
                  name: "".concat(e, "% of Row Width (").concat(t, "/12)")
                };
              }))),
              label: "Extra Large Screens / Wide Desktops Width"
            }].concat(a.prototype.defaults.traits)
          })
        }, {
          isComponent: function isComponent(t) {
            var e = !1;
            if (t && t.classList && t.classList.forEach(function (t) {
              ("col" == t || t.match(/^col-/)) && (e = !0);
            }), e) return {
              type: "column"
            };
          }
        }),
        view: o
      });
    };
    var f = function f(t, e, n, i) {
      t.add(i, {
        label: n,
        category: e,
        content: {
          type: i
        },
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n      <div class=\"drap-on-six\"><svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n      viewBox=\"0 0 42 42\" width=\"32\" height=\"50\">\n     <path d=\"M37.059,8H26H16H4.941C2.224,8,0,10.282,0,13s2.224,5,4.941,5H16h10h11.059 C39.776,18,42,15.718,42,13S39.776,8,37.059,8z\"/>\n     <path d=\"M37.059,24H26H16H4.941C2.224,24,0,26.282,0,29s2.224,5,4.941,5H16h10h11.059 C39.776,34,42,31.718,42,29S39.776,24,37.059,24z\"/>\n    </svg></div>\n      <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n        <a\n          target=\"_blank\"\n          href=\"#\"\n          draggable=\"false\"\n        >\n          <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </div>\n      <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n    </div>\n  ");
        }
      });
    };
    var m = function m(t, e, n) {
      var i = t.getType("default"),
        r = i.model,
        a = i.view;
      t.addType(n, {
        model: r.extend({
          defaults: Object.assign({}, r.prototype.defaults, {
            "custom-name": e,
            tagName: "div",
            resizable: !0,
            classes: ["w-100"]
          })
        }, {
          isComponent: function isComponent(t) {
            if (t && t.classList && t.classList.contains("w-100")) return {
              type: n
            };
          }
        }),
        view: a
      });
    };
    var v = function v(t, e, n, i) {
      t.add(i, {
        label: n,
        category: e,
        content: {
          type: i,
          classes: ["row"]
        },
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n      <div class=\"drap-on-six\">").concat(s, "</div>\n      <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n        <a\n          target=\"_blank\"\n          href=\"https://academy.drapcode.com/docs/app-builder/layout-component-row-column-break#row\"\n          draggable=\"false\"\n        >\n          <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </div>\n      <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n    </div>\n  ");
        }
      });
    };
    var b = function b(t, e, n) {
      var i = t.getType("default"),
        r = i.model,
        a = i.view;
      t.addType(n, {
        model: r.extend({
          defaults: Object.assign({}, r.prototype.defaults, {
            "custom-name": e,
            tagName: "div",
            draggable: ".container, .container-fluid, .data-group, .data-list, .jumbotron, form, form *",
            resizable: 1,
            droppable: !0,
            traits: [{
              type: "class_select",
              options: [{
                value: "",
                name: "Yes"
              }, {
                value: "no-gutters",
                name: "No"
              }],
              label: "Gutters?"
            }].concat(r.prototype.defaults.traits)
          })
        }, {
          isComponent: function isComponent(t) {
            if (t && t.classList && t.classList.contains("row")) return {
              type: n
            };
          }
        }),
        view: a
      });
    };
    var y = function y(t, e, n, i) {
      t.add(i, {
        label: n,
        category: e,
        content: "<div class=\"media\">\n               <img class=\"mr-3\" src=\"\">\n               <div class=\"media-body\">\n               <h5>Media heading</h5>\n               <div>Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in faucibus.</div>\n               </div>\n               </div>",
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n    <div class=\"drap-on-six\">").concat(h, "</div>\n    <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n      <a\n        target=\"_blank\"\n        href=\"#\"\n        draggable=\"false\"\n      >\n        <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n      </a>\n    </div>\n    <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n  </div>\n             ");
        }
      });
    };
    var w = function w(t, e, n) {
        var i = t.getType("default"),
          r = i.model,
          a = i.view;
        t.addType(n, {
          model: r.extend({
            defaults: Object.assign({}, r.prototype.defaults, {
              "custom-name": e,
              resizable: !0,
              tagName: "div",
              classes: ["media"]
            })
          }, {
            isComponent: function isComponent(t) {
              if (t && t.classList && t.classList.contains("media")) return {
                type: "media"
              };
            }
          }),
          view: a
        }), t.addType("media_body", {
          model: r.extend({
            defaults: Object.assign({}, r.prototype.defaults, {
              "custom-name": "Media Body",
              tagName: "div",
              classes: ["media-body"]
            })
          }, {
            isComponent: function isComponent(t) {
              if (t && t.classList && t.classList.contains("media-body")) return {
                type: "media_body"
              };
            }
          }),
          view: a
        });
      },
      x = "<svg aria-hidden=\"true\" width=\"32\" height=\"50\" focusable=\"false\" data-prefix=\"fas\" data-icon=\"font\" class=\"svg-inline--fa fa-font fa-w-14\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\"><path fill=\"currentColor\" d=\"M432 416h-23.41L277.88 53.69A32 32 0 0 0 247.58 32h-47.16a32 32 0 0 0-30.3 21.69L39.41 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-19.58l23.3-64h152.56l23.3 64H304a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM176.85 272L224 142.51 271.15 272z\"></path></svg>\n";
    var j = function j(t, e, n, i) {
      t.add("text", {
        label: n,
        category: e,
        content: {
          type: "text",
          content: "Insert your text here"
        },
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n      <div class=\"drap-on-six\">\n        ").concat(x, "\n      </div>\n      <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n        <a\n          target=\"_blank\"\n          href=\"https://academy.drapcode.com/docs/app-builder/basic-component-text\"\n          draggable=\"false\"\n        >\n          <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </div>\n      <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n    </div>\n  ");
        }
      });
    };
    var C = function C(t, e, n) {
        var i = t.getType("default"),
          r = (i.view, i.model),
          a = t.getType("text"),
          o = a.view;
        t.addType(n, {
          model: r.extend({
            defaults: _objectSpread({}, r.prototype.defaults, {
              "custom-name": e,
              tagName: "div",
              droppable: !0,
              editable: !0,
              resizable: !0,
              traits: [].concat(_toConsumableArray(a.model.prototype.defaults.traits), [{
                type: "webconnect-text",
                label: !1,
                content: "Insert your text here"
              }])
            })
          }),
          view: o
        });
      },
      M = "<svg aria-hidden=\"true\" width=\"32\" height=\"50\" focusable=\"false\" data-prefix=\"fas\" data-icon=\"image\" class=\"svg-inline--fa fa-image fa-w-16\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><path fill=\"currentColor\" d=\"M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z\"></path></svg>\n";
    var k = function k(t, e, n, i) {
      t.add(i, {
        label: n,
        category: e,
        content: {
          type: i,
          style: {
            height: "250px"
          }
        },
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n      <div class=\"drap-on-six\">").concat(M, "</div>\n      <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n        <a\n          target=\"_blank\"\n          href=\"https://academy.drapcode.com/docs/app-builder/basic-component-image\"\n          draggable=\"false\"\n        >\n          <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </div>\n      <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n    </div>\n  ");
        }
      });
    };
    var O = function O(t, e, n) {
      var i = t.getType("image"),
        r = i.model,
        a = i.view,
        o = t.getType("default").model;
      t.addType(n, {
        model: r.extend({
          defaults: _objectSpread({}, r.prototype.defaults, {
            "custom-name": e,
            tagName: "img",
            resizable: 1,
            loading: "eager",
            attributes: {
              src: "https://drapcode-static.s3.amazonaws.com/default.png",
              loading: "eager"
            },
            classes: ["img-fluid"],
            traits: [{
              type: "text",
              label: "Source (URL)",
              name: "src"
            }, {
              type: "select",
              options: [{
                value: "eager",
                name: "Eager (Default: Loads Immediately)"
              }, {
                value: "lazy",
                name: "Lazy (Loads Asynchronously)"
              }, {
                value: "auto",
                name: "Auto"
              }],
              label: "Load Type",
              name: "loading"
            }].concat(_toConsumableArray(r.prototype.defaults.traits), _toConsumableArray(o.prototype.defaults.traits), [{
              type: "webconnect-image",
              label: !1,
              content: "Insert your text here"
            }])
          })
        }, {
          isComponent: function isComponent(t) {
            if (t && "IMG" === t.tagName) return {
              type: n
            };
          }
        }),
        view: a
      });
    };
    var T = function T(t, e, n, i) {
      t.add(i, {
        label: n,
        category: e,
        content: {
          type: i
        },
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n      <div class=\"drap-on-six\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 576 512\" width=\"32\" height=\"50\"><path d=\"M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z\"/></svg></div>\n      <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n        <a\n          target=\"_blank\"\n          href=\"https://academy.drapcode.com/docs/app-builder/basic-component-video\"\n          draggable=\"false\"\n        >\n          <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </div>\n      <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n    </div>    \n    ");
        }
      });
    };
    var S = function S(t, e, n) {
        var i = t.getType("video"),
          r = i.model,
          a = i.view;
        n = "bs-embed-responsive", t.addType(n, {
          model: r.extend({
            defaults: Object.assign({}, r.prototype.defaults, {
              "custom-name": e,
              resizable: !0,
              droppable: !1,
              draggable: !1,
              copyable: !1,
              classes: ["embed-responsive-item"]
            })
          }, {
            isComponent: function isComponent(t) {
              if (t && "embed-responsive-item" === t.className) return {
                type: n
              };
            }
          }),
          view: a
        });
      },
      N = function N(t, e, n) {
        var i = "https://download.blender.org/peach/bigbuckbunny_movies/BigBuckBunny_320x180.mp4",
          r = t.getType("default"),
          a = r.model,
          o = r.view;
        t.addType(n, {
          model: a.extend({
            defaults: Object.assign({}, a.prototype.defaults, {
              "custom-name": e,
              tagName: "div",
              resizable: !0,
              droppable: !1,
              classes: ["embed-responsive", "embed-responsive-16by9"],
              traits: [{
                type: "class_select",
                options: [{
                  value: "embed-responsive-21by9",
                  name: "21:9"
                }, {
                  value: "embed-responsive-16by9",
                  name: "16:9"
                }, {
                  value: "embed-responsive-4by3",
                  name: "4:3"
                }, {
                  value: "embed-responsive-1by1",
                  name: "1:1"
                }],
                label: "Aspect Ratio"
              }].concat(a.prototype.defaults.traits)
            })
          }, {
            isComponent: function isComponent(t) {
              if (t && "embed-responsive" === t.className) return {
                type: n
              };
            }
          }),
          view: o.extend({
            init: function init() {
              var t = ["Aspect Ratio"].map(function (t) {
                return "change:".concat(t);
              }).join(" ");
              this.listenTo(this.model, t, this.render);
              var e = this.model.components();
              e.length || e.add("<iframe class=\"embed-responsive-item\" src=\"".concat(i, "\"></iframe>"));
            }
          })
        });
      },
      L = "<svg aria-hidden=\"true\" width=\"32\" height=\"50\" focusable=\"false\" data-prefix=\"fas\" data-icon=\"heading\" class=\"svg-inline--fa fa-heading fa-w-16\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><path fill=\"currentColor\" d=\"M448 96v320h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H320a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V288H160v128h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V96H32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-32v128h192V96h-32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16z\"></path></svg>\n";
    var D = function D(t, e, n, i) {
      t.add(i, {
        label: n,
        category: e,
        content: {
          type: i,
          content: "My Sample Heading"
        },
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n      <div class=\"drap-on-six\">").concat(L, "</div>\n      <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n        <a\n          target=\"_blank\"\n          href=\"https://academy.drapcode.com/docs/app-builder/basic-component-header\"\n          draggable=\"false\"\n        >\n          <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </div>\n      <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n    </div>    \n    ");
        }
      }), t.add(i + "frequently_used", {
        label: n,
        category: "Frequently Used",
        attributes: {
          style: "order: 0"
        },
        content: {
          type: i,
          content: "My Sample Heading"
        },
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n      <div class=\"drap-on-six\">").concat(L, "</div>\n      <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n        <a\n          target=\"_blank\"\n          href=\"https://academy.drapcode.com/docs/app-builder/basic-component-header\"\n          draggable=\"false\"\n        >\n          <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </div>\n      <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n    </div>    \n    ");
        }
      });
    };
    var E = function E(t, e, n) {
      var i = t.getType("text"),
        r = i.model,
        a = i.view;
      t.addType(n, {
        model: r.extend({
          defaults: Object.assign({}, r.prototype.defaults, {
            "custom-name": e,
            resizable: !0,
            tagName: "h1",
            traits: [{
              type: "select",
              options: [{
                value: "h1",
                name: "One (largest)"
              }, {
                value: "h2",
                name: "Two"
              }, {
                value: "h3",
                name: "Three"
              }, {
                value: "h4",
                name: "Four"
              }, {
                value: "h5",
                name: "Five"
              }, {
                value: "h6",
                name: "Six (smallest)"
              }],
              label: "Size",
              name: "tagName",
              changeProp: 1
            }, {
              type: "class_select",
              options: [{
                value: "",
                name: "None"
              }, {
                value: "display-1",
                name: "One (largest)"
              }, {
                value: "display-2",
                name: "Two "
              }, {
                value: "display-3",
                name: "Three "
              }, {
                value: "display-4",
                name: "Four (smallest)"
              }],
              label: "Display Heading"
            }].concat(r.prototype.defaults.traits)
          })
        }, {
          isComponent: function isComponent(t) {
            if (t && ["H1", "H2", "H3", "H4", "H5", "H6"].includes(t.tagName)) return {
              type: n
            };
          }
        }),
        view: a
      });
    };
    var I = function I(t, e, n, i) {
      t.add(i, {
        label: n,
        category: e,
        content: {
          type: i,
          content: "Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus."
        },
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n      <div class=\"drap-on-six\"><svg viewBox=\"0 0 20 20\" width=\"32\" height=\"50\" xmlns=\"http://www.w3.org/2000/svg\">\n      <g transform=\"translate(-380.000000, -5199.000000)\">\n          <g transform=\"translate(56.000000, 160.000000)\">\n              <path d=\"M334,5049 L330,5049 C325,5049 325,5041 330,5041 L334,5041 L334,5049 Z M330,5039 C322,5039 322,5051 330,5051 L334,5051 L334,5059 L336,5059 L336,5041 L338,5041 L338,5059 L340,5059 L340,5041 L344,5041 L344,5039 L330,5039 Z\"></path>\n          </g>\n      </g>\n  </svg></div>\n      <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n        <a\n          target=\"_blank\"\n          href=\"https://academy.drapcode.com/docs/app-builder/basic-component-paragraph\"\n          draggable=\"false\"\n        >\n          <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </div>\n      <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n    </div>\n  ");
        }
      });
    };
    var P = function P(t, e, n) {
      var i = t.getType("text"),
        r = i.model,
        a = i.view;
      t.addType(n, {
        model: r.extend({
          defaults: Object.assign({}, r.prototype.defaults, {
            "custom-name": e,
            resizable: !0,
            tagName: "p",
            traits: [{
              type: "class_select",
              options: [{
                value: "",
                name: "No"
              }, {
                value: "lead",
                name: "Yes"
              }],
              label: "Lead?"
            }].concat(r.prototype.defaults.traits)
          })
        }, {
          isComponent: function isComponent(t) {
            if (t && t.tagName && "P" === t.tagName) return {
              type: n
            };
          }
        }),
        view: a
      });
    };
    var A = function A(t, e, n, i) {
      t.add(i, {
        label: n,
        category: e,
        content: '<input name="input1" class="form-control"/>',
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n      <div class=\"drap-on-six\"><svg class=\"gjs-block-svg\" viewBox=\"0 0 24 24\" width=\"32\" height=\"50\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path class=\"gjs-block-svg-path\" d=\"M22,9 C22,8.4 21.5,8 20.75,8 L3.25,8 C2.5,8 2,8.4 2,9 L2,15 C2,15.6 2.5,16 3.25,16 L20.75,16 C21.5,16 22,15.6 22,15 L22,9 Z M21,15 L3,15 L3,9 L21,9 L21,15 Z\"></path>\n      <polygon class=\"gjs-block-svg-path\" points=\"4 10 5 10 5 14 4 14\"></polygon>\n    </svg></div>\n      <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n        <a\n          target=\"_blank\"\n          href=\"https://academy.drapcode.com/docs/app-builder/form-components#input\"\n          draggable=\"false\"\n        >\n          <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </div>\n      <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n    </div>\n  ");
        }
      });
    };
    var z = function z(t, e, n, i, r) {
      var a = t.getType("default"),
        o = a.model,
        s = a.view;
      t.addType(n, {
        model: o.extend({
          defaults: _objectSpread({}, o.prototype.defaults, {
            "custom-name": e,
            tagName: "input",
            draggable: "form .form-group",
            droppable: !1,
            resizable: !0,
            minLength: 0,
            maxLength: 200,
            traits: [i.value, i.name, i.placeholder, {
              label: "Min Length",
              type: "number",
              name: "minLength",
              placeholder: "eg. 5",
              min: 0,
              max: 200,
              step: 1,
              default: 0
            }, {
              label: "Max Length",
              type: "number",
              name: "maxLength",
              placeholder: "eg. 20",
              min: 0,
              max: 300,
              step: 1,
              default: 200
            }, {
              label: "Read Only",
              type: "checkbox",
              name: "readonly"
            }, {
              label: "Persist Value",
              description: "Don't reset value on form submit",
              type: "checkbox",
              name: "persistvalue"
            }, {
              label: r.labels.trait_type,
              type: "select",
              name: "type",
              options: [{
                value: "text",
                name: r.labels.type_text
              }, {
                value: "email",
                name: r.labels.type_email
              }, {
                value: "password",
                name: r.labels.type_password
              }, {
                value: "number",
                name: r.labels.type_number
              }, {
                value: "date",
                name: r.labels.type_date
              }, {
                value: "datetime-local",
                name: "datetime-local"
              }, {
                value: "hidden",
                name: r.labels.type_hidden
              }]
            }]
          })
        }, {
          isComponent: function isComponent(t) {
            if ("INPUT" === t.tagName) return {
              type: n
            };
          }
        }),
        view: s
      });
    };
    var _ = function _(t, e, n, i, r) {
      t.add("form_group_input", {
        label: n,
        category: e,
        content: "\n      <div class=\"form-group\">\n        <label>Name</label>\n        <input name=\"name\" placeholder=\"Type here your name\" class=\"form-control\"/>\n      </div>\n      ",
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n    <div class=\"drap-on-six\"><svg class=\"gjs-block-svg\" viewBox=\"0 0 24 24\" width=\"32\" height=\"50\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path class=\"gjs-block-svg-path\" d=\"M22,9 C22,8.4 21.5,8 20.75,8 L3.25,8 C2.5,8 2,8.4 2,9 L2,15 C2,15.6 2.5,16 3.25,16 L20.75,16 C21.5,16 22,15.6 22,15 L22,9 Z M21,15 L3,15 L3,9 L21,9 L21,15 Z\"></path>\n    <polygon class=\"gjs-block-svg-path\" points=\"4 10 5 10 5 14 4 14\"></polygon>\n    </svg>\n    </div>\n    <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n      <a\n        target=\"_blank\"\n        href=\"https://academy.drapcode.com/docs/app-builder/form-components#form-group\"\n        draggable=\"false\"\n      >\n        <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n      </a>\n    </div>\n    <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n  </div>\n    ");
        }
      }), t.add("input_group", {
        label: i,
        category: e,
        content: "\n      <div class=\"input-group\">\n        <div class=\"input-group-prepend\">\n          <span class=\"input-group-text\">$</span>\n        </div>\n        <input name=\"input1\" type=\"text\" class=\"form-control\" aria-label=\"Amount (to the nearest dollar)\">\n        <div class=\"input-group-append\">\n          <span class=\"input-group-text\">.00</span>\n        </div>\n      </div>\n      ",
        render: function render(t) {
          var e = t.model,
            n = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(n, "-label ").concat(n, "__drapcode-wrap\">\n    <div class=\"drap-on-six\"><svg class=\"gjs-block-svg\" viewBox=\"0 0 24 24\" width=\"32\" height=\"50\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path class=\"gjs-block-svg-path\" d=\"M22,9 C22,8.4 21.5,8 20.75,8 L3.25,8 C2.5,8 2,8.4 2,9 L2,15 C2,15.6 2.5,16 3.25,16 L20.75,16 C21.5,16 22,15.6 22,15 L22,9 Z M21,15 L3,15 L3,9 L21,9 L21,15 Z\"></path>\n    <polygon class=\"gjs-block-svg-path\" points=\"4 10 5 10 5 14 4 14\"></polygon>\n    </svg></div>\n    <div class=\"drapcode-compo-qustion ").concat(n, "__info\">\n      <a\n        target=\"_blank\"\n        href=\"https://academy.drapcode.com/docs/app-builder/form-components#input-group\"\n        draggable=\"false\"\n      >\n        <i class=\"bem-Svg ").concat(n, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(i, "?\"></i>\n      </a>\n    </div>\n    <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n  </div>\n    ");
        }
      });
    };
    var H = function H(t, e, n) {
      var i = t.getType("default"),
        r = i.model,
        a = i.view;
      t.addType("input_group", {
        model: r.extend({
          defaults: _objectSpread({}, r.prototype.defaults, {
            "custom-name": e,
            resizable: !0,
            tagName: "div",
            traits: []
          })
        }, {
          isComponent: function isComponent(t) {
            if (t && t.classList && t.classList.contains("form_group_input")) return {
              type: n
            };
          }
        }),
        view: a
      });
    };
    var V = function V(t, e, n, i) {
      t.add(i, {
        label: n,
        category: e,
        content: '<textarea name="textarea1" class="form-control"></textarea>',
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n      <div class=\"drap-on-six\">\n      <svg class=\"gjs-block-svg\" viewBox=\"0 0 24 24\" width=\"32\" height=\"50\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path class=\"gjs-block-svg-path\" d=\"M22,7.5 C22,6.6 21.5,6 20.75,6 L3.25,6 C2.5,6 2,6.6 2,7.5 L2,16.5 C2,17.4 2.5,18 3.25,18 L20.75,18 C21.5,18 22,17.4 22,16.5 L22,7.5 Z M21,17 L3,17 L3,7 L21,7 L21,17 Z\"></path>\n        <polygon class=\"gjs-block-svg-path\" points=\"4 8 5 8 5 12 4 12\"></polygon>\n        <polygon class=\"gjs-block-svg-path\" points=\"19 7 20 7 20 17 19 17\"></polygon>\n        <polygon class=\"gjs-block-svg-path\" points=\"20 8 21 8 21 9 20 9\"></polygon>\n        <polygon class=\"gjs-block-svg-path\" points=\"20 15 21 15 21 16 20 16\"></polygon>\n      </svg>\n      </div>\n      <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n        <a\n          target=\"_blank\"\n          href=\"https://academy.drapcode.com/docs/app-builder/form-components#textarea\"\n          draggable=\"false\"\n        >\n          <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </div>\n      <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n    </div>\n  ");
        }
      });
    };
    var F = function F(t, e, n, i) {
        var r = t.getType("default").view,
          a = t.getType("input").model;
        t.addType(n, {
          model: a.extend({
            defaults: _objectSpread({}, a.prototype.defaults, {
              "custom-name": e,
              resizable: !0,
              tagName: "textarea",
              traits: [i.name, i.placeholder]
            })
          }, {
            isComponent: function isComponent(t) {
              if ("TEXTAREA" === t.tagName) return {
                type: n
              };
            }
          }),
          view: r
        });
      },
      R = "<svg aria-hidden=\"true\" width=\"32\" height=\"50\" focusable=\"false\" data-prefix=\"fas\" data-icon=\"check-square\" class=\"svg-inline--fa fa-check-square fa-w-14\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\"><path fill=\"currentColor\" d=\"M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z\"></path></svg>\n";
    var B = function B(t, e, n, i) {
      t.add(i, {
        label: n,
        category: e,
        content: "\n    <div class=\"form-group col-12 col-md-12\">\n      <input name=\"defaultCheck\" type=\"checkbox\" id=\"defaultCheck1\" class=\"form-check-input dc-checkbox\" value=\"\"/>\n      <label class=\"form-check-label\" for=\"defaultCheck1\">Default checkbox</label>\n    </div>\n      ",
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n      <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n      <div class=\"drap-on-six\">").concat(R, "</div>\n      <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n        <a\n          target=\"_blank\"\n          href=\"https://academy.drapcode.com/docs/app-builder/form-components#checkbox\"\n          draggable=\"false\"\n        >\n          <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </div>\n      <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n    </div>\n    ");
        }
      });
    };
    var W = function W(t, e, n, i) {
        var r = t.getType("default"),
          a = r.model,
          o = r.view,
          s = t.getType("input").model;
        t.addType(n, {
          model: a.extend({
            defaults: _objectSpread({}, s.prototype.defaults, {
              "custom-name": e,
              copyable: !1,
              droppable: !1,
              resizable: !0,
              attributes: {
                type: "checkbox"
              },
              traits: [i.id, i.name, i.value]
            }),
            init: function init() {
              this.listenTo(this, "change:checked", this.handleChecked);
            },
            handleChecked: function handleChecked() {
              var t = this.get("checked"),
                e = this.get("attributes");
              var n = this.view;
              t ? e.checked = !0 : delete e.checked, n && (n.el.checked = t), this.set("attributes", _objectSpread({}, e));
            }
          }, {
            isComponent: function isComponent(t) {
              if ("INPUT" === t.tagName && "checkbox" === t.type) return {
                type: n
              };
            }
          }),
          view: o.extend({
            events: {
              click: "handleClick"
            },
            handleClick: function handleClick(t) {
              t.preventDefault();
            }
          })
        });
      },
      Y = "<svg aria-hidden=\"true\" width=\"32\" height=\"50\" focusable=\"false\" data-prefix=\"far\" data-icon=\"dot-circle\" class=\"svg-inline--fa fa-dot-circle fa-w-16\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><path fill=\"currentColor\" d=\"M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z\"></path></svg>\n";
    var U = function U(t, e, n, i) {
      t.add(i, {
        label: n,
        category: e,
        content: "\n        <div class=\"form-group col-12 col-md-12\">\n          <input name=\"exampleRadios\" type=\"radio\" id=\"exampleRadios1\" class=\"form-check-input dc-radio\" value=\"option1\"/>\n          <label class=\"form-radio-label\" for=\"exampleRadios1\">Default radio</label>\n        </div>\n      ",
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n      <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n      <div class=\"drap-on-six\">").concat(Y, "</div>\n      <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n        <a\n          target=\"_blank\"\n          href=\"https://academy.drapcode.com/docs/app-builder/form-components#radio-button\"\n          draggable=\"false\"\n        >\n          <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </div>\n      <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n    </div>\n    ");
        }
      });
    };
    var Z = function Z(t, e, n) {
        var i = t.getType("checkbox");
        t.addType(n, {
          model: i.model.extend({
            defaults: _objectSpread({}, i.model.prototype.defaults, {
              "custom-name": e,
              resizable: !0,
              attributes: {
                type: "radio"
              }
            })
          }, {
            isComponent: function isComponent(t) {
              if ("INPUT" === t.tagName && "radio" === t.type) return {
                type: n
              };
            }
          }),
          view: i.view
        });
      },
      G = (n(10), "<svg class=\"gjs-block-svg\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path class=\"gjs-block-svg-path\" d=\"M22,11.875 C22,11.35 21.5,11 20.75,11 L3.25,11 C2.5,11 2,11.35 2,11.875 L2,17.125 C2,17.65 2.5,18 3.25,18 L20.75,18 C21.5,18 22,17.65 22,17.125 L22,11.875 Z M21,17 L3,17 L3,12 L21,12 L21,17 Z\" fill-rule=\"nonzero\"></path>\n    <rect class=\"gjs-block-svg-path\" x=\"2\" y=\"5\" width=\"14\" height=\"5\" rx=\"0.5\"></rect>\n    <polygon class=\"gjs-block-svg-path\" fill-rule=\"nonzero\" points=\"4 13 5 13 5 16 4 16\"></polygon>\n</svg>\n");
    var q = function q(t, e, n, i) {
      t.add(i, {
        label: n,
        category: e,
        content: {
          type: "label",
          tagName: "span",
          classes: ["label", "badge-secondary"],
          content: "New!"
        },
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n      <div class=\"drap-on-six\">").concat(G, "</div>\n      <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n        <a\n          target=\"_blank\"\n          href=\"https://academy.drapcode.com/docs/app-builder/form-components#label\"\n          draggable=\"false\"\n        >\n          <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </div>\n      <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n    </div>\n  ");
        }
      });
    };
    var $ = function $(t, e, n) {
      var i = t.getType("text"),
        r = i.model,
        a = i.view;
      t.addType(n, {
        model: r.extend({
          defaults: Object.assign({}, r.prototype.defaults, {
            "custom-name": e,
            tagName: "span",
            classes: ["label"],
            traits: [{
              type: "class_select",
              options: [{
                value: "",
                name: "None"
              }, {
                value: "badge-primary",
                name: "Primary"
              }, {
                value: "badge-secondary",
                name: "Secondary"
              }, {
                value: "badge-success",
                name: "Success"
              }, {
                value: "badge-info",
                name: "Info"
              }, {
                value: "badge-warning",
                name: "Warning"
              }, {
                value: "badge-danger",
                name: "Danger"
              }, {
                value: "badge-light",
                name: "Light"
              }, {
                value: "badge-dark",
                name: "Dark"
              }],
              label: "Context"
            }, {
              type: "text",
              label: "For",
              name: "for"
            }].concat(r.prototype.defaults.traits)
          })
        }, {
          isComponent: function isComponent(t) {
            if (t.getAttribute && "label" === t.getAttribute("data-gjs-type")) return {
              type: n
            };
          }
        }),
        view: a
      });
    };
    var Q = function Q(t, e, n, i) {
      t.add(i, {
        label: n,
        category: e,
        content: "<input type=\"file\" name=\"file\" class=\"form-control-file\" onchange=\"fileUpload\">",
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n      <div class=\"drap-on-six\"><svg class=\"gjs-block-svg\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"50\">\n      <path class=\"gjs-block-svg-path\" d=\"M22,9 C22,8.4 21.5,8 20.75,8 L3.25,8 C2.5,8 2,8.4 2,9 L2,15 C2,15.6 2.5,16 3.25,16 L20.75,16 C21.5,16 22,15.6 22,15 L22,9 Z M21,15 L3,15 L3,9 L21,9 L21,15 Z\"></path>\n      <polygon class=\"gjs-block-svg-path\" points=\"4 10 5 10 5 14 4 14\"></polygon>\n  </svg></div>\n      <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n        <a\n          target=\"_blank\"\n          href=\"https://academy.drapcode.com/docs/app-builder/form-components#file-upload-field\"\n          draggable=\"false\"\n        >\n          <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </div>\n      <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n    </div>\n  ");
        }
      });
    };
    var J = function J(t, e, n, i) {
      var r = t.getType("default"),
        a = r.model,
        o = r.view;
      n = "file-input", t.addType(n, {
        model: a.extend({
          defaults: _objectSpread({}, a.prototype.defaults, {
            "custom-name": e,
            tagName: "input",
            draggable: "form .form-group",
            droppable: !1,
            resizable: !0,
            traits: [i.name]
          })
        }, {
          isComponent: function isComponent(t) {
            if ("INPUT" === t.tagName && function (t, e) {
              var n = t.className;
              if (n = n && n.toString(), n && n.split(" ").indexOf(e) >= 0) return 1;
            }(t, "form-control-file")) return {
              type: n
            };
          }
        }),
        view: o
      });
    };
    var X = function X(t, e, n, i) {
      t.add(i, {
        label: n,
        category: e,
        content: "<select class=\"form-control\" name=\"select1\">\n        ".concat(n ? "<option value=\"\">".concat(n, "</option>") : "", "\n        </select>"),
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "<div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n    <div class=\"drap-on-six\">\n    <svg class=\"gjs-block-svg\" viewBox=\"0 0 24 24\" width=\"32\" height=\"50\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path class=\"gjs-block-svg-path\" d=\"M22,9 C22,8.4 21.5,8 20.75,8 L3.25,8 C2.5,8 2,8.4 2,9 L2,15 C2,15.6 2.5,16 3.25,16 L20.75,16 C21.5,16 22,15.6 22,15 L22,9 Z M21,15 L3,15 L3,9 L21,9 L21,15 Z\" fill-rule=\"nonzero\"></path>\n    <polygon class=\"gjs-block-svg-path\" transform=\"translate(18.500000, 12.000000) scale(1, -1) translate(-18.500000, -12.000000) \" points=\"18.5 11 20 13 17 13\"></polygon>\n    <rect class=\"gjs-block-svg-path\" x=\"4\" y=\"11.5\" width=\"11\" height=\"1\"></rect>\n    </svg>\n    </div>\n    <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n      <a\n        target=\"_blank\"\n        href=\"https://academy.drapcode.com/docs/app-builder/form-components#select-dropdown-list\"\n        draggable=\"false\"\n      >\n        <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n      </a>\n    </div>\n    <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n  </div>\n    ");
        }
      });
    };
    var K = function K(t, e, n, i, r, a) {
      var o = e.getType("default"),
        s = o.model,
        l = e.getType("input").model;
      e.addType(i, {
        model: s.extend({
          defaults: _objectSpread({}, l.prototype.defaults, {
            "custom-name": n,
            resizable: !0,
            tagName: "select",
            traits: [r.name, {
              label: a.labels.trait_options,
              type: "select-options"
            }]
          })
        }, {
          isComponent: function isComponent(t) {
            if ("SELECT" === t.tagName) return {
              type: i
            };
          }
        }),
        view: o.view.extend({
          events: {
            mousedown: "handleClick"
          },
          handleClick: function handleClick(t) {
            t.preventDefault();
          }
        })
      });
      t.TraitManager.addType("select-options", {
        events: {
          keyup: "onChange"
        },
        onValueChange: function onValueChange() {
          var t = this.model.get("value").trim().split("\n"),
            e = [];
          for (var _n6 = 0; _n6 < t.length; _n6++) {
            var _i7 = t[_n6].split(a.optionsStringSeparator),
              _r3 = {
                tagName: "option",
                attributes: {}
              };
            _i7[1] ? (_r3.content = _i7[1], _r3.attributes.value = _i7[0]) : (_r3.content = _i7[0], _r3.attributes.value = _i7[0]), e.push(_r3);
          }
          this.target.get("components").reset(e), this.target.view.render();
        },
        getInputEl: function getInputEl() {
          if (!this.$input) {
            var _t6 = "";
            var _e10 = this.target.get("components");
            for (var _n7 = 0; _n7 < _e10.length; _n7++) {
              var _i8 = _e10.models[_n7],
                _r4 = _i8.get("attributes").value || "";
              _t6 += "".concat(_r4).concat(a.optionsStringSeparator).concat(_i8.get("content"), "\n");
            }
            this.$input = document.createElement("textarea"), this.$input.value = _t6;
          }
          return this.$input;
        }
      });
    };
    var tt = function tt(t, e, n, i) {
      t.add(i, {
        label: n,
        category: e,
        content: {
          type: "badge",
          tagName: "span",
          classes: ["badge"],
          content: "10"
        },
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n      <div class=\"drap-on-six\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" width=\"32\" height=\"50\">\x3c!-- Font Awesome Free 5.15.3 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) --\x3e<path d=\"M458.622 255.92l45.985-45.005c13.708-12.977 7.316-36.039-10.664-40.339l-62.65-15.99 17.661-62.015c4.991-17.838-11.829-34.663-29.661-29.671l-61.994 17.667-15.984-62.671C337.085.197 313.765-6.276 300.99 7.228L256 53.57 211.011 7.229c-12.63-13.351-36.047-7.234-40.325 10.668l-15.984 62.671-61.995-17.667C74.87 57.907 58.056 74.738 63.046 92.572l17.661 62.015-62.65 15.99C.069 174.878-6.31 197.944 7.392 210.915l45.985 45.005-45.985 45.004c-13.708 12.977-7.316 36.039 10.664 40.339l62.65 15.99-17.661 62.015c-4.991 17.838 11.829 34.663 29.661 29.671l61.994-17.667 15.984 62.671c4.439 18.575 27.696 24.018 40.325 10.668L256 458.61l44.989 46.001c12.5 13.488 35.987 7.486 40.325-10.668l15.984-62.671 61.994 17.667c17.836 4.994 34.651-11.837 29.661-29.671l-17.661-62.015 62.65-15.99c17.987-4.302 24.366-27.367 10.664-40.339l-45.984-45.004z\"/></svg></div>\n      <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n        <a\n          target=\"_blank\"\n          href=\"https://academy.drapcode.com/docs/app-builder/basic-component-badge\"\n          draggable=\"false\"\n        >\n          <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </div>\n      <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n    </div>\n  ");
        },
        style: {
          "vertical-align": "middle",
          "border-color": "#777"
        }
      });
    };
    var et = function et(t, e, n) {
      var i = t.getType("text"),
        r = i.model,
        a = i.view;
      t.addType(n, {
        model: r.extend({
          defaults: Object.assign({}, r.prototype.defaults, {
            "custom-name": e,
            tagName: "span",
            classes: ["badge"],
            traits: r.prototype.defaults.traits
          })
        }, {
          isComponent: function isComponent(t) {
            if (t.getAttribute && "badge" === t.getAttribute("data-gjs-type")) return {
              type: n
            };
          }
        }),
        view: a
      });
    };
    var nt = function nt(t, e, n, i) {
        t.add(i, {
          label: n,
          category: e,
          content: "<div class=\"row\">\n  <div class=\"col-4\">\n    <img\n      class=\"img-fluid\"\n      src=\"http://placehold.it/150x150/78c5d6/fff/\"\n      alt=\"Image\"\n    />\n  </div>\n  <div class=\"col-8\">\n    <strong class=\"mb-2 text-primary\">World</strong>\n    <h3 class=\"mb-0\">Featured post</h3>\n    <p class=\"card-text mb-auto\">\n      This is a wider card with supporting text below as a natural lead-in\n      to additional content.\n    </p>\n  </div>\n</div>" + "<div class=\"row\">\n  <div class=\"col-4\">\n    <img\n      class=\"img-fluid\"\n      src=\"http://placehold.it/150x150/78c5d6/fff/\"\n      alt=\"Image\"\n    />\n  </div>\n  <div class=\"col-8\">\n    <strong class=\"mb-2 text-success\">Design</strong>\n    <h3 class=\"mb-0\">Post Title</h3>\n    <p class=\"card-text mb-auto\">\n      This is a wider card with supporting text below as a natural lead-in\n      to additional content.\n    </p>\n  </div>\n</div>",
          render: function render(t) {
            var e = t.model,
              i = t.className;
            return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n      <div class=\"drap-on-six\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" width=\"32\" height=\"50\">\n      <path d=\"M149.333 216v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-80c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zM125.333 32H24C10.745 32 0 42.745 0 56v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zm80 448H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm-24-424v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24zm24 264H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24z\"/>\n  </svg></div>\n      <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n        <a\n          target=\"_blank\"\n          href=\"https://academy.drapcode.com/docs/app-builder/layout-component-list\"\n          draggable=\"false\"\n        >\n          <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </div>\n      <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n    </div>\n  ");
          }
        });
      },
      it = function it(t, e, n, i) {
        var r = "<div class=\"card\">\n        <img class=\"card-img-top\" src=\"http://placehold.it/250x150/78c5d6/fff/\" alt=\"Image\"/>\n        <div class=\"card-body\">\n              <h1 class=\"card-title\">Title here</h1>\n              <p class=\"card-text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt</p>\n    </div>\n  </div>";
        t.add(i, {
          label: n,
          category: e,
          content: "<div class=\"row\">\n      <div class=\"col-md-6 col-sm-12 col-lg-6\">".concat(r, "</div>\n      <div class=\"col-md-6 col-sm-12 col-lg-6\">").concat(r, "</div>\n  </div>"),
          render: function render(t) {
            var e = t.model,
              i = t.className;
            return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n    <div class=\"drap-on-six\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" width=\"32\" height=\"50\">\n    <path d=\"M296 32h192c13.255 0 24 10.745 24 24v160c0 13.255-10.745 24-24 24H296c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24zm-80 0H24C10.745 32 0 42.745 0 56v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zM0 296v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm296 184h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H296c-13.255 0-24 10.745-24 24v160c0 13.255 10.745 24 24 24z\"/>\n</svg></div>\n    <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n      <a\n        target=\"_blank\"\n        href=\"#\"\n        draggable=\"false\"\n      >\n        <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n      </a>\n    </div>\n    <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n  </div>\n");
          }
        });
      },
      rt = function rt(t, e, n, i, r) {
        var a = "\n  <style>\n    .".concat(i, "-items-c {\n      display: inline-block;\n      float: right;\n    }\n    .").concat(i, " {\n      background-color: #cdcdcd;\n      color: #000;\n      min-height: 50px;\n      width: 100%;\n    }\n    .").concat(i, "-container {\n      max-width: 950px;\n      margin: 0 auto;\n      width: 95%;\n    }\n    .").concat(i, "-container::after {\n      content: \"\";\n      clear: both;\n      display: block;\n    }\n    .").concat(i, "-brand {\n      vertical-align: top;\n      display: inline-block;\n      padding: 5px;\n      min-height: 50px;\n      min-width: 50px;\n      color: inherit;\n      text-decoration: none;\n    }\n    .").concat(i, "-menu {\n      padding: 10px 0;\n      display: block;\n      float: right;\n      margin: 0;\n    }\n    .").concat(i, "-menu-link {\n      margin: 0;\n      color: inherit;\n      text-decoration: none;\n      display: inline-block;\n      padding: 10px 15px;\n    }\n    .").concat(i, "-burger {\n      margin: 10px 0;\n      width: 45px;\n      padding: 5px 10px;\n      display: none;\n      float: right;\n      cursor: pointer;\n    }\n    .").concat(i, "-burger-line {\n      padding: 1px;\n      background-color: white;\n      margin: 5px 0;\n    }\n    @media (max-width: 768px) {\n      .").concat(i, "-burger {\n        display: block;\n      }\n      .").concat(i, "-items-c {\n        display: none;\n        width: 100%;\n      }\n      .").concat(i, "-menu {\n        width: 100%;\n      }\n      .").concat(i, "-menu-link {\n        display: block;\n      }\n    }\n  </style>\n  ");
        t.add(i, {
          label: "\n    <svg class=\"gjs-block-svg\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path class=\"gjs-block-svg-path\" d=\"M22,9 C22,8.4 21.5,8 20.75,8 L3.25,8 C2.5,8 2,8.4 2,9 L2,15 C2,15.6 2.5,16 3.25,16 L20.75,16 C21.5,16 22,15.6 22,15 L22,9 Z M21,15 L3,15 L3,9 L21,9 L21,15 Z\" fill-rule=\"nonzero\"></path>\n      <rect class=\"gjs-block-svg-path\" x=\"15\" y=\"10\" width=\"5\" height=\"1\"></rect>\n      <rect class=\"gjs-block-svg-path\" x=\"15\" y=\"13\" width=\"5\" height=\"1\"></rect>\n      <rect class=\"gjs-block-svg-path\" x=\"15\" y=\"11.5\" width=\"5\" height=\"1\"></rect>\n    </svg>\n    <div class=\"gjs-block-label\">".concat(n, "</div>"),
          category: e,
          content: "<div class=\"".concat(i, "\" data-gjs-droppable=\"false\" data-gjs-custom-name=\"").concat(n, "\" data-gjs=\"").concat(r.refs.navbarRef, "\">\n    <div class=\"").concat(i, "-container\" data-gjs-droppable=\"false\" data-gjs-draggable=\"false\"\n      data-gjs-removable=\"false\" data-gjs-copyable=\"false\" data-gjs-highlightable=\"false\"\n      data-gjs-custom-name=\"").concat(r.labels.labelNavbarContainer, "\">\n      <a href=\"/\" class=\"").concat(i, "-brand\" data-gjs-droppable=\"true\"></a>\n      <div class=\"").concat(i, "-burger\" data-gjs-type=\"burger-menu\">\n        <div class=\"").concat(i, "-burger-line\" data-gjs-custom-name=\"").concat(r.labels.labelBurgerLine, "\" data-gjs-droppable=\"false\" data-gjs-draggable=\"false\"></div>\n        <div class=\"").concat(i, "-burger-line\" data-gjs-custom-name=\"").concat(r.labels.labelBurgerLine, "\" data-gjs-droppable=\"false\" data-gjs-draggable=\"false\"></div>\n        <div class=\"").concat(i, "-burger-line\" data-gjs-custom-name=\"").concat(r.labels.labelBurgerLine, "\" data-gjs-droppable=\"false\" data-gjs-draggable=\"false\"></div>\n      </div>\n      <div class=\"").concat(i, "-items-c\" data-gjs=\"").concat(r.refs.navbarItemsRef, "\">\n        <nav class=\"").concat(i, "-menu\" data-gjs=\"").concat(r.refs.menuRef, "\" data-gjs-custom-name=\"").concat(r.labels.labelMenu, "\">\n          <a href=\"#\" class=\"").concat(i, "-menu-link\" data-gjs-custom-name=\"").concat(r.labels.labelMenuLink, "\" data-gjs-draggable=\"[data-gjs=").concat(r.refs.menuRef, "]\">").concat(r.labels.labelHome, "</a>\n          <a href=\"#\" class=\"").concat(i, "-menu-link\" data-gjs-custom-name=\"").concat(r.labels.labelMenuLink, "\" data-gjs-draggable=\"[data-gjs=").concat(r.refs.menuRef, "]\">").concat(r.labels.labelAbout, "</a>\n          <a href=\"#\" class=\"").concat(i, "-menu-link\" data-gjs-custom-name=\"").concat(r.labels.labelMenuLink, "\" data-gjs-draggable=\"[data-gjs=").concat(r.refs.menuRef, "]\">").concat(r.labels.labelContact, "</a>\n        </nav>\n      </div>\n    </div>\n  </div>\n  ").concat(a)
        });
      };
    var at = function at(t, e, n) {
        var i = t.getType("default"),
          r = i.model;
        i.view;
        t.addType(n, {
          model: r.extend({
            defaults: _objectSpread({}, r.prototype.defaults, {
              "custom-name": e,
              draggable: !1,
              droppable: !1,
              copyable: !1,
              removable: !1,
              resizable: !0,
              script: function script() {
                var t,
                  e = 0,
                  n = "gjs-collapse",
                  i = "max-height",
                  r = "ease-in-out",
                  a = .25,
                  o = function () {
                    var t,
                      e = document.createElement("void"),
                      n = {
                        transition: "transitionend",
                        OTransition: "oTransitionEnd",
                        MozTransition: "transitionend",
                        WebkitTransition: "webkitTransitionEnd"
                      };
                    for (t in n) if (void 0 !== e.style[t]) return n[t];
                  }(),
                  s = function s(t) {
                    e = 1;
                    var n = function (t) {
                        var e = window.getComputedStyle(t),
                          n = e.display,
                          r = (e.position, e.visibility, e.height, parseInt(e[i]));
                        if ("none" !== n && "0" !== r) return t.offsetHeight;
                        t.style.height = "auto", t.style.display = "block", t.style.position = "absolute", t.style.visibility = "hidden";
                        var a = t.offsetHeight;
                        return t.style.height = "", t.style.display = "", t.style.position = "", t.style.visibility = "", a;
                      }(t),
                      o = t.style;
                    o.display = "block", o.transition = i + " " + a + "s " + r, o.overflowY = "hidden", "" == o[i] && (o[i] = 0), 0 == parseInt(o[i]) ? (o[i] = "0", setTimeout(function () {
                      o[i] = n + "px";
                    }, 10)) : o[i] = "0";
                  };
                n in this || this.addEventListener("click", function (n) {
                  if (n.preventDefault(), !e) {
                    var r = this.closest("[data-gjs=navbar]").querySelector("[data-gjs=navbar-items]");
                    s(r), t || (r.addEventListener(o, function () {
                      e = 0;
                      var t = r.style;
                      0 == parseInt(t[i]) && (t.display = "", t[i] = "");
                    }), t = 1);
                  }
                }), this[n] = 1;
              }
            })
          }, {
            isComponent: function isComponent(t) {
              if (t.getAttribute && t.getAttribute("data-gjs-type") == n) return {
                type: n
              };
            }
          }),
          view: i.view
        });
      },
      ot = n(2),
      st = n.n(ot);
    var lt = function lt(t, e, n, i, r) {
      var a = "dc-nb-" + st()(8, "");
      t.add(i, {
        label: "\n    <svg class=\"gjs-block-svg\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"50\">\n      <path class=\"gjs-block-svg-path\" d=\"M22,9 C22,8.4 21.5,8 20.75,8 L3.25,8 C2.5,8 2,8.4 2,9 L2,15 C2,15.6 2.5,16 3.25,16 L20.75,16 C21.5,16 22,15.6 22,15 L22,9 Z M21,15 L3,15 L3,9 L21,9 L21,15 Z\" fill-rule=\"nonzero\"></path>\n      <rect class=\"gjs-block-svg-path\" x=\"15\" y=\"10\" width=\"5\" height=\"1\"></rect>\n      <rect class=\"gjs-block-svg-path\" x=\"15\" y=\"13\" width=\"5\" height=\"1\"></rect>\n      <rect class=\"gjs-block-svg-path\" x=\"15\" y=\"11.5\" width=\"5\" height=\"1\"></rect>\n    </svg>\n    <div class=\"gjs-block-label\">".concat(n, "</div>"),
        category: e,
        content: "\n    <nav class=\"navbar navbar-expand-lg navbar-dark bg-primary\" data-gjs-type=\"".concat(i, "\">\n      <a data-gjs-type=\"link-box\" class=\"navbar-brand\" href=\"#\"><div>DrapCode</div></a>\n      <button class=\"navbar-toggler\" type=\"button\" data-toggle=\"collapse\" data-target=\"#").concat(a, "\" data-bs-toggle=\"collapse\" data-bs-target=\"#").concat(a, "\" aria-controls=\"").concat(a, "\" aria-expanded=\"false\" aria-label=\"Toggle navigation\">\n        <span class=\"navbar-toggler-icon\"></span>\n      </button>\n      <div class=\"collapse navbar-collapse justify-content-end\" id=\"").concat(a, "\" data-gjs-type=\"").concat(r.types.navbar_container, "\">\n        <ul class=\"navbar-nav justify-content-end\" data-gjs-type=\"").concat(r.types.navbar_nav, "\">\n          <li class=\"nav-item active\">\n            <a data-gjs-type=\"link-box\" class=\"nav-link\" href=\"#\"><div>Home</div> <span class=\"sr-only\">(current)</span></a>\n          </li>\n          <li class=\"nav-item\">\n            <a data-gjs-type=\"link-box\" class=\"nav-link\" href=\"#\"><div>Features</div></a>\n          </li>\n          <li class=\"nav-item\">\n            <a data-gjs-type=\"link-box\" class=\"nav-link\" href=\"#\"><div>Pricing</div></a>\n          </li>\n          <li class=\"nav-item\">\n            <a data-gjs-type=\"link-box\" class=\"nav-link\" href=\"#\"><div>Contact</div></a>\n          </li>\n        </ul>\n      </div>\n    </nav>\n    "),
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n      <div class=\"drap-on-six\"><svg class=\"gjs-block-svg\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path class=\"gjs-block-svg-path\" d=\"M22,9 C22,8.4 21.5,8 20.75,8 L3.25,8 C2.5,8 2,8.4 2,9 L2,15 C2,15.6 2.5,16 3.25,16 L20.75,16 C21.5,16 22,15.6 22,15 L22,9 Z M21,15 L3,15 L3,9 L21,9 L21,15 Z\" fill-rule=\"nonzero\"></path>\n      <rect class=\"gjs-block-svg-path\" x=\"15\" y=\"10\" width=\"5\" height=\"1\"></rect>\n      <rect class=\"gjs-block-svg-path\" x=\"15\" y=\"13\" width=\"5\" height=\"1\"></rect>\n      <rect class=\"gjs-block-svg-path\" x=\"15\" y=\"11.5\" width=\"5\" height=\"1\"></rect>\n    </svg></div>\n      <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n        <a\n          target=\"_blank\"\n          href=\"https://academy.drapcode.com/docs/app-builder/layout-component-navbar\"\n          draggable=\"false\"\n        >\n          <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </div>\n      <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n    </div>\n  ");
        }
      }), t.add(i + "frequently_used", {
        label: "\n    <svg class=\"gjs-block-svg\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"50\">\n      <path class=\"gjs-block-svg-path\" d=\"M22,9 C22,8.4 21.5,8 20.75,8 L3.25,8 C2.5,8 2,8.4 2,9 L2,15 C2,15.6 2.5,16 3.25,16 L20.75,16 C21.5,16 22,15.6 22,15 L22,9 Z M21,15 L3,15 L3,9 L21,9 L21,15 Z\" fill-rule=\"nonzero\"></path>\n      <rect class=\"gjs-block-svg-path\" x=\"15\" y=\"10\" width=\"5\" height=\"1\"></rect>\n      <rect class=\"gjs-block-svg-path\" x=\"15\" y=\"13\" width=\"5\" height=\"1\"></rect>\n      <rect class=\"gjs-block-svg-path\" x=\"15\" y=\"11.5\" width=\"5\" height=\"1\"></rect>\n    </svg>\n    <div class=\"gjs-block-label\">".concat(n, "</div>"),
        category: "Frequently Used",
        attributes: {
          style: "order: 2"
        },
        content: "\n      <nav class=\"navbar navbar-expand-lg navbar-dark bg-primary\" data-gjs-type=\"".concat(i, "\">\n        <a data-gjs-type=\"link-box\" class=\"navbar-brand\" href=\"#\"><div>DrapCode</div></a>\n        <button class=\"navbar-toggler\" type=\"button\" data-toggle=\"collapse\" data-target=\"#").concat(a, "\" data-bs-toggle=\"collapse\" data-bs-target=\"#").concat(a, "\" aria-controls=\"").concat(a, "\" aria-expanded=\"false\" aria-label=\"Toggle navigation\">\n          <span class=\"navbar-toggler-icon\"></span>\n        </button>\n        <div class=\"collapse navbar-collapse justify-content-end\" id=\"").concat(a, "\" data-gjs-type=\"").concat(r.types.navbar_container, "\">\n          <ul class=\"navbar-nav justify-content-end\" data-gjs-type=\"").concat(r.types.navbar_nav, "\">\n            <li class=\"nav-item active\">\n              <a data-gjs-type=\"link-box\" class=\"nav-link\" href=\"#\"><div>Home</div> <span class=\"sr-only\">(current)</span></a>\n            </li>\n            <li class=\"nav-item\">\n              <a data-gjs-type=\"link-box\" class=\"nav-link\" href=\"#\"><div>Features</div></a>\n            </li>\n            <li class=\"nav-item\">\n              <a data-gjs-type=\"link-box\" class=\"nav-link\" href=\"#\"><div>Pricing</div></a>\n            </li>\n            <li class=\"nav-item\">\n              <a data-gjs-type=\"link-box\" class=\"nav-link\" href=\"#\"><div>Contact</div></a>\n            </li>\n          </ul>\n        </div>\n      </nav>\n    "),
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n    ").concat(e.get("label"), "\n    </div>\n\n    <span class=\"").concat(i, "__info\">\n      <a target=\"_blank\" href=\"https://academy.drapcode.com/docs/app-builder/layout-component-navbar\" draggable=\"false\">\n        <i class=\"").concat(i, "__info-fa fa fa-info-circle\" style=\"margin-left: 5px\" title=\"Check how to use ").concat(n, "?\"></i>\n      </a>\n    </span>\n  ");
        }
      });
    };
    var ct = function ct(t, e, n, i) {
      var r = t.getType("default"),
        a = r.model,
        o = r.view;
      t.addType(n, {
        model: a.extend({
          defaults: _objectSpread({}, a.prototype.defaults, {
            "custom-name": e,
            tagName: "nav",
            classes: ["navbar"],
            traits: [{
              type: "class_select",
              options: [{
                value: "navbar-dark",
                name: "Dark"
              }, {
                value: "navbar-light",
                name: "Light"
              }],
              label: "Theme"
            }, {
              type: "class_select",
              options: [{
                value: "bg-dark",
                name: "Dark"
              }, {
                value: "bg-primary",
                name: "Primary"
              }, {
                value: "bg-light",
                name: "Light"
              }],
              label: "Background Colour"
            }, {
              type: "class_select",
              options: [{
                value: "",
                name: "Default"
              }, {
                value: "flex-column",
                name: "Center"
              }],
              label: "Align Content"
            }, {
              type: "class_select",
              options: [{
                value: "",
                name: "Horizontal"
              }, {
                value: "flex-column",
                name: "Vertical"
              }],
              name: "alignment",
              label: "Alignment",
              changeProp: 1
            }, {
              type: "class_select",
              options: [{
                value: "",
                name: "Default"
              }, {
                value: "fixed-top",
                name: "Fixed Top"
              }, {
                value: "fixed-bottom",
                name: "Fixed Bottom"
              }, {
                value: "sticky-top",
                name: "Sticky Top"
              }],
              label: "Position"
            }].concat(a.prototype.defaults.traits),
            script: function script() {}
          }),
          init: function init() {
            this.listenTo(this, "change:alignment", this.updateNavbarAndNavigation);
          },
          updateNavbarAndNavigation: function updateNavbarAndNavigation() {
            var t = this.getAttributes();
            if (this.changed["alignment"]) {
              var _e11 = t.class.split(" ").filter(function (t) {
                return t.startsWith("flex-column") ? t.replace(t, "") : t;
              });
              _e11.push(this.changed["align-content"]), t.class = _e11.toString().replaceAll(",", " ");
              var _n8 = this.findType(i.types.navbar_nav),
                _r5 = _n8[0].getClasses();
              if (_r5.length > 0) {
                var _t7 = _r5 ? _r5.filter(function (t) {
                  return t.startsWith("flex-column") ? t.replace(t, "") : t;
                }) : [];
                "GJS_NO_CLASS" !== this.changed["alignment"] && _t7.push(this.changed["alignment"]), _n8[0].setClass(_t7);
              } else "GJS_NO_CLASS" !== this.changed["alignment"] && _n8[0].setAttributes({
                class: this.changed["alignment"]
              });
            }
          }
        }, {
          isComponent: function isComponent(t) {
            if (t.getAttribute && t.getAttribute("data-gjs-type") === n) return {
              type: n
            };
          }
        }),
        view: o
      }), t.addType(i.types.navbar_container, {
        model: a.extend({
          defaults: Object.assign({}, a.prototype.defaults, {
            "custom-name": i.labels.labelNavbarContainer,
            name: i.types.navbar_container,
            tagName: "div",
            classes: ["collapse", "navbar-collapse"],
            traits: [{
              type: "class_select",
              options: [{
                value: "",
                name: "Default"
              }, {
                value: "justify-content-start",
                name: "Start"
              }, {
                value: "justify-content-center",
                name: "Center"
              }, {
                value: "justify-content-end",
                name: "End"
              }, {
                value: "justify-content-around",
                name: "Around"
              }, {
                value: "justify-content-between",
                name: "Between"
              }],
              label: "Align Content",
              name: "align-content",
              changeProp: 1
            }].concat(a.prototype.defaults.traits),
            script: function script() {}
          }),
          init: function init() {
            this.listenTo(this, "change:align-content", this.updateNavigationAndItem);
          },
          updateNavigationAndItem: function updateNavigationAndItem() {
            var t = this.getAttributes();
            if (this.changed["align-content"]) {
              var _e12 = t.class.split(" ").filter(function (t) {
                return t.startsWith("justify-content") ? t.replace(t, "") : t;
              });
              _e12.push(this.changed["align-content"]), t.class = _e12.toString().replaceAll(",", " ");
              var _n9 = this.findType(i.types.navbar_nav),
                _r6 = _n9[0].getClasses();
              if (_r6.length > 0) {
                var _t8 = _r6 ? _r6.filter(function (t) {
                  return t.startsWith("justify-content") ? t.replace(t, "") : t;
                }) : [];
                "GJS_NO_CLASS" !== this.changed["align-content"] && _t8.push(this.changed["align-content"]), _n9[0].setClass(_t8);
              } else "GJS_NO_CLASS" !== this.changed["align-content"] && _n9[0].setAttributes({
                class: this.changed["align-content"]
              });
            }
          }
        }, {
          isComponent: function isComponent(t) {
            if (t.getAttribute && t.getAttribute("data-gjs-type") === i.types.navbar_container) return {
              type: i.types.navbar_container
            };
          }
        }),
        view: o
      }), t.addType(i.types.navbar_nav, {
        model: a.extend({
          defaults: Object.assign({}, a.prototype.defaults, {
            "custom-name": i.labels.labelNavbarNavigation,
            tagName: "ul",
            classes: ["navbar-nav"],
            traits: [{
              type: "class_select",
              options: [{
                value: "",
                name: "Horizontal"
              }, {
                value: "flex-column",
                name: "Vertical"
              }],
              label: "Alignment"
            }].concat(a.prototype.defaults.traits)
          })
        }, {
          isComponent: function isComponent(t) {
            if (t.getAttribute && t.getAttribute("data-gjs-type") === i.types.navbar_nav) return {
              type: i.types.navbar_nav
            };
          }
        }),
        view: o
      }), t.addType(i.types.nav_item, {
        model: a.extend({
          defaults: Object.assign({}, a.prototype.defaults, {
            "custom-name": i.labels.labelNavItem,
            tagName: "li",
            classes: ["nav-item"],
            traits: [{
              type: "class_select",
              options: [{
                value: "",
                name: "No"
              }, {
                value: "active",
                name: "Yes"
              }],
              label: "Active"
            }].concat(a.prototype.defaults.traits)
          })
        }, {
          isComponent: function isComponent(t) {
            if (t && t.classList && t.classList.contains("nav-item")) return {
              type: i.types.nav_item
            };
          }
        }),
        view: o
      });
    };
    var dt = function dt(t, e, n, i, r) {
      st()(8, "");
      t.add(i, {
        label: n,
        category: e,
        content: "\n    <li class=\"nav-item dropdown\" data-gjs-type=\"".concat(i, "\" style=\"display: inline-block\">\n      <a class=\"nav-link dropdown-toggle\" href=\"#\" data-toggle=\"dropdown\" data-bs-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" data-gjs-custom-name=\"").concat(r.labels.labelNavItemSubMenuToggle, "\">\n        Dropdown link\n      </a>\n      <ul class=\"dropdown-menu\" data-gjs-type=\"").concat(r.types.nav_item_dropdown_menu, "\">\n      <a data-gjs-type=\"link-box\" class=\"dropdown-item\" href=\"#\"><div data-gjs-type=\"text\" draggable=\"true\" data-highlightable=\"1\">Action</div></a>\n      <a data-gjs-type=\"link-box\" class=\"dropdown-item\" href=\"#\"><div data-gjs-type=\"text\" draggable=\"true\" data-highlightable=\"1\">Another action</div></a>\n        <a data-gjs-type=\"link-box\" class=\"dropdown-item\" href=\"#\"><div data-gjs-type=\"text\" draggable=\"true\" data-highlightable=\"1\">Something else here</div></a>\n      </ul>\n    </li>\n    "),
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n      <div class=\"drap-on-six\"><svg class=\"gjs-block-svg\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path class=\"gjs-block-svg-path\" d=\"M22,9 C22,8.4 21.5,8 20.75,8 L3.25,8 C2.5,8 2,8.4 2,9 L2,15 C2,15.6 2.5,16 3.25,16 L20.75,16 C21.5,16 22,15.6 22,15 L22,9 Z M21,15 L3,15 L3,9 L21,9 L21,15 Z\" fill-rule=\"nonzero\"></path>\n      <rect class=\"gjs-block-svg-path\" x=\"15\" y=\"10\" width=\"5\" height=\"1\"></rect>\n      <rect class=\"gjs-block-svg-path\" x=\"15\" y=\"13\" width=\"5\" height=\"1\"></rect>\n      <rect class=\"gjs-block-svg-path\" x=\"15\" y=\"11.5\" width=\"5\" height=\"1\"></rect>\n    </svg></div>\n      <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n        <a\n          target=\"_blank\"\n          href=\"https://academy.drapcode.com/docs/app-builder/layout-component-sub-menu\"\n          draggable=\"false\"\n        >\n          <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </div>\n      <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n    </div>\n  ");
        }
      });
    };
    var ut = function ut(t, e, n, i) {
      var r = t.getType("default"),
        a = r.model,
        o = r.view;
      t.addType(n, {
        model: a.extend({
          defaults: Object.assign({}, a.prototype.defaults, _objectSpread({}, a.prototype.defaults, {
            "custom-name": e,
            tagName: "li",
            classes: ["nav-item", "dropdown"],
            droppable: !1
          }))
        }, {
          isComponent: function isComponent(t) {
            if (t.getAttribute && t.getAttribute("data-gjs-type") === n) return {
              type: n
            };
          }
        }),
        view: o
      }), t.addType(i.types.nav_item_dropdown_menu, {
        model: a.extend({
          defaults: Object.assign({}, a.prototype.defaults, {
            "custom-name": i.labels.labelNavItemDropdownMenu,
            tagName: "ul",
            classes: ["dropdown-menu"]
          })
        }, {
          isComponent: function isComponent(t) {
            if (t.getAttribute && t.getAttribute("data-gjs-type") === i.types.nav_item_dropdown_menu) return {
              type: i.types.nav_item_dropdown_menu
            };
          }
        }),
        view: o
      });
    };
    var ht = function ht(t, e, n, i) {
      t.add(i, {
        label: n,
        category: e,
        content: "".concat("\n  <div class=\"jumbotron\">\n    <div class=\"jumbotron-body\">\n      <h1>This is Heading</h1>\n      <p class=\"lead\">\n        This is a simple hero unit, a simple jumbotron-style component for calling\n        extra attention to featured content or information.\n      </p>\n    </div>\n  </div>").concat("\n  <style>\n  @media (min-width: 576px)\n  .jumbotron {\n      padding: 4rem 2rem;\n  }\n  .jumbotron {\n      padding: 2rem 1rem;\n      margin-bottom: 2rem;\n      background-color: #e9ecef;\n      border-radius: .3rem;\n  }\n  .jumbotron-fluid {\n    padding-right: 0;\n    padding-left: 0;\n    border-radius: 0;\n  }\n  </style>\n  "),
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n      <div class=\"drap-on-six\">").concat(s, "</div>\n      <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n        <a\n          target=\"_blank\"\n          href=\"https://academy.drapcode.com/docs/app-builder/layout-component-jumbotron\"\n          draggable=\"false\"\n        >\n          <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </div>\n      <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n    </div>\n  ");
        }
      });
    };
    var pt = function pt(t, e, n) {
      var i = t.getType("default"),
        r = i.model,
        a = i.view;
      t.addType(n, {
        model: r.extend({
          defaults: _objectSpread({}, r.prototype.defaults, {
            "custom-name": e,
            tagName: "div",
            droppable: !0,
            resizable: !0,
            style: {
              "min-height": "500px"
            },
            classes: ["jumbotron"],
            traits: [{
              type: "jumbotron_class_select",
              options: [{
                value: "jumbotron",
                name: "Fixed"
              }, {
                value: "jumbotron jumbotron-fluid",
                name: "Fluid"
              }],
              label: "Width"
            }].concat(r.prototype.defaults.traits)
          })
        }, {
          isComponent: function isComponent(t) {
            if (t && t.classList && (t.classList.contains("jumbotron") || t.classList.contains("jumbotron-fluid"))) return {
              type: n
            };
          }
        }),
        view: a
      }), t.addType("jumbotron_body", {
        model: r.extend({
          defaults: Object.assign({}, r.prototype.defaults, {
            "custom-name": "Jumbotron Body",
            tagName: "p",
            classes: ["jumbotron-body"]
          })
        }, {
          isComponent: function isComponent(t) {
            if (t && t.classList && t.classList.contains("jumbotron-body")) return {
              type: "jumbotron_body"
            };
          }
        }),
        view: a
      });
    };
    var gt = function gt(t, e, n, i) {
      var r = "\n  <ul class=\"list-group p-3\">\n    ".concat("\n  <li class=\"list-group-item\">Insert your text here</li>\n  <li class=\"list-group-item\">Insert your text here</li>\n  <li class=\"list-group-item\">Insert your text here</li>\n  <li class=\"list-group-item\">Insert your text here</li>\n  <li class=\"list-group-item\">Insert your text here</li>", "\n  </ul>");
      t.add("list-group", {
        label: n,
        category: e,
        content: "".concat(r).concat("\n  <style>\n    ul {\n        display: block;\n        list-style-type: disc;\n        margin-block-start: 1em;\n        margin-block-end: 1em;\n        margin-inline-start: 0px;\n        margin-inline-end: 0px;\n        padding-inline-start: 40px;\n    }\n    ol {\n      display: block;\n      list-style-type: decimal;\n      margin-block-start: 1em;\n      margin-block-end: 1em;\n      margin-inline-start: 0px;\n      margin-inline-end: 0px;\n      padding-inline-start: 40px;\n    }\n    li {\n      display: list-item;\n      text-align: -webkit-match-parent;\n    }\n\n    .show-list-item > li {\n        display: list-item !important;\n    }\n\n    *, ::after, ::before {\n      box-sizing: border-box;\n    }\n    dl, ol, ul {\n        margin-top: 0;\n        margin-bottom: 1rem;\n    }\n    .list-group {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n      flex-direction: column;\n      padding-left: 0;\n      margin-bottom: 0;\n    }\n    .list-group {\n      max-width: 400px;\n    }\n    .list-group-item-list {\n      display: list-item !important;\n    }\n    .list-group-item {\n      position: relative;\n      display: block;\n      padding: .75rem 1.25rem;\n      margin-bottom: -1px;\n      background-color: #fff;\n      border: 1px solid rgba(0,0,0,.125);\n    }\n    .list-group-item:first-child {\n      border-top-left-radius: .25rem;\n      border-top-right-radius: .25rem;\n    }\n    .list-group-item:last-child {\n      margin-bottom: 0;\n      border-bottom-right-radius: .25rem;\n      border-bottom-left-radius: .25rem;\n    }\n    .list-group-item.active {\n      z-index: 2;\n      color: #fff;\n      background-color: #007bff;\n      border-color: #007bff;\n    }\n    .list-group-item.disabled, .list-group-item:disabled {\n      color: #6c757d;\n      background-color: #fff;\n    }\n    .list-group-item:focus, .list-group-item:hover {\n      z-index: 1;\n      text-decoration: none;\n    }\n    .list-group-flush:first-child .list-group-item:first-child {\n      border-top: 0;\n    }\n    .list-group-flush .list-group-item {\n      border-right: 0;\n      border-left: 0;\n      border-radius: 0;\n    }\n    .list-group-item-primary {\n      color: #004085;\n      background-color: #b8daff;\n    }\n    .list-group-item-secondary {\n      color: #383d41;\n      background-color: #d6d8db;\n    }\n    .list-group-item-success {\n      color: #155724;\n      background-color: #c3e6cb;\n    }\n    .list-group-item-danger {\n      color: #721c24;\n      background-color: #f5c6cb;\n    }\n    .list-group-item-warning {\n      color: #856404;\n      background-color: #ffeeba;\n    }\n    .list-group-item-info {\n      color: #0c5460;\n      background-color: #bee5eb;\n    }\n    .list-group-item-light {\n      color: #818182;\n      background-color: #fdfdfe;\n    }\n    .list-group-item-dark {\n      color: #1b1e21;\n      background-color: #c6c8ca;\n    }\n  </style>\n  "),
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n      <div class=\"drap-on-six\"><svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" aria-hidden=\"true\" focusable=\"false\" width=\"32\" height=\"50\" style=\"-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);\" preserveAspectRatio=\"xMidYMid meet\" viewBox=\"0 0 1792 1408\"><path d=\"M384 1056v64q0 13-9.5 22.5T352 1152h-64q-13 0-22.5-9.5T256 1120v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zm0-256v64q0 13-9.5 22.5T352 896h-64q-13 0-22.5-9.5T256 864v-64q0-13 9.5-22.5T288 768h64q13 0 22.5 9.5T384 800zm0-256v64q0 13-9.5 22.5T352 640h-64q-13 0-22.5-9.5T256 608v-64q0-13 9.5-22.5T288 512h64q13 0 22.5 9.5T384 544zm1152 512v64q0 13-9.5 22.5t-22.5 9.5H544q-13 0-22.5-9.5T512 1120v-64q0-13 9.5-22.5t22.5-9.5h960q13 0 22.5 9.5t9.5 22.5zm0-256v64q0 13-9.5 22.5T1504 896H544q-13 0-22.5-9.5T512 864v-64q0-13 9.5-22.5T544 768h960q13 0 22.5 9.5t9.5 22.5zm0-256v64q0 13-9.5 22.5T1504 640H544q-13 0-22.5-9.5T512 608v-64q0-13 9.5-22.5T544 512h960q13 0 22.5 9.5t9.5 22.5zm128 704V416q0-13-9.5-22.5T1632 384H160q-13 0-22.5 9.5T128 416v832q0 13 9.5 22.5t22.5 9.5h1472q13 0 22.5-9.5t9.5-22.5zm128-1088v1088q0 66-47 113t-113 47H160q-66 0-113-47T0 1248V160Q0 94 47 47T160 0h1472q66 0 113 47t47 113z\" fill=\"#c3cfe9\"/></svg></div>\n      <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n        <a\n          target=\"_blank\"\n          href=\"#\"\n          draggable=\"false\"\n        >\n          <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </div>\n      <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n    </div>\n  ");
        }
      });
    };
    var ft = function ft(t, e, n) {
      var i = t.getType("default"),
        r = i.model,
        a = i.view,
        o = t.getType("text"),
        s = o.model,
        l = o.view;
      t.addType("list-group", {
        model: r.extend({
          defaults: _objectSpread({}, r.prototype.defaults, {
            "custom-name": "List Group",
            tagName: "ul",
            resizable: !0,
            classes: ["list-group"],
            traits: [{
              type: "class_select",
              options: [{
                value: "list-group-flush",
                name: "Yes"
              }, {
                value: "",
                name: "No"
              }],
              label: "Flush"
            }, {
              type: "select",
              options: [{
                value: "ul",
                name: "ul (Unordered List)"
              }, {
                value: "ol",
                name: "ol (Ordered List)"
              }],
              label: "Type",
              name: "tagName",
              changeProp: 1
            }, {
              type: "class_select",
              options: [{
                value: "show-list-item",
                name: "List"
              }, {
                value: "",
                name: "Block"
              }],
              label: "Display Type"
            }].concat(r.prototype.defaults.traits)
          })
        }, {
          isComponent: function isComponent(t) {
            if (t && t.classList && t.classList.contains("list-group")) return {
              type: n
            };
          }
        }),
        view: a
      }), t.addType("list-group-item", {
        model: s.extend({
          defaults: _objectSpread({}, r.prototype.defaults, {
            "custom-name": "List Item",
            droppable: !0,
            editable: !0,
            tagName: "li",
            classes: ["list-group-item"],
            traits: [{
              type: "class_select",
              options: [{
                value: "list-group-item-list",
                name: "List"
              }, {
                value: "",
                name: "None"
              }],
              label: "Type"
            }].concat(s.prototype.defaults.traits)
          })
        }, {
          isComponent: function isComponent(t) {
            if (t && t.classList && t.classList.contains("list-group-item")) return {
              type: "list-group-item"
            };
          }
        }),
        view: l
      });
    };
    var mt = function mt(t, e, n, i) {
      var r = "\n    <nav class=\"sidebar\">\n      ".concat("\n            <div class=\"sidebar-header\">\n                <h3>Sidebar</h3>\n            </div>\n            <ul class=\"list-unstyled components sidebar-ul\">\n                <p>Heading</p>\n                <li class=\"sidebar-list\">\n                    <a data-gjs-type=\"link-box\" href=\"#\"><div>Home</div></a>\n                </li>\n                <li class=\"sidebar-list\">\n                    <a data-gjs-type=\"link-box\" href=\"#\"><div>About</div></a>\n                </li>\n                <li class=\"sidebar-list\">\n                    <a data-gjs-type=\"link-box\" href=\"#\"><div>Pages</div></a>\n                </li>\n                <li class=\"sidebar-list\">\n                    <a data-gjs-type=\"link-box\" href=\"#\"><div>Portfolio</div></a>\n                </li>\n                <li class=\"sidebar-list\">\n                    <a data-gjs-type=\"link-box\" href=\"#\"><div>Contact</div></a>\n                </li>\n            </ul>", "\n    </nav>");
      t.add("sidebar", {
        label: n,
        category: e,
        content: "".concat(r).concat("\n  <style>\n  a,\n  a:hover,\n  a:focus {\n      color: inherit;\n      text-decoration: none;\n      transition: all 0.3s;\n  }\n  \n  .sidebar {\n      min-width: 10 rem;\n      max-width: 15 rem;\n      background: #2d2d2d;\n      color: #fff;\n      min-height: 90vh;\n      transition: all 0.3s;\n  }\n  \n  .sidebar.active {\n      margin-left: -250px;\n  }\n  \n  .sidebar .sidebar-header {\n      padding: 20px;\n      background: #222222;\n  }\n  \n  .sidebar ul.components {\n      padding: 20px 0;\n  }\n  \n  .sidebar ul p {\n      color: #fff;\n      padding: 10px;\n  }\n  \n  .sidebar ul li a {\n      padding: 10px;\n      font-size: 1.1em;\n      display: block;\n  }\n  \n  .sidebar ul li a:hover {\n      color: #222222;\n      background: #fff;\n  }\n  \n  .sidebar ul li.active>a,\n  a[aria-expanded=\"true\"] {\n      color: #fff;\n      background: #222222;\n  }\n  \n  a[data-toggle=\"collapse\"] {\n      position: relative;\n  }\n  \n  .dropdown-toggle::after {\n      display: block;\n      position: absolute;\n      top: 50%;\n      right: 20px;\n      transform: translateY(-50%);\n  }\n  \n  ul ul a {\n      font-size: 0.9em !important;\n      padding-left: 30px !important;\n      background: #222222;\n  }\n  \n  ul.CTAs {\n      padding: 20px;\n  }\n  \n  ul.CTAs a {\n      text-align: center;\n      font-size: 0.9em !important;\n      display: block;\n      border-radius: 5px;\n      margin-bottom: 5px;\n  }\n  \n  a.download {\n      background: #fff;\n      color: #222222;\n  }\n  \n  a.article,\n  a.article:hover {\n      background: #222222 !important;\n      color: #fff !important;\n  }\n  </style>\n  "),
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "<div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n    <div class=\"drap-on-six\"><svg class=\"gjs-block-svg\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path class=\"gjs-block-svg-path\" d=\"M22,9 C22,8.4 21.5,8 20.75,8 L3.25,8 C2.5,8 2,8.4 2,9 L2,15 C2,15.6 2.5,16 3.25,16 L20.75,16 C21.5,16 22,15.6 22,15 L22,9 Z M21,15 L3,15 L3,9 L21,9 L21,15 Z\" fill-rule=\"nonzero\"></path>\n    <rect class=\"gjs-block-svg-path\" x=\"15\" y=\"10\" width=\"5\" height=\"1\"></rect>\n    <rect class=\"gjs-block-svg-path\" x=\"15\" y=\"13\" width=\"5\" height=\"1\"></rect>\n    <rect class=\"gjs-block-svg-path\" x=\"15\" y=\"11.5\" width=\"5\" height=\"1\"></rect>\n  </svg></div>\n    <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n      <a\n        target=\"_blank\"\n        href=\"https://academy.drapcode.com/docs/app-builder/layout-component-sidebar\"\n        draggable=\"false\"\n      >\n        <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n      </a>\n    </div>\n    <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n  </div>\n  ");
        }
      });
    };
    var vt = function vt(t, e, n) {
      var i = t.getType("default"),
        r = i.model,
        a = i.view;
      t.addType("sidebar", {
        model: r.extend({
          defaults: _objectSpread({}, r.prototype.defaults, {
            "custom-name": "SideBar",
            resizable: !0,
            tagName: "nav",
            classes: ["sidebar"]
          })
        }, {
          isComponent: function isComponent(t) {
            if (t && t.classList && t.classList.contains("sidebar")) return {
              type: n
            };
          }
        }),
        view: a
      }), t.addType("sidebar-header", {
        model: r.extend({
          defaults: _objectSpread({}, r.prototype.defaults, {
            "custom-name": "Header",
            tagName: "div",
            classes: ["sidebar-header"]
          })
        }, {
          isComponent: function isComponent(t) {
            if (t && t.classList && t.classList.contains("sidebar-header")) return {
              type: "sidebar-header"
            };
          }
        }),
        view: a
      }), t.addType("sidebar-ul", {
        model: r.extend({
          defaults: _objectSpread({}, r.prototype.defaults, {
            "custom-name": "Content",
            tagName: "ul",
            classes: ["sidebar-ul"]
          })
        }, {
          isComponent: function isComponent(t) {
            if (t && t.classList && t.classList.contains("sidebar-ul")) return {
              type: "sidebar-ul"
            };
          }
        }),
        view: a
      }), t.addType("sidebar-list", {
        model: r.extend({
          defaults: _objectSpread({}, r.prototype.defaults, {
            "custom-name": "List",
            droppable: !0,
            tagName: "li",
            classes: ["sidebar-list"],
            traits: [{
              type: "class_select",
              options: [{
                value: "active",
                name: "Yes"
              }, {
                value: "",
                name: "No"
              }],
              label: "Active"
            }].concat(r.prototype.defaults.traits)
          })
        }, {
          isComponent: function isComponent(t) {
            if (t && t.classList && t.classList.contains("sidebar-list")) return {
              type: "sidebar-list"
            };
          }
        }),
        view: a
      });
    };
    var bt = "data-",
      yt = "".concat(bt, "tab"),
      wt = "".concat(bt, "tabs"),
      xt = "".concat(bt, "tab-content"),
      jt = "".concat(bt, "tab-container");
    var Ct = {
      tabsBlock: {},
      tabsProps: {
        resizable: !0
      },
      tabProps: {},
      tabContentProps: {},
      tabContainerProps: {},
      attrTabs: wt,
      attrTab: yt,
      attrTabContent: xt,
      attrTabContainer: jt,
      classTab: "tab",
      classTabActive: "tab-active",
      classTabContent: "tab-content",
      classTabContainer: "tab-container",
      selectorTab: "href",
      template: "\n      <nav ".concat(jt, ">\n        <a href=\"#tab1\" ").concat(yt, "> <div data-gjs-type=\"text\" draggable=\"true\" data-highlightable=\"1\">Tab 1</div></a>\n        <a href=\"#tab2\" ").concat(yt, "> <div data-gjs-type=\"text\" draggable=\"true\" data-highlightable=\"1\">Tab 2</div></a>\n        <a href=\"#tab3\" ").concat(yt, "> <div data-gjs-type=\"text\" draggable=\"true\" data-highlightable=\"1\">Tab 3</div></a>\n      </nav>\n      <div id=\"tab1\" ").concat(xt, ">\n        <div>Tab 1 Content</div>\n      </div>\n      <div id=\"tab2\" ").concat(xt, ">\n        <div>Tab 2 Content</div>\n      </div>\n      <div id=\"tab3\" ").concat(xt, ">\n        <div>Tab 3 Content</div>\n      </div>\n    "),
      templateTabContent: "<div>New Tab Content</div>",
      style: "\n      .tab {\n        text-decoration: none;\n        color: inherit;\n        padding: 7px 14px;\n        transition: opacity 0.3s;\n        display: inline-block;\n        border-radius: 3px;\n        margin-right: 10px;\n      }\n\n      .tab-container{\n        border-bottom: 1px solid #dee2e6;\n      }\n\n      .tab.tab-active {\n        color: #495057;\n        background-color: #fff;\n        border-color: #dee2e6 #dee2e6 #fff;\n        border: 1px solid #dee2e6;\n        border-bottom: 1px solid transparent;\n        margin-bottom: -1rem;\n      }\n\n      .tab-content {\n        padding: 6px 12px;\n        min-height: 100px;\n        animation: fadeEffect 1s;\n      }\n      \n      @keyframes fadeEffect {\n        from {opacity: 0;}\n        to {opacity: 1;}\n      }\n    "
    };
    var Mt = function Mt(t, e, n, i) {
      var r = Ct.tabsBlock,
        a = Ct.style,
        o = "<div data-gjs-type=\"".concat(i, "\"></div>\n    ").concat(a ? "<style>".concat(a, "</style>") : "");
      r && t.add(i, _objectSpread({
        label: n,
        category: e,
        content: o,
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n      <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n      <div class=\"drap-on-six\"> <svg class=\"gjs-block-svg\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"50\">\n      <g fill-rule=\"evenodd\">\n        <path d=\"M22 9.3c0-.8-.5-1.3-1.3-1.3H3.4C2.5 8 2 8.5 2 9.3v7.4c0 .8.5 1.3 1.3 1.3h17.4c.8 0 1.3-.5 1.3-1.3V9.3zM21 17H3V9h18v8z\" fill-rule=\"nonzero\"/><rect x=\"3\" y=\"5\" width=\"4\" height=\"2\" rx=\".5\"/><rect x=\"8\" y=\"5\" width=\"4\" height=\"2\" rx=\".5\"/><rect x=\"13\" y=\"5\" width=\"4\" height=\"2\" rx=\".5\"/>\n      </g>\n      </svg></div>\n      <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n        <a\n          target=\"_blank\"\n          href=\"https://academy.drapcode.com/docs/app-builder/basic-component-audio\"\n          draggable=\"false\"\n        >\n          <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </div>\n      <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n    </div>\n    ");
        }
      }, r));
    };
    var kt = function kt(t, e, n) {
        var i = t.getType("default"),
          r = i.model,
          a = i.view,
          o = Ct.attrTabs,
          s = Ct.attrTab,
          l = Ct.attrTabContent,
          c = Ct.classTabActive,
          d = Ct.selectorTab,
          u = Ct.tabsProps,
          h = Ct.template,
          p = Ct.attrTabContainer;
        t.addType(n, {
          model: r.extend({
            defaults: _objectSpread({}, r.prototype.defaults, {
              name: e,
              "attr-tabs": o,
              "attr-tab": s,
              "attr-tab-content": l,
              "class-tab-active": c,
              "selector-tab": d,
              script: function script() {
                var t,
                  e = this,
                  n = "[" + "{[ attr-tab ]}" + "]",
                  i = "[" + "{[ attr-tab-content ]}" + "]",
                  r = "{[ class-tab-active ]}",
                  a = "{[ selector-tab ]}",
                  o = document.body,
                  s = o.matchesSelector || o.webkitMatchesSelector || o.mozMatchesSelector || o.msMatchesSelector,
                  l = function l(o) {
                    var s = e.querySelectorAll(n) || [];
                    for (t = 0; t < s.length; t++) {
                      var l = s[t],
                        c = l.className.replace(r, "").trim();
                      l.className = c;
                    }
                    !function () {
                      var n = e.querySelectorAll(i) || [];
                      for (t = 0; t < n.length; t++) n[t].style.display = "none";
                    }(), o.className += " " + r;
                    var d = o.getAttribute(a),
                      u = e.querySelector(d);
                    u && (u.style.display = "");
                  },
                  c = e.querySelector("." + r + n);
                (c = c || e.querySelector(n)) && l(c), e.addEventListener("click", function (t) {
                  var e = t.target;
                  ["A"].includes(e.tagName.toUpperCase()) || (e = e.closest("A")), s.call(e, n) && l(e);
                });
              }
            }, u),
            init: function init() {
              var t = this.getAttributes();
              t[o] = 1, this.setAttributes(t);
            }
          }, {
            isComponent: function isComponent(t) {
              if (t.hasAttribute && t.hasAttribute(o)) return {
                type: n
              };
            }
          }),
          view: a.extend({
            init: function init() {
              var t = this.model.components();
              !t.length && t.add(h);
            },
            onRender: function onRender() {
              var t = this.model.find("[".concat(p, "]"))[0];
              t && t.components().each(function (e) {
                t.onAdd(e);
              });
            }
          })
        });
      },
      Ot = function Ot(t, e, n) {
        var i = t.getType("link"),
          r = i.model,
          a = i.view,
          o = Ct.attrTab,
          s = Ct.classTab,
          l = Ct.selectorTab,
          c = Ct.attrTabContainer,
          d = Ct.tabProps,
          u = o,
          h = s;
        t.addType(n, {
          model: r.extend({
            defaults: _objectSpread({}, r.prototype.defaults, {
              name: e,
              draggable: "[".concat(c, "]"),
              droppable: !0
            }, d),
            init: function init() {
              var t = this.getAttributes();
              t[u] = 1, this.setAttributes(t), h && this.addClass(h);
            },
            clone: function clone() {
              var t = r.prototype.clone.apply(this, arguments);
              return t.addAttributes(_defineProperty({}, l, "")), t;
            }
          }, {
            isComponent: function isComponent(t) {
              if (t.hasAttribute && t.hasAttribute(u)) return {
                type: n
              };
            }
          }),
          view: a
        });
      },
      Tt = function Tt(t, e, n) {
        var i = t.getType("default"),
          r = i.model,
          a = i.view,
          o = Ct.attrTabContent,
          s = Ct.classTabContent,
          l = Ct.tabContentProps,
          c = o,
          d = s;
        t.addType(n, {
          model: r.extend({
            defaults: _objectSpread({}, r.prototype.defaults, {
              name: e,
              draggable: !1,
              copyable: !1,
              removable: !1
            }, l),
            init: function init() {
              var t = this.getAttributes();
              t[c] = 1, this.setAttributes(t), d && this.addClass(d);
            }
          }, {
            isComponent: function isComponent(t) {
              if (t.hasAttribute && t.hasAttribute(c)) return {
                type: n
              };
            }
          }),
          view: a
        });
      },
      St = function St(t, e, n) {
        var i = t.getType("default"),
          r = i.model,
          a = i.view,
          o = Ct.attrTabs,
          s = Ct.attrTab,
          l = Ct.classTabContainer,
          c = Ct.selectorTab,
          d = Ct.attrTabContainer,
          u = Ct.tabContainerProps,
          h = Ct.templateTabContent,
          p = d,
          g = l;
        t.addType(n, {
          model: r.extend({
            defaults: _objectSpread({}, r.prototype.defaults, {
              name: e,
              draggable: "[".concat(o, "]"),
              droppable: "[".concat(s, "]"),
              copyable: !1,
              removable: !1
            }, u),
            init: function init() {
              var t = this.getAttributes();
              t[p] = 1, this.setAttributes(t), g && this.addClass(g);
              var e = this.components();
              this.listenTo(e, "add", this.onAdd), this.listenTo(e, "remove", this.onRemove);
            },
            onRemove: function onRemove(t, e) {
              var n = t.tabContent;
              n && setTimeout(function () {
                var e = t.collection,
                  i = n.collection;
                !e && i && i.remove(n);
              }, 0);
            },
            onAdd: function onAdd(t, e) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              var i = t.getAttributes();
              if (!t.tabContent && !n.avoidStore) {
                var _e13 = i[c],
                  _n10 = this.closest("[".concat(o, "]")),
                  _r7 = _e13 && _n10.view.$el.find(_e13);
                if (_r7 && _r7.length) t.tabContent = _r7.data("model");else {
                  var _e14 = _n10.components().add({
                      type: "tab-content",
                      components: h
                    }),
                    _i9 = _e14.getId();
                  _e14.addAttributes({
                    id: _i9
                  }), t.addAttributes(_defineProperty({}, c, "#".concat(_i9))), t.tabContent = _e14, _e14.getEl().style.display = "none";
                }
              }
            }
          }, {
            isComponent: function isComponent(t) {
              if (t.hasAttribute && t.hasAttribute(p)) return {
                type: n
              };
            }
          }),
          view: a
        });
      };
    var Nt = "data-",
      Lt = "".concat(Nt, "accordion"),
      Dt = "".concat(Nt, "accordions"),
      Et = "".concat(Nt, "accordion-content"),
      It = "".concat(Nt, "accordion-container");
    var Pt = {
      accordionsBlock: {},
      accordionsProps: {
        resizable: !0
      },
      accordionProps: {},
      accordionContentProps: {},
      accordionContainerProps: {},
      attrAccordions: Dt,
      attrAccordion: Lt,
      attrAccordionContent: Et,
      attrAccordionContainer: It,
      classAccordion: "accordion",
      classAccordionActive: "accordion-active",
      classAccordionContent: "accordion-content",
      classAccordionContainer: "accordion-container",
      selectorAccordion: "href",
      template: "\n      <div ".concat(It, ">\n        <a href=\"#accordion1\" ").concat(Lt, ">\n          <div data-gjs-type=\"text\" draggable=\"true\" data-highlightable=\"1\">Accordion 1</div>\n        </a>\n        <div id=\"accordion1\" ").concat(Et, ">\n          <div>Accordion 1 Content</div>\n        </div>\n      </div>\n      <div ").concat(It, ">\n        <a href=\"#accordion2\" ").concat(Lt, ">\n          <div data-gjs-type=\"text\" draggable=\"true\" data-highlightable=\"1\">Accordion 2</div>\n        </a>\n        <div id=\"accordion2\" ").concat(Et, ">\n          <div>Accordion 2 Content</div>\n        </div>      \n      </div>\n      <div ").concat(It, ">\n        <a href=\"#accordion3\" ").concat(Lt, ">\n         <div data-gjs-type=\"text\" draggable=\"true\" data-highlightable=\"1\">Accordion 3</div>\n        </a>\n        <div id=\"accordion3\" ").concat(Et, ">\n          <div>Accordion 3 Content</div>\n        </div>\n      </div>\n    "),
      templateAccordionContent: "<div>New Accordion Content</div>",
      style: "\n      .accordion {\n        text-decoration: none;\n        color: inherit;\n        padding: 7px 14px;\n        transition: opacity 0.3s;\n        display: block;\n        border-radius: 3px;\n        background-color: #eee;\n        margin-top: 5px;\n      }\n      .accordion:hover {\n        text-decoration: none;\n      }\n\n      .accordion-content {\n        display: none;\n        padding: 6px 12px;\n        min-height: 100px;\n        border: solid 1px #eee;\n      }\n\n    "
    };
    var At = function At(t, e, n, i) {
      var r = Pt.accordionsBlock,
        a = Pt.style,
        o = "<div data-gjs-type=\"".concat(i, "\"></div>\n    ").concat(a ? "<style>".concat(a, "</style>") : "");
      r && t.add(i, _objectSpread({
        label: n,
        category: e,
        content: o,
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n      <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n      <div class=\"drap-on-six\"><svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" aria-hidden=\"true\" focusable=\"false\" width=\"32\" height=\"50\" style=\"-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);\" preserveAspectRatio=\"xMidYMid meet\" viewBox=\"0 0 1536 1536\"><g transform=\"translate(0 1536) scale(1 -1)\"><path d=\"M1145 989q-17 35-57 35H448q-40 0-57-35q-18-35 5-66l320-448q19-27 52-27t52 27l320 448q23 31 5 66zm135 259V288q0-13-9.5-22.5T1248 256H288q-13 0-22.5 9.5T256 288v960q0 13 9.5 22.5t22.5 9.5h960q13 0 22.5-9.5t9.5-22.5zm256-960v960q0 119-84.5 203.5T1248 1536H288q-119 0-203.5-84.5T0 1248V288Q0 169 84.5 84.5T288 0h960q119 0 203.5 84.5T1536 288z\" fill=\"#c3cfe9\"/></g></svg></div>\n      <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n        <a\n          target=\"_blank\"\n          href=\"https://academy.drapcode.com/docs/app-builder/layout-component-sections\"\n          draggable=\"false\"\n        >\n          <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </div>\n      <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n    </div>\n      ");
        }
      }, r));
    };
    var zt = function zt(t, e, n) {
        var i = t.getType("default"),
          r = i.model,
          a = i.view,
          o = Pt.attrAccordions,
          s = Pt.attrAccordion,
          l = Pt.attrAccordionContent,
          c = Pt.attrAccordionContainer,
          d = Pt.classAccordionActive,
          u = Pt.selectorAccordion,
          h = Pt.accordionsProps,
          p = Pt.template;
        t.addType(n, {
          model: r.extend({
            defaults: _objectSpread({}, r.prototype.defaults, {
              copyable: !1,
              droppable: !1,
              name: e,
              "attr-accordions": o,
              "attr-accordion": s,
              "attr-accordion-content": l,
              "attr-accordion-container": c,
              "class-accordion-active": d,
              "selector-accordion": u,
              script: function script() {
                var t,
                  e = this,
                  n = "[" + "{[ attr-accordion-content ]}" + "]",
                  i = "[" + "{[ attr-accordion-container ]}" + "]",
                  r = "{[ class-accordion-active ]}",
                  a = "{[ selector-accordion ]}",
                  o = document.body,
                  s = (o.matchesSelector || o.webkitMatchesSelector || o.mozMatchesSelector || o.msMatchesSelector, function (a) {
                    var o = e.querySelectorAll(i) || [];
                    for (t = 0; t < o.length; t++) {
                      var s = o[t],
                        l = s.className.replace(r, "").trim();
                      s.className = l;
                    }
                    !function () {
                      var i = e.querySelectorAll(n) || [];
                      for (t = 0; t < i.length; t++) i[t].style.display = "none";
                    }(), a.className += " " + r;
                  });
                e.addEventListener("click", function (t) {
                  var n = t.target;
                  var i, o;
                  ["A"].includes(n.tagName.toUpperCase()) || (n = n.closest("A")), "block" === e.querySelector(n.getAttribute(a)).style.display ? (i = n.parentElement, o = i.className.replace(r, "").trim(), i.className = o, e.querySelector(n.getAttribute(a)).style.display = "none") : (s(n.parentElement), e.querySelector(n.getAttribute(a)).style.display = "block");
                });
              }
            }, h),
            init: function init() {
              var t = this.getAttributes();
              t[o] = 1, this.setAttributes(t);
            }
          }, {
            isComponent: function isComponent(t) {
              if (t.hasAttribute && t.hasAttribute(o)) return {
                type: n
              };
            }
          }),
          view: a.extend({
            init: function init() {
              var t = this.model.components();
              !t.length && t.add(p);
            },
            onRender: function onRender() {}
          })
        });
      },
      _t = function _t(t, e, n) {
        var i = t.getType("link"),
          r = i.model,
          a = i.view,
          o = Pt.attrAccordion,
          s = Pt.classAccordion,
          l = Pt.selectorAccordion,
          c = Pt.attrAccordionContainer,
          d = Pt.accordionProps,
          u = o,
          h = s;
        t.addType(n, {
          model: r.extend({
            defaults: _objectSpread({}, r.prototype.defaults, {
              name: e,
              draggable: "[".concat(c, "]"),
              droppable: !0,
              copyable: !1,
              removable: !1,
              selectable: !0
            }, d),
            init: function init() {
              var t = this.getAttributes();
              t[u] = 1, this.setAttributes(t), h && this.addClass(h);
            },
            clone: function clone() {
              var t = r.prototype.clone.apply(this, arguments);
              return t.addAttributes(_defineProperty({}, l, "")), t;
            }
          }, {
            isComponent: function isComponent(t) {
              if (t.hasAttribute && t.hasAttribute(u)) return {
                type: n
              };
            }
          }),
          view: a
        });
      },
      Ht = function Ht(t, e, n) {
        var i = t.getType("default"),
          r = i.model,
          a = i.view,
          o = Pt.attrAccordionContent,
          s = Pt.classAccordionContent,
          l = Pt.attrAccordionContainer,
          c = Pt.accordionContentProps,
          d = o,
          u = s;
        t.addType(n, {
          model: r.extend({
            defaults: _objectSpread({}, r.prototype.defaults, {
              name: e,
              draggable: "[".concat(l, "]"),
              copyable: !1,
              removable: !1,
              selectable: !0
            }, c),
            init: function init() {
              var t = this.getAttributes();
              t[d] = 1, this.setAttributes(t), u && this.addClass(u);
            }
          }, {
            isComponent: function isComponent(t) {
              if (t.hasAttribute && t.hasAttribute(d)) return {
                type: n
              };
            }
          }),
          view: a
        });
      },
      Vt = function Vt(t, e, n) {
        var i = t.getType("default"),
          r = i.model,
          a = i.view,
          o = Pt.attrAccordions,
          s = Pt.attrAccordionContainer,
          l = Pt.classAccordionContainer,
          c = Pt.attrAccordionContent,
          d = Pt.selectorAccordion,
          u = Pt.accordionContainerProps,
          h = s,
          p = l;
        t.addType(n, {
          model: r.extend({
            defaults: _objectSpread({}, r.prototype.defaults, {
              name: e,
              draggable: "[".concat(o, ", ").concat(c, "]"),
              droppable: !1,
              copyable: !0,
              removable: !0
            }, u),
            init: function init() {
              var t = this.getAttributes();
              t[h] = 1, this.setAttributes(t), p && this.addClass(p), this.listenTo(this, "add", this.onAdd);
            },
            onAdd: function onAdd() {
              var t = this.components().models;
              if (t && Array.isArray(t)) {
                var _e15;
                for (var _n11 = t.length - 1; _n11 >= 0; _n11--) {
                  var _i10 = t[_n11];
                  _i10.getAttributes()["".concat(c)] ? (_e15 = _i10.getId(), _i10.setId(_e15)) : _i10.addAttributes(_defineProperty({}, d, "#".concat(_e15)));
                }
              }
            }
          }, {
            isComponent: function isComponent(t) {
              if (t.hasAttribute && t.hasAttribute(h)) return {
                type: n
              };
            }
          }),
          view: a
        });
      };
    var Ft = function Ft(t, e, n, i) {
      var r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {};
      var a = r,
        o = a.pfxCarousels;
      t.add(i, {
        label: n,
        category: e,
        activate: !0,
        select: !0,
        content: "\n        <div class='".concat(o, "' data-js=").concat(i, " data-gjs-type=").concat(i, ">\n        </div>"),
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n    <div class=\"drap-on-six\"><svg class=\"gjs-block-svg\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"50\">\n    <path d=\"M22 7.6c0-1-.5-1.6-1.3-1.6H3.4C2.5 6 2 6.7 2 7.6v9.8c0 1 .5 1.6 1.3 1.6h17.4c.8 0 1.3-.6 1.3-1.6V7.6zM21 18H3V7h18v11z\" fill-rule=\"nonzero\"/><path d=\"M4 12.5L6 14v-3zM20 12.5L18 14v-3z\"/>\n    </svg></div>\n    <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n      <a\n        target=\"_blank\"\n        href=\"https://academy.drapcode.com/docs/app-builder/layout-component-sections\"\n        draggable=\"false\"\n      >\n        <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n      </a>\n    </div>\n    <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n  </div>\n    ");
        }
      });
    };
    var Rt = function Rt(t, e, n) {
      var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
      var r = t.getType("default"),
        a = r.model,
        o = r.view,
        _ref = (i.pfxCarousels, i),
        s = _ref.toolbarBtnDrapCodeCarouselsCarouselCode,
        l = _ref.refs,
        c = _ref.commands;
      var d;
      t.addType("script", {
        view: {
          onRender: function onRender() {
            this.model.closestType(n) && (this.el.innerHTML = "");
          }
        }
      }), t.addType(n, {
        model: a.extend({
          defaults: _objectSpread({}, a.prototype.defaults, {
            name: e,
            editable: !0,
            droppable: !1
          }, i.propsDrapCodeCarouselsCarouselCode),
          init: function init() {
            this.listenTo(this, "change:".concat(l.keyDrapCodeCarouselsCustomCode), this.onDrapCodeCarouselSectionCodeChange);
            var t = this.get(l.keyDrapCodeCarouselsCustomCode) || i.carouselsPlaceholderContent;
            !this.components().length && this.components(t);
            var e = this.get("toolbar"),
              n = "drapcode-carousels";
            s && !e.filter(function (t) {
              return t.id === n;
            }).length && e.unshift(_objectSpread({
              id: n,
              command: c.drapcode_carousels_custom_code,
              label: "<svg viewBox=\"0 0 24 24\" height=\"16\" xmlns=\"http://www.w3.org/2000/svg\">\n              <path d=\"M22 7.6c0-1-.5-1.6-1.3-1.6H3.4C2.5 6 2 6.7 2 7.6v9.8c0 1 .5 1.6 1.3 1.6h17.4c.8 0 1.3-.6 1.3-1.6V7.6zM21 18H3V7h18v11z\" fill-rule=\"nonzero\"/><path d=\"M4 12.5L6 14v-3zM20 12.5L18 14v-3z\"/>\n              </svg>",
              attributes: {
                title: "Select Carousel"
              }
            }, s));
          },
          onDrapCodeCarouselSectionCodeChange: function onDrapCodeCarouselSectionCodeChange() {
            this.components(this.get(l.keyDrapCodeCarouselsCustomCode));
          }
        }, {
          isComponent: function isComponent(t) {
            if (t.getAttribute && t.getAttribute("data-gjs-type") === n) return {
              type: n
            };
          }
        }),
        view: o.extend({
          init: function init() {
            this.listenTo(this.model.components(), "add remove reset", this.onComponentsChange), this.onComponentsChange();
          },
          onComponentsChange: function onComponentsChange() {
            var _this2 = this;
            d && clearInterval(d), d = setTimeout(function () {
              var t = _this2.model;
              var e = 1;
              (t.get(l.keyDrapCodeCarouselsCustomCode) || "").indexOf("<script") >= 0 && (_this2.el.innerHTML = i.placeholderScript, e = 0), t.set({
                droppable: e
              });
            }, 0);
          },
          onActive: function onActive() {
            var t = this.model;
            this.em.get("Commands").run(c.drapcode_carousels_custom_code, {
              target: t
            });
          }
        })
      });
    };
    var Bt = function Bt(t, e, n, i, r) {
      var a = "\n  <style>\n    ".concat(i, " {\n      position:relative;\n      font-weight:400;\n      font-size:15px;\n      width:100%;\n      bottom:0;\n      right: 0;\n      left: 0;\n      clear:both;\n    }\n    ul {\n      padding:0;\n      margin:0;\n    }\n    li {\n      list-style:none;\n    }\n    a:focus,a:hover {\n      text-decoration:none;\n      -webkit-transition:.3s ease;\n      -o-transition:.3s ease;\n      transition:.3s ease;\n    }\n    a:focus {\n      outline:0;\n    }\n    img {\n      max-width:100%;\n    }\n    p {\n      font-size:16px;\n      line-height:30px;\n      color:#363940;\n      font-weight:300;\n    }\n    h4 {\n      margin:0;\n      font-weight:400;\n      padding:0;\n      color:#363940;\n    }\n    a {\n      color:#007bff;\n    }\n    .no-padding {\n      padding:0!important;\n    }\n    .").concat(i, "--absolute {\n      position:absolute;\n    }\n    .").concat(i, "--relative {\n      position:relative;\n    }\n    .").concat(i, "--static {\n      position:static;\n    }\n    .").concat(i, "--fixed {\n      position:fixed;\n    }\n    .").concat(i, "-big {\n      padding:105px 0 65px 0;\n      margin-top:1rem;\n    }\n    .").concat(i, "-big .").concat(i, "-widget {\n      margin-bottom:40px;\n    }\n    .").concat(i, "--light {\n      background:#e9ecef;\n    }\n    .").concat(i, "--dark {\n      background:#363940;\n    }\n    .").concat(i, "-big .").concat(i, "-menu ul li a,.").concat(i, "-big p,.").concat(i, "-big ul li {\n      color:#363940;\n    }\n    .").concat(i, "--dark h4,.").concat(i, "--dark .").concat(i, "-big p,.").concat(i, "--dark .").concat(i, "-menu ul li a,.").concat(i, "--dark .").concat(i, "-big ul li {\n      color:#e9ecef;\n    }\n    .").concat(i, "-menu {\n      padding-left:48px;\n    }\n    .").concat(i, "-menu ul li a {\n      font-size:15px;\n      line-height:32px;\n      -webkit-transition:.3s;\n      -o-transition:.3s;\n      transition:.3s;\n    }\n    .").concat(i, "-menu ul li a:hover {\n      color:#0056b3;\n    }\n    .").concat(i, "-menu--1 {\n      width:100%;\n    }\n    .").concat(i, "-widget-title {\n      line-height:42px;\n      margin-bottom:10px;\n      font-size:18px;\n    }\n    .mini-").concat(i, " {\n      background:#192027;\n      text-align:center;\n      padding:32px 0;\n    }\n    .mini-").concat(i, " p {\n      margin:0;\n      line-height:26px;\n      font-size:15px;\n      color:#999;\n    }\n    .mini-").concat(i, " p a {\n      color:#007bff;\n    }\n    .mini-").concat(i, " p a:hover {\n      color:#34bfa3;\n    }\n    .widget-about img {\n      display:block;\n      margin-bottom:30px;\n    }\n    .widget-about p {\n      font-weight:400;\n    }\n    .widget-about .contact-details {\n      margin:30px 0 0 0;\n    }\n    .widget-about .contact-details li {\n      margin-bottom:10px;\n    }\n    .widget-about .contact-details li:last-child {\n      margin-bottom:0;\n    }\n    .widget-about .contact-details li span {\n      padding-right:12px;\n    }\n    .widget-about .contact-details li a {\n      color:#007bff;\n    }\n    @media (max-width:991px) {\n      .").concat(i, "-menu {\n        padding-left:0;\n      }\n    }   \n  </style>\n  ");
      var o = "\n  <div class=\"footer-big\" data-gjs-custom-name=\"".concat(r.labels.labelFooterBigContainer, "\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-md-3 col-sm-12\">\n          <div class=\"footer-widget\" data-gjs-custom-name=\"").concat(r.labels.labelFooterWidget, "\">\n            <div class=\"widget-about\" data-gjs-custom-name=\"").concat(r.labels.labelFooterWidgetAbout, "\">\n              <img src=\"https://picsum.photos/250/80\" alt=\"Image\" class=\"img-fluid\">\n              <p>We are a young company always looking for new and creative ideas to help you with our products in your everyday work.</p>\n              <ul class=\"contact-details\" data-gjs-custom-name=\"").concat(r.labels.labelFooterContact, "\">\n                <li>\n                  <span class=\"icon-earphones\"></span> Call Us:\n                  <a href=\"tel:XXX-XXX-XXX\">XXX-XXX-XXX</a>\n                </li>\n                <li>\n                  <span class=\"icon-envelope-open\"></span>\n                  <a href=\"mailto:support@drapcode.com\">support@drapcode.com</a>\n                </li>\n              </ul>\n            </div>\n          </div>\n        </div>\n        <div class=\"col-md-3 col-sm-4\">\n          <div class=\"footer-widget\" data-gjs-custom-name=\"").concat(r.labels.labelFooterWidget, "\">\n            <div class=\"footer-menu footer-menu--1\" data-gjs-custom-name=\"").concat(r.labels.labelFooterMenu, "\">\n              <h4 class=\"footer-widget-title\">Popular Category</h4>\n              <ul>\n                <li>\n                  <a href=\"#\">Category #1</a>\n                </li>\n                <li>\n                  <a href=\"#\">Category #2</a>\n                </li>\n                <li>\n                  <a href=\"#\">Category #3</a>\n                </li>\n                <li>\n                  <a href=\"#\">Category #4</a>\n                </li>\n                <li>\n                  <a href=\"#\">Category #5</a>\n                </li>\n              </ul>\n            </div>\n          </div>\n        </div>\n        <div class=\"col-md-3 col-sm-4\">\n          <div class=\"footer-widget\" data-gjs-custom-name=\"").concat(r.labels.labelFooterWidget, "\">\n            <div class=\"footer-menu\" data-gjs-custom-name=\"").concat(r.labels.labelFooterMenu, "\">\n              <h4 class=\"footer-widget-title\">Our Company</h4>\n              <ul>\n                <li>\n                  <a href=\"#\">About Us</a>\n                </li>\n                <li>\n                  <a href=\"#\">How It Works</a>\n                </li>\n                <li>\n                  <a href=\"#\">Testimonials</a>\n                </li>\n                <li>\n                  <a href=\"#\">Contact Us</a>\n                </li>\n                <li>\n                  <a href=\"#\">Blog</a>\n                </li>\n              </ul>\n            </div>\n          </div>\n        </div>\n        <div class=\"col-md-3 col-sm-4\">\n          <div class=\"footer-widget\" data-gjs-custom-name=\"").concat(r.labels.labelFooterWidget, "\">\n            <div class=\"footer-menu no-padding\" data-gjs-custom-name=\"").concat(r.labels.labelFooterMenu, "\">\n              <h4 class=\"footer-widget-title\">Help Support</h4>\n              <ul>\n                <li>\n                  <a href=\"#\">Support Forum</a>\n                </li>\n                <li>\n                  <a href=\"#\">Terms &amp; Conditions</a>\n                </li>\n                <li>\n                  <a href=\"#\">Support Policy</a>\n                </li>\n                <li>\n                  <a href=\"#\">FAQs</a>\n                </li>\n              </ul>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"mini-footer\" data-gjs-custom-name=\"").concat(r.labels.labelMiniFooter, "\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-md-12\">\n          <div class=\"copyright-text\" data-gjs-custom-name=\"").concat(r.labels.labelFooterCopyright, "\">\n            <p>Copyright 2020\n              <a href=\"#\">DrapCode</a>. All rights reserved.\n            </p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>"),
        s = "\n    <footer class=\"footer-area footer--light footer--relative\">\n      ".concat(o, "\n    </footer>");
      t.add("footer", {
        label: n,
        category: e,
        content: "".concat(s).concat(a),
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n      <div class=\"drap-on-six\"> <svg viewBox=\"0 0 24 24\" width=\"32\" height=\"50\" xmlns=\"http://www.w3.org/2000/svg\"><g><path d=\"m21 0h-18c-1.654 0-3 1.346-3 3v18c0 1.654 1.346 3 3 3h18c1.654 0 3-1.346 3-3v-18c0-1.654-1.346-3-3-3zm1 21c0 .552-.448 1-1 1h-18c-.552 0-1-.448-1-1v-18c0-.552.448-1 1-1h18c.552 0 1 .448 1 1z\"/><path d=\"m18.25 13h-12.5c-.965 0-1.75.785-1.75 1.75v3.5c0 .965.785 1.75 1.75 1.75h12.5c.965 0 1.75-.785 1.75-1.75v-3.5c0-.965-.785-1.75-1.75-1.75z\"/></g></svg></div>\n      <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n        <a\n          target=\"_blank\"\n          href=\"https://academy.drapcode.com/docs/app-builder/layout-component-footer\"\n          draggable=\"false\"\n        >\n          <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </div>\n      <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n    </div>\n  ");
        }
      });
    };
    var Wt = function Wt(t, e, n) {
      var i = t.getType("default"),
        r = i.model,
        a = i.view;
      t.addType("footer", {
        model: r.extend({
          defaults: _objectSpread({}, r.prototype.defaults, {
            "custom-name": e,
            tagName: "footer",
            classes: ["footer-area"],
            resizable: !0,
            traits: [{
              type: "class_select",
              options: [{
                value: "footer--light",
                name: "Light"
              }, {
                value: "footer--dark",
                name: "Dark"
              }],
              label: "Theme"
            }, {
              type: "class_select",
              options: [{
                value: "footer--absolute",
                name: "Absolute"
              }, {
                value: "footer--fixed",
                name: "Fixed"
              }, {
                value: "footer--relative",
                name: "Relative"
              }, {
                value: "footer--static",
                name: "Static"
              }],
              label: "Position"
            }].concat(r.prototype.defaults.traits)
          })
        }, {
          isComponent: function isComponent(t) {
            if (t && t.classList && t.classList.contains("footer-area")) return {
              type: n
            };
          }
        }),
        view: a
      });
    };
    var Yt = function Yt(t, e, n, i, r) {
      var a = "\n  <div class=\"".concat(r.types.modal_dialog, "\">\n    <div class=\"").concat(r.types.modal_content, "\">\n      <div class=\"").concat(r.types.modal_header, "\">\n        <h5 class=\"").concat(r.types.modal_title, "\" data-gjs-custom-name=\"").concat(r.labels.modal_title, "\">Modal Title</h5>\n        <button type=\"button\" class=\"btn close\" aria-label=\"Close\">x</button>\n      </div>\n      <div class=\"").concat(r.types.modal_body, "\">\n        <p>Modal body text goes here.</p>\n      </div>\n      <div class=\"").concat(r.types.modal_footer, "\">\n        <button type=\"button\" class=\"btn btn-secondary\">Close</button>\n      </div>\n    </div>\n  </div>"),
        o = "\n  <div class=\"modal fade show\">\n    ".concat(a, "\n  </div>");
      t.add(i, {
        label: n,
        attributes: {
          class: "fa fa-window-restore",
          style: "display: none"
        },
        category: e,
        content: "".concat(o).concat("\n  <style>\n  .modal.show{\n    display: block;\n    background-color: rgba(0, 0, 0, 0.6);\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n  </style>\n  ")
      });
    };
    var Ut = function Ut(t, e, n, i) {
        var r = t.getType("default"),
          a = r.model,
          o = r.view,
          s = "dc-modal-" + st()(8, "");
        t.addType(n, {
          model: a.extend({
            defaults: _objectSpread({}, a.prototype.defaults, {
              "custom-name": e,
              tagName: "div",
              classes: ["modal"],
              attributes: {
                role: "dialog",
                tabindex: "-1",
                id: s,
                "data-modal-show": ""
              },
              traits: [{
                type: "select",
                options: [{
                  value: "yes",
                  name: "Yes"
                }, {
                  value: "",
                  name: "No"
                }],
                label: "Display On Load",
                name: "data-modal-show"
              }].concat(a.prototype.defaults.traits)
            })
          }, {
            isComponent: function isComponent(t) {
              if (t && t.classList && t.classList.contains("modal")) return {
                type: n
              };
            }
          }),
          view: o
        }), t.addType(i.types.modal_dialog, {
          model: a.extend({
            defaults: _objectSpread({}, a.prototype.defaults, {
              "custom-name": i.labels.modal_dialog,
              tagName: "div",
              classes: ["modal-dialog"],
              attributes: {
                role: "document"
              },
              removable: !1,
              traits: [{
                type: "class_select",
                options: [{
                  value: "modal-dialog-centered",
                  name: "Yes"
                }, {
                  value: "",
                  name: "No"
                }],
                label: "Vertically Centered"
              }, {
                type: "class_select",
                options: [{
                  value: "modal-sm",
                  name: "Small"
                }, {
                  value: "modal-lg",
                  name: "Large"
                }, {
                  value: "",
                  name: "Default"
                }],
                label: "Size"
              }].concat(a.prototype.defaults.traits)
            })
          }, {
            isComponent: function isComponent(t) {
              if (t && t.classList && t.classList.contains("modal-dialog")) return {
                type: i.types.modal_dialog
              };
            }
          }),
          view: o
        }), t.addType(i.types.modal_content, {
          model: a.extend({
            defaults: _objectSpread({}, a.prototype.defaults, {
              "custom-name": i.labels.modal_content,
              tagName: "div",
              classes: ["modal-content"],
              removable: !1
            })
          }, {
            isComponent: function isComponent(t) {
              if (t && t.classList && t.classList.contains("modal-content")) return {
                type: i.types.modal_content
              };
            }
          }),
          view: o
        }), t.addType(i.types.modal_header, {
          model: a.extend({
            defaults: _objectSpread({}, a.prototype.defaults, {
              "custom-name": i.labels.modal_header,
              tagName: "div",
              classes: ["modal-header"],
              removable: !1
            })
          }, {
            isComponent: function isComponent(t) {
              if (t && t.classList && t.classList.contains("modal-header")) return {
                type: i.types.modal_header
              };
            }
          }),
          view: o
        }), t.addType(i.types.modal_body, {
          model: a.extend({
            defaults: _objectSpread({}, a.prototype.defaults, {
              "custom-name": i.labels.modal_body,
              tagName: "div",
              classes: ["modal-body"],
              removable: !1
            })
          }, {
            isComponent: function isComponent(t) {
              if (t && t.classList && t.classList.contains("modal-body")) return {
                type: i.types.modal_body
              };
            }
          }),
          view: o
        }), t.addType(i.types.modal_footer, {
          model: a.extend({
            defaults: _objectSpread({}, a.prototype.defaults, {
              "custom-name": i.labels.modal_footer,
              tagName: "div",
              classes: ["modal-footer"],
              removable: !1
            })
          }, {
            isComponent: function isComponent(t) {
              if (t && t.classList && t.classList.contains("modal-footer")) return {
                type: i.types.modal_footer
              };
            }
          }),
          view: o
        });
      },
      Zt = "<svg xmlns=\"http://www.w3.org/2000/svg\"\n    xmlns:xlink=\"http://www.w3.org/1999/xlink\" aria-hidden=\"true\" focusable=\"false\" width=\"1.5em\" height=\"1.5em\" style=\"-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);\" preserveAspectRatio=\"xMidYMid meet\" viewBox=\"0 0 24 24\">\n    <path d=\"M13.397 20.997v-8.196h2.765l.411-3.209h-3.176V7.548c0-.926.258-1.56 1.587-1.56h1.684V3.127A22.336 22.336 0 0 0 14.201 3c-2.444 0-4.122 1.492-4.122 4.231v2.355H7.332v3.209h2.753v8.202h3.312z\" fill=\"#ffff\"/>\n    <rect x=\"0\" y=\"0\" width=\"24\" height=\"24\" fill=\"rgba(0, 0, 0, 0)\" />\n</svg>";
    var Gt = function Gt(t, e, n, i) {
      t.add(i, {
        label: n,
        category: e,
        activate: !0,
        select: !0,
        content: "\n          <button type=\"submit\" class=\"btn btn-primary btn-sm btn-facebook\">\n          ".concat(Zt, "\n          Login</button>\n      "),
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n    <div class=\"drap-on-six\"><svg class=\"gjs-block-svg\" viewBox=\"0 0 24 24\" width=\"32\" height=\"50\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path class=\"gjs-block-svg-path\" d=\"M22,9 C22,8.4 21.5,8 20.75,8 L3.25,8 C2.5,8 2,8.4 2,9 L2,15 C2,15.6 2.5,16 3.25,16 L20.75,16 C21.5,16 22,15.6 22,15 L22,9 Z M21,15 L3,15 L3,9 L21,9 L21,15 Z\" fill-rule=\"nonzero\"></path>\n    <rect class=\"gjs-block-svg-path\" x=\"4\" y=\"11.5\" width=\"16\" height=\"1\"></rect>\n    </svg></div>\n    <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n      <a\n        target=\"_blank\"\n        href=\"https://academy.drapcode.com/docs/app-builder/form-components#file-upload-field\"\n        draggable=\"false\"\n      >\n        <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n      </a>\n    </div>\n    <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n  </div>\n    ");
        }
      });
    };
    var qt = function qt(t, e, n, i) {
        var r = t.getType("default"),
          a = r.model,
          o = r.view;
        var s;
        t.addType(n, {
          model: a.extend({
            defaults: _objectSpread({}, a.prototype.defaults, {
              "custom-name": e,
              editable: !0,
              droppable: !1,
              resizable: !0,
              attributes: {
                role: "button"
              },
              traits: [{
                type: "content",
                label: "Text"
              }, {
                label: "Type",
                type: "button-type",
                name: "type",
                options: [{
                  value: "submit",
                  name: "Submit"
                }, {
                  value: "reset",
                  name: "Reset"
                }, {
                  value: "button",
                  name: "Button"
                }]
              }, {
                type: "webconnect-text",
                label: !1,
                content: "Login"
              }]
            }),
            init: function init() {},
            onCustomButtonChange: function onCustomButtonChange() {
              this.components(this.get(n));
            },
            afterChange: function afterChange(t) {
              this.attributes.type === n && 0 === this.attributes.classes.filter(function (t) {
                return "btn" === t.id;
              }).length && this.changeType("link");
            }
          }, {
            isComponent: function isComponent(t) {
              if (t && t.classList && t.classList.contains("btn-facebook")) return {
                type: n
              };
            }
          }),
          view: o.extend({
            events: {
              click: "handleClick",
              dblclick: "onActive"
            },
            init: function init() {
              this.listenTo(this.model, "change:content", this.updateContent), this.listenTo(this.model.components(), "add remove reset", this.onComponentsChange), this.onComponentsChange();
            },
            onComponentsChange: function onComponentsChange() {
              var _this3 = this;
              s && clearInterval(s), s = setTimeout(function () {
                var t = _this3.model;
                t.set({
                  droppable: 1
                });
              }, 0);
            },
            onActive: function onActive() {
              var t = this.model;
              this.em.get("Commands").run(i, {
                target: t
              });
            },
            updateContent: function updateContent() {
              this.el.innerHTML = this.model.get("content");
            },
            handleClick: function handleClick(t) {
              t.preventDefault();
            }
          })
        });
      },
      $t = "<svg xmlns=\"http://www.w3.org/2000/svg\"\n    xmlns:xlink=\"http://www.w3.org/1999/xlink\" aria-hidden=\"true\" focusable=\"false\" width=\"1.5em\" height=\"1.5em\" style=\"-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);\" preserveAspectRatio=\"xMidYMid meet\" viewBox=\"0 0 24 24\">\n    <path d=\"M20.283 10.356h-8.327v3.451h4.792c-.446 2.193-2.313 3.453-4.792 3.453a5.27 5.27 0 0 1-5.279-5.28a5.27 5.27 0 0 1 5.279-5.279c1.259 0 2.397.447 3.29 1.178l2.6-2.599c-1.584-1.381-3.615-2.233-5.89-2.233a8.908 8.908 0 0 0-8.934 8.934a8.907 8.907 0 0 0 8.934 8.934c4.467 0 8.529-3.249 8.529-8.934c0-.528-.081-1.097-.202-1.625z\" fill=\"#ffff\"/>\n    <rect x=\"0\" y=\"0\" width=\"24\" height=\"24\" fill=\"rgba(0, 0, 0, 0)\" />\n</svg>";
    var Qt = function Qt(t, e, n, i) {
      t.add(i, {
        label: n,
        category: e,
        activate: !0,
        select: !0,
        content: "\n          <button type=\"submit\" class=\"btn btn-primary btn-sm btn-google\">\n          ".concat($t, "\n          Login</button>\n      "),
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n    <div class=\"drap-on-six\"><svg class=\"gjs-block-svg\" viewBox=\"0 0 24 24\" width=\"32\" height=\"50\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path class=\"gjs-block-svg-path\" d=\"M22,9 C22,8.4 21.5,8 20.75,8 L3.25,8 C2.5,8 2,8.4 2,9 L2,15 C2,15.6 2.5,16 3.25,16 L20.75,16 C21.5,16 22,15.6 22,15 L22,9 Z M21,15 L3,15 L3,9 L21,9 L21,15 Z\" fill-rule=\"nonzero\"></path>\n    <rect class=\"gjs-block-svg-path\" x=\"4\" y=\"11.5\" width=\"16\" height=\"1\"></rect>\n  </svg></div>\n    <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n      <a\n        target=\"_blank\"\n        href=\"https://academy.drapcode.com/docs/app-builder/basic-component-audio\"\n        draggable=\"false\"\n      >\n        <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n      </a>\n    </div>\n    <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n  </div>\n    ");
        }
      });
    };
    var Jt = function Jt(t, e, n, i) {
      var r = t.getType("default"),
        a = r.model,
        o = r.view;
      var s;
      t.addType(n, {
        model: a.extend({
          defaults: _objectSpread({}, a.prototype.defaults, {
            "custom-name": e,
            editable: !0,
            droppable: !1,
            resizable: !0,
            attributes: {
              role: "button"
            },
            traits: [{
              type: "content",
              label: "Text"
            }, {
              label: "Type",
              type: "button-type",
              name: "type",
              options: [{
                value: "submit",
                name: "Submit"
              }, {
                value: "reset",
                name: "Reset"
              }, {
                value: "button",
                name: "Button"
              }]
            }, {
              type: "webconnect-text",
              label: !1,
              content: "Login"
            }]
          }),
          init: function init() {},
          onCustomButtonChange: function onCustomButtonChange() {
            this.components(this.get(n));
          },
          afterChange: function afterChange(t) {
            this.attributes.type === n && 0 === this.attributes.classes.filter(function (t) {
              return "btn" === t.id;
            }).length && this.changeType("link");
          }
        }, {
          isComponent: function isComponent(t) {
            if (t && t.classList && t.classList.contains("btn-google")) return {
              type: n
            };
          }
        }),
        view: o.extend({
          events: {
            click: "handleClick",
            dblclick: "onActive"
          },
          init: function init() {
            this.listenTo(this.model, "change:content", this.updateContent), this.listenTo(this.model.components(), "add remove reset", this.onComponentsChange), this.onComponentsChange();
          },
          onComponentsChange: function onComponentsChange() {
            var _this4 = this;
            s && clearInterval(s), s = setTimeout(function () {
              var t = _this4.model;
              t.set({
                droppable: 1
              });
            }, 0);
          },
          onActive: function onActive() {
            var t = this.model;
            this.em.get("Commands").run(i, {
              target: t
            });
          },
          updateContent: function updateContent() {
            this.el.innerHTML = this.model.get("content");
          },
          handleClick: function handleClick(t) {
            t.preventDefault();
          }
        })
      });
    };
    var Xt = function Xt(t, e, n, i) {
      var r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {};
      var a = r,
        o = a.pfxSections;
      t.add(i, {
        label: n,
        category: e,
        activate: !0,
        select: !0,
        content: "\n        <section class='".concat(o, "' data-js=").concat(i, " data-gjs-type=").concat(i, " style='padding: 12px;min-height: auto;'>\n        </section>"),
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n    <div class=\"drap-on-six\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"50\" fill=\"currentColor\" class=\"bi bi-grid-3x2-gap-fill\" viewBox=\"0 0 16 16\">\n    <path d=\"M1 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V4zM1 9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V9zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V9zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V9z\"/>\n    </svg></div>\n    <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n      <a\n        target=\"_blank\"\n        href=\"https://academy.drapcode.com/docs/app-builder/layout-component-sections\"\n        draggable=\"false\"\n      >\n        <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n      </a>\n    </div>\n    <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n  </div>\n    ");
        }
      }), t.add(i + "frequently_used", {
        label: n,
        category: "Frequently Used",
        attributes: {
          style: "order: 3"
        },
        activate: !0,
        select: !0,
        content: "\n        <section class='".concat(o, "' data-js=").concat(i, " data-gjs-type=").concat(i, " style='padding: 12px;min-height: auto;'>\n        </section>"),
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n    <div class=\"drap-on-six\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"50\" fill=\"currentColor\" class=\"bi bi-grid-3x2-gap-fill\" viewBox=\"0 0 16 16\">\n    <path d=\"M1 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V4zM1 9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V9zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V9zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V9z\"/>\n    </svg></div>\n    <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n      <a\n        target=\"_blank\"\n        href=\"https://academy.drapcode.com/docs/app-builder/layout-component-sections\"\n        draggable=\"false\"\n      >\n        <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n      </a>\n    </div>\n    <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n  </div>\n    ");
        }
      });
    };
    var Kt = function Kt(t, e, n) {
      var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
      var r = t.getType("default"),
        a = r.model,
        o = r.view,
        _ref2 = (i.pfxSections, i),
        s = _ref2.toolbarBtnDrapCodeSectionsSectionCode,
        l = _ref2.refs,
        c = _ref2.commands;
      var d;
      t.addType("script", {
        view: {
          onRender: function onRender() {
            this.model.closestType(n) && (this.el.innerHTML = "");
          }
        }
      }), t.addType(n, {
        model: a.extend({
          defaults: _objectSpread({}, a.prototype.defaults, {
            name: e,
            editable: !0,
            droppable: !1
          }, i.propsDrapCodeSectionsSectionCode),
          init: function init() {
            this.listenTo(this, "change:".concat(l.keyDrapCodeSectionsCustomCode), this.onDrapCodeSectionsSectionCodeChange);
            var t = this.get(l.keyDrapCodeSectionsCustomCode) || i.sectionsPlaceholderContent;
            !this.components().length && this.components(t);
            var e = this.get("toolbar"),
              n = "drapcode-sections";
            s && !e.filter(function (t) {
              return t.id === n;
            }).length && e.unshift(_objectSpread({
              id: n,
              command: c.drapcode_sections_custom_code,
              label: "<svg fill=\"currentColor\" class=\"bi bi-grid-3x2-gap-fill\" viewBox=\"0 0 16 16\">\n              <path d=\"M1 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V4zM1 9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V9zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V9zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V9z\"/>\n            </svg>",
              attributes: {
                title: "Select Section"
              }
            }, s));
          },
          onDrapCodeSectionsSectionCodeChange: function onDrapCodeSectionsSectionCodeChange() {
            this.components(this.get(l.keyDrapCodeSectionsCustomCode));
          }
        }, {
          isComponent: function isComponent(t) {
            if (t.getAttribute && t.getAttribute("data-gjs-type") === n) return {
              type: n
            };
          }
        }),
        view: o.extend({
          init: function init() {
            this.listenTo(this.model.components(), "add remove reset", this.onComponentsChange), this.onComponentsChange();
          },
          onComponentsChange: function onComponentsChange() {
            var _this5 = this;
            d && clearInterval(d), d = setTimeout(function () {
              var t = _this5.model;
              var e = 1;
              (t.get(l.keyDrapCodeSectionsCustomCode) || "").indexOf("<script") >= 0 && (_this5.el.innerHTML = i.placeholderScript, e = 0), t.set({
                droppable: e
              });
            }, 0);
          },
          onActive: function onActive() {
            var t = this.model;
            this.em.get("Commands").run(c.drapcode_sections_custom_code, {
              target: t
            });
          }
        })
      });
    };
    var te = function te(t, e, n, i) {
        var r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {};
        var a = r,
          o = (a.pfxSections, a.sections),
          s = o;
        s.forEach(function (e) {
          t.add(e.value, {
            label: e.label,
            category: "Sections",
            attributes: {
              title: e.label
            },
            select: !0,
            content: "".concat(e.code),
            render: function render(t) {
              var i = t.model,
                r = t.className;
              return "\n      <div class=\"drapcode-compo-seventeen ".concat(r, "-label ").concat(r, "__drapcode-wrap\">\n      <div class=\"drap-on-six\">").concat(e.view, "</div>\n      <div class=\"drapcode-compo-qustion ").concat(r, "__info\">\n        <a\n          target=\"_blank\"\n          href=\"https://academy.drapcode.com/docs/app-builder/layout-component-sections\"\n          draggable=\"false\"\n        >\n          <i class=\"bem-Svg ").concat(r, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </div>\n      <div class=\"drapcode-com-one\">").concat(i.get("label"), "</div>\n    </div>\n      ");
            }
          });
        });
      },
      ee = function ee(t, e, n, i) {
        var r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {};
        var a = r,
          o = a.pfxCards;
        t.add(i, {
          label: n,
          category: e,
          activate: !0,
          select: !0,
          content: "\n        <div class='".concat(o, "' data-js=").concat(i, " data-gjs-type=").concat(i, ">\n        </div>"),
          render: function render(t) {
            var e = t.model,
              i = t.className;
            return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n    <div class=\"drap-on-six\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 576 512\" width=\"32\" height=\"50\">\n    <path d=\"M527.9 32H48.1C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48.1 48h479.8c26.6 0 48.1-21.5 48.1-48V80c0-26.5-21.5-48-48.1-48zM54.1 80h467.8c3.3 0 6 2.7 6 6v42H48.1V86c0-3.3 2.7-6 6-6zm467.8 352H54.1c-3.3 0-6-2.7-6-6V256h479.8v170c0 3.3-2.7 6-6 6zM192 332v40c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12zm192 0v40c0 6.6-5.4 12-12 12H236c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12z\"/>\n    </svg></div>\n    <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n      <a\n        target=\"_blank\"\n        href=\"https://academy.drapcode.com/docs/app-builder/layout-component-sections\"\n        draggable=\"false\"\n      >\n        <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n      </a>\n    </div>\n    <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n  </div>\n    ");
          }
        });
      };
    var ne = function ne(t, e, n) {
      var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
      var r = t.getType("default"),
        a = r.model,
        o = r.view,
        _ref3 = (i.pfxCards, i),
        s = _ref3.toolbarBtnDrapCodeCardsCardCode,
        l = _ref3.refs,
        c = _ref3.commands;
      var d;
      t.addType("script", {
        view: {
          onRender: function onRender() {
            this.model.closestType(n) && (this.el.innerHTML = "");
          }
        }
      }), t.addType(n, {
        model: a.extend({
          defaults: _objectSpread({}, a.prototype.defaults, {
            name: e,
            editable: !0,
            droppable: !1
          }, i.propsDrapCodeCardsCardCode),
          init: function init() {
            this.listenTo(this, "change:".concat(l.keyDrapCodeCardsCustomCode), this.onDrapCodeCardSectionCodeChange);
            var t = this.get(l.keyDrapCodeCardsCustomCode) || i.cardsPlaceholderContent;
            !this.components().length && this.components(t);
            var e = this.get("toolbar"),
              n = "drapcode-cards";
            s && !e.filter(function (t) {
              return t.id === n;
            }).length && e.unshift(_objectSpread({
              id: n,
              command: c.drapcode_cards_custom_code,
              label: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 576 512\" height=\"14\">\n              <path d=\"M527.9 32H48.1C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48.1 48h479.8c26.6 0 48.1-21.5 48.1-48V80c0-26.5-21.5-48-48.1-48zM54.1 80h467.8c3.3 0 6 2.7 6 6v42H48.1V86c0-3.3 2.7-6 6-6zm467.8 352H54.1c-3.3 0-6-2.7-6-6V256h479.8v170c0 3.3-2.7 6-6 6zM192 332v40c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12zm192 0v40c0 6.6-5.4 12-12 12H236c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12z\"/>\n              </svg>",
              attributes: {
                title: "Select Card"
              }
            }, s));
          },
          onDrapCodeCardSectionCodeChange: function onDrapCodeCardSectionCodeChange() {
            this.components(this.get(l.keyDrapCodeCardsCustomCode));
          }
        }, {
          isComponent: function isComponent(t) {
            if (t.getAttribute && t.getAttribute("data-gjs-type") === n) return {
              type: n
            };
          }
        }),
        view: o.extend({
          init: function init() {
            this.listenTo(this.model.components(), "add remove reset", this.onComponentsChange), this.onComponentsChange();
          },
          onComponentsChange: function onComponentsChange() {
            var _this6 = this;
            d && clearInterval(d), d = setTimeout(function () {
              var t = _this6.model;
              var e = 1;
              (t.get(l.keyDrapCodeCardsCustomCode) || "").indexOf("<script") >= 0 && (_this6.el.innerHTML = i.placeholderScript, e = 0), t.set({
                droppable: e
              });
            }, 0);
          },
          onActive: function onActive() {
            var t = this.model;
            this.em.get("Commands").run(c.drapcode_cards_custom_code, {
              target: t
            });
          }
        })
      });
    };
    var ie = function ie(t, e, n, i) {
      var r = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="50"><path d="M11 13c.2.4.2.8 0 1.1-.4.3-.8.3-1.1 0a3.8 3.8 0 010-5.3L12.5 6a3.8 3.8 0 015.4 5.4l-1.1 1c0-.5-.1-1.2-.3-1.7l.3-.4a2.3 2.3 0 000-3.2 2.3 2.3 0 00-3.2 0L11 9.9a2.3 2.3 0 000 3.2zm2-3.1c.4-.3.8-.3 1.1 0a3.8 3.8 0 010 5.3L11.5 18A3.8 3.8 0 016 12.5l1.1-1c0 .5.1 1.2.3 1.7l-.3.4a2.3 2.3 0 000 3.2 2.3 2.3 0 003.2 0l2.7-2.7a2.3 2.3 0 000-3.2.7.7 0 010-1zM3 3v18h18V3H3zm0-2h18a2 2 0 012 2v18a2 2 0 01-2 2H3a2 2 0 01-2-2V3c0-1.1.9-2 2-2z"></path></svg>';
      t.add(i, {
        label: n,
        category: e,
        content: {
          type: i,
          classes: [i],
          style: {
            display: "inline-block",
            padding: "5px",
            height: "50px",
            width: "50px",
            cursor: "pointer"
          }
        },
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n      <div class=\"drap-on-six\">").concat(r, "</div>\n      <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n        <a\n          target=\"_blank\"\n          href=\"https://academy.drapcode.com/docs/app-builder/layout-component-container\"\n          draggable=\"false\"\n        >\n          <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </div>\n      <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n    </div>\n  ");
        }
      });
    };
    var re = function re(t, e, n) {
      var i = t.getType("default"),
        r = i.model,
        a = i.view;
      t.addType(n, {
        model: r.extend({
          defaults: _objectSpread({}, r.prototype.defaults, {
            "custom-name": e,
            resizable: !0,
            tagName: "a",
            traits: [{
              type: "webconnect-href",
              name: "href",
              label: !1
            }, {
              type: "webconnect-link",
              label: !1
            }, {
              type: "webconnect-event",
              label: "Event",
              name: "onclick"
            }, {
              label: "Prevent Double Click",
              type: "checkbox",
              name: "data-prevent-dblclick"
            }, {
              label: "Disable Duration (milliseconds)",
              type: "number",
              name: "data-disable-duration",
              placeholder: "eg. 5000",
              min: 1e3,
              max: 15e3,
              step: 500,
              default: 5e3
            }].concat(r.prototype.defaults.traits)
          })
        }, {
          isComponent: function isComponent(t) {
            if (t.tagName && "A" === t.tagName && t.getAttribute && t.getAttribute("data-gjs-type") === n) return {
              type: n
            };
          }
        }),
        view: a
      });
    };
    var ae = function ae(t, e, n, i) {
        t.add(i, {
          label: n,
          category: e,
          content: {
            type: i,
            name: "Horizontal Line",
            resizable: !0,
            tagName: "hr"
          },
          render: function render(t) {
            var e = t.model,
              i = t.className;
            return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n    <div class=\"drap-on-six\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\" width=\"32\" height=\"50\">\n    <path d=\"M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z\"/>\n    </svg></div>\n    <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n      <a\n        target=\"_blank\"\n        href=\"#\"\n        draggable=\"false\"\n      >\n        <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n      </a>\n    </div>\n    <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n  </div>\n");
          }
        });
      },
      oe = function oe(t, e, n, i) {
        t.add(i, {
          label: n,
          category: e,
          content: {
            type: i,
            name: "Vertical Line",
            resizable: !0,
            style: {
              "box-sizing": "content-box",
              height: "100px",
              width: "32px",
              overflow: "visible",
              "margin-top": "1rem",
              "margin-bottom": "1rem",
              border: "0",
              "border-top-color": "currentcolor",
              "border-top-style": "none",
              "border-top-width": "0px",
              "border-left-color": "currentcolor",
              "border-left-style": "none",
              "border-left-width": "0px",
              "border-left": "1px solid rgba(0,0,0,.1)"
            }
          },
          render: function render(t) {
            var e = t.model,
              i = t.className;
            return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n      <div class=\"drap-on-six\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\" width=\"32\" height=\"50\" style=\"transform: rotate(90deg);\">\n      <path d=\"M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z\"/>\n      </svg></div>\n      <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n        <a\n          target=\"_blank\"\n          href=\"#\"\n          draggable=\"false\"\n        >\n          <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </div>\n      <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n    </div>    \n    ");
          }
        });
      },
      se = function se(t, e, n, i) {
        t.add(i, {
          label: n,
          category: e,
          content: {
            type: i,
            classes: [i],
            style: {
              padding: "5px",
              height: "50px",
              width: "auto"
            }
          },
          render: function render(t) {
            var e = t.model,
              i = t.className;
            return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n    <div class=\"drap-on-six\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\" width=\"32\" height=\"50\"><path d=\"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z\"/></svg></div>\n    <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n      <a\n        target=\"_blank\"\n        href=\"#\"\n        draggable=\"false\"\n      >\n        <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n      </a>\n    </div>\n    <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n  </div>\n  ");
          }
        });
      };
    var le = function le(t, e, n) {
      var i = t.getType("default"),
        r = i.model,
        a = i.view;
      t.addType(n, {
        model: r.extend({
          defaults: _objectSpread({}, r.prototype.defaults, {
            "custom-name": e,
            resizable: !0,
            tagName: "div",
            traits: [{
              type: "select",
              options: [{
                value: "div",
                name: "Div"
              }, {
                value: "span",
                name: "Span"
              }],
              label: "Type",
              name: "tagName",
              changeProp: 1
            }].concat(r.prototype.defaults.traits)
          })
        }, {
          isComponent: function isComponent(t) {
            if (t.getAttribute && "box" === t.getAttribute("data-gjs-type") && t && t.classList && t.classList.contains("box")) return {
              type: n
            };
          }
        }),
        view: a
      });
    };
    var ce = function ce(t, e, n, i) {
      t.add(i, {
        label: n,
        category: e,
        content: {
          type: i,
          name: "Table",
          tagName: "table",
          resizable: !0,
          content: "\n      <thead>\n        <tr>\n          <th scope=\"col\"><div>#</div>\n          </th>\n          <th scope=\"col\"><div>First</div>\n          </th>\n          <th scope=\"col\"><div>Last</div>\n          </th>\n          <th scope=\"col\"><div>Handle</div>\n          </th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr>\n          <td scope=\"row\">\n            <div>1</div>\n          </td>\n          <td>\n            <div>Mark</div>\n          </td>\n          <td>\n            <div>Otto</div>\n          </td>\n          <td>\n            <div>@mdo</div>\n          </td>\n        </tr>\n    </tbody>"
        },
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n    <div class=\"drap-on-six\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" width=\"32\" height=\"50\"><path d=\"M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z\"/></svg></div>\n    <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n      <a\n        target=\"_blank\"\n        href=\"#\"\n        draggable=\"false\"\n      >\n        <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n      </a>\n    </div>\n    <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n  </div>\n");
        }
      });
    };
    var de = function de(t, e, n) {
      var i = t.getType("default"),
        r = i.model,
        a = i.view;
      t.addType("thead", {
        model: r.extend({
          defaults: _objectSpread({}, t.getType("thead").model.prototype.defaults, {
            "custom-name": "Table Head",
            tagName: "thead",
            editable: !0,
            traits: [{
              type: "scope",
              options: [{
                value: "col",
                name: "Column"
              }, {
                value: "row",
                name: "Row"
              }],
              label: "Scope"
            }].concat(t.getType("thead").model.prototype.defaults.traits)
          })
        }, {
          isComponent: function isComponent(t) {
            if (t.tagName && "THEAD" === t.tagName && t.getAttribute && "thead" === t.getAttribute("data-gjs-type")) return {
              type: n
            };
          }
        }),
        view: a
      }), t.addType("tbody", {
        model: r.extend({
          defaults: _objectSpread({}, t.getType("tbody").model.prototype.defaults, {
            "custom-name": "Table Body",
            tagName: "tbody",
            editable: !0,
            droppable: !0,
            layerable: !0,
            selectable: !0
          }, t.getType("tbody").model.prototype.defaults.traits)
        }, {
          isComponent: function isComponent(t) {
            if (t.tagName && "tbody" === t.tagName && t.getAttribute && "tbody" === t.getAttribute("data-gjs-type")) return {
              type: n
            };
          }
        }),
        view: a
      }), t.addType("tr", {
        model: r.extend({
          defaults: _objectSpread({}, t.getType("row").model.prototype.defaults, {
            "custom-name": "Table Row",
            tagName: "tr"
          }, t.getType("row").model.prototype.defaults.traits)
        }, {
          isComponent: function isComponent(t) {
            if (t.tagName && "TR" === t.tagName && t.getAttribute && "tr" === t.getAttribute("data-gjs-type")) return {
              type: n
            };
          }
        }),
        view: a
      }), t.addType("th", {
        model: r.extend({
          defaults: _objectSpread({}, t.getType("cell").model.prototype.defaults, {
            "custom-name": "Header Cell",
            tagName: "th",
            traits: [{
              type: "scope",
              options: [{
                value: "col",
                name: "Column"
              }, {
                value: "row",
                name: "Row"
              }],
              label: "Scope"
            }].concat(t.getType("cell").model.prototype.defaults.traits)
          })
        }, {
          isComponent: function isComponent(t) {
            if (t.tagName && "TH" === t.tagName && t.getAttribute && "th" === t.getAttribute("data-gjs-type")) return {
              type: n
            };
          }
        }),
        view: a
      });
    };
    var ue = function ue(t, e, n, i) {
      t.add(i, {
        label: n,
        category: e,
        content: "\n    <nav aria-label=\"breadcrumb\" class=\"main-breadcrumb\" data-gjs-type=\"".concat(i, "\" data-gjs-name=\"").concat(n, "\">\n      <ol class=\"breadcrumb\" data-gjs-type=\"breadcrumb-container\" data-gjs-name=\"Breadcrumb Container\" style=\"background-color:  rgba(255,255,255,0);\">\n        <li class=\"breadcrumb-item\" data-gjs-type=\"breadcrumb-item\" data-gjs-name=\"Breadcrumb Item\">\n          <a data-gjs-type=\"link-box\" href=\"#\">\n            <i data-gjs-type=\"drapcode-icons\" draggable=\"true\" data-highlightable=\"1\" data-js=\"drapcode-icons\" class=\"drapcode-icons gjs-selected\"><svg data-gjs-type=\"svg\" draggable=\"false\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\"\n                viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-gjs=\"drapcode-icons-svg\" class=\"feather feather-home\" id=\"iwiap\">\n                <path data-gjs-type=\"svg-in\" draggable=\"true\" d=\"M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z\" id=\"ix246\">\n                </path>\n                <polyline data-gjs-type=\"svg-in\" draggable=\"true\" points=\"9 22 9 12 15 12 15 22\">\n                </polyline>\n              </svg></i>\n          </a>\n        </li>\n        <li class=\"breadcrumb-item\" data-gjs-type=\"breadcrumb-item\" data-gjs-name=\"Breadcrumb Item\">\n          <a data-gjs-type=\"link-box\" href=\"#\">\n            <div data-gjs-type=\"text\" style=\"display: inline\">User</div>\n          </a>\n        </li>\n        <li class=\"breadcrumb-item active\" data-gjs-type=\"breadcrumb-item\" data-gjs-name=\"Breadcrumb Item\">\n          <div data-gjs-type=\"text\" style=\"display: inline\">User Profile</div>\n        </li>\n      </ol>\n    </nav>\n    "),
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n    <div class=\"drap-on-six\"><svg viewBox=\"0 0 300 300\" width=\"32\" height=\"50\" xmlns=\"http://www.w3.org/2000/svg\"><rect y=\"125\" width=\"90\" height=\"50\" rx=\"10\"></rect><path d=\"M115 135v30h70v-30h-70zm0-10h70a10 10 0 0 1 10 10v30a10 10 0 0 1-10 10h-70a10 10 0 0 1-10-10v-30a10 10 0 0 1 10-10zM220 135v30h70v-30h-70zm0-10h70a10 10 0 0 1 10 10v30a10 10 0 0 1-10 10h-70a10 10 0 0 1-10-10v-30a10 10 0 0 1 10-10z\"></path></svg></div>\n    <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n      <a\n        target=\"_blank\"\n        href=\"#\"\n        draggable=\"false\"\n      >\n        <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n      </a>\n    </div>\n    <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n  </div>\n");
        }
      });
    };
    var he = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" width=\"32\" height=\"50\">\x3c!-- Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) --\x3e<path d=\"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.7 272l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z\"/></svg>";
    var pe = function pe(t, e, n, i) {
      t.add(i, {
        label: n,
        category: e,
        content: {
          type: i,
          style: {
            height: "32px",
            width: "300px"
          }
        },
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n      <div class=\"drap-on-six\">").concat(he, "</div>\n      <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n        <a\n          target=\"_blank\"\n          href=\"https://academy.drapcode.com/docs/app-builder/basic-component-audio\"\n          draggable=\"false\"\n        >\n          <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </div>\n      <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n    </div>\n  ");
        }
      });
    };
    var ge = function ge(t, e, n) {
      var i = t.getType("audio"),
        r = i.model,
        a = i.view;
      t.addType(n, {
        model: r.extend({
          defaults: Object.assign({}, r.prototype.defaults, {
            "custom-name": e,
            resizable: !0,
            classes: ["audio"]
          })
        }, {
          isComponent: function isComponent(t) {
            if (t && "audio" === t.className) return {
              type: n
            };
          }
        }),
        view: a
      });
    };
    var fe = function fe(t, e, n, i) {
      t.add(i, {
        label: n,
        category: e,
        type: i,
        content: "<iframe> </iframe>",
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n    <div class=\"drapcode-compo-seventeen ".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n      <div class=\"drap-on-six\"><svg xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\" role=\"img\" width=\"32\" height=\"50\" preserveAspectRatio=\"xMidYMid meet\" viewBox=\"0 0 24 24\"><g fill=\"none\" stroke-width=\"1.5\"><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M6 3v18M18 3v18M3 6h18\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.6 9h4.8a.6.6 0 0 1 .6.6v4.8a.6.6 0 0 1-.6.6H9.6a.6.6 0 0 1-.6-.6V9.6a.6.6 0 0 1 .6-.6Z\" clip-rule=\"evenodd\"/><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3 18h18\"/></g></svg></div>\n      <div class=\"drapcode-compo-qustion ").concat(i, "__info\">\n        <a\n          target=\"_blank\"\n          href=\"https://academy.drapcode.com/docs/app-builder/basic-component-audio\"\n          draggable=\"false\"\n        >\n          <i class=\"bem-Svg ").concat(i, "__info-fa fa fa-info-circle\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </div>\n      <div class=\"drapcode-com-one\">").concat(e.get("label"), "</div>\n    </div>\n  ");
        }
      });
    };
    var me = function me(t, e, n) {
      var i = t.getType("default"),
        r = i.model,
        a = i.view;
      t.addType(n, {
        model: r.extend({
          defaults: _objectSpread({}, r.prototype.defaults, {
            "custom-name": e,
            tagName: "iframe",
            resizable: !0,
            attributes: {
              src: "https://drapcode-static.s3.amazonaws.com/default.png",
              loading: "eager"
            },
            traits: [{
              type: "text",
              label: "Source (URL)",
              name: "src"
            }, {
              type: "select",
              options: [{
                value: "eager",
                name: "Eager (Default: Loads Immediately)"
              }, {
                value: "lazy",
                name: "Lazy (Loads Asynchronously)"
              }, {
                value: "auto",
                name: "Auto"
              }],
              label: "Load Type",
              name: "loading"
            }].concat(_toConsumableArray(r.prototype.defaults.traits), [{
              type: "webconnect-iframe",
              label: !1,
              content: "Insert your text here"
            }])
          })
        }, {
          isComponent: function isComponent(t) {
            if (t && "IFRAME" === t.tagName && "embed-responsive-item" !== t.className) return {
              type: n
            };
          }
        }),
        view: a
      });
    };
    var ve = function ve(t, e, n, i) {
      t.add(i, {
        label: "\n    <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"50\" fill=\"currentColor\" class=\"bi bi-file-earmark-richtext\" viewBox=\"0 0 16 16\">\n    <path d=\"M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z\"></path>\n    <path d=\"M4.5 12.5A.5.5 0 0 1 5 12h3a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-2A.5.5 0 0 1 5 10h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm1.639-3.708 1.33.886 1.854-1.855a.25.25 0 0 1 .289-.047l1.888.974V8.5a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5V8s1.54-1.274 1.639-1.208zM6.25 6a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5z\"></path>\n    </svg>\n          <div>".concat(n, "</div>\n          "),
        category: e,
        content: {
          type: i,
          classes: [i],
          content: "<div style=\"padding:16% 0;height:200px; width:auto;text-align:center\" >Page Placeholder</div>",
          attributes: {
            id: "page-placeholder"
          }
        },
        render: function render(t) {
          var e = t.model,
            i = t.className;
          return "\n      <div class=\"".concat(i, "-label ").concat(i, "__drapcode-wrap\">\n      ").concat(e.get("label"), "\n      </div>\n  \n      <span class=\"").concat(i, "__info no-doc\">\n        <a target=\"_blank\" href=\"https://academy.drapcode.com/docs/app-builder/basic-component-header\" draggable=\"false\">\n          <i class=\"").concat(i, "__info-fa fa fa-info-circle\" style=\"margin-left: 5px\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </span>\n    ");
        }
      });
    };
    var be = function be(t, e, n) {
        var i = t.getType("default"),
          r = i.model,
          a = i.view;
        t.addType(n, {
          model: r.extend({
            defaults: _objectSpread({}, r.prototype.defaults, {
              "custom-name": e,
              resizable: !0,
              tagName: "div",
              traits: [{
                type: "select",
                options: [{
                  value: "div",
                  name: "Div"
                }, {
                  value: "span",
                  name: "Span"
                }],
                label: "Type",
                name: "tagName",
                changeProp: 1
              }].concat(r.prototype.defaults.traits)
            })
          }, {
            isComponent: function isComponent(t) {
              if (t.getAttribute && "pagePlaceholder" === t.getAttribute("data-gjs-type") && t && t.classList && t.classList.contains("pagePlaceholder")) return {
                type: n
              };
            }
          }),
          view: a
        });
      },
      ye = function ye(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        var n = t.DomComponents,
          i = t.BlockManager,
          r = t,
          a = e.types,
          o = e.commands,
          s = e.labels,
          h = e.blocks,
          x = e.labelWebConnectBasicCategory,
          M = e.labelWebConnectAdvancedCategory,
          L = e.labelWebConnectFormCategory,
          R = e.labelWebConnectLayoutCategory,
          Y = e.labelWebConnectMediaCategory,
          G = e.labelWebConnectSocialCategory,
          ot = {
            id: {
              name: "id",
              label: s.trait_id
            },
            for: {
              name: "for",
              label: s.trait_for
            },
            name: {
              name: "name",
              label: s.trait_name
            },
            placeholder: {
              name: "placeholder",
              label: s.trait_placeholder
            },
            value: {
              name: "value",
              label: s.trait_value
            },
            required: {
              type: "checkbox",
              name: "required",
              label: s.trait_required
            },
            checked: {
              label: s.trait_checked,
              type: "checkbox",
              name: "checked",
              changeProp: 1
            }
          };
        h.text && (j(i, x, s.text, a.text), C(n, s.text, a.text)), h.header && (D(i, x, s.header, a.header), E(n, s.header, a.header)), h.paragraph && (I(i, x, s.paragraph, a.paragraph), P(n, s.paragraph, a.paragraph)), h.badge && (tt(i, x, s.badge, a.badge), et(n, s.badge, a.badge)), h.image && (k(i, x, s.image, a.image), O(n, s.image, a.image)), h.video && (N(n, "Embed", a.video), T(i, x, s.video, a.video), S(n, s.video, a.video)), h.audio && (pe(i, x, s.audio, a.audio), ge(n, s.audio, a.audio)), h.linkBox && (ie(i, x, s.link_box, a.link_box), re(n, s.link_box, a.link_box)), h.breadcrumb && ue(i, x, s.breadcrumb, a.breadcrumb), h.container && (l(i, R, s.container, a.container), c(n, s.container, a.container)), h.row && (v(i, R, s.row, a.row), b(n, s.row, a.row)), h.column && (p(i, R, s.column, a.column), g(n, s.column, a.column, r)), h.sections && (Xt(i, R, s.sections, a.sections, e), te(i, R, s.sections, a.sections, e), Kt(n, s.sections, a.sections, e)), h.column_break && (f(i, R, s.column_break, a.column_break), m(n, s.column_break, a.column_break)), h.media_object && (y(i, R, s.media_object, a.media_object), w(n, s.media_object, a.media_object)), h.navbar_old && (rt(i, R, s.navbar_old, a.navbar_old, e), at(n, s.navbar_old, a.burgerType)), h.navbar && (lt(i, R, s.navbar, a.navbar, e), ct(n, s.navbar, a.navbar, e)), h.nav_item_submenu && (dt(i, R, s.labelNavItemSubMenu, a.nav_item_dropdown, e), ut(n, s.labelNavItemSubMenu, a.nav_item_dropdown, e)), h.jumbotron && (ht(i, R, s.jumbotron, a.jumbotron), pt(n, s.jumbotron, a.jumbotron)), h.side_bar && (mt(i, R, s.side_bar, a.side_bar), vt(n, s.side_bar, a.side_bar)), h.footer && (Bt(i, R, s.footer, a.footer, e), Wt(n, s.footer, a.footer)), h.list && nt(i, R, s.list, a.list), h.grid && it(i, R, s.grid, a.grid), h.horizontalLine && ae(i, R, s.horizontal_line, a.horizontal_line), h.verticalLine && oe(i, R, s.vertical_line, a.vertical_line), h.box && (se(i, R, s.box, a.box), le(n, s.box, a.box)), h.pagePlaceholder && (ve(i, R, s.pagePlaceholder, a.pagePlaceholder), be(n, s.pagePlaceholder, a.pagePlaceholder)), h.table && (ce(i, R, s.table, a.table), de(n, s.table, a.table)), h.input && (A(i, L, s.input, a.input), z(n, s.input, a.input, ot, e), Q(i, L, s.file_input, a.file_input), J(n, s.file_input, a.file_input, ot)), h.form_group_input && (_(i, L, s.form_group_input, s.input_group, a.form_group_input), H(n, s.form_group_input, a.form_group_input)), h.textarea && (V(i, L, s.textarea, a.textarea), F(n, s.textarea, a.textarea, ot)), h.select && (X(i, L, s.select, a.select), K(t, n, s.select, a.select, ot, e)), h.checkbox && (B(i, L, s.checkbox, a.checkbox), W(n, s.checkbox, a.checkbox, ot)), h.radio && (U(i, L, s.radio, a.radio), Z(n, s.radio, a.radio)), h.label && (q(i, L, s.label, a.label), $(n, s.label, a.label)), h.button && (d(i, L, s.button, a.button), u(n, s.button, a.button)), h.card && (ee(i, M, s.cards, a.cards, e), ne(n, s.cards, a.cards, e)), h.tabs && (Mt(i, M, s.tabs, a.tabs), kt(n, s.tabs, a.tabs), Ot(n, s.tab, a.tab), Tt(n, s.tab_content, a.tab_content), St(n, s.tab_container, a.tab_container)), h.list_group && (gt(i, M, s.list_group, a.list_group), ft(n, s.list_group, a.list_group)), h.accordions && (At(i, M, s.accordions, a.accordions), zt(n, s.accordions, a.accordions), _t(n, s.accordion, a.accordion), Ht(n, s.accordion_content, a.accordion_content), Vt(n, s.accordion_container, a.accordion_container)), h.carousel && (Ft(i, M, s.carousels, a.carousels, e), Rt(n, s.carousels, a.carousels, e)), h.modal && (Yt(i, M, s.modal, a.modal, e), Ut(n, s.modal, a.modal, e)), h.facebook_button && (Gt(i, G, s.facebook_button, a.facebook_button), qt(n, s.facebook_button, a.facebook_button)), h.google_button && (Qt(i, G, s.google_button, a.google_button), Jt(n, s.google_button, a.google_button)), h.iframe && (fe(i, x, s.iframe, a.iframe), me(n, s.iframe, a.iframe));
      },
      we = n(0);
    function xe(t, e) {
      return e = null == e ? t.length - 1 : +e, function () {
        for (var n = Math.max(arguments.length - e, 0), i = Array(n), r = 0; r < n; r++) i[r] = arguments[r + e];
        switch (e) {
          case 0:
            return t.call(this, i);
          case 1:
            return t.call(this, arguments[0], i);
          case 2:
            return t.call(this, arguments[0], arguments[1], i);
        }
        var a = Array(e + 1);
        for (r = 0; r < e; r++) a[r] = arguments[r];
        return a[e] = i, t.apply(this, a);
      };
    }
    function je(t) {
      var e = typeof t;
      return 'function' === e || 'object' === e && !!t;
    }
    function Ce(t) {
      return null === t;
    }
    function Me(t) {
      return void 0 === t;
    }
    function ke(t) {
      return !0 === t || !1 === t || '[object Boolean]' === we["t"].call(t);
    }
    function Oe(t) {
      return !(!t || 1 !== t.nodeType);
    }
    function Te(t) {
      var e = '[object ' + t + ']';
      return function (t) {
        return we["t"].call(t) === e;
      };
    }
    var Se = Te('String'),
      Ne = Te('Number'),
      Le = Te('Date'),
      De = Te('RegExp'),
      Ee = Te('Error'),
      Ie = Te('Symbol'),
      Pe = Te('ArrayBuffer'),
      Ae = Te('Function'),
      ze = we["p"].document && we["p"].document.childNodes;
    1 && 'object' != typeof Int8Array && 'function' != typeof ze && (Ae = function Ae(t) {
      return 'function' == typeof t || !1;
    });
    var _e = Ae,
      He = Te('Object'),
      Ve = we["s"] && He(new DataView(new ArrayBuffer(8))),
      Fe = 'undefined' != typeof Map && He(new Map()),
      Re = Te('DataView');
    var Be = Ve ? function (t) {
        return null != t && _e(t.getInt8) && Pe(t.buffer);
      } : Re,
      We = we["k"] || Te('Array');
    function Ye(t, e) {
      return null != t && we["i"].call(t, e);
    }
    var Ue = Te('Arguments');
    !function () {
      Ue(arguments) || (Ue = function Ue(t) {
        return Ye(t, 'callee');
      });
    }();
    var Ze = Ue;
    function Ge(t) {
      return !Ie(t) && Object(we["f"])(t) && !isNaN(parseFloat(t));
    }
    function qe(t) {
      return Ne(t) && Object(we["g"])(t);
    }
    function $e(t) {
      return function () {
        return t;
      };
    }
    function Qe(t) {
      return function (e) {
        var n = t(e);
        return 'number' == typeof n && n >= 0 && n <= we["b"];
      };
    }
    function Je(t) {
      return function (e) {
        return null == e ? void 0 : e[t];
      };
    }
    var Xe = Je('byteLength'),
      Ke = Qe(Xe),
      tn = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
    var en = we["r"] ? function (t) {
        return we["l"] ? Object(we["l"])(t) && !Be(t) : Ke(t) && tn.test(we["t"].call(t));
      } : $e(!1),
      nn = Je('length');
    function rn(t, e) {
      e = function (t) {
        for (var e = {}, n = t.length, i = 0; i < n; ++i) e[t[i]] = !0;
        return {
          contains: function contains(t) {
            return !0 === e[t];
          },
          push: function push(n) {
            return e[n] = !0, t.push(n);
          }
        };
      }(e);
      var n = we["n"].length,
        i = t.constructor,
        r = _e(i) && i.prototype || we["c"],
        a = 'constructor';
      for (Ye(t, a) && !e.contains(a) && e.push(a); n--;) (a = we["n"][n]) in t && t[a] !== r[a] && !e.contains(a) && e.push(a);
    }
    function an(t) {
      if (!je(t)) return [];
      if (we["m"]) return Object(we["m"])(t);
      var e = [];
      for (var n in t) Ye(t, n) && e.push(n);
      return we["h"] && rn(t, e), e;
    }
    function on(t) {
      if (null == t) return !0;
      var e = nn(t);
      return 'number' == typeof e && (We(t) || Se(t) || Ze(t)) ? 0 === e : 0 === nn(an(t));
    }
    function sn(t, e) {
      var n = an(e),
        i = n.length;
      if (null == t) return !i;
      for (var r = Object(t), a = 0; a < i; a++) {
        var o = n[a];
        if (e[o] !== r[o] || !(o in r)) return !1;
      }
      return !0;
    }
    function ln(t) {
      return t instanceof ln ? t : this instanceof ln ? void (this._wrapped = t) : new ln(t);
    }
    function cn(t) {
      return new Uint8Array(t.buffer || t, t.byteOffset || 0, Xe(t));
    }
    ln.VERSION = we["e"], ln.prototype.value = function () {
      return this._wrapped;
    }, ln.prototype.valueOf = ln.prototype.toJSON = ln.prototype.value, ln.prototype.toString = function () {
      return String(this._wrapped);
    };
    var dn = '[object DataView]';
    function un(t, e, n, i) {
      if (t === e) return 0 !== t || 1 / t == 1 / e;
      if (null == t || null == e) return !1;
      if (t != t) return e != e;
      var r = typeof t;
      return ('function' === r || 'object' === r || 'object' == typeof e) && function t(e, n, i, r) {
        e instanceof ln && (e = e._wrapped);
        n instanceof ln && (n = n._wrapped);
        var a = we["t"].call(e);
        if (a !== we["t"].call(n)) return !1;
        if (Ve && '[object Object]' == a && Be(e)) {
          if (!Be(n)) return !1;
          a = dn;
        }
        switch (a) {
          case '[object RegExp]':
          case '[object String]':
            return '' + e == '' + n;
          case '[object Number]':
            return +e != +e ? +n != +n : 0 == +e ? 1 / +e == 1 / n : +e == +n;
          case '[object Date]':
          case '[object Boolean]':
            return +e == +n;
          case '[object Symbol]':
            return we["d"].valueOf.call(e) === we["d"].valueOf.call(n);
          case '[object ArrayBuffer]':
          case dn:
            return t(cn(e), cn(n), i, r);
        }
        var o = '[object Array]' === a;
        if (!o && en(e)) {
          if (Xe(e) !== Xe(n)) return !1;
          if (e.buffer === n.buffer && e.byteOffset === n.byteOffset) return !0;
          o = !0;
        }
        if (!o) {
          if ('object' != typeof e || 'object' != typeof n) return !1;
          var s = e.constructor,
            l = n.constructor;
          if (s !== l && !(_e(s) && s instanceof s && _e(l) && l instanceof l) && 'constructor' in e && 'constructor' in n) return !1;
        }
        r = r || [];
        var c = (i = i || []).length;
        for (; c--;) if (i[c] === e) return r[c] === n;
        if (i.push(e), r.push(n), o) {
          if ((c = e.length) !== n.length) return !1;
          for (; c--;) if (!un(e[c], n[c], i, r)) return !1;
        } else {
          var d,
            u = an(e);
          if (c = u.length, an(n).length !== c) return !1;
          for (; c--;) if (d = u[c], !Ye(n, d) || !un(e[d], n[d], i, r)) return !1;
        }
        return i.pop(), r.pop(), !0;
      }(t, e, n, i);
    }
    function hn(t, e) {
      return un(t, e);
    }
    function pn(t) {
      if (!je(t)) return [];
      var e = [];
      for (var n in t) e.push(n);
      return we["h"] && rn(t, e), e;
    }
    function gn(t) {
      var e = nn(t);
      return function (n) {
        if (null == n) return !1;
        var i = pn(n);
        if (nn(i)) return !1;
        for (var r = 0; r < e; r++) if (!_e(n[t[r]])) return !1;
        return t !== wn || !_e(n[fn]);
      };
    }
    var fn = 'forEach',
      mn = 'has',
      vn = ['clear', 'delete'],
      bn = ['get', mn, 'set'],
      yn = vn.concat(fn, bn),
      wn = vn.concat(bn),
      xn = ['add'].concat(vn, fn, mn),
      jn = Fe ? gn(yn) : Te('Map'),
      Cn = Fe ? gn(wn) : Te('WeakMap'),
      Mn = Fe ? gn(xn) : Te('Set'),
      kn = Te('WeakSet');
    function On(t) {
      for (var e = an(t), n = e.length, i = Array(n), r = 0; r < n; r++) i[r] = t[e[r]];
      return i;
    }
    function Tn(t) {
      for (var e = an(t), n = e.length, i = Array(n), r = 0; r < n; r++) i[r] = [e[r], t[e[r]]];
      return i;
    }
    function Sn(t) {
      for (var e = {}, n = an(t), i = 0, r = n.length; i < r; i++) e[t[n[i]]] = n[i];
      return e;
    }
    function Nn(t) {
      var e = [];
      for (var n in t) _e(t[n]) && e.push(n);
      return e.sort();
    }
    function Ln(t, e) {
      return function (n) {
        var i = arguments.length;
        if (e && (n = Object(n)), i < 2 || null == n) return n;
        for (var r = 1; r < i; r++) for (var a = arguments[r], o = t(a), s = o.length, l = 0; l < s; l++) {
          var c = o[l];
          e && void 0 !== n[c] || (n[c] = a[c]);
        }
        return n;
      };
    }
    var Dn = Ln(pn),
      En = Ln(an),
      In = Ln(pn, !0);
    function Pn(t) {
      if (!je(t)) return {};
      if (we["j"]) return Object(we["j"])(t);
      var e = function e() {};
      e.prototype = t;
      var n = new e();
      return e.prototype = null, n;
    }
    function An(t, e) {
      var n = Pn(t);
      return e && En(n, e), n;
    }
    function zn(t) {
      return je(t) ? We(t) ? t.slice() : Dn({}, t) : t;
    }
    function _n(t, e) {
      return e(t), t;
    }
    function Hn(t) {
      return We(t) ? t : [t];
    }
    function Vn(t) {
      return ln.toPath(t);
    }
    function Fn(t, e) {
      for (var n = e.length, i = 0; i < n; i++) {
        if (null == t) return;
        t = t[e[i]];
      }
      return n ? t : void 0;
    }
    function Rn(t, e, n) {
      var i = Fn(t, Vn(e));
      return Me(i) ? n : i;
    }
    function Bn(t, e) {
      for (var n = (e = Vn(e)).length, i = 0; i < n; i++) {
        var r = e[i];
        if (!Ye(t, r)) return !1;
        t = t[r];
      }
      return !!n;
    }
    function Wn(t) {
      return t;
    }
    function Yn(t) {
      return t = En({}, t), function (e) {
        return sn(e, t);
      };
    }
    function Un(t) {
      return t = Vn(t), function (e) {
        return Fn(e, t);
      };
    }
    function Zn(t, e, n) {
      if (void 0 === e) return t;
      switch (null == n ? 3 : n) {
        case 1:
          return function (n) {
            return t.call(e, n);
          };
        case 3:
          return function (n, i, r) {
            return t.call(e, n, i, r);
          };
        case 4:
          return function (n, i, r, a) {
            return t.call(e, n, i, r, a);
          };
      }
      return function () {
        return t.apply(e, arguments);
      };
    }
    function Gn(t, e, n) {
      return null == t ? Wn : _e(t) ? Zn(t, e, n) : je(t) && !We(t) ? Yn(t) : Un(t);
    }
    function qn(t, e) {
      return Gn(t, e, 1 / 0);
    }
    function $n(t, e, n) {
      return ln.iteratee !== qn ? ln.iteratee(t, e) : Gn(t, e, n);
    }
    function Qn(t, e, n) {
      e = $n(e, n);
      for (var i = an(t), r = i.length, a = {}, o = 0; o < r; o++) {
        var s = i[o];
        a[s] = e(t[s], s, t);
      }
      return a;
    }
    function Jn() {}
    function Xn(t) {
      return null == t ? Jn : function (e) {
        return Rn(t, e);
      };
    }
    function Kn(t, e, n) {
      var i = Array(Math.max(0, t));
      e = Zn(e, n, 1);
      for (var r = 0; r < t; r++) i[r] = e(r);
      return i;
    }
    function ti(t, e) {
      return null == e && (e = t, t = 0), t + Math.floor(Math.random() * (e - t + 1));
    }
    ln.toPath = Hn, ln.iteratee = qn;
    var ei = Date.now || function () {
      return new Date().getTime();
    };
    function ni(t) {
      var e = function e(_e16) {
          return t[_e16];
        },
        n = '(?:' + an(t).join('|') + ')',
        i = RegExp(n),
        r = RegExp(n, 'g');
      return function (t) {
        return t = null == t ? '' : '' + t, i.test(t) ? t.replace(r, e) : t;
      };
    }
    var ii = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#x27;',
        '`': '&#x60;'
      },
      ri = ni(ii),
      ai = ni(Sn(ii)),
      oi = ln.templateSettings = {
        evaluate: /<%([\s\S]+?)%>/g,
        interpolate: /<%=([\s\S]+?)%>/g,
        escape: /<%-([\s\S]+?)%>/g
      },
      si = /(.)^/,
      li = {
        "'": "'",
        '\\': '\\',
        '\r': 'r',
        '\n': 'n',
        "\u2028": 'u2028',
        "\u2029": 'u2029'
      },
      ci = /\\|'|\r|\n|\u2028|\u2029/g;
    function di(t) {
      return '\\' + li[t];
    }
    var ui = /^\s*(\w|\$)+\s*$/;
    function hi(t, e, n) {
      !e && n && (e = n), e = In({}, e, ln.templateSettings);
      var i = RegExp([(e.escape || si).source, (e.interpolate || si).source, (e.evaluate || si).source].join('|') + '|$', 'g'),
        r = 0,
        a = "__p+='";
      t.replace(i, function (e, n, i, o, s) {
        return a += t.slice(r, s).replace(ci, di), r = s + e.length, n ? a += "'+\n((__t=(" + n + "))==null?'':_.escape(__t))+\n'" : i ? a += "'+\n((__t=(" + i + "))==null?'':__t)+\n'" : o && (a += "';\n" + o + "\n__p+='"), e;
      }), a += "';\n";
      var o,
        s = e.variable;
      if (s) {
        if (!ui.test(s)) throw new Error('variable is not a bare identifier: ' + s);
      } else a = 'with(obj||{}){\n' + a + '}\n', s = 'obj';
      a = "var __t,__p='',__j=Array.prototype.join," + "print=function(){__p+=__j.call(arguments,'');};\n" + a + 'return __p;\n';
      try {
        o = new Function(s, '_', a);
      } catch (t) {
        throw t.source = a, t;
      }
      var l = function l(t) {
        return o.call(this, t, ln);
      };
      return l.source = 'function(' + s + '){\n' + a + '}', l;
    }
    function pi(t, e, n) {
      var i = (e = Vn(e)).length;
      if (!i) return _e(n) ? n.call(t) : n;
      for (var r = 0; r < i; r++) {
        var a = null == t ? void 0 : t[e[r]];
        void 0 === a && (a = n, r = i), t = _e(a) ? a.call(t) : a;
      }
      return t;
    }
    var gi = 0;
    function fi(t) {
      var e = ++gi + '';
      return t ? t + e : e;
    }
    function mi(t) {
      var e = ln(t);
      return e._chain = !0, e;
    }
    function vi(t, e, n, i, r) {
      if (!(i instanceof e)) return t.apply(n, r);
      var a = Pn(t.prototype),
        o = t.apply(a, r);
      return je(o) ? o : a;
    }
    var bi = xe(function (t, e) {
      var n = bi.placeholder,
        _i11 = function i() {
          for (var r = 0, a = e.length, o = Array(a), s = 0; s < a; s++) o[s] = e[s] === n ? arguments[r++] : e[s];
          for (; r < arguments.length;) o.push(arguments[r++]);
          return vi(t, _i11, this, this, o);
        };
      return _i11;
    });
    bi.placeholder = ln;
    var yi = bi,
      wi = xe(function (t, e, n) {
        if (!_e(t)) throw new TypeError('Bind must be called on a function');
        var i = xe(function (r) {
          return vi(t, i, e, this, n.concat(r));
        });
        return i;
      }),
      xi = Qe(nn);
    function ji(t, e, n, i) {
      if (i = i || [], e || 0 === e) {
        if (e <= 0) return i.concat(t);
      } else e = 1 / 0;
      for (var r = i.length, a = 0, o = nn(t); a < o; a++) {
        var s = t[a];
        if (xi(s) && (We(s) || Ze(s))) {
          if (e > 1) ji(s, e - 1, n, i), r = i.length;else for (var l = 0, c = s.length; l < c;) i[r++] = s[l++];
        } else n || (i[r++] = s);
      }
      return i;
    }
    var Ci = xe(function (t, e) {
      var n = (e = ji(e, !1, !1)).length;
      if (n < 1) throw new Error('bindAll must be passed function names');
      for (; n--;) {
        var i = e[n];
        t[i] = wi(t[i], t);
      }
      return t;
    });
    function Mi(t, e) {
      var _n12 = function n(i) {
        var r = _n12.cache,
          a = '' + (e ? e.apply(this, arguments) : i);
        return Ye(r, a) || (r[a] = t.apply(this, arguments)), r[a];
      };
      return _n12.cache = {}, _n12;
    }
    var ki = xe(function (t, e, n) {
        return setTimeout(function () {
          return t.apply(null, n);
        }, e);
      }),
      Oi = yi(ki, ln, 1);
    function Ti(t, e, n) {
      var i,
        r,
        a,
        o,
        s = 0;
      n || (n = {});
      var l = function l() {
          s = !1 === n.leading ? 0 : ei(), i = null, o = t.apply(r, a), i || (r = a = null);
        },
        c = function c() {
          var c = ei();
          s || !1 !== n.leading || (s = c);
          var d = e - (c - s);
          return r = this, a = arguments, d <= 0 || d > e ? (i && (clearTimeout(i), i = null), s = c, o = t.apply(r, a), i || (r = a = null)) : i || !1 === n.trailing || (i = setTimeout(l, d)), o;
        };
      return c.cancel = function () {
        clearTimeout(i), s = 0, i = r = a = null;
      }, c;
    }
    function Si(t, e, n) {
      var i,
        r,
        a,
        o,
        s,
        _l2 = function l() {
          var c = ei() - r;
          e > c ? i = setTimeout(_l2, e - c) : (i = null, n || (o = t.apply(s, a)), i || (a = s = null));
        },
        c = xe(function (c) {
          return s = this, a = c, r = ei(), i || (i = setTimeout(_l2, e), n && (o = t.apply(s, a))), o;
        });
      return c.cancel = function () {
        clearTimeout(i), i = a = s = null;
      }, c;
    }
    function Ni(t, e) {
      return yi(e, t);
    }
    function Li(t) {
      return function () {
        return !t.apply(this, arguments);
      };
    }
    function Di() {
      var t = arguments,
        e = t.length - 1;
      return function () {
        for (var n = e, i = t[e].apply(this, arguments); n--;) i = t[n].call(this, i);
        return i;
      };
    }
    function Ei(t, e) {
      return function () {
        if (--t < 1) return e.apply(this, arguments);
      };
    }
    function Ii(t, e) {
      var n;
      return function () {
        return --t > 0 && (n = e.apply(this, arguments)), t <= 1 && (e = null), n;
      };
    }
    var Pi = yi(Ii, 2);
    function Ai(t, e, n) {
      e = $n(e, n);
      for (var i, r = an(t), a = 0, o = r.length; a < o; a++) if (e(t[i = r[a]], i, t)) return i;
    }
    function zi(t) {
      return function (e, n, i) {
        n = $n(n, i);
        for (var r = nn(e), a = t > 0 ? 0 : r - 1; a >= 0 && a < r; a += t) if (n(e[a], a, e)) return a;
        return -1;
      };
    }
    var _i = zi(1),
      Hi = zi(-1);
    function Vi(t, e, n, i) {
      for (var r = (n = $n(n, i, 1))(e), a = 0, o = nn(t); a < o;) {
        var s = Math.floor((a + o) / 2);
        n(t[s]) < r ? a = s + 1 : o = s;
      }
      return a;
    }
    function Fi(t, e, n) {
      return function (i, r, a) {
        var o = 0,
          s = nn(i);
        if ('number' == typeof a) t > 0 ? o = a >= 0 ? a : Math.max(a + s, o) : s = a >= 0 ? Math.min(a + 1, s) : a + s + 1;else if (n && a && s) return i[a = n(i, r)] === r ? a : -1;
        if (r != r) return (a = e(we["q"].call(i, o, s), qe)) >= 0 ? a + o : -1;
        for (a = t > 0 ? o : s - 1; a >= 0 && a < s; a += t) if (i[a] === r) return a;
        return -1;
      };
    }
    var Ri = Fi(1, _i, Vi),
      Bi = Fi(-1, Hi);
    function Wi(t, e, n) {
      var i = (xi(t) ? _i : Ai)(t, e, n);
      if (void 0 !== i && -1 !== i) return t[i];
    }
    function Yi(t, e) {
      return Wi(t, Yn(e));
    }
    function Ui(t, e, n) {
      var i, r;
      if (e = Zn(e, n), xi(t)) for (i = 0, r = t.length; i < r; i++) e(t[i], i, t);else {
        var a = an(t);
        for (i = 0, r = a.length; i < r; i++) e(t[a[i]], a[i], t);
      }
      return t;
    }
    function Zi(t, e, n) {
      e = $n(e, n);
      for (var i = !xi(t) && an(t), r = (i || t).length, a = Array(r), o = 0; o < r; o++) {
        var s = i ? i[o] : o;
        a[o] = e(t[s], s, t);
      }
      return a;
    }
    function Gi(t) {
      var e = function e(_e17, n, i, r) {
        var a = !xi(_e17) && an(_e17),
          o = (a || _e17).length,
          s = t > 0 ? 0 : o - 1;
        for (r || (i = _e17[a ? a[s] : s], s += t); s >= 0 && s < o; s += t) {
          var l = a ? a[s] : s;
          i = n(i, _e17[l], l, _e17);
        }
        return i;
      };
      return function (t, n, i, r) {
        var a = arguments.length >= 3;
        return e(t, Zn(n, r, 4), i, a);
      };
    }
    var qi = Gi(1),
      $i = Gi(-1);
    function Qi(t, e, n) {
      var i = [];
      return e = $n(e, n), Ui(t, function (t, n, r) {
        e(t, n, r) && i.push(t);
      }), i;
    }
    function Ji(t, e, n) {
      return Qi(t, Li($n(e)), n);
    }
    function Xi(t, e, n) {
      e = $n(e, n);
      for (var i = !xi(t) && an(t), r = (i || t).length, a = 0; a < r; a++) {
        var o = i ? i[a] : a;
        if (!e(t[o], o, t)) return !1;
      }
      return !0;
    }
    function Ki(t, e, n) {
      e = $n(e, n);
      for (var i = !xi(t) && an(t), r = (i || t).length, a = 0; a < r; a++) {
        var o = i ? i[a] : a;
        if (e(t[o], o, t)) return !0;
      }
      return !1;
    }
    function tr(t, e, n, i) {
      return xi(t) || (t = On(t)), ('number' != typeof n || i) && (n = 0), Ri(t, e, n) >= 0;
    }
    var er = xe(function (t, e, n) {
      var i, r;
      return _e(e) ? r = e : (e = Vn(e), i = e.slice(0, -1), e = e[e.length - 1]), Zi(t, function (t) {
        var a = r;
        if (!a) {
          if (i && i.length && (t = Fn(t, i)), null == t) return;
          a = t[e];
        }
        return null == a ? a : a.apply(t, n);
      });
    });
    function nr(t, e) {
      return Zi(t, Un(e));
    }
    function ir(t, e) {
      return Qi(t, Yn(e));
    }
    function rr(t, e, n) {
      var i,
        r,
        a = -1 / 0,
        o = -1 / 0;
      if (null == e || 'number' == typeof e && 'object' != typeof t[0] && null != t) for (var s = 0, l = (t = xi(t) ? t : On(t)).length; s < l; s++) null != (i = t[s]) && i > a && (a = i);else e = $n(e, n), Ui(t, function (t, n, i) {
        ((r = e(t, n, i)) > o || r === -1 / 0 && a === -1 / 0) && (a = t, o = r);
      });
      return a;
    }
    function ar(t, e, n) {
      var i,
        r,
        a = 1 / 0,
        o = 1 / 0;
      if (null == e || 'number' == typeof e && 'object' != typeof t[0] && null != t) for (var s = 0, l = (t = xi(t) ? t : On(t)).length; s < l; s++) null != (i = t[s]) && i < a && (a = i);else e = $n(e, n), Ui(t, function (t, n, i) {
        ((r = e(t, n, i)) < o || r === 1 / 0 && a === 1 / 0) && (a = t, o = r);
      });
      return a;
    }
    var or = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
    function sr(t) {
      return t ? We(t) ? we["q"].call(t) : Se(t) ? t.match(or) : xi(t) ? Zi(t, Wn) : On(t) : [];
    }
    function lr(t, e, n) {
      if (null == e || n) return xi(t) || (t = On(t)), t[ti(t.length - 1)];
      var i = sr(t),
        r = nn(i);
      e = Math.max(Math.min(e, r), 0);
      for (var a = r - 1, o = 0; o < e; o++) {
        var s = ti(o, a),
          l = i[o];
        i[o] = i[s], i[s] = l;
      }
      return i.slice(0, e);
    }
    function cr(t) {
      return lr(t, 1 / 0);
    }
    function dr(t, e, n) {
      var i = 0;
      return e = $n(e, n), nr(Zi(t, function (t, n, r) {
        return {
          value: t,
          index: i++,
          criteria: e(t, n, r)
        };
      }).sort(function (t, e) {
        var n = t.criteria,
          i = e.criteria;
        if (n !== i) {
          if (n > i || void 0 === n) return 1;
          if (n < i || void 0 === i) return -1;
        }
        return t.index - e.index;
      }), 'value');
    }
    function ur(t, e) {
      return function (n, i, r) {
        var a = e ? [[], []] : {};
        return i = $n(i, r), Ui(n, function (e, r) {
          var o = i(e, r, n);
          t(a, e, o);
        }), a;
      };
    }
    var hr = ur(function (t, e, n) {
        Ye(t, n) ? t[n].push(e) : t[n] = [e];
      }),
      pr = ur(function (t, e, n) {
        t[n] = e;
      }),
      gr = ur(function (t, e, n) {
        Ye(t, n) ? t[n]++ : t[n] = 1;
      }),
      fr = ur(function (t, e, n) {
        t[n ? 0 : 1].push(e);
      }, !0);
    function mr(t) {
      return null == t ? 0 : xi(t) ? t.length : an(t).length;
    }
    function vr(t, e, n) {
      return e in n;
    }
    var br = xe(function (t, e) {
        var n = {},
          i = e[0];
        if (null == t) return n;
        _e(i) ? (e.length > 1 && (i = Zn(i, e[1])), e = pn(t)) : (i = vr, e = ji(e, !1, !1), t = Object(t));
        for (var r = 0, a = e.length; r < a; r++) {
          var o = e[r],
            s = t[o];
          i(s, o, t) && (n[o] = s);
        }
        return n;
      }),
      yr = xe(function (t, e) {
        var n,
          i = e[0];
        return _e(i) ? (i = Li(i), e.length > 1 && (n = e[1])) : (e = Zi(ji(e, !1, !1), String), i = function i(t, n) {
          return !tr(e, n);
        }), br(t, i, n);
      });
    function wr(t, e, n) {
      return we["q"].call(t, 0, Math.max(0, t.length - (null == e || n ? 1 : e)));
    }
    function xr(t, e, n) {
      return null == t || t.length < 1 ? null == e || n ? void 0 : [] : null == e || n ? t[0] : wr(t, t.length - e);
    }
    function jr(t, e, n) {
      return we["q"].call(t, null == e || n ? 1 : e);
    }
    function Cr(t, e, n) {
      return null == t || t.length < 1 ? null == e || n ? void 0 : [] : null == e || n ? t[t.length - 1] : jr(t, Math.max(0, t.length - e));
    }
    function Mr(t) {
      return Qi(t, Boolean);
    }
    function kr(t, e) {
      return ji(t, e, !1);
    }
    var Or = xe(function (t, e) {
        return e = ji(e, !0, !0), Qi(t, function (t) {
          return !tr(e, t);
        });
      }),
      Tr = xe(function (t, e) {
        return Or(t, e);
      });
    function Sr(t, e, n, i) {
      ke(e) || (i = n, n = e, e = !1), null != n && (n = $n(n, i));
      for (var r = [], a = [], o = 0, s = nn(t); o < s; o++) {
        var l = t[o],
          c = n ? n(l, o, t) : l;
        e && !n ? (o && a === c || r.push(l), a = c) : n ? tr(a, c) || (a.push(c), r.push(l)) : tr(r, l) || r.push(l);
      }
      return r;
    }
    var Nr = xe(function (t) {
      return Sr(ji(t, !0, !0));
    });
    function Lr(t) {
      for (var e = [], n = arguments.length, i = 0, r = nn(t); i < r; i++) {
        var a = t[i];
        if (!tr(e, a)) {
          var o;
          for (o = 1; o < n && tr(arguments[o], a); o++);
          o === n && e.push(a);
        }
      }
      return e;
    }
    function Dr(t) {
      for (var e = t && rr(t, nn).length || 0, n = Array(e), i = 0; i < e; i++) n[i] = nr(t, i);
      return n;
    }
    var Er = xe(Dr);
    function Ir(t, e) {
      for (var n = {}, i = 0, r = nn(t); i < r; i++) e ? n[t[i]] = e[i] : n[t[i][0]] = t[i][1];
      return n;
    }
    function Pr(t, e, n) {
      null == e && (e = t || 0, t = 0), n || (n = e < t ? -1 : 1);
      for (var i = Math.max(Math.ceil((e - t) / n), 0), r = Array(i), a = 0; a < i; a++, t += n) r[a] = t;
      return r;
    }
    function Ar(t, e) {
      if (null == e || e < 1) return [];
      for (var n = [], i = 0, r = t.length; i < r;) n.push(we["q"].call(t, i, i += e));
      return n;
    }
    function zr(t, e) {
      return t._chain ? ln(e).chain() : e;
    }
    function _r(t) {
      return Ui(Nn(t), function (e) {
        var n = ln[e] = t[e];
        ln.prototype[e] = function () {
          var t = [this._wrapped];
          return we["o"].apply(t, arguments), zr(this, n.apply(ln, t));
        };
      }), ln;
    }
    Ui(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function (t) {
      var e = we["a"][t];
      ln.prototype[t] = function () {
        var n = this._wrapped;
        return null != n && (e.apply(n, arguments), 'shift' !== t && 'splice' !== t || 0 !== n.length || delete n[0]), zr(this, n);
      };
    }), Ui(['concat', 'join', 'slice'], function (t) {
      var e = we["a"][t];
      ln.prototype[t] = function () {
        var t = this._wrapped;
        return null != t && (t = e.apply(t, arguments)), zr(this, t);
      };
    });
    var Hr = ln,
      Vr = _r(i);
    Vr._ = Vr;
    var Fr = Vr,
      Rr = function Rr(t) {
        var e = t.TraitManager;
        e.addType("class_select", {
          events: {
            change: "onChange"
          },
          createInput: function createInput(t) {
            var e = t.trait;
            var n = this.model.get("options") || [],
              i = document.createElement("select"),
              r = (this.target, this.target.view.el);
            for (var _t9 = 0; _t9 < n.length; _t9++) {
              var _e18 = n[_t9].name,
                _a4 = n[_t9].value;
              "" == _a4 && (_a4 = "GJS_NO_CLASS");
              var _o3 = document.createElement("option");
              _o3.text = _e18, _o3.value = _a4;
              var _s2 = _a4.split(" ");
              Fr.intersection(r.classList, _s2).length == _s2.length && _o3.setAttribute("selected", "selected"), i.append(_o3);
            }
            return i;
          },
          onUpdate: function onUpdate(t) {
            var e = t.elInput,
              n = t.component;
            var i = n.getClasses();
            var r = this.model.get("options") || [];
            for (var _t10 = 0; _t10 < r.length; _t10++) {
              r[_t10].name;
              var _n13 = r[_t10].value;
              if (_n13 && i.includes(_n13)) return void (e.value = _n13);
            }
            e.value = "GJS_NO_CLASS";
          },
          onEvent: function onEvent(t) {
            var e = t.elInput,
              n = t.component,
              i = t.event;
            var r = this.model.get("options").map(function (t) {
              return t.value;
            });
            for (var _t11 = 0; _t11 < r.length; _t11++) if (r[_t11].length > 0) {
              var a = r[_t11].split(" ");
              for (var _t12 = 0; _t12 < a.length; _t12++) a[_t12].length > 0 && n.removeClass(a[_t12]);
            }
            var o = this.model.get("value");
            if (delete n.attributes.attributes[""], o.length > 0 && "GJS_NO_CLASS" != o) {
              var _t13 = o.split(" ");
              for (var _e19 = 0; _e19 < _t13.length; _e19++) n.addClass(_t13[_e19]);
            }
            n.em.trigger("component:toggled");
          }
        }), e.addType("jumbotron_class_select", {
          events: {
            change: "onChange"
          },
          createInput: function createInput(t) {
            var e = t.trait;
            var n = this.model.get("options") || [],
              i = document.createElement("select"),
              r = (this.target, this.target.view.el);
            for (var _t14 = 0; _t14 < n.length; _t14++) {
              var _e20 = n[_t14].name,
                _a5 = n[_t14].value;
              "" == _a5 && (_a5 = "GJS_NO_CLASS");
              var _o4 = document.createElement("option");
              _o4.text = _e20, _o4.value = _a5;
              var _s3 = _a5.split(" ");
              Fr.intersection(r.classList, _s3).length == _s3.length && _o4.setAttribute("selected", "selected"), i.append(_o4);
            }
            return i;
          },
          onUpdate: function onUpdate(t) {
            var e = t.elInput,
              n = t.component;
            var i = n.getClasses();
            var r = this.model.get("options") || [];
            for (var _t15 = 0; _t15 < r.length; _t15++) {
              r[_t15].name;
              var _n14 = r[_t15].value,
                _a6 = _t15 + 1,
                _o5 = i[_t15];
              if (_n14 && i.length === _a6 && i.includes(_o5)) return void (e.value = _n14);
            }
            e.value = "GJS_NO_CLASS";
          },
          onEvent: function onEvent(t) {
            var e = t.elInput,
              n = t.component,
              i = t.event;
            var r = this.model.get("options").map(function (t) {
              return t.value;
            });
            for (var _t16 = 0; _t16 < r.length; _t16++) if (r[_t16].length > 0) {
              var a = r[_t16].split(" ");
              for (var _t17 = 0; _t17 < a.length; _t17++) a[_t17].length > 0 && n.removeClass(a[_t17]);
            }
            var o = this.model.get("value");
            if (delete n.attributes.attributes[""], o.length > 0 && "GJS_NO_CLASS" != o) {
              var _t18 = o.split(" ");
              for (var _e21 = 0; _e21 < _t18.length; _e21++) n.addClass(_t18[_e21]);
            }
            n.em.trigger("component:toggled");
          }
        });
        var n = e.getType("text");
        e.addType("content", {
          events: {
            keyup: "onChange"
          },
          onValueChange: function onValueChange() {
            var t = this.model;
            t.target.set("content", t.get("value"));
          },
          getInputEl: function getInputEl() {
            return this.inputEl || (this.inputEl = n.prototype.getInputEl.bind(this)(), this.inputEl.value = this.target.get("content")), this.inputEl;
          }
        }), e.addType("button-type", {
          createInput: function createInput(t) {
            var e = t.trait;
            var n = e.get("options") || [],
              i = document.createElement("select");
            for (var _t19 = 0; _t19 < n.length; _t19++) {
              var _e22 = n[_t19].name,
                _r8 = n[_t19].value,
                _a7 = document.createElement("option");
              _a7.text = _e22, _a7.value = _r8, i.append(_a7);
            }
            return i;
          },
          onEvent: function onEvent(t) {
            var e = t.elInput,
              n = t.component;
            var i = this.model.get("value"),
              r = this.model.get("name"),
              a = n.attributes.attributes;
            if (a[r] = i, i) {
              n.attributes.attributes = a;
              var _t20 = n.getTrait("onclick");
              if ("submit" === i && _t20) {
                n.removeTrait("onclick");
                var _t21 = n.getAttributes();
                delete _t21["onclick"], n.setAttributes(_t21);
              } else "submit" === i || _t20 || n.addTrait({
                type: "webconnect-event",
                label: "Event",
                name: "onclick"
              });
            }
          },
          onUpdate: function onUpdate(t) {
            var e = t.elInput,
              n = t.component;
            var i = n.getAttributes(),
              r = this.model.get("name"),
              a = i[r];
            if (a) {
              e.value = i[r];
              var _t22 = n.getTrait("onclick");
              "submit" === a && _t22 ? (n.removeTrait("onclick"), delete i["onclick"], n.setAttributes(i)) : "submit" === a || _t22 || n.addTrait({
                type: "webconnect-event",
                label: "Event",
                name: "onclick"
              });
            }
          }
        });
      };
    var Br = [{
      label: "<img src=\"https://d2n21xxzvzssqy.cloudfront.net/asset_icon/button.png\"/>",
      name: "Normal Button",
      type: "bootstrap_button",
      content: "<button class=\"btn btn-primary\">Button</button>"
    }, {
      label: "<img src=\"https://d2n21xxzvzssqy.cloudfront.net/asset_icon/button_outline.png\"/>",
      name: "Outline Button",
      type: "bootstrap_button",
      content: "<button type=\"button\" class=\"btn btn-outline-primary\">Button</button>"
    }, {
      label: "<img src=\"https://d2n21xxzvzssqy.cloudfront.net/asset_icon/btn_group.png\"/>",
      name: "Group Button",
      type: "bootstrap_button",
      content: "<div class=\"btn-group\" role=\"group\" aria-label=\"Basic example\">\n<button type=\"button\" class=\"btn btn-secondary\">Left</button>\n<button type=\"button\" class=\"btn btn-secondary\">Middle</button>\n<button type=\"button\" class=\"btn btn-secondary\">Right</button>\n</div>"
    }, {
      label: "<img src=\"https://d2n21xxzvzssqy.cloudfront.net/asset_icon/default_card.png\"/>",
      name: "Default Card",
      type: "bootstrap_card",
      content: "<div class=\"card\">\n    <div class=\"card-body\">\n      <h5 class=\"card-title\">Card title</h5>\n      <h6 class=\"card-subtitle mb-2 text-muted\">Card subtitle</h6>\n      <p class=\"card-text\">Some quick example text to build on the card title and make up the bulk of the card's content.</p>\n      <a href=\"#\" class=\"card-link\">Card link</a>\n      <a href=\"#\" class=\"card-link\">Another link</a>\n    </div>\n  </div>"
    }, {
      label: "<img src=\"https://d2n21xxzvzssqy.cloudfront.net/asset_icon/header_footer_card.png\"/>",
      name: "Full Card",
      type: "bootstrap_card",
      content: "<div class=\"card text-center\">\n    <div class=\"card-header\">\n      Featured\n    </div>\n    <div class=\"card-body\">\n      <h5 class=\"card-title\">Special title treatment</h5>\n      <p class=\"card-text\">With supporting text below as a natural lead-in to additional content.</p>\n      <a href=\"#\" class=\"btn btn-primary\">Go somewhere</a>\n    </div>\n    <div class=\"card-footer text-muted\">\n      2 days ago\n    </div>\n  </div>"
    }, {
      label: "<img src=\"https://d2n21xxzvzssqy.cloudfront.net/asset_icon/image_overlay_card.png\"/>",
      name: "Image Overlay Card",
      type: "bootstrap_card",
      content: "<div class=\"card mb-3\">\n    <img class=\"card-img-top\" src=\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22831%22%20height%3D%22180%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20831%20180%22%20preserveAspectRatio%3D%22none%22%3E%3Cdefs%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%23holder_1725f0f99e1%20text%20%7B%20fill%3Argba(255%2C255%2C255%2C.75)%3Bfont-weight%3Anormal%3Bfont-family%3AHelvetica%2C%20monospace%3Bfont-size%3A42pt%20%7D%20%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22holder_1725f0f99e1%22%3E%3Crect%20width%3D%22831%22%20height%3D%22180%22%20fill%3D%22%23777%22%3E%3C%2Frect%3E%3Cg%3E%3Ctext%20x%3D%22307.5500030517578%22%20y%3D%22106.95%22%3E831x180%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E\" alt=\"Card image cap\">\n    <div class=\"card-body\">\n      <h5 class=\"card-title\">Card title</h5>\n      <p class=\"card-text\">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>\n      <p class=\"card-text\"><small class=\"text-muted\">Last updated 3 mins ago</small></p>\n    </div>\n  </div>"
    }];
    var Wr = n(4),
      Yr = n.n(Wr);
    var Ur = "\n<style>\n  .card {\n    margin-bottom: 1.875rem;\n    border: none;\n    border-radius: 0;\n    box-shadow: 0 10px 40px 0 rgba(62,57,107,.07),0 2px 9px 0 rgba(62,57,107,.06);\n  }\n</style>\n";
    var Zr = function Zr(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      var n = t.Commands;
      var i;
      var r = e.modalTitle,
        a = e.commands,
        o = e.types;
      n.add(a.button, {
        run: function run(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          this.editor = t, this.options = n, this.target = n.target || t.getSelected();
          var i = this.target;
          i && i.get("editable") && this.showCustomButton(i);
        },
        stop: function stop(t) {
          t.Modal.close();
        },
        showCustomButton: function showCustomButton(t) {
          var _this7 = this;
          var e = this.editor,
            n = this.options,
            a = n.title || r,
            s = e.AssetManager,
            l = s.getContainer();
          s.setTarget(t);
          var c = Br.filter(function (t) {
            return t.type == o.button;
          });
          s.render(c);
          var d = s.getAssetsEl();
          d && (d.className = "gjs-am-assets gjs-am-assets--button"), e.Modal.open({
            title: a,
            content: l
          }).getModel().once("change:open", function () {
            return e.stopCommand(_this7.id);
          }), i = Yr()(l.querySelector(".gjs-am-assets-header")), Yr()(l.querySelector(".gjs-am-file-uploader")).hide(), i.hide();
        }
      }), n.add(a.card, {
        run: function run(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          this.editor = t, this.options = n, this.target = n.target || t.getSelected();
          var i = this.target;
          i && i.get("editable") && this.showCustomButton(i);
        },
        stop: function stop(t) {
          t.Modal.close();
        },
        showCustomButton: function showCustomButton(t) {
          var _this8 = this;
          var e = this.editor,
            n = this.options,
            a = n.title || r,
            s = e.AssetManager,
            l = s.getContainer();
          s.setTarget(t);
          var c = Br.filter(function (t) {
            return t.type == o.card;
          });
          s.render(c);
          var d = s.getAssetsEl();
          d && (d.className = "gjs-am-assets gjs-am-assets--card"), e.Modal.open({
            title: a,
            content: l
          }).getModel().once("change:open", function () {
            return e.stopCommand(_this8.id);
          }), i = Yr()(l.querySelector(".gjs-am-assets-header")), Yr()(l.querySelector(".gjs-am-file-uploader")).hide(), i.hide();
        }
      });
      var s = e.sectionsModalTitle,
        l = e.codeViewOptions,
        c = e.commandDrapCodeSectionsSectionCode,
        d = e.refs,
        u = e.sectionsPlaceholderContent,
        h = e.sections,
        p = d.keyDrapCodeSectionsCustomCode,
        g = d.drapcodeSectionRef,
        f = function f(t, e) {
          e instanceof HTMLElement ? t.appendChild(e) : e && t.insertAdjacentHTML("beforeend", e);
        };
      var m = [];
      n.add(a.drapcode_sections_custom_code, _objectSpread({
        keyDrapCodeSectionsCustomCode: p,
        run: function run(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          this.editor = t, this.options = n, this.target = n.target || t.getSelected();
          var i = this.target;
          i && i.get("editable") && this.showDrapcodeSectionsCode(i);
        },
        stop: function stop(t) {
          t.Modal.close();
        },
        showDrapcodeSectionsCode: function () {
          var _showDrapcodeSectionsCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(t) {
            var _this9 = this;
            var e, n, i, r, a;
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  e = this.editor, n = this.options, i = n.title || s;
                  m = h;
                  r = this.getContent(), a = t.get(p) || "";
                  e.Modal.open({
                    title: i,
                    content: r
                  }).getModel().once("change:open", function () {
                    return e.stopCommand(_this9.id);
                  }), this.getCodeViewer().setContent(a);
                case 4:
                case "end":
                  return _context.stop();
              }
            }, _callee, this);
          }));
          function showDrapcodeSectionsCode(_x) {
            return _showDrapcodeSectionsCode.apply(this, arguments);
          }
          return showDrapcodeSectionsCode;
        }(),
        getPreContent: function getPreContent() {},
        getPostContent: function getPostContent() {},
        getBreakPoint: function getBreakPoint() {
          return document.createElement("br");
        },
        getContent: function getContent() {
          var t = this.editor,
            e = document.createElement("div"),
            n = document.createElement("div"),
            i = this.getCodeViewer(),
            r = t.getConfig("stylePrefix");
          e.className = "".concat(r, "drapcode-sections"), n.className = "".concat(r, "drapcode-sections-gallery-div"), n.id = "".concat(r, "drapcode-sections-gallery-div"), f(e, this.getPreContent()), f(n, this.getPreContent()), this.loadSectionList(m, n);
          var a = [n, i.getElement()];
          return this.appendChildComponentsToContent(e, a), f(n, this.getPostContent()), f(e, this.getPostContent()), i.refresh(), setTimeout(function () {
            return i.focus();
          }, 0), e;
        },
        appendChildComponentsToContent: function appendChildComponentsToContent(t, e) {
          var _this10 = this;
          e.forEach(function (e) {
            "" === e.id || void 0 === e.id ? (e.style = "display: none; visibility: hidden; height: 0vh;", t.appendChild(e)) : (t.appendChild(e), e.className.includes("no-break") || t.appendChild(_this10.getBreakPoint()), e.className.includes("two-break") && t.appendChild(_this10.getBreakPoint()));
          });
        },
        handleSave: function handleSave() {
          var t = this.editor,
            e = this.target;
          "" === this.getCodeViewer().getContent() && this.getCodeViewer().setContent(u);
          var n = this.getCodeViewer().getContent();
          e.set(p, n), t.Modal.close();
        },
        loadSectionList: function () {
          var _loadSectionList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(t, e) {
            var _this11 = this;
            var n, i, r;
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  n = this.editor, i = this.options, r = n.getConfig("stylePrefix");
                  e.innerHTML = "", t.forEach(function (n) {
                    var i = document.createAttribute("title");
                    i.value = "Click to add Section ".concat(n.label, " to Canvas");
                    var a = document.createElement("div");
                    a.id = "".concat(r, "drapcode-sections-").concat(n.value), a.className = "".concat(r, "drapcode-sections"), a.setAttributeNode(i), a.innerHTML = "\n\n        <div class=\"preview-drapcode-sections\">\n          <span class=\"inner-html\">\n            <div class=\"mkp-components\">\n            ".concat(n.view, "\n            </div>\n          </span>\n          <span class=\"label text-center\">").concat(n.label, "</span>\n        </div>\n\n        "), a.onclick = function () {
                      _this11.handleClick(n, t, e), _this11.handleSave();
                    }, e.appendChild(a);
                  });
                case 2:
                case "end":
                  return _context2.stop();
              }
            }, _callee2, this);
          }));
          function loadSectionList(_x2, _x3) {
            return _loadSectionList.apply(this, arguments);
          }
          return loadSectionList;
        }(),
        handleClick: function () {
          var _handleClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(t, e, n) {
            var i, r, a, o, s, l, _e23;
            return _regeneratorRuntime().wrap(function _callee3$(_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  i = this.editor, r = this.options, a = i.getConfig("stylePrefix"), o = document.querySelectorAll("div.".concat(a, "drapcode-sections")), s = document.querySelector("div[id=".concat(a, "drapcode-sections-").concat(t.value, "]")), l = s.querySelector(".inner-html");
                  if (o.forEach(function (t) {
                    t.querySelector(".inner-html").classList.remove("selected-drapcode-section-comp");
                  }), l.classList.add("selected-drapcode-section-comp"), s) {
                    _e23 = t.code;
                    this.getCodeViewer().setContent(_e23);
                  } else this.getCodeViewer().setContent(u);
                case 2:
                case "end":
                  return _context3.stop();
              }
            }, _callee3, this);
          }));
          function handleClick(_x4, _x5, _x6) {
            return _handleClick.apply(this, arguments);
          }
          return handleClick;
        }(),
        getCodeViewer: function getCodeViewer() {
          var t = this.editor;
          return this.codeViewer || (this.codeViewer = t.CodeManager.createViewer(_objectSpread({
            codeName: "htmlmixed",
            theme: "hopscotch",
            readOnly: 0
          }, l))), this.codeViewer;
        }
      }, c));
      var v = e.carouselsModalTitle,
        b = e.carouselsCodeViewOptions,
        y = e.commandDrapCodeCarouselsCarouselCode,
        w = e.carouselsPlaceholderContent,
        x = e.carousels,
        j = d.keyDrapCodeCarouselsCustomCode,
        C = d.drapcodeCarouselRef;
      var M = [];
      n.add(a.drapcode_carousels_custom_code, _objectSpread({
        keyDrapCodeCarouselsCustomCode: j,
        run: function run(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          this.editor = t, this.options = n, this.target = n.target || t.getSelected();
          var i = this.target;
          i && i.get("editable") && this.showDrapcodeCarouselsCode(i);
        },
        stop: function stop(t) {
          t.Modal.close();
        },
        showDrapcodeCarouselsCode: function () {
          var _showDrapcodeCarouselsCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(t) {
            var _this12 = this;
            var e, n, i, r, a;
            return _regeneratorRuntime().wrap(function _callee4$(_context4) {
              while (1) switch (_context4.prev = _context4.next) {
                case 0:
                  e = this.editor, n = this.options, i = n.title || v;
                  M = x;
                  r = this.getContent(), a = t.get(j) || "";
                  e.Modal.open({
                    title: i,
                    content: r
                  }).getModel().once("change:open", function () {
                    return e.stopCommand(_this12.id);
                  }), this.getCodeViewerForCarousel().setContent(a);
                case 4:
                case "end":
                  return _context4.stop();
              }
            }, _callee4, this);
          }));
          function showDrapcodeCarouselsCode(_x7) {
            return _showDrapcodeCarouselsCode.apply(this, arguments);
          }
          return showDrapcodeCarouselsCode;
        }(),
        getPreContent: function getPreContent() {},
        getPostContent: function getPostContent() {},
        getBreakPoint: function getBreakPoint() {
          return document.createElement("br");
        },
        getContent: function getContent() {
          var t = this.editor,
            e = document.createElement("div"),
            n = document.createElement("div"),
            i = this.getCodeViewerForCarousel(),
            r = t.getConfig("stylePrefix");
          e.className = "".concat(r, "drapcode-carousels"), n.className = "".concat(r, "drapcode-carousels-gallery-div"), n.id = "".concat(r, "drapcode-carousels-gallery-div"), f(e, this.getPreContent()), f(n, this.getPreContent()), this.loadCarouselList(M, n);
          var a = [n, i.getElement()];
          return this.appendChildComponentsToContent(e, a), f(n, this.getPostContent()), f(e, this.getPostContent()), i.refresh(), setTimeout(function () {
            return i.focus();
          }, 0), e;
        },
        appendChildComponentsToContent: function appendChildComponentsToContent(t, e) {
          var _this13 = this;
          e.forEach(function (e) {
            "" === e.id || void 0 === e.id ? (e.style = "display: none; visibility: hidden; height: 0vh;", t.appendChild(e)) : (t.appendChild(e), e.className.includes("no-break") || t.appendChild(_this13.getBreakPoint()), e.className.includes("two-break") && t.appendChild(_this13.getBreakPoint()));
          });
        },
        handleSaveForCarousel: function handleSaveForCarousel() {
          var t = this.editor,
            e = this.target;
          "" === this.getCodeViewerForCarousel().getContent() && this.getCodeViewerForCarousel().setContent(w);
          var n = this.getCodeViewerForCarousel().getContent();
          e.set(j, n), t.Modal.close();
        },
        loadCarouselList: function () {
          var _loadCarouselList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(t, e) {
            var _this14 = this;
            var n, i, r;
            return _regeneratorRuntime().wrap(function _callee5$(_context5) {
              while (1) switch (_context5.prev = _context5.next) {
                case 0:
                  n = this.editor, i = this.options, r = n.getConfig("stylePrefix");
                  e.innerHTML = "", t.forEach(function (n) {
                    var i = document.createAttribute("title");
                    i.value = "Click to add ".concat(n.label, " to Canvas");
                    var a = document.createElement("div");
                    a.id = "".concat(r, "drapcode-carousels-").concat(n.value), a.className = "".concat(r, "drapcode-carousels"), a.setAttributeNode(i), a.innerHTML = "\n  \n          <div class=\"preview-drapcode-carousels\">\n            <span class=\"inner-html\">\n              <div class=\"mkp-components\">\n              ".concat(n.view, "\n              </div>\n            </span>\n            <span class=\"label text-center\">").concat(n.label, "</span>\n          </div>\n  \n          "), a.onclick = function () {
                      _this14.handleClickForCarousel(n, t, e), _this14.handleSaveForCarousel();
                    }, e.appendChild(a);
                  });
                case 2:
                case "end":
                  return _context5.stop();
              }
            }, _callee5, this);
          }));
          function loadCarouselList(_x8, _x9) {
            return _loadCarouselList.apply(this, arguments);
          }
          return loadCarouselList;
        }(),
        handleClickForCarousel: function () {
          var _handleClickForCarousel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(t, e, n) {
            var i, r, a, o, s, l, _e24;
            return _regeneratorRuntime().wrap(function _callee6$(_context6) {
              while (1) switch (_context6.prev = _context6.next) {
                case 0:
                  i = this.editor, r = this.options, a = i.getConfig("stylePrefix"), o = document.querySelectorAll("div.".concat(a, "drapcode-carousels")), s = document.querySelector("div[id=".concat(a, "drapcode-carousels-").concat(t.value, "]")), l = s.querySelector(".inner-html");
                  if (o.forEach(function (t) {
                    t.querySelector(".inner-html").classList.remove("selected-drapcode-carousel-comp");
                  }), l.classList.add("selected-drapcode-carousel-comp"), s) {
                    _e24 = t.code;
                    this.getCodeViewerForCarousel().setContent(_e24);
                  } else this.getCodeViewerForCarousel().setContent(w);
                case 2:
                case "end":
                  return _context6.stop();
              }
            }, _callee6, this);
          }));
          function handleClickForCarousel(_x10, _x11, _x12) {
            return _handleClickForCarousel.apply(this, arguments);
          }
          return handleClickForCarousel;
        }(),
        getCodeViewerForCarousel: function getCodeViewerForCarousel() {
          var t = this.editor;
          return this.codeViewer || (this.codeViewer = t.CodeManager.createViewer(_objectSpread({
            codeName: "htmlmixed",
            theme: "hopscotch",
            readOnly: 0
          }, b))), this.codeViewer;
        }
      }, y));
      var k = e.cardsModalTitle,
        O = e.cardsCodeViewOptions,
        T = e.commandDrapCodeCardsCardCode,
        S = e.cardsPlaceholderContent,
        N = e.cards,
        L = d.keyDrapCodeCardsCustomCode,
        D = d.drapcodeCardRef;
      var E = [];
      n.add(a.drapcode_cards_custom_code, _objectSpread({
        keyDrapCodeCardsCustomCode: L,
        run: function run(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          this.editor = t, this.options = n, this.target = n.target || t.getSelected();
          var i = this.target;
          i && i.get("editable") && this.showDrapcodeCardsCode(i);
        },
        stop: function stop(t) {
          t.Modal.close();
        },
        showDrapcodeCardsCode: function () {
          var _showDrapcodeCardsCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(t) {
            var _this15 = this;
            var e, n, i, r, a;
            return _regeneratorRuntime().wrap(function _callee7$(_context7) {
              while (1) switch (_context7.prev = _context7.next) {
                case 0:
                  e = this.editor, n = this.options, i = n.title || k;
                  E = N;
                  r = this.getContent(), a = t.get(L) || "";
                  e.Modal.open({
                    title: i,
                    content: r
                  }).getModel().once("change:open", function () {
                    return e.stopCommand(_this15.id);
                  }), this.getCodeViewerForCard().setContent(a);
                case 4:
                case "end":
                  return _context7.stop();
              }
            }, _callee7, this);
          }));
          function showDrapcodeCardsCode(_x13) {
            return _showDrapcodeCardsCode.apply(this, arguments);
          }
          return showDrapcodeCardsCode;
        }(),
        getPreContent: function getPreContent() {},
        getPostContent: function getPostContent() {},
        getBreakPoint: function getBreakPoint() {
          return document.createElement("br");
        },
        getContent: function getContent() {
          var t = this.editor,
            e = document.createElement("div"),
            n = document.createElement("div"),
            i = this.getCodeViewerForCard(),
            r = t.getConfig("stylePrefix");
          e.className = "".concat(r, "drapcode-cards"), n.className = "".concat(r, "drapcode-cards-gallery-div"), n.id = "".concat(r, "drapcode-cards-gallery-div"), f(e, this.getPreContent()), f(n, this.getPreContent()), this.loadCardList(E, n);
          var a = [n, i.getElement()];
          return this.appendChildComponentsToContent(e, a), f(n, this.getPostContent()), f(e, this.getPostContent()), i.refresh(), setTimeout(function () {
            return i.focus();
          }, 0), e;
        },
        appendChildComponentsToContent: function appendChildComponentsToContent(t, e) {
          var _this16 = this;
          e.forEach(function (e) {
            "" === e.id || void 0 === e.id ? (e.style = "display: none; visibility: hidden; height: 0vh;", t.appendChild(e)) : (t.appendChild(e), e.className.includes("no-break") || t.appendChild(_this16.getBreakPoint()), e.className.includes("two-break") && t.appendChild(_this16.getBreakPoint()));
          });
        },
        handleSaveForCard: function handleSaveForCard() {
          var t = this.editor,
            e = this.target;
          "" === this.getCodeViewerForCard().getContent() && this.getCodeViewerForCard().setContent(S);
          var n = this.getCodeViewerForCard().getContent();
          e.replaceWith(n), t.Modal.close();
        },
        loadCardList: function () {
          var _loadCardList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(t, e) {
            var _this17 = this;
            var n, i, r;
            return _regeneratorRuntime().wrap(function _callee8$(_context8) {
              while (1) switch (_context8.prev = _context8.next) {
                case 0:
                  n = this.editor, i = this.options, r = n.getConfig("stylePrefix");
                  e.innerHTML = "", t.forEach(function (n) {
                    var i = document.createAttribute("title");
                    i.value = "Click to add ".concat(n.label, " to Canvas");
                    var a = document.createElement("div");
                    a.id = "".concat(r, "drapcode-cards-").concat(n.value), a.className = "".concat(r, "drapcode-cards-gallery-img"), a.setAttributeNode(i), a.innerHTML = "\n  \n          <div class=\"preview-drapcode-cards\">\n            <span class=\"inner-html\">\n              <div class=\"mkp-components\">\n              ".concat(n.view, "\n              </div>\n            </span>\n            \x3c!-- <span class=\"label text-center\">").concat(n.label, "</span> --\x3e\n          </div>\n  \n          "), a.onclick = function () {
                      _this17.handleClickForCard(n, t, e), _this17.handleSaveForCard();
                    }, e.appendChild(a);
                  });
                case 2:
                case "end":
                  return _context8.stop();
              }
            }, _callee8, this);
          }));
          function loadCardList(_x14, _x15) {
            return _loadCardList.apply(this, arguments);
          }
          return loadCardList;
        }(),
        handleClickForCard: function () {
          var _handleClickForCard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(t, e, n) {
            var i, r, a, o, s, l, _e25;
            return _regeneratorRuntime().wrap(function _callee9$(_context9) {
              while (1) switch (_context9.prev = _context9.next) {
                case 0:
                  i = this.editor, r = this.options, a = i.getConfig("stylePrefix"), o = document.querySelectorAll("div.".concat(a, "drapcode-cards")), s = document.querySelector("div[id=".concat(a, "drapcode-cards-").concat(t.value, "]")), l = s.querySelector(".inner-html");
                  if (o.forEach(function (t) {
                    t.querySelector(".inner-html").classList.remove("selected-drapcode-card-comp");
                  }), l.classList.add("selected-drapcode-card-comp"), s) {
                    _e25 = t.code + Ur;
                    this.getCodeViewerForCard().setContent(_e25);
                  } else this.getCodeViewerForCard().setContent(S + Ur);
                case 2:
                case "end":
                  return _context9.stop();
              }
            }, _callee9, this);
          }));
          function handleClickForCard(_x16, _x17, _x18) {
            return _handleClickForCard.apply(this, arguments);
          }
          return handleClickForCard;
        }(),
        getCodeViewerForCard: function getCodeViewerForCard() {
          var t = this.editor;
          return this.codeViewer || (this.codeViewer = t.CodeManager.createViewer(_objectSpread({
            codeName: "htmlmixed",
            theme: "hopscotch",
            readOnly: 0
          }, O))), this.codeViewer;
        }
      }, T));
    };
    var Gr = [{
      label: "1 Column: Blank",
      name: "section11Empty",
      type: "view",
      content: "\n    <div class=\"dc-sview sContainer\">\n      ".concat("\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"154.8449\" height=\"93.7159\" viewBox=\"0 0 154.8449 93.7159\"><defs><style>.cls-1{fill:#272940;}</style></defs><title>1 Column: Blank</title><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><path class=\"cls-1\" d=\"M150.7385,93.7159H4.1064A4.15,4.15,0,0,1,0,89.5234V4.1925A4.15,4.15,0,0,1,4.1064,0H150.7385a4.15,4.15,0,0,1,4.1064,4.1925V89.5234A4.15,4.15,0,0,1,150.7385,93.7159ZM8.3205,89.4135H146.5244a4.15,4.15,0,0,0,4.1064-4.1925V8.4949a4.15,4.15,0,0,0-4.1064-4.1925H8.3205A4.15,4.15,0,0,0,4.2141,8.4949V85.221A4.15,4.15,0,0,0,8.3205,89.4135Z\"/></g></g></svg>\n", "\n    </div>\n    ")
    }, {
      label: "2 Columns: Blank",
      name: "section22Empty",
      type: "view",
      content: "\n    <div class=\"dc-sview sContainer\">\n      ".concat("\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"154.8449\" height=\"93.8966\" viewBox=\"0 0 154.8449 93.8966\"><defs><style>.cls-1{fill:#272940;}</style></defs><title>2 Columns: Blank</title><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><path class=\"cls-1\" d=\"M67.7608,93.8966H5.3512A5.4017,5.4017,0,0,1,0,88.4457V5.451A5.4018,5.4018,0,0,1,5.3512,0h62.41a5.4018,5.4018,0,0,1,5.3511,5.451V88.4457A5.4017,5.4017,0,0,1,67.7608,93.8966ZM9.3468,89.5912H63.7651a5.4018,5.4018,0,0,0,5.3512-5.451V9.7565a5.4018,5.4018,0,0,0-5.3512-5.451H9.3468a5.4017,5.4017,0,0,0-5.3511,5.451V84.14A5.4017,5.4017,0,0,0,9.3468,89.5912Z\"/><path class=\"cls-1\" d=\"M149.4767,93.8966H86.8682A5.41,5.41,0,0,1,81.5,88.4457V5.451A5.41,5.41,0,0,1,86.8682,0h62.6085a5.41,5.41,0,0,1,5.3682,5.451V88.4457A5.41,5.41,0,0,1,149.4767,93.8966Zm-58.6-4.3054h54.5917a5.41,5.41,0,0,0,5.3682-5.451V9.7565a5.41,5.41,0,0,0-5.3682-5.451H90.8766a5.41,5.41,0,0,0-5.3682,5.451V84.14A5.41,5.41,0,0,0,90.8766,89.5912Z\"/></g></g></svg>\n", "\n    </div>")
    }, {
      label: "3 Columns: Blank",
      name: "section33Empty",
      type: "view",
      content: "\n    <div class=\"dc-sview sContainer\">\n      ".concat("\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"154.8392\" height=\"94.2129\" viewBox=\"0 0 154.8392 94.2129\"><defs><style>.cls-1{fill:#272940;}</style></defs><title>3 Columns: Blank</title><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><path class=\"cls-1\" d=\"M46.5108,94.2129H2.5956A2.5956,2.5956,0,0,1,0,91.6173V2.5956A2.5956,2.5956,0,0,1,2.5956,0H46.5108a2.5955,2.5955,0,0,1,2.5956,2.5956V91.6173A2.5955,2.5955,0,0,1,46.5108,94.2129Zm-39.9152-4H42.5108a2.5955,2.5955,0,0,0,2.5956-2.5956V6.5956A2.5955,2.5955,0,0,0,42.5108,4H6.5956A2.5956,2.5956,0,0,0,4,6.5956V87.6173A2.5956,2.5956,0,0,0,6.5956,90.2129Z\"/><path class=\"cls-1\" d=\"M152.2436,94.2129H108.3283a2.5956,2.5956,0,0,1-2.5956-2.5956V2.5956A2.5956,2.5956,0,0,1,108.3283,0h43.9153a2.5956,2.5956,0,0,1,2.5956,2.5956V91.6173A2.5956,2.5956,0,0,1,152.2436,94.2129Zm-39.9153-4h35.9153a2.5956,2.5956,0,0,0,2.5956-2.5956V6.5956A2.5956,2.5956,0,0,0,148.2436,4H112.3283a2.5956,2.5956,0,0,0-2.5956,2.5956V87.6173A2.5956,2.5956,0,0,0,112.3283,90.2129Z\"/><path class=\"cls-1\" d=\"M99.4519,94.2129H55.5367a2.5956,2.5956,0,0,1-2.5956-2.5956V2.5956A2.5956,2.5956,0,0,1,55.5367,0H99.4519a2.5956,2.5956,0,0,1,2.5956,2.5956V91.6173A2.5956,2.5956,0,0,1,99.4519,94.2129Zm-39.9152-4H95.4519a2.5956,2.5956,0,0,0,2.5956-2.5956V6.5956A2.5956,2.5956,0,0,0,95.4519,4H59.5367a2.5956,2.5956,0,0,0-2.5956,2.5956V87.6173A2.5956,2.5956,0,0,0,59.5367,90.2129Z\"/></g></g></svg>\n", "\n    </div>")
    }, {
      label: "4 Columns: Blank",
      name: "section44Empty",
      type: "view",
      content: "\n    <div class=\"dc-sview sContainer\">\n      ".concat("\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"154.8193\" height=\"94.2095\" viewBox=\"0 0 154.8193 94.2095\"><defs><style>.cls-1{fill:#272940;}</style></defs><title>4 Columns: Blank</title><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><path class=\"cls-1\" d=\"M34.2179,94.21H2.3456A2.3457,2.3457,0,0,1,0,91.8639V2.3456A2.3457,2.3457,0,0,1,2.3456,0H34.2179a2.3457,2.3457,0,0,1,2.3456,2.3456V91.8639A2.3457,2.3457,0,0,1,34.2179,94.21Zm-27.8723-4H30.2179a2.3457,2.3457,0,0,0,2.3456-2.3456V6.3456A2.3457,2.3457,0,0,0,30.2179,4H6.3456A2.3457,2.3457,0,0,0,4,6.3456V87.8639A2.3457,2.3457,0,0,0,6.3456,90.21Z\"/><path class=\"cls-1\" d=\"M73.48,94.21H41.6073a2.3457,2.3457,0,0,1-2.3456-2.3456V2.3456A2.3457,2.3457,0,0,1,41.6073,0H73.48a2.3457,2.3457,0,0,1,2.3456,2.3456V91.8639A2.3457,2.3457,0,0,1,73.48,94.21Zm-27.8723-4H69.48a2.3457,2.3457,0,0,0,2.3456-2.3456V6.3456A2.3457,2.3457,0,0,0,69.48,4H45.6073a2.3457,2.3457,0,0,0-2.3456,2.3456V87.8639A2.3457,2.3457,0,0,0,45.6073,90.21Z\"/><path class=\"cls-1\" d=\"M112.7413,94.21H80.869a2.3457,2.3457,0,0,1-2.3456-2.3456V2.3456A2.3457,2.3457,0,0,1,80.869,0h31.8723a2.3456,2.3456,0,0,1,2.3456,2.3456V91.8639A2.3456,2.3456,0,0,1,112.7413,94.21Zm-27.8723-4h23.8723a2.3456,2.3456,0,0,0,2.3456-2.3456V6.3456A2.3456,2.3456,0,0,0,108.7413,4H84.869a2.3457,2.3457,0,0,0-2.3456,2.3456V87.8639A2.3457,2.3457,0,0,0,84.869,90.21Z\"/><path class=\"cls-1\" d=\"M152.4737,94.21H120.6015a2.3456,2.3456,0,0,1-2.3456-2.3456V2.3456A2.3456,2.3456,0,0,1,120.6015,0h31.8722a2.3456,2.3456,0,0,1,2.3456,2.3456V91.8639A2.3456,2.3456,0,0,1,152.4737,94.21Zm-27.8722-4h23.8722a2.3456,2.3456,0,0,0,2.3456-2.3456V6.3456A2.3456,2.3456,0,0,0,148.4737,4H124.6015a2.3456,2.3456,0,0,0-2.3456,2.3456V87.8639A2.3456,2.3456,0,0,0,124.6015,90.21Z\"/></g></g></svg>\n", "\n    </div>")
    }, {
      label: "1 Column: 12/12",
      name: "section11",
      type: "view",
      content: "\n    <div class=\"dc-sview sContainer\">\n      ".concat("\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"154.8449\" height=\"93.8966\" viewBox=\"0 0 154.8449 93.8966\"><defs><style>.cls-1{fill:#272940;}.cls-2{fill:#8387a5;}.cls-3{fill:none;}</style></defs><title>1 Column: 12/12</title><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><rect class=\"cls-1\" x=\"0.3491\" y=\"35.152\" width=\"77.437\" height=\"4.8794\" rx=\"2.4397\"/><rect class=\"cls-2\" x=\"0.1669\" y=\"50.4243\" width=\"52.5865\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"59.2301\" y=\"50.4243\" width=\"53.3598\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"118.7765\" y=\"50.4243\" width=\"24.2633\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"0.1669\" y=\"44.2454\" width=\"28.4199\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"34.9668\" y=\"44.2454\" width=\"61.6731\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"101.4733\" y=\"44.2454\" width=\"53.3598\" height=\"3.3581\" rx=\"1.679\"/></g></g></svg>\n", "\n    </div>\n    ")
    }, {
      label: "2 Columns: 4/12,8/12",
      name: "section22",
      type: "view",
      content: "\n    <div class=\"dc-sview sContainer\">\n      ".concat("\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"154.8449\" height=\"93.8966\" viewBox=\"0 0 154.8449 93.8966\"><defs><style>.cls-1{fill:#272940;}.cls-2{fill:#8387a5;}.cls-3{fill:none;}</style></defs><title>2 Columns: 4/12,8/12</title><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><rect class=\"cls-1\" x=\"0.3381\" y=\"39.5\" width=\"70.0595\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-2\" x=\"0.2482\" y=\"56.7148\" width=\"23.8508\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"27.0365\" y=\"56.7148\" width=\"24.2015\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"54.044\" y=\"56.7148\" width=\"11.0047\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"0.2482\" y=\"49.75\" width=\"12.89\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"16.0318\" y=\"49.75\" width=\"27.9721\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"46.196\" y=\"49.75\" width=\"24.2015\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-1\" x=\"84.6923\" y=\"39.5\" width=\"70.0595\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-2\" x=\"84.6024\" y=\"56.7148\" width=\"23.8508\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"111.3907\" y=\"56.7148\" width=\"24.2015\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"138.3983\" y=\"56.7148\" width=\"11.0047\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"84.6024\" y=\"49.75\" width=\"12.89\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"100.386\" y=\"49.75\" width=\"27.9721\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"130.5503\" y=\"49.75\" width=\"24.2015\" height=\"3.7852\" rx=\"1.8926\"/></g></g></svg>\n", "\n    </div>")
    }, {
      label: "3 Columns: 8/12,4/12",
      name: "section33",
      type: "view",
      content: "\n    <div class=\"dc-sview sContainer\">\n      ".concat("\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"154.8449\" height=\"93.8966\" viewBox=\"0 0 154.8449 93.8966\"><defs><style>.cls-3{fill:none;}.cls-1{fill:#272940;}.cls-2{fill:#8387a5;}</style></defs><title>3 Columns: 8/12,4/12</title><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><rect class=\"cls-1\" x=\"0.2605\" y=\"36.4483\" width=\"44.5994\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-2\" x=\"0.1706\" y=\"53.6631\" width=\"15.1944\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"17.2363\" y=\"53.6631\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"34.4417\" y=\"53.6631\" width=\"7.0106\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"0.1706\" y=\"46.6983\" width=\"8.2117\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"10.2257\" y=\"46.6983\" width=\"17.8199\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"29.4421\" y=\"46.6983\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-1\" x=\"110.0748\" y=\"36.4483\" width=\"44.5994\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-2\" x=\"109.9849\" y=\"53.6631\" width=\"15.1944\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"127.0507\" y=\"53.6631\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"144.2561\" y=\"53.6631\" width=\"7.0106\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"109.9849\" y=\"46.6983\" width=\"8.2117\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"120.04\" y=\"46.6983\" width=\"17.8199\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"139.2564\" y=\"46.6983\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-1\" x=\"55.0748\" y=\"36.4483\" width=\"44.5994\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-2\" x=\"54.9849\" y=\"53.6631\" width=\"15.1944\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"72.0507\" y=\"53.6631\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"89.2561\" y=\"53.6631\" width=\"7.0106\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"54.9849\" y=\"46.6983\" width=\"8.2117\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"65.04\" y=\"46.6983\" width=\"17.8199\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"84.2564\" y=\"46.6983\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/></g></g></svg>\n", "\n    </div>")
    }, {
      label: "4 Columns: 4x3/12",
      name: "section44",
      type: "view",
      content: "\n    <div class=\"dc-sview sContainer\">\n      ".concat("\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"154.8449\" height=\"93.8966\" viewBox=\"0 0 154.8449 93.8966\"><defs><style>.cls-3{fill:none;}.cls-1{fill:#272940;}.cls-2{fill:#8387a5;}</style></defs><title>4 Columns: 4x3/12</title><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><rect class=\"cls-1\" x=\"0.5839\" y=\"36.1983\" width=\"29.3851\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-2\" x=\"0.494\" y=\"53.4131\" width=\"10.0215\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"11.7497\" y=\"53.4131\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"23.0976\" y=\"53.4131\" width=\"4.6239\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"0.494\" y=\"46.4483\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"7.1259\" y=\"46.4483\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"19.8001\" y=\"46.4483\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-1\" x=\"40.1171\" y=\"36.1983\" width=\"29.3851\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-2\" x=\"40.0272\" y=\"53.4131\" width=\"10.0215\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"51.283\" y=\"53.4131\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"62.6308\" y=\"53.4131\" width=\"4.6239\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"40.0272\" y=\"46.4483\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"46.6591\" y=\"46.4483\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"59.3333\" y=\"46.4483\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-1\" x=\"82.6023\" y=\"36.1983\" width=\"29.3851\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-2\" x=\"82.5124\" y=\"53.4131\" width=\"10.0215\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"93.7682\" y=\"53.4131\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"105.1161\" y=\"53.4131\" width=\"4.6239\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"82.5124\" y=\"46.4483\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"89.1443\" y=\"46.4483\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"101.8186\" y=\"46.4483\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-1\" x=\"124.87\" y=\"36.1983\" width=\"29.3851\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-2\" x=\"124.7801\" y=\"53.4131\" width=\"10.0215\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"136.0359\" y=\"53.4131\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"147.3838\" y=\"53.4131\" width=\"4.6239\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"124.7801\" y=\"46.4483\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"131.412\" y=\"46.4483\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"144.0862\" y=\"46.4483\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/></g></g></svg>\n", "\n    </div>")
    }, {
      label: "2 Columns: 4/12,8/12",
      name: "section4060",
      type: "view",
      content: "\n    <div class=\"dc-sview sContainer\">\n      ".concat("\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"154.8449\" height=\"93.8966\" viewBox=\"0 0 154.8449 93.8966\"><defs><style>.cls-3{fill:none;}.cls-1{fill:#272940;}.cls-2{fill:#8387a5;}</style></defs><title>2 Columns: 4/12,8/12</title><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><rect class=\"cls-1\" x=\"0.2605\" y=\"36.4483\" width=\"44.5994\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-2\" x=\"0.1706\" y=\"53.6631\" width=\"15.1944\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"17.2363\" y=\"53.6631\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"34.4417\" y=\"53.6631\" width=\"7.0106\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"0.1706\" y=\"46.6983\" width=\"8.2117\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"10.2257\" y=\"46.6983\" width=\"17.8199\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"29.4421\" y=\"46.6983\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-1\" x=\"55.1858\" y=\"36.4483\" width=\"99.659\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-2\" x=\"54.9849\" y=\"53.6631\" width=\"33.9524\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"93.1189\" y=\"53.6631\" width=\"34.4517\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"131.565\" y=\"53.6631\" width=\"15.6655\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"54.9849\" y=\"46.6983\" width=\"18.3493\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"77.4534\" y=\"46.6983\" width=\"39.8191\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"120.3932\" y=\"46.6983\" width=\"34.4517\" height=\"3.7852\" rx=\"1.8926\"/></g></g></svg>\n", "\n    </div>")
    }, {
      label: "2 Columns: 8/12,4/12",
      name: "section6040",
      type: "view",
      content: "\n    <div class=\"dc-sview sContainer\">\n      ".concat("\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"154.8449\" height=\"93.8966\" viewBox=\"0 0 154.8449 93.8966\"><defs><style>.cls-3{fill:none;}.cls-1{fill:#272940;}.cls-2{fill:#8387a5;}</style></defs><title>2 Columns: 8/12,4/12</title><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><rect class=\"cls-1\" x=\"0.3708\" y=\"36.4483\" width=\"99.3035\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-2\" x=\"0.1706\" y=\"53.6631\" width=\"33.8313\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"38.1686\" y=\"53.6631\" width=\"34.3288\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"76.4775\" y=\"53.6631\" width=\"15.6096\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"0.1706\" y=\"46.6983\" width=\"18.2838\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"22.5589\" y=\"46.6983\" width=\"39.6771\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"65.3455\" y=\"46.6983\" width=\"34.3288\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-1\" x=\"110.0748\" y=\"36.4483\" width=\"44.5994\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-2\" x=\"109.9849\" y=\"53.6631\" width=\"15.1944\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"127.0507\" y=\"53.6631\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"144.2561\" y=\"53.6631\" width=\"7.0106\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"109.9849\" y=\"46.6983\" width=\"8.2117\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"120.04\" y=\"46.6983\" width=\"17.8199\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"139.2564\" y=\"46.6983\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/></g></g></svg>\n", "\n    </div>")
    }, {
      label: "3 Columns: 6/12,3/12,3/12",
      name: "section633",
      type: "view",
      content: "\n    <div class=\"dc-sview sContainer\">\n      ".concat("\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"154.8449\" height=\"93.8966\" viewBox=\"0 0 154.8449 93.8966\"><defs><style>.cls-3{fill:none;}.cls-1{fill:#272940;}.cls-2{fill:#8387a5;}</style></defs><title>3 Columns: 6/12,3/12,3/12</title><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><rect class=\"cls-1\" x=\"0.7045\" y=\"36.1983\" width=\"68.7977\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-2\" x=\"0.494\" y=\"53.4131\" width=\"23.4628\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"26.8465\" y=\"53.4131\" width=\"23.8078\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"53.4147\" y=\"53.4131\" width=\"10.8257\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"0.494\" y=\"46.4483\" width=\"12.6803\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"16.0208\" y=\"46.4483\" width=\"27.517\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"45.6944\" y=\"46.4483\" width=\"23.8078\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-1\" x=\"82.6023\" y=\"36.1983\" width=\"29.3851\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-2\" x=\"82.5124\" y=\"53.4131\" width=\"10.0215\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"93.7682\" y=\"53.4131\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"105.1161\" y=\"53.4131\" width=\"4.6239\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"82.5124\" y=\"46.4483\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"89.1443\" y=\"46.4483\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"101.8186\" y=\"46.4483\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-1\" x=\"124.87\" y=\"36.1983\" width=\"29.3851\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-2\" x=\"124.7801\" y=\"53.4131\" width=\"10.0215\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"136.0359\" y=\"53.4131\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"147.3838\" y=\"53.4131\" width=\"4.6239\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"124.7801\" y=\"46.4483\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"131.412\" y=\"46.4483\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"144.0862\" y=\"46.4483\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/></g></g></svg>\n", "\n    </div>")
    }, {
      label: "3 Columns: 3/12,6/12,3/12",
      name: "section363",
      type: "view",
      content: "\n    <div class=\"dc-sview sContainer\">\n      ".concat("\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"154.8449\" height=\"93.8966\" viewBox=\"0 0 154.8449 93.8966\"><defs><style>.cls-3{fill:none;}.cls-1{fill:#272940;}.cls-2{fill:#8387a5;}</style></defs><title>3 Columns: 3/12,6/12,3/12</title><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><rect class=\"cls-1\" x=\"0.5839\" y=\"36.1983\" width=\"29.3851\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-2\" x=\"0.494\" y=\"53.4131\" width=\"10.0215\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"11.7497\" y=\"53.4131\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"23.0976\" y=\"53.4131\" width=\"4.6239\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"0.494\" y=\"46.4483\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"7.1259\" y=\"46.4483\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"19.8001\" y=\"46.4483\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-1\" x=\"40.2467\" y=\"36.1983\" width=\"71.7408\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-2\" x=\"40.0272\" y=\"53.4131\" width=\"24.4665\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"67.507\" y=\"53.4131\" width=\"24.8263\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"95.2117\" y=\"53.4131\" width=\"11.2888\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"40.0272\" y=\"46.4483\" width=\"13.2227\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"56.2182\" y=\"46.4483\" width=\"28.6941\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"87.1611\" y=\"46.4483\" width=\"24.8263\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-1\" x=\"124.87\" y=\"36.1983\" width=\"29.3851\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-2\" x=\"124.7801\" y=\"53.4131\" width=\"10.0215\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"136.0359\" y=\"53.4131\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"147.3838\" y=\"53.4131\" width=\"4.6239\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"124.7801\" y=\"46.4483\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"131.412\" y=\"46.4483\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"144.0862\" y=\"46.4483\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/></g></g></svg>\n", "\n    </div>")
    }, {
      label: "2 Columns",
      name: "section2columns",
      type: "view",
      content: "\n    <div class=\"dc-sview sContainer sdContainer\">\n      ".concat("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"154.5037\" height=\"93.8966\" viewBox=\"0 0 154.5037 93.8966\"><defs><style>.cls-1{fill:#272940;}.cls-2{fill:#b3b6c6;}.cls-3{fill:#8387a5;}</style></defs><title>2 Columns</title><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><rect class=\"cls-1\" x=\"0.1494\" width=\"70\" height=\"30\" rx=\"5\"/><path class=\"cls-2\" d=\"M45.6516,17.2621V6.69a.7378.7378,0,0,0-.7382-.7382H25.3854a.738.738,0,0,0-.7381.7382v17.359H45.6767v-6.77l-.0251-.0165m-.7382-.5-7.421-5.02-.5442-.3682-.4285.4981L31.825,17.3257,28.8855,14.8l-.4959-.4264-.4828.4412L25.3854,17.118V6.69h19.528Zm-19.528,1.3557,3.019-2.7581,3.4984,3.0064,5.1764-6.0127L44.9386,17.67v5.64H25.3854Z\"/><path class=\"cls-2\" d=\"M30.8013,13.5473a2.643,2.643,0,1,0-2.643-2.643,2.6459,2.6459,0,0,0,2.643,2.643m0-4.5478a1.9046,1.9046,0,1,1-1.9048,1.9048A1.9046,1.9046,0,0,1,30.8013,9Z\"/><rect class=\"cls-1\" x=\"0.0899\" y=\"39.0104\" width=\"70.0595\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-3\" y=\"56.2252\" width=\"23.8508\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"26.7883\" y=\"56.2252\" width=\"24.2015\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"53.7958\" y=\"56.2252\" width=\"11.0047\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" y=\"49.2604\" width=\"12.89\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"15.7836\" y=\"49.2604\" width=\"27.9721\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"45.9479\" y=\"49.2604\" width=\"24.2015\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" y=\"69.8422\" width=\"23.8508\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"26.7883\" y=\"69.8422\" width=\"24.2015\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"53.7958\" y=\"69.8422\" width=\"11.0047\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" y=\"62.8774\" width=\"12.89\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"15.7836\" y=\"62.8774\" width=\"27.9721\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"45.9479\" y=\"62.8774\" width=\"24.2015\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" y=\"83.4592\" width=\"23.8508\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"26.7883\" y=\"83.4592\" width=\"24.2015\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"53.7958\" y=\"83.4592\" width=\"11.0047\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" y=\"76.4944\" width=\"12.89\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"15.7836\" y=\"76.4944\" width=\"27.9721\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"45.9479\" y=\"76.4944\" width=\"24.2015\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" y=\"90.1114\" width=\"12.89\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"15.7836\" y=\"90.1114\" width=\"27.9721\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"45.9479\" y=\"90.1114\" width=\"24.2015\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-1\" x=\"84.5037\" width=\"70\" height=\"30\" rx=\"5\"/><path class=\"cls-2\" d=\"M130.0058,17.2621V6.69a.7377.7377,0,0,0-.7381-.7382H109.74a.738.738,0,0,0-.7381.7382v17.359H130.031v-6.77l-.0252-.0165m-.7381-.5-7.4211-5.02-.5441-.3682-.4286.4981-4.6947,5.4537L113.24,14.8l-.496-.4264-.4827.4412L109.74,17.118V6.69h19.528ZM109.74,18.1181l3.0189-2.7581,3.4985,3.0064,5.1764-6.0127,7.8594,5.3167v5.64H109.74Z\"/><path class=\"cls-2\" d=\"M115.1556,13.5473a2.643,2.643,0,1,0-2.643-2.643,2.6459,2.6459,0,0,0,2.643,2.643m0-4.5478a1.9046,1.9046,0,1,1-1.9049,1.9048A1.9046,1.9046,0,0,1,115.1556,9Z\"/><rect class=\"cls-1\" x=\"84.4442\" y=\"39.0104\" width=\"70.0595\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-3\" x=\"84.3543\" y=\"56.2252\" width=\"23.8508\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"111.1426\" y=\"56.2252\" width=\"24.2015\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"138.1501\" y=\"56.2252\" width=\"11.0047\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"84.3543\" y=\"49.2604\" width=\"12.89\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"100.1379\" y=\"49.2604\" width=\"27.9721\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"130.3021\" y=\"49.2604\" width=\"24.2015\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"84.3543\" y=\"69.8422\" width=\"23.8508\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"111.1426\" y=\"69.8422\" width=\"24.2015\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"138.1501\" y=\"69.8422\" width=\"11.0047\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"84.3543\" y=\"62.8774\" width=\"12.89\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"100.1379\" y=\"62.8774\" width=\"27.9721\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"130.3021\" y=\"62.8774\" width=\"24.2015\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"84.3543\" y=\"83.4592\" width=\"23.8508\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"111.1426\" y=\"83.4592\" width=\"24.2015\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"138.1501\" y=\"83.4592\" width=\"11.0047\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"84.3543\" y=\"76.4944\" width=\"12.89\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"100.1379\" y=\"76.4944\" width=\"27.9721\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"130.3021\" y=\"76.4944\" width=\"24.2015\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"84.3543\" y=\"90.1114\" width=\"12.89\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"100.1379\" y=\"90.1114\" width=\"27.9721\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"130.3021\" y=\"90.1114\" width=\"24.2015\" height=\"3.7852\" rx=\"1.8926\"/></g></g></svg>", "\n    </div>")
    }, {
      label: "3 Columns",
      name: "section3columns",
      type: "view",
      content: "\n    <div class=\"dc-sview sContainer sdContainer\">\n      ".concat("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"154.8143\" height=\"93.8966\" viewBox=\"0 0 154.8143 93.8966\"><defs><style>.cls-1{fill:#272940;}.cls-2{fill:#b3b6c6;}.cls-3{fill:#8387a5;}</style></defs><title>3 Columns</title><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><path class=\"cls-1\" d=\"M40.5,30H4.5C2.0147,30,0,28.6569,0,27V3C0,1.3431,2.0147,0,4.5,0h36C42.9853,0,45,1.3431,45,3V27C45,28.6569,42.9853,30,40.5,30Z\"/><path class=\"cls-2\" d=\"M33.19,17.2621V6.69a.7378.7378,0,0,0-.7382-.7382H12.9237a.738.738,0,0,0-.7381.7382v17.359H33.215v-6.77l-.0251-.0165m-.7382-.5-7.421-5.02-.5442-.3682-.4285.4981-4.6947,5.4537L16.4238,14.8l-.4959-.4264-.4828.4412L12.9237,17.118V6.69h19.528Zm-19.528,1.3557,3.019-2.7581,3.4984,3.0064,5.1764-6.0127L32.4769,17.67v5.64H12.9237Z\"/><path class=\"cls-2\" d=\"M18.34,13.5473a2.643,2.643,0,1,0-2.643-2.643,2.6459,2.6459,0,0,0,2.643,2.643M18.34,9a1.9046,1.9046,0,1,1-1.9048,1.9048A1.9045,1.9045,0,0,1,18.34,9Z\"/><rect class=\"cls-1\" x=\"0.4006\" y=\"39.0104\" width=\"44.5994\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-3\" x=\"0.3107\" y=\"56.2252\" width=\"15.1944\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"17.3764\" y=\"56.2252\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"34.5818\" y=\"56.2252\" width=\"7.0106\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"0.3107\" y=\"49.2604\" width=\"8.2117\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"10.3658\" y=\"49.2604\" width=\"17.8199\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"29.5822\" y=\"49.2604\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"0.3107\" y=\"69.8422\" width=\"15.1944\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"17.3764\" y=\"69.8422\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"34.5818\" y=\"69.8422\" width=\"7.0106\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"0.3107\" y=\"62.8774\" width=\"8.2117\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"10.3658\" y=\"62.8774\" width=\"17.8199\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"29.5822\" y=\"62.8774\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"0.3107\" y=\"83.4592\" width=\"15.1944\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"17.3764\" y=\"83.4592\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"34.5818\" y=\"83.4592\" width=\"7.0106\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"0.3107\" y=\"76.4944\" width=\"8.2117\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"10.3658\" y=\"76.4944\" width=\"17.8199\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"29.5822\" y=\"76.4944\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"0.3107\" y=\"90.1114\" width=\"8.2117\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"10.3658\" y=\"90.1114\" width=\"17.8199\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"29.5822\" y=\"90.1114\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><path class=\"cls-1\" d=\"M150.3143,30h-36c-2.4852,0-4.5-1.3431-4.5-3V3c0-1.6569,2.0148-3,4.5-3h36c2.4853,0,4.5,1.3431,4.5,3V27C154.8143,28.6569,152.8,30,150.3143,30Z\"/><path class=\"cls-2\" d=\"M143.6739,17.2621V6.69a.7378.7378,0,0,0-.7382-.7382h-19.528a.738.738,0,0,0-.7381.7382v17.359H143.699v-6.77l-.0251-.0165m-.7382-.5-7.421-5.02-.5442-.3682-.4285.4981-4.6947,5.4537L126.9078,14.8l-.4959-.4264-.4828.4412-2.5214,2.3032V6.69h19.528Zm-19.528,1.3557,3.019-2.7581,3.4984,3.0064,5.1764-6.0127,7.8594,5.3167v5.64H123.4077Z\"/><path class=\"cls-2\" d=\"M128.8236,13.5473a2.643,2.643,0,1,0-2.643-2.643,2.6459,2.6459,0,0,0,2.643,2.643m0-4.5478a1.9046,1.9046,0,1,1-1.9048,1.9048A1.9045,1.9045,0,0,1,128.8236,9Z\"/><rect class=\"cls-1\" x=\"110.2149\" y=\"39.0104\" width=\"44.5994\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-3\" x=\"110.125\" y=\"56.2252\" width=\"15.1944\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"127.1907\" y=\"56.2252\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"144.3961\" y=\"56.2252\" width=\"7.0106\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"110.125\" y=\"49.2604\" width=\"8.2117\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"120.1801\" y=\"49.2604\" width=\"17.8199\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"139.3965\" y=\"49.2604\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"110.125\" y=\"69.8422\" width=\"15.1944\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"127.1907\" y=\"69.8422\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"144.3961\" y=\"69.8422\" width=\"7.0106\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"110.125\" y=\"62.8774\" width=\"8.2117\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"120.1801\" y=\"62.8774\" width=\"17.8199\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"139.3965\" y=\"62.8774\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"110.125\" y=\"83.4592\" width=\"15.1944\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"127.1907\" y=\"83.4592\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"144.3961\" y=\"83.4592\" width=\"7.0106\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"110.125\" y=\"76.4944\" width=\"8.2117\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"120.1801\" y=\"76.4944\" width=\"17.8199\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"139.3965\" y=\"76.4944\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"110.125\" y=\"90.1114\" width=\"8.2117\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"120.1801\" y=\"90.1114\" width=\"17.8199\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"139.3965\" y=\"90.1114\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><path class=\"cls-1\" d=\"M95.3143,30h-36c-2.4852,0-4.5-1.3431-4.5-3V3c0-1.6569,2.0148-3,4.5-3h36c2.4853,0,4.5,1.3431,4.5,3V27C99.8143,28.6569,97.8,30,95.3143,30Z\"/><path class=\"cls-2\" d=\"M88.0042,17.2621V6.69a.7377.7377,0,0,0-.7382-.7382H67.7381A.7381.7381,0,0,0,67,6.69v17.359H88.0293v-6.77l-.0251-.0165m-.7382-.5-7.421-5.02-.5442-.3682-.4285.4981-4.6947,5.4537L71.2381,14.8l-.4959-.4264-.4828.4412L67.7381,17.118V6.69H87.266ZM67.7381,18.1181,70.757,15.36l3.4984,3.0064,5.1764-6.0127,7.86,5.3167v5.64H67.7381Z\"/><path class=\"cls-2\" d=\"M73.1539,13.5473a2.643,2.643,0,1,0-2.643-2.643,2.6459,2.6459,0,0,0,2.643,2.643m0-4.5478a1.9046,1.9046,0,1,1-1.9048,1.9048A1.9046,1.9046,0,0,1,73.1539,9Z\"/><rect class=\"cls-1\" x=\"55.2149\" y=\"39.0104\" width=\"44.5994\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-3\" x=\"55.125\" y=\"56.2252\" width=\"15.1944\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"72.1907\" y=\"56.2252\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"89.3961\" y=\"56.2252\" width=\"7.0106\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"55.125\" y=\"49.2604\" width=\"8.2117\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"65.1801\" y=\"49.2604\" width=\"17.8199\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"84.3965\" y=\"49.2604\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"55.125\" y=\"69.8422\" width=\"15.1944\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"72.1907\" y=\"69.8422\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"89.3961\" y=\"69.8422\" width=\"7.0106\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"55.125\" y=\"62.8774\" width=\"8.2117\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"65.1801\" y=\"62.8774\" width=\"17.8199\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"84.3965\" y=\"62.8774\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"55.125\" y=\"83.4592\" width=\"15.1944\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"72.1907\" y=\"83.4592\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"89.3961\" y=\"83.4592\" width=\"7.0106\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"55.125\" y=\"76.4944\" width=\"8.2117\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"65.1801\" y=\"76.4944\" width=\"17.8199\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"84.3965\" y=\"76.4944\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"55.125\" y=\"90.1114\" width=\"8.2117\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"65.1801\" y=\"90.1114\" width=\"17.8199\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"84.3965\" y=\"90.1114\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/></g></g></svg>", "\n    </div>")
    }, {
      label: "4 Columns",
      name: "section4columns",
      type: "view",
      content: "\n    <div class=\"dc-sview sContainer sdContainer\">\n      ".concat("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"154.2861\" height=\"93.8966\" viewBox=\"0 0 154.2861 93.8966\"><defs><style>.cls-1{fill:#272940;}.cls-2{fill:#b3b6c6;}.cls-3{fill:#8387a5;}</style></defs><title>4 Columns</title><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><rect class=\"cls-1\" width=\"30\" height=\"30\" rx=\"3\"/><path class=\"cls-2\" d=\"M25.49,17.2621V6.69a.7378.7378,0,0,0-.7382-.7382H5.2235a.7381.7381,0,0,0-.7382.7382v17.359H25.5147v-6.77l-.0251-.0165m-.7382-.5-7.421-5.02-.5442-.3682-.4285.4981L11.663,17.3257,8.7235,14.8l-.4959-.4264-.4828.4412L5.2235,17.118V6.69H24.7514ZM5.2235,18.1181,8.2424,15.36l3.4984,3.0064,5.1764-6.0127L24.7766,17.67v5.64H5.2235Z\"/><path class=\"cls-2\" d=\"M10.6393,13.5473a2.643,2.643,0,1,0-2.643-2.643,2.6459,2.6459,0,0,0,2.643,2.643m0-4.5478a1.9046,1.9046,0,1,1-1.9048,1.9048A1.9046,1.9046,0,0,1,10.6393,9Z\"/><rect class=\"cls-1\" x=\"0.0899\" y=\"39.0104\" width=\"29.3851\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-3\" y=\"56.2252\" width=\"10.0215\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"11.2558\" y=\"56.2252\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"22.6036\" y=\"56.2252\" width=\"4.6239\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" y=\"49.2604\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"6.6319\" y=\"49.2604\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"19.3061\" y=\"49.2604\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" y=\"69.8422\" width=\"10.0215\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"11.2558\" y=\"69.8422\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"22.6036\" y=\"69.8422\" width=\"4.6239\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" y=\"62.8774\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"6.6319\" y=\"62.8774\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"19.3061\" y=\"62.8774\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" y=\"83.4592\" width=\"10.0215\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"11.2558\" y=\"83.4592\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"22.6036\" y=\"83.4592\" width=\"4.6239\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" y=\"76.4944\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"6.6319\" y=\"76.4944\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"19.3061\" y=\"76.4944\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" y=\"90.1114\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"6.6319\" y=\"90.1114\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"19.3061\" y=\"90.1114\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-1\" x=\"39.5332\" width=\"30\" height=\"30\" rx=\"3\"/><path class=\"cls-2\" d=\"M65.0228,17.2621V6.69a.7378.7378,0,0,0-.7382-.7382H44.7567a.7381.7381,0,0,0-.7382.7382v17.359H65.0479v-6.77l-.0251-.0165m-.7382-.5-7.421-5.02-.5442-.3682-.4285.4981-4.6947,5.4537L48.2567,14.8l-.4959-.4264-.4828.4412L44.7567,17.118V6.69H64.2846ZM44.7567,18.1181,47.7756,15.36l3.4984,3.0064L56.45,12.3537,64.31,17.67v5.64H44.7567Z\"/><path class=\"cls-2\" d=\"M50.1725,13.5473a2.643,2.643,0,1,0-2.643-2.643,2.6459,2.6459,0,0,0,2.643,2.643m0-4.5478a1.9046,1.9046,0,1,1-1.9048,1.9048A1.9046,1.9046,0,0,1,50.1725,9Z\"/><rect class=\"cls-1\" x=\"39.6231\" y=\"39.0104\" width=\"29.3851\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-3\" x=\"39.5332\" y=\"56.2252\" width=\"10.0215\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"50.789\" y=\"56.2252\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"62.1368\" y=\"56.2252\" width=\"4.6239\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"39.5332\" y=\"49.2604\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"46.1651\" y=\"49.2604\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"58.8393\" y=\"49.2604\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"39.5332\" y=\"69.8422\" width=\"10.0215\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"50.789\" y=\"69.8422\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"62.1368\" y=\"69.8422\" width=\"4.6239\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"39.5332\" y=\"62.8774\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"46.1651\" y=\"62.8774\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"58.8393\" y=\"62.8774\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"39.5332\" y=\"83.4592\" width=\"10.0215\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"50.789\" y=\"83.4592\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"62.1368\" y=\"83.4592\" width=\"4.6239\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"39.5332\" y=\"76.4944\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"46.1651\" y=\"76.4944\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"58.8393\" y=\"76.4944\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"39.5332\" y=\"90.1114\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"46.1651\" y=\"90.1114\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"58.8393\" y=\"90.1114\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-1\" x=\"82.0184\" width=\"30\" height=\"30\" rx=\"3\"/><path class=\"cls-2\" d=\"M107.508,17.2621V6.69a.7377.7377,0,0,0-.7382-.7382H87.2419a.7381.7381,0,0,0-.7382.7382v17.359h21.0294v-6.77l-.0251-.0165m-.7382-.5-7.421-5.02-.5441-.3682-.4286.4981-4.6947,5.4537L90.742,14.8l-.496-.4264-.4828.4412L87.2419,17.118V6.69H106.77ZM87.2419,18.1181,90.2608,15.36l3.4985,3.0064,5.1763-6.0127,7.86,5.3167v5.64H87.2419Z\"/><path class=\"cls-2\" d=\"M92.6578,13.5473a2.643,2.643,0,1,0-2.643-2.643,2.646,2.646,0,0,0,2.643,2.643m0-4.5478a1.9046,1.9046,0,1,1-1.9049,1.9048A1.9046,1.9046,0,0,1,92.6578,9Z\"/><rect class=\"cls-1\" x=\"82.1083\" y=\"39.0104\" width=\"29.3851\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-3\" x=\"82.0184\" y=\"56.2252\" width=\"10.0215\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"93.2742\" y=\"56.2252\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"104.6221\" y=\"56.2252\" width=\"4.6239\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"82.0184\" y=\"49.2604\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"88.6503\" y=\"49.2604\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"101.3246\" y=\"49.2604\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"82.0184\" y=\"69.8422\" width=\"10.0215\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"93.2742\" y=\"69.8422\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"104.6221\" y=\"69.8422\" width=\"4.6239\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"82.0184\" y=\"62.8774\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"88.6503\" y=\"62.8774\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"101.3246\" y=\"62.8774\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"82.0184\" y=\"83.4592\" width=\"10.0215\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"93.2742\" y=\"83.4592\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"104.6221\" y=\"83.4592\" width=\"4.6239\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"82.0184\" y=\"76.4944\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"88.6503\" y=\"76.4944\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"101.3246\" y=\"76.4944\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"82.0184\" y=\"90.1114\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"88.6503\" y=\"90.1114\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"101.3246\" y=\"90.1114\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-1\" x=\"124.2861\" width=\"30\" height=\"30\" rx=\"3\"/><path class=\"cls-2\" d=\"M149.7757,17.2621V6.69a.7377.7377,0,0,0-.7382-.7382H129.51a.7381.7381,0,0,0-.7382.7382v17.359h21.0294v-6.77l-.0251-.0165m-.7382-.5-7.421-5.02-.5441-.3682-.4286.4981-4.6947,5.4537L133.01,14.8l-.4959-.4264-.4828.4412L129.51,17.118V6.69h19.5279ZM129.51,18.1181l3.0189-2.7581,3.4984,3.0064,5.1764-6.0127,7.8595,5.3167v5.64H129.51Z\"/><path class=\"cls-2\" d=\"M134.9255,13.5473a2.643,2.643,0,1,0-2.6431-2.643,2.6459,2.6459,0,0,0,2.6431,2.643m0-4.5478a1.9046,1.9046,0,1,1-1.9049,1.9048A1.9046,1.9046,0,0,1,134.9255,9Z\"/><rect class=\"cls-1\" x=\"124.376\" y=\"39.0104\" width=\"29.3851\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-3\" x=\"124.2861\" y=\"56.2252\" width=\"10.0215\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"135.5419\" y=\"56.2252\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"146.8898\" y=\"56.2252\" width=\"4.6239\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"124.2861\" y=\"49.2604\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"130.918\" y=\"49.2604\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"143.5923\" y=\"49.2604\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"124.2861\" y=\"69.8422\" width=\"10.0215\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"135.5419\" y=\"69.8422\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"146.8898\" y=\"69.8422\" width=\"4.6239\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"124.2861\" y=\"62.8774\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"130.918\" y=\"62.8774\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"143.5923\" y=\"62.8774\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"124.2861\" y=\"83.4592\" width=\"10.0215\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"135.5419\" y=\"83.4592\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"146.8898\" y=\"83.4592\" width=\"4.6239\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"124.2861\" y=\"76.4944\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"130.918\" y=\"76.4944\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"143.5923\" y=\"76.4944\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"124.2861\" y=\"90.1114\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"130.918\" y=\"90.1114\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"143.5923\" y=\"90.1114\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/></g></g></svg>", "\n    </div>")
    }, {
      label: "2 Columns Header Banner",
      name: "section2columnsHB",
      type: "view",
      content: "\n    <div class=\"dc-sview sContainer sdContainer\">\n      ".concat("\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"154.5037\" height=\"93.8966\" viewBox=\"0 0 154.5037 93.8966\"><defs><style>.cls-1{fill:#272940;}.cls-2{fill:#b3b6c6;}.cls-3{fill:#8387a5;}</style></defs><title>2 Columns Header Banner</title><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><rect class=\"cls-1\" x=\"0.1494\" width=\"154.3543\" height=\"30\" rx=\"5\"/><path class=\"cls-2\" d=\"M87.8161,17.2621V6.69a.7377.7377,0,0,0-.7382-.7382H67.55a.7381.7381,0,0,0-.7382.7382v17.359H87.8412v-6.77l-.0251-.0165m-.7382-.5-7.421-5.02-.5441-.3682-.4286.4981L73.99,17.3257,71.05,14.8l-.496-.4264-.4828.4412L67.55,17.118V6.69H87.0779ZM67.55,18.1181,70.5689,15.36l3.4985,3.0064,5.1763-6.0127L87.1032,17.67v5.64H67.55Z\"/><path class=\"cls-2\" d=\"M72.9659,13.5473a2.643,2.643,0,1,0-2.643-2.643,2.646,2.646,0,0,0,2.643,2.643m0-4.5478a1.9046,1.9046,0,1,1-1.9049,1.9048A1.9046,1.9046,0,0,1,72.9659,9Z\"/><rect class=\"cls-1\" x=\"0.0899\" y=\"39.0104\" width=\"70.0595\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-3\" y=\"56.2252\" width=\"23.8508\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"26.7883\" y=\"56.2252\" width=\"24.2015\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"53.7958\" y=\"56.2252\" width=\"11.0047\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" y=\"49.2604\" width=\"12.89\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"15.7836\" y=\"49.2604\" width=\"27.9721\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"45.9479\" y=\"49.2604\" width=\"24.2015\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" y=\"69.8422\" width=\"23.8508\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"26.7883\" y=\"69.8422\" width=\"24.2015\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"53.7958\" y=\"69.8422\" width=\"11.0047\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" y=\"62.8774\" width=\"12.89\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"15.7836\" y=\"62.8774\" width=\"27.9721\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"45.9479\" y=\"62.8774\" width=\"24.2015\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" y=\"83.4592\" width=\"23.8508\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"26.7883\" y=\"83.4592\" width=\"24.2015\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"53.7958\" y=\"83.4592\" width=\"11.0047\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" y=\"76.4944\" width=\"12.89\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"15.7836\" y=\"76.4944\" width=\"27.9721\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"45.9479\" y=\"76.4944\" width=\"24.2015\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" y=\"90.1114\" width=\"12.89\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"15.7836\" y=\"90.1114\" width=\"27.9721\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"45.9479\" y=\"90.1114\" width=\"24.2015\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-1\" x=\"84.4442\" y=\"39.0104\" width=\"70.0595\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-3\" x=\"84.3543\" y=\"56.2252\" width=\"23.8508\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"111.1426\" y=\"56.2252\" width=\"24.2015\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"138.1501\" y=\"56.2252\" width=\"11.0047\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"84.3543\" y=\"49.2604\" width=\"12.89\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"100.1379\" y=\"49.2604\" width=\"27.9721\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"130.3021\" y=\"49.2604\" width=\"24.2015\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"84.3543\" y=\"69.8422\" width=\"23.8508\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"111.1426\" y=\"69.8422\" width=\"24.2015\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"138.1501\" y=\"69.8422\" width=\"11.0047\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"84.3543\" y=\"62.8774\" width=\"12.89\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"100.1379\" y=\"62.8774\" width=\"27.9721\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"130.3021\" y=\"62.8774\" width=\"24.2015\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"84.3543\" y=\"83.4592\" width=\"23.8508\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"111.1426\" y=\"83.4592\" width=\"24.2015\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"138.1501\" y=\"83.4592\" width=\"11.0047\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"84.3543\" y=\"76.4944\" width=\"12.89\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"100.1379\" y=\"76.4944\" width=\"27.9721\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"130.3021\" y=\"76.4944\" width=\"24.2015\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"84.3543\" y=\"90.1114\" width=\"12.89\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"100.1379\" y=\"90.1114\" width=\"27.9721\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"130.3021\" y=\"90.1114\" width=\"24.2015\" height=\"3.7852\" rx=\"1.8926\"/></g></g></svg>\n", "\n    </div>")
    }, {
      label: "3 Columns Header Banner",
      name: "section3columnsHB",
      type: "view",
      content: "\n    <div class=\"dc-sview sContainer sdContainer\">\n      ".concat("\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"154.5037\" height=\"93.157\" viewBox=\"0 0 154.5037 93.157\"><defs><style>.cls-1{fill:#272940;}.cls-2{fill:#8387a5;}.cls-3{fill:#b3b6c6;}</style></defs><title>3 Columns Header Banner</title><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><rect class=\"cls-1\" x=\"0.0899\" y=\"38.2707\" width=\"44.5994\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-2\" y=\"55.4855\" width=\"15.1944\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"17.0657\" y=\"55.4855\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"34.2711\" y=\"55.4855\" width=\"7.0106\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" y=\"48.5207\" width=\"8.2117\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"10.0551\" y=\"48.5207\" width=\"17.8199\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"29.2715\" y=\"48.5207\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" y=\"69.1026\" width=\"15.1944\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"17.0657\" y=\"69.1026\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"34.2711\" y=\"69.1026\" width=\"7.0106\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" y=\"62.1378\" width=\"8.2117\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"10.0551\" y=\"62.1378\" width=\"17.8199\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"29.2715\" y=\"62.1378\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" y=\"82.7196\" width=\"15.1944\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"17.0657\" y=\"82.7196\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"34.2711\" y=\"82.7196\" width=\"7.0106\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" y=\"75.7548\" width=\"8.2117\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"10.0551\" y=\"75.7548\" width=\"17.8199\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"29.2715\" y=\"75.7548\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" y=\"89.3718\" width=\"8.2117\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"10.0551\" y=\"89.3718\" width=\"17.8199\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"29.2715\" y=\"89.3718\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-1\" x=\"109.9042\" y=\"38.2707\" width=\"44.5994\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-2\" x=\"109.8143\" y=\"55.4855\" width=\"15.1944\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"126.8801\" y=\"55.4855\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"144.0855\" y=\"55.4855\" width=\"7.0106\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"109.8143\" y=\"48.5207\" width=\"8.2117\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"119.8694\" y=\"48.5207\" width=\"17.8199\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"139.0859\" y=\"48.5207\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"109.8143\" y=\"69.1026\" width=\"15.1944\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"126.8801\" y=\"69.1026\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"144.0855\" y=\"69.1026\" width=\"7.0106\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"109.8143\" y=\"62.1378\" width=\"8.2117\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"119.8694\" y=\"62.1378\" width=\"17.8199\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"139.0859\" y=\"62.1378\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"109.8143\" y=\"82.7196\" width=\"15.1944\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"126.8801\" y=\"82.7196\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"144.0855\" y=\"82.7196\" width=\"7.0106\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"109.8143\" y=\"75.7548\" width=\"8.2117\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"119.8694\" y=\"75.7548\" width=\"17.8199\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"139.0859\" y=\"75.7548\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"109.8143\" y=\"89.3718\" width=\"8.2117\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"119.8694\" y=\"89.3718\" width=\"17.8199\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"139.0859\" y=\"89.3718\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-1\" x=\"54.9042\" y=\"38.2707\" width=\"44.5994\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-2\" x=\"54.8143\" y=\"55.4855\" width=\"15.1944\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"71.8801\" y=\"55.4855\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"89.0855\" y=\"55.4855\" width=\"7.0106\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"54.8143\" y=\"48.5207\" width=\"8.2117\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"64.8694\" y=\"48.5207\" width=\"17.8199\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"84.0859\" y=\"48.5207\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"54.8143\" y=\"69.1026\" width=\"15.1944\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"71.8801\" y=\"69.1026\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"89.0855\" y=\"69.1026\" width=\"7.0106\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"54.8143\" y=\"62.1378\" width=\"8.2117\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"64.8694\" y=\"62.1378\" width=\"17.8199\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"84.0859\" y=\"62.1378\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"54.8143\" y=\"82.7196\" width=\"15.1944\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"71.8801\" y=\"82.7196\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"89.0855\" y=\"82.7196\" width=\"7.0106\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"54.8143\" y=\"75.7548\" width=\"8.2117\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"64.8694\" y=\"75.7548\" width=\"17.8199\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"84.0859\" y=\"75.7548\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"54.8143\" y=\"89.3718\" width=\"8.2117\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"64.8694\" y=\"89.3718\" width=\"17.8199\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-2\" x=\"84.0859\" y=\"89.3718\" width=\"15.4178\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-1\" x=\"0.0269\" width=\"154.3543\" height=\"30\" rx=\"5\"/><path class=\"cls-3\" d=\"M87.6936,17.2621V6.69a.7378.7378,0,0,0-.7382-.7382H67.4275a.7381.7381,0,0,0-.7382.7382v17.359H87.7187v-6.77l-.0251-.0165m-.7382-.5-7.421-5.02-.5442-.3682-.4285.4981L73.867,17.3257,70.9275,14.8l-.4959-.4264-.4828.4412L67.4275,17.118V6.69H86.9554ZM67.4275,18.1181,70.4464,15.36l3.4984,3.0064,5.1764-6.0127L86.9807,17.67v5.64H67.4275Z\"/><path class=\"cls-3\" d=\"M72.8433,13.5473a2.643,2.643,0,1,0-2.643-2.643,2.6459,2.6459,0,0,0,2.643,2.643m0-4.5478a1.9046,1.9046,0,1,1-1.9048,1.9048A1.9046,1.9046,0,0,1,72.8433,9Z\"/></g></g></svg>\n", "\n    </div>")
    }, {
      label: "4 Columns Header Banner",
      name: "section4columnsHB",
      type: "view",
      content: "\n    <div class=\"dc-sview sContainer sdContainer\">\n      ".concat("\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"154.3543\" height=\"92.8944\" viewBox=\"0 0 154.3543 92.8944\"><defs><style>.cls-1{fill:#272940;}.cls-2{fill:#b3b6c6;}.cls-3{fill:#8387a5;}</style></defs><title>4 Columns Header Banner</title><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><rect class=\"cls-1\" width=\"154.3543\" height=\"30\" rx=\"5\"/><path class=\"cls-2\" d=\"M87.6667,17.2621V6.69a.7377.7377,0,0,0-.7382-.7382H67.4006a.7381.7381,0,0,0-.7382.7382v17.359H87.6918v-6.77l-.0251-.0165m-.7382-.5-7.421-5.02-.5441-.3682-.4286.4981L73.84,17.3257,70.9007,14.8l-.496-.4264-.4828.4412L67.4006,17.118V6.69H86.9285ZM67.4006,18.1181,70.42,15.36l3.4984,3.0064,5.1764-6.0127L86.9538,17.67v5.64H67.4006Z\"/><path class=\"cls-2\" d=\"M72.8165,13.5473a2.643,2.643,0,1,0-2.643-2.643,2.646,2.646,0,0,0,2.643,2.643m0-4.5478a1.9046,1.9046,0,1,1-1.9049,1.9048A1.9046,1.9046,0,0,1,72.8165,9Z\"/><rect class=\"cls-1\" x=\"0.2634\" y=\"38.0081\" width=\"29.3851\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-3\" x=\"0.1735\" y=\"55.2229\" width=\"10.0215\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"11.4292\" y=\"55.2229\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"22.7771\" y=\"55.2229\" width=\"4.6239\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"0.1735\" y=\"48.2581\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"6.8053\" y=\"48.2581\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"19.4796\" y=\"48.2581\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"0.1735\" y=\"68.8399\" width=\"10.0215\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"11.4292\" y=\"68.8399\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"22.7771\" y=\"68.8399\" width=\"4.6239\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"0.1735\" y=\"61.8751\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"6.8053\" y=\"61.8751\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"19.4796\" y=\"61.8751\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"0.1735\" y=\"82.4569\" width=\"10.0215\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"11.4292\" y=\"82.4569\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"22.7771\" y=\"82.4569\" width=\"4.6239\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"0.1735\" y=\"75.4921\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"6.8053\" y=\"75.4921\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"19.4796\" y=\"75.4921\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"0.1735\" y=\"89.1091\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"6.8053\" y=\"89.1091\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"19.4796\" y=\"89.1091\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-1\" x=\"39.7966\" y=\"38.0081\" width=\"29.3851\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-3\" x=\"39.7067\" y=\"55.2229\" width=\"10.0215\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"50.9624\" y=\"55.2229\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"62.3103\" y=\"55.2229\" width=\"4.6239\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"39.7067\" y=\"48.2581\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"46.3385\" y=\"48.2581\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"59.0128\" y=\"48.2581\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"39.7067\" y=\"68.8399\" width=\"10.0215\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"50.9624\" y=\"68.8399\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"62.3103\" y=\"68.8399\" width=\"4.6239\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"39.7067\" y=\"61.8751\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"46.3385\" y=\"61.8751\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"59.0128\" y=\"61.8751\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"39.7067\" y=\"82.4569\" width=\"10.0215\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"50.9624\" y=\"82.4569\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"62.3103\" y=\"82.4569\" width=\"4.6239\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"39.7067\" y=\"75.4921\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"46.3385\" y=\"75.4921\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"59.0128\" y=\"75.4921\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"39.7067\" y=\"89.1091\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"46.3385\" y=\"89.1091\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"59.0128\" y=\"89.1091\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-1\" x=\"82.2818\" y=\"38.0081\" width=\"29.3851\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-3\" x=\"82.1919\" y=\"55.2229\" width=\"10.0215\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"93.4477\" y=\"55.2229\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"104.7955\" y=\"55.2229\" width=\"4.6239\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"82.1919\" y=\"48.2581\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"88.8238\" y=\"48.2581\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"101.498\" y=\"48.2581\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"82.1919\" y=\"68.8399\" width=\"10.0215\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"93.4477\" y=\"68.8399\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"104.7955\" y=\"68.8399\" width=\"4.6239\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"82.1919\" y=\"61.8751\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"88.8238\" y=\"61.8751\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"101.498\" y=\"61.8751\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"82.1919\" y=\"82.4569\" width=\"10.0215\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"93.4477\" y=\"82.4569\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"104.7955\" y=\"82.4569\" width=\"4.6239\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"82.1919\" y=\"75.4921\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"88.8238\" y=\"75.4921\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"101.498\" y=\"75.4921\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"82.1919\" y=\"89.1091\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"88.8238\" y=\"89.1091\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"101.498\" y=\"89.1091\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-1\" x=\"124.5495\" y=\"38.0081\" width=\"29.3851\" height=\"5.5\" rx=\"2.75\"/><rect class=\"cls-3\" x=\"124.4596\" y=\"55.2229\" width=\"10.0215\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"135.7154\" y=\"55.2229\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"147.0632\" y=\"55.2229\" width=\"4.6239\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"124.4596\" y=\"48.2581\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"131.0915\" y=\"48.2581\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"143.7657\" y=\"48.2581\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"124.4596\" y=\"68.8399\" width=\"10.0215\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"135.7154\" y=\"68.8399\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"147.0632\" y=\"68.8399\" width=\"4.6239\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"124.4596\" y=\"61.8751\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"131.0915\" y=\"61.8751\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"143.7657\" y=\"61.8751\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"124.4596\" y=\"82.4569\" width=\"10.0215\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"135.7154\" y=\"82.4569\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"147.0632\" y=\"82.4569\" width=\"4.6239\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"124.4596\" y=\"75.4921\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"131.0915\" y=\"75.4921\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"143.7657\" y=\"75.4921\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"124.4596\" y=\"89.1091\" width=\"5.416\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"131.0915\" y=\"89.1091\" width=\"11.7532\" height=\"3.7852\" rx=\"1.8926\"/><rect class=\"cls-3\" x=\"143.7657\" y=\"89.1091\" width=\"10.1689\" height=\"3.7852\" rx=\"1.8926\"/></g></g></svg>\n", "\n    </div>")
    }, {
      label: "List: 2 Columns 3 Rows",
      name: "section2columns3RowsList",
      type: "view",
      content: "\n    <div class=\"dc-sview sContainer sdContainer\">\n      ".concat("\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"154.6615\" height=\"93.7198\" viewBox=\"0 0 154.6615 93.7198\"><defs><style>.cls-1{fill:#272940;}.cls-2{fill:#8387a5;}.cls-3{fill:#b3b6c6;}</style></defs><title>List: 2 Columns 3 Rows</title><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><rect class=\"cls-1\" x=\"27.6269\" y=\"0.5213\" width=\"39.5668\" height=\"4.8794\" rx=\"2.4397\"/><rect class=\"cls-2\" x=\"27.5471\" y=\"15.7936\" width=\"13.4798\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"42.6871\" y=\"15.7936\" width=\"13.678\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"57.951\" y=\"15.7936\" width=\"6.2195\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"27.5471\" y=\"9.6147\" width=\"7.285\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"36.4676\" y=\"9.6147\" width=\"15.809\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"53.5156\" y=\"9.6147\" width=\"13.678\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-1\" width=\"24.5755\" height=\"24.5755\" rx=\"5\"/><path class=\"cls-3\" d=\"M20.8806,14.1408V5.48a.6044.6044,0,0,0-.6047-.6047H4.279a.6047.6047,0,0,0-.6047.6047V19.7H20.9012V14.1543l-.0206-.0135m-.6047-.4094L14.1968,9.619l-.4458-.3017L13.4,9.7254,9.5541,14.1929l-2.4079-2.069L6.74,11.7746l-.3955.3614L4.279,14.0228V5.48H20.2759ZM4.279,14.842l2.473-2.2593,2.8659,2.4627,4.24-4.9255,6.4383,4.3554v4.62H4.279Z\"/><path class=\"cls-3\" d=\"M8.7155,11.0977A2.1651,2.1651,0,1,0,6.55,8.9326a2.1675,2.1675,0,0,0,2.1651,2.1651m0-3.7255a1.56,1.56,0,1,1-1.56,1.56A1.56,1.56,0,0,1,8.7155,7.3722Z\"/><rect class=\"cls-1\" x=\"115.0947\" y=\"0.5213\" width=\"39.5668\" height=\"4.8794\" rx=\"2.4397\"/><rect class=\"cls-2\" x=\"115.015\" y=\"15.7936\" width=\"13.4798\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"130.155\" y=\"15.7936\" width=\"13.678\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"145.4189\" y=\"15.7936\" width=\"6.2195\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"115.015\" y=\"9.6147\" width=\"7.285\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"123.9354\" y=\"9.6147\" width=\"15.809\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"140.9834\" y=\"9.6147\" width=\"13.678\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-1\" x=\"87.4679\" width=\"24.5755\" height=\"24.5755\" rx=\"5\"/><path class=\"cls-3\" d=\"M108.3485,14.1408V5.48a.6044.6044,0,0,0-.6047-.6047H91.7468a.6047.6047,0,0,0-.6047.6047V19.7h17.227V14.1543l-.0206-.0135m-.6047-.4094L101.6646,9.619l-.4458-.3017-.351.4081L97.022,14.1929l-2.408-2.069-.4063-.3493-.3954.3614-2.0655,1.8868V5.48h15.997ZM91.7468,14.842,94.22,12.5827l2.8658,2.4627,4.24-4.9255,6.4384,4.3554v4.62H91.7468Z\"/><path class=\"cls-3\" d=\"M96.1834,11.0977a2.1651,2.1651,0,1,0-2.1651-2.1651,2.1675,2.1675,0,0,0,2.1651,2.1651m0-3.7255a1.56,1.56,0,1,1-1.56,1.56A1.56,1.56,0,0,1,96.1834,7.3722Z\"/><rect class=\"cls-1\" x=\"27.6269\" y=\"69.6656\" width=\"39.5668\" height=\"4.8794\" rx=\"2.4397\"/><rect class=\"cls-2\" x=\"27.5471\" y=\"84.9379\" width=\"13.4798\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"42.6871\" y=\"84.9379\" width=\"13.678\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"57.951\" y=\"84.9379\" width=\"6.2195\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"27.5471\" y=\"78.759\" width=\"7.285\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"36.4676\" y=\"78.759\" width=\"15.809\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"53.5156\" y=\"78.759\" width=\"13.678\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-1\" y=\"69.1443\" width=\"24.5755\" height=\"24.5755\" rx=\"5\"/><path class=\"cls-3\" d=\"M20.8806,83.2851V74.6243a.6044.6044,0,0,0-.6047-.6047H4.279a.6047.6047,0,0,0-.6047.6047v14.22H20.9012V83.2986l-.0206-.0135m-.6047-.4094-6.0791-4.1124-.4458-.3017L13.4,78.87,9.5541,83.3372l-2.4079-2.069L6.74,80.9189l-.3955.3614L4.279,83.1671V74.6243H20.2759ZM4.279,83.9863,6.752,81.727,9.6179,84.19l4.24-4.9255L20.2966,83.62v4.62H4.279Z\"/><path class=\"cls-3\" d=\"M8.7155,80.242A2.1651,2.1651,0,1,0,6.55,78.0769,2.1675,2.1675,0,0,0,8.7155,80.242m0-3.7255a1.56,1.56,0,1,1-1.56,1.56A1.56,1.56,0,0,1,8.7155,76.5165Z\"/><rect class=\"cls-1\" x=\"115.0947\" y=\"69.6656\" width=\"39.5668\" height=\"4.8794\" rx=\"2.4397\"/><rect class=\"cls-2\" x=\"115.015\" y=\"84.9379\" width=\"13.4798\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"130.155\" y=\"84.9379\" width=\"13.678\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"145.4189\" y=\"84.9379\" width=\"6.2195\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"115.015\" y=\"78.759\" width=\"7.285\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"123.9354\" y=\"78.759\" width=\"15.809\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"140.9834\" y=\"78.759\" width=\"13.678\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-1\" x=\"87.4679\" y=\"69.1443\" width=\"24.5755\" height=\"24.5755\" rx=\"5\"/><path class=\"cls-3\" d=\"M108.3485,83.2851V74.6243a.6044.6044,0,0,0-.6047-.6047H91.7468a.6047.6047,0,0,0-.6047.6047v14.22h17.227V83.2986l-.0206-.0135m-.6047-.4094-6.0792-4.1124-.4458-.3017-.351.408L97.022,83.3372l-2.408-2.069-.4063-.3493-.3954.3614-2.0655,1.8868V74.6243h15.997Zm-15.997,1.1106L94.22,81.727,97.0857,84.19l4.24-4.9255,6.4384,4.3554v4.62H91.7468Z\"/><path class=\"cls-3\" d=\"M96.1834,80.242a2.1651,2.1651,0,1,0-2.1651-2.1651,2.1675,2.1675,0,0,0,2.1651,2.1651m0-3.7255a1.56,1.56,0,1,1-1.56,1.56A1.56,1.56,0,0,1,96.1834,76.5165Z\"/><rect class=\"cls-1\" x=\"27.6269\" y=\"35.0935\" width=\"39.5668\" height=\"4.8794\" rx=\"2.4397\"/><rect class=\"cls-2\" x=\"27.5471\" y=\"50.3657\" width=\"13.4798\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"42.6871\" y=\"50.3657\" width=\"13.678\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"57.951\" y=\"50.3657\" width=\"6.2195\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"27.5471\" y=\"44.1868\" width=\"7.285\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"36.4676\" y=\"44.1868\" width=\"15.809\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"53.5156\" y=\"44.1868\" width=\"13.678\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-1\" y=\"34.5721\" width=\"24.5755\" height=\"24.5755\" rx=\"5\"/><path class=\"cls-3\" d=\"M20.8806,48.713V40.0522a.6043.6043,0,0,0-.6047-.6047H4.279a.6046.6046,0,0,0-.6047.6047v14.22H20.9012V48.7265l-.0206-.0135m-.6047-.4094-6.0791-4.1125-.4458-.3017-.3511.4081L9.5541,48.7651,7.1462,46.696,6.74,46.3468l-.3955.3614L4.279,48.5949V40.0522H20.2759ZM4.279,49.4142l2.473-2.2594,2.8659,2.4627,4.24-4.9254,6.4383,4.3553v4.62H4.279Z\"/><path class=\"cls-3\" d=\"M8.7155,45.67A2.1651,2.1651,0,1,0,6.55,43.5047,2.1675,2.1675,0,0,0,8.7155,45.67m0-3.7254a1.56,1.56,0,1,1-1.56,1.56A1.56,1.56,0,0,1,8.7155,41.9444Z\"/><rect class=\"cls-1\" x=\"115.0947\" y=\"35.0935\" width=\"39.5668\" height=\"4.8794\" rx=\"2.4397\"/><rect class=\"cls-2\" x=\"115.015\" y=\"50.3657\" width=\"13.4798\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"130.155\" y=\"50.3657\" width=\"13.678\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"145.4189\" y=\"50.3657\" width=\"6.2195\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"115.015\" y=\"44.1868\" width=\"7.285\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"123.9354\" y=\"44.1868\" width=\"15.809\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"140.9834\" y=\"44.1868\" width=\"13.678\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-1\" x=\"87.4679\" y=\"34.5721\" width=\"24.5755\" height=\"24.5755\" rx=\"5\"/><path class=\"cls-3\" d=\"M108.3485,48.713V40.0522a.6043.6043,0,0,0-.6047-.6047H91.7468a.6046.6046,0,0,0-.6047.6047v14.22h17.227V48.7265l-.0206-.0135m-.6047-.4094-6.0792-4.1125-.4458-.3017-.351.4081L97.022,48.7651,94.614,46.696l-.4063-.3492-.3954.3614-2.0655,1.8867V40.0522h15.997Zm-15.997,1.1106L94.22,47.1548l2.8658,2.4627,4.24-4.9254,6.4384,4.3553v4.62H91.7468Z\"/><path class=\"cls-3\" d=\"M96.1834,45.67a2.1651,2.1651,0,1,0-2.1651-2.1651A2.1675,2.1675,0,0,0,96.1834,45.67m0-3.7254a1.56,1.56,0,1,1-1.56,1.56A1.56,1.56,0,0,1,96.1834,41.9444Z\"/></g></g></svg>\n", "\n    </div>")
    }, {
      label: "List Header: 2 Columns",
      name: "section2columns3RowsListWithHeader",
      type: "view",
      content: "\n    <div class=\"dc-sview sContainer sdContainer\">\n      ".concat("\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"154.3543\" height=\"93.4397\" viewBox=\"0 0 154.3543 93.4397\"><defs><style>.cls-1{fill:#272940;}.cls-2{fill:#b3b6c6;}.cls-3{fill:#8387a5;}</style></defs><title>List Header: 2 Columns</title><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><rect class=\"cls-1\" width=\"154.3543\" height=\"30\" rx=\"5\"/><path class=\"cls-2\" d=\"M87.6667,17.2621V6.69a.7377.7377,0,0,0-.7382-.7382H67.4006a.7381.7381,0,0,0-.7382.7382v17.359H87.6918v-6.77l-.0251-.0165m-.7382-.5-7.421-5.02-.5441-.3682-.4286.4981L73.84,17.3257,70.9007,14.8l-.496-.4264-.4828.4412L67.4006,17.118V6.69H86.9285ZM67.4006,18.1181,70.42,15.36l3.4984,3.0064,5.1764-6.0127L86.9538,17.67v5.64H67.4006Z\"/><path class=\"cls-2\" d=\"M72.8165,13.5473a2.643,2.643,0,1,0-2.643-2.643,2.646,2.646,0,0,0,2.643,2.643m0-4.5478a1.9046,1.9046,0,1,1-1.9049,1.9048A1.9046,1.9046,0,0,1,72.8165,9Z\"/><rect class=\"cls-1\" x=\"27.6269\" y=\"38.5449\" width=\"39.5668\" height=\"4.8794\" rx=\"2.4397\"/><rect class=\"cls-3\" x=\"27.5471\" y=\"53.8171\" width=\"13.4798\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-3\" x=\"42.6871\" y=\"53.8171\" width=\"13.678\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-3\" x=\"57.951\" y=\"53.8171\" width=\"6.2195\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-3\" x=\"27.5471\" y=\"47.6382\" width=\"7.285\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-3\" x=\"36.4676\" y=\"47.6382\" width=\"15.809\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-3\" x=\"53.5156\" y=\"47.6382\" width=\"13.678\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-1\" y=\"38.0235\" width=\"24.5755\" height=\"24.5755\" rx=\"5\"/><path class=\"cls-2\" d=\"M20.8806,52.1644V43.5036a.6043.6043,0,0,0-.6047-.6047H4.279a.6046.6046,0,0,0-.6047.6047v14.22H20.9012V52.1779l-.0206-.0135m-.6047-.4094-6.0791-4.1125-.4458-.3017-.3511.4081L9.5541,52.2165,7.1462,50.1474,6.74,49.7982l-.3955.3614L4.279,52.0463V43.5036H20.2759ZM4.279,52.8656l2.473-2.2594,2.8659,2.4627,4.24-4.9254,6.4383,4.3553v4.62H4.279Z\"/><path class=\"cls-2\" d=\"M8.7155,49.1212A2.1651,2.1651,0,1,0,6.55,46.9561a2.1675,2.1675,0,0,0,2.1651,2.1651m0-3.7254a1.56,1.56,0,1,1-1.56,1.56A1.56,1.56,0,0,1,8.7155,45.3958Z\"/><rect class=\"cls-1\" x=\"114.5807\" y=\"38.5449\" width=\"39.5668\" height=\"4.8794\" rx=\"2.4397\"/><rect class=\"cls-3\" x=\"114.5009\" y=\"53.8171\" width=\"13.4798\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-3\" x=\"129.6409\" y=\"53.8171\" width=\"13.678\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-3\" x=\"144.9048\" y=\"53.8171\" width=\"6.2195\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-3\" x=\"114.5009\" y=\"47.6382\" width=\"7.285\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-3\" x=\"123.4214\" y=\"47.6382\" width=\"15.809\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-3\" x=\"140.4694\" y=\"47.6382\" width=\"13.678\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-1\" x=\"86.9538\" y=\"38.0235\" width=\"24.5755\" height=\"24.5755\" rx=\"5\"/><path class=\"cls-2\" d=\"M107.8344,52.1644V43.5036a.6043.6043,0,0,0-.6047-.6047H91.2327a.6046.6046,0,0,0-.6046.6047v14.22H107.855V52.1779l-.0206-.0135m-.6047-.4094-6.0792-4.1125-.4457-.3017-.3511.4081-3.8458,4.4676L94.1,50.1474l-.4062-.3492-.3955.3614-2.0655,1.8867V43.5036H107.23Zm-15.997,1.1106,2.4731-2.2594,2.8658,2.4627,4.24-4.9254,6.4383,4.3553v4.62H91.2327Z\"/><path class=\"cls-2\" d=\"M95.6693,49.1212a2.1651,2.1651,0,1,0-2.1651-2.1651,2.1675,2.1675,0,0,0,2.1651,2.1651m0-3.7254a1.56,1.56,0,1,1-1.56,1.56A1.56,1.56,0,0,1,95.6693,45.3958Z\"/><rect class=\"cls-1\" x=\"27.6269\" y=\"69.3855\" width=\"39.5668\" height=\"4.8794\" rx=\"2.4397\"/><rect class=\"cls-3\" x=\"27.5471\" y=\"84.6578\" width=\"13.4798\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-3\" x=\"42.6871\" y=\"84.6578\" width=\"13.678\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-3\" x=\"57.951\" y=\"84.6578\" width=\"6.2195\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-3\" x=\"27.5471\" y=\"78.4789\" width=\"7.285\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-3\" x=\"36.4676\" y=\"78.4789\" width=\"15.809\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-3\" x=\"53.5156\" y=\"78.4789\" width=\"13.678\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-1\" y=\"68.8642\" width=\"24.5755\" height=\"24.5755\" rx=\"5\"/><path class=\"cls-2\" d=\"M20.8806,83.0051V74.3443a.6043.6043,0,0,0-.6047-.6047H4.279a.6046.6046,0,0,0-.6047.6047v14.22H20.9012V83.0185l-.0206-.0134m-.6047-.4094-6.0791-4.1125-.4458-.3017L13.4,78.59,9.5541,83.0571l-2.4079-2.069L6.74,80.6389,6.3444,81,4.279,82.887V74.3443H20.2759ZM4.279,83.7063l2.473-2.2594L9.6179,83.91l4.24-4.9254L20.2966,83.34v4.62H4.279Z\"/><path class=\"cls-2\" d=\"M8.7155,79.9619A2.1651,2.1651,0,1,0,6.55,77.7968a2.1675,2.1675,0,0,0,2.1651,2.1651m0-3.7255a1.56,1.56,0,1,1-1.56,1.56A1.56,1.56,0,0,1,8.7155,76.2364Z\"/><rect class=\"cls-1\" x=\"114.5807\" y=\"69.3855\" width=\"39.5668\" height=\"4.8794\" rx=\"2.4397\"/><rect class=\"cls-3\" x=\"114.5009\" y=\"84.6578\" width=\"13.4798\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-3\" x=\"129.6409\" y=\"84.6578\" width=\"13.678\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-3\" x=\"144.9048\" y=\"84.6578\" width=\"6.2195\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-3\" x=\"114.5009\" y=\"78.4789\" width=\"7.285\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-3\" x=\"123.4214\" y=\"78.4789\" width=\"15.809\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-3\" x=\"140.4694\" y=\"78.4789\" width=\"13.678\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-1\" x=\"86.9538\" y=\"68.8642\" width=\"24.5755\" height=\"24.5755\" rx=\"5\"/><path class=\"cls-2\" d=\"M107.8344,83.0051V74.3443a.6043.6043,0,0,0-.6047-.6047H91.2327a.6046.6046,0,0,0-.6046.6047v14.22H107.855V83.0185l-.0206-.0134m-.6047-.4094-6.0792-4.1125-.4457-.3017-.3511.4081-3.8458,4.4675L94.1,80.9881l-.4062-.3492L93.2982,81,91.2327,82.887V74.3443H107.23Zm-15.997,1.1106,2.4731-2.2594L96.5716,83.91l4.24-4.9254L107.25,83.34v4.62H91.2327Z\"/><path class=\"cls-2\" d=\"M95.6693,79.9619a2.1651,2.1651,0,1,0-2.1651-2.1651,2.1675,2.1675,0,0,0,2.1651,2.1651m0-3.7255a1.56,1.56,0,1,1-1.56,1.56A1.56,1.56,0,0,1,95.6693,76.2364Z\"/></g></g></svg>\n", "\n    </div>")
    }, {
      label: "1 Row Form",
      name: "section1rowForm",
      type: "view",
      content: "\n    <div class=\"dc-sview sContainer sdContainer\">\n      ".concat("\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"154.8449\" height=\"93.7159\" viewBox=\"0 0 154.8449 93.7159\"><defs><style>.cls-1{fill:#272940;}</style></defs><title>1 Row Form</title><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><path class=\"cls-1\" d=\"M150.7385,93.7159H4.1064A4.15,4.15,0,0,1,0,89.5234V4.1925A4.15,4.15,0,0,1,4.1064,0H150.7385a4.15,4.15,0,0,1,4.1064,4.1925V89.5234A4.15,4.15,0,0,1,150.7385,93.7159ZM8.3205,89.4135H146.5244a4.15,4.15,0,0,0,4.1064-4.1925V8.4949a4.15,4.15,0,0,0-4.1064-4.1925H8.3205A4.15,4.15,0,0,0,4.2141,8.4949V85.221A4.15,4.15,0,0,0,8.3205,89.4135Z\"/><rect class=\"cls-1\" x=\"42.466\" y=\"74.0296\" width=\"29.4614\" height=\"7.6654\" rx=\"0.7902\"/><path class=\"cls-1\" d=\"M50.3792,61.82H43.2561a.79.79,0,0,0-.79.79v7.1656a.79.79,0,0,0,.79.79h7.1231a.79.79,0,0,0,.79-.79V62.61A.79.79,0,0,0,50.3792,61.82Zm-1.3463,5.8085a.79.79,0,0,1-.79.79h-2.85a.79.79,0,0,1-.79-.79v-2.871a.79.79,0,0,1,.79-.79h2.85a.79.79,0,0,1,.79.79Z\"/><rect class=\"cls-1\" x=\"42.466\" y=\"7.7167\" width=\"38.7185\" height=\"6.2116\" rx=\"0.8373\"/><rect class=\"cls-1\" x=\"42.466\" y=\"20.7693\" width=\"17.7167\" height=\"4.4513\" rx=\"0.7902\"/><path class=\"cls-1\" d=\"M119.1128,27.9162H43.2561a.79.79,0,0,0-.79.79v8.687a.79.79,0,0,0,.79.79h75.8567a.79.79,0,0,0,.79-.79v-8.687A.79.79,0,0,0,119.1128,27.9162Zm-1.5979,7.69a.79.79,0,0,1-.79.79h-71.42a.79.79,0,0,1-.79-.79V30.4936a.79.79,0,0,1,.79-.79h71.42a.79.79,0,0,1,.79.79Z\"/><rect class=\"cls-1\" x=\"42.466\" y=\"41.5981\" width=\"17.7167\" height=\"4.4513\" rx=\"0.7902\"/><rect class=\"cls-1\" x=\"54.2107\" y=\"64.2953\" width=\"17.7167\" height=\"4.4513\" rx=\"0.7902\"/><path class=\"cls-1\" d=\"M119.1128,48.745H43.2561a.79.79,0,0,0-.79.79v8.687a.79.79,0,0,0,.79.79h75.8567a.79.79,0,0,0,.79-.79v-8.687A.79.79,0,0,0,119.1128,48.745Zm-1.5979,7.69a.79.79,0,0,1-.79.79h-71.42a.79.79,0,0,1-.79-.79V51.3224a.79.79,0,0,1,.79-.79h71.42a.79.79,0,0,1,.79.79Z\"/></g></g></svg>\n", "\n    </div>")
    }, {
      label: "3 Rows",
      name: "section3rows",
      type: "view",
      content: "\n    <div class=\"dc-sview sContainer sdContainer\">\n      ".concat("\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"154.9181\" height=\"93.3753\" viewBox=\"0 0 154.9181 93.3753\"><defs><style>.cls-1{fill:#272940;}.cls-2{fill:#8387a5;}.cls-3{fill:#b3b6c6;}</style></defs><title>3 Rows</title><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><rect class=\"cls-1\" x=\"64.4439\" y=\"2.6236\" width=\"90.4083\" height=\"4.8794\" rx=\"2.4397\"/><rect class=\"cls-2\" x=\"64.2617\" y=\"17.8958\" width=\"30.8008\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"98.856\" y=\"17.8958\" width=\"31.2537\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"133.7333\" y=\"17.8958\" width=\"14.2114\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"64.2617\" y=\"11.7169\" width=\"16.646\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"84.6446\" y=\"11.7169\" width=\"36.123\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"123.5985\" y=\"11.7169\" width=\"31.2537\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-1\" width=\"49.5262\" height=\"26.438\" rx=\"5\"/><path class=\"cls-3\" d=\"M34.0072,15.2125V5.8954a.65.65,0,0,0-.6505-.6506H16.1473a.65.65,0,0,0-.6505.6506V21.1932H34.0293V15.227l-.0221-.0145m-.6505-.44-6.54-4.4241-.48-.3246-.3776.439-4.1373,4.8062-2.59-2.2259-.437-.3757-.4255.3888-2.222,2.03v-9.19H33.3567ZM16.1473,15.9669l2.66-2.4306,3.0831,2.6494,4.5617-5.2988,6.9263,4.6854v4.97H16.1473Z\"/><path class=\"cls-3\" d=\"M20.92,11.9387A2.3292,2.3292,0,1,0,18.591,9.61,2.3316,2.3316,0,0,0,20.92,11.9387m0-4.0078A1.6784,1.6784,0,1,1,19.2415,9.61,1.6785,1.6785,0,0,1,20.92,7.9309Z\"/><rect class=\"cls-1\" x=\"64.4439\" y=\"69.5609\" width=\"90.4083\" height=\"4.8794\" rx=\"2.4397\"/><rect class=\"cls-2\" x=\"64.2617\" y=\"84.8332\" width=\"30.8008\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"98.856\" y=\"84.8332\" width=\"31.2537\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"133.7333\" y=\"84.8332\" width=\"14.2114\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"64.2617\" y=\"78.6543\" width=\"16.646\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"84.6446\" y=\"78.6543\" width=\"36.123\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"123.5985\" y=\"78.6543\" width=\"31.2537\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-1\" x=\"0.3683\" y=\"37.3725\" width=\"90.4083\" height=\"4.8794\" rx=\"2.4397\"/><rect class=\"cls-2\" x=\"0.1861\" y=\"52.6447\" width=\"30.8008\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"34.7803\" y=\"52.6447\" width=\"31.2537\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"69.6577\" y=\"52.6447\" width=\"14.2114\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"0.1861\" y=\"46.4659\" width=\"16.646\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"20.569\" y=\"46.4659\" width=\"36.123\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"59.5229\" y=\"46.4659\" width=\"31.2537\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-1\" y=\"66.9373\" width=\"49.5262\" height=\"26.438\" rx=\"5\"/><path class=\"cls-3\" d=\"M34.0072,82.15V72.8327a.65.65,0,0,0-.6505-.6505H16.1473a.65.65,0,0,0-.6505.6505V88.1305H34.0293V82.1644l-.0221-.0145m-.6505-.44-6.54-4.4242-.48-.3245L25.96,77.4l-4.1373,4.8061-2.59-2.2258-.437-.3757-.4255.3887-2.222,2.03v-9.19H33.3567ZM16.1473,82.9042l2.66-2.4306,3.0831,2.6494,4.5617-5.2987L33.3789,82.51v4.97H16.1473Z\"/><path class=\"cls-3\" d=\"M20.92,78.8761a2.3292,2.3292,0,1,0-2.3292-2.3292A2.3317,2.3317,0,0,0,20.92,78.8761m0-4.0078a1.6784,1.6784,0,1,1-1.6787,1.6786A1.6784,1.6784,0,0,1,20.92,74.8683Z\"/><rect class=\"cls-1\" x=\"105.3919\" y=\"32.1884\" width=\"49.5262\" height=\"26.438\" rx=\"5\"/><path class=\"cls-3\" d=\"M139.3991,47.401V38.0838a.65.65,0,0,0-.65-.6506H121.5392a.6505.6505,0,0,0-.65.6506V53.3816h18.5325V47.4154l-.0221-.0144m-.65-.4405-6.54-4.4241-.48-.3246-.3776.439-4.1373,4.8062-2.5905-2.2259-.437-.3757-.4255.3888-2.222,2.03v-9.19h17.2094Zm-17.2094,1.1948L124.2,45.7247l3.0831,2.6494,4.5618-5.2988,6.9262,4.6854v4.97H121.5392Z\"/><path class=\"cls-3\" d=\"M126.3121,44.1272a2.3292,2.3292,0,1,0-2.3292-2.3292,2.3318,2.3318,0,0,0,2.3292,2.3292m0-4.0079a1.6785,1.6785,0,1,1-1.6787,1.6787A1.6785,1.6785,0,0,1,126.3121,40.1193Z\"/></g></g></svg>\n", "\n    </div>")
    }, {
      label: "3 Rows",
      name: "section3rowsLeftAlign",
      type: "view",
      content: "\n    <div class=\"dc-sview sContainer sdContainer\">\n      ".concat("\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"154.8523\" height=\"93.3753\" viewBox=\"0 0 154.8523 93.3753\"><defs><style>.cls-1{fill:#272940;}.cls-2{fill:#8387a5;}.cls-3{fill:#b3b6c6;}</style></defs><title>3 Rows</title><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><rect class=\"cls-1\" x=\"64.4439\" y=\"2.6236\" width=\"90.4083\" height=\"4.8794\" rx=\"2.4397\"/><rect class=\"cls-2\" x=\"64.2617\" y=\"17.8958\" width=\"30.8008\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"98.856\" y=\"17.8958\" width=\"31.2537\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"133.7333\" y=\"17.8958\" width=\"14.2114\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"64.2617\" y=\"11.7169\" width=\"16.646\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"84.6446\" y=\"11.7169\" width=\"36.123\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"123.5985\" y=\"11.7169\" width=\"31.2537\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-1\" width=\"49.5262\" height=\"26.438\" rx=\"5\"/><path class=\"cls-3\" d=\"M34.0072,15.2125V5.8954a.65.65,0,0,0-.6505-.6506H16.1473a.65.65,0,0,0-.6505.6506V21.1932H34.0293V15.227l-.0221-.0145m-.6505-.44-6.54-4.4241-.48-.3246-.3776.439-4.1373,4.8062-2.59-2.2259-.437-.3757-.4255.3888-2.222,2.03v-9.19H33.3567ZM16.1473,15.9669l2.66-2.4306,3.0831,2.6494,4.5617-5.2988,6.9263,4.6854v4.97H16.1473Z\"/><path class=\"cls-3\" d=\"M20.92,11.9387A2.3292,2.3292,0,1,0,18.591,9.61,2.3316,2.3316,0,0,0,20.92,11.9387m0-4.0078A1.6784,1.6784,0,1,1,19.2415,9.61,1.6785,1.6785,0,0,1,20.92,7.9309Z\"/><rect class=\"cls-1\" x=\"64.4439\" y=\"69.5609\" width=\"90.4083\" height=\"4.8794\" rx=\"2.4397\"/><rect class=\"cls-2\" x=\"64.2617\" y=\"84.8332\" width=\"30.8008\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"98.856\" y=\"84.8332\" width=\"31.2537\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"133.7333\" y=\"84.8332\" width=\"14.2114\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"64.2617\" y=\"78.6543\" width=\"16.646\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"84.6446\" y=\"78.6543\" width=\"36.123\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"123.5985\" y=\"78.6543\" width=\"31.2537\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-1\" y=\"66.9373\" width=\"49.5262\" height=\"26.438\" rx=\"5\"/><path class=\"cls-3\" d=\"M34.0072,82.15V72.8327a.65.65,0,0,0-.6505-.6505H16.1473a.65.65,0,0,0-.6505.6505V88.1305H34.0293V82.1644l-.0221-.0145m-.6505-.44-6.54-4.4242-.48-.3245L25.96,77.4l-4.1373,4.8061-2.59-2.2258-.437-.3757-.4255.3887-2.222,2.03v-9.19H33.3567ZM16.1473,82.9042l2.66-2.4306,3.0831,2.6494,4.5617-5.2987L33.3789,82.51v4.97H16.1473Z\"/><path class=\"cls-3\" d=\"M20.92,78.8761a2.3292,2.3292,0,1,0-2.3292-2.3292A2.3317,2.3317,0,0,0,20.92,78.8761m0-4.0078a1.6784,1.6784,0,1,1-1.6787,1.6786A1.6784,1.6784,0,0,1,20.92,74.8683Z\"/><rect class=\"cls-1\" x=\"64.4439\" y=\"36.0922\" width=\"90.4083\" height=\"4.8794\" rx=\"2.4397\"/><rect class=\"cls-2\" x=\"64.2617\" y=\"51.3645\" width=\"30.8008\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"98.856\" y=\"51.3645\" width=\"31.2537\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"133.7333\" y=\"51.3645\" width=\"14.2114\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"64.2617\" y=\"45.1856\" width=\"16.646\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"84.6446\" y=\"45.1856\" width=\"36.123\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"123.5985\" y=\"45.1856\" width=\"31.2537\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-1\" y=\"33.4687\" width=\"49.5262\" height=\"26.438\" rx=\"5\"/><path class=\"cls-3\" d=\"M34.0072,48.6812V39.364a.65.65,0,0,0-.6505-.65H16.1473a.65.65,0,0,0-.6505.65V54.6619H34.0293V48.6957l-.0221-.0145m-.6505-.44-6.54-4.4242-.48-.3245-.3776.439-4.1373,4.8061-2.59-2.2258-.437-.3757-.4255.3887-2.222,2.03v-9.19H33.3567ZM16.1473,49.4356l2.66-2.4306,3.0831,2.6493,4.5617-5.2987,6.9263,4.6854v4.97H16.1473Z\"/><path class=\"cls-3\" d=\"M20.92,45.4074a2.3292,2.3292,0,1,0-2.3292-2.3292A2.3317,2.3317,0,0,0,20.92,45.4074m0-4.0078a1.6784,1.6784,0,1,1-1.6787,1.6786A1.6784,1.6784,0,0,1,20.92,41.4Z\"/></g></g></svg>\n", "\n    </div>")
    }, {
      label: "3 Rows Simple",
      name: "section3rowsSimple",
      type: "view",
      content: "\n    <div class=\"dc-sview sContainer sdContainer\">\n      ".concat("\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"155.0383\" height=\"93.5919\" viewBox=\"0 0 155.0383 93.5919\"><defs><style>.cls-1{fill:#272940;}.cls-2{fill:#8387a5;}</style></defs><title>3 Rows Simple</title><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><rect class=\"cls-1\" x=\"0.4659\" width=\"77.0469\" height=\"4.8794\" rx=\"2.4397\"/><rect class=\"cls-2\" x=\"0.1553\" y=\"15.2722\" width=\"52.4975\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"59.1185\" y=\"15.2722\" width=\"53.2695\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"118.5642\" y=\"15.2722\" width=\"24.2222\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"0.1553\" y=\"9.0934\" width=\"28.3718\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"34.8963\" y=\"9.0934\" width=\"61.5688\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"101.2902\" y=\"9.0934\" width=\"53.2695\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-1\" x=\"0.3119\" y=\"74.9616\" width=\"77.6795\" height=\"4.8794\" rx=\"2.4397\"/><rect class=\"cls-2\" y=\"90.2338\" width=\"52.713\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"59.2052\" y=\"90.2338\" width=\"53.4882\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"118.895\" y=\"90.2338\" width=\"24.3216\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" y=\"84.055\" width=\"28.4883\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"34.8836\" y=\"84.055\" width=\"61.8215\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"101.5501\" y=\"84.055\" width=\"53.4882\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-1\" x=\"0.3491\" y=\"35.152\" width=\"77.437\" height=\"4.8794\" rx=\"2.4397\"/><rect class=\"cls-2\" x=\"0.1669\" y=\"50.4243\" width=\"52.5865\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"59.2301\" y=\"50.4243\" width=\"53.3598\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"118.7765\" y=\"50.4243\" width=\"24.2633\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"0.1669\" y=\"44.2454\" width=\"28.4199\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"34.9668\" y=\"44.2454\" width=\"61.6731\" height=\"3.3581\" rx=\"1.679\"/><rect class=\"cls-2\" x=\"101.4733\" y=\"44.2454\" width=\"53.3598\" height=\"3.3581\" rx=\"1.679\"/></g></g></svg>\n", "\n    </div>")
    }];
    var qr = "data:image/svg+xml;base64,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";
    var $r = [{
        name: "section11Empty",
        type: "code",
        content: "<div class='container'>\n    <div class='row'>\n      <div class='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'></div>\n    </div>\n    </div>"
      }, {
        name: "section22Empty",
        type: "code",
        content: "<div class='container'>\n    <div class='row'>\n      <div class='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'></div>\n      <div class='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'></div>\n    </div>\n    </div>"
      }, {
        name: "section33Empty",
        type: "code",
        content: "<div class='container'>\n    <div class='row'>\n      <div class='col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'></div>\n      <div class='col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'></div>\n      <div class='col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'></div>\n    </div>\n    </div>"
      }, {
        name: "section44Empty",
        type: "code",
        content: "<div class='container'>\n    <div class='row'>\n      <div class='col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3'></div>\n      <div class='col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3'></div>\n      <div class='col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3'></div>\n      <div class='col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3'></div>\n    </div>\n    </div>"
      }, {
        name: "section11",
        type: "code",
        content: "<div class='container'>\n    <div class='row'>\n      <div class='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>\n        <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n          <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n            <h3 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">My Sample Heading</h3>\n          </div>\n          <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n            <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n          </div>\n        </div>\n      </div>\n    </div>\n    </div>"
      }, {
        name: "section22",
        type: "code",
        content: "<div class='container'>\n    <div class='row'>\n      <div class='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>\n        <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n          <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n            <h3 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">My Sample Heading</h3>\n          </div>\n          <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n            <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n          </div>\n        </div>\n      </div>\n      <div class='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>\n        <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n          <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n            <h3 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">My Sample Heading</h3>\n          </div>\n          <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n            <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n          </div>\n        </div>\n      </div>\n    </div>\n    </div>"
      }, {
        name: "section33",
        type: "code",
        content: "\n    <div class='container'>\n  <div class='row'>\n    <div class='col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'>\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h3 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">My Sample Heading</h3>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n        </div>\n      </div>\n    </div>\n    <div class='col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'>\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h3 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">My Sample Heading</h3>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n        </div>\n      </div>\n    </div>\n    <div class='col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'>\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h3 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">My Sample Heading</h3>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n    "
      }, {
        name: "section44",
        type: "code",
        content: "<div class='container'>\n    <div class='row'>\n      <div class='col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3'>\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n      <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n        <h3 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">My Sample Heading</h3>\n      </div>\n      <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n        <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n      </div>\n    </div>\n      </div>\n      <div class='col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3'>\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n      <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n        <h3 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">My Sample Heading</h3>\n      </div>\n      <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n        <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n      </div>\n    </div>\n      </div>\n      <div class='col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3'>\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n      <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n        <h3 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">My Sample Heading</h3>\n      </div>\n      <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n        <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n      </div>\n    </div>\n      </div>\n      <div class='col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3'>\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n      <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n        <h3 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">My Sample Heading</h3>\n      </div>\n      <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n        <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n      </div>\n    </div>\n      </div>\n    </div>\n    </div>"
      }, {
        name: "section4060",
        type: "code",
        content: "<div class='container'>\n    <div class='row'>\n        <div class='col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4'>\n        <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h3 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">My Sample Heading</h3>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n        </div>\n      </div>\n        </div>\n        <div class='col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8'>\n        <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h3 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">My Sample Heading</h3>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n        </div>\n      </div>\n        </div>\n    </div>\n    </div>"
      }, {
        name: "section6040",
        type: "code",
        content: "<div class='container'>\n    <div class='row'>\n        <div class='col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8'>\n        <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h3 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">My Sample Heading</h3>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n        </div>\n      </div>\n        </div>\n        <div class='col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4'>\n        <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h3 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">My Sample Heading</h3>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n        </div>\n      </div>\n        </div>\n    </div>\n    </div>"
      }, {
        name: "section633",
        type: "code",
        content: "<div class='container'>\n    <div class='row'>\n        <div class='col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>\n        <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h3 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">My Sample Heading</h3>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n        </div>\n      </div>\n        </div>\n        <div class='col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3'>\n        <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h3 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">My Sample Heading</h3>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n        </div>\n      </div>\n        </div>\n        <div class='col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3'>\n        <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h3 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">My Sample Heading</h3>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n        </div>\n      </div>\n        </div>\n    </div>\n    </div>"
      }, {
        name: "section363",
        type: "code",
        content: "<div class='container'>\n    <div class='row'>\n        <div class='col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3'>\n        <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h3 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">My Sample Heading</h3>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n        </div>\n      </div>\n        </div>\n        <div class='col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>\n        <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h3 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">My Sample Heading</h3>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n        </div>\n      </div>\n        </div>\n        <div class='col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3'>\n        <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h3 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">My Sample Heading</h3>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n        </div>\n      </div>\n        </div>\n    </div>\n    </div>"
      }, {
        name: "section2columns",
        type: "code",
        content: "\n    <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container\">\n  <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\"><img data-gjs-type=\"bs-image\" draggable=\"true\" src=".concat(qr, " class=\"img-fluid\"></div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h1 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\" contenteditable=\"false\">Heading</h1>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n        </div>\n      </div>\n    </div>\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\"><img data-gjs-type=\"bs-image\" draggable=\"true\" src=").concat(qr, " class=\"img-fluid\"></div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h1 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\" contenteditable=\"false\">Heading</h1>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n    ")
      }, {
        name: "section3columns",
        type: "code",
        content: "\n    <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container\">\n  <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\"><img data-gjs-type=\"bs-image\" draggable=\"true\" src=".concat(qr, " class=\"img-fluid\"></div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h1 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\" contenteditable=\"false\">Heading</h1>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n        </div>\n      </div>\n    </div>\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\"><img data-gjs-type=\"bs-image\" draggable=\"true\" src=").concat(qr, " class=\"img-fluid\"></div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h1 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\" contenteditable=\"false\">Heading</h1>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n        </div>\n      </div>\n    </div>\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\"><img data-gjs-type=\"bs-image\" draggable=\"true\" src=").concat(qr, " class=\"img-fluid\"></div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h1 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\" contenteditable=\"false\">Heading</h1>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n    ")
      }, {
        name: "section4columns",
        type: "code",
        content: "\n    <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container \">\n  <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-lg-3 col-xl-3 col-md-3\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\"><img data-gjs-type=\"bs-image\" draggable=\"true\" src=".concat(qr, " class=\"img-fluid\"></div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h1 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\">Heading\n          </h1>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.\n          </p>\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.\n          </p>\n        </div>\n      </div>\n    </div>\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\"><img data-gjs-type=\"bs-image\" draggable=\"true\" src=").concat(qr, " class=\"img-fluid\"></div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h1 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\">Heading\n          </h1>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.\n          </p>\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.\n          </p>\n        </div>\n      </div>\n    </div>\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\"><img data-gjs-type=\"bs-image\" draggable=\"true\" src=").concat(qr, " class=\"img-fluid\"></div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h1 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Heading\n          </h1>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.\n          </p>\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.\n          </p>\n        </div>\n      </div>\n    </div>\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\"><img data-gjs-type=\"bs-image\" draggable=\"true\" src=").concat(qr, " class=\"img-fluid\"></div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h1 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\">Heading\n          </h1>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.\n          </p>\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.\n          </p>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n    ")
      }, {
        name: "section3columnsHB",
        type: "code",
        content: "\n    <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container\">\n  <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 \"><img data-gjs-type=\"bs-image\" draggable=\"true\" src=".concat(qr, " class=\"img-fluid\" style=\"width: 100%; height: 300px;\">\n      <div data-gjs-type=\"column_break\" draggable=\"true\" data-highlightable=\"1\" class=\"w-100\" style=\"height: 32px;\"></div>\n    </div>\n  </div>\n  <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-xl-4 col-lg-4 col-md-4\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h1 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\" contenteditable=\"false\">Heading</h1>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n        </div>\n      </div>\n    </div>\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-xl-4 col-lg-4 col-md-4\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h1 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Heading</h1>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n        </div>\n      </div>\n    </div>\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-xl-4 col-lg-4 col-md-4\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h1 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Heading</h1>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n    ")
      }, {
        name: "section4columnsHB",
        type: "code",
        content: "\n    <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container\">\n  <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 \"><img data-gjs-type=\"bs-image\" draggable=\"true\" src=".concat(qr, " class=\"img-fluid\" style=\"width: 100%; height: 300px;\">\n      <div data-gjs-type=\"column_break\" draggable=\"true\" data-highlightable=\"1\" class=\"w-100\" style=\"height: 32px;\"></div>\n    </div>\n  </div>\n  <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-xl-3 col-lg-3 col-md-3\">\n        <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n            <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n            <h1 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\" contenteditable=\"false\">Heading</h1>\n            </div>\n            <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n            <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n            <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n            </div>\n        </div>\n    </div>\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-xl-3 col-lg-3 col-md-3\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h1 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\" contenteditable=\"false\">Heading</h1>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n        </div>\n      </div>\n    </div>\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-xl-3 col-lg-3 col-md-3\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h1 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Heading</h1>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n        </div>\n      </div>\n    </div>\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-xl-3 col-lg-3 col-md-3\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h1 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Heading</h1>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n    ")
      }, {
        name: "section2columnsHB",
        type: "code",
        content: "\n    <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container\">\n  <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 \"><img data-gjs-type=\"bs-image\" draggable=\"true\" src=".concat(qr, " class=\"img-fluid\" style=\"width: 100%; height: 300px;\">\n      <div data-gjs-type=\"column_break\" draggable=\"true\" data-highlightable=\"1\" class=\"w-100\" style=\"height: 32px;\"></div>\n    </div>\n  </div>\n  <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-xl-6 col-lg-6 col-md-6\">\n        <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n            <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n            <h1 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\" contenteditable=\"false\">Heading</h1>\n            </div>\n            <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n            <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n            <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n            </div>\n        </div>\n    </div>\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-xl-6 col-lg-6 col-md-6\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h1 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\" contenteditable=\"false\">Heading</h1>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n    ")
      }, {
        name: "section2columns3RowsList",
        type: "code",
        content: "\n    <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container\">\n  <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-xl-6 col-lg-6 col-md-6\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4\"><img data-gjs-type=\"bs-image\" draggable=\"true\" src=".concat(qr, " class=\"img-fluid\"></div>\n          <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8\">\n            <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n              <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n                <h3 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Heading</h3>\n              </div>\n              <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n                <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-xl-6 col-lg-6 col-md-6\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4\"><img data-gjs-type=\"bs-image\" draggable=\"true\" src=").concat(qr, " class=\"img-fluid\"></div>\n          <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8\">\n            <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n              <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n                <h3 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\">Heading</h3>\n              </div>\n              <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n                <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-xl-6 col-lg-6 col-md-6\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4\"><img data-gjs-type=\"bs-image\" draggable=\"true\" src=").concat(qr, " class=\"img-fluid\"></div>\n          <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8\">\n            <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n              <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n                <h3 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\">Heading</h3>\n              </div>\n              <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n                <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-xl-6 col-lg-6 col-md-6\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4\"><img data-gjs-type=\"bs-image\" draggable=\"true\" src=").concat(qr, " class=\"img-fluid\"></div>\n          <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8\">\n            <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n              <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n                <h3 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\">Heading</h3>\n              </div>\n              <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n                <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-xl-6 col-lg-6 col-md-6\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4\"><img data-gjs-type=\"bs-image\" draggable=\"true\" src=").concat(qr, " class=\"img-fluid\"></div>\n          <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8\">\n            <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n              <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n                <h3 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\">Heading</h3>\n              </div>\n              <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n                <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-xl-6 col-lg-6 col-md-6\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4\"><img data-gjs-type=\"bs-image\" draggable=\"true\" src=").concat(qr, " class=\"img-fluid\"></div>\n          <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8\">\n            <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n              <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n                <h3 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\">Heading</h3>\n              </div>\n              <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n                <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n    ")
      }, {
        name: "section2columns3RowsListWithHeader",
        type: "code",
        content: "\n    <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container\">\n  <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 \"><img data-gjs-type=\"bs-image\" draggable=\"true\" src=".concat(qr, " class=\"img-fluid\"\n        style=\"width: 100%; height: 300px;\"></div>\n    <div data-gjs-type=\"column_break\" draggable=\"true\" data-highlightable=\"1\" class=\"w-100\" style=\"height: 32px;\"></div>\n  </div>\n  <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-xl-6 col-lg-6 col-md-6\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4\"><img data-gjs-type=\"bs-image\" draggable=\"true\" src=").concat(qr, " class=\"img-fluid\"></div>\n          <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8\">\n            <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n              <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n                <h3 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Heading\n                </h3>\n              </div>\n              <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n                <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.\n                </p>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-xl-6 col-lg-6 col-md-6\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4\"><img data-gjs-type=\"bs-image\" draggable=\"true\" src=").concat(qr, " class=\"img-fluid\"></div>\n          <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8\">\n            <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n              <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n                <h3 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Heading\n                </h3>\n              </div>\n              <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n                <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.\n                </p>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-xl-6 col-lg-6 col-md-6\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4\"><img data-gjs-type=\"bs-image\" draggable=\"true\" src=").concat(qr, " class=\"img-fluid\"></div>\n          <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8\">\n            <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n              <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n                <h3 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\">Heading\n                </h3>\n              </div>\n              <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n                <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.\n                </p>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-xl-6 col-lg-6 col-md-6\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4\"><img data-gjs-type=\"bs-image\" draggable=\"true\" src=").concat(qr, " class=\"img-fluid\"></div>\n          <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8\">\n            <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n              <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n                <h3 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\">Heading\n                </h3>\n              </div>\n              <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n                <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.\n                </p>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n    ")
      }, {
        name: "section1rowForm",
        type: "code",
        content: "\n    <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container\">\n  <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\">\n      <form data-gjs-type=\"form\" draggable=\"true\" data-highlightable=\"1\" id=\"dc-form-9YWv1ecj\" class=\"dc-form-default dc-form-bordered\">\n        <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-md-12\">\n          <h4 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"title\">Form Details</h4>\n        </div>\n        <div data-gjs-type=\"default\" draggable=\"false\" data-highlightable=\"1\" class=\"form-container\">\n          <div data-gjs-type=\"default\" draggable=\"true\" data-highlightable=\"1\" class=\"alert alert-danger alert-message\" style=\"display: none;\"></div>\n          <div data-gjs-type=\"default\" draggable=\"true\" data-highlightable=\"1\" class=\"alert alert-success success-message\" style=\"display: none;\"></div>\n          <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"form-group col-12 col-md-12\"><label data-gjs-type=\"label\" draggable=\"true\" data-highlightable=\"1\" class=\"label\">Name</label><input data-gjs-type=\"input\"\n              draggable=\"true\" data-highlightable=\"1\" name=\"name\" type=\"text\" placeholder=\"Type here your name\" class=\"form-control input--style\"></div>\n          <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"form-group col-12 col-md-12\"><label data-gjs-type=\"label\" draggable=\"true\" data-highlightable=\"1\" class=\"label\">Email</label><input data-gjs-type=\"input\"\n              draggable=\"true\" data-highlightable=\"1\" name=\"email\" type=\"email\" placeholder=\"Type here your email\" class=\"form-control input--style\"></div>\n          <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"form-group col-12 col-md-12\"><input data-gjs-type=\"checkbox\" draggable=\"true\" data-highlightable=\"1\" name=\"sex\" type=\"checkbox\" id=\"dc-form-cb-m-5c7fWr21\" value=\"M\"\n              class=\"form-check-input dc-checkbox\"><label data-gjs-type=\"label\" draggable=\"true\" data-highlightable=\"1\" for=\"dc-form-cb-m-5c7fWr21\" class=\"form-check-label\">M</label></div>\n          <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"form-group col-12 col-md-12\"><input data-gjs-type=\"checkbox\" draggable=\"true\" data-highlightable=\"1\" name=\"sex\" type=\"checkbox\" id=\"dc-form-cb-f-xeFCs0lx\" value=\"F\"\n              class=\"form-check-input dc-checkbox\"><label data-gjs-type=\"label\" draggable=\"true\" data-highlightable=\"1\" for=\"dc-form-cb-f-xeFCs0lx\" class=\"form-check-label\">F</label></div>\n          <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"form-group col-12 col-md-12\"><label data-gjs-type=\"label\" draggable=\"true\" data-highlightable=\"1\" class=\"label\">Message</label><textarea data-gjs-type=\"textarea\"\n              draggable=\"true\" data-highlightable=\"1\" name=\"message\" placeholder=\"Type here your message\" class=\"form-control input--style\"></textarea></div>\n          <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"form-group col-12 col-md-12 p-t-10 no-border-bottom\"><button data-gjs-type=\"bootstrap_button\" draggable=\"true\" data-highlightable=\"1\" role=\"button\" type=\"submit\"\n              class=\"btn btn-primary\">Send</button></div>\n        </div>\n      </form>\n    </div>\n  </div>\n</div>\n    "
      }, {
        name: "section3rows",
        type: "code",
        content: "\n    <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container\">\n  <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4\"><img data-gjs-type=\"bs-image\" draggable=\"true\" src=".concat(qr, " class=\"img-fluid\">\n    </div>\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h1 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">My Sample Heading</h1>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n        </div>\n      </div>\n    </div>\n    <div data-gjs-type=\"column_break\" draggable=\"true\" data-highlightable=\"1\" class=\"w-100\" style=\"height: 32px;\"></div>\n  </div>\n  <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h1 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">My Sample Heading</h1>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n        </div>\n      </div>\n    </div>\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4\"><img data-gjs-type=\"bs-image\" draggable=\"true\" src=").concat(qr, " class=\"img-fluid\">\n    </div>\n    <div data-gjs-type=\"column_break\" draggable=\"true\" data-highlightable=\"1\" class=\"w-100\" style=\"height: 32px;\"></div>\n  </div>\n  <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4\"><img data-gjs-type=\"bs-image\" draggable=\"true\" src=").concat(qr, " class=\"img-fluid\">\n    </div>\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h1 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">My Sample Heading</h1>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n    ")
      }, {
        name: "section3rowsLeftAlign",
        type: "code",
        content: "\n    <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container\">\n  <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4\"><img data-gjs-type=\"bs-image\" draggable=\"true\" src=".concat(qr, " class=\"img-fluid\">\n    </div>\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h1 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">My Sample Heading</h1>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n        </div>\n      </div>\n    </div>\n    <div data-gjs-type=\"column_break\" draggable=\"true\" data-highlightable=\"1\" class=\"w-100\" style=\"height: 32px;\"></div>\n  </div>\n  <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4\"><img data-gjs-type=\"bs-image\" draggable=\"true\" src=").concat(qr, " class=\"img-fluid\">\n    </div>\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h1 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">My Sample Heading</h1>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4\"><img data-gjs-type=\"bs-image\" draggable=\"true\" src=").concat(qr, " class=\"img-fluid\">\n    </div>\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h1 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">My Sample Heading</h1>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n    ")
      }, {
        name: "section3rowsSimple",
        type: "code",
        content: "\n    <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container\">\n  <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h2 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">My Sample Heading\n          </h2>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.\n          </p>\n        </div>\n      </div>\n    </div>\n    <div data-gjs-type=\"column_break\" draggable=\"true\" data-highlightable=\"1\" class=\"w-100\" style=\"height: 32px;\">\n    </div>\n  </div>\n  <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h2 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">My Sample Heading\n          </h2>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.\n          </p>\n        </div>\n      </div>\n    </div>\n    <div data-gjs-type=\"column_break\" draggable=\"true\" data-highlightable=\"1\" class=\"w-100\" style=\"height: 32px;\">\n    </div>\n  </div>\n  <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n    <div data-gjs-type=\"column\" draggable=\"true\" data-highlightable=\"1\" class=\"col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\">\n      <div data-gjs-type=\"container\" draggable=\"true\" data-highlightable=\"1\" class=\"container-fluid\">\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <h2 data-gjs-type=\"header\" draggable=\"true\" data-highlightable=\"1\" class=\"\">My Sample Heading\n          </h2>\n        </div>\n        <div data-gjs-type=\"row\" draggable=\"true\" data-highlightable=\"1\" class=\"row\">\n          <p data-gjs-type=\"paragraph\" draggable=\"true\" data-highlightable=\"1\" class=\"\">Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.\n          </p>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n    "
      }],
      Qr = "drapcode-sections";
    var Jr = [];
    ["section11Empty", "section22Empty", "section33Empty", "section44Empty", "section11", "section22", "section33", "section44", "section4060", "section6040", "section633", "section363", "section2columns", "section3columns", "section4columns", "section2columnsHB", "section3columnsHB", "section4columnsHB", "section2columns3RowsList", "section2columns3RowsListWithHeader", "section1rowForm", "section3rows", "section3rowsLeftAlign", "section3rowsSimple"].forEach(function (t) {
      var e = Gr.filter(function (e) {
          return e.name === t;
        })[0],
        n = $r.filter(function (e) {
          return e.name === t;
        })[0];
      Jr.push({
        label: e.label,
        value: t,
        view: e.content,
        code: n.content
      });
    });
    var Xr = [].concat(Jr),
      Kr = "drapcode-carousel",
      ta = "dc-carousel-" + st()(8, ""),
      ea = [{
        label: "Carousel 001",
        value: "carousel01",
        view: "\n<div class=\"dc-sview sContainer\">\n    <span span=\"12\" class=\"dc-scview dc-carousel-s12\">\n    <img class=\"d-block img-fluid\" style=\"height:100px; width: 220px\" src=\"https://public-webconnect.s3.amazonaws.com/static/image/Carousel-001.gif\" alt=\"Carousel 001\">\n    </span>\n</div>",
        code: "<div id=\"".concat(ta, "\" class=\"carousel slide\" data-ride=\"carousel\" data-gjs-type=\"carousel-container\" data-gjs-custom-name=\"Carousel\" data-pause=\"hover\" data-interval=\"5000\">\n<div class=\"carousel-inner\" data-gjs-type=\"carousel-inner\" data-gjs-custom-name=\"Carousel Container\">\n  <div class=\"carousel-item active\" data-gjs-type=\"carousel-item\" data-gjs-custom-name=\"Carousel Item\">\n    <img class=\"d-block img-fluid\" data-gjs-type=\"bs-image\" style=\"width: 100%\" src=\"https://picsum.photos/1250/400\" alt=\"First slide\">\n  </div>\n  <div class=\"carousel-item\" data-gjs-type=\"carousel-item\" data-gjs-custom-name=\"Carousel Item\">\n    <img class=\"d-block img-fluid\" data-gjs-type=\"bs-image\" style=\"width: 100%\" src=\"https://picsum.photos/1250/400\" alt=\"Second slide\">\n  </div>\n  <div class=\"carousel-item\" data-gjs-type=\"carousel-item\" data-gjs-custom-name=\"Carousel Item\">\n    <img class=\"d-block img-fluid\" data-gjs-type=\"bs-image\" style=\"width: 100%\" src=\"https://picsum.photos/1250/400\" alt=\"Third slide\">\n  </div>\n</div>\n</div>")
      }, {
        label: "Carousel 002",
        value: "carousel02",
        view: "\n<div class=\"dc-sview sContainer\">\n    <span span=\"12\" class=\"dc-scview dc-carousel-s12\">\n    <img class=\"d-block img-fluid\" style=\"height:100px; width: 220px\" src=\"https://public-webconnect.s3.amazonaws.com/static/image/Carousel-002-1.gif\" alt=\"Carousel 002\">\n    </span>\n</div>",
        code: "<div id=\"".concat(ta, "\" class=\"carousel slide\" data-ride=\"carousel\" data-gjs-type=\"carousel-container\" data-gjs-custom-name=\"Carousel\" data-pause=\"hover\" data-interval=\"5000\">\n<div class=\"carousel-inner\" data-gjs-type=\"carousel-inner\" data-gjs-custom-name=\"Carousel Container\">\n  <div class=\"carousel-item active\" data-gjs-type=\"carousel-item\" data-gjs-custom-name=\"Carousel Item\">\n    <img class=\"d-block img-fluid\" data-gjs-type=\"bs-image\" style=\"width: 100%\" src=\"https://picsum.photos/1250/400\" alt=\"First slide\">\n  </div>\n  <div class=\"carousel-item\" data-gjs-type=\"carousel-item\" data-gjs-custom-name=\"Carousel Item\">\n    <img class=\"d-block img-fluid\" data-gjs-type=\"bs-image\" style=\"width: 100%\" src=\"https://picsum.photos/1250/400\" alt=\"Second slide\">\n  </div>\n  <div class=\"carousel-item\" data-gjs-type=\"carousel-item\" data-gjs-custom-name=\"Carousel Item\">\n    <img class=\"d-block img-fluid\" data-gjs-type=\"bs-image\" style=\"width: 100%\" src=\"https://picsum.photos/1250/400\" alt=\"Third slide\">\n  </div>\n</div>\n<a class=\"carousel-control-prev\" href=\"#").concat(ta, "\" role=\"button\" data-slide=\"prev\">\n  <span class=\"carousel-control-prev-icon\" aria-hidden=\"true\" data-gjs-type=\"carousel-control-prev-icon\" data-gjs-custom-name=\"Prev\"></span>\n  <span class=\"sr-only\">Previous</span>\n</a>\n<a class=\"carousel-control-next\" href=\"#").concat(ta, "\" role=\"button\" data-slide=\"next\">\n  <span class=\"carousel-control-next-icon\" aria-hidden=\"true\" data-gjs-type=\"carousel-control-next-icon\" data-gjs-custom-name=\"Next\"></span>\n  <span class=\"sr-only\">Next</span>\n</a>\n</div>")
      }, {
        label: "Carousel 003",
        value: "carousel03",
        view: "\n<div class=\"dc-sview sContainer\">\n    <span span=\"12\" class=\"dc-scview dc-carousel-s12\">\n    <img class=\"d-block img-fluid\" style=\"height:100px; width: 220px\" src=\"https://public-webconnect.s3.amazonaws.com/static/image/Carousel-003.gif\" alt=\"Carousel 003\">\n    </span>\n</div>",
        code: "<div id=\"".concat(ta, "\" class=\"carousel slide\" data-ride=\"carousel\" data-gjs-type=\"carousel-container\" data-gjs-custom-name=\"Carousel\" data-pause=\"hover\" data-interval=\"5000\">\n<ol class=\"carousel-indicators\" data-gjs-type=\"carousel-indicators\" data-gjs-custom-name=\"Carousel Indicators\">\n  <li data-target=\"#").concat(ta, "\" data-slide-to=\"0\" class=\"active\" data-gjs-type=\"carousel-list-item\"></li>\n  <li data-target=\"#").concat(ta, "\" data-slide-to=\"1\" data-gjs-type=\"carousel-list-item\"></li>\n  <li data-target=\"#").concat(ta, "\" data-slide-to=\"2\" data-gjs-type=\"carousel-list-item\"></li>\n</ol>\n<div class=\"carousel-inner\" data-gjs-type=\"carousel-inner\" data-gjs-custom-name=\"Carousel Container\">\n  <div class=\"carousel-item active\" data-gjs-type=\"carousel-item\" data-gjs-custom-name=\"Carousel Item\">\n    <img class=\"d-block img-fluid\" data-gjs-type=\"bs-image\" style=\"width: 100%\" src=\"https://picsum.photos/1250/400\" alt=\"First slide\">\n  </div>\n  <div class=\"carousel-item\" data-gjs-type=\"carousel-item\" data-gjs-custom-name=\"Carousel Item\">\n    <img class=\"d-block img-fluid\" data-gjs-type=\"bs-image\" style=\"width: 100%\" src=\"https://picsum.photos/1250/400\" alt=\"Second slide\">\n  </div>\n  <div class=\"carousel-item\" data-gjs-type=\"carousel-item\" data-gjs-custom-name=\"Carousel Item\">\n    <img class=\"d-block img-fluid\" data-gjs-type=\"bs-image\" style=\"width: 100%\" src=\"https://picsum.photos/1250/400\" alt=\"Third slide\">\n  </div>\n</div>\n<a class=\"carousel-control-prev\" href=\"#").concat(ta, "\" role=\"button\" data-slide=\"prev\">\n  <span class=\"carousel-control-prev-icon\" aria-hidden=\"true\" data-gjs-type=\"carousel-control-prev-icon\" data-gjs-custom-name=\"Prev\"></span>\n  <span class=\"sr-only\">Previous</span>\n</a>\n<a class=\"carousel-control-next\" href=\"#").concat(ta, "\" role=\"button\" data-slide=\"next\">\n  <span class=\"carousel-control-next-icon\" aria-hidden=\"true\" data-gjs-type=\"carousel-control-next-icon\" data-gjs-custom-name=\"Next\"></span>\n  <span class=\"sr-only\">Next</span>\n</a>\n</div>")
      }, {
        label: "Carousel 004",
        value: "carousel04",
        view: "\n<div class=\"dc-sview sContainer\">\n    <span span=\"12\" class=\"dc-scview dc-carousel-s12\">\n    <img class=\"d-block img-fluid\" style=\"height:100px; width: 220px\" src=\"https://public-webconnect.s3.amazonaws.com/static/image/Carousel-004.gif\" alt=\"Carousel 004\">\n    </span>\n</div>",
        code: "<div id=\"".concat(ta, "\" class=\"carousel slide\" data-ride=\"carousel\" data-gjs-type=\"carousel-container\" data-gjs-custom-name=\"Carousel\" data-pause=\"hover\" data-interval=\"5000\">\n<div class=\"carousel-inner\" data-gjs-type=\"carousel-inner\" data-gjs-custom-name=\"Carousel Container\">\n  <div class=\"carousel-item active\" data-gjs-type=\"carousel-item\" data-gjs-custom-name=\"Carousel Item\">\n    <img class=\"d-block img-fluid\" data-gjs-type=\"bs-image\" style=\"width: 100%\" src=\"https://picsum.photos/1250/400\" alt=\"First slide\">\n    <div class=\"carousel-caption d-none d-md-block\" data-gjs-type=\"carousel-caption\" data-gjs-custom-name=\"Carousel Caption\">\n      <h5>First Slide Label</h5>\n      <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>\n    </div>\n  </div>\n  <div class=\"carousel-item\" data-gjs-type=\"carousel-item\" data-gjs-custom-name=\"Carousel Item\">\n    <img class=\"d-block img-fluid\" data-gjs-type=\"bs-image\" style=\"width: 100%\" src=\"https://picsum.photos/1250/400\" alt=\"Second slide\">\n    <div class=\"carousel-caption d-none d-md-block\" data-gjs-type=\"carousel-caption\" data-gjs-custom-name=\"Carousel Caption\">\n      <h5>Second Slide Label</h5>\n      <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>\n    </div>\n  </div>\n  <div class=\"carousel-item\" data-gjs-type=\"carousel-item\" data-gjs-custom-name=\"Carousel Item\">\n    <img class=\"d-block img-fluid\" data-gjs-type=\"bs-image\" style=\"width: 100%\" src=\"https://picsum.photos/1250/400\" alt=\"Third slide\">\n    <div class=\"carousel-caption d-none d-md-block\" data-gjs-type=\"carousel-caption\" data-gjs-custom-name=\"Carousel Caption\">\n      <h5>Third Slide Label</h5>\n      <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>\n    </div>\n  </div>\n</div>\n</div>")
      }, {
        label: "Carousel 005",
        value: "carousel05",
        view: "\n<div class=\"dc-sview sContainer\">\n    <span span=\"12\" class=\"dc-scview dc-carousel-s12\">\n    <img class=\"d-block img-fluid\" style=\"height:100px; width: 220px\" src=\"https://public-webconnect.s3.amazonaws.com/static/image/Carousel-005.gif\" alt=\"Carousel 005\">\n    </span>\n</div>",
        code: "<div id=\"".concat(ta, "\" class=\"carousel slide\" data-ride=\"carousel\" data-gjs-type=\"carousel-container\" data-gjs-custom-name=\"Carousel\" data-pause=\"hover\" data-interval=\"5000\">\n<div class=\"carousel-inner\" data-gjs-type=\"carousel-inner\" data-gjs-custom-name=\"Carousel Container\">\n  <div class=\"carousel-item active\" data-gjs-type=\"carousel-item\" data-gjs-custom-name=\"Carousel Item\">\n    <img class=\"d-block img-fluid\" data-gjs-type=\"bs-image\" style=\"width: 100%\" src=\"https://picsum.photos/1250/400\" alt=\"First slide\">\n    <div class=\"carousel-caption d-none d-md-block\" data-gjs-type=\"carousel-caption\" data-gjs-custom-name=\"Carousel Caption\">\n      <h5>First Slide Label</h5>\n      <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>\n    </div>\n  </div>\n  <div class=\"carousel-item\" data-gjs-type=\"carousel-item\" data-gjs-custom-name=\"Carousel Item\">\n    <img class=\"d-block img-fluid\" data-gjs-type=\"bs-image\" style=\"width: 100%\" src=\"https://picsum.photos/1250/400\" alt=\"Second slide\">\n    <div class=\"carousel-caption d-none d-md-block\" data-gjs-type=\"carousel-caption\" data-gjs-custom-name=\"Carousel Caption\">\n      <h5>Second Slide Label</h5>\n      <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>\n    </div>\n  </div>\n  <div class=\"carousel-item\" data-gjs-type=\"carousel-item\" data-gjs-custom-name=\"Carousel Item\">\n    <img class=\"d-block img-fluid\" data-gjs-type=\"bs-image\" style=\"width: 100%\" src=\"https://picsum.photos/1250/400\" alt=\"Third slide\">\n    <div class=\"carousel-caption d-none d-md-block\" data-gjs-type=\"carousel-caption\" data-gjs-custom-name=\"Carousel Caption\">\n      <h5>Third Slide Label</h5>\n      <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>\n    </div>\n  </div>\n</div>\n<a class=\"carousel-control-prev\" href=\"#").concat(ta, "\" role=\"button\" data-slide=\"prev\">\n  <span class=\"carousel-control-prev-icon\" aria-hidden=\"true\" data-gjs-type=\"carousel-control-prev-icon\" data-gjs-custom-name=\"Prev\"></span>\n  <span class=\"sr-only\">Previous</span>\n</a>\n<a class=\"carousel-control-next\" href=\"#").concat(ta, "\" role=\"button\" data-slide=\"next\">\n  <span class=\"carousel-control-next-icon\" aria-hidden=\"true\" data-gjs-type=\"carousel-control-next-icon\" data-gjs-custom-name=\"Next\"></span>\n  <span class=\"sr-only\">Next</span>\n</a>\n</div>")
      }, {
        label: "Carousel 006",
        value: "carousel06",
        view: "\n<div class=\"dc-sview sContainer\">\n    <span span=\"12\" class=\"dc-scview dc-carousel-s12\">\n    <img class=\"d-block img-fluid\" style=\"height:100px; width: 220px\" src=\"https://public-webconnect.s3.amazonaws.com/static/image/Carousel-006-1.gif\" alt=\"Carousel 006\">\n    </span>\n</div>",
        code: "<div id=\"".concat(ta, "\" class=\"carousel slide\" data-ride=\"carousel\" data-gjs-type=\"carousel-container\" data-gjs-custom-name=\"Carousel\" data-pause=\"hover\" data-interval=\"5000\">\n<ol class=\"carousel-indicators\" data-gjs-type=\"carousel-indicators\" data-gjs-custom-name=\"Carousel Indicators\">\n  <li data-target=\"#").concat(ta, "\" data-slide-to=\"0\" class=\"active\" data-gjs-type=\"carousel-list-item\"></li>\n  <li data-target=\"#").concat(ta, "\" data-slide-to=\"1\" data-gjs-type=\"carousel-list-item\"></li>\n  <li data-target=\"#").concat(ta, "\" data-slide-to=\"2\" data-gjs-type=\"carousel-list-item\"></li>\n</ol>\n<div class=\"carousel-inner\" data-gjs-type=\"carousel-inner\" data-gjs-custom-name=\"Carousel Container\">\n  <div class=\"carousel-item active\" data-gjs-type=\"carousel-item\" data-gjs-custom-name=\"Carousel Item\">\n    <img class=\"d-block img-fluid\" data-gjs-type=\"bs-image\" style=\"width: 100%\" src=\"https://picsum.photos/1250/400\" alt=\"First slide\">\n    <div class=\"carousel-caption d-none d-md-block\" data-gjs-type=\"carousel-caption\" data-gjs-custom-name=\"Carousel Caption\">\n      <h5>First Slide Label</h5>\n      <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>\n    </div>\n  </div>\n  <div class=\"carousel-item\" data-gjs-type=\"carousel-item\" data-gjs-custom-name=\"Carousel Item\">\n    <img class=\"d-block img-fluid\" data-gjs-type=\"bs-image\" style=\"width: 100%\" src=\"https://picsum.photos/1250/400\" alt=\"Second slide\">\n    <div class=\"carousel-caption d-none d-md-block\" data-gjs-type=\"carousel-caption\" data-gjs-custom-name=\"Carousel Caption\">\n      <h5>Second Slide Label</h5>\n      <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>\n    </div>\n  </div>\n  <div class=\"carousel-item\" data-gjs-type=\"carousel-item\" data-gjs-custom-name=\"Carousel Item\">\n    <img class=\"d-block img-fluid\" data-gjs-type=\"bs-image\" style=\"width: 100%\" src=\"https://picsum.photos/1250/400\" alt=\"Third slide\">\n    <div class=\"carousel-caption d-none d-md-block\" data-gjs-type=\"carousel-caption\" data-gjs-custom-name=\"Carousel Caption\">\n      <h5>Third Slide Label</h5>\n      <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>\n    </div>\n  </div>\n</div>\n<a class=\"carousel-control-prev\" href=\"#").concat(ta, "\" role=\"button\" data-slide=\"prev\">\n  <span class=\"carousel-control-prev-icon\" aria-hidden=\"true\" data-gjs-type=\"carousel-control-prev-icon\" data-gjs-custom-name=\"Prev\"></span>\n  <span class=\"sr-only\">Previous</span>\n</a>\n<a class=\"carousel-control-next\" href=\"#").concat(ta, "\" role=\"button\" data-slide=\"next\">\n  <span class=\"carousel-control-next-icon\" aria-hidden=\"true\" data-gjs-type=\"carousel-control-next-icon\" data-gjs-custom-name=\"Next\"></span>\n  <span class=\"sr-only\">Next</span>\n</a>\n</div>")
      }],
      na = "dc-card-" + st()(8, ""),
      ia = "<div id=\"".concat(na, "\" class=\"card\" data-gjs-type=\"card\">\n<div class=\"card-body\" data-gjs-type=\"card-body\">\n  <h5 class=\"card-title\">Card title</h5>\n  <h6 class=\"card-subtitle mb-2 text-muted\">Card subtitle</h6>\n  <p class=\"card-text\">Some quick example text to build on the card title and make up the bulk of the card's content.</p>\n  <a href=\"#\" class=\"card-link\">Card link</a>\n  <a href=\"#\" class=\"card-link\">Another link</a>\n</div>\n</div>"),
      ra = "<div id=\"".concat(na, "\" class=\"card text-center card-full\"  data-gjs-type=\"card\" data-gjs-custom-name=\"Full Card\">\n  <div class=\"card-header\" data-gjs-type=\"card-header\">\n    Featured\n  </div>\n  <div class=\"card-body\" data-gjs-type=\"card-body\">\n    <h5 class=\"card-title\">Special title treatment</h5>\n    <p class=\"card-text\">With supporting text below as a natural lead-in to additional content.</p>\n    <a href=\"#\" class=\"btn btn-primary\">Go somewhere</a>\n  </div>\n  <div class=\"card-footer text-muted\" data-gjs-type=\"card-footer\">\n    2 days ago\n  </div>\n</div>"),
      aa = "<div id=\"".concat(na, "\" class=\"card card-image\"  data-gjs-type=\"card\" data-gjs-custom-name=\"Image Card\">\n  <img class=\"card-img-top\" src=\"https://picsum.photos/831/450\" alt=\"Card Image\">\n  <div class=\"card-body\" data-gjs-type=\"card-body\">\n    <h5 class=\"card-title\">Card title</h5>\n    <p class=\"card-text\">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>\n    <p class=\"card-text\"><small class=\"text-muted\">Last updated 3 mins ago</small></p>\n    <a href=\"#\" class=\"btn btn-primary\">Go somewhere</a>\n  </div>\n</div>"),
      oa = "\n<div id=\"".concat(na, "\" class=\"card card-004 profile-card\"  data-gjs-type=\"card\" data-gjs-custom-name=\"Card 004\">\n<div class=\"profile-card-1\" data-gjs-type=\"card-body\">\n  <img src=\"https://images.pexels.com/photos/946351/pexels-photo-946351.jpeg?w=500&h=650&auto=compress&cs=tinysrgb\" alt=\"profile-sample1\" class=\"background\"/>\n  <img src=\"https://randomuser.me/api/portraits/women/20.jpg\" alt=\"profile-image\" class=\"profile\"/>\n      <div class=\"card-content\">\n        <h2>Savannah Fields<small>Engineer</small></h3>\n        <div class=\"icon-block\"><a href=\"#\">\n          <i data-gjs-type=\"drapcode-icons\" draggable=\"true\" data-js=\"drapcode-icons\" class=\"drapcode-icons\"><svg data-gjs-type=\"svg\" draggable=\"false\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-gjs=\"drapcode-icons-svg\" class=\"feather feather-facebook gjs-selected\"><path data-gjs-type=\"svg-in\" draggable=\"true\" d=\"M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z\" id=\"i1yg3\" class=\"\">\n          </path></svg></i></a>\n          <a href=\"#\">\n          <i data-gjs-type=\"drapcode-icons\" draggable=\"true\" data-highlightable=\"1\" data-js=\"drapcode-icons\" class=\"drapcode-icons gjs-selected\"><svg data-gjs-type=\"svg\" draggable=\"false\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-gjs=\"drapcode-icons-svg\" class=\"feather feather-twitter\"><path data-gjs-type=\"svg-in\" draggable=\"true\" d=\"M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z\" id=\"ildh4\">\n          </path></svg></i></a>\n          <a href=\"#\"><i data-gjs-type=\"drapcode-icons\" draggable=\"true\" data-highlightable=\"1\" data-js=\"drapcode-icons\" class=\"drapcode-icons gjs-selected\"><svg data-gjs-type=\"svg\" draggable=\"false\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-gjs=\"drapcode-icons-svg\" class=\"feather feather-linkedin\"><path data-gjs-type=\"svg-in\" draggable=\"true\" d=\"M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z\" id=\"iwnqx\">\n          </path><rect data-gjs-type=\"svg-in\" draggable=\"true\" x=\"2\" y=\"9\" width=\"4\" height=\"12\" id=\"iqbsb\">\n          </rect><circle data-gjs-type=\"svg-in\" draggable=\"true\" cx=\"4\" cy=\"4\" r=\"2\" id=\"i6x2d\">\n          </circle></svg></i></a>\n        </div>\n      </div>\n  </div>\n</div>"),
      sa = "\n<div id=\"".concat(na, "\" class=\"card card-005 profile-card\"  data-gjs-type=\"card\" data-gjs-custom-name=\"Card 005\">\n  <div class=\"profile-card-3\" data-gjs-type=\"card-body\">\n    <div class=\"background-block\"  data-gjs-type=\"image-block\">\n        <img src=\"https://images.pexels.com/photos/459225/pexels-photo-459225.jpeg?auto=compress&cs=tinysrgb&h=650&w=940\" alt=\"profile-sample1\" class=\"background\"/>\n    </div>\n    <div class=\"profile-thumb-block\">\n        <img src=\"https://randomuser.me/api/portraits/men/41.jpg\" alt=\"profile-image\" class=\"profile\"/>\n    </div>\n    <div class=\"card-content\">\n        <h2>Justin Mccoy<small>Designer</small></h3>\n        <div class=\"icon-block\"><a href=\"#\">\n          <i data-gjs-type=\"drapcode-icons\" draggable=\"true\" data-js=\"drapcode-icons\" class=\"drapcode-icons\"><svg data-gjs-type=\"svg\" draggable=\"false\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-gjs=\"drapcode-icons-svg\" class=\"feather feather-facebook gjs-selected\"><path data-gjs-type=\"svg-in\" draggable=\"true\" d=\"M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z\" id=\"i1yg3\" class=\"\">\n          </path></svg></i></a>\n          <a href=\"#\">\n          <i data-gjs-type=\"drapcode-icons\" draggable=\"true\" data-highlightable=\"1\" data-js=\"drapcode-icons\" class=\"drapcode-icons gjs-selected\"><svg data-gjs-type=\"svg\" draggable=\"false\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-gjs=\"drapcode-icons-svg\" class=\"feather feather-twitter\"><path data-gjs-type=\"svg-in\" draggable=\"true\" d=\"M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z\" id=\"ildh4\">\n          </path></svg></i></a>\n          <a href=\"#\"><i data-gjs-type=\"drapcode-icons\" draggable=\"true\" data-highlightable=\"1\" data-js=\"drapcode-icons\" class=\"drapcode-icons gjs-selected\"><svg data-gjs-type=\"svg\" draggable=\"false\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-gjs=\"drapcode-icons-svg\" class=\"feather feather-linkedin\"><path data-gjs-type=\"svg-in\" draggable=\"true\" d=\"M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z\" id=\"iwnqx\">\n          </path><rect data-gjs-type=\"svg-in\" draggable=\"true\" x=\"2\" y=\"9\" width=\"4\" height=\"12\" id=\"iqbsb\">\n          </rect><circle data-gjs-type=\"svg-in\" draggable=\"true\" cx=\"4\" cy=\"4\" r=\"2\" id=\"i6x2d\">\n          </circle></svg></i></a>\n        </div>\n    </div>\n  </div>\n</div>"),
      la = "\n<div id=\"".concat(na, "\" class=\"card-006 profile-card\"  data-gjs-type=\"card\" data-gjs-custom-name=\"Card 006\">\n  <div class=\"card profile-card-5\" data-gjs-type=\"profile-card\">\n  <div class=\"card-img-block\">\n      <img class=\"card-img-top\" src=\"https://images.unsplash.com/photo-1517832207067-4db24a2ae47c\" alt=\"Card image cap\">\n  </div>\n      <div class=\"card-body pt-0\" data-gjs-type=\"card-body\">\n      <h5 class=\"card-title\">Florence Garza</h5>\n      <p class=\"card-text\">Some quick example text to build on the card title and make up the bulk of the card's content.</p>\n    </div>\n  </div>\n</div>"),
      ca = "\n<div id=\"".concat(na, "\" class=\"card card-007 product-card\"  data-gjs-type=\"card\" data-gjs-custom-name=\"Card 007\">\n\x3c!-- List group--\x3e\n<ul class=\"list-group\">\n\n  \x3c!-- list group item--\x3e\n  <li class=\"list-group-item\">\n    \x3c!-- Custom content--\x3e\n    <div class=\"media align-items-lg-center flex-column flex-lg-row p-3\">\n      <div class=\"media-body order-2 order-lg-1\">\n        <h5 class=\"mt-0 font-weight-bold mb-2\">Awesome product</h5>\n        <p class=\"font-italic text-muted mb-0 small\">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Suscipit fuga autem maiores necessitatibus.</p>\n        <div class=\"d-flex align-items-center justify-content-between mt-1\">\n          <h6 class=\"font-weight-bold my-2\">$120.00</h6>\n          <ul class=\"list-inline small\">\n            <li class=\"list-inline-item m-0\">\n              <i data-gjs-type=\"drapcode-icons\" draggable=\"true\" data-highlightable=\"1\" data-js=\"drapcode-icons\" class=\"drapcode-icons text-success\">\n              <svg data-gjs-type=\"svg\" draggable=\"false\" xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"#28a745 \" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-gjs=\"drapcode-icons-svg\" class=\"feather feather-star\"><polygon data-gjs-type=\"svg-in\" draggable=\"true\" points=\"12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2\">\n              </polygon></svg></i><i data-gjs-type=\"drapcode-icons\" draggable=\"true\" data-highlightable=\"1\" data-js=\"drapcode-icons\" class=\"drapcode-icons text-success\">\n              <svg data-gjs-type=\"svg\" draggable=\"false\" xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"#28a745 \" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-gjs=\"drapcode-icons-svg\" class=\"feather feather-star\"><polygon data-gjs-type=\"svg-in\" draggable=\"true\" points=\"12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2\">\n              </polygon></svg></i><i data-gjs-type=\"drapcode-icons\" draggable=\"true\" data-highlightable=\"1\" data-js=\"drapcode-icons\" class=\"drapcode-icons text-success\">\n              <svg data-gjs-type=\"svg\" draggable=\"false\" xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"#28a745 \" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-gjs=\"drapcode-icons-svg\" class=\"feather feather-star\"><polygon data-gjs-type=\"svg-in\" draggable=\"true\" points=\"12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2\">\n              </polygon></svg></i><i data-gjs-type=\"drapcode-icons\" draggable=\"true\" data-highlightable=\"1\" data-js=\"drapcode-icons\" class=\"drapcode-icons text-success\">\n              <svg data-gjs-type=\"svg\" draggable=\"false\" xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"#28a745 \" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-gjs=\"drapcode-icons-svg\" class=\"feather feather-star\"><polygon data-gjs-type=\"svg-in\" draggable=\"true\" points=\"12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2\">\n              </polygon></svg></i><i data-gjs-type=\"drapcode-icons\" draggable=\"true\" data-highlightable=\"1\" data-js=\"drapcode-icons\" class=\"drapcode-icons text-gray\">\n              <svg data-gjs-type=\"svg\" draggable=\"false\" xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-gjs=\"drapcode-icons-svg\" class=\"feather feather-star\"><polygon data-gjs-type=\"svg-in\" draggable=\"true\" points=\"12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2\">\n              </polygon></svg></i>\n            </li>\n          </ul>\n        </div>\n      </div><img src=\"https://i.imgur.com/JvPeqEF.jpg\" alt=\"Generic placeholder image\" width=\"200\" class=\"ml-lg-5 order-1 order-lg-2\">\n    </div>\n    \x3c!-- End --\x3e\n  </li>\n  \x3c!-- End --\x3e\n  </ul>\n  \x3c!-- End --\x3e\n</div>"),
      da = "\n<div id=\"".concat(na, "\" class=\"card card-008\"  data-gjs-type=\"card\" data-gjs-custom-name=\"Card 008\">\n  <div class=\"row p-2 bg-white border rounded\">\n  <div class=\"col-md-3 mt-1\"><img class=\"img-fluid img-responsive rounded product-image\" src=\"https://i.imgur.com/QpjAiHq.jpg\"></div>\n  <div class=\"col-md-6 mt-1\">\n      <h5>Quant olap shirts</h5>\n      <div class=\"d-flex flex-row\">\n          <div class=\"ratings mr-2\">\n            <i data-gjs-type=\"drapcode-icons\" draggable=\"true\" data-highlightable=\"1\" data-js=\"drapcode-icons\" class=\"drapcode-icons\">\n          <svg data-gjs-type=\"svg\" draggable=\"false\" xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"red\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-gjs=\"drapcode-icons-svg\" class=\"feather feather-star\"><polygon data-gjs-type=\"svg-in\" draggable=\"true\" points=\"12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2\"></polygon></svg></i><i data-gjs-type=\"drapcode-icons\" draggable=\"true\" data-highlightable=\"1\" data-js=\"drapcode-icons\" class=\"drapcode-icons\">\n          <svg data-gjs-type=\"svg\" draggable=\"false\" xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"red\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-gjs=\"drapcode-icons-svg\" class=\"feather feather-star\"><polygon data-gjs-type=\"svg-in\" draggable=\"true\" points=\"12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2\"></polygon></svg></i><i data-gjs-type=\"drapcode-icons\" draggable=\"true\" data-highlightable=\"1\" data-js=\"drapcode-icons\" class=\"drapcode-icons\">\n          <svg data-gjs-type=\"svg\" draggable=\"false\" xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"red\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-gjs=\"drapcode-icons-svg\" class=\"feather feather-star\"><polygon data-gjs-type=\"svg-in\" draggable=\"true\" points=\"12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2\"></polygon></svg></i><i data-gjs-type=\"drapcode-icons\" draggable=\"true\" data-highlightable=\"1\" data-js=\"drapcode-icons\" class=\"drapcode-icons\">\n          <svg data-gjs-type=\"svg\" draggable=\"false\" xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"red\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-gjs=\"drapcode-icons-svg\" class=\"feather feather-star\"><polygon data-gjs-type=\"svg-in\" draggable=\"true\" points=\"12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2\"></polygon></svg></i>\n          </div><span>310</span>\n      </div>\n      <div class=\"mt-1 mb-1 spec-1\"><span>100% cotton</span><span class=\"dot\"></span><span>Light weight</span><span class=\"dot\"></span><span>Best finish<br></span></div>\n      <div class=\"mt-1 mb-1 spec-1\"><span>Unique design</span><span class=\"dot\"></span><span>For men</span><span class=\"dot\"></span><span>Casual<br></span></div>\n      <p class=\"text-justify text-truncate para mb-0\">There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.<br><br></p>\n  </div>\n  <div class=\"align-items-center align-content-center col-md-3 border-left mt-1\">\n      <div class=\"d-flex flex-row align-items-center\">\n          <h5 class=\"mr-1\">$13.99</h5><span class=\"strike-text\">$20.99</span>\n      </div>\n      <h6 class=\"text-success\">Free shipping</h6>\n      <div class=\"d-flex flex-column mt-4\"><button class=\"btn btn-primary btn-sm\" type=\"button\">Details</button><button class=\"btn btn-outline-primary btn-sm mt-2\" type=\"button\">Add to wishlist</button></div>\n  </div>\n  </div>\n</div>\n"),
      ua = "\n<div id=\"".concat(na, "\" class=\"card card-009 product-card\"  data-gjs-type=\"card\" data-gjs-custom-name=\"Card 009\">\n  <div class=\"card-body\" data-gjs-type=\"card-body\">\n    <div class=\"media align-items-center align-items-lg-start text-center text-lg-left flex-column flex-lg-row\">\n        <div class=\"mr-2 mb-3 mb-lg-0\"> <img src=\"https://i.imgur.com/5Aqgz7o.jpg\" width=\"150\" height=\"150\" alt=\"\"> </div>\n        <div class=\"media-body\">\n            <h6 class=\"media-title font-weight-semibold\"> <a href=\"#\" data-abc=\"true\">Apple iPhone XR (Red, 128 GB)</a> </h6>\n            <ul class=\"list-inline list-inline-dotted mb-3 mb-lg-2\">\n                <li class=\"list-inline-item\"><a href=\"#\" class=\"text-muted\" data-abc=\"true\">Phones</a></li>\n                <li class=\"list-inline-item\"><a href=\"#\" class=\"text-muted\" data-abc=\"true\">Mobiles</a></li>\n            </ul>\n            <p class=\"mb-3\">128 GB ROM | 15.49 cm (6.1 inch) Display 12MP Rear Camera | 7MP Front Camera A12 Bionic Chip Processor | Gorilla Glass with high quality display </p>\n            <ul class=\"list-inline list-inline-dotted mb-0\">\n                <li class=\"list-inline-item\">All items from <a href=\"#\" data-abc=\"true\">Mobile point</a></li>\n                <li class=\"list-inline-item\">Add to <a href=\"#\" data-abc=\"true\">wishlist</a></li>\n            </ul>\n        </div>\n        <div class=\"mt-3 mt-lg-0 ml-lg-3 text-center\">\n            <h3 class=\"mb-0 font-weight-semibold\">$459.99</h3>\n            <div>\n              <i data-gjs-type=\"drapcode-icons\" draggable=\"true\" data-highlightable=\"1\" data-js=\"drapcode-icons\" class=\"drapcode-icons gjs-selected\"><svg data-gjs-type=\"svg\" draggable=\"false\" xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"#1e1e1e\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-gjs=\"drapcode-icons-svg\" class=\"feather feather-star\"><polygon data-gjs-type=\"svg-in\" draggable=\"true\" points=\"12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2\">\n              </polygon></svg></i>\n              <i data-gjs-type=\"drapcode-icons\" draggable=\"true\" data-highlightable=\"1\" data-js=\"drapcode-icons\" class=\"drapcode-icons gjs-selected\"><svg data-gjs-type=\"svg\" draggable=\"false\" xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"#1e1e1e\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-gjs=\"drapcode-icons-svg\" class=\"feather feather-star\"><polygon data-gjs-type=\"svg-in\" draggable=\"true\" points=\"12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2\">\n              </polygon></svg></i>\n              <i data-gjs-type=\"drapcode-icons\" draggable=\"true\" data-highlightable=\"1\" data-js=\"drapcode-icons\" class=\"drapcode-icons gjs-selected\"><svg data-gjs-type=\"svg\" draggable=\"false\" xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"#1e1e1e\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-gjs=\"drapcode-icons-svg\" class=\"feather feather-star\"><polygon data-gjs-type=\"svg-in\" draggable=\"true\" points=\"12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2\">\n              </polygon></svg></i>\n              <i data-gjs-type=\"drapcode-icons\" draggable=\"true\" data-highlightable=\"1\" data-js=\"drapcode-icons\" class=\"drapcode-icons gjs-selected\"><svg data-gjs-type=\"svg\" draggable=\"false\" xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"#1e1e1e\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-gjs=\"drapcode-icons-svg\" class=\"feather feather-star\"><polygon data-gjs-type=\"svg-in\" draggable=\"true\" points=\"12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2\">\n              </polygon></svg></i>\n            </div>\n            <div class=\"text-muted\">1985 reviews</div> <button type=\"button\" class=\"btn btn-warning mt-4 text-white\"><i class=\"icon-cart-add mr-2\"></i> Add to cart</button>\n        </div>\n    </div>\n  </div>\n</div>\n"),
      ha = "\n<div id=\"".concat(na, "\" class=\"card p-3 card-010 product-card\"  data-gjs-type=\"card\" data-gjs-custom-name=\"Card 010\">\n<div class=\"card-body\" data-gjs-type=\"card-body\">\n<div></div>\n<div class=\"about-product text-center mt-2\">\n<img src=\"https://i.imgur.com/3VTaSeb.png\" width=\"300\">\n    <div>\n        <h4>Believing is seeing</h4>\n        <h6 class=\"mt-0 text-black-50\">Apple pro display XDR</h6>\n    </div>\n</div>\n<div class=\"stats mt-2\">\n    <div class=\"d-flex justify-content-between p-price\"><span>Pro Display XDR</span><span>₹5,999</span></div>\n    <div class=\"d-flex justify-content-between p-price\"><span>Pro stand</span><span>₹999</span></div>\n    <div class=\"d-flex justify-content-between p-price\"><span>Vesa Mount Adapter</span><span>₹199</span></div>\n</div>\n<div class=\"d-flex justify-content-between total font-weight-bold mt-4\"><span>Total</span><span>₹7,197.00</span></div>\n</div>\n</div>\n"),
      pa = "\n<div id=\"".concat(na, "\" class=\"card card-011\"  data-gjs-type=\"card\" data-gjs-custom-name=\"Card 011\">\n  <div class=\"product-grid\">\n    <div class=\"product-image\">\n        <a href=\"#\" class=\"image\">\n            <img class=\"pic-1\" src=\"https://public-webconnect.s3.amazonaws.com/static/image/Card-011-img.jpg\">\n        </a>\n        <span class=\"product-sale-label\">Sale!</span>\n        <ul class=\"product-links\">\n            <li><a href=\"#\">\n                <i data-js=\"drapcode-icons\" class=\"drapcode-icons\">\n                <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-gjs=\"drapcode-icons-svg\" draggable=\"false\" class=\"feather feather-shopping-cart\"><circle cx=\"9\" cy=\"21\" r=\"1\">\n                </circle><circle cx=\"20\" cy=\"21\" r=\"1\">\n                </circle><path d=\"M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6\">\n                </path></svg></i>\n            Add to cart</a></li>\n            <li><a href=\"#\">\n                <i data-js=\"drapcode-icons\" class=\"drapcode-icons\">\n                <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-gjs=\"drapcode-icons-svg\" draggable=\"false\" class=\"feather feather-search\"><circle cx=\"11\" cy=\"11\" r=\"8\">\n                </circle><line x1=\"21\" y1=\"21\" x2=\"16.65\" y2=\"16.65\">\n                </line></svg></i>\n            Quick View</a></li>\n        </ul>\n    </div>\n    <div class=\"product-content\">\n        <h3 class=\"title\"><a href=\"#\">Women's T-Shirt</a></h3>\n        <div class=\"price\"><span>$85.55</span> $71.11</div>\n    </div>\n  </div>\n</div>\n"),
      ga = "\n<div id=\"".concat(na, "\" class=\"card-012\"  data-gjs-type=\"card\" data-gjs-custom-name=\"Card 012\">\n    <div class=\"product-grid\">\n        <div class=\"product-image\">\n            <a href=\"#\" class=\"image\">\n                <img class=\"pic-1\" src=\"https://public-webconnect.s3.amazonaws.com/static/image/Card-012-img.jpg\">\n            </a>\n            <span class=\"product-discount-label\">-33%</span>\n        </div>\n        <div class=\"product-content\" data-gjs-custom-name=\"Product Content\">\n            <ul class=\"rating\" data-gjs-custom-name=\"Rating\">\n                <li>\n                    <i data-gjs-type=\"drapcode-icons\" draggable=\"true\" data-highlightable=\"1\" data-js=\"drapcode-icons\" class=\"drapcode-icons text-success\">\n                    <svg data-gjs-type=\"svg\" draggable=\"false\" xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"#28a745 \" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-gjs=\"drapcode-icons-svg\" class=\"feather feather-star\"><polygon data-gjs-type=\"svg-in\" draggable=\"true\" points=\"12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2\">\n                    </polygon></svg></i><i data-gjs-type=\"drapcode-icons\" draggable=\"true\" data-highlightable=\"1\" data-js=\"drapcode-icons\" class=\"drapcode-icons text-success\">\n                    <svg data-gjs-type=\"svg\" draggable=\"false\" xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"#28a745 \" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-gjs=\"drapcode-icons-svg\" class=\"feather feather-star\"><polygon data-gjs-type=\"svg-in\" draggable=\"true\" points=\"12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2\">\n                    </polygon></svg></i><i data-gjs-type=\"drapcode-icons\" draggable=\"true\" data-highlightable=\"1\" data-js=\"drapcode-icons\" class=\"drapcode-icons text-success\">\n                    <svg data-gjs-type=\"svg\" draggable=\"false\" xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"#28a745 \" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-gjs=\"drapcode-icons-svg\" class=\"feather feather-star\"><polygon data-gjs-type=\"svg-in\" draggable=\"true\" points=\"12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2\">\n                    </polygon></svg></i><i data-gjs-type=\"drapcode-icons\" draggable=\"true\" data-highlightable=\"1\" data-js=\"drapcode-icons\" class=\"drapcode-icons text-success\">\n                    <svg data-gjs-type=\"svg\" draggable=\"false\" xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"#28a745 \" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-gjs=\"drapcode-icons-svg\" class=\"feather feather-star\"><polygon data-gjs-type=\"svg-in\" draggable=\"true\" points=\"12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2\">\n                    </polygon></svg></i><i data-gjs-type=\"drapcode-icons\" draggable=\"true\" data-highlightable=\"1\" data-js=\"drapcode-icons\" class=\"drapcode-icons text-gray\">\n                    <svg data-gjs-type=\"svg\" draggable=\"false\" xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-gjs=\"drapcode-icons-svg\" class=\"feather feather-star\"><polygon data-gjs-type=\"svg-in\" draggable=\"true\" points=\"12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2\">\n                    </polygon></svg></i>\n                </li>\n            </ul>\n            <h3 class=\"title\"><a href=\"#\">Men's Blazer</a></h3>\n            <div class=\"price\"><span>$90.00</span> $66.00</div>\n            <a class=\"add-to-cart\" href=\"#\">add to cart</a>\n        </div>\n    </div>\n</div>\n"),
      fa = "drapcode-card",
      ma = [{
        label: "Card",
        value: "card01",
        view: "\n<div class=\"dc-cardView cardContainer\">\n    <span span=\"12\" class=\"dc-scview dc-card-s12\">\n    <img class=\"d-block img-fluid\" src=\"https://public-webconnect.s3.amazonaws.com/static/image/Card.png\" alt=\"Card\">\n    </span>\n</div>",
        code: ia
      }, {
        label: "Full Card",
        value: "card02",
        view: "\n<div class=\"dc-cardView cardContainer\">\n    <span span=\"12\" class=\"dc-scview dc-card-s12\">\n    <img class=\"d-block img-fluid\" src=\"https://public-webconnect.s3.amazonaws.com/static/image/Card-Full.png\" alt=\"Full Card\">\n    </span>\n</div>",
        code: ra
      }, {
        label: "Image Card",
        value: "card03",
        view: "\n<div class=\"dc-cardView cardContainer\">\n    <span span=\"12\" class=\"dc-scview dc-card-s12\">\n    <img class=\"d-block img-fluid\" src=\"https://public-webconnect.s3.amazonaws.com/static/image/Card-Image.png\" alt=\"Image Card\">\n    </span>\n</div>",
        code: aa
      }, {
        label: "Card 004",
        value: "card004",
        view: "\n<div class=\"dc-cardView cardContainer\">\n    <span span=\"12\" class=\"dc-scview dc-card-s12\">\n    <img class=\"d-block img-fluid\" src=\"https://public-webconnect.s3.amazonaws.com/static/image/Card-006.png\" alt=\"Card 004\">\n    </span>\n</div>",
        code: oa + "\n<style>\n  .card-004 .profile-card-1 {\n    font-family: 'Open Sans', Arial, sans-serif;\n    position: relative;\n    float: left;\n    overflow: hidden;\n    width: 100%;\n    color: #ffffff;\n    text-align: center;\n    height:368px;\n    border:none;\n  }\n  .card-004 .profile-card-1 .background {\n    width:100%;\n    vertical-align: top;\n    opacity: 0.9;\n    -webkit-filter: blur(5px);\n    filter: blur(5px);\n    -webkit-transform: scale(1.8);\n    transform: scale(2.8);\n  }\n  .card-004 .profile-card-1 .card-content {\n    width: 100%;\n    padding: 15px 25px;\n    position: absolute;\n    left: 0;\n    top: 50%;\n  }\n  .card-004 .profile-card-1 .profile {\n    border-radius: 50%;\n    position: absolute;\n    bottom: 50%;\n    left: 50%;\n    max-width: 100px;\n    opacity: 1;\n    box-shadow: 3px 3px 20px rgba(0, 0, 0, 0.5);\n    border: 2px solid rgba(255, 255, 255, 1);\n    -webkit-transform: translate(-50%, 0%);\n    transform: translate(-50%, 0%);\n  }\n  .card-004 .profile-card-1 h2 {\n    margin: 0 0 5px;\n    font-weight: 600;\n    font-size:25px;\n  }\n  .card-004 .profile-card-1 h2 small {\n    display: block;\n    font-size: 15px;\n    margin-top:10px;\n  }\n  .card-004 .profile-card-1 i {\n    display: inline-block;\n      font-size: 16px;\n      color: #ffffff;\n      text-align: center;\n      border: 1px solid #fff;\n      width: 30px;\n      height: 30px;\n      line-height: 30px;\n      border-radius: 50%;\n      margin:0 5px;\n  }\n  .card-004 .profile-card-1 .icon-block{\n      float:left;\n      width:100%;\n      margin-top:15px;\n  }\n  .card-004 .profile-card-1 .icon-block a{\n      text-decoration:none;\n  }\n  .card-004 .profile-card-1 i:hover {\n    background-color:#fff;\n    color:#2E3434;\n    text-decoration:none;\n  }\n</style>"
      }, {
        label: "Card 005",
        value: "card005",
        view: "\n<div class=\"dc-cardView cardContainer\">\n    <span span=\"12\" class=\"dc-scview dc-card-s12\">\n    <img class=\"d-block img-fluid\" src=\"https://public-webconnect.s3.amazonaws.com/static/image/Card-007.png\" alt=\"Card 005\">\n    </span>\n</div>",
        code: sa + "\n<style>\n.card-005 .profile-card-3 {\n  font-family: 'Open Sans', Arial, sans-serif;\n  position: relative;\n  float: left;\n  overflow: hidden;\n  width: 100%;\n  text-align: center;\n  height:368px;\n  border:none;\n}\n.card-005 .profile-card-3 .background-block {\n    float: left;\n    width: 100%;\n    height: 200px;\n    overflow: hidden;\n}\n.card-005 .profile-card-3 .background-block .background {\n  width:100%;\n  vertical-align: top;\n  opacity: 0.9;\n  -webkit-filter: blur(0.5px);\n  filter: blur(0.5px);\n   -webkit-transform: scale(1.8);\n  transform: scale(2.8);\n}\n.card-005 .profile-card-3 .card-content {\n  width: 100%;\n  padding: 15px 25px;\n  color:#232323;\n  float:left;\n  background:#efefef;\n  height:50%;\n  border-radius:0 0 5px 5px;\n  position: relative;\n  z-index: 9999;\n}\n.card-005 .profile-card-3 .card-content::before {\n    content: '';\n    background: #efefef;\n    width: 120%;\n    height: 100%;\n    left: 11px;\n    bottom: 51px;\n    position: absolute;\n    z-index: -1;\n    transform: rotate(-13deg);\n}\n.card-005 .profile-card-3 .profile {\n  border-radius: 50%;\n  position: absolute;\n  bottom: 50%;\n  left: 50%;\n  max-width: 100px;\n  opacity: 1;\n  box-shadow: 3px 3px 20px rgba(0, 0, 0, 0.5);\n  border: 2px solid rgba(255, 255, 255, 1);\n  -webkit-transform: translate(-50%, 0%);\n  transform: translate(-50%, 0%);\n  z-index:99999;\n}\n.card-005 .profile-card-3 h2 {\n  margin: 0 0 5px;\n  font-weight: 600;\n  font-size:25px;\n}\n.card-005 .profile-card-3 h2 small {\n  display: block;\n  font-size: 15px;\n  margin-top:10px;\n}\n.card-005 .profile-card-3 i {\n  display: inline-block;\n    font-size: 16px;\n    color: #232323;\n    text-align: center;\n    border: 1px solid #232323;\n    width: 30px;\n    height: 30px;\n    line-height: 30px;\n    border-radius: 50%;\n    margin:0 5px;\n}\n.card-005 .profile-card-3 .icon-block{\n    float:left;\n    width:100%;\n    margin-top:15px;\n}\n.card-005 .profile-card-3 .icon-block a{\n    text-decoration:none;\n}\n.card-005 .profile-card-3 i:hover {\n  background-color:#232323;\n  color:#fff;\n  text-decoration:none;\n}\n</style>"
      }, {
        label: "Card 006",
        value: "card006",
        view: "\n<div class=\"dc-cardView cardContainer\">\n    <span span=\"12\" class=\"dc-scview dc-card-s12\">\n    <img class=\"d-block img-fluid\" src=\"https://public-webconnect.s3.amazonaws.com/static/image/Card-008.png\" alt=\"Card 006\">\n    </span>\n</div>",
        code: la + "\n<style>\n.card-006 .profile-card-5{\n    margin-top:20px;\n}\n.card-006 .profile-card-5 .btn{\n    border-radius:2px;\n    text-transform:uppercase;\n    font-size:12px;\n    padding:7px 20px;\n}\n.card-006 .profile-card-5 .card-img-block {\n    width: 91%;\n    margin: 0 auto;\n    position: relative;\n    top: -20px;\n    \n}\n.card-006 .profile-card-5 .card-img-block img{\n    border-radius:5px;\n    box-shadow:0 0 10px rgba(0,0,0,0.63);\n}\n.card-006 .profile-card-5 h5{\n    color:#4E5E30;\n    font-weight:600;\n}\n.card-006 .profile-card-5 p{\n    font-size:14px;\n    font-weight:300;\n}\n.card-006 .profile-card-5 .btn-primary{\n    background-color:#4E5E30;\n    border-color:#4E5E30;\n}\n</style>"
      }, {
        label: "Card 007",
        value: "card007",
        view: "\n<div class=\"dc-cardView cardContainer\">\n    <span span=\"12\" class=\"dc-scview dc-card-s12\">\n    <img class=\"d-block img-fluid\" src=\"https://public-webconnect.s3.amazonaws.com/static/image/Card-009.png\" alt=\"Card 007\">\n    </span>\n</div>",
        code: ca
      }, {
        label: "Card 008",
        value: "card008",
        view: "\n<div class=\"dc-cardView cardContainer\">\n    <span span=\"12\" class=\"dc-scview dc-card-s12\">\n    <img class=\"d-block img-fluid\" src=\"https://public-webconnect.s3.amazonaws.com/static/image/Card-012.png\" alt=\"Card 008\">\n    </span>\n</div>",
        code: da + "\n<style>\n.card-008 .ratings i {\n  font-size: 16px;\n  color: red\n}\n\n.card-008 .strike-text {\n  color: red;\n  text-decoration: line-through\n}\n\n.card-008 .product-image {\n  width: 100%\n}\n\n.card-008 .dot {\n  height: 7px;\n  width: 7px;\n  margin-left: 6px;\n  margin-right: 6px;\n  margin-top: 3px;\n  background-color: blue;\n  border-radius: 50%;\n  display: inline-block\n}\n\n.card-008 .spec-1 {\n  color: #938787;\n  font-size: 15px\n}\n\n.card-008 h5 {\n  font-weight: 400\n}\n\n.card-008 .para {\n  font-size: 16px\n}\n</style>"
      }, {
        label: "Card 009",
        value: "card009",
        view: "\n<div class=\"dc-cardView cardContainer\">\n    <span span=\"12\" class=\"dc-scview dc-card-s12\">\n    <img class=\"d-block img-fluid\" src=\"https://public-webconnect.s3.amazonaws.com/static/image/Card-005.png\" alt=\"Card 009\">\n    </span>\n</div>",
        code: ua
      }, {
        label: "Card 010",
        value: "card010",
        view: "\n<div class=\"dc-cardView cardContainer\">\n    <span span=\"12\" class=\"dc-scview dc-card-s12\">\n    <img class=\"d-block img-fluid\" src=\"https://public-webconnect.s3.amazonaws.com/static/image/Card-004.png\" alt=\"Card 010\">\n    </span>\n</div>",
        code: ha
      }, {
        label: "Card 011",
        value: "card011",
        view: "\n<div class=\"dc-cardView cardContainer\">\n    <span span=\"12\" class=\"dc-scview dc-card-s12\">\n    <img class=\"d-block img-fluid\" src=\"https://public-webconnect.s3.amazonaws.com/static/image/Card-011.png\" alt=\"Card 011\">\n    </span>\n</div>",
        code: pa + "\n<style>\n.card-011 .product-grid{\n  font-family: 'Poppins', sans-serif;\n  text-align: center;\n  border: 1px solid #e7e7e7;\n}\n.card-011 .product-grid .product-image{ position: relative; }\n.card-011 .product-grid .product-image a.image{ display: block; }\n.card-011 .product-grid .product-image img{\n  width: 100%;\n  height: auto;\n  transition: all 0.3s ease 0s;\n}\n.card-011 .product-grid .product-image:hover img{ transform: translate(10px,-10px); }\n.card-011 .product-grid .product-sale-label{\n  color: #fff;\n  background: #1abc9c;\n  font-size: 13px;\n  text-transform: capitalize;\n  line-height: 35px;\n  width: 55px;\n  height: 35px;\n  position: absolute;\n  top: 0;\n  right: 0;\n  animation: bg-animate 5s infinite linear;\n}\n.card-011 .product-grid .product-links{\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  bottom: 15px;\n  left: 20px;\n  transition: all 0.3s ease 0s;\n}\n.card-011 .product-grid:hover .product-links{ opacity: 1; }\n.card-011 .product-grid .product-links li{\n  margin: 0 0 5px;\n  opacity: 0;\n  transform: translateX(-100%);\n  transition: all 0.3s ease 0s;\n}\n.card-011 .product-grid:hover .product-links li:nth-child(2){ transition: all 0.3s ease 0.15s; }\n.card-011 .product-grid:hover .product-links li{\n  opacity: 1;\n  transform: translateX(0);\n}\n.card-011 .product-grid .product-links li a{\n  color: #fff;\n  background-color: #00b894;\n  font-size: 14px;\n  text-shadow: 0 0 3px rgba(0,0,0,0.7);\n  padding: 8px 10px;\n  display: block;\n  opacity: 0.9;\n  transition: all 0.3s ease 0s;\n  animation: bg-animate 5s infinite linear;\n}\n.card-011 .product-grid .product-links li a:hover{\n  color: #fff;\n  box-shadow: 0 0 0 3px #fff inset;\n  opacity: 1;\n}\n.card-011 .product-grid .product-links li a i{ margin: 0 5px 0 0; }\n.card-011 .product-grid .product-content{ padding: 15px 0 5px; }\n.card-011 .product-grid .title{\n  font-size: 17px;\n  font-weight: 400;\n  text-transform: capitalize;\n  padding: 0 10px 14px;\n  margin: 0 0 7px;\n  border-bottom: 1px solid #dfe5e9;\n}\n.card-011 .product-grid .title a{\n  color: #000;\n  transition: all 0.3s ease 0s;\n}\n.card-011 .product-grid .title a:hover{ animation: color-animate 5s infinite linear; }\n.card-011 .product-grid .price{\n  color: #1abc9c;\n  font-size: 20px;\n  font-weight: 400;\n  animation: color-animate 5s infinite linear;\n}\n.card-011 .product-grid .price span{\n  color: #999;\n  text-decoration: line-through;\n  margin: 0 3px 0 0;\n}\n@keyframes color-animate{\n  0%{ color: #00b894; }\n  20%{ color: #00cec9; }\n  40%{ color: #0984e3; }\n  60%{ color: #6c5ce7; }\n  80%{ color: #e84393; }\n  100%{ color: #00b894; }\n}\n@keyframes bg-animate{\n  0%{ background-color: #00b894; }\n  20%{ background-color: #00cec9; }\n  40%{ background-color: #0984e3; }\n  60%{ background-color: #6c5ce7; }\n  80%{ background-color: #e84393; }\n  100%{ background-color: #00b894; }\n}\n@media screen and (max-width:1200px){\n    .card-011 .product-grid{ margin: 0 0 30px; }\n}\n</style>"
      }, {
        label: "Card 012",
        value: "card012",
        view: "\n<div class=\"dc-cardView cardContainer\">\n    <span span=\"12\" class=\"dc-scview dc-card-s12\">\n    <img class=\"d-block img-fluid\" src=\"https://public-webconnect.s3.amazonaws.com/static/image/Card-013.png\" alt=\"Card 012\">\n    </span>\n</div>",
        code: ga + "\n<style>\n.card-012 .product-grid{\n    font-family: 'Poppins', sans-serif;\n    text-align: center;\n    border-radius: 15px;\n    border: 1px solid #e7e7e7;\n    overflow: hidden;\n    transition: all 0.4s ease-out;\n}\n.card-012 .product-grid:hover{ box-shadow: 5px 10px 30px rgba(0, 0, 0, 0.1); }\n.card-012 .product-grid .product-image{ position: relative; }\n.card-012 .product-grid .product-image a.image{ display: block; }\n.card-012 .product-grid .product-image img{\n    width: 100%;\n    height: auto;\n}\n.card-012 .product-grid .product-discount-label{\n    color: #fff;\n    background: #78a206;\n    font-size: 14px;\n    font-weight: 400;\n    text-transform: uppercase;\n    padding: 2px 8px;\n    border-radius: 5px;\n    position: absolute;\n    top: 12px;\n    left: 12px;\n}\n.card-012 .product-grid .product-links{\n    width: 145px;\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    opacity: 0;\n    transform: translateX(-50%) translateY(-50%);\n    position: absolute;\n    top: 65%;\n    left: 50%;\n    transition: all 0.4s ease 0s;\n}\n.card-012 .product-grid:hover .product-links{\n    opacity: 1;\n    top: 50%;\n}\n.card-012 .product-grid .product-links li{\n    display: inline-block;\n    margin: 0 2px;\n}\n.card-012 .product-grid .product-links li a{\n    color: #2c2c2c;\n    background: #fff;\n    font-size: 16px;\n    line-height: 42px;\n    width: 40px;\n    height: 40px;\n    border-radius: 50px;\n    display: block;\n    position: relative;\n    transition: all 0.4s ease-out 0s;\n}\n.card-012 .product-grid .product-links li a:hover{\n    color: #fff;\n    background: #78a206;\n    box-shadow: 1px 1px 30px 0 rgba(0, 0, 0, 0.2);\n}\n.card-012 .product-grid .product-links li a:before,\n.card-012 .product-grid .product-links li a:after{\n    content: attr(data-tip);\n    color: #fff;\n    background-color: #555;\n    font-size: 12px;\n    line-height: 18px;\n    padding: 5px 10px;\n    white-space: nowrap;\n    display: none;\n    transform: translateX(-50%);\n    position: absolute;\n    left: 50%;\n    top: -40px;\n    transition: all 0.3s ease 0s;\n}\n.card-012 .product-grid .product-links li a:after{\n    content: '';\n    height: 10px;\n    width: 10px;\n    padding: 0;\n    transform: translateX(-50%) rotate(45deg);\n    top: -18px;\n    z-index: -1;\n}\n.card-012 .product-grid .product-links li a:hover:before,\n.card-012 .product-grid .product-links li a:hover:after{\n    display: block;\n}\n.card-012 .product-grid .product-content{\n    padding: 12px 12px 15px;\n    position: relative;\n}\n.card-012 .product-grid .rating{\n    padding: 0;\n    margin: 0 0 8px;\n    list-style: none;\n}\n.card-012 .product-grid .rating li{\n    color: #78a206;\n    font-size: 14px;\n}\n.card-012 .product-grid .rating .far{ color: #808080; }\n.card-012 .product-grid .title{\n    font-size: 18px;\n    font-weight: 600;\n    text-transform: uppercase;\n    margin: 0 0 15px;\n}\n.card-012 .product-grid .title a{\n    color: #2c2c2c;\n    transition: all 0.3s ease 0s;\n}\n.card-012 .product-grid .title a:hover{ color: #78a206; }\n.card-012 .product-grid .price{\n    color: #78a206;\n    font-size: 17px;\n    font-weight: 600;\n    display: block;\n    transition: all 0.4s ease-in-out;\n}\n.card-012 .product-grid .price span{\n    color: #999;\n    font-weight: 500;\n    text-decoration: line-through;\n}\n.card-012 .product-grid:hover .price{ opacity: 0; }\n.card-012 .product-grid .add-to-cart{\n    color: #fff;\n    background-color: #78a206;\n    font-size: 16px;\n    font-weight: 500;\n    text-transform: uppercase;\n    line-height: 40px;\n    width: 140px;\n    height: 40px;\n    border-radius: 50px;\n    opacity: 0;\n    transform: translateX(-50%);\n    position: absolute;\n    bottom: 50px;\n    left: 50%;\n    transition: all .4s ease-out;\n}\n.card-012 .product-grid .add-to-cart:hover{ background-color: #2f2f2f; }\n.card-012 .product-grid:hover .add-to-cart{\n    opacity: 1;\n    bottom: 8px;\n}\n@media screen and (max-width:1200px){\n    .card-012 .product-grid{ margin: 0 0 30px; }\n}\n</style>\n"
      }],
      va = function va(t) {
        t.Config.canvasCss += "\n    /* Layout */\n    #wrapper{width:100%!important;position:inherit!important}\n    [data-gjs-type=wrapper]{width:100%;!important}\n    .gjs-dashed .container, .gjs-dashed .container-fluid,\n    .gjs-dashed .row,\n    .gjs-dashed .col, .gjs-dashed [class^=\"col-\"] {\n      min-height: 1.5rem;\n    }\n    .gjs-dashed .w-100 {\n      min-height: .25rem !important;\n      background-color: rgba(0,0,0,0.1);\n    }\n    .gjs-dashed img {\n      min-width: 25px;\n      min-height: 25px;\n      background-color: rgba(0,0,0,0.5);\n    }\n    /* Components */\n    .gjs-dashed .btn-group,\n    .gjs-dashed .btn-toolbar {\n      padding-right: 1.5rem !important;\n      min-height: 1.5rem !important;\n    }\n    .gjs-dashed .card,\n    .gjs-dashed .card-group, .gjs-dashed .card-deck, .gjs-dashed .card-columns {\n      min-height: 1.5rem !important;\n    }\n    .gjs-dashed .collapse {\n      display: block !important;\n      min-height: 1.5rem !important;\n    }\n    .gjs-dashed .dropdown {\n      display: block !important;\n      min-height: 1.5rem !important;\n    }\n    .gjs-dashed .dropdown-menu {\n      min-height: 1.5rem !important;\n      display: block !important;\n    }\n  ";
      };
    e["default"] = a.a.plugins.add("bootstrap4-blocks", function (t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      var n = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
          button: !0,
          card: !0,
          card_full: !0,
          card_image: !0,
          container: !0,
          row: !0,
          column: !0,
          media_object: !0,
          column_break: !0,
          text: !0,
          image: !0,
          video: !0,
          audio: !0,
          header: !0,
          paragraph: !0,
          input: !0,
          form_group_input: !0,
          input_group: !0,
          textarea: !0,
          select: !0,
          label: !0,
          checkbox: !0,
          radio: !0,
          tabs: !0,
          badge: !0,
          list: !1,
          grid: !1,
          navbar_old: !1,
          navbar: !0,
          nav_item_submenu: !0,
          jumbotron: !0,
          list_group: !0,
          side_bar: !0,
          accordions: !0,
          carousel: !1,
          footer: !0,
          modal: !0,
          facebook_button: !0,
          google_button: !0,
          sections: !0
        }, "sections", !0), "cards", !0), "linkBox", !0), "horizontalLine", !0), "verticalLine", !0), "box", !0), "table", !1), "breadcrumb", !0), "iframe", !0), "pagePlaceholder", !0),
        i = {
          button: "bootstrap_button",
          card: "card",
          card_full: "card-full",
          card_image: "card-image",
          container: "container",
          row: "row",
          column: "column",
          badge: "badge",
          column_break: "column_break",
          media_object: "media_object",
          text: "text",
          image: "bs-image",
          video: "bs-video",
          audio: "bs-audio",
          header: "header",
          paragraph: "paragraph",
          input: "input",
          file_input: "file",
          form_group_input: "form-group",
          input_group: "input-group",
          textarea: "textarea",
          select: "select",
          select_option: "- Select option -",
          option: "option",
          label: "label",
          checkbox: "checkbox",
          radio: "radio",
          list: "list",
          grid: "grid",
          navbar_old: "navbar_old",
          navbar: "navbar",
          navbar_container: "navbar-container",
          navbar_nav: "navbar-nav",
          nav_item_dropdown: "navbar_item_dropdown",
          nav_item_dropdown_menu: "navbar_item_dropdown_menu",
          nav_item_dropdown_toggle: "navbar_item_dropdown_toggle",
          nav_item: "nav-item",
          burgerType: "burger-menu",
          jumbotron: "jumbotron",
          list_group: "list-group",
          side_bar: "sidebar",
          tabs: "tabs",
          tab: "tab",
          tab_container: "tab-container",
          tab_content: "tab-content",
          accordions: "accordions",
          accordion: "accordion",
          accordion_container: "accordion-container",
          accordion_content: "accordion-content",
          sliders: "sliders",
          slider: "slider",
          slides: "slides",
          slide: "slide",
          nav_prev: "nav-prev",
          nav_next: "nav-next",
          slider_frame: "slider-frame",
          footer: "footer",
          modal: "modal",
          modal_dialog: "modal-dialog",
          modal_content: "modal-content",
          modal_header: "modal-header",
          modal_title: "modal-title",
          modal_body: "modal-body",
          modal_footer: "modal-footer",
          facebook_button: "facebook-button",
          google_button: "google-button",
          sections: Qr,
          carousels: Kr,
          cards: fa,
          link_box: "link-box",
          horizontal_line: "horizontal-line",
          vertical_line: "vertical-line",
          box: "box",
          table: "table",
          breadcrumb: "main-beadcrumb",
          iframe: "iframe",
          pagePlaceholder: "pagePlaceholder"
        },
        r = {
          button: "Button",
          card: "Card",
          card_full: "Full Card",
          card_image: "Image Card",
          container: "Container",
          row: "Row",
          column: "Column",
          column_break: "Column Break",
          media_object: "Media Object",
          text: "Text",
          image: "Image",
          video: "Video",
          audio: "Audio",
          header: "Heading",
          paragraph: "Paragraph",
          input: "Input",
          file_input: "File",
          form_group_input: "Form Group",
          input_group: "Input Group",
          textarea: "Textarea",
          select: "Select",
          select_option: "- Select option -",
          option: "Option",
          label: "Label",
          checkbox: "Checkbox",
          radio: "Radio",
          alert: "Alert",
          tabs: "Tabs",
          tab: "Tab",
          tab_container: "Tab Container",
          tab_content: "Tab Content",
          badge: "Badge",
          button_group: "Button Group",
          button_toolbar: "Button Toolbar",
          card_container: "Card Container",
          collapse: "Collapse",
          dropdown: "Dropdown",
          dropdown_menu: "Dropdown Menu",
          dropdown_item: "Dropdown Item",
          list: "List",
          grid: "Grid",
          navbar_old: "Navbar Old",
          navbar: "Navbar",
          labelNavbarContainer: "Navbar Container",
          labelNavbarNavigation: "Navbar Navigation",
          labelNavItem: "Navigation Item",
          labelNavItemSubMenu: "Sub Menu",
          labelNavItemSubMenuToggle: "Sub Menu Toggle",
          labelNavItemDropdownMenu: "Dropdown Menu",
          labelBurger: "Burger",
          labelBurgerLine: "Burger Line",
          labelHome: "Home",
          labelAbout: "About",
          labelContact: "Contact",
          labelMenu: "Navbar Menu",
          labelMenuLink: "Menu link",
          trait_id: "ID",
          trait_for: "For",
          trait_name: "Name",
          trait_placeholder: "Placeholder",
          trait_value: "Value",
          trait_required: "Required",
          trait_type: "Type",
          trait_options: "Options",
          trait_checked: "Checked",
          jumbotron: "Jumbotron",
          list_group: "List Group",
          side_bar: "Side Bar",
          accordions: "Accordions",
          accordion: "Accordion",
          accordion_container: "Accordion Container",
          accordion_content: "Accordion Content",
          sliders: "Carousel",
          slider: "Carousel Slider",
          slides: "Carousel Slides",
          slide: "Carousel Slide",
          nav_prev: "Nav Prev",
          nav_next: "Nav Next",
          slider_frame: "Carousel Frame",
          footer: "Footer",
          labelFooterBigContainer: "Footer Big",
          labelFooterWidget: "Footer Widget",
          labelFooterWidgetAbout: "Widget About",
          labelFooterContact: "Contact Details",
          labelFooterMenu: "Footer Menu",
          labelMiniFooter: "Mini Footer",
          labelFooterCopyright: "Copyright",
          modal: "Modal",
          modal_dialog: "Modal Dialog",
          modal_content: "Modal Content",
          modal_header: "Modal Header",
          modal_title: "Modal Title",
          modal_body: "Modal Body",
          modal_footer: "Modal Footer",
          facebook_button: "Facebook Button",
          google_button: "Google Button",
          sections: "Sections",
          drapcode_sections_custom_code: "Sections Custom Code",
          carousels: "Carousels",
          drapcode_carousels_custom_code: "Carousels Custom Code",
          cards: "Cards",
          drapcode_cards_custom_code: "Cards Custom Code",
          link_box: "Link Box",
          horizontal_line: "Horizontal Line",
          vertical_line: "Vertical Line",
          box: "Box",
          table: "Table",
          breadcrumb: "Breadcrumb",
          iframe: "Iframe",
          pagePlaceholder: "Page Placeholder"
        },
        a = {
          button: "bootstrap_button:open-modal",
          card: "card:open-modal",
          drapcode_sections_custom_code: "drapcode-sections:open-modal",
          drapcode_carousels_custom_code: "drapcode-carousels:open-modal",
          drapcode_cards_custom_code: "drapcode-cards:open-modal"
        },
        s = {
          hNavbarRef: "h-navbar",
          navbarRef: "navbar",
          navbarItemsRef: "navbar-items",
          menuRef: "navbar-menu",
          drapcodeSectionRef: Qr,
          keyDrapCodeSectionsCustomCode: Qr + "__code",
          drapcodeCarouselRef: Kr,
          keyDrapCodeCarouselsCustomCode: Kr + "__code",
          drapcodeCardRef: fa,
          keyDrapCodeCardsCustomCode: fa + "__code"
        };
      var l = _objectSpread({
        blocks: n,
        labels: r,
        types: i,
        commands: a,
        refs: s,
        optionsStringSeparator: "::",
        labelWebConnectBasicCategory: "Basic",
        labelWebConnectFormCategory: "Forms",
        labelWebConnectAdvancedCategory: "Advanced",
        labelWebConnectSocialCategory: "Social",
        labelWebConnectLayoutCategory: "Layout",
        labelWebConnectMediaCategory: "Media",
        labelWebConnectTypographyCategory: "Typography",
        pfxSections: "dc-sections",
        sections: Xr,
        blockDrapCodeSectionsSectionCode: {},
        propsDrapCodeSectionsSectionCode: {},
        sectionsPlaceholderContent: "\n        <div class='container'>\n          <div class='row'>\n            <div class='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'></div>\n          </div>\n        </div>",
        toolbarBtnDrapCodeSectionsSectionCode: {},
        sectionsPlaceholderScript: "<div style=\"pointer-events: none; padding: 10px;\">\n        <svg viewBox=\"0 0 24 24\" style=\"height: 30px; vertical-align: middle;\">\n          <path d=\"M13 14h-2v-4h2m0 8h-2v-2h2M1 21h22L12 2 1 21z\"></path>\n          </svg>\n          Section with <i>&lt;script&gt;</i> can't be rendered on the canvas\n        </div>",
        sectionsModalTitle: "Sections",
        sectionsCodeViewOptions: {},
        commandDrapCodeSectionsSectionCode: {},
        pfxCarousels: "dc-carousels",
        carousels: ea,
        blockDrapCodeCarouselsCarouselCode: {},
        propsDrapCodeCarouselsCarouselCode: {},
        carouselsPlaceholderContent: "\n        <div id=\"dc-carousel-default\" class=\"carousel slide\" data-ride=\"carousel\" data-gjs-type=\"carousel-container\" data-gjs-custom-name=\"Carousel Conatiner\">\n          <div class=\"carousel-inner\" data-gjs-type=\"carousel-inner\" data-gjs-custom-name=\"Carousel Inner\">\n            <div class=\"carousel-item active\" data-gjs-type=\"carousel-item\" data-gjs-custom-name=\"Carousel Item\">\n              <img class=\"d-block img-fluid\" data-gjs-type=\"bs-image\" style=\"width: 100%\" src=\"https://picsum.photos/1250/400\" alt=\"First slide\">\n            </div>\n            <div class=\"carousel-item\" data-gjs-type=\"carousel-item\" data-gjs-custom-name=\"Carousel Item\">\n              <img class=\"d-block img-fluid\" data-gjs-type=\"bs-image\" style=\"width: 100%\" src=\"https://picsum.photos/1250/400\" alt=\"Second slide\">\n            </div>\n            <div class=\"carousel-item\" data-gjs-type=\"carousel-item\" data-gjs-custom-name=\"Carousel Item\">\n              <img class=\"d-block img-fluid\" data-gjs-type=\"bs-image\" style=\"width: 100%\" src=\"https://picsum.photos/1250/400\" alt=\"Third slide\">\n            </div>\n          </div>\n        </div>",
        toolbarBtnDrapCodeCarouselsCarouselCode: {},
        carouselsPlaceholderScript: "<div style=\"pointer-events: none; padding: 10px;\">\n        <svg viewBox=\"0 0 24 24\" style=\"height: 30px; vertical-align: middle;\">\n          <path d=\"M13 14h-2v-4h2m0 8h-2v-2h2M1 21h22L12 2 1 21z\"></path>\n          </svg>\n          Carousel with <i>&lt;script&gt;</i> can't be rendered on the canvas\n        </div>",
        carouselsModalTitle: "Carousels",
        carouselsCodeViewOptions: {},
        commandDrapCodeCarouselsCarouselCode: {},
        pfxCards: "dc-cards",
        cards: ma,
        blockDrapCodeCardsCardCode: {},
        propsDrapCodeCardsCardCode: {},
        cardsPlaceholderContent: "\n        <div id=\"dc-card-default\" class=\"card\" data-gjs-type=\"card\">\n          <div class=\"card-body\" data-gjs-type=\"card-body\">\n            <h5 class=\"card-title\">Card title</h5>\n            <h6 class=\"card-subtitle mb-2 text-muted\">Card subtitle</h6>\n            <p class=\"card-text\">Some quick example text to build on the card title and make up the bulk of the card's content.</p>\n            <a href=\"#\" class=\"card-link\">Card link</a>\n            <a href=\"#\" class=\"card-link\">Another link</a>\n          </div>\n        </div>",
        toolbarBtnDrapCodeCardsCardCode: {},
        cardsPlaceholderScript: "<div style=\"pointer-events: none; padding: 10px;\">\n        <svg viewBox=\"0 0 24 24\" style=\"height: 30px; vertical-align: middle;\">\n          <path d=\"M13 14h-2v-4h2m0 8h-2v-2h2M1 21h22L12 2 1 21z\"></path>\n          </svg>\n          Card with <i>&lt;script&gt;</i> can't be rendered on the canvas\n        </div>",
        cardsModalTitle: "Cards",
        cardsCodeViewOptions: {},
        commandDrapCodeCardsCardCode: {}
      }, e);
      for (var _t23 in l) _t23 in e || (e[_t23] = l[_t23]);
      o(t, e), Zr(t, e), Rr(t, e), ye(t, e), va(t);
    });
  }]);
});